webpackJsonp([0],{

/***/ "./app_modules recursive ^\\.\\/[a-zA-Z0-9_\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(dist|node_modules|tests)).*\\.(js|jsx|css|json)$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./assessment-shell/component.js": "./app_modules/assessment-shell/component.js",
	"./assessment-shell/contentmodel.js": "./app_modules/assessment-shell/contentmodel.js",
	"./assessment-shell/index.js": "./app_modules/assessment-shell/index.js",
	"./assessment-shell/style.css": "./app_modules/assessment-shell/style.css",
	"./collapsible-activity/component.js": "./app_modules/collapsible-activity/component.js",
	"./collapsible-activity/contentmodel.js": "./app_modules/collapsible-activity/contentmodel.js",
	"./collapsible-activity/index.js": "./app_modules/collapsible-activity/index.js",
	"./collapsible-activity/style.css": "./app_modules/collapsible-activity/style.css",
	"./course-of-action-activity/package-lock.json": "./app_modules/course-of-action-activity/package-lock.json",
	"./course-of-action-activity/package.json": "./app_modules/course-of-action-activity/package.json",
	"./course-of-action-activity/src/component.js": "./app_modules/course-of-action-activity/src/component.js",
	"./course-of-action-activity/src/contentmodel.js": "./app_modules/course-of-action-activity/src/contentmodel.js",
	"./course-of-action-activity/src/index.js": "./app_modules/course-of-action-activity/src/index.js",
	"./course-of-action-activity/src/style.css": "./app_modules/course-of-action-activity/src/style.css",
	"./default-simulation-shell/component.js": "./app_modules/default-simulation-shell/component.js",
	"./default-simulation-shell/contentmodel.js": "./app_modules/default-simulation-shell/contentmodel.js",
	"./default-simulation-shell/index.js": "./app_modules/default-simulation-shell/index.js",
	"./default-simulation-shell/style.css": "./app_modules/default-simulation-shell/style.css",
	"./deloitte-auth-strategy/component.js": "./app_modules/deloitte-auth-strategy/component.js",
	"./deloitte-auth-strategy/component.localmode.js": "./app_modules/deloitte-auth-strategy/component.localmode.js",
	"./deloitte-auth-strategy/component.mock.js": "./app_modules/deloitte-auth-strategy/component.mock.js",
	"./deloitte-auth-strategy/contentmodel.js": "./app_modules/deloitte-auth-strategy/contentmodel.js",
	"./deloitte-auth-strategy/index.js": "./app_modules/deloitte-auth-strategy/index.js",
	"./deloitte-auth-strategy/setup/simgate.json": "./app_modules/deloitte-auth-strategy/setup/simgate.json",
	"./document-builder-activity/package.json": "./app_modules/document-builder-activity/package.json",
	"./document-builder-activity/src/component.js": "./app_modules/document-builder-activity/src/component.js",
	"./document-builder-activity/src/contentmodel.js": "./app_modules/document-builder-activity/src/contentmodel.js",
	"./document-builder-activity/src/index.js": "./app_modules/document-builder-activity/src/index.js",
	"./document-builder-activity/src/style.css": "./app_modules/document-builder-activity/src/style.css",
	"./example-activity/component.js": "./app_modules/example-activity/component.js",
	"./example-activity/contentmodel.js": "./app_modules/example-activity/contentmodel.js",
	"./example-activity/index.js": "./app_modules/example-activity/index.js",
	"./example-activity/style.css": "./app_modules/example-activity/style.css",
	"./form-control-activity/buttons/component.js": "./app_modules/form-control-activity/buttons/component.js",
	"./form-control-activity/buttons/contentmodel.js": "./app_modules/form-control-activity/buttons/contentmodel.js",
	"./form-control-activity/buttons/viewstore.js": "./app_modules/form-control-activity/buttons/viewstore.js",
	"./form-control-activity/forms/component.js": "./app_modules/form-control-activity/forms/component.js",
	"./form-control-activity/forms/contentmodel.js": "./app_modules/form-control-activity/forms/contentmodel.js",
	"./form-control-activity/forms/viewstore.js": "./app_modules/form-control-activity/forms/viewstore.js",
	"./form-control-activity/index.js": "./app_modules/form-control-activity/index.js",
	"./form-control-activity/inputFields/component.js": "./app_modules/form-control-activity/inputFields/component.js",
	"./form-control-activity/inputFields/contentmodel.js": "./app_modules/form-control-activity/inputFields/contentmodel.js",
	"./form-control-activity/inputFields/viewstore.js": "./app_modules/form-control-activity/inputFields/viewstore.js",
	"./form-control-activity/layouts/component.js": "./app_modules/form-control-activity/layouts/component.js",
	"./form-control-activity/layouts/contentmodel.js": "./app_modules/form-control-activity/layouts/contentmodel.js",
	"./form-control-activity/layouts/viewstore.js": "./app_modules/form-control-activity/layouts/viewstore.js",
	"./form-control-activity/progress/component.js": "./app_modules/form-control-activity/progress/component.js",
	"./form-control-activity/progress/contentmodel.js": "./app_modules/form-control-activity/progress/contentmodel.js",
	"./form-control-activity/progress/viewstore.js": "./app_modules/form-control-activity/progress/viewstore.js",
	"./form-control-activity/static/component.js": "./app_modules/form-control-activity/static/component.js",
	"./form-control-activity/static/contentmodel.js": "./app_modules/form-control-activity/static/contentmodel.js",
	"./form-control-activity/static/viewstore.js": "./app_modules/form-control-activity/static/viewstore.js",
	"./form-control-activity/style.css": "./app_modules/form-control-activity/style.css",
	"./graph-activity/package-lock.json": "./app_modules/graph-activity/package-lock.json",
	"./graph-activity/package.json": "./app_modules/graph-activity/package.json",
	"./graph-activity/src/component.js": "./app_modules/graph-activity/src/component.js",
	"./graph-activity/src/contentmodel.js": "./app_modules/graph-activity/src/contentmodel.js",
	"./graph-activity/src/index.js": "./app_modules/graph-activity/src/index.js",
	"./graph-activity/src/style.css": "./app_modules/graph-activity/src/style.css",
	"./resources-activity/package.json": "./app_modules/resources-activity/package.json",
	"./resources-activity/src/component.js": "./app_modules/resources-activity/src/component.js",
	"./resources-activity/src/contentmodel.js": "./app_modules/resources-activity/src/contentmodel.js",
	"./resources-activity/src/index.js": "./app_modules/resources-activity/src/index.js",
	"./resources-activity/src/style.css": "./app_modules/resources-activity/src/style.css",
	"./resources-activity/src/viewstore.js": "./app_modules/resources-activity/src/viewstore.js",
	"./simgate-auth-strategy/component.js": "./app_modules/simgate-auth-strategy/component.js",
	"./simgate-auth-strategy/component.localmode.js": "./app_modules/simgate-auth-strategy/component.localmode.js",
	"./simgate-auth-strategy/contentmodel.js": "./app_modules/simgate-auth-strategy/contentmodel.js",
	"./simgate-auth-strategy/index.js": "./app_modules/simgate-auth-strategy/index.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app_modules recursive ^\\.\\/[a-zA-Z0-9_\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(dist|node_modules|tests)).*\\.(js|jsx|css|json)$";

/***/ }),

/***/ "./app_modules/assessment-shell/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.DefaultShellComponent = exports.DefaultShellViewStore = exports.MenuBar = undefined;

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _dec, _dec2, _dec3, _desc, _value, _class2, _class4, _class5, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

var _simgateDatamodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simgate-datamodel/index.js");

var _simgateDatamodel2 = _interopRequireDefault(_simgateDatamodel);

var _projectDomainStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/project-domain-store/index.js");

var _projectDomainStore2 = _interopRequireDefault(_projectDomainStore);

var _simDomainStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/sim-domain-store/index.js");

var _simDomainStore2 = _interopRequireDefault(_simDomainStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var MenuBar = exports.MenuBar = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
  (0, _inherits3.default)(MenuBar, _BaseComponent);

  function MenuBar() {
    (0, _classCallCheck3.default)(this, MenuBar);
    return (0, _possibleConstructorReturn3.default)(this, (MenuBar.__proto__ || (0, _getPrototypeOf2.default)(MenuBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(MenuBar, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          viewMap = _props.viewMap,
          clickItem = _props.clickItem,
          currentView = _props.currentView,
          currentViewId = _props.currentViewId,
          currentRound = _props.currentRound;

      var items = [];
      (0, _keys2.default)(viewMap).reduce(function (acc, k) {
        var v = viewMap[k];
        var element = null;
        if (typeof v === "function") {
          element = { id: k, Component: v };
        } else if (v.show || v.menu && v.menu.show) {
          element = v;
        } else if (v.onClick || v.clickItem) {
          element = (0, _assign2.default)({}, v, { id: k }, { clickItem: v.onClick || v.clickItem });
        }

        if (!element) {
          return;
        }

        element.iconClass = element.icon || element.contentModel && element.contentModel.icon || "";
        element.menu = (0, _assign2.default)({ clickItem: clickItem }, element, element.menu);
        element.itemStatus = currentViewId && element.menu.id === currentViewId || currentView && currentView.id === element.menu.id ? "active" : "inactive";

        items.push(element);
        return [];
      }, []);

      function getItem(css, item) {
        return _react2.default.createElement(
          "div",
          { className: "item " + css + " " + item.itemStatus + " " + item.menu.id, onClick: function onClick(e) {
              return !!item.menu.clickItem && item.menu.clickItem(item, viewMap);
            }, disabled: item.menu.hasOwnProperty('enabled') ? !item.menu.enabled : false },
          _react2.default.createElement("div", { className: "icon" }),
          _react2.default.createElement(
            "div",
            { className: "label" },
            item.menu.displayName || item.menu.id
          )
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "menu" },
        _react2.default.createElement(
          "div",
          { className: "item message round" },
          !!currentRound && currentRound.displayName || currentRound.id
        ),
        _react2.default.createElement(
          "div",
          { className: "sub-menu" },
          items.map(function (view, index) {
            return _react2.default.createElement(
              "div",
              { key: "" + view.menu.id + index, className: "item " + view.iconClass + " " + view.itemStatus + " " + view.menu.id, onClick: function onClick(e) {
                  return !!view.menu.clickItem && view.menu.clickItem(view, viewMap);
                }, disabled: view.menu.hasOwnProperty('enabled') ? !view.menu.enabled : false },
              _react2.default.createElement("div", { className: "icon" }),
              _react2.default.createElement(
                "div",
                { className: "label" },
                view.menu.displayName || view.menu.id
              )
            );
          })
        )
      );
    }
  }]);
  return MenuBar;
}(_baseComponent2.default)) || _class;

var DefaultShellViewStore = exports.DefaultShellViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class2 = function (_mix$with) {
  (0, _inherits3.default)(DefaultShellViewStore, _mix$with);

  function DefaultShellViewStore() {
    (0, _classCallCheck3.default)(this, DefaultShellViewStore);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (DefaultShellViewStore.__proto__ || (0, _getPrototypeOf2.default)(DefaultShellViewStore)).apply(this, arguments));

    _this2.isInitilized = false;
    var _this2$props = _this2.props,
        shell = _this2$props.contentModel,
        simulation = _this2$props.simulation,
        simDomainStore = _this2$props.dataModel.domainStore,
        projectDomainStore = _this2$props.projectDomainStore,
        parentPathId = _this2$props.parentPathId,
        application = _this2$props.application;
    return _this2;
  }

  (0, _createClass3.default)(DefaultShellViewStore, [{
    key: "completeState",
    value: function completeState() {
      var simDomainStore = this.props.dataModel.domainStore;


      simDomainStore.completeTask();
    }
  }, {
    key: "logout",
    value: function logout() {
      var _props2 = this.props,
          contentModel = _props2.contentModel,
          projectDomainStore = _props2.dataModel.domainStore;

      var modalViewStore = window.application.modalViewStore;

      //just in case we're already signed in :-)
      if (!(process && __webpack_require__.i({"api":"simgate","NODE_ENV":"production","localMode":false}) && __webpack_require__.i({"api":"simgate","NODE_ENV":"production","localMode":false}).mockMode)) projectDomainStore.refreshContext();

      modalViewStore.setModal({
        title: "Are you sure you want to logout?",
        message: "",
        confirmLabel: 'Logout',
        confirmBtnClass: 'green check-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          projectDomainStore.simgate.signOut().then(function () {
            return window.location.reload();
          }).catch(function () {
            return window.location.reload();
          });
        }
      });
    }
  }, {
    key: "updateState",
    value: function updateState() {
      var _props3 = this.props,
          contentModel = _props3.contentModel,
          domainStore = _props3.dataModel.domainStore;


      var viewMap = this.viewMap;
      var selectView = this.selectView;
      var self = this;

      var first = null;
      var home = null;
      var inputs = [];

      for (var i in viewMap) {
        first = viewMap[i];
        break;
      }

      selectView(first, viewMap);
    }
  }, {
    key: "currentRound",
    get: function get() {
      var _props4 = this.props,
          simulation = _props4.simulation,
          simDomainStore = _props4.dataModel.domainStore;


      var round = simulation.rounds[0];
      return round;
    }
  }, {
    key: "currentTeamState",
    get: function get() {
      var simDomainStore = this.props.dataModel.domainStore;

      return this.currentRound.teamStates.find(function (ts) {
        return ts.id === simDomainStore.teamStateName;
      }) || this.currentRound.teamStates[0];
    }
  }, {
    key: "currentTeamName",
    get: function get() {
      var projectDomainStore = this.props.projectDomainStore;

      return projectDomainStore.context && projectDomainStore.context.team && projectDomainStore.context.team.name || "-";
    }
  }, {
    key: "currentSessionName",
    get: function get() {
      var projectDomainStore = this.props.projectDomainStore;

      return projectDomainStore.context && projectDomainStore.context.sessionName || "-";
    }
  }, {
    key: "viewMap",
    get: function get() {
      var _props5 = this.props,
          dataModel = _props5.dataModel,
          simDomainStore = _props5.dataModel.domainStore;


      if (!simDomainStore.pathId || !simDomainStore.teamStateName) return {
        "loading": {
          id: "loading",
          Component: function Component() {
            return _react2.default.createElement(
              "div",
              null,
              "Loading..."
            );
          }
        }
      };

      var tasks = this.currentTeamState.tasks;
      return tasks && tasks.reduce(function (acc, task) {
        acc[task.id] = {
          id: task.id,
          contentModel: task,
          menu: {
            get show() {
              return true;
            }, // can be computed based on activity
            get enabled() {
              return true;
            }, // can be computed based on activity
            displayName: task.displayTitle || task.id
          },
          dataModel: dataModel,
          viewMode: "simulation"
        };
        return acc;
      }, {});
    }
  }]);
  return DefaultShellViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), (_applyDecoratedDescriptor(_class2.prototype, "completeState", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "completeState"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentRound", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "currentRound"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentTeamState", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "currentTeamState"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentTeamName", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "currentTeamName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentSessionName", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "currentSessionName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "viewMap", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "viewMap"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "logout", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "logout"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateState", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "updateState"), _class2.prototype)), _class2));

//@autoclass
var DefaultShellComponent = exports.DefaultShellComponent = (0, _mobxReact.observer)(_class4 = (_temp = _class5 = function (_BaseComponent2) {
  (0, _inherits3.default)(DefaultShellComponent, _BaseComponent2);

  function DefaultShellComponent() {
    (0, _classCallCheck3.default)(this, DefaultShellComponent);
    return (0, _possibleConstructorReturn3.default)(this, (DefaultShellComponent.__proto__ || (0, _getPrototypeOf2.default)(DefaultShellComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(DefaultShellComponent, [{
    key: "render",
    value: function render() {
      var _props6 = this.props,
          shell = _props6.contentModel,
          simulation = _props6.simulation,
          dataModel = _props6.dataModel,
          projectDomainStore = _props6.projectDomainStore,
          parentPathId = _props6.parentPathId,
          application = _props6.application;
      var _viewStore = this.viewStore,
          viewMap = _viewStore.viewMap,
          selectView = _viewStore.selectView,
          clearView = _viewStore.clearView,
          SelectedView = _viewStore.SelectedView,
          currentRound = _viewStore.currentRound,
          currentTeamState = _viewStore.currentTeamState,
          currentTeamName = _viewStore.currentTeamName,
          currentSessionName = _viewStore.currentSessionName,
          completeState = _viewStore.completeState,
          logout = _viewStore.logout,
          isInitilized = _viewStore.isInitilized,
          updateState = _viewStore.updateState;


      if (!SelectedView && !viewMap["loading"] && !isInitilized) {
        this.viewStore.isInitilized = true;
        updateState();
      }

      return _react2.default.createElement(
        "div",
        { className: "app-shell" },
        _react2.default.createElement(
          "div",
          { className: "content" },
          _react2.default.createElement(
            "div",
            { className: "activity-area" },
            !SelectedView ? _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: shell.body } }) : _react2.default.createElement(SelectedView, null)
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "footer" },
          _react2.default.createElement(
            "div",
            { className: "actions" },
            _react2.default.createElement(
              "div",
              { className: "action", onClick: logout },
              "Logout"
            )
          )
        )
      );
    }
  }]);
  return DefaultShellComponent;
}(_baseComponent2.default), _class5.ViewStore = DefaultShellViewStore, _temp)) || _class4;

var Component = exports.Component = DefaultShellComponent;
var _default = Component;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MenuBar, "MenuBar", "D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/component.js");

  __REACT_HOT_LOADER__.register(DefaultShellViewStore, "DefaultShellViewStore", "D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/component.js");

  __REACT_HOT_LOADER__.register(DefaultShellComponent, "DefaultShellComponent", "D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/component.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./app_modules/assessment-shell/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssessmentShellContentModel = exports.AssessmentShellSubContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _class2, _temp2, _dec, _desc2, _value2, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _class4, _temp4;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _trcExampleActivity = __webpack_require__("./node_modules/trc-example-activity/dist/index.js");

var _component = __webpack_require__("./app_modules/assessment-shell/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var AssessmentShellSubContentModel = exports.AssessmentShellSubContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(AssessmentShellSubContentModel, _BaseContentModel);

  function AssessmentShellSubContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AssessmentShellSubContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AssessmentShellSubContentModel.__proto__ || (0, _getPrototypeOf2.default)(AssessmentShellSubContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'text', _descriptor, _this), _initDefineProp(_this, 'richText', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /* @slot */

  /* @slot("RichText") */

  return AssessmentShellSubContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  text: "",
  richText: "RichText" }, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'text', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'richText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text for richText";
  }
})), _class);
var AssessmentShellContentModel = exports.AssessmentShellContentModel = (_dec = _mobx.observable.ref, (_class3 = (_temp4 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(AssessmentShellContentModel, _BaseContentModel2);

  function AssessmentShellContentModel() {
    var _ref2;

    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, AssessmentShellContentModel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = AssessmentShellContentModel.__proto__ || (0, _getPrototypeOf2.default)(AssessmentShellContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _initDefineProp(_this2, '_options', _descriptor3, _this2), _this2.Component = _component2.default, _initDefineProp(_this2, 'logo', _descriptor4, _this2), _initDefineProp(_this2, 'header', _descriptor5, _this2), _initDefineProp(_this2, 'body', _descriptor6, _this2), _initDefineProp(_this2, 'textOptionsSlot', _descriptor7, _this2), _initDefineProp(_this2, 'ref', _descriptor8, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }
  // the ContentModel classes contain the customizable "slots" that content creators will be filling in
  // presently these are defined via static _slots, but will be applied via @slot sugar
  // see the list below for examples of the slot types, and the editor input created for each:

  // options are a way to supply slots with specific options
  // this is currently defined manually, but will be taken care of by @options decorator 

  // define the default Component (Sim) view of this component

  /* @slot */

  // below is what content model definitions will ultimately look like. note the commented out decorators.
  // when these are in place, you will not need @observable, @observable.ref, etc

  /* @slot */
  /* @slot("RichText") */
  /* @options(["Option1", "Option2", "Option3"]) @slot */
  /* @slot("ExampleActivityContentModel") */

  return AssessmentShellContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  logo: "",
  header: "", // textarea
  body: "RichText", // trix wysiwyg
  textOptionsSlot: "", // see _options,
  ref: _trcExampleActivity.ContentModel }, _temp4), (_descriptor3 = _applyDecoratedDescriptor(_class3.prototype, '_options', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get textOptionsSlot() {
        // turns textOptionsSlot into dropdown
        return ["Option1", "Option2", "Option3"];
      }
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'logo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "assets/images/trc-logo-inverted.svg";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'header', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'body', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, 'textOptionsSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'ref', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class3));
var _default = AssessmentShellContentModel;
exports.default = _default;
;

var _temp5 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AssessmentShellSubContentModel, 'AssessmentShellSubContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/contentmodel.js');

  __REACT_HOT_LOADER__.register(AssessmentShellContentModel, 'AssessmentShellContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/assessment-shell/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./app_modules/assessment-shell/contentmodel.js");

var defaultShellContentModels = _interopRequireWildcard(_contentmodel);

var _style = __webpack_require__("./app_modules/assessment-shell/style.css");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = defaultShellContentModels;
var ContentModel = exports.ContentModel = defaultShellContentModels.default;

var description = exports.description = "This is the default-simulation-shell";
var instructions = exports.instructions = '\nThese are the default-simulation-shell installation instructions:\n  Step 1...\n  Step 2...\n  Step 3...\n';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/index.js');

  __REACT_HOT_LOADER__.register(description, 'description', 'D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/index.js');

  __REACT_HOT_LOADER__.register(instructions, 'instructions', 'D:/VSTS/agent/_work/24/s/app_modules/assessment-shell/index.js');
}();

;

/***/ }),

/***/ "./app_modules/assessment-shell/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app_modules/collapsible-activity/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CollapsibleComponent = exports.CollapsibleViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _class3, _class4, _temp2;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CollapsibleViewStore = exports.CollapsibleViewStore = (_dec = _mobx.action.bound, (_class = function (_BaseViewStore) {
    (0, _inherits3.default)(CollapsibleViewStore, _BaseViewStore);

    function CollapsibleViewStore() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CollapsibleViewStore);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CollapsibleViewStore.__proto__ || (0, _getPrototypeOf2.default)(CollapsibleViewStore)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, "open", _descriptor, _this), _initDefineProp(_this, "fixed", _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CollapsibleViewStore, [{
        key: "save",
        value: function save() {}
    }, {
        key: "invalid",


        // validation is a derivation
        get: function get() {
            var invalid = {};
            return invalid;
        }
    }]);
    return CollapsibleViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "open", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "fixed", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype)), _class));

var CollapsibleComponent = exports.CollapsibleComponent = (0, _mobxReact.observer)(_class3 = (_temp2 = _class4 = function (_BaseComponent) {
    (0, _inherits3.default)(CollapsibleComponent, _BaseComponent);

    function CollapsibleComponent() {
        (0, _classCallCheck3.default)(this, CollapsibleComponent);
        return (0, _possibleConstructorReturn3.default)(this, (CollapsibleComponent.__proto__ || (0, _getPrototypeOf2.default)(CollapsibleComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(CollapsibleComponent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                currentView = _props.currentView,
                contentModel = _props.contentModel,
                form = _props.form,
                lastCm = _props.lastCm,
                viewBreadcrumbs = _props.viewBreadcrumbs,
                insideEditor = _props.insideEditor;
            var titleContent = contentModel.titleContent,
                innerContent = contentModel.innerContent; // this contentModel's properties

            var titleProps = {
                currentView: { contentModel: contentModel },
                options: { contentModel: titleContent },
                contentModel: titleContent,
                lastCm: lastCm,
                viewBreadcrumbs: viewBreadcrumbs,
                insideEditor: insideEditor,
                form: form
            };
            var innerProps = {
                currentView: { contentModel: contentModel },
                options: { contentModel: innerContent },
                contentModel: innerContent,
                lastCm: lastCm,
                viewBreadcrumbs: viewBreadcrumbs,
                insideEditor: insideEditor,
                form: form
            };

            var titleElement = titleContent && titleContent.Component ? _react2.default.createElement(titleContent.Component, titleProps) : _react2.default.createElement(
                "div",
                null,
                "No Title Provided"
            );
            var innerElement = innerContent && innerContent.Component ? _react2.default.createElement(innerContent.Component, innerProps) : _react2.default.createElement(
                "div",
                null,
                "No Content Provided"
            );

            var viewStore = this.viewStore;

            return _react2.default.createElement(
                "div",
                { className: "accordion-container" + (viewStore.open ? " open" : "") + (viewStore.fixed ? " fixed" : "") },
                _react2.default.createElement(
                    "div",
                    { className: "accordion-fixed" },
                    _react2.default.createElement(
                        "div",
                        { className: "metrics-bar" },
                        titleElement
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "accordion-title", onClick: function onClick() {
                            viewStore.open = !viewStore.open;
                        } },
                    _react2.default.createElement(
                        "div",
                        { className: "metrics-bar" },
                        titleElement,
                        _react2.default.createElement("div", { className: "metric-icon" })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "panel", id: "accordion-1" },
                    innerElement
                )
            );
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {

            var viewStore = this.viewStore;
            (0, _jquery2.default)('.activity-area').scroll(function () {
                var y = (0, _jquery2.default)('.activity-area').scrollTop();
                if (y > 120) {
                    viewStore.fixed = true;
                } else {
                    viewStore.fixed = false;
                }
            });
            (0, _jquery2.default)('.task-preview').scroll(function () {
                var y = (0, _jquery2.default)('.task-preview').scrollTop();
                if (y > 120) {
                    viewStore.fixed = true;
                } else {
                    viewStore.fixed = false;
                }
            });
        }
    }]);
    return CollapsibleComponent;
}(_baseComponent2.default), _class4.ViewStore = CollapsibleViewStore, _temp2)) || _class3;

var _default = CollapsibleComponent;
exports.default = _default; //need to export top level component as "default"

;

var _temp3 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(CollapsibleViewStore, "CollapsibleViewStore", "D:/VSTS/agent/_work/24/s/app_modules/collapsible-activity/component.js");

    __REACT_HOT_LOADER__.register(CollapsibleComponent, "CollapsibleComponent", "D:/VSTS/agent/_work/24/s/app_modules/collapsible-activity/component.js");

    __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/collapsible-activity/component.js");
}();

;

/***/ }),

/***/ "./app_modules/collapsible-activity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsibleContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _class2, _temp2;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _component = __webpack_require__("./app_modules/collapsible-activity/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CollapsibleContentModel = exports.CollapsibleContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(CollapsibleContentModel, _BaseContentModel);

  function CollapsibleContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CollapsibleContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CollapsibleContentModel.__proto__ || (0, _getPrototypeOf2.default)(CollapsibleContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.Component = _component2.default, _initDefineProp(_this, 'titleContent', _descriptor, _this), _initDefineProp(_this, 'innerContent', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /* @slot */
  /* @slot */

  return CollapsibleContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  titleContent: _baseContentmodel2.default,
  innerContent: _baseContentmodel2.default
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'titleContent', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'innerContent', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class);
var _default = CollapsibleContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CollapsibleContentModel, 'CollapsibleContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/collapsible-activity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/collapsible-activity/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/collapsible-activity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./app_modules/collapsible-activity/contentmodel.js");

var allContentModels = _interopRequireWildcard(_contentmodel);

__webpack_require__("./app_modules/collapsible-activity/style.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = allContentModels;
var ContentModel = exports.ContentModel = allContentModels.default;

var description = exports.description = "This is the example-activity.";
var instructions = exports.instructions = '';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'D:/VSTS/agent/_work/24/s/app_modules/collapsible-activity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/collapsible-activity/index.js');

  __REACT_HOT_LOADER__.register(description, 'description', 'D:/VSTS/agent/_work/24/s/app_modules/collapsible-activity/index.js');

  __REACT_HOT_LOADER__.register(instructions, 'instructions', 'D:/VSTS/agent/_work/24/s/app_modules/collapsible-activity/index.js');
}();

;

/***/ }),

/***/ "./app_modules/collapsible-activity/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app_modules/course-of-action-activity/package-lock.json":
/***/ (function(module, exports) {

module.exports = {"name":"course-of-action-activity","version":"1.0.6","lockfileVersion":1,"requires":true,"dependencies":{"aggregate-error":{"version":"1.0.0","resolved":"https://registry.npmjs.org/aggregate-error/-/aggregate-error-1.0.0.tgz","integrity":"sha1-iINE2tAiCnLjr1CQYRf0h3GSX6w=","dev":true,"requires":{"clean-stack":"1.3.0","indent-string":"3.2.0"}},"ansi-regex":{"version":"2.1.1","resolved":"https://registry.npmjs.org/ansi-regex/-/ansi-regex-2.1.1.tgz","integrity":"sha1-w7M6te42DYbg5ijwRorn7yfWVN8=","dev":true},"ansi-styles":{"version":"2.2.1","resolved":"https://registry.npmjs.org/ansi-styles/-/ansi-styles-2.2.1.tgz","integrity":"sha1-tDLdM1i2NM914eRmQ2gkBTPB3b4=","dev":true},"anymatch":{"version":"1.3.2","resolved":"https://registry.npmjs.org/anymatch/-/anymatch-1.3.2.tgz","integrity":"sha512-0XNayC8lTHQ2OI8aljNCN3sSx6hsr/1+rlcDAotXJR7C1oZZHCNsfpbKwMjRA3Uqb5tF1Rae2oloTr4xpq+WjA==","dev":true,"optional":true,"requires":{"micromatch":"2.3.11","normalize-path":"2.1.1"}},"arr-diff":{"version":"2.0.0","resolved":"https://registry.npmjs.org/arr-diff/-/arr-diff-2.0.0.tgz","integrity":"sha1-jzuCf5Vai9ZpaX5KQlasPOrjVs8=","dev":true,"optional":true,"requires":{"arr-flatten":"1.1.0"}},"arr-flatten":{"version":"1.1.0","resolved":"https://registry.npmjs.org/arr-flatten/-/arr-flatten-1.1.0.tgz","integrity":"sha512-L3hKV5R/p5o81R7O02IGnwpDmkp6E982XhtbuwSe3O4qOtMMMtodicASA1Cny2U+aCXcNpml+m4dPsvsJ3jatg==","dev":true,"optional":true},"array-find-index":{"version":"1.0.2","resolved":"https://registry.npmjs.org/array-find-index/-/array-find-index-1.0.2.tgz","integrity":"sha1-3wEKoSh+Fku9pvlyOwqWoexBh6E=","dev":true},"array-unique":{"version":"0.2.1","resolved":"https://registry.npmjs.org/array-unique/-/array-unique-0.2.1.tgz","integrity":"sha1-odl8yvy8JiXMcPrc6zalDFiwGlM=","dev":true,"optional":true},"arrify":{"version":"1.0.1","resolved":"https://registry.npmjs.org/arrify/-/arrify-1.0.1.tgz","integrity":"sha1-iYUI2iIm84DfkEcoRWhJwVAaSw0=","dev":true},"asap":{"version":"2.0.6","resolved":"https://registry.npmjs.org/asap/-/asap-2.0.6.tgz","integrity":"sha1-5QNHYR1+aQlDIIu9r+vLwvuGbUY="},"async-each":{"version":"1.0.1","resolved":"https://registry.npmjs.org/async-each/-/async-each-1.0.1.tgz","integrity":"sha1-GdOGodntxufByF04iu28xW0zYC0=","dev":true,"optional":true},"babel-cli":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-cli/-/babel-cli-6.26.0.tgz","integrity":"sha1-UCq1SHTX24itALiHoGODzgPQAvE=","dev":true,"requires":{"babel-core":"6.26.0","babel-polyfill":"6.26.0","babel-register":"6.26.0","babel-runtime":"6.26.0","chokidar":"1.7.0","commander":"2.13.0","convert-source-map":"1.5.1","fs-readdir-recursive":"1.1.0","glob":"7.1.2","lodash":"4.17.4","output-file-sync":"1.1.2","path-is-absolute":"1.0.1","slash":"1.0.0","source-map":"0.5.7","v8flags":"2.1.1"}},"babel-code-frame":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-code-frame/-/babel-code-frame-6.26.0.tgz","integrity":"sha1-Y/1D99weO7fONZR9uP42mj9Yx0s=","dev":true,"requires":{"chalk":"1.1.3","esutils":"2.0.2","js-tokens":"3.0.2"}},"babel-core":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-core/-/babel-core-6.26.0.tgz","integrity":"sha1-rzL3izGm/O8RnIew/Y2XU/A6C7g=","dev":true,"requires":{"babel-code-frame":"6.26.0","babel-generator":"6.26.0","babel-helpers":"6.24.1","babel-messages":"6.23.0","babel-register":"6.26.0","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0","babylon":"6.18.0","convert-source-map":"1.5.1","debug":"2.6.9","json5":"0.5.1","lodash":"4.17.4","minimatch":"3.0.4","path-is-absolute":"1.0.1","private":"0.1.8","slash":"1.0.0","source-map":"0.5.7"}},"babel-generator":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-generator/-/babel-generator-6.26.0.tgz","integrity":"sha1-rBriAHC3n248odMmlhMFN3TyDcU=","dev":true,"requires":{"babel-messages":"6.23.0","babel-runtime":"6.26.0","babel-types":"6.26.0","detect-indent":"4.0.0","jsesc":"1.3.0","lodash":"4.17.4","source-map":"0.5.7","trim-right":"1.0.1"}},"babel-helper-bindify-decorators":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-bindify-decorators/-/babel-helper-bindify-decorators-6.24.1.tgz","integrity":"sha1-FMGeXxQte0fxmlJDHlKxzLxAozA=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-builder-binary-assignment-operator-visitor":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-builder-binary-assignment-operator-visitor/-/babel-helper-builder-binary-assignment-operator-visitor-6.24.1.tgz","integrity":"sha1-zORReto1b0IgvK6KAsKzRvmlZmQ=","dev":true,"requires":{"babel-helper-explode-assignable-expression":"6.24.1","babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-helper-builder-react-jsx":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-helper-builder-react-jsx/-/babel-helper-builder-react-jsx-6.26.0.tgz","integrity":"sha1-Of+DE7dci2Xc7/HzHTg+D/KkCKA=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0","esutils":"2.0.2"}},"babel-helper-call-delegate":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-call-delegate/-/babel-helper-call-delegate-6.24.1.tgz","integrity":"sha1-7Oaqzdx25Bw0YfiL/Fdb0Nqi340=","dev":true,"requires":{"babel-helper-hoist-variables":"6.24.1","babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-define-map":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-helper-define-map/-/babel-helper-define-map-6.26.0.tgz","integrity":"sha1-pfVtq0GiX5fstJjH66ypgZ+Vvl8=","dev":true,"requires":{"babel-helper-function-name":"6.24.1","babel-runtime":"6.26.0","babel-types":"6.26.0","lodash":"4.17.4"}},"babel-helper-explode-assignable-expression":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-explode-assignable-expression/-/babel-helper-explode-assignable-expression-6.24.1.tgz","integrity":"sha1-8luCz33BBDPFX3BZLVdGQArCLKo=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-explode-class":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-explode-class/-/babel-helper-explode-class-6.24.1.tgz","integrity":"sha1-fcKjkQ3uAHBW4eMdZAztPVTqqes=","dev":true,"requires":{"babel-helper-bindify-decorators":"6.24.1","babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-function-name":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-function-name/-/babel-helper-function-name-6.24.1.tgz","integrity":"sha1-00dbjAPtmCQqJbSDUasYOZ01gKk=","dev":true,"requires":{"babel-helper-get-function-arity":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-get-function-arity":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-get-function-arity/-/babel-helper-get-function-arity-6.24.1.tgz","integrity":"sha1-j3eCqpNAfEHTqlCQj4mwMbG2hT0=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-helper-hoist-variables":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-hoist-variables/-/babel-helper-hoist-variables-6.24.1.tgz","integrity":"sha1-HssnaJydJVE+rbyZFKc/VAi+enY=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-helper-optimise-call-expression":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-optimise-call-expression/-/babel-helper-optimise-call-expression-6.24.1.tgz","integrity":"sha1-96E0J7qfc/j0+pk8VKl4gtEkQlc=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-helper-regex":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-helper-regex/-/babel-helper-regex-6.26.0.tgz","integrity":"sha1-MlxZ+QL4LyS3T6zu0DY5VPZJXnI=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0","lodash":"4.17.4"}},"babel-helper-remap-async-to-generator":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-remap-async-to-generator/-/babel-helper-remap-async-to-generator-6.24.1.tgz","integrity":"sha1-XsWBgnrXI/7N04HxySg5BnbkVRs=","dev":true,"requires":{"babel-helper-function-name":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-replace-supers":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-replace-supers/-/babel-helper-replace-supers-6.24.1.tgz","integrity":"sha1-v22/5Dk40XNpohPKiov3S2qQqxo=","dev":true,"requires":{"babel-helper-optimise-call-expression":"6.24.1","babel-messages":"6.23.0","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helpers":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helpers/-/babel-helpers-6.24.1.tgz","integrity":"sha1-NHHenK7DiOXIUOWX5Yom3fN2ArI=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-messages":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-messages/-/babel-messages-6.23.0.tgz","integrity":"sha1-8830cDhYA1sqKVHG7F7fbGLyYw4=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-check-es2015-constants":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-check-es2015-constants/-/babel-plugin-check-es2015-constants-6.22.0.tgz","integrity":"sha1-NRV7EBQm/S/9PaP3XH0ekYNbv4o=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-module-resolver":{"version":"3.0.0","resolved":"https://registry.npmjs.org/babel-plugin-module-resolver/-/babel-plugin-module-resolver-3.0.0.tgz","integrity":"sha512-U394VtqR+uGozwV43paA9tUOJ2WYP/OpLMla7u/Qi+/A0chDwuRoYu1hkqkkNTAvoq21ybSIgdCeDV4GVvqfeA==","dev":true,"requires":{"find-babel-config":"1.1.0","glob":"7.1.2","pkg-up":"2.0.0","reselect":"3.0.1","resolve":"1.5.0"}},"babel-plugin-syntax-async-functions":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-async-functions/-/babel-plugin-syntax-async-functions-6.13.0.tgz","integrity":"sha1-ytnK0RkbWtY0vzCuCHI5HgZHvpU=","dev":true},"babel-plugin-syntax-async-generators":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-async-generators/-/babel-plugin-syntax-async-generators-6.13.0.tgz","integrity":"sha1-a8lj67FuzLrmuStZbrfzXDQqi5o=","dev":true},"babel-plugin-syntax-class-constructor-call":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-class-constructor-call/-/babel-plugin-syntax-class-constructor-call-6.18.0.tgz","integrity":"sha1-nLnTn+Q8hgC+yBRkVt3L1OGnZBY=","dev":true},"babel-plugin-syntax-class-properties":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-class-properties/-/babel-plugin-syntax-class-properties-6.13.0.tgz","integrity":"sha1-1+sjt5oxf4VDlixQW4J8fWysJ94=","dev":true},"babel-plugin-syntax-decorators":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-decorators/-/babel-plugin-syntax-decorators-6.13.0.tgz","integrity":"sha1-MSVjtNvePMgGzuPkFszurd0RrAs=","dev":true},"babel-plugin-syntax-dynamic-import":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-dynamic-import/-/babel-plugin-syntax-dynamic-import-6.18.0.tgz","integrity":"sha1-jWomIpyDdFqZgqRBBRVyyqF5sdo=","dev":true},"babel-plugin-syntax-exponentiation-operator":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-exponentiation-operator/-/babel-plugin-syntax-exponentiation-operator-6.13.0.tgz","integrity":"sha1-nufoM3KQ2pUoggGmpX9BcDF4MN4=","dev":true},"babel-plugin-syntax-export-extensions":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-export-extensions/-/babel-plugin-syntax-export-extensions-6.13.0.tgz","integrity":"sha1-cKFITw+QiaToStRLrDU8lbmxJyE=","dev":true},"babel-plugin-syntax-flow":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-flow/-/babel-plugin-syntax-flow-6.18.0.tgz","integrity":"sha1-TDqyCiryaqIM0lmVw5jE63AxDI0=","dev":true},"babel-plugin-syntax-jsx":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-jsx/-/babel-plugin-syntax-jsx-6.18.0.tgz","integrity":"sha1-CvMqmm4Tyno/1QaeYtew9Y0NiUY=","dev":true},"babel-plugin-syntax-object-rest-spread":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-object-rest-spread/-/babel-plugin-syntax-object-rest-spread-6.13.0.tgz","integrity":"sha1-/WU28rzhODb/o6VFjEkDpZe7O/U=","dev":true},"babel-plugin-syntax-trailing-function-commas":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-trailing-function-commas/-/babel-plugin-syntax-trailing-function-commas-6.22.0.tgz","integrity":"sha1-ugNgk3+NBuQBgKQ/4NVhb/9TLPM=","dev":true},"babel-plugin-transform-async-generator-functions":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-async-generator-functions/-/babel-plugin-transform-async-generator-functions-6.24.1.tgz","integrity":"sha1-8FiQAUX9PpkHpt3yjaWfIVJYpds=","dev":true,"requires":{"babel-helper-remap-async-to-generator":"6.24.1","babel-plugin-syntax-async-generators":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-async-to-generator":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-async-to-generator/-/babel-plugin-transform-async-to-generator-6.24.1.tgz","integrity":"sha1-ZTbjeK/2yx1VF6wOQOs+n8jQh2E=","dev":true,"requires":{"babel-helper-remap-async-to-generator":"6.24.1","babel-plugin-syntax-async-functions":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-class-constructor-call":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-class-constructor-call/-/babel-plugin-transform-class-constructor-call-6.24.1.tgz","integrity":"sha1-gNwoVQWsBn3LjWxl4vbxGrd2Xvk=","dev":true,"requires":{"babel-plugin-syntax-class-constructor-call":"6.18.0","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-class-properties":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-class-properties/-/babel-plugin-transform-class-properties-6.24.1.tgz","integrity":"sha1-anl2PqYdM9NvN7YRqp3vgagbRqw=","dev":true,"requires":{"babel-helper-function-name":"6.24.1","babel-plugin-syntax-class-properties":"6.13.0","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-decorators":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-decorators/-/babel-plugin-transform-decorators-6.24.1.tgz","integrity":"sha1-eIAT2PjGtSIr33s0Q5Df13Vp4k0=","dev":true,"requires":{"babel-helper-explode-class":"6.24.1","babel-plugin-syntax-decorators":"6.13.0","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-decorators-legacy":{"version":"1.3.4","resolved":"https://registry.npmjs.org/babel-plugin-transform-decorators-legacy/-/babel-plugin-transform-decorators-legacy-1.3.4.tgz","integrity":"sha1-dBtY9sW86eYCfgiC2cmU8E82aSU=","dev":true,"requires":{"babel-plugin-syntax-decorators":"6.13.0","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-arrow-functions":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-arrow-functions/-/babel-plugin-transform-es2015-arrow-functions-6.22.0.tgz","integrity":"sha1-RSaSy3EdX3ncf4XkQM5BufJE0iE=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-block-scoped-functions":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-block-scoped-functions/-/babel-plugin-transform-es2015-block-scoped-functions-6.22.0.tgz","integrity":"sha1-u8UbSflk1wy42OC5ToICRs46YUE=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-block-scoping":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-block-scoping/-/babel-plugin-transform-es2015-block-scoping-6.26.0.tgz","integrity":"sha1-1w9SmcEwjQXBL0Y4E7CgnnOxiV8=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0","lodash":"4.17.4"}},"babel-plugin-transform-es2015-classes":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-classes/-/babel-plugin-transform-es2015-classes-6.24.1.tgz","integrity":"sha1-WkxYpQyclGHlZLSyo7+ryXolhNs=","dev":true,"requires":{"babel-helper-define-map":"6.26.0","babel-helper-function-name":"6.24.1","babel-helper-optimise-call-expression":"6.24.1","babel-helper-replace-supers":"6.24.1","babel-messages":"6.23.0","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-computed-properties":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-computed-properties/-/babel-plugin-transform-es2015-computed-properties-6.24.1.tgz","integrity":"sha1-b+Ko0WiV1WNPTNmZttNICjCBWbM=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-destructuring":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-destructuring/-/babel-plugin-transform-es2015-destructuring-6.23.0.tgz","integrity":"sha1-mXux8auWf2gtKwh2/jWNYOdlxW0=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-duplicate-keys":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-duplicate-keys/-/babel-plugin-transform-es2015-duplicate-keys-6.24.1.tgz","integrity":"sha1-c+s9MQypaePvnskcU3QabxV2Qj4=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-for-of":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-for-of/-/babel-plugin-transform-es2015-for-of-6.23.0.tgz","integrity":"sha1-9HyVsrYT3x0+zC/bdXNiPHUkhpE=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-function-name":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-function-name/-/babel-plugin-transform-es2015-function-name-6.24.1.tgz","integrity":"sha1-g0yJhTvDaxrw86TF26qU/Y6sqos=","dev":true,"requires":{"babel-helper-function-name":"6.24.1","babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-literals":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-literals/-/babel-plugin-transform-es2015-literals-6.22.0.tgz","integrity":"sha1-T1SgLWzWbPkVKAAZox0xklN3yi4=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-modules-amd":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-modules-amd/-/babel-plugin-transform-es2015-modules-amd-6.24.1.tgz","integrity":"sha1-Oz5UAXI5hC1tGcMBHEvS8AoA0VQ=","dev":true,"requires":{"babel-plugin-transform-es2015-modules-commonjs":"6.26.0","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-modules-commonjs":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-modules-commonjs/-/babel-plugin-transform-es2015-modules-commonjs-6.26.0.tgz","integrity":"sha1-DYOUApt9xqvhqX7xgeAHWN0uXYo=","dev":true,"requires":{"babel-plugin-transform-strict-mode":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-modules-systemjs":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-modules-systemjs/-/babel-plugin-transform-es2015-modules-systemjs-6.24.1.tgz","integrity":"sha1-/4mhQrkRmpBhlfXxBuzzBdlAfSM=","dev":true,"requires":{"babel-helper-hoist-variables":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-modules-umd":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-modules-umd/-/babel-plugin-transform-es2015-modules-umd-6.24.1.tgz","integrity":"sha1-rJl+YoXNGO1hdq22B9YCNErThGg=","dev":true,"requires":{"babel-plugin-transform-es2015-modules-amd":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-object-super":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-object-super/-/babel-plugin-transform-es2015-object-super-6.24.1.tgz","integrity":"sha1-JM72muIcuDp/hgPa0CH1cusnj40=","dev":true,"requires":{"babel-helper-replace-supers":"6.24.1","babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-parameters":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-parameters/-/babel-plugin-transform-es2015-parameters-6.24.1.tgz","integrity":"sha1-V6w1GrScrxSpfNE7CfZv3wpiXys=","dev":true,"requires":{"babel-helper-call-delegate":"6.24.1","babel-helper-get-function-arity":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-shorthand-properties":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-shorthand-properties/-/babel-plugin-transform-es2015-shorthand-properties-6.24.1.tgz","integrity":"sha1-JPh11nIch2YbvZmkYi5R8U3jiqA=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-spread":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-spread/-/babel-plugin-transform-es2015-spread-6.22.0.tgz","integrity":"sha1-1taKmfia7cRTbIGlQujdnxdG+NE=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-sticky-regex":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-sticky-regex/-/babel-plugin-transform-es2015-sticky-regex-6.24.1.tgz","integrity":"sha1-AMHNsaynERLN8M9hJsLta0V8zbw=","dev":true,"requires":{"babel-helper-regex":"6.26.0","babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-template-literals":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-template-literals/-/babel-plugin-transform-es2015-template-literals-6.22.0.tgz","integrity":"sha1-qEs0UPfp+PH2g51taH2oS7EjbY0=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-typeof-symbol":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-typeof-symbol/-/babel-plugin-transform-es2015-typeof-symbol-6.23.0.tgz","integrity":"sha1-3sCfHN3/lLUqxz1QXITfWdzOs3I=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-unicode-regex":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-unicode-regex/-/babel-plugin-transform-es2015-unicode-regex-6.24.1.tgz","integrity":"sha1-04sS9C6nMj9yk4fxinxa4frrNek=","dev":true,"requires":{"babel-helper-regex":"6.26.0","babel-runtime":"6.26.0","regexpu-core":"2.0.0"}},"babel-plugin-transform-exponentiation-operator":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-exponentiation-operator/-/babel-plugin-transform-exponentiation-operator-6.24.1.tgz","integrity":"sha1-KrDJx/MJj6SJB3cruBP+QejeOg4=","dev":true,"requires":{"babel-helper-builder-binary-assignment-operator-visitor":"6.24.1","babel-plugin-syntax-exponentiation-operator":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-export-extensions":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-export-extensions/-/babel-plugin-transform-export-extensions-6.22.0.tgz","integrity":"sha1-U3OLR+deghhYnuqUbLvTkQm75lM=","dev":true,"requires":{"babel-plugin-syntax-export-extensions":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-flow-strip-types":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-flow-strip-types/-/babel-plugin-transform-flow-strip-types-6.22.0.tgz","integrity":"sha1-hMtnKTXUNxT9wyvOhFaNh0Qc988=","dev":true,"requires":{"babel-plugin-syntax-flow":"6.18.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-object-rest-spread":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-object-rest-spread/-/babel-plugin-transform-object-rest-spread-6.26.0.tgz","integrity":"sha1-DzZpLVD+9rfi1LOsFHgTepY7ewY=","dev":true,"requires":{"babel-plugin-syntax-object-rest-spread":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-react-display-name":{"version":"6.25.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-react-display-name/-/babel-plugin-transform-react-display-name-6.25.0.tgz","integrity":"sha1-Z+K/Hx6ck6sI25Z5LgU5K/LMKNE=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-react-jsx":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-react-jsx/-/babel-plugin-transform-react-jsx-6.24.1.tgz","integrity":"sha1-hAoCjn30YN/DotKfDA2R9jduZqM=","dev":true,"requires":{"babel-helper-builder-react-jsx":"6.26.0","babel-plugin-syntax-jsx":"6.18.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-react-jsx-self":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-react-jsx-self/-/babel-plugin-transform-react-jsx-self-6.22.0.tgz","integrity":"sha1-322AqdomEqEh5t3XVYvL7PBuY24=","dev":true,"requires":{"babel-plugin-syntax-jsx":"6.18.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-react-jsx-source":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-react-jsx-source/-/babel-plugin-transform-react-jsx-source-6.22.0.tgz","integrity":"sha1-ZqwSFT9c0tF7PBkmj0vwGX9E7NY=","dev":true,"requires":{"babel-plugin-syntax-jsx":"6.18.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-regenerator":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-regenerator/-/babel-plugin-transform-regenerator-6.26.0.tgz","integrity":"sha1-4HA2lvveJ/Cj78rPi03KL3s6jy8=","dev":true,"requires":{"regenerator-transform":"0.10.1"}},"babel-plugin-transform-require-ignore":{"version":"0.1.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-require-ignore/-/babel-plugin-transform-require-ignore-0.1.1.tgz","integrity":"sha512-A7EmlVd3ZYWJI3eg3dklAXn1yfq8Y5omHMQgAUo0FwGLYRuL5daLR6+LtCVHi4f9+fStr7HuPkW9rmKtcmY67w==","dev":true},"babel-plugin-transform-runtime":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-runtime/-/babel-plugin-transform-runtime-6.23.0.tgz","integrity":"sha1-iEkNRGUC6puOfvsP4J7E2ZR5se4=","dev":true,"requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-strict-mode":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-strict-mode/-/babel-plugin-transform-strict-mode-6.24.1.tgz","integrity":"sha1-1fr3qleKZbvlkc9e2uBKDGcCB1g=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-polyfill":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-polyfill/-/babel-polyfill-6.26.0.tgz","integrity":"sha1-N5k3q8Z9eJWXCtxiHyhM2WbPIVM=","dev":true,"requires":{"babel-runtime":"6.26.0","core-js":"2.5.3","regenerator-runtime":"0.10.5"},"dependencies":{"core-js":{"version":"2.5.3","resolved":"https://registry.npmjs.org/core-js/-/core-js-2.5.3.tgz","integrity":"sha1-isw4NFgk8W2DZbfJtCWRaOjtYD4=","dev":true},"regenerator-runtime":{"version":"0.10.5","resolved":"https://registry.npmjs.org/regenerator-runtime/-/regenerator-runtime-0.10.5.tgz","integrity":"sha1-M2w+/BIgrc7dosn6tntaeVWjNlg=","dev":true}}},"babel-preset-es2015":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-es2015/-/babel-preset-es2015-6.24.1.tgz","integrity":"sha1-1EBQ1rwsn+6nAqrzjXJ6AhBTiTk=","dev":true,"requires":{"babel-plugin-check-es2015-constants":"6.22.0","babel-plugin-transform-es2015-arrow-functions":"6.22.0","babel-plugin-transform-es2015-block-scoped-functions":"6.22.0","babel-plugin-transform-es2015-block-scoping":"6.26.0","babel-plugin-transform-es2015-classes":"6.24.1","babel-plugin-transform-es2015-computed-properties":"6.24.1","babel-plugin-transform-es2015-destructuring":"6.23.0","babel-plugin-transform-es2015-duplicate-keys":"6.24.1","babel-plugin-transform-es2015-for-of":"6.23.0","babel-plugin-transform-es2015-function-name":"6.24.1","babel-plugin-transform-es2015-literals":"6.22.0","babel-plugin-transform-es2015-modules-amd":"6.24.1","babel-plugin-transform-es2015-modules-commonjs":"6.26.0","babel-plugin-transform-es2015-modules-systemjs":"6.24.1","babel-plugin-transform-es2015-modules-umd":"6.24.1","babel-plugin-transform-es2015-object-super":"6.24.1","babel-plugin-transform-es2015-parameters":"6.24.1","babel-plugin-transform-es2015-shorthand-properties":"6.24.1","babel-plugin-transform-es2015-spread":"6.22.0","babel-plugin-transform-es2015-sticky-regex":"6.24.1","babel-plugin-transform-es2015-template-literals":"6.22.0","babel-plugin-transform-es2015-typeof-symbol":"6.23.0","babel-plugin-transform-es2015-unicode-regex":"6.24.1","babel-plugin-transform-regenerator":"6.26.0"}},"babel-preset-flow":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-preset-flow/-/babel-preset-flow-6.23.0.tgz","integrity":"sha1-5xIYiHCFrpoktb5Baa/7WZgWxJ0=","dev":true,"requires":{"babel-plugin-transform-flow-strip-types":"6.22.0"}},"babel-preset-react":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-react/-/babel-preset-react-6.24.1.tgz","integrity":"sha1-umnfrqRfw+xjm2pOzqbhdwLJE4A=","dev":true,"requires":{"babel-plugin-syntax-jsx":"6.18.0","babel-plugin-transform-react-display-name":"6.25.0","babel-plugin-transform-react-jsx":"6.24.1","babel-plugin-transform-react-jsx-self":"6.22.0","babel-plugin-transform-react-jsx-source":"6.22.0","babel-preset-flow":"6.23.0"}},"babel-preset-stage-1":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-stage-1/-/babel-preset-stage-1-6.24.1.tgz","integrity":"sha1-dpLNfc1oSZB+auSgqFWJz7niv7A=","dev":true,"requires":{"babel-plugin-transform-class-constructor-call":"6.24.1","babel-plugin-transform-export-extensions":"6.22.0","babel-preset-stage-2":"6.24.1"}},"babel-preset-stage-2":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-stage-2/-/babel-preset-stage-2-6.24.1.tgz","integrity":"sha1-2eKWD7PXEYfw5k7sYrwHdnIZvcE=","dev":true,"requires":{"babel-plugin-syntax-dynamic-import":"6.18.0","babel-plugin-transform-class-properties":"6.24.1","babel-plugin-transform-decorators":"6.24.1","babel-preset-stage-3":"6.24.1"}},"babel-preset-stage-3":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-stage-3/-/babel-preset-stage-3-6.24.1.tgz","integrity":"sha1-g2raCp56f6N8sTj7kyb4eTSkg5U=","dev":true,"requires":{"babel-plugin-syntax-trailing-function-commas":"6.22.0","babel-plugin-transform-async-generator-functions":"6.24.1","babel-plugin-transform-async-to-generator":"6.24.1","babel-plugin-transform-exponentiation-operator":"6.24.1","babel-plugin-transform-object-rest-spread":"6.26.0"}},"babel-register":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-register/-/babel-register-6.26.0.tgz","integrity":"sha1-btAhFz4vy0htestFxgCahW9kcHE=","dev":true,"requires":{"babel-core":"6.26.0","babel-runtime":"6.26.0","core-js":"2.5.3","home-or-tmp":"2.0.0","lodash":"4.17.4","mkdirp":"0.5.1","source-map-support":"0.4.18"},"dependencies":{"core-js":{"version":"2.5.3","resolved":"https://registry.npmjs.org/core-js/-/core-js-2.5.3.tgz","integrity":"sha1-isw4NFgk8W2DZbfJtCWRaOjtYD4=","dev":true}}},"babel-runtime":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-runtime/-/babel-runtime-6.26.0.tgz","integrity":"sha1-llxwWGaOgrVde/4E/yM3vItWR/4=","dev":true,"requires":{"core-js":"2.5.3","regenerator-runtime":"0.11.1"},"dependencies":{"core-js":{"version":"2.5.3","resolved":"https://registry.npmjs.org/core-js/-/core-js-2.5.3.tgz","integrity":"sha1-isw4NFgk8W2DZbfJtCWRaOjtYD4=","dev":true}}},"babel-template":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-template/-/babel-template-6.26.0.tgz","integrity":"sha1-3gPi0WOWsGn0bdn/+FIfsaDjXgI=","dev":true,"requires":{"babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0","babylon":"6.18.0","lodash":"4.17.4"}},"babel-traverse":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-traverse/-/babel-traverse-6.26.0.tgz","integrity":"sha1-RqnL1+3MYsjlwGTi0tjQ9ANXZu4=","dev":true,"requires":{"babel-code-frame":"6.26.0","babel-messages":"6.23.0","babel-runtime":"6.26.0","babel-types":"6.26.0","babylon":"6.18.0","debug":"2.6.9","globals":"9.18.0","invariant":"2.2.2","lodash":"4.17.4"}},"babel-types":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-types/-/babel-types-6.26.0.tgz","integrity":"sha1-o7Bz+Uq0nrb6Vc1lInozQ4BjJJc=","dev":true,"requires":{"babel-runtime":"6.26.0","esutils":"2.0.2","lodash":"4.17.4","to-fast-properties":"1.0.3"}},"babylon":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babylon/-/babylon-6.18.0.tgz","integrity":"sha512-q/UEjfGJ2Cm3oKV71DJz9d25TPnq5rhBVL2Q4fA5wcC3jcrdn7+SssEybFIxwAvvP+YCsCYNKughoF33GxgycQ==","dev":true},"balanced-match":{"version":"1.0.0","resolved":"https://registry.npmjs.org/balanced-match/-/balanced-match-1.0.0.tgz","integrity":"sha1-ibTRmasr7kneFk6gK4nORi1xt2c=","dev":true},"binary-extensions":{"version":"1.11.0","resolved":"https://registry.npmjs.org/binary-extensions/-/binary-extensions-1.11.0.tgz","integrity":"sha1-RqoXUftqL5PuXmibsQh9SxTGwgU=","dev":true,"optional":true},"boolbase":{"version":"1.0.0","resolved":"https://registry.npmjs.org/boolbase/-/boolbase-1.0.0.tgz","integrity":"sha1-aN/1++YMUes3cl6p4+0xDcwed24=","dev":true},"brace-expansion":{"version":"1.1.8","resolved":"https://registry.npmjs.org/brace-expansion/-/brace-expansion-1.1.8.tgz","integrity":"sha1-wHshHHyVLsH479Uad+8NHTmQopI=","dev":true,"requires":{"balanced-match":"1.0.0","concat-map":"0.0.1"}},"braces":{"version":"1.8.5","resolved":"https://registry.npmjs.org/braces/-/braces-1.8.5.tgz","integrity":"sha1-uneWLhLf+WnWt2cR6RS3N4V79qc=","dev":true,"optional":true,"requires":{"expand-range":"1.8.2","preserve":"0.2.0","repeat-element":"1.1.2"}},"builtin-modules":{"version":"1.1.1","resolved":"https://registry.npmjs.org/builtin-modules/-/builtin-modules-1.1.1.tgz","integrity":"sha1-Jw8HbFpywC9bZaR9+Uxf46J4iS8=","dev":true},"camelcase":{"version":"2.1.1","resolved":"https://registry.npmjs.org/camelcase/-/camelcase-2.1.1.tgz","integrity":"sha1-fB0W1nmhu+WcoCys7PsBHiAfWh8=","dev":true},"camelcase-keys":{"version":"2.1.0","resolved":"https://registry.npmjs.org/camelcase-keys/-/camelcase-keys-2.1.0.tgz","integrity":"sha1-MIvur/3ygRkFHvodkyITyRuPkuc=","dev":true,"requires":{"camelcase":"2.1.1","map-obj":"1.0.1"}},"chalk":{"version":"1.1.3","resolved":"https://registry.npmjs.org/chalk/-/chalk-1.1.3.tgz","integrity":"sha1-qBFcVeSnAv5NFQq9OHKCKn4J/Jg=","dev":true,"requires":{"ansi-styles":"2.2.1","escape-string-regexp":"1.0.5","has-ansi":"2.0.0","strip-ansi":"3.0.1","supports-color":"2.0.0"}},"cheerio":{"version":"0.22.0","resolved":"https://registry.npmjs.org/cheerio/-/cheerio-0.22.0.tgz","integrity":"sha1-qbqoYKP5tZWmuBsahocxIe06Jp4=","dev":true,"requires":{"css-select":"1.2.0","dom-serializer":"0.1.0","entities":"1.1.1","htmlparser2":"3.9.2","lodash.assignin":"4.2.0","lodash.bind":"4.2.1","lodash.defaults":"4.2.0","lodash.filter":"4.6.0","lodash.flatten":"4.4.0","lodash.foreach":"4.5.0","lodash.map":"4.6.0","lodash.merge":"4.6.0","lodash.pick":"4.4.0","lodash.reduce":"4.6.0","lodash.reject":"4.6.0","lodash.some":"4.6.0"}},"chokidar":{"version":"1.7.0","resolved":"https://registry.npmjs.org/chokidar/-/chokidar-1.7.0.tgz","integrity":"sha1-eY5ol3gVHIB2tLNg5e3SjNortGg=","dev":true,"optional":true,"requires":{"anymatch":"1.3.2","async-each":"1.0.1","fsevents":"1.1.3","glob-parent":"2.0.0","inherits":"2.0.3","is-binary-path":"1.0.1","is-glob":"2.0.1","path-is-absolute":"1.0.1","readdirp":"2.1.0"}},"clean-stack":{"version":"1.3.0","resolved":"https://registry.npmjs.org/clean-stack/-/clean-stack-1.3.0.tgz","integrity":"sha1-noIVAa6XmYbEax1m0tQy2y/UrjE=","dev":true},"cloner":{"version":"git+https://github.com/cellvia/cloner.git#0d896e0d8aa875a6007971ddd34c84218d898309"},"commander":{"version":"2.13.0","resolved":"https://registry.npmjs.org/commander/-/commander-2.13.0.tgz","integrity":"sha512-MVuS359B+YzaWqjCL/c+22gfryv+mCBPHAv3zyVI2GN8EY6IRP8VwtasXn8jyyhvvq84R4ImN1OKRtcbIasjYA==","dev":true},"component-testing-tools":{"version":"git+https://gitlab.com/regiscompany/component-testing-tools.git#cf528c7fee68e668bbf9b4124faa8d4ed3e0a9b6","dev":true},"concat-map":{"version":"0.0.1","resolved":"https://registry.npmjs.org/concat-map/-/concat-map-0.0.1.tgz","integrity":"sha1-2Klr13/Wjfd5OnMDajug1UBdR3s=","dev":true},"convert-source-map":{"version":"1.5.1","resolved":"https://registry.npmjs.org/convert-source-map/-/convert-source-map-1.5.1.tgz","integrity":"sha1-uCeAl7m8IpNl3lxiz1/K7YtVmeU=","dev":true},"copyfiles":{"version":"1.2.0","resolved":"https://registry.npmjs.org/copyfiles/-/copyfiles-1.2.0.tgz","integrity":"sha1-qNo6xBqiIgrim9PFi2mEKU8sWTw=","dev":true,"requires":{"glob":"7.1.2","ltcdr":"2.2.1","minimatch":"3.0.4","mkdirp":"0.5.1","noms":"0.0.0","through2":"2.0.3"}},"core-js":{"version":"1.2.7","resolved":"https://registry.npmjs.org/core-js/-/core-js-1.2.7.tgz","integrity":"sha1-ZSKUwUZR2yj6k70tX/KYOk8IxjY="},"core-util-is":{"version":"1.0.2","resolved":"https://registry.npmjs.org/core-util-is/-/core-util-is-1.0.2.tgz","integrity":"sha1-tf1UIgqivFq1eqtxQMlAdUUDwac=","dev":true},"create-react-class":{"version":"15.6.2","resolved":"https://registry.npmjs.org/create-react-class/-/create-react-class-15.6.2.tgz","integrity":"sha1-zx7RXxKq1/FO9fLf4F5sQvke8Co=","requires":{"fbjs":"0.8.16","loose-envify":"1.3.1","object-assign":"4.1.1"}},"cross-env":{"version":"5.1.3","resolved":"https://registry.npmjs.org/cross-env/-/cross-env-5.1.3.tgz","integrity":"sha512-UOokgwvDzCT0mqRSLEkJzUhYXB1vK3E5UgDrD41QiXsm9UetcW2rCGHYz/O3p873lMJ1VZbFCF9Izkwh7nYR5A==","dev":true,"requires":{"cross-spawn":"5.1.0","is-windows":"1.0.1"}},"cross-spawn":{"version":"5.1.0","resolved":"https://registry.npmjs.org/cross-spawn/-/cross-spawn-5.1.0.tgz","integrity":"sha1-6L0O/uWPz/b4+UUQoKVUu/ojVEk=","dev":true,"requires":{"lru-cache":"4.1.1","shebang-command":"1.2.0","which":"1.3.0"}},"css-select":{"version":"1.2.0","resolved":"https://registry.npmjs.org/css-select/-/css-select-1.2.0.tgz","integrity":"sha1-KzoRBTnFNV8c2NMUYj6HCxIeyFg=","dev":true,"requires":{"boolbase":"1.0.0","css-what":"2.1.0","domutils":"1.5.1","nth-check":"1.0.1"}},"css-what":{"version":"2.1.0","resolved":"https://registry.npmjs.org/css-what/-/css-what-2.1.0.tgz","integrity":"sha1-lGfQMsOM+u+58teVASUwYvh/ob0=","dev":true},"currently-unhandled":{"version":"0.4.1","resolved":"https://registry.npmjs.org/currently-unhandled/-/currently-unhandled-0.4.1.tgz","integrity":"sha1-mI3zP+qxke95mmE2nddsF635V+o=","dev":true,"requires":{"array-find-index":"1.0.2"}},"debug":{"version":"2.6.9","resolved":"https://registry.npmjs.org/debug/-/debug-2.6.9.tgz","integrity":"sha512-bC7ElrdJaJnPbAP+1EotYvqZsb3ecl5wi6Bfi6BJTUcNowp6cvspg0jXznRTKDjm/E7AdgFBVeAPVMNcKGsHMA==","dev":true,"requires":{"ms":"2.0.0"}},"decamelize":{"version":"1.2.0","resolved":"https://registry.npmjs.org/decamelize/-/decamelize-1.2.0.tgz","integrity":"sha1-9lNNFRSCabIDUue+4m9QH5oZEpA=","dev":true},"decompress-response":{"version":"3.3.0","resolved":"https://registry.npmjs.org/decompress-response/-/decompress-response-3.3.0.tgz","integrity":"sha1-gKTdMjdIOEv6JICDYirt7Jgq3/M=","dev":true,"requires":{"mimic-response":"1.0.0"}},"deep-bind-decorator":{"version":"git+https://gitlab.com/regiscompany/deep-bind-decorator.git#1f0d4e74054afaae21ebb9685a39ac5792847de1","requires":{"cloner":"git+https://github.com/cellvia/cloner.git#0d896e0d8aa875a6007971ddd34c84218d898309","traverse":"0.6.6"}},"deep-equal":{"version":"1.0.1","resolved":"https://registry.npmjs.org/deep-equal/-/deep-equal-1.0.1.tgz","integrity":"sha1-9dJgKStmDghO/0zbyfCK0yR0SLU=","dev":true},"deep-extend":{"version":"0.5.0","resolved":"https://registry.npmjs.org/deep-extend/-/deep-extend-0.5.0.tgz","integrity":"sha1-bvSgmwX5iw41jW2T1Mo8rsZnKAM=","dev":true},"define-properties":{"version":"1.1.2","resolved":"https://registry.npmjs.org/define-properties/-/define-properties-1.1.2.tgz","integrity":"sha1-g6c/L+pWmJj7c3GTyPhzyvbUXJQ=","dev":true,"requires":{"foreach":"2.0.5","object-keys":"1.0.11"}},"defined":{"version":"1.0.0","resolved":"https://registry.npmjs.org/defined/-/defined-1.0.0.tgz","integrity":"sha1-yY2bzvdWdBiOEQlpFRGZ45sfppM=","dev":true},"detect-indent":{"version":"4.0.0","resolved":"https://registry.npmjs.org/detect-indent/-/detect-indent-4.0.0.tgz","integrity":"sha1-920GQ1LN9Docts5hnE7jqUdd4gg=","dev":true,"requires":{"repeating":"2.0.1"}},"dom-serializer":{"version":"0.1.0","resolved":"https://registry.npmjs.org/dom-serializer/-/dom-serializer-0.1.0.tgz","integrity":"sha1-BzxpdUbOB4DOI75KKOKT5AvDDII=","dev":true,"requires":{"domelementtype":"1.1.3","entities":"1.1.1"},"dependencies":{"domelementtype":{"version":"1.1.3","resolved":"https://registry.npmjs.org/domelementtype/-/domelementtype-1.1.3.tgz","integrity":"sha1-vSh3PiZCiBrsUVRJJCmcXNgiGFs=","dev":true}}},"domelementtype":{"version":"1.3.0","resolved":"https://registry.npmjs.org/domelementtype/-/domelementtype-1.3.0.tgz","integrity":"sha1-sXrtguirWeUt2cGbF1bg/BhyBMI=","dev":true},"domhandler":{"version":"2.4.1","resolved":"https://registry.npmjs.org/domhandler/-/domhandler-2.4.1.tgz","integrity":"sha1-iS5HAAqZvlW783dP/qBWHYh5wlk=","dev":true,"requires":{"domelementtype":"1.3.0"}},"domutils":{"version":"1.5.1","resolved":"https://registry.npmjs.org/domutils/-/domutils-1.5.1.tgz","integrity":"sha1-3NhIiib1Y9YQeeSMn3t+Mjc2gs8=","dev":true,"requires":{"dom-serializer":"0.1.0","domelementtype":"1.3.0"}},"duplexer3":{"version":"0.1.4","resolved":"https://registry.npmjs.org/duplexer3/-/duplexer3-0.1.4.tgz","integrity":"sha1-7gHdHKwO08vH/b6jfcCo8c4ALOI=","dev":true},"encoding":{"version":"0.1.12","resolved":"https://registry.npmjs.org/encoding/-/encoding-0.1.12.tgz","integrity":"sha1-U4tm8+5izRq1HsMjgp0flIDHS+s=","requires":{"iconv-lite":"0.4.19"}},"entities":{"version":"1.1.1","resolved":"https://registry.npmjs.org/entities/-/entities-1.1.1.tgz","integrity":"sha1-blwtClYhtdra7O+AuQ7ftc13cvA=","dev":true},"enzyme":{"version":"2.9.1","resolved":"https://registry.npmjs.org/enzyme/-/enzyme-2.9.1.tgz","integrity":"sha1-B9XOaRJBJA+4F78sSxjW5TAkDfY=","dev":true,"requires":{"cheerio":"0.22.0","function.prototype.name":"1.1.0","is-subset":"0.1.1","lodash":"4.17.4","object-is":"1.0.1","object.assign":"4.1.0","object.entries":"1.0.4","object.values":"1.0.4","prop-types":"15.6.0","uuid":"3.2.1"}},"error-ex":{"version":"1.3.1","resolved":"https://registry.npmjs.org/error-ex/-/error-ex-1.3.1.tgz","integrity":"sha1-+FWobOYa3E6GIcPNoh56dhLDqNw=","dev":true,"requires":{"is-arrayish":"0.2.1"}},"es-abstract":{"version":"1.10.0","resolved":"https://registry.npmjs.org/es-abstract/-/es-abstract-1.10.0.tgz","integrity":"sha512-/uh/DhdqIOSkAWifU+8nG78vlQxdLckUdI/sPgy0VhuXi2qJ7T8czBmqIYtLQVpCIFYafChnsRsB5pyb1JdmCQ==","dev":true,"requires":{"es-to-primitive":"1.1.1","function-bind":"1.1.1","has":"1.0.1","is-callable":"1.1.3","is-regex":"1.0.4"}},"es-to-primitive":{"version":"1.1.1","resolved":"https://registry.npmjs.org/es-to-primitive/-/es-to-primitive-1.1.1.tgz","integrity":"sha1-RTVSSKiJeQNLZ5Lhm7gfK3l13Q0=","dev":true,"requires":{"is-callable":"1.1.3","is-date-object":"1.0.1","is-symbol":"1.0.1"}},"escape-string-regexp":{"version":"1.0.5","resolved":"https://registry.npmjs.org/escape-string-regexp/-/escape-string-regexp-1.0.5.tgz","integrity":"sha1-G2HAViGQqN/2rjuyzwIAyhMLhtQ=","dev":true},"esutils":{"version":"2.0.2","resolved":"https://registry.npmjs.org/esutils/-/esutils-2.0.2.tgz","integrity":"sha1-Cr9PHKpbyx96nYrMbepPqqBLrJs=","dev":true},"exec-sh":{"version":"0.2.1","resolved":"https://registry.npmjs.org/exec-sh/-/exec-sh-0.2.1.tgz","integrity":"sha512-aLt95pexaugVtQerpmE51+4QfWrNc304uez7jvj6fWnN8GeEHpttB8F36n8N7uVhUMbH/1enbxQ9HImZ4w/9qg==","dev":true,"requires":{"merge":"1.2.0"}},"expand-brackets":{"version":"0.1.5","resolved":"https://registry.npmjs.org/expand-brackets/-/expand-brackets-0.1.5.tgz","integrity":"sha1-3wcoTjQqgHzXM6xa9yQR5YHRF3s=","dev":true,"optional":true,"requires":{"is-posix-bracket":"0.1.1"}},"expand-range":{"version":"1.8.2","resolved":"https://registry.npmjs.org/expand-range/-/expand-range-1.8.2.tgz","integrity":"sha1-opnv/TNf4nIeuujiV+x5ZE/IUzc=","dev":true,"optional":true,"requires":{"fill-range":"2.2.3"}},"extglob":{"version":"0.3.2","resolved":"https://registry.npmjs.org/extglob/-/extglob-0.3.2.tgz","integrity":"sha1-Lhj/PS9JqydlzskCPwEdqo2DSaE=","dev":true,"optional":true,"requires":{"is-extglob":"1.0.0"}},"fbjs":{"version":"0.8.16","resolved":"https://registry.npmjs.org/fbjs/-/fbjs-0.8.16.tgz","integrity":"sha1-XmdDL1UNxBtXK/VYR7ispk5TN9s=","requires":{"core-js":"1.2.7","isomorphic-fetch":"2.2.1","loose-envify":"1.3.1","object-assign":"4.1.1","promise":"7.3.1","setimmediate":"1.0.5","ua-parser-js":"0.7.17"}},"filename-regex":{"version":"2.0.1","resolved":"https://registry.npmjs.org/filename-regex/-/filename-regex-2.0.1.tgz","integrity":"sha1-wcS5vuPglyXdsQa3XB4wH+LxiyY=","dev":true,"optional":true},"fill-range":{"version":"2.2.3","resolved":"https://registry.npmjs.org/fill-range/-/fill-range-2.2.3.tgz","integrity":"sha1-ULd9/X5Gm8dJJHCWNpn+eoSFpyM=","dev":true,"optional":true,"requires":{"is-number":"2.1.0","isobject":"2.1.0","randomatic":"1.1.7","repeat-element":"1.1.2","repeat-string":"1.6.1"}},"find-babel-config":{"version":"1.1.0","resolved":"https://registry.npmjs.org/find-babel-config/-/find-babel-config-1.1.0.tgz","integrity":"sha1-rMAQQ6Z0n+w0Qpvmtk9ULrtdY1U=","dev":true,"requires":{"json5":"0.5.1","path-exists":"3.0.0"}},"find-up":{"version":"2.1.0","resolved":"https://registry.npmjs.org/find-up/-/find-up-2.1.0.tgz","integrity":"sha1-RdG35QbHF93UgndaK3eSCjwMV6c=","dev":true,"requires":{"locate-path":"2.0.0"}},"for-in":{"version":"1.0.2","resolved":"https://registry.npmjs.org/for-in/-/for-in-1.0.2.tgz","integrity":"sha1-gQaNKVqBQuwKxybG4iAMMPttXoA=","dev":true,"optional":true},"for-own":{"version":"0.1.5","resolved":"https://registry.npmjs.org/for-own/-/for-own-0.1.5.tgz","integrity":"sha1-UmXGgaTylNq78XyVCbZ2OqhFEM4=","dev":true,"optional":true,"requires":{"for-in":"1.0.2"}},"foreach":{"version":"2.0.5","resolved":"https://registry.npmjs.org/foreach/-/foreach-2.0.5.tgz","integrity":"sha1-C+4AUBiusmDQo6865ljdATbsG5k=","dev":true},"fs-readdir-recursive":{"version":"1.1.0","resolved":"https://registry.npmjs.org/fs-readdir-recursive/-/fs-readdir-recursive-1.1.0.tgz","integrity":"sha512-GNanXlVr2pf02+sPN40XN8HG+ePaNcvM0q5mZBd668Obwb0yD5GiUbZOFgwn8kGMY6I3mdyDJzieUy3PTYyTRA==","dev":true},"fs.realpath":{"version":"1.0.0","resolved":"https://registry.npmjs.org/fs.realpath/-/fs.realpath-1.0.0.tgz","integrity":"sha1-FQStJSMVjKpA20onh8sBQRmU6k8=","dev":true},"fsevents":{"version":"1.1.3","resolved":"https://registry.npmjs.org/fsevents/-/fsevents-1.1.3.tgz","integrity":"sha512-WIr7iDkdmdbxu/Gh6eKEZJL6KPE74/5MEsf2whTOFNxbIoIixogroLdKYqB6FDav4Wavh/lZdzzd3b2KxIXC5Q==","dev":true,"optional":true,"requires":{"nan":"2.8.0","node-pre-gyp":"0.6.39"},"dependencies":{"abbrev":{"version":"1.1.0","bundled":true,"dev":true,"optional":true},"ajv":{"version":"4.11.8","bundled":true,"dev":true,"optional":true,"requires":{"co":"4.6.0","json-stable-stringify":"1.0.1"}},"ansi-regex":{"version":"2.1.1","bundled":true,"dev":true},"aproba":{"version":"1.1.1","bundled":true,"dev":true,"optional":true},"are-we-there-yet":{"version":"1.1.4","bundled":true,"dev":true,"optional":true,"requires":{"delegates":"1.0.0","readable-stream":"2.2.9"}},"asn1":{"version":"0.2.3","bundled":true,"dev":true,"optional":true},"assert-plus":{"version":"0.2.0","bundled":true,"dev":true,"optional":true},"asynckit":{"version":"0.4.0","bundled":true,"dev":true,"optional":true},"aws-sign2":{"version":"0.6.0","bundled":true,"dev":true,"optional":true},"aws4":{"version":"1.6.0","bundled":true,"dev":true,"optional":true},"balanced-match":{"version":"0.4.2","bundled":true,"dev":true},"bcrypt-pbkdf":{"version":"1.0.1","bundled":true,"dev":true,"optional":true,"requires":{"tweetnacl":"0.14.5"}},"block-stream":{"version":"0.0.9","bundled":true,"dev":true,"requires":{"inherits":"2.0.3"}},"boom":{"version":"2.10.1","bundled":true,"dev":true,"requires":{"hoek":"2.16.3"}},"brace-expansion":{"version":"1.1.7","bundled":true,"dev":true,"requires":{"balanced-match":"0.4.2","concat-map":"0.0.1"}},"buffer-shims":{"version":"1.0.0","bundled":true,"dev":true},"caseless":{"version":"0.12.0","bundled":true,"dev":true,"optional":true},"co":{"version":"4.6.0","bundled":true,"dev":true,"optional":true},"code-point-at":{"version":"1.1.0","bundled":true,"dev":true},"combined-stream":{"version":"1.0.5","bundled":true,"dev":true,"requires":{"delayed-stream":"1.0.0"}},"concat-map":{"version":"0.0.1","bundled":true,"dev":true},"console-control-strings":{"version":"1.1.0","bundled":true,"dev":true},"core-util-is":{"version":"1.0.2","bundled":true,"dev":true},"cryptiles":{"version":"2.0.5","bundled":true,"dev":true,"requires":{"boom":"2.10.1"}},"dashdash":{"version":"1.14.1","bundled":true,"dev":true,"optional":true,"requires":{"assert-plus":"1.0.0"},"dependencies":{"assert-plus":{"version":"1.0.0","bundled":true,"dev":true,"optional":true}}},"debug":{"version":"2.6.8","bundled":true,"dev":true,"optional":true,"requires":{"ms":"2.0.0"}},"deep-extend":{"version":"0.4.2","bundled":true,"dev":true,"optional":true},"delayed-stream":{"version":"1.0.0","bundled":true,"dev":true},"delegates":{"version":"1.0.0","bundled":true,"dev":true,"optional":true},"detect-libc":{"version":"1.0.2","bundled":true,"dev":true,"optional":true},"ecc-jsbn":{"version":"0.1.1","bundled":true,"dev":true,"optional":true,"requires":{"jsbn":"0.1.1"}},"extend":{"version":"3.0.1","bundled":true,"dev":true,"optional":true},"extsprintf":{"version":"1.0.2","bundled":true,"dev":true},"forever-agent":{"version":"0.6.1","bundled":true,"dev":true,"optional":true},"form-data":{"version":"2.1.4","bundled":true,"dev":true,"optional":true,"requires":{"asynckit":"0.4.0","combined-stream":"1.0.5","mime-types":"2.1.15"}},"fs.realpath":{"version":"1.0.0","bundled":true,"dev":true},"fstream":{"version":"1.0.11","bundled":true,"dev":true,"requires":{"graceful-fs":"4.1.11","inherits":"2.0.3","mkdirp":"0.5.1","rimraf":"2.6.1"}},"fstream-ignore":{"version":"1.0.5","bundled":true,"dev":true,"optional":true,"requires":{"fstream":"1.0.11","inherits":"2.0.3","minimatch":"3.0.4"}},"gauge":{"version":"2.7.4","bundled":true,"dev":true,"optional":true,"requires":{"aproba":"1.1.1","console-control-strings":"1.1.0","has-unicode":"2.0.1","object-assign":"4.1.1","signal-exit":"3.0.2","string-width":"1.0.2","strip-ansi":"3.0.1","wide-align":"1.1.2"}},"getpass":{"version":"0.1.7","bundled":true,"dev":true,"optional":true,"requires":{"assert-plus":"1.0.0"},"dependencies":{"assert-plus":{"version":"1.0.0","bundled":true,"dev":true,"optional":true}}},"glob":{"version":"7.1.2","bundled":true,"dev":true,"requires":{"fs.realpath":"1.0.0","inflight":"1.0.6","inherits":"2.0.3","minimatch":"3.0.4","once":"1.4.0","path-is-absolute":"1.0.1"}},"graceful-fs":{"version":"4.1.11","bundled":true,"dev":true},"har-schema":{"version":"1.0.5","bundled":true,"dev":true,"optional":true},"har-validator":{"version":"4.2.1","bundled":true,"dev":true,"optional":true,"requires":{"ajv":"4.11.8","har-schema":"1.0.5"}},"has-unicode":{"version":"2.0.1","bundled":true,"dev":true,"optional":true},"hawk":{"version":"3.1.3","bundled":true,"dev":true,"requires":{"boom":"2.10.1","cryptiles":"2.0.5","hoek":"2.16.3","sntp":"1.0.9"}},"hoek":{"version":"2.16.3","bundled":true,"dev":true},"http-signature":{"version":"1.1.1","bundled":true,"dev":true,"optional":true,"requires":{"assert-plus":"0.2.0","jsprim":"1.4.0","sshpk":"1.13.0"}},"inflight":{"version":"1.0.6","bundled":true,"dev":true,"requires":{"once":"1.4.0","wrappy":"1.0.2"}},"inherits":{"version":"2.0.3","bundled":true,"dev":true},"ini":{"version":"1.3.4","bundled":true,"dev":true,"optional":true},"is-fullwidth-code-point":{"version":"1.0.0","bundled":true,"dev":true,"requires":{"number-is-nan":"1.0.1"}},"is-typedarray":{"version":"1.0.0","bundled":true,"dev":true,"optional":true},"isarray":{"version":"1.0.0","bundled":true,"dev":true},"isstream":{"version":"0.1.2","bundled":true,"dev":true,"optional":true},"jodid25519":{"version":"1.0.2","bundled":true,"dev":true,"optional":true,"requires":{"jsbn":"0.1.1"}},"jsbn":{"version":"0.1.1","bundled":true,"dev":true,"optional":true},"json-schema":{"version":"0.2.3","bundled":true,"dev":true,"optional":true},"json-stable-stringify":{"version":"1.0.1","bundled":true,"dev":true,"optional":true,"requires":{"jsonify":"0.0.0"}},"json-stringify-safe":{"version":"5.0.1","bundled":true,"dev":true,"optional":true},"jsonify":{"version":"0.0.0","bundled":true,"dev":true,"optional":true},"jsprim":{"version":"1.4.0","bundled":true,"dev":true,"optional":true,"requires":{"assert-plus":"1.0.0","extsprintf":"1.0.2","json-schema":"0.2.3","verror":"1.3.6"},"dependencies":{"assert-plus":{"version":"1.0.0","bundled":true,"dev":true,"optional":true}}},"mime-db":{"version":"1.27.0","bundled":true,"dev":true},"mime-types":{"version":"2.1.15","bundled":true,"dev":true,"requires":{"mime-db":"1.27.0"}},"minimatch":{"version":"3.0.4","bundled":true,"dev":true,"requires":{"brace-expansion":"1.1.7"}},"minimist":{"version":"0.0.8","bundled":true,"dev":true},"mkdirp":{"version":"0.5.1","bundled":true,"dev":true,"requires":{"minimist":"0.0.8"}},"ms":{"version":"2.0.0","bundled":true,"dev":true,"optional":true},"node-pre-gyp":{"version":"0.6.39","bundled":true,"dev":true,"optional":true,"requires":{"detect-libc":"1.0.2","hawk":"3.1.3","mkdirp":"0.5.1","nopt":"4.0.1","npmlog":"4.1.0","rc":"1.2.1","request":"2.81.0","rimraf":"2.6.1","semver":"5.3.0","tar":"2.2.1","tar-pack":"3.4.0"}},"nopt":{"version":"4.0.1","bundled":true,"dev":true,"optional":true,"requires":{"abbrev":"1.1.0","osenv":"0.1.4"}},"npmlog":{"version":"4.1.0","bundled":true,"dev":true,"optional":true,"requires":{"are-we-there-yet":"1.1.4","console-control-strings":"1.1.0","gauge":"2.7.4","set-blocking":"2.0.0"}},"number-is-nan":{"version":"1.0.1","bundled":true,"dev":true},"oauth-sign":{"version":"0.8.2","bundled":true,"dev":true,"optional":true},"object-assign":{"version":"4.1.1","bundled":true,"dev":true,"optional":true},"once":{"version":"1.4.0","bundled":true,"dev":true,"requires":{"wrappy":"1.0.2"}},"os-homedir":{"version":"1.0.2","bundled":true,"dev":true,"optional":true},"os-tmpdir":{"version":"1.0.2","bundled":true,"dev":true,"optional":true},"osenv":{"version":"0.1.4","bundled":true,"dev":true,"optional":true,"requires":{"os-homedir":"1.0.2","os-tmpdir":"1.0.2"}},"path-is-absolute":{"version":"1.0.1","bundled":true,"dev":true},"performance-now":{"version":"0.2.0","bundled":true,"dev":true,"optional":true},"process-nextick-args":{"version":"1.0.7","bundled":true,"dev":true},"punycode":{"version":"1.4.1","bundled":true,"dev":true,"optional":true},"qs":{"version":"6.4.0","bundled":true,"dev":true,"optional":true},"rc":{"version":"1.2.1","bundled":true,"dev":true,"optional":true,"requires":{"deep-extend":"0.4.2","ini":"1.3.4","minimist":"1.2.0","strip-json-comments":"2.0.1"},"dependencies":{"minimist":{"version":"1.2.0","bundled":true,"dev":true,"optional":true}}},"readable-stream":{"version":"2.2.9","bundled":true,"dev":true,"requires":{"buffer-shims":"1.0.0","core-util-is":"1.0.2","inherits":"2.0.3","isarray":"1.0.0","process-nextick-args":"1.0.7","string_decoder":"1.0.1","util-deprecate":"1.0.2"}},"request":{"version":"2.81.0","bundled":true,"dev":true,"optional":true,"requires":{"aws-sign2":"0.6.0","aws4":"1.6.0","caseless":"0.12.0","combined-stream":"1.0.5","extend":"3.0.1","forever-agent":"0.6.1","form-data":"2.1.4","har-validator":"4.2.1","hawk":"3.1.3","http-signature":"1.1.1","is-typedarray":"1.0.0","isstream":"0.1.2","json-stringify-safe":"5.0.1","mime-types":"2.1.15","oauth-sign":"0.8.2","performance-now":"0.2.0","qs":"6.4.0","safe-buffer":"5.0.1","stringstream":"0.0.5","tough-cookie":"2.3.2","tunnel-agent":"0.6.0","uuid":"3.0.1"}},"rimraf":{"version":"2.6.1","bundled":true,"dev":true,"requires":{"glob":"7.1.2"}},"safe-buffer":{"version":"5.0.1","bundled":true,"dev":true},"semver":{"version":"5.3.0","bundled":true,"dev":true,"optional":true},"set-blocking":{"version":"2.0.0","bundled":true,"dev":true,"optional":true},"signal-exit":{"version":"3.0.2","bundled":true,"dev":true,"optional":true},"sntp":{"version":"1.0.9","bundled":true,"dev":true,"requires":{"hoek":"2.16.3"}},"sshpk":{"version":"1.13.0","bundled":true,"dev":true,"optional":true,"requires":{"asn1":"0.2.3","assert-plus":"1.0.0","bcrypt-pbkdf":"1.0.1","dashdash":"1.14.1","ecc-jsbn":"0.1.1","getpass":"0.1.7","jodid25519":"1.0.2","jsbn":"0.1.1","tweetnacl":"0.14.5"},"dependencies":{"assert-plus":{"version":"1.0.0","bundled":true,"dev":true,"optional":true}}},"string-width":{"version":"1.0.2","bundled":true,"dev":true,"requires":{"code-point-at":"1.1.0","is-fullwidth-code-point":"1.0.0","strip-ansi":"3.0.1"}},"string_decoder":{"version":"1.0.1","bundled":true,"dev":true,"requires":{"safe-buffer":"5.0.1"}},"stringstream":{"version":"0.0.5","bundled":true,"dev":true,"optional":true},"strip-ansi":{"version":"3.0.1","bundled":true,"dev":true,"requires":{"ansi-regex":"2.1.1"}},"strip-json-comments":{"version":"2.0.1","bundled":true,"dev":true,"optional":true},"tar":{"version":"2.2.1","bundled":true,"dev":true,"requires":{"block-stream":"0.0.9","fstream":"1.0.11","inherits":"2.0.3"}},"tar-pack":{"version":"3.4.0","bundled":true,"dev":true,"optional":true,"requires":{"debug":"2.6.8","fstream":"1.0.11","fstream-ignore":"1.0.5","once":"1.4.0","readable-stream":"2.2.9","rimraf":"2.6.1","tar":"2.2.1","uid-number":"0.0.6"}},"tough-cookie":{"version":"2.3.2","bundled":true,"dev":true,"optional":true,"requires":{"punycode":"1.4.1"}},"tunnel-agent":{"version":"0.6.0","bundled":true,"dev":true,"optional":true,"requires":{"safe-buffer":"5.0.1"}},"tweetnacl":{"version":"0.14.5","bundled":true,"dev":true,"optional":true},"uid-number":{"version":"0.0.6","bundled":true,"dev":true,"optional":true},"util-deprecate":{"version":"1.0.2","bundled":true,"dev":true},"uuid":{"version":"3.0.1","bundled":true,"dev":true,"optional":true},"verror":{"version":"1.3.6","bundled":true,"dev":true,"optional":true,"requires":{"extsprintf":"1.0.2"}},"wide-align":{"version":"1.1.2","bundled":true,"dev":true,"optional":true,"requires":{"string-width":"1.0.2"}},"wrappy":{"version":"1.0.2","bundled":true,"dev":true}}},"function-bind":{"version":"1.1.1","resolved":"https://registry.npmjs.org/function-bind/-/function-bind-1.1.1.tgz","integrity":"sha512-yIovAzMX49sF8Yl58fSCWJ5svSLuaibPxXQJFLmBObTuCr0Mf1KiPopGM9NiFjiYBCbfaa2Fh6breQ6ANVTI0A==","dev":true},"function.prototype.name":{"version":"1.1.0","resolved":"https://registry.npmjs.org/function.prototype.name/-/function.prototype.name-1.1.0.tgz","integrity":"sha512-Bs0VRrTz4ghD8pTmbJQD1mZ8A/mN0ur/jGz+A6FBxPDUPkm1tNfF6bhTYPA7i7aF4lZJVr+OXTNNrnnIl58Wfg==","dev":true,"requires":{"define-properties":"1.1.2","function-bind":"1.1.1","is-callable":"1.1.3"}},"get-stdin":{"version":"4.0.1","resolved":"https://registry.npmjs.org/get-stdin/-/get-stdin-4.0.1.tgz","integrity":"sha1-uWjGsKBDhDJJAui/Gl3zJXmkUP4=","dev":true},"get-stream":{"version":"3.0.0","resolved":"https://registry.npmjs.org/get-stream/-/get-stream-3.0.0.tgz","integrity":"sha1-jpQ9E1jcN1VQVOy+LtsFqhdO3hQ=","dev":true},"git-tag":{"version":"git+https://github.com/cellvia/git-tag.git#26d931a1a6fe7f4f0f655ea36081bb6db447bae7","dev":true,"requires":{"semver":"4.2.2"},"dependencies":{"semver":{"version":"4.2.2","resolved":"https://registry.npmjs.org/semver/-/semver-4.2.2.tgz","integrity":"sha1-pqpqxqY8Dcev9+pI1UVa4rk6MGI=","dev":true}}},"glob":{"version":"7.1.2","resolved":"https://registry.npmjs.org/glob/-/glob-7.1.2.tgz","integrity":"sha512-MJTUg1kjuLeQCJ+ccE4Vpa6kKVXkPYJ2mOCQyUuKLcLQsdrMCpBPUi8qVE6+YuaJkozeA9NusTAw3hLr8Xe5EQ==","dev":true,"requires":{"fs.realpath":"1.0.0","inflight":"1.0.6","inherits":"2.0.3","minimatch":"3.0.4","once":"1.4.0","path-is-absolute":"1.0.1"}},"glob-base":{"version":"0.3.0","resolved":"https://registry.npmjs.org/glob-base/-/glob-base-0.3.0.tgz","integrity":"sha1-27Fk9iIbHAscz4Kuoyi0l98Oo8Q=","dev":true,"optional":true,"requires":{"glob-parent":"2.0.0","is-glob":"2.0.1"}},"glob-parent":{"version":"2.0.0","resolved":"https://registry.npmjs.org/glob-parent/-/glob-parent-2.0.0.tgz","integrity":"sha1-gTg9ctsFT8zPUzbaqQLxgvbtuyg=","dev":true,"requires":{"is-glob":"2.0.1"}},"globals":{"version":"9.18.0","resolved":"https://registry.npmjs.org/globals/-/globals-9.18.0.tgz","integrity":"sha512-S0nG3CLEQiY/ILxqtztTWH/3iRRdyBLw6KMDxnKMchrtbj2OFmehVh0WUCfW3DUrIgx/qFrJPICrq4Z4sTR9UQ==","dev":true},"got":{"version":"7.1.0","resolved":"https://registry.npmjs.org/got/-/got-7.1.0.tgz","integrity":"sha512-Y5WMo7xKKq1muPsxD+KmrR8DH5auG7fBdDVueZwETwV6VytKyU9OX/ddpq2/1hp1vIPvVb4T81dKQz3BivkNLw==","dev":true,"requires":{"decompress-response":"3.3.0","duplexer3":"0.1.4","get-stream":"3.0.0","is-plain-obj":"1.1.0","is-retry-allowed":"1.1.0","is-stream":"1.1.0","isurl":"1.0.0","lowercase-keys":"1.0.0","p-cancelable":"0.3.0","p-timeout":"1.2.1","safe-buffer":"5.1.1","timed-out":"4.0.1","url-parse-lax":"1.0.0","url-to-options":"1.0.1"}},"graceful-fs":{"version":"4.1.11","resolved":"https://registry.npmjs.org/graceful-fs/-/graceful-fs-4.1.11.tgz","integrity":"sha1-Dovf5NHduIVNZOBOp8AOKgJuVlg=","dev":true},"has":{"version":"1.0.1","resolved":"https://registry.npmjs.org/has/-/has-1.0.1.tgz","integrity":"sha1-hGFzP1OLCDfJNh45qauelwTcLyg=","dev":true,"requires":{"function-bind":"1.1.1"}},"has-ansi":{"version":"2.0.0","resolved":"https://registry.npmjs.org/has-ansi/-/has-ansi-2.0.0.tgz","integrity":"sha1-NPUEnOHs3ysGSa8+8k5F7TVBbZE=","dev":true,"requires":{"ansi-regex":"2.1.1"}},"has-symbol-support-x":{"version":"1.4.1","resolved":"https://registry.npmjs.org/has-symbol-support-x/-/has-symbol-support-x-1.4.1.tgz","integrity":"sha512-JkaetveU7hFbqnAC1EV1sF4rlojU2D4Usc5CmS69l6NfmPDnpnFUegzFg33eDkkpNCxZ0mQp65HwUDrNFS/8MA==","dev":true},"has-symbols":{"version":"1.0.0","resolved":"https://registry.npmjs.org/has-symbols/-/has-symbols-1.0.0.tgz","integrity":"sha1-uhqPGvKg/DllD1yFA2dwQSIGO0Q=","dev":true},"has-to-string-tag-x":{"version":"1.4.1","resolved":"https://registry.npmjs.org/has-to-string-tag-x/-/has-to-string-tag-x-1.4.1.tgz","integrity":"sha512-vdbKfmw+3LoOYVr+mtxHaX5a96+0f3DljYd8JOqvOLsf5mw2Otda2qCDT9qRqLAhrjyQ0h7ual5nOiASpsGNFw==","dev":true,"requires":{"has-symbol-support-x":"1.4.1"}},"hoist-non-react-statics":{"version":"2.3.1","resolved":"https://registry.npmjs.org/hoist-non-react-statics/-/hoist-non-react-statics-2.3.1.tgz","integrity":"sha1-ND24TGAYxlB3iJgkATWhQg7iLOA="},"home-or-tmp":{"version":"2.0.0","resolved":"https://registry.npmjs.org/home-or-tmp/-/home-or-tmp-2.0.0.tgz","integrity":"sha1-42w/LSyufXRqhX440Y1fMqeILbg=","dev":true,"requires":{"os-homedir":"1.0.2","os-tmpdir":"1.0.2"}},"hosted-git-info":{"version":"2.5.0","resolved":"https://registry.npmjs.org/hosted-git-info/-/hosted-git-info-2.5.0.tgz","integrity":"sha512-pNgbURSuab90KbTqvRPsseaTxOJCZBD0a7t+haSN33piP9cCM4l0CqdzAif2hUqm716UovKB2ROmiabGAKVXyg==","dev":true},"htmlparser2":{"version":"3.9.2","resolved":"https://registry.npmjs.org/htmlparser2/-/htmlparser2-3.9.2.tgz","integrity":"sha1-G9+HrMoPP55T+k/M6w9LTLsAszg=","dev":true,"requires":{"domelementtype":"1.3.0","domhandler":"2.4.1","domutils":"1.5.1","entities":"1.1.1","inherits":"2.0.3","readable-stream":"2.3.3"}},"iconv-lite":{"version":"0.4.19","resolved":"https://registry.npmjs.org/iconv-lite/-/iconv-lite-0.4.19.tgz","integrity":"sha512-oTZqweIP51xaGPI4uPa56/Pri/480R+mo7SeU+YETByQNhDG55ycFyNLIgta9vXhILrxXDmF7ZGhqZIcuN0gJQ=="},"ignore-styles":{"version":"5.0.1","resolved":"https://registry.npmjs.org/ignore-styles/-/ignore-styles-5.0.1.tgz","integrity":"sha1-tJ7yJ0va/NikiAqWa/440aC/RnE=","dev":true},"indent-string":{"version":"3.2.0","resolved":"https://registry.npmjs.org/indent-string/-/indent-string-3.2.0.tgz","integrity":"sha1-Sl/W0nzDMvN+VBmlBNu4NxBckok=","dev":true},"inflight":{"version":"1.0.6","resolved":"https://registry.npmjs.org/inflight/-/inflight-1.0.6.tgz","integrity":"sha1-Sb1jMdfQLQwJvJEKEHW6gWW1bfk=","dev":true,"requires":{"once":"1.4.0","wrappy":"1.0.2"}},"inherits":{"version":"2.0.3","resolved":"https://registry.npmjs.org/inherits/-/inherits-2.0.3.tgz","integrity":"sha1-Yzwsg+PaQqUC9SRmAiSA9CCCYd4=","dev":true},"invariant":{"version":"2.2.2","resolved":"https://registry.npmjs.org/invariant/-/invariant-2.2.2.tgz","integrity":"sha1-nh9WrArNtr8wMwbzOL47IErmA2A=","dev":true,"requires":{"loose-envify":"1.3.1"}},"is-arrayish":{"version":"0.2.1","resolved":"https://registry.npmjs.org/is-arrayish/-/is-arrayish-0.2.1.tgz","integrity":"sha1-d8mYQFJ6qOyxqLppe4BkWnqSap0=","dev":true},"is-binary-path":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-binary-path/-/is-binary-path-1.0.1.tgz","integrity":"sha1-dfFmQrSA8YenEcgUFh/TpKdlWJg=","dev":true,"optional":true,"requires":{"binary-extensions":"1.11.0"}},"is-buffer":{"version":"1.1.6","resolved":"https://registry.npmjs.org/is-buffer/-/is-buffer-1.1.6.tgz","integrity":"sha512-NcdALwpXkTm5Zvvbk7owOUSvVvBKDgKP5/ewfXEznmQFfs4ZRmanOeKBTjRVjka3QFoN6XJ+9F3USqfHqTaU5w==","dev":true},"is-builtin-module":{"version":"1.0.0","resolved":"https://registry.npmjs.org/is-builtin-module/-/is-builtin-module-1.0.0.tgz","integrity":"sha1-VAVy0096wxGfj3bDDLwbHgN6/74=","dev":true,"requires":{"builtin-modules":"1.1.1"}},"is-callable":{"version":"1.1.3","resolved":"https://registry.npmjs.org/is-callable/-/is-callable-1.1.3.tgz","integrity":"sha1-hut1OSgF3cM69xySoO7fdO52BLI=","dev":true},"is-date-object":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-date-object/-/is-date-object-1.0.1.tgz","integrity":"sha1-mqIOtq7rv/d/vTPnTKAbM1gdOhY=","dev":true},"is-dotfile":{"version":"1.0.3","resolved":"https://registry.npmjs.org/is-dotfile/-/is-dotfile-1.0.3.tgz","integrity":"sha1-pqLzL/0t+wT1yiXs0Pa4PPeYoeE=","dev":true,"optional":true},"is-equal-shallow":{"version":"0.1.3","resolved":"https://registry.npmjs.org/is-equal-shallow/-/is-equal-shallow-0.1.3.tgz","integrity":"sha1-IjgJj8Ih3gvPpdnqxMRdY4qhxTQ=","dev":true,"optional":true,"requires":{"is-primitive":"2.0.0"}},"is-extendable":{"version":"0.1.1","resolved":"https://registry.npmjs.org/is-extendable/-/is-extendable-0.1.1.tgz","integrity":"sha1-YrEQ4omkcUGOPsNqYX1HLjAd/Ik=","dev":true,"optional":true},"is-extglob":{"version":"1.0.0","resolved":"https://registry.npmjs.org/is-extglob/-/is-extglob-1.0.0.tgz","integrity":"sha1-rEaBd8SUNAWgkvyPKXYMb/xiBsA=","dev":true},"is-finite":{"version":"1.0.2","resolved":"https://registry.npmjs.org/is-finite/-/is-finite-1.0.2.tgz","integrity":"sha1-zGZ3aVYCvlUO8R6LSqYwU0K20Ko=","dev":true,"requires":{"number-is-nan":"1.0.1"}},"is-glob":{"version":"2.0.1","resolved":"https://registry.npmjs.org/is-glob/-/is-glob-2.0.1.tgz","integrity":"sha1-0Jb5JqPe1WAPP9/ZEZjLCIjC2GM=","dev":true,"requires":{"is-extglob":"1.0.0"}},"is-number":{"version":"2.1.0","resolved":"https://registry.npmjs.org/is-number/-/is-number-2.1.0.tgz","integrity":"sha1-Afy7s5NGOlSPL0ZszhbezknbkI8=","dev":true,"optional":true,"requires":{"kind-of":"3.2.2"}},"is-object":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-object/-/is-object-1.0.1.tgz","integrity":"sha1-iVJojF7C/9awPsyF52ngKQMINHA=","dev":true},"is-online":{"version":"6.1.0","resolved":"https://registry.npmjs.org/is-online/-/is-online-6.1.0.tgz","integrity":"sha1-g4ZpyVc1NaHF6advBLvEhSbz+AU=","dev":true,"requires":{"is-reachable":"2.3.3","random-item":"1.0.0","root-hints":"1.0.15"}},"is-online-cli":{"version":"2.0.0","resolved":"https://registry.npmjs.org/is-online-cli/-/is-online-cli-2.0.0.tgz","integrity":"sha1-5fmQwy+i52/obVtvJB3bucABdOA=","dev":true,"requires":{"is-online":"6.1.0","log-symbols":"1.0.2","meow":"3.7.0"}},"is-plain-obj":{"version":"1.1.0","resolved":"https://registry.npmjs.org/is-plain-obj/-/is-plain-obj-1.1.0.tgz","integrity":"sha1-caUMhCnfync8kqOQpKA7OfzVHT4=","dev":true},"is-port-reachable":{"version":"2.0.0","resolved":"https://registry.npmjs.org/is-port-reachable/-/is-port-reachable-2.0.0.tgz","integrity":"sha1-VNE9ZUkX60M64+4ty8N3TyzUTrI=","dev":true},"is-posix-bracket":{"version":"0.1.1","resolved":"https://registry.npmjs.org/is-posix-bracket/-/is-posix-bracket-0.1.1.tgz","integrity":"sha1-MzTceXdDaOkvAW5vvAqI9c1ua8Q=","dev":true,"optional":true},"is-primitive":{"version":"2.0.0","resolved":"https://registry.npmjs.org/is-primitive/-/is-primitive-2.0.0.tgz","integrity":"sha1-IHurkWOEmcB7Kt8kCkGochADRXU=","dev":true,"optional":true},"is-reachable":{"version":"2.3.3","resolved":"https://registry.npmjs.org/is-reachable/-/is-reachable-2.3.3.tgz","integrity":"sha512-C+bGulHckKAtG6jji9gXawYASctmcpTnQMfKR7CiTC4D4IWgilNkuHBu0QPpWHRawi0WFein9POBLduCdHSbVw==","dev":true,"requires":{"arrify":"1.0.1","got":"7.1.0","is-port-reachable":"2.0.0","p-any":"1.1.0","p-timeout":"1.2.1","pify":"3.0.0","port-numbers":"2.0.17","prepend-http":"1.0.4","router-ips":"1.0.0","url-parse":"1.2.0"}},"is-regex":{"version":"1.0.4","resolved":"https://registry.npmjs.org/is-regex/-/is-regex-1.0.4.tgz","integrity":"sha1-VRdIm1RwkbCTDglWVM7SXul+lJE=","dev":true,"requires":{"has":"1.0.1"}},"is-retry-allowed":{"version":"1.1.0","resolved":"https://registry.npmjs.org/is-retry-allowed/-/is-retry-allowed-1.1.0.tgz","integrity":"sha1-EaBgVotnM5REAz0BJaYaINVk+zQ=","dev":true},"is-stream":{"version":"1.1.0","resolved":"https://registry.npmjs.org/is-stream/-/is-stream-1.1.0.tgz","integrity":"sha1-EtSj3U5o4Lec6428hBc66A2RykQ="},"is-subset":{"version":"0.1.1","resolved":"https://registry.npmjs.org/is-subset/-/is-subset-0.1.1.tgz","integrity":"sha1-ilkRfZMt4d4A8kX83TnOQ/HpOaY=","dev":true},"is-symbol":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-symbol/-/is-symbol-1.0.1.tgz","integrity":"sha1-PMWfAAJRlLarLjjbrmaJJWtmBXI=","dev":true},"is-utf8":{"version":"0.2.1","resolved":"https://registry.npmjs.org/is-utf8/-/is-utf8-0.2.1.tgz","integrity":"sha1-Sw2hRCEE0bM2NA6AeX6GXPOffXI=","dev":true},"is-windows":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-windows/-/is-windows-1.0.1.tgz","integrity":"sha1-MQ23D3QtJZoWo2kgK1GvhCMzENk=","dev":true},"isarray":{"version":"1.0.0","resolved":"https://registry.npmjs.org/isarray/-/isarray-1.0.0.tgz","integrity":"sha1-u5NdSFgsuhaMBoNJV6VKPgcSTxE=","dev":true},"isexe":{"version":"2.0.0","resolved":"https://registry.npmjs.org/isexe/-/isexe-2.0.0.tgz","integrity":"sha1-6PvzdNxVb/iUehDcsFctYz8s+hA=","dev":true},"isobject":{"version":"2.1.0","resolved":"https://registry.npmjs.org/isobject/-/isobject-2.1.0.tgz","integrity":"sha1-8GVWEJaj8dou9GJy+BXIQNh+DIk=","dev":true,"optional":true,"requires":{"isarray":"1.0.0"}},"isomorphic-fetch":{"version":"2.2.1","resolved":"https://registry.npmjs.org/isomorphic-fetch/-/isomorphic-fetch-2.2.1.tgz","integrity":"sha1-YRrhrPFPXoH3KVB0coGf6XM1WKk=","requires":{"node-fetch":"1.7.3","whatwg-fetch":"2.0.3"}},"isurl":{"version":"1.0.0","resolved":"https://registry.npmjs.org/isurl/-/isurl-1.0.0.tgz","integrity":"sha512-1P/yWsxPlDtn7QeRD+ULKQPaIaN6yF368GZ2vDfv0AL0NwpStafjWCDDdn0k8wgFMWpVAqG7oJhxHnlud42i9w==","dev":true,"requires":{"has-to-string-tag-x":"1.4.1","is-object":"1.0.1"}},"js-tokens":{"version":"3.0.2","resolved":"https://registry.npmjs.org/js-tokens/-/js-tokens-3.0.2.tgz","integrity":"sha1-mGbfOVECEw449/mWvOtlRDIJwls="},"jsesc":{"version":"1.3.0","resolved":"https://registry.npmjs.org/jsesc/-/jsesc-1.3.0.tgz","integrity":"sha1-RsP+yMGJKxKwgz25vHYiF226s0s=","dev":true},"json5":{"version":"0.5.1","resolved":"https://registry.npmjs.org/json5/-/json5-0.5.1.tgz","integrity":"sha1-Hq3nrMASA0rYTiOWdn6tn6VJWCE=","dev":true},"kind-of":{"version":"3.2.2","resolved":"https://registry.npmjs.org/kind-of/-/kind-of-3.2.2.tgz","integrity":"sha1-MeohpzS6ubuw8yRm2JOupR5KPGQ=","dev":true,"requires":{"is-buffer":"1.1.6"}},"load-json-file":{"version":"1.1.0","resolved":"https://registry.npmjs.org/load-json-file/-/load-json-file-1.1.0.tgz","integrity":"sha1-lWkFcI1YtLq0wiYbBPWfMcmTdMA=","dev":true,"requires":{"graceful-fs":"4.1.11","parse-json":"2.2.0","pify":"2.3.0","pinkie-promise":"2.0.1","strip-bom":"2.0.0"},"dependencies":{"pify":{"version":"2.3.0","resolved":"https://registry.npmjs.org/pify/-/pify-2.3.0.tgz","integrity":"sha1-7RQaasBDqEnqWISY59yosVMw6Qw=","dev":true}}},"locate-path":{"version":"2.0.0","resolved":"https://registry.npmjs.org/locate-path/-/locate-path-2.0.0.tgz","integrity":"sha1-K1aLJl7slExtnA3pw9u7ygNUzY4=","dev":true,"requires":{"p-locate":"2.0.0","path-exists":"3.0.0"}},"lodash":{"version":"4.17.4","resolved":"https://registry.npmjs.org/lodash/-/lodash-4.17.4.tgz","integrity":"sha1-eCA6TRwyiuHYbcpkYONptX9AVa4=","dev":true},"lodash.assignin":{"version":"4.2.0","resolved":"https://registry.npmjs.org/lodash.assignin/-/lodash.assignin-4.2.0.tgz","integrity":"sha1-uo31+4QesKPoBEIysOJjqNxqKKI=","dev":true},"lodash.bind":{"version":"4.2.1","resolved":"https://registry.npmjs.org/lodash.bind/-/lodash.bind-4.2.1.tgz","integrity":"sha1-euMBfpOWIqwxt9fX3LGzTbFpDTU=","dev":true},"lodash.defaults":{"version":"4.2.0","resolved":"https://registry.npmjs.org/lodash.defaults/-/lodash.defaults-4.2.0.tgz","integrity":"sha1-0JF4cW/+pN3p5ft7N/bwgCJ0WAw=","dev":true},"lodash.filter":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.filter/-/lodash.filter-4.6.0.tgz","integrity":"sha1-ZosdSYFgOuHMWm+nYBQ+SAtMSs4=","dev":true},"lodash.flatten":{"version":"4.4.0","resolved":"https://registry.npmjs.org/lodash.flatten/-/lodash.flatten-4.4.0.tgz","integrity":"sha1-8xwiIlqWMtK7+OSt2+8kCqdlph8=","dev":true},"lodash.foreach":{"version":"4.5.0","resolved":"https://registry.npmjs.org/lodash.foreach/-/lodash.foreach-4.5.0.tgz","integrity":"sha1-Gmo16s5AEoDH8G3d7DUWWrJ+PlM=","dev":true},"lodash.map":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.map/-/lodash.map-4.6.0.tgz","integrity":"sha1-dx7Hg540c9nEzeKLGTlMNWL09tM=","dev":true},"lodash.merge":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.merge/-/lodash.merge-4.6.0.tgz","integrity":"sha1-aYhLoUSsM/5plzemCG3v+t0PicU=","dev":true},"lodash.pick":{"version":"4.4.0","resolved":"https://registry.npmjs.org/lodash.pick/-/lodash.pick-4.4.0.tgz","integrity":"sha1-UvBWEP/53tQiYRRB7R/BI6AwAbM=","dev":true},"lodash.reduce":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.reduce/-/lodash.reduce-4.6.0.tgz","integrity":"sha1-8atrg5KZrUj3hKu/R2WW8DuRTTs=","dev":true},"lodash.reject":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.reject/-/lodash.reject-4.6.0.tgz","integrity":"sha1-gNZJLcFHCGS79YNTO2UfQqn1JBU=","dev":true},"lodash.some":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.some/-/lodash.some-4.6.0.tgz","integrity":"sha1-G7nzFO9ri63tE7VJFpsqlF62jk0=","dev":true},"log-symbols":{"version":"1.0.2","resolved":"https://registry.npmjs.org/log-symbols/-/log-symbols-1.0.2.tgz","integrity":"sha1-N2/3tY6jCGoPCfrMdGF+ylAeGhg=","dev":true,"requires":{"chalk":"1.1.3"}},"loose-envify":{"version":"1.3.1","resolved":"https://registry.npmjs.org/loose-envify/-/loose-envify-1.3.1.tgz","integrity":"sha1-0aitM/qc4OcT1l/dCsi3SNR4yEg=","requires":{"js-tokens":"3.0.2"}},"loud-rejection":{"version":"1.6.0","resolved":"https://registry.npmjs.org/loud-rejection/-/loud-rejection-1.6.0.tgz","integrity":"sha1-W0b4AUft7leIcPCG0Eghz5mOVR8=","dev":true,"requires":{"currently-unhandled":"0.4.1","signal-exit":"3.0.2"}},"lowercase-keys":{"version":"1.0.0","resolved":"https://registry.npmjs.org/lowercase-keys/-/lowercase-keys-1.0.0.tgz","integrity":"sha1-TjNms55/VFfjXxMkvfb4jQv8cwY=","dev":true},"lru-cache":{"version":"4.1.1","resolved":"https://registry.npmjs.org/lru-cache/-/lru-cache-4.1.1.tgz","integrity":"sha512-q4spe4KTfsAS1SUHLO0wz8Qiyf1+vMIAgpRYioFYDMNqKfHQbg+AVDH3i4fvpl71/P1L0dBl+fQi+P37UYf0ew==","dev":true,"requires":{"pseudomap":"1.0.2","yallist":"2.1.2"}},"ltcdr":{"version":"2.2.1","resolved":"https://registry.npmjs.org/ltcdr/-/ltcdr-2.2.1.tgz","integrity":"sha1-Wrh60dTB2rjowIu/A37gwZAih88=","dev":true},"map-obj":{"version":"1.0.1","resolved":"https://registry.npmjs.org/map-obj/-/map-obj-1.0.1.tgz","integrity":"sha1-2TPOuSBdgr3PSIb2dCvcK03qFG0=","dev":true},"meow":{"version":"3.7.0","resolved":"https://registry.npmjs.org/meow/-/meow-3.7.0.tgz","integrity":"sha1-cstmi0JSKCkKu/qFaJJYcwioAfs=","dev":true,"requires":{"camelcase-keys":"2.1.0","decamelize":"1.2.0","loud-rejection":"1.6.0","map-obj":"1.0.1","minimist":"1.2.0","normalize-package-data":"2.4.0","object-assign":"4.1.1","read-pkg-up":"1.0.1","redent":"1.0.0","trim-newlines":"1.0.0"},"dependencies":{"minimist":{"version":"1.2.0","resolved":"https://registry.npmjs.org/minimist/-/minimist-1.2.0.tgz","integrity":"sha1-o1AIsg9BOD7sH7kU9M1d95omQoQ=","dev":true}}},"merge":{"version":"1.2.0","resolved":"https://registry.npmjs.org/merge/-/merge-1.2.0.tgz","integrity":"sha1-dTHjnUlJwoGma4xabgJl6LBYlNo=","dev":true},"micromatch":{"version":"2.3.11","resolved":"https://registry.npmjs.org/micromatch/-/micromatch-2.3.11.tgz","integrity":"sha1-hmd8l9FyCzY0MdBNDRUpO9OMFWU=","dev":true,"optional":true,"requires":{"arr-diff":"2.0.0","array-unique":"0.2.1","braces":"1.8.5","expand-brackets":"0.1.5","extglob":"0.3.2","filename-regex":"2.0.1","is-extglob":"1.0.0","is-glob":"2.0.1","kind-of":"3.2.2","normalize-path":"2.1.1","object.omit":"2.0.1","parse-glob":"3.0.4","regex-cache":"0.4.4"}},"mimic-response":{"version":"1.0.0","resolved":"https://registry.npmjs.org/mimic-response/-/mimic-response-1.0.0.tgz","integrity":"sha1-3z02Uqc/3ta5sLJBRub9BSNTRY4=","dev":true},"minimatch":{"version":"3.0.4","resolved":"https://registry.npmjs.org/minimatch/-/minimatch-3.0.4.tgz","integrity":"sha512-yJHVQEhyqPLUTgt9B83PXu6W3rx4MvvHvSUvToogpwoGDOUQ+yDrR0HRot+yOCdCO7u4hX3pWft6kWBBcqh0UA==","dev":true,"requires":{"brace-expansion":"1.1.8"}},"minimist":{"version":"0.0.8","resolved":"https://registry.npmjs.org/minimist/-/minimist-0.0.8.tgz","integrity":"sha1-hX/Kv8M5fSYluCKCYuhqp6ARsF0=","dev":true},"mkdirp":{"version":"0.5.1","resolved":"https://registry.npmjs.org/mkdirp/-/mkdirp-0.5.1.tgz","integrity":"sha1-MAV0OOrGz3+MR2fzhkjWaX11yQM=","dev":true,"requires":{"minimist":"0.0.8"}},"mobx":{"version":"3.4.1","resolved":"https://registry.npmjs.org/mobx/-/mobx-3.4.1.tgz","integrity":"sha1-N6vl7ogtQBgo2fJsbBovR2FLu+8="},"mobx-react":{"version":"4.3.5","resolved":"https://registry.npmjs.org/mobx-react/-/mobx-react-4.3.5.tgz","integrity":"sha1-doU/Ly70pvlgw3S82fAeh1kpwEw=","requires":{"hoist-non-react-statics":"2.3.1"}},"ms":{"version":"2.0.0","resolved":"https://registry.npmjs.org/ms/-/ms-2.0.0.tgz","integrity":"sha1-VgiurfwAvmwpAd9fmGF4jeDVl8g=","dev":true},"nan":{"version":"2.8.0","resolved":"https://registry.npmjs.org/nan/-/nan-2.8.0.tgz","integrity":"sha1-7XFfP+neArV6XmJS2QqWZ14fCFo=","dev":true,"optional":true},"node-fetch":{"version":"1.7.3","resolved":"https://registry.npmjs.org/node-fetch/-/node-fetch-1.7.3.tgz","integrity":"sha512-NhZ4CsKx7cYm2vSrBAr2PvFOe6sWDf0UYLRqA6svUYg7+/TSfVAu49jYC4BvQ4Sms9SZgdqGBgroqfDhJdTyKQ==","requires":{"encoding":"0.1.12","is-stream":"1.1.0"}},"noms":{"version":"0.0.0","resolved":"https://registry.npmjs.org/noms/-/noms-0.0.0.tgz","integrity":"sha1-2o69nzr51nYJGbJ9nNyAkqczKFk=","dev":true,"requires":{"inherits":"2.0.3","readable-stream":"1.0.34"},"dependencies":{"isarray":{"version":"0.0.1","resolved":"https://registry.npmjs.org/isarray/-/isarray-0.0.1.tgz","integrity":"sha1-ihis/Kmo9Bd+Cav8YDiTmwXR7t8=","dev":true},"readable-stream":{"version":"1.0.34","resolved":"https://registry.npmjs.org/readable-stream/-/readable-stream-1.0.34.tgz","integrity":"sha1-Elgg40vIQtLyqq+v5MKRbuMsFXw=","dev":true,"requires":{"core-util-is":"1.0.2","inherits":"2.0.3","isarray":"0.0.1","string_decoder":"0.10.31"}},"string_decoder":{"version":"0.10.31","resolved":"https://registry.npmjs.org/string_decoder/-/string_decoder-0.10.31.tgz","integrity":"sha1-YuIDvEF2bGwoyfyEMB2rHFMQ+pQ=","dev":true}}},"normalize-package-data":{"version":"2.4.0","resolved":"https://registry.npmjs.org/normalize-package-data/-/normalize-package-data-2.4.0.tgz","integrity":"sha512-9jjUFbTPfEy3R/ad/2oNbKtW9Hgovl5O1FvFWKkKblNXoN/Oou6+9+KKohPK13Yc3/TyunyWhJp6gvRNR/PPAw==","dev":true,"requires":{"hosted-git-info":"2.5.0","is-builtin-module":"1.0.0","semver":"5.5.0","validate-npm-package-license":"3.0.1"}},"normalize-path":{"version":"2.1.1","resolved":"https://registry.npmjs.org/normalize-path/-/normalize-path-2.1.1.tgz","integrity":"sha1-GrKLVW4Zg2Oowab35vogE3/mrtk=","dev":true,"requires":{"remove-trailing-separator":"1.1.0"}},"nth-check":{"version":"1.0.1","resolved":"https://registry.npmjs.org/nth-check/-/nth-check-1.0.1.tgz","integrity":"sha1-mSms32KPwsQQmN6rgqxYDPFJquQ=","dev":true,"requires":{"boolbase":"1.0.0"}},"number-is-nan":{"version":"1.0.1","resolved":"https://registry.npmjs.org/number-is-nan/-/number-is-nan-1.0.1.tgz","integrity":"sha1-CXtgK1NCKlIsGvuHkDGDNpQaAR0=","dev":true},"object-assign":{"version":"4.1.1","resolved":"https://registry.npmjs.org/object-assign/-/object-assign-4.1.1.tgz","integrity":"sha1-IQmtx5ZYh8/AXLvUQsrIv7s2CGM="},"object-inspect":{"version":"1.1.0","resolved":"https://registry.npmjs.org/object-inspect/-/object-inspect-1.1.0.tgz","integrity":"sha1-NLymRKgPlPi6QaD50JhOr2Os8U0=","dev":true},"object-is":{"version":"1.0.1","resolved":"https://registry.npmjs.org/object-is/-/object-is-1.0.1.tgz","integrity":"sha1-CqYOyZiaCz7Xlc9NBvYs8a1lObY=","dev":true},"object-keys":{"version":"1.0.11","resolved":"https://registry.npmjs.org/object-keys/-/object-keys-1.0.11.tgz","integrity":"sha1-xUYBd4rVYPEULODgG8yotW0TQm0=","dev":true},"object.assign":{"version":"4.1.0","resolved":"https://registry.npmjs.org/object.assign/-/object.assign-4.1.0.tgz","integrity":"sha512-exHJeq6kBKj58mqGyTQ9DFvrZC/eR6OwxzoM9YRoGBqrXYonaFyGiFMuc9VZrXf7DarreEwMpurG3dd+CNyW5w==","dev":true,"requires":{"define-properties":"1.1.2","function-bind":"1.1.1","has-symbols":"1.0.0","object-keys":"1.0.11"}},"object.entries":{"version":"1.0.4","resolved":"https://registry.npmjs.org/object.entries/-/object.entries-1.0.4.tgz","integrity":"sha1-G/mk3SKI9bM/Opk9JXZh8F0WGl8=","dev":true,"requires":{"define-properties":"1.1.2","es-abstract":"1.10.0","function-bind":"1.1.1","has":"1.0.1"}},"object.omit":{"version":"2.0.1","resolved":"https://registry.npmjs.org/object.omit/-/object.omit-2.0.1.tgz","integrity":"sha1-Gpx0SCnznbuFjHbKNXmuKlTr0fo=","dev":true,"optional":true,"requires":{"for-own":"0.1.5","is-extendable":"0.1.1"}},"object.values":{"version":"1.0.4","resolved":"https://registry.npmjs.org/object.values/-/object.values-1.0.4.tgz","integrity":"sha1-5STaCbT2b/Bd9FdUbscqyZ8TBpo=","dev":true,"requires":{"define-properties":"1.1.2","es-abstract":"1.10.0","function-bind":"1.1.1","has":"1.0.1"}},"once":{"version":"1.4.0","resolved":"https://registry.npmjs.org/once/-/once-1.4.0.tgz","integrity":"sha1-WDsap3WWHUsROsF9nFC6753Xa9E=","dev":true,"requires":{"wrappy":"1.0.2"}},"os-homedir":{"version":"1.0.2","resolved":"https://registry.npmjs.org/os-homedir/-/os-homedir-1.0.2.tgz","integrity":"sha1-/7xJiDNuDoM94MFox+8VISGqf7M=","dev":true},"os-tmpdir":{"version":"1.0.2","resolved":"https://registry.npmjs.org/os-tmpdir/-/os-tmpdir-1.0.2.tgz","integrity":"sha1-u+Z0BseaqFxc/sdm/lc0VV36EnQ=","dev":true},"output-file-sync":{"version":"1.1.2","resolved":"https://registry.npmjs.org/output-file-sync/-/output-file-sync-1.1.2.tgz","integrity":"sha1-0KM+7+YaIF+suQCS6CZZjVJFznY=","dev":true,"requires":{"graceful-fs":"4.1.11","mkdirp":"0.5.1","object-assign":"4.1.1"}},"p-any":{"version":"1.1.0","resolved":"https://registry.npmjs.org/p-any/-/p-any-1.1.0.tgz","integrity":"sha512-Ef0tVa4CZ5pTAmKn+Cg3w8ABBXh+hHO1aV8281dKOoUHfX+3tjG2EaFcC+aZyagg9b4EYGsHEjz21DnEE8Og2g==","dev":true,"requires":{"p-some":"2.0.1"}},"p-cancelable":{"version":"0.3.0","resolved":"https://registry.npmjs.org/p-cancelable/-/p-cancelable-0.3.0.tgz","integrity":"sha512-RVbZPLso8+jFeq1MfNvgXtCRED2raz/dKpacfTNxsx6pLEpEomM7gah6VeHSYV3+vo0OAi4MkArtQcWWXuQoyw==","dev":true},"p-finally":{"version":"1.0.0","resolved":"https://registry.npmjs.org/p-finally/-/p-finally-1.0.0.tgz","integrity":"sha1-P7z7FbiZpEEjs0ttzBi3JDNqLK4=","dev":true},"p-limit":{"version":"1.2.0","resolved":"https://registry.npmjs.org/p-limit/-/p-limit-1.2.0.tgz","integrity":"sha512-Y/OtIaXtUPr4/YpMv1pCL5L5ed0rumAaAeBSj12F+bSlMdys7i8oQF/GUJmfpTS/QoaRrS/k6pma29haJpsMng==","dev":true,"requires":{"p-try":"1.0.0"}},"p-locate":{"version":"2.0.0","resolved":"https://registry.npmjs.org/p-locate/-/p-locate-2.0.0.tgz","integrity":"sha1-IKAQOyIqcMj9OcwuWAaA893l7EM=","dev":true,"requires":{"p-limit":"1.2.0"}},"p-some":{"version":"2.0.1","resolved":"https://registry.npmjs.org/p-some/-/p-some-2.0.1.tgz","integrity":"sha1-Zdh8ixVO289SIdFnd4ttLhUPbwY=","dev":true,"requires":{"aggregate-error":"1.0.0"}},"p-timeout":{"version":"1.2.1","resolved":"https://registry.npmjs.org/p-timeout/-/p-timeout-1.2.1.tgz","integrity":"sha1-XrOzU7f86Z8QGhA4iAuwVOu+o4Y=","dev":true,"requires":{"p-finally":"1.0.0"}},"p-try":{"version":"1.0.0","resolved":"https://registry.npmjs.org/p-try/-/p-try-1.0.0.tgz","integrity":"sha1-y8ec26+P1CKOE/Yh8rGiN8GyB7M=","dev":true},"parse-glob":{"version":"3.0.4","resolved":"https://registry.npmjs.org/parse-glob/-/parse-glob-3.0.4.tgz","integrity":"sha1-ssN2z7EfNVE7rdFz7wu246OIORw=","dev":true,"optional":true,"requires":{"glob-base":"0.3.0","is-dotfile":"1.0.3","is-extglob":"1.0.0","is-glob":"2.0.1"}},"parse-json":{"version":"2.2.0","resolved":"https://registry.npmjs.org/parse-json/-/parse-json-2.2.0.tgz","integrity":"sha1-9ID0BDTvgHQfhGkJn43qGPVaTck=","dev":true,"requires":{"error-ex":"1.3.1"}},"path-exists":{"version":"3.0.0","resolved":"https://registry.npmjs.org/path-exists/-/path-exists-3.0.0.tgz","integrity":"sha1-zg6+ql94yxiSXqfYENe1mwEP1RU=","dev":true},"path-is-absolute":{"version":"1.0.1","resolved":"https://registry.npmjs.org/path-is-absolute/-/path-is-absolute-1.0.1.tgz","integrity":"sha1-F0uSaHNVNP+8es5r9TpanhtcX18=","dev":true},"path-parse":{"version":"1.0.5","resolved":"https://registry.npmjs.org/path-parse/-/path-parse-1.0.5.tgz","integrity":"sha1-PBrfhx6pzWyUMbbqK9dKD/BVxME=","dev":true},"path-type":{"version":"1.1.0","resolved":"https://registry.npmjs.org/path-type/-/path-type-1.1.0.tgz","integrity":"sha1-WcRPfuSR2nBNpBXaWkBwuk+P5EE=","dev":true,"requires":{"graceful-fs":"4.1.11","pify":"2.3.0","pinkie-promise":"2.0.1"},"dependencies":{"pify":{"version":"2.3.0","resolved":"https://registry.npmjs.org/pify/-/pify-2.3.0.tgz","integrity":"sha1-7RQaasBDqEnqWISY59yosVMw6Qw=","dev":true}}},"pify":{"version":"3.0.0","resolved":"https://registry.npmjs.org/pify/-/pify-3.0.0.tgz","integrity":"sha1-5aSs0sEB/fPZpNB/DbxNtJ3SgXY=","dev":true},"pinkie":{"version":"2.0.4","resolved":"https://registry.npmjs.org/pinkie/-/pinkie-2.0.4.tgz","integrity":"sha1-clVrgM+g1IqXToDnckjoDtT3+HA=","dev":true},"pinkie-promise":{"version":"2.0.1","resolved":"https://registry.npmjs.org/pinkie-promise/-/pinkie-promise-2.0.1.tgz","integrity":"sha1-ITXW36ejWMBprJsXh3YogihFD/o=","dev":true,"requires":{"pinkie":"2.0.4"}},"pkg-up":{"version":"2.0.0","resolved":"https://registry.npmjs.org/pkg-up/-/pkg-up-2.0.0.tgz","integrity":"sha1-yBmscoBZpGHKscOImivjxJoATX8=","dev":true,"requires":{"find-up":"2.1.0"}},"port-numbers":{"version":"2.0.17","resolved":"https://registry.npmjs.org/port-numbers/-/port-numbers-2.0.17.tgz","integrity":"sha512-YJp4ryb/CBFKgby8C/imUL38hnD+QvAjKmhhVEOrmzo0CeLkVj3d7GBlcAImerNFmioBDZRpaC6kpRXfgholYw==","dev":true},"prepend-http":{"version":"1.0.4","resolved":"https://registry.npmjs.org/prepend-http/-/prepend-http-1.0.4.tgz","integrity":"sha1-1PRWKwzjaW5BrFLQ4ALlemNdxtw=","dev":true},"preserve":{"version":"0.2.0","resolved":"https://registry.npmjs.org/preserve/-/preserve-0.2.0.tgz","integrity":"sha1-gV7R9uvGWSb4ZbMQwHE7yzMVzks=","dev":true,"optional":true},"private":{"version":"0.1.8","resolved":"https://registry.npmjs.org/private/-/private-0.1.8.tgz","integrity":"sha512-VvivMrbvd2nKkiG38qjULzlc+4Vx4wm/whI9pQD35YrARNnhxeiRktSOhSukRLFNlzg6Br/cJPet5J/u19r/mg==","dev":true},"process-nextick-args":{"version":"1.0.7","resolved":"https://registry.npmjs.org/process-nextick-args/-/process-nextick-args-1.0.7.tgz","integrity":"sha1-FQ4gt1ZZCtP5EJPyWk8q2L/zC6M=","dev":true},"promise":{"version":"7.3.1","resolved":"https://registry.npmjs.org/promise/-/promise-7.3.1.tgz","integrity":"sha512-nolQXZ/4L+bP/UGlkfaIujX9BKxGwmQ9OT4mOt5yvy8iK1h3wqTEJCijzGANTCCl9nWjY41juyAn2K3Q1hLLTg==","requires":{"asap":"2.0.6"}},"prop-types":{"version":"15.6.0","resolved":"https://registry.npmjs.org/prop-types/-/prop-types-15.6.0.tgz","integrity":"sha1-zq8IMCL8RrSjX2nhPvda7Q1jmFY=","requires":{"fbjs":"0.8.16","loose-envify":"1.3.1","object-assign":"4.1.1"}},"pseudomap":{"version":"1.0.2","resolved":"https://registry.npmjs.org/pseudomap/-/pseudomap-1.0.2.tgz","integrity":"sha1-8FKijacOYYkX7wqKw0wa5aaChrM=","dev":true},"querystringify":{"version":"1.0.0","resolved":"https://registry.npmjs.org/querystringify/-/querystringify-1.0.0.tgz","integrity":"sha1-YoYkIRLFtxL6ZU5SZlK/ahP/Bcs=","dev":true},"random-item":{"version":"1.0.0","resolved":"https://registry.npmjs.org/random-item/-/random-item-1.0.0.tgz","integrity":"sha1-Fu4xYmywUMihaGpfD0KmuZoqrxE=","dev":true},"randomatic":{"version":"1.1.7","resolved":"https://registry.npmjs.org/randomatic/-/randomatic-1.1.7.tgz","integrity":"sha512-D5JUjPyJbaJDkuAazpVnSfVkLlpeO3wDlPROTMLGKG1zMFNFRgrciKo1ltz/AzNTkqE0HzDx655QOL51N06how==","dev":true,"optional":true,"requires":{"is-number":"3.0.0","kind-of":"4.0.0"},"dependencies":{"is-number":{"version":"3.0.0","resolved":"https://registry.npmjs.org/is-number/-/is-number-3.0.0.tgz","integrity":"sha1-JP1iAaR4LPUFYcgQJ2r8fRLXEZU=","dev":true,"optional":true,"requires":{"kind-of":"3.2.2"},"dependencies":{"kind-of":{"version":"3.2.2","resolved":"https://registry.npmjs.org/kind-of/-/kind-of-3.2.2.tgz","integrity":"sha1-MeohpzS6ubuw8yRm2JOupR5KPGQ=","dev":true,"optional":true,"requires":{"is-buffer":"1.1.6"}}}},"kind-of":{"version":"4.0.0","resolved":"https://registry.npmjs.org/kind-of/-/kind-of-4.0.0.tgz","integrity":"sha1-IIE989cSkosgc3hpGkUGb65y3Vc=","dev":true,"optional":true,"requires":{"is-buffer":"1.1.6"}}}},"react":{"version":"15.6.2","resolved":"https://registry.npmjs.org/react/-/react-15.6.2.tgz","integrity":"sha1-26BDSrQ5z+gvEI8PURZjkIF5qnI=","requires":{"create-react-class":"15.6.2","fbjs":"0.8.16","loose-envify":"1.3.1","object-assign":"4.1.1","prop-types":"15.6.0"}},"react-dom":{"version":"15.6.2","resolved":"https://registry.npmjs.org/react-dom/-/react-dom-15.6.2.tgz","integrity":"sha1-Qc+t9pO3V/rycIRDodH9WgK+9zA=","requires":{"fbjs":"0.8.16","loose-envify":"1.3.1","object-assign":"4.1.1","prop-types":"15.6.0"}},"react-test-renderer":{"version":"15.6.2","resolved":"https://registry.npmjs.org/react-test-renderer/-/react-test-renderer-15.6.2.tgz","integrity":"sha1-0DM0NPwsQ4CSaWyncNpe1IA376g=","dev":true,"requires":{"fbjs":"0.8.16","object-assign":"4.1.1"}},"read-pkg":{"version":"1.1.0","resolved":"https://registry.npmjs.org/read-pkg/-/read-pkg-1.1.0.tgz","integrity":"sha1-9f+qXs0pyzHAR0vKfXVra7KePyg=","dev":true,"requires":{"load-json-file":"1.1.0","normalize-package-data":"2.4.0","path-type":"1.1.0"}},"read-pkg-up":{"version":"1.0.1","resolved":"https://registry.npmjs.org/read-pkg-up/-/read-pkg-up-1.0.1.tgz","integrity":"sha1-nWPBMnbAZZGNV/ACpX9AobZD+wI=","dev":true,"requires":{"find-up":"1.1.2","read-pkg":"1.1.0"},"dependencies":{"find-up":{"version":"1.1.2","resolved":"https://registry.npmjs.org/find-up/-/find-up-1.1.2.tgz","integrity":"sha1-ay6YIrGizgpgq2TWEOzK1TyyTQ8=","dev":true,"requires":{"path-exists":"2.1.0","pinkie-promise":"2.0.1"}},"path-exists":{"version":"2.1.0","resolved":"https://registry.npmjs.org/path-exists/-/path-exists-2.1.0.tgz","integrity":"sha1-D+tsZPD8UY2adU3V77YscCJ2H0s=","dev":true,"requires":{"pinkie-promise":"2.0.1"}}}},"readable-stream":{"version":"2.3.3","resolved":"https://registry.npmjs.org/readable-stream/-/readable-stream-2.3.3.tgz","integrity":"sha512-m+qzzcn7KUxEmd1gMbchF+Y2eIUbieUaxkWtptyHywrX0rE8QEYqPC07Vuy4Wm32/xE16NcdBctb8S0Xe/5IeQ==","dev":true,"requires":{"core-util-is":"1.0.2","inherits":"2.0.3","isarray":"1.0.0","process-nextick-args":"1.0.7","safe-buffer":"5.1.1","string_decoder":"1.0.3","util-deprecate":"1.0.2"}},"readdirp":{"version":"2.1.0","resolved":"https://registry.npmjs.org/readdirp/-/readdirp-2.1.0.tgz","integrity":"sha1-TtCtBg3zBzMAxIRANz9y0cxkLXg=","dev":true,"optional":true,"requires":{"graceful-fs":"4.1.11","minimatch":"3.0.4","readable-stream":"2.3.3","set-immediate-shim":"1.0.1"}},"redent":{"version":"1.0.0","resolved":"https://registry.npmjs.org/redent/-/redent-1.0.0.tgz","integrity":"sha1-z5Fqsf1fHxbfsggi3W7H9zDCr94=","dev":true,"requires":{"indent-string":"2.1.0","strip-indent":"1.0.1"},"dependencies":{"indent-string":{"version":"2.1.0","resolved":"https://registry.npmjs.org/indent-string/-/indent-string-2.1.0.tgz","integrity":"sha1-ji1INIdCEhtKghi3oTfppSBJ3IA=","dev":true,"requires":{"repeating":"2.0.1"}}}},"regenerate":{"version":"1.3.3","resolved":"https://registry.npmjs.org/regenerate/-/regenerate-1.3.3.tgz","integrity":"sha512-jVpo1GadrDAK59t/0jRx5VxYWQEDkkEKi6+HjE3joFVLfDOh9Xrdh0dF1eSq+BI/SwvTQ44gSscJ8N5zYL61sg==","dev":true},"regenerator-runtime":{"version":"0.11.1","resolved":"https://registry.npmjs.org/regenerator-runtime/-/regenerator-runtime-0.11.1.tgz","integrity":"sha512-MguG95oij0fC3QV3URf4V2SDYGJhJnJGqvIIgdECeODCT98wSWDAJ94SSuVpYQUoTcGUIL6L4yNB7j1DFFHSBg==","dev":true},"regenerator-transform":{"version":"0.10.1","resolved":"https://registry.npmjs.org/regenerator-transform/-/regenerator-transform-0.10.1.tgz","integrity":"sha512-PJepbvDbuK1xgIgnau7Y90cwaAmO/LCLMI2mPvaXq2heGMR3aWW5/BQvYrhJ8jgmQjXewXvBjzfqKcVOmhjZ6Q==","dev":true,"requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0","private":"0.1.8"}},"regex-cache":{"version":"0.4.4","resolved":"https://registry.npmjs.org/regex-cache/-/regex-cache-0.4.4.tgz","integrity":"sha512-nVIZwtCjkC9YgvWkpM55B5rBhBYRZhAaJbgcFYXXsHnbZ9UZI9nnVWYZpBlCqv9ho2eZryPnWrZGsOdPwVWXWQ==","dev":true,"optional":true,"requires":{"is-equal-shallow":"0.1.3"}},"regexpu-core":{"version":"2.0.0","resolved":"https://registry.npmjs.org/regexpu-core/-/regexpu-core-2.0.0.tgz","integrity":"sha1-SdA4g3uNz4v6W5pCE5k45uoq4kA=","dev":true,"requires":{"regenerate":"1.3.3","regjsgen":"0.2.0","regjsparser":"0.1.5"}},"regjsgen":{"version":"0.2.0","resolved":"https://registry.npmjs.org/regjsgen/-/regjsgen-0.2.0.tgz","integrity":"sha1-bAFq3qxVT3WCP+N6wFuS1aTtsfc=","dev":true},"regjsparser":{"version":"0.1.5","resolved":"https://registry.npmjs.org/regjsparser/-/regjsparser-0.1.5.tgz","integrity":"sha1-fuj4Tcb6eS0/0K4ijSS9lJ6tIFw=","dev":true,"requires":{"jsesc":"0.5.0"},"dependencies":{"jsesc":{"version":"0.5.0","resolved":"https://registry.npmjs.org/jsesc/-/jsesc-0.5.0.tgz","integrity":"sha1-597mbjXW/Bb3EP6R1c9p9w8IkR0=","dev":true}}},"remove-trailing-separator":{"version":"1.1.0","resolved":"https://registry.npmjs.org/remove-trailing-separator/-/remove-trailing-separator-1.1.0.tgz","integrity":"sha1-wkvOKig62tW8P1jg1IJJuSN52O8=","dev":true},"repeat-element":{"version":"1.1.2","resolved":"https://registry.npmjs.org/repeat-element/-/repeat-element-1.1.2.tgz","integrity":"sha1-7wiaF40Ug7quTZPrmLT55OEdmQo=","dev":true},"repeat-string":{"version":"1.6.1","resolved":"https://registry.npmjs.org/repeat-string/-/repeat-string-1.6.1.tgz","integrity":"sha1-jcrkcOHIirwtYA//Sndihtp15jc=","dev":true,"optional":true},"repeating":{"version":"2.0.1","resolved":"https://registry.npmjs.org/repeating/-/repeating-2.0.1.tgz","integrity":"sha1-UhTFOpJtNVJwdSf7q0FdvAjQbdo=","dev":true,"requires":{"is-finite":"1.0.2"}},"requires-port":{"version":"1.0.0","resolved":"https://registry.npmjs.org/requires-port/-/requires-port-1.0.0.tgz","integrity":"sha1-kl0mAdOaxIXgkc8NpcbmlNw9yv8=","dev":true},"reselect":{"version":"3.0.1","resolved":"https://registry.npmjs.org/reselect/-/reselect-3.0.1.tgz","integrity":"sha1-79qpjqdFEyTQkrKyFjpqHXqaIUc=","dev":true},"resolve":{"version":"1.5.0","resolved":"https://registry.npmjs.org/resolve/-/resolve-1.5.0.tgz","integrity":"sha512-hgoSGrc3pjzAPHNBg+KnFcK2HwlHTs/YrAGUr6qgTVUZmXv1UEXXl0bZNBKMA9fud6lRYFdPGz0xXxycPzmmiw==","dev":true,"requires":{"path-parse":"1.0.5"}},"resumer":{"version":"0.0.0","resolved":"https://registry.npmjs.org/resumer/-/resumer-0.0.0.tgz","integrity":"sha1-8ej0YeQGS6Oegq883CqMiT0HZ1k=","dev":true,"requires":{"through":"2.3.8"}},"root-hints":{"version":"1.0.15","resolved":"https://registry.npmjs.org/root-hints/-/root-hints-1.0.15.tgz","integrity":"sha1-+xF75MW/f8FQYg2rLIf4Dc8MwnI=","dev":true},"router-ips":{"version":"1.0.0","resolved":"https://registry.npmjs.org/router-ips/-/router-ips-1.0.0.tgz","integrity":"sha1-ROAIWOvrwBM9WOQLLNih+7BCA/U=","dev":true},"safe-buffer":{"version":"5.1.1","resolved":"https://registry.npmjs.org/safe-buffer/-/safe-buffer-5.1.1.tgz","integrity":"sha512-kKvNJn6Mm93gAczWVJg7wH+wGYWNrDHdWvpUmHyEsgCtIwwo3bqPtV4tR5tuPaUhTOo/kvhVwd8XwwOllGYkbg==","dev":true},"semver":{"version":"5.5.0","resolved":"https://registry.npmjs.org/semver/-/semver-5.5.0.tgz","integrity":"sha512-4SJ3dm0WAwWy/NVeioZh5AntkdJoWKxHxcmyP622fOkgHa4z3R0TdBJICINyaSDE6uNwVc8gZr+ZinwZAH4xIA==","dev":true},"set-immediate-shim":{"version":"1.0.1","resolved":"https://registry.npmjs.org/set-immediate-shim/-/set-immediate-shim-1.0.1.tgz","integrity":"sha1-SysbJ+uAip+NzEgaWOXlb1mfP2E=","dev":true,"optional":true},"setimmediate":{"version":"1.0.5","resolved":"https://registry.npmjs.org/setimmediate/-/setimmediate-1.0.5.tgz","integrity":"sha1-KQy7Iy4waULX1+qbg3Mqt4VvgoU="},"shebang-command":{"version":"1.2.0","resolved":"https://registry.npmjs.org/shebang-command/-/shebang-command-1.2.0.tgz","integrity":"sha1-RKrGW2lbAzmJaMOfNj/uXer98eo=","dev":true,"requires":{"shebang-regex":"1.0.0"}},"shebang-regex":{"version":"1.0.0","resolved":"https://registry.npmjs.org/shebang-regex/-/shebang-regex-1.0.0.tgz","integrity":"sha1-2kL0l0DAtC2yypcoVxyxkMmO/qM=","dev":true},"signal-exit":{"version":"3.0.2","resolved":"https://registry.npmjs.org/signal-exit/-/signal-exit-3.0.2.tgz","integrity":"sha1-tf3AjxKH6hF4Yo5BXiUTK3NkbG0=","dev":true},"slash":{"version":"1.0.0","resolved":"https://registry.npmjs.org/slash/-/slash-1.0.0.tgz","integrity":"sha1-xB8vbDn8FtHNF61LXYlhFK5HDVU=","dev":true},"source-map":{"version":"0.5.7","resolved":"https://registry.npmjs.org/source-map/-/source-map-0.5.7.tgz","integrity":"sha1-igOdLRAh0i0eoUyA2OpGi6LvP8w=","dev":true},"source-map-support":{"version":"0.4.18","resolved":"https://registry.npmjs.org/source-map-support/-/source-map-support-0.4.18.tgz","integrity":"sha512-try0/JqxPLF9nOjvSta7tVondkP5dwgyLDjVoyMDlmjugT2lRZ1OfsrYTkCd2hkDnJTKRbO/Rl3orm8vlsUzbA==","dev":true,"requires":{"source-map":"0.5.7"}},"spdx-correct":{"version":"1.0.2","resolved":"https://registry.npmjs.org/spdx-correct/-/spdx-correct-1.0.2.tgz","integrity":"sha1-SzBz2TP/UfORLwOsVRlJikFQ20A=","dev":true,"requires":{"spdx-license-ids":"1.2.2"}},"spdx-expression-parse":{"version":"1.0.4","resolved":"https://registry.npmjs.org/spdx-expression-parse/-/spdx-expression-parse-1.0.4.tgz","integrity":"sha1-m98vIOH0DtRH++JzJmGR/O1RYmw=","dev":true},"spdx-license-ids":{"version":"1.2.2","resolved":"https://registry.npmjs.org/spdx-license-ids/-/spdx-license-ids-1.2.2.tgz","integrity":"sha1-yd96NCRZSt5r0RkA1ZZpbcBrrFc=","dev":true},"string.prototype.trim":{"version":"1.1.2","resolved":"https://registry.npmjs.org/string.prototype.trim/-/string.prototype.trim-1.1.2.tgz","integrity":"sha1-0E3iyJ4Tf019IG8Ia17S+ua+jOo=","dev":true,"requires":{"define-properties":"1.1.2","es-abstract":"1.10.0","function-bind":"1.1.1"}},"string_decoder":{"version":"1.0.3","resolved":"https://registry.npmjs.org/string_decoder/-/string_decoder-1.0.3.tgz","integrity":"sha512-4AH6Z5fzNNBcH+6XDMfA/BTt87skxqJlO0lAh3Dker5zThcAxG6mKz+iGu308UKoPPQ8Dcqx/4JhujzltRa+hQ==","dev":true,"requires":{"safe-buffer":"5.1.1"}},"strip-ansi":{"version":"3.0.1","resolved":"https://registry.npmjs.org/strip-ansi/-/strip-ansi-3.0.1.tgz","integrity":"sha1-ajhfuIU9lS1f8F0Oiq+UJ43GPc8=","dev":true,"requires":{"ansi-regex":"2.1.1"}},"strip-bom":{"version":"2.0.0","resolved":"https://registry.npmjs.org/strip-bom/-/strip-bom-2.0.0.tgz","integrity":"sha1-YhmoVhZSBJHzV4i9vxRHqZx+aw4=","dev":true,"requires":{"is-utf8":"0.2.1"}},"strip-indent":{"version":"1.0.1","resolved":"https://registry.npmjs.org/strip-indent/-/strip-indent-1.0.1.tgz","integrity":"sha1-DHlipq3vp7vUrDZkYKY4VSrhoKI=","dev":true,"requires":{"get-stdin":"4.0.1"}},"supports-color":{"version":"2.0.0","resolved":"https://registry.npmjs.org/supports-color/-/supports-color-2.0.0.tgz","integrity":"sha1-U10EXOa2Nj+kARcIRimZXp3zJMc=","dev":true},"tape":{"version":"4.5.1","resolved":"https://registry.npmjs.org/tape/-/tape-4.5.1.tgz","integrity":"sha1-K7PqGb3J9SJSF7P5fL95hsxMbow=","dev":true,"requires":{"deep-equal":"1.0.1","defined":"1.0.0","function-bind":"1.1.1","glob":"7.0.6","has":"1.0.1","inherits":"2.0.3","minimist":"1.2.0","object-inspect":"1.1.0","resolve":"1.1.7","resumer":"0.0.0","string.prototype.trim":"1.1.2","through":"2.3.8"},"dependencies":{"glob":{"version":"7.0.6","resolved":"https://registry.npmjs.org/glob/-/glob-7.0.6.tgz","integrity":"sha1-IRuvr0nlJbjNkyYNFKsTYVKz9Xo=","dev":true,"requires":{"fs.realpath":"1.0.0","inflight":"1.0.6","inherits":"2.0.3","minimatch":"3.0.4","once":"1.4.0","path-is-absolute":"1.0.1"}},"minimist":{"version":"1.2.0","resolved":"https://registry.npmjs.org/minimist/-/minimist-1.2.0.tgz","integrity":"sha1-o1AIsg9BOD7sH7kU9M1d95omQoQ=","dev":true},"resolve":{"version":"1.1.7","resolved":"https://registry.npmjs.org/resolve/-/resolve-1.1.7.tgz","integrity":"sha1-IDEU2CrSxe2ejgQRs5ModeiJ6Xs=","dev":true}}},"through":{"version":"2.3.8","resolved":"https://registry.npmjs.org/through/-/through-2.3.8.tgz","integrity":"sha1-DdTJ/6q8NXlgsbckEV1+Doai4fU=","dev":true},"through2":{"version":"2.0.3","resolved":"https://registry.npmjs.org/through2/-/through2-2.0.3.tgz","integrity":"sha1-AARWmzfHx0ujnEPzzteNGtlBQL4=","dev":true,"requires":{"readable-stream":"2.3.3","xtend":"4.0.1"}},"timed-out":{"version":"4.0.1","resolved":"https://registry.npmjs.org/timed-out/-/timed-out-4.0.1.tgz","integrity":"sha1-8y6srFoXW+ol1/q1Zas+2HQe9W8=","dev":true},"to-fast-properties":{"version":"1.0.3","resolved":"https://registry.npmjs.org/to-fast-properties/-/to-fast-properties-1.0.3.tgz","integrity":"sha1-uDVx+k2MJbguIxsG46MFXeTKGkc=","dev":true},"traverse":{"version":"0.6.6","resolved":"https://registry.npmjs.org/traverse/-/traverse-0.6.6.tgz","integrity":"sha1-y99WD9e5r2MlAv7UD5GMFX6pcTc="},"trc-debug-runner":{"version":"git+https://gitlab.com/regiscompany/trc-debug-runner.git#9885f75a6416e45a6613b56b782a433028be17e0","dev":true,"requires":{"babel-polyfill":"6.26.0","babel-register":"6.26.0","glob":"7.1.2","ignore-styles":"5.0.1","minimist":"1.2.0","watch":"1.0.2"},"dependencies":{"minimist":{"version":"1.2.0","resolved":"https://registry.npmjs.org/minimist/-/minimist-1.2.0.tgz","integrity":"sha1-o1AIsg9BOD7sH7kU9M1d95omQoQ=","dev":true}}},"trc-tagme":{"version":"git+https://gitlab.com/regiscompany/trc-tagme.git#cae7e7da506a24aa087eb6dcab4f42aae32035d1","dev":true,"requires":{"git-tag":"git+https://github.com/cellvia/git-tag.git#26d931a1a6fe7f4f0f655ea36081bb6db447bae7"}},"trim-newlines":{"version":"1.0.0","resolved":"https://registry.npmjs.org/trim-newlines/-/trim-newlines-1.0.0.tgz","integrity":"sha1-WIeWa7WCpFA6QetST301ARgVphM=","dev":true},"trim-right":{"version":"1.0.1","resolved":"https://registry.npmjs.org/trim-right/-/trim-right-1.0.1.tgz","integrity":"sha1-yy4SAwZ+DI3h9hQJS5/kVwTqYAM=","dev":true},"ua-parser-js":{"version":"0.7.17","resolved":"https://registry.npmjs.org/ua-parser-js/-/ua-parser-js-0.7.17.tgz","integrity":"sha512-uRdSdu1oA1rncCQL7sCj8vSyZkgtL7faaw9Tc9rZ3mGgraQ7+Pdx7w5mnOSF3gw9ZNG6oc+KXfkon3bKuROm0g=="},"url-parse":{"version":"1.2.0","resolved":"https://registry.npmjs.org/url-parse/-/url-parse-1.2.0.tgz","integrity":"sha512-DT1XbYAfmQP65M/mE6OALxmXzZ/z1+e5zk2TcSKe/KiYbNGZxgtttzC0mR/sjopbpOXcbniq7eIKmocJnUWlEw==","dev":true,"requires":{"querystringify":"1.0.0","requires-port":"1.0.0"}},"url-parse-lax":{"version":"1.0.0","resolved":"https://registry.npmjs.org/url-parse-lax/-/url-parse-lax-1.0.0.tgz","integrity":"sha1-evjzA2Rem9eaJy56FKxovAYJ2nM=","dev":true,"requires":{"prepend-http":"1.0.4"}},"url-to-options":{"version":"1.0.1","resolved":"https://registry.npmjs.org/url-to-options/-/url-to-options-1.0.1.tgz","integrity":"sha1-FQWgOiiaSMvXpDTvuu7FBV9WM6k=","dev":true},"user-home":{"version":"1.1.1","resolved":"https://registry.npmjs.org/user-home/-/user-home-1.1.1.tgz","integrity":"sha1-K1viOjK2Onyd640PKNSFcko98ZA=","dev":true},"util-deprecate":{"version":"1.0.2","resolved":"https://registry.npmjs.org/util-deprecate/-/util-deprecate-1.0.2.tgz","integrity":"sha1-RQ1Nyfpw3nMnYvvS1KKJgUGaDM8=","dev":true},"uuid":{"version":"3.2.1","resolved":"https://registry.npmjs.org/uuid/-/uuid-3.2.1.tgz","integrity":"sha512-jZnMwlb9Iku/O3smGWvZhauCf6cvvpKi4BKRiliS3cxnI+Gz9j5MEpTz2UFuXiKPJocb7gnsLHwiS05ige5BEA==","dev":true},"v8flags":{"version":"2.1.1","resolved":"https://registry.npmjs.org/v8flags/-/v8flags-2.1.1.tgz","integrity":"sha1-qrGh+jDUX4jdMhFIh1rALAtV5bQ=","dev":true,"requires":{"user-home":"1.1.1"}},"validate-npm-package-license":{"version":"3.0.1","resolved":"https://registry.npmjs.org/validate-npm-package-license/-/validate-npm-package-license-3.0.1.tgz","integrity":"sha1-KAS6vnEq0zeUWaz74kdGqywwP7w=","dev":true,"requires":{"spdx-correct":"1.0.2","spdx-expression-parse":"1.0.4"}},"watch":{"version":"1.0.2","resolved":"https://registry.npmjs.org/watch/-/watch-1.0.2.tgz","integrity":"sha1-NApxe952Vyb6CqB9ch4BR6VR3ww=","dev":true,"requires":{"exec-sh":"0.2.1","minimist":"1.2.0"},"dependencies":{"minimist":{"version":"1.2.0","resolved":"https://registry.npmjs.org/minimist/-/minimist-1.2.0.tgz","integrity":"sha1-o1AIsg9BOD7sH7kU9M1d95omQoQ=","dev":true}}},"whatwg-fetch":{"version":"2.0.3","resolved":"https://registry.npmjs.org/whatwg-fetch/-/whatwg-fetch-2.0.3.tgz","integrity":"sha1-nITsLc9oGH/wC8ZOEnS0QhduHIQ="},"which":{"version":"1.3.0","resolved":"https://registry.npmjs.org/which/-/which-1.3.0.tgz","integrity":"sha512-xcJpopdamTuY5duC/KnTTNBraPK54YwpenP4lzxU8H91GudWpFv38u0CKjclE1Wi2EH2EDz5LRcHcKbCIzqGyg==","dev":true,"requires":{"isexe":"2.0.0"}},"wrappy":{"version":"1.0.2","resolved":"https://registry.npmjs.org/wrappy/-/wrappy-1.0.2.tgz","integrity":"sha1-tSQ9jz7BqjXxNkYFvA0QNuMKtp8=","dev":true},"xtend":{"version":"4.0.1","resolved":"https://registry.npmjs.org/xtend/-/xtend-4.0.1.tgz","integrity":"sha1-pcbVMr5lbiPbgg77lDofBJmNY68=","dev":true},"yallist":{"version":"2.1.2","resolved":"https://registry.npmjs.org/yallist/-/yallist-2.1.2.tgz","integrity":"sha1-HBH5IY8HYImkfdUS+TxmmaaoHVI=","dev":true}}}

/***/ }),

/***/ "./app_modules/course-of-action-activity/package.json":
/***/ (function(module, exports) {

module.exports = {"name":"course-of-action-activity","version":"1.0.6","description":"TRC  Course of Action Activity","main":"dist/index.js","module":"src/index.js","files":["dist","README.md","CHANGELOG.md"],"scripts":{"test":"cross-env BABEL_ENV=test node ./node_modules/.bin/trc-test \"tests/*.js\"","inspect":"cross-env BABEL_ENV=test node ./node_modules/.bin/trc-inspect \"tests/*.js\"","compile":"npm run test && npm run copy-css && npm run copy-json && npm run copy-xml && babel src -d dist","copy-css":"copyfiles -u 1 \"src/*.css\" dist && copyfiles -u 1 \"src/**/*.css\" dist","copy-json":"copyfiles -u 1 \"src/*.json\" dist && copyfiles -u 1 \"src/**/*.json\" dist","copy-xml":"copyfiles -u 1 \"src/*.xml\" dist && copyfiles -u 1 \"src/**/*.xml\" dist","publish-major":"npm run test && npm run compile && is-online && npm version major && trc-tagme && git push --follow-tags","publish-minor":"npm run test && npm run compile && is-online && npm version minor && trc-tagme && git push --follow-tags","publish":"npm run test && npm run compile && is-online && npm version patch && trc-tagme && git push --follow-tags","publish-patch":"npm run publish"},"devDependencies":{"babel-cli":"^6.26.0","babel-plugin-module-resolver":"^3.0.0-beta.5","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-require-ignore":"^0.1.1","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.0","babel-preset-react":"^6.24.0","babel-preset-stage-1":"^6.24.0","component-testing-tools":"https://gitlab.com/regiscompany/component-testing-tools.git","copyfiles":"1.2.0","cross-env":"^5.0.5","deep-extend":"^0.5.0","enzyme":"^2.9.1","is-online-cli":"^2.0.0","react-test-renderer":"^15.6.1","tape":"4.5.1","trc-debug-runner":"https://gitlab.com/regiscompany/trc-debug-runner.git","trc-tagme":"https://gitlab.com/regiscompany/trc-tagme.git"},"author":"","license":"ISC","dependencies":{"deep-bind-decorator":"https://gitlab.com/regiscompany/deep-bind-decorator.git#v1.0.4","mobx":"^3.0.2","mobx-react":"^4.1.0","react":"^15.4.2","react-dom":"^15.4.2"},"repository":{"type":"git","url":"git+https://gitlab.com/regiscompany/trc-component-template.git"}}

/***/ }),

/***/ "./app_modules/course-of-action-activity/src/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CourseOfAction = exports.CourseOfActionViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _class3, _class4, _temp2, _dec5, _desc2, _value2, _class5, _class6, _class7, _temp3;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * A course of action component presents one or more selections and users choose one of the selections.
 * At any time, only one action is visible.
 * Zero or one of the selections may be selected.
 * Selections can have criteria: choices that users make to further describe why they choose a particular action.
 */

var CourseOfActionViewStore = exports.CourseOfActionViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(CourseOfActionViewStore, _BaseViewStore);

  function CourseOfActionViewStore() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CourseOfActionViewStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CourseOfActionViewStore.__proto__ || (0, _getPrototypeOf2.default)(CourseOfActionViewStore)).call.apply(_ref, [this].concat(args))), _this), _this.currentTabIndex = 0, _this.currentSelectionTabIndex = 10000, _initDefineProp(_this, 'visibleAction', _descriptor, _this), _initDefineProp(_this, 'optionValues', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CourseOfActionViewStore, [{
    key: 'updateUserInput',
    value: function updateUserInput(val) {
      var contentModel = this.props.contentModel;

      // this updates user input property `userInput`, defined on the contentModel

      contentModel.updateInput("userInput", val);
    }
  }, {
    key: 'save',
    value: function save() {
      alert("This will save user input");
    }
  }, {
    key: 'showAction',
    value: function showAction(index) {
      this.visibleAction = index;
    }
  }, {
    key: 'selectAction',
    value: function selectAction() {
      var contentModel = this.props.contentModel;


      contentModel.setInput('selectedActionIndex', this.visibleAction);
      contentModel.saveInputs(function () {
        return console.info('Selected COA Action');
      });
    }
  }, {
    key: 'nextTabIndex',
    get: function get() {
      return ++this.currentTabIndex;
    }
  }, {
    key: 'nextSelectionTabIndex',
    get: function get() {
      return ++this.currentSelectionTabIndex;
    }
  }, {
    key: 'invalid',
    get: function get() {
      return {};
    }
  }, {
    key: 'selectedAction',
    get: function get() {
      var contentModel = this.props.contentModel;


      var action = contentModel.getInput('selectedActionIndex');
      return action;
    }
  }]);
  return CourseOfActionViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'visibleAction', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'optionValues', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'invalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectedAction', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectedAction'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateUserInput', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateUserInput'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'save', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'save'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showAction', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'showAction'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectAction', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectAction'), _class.prototype)), _class));

var CourseOfAction = exports.CourseOfAction = (0, _autoclassDecorator2.default)(_class3 = (0, _simboxEditable.Decorator)(_class3 = (0, _mobxReact.observer)(_class3 = (_temp2 = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(CourseOfAction, _BaseComponent);

  function CourseOfAction() {
    (0, _classCallCheck3.default)(this, CourseOfAction);
    return (0, _possibleConstructorReturn3.default)(this, (CourseOfAction.__proto__ || (0, _getPrototypeOf2.default)(CourseOfAction)).apply(this, arguments));
  }

  (0, _createClass3.default)(CourseOfAction, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'render',
    value: function render() {
      var contentModel = this.props.contentModel;
      var selections = contentModel.selections,
          criteriaTitle = contentModel.criteriaTitle,
          introText = contentModel.introText; // this contentModel's properties

      var _viewStore = this.viewStore,
          visibleAction = _viewStore.visibleAction,
          showAction = _viewStore.showAction,
          selectAction = _viewStore.selectAction,
          selectOption = _viewStore.selectOption,
          selectedAction = _viewStore.selectedAction,
          optionValue = _viewStore.optionValue; // this components viewStore.  Will have selections and UI properties

      var vs = this.viewStore;

      if (!selections || selections.length === 0) {
        return _react2.default.createElement(
          'div',
          { className: 'coa' },
          'You must have at least one Action.'
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'coa', role: 'main', 'aria-label': 'Course of Action' },
        _react2.default.createElement('div', { className: 'introduction', dangerouslySetInnerHTML: { __html: introText } }),
        _react2.default.createElement(
          'div',
          { className: 'coa-content' },
          _react2.default.createElement(
            'div',
            { className: 'tabbed-panel' },
            _react2.default.createElement(
              'div',
              { className: 'tabs', role: 'navigation',
                'aria-label': 'Course of Action: Choose one of ' + selections.length + ' options' },
              selections.map(function (action, index) {
                return _react2.default.createElement(
                  'div',
                  {
                    key: index,
                    className: 'tab' + (index === visibleAction ? ' selected' : ''),
                    onClick: function onClick() {
                      return showAction(index);
                    },
                    role: 'button',
                    'aria-label': 'Option ' + (index + 1) + ': ' + action.title + '.\n                    ' + (index === selectedAction ? 'This option is selected' : ''),
                    tabIndex: vs.nextTabIndex
                  },
                  index === selectedAction ? _react2.default.createElement('i', { className: 'fa fa-check', 'aria-label': 'Selected' }) : null,
                  _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: action.title } })
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'tab-contents' },
              visibleAction >= 0 && _react2.default.createElement(
                'div',
                { className: 'tab-content' },
                _react2.default.createElement('div', { className: 'heading',
                  dangerouslySetInnerHTML: { __html: selections[visibleAction].text } }),
                _react2.default.createElement(
                  'div',
                  { className: 'selected-tab' },
                  selectedAction >= 0 && _react2.default.createElement(
                    'div',
                    { className: 'selected-title', tabIndex: vs.nextSelectionTabIndex },
                    _react2.default.createElement('span', {
                      dangerouslySetInnerHTML: { __html: selections[selectedAction].title } }),
                    _react2.default.createElement(
                      'span',
                      { className: 'is-selected' },
                      'is selected'
                    )
                  ),
                  selectedAction < 0 && _react2.default.createElement(
                    'div',
                    { className: 'selected-title',
                      tabIndex: vs.nextSelectionTabIndex },
                    'Select an action'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'button',
                      onClick: selectAction,
                      role: 'button',
                      'aria-labelledby': selections[selectedAction] ? selections[selectedAction].displayName : '',
                      tabIndex: vs.nextSelectionTabIndex },
                    'Select\xA0',
                    _react2.default.createElement('span', {
                      id: selections[selectedAction] ? selections[selectedAction].displayName : '',
                      dangerouslySetInnerHTML: { __html: selections[visibleAction].title } })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'outcomes-panel' },
            _react2.default.createElement('h3', { className: 'outcomes-title',
              dangerouslySetInnerHTML: { __html: criteriaTitle } }),
            _react2.default.createElement(
              'div',
              { className: 'outcomes' },
              _react2.default.createElement(
                'div',
                { className: 'outcome' },
                visibleAction >= 0 && selections[visibleAction].impacts.map(function (currentImpact, impactIndex) {
                  return _react2.default.createElement(ImpactOptions, { impact: currentImpact, nextTabIndex: vs.nextTabIndex, key: currentImpact.id });
                })
              )
            )
          )
        )
      );
    }
  }]);
  return CourseOfAction;
}(_baseComponent2.default), _class4.ViewStore = CourseOfActionViewStore, _temp2)) || _class3) || _class3) || _class3;

var impactOptionsViewStore = (_dec5 = _mobx.action.bound, (_class5 = function (_BaseViewStore2) {
  (0, _inherits3.default)(impactOptionsViewStore, _BaseViewStore2);

  function impactOptionsViewStore() {
    (0, _classCallCheck3.default)(this, impactOptionsViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (impactOptionsViewStore.__proto__ || (0, _getPrototypeOf2.default)(impactOptionsViewStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(impactOptionsViewStore, [{
    key: 'selectValue',
    value: function selectValue(value) {
      var impact = this.props.impact;


      impact.setInput('selectedValue', value);
      impact.saveInputs();
    }
  }, {
    key: 'selectedValue',
    get: function get() {
      var impact = this.props.impact;


      return impact.getInput('selectedValue');
    }
  }]);
  return impactOptionsViewStore;
}(_baseViewstore2.default), (_applyDecoratedDescriptor(_class5.prototype, 'selectedValue', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'selectedValue'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'selectValue', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'selectValue'), _class5.prototype)), _class5));

var ImpactOptions = (0, _mobxReact.observer)(_class6 = (_temp3 = _class7 = function (_BaseComponent2) {
  (0, _inherits3.default)(ImpactOptions, _BaseComponent2);

  function ImpactOptions() {
    (0, _classCallCheck3.default)(this, ImpactOptions);
    return (0, _possibleConstructorReturn3.default)(this, (ImpactOptions.__proto__ || (0, _getPrototypeOf2.default)(ImpactOptions)).apply(this, arguments));
  }

  (0, _createClass3.default)(ImpactOptions, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          impact = _props.impact,
          nextTabIndex = _props.nextTabIndex,
          inputStore = _props.inputStore;
      var _viewStore2 = this.viewStore,
          selectedValue = _viewStore2.selectedValue,
          selectValue = _viewStore2.selectValue;


      console.log(inputStore);

      return _react2.default.createElement(
        'div',
        { className: 'impact' },
        _react2.default.createElement(
          'h4',
          { className: 'impact-title', 'aria-labeledby': impact.displayName },
          _react2.default.createElement('span', { id: impact.displayName, dangerouslySetInnerHTML: { __html: impact.text } })
        ),
        _react2.default.createElement(
          'div',
          { className: 'options' },
          impact.options.map(function (option, optionIndex) {
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('input', { type: 'radio',
                name: impact.displayName,
                value: option.value,
                key: option.id,
                id: option.displayName + '_' + optionIndex,
                onChange: function onChange(e) {
                  selectValue(option.value);_this5.forceUpdate();
                },
                checked: selectedValue === option.value,
                tabIndex: nextTabIndex }),
              _react2.default.createElement(
                'label',
                { htmlFor: option.displayName + '_' + optionIndex },
                option.name
              )
            );
          })
        )
      );
    }
  }]);
  return ImpactOptions;
}(_baseComponent2.default), _class7.ViewStore = impactOptionsViewStore, _temp3)) || _class6;

var _default = CourseOfAction;
exports.default = _default;
;

var _temp4 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CourseOfActionViewStore, 'CourseOfActionViewStore', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/component.js');

  __REACT_HOT_LOADER__.register(CourseOfAction, 'CourseOfAction', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/component.js');

  __REACT_HOT_LOADER__.register(impactOptionsViewStore, 'impactOptionsViewStore', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/component.js');

  __REACT_HOT_LOADER__.register(ImpactOptions, 'ImpactOptions', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/component.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/component.js');
}();

;

/***/ }),

/***/ "./app_modules/course-of-action-activity/src/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CourseOfActionContentModel = exports.CourseOfActionActionContentModel = exports.CourseOfActionImpactContentModel = exports.CourseOfActionOptionContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _class2, _temp2, _dec, _desc2, _value2, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class4, _temp4, _desc3, _value3, _class5, _descriptor7, _descriptor8, _descriptor9, _class6, _temp6, _dec2, _desc4, _value4, _class7, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _class8, _temp8;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _component = __webpack_require__("./app_modules/course-of-action-activity/src/component.js");

var _component2 = _interopRequireDefault(_component);

var _deepBindDecorator = __webpack_require__("./node_modules/deep-bind-decorator/dist/deep-bind-decorator.js");

var _deepBindDecorator2 = _interopRequireDefault(_deepBindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CourseOfActionOptionContentModel = exports.CourseOfActionOptionContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(CourseOfActionOptionContentModel, _BaseContentModel);

  function CourseOfActionOptionContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CourseOfActionOptionContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CourseOfActionOptionContentModel.__proto__ || (0, _getPrototypeOf2.default)(CourseOfActionOptionContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'name', _descriptor, _this), _initDefineProp(_this, 'value', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CourseOfActionOptionContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return { name: "Default",
        value: "1" };
    }
    /* @slot */
    /* @slot */
  }]);
  return CourseOfActionOptionContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  name: "",
  value: ""
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
})), _class);
var CourseOfActionImpactContentModel = exports.CourseOfActionImpactContentModel = (_dec = _mobx.observable.shallow, (_class3 = (_temp4 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(CourseOfActionImpactContentModel, _BaseContentModel2);

  function CourseOfActionImpactContentModel() {
    var _ref2;

    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, CourseOfActionImpactContentModel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = CourseOfActionImpactContentModel.__proto__ || (0, _getPrototypeOf2.default)(CourseOfActionImpactContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _initDefineProp(_this2, 'text', _descriptor3, _this2), _initDefineProp(_this2, 'options', _descriptor4, _this2), _initDefineProp(_this2, 'selectedOption', _descriptor5, _this2), _initDefineProp(_this2, 'selectedValue', _descriptor6, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  (0, _createClass3.default)(CourseOfActionImpactContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return { text: "Default",
        options: [] };
    }
    /* @slot("RichText") */
    /* @slot([CourseOfActionOptionContentModel]) */
  }]);
  return CourseOfActionImpactContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  text: 'RichText',
  options: [CourseOfActionOptionContentModel]
}, _temp4), (_descriptor3 = _applyDecoratedDescriptor(_class3.prototype, 'text', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'options', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'selectedOption', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return -1;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'selectedValue', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_selectedValue:G';
      },
      defaultValue: ''
    };
  }
})), _class3));
var CourseOfActionActionContentModel = exports.CourseOfActionActionContentModel = (_class5 = (_temp6 = _class6 = function (_BaseContentModel3) {
  (0, _inherits3.default)(CourseOfActionActionContentModel, _BaseContentModel3);

  function CourseOfActionActionContentModel() {
    var _ref3;

    var _temp5, _this3, _ret3;

    (0, _classCallCheck3.default)(this, CourseOfActionActionContentModel);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp5 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = CourseOfActionActionContentModel.__proto__ || (0, _getPrototypeOf2.default)(CourseOfActionActionContentModel)).call.apply(_ref3, [this].concat(args))), _this3), _initDefineProp(_this3, 'impacts', _descriptor7, _this3), _initDefineProp(_this3, 'text', _descriptor8, _this3), _initDefineProp(_this3, 'title', _descriptor9, _this3), _temp5), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
  }

  (0, _createClass3.default)(CourseOfActionActionContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return {
        text: "Default",
        impacts: [],
        title: ""
      };
    }
    /* @slot(CourseOfActionImpactContentModel) */
    /* @slot("RichText") */
    /* @slot */
  }]);
  return CourseOfActionActionContentModel;
}(_baseContentmodel2.default), _class6._slots = {
  impacts: [CourseOfActionImpactContentModel],
  text: "RichText",
  title: ""
}, _temp6), (_descriptor7 = _applyDecoratedDescriptor(_class5.prototype, 'impacts', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class5.prototype, 'text', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class5.prototype, 'title', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
})), _class5);
var CourseOfActionContentModel = exports.CourseOfActionContentModel = (_dec2 = _mobx.observable.shallow, (_class7 = (_temp8 = _class8 = function (_BaseContentModel4) {
  (0, _inherits3.default)(CourseOfActionContentModel, _BaseContentModel4);

  function CourseOfActionContentModel() {
    var _ref4;

    var _temp7, _this4, _ret4;

    (0, _classCallCheck3.default)(this, CourseOfActionContentModel);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp7 = (_this4 = (0, _possibleConstructorReturn3.default)(this, (_ref4 = CourseOfActionContentModel.__proto__ || (0, _getPrototypeOf2.default)(CourseOfActionContentModel)).call.apply(_ref4, [this].concat(args))), _this4), _this4.Component = _component2.default, _initDefineProp(_this4, 'selections', _descriptor10, _this4), _initDefineProp(_this4, 'criteriaTitle', _descriptor11, _this4), _initDefineProp(_this4, 'introText', _descriptor12, _this4), _initDefineProp(_this4, 'selectedAction', _descriptor13, _this4), _initDefineProp(_this4, 'selectedActionIndex', _descriptor14, _this4), _initDefineProp(_this4, 'optionValues', _descriptor15, _this4), _temp7), (0, _possibleConstructorReturn3.default)(_this4, _ret4);
  }

  (0, _createClass3.default)(CourseOfActionContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return {
        criteriaTitle: "Default",
        selections: []
      };
    }

    // define the default Component (Sim) view of this component

    /* @slot([CourseOfActionActionContentModel]) */
    /* slot */
    /* slot */
  }]);
  return CourseOfActionContentModel;
}(_baseContentmodel2.default), _class8._slots = {
  selections: [CourseOfActionActionContentModel],
  criteriaTitle: "",
  introText: "RichText"
}, _temp8), (_descriptor10 = _applyDecoratedDescriptor(_class7.prototype, 'selections', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class7.prototype, 'criteriaTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "How will the selected action impact the following?";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class7.prototype, 'introText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class7.prototype, 'selectedAction', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return -1;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class7.prototype, 'selectedActionIndex', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_selectedActionIndex:G';
      },
      defaultValue: -1
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class7.prototype, 'optionValues', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_optionValues:G';
      },
      defaultValue: {}
    };
  }
})), _class7));
var _default = CourseOfActionContentModel;
exports.default = _default;
;

var _temp9 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CourseOfActionOptionContentModel, 'CourseOfActionOptionContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/contentmodel.js');

  __REACT_HOT_LOADER__.register(CourseOfActionImpactContentModel, 'CourseOfActionImpactContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/contentmodel.js');

  __REACT_HOT_LOADER__.register(CourseOfActionActionContentModel, 'CourseOfActionActionContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/contentmodel.js');

  __REACT_HOT_LOADER__.register(CourseOfActionContentModel, 'CourseOfActionContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/course-of-action-activity/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./app_modules/course-of-action-activity/src/contentmodel.js");

var courseOfActionContentModels = _interopRequireWildcard(_contentmodel);

__webpack_require__("./app_modules/course-of-action-activity/src/style.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = courseOfActionContentModels;
var ContentModel = exports.ContentModel = courseOfActionContentModels.default;

var description = exports.description = "This is the course of action activity.";
var instructions = exports.instructions = "";
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/index.js');

  __REACT_HOT_LOADER__.register(description, 'description', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/index.js');

  __REACT_HOT_LOADER__.register(instructions, 'instructions', 'D:/VSTS/agent/_work/24/s/app_modules/course-of-action-activity/src/index.js');
}();

;

/***/ }),

/***/ "./app_modules/course-of-action-activity/src/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app_modules/default-simulation-shell/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.DefaultShellComponent = exports.DefaultShellViewStore = exports.MenuBar = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _desc, _value, _class2, _descriptor, _descriptor2, _class4, _class5, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

var _simgateDatamodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simgate-datamodel/index.js");

var _simgateDatamodel2 = _interopRequireDefault(_simgateDatamodel);

var _projectDomainStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/project-domain-store/index.js");

var _projectDomainStore2 = _interopRequireDefault(_projectDomainStore);

var _simDomainStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/sim-domain-store/index.js");

var _simDomainStore2 = _interopRequireDefault(_simDomainStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var MenuBar = exports.MenuBar = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
    (0, _inherits3.default)(MenuBar, _BaseComponent);

    function MenuBar() {
        (0, _classCallCheck3.default)(this, MenuBar);
        return (0, _possibleConstructorReturn3.default)(this, (MenuBar.__proto__ || (0, _getPrototypeOf2.default)(MenuBar)).apply(this, arguments));
    }

    (0, _createClass3.default)(MenuBar, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                viewMap = _props.viewMap,
                clickItem = _props.clickItem,
                currentView = _props.currentView,
                currentViewId = _props.currentViewId,
                currentRound = _props.currentRound,
                isEvent = _props.isEvent;

            var specificItems = [];
            var genericItems = [];
            var positions = ["Strategy", "Lease Management", "Exploration", "Development", "Production", "Transportation", "Refining", "Product Marketing"];
            var home = null;
            var resources = null;
            var financials = null;
            (0, _keys2.default)(viewMap).reduce(function (acc, k) {
                var v = viewMap[k];
                var element = null;
                if (typeof v === "function") {
                    element = { id: k, Component: v };
                } else if (v.show || v.menu && v.menu.show) {
                    element = v;
                } else if (v.onClick || v.clickItem) {
                    element = (0, _assign2.default)({}, v, { id: k }, { clickItem: v.onClick || v.clickItem });
                }

                if (!element || element.menu.displayName.indexOf("Event") == 0) {
                    return;
                }

                element.iconClass = element.icon || element.contentModel && element.contentModel.icon || "";
                element.menu = (0, _assign2.default)({ clickItem: clickItem }, element, element.menu);
                element.itemStatus = currentViewId && element.menu.id === currentViewId || currentView && currentView.id === element.menu.id ? "active" : "inactive";
                element.itemStatus += element.contentModel && element.contentModel.activity && (element.contentModel.activity.isSubmitted || element.contentModel.activity.isCompleted) ? " complete" : "";
                element.itemStatus += isEvent ? " disabled" : "";

                if (positions.indexOf(element.menu.displayName) >= 0) {
                    specificItems[positions.indexOf(element.menu.displayName)] = element;
                } else if (element.menu.displayName == "Home") {
                    home = element;
                } else if (element.menu.displayName == "Resources") {
                    resources = element;
                } else if (element.menu.displayName == "Financials") {
                    financials = element;
                } else {
                    genericItems.push(element);
                }
                return [];
            }, []);

            function getItem(css, item) {
                return _react2.default.createElement(
                    "div",
                    { className: "item " + css + " " + item.itemStatus + " " + item.menu.id, onClick: function onClick(e) {
                            return !!item.menu.clickItem && item.menu.clickItem(item, viewMap);
                        }, disabled: item.menu.hasOwnProperty('enabled') ? !item.menu.enabled : false },
                    _react2.default.createElement("div", { className: "icon" }),
                    _react2.default.createElement(
                        "div",
                        { className: "label" },
                        item.menu.displayName || item.menu.id
                    )
                );
            }

            return _react2.default.createElement(
                "div",
                { className: "menu" },
                home && _react2.default.createElement(
                    "div",
                    { className: "item home " + (isEvent ? " disabled " : " ") + home.menu.id, onClick: function onClick(e) {
                            return !!home.menu.clickItem && home.menu.clickItem(home, viewMap);
                        } },
                    _react2.default.createElement("div", { className: "icon" }),
                    _react2.default.createElement(
                        "div",
                        { className: "label" },
                        "Home"
                    )
                ),
                resources && _react2.default.createElement(
                    "div",
                    { className: "item resources " + (isEvent ? " disabled " : " ") + " " + resources.menu.id, style: { paddingTop: 0, paddingBottom: '5px' }, onClick: function onClick(e) {
                            return !!resources.menu.clickItem && resources.menu.clickItem(resources, viewMap);
                        } },
                    _react2.default.createElement("div", { className: "icon" }),
                    _react2.default.createElement(
                        "div",
                        { className: "label" },
                        "Resources"
                    )
                ),
                financials && _react2.default.createElement(
                    "div",
                    { className: "item financials " + (isEvent ? " disabled " : " ") + " " + financials.menu.id, style: { paddingTop: 0 }, onClick: function onClick(e) {
                            return !!financials.menu.clickItem && financials.menu.clickItem(financials, viewMap);
                        } },
                    _react2.default.createElement("div", { className: "icon fa fa-book" }),
                    _react2.default.createElement(
                        "div",
                        { className: "label" },
                        "Financials"
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "item message round" },
                    !!currentRound && currentRound.displayName || currentRound.id
                ),
                _react2.default.createElement(
                    "div",
                    { className: "sub-menu" },
                    genericItems.map(function (view, index) {
                        return _react2.default.createElement(
                            "div",
                            { key: "" + view.menu.id + index, className: "item " + view.iconClass + " " + view.itemStatus + " " + view.menu.id, onClick: function onClick(e) {
                                    return !!view.menu.clickItem && view.menu.clickItem(view, viewMap);
                                }, disabled: view.menu.hasOwnProperty('enabled') ? !view.menu.enabled : false },
                            _react2.default.createElement("div", { className: "icon" }),
                            _react2.default.createElement(
                                "div",
                                { className: "label" },
                                view.menu.displayName || view.menu.id
                            )
                        );
                    })
                ),
                specificItems[0] && _react2.default.createElement(
                    "div",
                    { className: "sub-menu" },
                    _react2.default.createElement(
                        "div",
                        { className: "title" },
                        "Strategy"
                    ),
                    getItem("capital", specificItems[0])
                ),
                (specificItems[1] || specificItems[2] || specificItems[3] || specificItems[4]) && _react2.default.createElement(
                    "div",
                    { className: "sub-menu" },
                    _react2.default.createElement(
                        "div",
                        { className: "title" },
                        "Upstream"
                    ),
                    specificItems[1] && getItem("lease", specificItems[1]),
                    specificItems[2] && getItem("exploration", specificItems[2]),
                    specificItems[3] && getItem("development", specificItems[3]),
                    specificItems[4] && getItem("production", specificItems[4])
                ),
                specificItems[5] && _react2.default.createElement(
                    "div",
                    { className: "sub-menu" },
                    _react2.default.createElement(
                        "div",
                        { className: "title" },
                        "Midstream"
                    ),
                    getItem("transportation", specificItems[5])
                ),
                (specificItems[7] || specificItems[7]) && _react2.default.createElement(
                    "div",
                    { className: "sub-menu" },
                    _react2.default.createElement(
                        "div",
                        { className: "title" },
                        "Downstream"
                    ),
                    specificItems[1] && getItem("refining", specificItems[6]),
                    specificItems[2] && getItem("marketing", specificItems[7])
                )
            );
        }
    }]);
    return MenuBar;
}(_baseComponent2.default)) || _class;

var DefaultShellViewStore = exports.DefaultShellViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, (_class2 = function (_mix$with) {
    (0, _inherits3.default)(DefaultShellViewStore, _mix$with);

    function DefaultShellViewStore() {
        (0, _classCallCheck3.default)(this, DefaultShellViewStore);

        // <Shell 
        //   contentModel={simulation.shell} 
        //   simulation={simulation} 
        //   dataModel={dataModel} 
        //   projectDomainStore={projectDomainStore}
        //   parentPathId={parentPathId}
        //   application={application}
        // />

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (DefaultShellViewStore.__proto__ || (0, _getPrototypeOf2.default)(DefaultShellViewStore)).apply(this, arguments));

        _initDefineProp(_this2, "isInitilized", _descriptor, _this2);

        _initDefineProp(_this2, "needsStrategy", _descriptor2, _this2);

        _this2.advanceInterval = null;
        var _this2$props = _this2.props,
            shell = _this2$props.contentModel,
            simulation = _this2$props.simulation,
            simDomainStore = _this2$props.dataModel.domainStore,
            projectDomainStore = _this2$props.projectDomainStore,
            parentPathId = _this2$props.parentPathId,
            application = _this2$props.application;


        window.application.shell = _this2;
        return _this2;
    }

    (0, _createClass3.default)(DefaultShellViewStore, [{
        key: "completeState",
        value: function completeState() {
            var simDomainStore = this.props.dataModel.domainStore;


            simDomainStore.completeTask();
        }
    }, {
        key: "logout",
        value: function logout() {
            var _props2 = this.props,
                contentModel = _props2.contentModel,
                projectDomainStore = _props2.dataModel.domainStore;

            var modalViewStore = window.application.modalViewStore;

            //just in case we're already signed in :-)
            if (!(process && __webpack_require__.i({"api":"simgate","NODE_ENV":"production","localMode":false}) && __webpack_require__.i({"api":"simgate","NODE_ENV":"production","localMode":false}).mockMode)) projectDomainStore.refreshContext();

            var dirtyEntities = contentModel.$parent.entities.values().filter(function (ent) {
                return ent.isDirty;
            });
            modalViewStore.setModal({
                title: "Are you sure you want to log out?",
                message: "Any unsaved changes may be lost.",
                confirmLabel: 'Logout',
                confirmBtnClass: 'green check-a',
                cancelLabel: 'Cancel',
                cancelBtnClass: 'red times-b',
                onConfirmFunc: function onConfirmFunc() {
                    projectDomainStore.simgate.signOut().then(function () {
                        return window.location.reload();
                    }).catch(function () {
                        return window.location.reload();
                    });
                }
            });
        }
    }, {
        key: "showEvent",
        value: function showEvent(event) {
            this.selectView(event);
        }
    }, {
        key: "checkForAdvanced",
        value: function checkForAdvanced() {

            if (this.advanceInterval || this.roundComplete < 1) {
                return;
            }

            var _props3 = this.props,
                simulation = _props3.simulation,
                simDomainStore = _props3.dataModel.domainStore;


            var roundNo = simDomainStore.currentRoundNo ? simDomainStore.currentRoundNo - 1 : 0;

            var self = this;
            this.advanceInterval = setInterval(function () {
                simDomainStore.refreshContext(function () {
                    var newRoundNo = simDomainStore.currentRoundNo ? simDomainStore.currentRoundNo - 1 : 0;
                    if (newRoundNo != roundNo) {
                        clearInterval(self.advanceInterval);
                        self.advanceInterval = null;
                        self.isInitilized = false;
                        return;
                    }
                });
            }, 15 * 1000);
        }
    }, {
        key: "preSelectView",
        value: function preSelectView(menu) {
            if (this._currentView == menu.id) {
                return;
            }
            this.selectView(menu);
        }
    }, {
        key: "updateState",
        value: function updateState() {
            var _props4 = this.props,
                contentModel = _props4.contentModel,
                domainStore = _props4.dataModel.domainStore;


            this.isInitilized = true;
            var viewMap = this.viewMap;
            var eventList = this.eventList;
            var selectView = this.selectView;
            var roundComplete = this.roundComplete;
            var self = this;

            var first = null;
            var home = null;
            var resources = null;
            var financials = null;
            var inputs = [];

            for (var i in viewMap) {
                var view = viewMap[i];
                inputs.push(view.contentModel.activity.id + "_isSubmitted");
            }

            this.isLoading = true;

            if (!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId || inputs.length == 0) {
                return;
            }

            var taskArgs = [domainStore.simgate.selectData, {
                select: inputs,
                path: window.application.dataModel.domainStore.context.team.pathId
            }, {
                //wrap in action for mobx transaction purposes (only refresh views after complete)
                onSuccess: (0, _mobx.action)("loadData-callback", function (res) {
                    var data = res.selected && res.selected.data || {};

                    var any = false;
                    for (var _i in viewMap) {
                        (function (view) {
                            var variable = view.contentModel.activity.id + "_isSubmitted";
                            view.contentModel.activity.isSubmitted = data && data[variable] !== undefined && !!data[variable];

                            if (!home) {
                                home = view;
                            } else if (!resources) {
                                resources = view;
                            } else if (!financials) {
                                financials = view;
                            }
                            any = any || view.contentModel.activity.isSubmitted;
                            if ((!first || first == home || first == resources || first == financials) && !view.contentModel.activity.isSubmitted) {
                                first = view;
                            }

                            if (view.contentModel.displayTitle == "Strategy") {
                                self.needsStrategy = !view.contentModel.activity.isSubmitted;
                            }

                            if (view.contentModel.displayTitle == "Development" && window.application.dataModel.domainStore.context.team.num5 == 1) {
                                var event = eventList["Event 1.1"];
                                if (!event) {
                                    return;
                                }
                                if (view.contentModel.activity.isSubmitted && !event.isSubmitted) {
                                    first = event;
                                    self.showEvent(event);
                                    (0, _mobx.when)(function () {
                                        return event.contentModel.activity.isSubmitted;
                                    }, function () {
                                        var selected = false;
                                        for (var j in viewMap) {
                                            if (viewMap[j].contentModel.displayTitle == "Production") {
                                                selectView(viewMap[j], viewMap);
                                                selected = true;
                                            }
                                        }
                                        if (!selected) {
                                            selectView(view);
                                        }
                                    });
                                } else if (!view.contentModel.activity.isSubmitted) {
                                    (0, _mobx.when)(function () {
                                        return view.contentModel.activity.isSubmitted;
                                    }, function () {
                                        self.showEvent(event);
                                        (0, _mobx.when)(function () {
                                            return event.contentModel.activity.isSubmitted;
                                        }, function () {
                                            var selected = false;
                                            for (var j in viewMap) {
                                                if (viewMap[j].contentModel.displayTitle == "Production") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if (!selected) {
                                                selectView(view);
                                            }
                                        });
                                    });
                                }
                            } else if (view.contentModel.displayTitle == "Refining" && window.application.dataModel.domainStore.context.team.num5 == 1) {
                                var _event = eventList["Event 1.2"];
                                if (!_event) {
                                    return;
                                }
                                if (!view.contentModel.activity.isSubmitted) {
                                    (0, _mobx.when)(function () {
                                        return view.contentModel.activity.isSubmitted;
                                    }, function () {
                                        if (view.contentModel.activity.HSEIndex === undefined || view.contentModel.activity.HSEIndex > 112) {
                                            return;
                                        }
                                        self.showEvent(_event);
                                        (0, _mobx.when)(function () {
                                            return _event.contentModel.activity.isSubmitted;
                                        }, function () {
                                            var selected = false;
                                            for (var j in viewMap) {
                                                if (viewMap[j].contentModel.displayTitle == "Product Marketing") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if (!selected) {
                                                selectView(view);
                                            }
                                        });
                                    });
                                }
                            } else if (view.contentModel.displayTitle == "Production" && window.application.dataModel.domainStore.context.team.num5 == 2) {
                                var _event2 = eventList["Event 2.1"];
                                if (!_event2) {
                                    return;
                                }
                                if (view.contentModel.activity.isSubmitted && !_event2.isSubmitted) {
                                    first = _event2;
                                    self.showEvent(_event2);
                                    (0, _mobx.when)(function () {
                                        return _event2.contentModel.activity.isSubmitted;
                                    }, function () {
                                        var selected = false;
                                        for (var j in viewMap) {
                                            if (viewMap[j].contentModel.displayTitle == "Transportation") {
                                                selectView(viewMap[j], viewMap);
                                                selected = true;
                                            }
                                        }
                                        if (!selected) {
                                            selectView(view);
                                        }
                                    });
                                } else if (!view.contentModel.activity.isSubmitted) {
                                    (0, _mobx.when)(function () {
                                        return view.contentModel.activity.isSubmitted;
                                    }, function () {
                                        self.showEvent(_event2);
                                        (0, _mobx.when)(function () {
                                            return _event2.contentModel.activity.isSubmitted;
                                        }, function () {
                                            var selected = false;
                                            for (var j in viewMap) {
                                                if (viewMap[j].contentModel.displayTitle == "Transportation") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if (!selected) {
                                                selectView(view);
                                            }
                                        });
                                    });
                                }
                            } else if (view.contentModel.displayTitle == "Transportation" && window.application.dataModel.domainStore.context.team.num5 == 2) {
                                var _event3 = eventList["Event 2.2"];
                                if (!_event3) {
                                    return;
                                }
                                if (view.contentModel.activity.isSubmitted && !_event3.isSubmitted) {
                                    first = _event3;
                                    self.showEvent(_event3);
                                    (0, _mobx.when)(function () {
                                        return _event3.contentModel.activity.isSubmitted;
                                    }, function () {
                                        var selected = false;
                                        for (var j in viewMap) {
                                            if (viewMap[j].contentModel.displayTitle == "Refining") {
                                                selectView(viewMap[j], viewMap);
                                                selected = true;
                                            }
                                        }
                                        if (!selected) {
                                            selectView(view);
                                        }
                                    });
                                } else if (!view.contentModel.activity.isSubmitted) {
                                    (0, _mobx.when)(function () {
                                        return view.contentModel.activity.isSubmitted;
                                    }, function () {
                                        self.showEvent(_event3);
                                        (0, _mobx.when)(function () {
                                            return _event3.contentModel.activity.isSubmitted;
                                        }, function () {
                                            var selected = false;
                                            for (var j in viewMap) {
                                                if (viewMap[j].contentModel.displayTitle == "Refining") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if (!selected) {
                                                selectView(view);
                                            }
                                        });
                                    });
                                }
                            } else if (view.contentModel.displayTitle == "Home" && window.application.dataModel.domainStore.context.team.num5 == 3) {
                                var _event4 = eventList["Event 3.1"];
                                if (!_event4) {
                                    return;
                                }
                                if (view.contentModel.activity.isSubmitted && !_event4.isSubmitted) {
                                    first = _event4;
                                    self.showEvent(_event4);
                                    (0, _mobx.when)(function () {
                                        return _event4.contentModel.activity.isSubmitted;
                                    }, function () {
                                        var selected = false;
                                        for (var j in viewMap) {
                                            if (viewMap[j].contentModel.displayTitle == "Strategy") {
                                                selectView(viewMap[j], viewMap);
                                                selected = true;
                                            }
                                        }
                                        if (!selected) {
                                            selectView(view);
                                        }
                                    });
                                } else if (!view.contentModel.activity.isSubmitted) {
                                    (0, _mobx.when)(function () {
                                        return view.contentModel.activity.isSubmitted;
                                    }, function () {
                                        self.showEvent(_event4);
                                        (0, _mobx.when)(function () {
                                            return _event4.contentModel.activity.isSubmitted;
                                        }, function () {
                                            var selected = false;
                                            for (var j in viewMap) {
                                                if (viewMap[j].contentModel.displayTitle == "Strategy") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if (!selected) {
                                                selectView(view);
                                            }
                                        });
                                    });
                                }
                            } else if (view.contentModel.displayTitle == "Refining" && window.application.dataModel.domainStore.context.team.num5 == 3) {
                                var _event5 = eventList["Event 3.2"];
                                if (!_event5) {
                                    return;
                                }
                                if (view.contentModel.activity.isSubmitted && !_event5.isSubmitted) {
                                    first = _event5;
                                    self.showEvent(_event5);
                                    (0, _mobx.when)(function () {
                                        return _event5.contentModel.activity.isSubmitted;
                                    }, function () {
                                        var selected = false;
                                        for (var j in viewMap) {
                                            if (viewMap[j].contentModel.displayTitle == "Product Marketing") {
                                                selectView(viewMap[j], viewMap);
                                                selected = true;
                                            }
                                        }
                                        if (!selected) {
                                            selectView(view);
                                        }
                                    });
                                } else if (!view.contentModel.activity.isSubmitted) {
                                    (0, _mobx.when)(function () {
                                        return view.contentModel.activity.isSubmitted;
                                    }, function () {
                                        self.showEvent(_event5);
                                        (0, _mobx.when)(function () {
                                            return _event5.contentModel.activity.isSubmitted;
                                        }, function () {
                                            var selected = false;
                                            for (var j in viewMap) {
                                                if (viewMap[j].contentModel.displayTitle == "Product Marketing") {
                                                    selectView(viewMap[j], viewMap);
                                                    selected = true;
                                                }
                                            }
                                            if (!selected) {
                                                selectView(view);
                                            }
                                        });
                                    });
                                }
                            }
                        })(viewMap[_i]);
                    }

                    if (!any && home) {
                        selectView(home, viewMap);
                    } else if (first) {
                        selectView(first, viewMap);
                    }

                    self.isLoading = false;
                }),
                onFailure: (0, _mobx.action)("loadData-error", function (err) {
                    debugger;
                    alert("There was a problem loading your data - " + err);
                })
            }];

            if (domainStore.simgate.runTask) {
                var _domainStore$simgate;

                (_domainStore$simgate = domainStore.simgate).runTask.apply(_domainStore$simgate, taskArgs);
            } else if (domainStore.simgate.AsyncTask) {
                var asyncTask = new domainStore.simgate.AsyncTask();
                asyncTask.runTask.apply(asyncTask, taskArgs);
            } else {
                domainStore.simgate.selectData(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
            }
        }
    }, {
        key: "currentRound",
        get: function get() {
            var _props5 = this.props,
                simulation = _props5.simulation,
                simDomainStore = _props5.dataModel.domainStore;


            var round = simulation.rounds[simDomainStore.currentRoundNo ? simDomainStore.currentRoundNo - 1 : 0];
            return round;
        }
    }, {
        key: "currentTeamState",
        get: function get() {
            var simDomainStore = this.props.dataModel.domainStore;

            return this.currentRound.teamStates.find(function (ts) {
                return ts.id === simDomainStore.teamStateName;
            });
        }
    }, {
        key: "currentTeamName",
        get: function get() {
            var projectDomainStore = this.props.projectDomainStore;

            return projectDomainStore.context && projectDomainStore.context.team && projectDomainStore.context.team.name || "-";
        }
    }, {
        key: "currentSessionName",
        get: function get() {
            var projectDomainStore = this.props.projectDomainStore;

            return projectDomainStore.context && projectDomainStore.context.sessionName || "-";
        }
    }, {
        key: "eventList",
        get: function get() {
            var _props6 = this.props,
                dataModel = _props6.dataModel,
                simDomainStore = _props6.dataModel.domainStore;


            var tasks = this.currentTeamState.tasks;
            return tasks && tasks.reduce(function (acc, task) {
                if (task.displayTitle.indexOf("Event") < 0) {
                    return acc;
                }
                acc[task.displayTitle] = {
                    id: task.id,
                    contentModel: task,
                    menu: {
                        get show() {
                            return true;
                        }, // can be computed based on activity
                        get enabled() {
                            return true;
                        }, // can be computed based on activity
                        displayName: task.displayTitle || task.id
                    },
                    dataModel: dataModel,
                    viewMode: "simulation"
                };
                return acc;
            }, {});
        }
    }, {
        key: "viewMap",
        get: function get() {
            var _props7 = this.props,
                dataModel = _props7.dataModel,
                simDomainStore = _props7.dataModel.domainStore;


            if (!simDomainStore.pathId || !simDomainStore.teamStateName) return {
                "loading": {
                    id: "loading",
                    Component: function Component() {
                        return _react2.default.createElement(
                            "div",
                            null,
                            "Loading..."
                        );
                    }
                }
            };

            var tasks = this.currentTeamState.tasks;
            return tasks && tasks.reduce(function (acc, task) {
                acc[task.id] = {
                    id: task.id,
                    contentModel: task,
                    menu: {
                        get show() {
                            return true;
                        }, // can be computed based on activity
                        get enabled() {
                            return true;
                        }, // can be computed based on activity
                        displayName: task.displayTitle || task.id
                    },
                    dataModel: dataModel,
                    viewMode: "simulation"
                };
                return acc;
            }, {});
        }
    }, {
        key: "roundComplete",
        get: function get() {
            var complete = 0;
            var total = 0;
            var viewMap = this.viewMap;

            if (viewMap.loading) {
                return 0;
            }

            for (var i in viewMap) {
                var view = viewMap[i];
                if (view.menu.displayName == "Resources" || view.menu.displayName == "Home" || view.menu.displayName == "Financials" || view.menu.displayName == "Event 1.2") {
                    continue;
                }
                complete += view.contentModel.activity.isSubmitted ? 1 : 0;
                total += 1;
            }
            if (total == 0 || complete == 0) {
                return 0;
            }
            if (complete >= total) {
                return 1;
            }

            return complete / total;
        }
    }, {
        key: "isEvent",
        get: function get() {
            var current = this.currentView;
            return current && current.menu && current.menu.displayName && current.menu.displayName.indexOf("Event") == 0;
        }
    }]);
    return DefaultShellViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "isInitilized", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "needsStrategy", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return true;
    }
}), _applyDecoratedDescriptor(_class2.prototype, "completeState", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "completeState"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentRound", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "currentRound"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentTeamState", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "currentTeamState"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentTeamName", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "currentTeamName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentSessionName", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "currentSessionName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "eventList", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "eventList"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "viewMap", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "viewMap"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "logout", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "logout"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "roundComplete", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "roundComplete"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isEvent", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "isEvent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showEvent", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "showEvent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "checkForAdvanced", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "checkForAdvanced"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "preSelectView", [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "preSelectView"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateState", [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "updateState"), _class2.prototype)), _class2));

//@autoclass
var DefaultShellComponent = exports.DefaultShellComponent = (0, _mobxReact.observer)(_class4 = (_temp = _class5 = function (_BaseComponent2) {
    (0, _inherits3.default)(DefaultShellComponent, _BaseComponent2);

    function DefaultShellComponent() {
        (0, _classCallCheck3.default)(this, DefaultShellComponent);
        return (0, _possibleConstructorReturn3.default)(this, (DefaultShellComponent.__proto__ || (0, _getPrototypeOf2.default)(DefaultShellComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(DefaultShellComponent, [{
        key: "render",
        value: function render() {
            var _props8 = this.props,
                shell = _props8.contentModel,
                simulation = _props8.simulation,
                dataModel = _props8.dataModel,
                projectDomainStore = _props8.projectDomainStore,
                parentPathId = _props8.parentPathId,
                application = _props8.application;
            var _viewStore = this.viewStore,
                isInitilized = _viewStore.isInitilized,
                viewMap = _viewStore.viewMap,
                preSelectView = _viewStore.preSelectView,
                clearView = _viewStore.clearView,
                SelectedView = _viewStore.SelectedView,
                currentRound = _viewStore.currentRound,
                currentTeamState = _viewStore.currentTeamState,
                currentTeamName = _viewStore.currentTeamName,
                currentSessionName = _viewStore.currentSessionName,
                completeState = _viewStore.completeState,
                logout = _viewStore.logout,
                updateState = _viewStore.updateState,
                roundComplete = _viewStore.roundComplete,
                checkForAdvanced = _viewStore.checkForAdvanced,
                isEvent = _viewStore.isEvent,
                needsStrategy = _viewStore.needsStrategy;


            if (!SelectedView && !viewMap["loading"] && !isInitilized) {
                updateState();
            }

            if (roundComplete == 1) {
                checkForAdvanced();
            }

            return _react2.default.createElement(
                "div",
                { className: "app-shell" },
                _react2.default.createElement(
                    "div",
                    { className: "content" },
                    _react2.default.createElement(
                        "div",
                        { className: "side-bar" + (isEvent ? " disabled" : "") },
                        _react2.default.createElement(
                            "div",
                            { className: "logo-bar" },
                            _react2.default.createElement("div", { className: "logo" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "tagline" },
                            "Oil & Gas"
                        ),
                        _react2.default.createElement(MenuBar, { viewMap: viewMap, clickItem: preSelectView, currentRound: currentRound, isEvent: isEvent })
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "activity-area" },
                        !SelectedView ? _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: shell.body } }) : _react2.default.createElement(SelectedView, { needsStrategy: needsStrategy })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "footer" },
                    _react2.default.createElement(
                        "div",
                        { className: "actions" },
                        _react2.default.createElement(
                            "div",
                            { className: "action", onClick: logout },
                            "Logout"
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "session-details" },
                        _react2.default.createElement(
                            "div",
                            { className: "detail" },
                            "Session: ",
                            currentSessionName
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "detail" },
                            "Team: ",
                            currentTeamName
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "detail" },
                            "Name: ",
                            projectDomainStore.context.user.loginName
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "detail" },
                            currentRound.displayName || currentRound.id
                        )
                    ),
                    roundComplete == 1 ? _react2.default.createElement(
                        "div",
                        { className: "progress-bar" },
                        _react2.default.createElement(
                            "div",
                            { className: "label", style: { width: "210px", fontSize: "18px" } },
                            _react2.default.createElement("i", { className: "fa fa-spin fa-spinner fa-fw", style: { marginRight: "10px" } }),
                            "Waiting for facilitator"
                        )
                    ) : _react2.default.createElement(
                        "div",
                        { className: "progress-bar" },
                        _react2.default.createElement(
                            "div",
                            { className: "label" },
                            "Round Progress:"
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "bar" },
                            _react2.default.createElement("div", { className: "fill", style: { width: roundComplete * 100 + "%" } })
                        )
                    )
                )
            );
        }
    }]);
    return DefaultShellComponent;
}(_baseComponent2.default), _class5.ViewStore = DefaultShellViewStore, _temp)) || _class4;

var Component = exports.Component = DefaultShellComponent;
var _default = Component;
exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(MenuBar, "MenuBar", "D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/component.js");

    __REACT_HOT_LOADER__.register(DefaultShellViewStore, "DefaultShellViewStore", "D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/component.js");

    __REACT_HOT_LOADER__.register(DefaultShellComponent, "DefaultShellComponent", "D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/component.js");

    __REACT_HOT_LOADER__.register(Component, "Component", "D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/component.js");

    __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/component.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./app_modules/default-simulation-shell/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultShellContentModel = exports.DefaultShellSubContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _class2, _temp2, _dec, _desc2, _value2, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _class4, _temp4;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _trcExampleActivity = __webpack_require__("./node_modules/trc-example-activity/dist/index.js");

var _component = __webpack_require__("./app_modules/default-simulation-shell/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DefaultShellSubContentModel = exports.DefaultShellSubContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(DefaultShellSubContentModel, _BaseContentModel);

  function DefaultShellSubContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DefaultShellSubContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DefaultShellSubContentModel.__proto__ || (0, _getPrototypeOf2.default)(DefaultShellSubContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'text', _descriptor, _this), _initDefineProp(_this, 'richText', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /* @slot */

  /* @slot("RichText") */

  return DefaultShellSubContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  text: "",
  richText: "RichText" }, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'text', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'richText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text for richText";
  }
})), _class);
var DefaultShellContentModel = exports.DefaultShellContentModel = (_dec = _mobx.observable.ref, (_class3 = (_temp4 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(DefaultShellContentModel, _BaseContentModel2);

  function DefaultShellContentModel() {
    var _ref2;

    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, DefaultShellContentModel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DefaultShellContentModel.__proto__ || (0, _getPrototypeOf2.default)(DefaultShellContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _initDefineProp(_this2, '_options', _descriptor3, _this2), _this2.Component = _component2.default, _initDefineProp(_this2, 'logo', _descriptor4, _this2), _initDefineProp(_this2, 'header', _descriptor5, _this2), _initDefineProp(_this2, 'body', _descriptor6, _this2), _initDefineProp(_this2, 'textOptionsSlot', _descriptor7, _this2), _initDefineProp(_this2, 'ref', _descriptor8, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }
  // the ContentModel classes contain the customizable "slots" that content creators will be filling in
  // presently these are defined via static _slots, but will be applied via @slot sugar
  // see the list below for examples of the slot types, and the editor input created for each:

  // options are a way to supply slots with specific options
  // this is currently defined manually, but will be taken care of by @options decorator 

  // define the default Component (Sim) view of this component

  /* @slot */

  // below is what content model definitions will ultimately look like. note the commented out decorators.
  // when these are in place, you will not need @observable, @observable.ref, etc

  /* @slot */
  /* @slot("RichText") */
  /* @options(["Option1", "Option2", "Option3"]) @slot */
  /* @slot("ExampleActivityContentModel") */

  return DefaultShellContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  logo: "",
  header: "", // textarea
  body: "RichText", // trix wysiwyg
  textOptionsSlot: "", // see _options,
  ref: _trcExampleActivity.ContentModel }, _temp4), (_descriptor3 = _applyDecoratedDescriptor(_class3.prototype, '_options', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get textOptionsSlot() {
        // turns textOptionsSlot into dropdown
        return ["Option1", "Option2", "Option3"];
      }
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'logo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "assets/images/trc-logo-inverted.svg";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'header', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'body', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, 'textOptionsSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'ref', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class3));
var _default = DefaultShellContentModel;
exports.default = _default;
;

var _temp5 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DefaultShellSubContentModel, 'DefaultShellSubContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/contentmodel.js');

  __REACT_HOT_LOADER__.register(DefaultShellContentModel, 'DefaultShellContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/default-simulation-shell/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./app_modules/default-simulation-shell/contentmodel.js");

var defaultShellContentModels = _interopRequireWildcard(_contentmodel);

var _style = __webpack_require__("./app_modules/default-simulation-shell/style.css");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = defaultShellContentModels;
var ContentModel = exports.ContentModel = defaultShellContentModels.default;

var description = exports.description = "This is the default-simulation-shell";
var instructions = exports.instructions = '\nThese are the default-simulation-shell installation instructions:\n  Step 1...\n  Step 2...\n  Step 3...\n';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/index.js');

  __REACT_HOT_LOADER__.register(description, 'description', 'D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/index.js');

  __REACT_HOT_LOADER__.register(instructions, 'instructions', 'D:/VSTS/agent/_work/24/s/app_modules/default-simulation-shell/index.js');
}();

;

/***/ }),

/***/ "./app_modules/default-simulation-shell/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app_modules/deloitte-auth-strategy/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeloitteChooseSession = exports.DeloitteSignUp = exports.DeloitteSignIn = exports.DeloitteAuthViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _dec5, _dec6, _class3, _class4, _temp, _class5, _class6;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _deepExtend = __webpack_require__("./node_modules/deep-extend/lib/deep-extend.js");

var _deepExtend2 = _interopRequireDefault(_deepExtend);

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DeloitteAuthViewStore = exports.DeloitteAuthViewStore = (_dec = _mobx.observable.ref, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class = function (_mix$with) {
  (0, _inherits3.default)(DeloitteAuthViewStore, _mix$with);

  function DeloitteAuthViewStore() {
    (0, _classCallCheck3.default)(this, DeloitteAuthViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DeloitteAuthViewStore.__proto__ || (0, _getPrototypeOf2.default)(DeloitteAuthViewStore)).apply(this, arguments));

    _initDefineProp(_this, "role", _descriptor, _this);

    _initDefineProp(_this, "claim", _descriptor2, _this);

    _initDefineProp(_this, "warning", _descriptor3, _this);

    var _this$props = _this.props,
        contentModel = _this$props.contentModel,
        projectDomainStore = _this$props.dataModel.domainStore,
        route = _this$props.currentView.route,
        modalViewStore = _this$props.modalViewStore;

    //just in case we're already signed in :-)

    var self = _this;
    projectDomainStore.refreshContext = _mobx.action.bound(function (cb, errCb) {

      if (!projectDomainStore.simgate) throw new Error("missing simgate");
      projectDomainStore.isRefreshing = true;
      var callback = (0, _mobx.action)("getContext-callback", function (res) {
        if (projectDomainStore.contextIsLoaded && res.context.pathID === 0) throw new Error('{"IsError":true,"ErrorMessage":"Access denied. Lost simgate context!"}');

        var _res$context = res.context,
            userId = _res$context.userId,
            roleId = _res$context.roleId;


        if (roleId > 0) {
          if (roleId == 1) {
            // handle a super admin specially
            if (window.location.href.indexOf("authoring") < 0 && window.location.href.indexOf("localhost") < 0 || window.location.href.indexOf("participant") >= 0) {
              window.location.href = window.location.origin + "/dashboard";
              return;
            }
          } else if (roleId != 2) {
            window.location.href = window.location.origin + "/dashboard";
            return;
          }

          if (roleId == 2) {
            // get the team and session information
            projectDomainStore.simgate.execQuery({
              query: "custom-queries://getContextData",
              parameters: { userId: userId }
            }).then(function (result) {

              res.context.team = {
                id: result.data[0][0].PathID,
                pathId: result.data[0][0].PathID,
                pathType: result.data[0][0].PathType,
                parentId: result.data[0][0].ParentID,
                attr1: result.data[0][0].Attr1,
                attr2: result.data[0][0].Attr2,
                attr3: result.data[0][0].Attr3,
                attr4: result.data[0][0].Attr4,
                attr5: result.data[0][0].Attr5,
                num1: result.data[0][0].Num1,
                num2: result.data[0][0].Num2,
                num3: result.data[0][0].Num3,
                num4: result.data[0][0].Num4,
                num5: result.data[0][0].Num5
              };
              res.context.user.pathId = result.data[0][0].UserTeamID;
              res.context.sessionName = result.data[0][0].SessionName;

              projectDomainStore.pathId = res.context.user.pathId;
              projectDomainStore.currentRoundNo = res.context.team.num5 || 1;
              projectDomainStore.teamStateName = res.context.team.attr4;
              projectDomainStore.context.simParentPathId = res.context.team.parentId;

              (0, _deepExtend2.default)(projectDomainStore.context, res.context);

              projectDomainStore.isRefreshing = false;
              projectDomainStore.hasRefreshed = +new Date();
              projectDomainStore.contextIsLoaded = true;

              if (typeof cb === "function") cb();
            }).catch(errCb);
          } else {
            projectDomainStore.pathId = 1;
            projectDomainStore.currentRoundNo = 0;
            projectDomainStore.teamStateName = "";
            projectDomainStore.context.simParentPathId = 3;

            (0, _deepExtend2.default)(projectDomainStore.context, res.context);

            projectDomainStore.isRefreshing = false;
            projectDomainStore.hasRefreshed = +new Date();
            projectDomainStore.contextIsLoaded = true;
          }
        } else {
          projectDomainStore.pathId = 0;
          projectDomainStore.currentRoundNo = 0;
          projectDomainStore.teamStateName = null;
          projectDomainStore.context.simParentPathId = 3;

          (0, _deepExtend2.default)(projectDomainStore.context, res.context);

          projectDomainStore.isRefreshing = false;
          projectDomainStore.hasRefreshed = +new Date();
          projectDomainStore.contextIsLoaded = true;

          if (typeof cb === "function") cb();
        }
      });

      var taskArgs = [projectDomainStore.simgate.getContext, {}, {
        onSuccess: callback,
        onFailure: errCb
      }];
      if (projectDomainStore.simgate.runTask) {
        var _projectDomainStore$s;

        (_projectDomainStore$s = projectDomainStore.simgate).runTask.apply(_projectDomainStore$s, taskArgs);
      } else if (projectDomainStore.simgate.AsyncTask) {
        var asyncTask = new projectDomainStore.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        projectDomainStore.simgate.getContext(taskArgs[1]).then(callback).catch(errCb);
      }

      return projectDomainStore;
    });

    projectDomainStore.refreshContext();

    // set up condition for this auth strategy being "done""
    (0, _mobx.when)(function () {
      return projectDomainStore.context.simParentPathId > 0 //we have user's future team paths' parent path
      && projectDomainStore.context.user.roleID && route.roles.some(function (r) {
        return r.roleId === projectDomainStore.context.user.roleID;
      });
    }, //user context reflects they are allowed in to this route
    function () {
      projectDomainStore.signOut = (0, _mobx.action)(function () {
        var dirtyEntities = contentModel.$parent.entities.values().filter(function (ent) {
          return ent.isDirty;
        });
        modalViewStore.setModal({
          title: "Would you like to log out?",
          message: dirtyEntities.length ? "You will lose " + dirtyEntities.length + " unsaved changes." : "",
          confirmLabel: 'Logout',
          confirmBtnClass: 'green check-a',
          cancelLabel: 'Cancel',
          cancelBtnClass: 'red times-b',
          onConfirmFunc: function onConfirmFunc() {
            return projectDomainStore._signOut(function () {
              return window.location.reload();
            });
          }
        });
      });
      contentModel.done = true;
    });
    return _this;
  }

  (0, _createClass3.default)(DeloitteAuthViewStore, [{
    key: "handleSignIn",
    value: function handleSignIn(e) {
      var _this2 = this;

      e && e.preventDefault && e.preventDefault();
      var domainStore = this.props.dataModel.domainStore;

      var errCb = function errCb(err) {
        err && (_this2.warning = err.message);
      };

      try {
        var self = this;
        if (!domainStore.simgate) throw new Error("missing simgate");
        var signOutCb = function signOutCb() {
          domainStore.simgate.signIn(self.claim).then(function (res) {
            if (!res || !res.context) throw new Error("Access denied.");

            var _res$context2 = res.context,
                userId = _res$context2.userId,
                roleId = _res$context2.roleId;


            if (roleId == 1) {
              // handle a super admin specially
              if (window.location.href.indexOf("authoring") < 0 && window.location.href.indexOf("localhost") < 0 || window.location.href.indexOf("participant") >= 0) {
                window.location.href = window.location.origin + "/dashboard";
                return;
              }
            } else if (roleId != 2) {
              window.location.href = window.location.origin + "/dashboard";
              return;
            }

            if (roleId == 2) {

              // get the team and session information
              domainStore.simgate.execQuery({
                query: "custom-queries://getContextData",
                parameters: { userId: userId }
              }).then(function (result) {

                res.context.team = {
                  id: result.data[0][0].PathID,
                  pathId: result.data[0][0].PathID,
                  pathType: result.data[0][0].PathType,
                  parentId: result.data[0][0].ParentID,
                  attr1: result.data[0][0].Attr1,
                  attr2: result.data[0][0].Attr2,
                  attr3: result.data[0][0].Attr3,
                  attr4: result.data[0][0].Attr4,
                  attr5: result.data[0][0].Attr5,
                  num1: result.data[0][0].Num1,
                  num2: result.data[0][0].Num2,
                  num3: result.data[0][0].Num3,
                  num4: result.data[0][0].Num4,
                  num5: result.data[0][0].Num5
                };
                res.context.user.pathId = result.data[0][0].UserTeamID;
                res.context.sessionName = result.data[0][0].SessionName;

                (0, _deepExtend2.default)(domainStore.context, res.context);

                domainStore.contextIsLoaded = true;
                if (typeof cb === "function") cb();
              }).catch(errCb);
            } else {
              (0, _deepExtend2.default)(domainStore.context, res.context);

              domainStore.contextIsLoaded = true;
              if (typeof cb === "function") cb();
            }
          }).catch(errCb);
        };

        domainStore.simgate.signOut().then(signOutCb).catch(signOutCb);

        domainStore.signIn(this.claim, null, errCb);
      } catch (err) {
        errCb(err);
      }
    }
  }, {
    key: "handleSignUp",
    value: function handleSignUp(e) {
      var _this3 = this;

      e.preventDefault();
      var _props = this.props,
          domainStore = _props.dataModel.domainStore,
          _props$contentModel = _props.contentModel,
          allowSignupFor = _props$contentModel.allowSignupFor,
          authCode = _props$contentModel.authCode;


      domainStore.createUser({
        roleID: allowSignupFor.roleId,
        firstName: this.claim.firstName,
        lastName: this.claim.lastName,
        email: this.claim.loginName,
        loginName: this.claim.loginName,
        password: this.claim.password,
        authCode: this.claim.authCode

      }, function () {
        return _this3.handleSignIn();
      });
    }
  }, {
    key: "updateClaim",
    value: function updateClaim(which, val) {
      this.claim[which] = val;
    }
  }, {
    key: "viewMap",
    get: function get() {
      return {
        "signup": {
          id: "signup",
          Component: DeloitteSignUp,
          contentModel: this.props.contentModel
        },
        "chooseSession": {
          id: "chooseSession",
          Component: DeloitteChooseSession,
          contentModel: this.props.contentModel
        }
      };
    }
  }, {
    key: "invalidSignUp",
    get: function get() {
      var invalid = {};
      var authCode = this.props.contentModel.authCode;


      if (!this.claim.firstName) invalid.firstName = "*Please enter your first name";
      if (!this.claim.lastName) invalid.lastName = "*Please enter your last name";
      if (!this.claim.loginName) invalid.email = "*Please enter email";
      if (!this.claim.password) invalid.password = "*Please enter password";
      if (!this.claim.passwordConfirm) invalid.passwordConfirm = "*Please confirm password";
      if (this.claim.password && this.claim.passwordConfirm && this.claim.password != this.claim.passwordConfirm) invalid.passwordConfirm = "*Password and password confirm must match";
      // @TODO use encryption to make this worth something
      if (this.claim.authCode !== authCode) invalid.authCode = "*Invalid auth code";
      return invalid;
    }
  }, {
    key: "invalidSignIn",
    get: function get() {
      var domainStore = this.props.dataModel.domainStore;
      var _props2 = this.props,
          roles = _props2.currentView.route.roles,
          authCode = _props2.contentModel.authCode;


      var invalid = {};

      if (!this.claim.loginName) invalid.email = "*Please enter email";
      if (!this.claim.password) invalid.password = "*Please enter password";
      if (domainStore.context.user.roleID && !roles.some(function (r) {
        return r.roleId === domainStore.context.user.roleID;
      })) invalid.notAuthorized = "Not authorized.";
      return invalid;
    }
  }]);
  return DeloitteAuthViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "role", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "claim", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      firstName: "",
      lastName: "",
      loginName: "",
      password: "",
      passwordConfirm: "",
      demographic1: 0,
      demographic2: 0,
      demographic3: 0,
      demographic4: 0,
      demographic5: 0,
      authCode: "regis123"
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "viewMap", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "viewMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalidSignUp", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalidSignUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalidSignIn", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalidSignIn"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "warning", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleSignIn", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "handleSignIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSignUp", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "handleSignUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateClaim", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "updateClaim"), _class.prototype)), _class));
var DeloitteSignIn = exports.DeloitteSignIn = (_dec5 = (0, _mobxReact.inject)("dataModel"), _dec6 = (0, _mobxReact.inject)("modalViewStore"), (0, _simboxEditable.Decorator)(_class3 = _dec5(_class3 = _dec6(_class3 = (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = (_temp = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(DeloitteSignIn, _BaseComponent);

  function DeloitteSignIn() {
    (0, _classCallCheck3.default)(this, DeloitteSignIn);
    return (0, _possibleConstructorReturn3.default)(this, (DeloitteSignIn.__proto__ || (0, _getPrototypeOf2.default)(DeloitteSignIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(DeloitteSignIn, [{
    key: "render",
    value: function render() {
      var _props3 = this.props,
          domainStore = _props3.dataModel.domainStore,
          authContentModel = _props3.contentModel;
      var title = authContentModel.title,
          headerMessage = authContentModel.headerMessage,
          welcomeMessage = authContentModel.welcomeMessage,
          allowSignupFor = authContentModel.allowSignupFor;
      var _viewStore = this.viewStore,
          SelectedView = _viewStore.SelectedView,
          clearView = _viewStore.clearView,
          selectView = _viewStore.selectView,
          handleSignIn = _viewStore.handleSignIn,
          invalid = _viewStore.invalidSignIn,
          claim = _viewStore.claim,
          updateClaim = _viewStore.updateClaim,
          warning = _viewStore.warning;


      if (invalid.notAuthorized) {
        return _react2.default.createElement(
          "div",
          null,
          invalid.notAuthorized,
          _react2.default.createElement(
            "button",
            { onClick: function onClick() {
                return domainStore.signOut(function () {
                  return window.location.reload();
                });
              } },
            "Reload"
          )
        );
      }

      if (SelectedView) return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(SelectedView, { viewStore: this.viewStore })
      );

      //actual sign in view    
      return _react2.default.createElement(
        "div",
        { className: "sign-on-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "input-box sign-on" },
          _react2.default.createElement(
            "form",
            { "data-editable": authContentModel },
            _react2.default.createElement(
              "div",
              { className: "role-title" },
              title
            ),
            _react2.default.createElement(
              "div",
              { className: "messages" },
              !!headerMessage && _react2.default.createElement(
                "h2",
                { className: "header-message" },
                headerMessage
              ),
              !!welcomeMessage && _react2.default.createElement(
                "div",
                { className: "welcome-message" },
                welcomeMessage
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "inputs" },
              _react2.default.createElement("input", { className: "email", type: "text", value: claim.loginName, placeholder: "Email Address", onChange: function onChange(e) {
                  return updateClaim("loginName", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.email
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "password", type: "password", value: claim.password, placeholder: "Password", onChange: function onChange(e) {
                  return updateClaim("password", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.password
              ),
              _react2.default.createElement("br", null),
              !!warning && _react2.default.createElement(
                "h2",
                null,
                warning
              ),
              _react2.default.createElement(
                "div",
                { className: "sign-in-actions" },
                _react2.default.createElement(
                  "button",
                  { disabled: (0, _keys2.default)(invalid).length, className: "btn red sign-in-b", onClick: handleSignIn },
                  "Sign In"
                )
              )
            ),
            !!allowSignupFor && _react2.default.createElement(
              "div",
              { className: "sign-up-container" },
              _react2.default.createElement(
                "span",
                { className: "nr-text" },
                "Not Registered?"
              ),
              _react2.default.createElement(
                "span",
                { className: "nr-link", onClick: function onClick(e) {
                    e.preventDefault();selectView("signup", { role: allowSignupFor });
                  } },
                "Sign Up"
              )
            )
          )
        )
      );
    }
  }]);
  return DeloitteSignIn;
}(_baseComponent2.default), _class4.ViewStore = DeloitteAuthViewStore, _temp)) || _class3) || _class3) || _class3) || _class3) || _class3);
var _default = DeloitteSignIn;
exports.default = _default;

var DeloitteSignUp = exports.DeloitteSignUp = (0, _simboxEditable.Decorator)(_class5 = (0, _mobxReact.observer)(_class5 = (0, _autoclassDecorator2.default)(_class5 = function (_BaseComponent2) {
  (0, _inherits3.default)(DeloitteSignUp, _BaseComponent2);

  function DeloitteSignUp() {
    (0, _classCallCheck3.default)(this, DeloitteSignUp);
    return (0, _possibleConstructorReturn3.default)(this, (DeloitteSignUp.__proto__ || (0, _getPrototypeOf2.default)(DeloitteSignUp)).apply(this, arguments));
  }

  (0, _createClass3.default)(DeloitteSignUp, [{
    key: "render",
    value: function render() {
      var _props4 = this.props,
          contentModel = _props4.contentModel,
          _props4$contentModel = _props4.contentModel,
          signUpMessage = _props4$contentModel.signUpMessage,
          allowSignupFor = _props4$contentModel.allowSignupFor,
          title = _props4$contentModel.title,
          _props4$viewStore = _props4.viewStore,
          handleSignUp = _props4$viewStore.handleSignUp,
          claim = _props4$viewStore.claim,
          updateClaim = _props4$viewStore.updateClaim,
          invalid = _props4$viewStore.invalidSignUp,
          clearView = _props4$viewStore.clearView;


      return _react2.default.createElement(
        "div",
        { className: "sign-on-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "input-box sign-on" },
          _react2.default.createElement(
            "form",
            null,
            !!contentModel.title && _react2.default.createElement(
              "div",
              { className: "role-title" },
              contentModel.title
            ),
            !!signUpMessage && _react2.default.createElement(
              "div",
              { className: "messages" },
              !!signUpMessage && _react2.default.createElement(
                "div",
                { className: "welcome-message" },
                signUpMessage
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "inputs" },
              _react2.default.createElement("input", { className: "firstName", type: "text", value: claim.firstName, placeholder: "First Name", onChange: function onChange(e) {
                  return updateClaim("firstName", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.firstName
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "lastName", type: "text", value: claim.lastName, placeholder: "Last Name", onChange: function onChange(e) {
                  return updateClaim("lastName", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.lastName
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "email", type: "text", value: claim.loginName, placeholder: "Email Address", onChange: function onChange(e) {
                  return updateClaim("loginName", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.email
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "password", type: "password", value: claim.password, placeholder: "Password", onChange: function onChange(e) {
                  return updateClaim("password", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.password
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "passwordConfirm", type: "password", value: claim.passwordConfirm, placeholder: "Confirm Password", onChange: function onChange(e) {
                  return updateClaim("passwordConfirm", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.passwordConfirm
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "select",
                { className: "demographic1", type: "text", value: claim.demographic1, placeholder: "Demographic 1", onChange: function onChange(e) {
                    return updateClaim("demographic1", e.target.value);
                  } },
                _react2.default.createElement(
                  "option",
                  { value: "0" },
                  "Demographic 1"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "1" },
                  "Value 1"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "2" },
                  "Value 2"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "3" },
                  "Value 3"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "4" },
                  "Value 4"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "5" },
                  "Value 5"
                )
              ),
              _react2.default.createElement(
                "select",
                { className: "demographic2", type: "text", value: claim.demographic2, placeholder: "Demographic 2", onChange: function onChange(e) {
                    return updateClaim("demographic2", e.target.value);
                  } },
                _react2.default.createElement(
                  "option",
                  { value: "0" },
                  "Demographic 2"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "1" },
                  "Value 1"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "2" },
                  "Value 2"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "3" },
                  "Value 3"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "4" },
                  "Value 4"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "5" },
                  "Value 5"
                )
              ),
              _react2.default.createElement(
                "select",
                { className: "demographic3", type: "text", value: claim.demographic3, placeholder: "Demographic 3", onChange: function onChange(e) {
                    return updateClaim("demographic3", e.target.value);
                  } },
                _react2.default.createElement(
                  "option",
                  { value: "0" },
                  "Demographic 3"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "1" },
                  "Value 1"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "2" },
                  "Value 2"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "3" },
                  "Value 3"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "4" },
                  "Value 4"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "5" },
                  "Value 5"
                )
              ),
              _react2.default.createElement(
                "select",
                { className: "demographic4", type: "text", value: claim.demographic4, placeholder: "Demographic 4", onChange: function onChange(e) {
                    return updateClaim("demographic4", e.target.value);
                  } },
                _react2.default.createElement(
                  "option",
                  { value: "0" },
                  "Demographic 4"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "1" },
                  "Value 1"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "2" },
                  "Value 2"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "3" },
                  "Value 3"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "4" },
                  "Value 4"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "5" },
                  "Value 5"
                )
              ),
              _react2.default.createElement(
                "select",
                { className: "demographic5", type: "text", value: claim.demographic5, placeholder: "Demographic 5", onChange: function onChange(e) {
                    return updateClaim("demographic5", e.target.value);
                  } },
                _react2.default.createElement(
                  "option",
                  { value: "0" },
                  "Demographic 5"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "1" },
                  "Value 1"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "2" },
                  "Value 2"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "3" },
                  "Value 3"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "4" },
                  "Value 4"
                ),
                _react2.default.createElement(
                  "option",
                  { value: "5" },
                  "Value 5"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: "sign-in-actions" },
                _react2.default.createElement(
                  "span",
                  { className: "btn red sign-up-b", disabled: !!(0, _keys2.default)(invalid).length, onClick: handleSignUp },
                  "Sign Up"
                )
              )
            ),
            !!allowSignupFor && _react2.default.createElement(
              "div",
              { className: "sign-up-container" },
              _react2.default.createElement(
                "span",
                { className: "nr-text" },
                "Already Registered?"
              ),
              _react2.default.createElement(
                "span",
                { className: "nr-link", onClick: function onClick(e) {
                    return clearView();
                  } },
                "Sign In"
              )
            )
          )
        )
      );
    }
  }]);
  return DeloitteSignUp;
}(_baseComponent2.default)) || _class5) || _class5) || _class5;

var DeloitteChooseSession = exports.DeloitteChooseSession = (0, _simboxEditable.Decorator)(_class6 = (0, _mobxReact.observer)(_class6 = (0, _autoclassDecorator2.default)(_class6 = function (_BaseComponent3) {
  (0, _inherits3.default)(DeloitteChooseSession, _BaseComponent3);

  function DeloitteChooseSession() {
    (0, _classCallCheck3.default)(this, DeloitteChooseSession);
    return (0, _possibleConstructorReturn3.default)(this, (DeloitteChooseSession.__proto__ || (0, _getPrototypeOf2.default)(DeloitteChooseSession)).apply(this, arguments));
  }

  (0, _createClass3.default)(DeloitteChooseSession, [{
    key: "render",
    value: function render() {
      var _props5 = this.props,
          contentModel = _props5.contentModel,
          signUpMessage = _props5.contentModel.signUpMessage,
          handleSignUp = _props5.handleSignUp,
          claim = _props5.claim,
          updateClaim = _props5.updateClaim,
          invalid = _props5.invalid;


      return _react2.default.createElement(
        "div",
        { className: "sign-on-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "input-box sign-on" },
          _react2.default.createElement(
            "form",
            { "data-editable": contentModel },
            !!signUpMessage && _react2.default.createElement(
              "div",
              { className: "messages" },
              !!signUpMessage && _react2.default.createElement(
                "div",
                { className: "signup-message" },
                signUpMessage
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "inputs" },
              _react2.default.createElement("input", { className: "email", type: "text", value: claim.loginName, placeholder: "Email Address", onChange: function onChange(e) {
                  return updateClaim("loginName", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.email
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "password", type: "password", value: claim.password, placeholder: "Password", onChange: function onChange(e) {
                  return updateClaim("password", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.password
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "div",
                { className: "sign-in-actions" },
                _react2.default.createElement(
                  "span",
                  { className: "btn red sign-up-b", onClick: handleSignUp },
                  "Sign Up"
                )
              )
            )
          )
        )
      );
    }
  }]);
  return DeloitteChooseSession;
}(_baseComponent2.default)) || _class6) || _class6) || _class6;

;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DeloitteAuthViewStore, "DeloitteAuthViewStore", "D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/component.js");

  __REACT_HOT_LOADER__.register(DeloitteSignIn, "DeloitteSignIn", "D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/component.js");

  __REACT_HOT_LOADER__.register(DeloitteSignUp, "DeloitteSignUp", "D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/component.js");

  __REACT_HOT_LOADER__.register(DeloitteChooseSession, "DeloitteChooseSession", "D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/component.js");
}();

;

/***/ }),

/***/ "./app_modules/deloitte-auth-strategy/component.localmode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class2, _temp;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _component = __webpack_require__("./app_modules/deloitte-auth-strategy/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this mock component mixin is necessary when a superclass is "injected", ie when @editable is used
// it merges statics onto the wrappedComponent so they are still accessible
var MockComponentMixin = (0, _mixwith.Mixin)(function (superclass) {
  return function (_superclass) {
    (0, _inherits3.default)(_class, _superclass);

    function _class() {
      (0, _classCallCheck3.default)(this, _class);

      var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));

      if (superclass.wrappedComponent) {
        (0, _keys2.default)(_this.constructor).forEach(function (k) {
          superclass.wrappedComponent[k] = _this.constructor[k];
        });
      }
      return _this;
    }

    return _class;
  }(superclass);
});

var SimgateAuthMock = (_temp = _class2 = function (_mix$with) {
  (0, _inherits3.default)(SimgateAuthMock, _mix$with);

  function SimgateAuthMock() {
    (0, _classCallCheck3.default)(this, SimgateAuthMock);
    return (0, _possibleConstructorReturn3.default)(this, (SimgateAuthMock.__proto__ || (0, _getPrototypeOf2.default)(SimgateAuthMock)).apply(this, arguments));
  }

  return SimgateAuthMock;
}((0, _mixwith.mix)(_component2.default).with(MockComponentMixin)), _class2.setUpMock = function (context) {
  var _context$props = context.props,
      domainStore = _context$props.dataModel.domainStore,
      _context$props$conten = _context$props.contentModel,
      apiUrl = _context$props$conten.apiUrl,
      applicationId = _context$props$conten.applicationId,
      route = _context$props.currentView.route;


  domainStore.mockRoleId = route.role.roleId;
}, _temp);
exports.default = SimgateAuthMock;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MockComponentMixin, 'MockComponentMixin', 'D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/component.localmode.js');

  __REACT_HOT_LOADER__.register(SimgateAuthMock, 'SimgateAuthMock', 'D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/component.localmode.js');
}();

;

/***/ }),

/***/ "./app_modules/deloitte-auth-strategy/component.mock.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class2, _temp;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _component = __webpack_require__("./app_modules/deloitte-auth-strategy/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this mock component mixin is necessary when a superclass is "injected", ie when @editable is used
// it merges statics onto the wrappedComponent so they are still accessible
var MockComponentMixin = (0, _mixwith.Mixin)(function (superclass) {
  return function (_superclass) {
    (0, _inherits3.default)(_class, _superclass);

    function _class() {
      (0, _classCallCheck3.default)(this, _class);

      var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));

      if (superclass.wrappedComponent) {
        (0, _keys2.default)(_this.constructor).forEach(function (k) {
          superclass.wrappedComponent[k] = _this.constructor[k];
        });
      }
      return _this;
    }

    return _class;
  }(superclass);
});

var SimgateAuthMock = (_temp = _class2 = function (_mix$with) {
  (0, _inherits3.default)(SimgateAuthMock, _mix$with);

  function SimgateAuthMock() {
    (0, _classCallCheck3.default)(this, SimgateAuthMock);
    return (0, _possibleConstructorReturn3.default)(this, (SimgateAuthMock.__proto__ || (0, _getPrototypeOf2.default)(SimgateAuthMock)).apply(this, arguments));
  }

  return SimgateAuthMock;
}((0, _mixwith.mix)(_component2.default).with(MockComponentMixin)), _class2.setUpMock = function (context) {
  var _context$props = context.props,
      domainStore = _context$props.dataModel.domainStore,
      _context$props$conten = _context$props.contentModel,
      apiUrl = _context$props$conten.apiUrl,
      applicationId = _context$props$conten.applicationId,
      route = _context$props.currentView.route;


  domainStore.mockRoleId = route.role.roleId;
}, _temp);
exports.default = SimgateAuthMock;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MockComponentMixin, 'MockComponentMixin', 'D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/component.mock.js');

  __REACT_HOT_LOADER__.register(SimgateAuthMock, 'SimgateAuthMock', 'D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/component.mock.js');
}();

;

/***/ }),

/***/ "./app_modules/deloitte-auth-strategy/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeloitteAuthContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class2, _temp2;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _component = __webpack_require__("./app_modules/deloitte-auth-strategy/component.js");

var _component2 = _interopRequireDefault(_component);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/contentmodel.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DeloitteAuthContentModel = exports.DeloitteAuthContentModel = (_dec = _mobx.observable.ref, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(DeloitteAuthContentModel, _BaseContentModel);

  function DeloitteAuthContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DeloitteAuthContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DeloitteAuthContentModel.__proto__ || (0, _getPrototypeOf2.default)(DeloitteAuthContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.Component = _component2.default, _initDefineProp(_this, 'title', _descriptor, _this), _initDefineProp(_this, 'welcomeMessage', _descriptor2, _this), _initDefineProp(_this, 'headerMessage', _descriptor3, _this), _initDefineProp(_this, 'signUpMessage', _descriptor4, _this), _initDefineProp(_this, 'allowSignupFor', _descriptor5, _this), _initDefineProp(_this, 'authCode', _descriptor6, _this), _initDefineProp(_this, 'done', _descriptor7, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* @slot */
  /* @slot */
  /* @slot */
  /* @slot */
  /* @slot */

  return DeloitteAuthContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  title: "",
  welcomeMessage: "",
  headerMessage: "",
  signUpMessage: "",
  allowSignupFor: _contentmodel.RoleContentModel,
  authCode: ""
}, _class2._meta = {
  allowSignupFor: {
    // @TODO actually implement :-)
    hideMenu: ["add"]
  }
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'title', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'welcomeMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'headerMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'signUpMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'allowSignupFor', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'authCode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Regis123";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'done', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class));
var _default = DeloitteAuthContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DeloitteAuthContentModel, 'DeloitteAuthContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/deloitte-auth-strategy/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = exports.description = undefined;

var _contentmodel = __webpack_require__("./app_modules/deloitte-auth-strategy/contentmodel.js");

var deloitteAuthContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// // in local context, style will be loaded via normal webpack require (direct insert into head)
// // in remote context, webpack will compile this as a string, and export as "stylesheet" from module
// import style from './style.css';

var description = exports.description = "Deloitte auth strategy is the default way to authorize via simgate.";
var ContentModels = exports.ContentModels = deloitteAuthContentModels;
var ContentModel = exports.ContentModel = deloitteAuthContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(description, "description", "D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/index.js");

  __REACT_HOT_LOADER__.register(ContentModels, "ContentModels", "D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/index.js");

  __REACT_HOT_LOADER__.register(ContentModel, "ContentModel", "D:/VSTS/agent/_work/24/s/app_modules/deloitte-auth-strategy/index.js");
}();

;

/***/ }),

/***/ "./app_modules/deloitte-auth-strategy/setup/simgate.json":
/***/ (function(module, exports) {

module.exports = {"pathTypes":{"1":"session","2":"team"},"policies":{"User.Create":{"allowed":[1],"result":{"select":["id","pathid","roleid","name","email","login","props"],"restrict":["password"]},"result-1":{"select":"*","group":true}},"Security.Register":{"allowed":[0,1,2],"!roleId-0":2}}}

/***/ }),

/***/ "./app_modules/document-builder-activity/package.json":
/***/ (function(module, exports) {

module.exports = {"name":"document-builder-activity","version":"1.0.5","description":"TRC Document Builder Activity","main":"dist/index.js","module":"src/index.js","files":["dist","CHANGELOG.md","README.md"],"scripts":{"test":"cross-env BABEL_ENV=test node ./node_modules/.bin/trc-test \"tests/*.js\"","inspect":"cross-env BABEL_ENV=test node ./node_modules/.bin/trc-inspect \"tests/*.js\"","compile":"npm run test && npm run copy-css && npm run copy-json && npm run copy-xml && babel src -d dist","copy-css":"copyfiles -u 1 \"src/*.css\" dist && copyfiles -u 1 \"src/**/*.css\" dist","copy-json":"copyfiles -u 1 \"src/*.json\" dist && copyfiles -u 1 \"src/**/*.json\" dist","copy-xml":"copyfiles -u 1 \"src/*.xml\" dist && copyfiles -u 1 \"src/**/*.xml\" dist","publish-major":"npm run test && npm run compile && is-online && npm version major && trc-tagme && git push --follow-tags","publish-minor":"npm run test && npm run compile && is-online && npm version minor && trc-tagme && git push --follow-tags","publish":"npm run test && npm run compile && is-online && npm version patch && trc-tagme && git push --follow-tags","publish-patch":"npm run publish"},"dependencies":{"deep-bind-decorator":"https://gitlab.com/regiscompany/deep-bind-decorator.git#v1.0.4","mobx":"^3.0.2","mobx-react":"^4.1.0","react":"^15.4.2","react-dom":"^15.4.2","react-sortable-hoc":"^0.6.7"},"devDependencies":{"babel-cli":"^6.26.0","babel-plugin-module-resolver":"^3.0.0-beta.5","babel-plugin-transform-css-import-to-string":"0.0.2","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-require-ignore":"^0.1.1","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.0","babel-preset-react":"^6.24.0","babel-preset-stage-1":"^6.24.0","component-testing-tools":"https://gitlab.com/regiscompany/component-testing-tools.git","copyfiles":"1.2.0","cross-env":"^5.0.5","deep-extend":"^0.5.0","enzyme":"^2.9.1","is-online-cli":"^2.0.0","react-test-renderer":"^15.6.1","tape":"4.5.1","trc-debug-runner":"https://gitlab.com/regiscompany/trc-debug-runner.git","trc-tagme":"https://gitlab.com/regiscompany/trc-tagme.git"},"author":"","license":"ISC","repository":{"type":"git","url":"git+https://gitlab.com/regiscompany/document-builder-component.git"}}

/***/ }),

/***/ "./app_modules/document-builder-activity/src/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentBuilder = exports.DocumentBuilderViewStore = undefined;

var _getIterator2 = __webpack_require__("./node_modules/babel-runtime/core-js/get-iterator.js");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _desc, _value, _class, _dec3, _dec4, _dec5, _dec6, _dec7, _class3, _desc2, _value2, _class4, _class5, _temp2;

//import {Decorator as editable} from 'simbox-editable';

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _reactSortableHoc = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// this is like a ViewModel, contains all user actions for this component
var DocumentBuilderViewStore = exports.DocumentBuilderViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(DocumentBuilderViewStore, _BaseViewStore);

  function DocumentBuilderViewStore() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DocumentBuilderViewStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DocumentBuilderViewStore.__proto__ || (0, _getPrototypeOf2.default)(DocumentBuilderViewStore)).call.apply(_ref, [this].concat(args))), _this), _this.hasRandomized = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DocumentBuilderViewStore, [{
    key: "updateUserInput",
    value: function updateUserInput(val) {
      /*const {
        contentModel
      } = this.props;
        // this updates user input property `userInput`, defined on the contentModel
      contentModel.updateInput("userInput", val)*/
    }
  }, {
    key: "save",
    value: function save() {
      var contentModel = this.props.contentModel;
      this.props.contentModel.isSubmitted = true;

      var set = {};
      contentModel.items.forEach(function (item) {
        set[contentModel.id + "_" + item.id] = item.inTarget ? item.targetIndex : -1;
      });

      set[contentModel.id + "_isCompleted"] = true;
      set[contentModel.id + "_isSubmitted"] = true;
      window.simgate.updateData({
        path: window.application.dataModel.domainStore.context.team.pathId,
        set: set
      }).then((0, _mobx.action)("loadData-callback", function (res) {})).catch((0, _mobx.action)("loadData-error", function (err) {
        debugger;
        alert("There was a problem saving your data - " + err);
      }));
    }
  }, {
    key: "invalid",


    // validation is a derivation
    get: function get() {
      /*const invalid = {};
      const {
        contentModel: {
          userInput: {
            value: userInputValue
          }
        }
      } = this.props;
        if(!userInputValue) invalid.userInput = "User, please provide a value!"
        return invalid;*/
      return false;
    }

    // actions update state

  }]);
  return DocumentBuilderViewStore;
}(_baseViewstore2.default), (_applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateUserInput", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "updateUserInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype)), _class));

//@editable // this makes the view editable via authoring tool via data-editable

// this automatically gives consistent `className`s to components using module and component names
var DocumentBuilder = exports.DocumentBuilder = (_dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = (_class4 = (_temp2 = _class5 = function (_BaseComponent) {
  (0, _inherits3.default)(DocumentBuilder, _BaseComponent);

  function DocumentBuilder() {
    (0, _classCallCheck3.default)(this, DocumentBuilder);
    return (0, _possibleConstructorReturn3.default)(this, (DocumentBuilder.__proto__ || (0, _getPrototypeOf2.default)(DocumentBuilder)).apply(this, arguments));
  }

  (0, _createClass3.default)(DocumentBuilder, [{
    key: "sourceItems",
    //ViewStore gets auto-instantiated and attached to the component on creation

    value: function sourceItems() {
      if (!this.props.contentModel) return [];
      var items = this.props.contentModel.items.filter(function (item) {
        return !item.inTarget;
      });
      return items.sort(function (a, b) {
        if (a.sourceIndex < b.sourceIndex) {
          return -1;
        }
        if (a.sourceIndex > b.sourceIndex) {
          return 1;
        }
        return 0;
      });
    }
  }, {
    key: "targetItems",
    value: function targetItems() {
      if (!this.props.contentModel) return [];
      var items = this.props.contentModel.items.filter(function (item) {
        return item.inTarget;
      });
      return items.sort(function (a, b) {
        if (a.targetIndex < b.targetIndex) {
          return -1;
        }
        if (a.targetIndex > b.targetIndex) {
          return 1;
        }
        return 0;
      });
    }
  }, {
    key: "moveItemFromSourceToTarget",
    value: function moveItemFromSourceToTarget(item) {
      var array = this.sourceItems().slice();

      for (var i = item.sourceIndex; i < array.length; i++) {
        array[i].sourceIndex -= 1;
      }

      item.targetIndex = this.targetItems().length;
      item.inTarget = true;
      item.sourceIndex = -1;
    }
  }, {
    key: "moveItemFromTargetToSource",
    value: function moveItemFromTargetToSource(item) {
      var array = this.targetItems().slice();

      for (var i = item.targetIndex; i < array.length; i++) {
        array[i].targetIndex -= 1;
      }

      item.sourceIndex = this.sourceItems().length;
      item.inTarget = false;
      item.targetIndex = -1;
    }
  }, {
    key: "move",
    value: function move(from, to) {
      var array = this.targetItems().slice();
      if (to === from) return;

      var target = array[from];
      var increment = to < from ? -1 : 1;

      for (var k = from; k != to; k += increment) {
        array[k] = array[k + increment];
      }
      array[to] = target;
      var i = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(array), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          item.targetIndex = i++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "moveTargetItemDown",
    value: function moveTargetItemDown(item) {
      if (item.targetIndex < this.targetItems().length - 1) {
        this.move(item.targetIndex, item.targetIndex + 1);
      }
    }
  }, {
    key: "moveTargetItemUp",
    value: function moveTargetItemUp(item) {
      var index = item.targetIndex;
      if (item.targetIndex > 0) {
        this.move(item.targetIndex, item.targetIndex - 1);
      }
    }
  }, {
    key: "canMoveDown",
    value: function canMoveDown(item) {
      var arr = item.inTarget ? this.targetItems() : this.sourceItems();
      var index = item.inTarget ? item.targetIndex : item.sourceIndex;
      return index < arr.length - 1;
    }
  }, {
    key: "canMoveUp",
    value: function canMoveUp(item) {
      var index = item.inTarget ? item.targetIndex : item.sourceIndex;
      return index > 0;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          currentView = _props.currentView,
          contentModel = _props.contentModel;


      if (contentModel.randomizeItems && !this.viewStore.hasRandomized) {
        this.viewStore.hasRandomized = true;
        var list = [];
        for (var i = 0; i < contentModel.items.length; ++i) {
          list.push(i);
        }
        list = list.sort(function (a, b) {
          return Math.random() - 0.5;
        });
        for (var i = 0; i < contentModel.items.length; ++i) {
          contentModel.items[i].sourceIndex = list[i];
          contentModel.items[i].targetIndex = -1;
          contentModel.items[i].inTarget = false;
        }
      } else {
        for (var i = 0; i < contentModel.items.length; ++i) {
          contentModel.items[i].sourceIndex = i;
          contentModel.items[i].targetIndex = -1;
          contentModel.items[i].inTarget = false;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          currentView = _props2.currentView,
          contentModel = _props2.contentModel;
      var items = contentModel.items,
          activityTitle = contentModel.activityTitle,
          preActivityText = contentModel.preActivityText,
          sourceTitle = contentModel.sourceTitle,
          targetTitle = contentModel.targetTitle,
          postActivityText = contentModel.postActivityText; // this contentModel's properties

      var _viewStore = this.viewStore,
          updateUserInput = _viewStore.updateUserInput,
          invalid = _viewStore.invalid,
          save = _viewStore.save; // this components viewStore.  Will have actions and UI properties

      var self = this;

      var available = [];
      var selected = [];
      for (var i = 0; i < this.sourceItems().length; ++i) {
        (function (item) {
          available.push(_react2.default.createElement(
            "div",
            { className: "styled-item", key: i, onClick: function onClick(id) {
                return self.moveItemFromSourceToTarget(item);
              } },
            _react2.default.createElement("div", { className: "item-content", dangerouslySetInnerHTML: { __html: item.content } }),
            _react2.default.createElement(
              "div",
              { className: "source-to-target" },
              _react2.default.createElement("div", { className: "fa fa-caret-right" })
            )
          ));
        })(this.sourceItems()[i]);
      }
      for (var i = 0; i < this.targetItems().length; ++i) {
        (function (item) {
          selected.push(_react2.default.createElement(
            "div",
            { className: "styled-item back", key: i },
            _react2.default.createElement(
              "div",
              { className: "target-to-source-wrapper", onClick: function onClick(id) {
                  return self.moveItemFromTargetToSource(item);
                } },
              _react2.default.createElement(
                "div",
                { className: "target-to-source" },
                _react2.default.createElement("div", { className: "fa fa-caret-left" })
              ),
              _react2.default.createElement("div", { className: "item-content", dangerouslySetInnerHTML: { __html: item.content } })
            ),
            _react2.default.createElement(
              "div",
              { className: "target-prioritizer" },
              item.targetIndex > 0 ? _react2.default.createElement(
                "div",
                { className: "move-up", onClick: function onClick(id) {
                    return self.moveTargetItemUp(item);
                  } },
                _react2.default.createElement("div", { className: "fa fa-caret-up" })
              ) : '',
              item.targetIndex < self.targetItems().length - 1 ? _react2.default.createElement(
                "div",
                { className: "move-down", onClick: function onClick(id) {
                    return self.moveTargetItemDown(item);
                  } },
                _react2.default.createElement("div", { className: "fa fa-caret-down" })
              ) : ''
            )
          ));
        })(this.targetItems()[i]);
      }

      var disabled = false;
      if (available.length == 0) {
        available.push(_react2.default.createElement(
          "div",
          { className: "no-items" },
          _react2.default.createElement(
            "span",
            null,
            "List Empty"
          )
        ));
      }
      if (selected.length == 0) {
        disabled = true;
        selected.push(_react2.default.createElement(
          "div",
          { className: "no-items" },
          _react2.default.createElement(
            "span",
            null,
            "List Empty"
          )
        ));
      }

      return _react2.default.createElement(
        "div",
        { className: "list-builder-wrapper form" },
        activityTitle && _react2.default.createElement(
          "div",
          { className: "activity-title" },
          activityTitle
        ),
        preActivityText && _react2.default.createElement("div", { className: "instructions text-sm", dangerouslySetInnerHTML: { __html: preActivityText } }),
        _react2.default.createElement(
          "div",
          { className: "list-builder" },
          _react2.default.createElement(
            "div",
            { className: "source-set" },
            _react2.default.createElement(
              "div",
              { className: "title" },
              sourceTitle
            ),
            _react2.default.createElement(
              "div",
              { className: "list scrollbar" },
              available
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "target-set" },
            _react2.default.createElement(
              "div",
              { className: "title" },
              targetTitle
            ),
            _react2.default.createElement(
              "div",
              { className: "list scrollbar" },
              selected
            )
          )
        ),
        postActivityText && _react2.default.createElement("div", { className: "instructions", dangerouslySetInnerHTML: { __html: postActivityText } }),
        _react2.default.createElement(
          "div",
          { className: "btn btn-main-small right" + (disabled ? " disabled" : ""), onClick: save },
          "Submit"
        )
      );
    }
  }]);
  return DocumentBuilder;
}(_baseComponent2.default), _class5.ViewStore = DocumentBuilderViewStore, _temp2), (_applyDecoratedDescriptor(_class4.prototype, "moveItemFromSourceToTarget", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, "moveItemFromSourceToTarget"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "moveItemFromTargetToSource", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, "moveItemFromTargetToSource"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "move", [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, "move"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "moveTargetItemDown", [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, "moveTargetItemDown"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "moveTargetItemUp", [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, "moveTargetItemUp"), _class4.prototype)), _class4)) || _class3) || _class3);
var _default = DocumentBuilder;
exports.default = _default; //need to export top level component as "default"

;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DocumentBuilderViewStore, "DocumentBuilderViewStore", "D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/component.js");

  __REACT_HOT_LOADER__.register(DocumentBuilder, "DocumentBuilder", "D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/component.js");
}();

;

/***/ }),

/***/ "./app_modules/document-builder-activity/src/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentBuilderContentModel = exports.DocumentBuilderItemContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class2, _temp2, _dec, _desc2, _value2, _class3, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _class4, _temp4;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _deepBindDecorator = __webpack_require__("./node_modules/deep-bind-decorator/dist/deep-bind-decorator.js");

var _deepBindDecorator2 = _interopRequireDefault(_deepBindDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _component = __webpack_require__("./app_modules/document-builder-activity/src/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DocumentBuilderItemContentModel = exports.DocumentBuilderItemContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(DocumentBuilderItemContentModel, _BaseContentModel);

  function DocumentBuilderItemContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DocumentBuilderItemContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DocumentBuilderItemContentModel.__proto__ || (0, _getPrototypeOf2.default)(DocumentBuilderItemContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'content', _descriptor, _this), _initDefineProp(_this, 'sourceIndex', _descriptor2, _this), _initDefineProp(_this, 'targetIndex', _descriptor3, _this), _initDefineProp(_this, 'inTarget', _descriptor4, _this), _initDefineProp(_this, 'originalIndex', _descriptor5, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DocumentBuilderItemContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return {
        content: "Item Content 1",
        sourceIndex: 0,
        targetIndex: 1,
        inTarget: false,
        originalIndex: 1
      };
    }

    /* @slot */
  }]);
  return DocumentBuilderItemContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  content: "" // the content of this item
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'content', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Item Content";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'sourceIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'targetIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'inTarget', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'originalIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
})), _class);
var DocumentBuilderContentModel = exports.DocumentBuilderContentModel = (_dec = _mobx.observable.shallow, (_class3 = (_temp4 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(DocumentBuilderContentModel, _BaseContentModel2);

  function DocumentBuilderContentModel() {
    var _ref2;

    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, DocumentBuilderContentModel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DocumentBuilderContentModel.__proto__ || (0, _getPrototypeOf2.default)(DocumentBuilderContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _this2.Component = _component2.default, _initDefineProp(_this2, 'activityTitle', _descriptor6, _this2), _initDefineProp(_this2, 'preActivityText', _descriptor7, _this2), _initDefineProp(_this2, 'sourceTitle', _descriptor8, _this2), _initDefineProp(_this2, 'targetTitle', _descriptor9, _this2), _initDefineProp(_this2, 'postActivityText', _descriptor10, _this2), _initDefineProp(_this2, 'randomizeItems', _descriptor11, _this2), _initDefineProp(_this2, 'items', _descriptor12, _this2), _initDefineProp(_this2, 'userInput', _descriptor13, _this2), _initDefineProp(_this2, 'isSubmitted', _descriptor14, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }
  // the ContentModel classes contain the customizable "slots" that content creators will be filling in
  // presently these are defined via static _slots, but will be applied via @slot sugar
  // see the list below for examples of the slot types, and the editor input created for each:


  (0, _createClass3.default)(DocumentBuilderContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return {
        sourceTitle: "Source Items",
        targetTitle: "Selected Items",
        randomize: true,
        items: [new DocumentBuilderItemContentModel(DocumentBuilderItemContentModel._defaults)]
      };
    }

    // define the default Component (Sim) view of this component

    /* @slot */
    /* @slot */
    /* @slot */
    /* @slot */
    /* @slot */
    /* @slot */
    /* @slot([DocumentBuilderItemContentModel]) */

    /* @input("variableName") userInput = "default value" */


    // this will create a user input whose variable name is the contentmodel id appended with 'variableName'

  }]);
  return DocumentBuilderContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  activityTitle: "",
  preActivityText: "",
  sourceTitle: "",
  targetTitle: "",
  randomizeItems: true,
  postActivityText: "",
  items: [DocumentBuilderItemContentModel]
}, _temp4), (_descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'activityTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Activity Title (Optional)";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, 'preActivityText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Pre Activity Text (Optional)";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'sourceTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Available Items";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'targetTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Selected Items";
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, 'postActivityText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Post Activity Text (Optional)";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, 'randomizeItems', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class3.prototype, 'items', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class3.prototype, 'userInput', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_' + this.userInput.suffix + ':G';
      },
      suffix: "variableName",
      value: ""
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class3.prototype, 'isSubmitted', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class3));
var _default = DocumentBuilderContentModel;
exports.default = _default;
;

var _temp5 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DocumentBuilderItemContentModel, 'DocumentBuilderItemContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/contentmodel.js');

  __REACT_HOT_LOADER__.register(DocumentBuilderContentModel, 'DocumentBuilderContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/document-builder-activity/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./app_modules/document-builder-activity/src/contentmodel.js");

var contentModels = _interopRequireWildcard(_contentmodel);

__webpack_require__("./app_modules/document-builder-activity/src/style.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = contentModels;
var ContentModel = exports.ContentModel = contentModels.default;

var description = exports.description = "Allows users to select items from a list and order them, so users are engaged in synthesis and analysis";
var instructions = exports.instructions = "Users should drag and drop items using their mouse.";
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, "ContentModels", "D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/index.js");

  __REACT_HOT_LOADER__.register(ContentModel, "ContentModel", "D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/index.js");

  __REACT_HOT_LOADER__.register(description, "description", "D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/index.js");

  __REACT_HOT_LOADER__.register(instructions, "instructions", "D:/VSTS/agent/_work/24/s/app_modules/document-builder-activity/src/index.js");
}();

;

/***/ }),

/***/ "./app_modules/document-builder-activity/src/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app_modules/example-activity/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleSub = exports.Example = exports.ExampleViewStore = undefined;

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _class2, _class3, _temp, _class4;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// this is like a ViewModel, contains all user actions for this component
var ExampleViewStore = exports.ExampleViewStore = (_dec = _mobx.action.bound, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(ExampleViewStore, _BaseViewStore);

  function ExampleViewStore() {
    (0, _classCallCheck3.default)(this, ExampleViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (ExampleViewStore.__proto__ || (0, _getPrototypeOf2.default)(ExampleViewStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExampleViewStore, [{
    key: "save",
    value: function save() {
      var _this2 = this;

      var _props = this.props,
          activity = _props.contentModel,
          _props$inputStore = _props.inputStore,
          saveData = _props$inputStore.saveData,
          setInput = _props$inputStore.setInput;

      setInput(activity, "isCompleted", true);
      saveData(function () {
        return console.log(_this2.id + " saved!");
      });
    }
  }, {
    key: "invalid",
    get: function get() {
      var invalid = {};
      var _props2 = this.props,
          activity = _props2.contentModel,
          _props2$inputStore = _props2.inputStore,
          getInput = _props2$inputStore.getInput,
          setInput = _props2$inputStore.setInput;


      var userInputValue = getInput(activity, "userInput");

      if (!userInputValue) invalid.userInput = "User, please provide a value!";

      return invalid;
    }
  }]);
  return ExampleViewStore;
}(_baseViewstore2.default), (_applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype)), _class));

// this automatically gives consistent `className`s to components using module and component names
var Example = exports.Example = (0, _simboxEditable.Decorator)(_class2 = (0, _mobxReact.observer)(_class2 = (0, _autoclassDecorator2.default)(_class2 = (_temp = _class3 = function (_BaseComponent) {
  (0, _inherits3.default)(Example, _BaseComponent);

  function Example() {
    (0, _classCallCheck3.default)(this, Example);
    return (0, _possibleConstructorReturn3.default)(this, (Example.__proto__ || (0, _getPrototypeOf2.default)(Example)).apply(this, arguments));
  }

  (0, _createClass3.default)(Example, [{
    key: "render",
    //ViewStore gets auto-instantiated and attached to the component on creation
    value: function render() {
      var _props3 = this.props,
          currentView = _props3.currentView,
          contentModel = _props3.contentModel,
          _props3$inputStore = _props3.inputStore,
          getInput = _props3$inputStore.getInput,
          setInput = _props3$inputStore.setInput,
          isDirty = _props3$inputStore.isDirty,
          isLoading = _props3$inputStore.isLoading,
          revert = _props3$inputStore.revert;
      var textSlot = contentModel.textSlot,
          richTextSlot = contentModel.richTextSlot,
          textOptionsSlot = contentModel.textOptionsSlot,
          numberSlot = contentModel.numberSlot,
          booleanSlot = contentModel.booleanSlot,
          referenceSlot = contentModel.referenceSlot,
          referenceArraySlot = contentModel.referenceArraySlot; // this contentModel's properties

      var _viewStore = this.viewStore,
          invalid = _viewStore.invalid,
          save = _viewStore.save; // this components viewStore.  Will have actions and UI properties

      function createMarkup(html) {
        return { __html: html };
      }

      if (isLoading) return _react2.default.createElement(
        "div",
        null,
        "Loading..."
      );

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "header" },
          _react2.default.createElement(
            "h2",
            { className: "title" },
            textOptionsSlot,
            " - ",
            numberSlot
          ),
          _react2.default.createElement(
            "div",
            { className: "subtitle" },
            textSlot
          ),
          !!booleanSlot && _react2.default.createElement(
            "div",
            { className: "boolean" },
            "Boolean selected"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "content-area" },
          _react2.default.createElement(
            "div",
            { className: "left-column" },
            _react2.default.createElement("div", { dangerouslySetInnerHTML: createMarkup(richTextSlot) }),
            _react2.default.createElement("hr", null),
            !!invalid.userInput && _react2.default.createElement(
              "div",
              { className: "validation-error" },
              invalid.userInput
            ),
            _react2.default.createElement("input", { type: "text", value: getInput(contentModel, "userInput"), onChange: function onChange(e) {
                return setInput(contentModel, "userInput", e.target.value);
              } }),
            _react2.default.createElement("textarea", { disabled: "true", value: getInput(contentModel, "userInput_computed") }),
            _react2.default.createElement("hr", null),
            _react2.default.createElement(
              "button",
              { onClick: save, disabled: (0, _keys2.default)(invalid).length || !isDirty },
              "Save"
            ),
            _react2.default.createElement(
              "button",
              { onClick: revert, disabled: !isDirty },
              "Undo"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "center-column" },
            _react2.default.createElement(
              "div",
              null,
              "Single / direct reference slot:"
            ),
            _react2.default.createElement(ExampleSub, { "data-editable": [contentModel, "referenceSlot"], contentModel: referenceSlot })
          ),
          _react2.default.createElement(
            "div",
            { className: "right-column", "data-editable": [contentModel, "referenceArraySlot"] },
            _react2.default.createElement(
              "div",
              null,
              "Array of references slot:"
            ),
            referenceArraySlot.map(function (cm) {
              return _react2.default.createElement(ExampleSub, { key: cm.id, contentModel: cm });
            })
          )
        )
      );
    }
  }]);
  return Example;
}(_baseComponent2.default), _class3.ViewStore = ExampleViewStore, _temp)) || _class2) || _class2) || _class2;

var _default = Example;
exports.default = _default; //need to export top level component as "default"

var ExampleSub = exports.ExampleSub = (0, _simboxEditable.Decorator)(_class4 = (0, _mobxReact.observer)(_class4 = (0, _autoclassDecorator2.default)(_class4 = function (_BaseComponent2) {
  (0, _inherits3.default)(ExampleSub, _BaseComponent2);

  function ExampleSub() {
    (0, _classCallCheck3.default)(this, ExampleSub);
    return (0, _possibleConstructorReturn3.default)(this, (ExampleSub.__proto__ || (0, _getPrototypeOf2.default)(ExampleSub)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExampleSub, [{
    key: "render",
    value: function render() {
      var contentModel = this.props.contentModel;

      if (!contentModel) return _react2.default.createElement(
        "div",
        null,
        "No contentmodel supplied"
      );
      var text = contentModel.text,
          richText = contentModel.richText;


      function createMarkup(html) {
        return { __html: html };
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "title" },
          text
        ),
        _react2.default.createElement("div", { className: "body", dangerouslySetInnerHTML: createMarkup(richText) })
      );
    }
  }]);
  return ExampleSub;
}(_baseComponent2.default)) || _class4) || _class4) || _class4;

;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExampleViewStore, "ExampleViewStore", "D:/VSTS/agent/_work/24/s/app_modules/example-activity/component.js");

  __REACT_HOT_LOADER__.register(Example, "Example", "D:/VSTS/agent/_work/24/s/app_modules/example-activity/component.js");

  __REACT_HOT_LOADER__.register(ExampleSub, "ExampleSub", "D:/VSTS/agent/_work/24/s/app_modules/example-activity/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/example-activity/component.js");
}();

;

/***/ }),

/***/ "./app_modules/example-activity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleContentModel = exports.ExampleSubContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _class2, _temp2, _dec, _dec2, _desc2, _value2, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _class4, _temp4;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _component = __webpack_require__("./app_modules/example-activity/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ExampleSubContentModel = exports.ExampleSubContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(ExampleSubContentModel, _BaseContentModel);

  function ExampleSubContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExampleSubContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExampleSubContentModel.__proto__ || (0, _getPrototypeOf2.default)(ExampleSubContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'text', _descriptor, _this), _initDefineProp(_this, 'richText', _descriptor2, _this), _initDefineProp(_this, 'userInput', _descriptor3, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /* @slot */

  /* @slot("RichText") */

  return ExampleSubContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  text: "",
  richText: "RichText" }, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'text', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'richText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text for richText";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'userInput', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_userInput:G';
      },
      defaultValue: "another default"
    };
  }
})), _class);
var ExampleContentModel = exports.ExampleContentModel = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.shallow, (_class3 = (_temp4 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(ExampleContentModel, _BaseContentModel2);

  function ExampleContentModel() {
    var _ref2;

    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, ExampleContentModel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ExampleContentModel.__proto__ || (0, _getPrototypeOf2.default)(ExampleContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _initDefineProp(_this2, '_options', _descriptor4, _this2), _this2.Component = _component2.default, _initDefineProp(_this2, 'textSlot', _descriptor5, _this2), _initDefineProp(_this2, 'richTextSlot', _descriptor6, _this2), _initDefineProp(_this2, 'textOptionsSlot', _descriptor7, _this2), _initDefineProp(_this2, 'numberSlot', _descriptor8, _this2), _initDefineProp(_this2, 'booleanSlot', _descriptor9, _this2), _initDefineProp(_this2, 'referenceSlot', _descriptor10, _this2), _initDefineProp(_this2, 'referenceArraySlot', _descriptor11, _this2), _initDefineProp(_this2, 'isCompleted', _descriptor12, _this2), _initDefineProp(_this2, 'userInput', _descriptor13, _this2), _initDefineProp(_this2, 'userInput_computed', _descriptor14, _this2), _initDefineProp(_this2, 'customUserInput', _descriptor15, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }
  // the ContentModel classes contain the customizable "slots" that content creators will be filling in
  // presently these are defined via static _slots, but will be applied via @slot sugar
  // see the list below for examples of the slot types, and the editor input created for each:

  // options are a way to supply slots with specific options
  // this is currently defined manually, but will be taken care of by @options decorator 

  // define the default Component (Sim) view of this component

  /* @slot */

  // below is what content model definitions will ultimately look like. note the commented out decorators.
  // when these are in place, you will not need @observable, @observable.ref, etc

  /* @slot("RichText") */
  /* @options(["Option1", "Option2", "Option3"]) @slot */
  /* @slot */
  /* @slot */
  /* @slot(ExampleSubContentModel) */
  /* @slot([ExampleSubContentModel]) */

  // @input userInput = 100
  // creates...

  // @input.computed userInput_computed = () => {
  // const userInput2Val = this.$inputStore.getInput(this, "userInput2")
  // return userInput2Val + " was computed ... "
  // }
  // creates...

  // @input( () => `G:${this.id}_customVarName123:G` ) customUserInput = () => this.textOptionsSlot
  // creates...

  return ExampleContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  textSlot: "", // textarea
  richTextSlot: "RichText", // trix wysiwyg
  textOptionsSlot: "", // see _options
  numberSlot: 0, // text input, coerced to number
  booleanSlot: false, // checkbox
  referenceSlot: ExampleSubContentModel, // data-editable, contentModel mode
  referenceArraySlot: [ExampleSubContentModel] // data-editable, arrayAccessor mode
}, _temp4), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, '_options', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get textOptionsSlot() {
        // turns textOptionsSlot into dropdown
        return ["Option1", "Option2", "Option3"];
      }
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'textSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'richTextSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, 'textOptionsSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'numberSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'booleanSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, 'referenceSlot', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, 'referenceArraySlot', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class3.prototype, 'isCompleted', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_isCompleted:G';
      },
      defaultValue: false };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class3.prototype, 'userInput', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_userInput:G';
      },
      defaultValue: 100,
      value: "" };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class3.prototype, 'userInput_computed', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_userInput_computed:G';
      },
      get value() {
        if (!this.$inputStore) return "";
        var userInputVal = this.$inputStore.getInput(this, "userInput");
        return userInputVal + " was computed! (also gets saved, but is computed on UI), saves to variable: " + this["userInput_computed"].variable;
      }
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class3.prototype, 'customUserInput', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_customVarName123:G';
      },
      get defaultValue() {
        return this.textOptionsSlot;
      },
      value: ""
    };
  }
})), _class3));
var _default = ExampleContentModel;
exports.default = _default;
;

var _temp5 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExampleSubContentModel, 'ExampleSubContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/example-activity/contentmodel.js');

  __REACT_HOT_LOADER__.register(ExampleContentModel, 'ExampleContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/example-activity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/example-activity/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/example-activity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./app_modules/example-activity/contentmodel.js");

var allContentModels = _interopRequireWildcard(_contentmodel);

var _style = __webpack_require__("./app_modules/example-activity/style.css");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = allContentModels;
var ContentModel = exports.ContentModel = allContentModels.default;

var description = exports.description = "This is the example-activity.";
var instructions = exports.instructions = '\nThese are the example-activity installation instructions:\n  Step 1...\n  Step 2...\n  Step 3...\n';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'D:/VSTS/agent/_work/24/s/app_modules/example-activity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/example-activity/index.js');

  __REACT_HOT_LOADER__.register(description, 'description', 'D:/VSTS/agent/_work/24/s/app_modules/example-activity/index.js');

  __REACT_HOT_LOADER__.register(instructions, 'instructions', 'D:/VSTS/agent/_work/24/s/app_modules/example-activity/index.js');
}();

;

/***/ }),

/***/ "./app_modules/example-activity/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app_modules/form-control-activity/buttons/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgressButtonComponent = exports.ButtonComponent = undefined;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _numeral = __webpack_require__("./node_modules/numeral/numeral.js");

var _numeral2 = _interopRequireDefault(_numeral);

var _viewstore = __webpack_require__("./app_modules/form-control-activity/buttons/viewstore.js");

var _contentmodel = __webpack_require__("./app_modules/form-control-activity/buttons/contentmodel.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonComponent = exports.ButtonComponent = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
    (0, _inherits3.default)(ButtonComponent, _BaseComponent);

    function ButtonComponent() {
        (0, _classCallCheck3.default)(this, ButtonComponent);
        return (0, _possibleConstructorReturn3.default)(this, (ButtonComponent.__proto__ || (0, _getPrototypeOf2.default)(ButtonComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(ButtonComponent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                currentView = _props.currentView,
                contentModel = _props.contentModel,
                form = _props.form;
            var label = contentModel.label,
                tooltip = contentModel.tooltip,
                action = contentModel.action,
                disabled = contentModel.disabled,
                css = contentModel.css,
                tabindex = contentModel.tabindex; // this contentModel's properties

            var _viewStore = this.viewStore,
                invalid = _viewStore.invalid,
                save = _viewStore.save,
                onClick = _viewStore.onClick,
                errorMessage = _viewStore.errorMessage; // this component's viewStore.  Will have actions and UI properties

            if (form.props.contentModel.submitAction == "proceed" && form.props.contentModel.isSubmitted || contentModel.id == "ProgressButton_996") {
                return _react2.default.createElement("div", null);
            }

            if (errorMessage) {
                return _react2.default.createElement(
                    "div",
                    { className: "btn-progress-container right" },
                    _react2.default.createElement(
                        "div",
                        { className: "btn " + css + " error btn-progress disabled" },
                        form.updating && _react2.default.createElement("i", { className: "fa fa-spinner fa-spin" }),
                        _react2.default.createElement("span", { className: "btn-label", dangerouslySetInnerHTML: { __html: label } })
                    ),
                    _react2.default.createElement(
                        "span",
                        { className: "progress-bar-label", style: { color: 'red' } },
                        errorMessage
                    )
                );
            }

            return _react2.default.createElement(
                "div",
                { className: "btn-progress-container right" },
                _react2.default.createElement(
                    "div",
                    { className: "btn " + css + " btn-progress" + (disabled || form.props.contentModel.isSubmitted || this.viewStore.isClicked || form.updating ? " disabled " : ""), onClick: onClick },
                    form.updating && _react2.default.createElement("i", { className: "fa fa-spinner fa-spin" }),
                    _react2.default.createElement("span", { className: "btn-label", dangerouslySetInnerHTML: { __html: label } })
                ),
                _react2.default.createElement("span", { className: "progress-bar-label" })
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.ButtonViewStore;
        }
    }]);
    return ButtonComponent;
}(_baseComponent2.default)) || _class;

var ProgressButtonComponent = exports.ProgressButtonComponent = (0, _mobxReact.observer)(_class2 = function (_BaseComponent2) {
    (0, _inherits3.default)(ProgressButtonComponent, _BaseComponent2);

    function ProgressButtonComponent() {
        (0, _classCallCheck3.default)(this, ProgressButtonComponent);
        return (0, _possibleConstructorReturn3.default)(this, (ProgressButtonComponent.__proto__ || (0, _getPrototypeOf2.default)(ProgressButtonComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(ProgressButtonComponent, [{
        key: "render",
        value: function render() {
            var _props2 = this.props,
                currentView = _props2.currentView,
                contentModel = _props2.contentModel,
                form = _props2.form;
            var label = contentModel.label,
                tooltip = contentModel.tooltip,
                action = contentModel.action,
                disabled = contentModel.disabled,
                css = contentModel.css,
                tabindex = contentModel.tabindex; // this contentModel's properties

            var _viewStore2 = this.viewStore,
                invalid = _viewStore2.invalid,
                save = _viewStore2.save,
                onClick = _viewStore2.onClick,
                progress = _viewStore2.progress; // this component's viewStore.  Will have actions and UI properties

            var percent = (0, _numeral2.default)(form.props.contentModel.isSubmitted ? 1 : progress).format("0,0%");

            if (form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"] < 0 || form.dbVariableStore["G:FI_RES_CapitalRemainingInStream2:G"] < 0 || form.dbVariableStore["G:FI_RES_CapitalRemainingInStream3:G"] < 0 || form.props.contentModel.id.indexOf('activity_680096016') < 0 && window.application.shell && window.application.shell.needsStrategy) {
                return _react2.default.createElement(
                    "div",
                    { className: "btn-progress-container right" },
                    _react2.default.createElement(
                        "div",
                        { className: "btn " + css + " btn-progress disabled" },
                        _react2.default.createElement("span", { className: "btn-label", dangerouslySetInnerHTML: { __html: label } })
                    ),
                    _react2.default.createElement(
                        "span",
                        { className: "progress-bar-label", style: { color: 'red' } },
                        window.application.shell && window.application.shell.needsStrategy ? "You must finalize your strategy." : "You have exceeded your budget."
                    )
                );
            }

            return _react2.default.createElement(
                "div",
                { className: "btn-progress-container right" },
                _react2.default.createElement(
                    "div",
                    { className: "btn " + css + " btn-progress" + (progress < 1 || form.props.contentModel.isSubmitted ? " disabled" : ""), onClick: onClick },
                    _react2.default.createElement("span", { className: "btn-label", dangerouslySetInnerHTML: { __html: label } })
                )
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.ProgressButtonViewStore;
        }
    }]);
    return ProgressButtonComponent;
}(_baseComponent2.default)) || _class2;

var _default = ButtonComponent;
exports.default = _default; //need to export top level component as "default"

;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ButtonComponent, "ButtonComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/buttons/component.js");

    __REACT_HOT_LOADER__.register(ProgressButtonComponent, "ProgressButtonComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/buttons/component.js");

    __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/buttons/component.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/buttons/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgressButtonContentModel = exports.ButtonContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _component = __webpack_require__("./app_modules/form-control-activity/buttons/component.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ButtonContentModel = exports.ButtonContentModel = (_class = function (_BaseContentModel) {
    (0, _inherits3.default)(ButtonContentModel, _BaseContentModel);

    function ButtonContentModel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ButtonContentModel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonContentModel.__proto__ || (0, _getPrototypeOf2.default)(ButtonContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.Component = _component.ButtonComponent, _initDefineProp(_this, 'label', _descriptor, _this), _initDefineProp(_this, 'tooltip', _descriptor2, _this), _initDefineProp(_this, 'action', _descriptor3, _this), _initDefineProp(_this, 'disabled', _descriptor4, _this), _initDefineProp(_this, 'css', _descriptor5, _this), _initDefineProp(_this, 'tabindex', _descriptor6, _this), _initDefineProp(_this, '_options', _descriptor7, _this), _initDefineProp(_this, 'value', _descriptor8, _this), _this.isReadOnly = true, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ButtonContentModel, [{
        key: 'variable',
        get: function get() {
            if (this.action == "commit-1") {
                return "G:FI_RES_RunExplorationR1P1:G";
            } else if (this.action == "commit-2") {
                return "G:FI_RES_RunExplorationR1P2:G";
            } else if (this.action == "commit-3") {
                return "G:FI_RES_RunExplorationR2P1:G";
            } else if (this.action == "commit-4") {
                return "G:FI_RES_RunExplorationR2P2:G";
            }
            return null;
        }
    }], [{
        key: '_slots',
        get: function get() {
            return {
                label: "",
                tooltip: "",
                action: "",
                disabled: false,
                css: "",
                tabindex: 0
            };
        }
    }, {
        key: '_defaults',
        get: function get() {
            return {
                label: "Button",
                tooltip: "This is a tooltip",
                action: "submit",
                disabled: false,
                css: "",
                tabindex: 0
            };
        }
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return ButtonContentModel;
}(_baseContentmodel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'label', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'tooltip', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'action', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'disabled', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'css', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'tabindex', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, '_options', [_mobx.observable, _baseContentmodel.deepBind], {
    enumerable: true,
    initializer: function initializer() {
        return {
            get actions() {
                return ["submit", "none"];
            }
        };
    }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'value', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
})), _class);

var ProgressButtonContentModel = exports.ProgressButtonContentModel = function (_ButtonContentModel) {
    (0, _inherits3.default)(ProgressButtonContentModel, _ButtonContentModel);

    function ProgressButtonContentModel() {
        var _ref2;

        var _temp2, _this2, _ret2;

        (0, _classCallCheck3.default)(this, ProgressButtonContentModel);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ProgressButtonContentModel.__proto__ || (0, _getPrototypeOf2.default)(ProgressButtonContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _this2.Component = _component.ButtonComponent, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
    }

    (0, _createClass3.default)(ProgressButtonContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, ButtonContentModel._slots, {});
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, ButtonContentModel._defaults, {});
        }
    }]);
    return ProgressButtonContentModel;
}(ButtonContentModel);

var _default = ButtonContentModel;
exports.default = _default;
;

var _temp3 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ButtonContentModel, 'ButtonContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/buttons/contentmodel.js');

    __REACT_HOT_LOADER__.register(ProgressButtonContentModel, 'ProgressButtonContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/buttons/contentmodel.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/buttons/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/buttons/viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgressButtonViewStore = exports.ButtonViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _dec5, _desc2, _value2, _class3, _descriptor3;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ButtonViewStore = exports.ButtonViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class = function (_BaseViewStore) {
    (0, _inherits3.default)(ButtonViewStore, _BaseViewStore);

    function ButtonViewStore(props) {
        (0, _classCallCheck3.default)(this, ButtonViewStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ButtonViewStore.__proto__ || (0, _getPrototypeOf2.default)(ButtonViewStore)).call(this, props));

        _initDefineProp(_this, "isClicked", _descriptor, _this);

        _initDefineProp(_this, "errorMessage", _descriptor2, _this);

        _this.valid = true;
        _this.value = 0;


        if (_this.props.form) {
            _this.props.form.controls.push(_this);
        }

        //this.validate();
        return _this;
    }

    // validation is a derivation


    (0, _createClass3.default)(ButtonViewStore, [{
        key: "save",
        value: function save() {}
    }, {
        key: "onClick",
        value: function onClick(e) {
            if (this.isClicked) {
                return;
            }

            var form = this.props.form;
            if (!form) {
                return;
            }

            if (form.updating) {
                var self = this;
                setTimeout(function () {
                    self.onClick(e);
                }, 50);
                return;
            }

            this.isClicked = true;

            if (this.props.contentModel.action == "commit-1" || this.props.contentModel.action == "commit-2" || this.props.contentModel.action == "commit-3" || this.props.contentModel.action == "commit-4") {
                this.disableFields();

                var total = 0;
                var complete = 0;
                for (var i = 0; i < form.controls.length; ++i) {
                    if (form.controls[i].constructor.name != "ButtonViewStore" || form.controls[i].props.contentModel.id == "ProgressButton_996") {
                        continue;
                    }
                    if (form.controls[i].isClicked) {
                        complete += 1;
                    }
                    total += 1;
                }
                if (complete >= total) {
                    setTimeout(function () {
                        form.isSubmitting = true;
                        form.update();
                    }, 200);
                }
            } else {
                form.isSubmitting = true;
            }
            if (form.props.contentModel.id.indexOf('activity_680096016') >= 0 && window.application.shell.needsStrategy) {
                window.application.shell.needsStrategy = false;
            }

            if (form.props.contentModel.id == "activity_917175720" || form.props.contentModel.id == "activity_917175720_2" || form.props.contentModel.id == "activity_917175720_3") {

                var set = {};
                set["G:FI_RES_BidStatusR1P1:" + window.application.dataModel.domainStore.context.team.num5] = -2;
                set["G:FI_RES_BidStatusR1P2:" + window.application.dataModel.domainStore.context.team.num5] = -2;
                set["G:FI_RES_BidStatusR2P1:" + window.application.dataModel.domainStore.context.team.num5] = -2;
                set["G:FI_RES_BidStatusR2P2:" + window.application.dataModel.domainStore.context.team.num5] = -2;
                window.simgate.updateData({
                    path: window.application.dataModel.domainStore.context.team.pathId,
                    set: set
                });

                for (var _i = 0; _i < form.controls.length; ++_i) {
                    if (form.controls[_i].props.contentModel.id == "DropDownInputField_206" || form.controls[_i].props.contentModel.id == "DropDownInputField_994" || form.controls[_i].props.contentModel.id == "DropDownInputField_107" || form.controls[_i].props.contentModel.id == "DropDownInputField_124") {
                        form.controls[_i].value = -2;
                    }
                }

                form.dbVariableStore["G:FI_RES_BidStatusR1P1:G"] = -2;
                form.dbVariableStore["G:FI_RES_BidStatusR1P2:G"] = -2;
                form.dbVariableStore["G:FI_RES_BidStatusR2P1:G"] = -2;
                form.dbVariableStore["G:FI_RES_BidStatusR2P2:G"] = -2;
            }

            form.update();
        }
    }, {
        key: "update",
        value: function update() {
            if (this.isClicked || this.props.form.props.contentModel.isSubmitted) {
                this.errorMessage = "";
                this.props.contentModel.disabled = true;
                return;
            }

            var form = this.props.form;
            if (!form) {
                return;
            }

            this.props.contentModel.disabled = false;
            this.errorMessage = "";

            if (this.props.contentModel.id != "ProgressButton_244" && this.props.contentModel.id != "Round1Intro_Button" && this.props.contentModel.id != "Round2Intro_Button" && this.props.contentModel.id != "Round3Intro_Button" && window.application.shell.needsStrategy) {
                this.errorMessage = "You must finalize your strategy.";
                return;
            }

            if (this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"] < 0 || this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream2:G"] < 0 || this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream3:G"] < 0) {
                this.errorMessage = "You have exceeded your budget.";
            } else if (this.props.contentModel.action == "commit-1" && parseFloat(this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"]) < parseFloat(this.props.form.dbVariableStore["G:FI_RES_BlockExpenditureR1P1:G"])) {
                this.errorMessage = "Exploration may exceed budget.";
            } else if (this.props.contentModel.action == "commit-2" && parseFloat(this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"]) < parseFloat(this.props.form.dbVariableStore["G:FI_RES_BlockExpenditureR1P2:G"])) {
                this.errorMessage = "Exploration may exceed budget.";
            } else if (this.props.contentModel.action == "commit-3" && parseFloat(this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"]) < parseFloat(this.props.form.dbVariableStore["G:FI_RES_BlockExpenditureR2P1:G"])) {
                this.errorMessage = "Exploration may exceed budget.";
            } else if (this.props.contentModel.action == "commit-4" && parseFloat(this.props.form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"]) < parseFloat(this.props.form.dbVariableStore["G:FI_RES_BlockExpenditureR2P2:G"])) {
                this.errorMessage = "Exploration may exceed budget.";
            }

            if (this.props.contentModel.id == "ProgressButton_996") {
                var total = 0;
                var complete = 0;
                for (var i = 0; i < form.controls.length; ++i) {
                    if (form.controls[i].constructor.name != "ButtonViewStore" || form.controls[i] == this) {
                        continue;
                    }
                    if (form.controls[i].isClicked) {
                        complete += 1;
                    }
                    total += 1;
                }
                if (complete < total) {
                    this.errorMessage = complete + " of " + total + " explorations committed.";
                }
            } else if (this.props.contentModel.id == "ProgressButton_244") {
                var value = parseInt(form.dbVariableStore["G:FI_RES_SumCapitalAllocationPercent:G"]);
                var totalField = null;
                for (var _i2 = 0; _i2 < form.controls.length; ++_i2) {
                    if (form.controls[_i2].props.contentModel.id == "NumberInputField_20") {
                        totalField = form.controls[_i2];
                        break;
                    }
                }
                if (value != 100) {
                    if (totalField != null) {
                        totalField.props.contentModel.value = totalField.value + "_FAKE";
                        totalField.valid = false;
                    }
                    this.errorMessage = "Total allocation % must equal 100%";
                } else {
                    if (totalField != null) {
                        totalField.valid = true;
                    }

                    if (form.dbVariableStore["G:FI_DEC_Initiative1:G"] == form.dbVariableStore["G:FI_DEC_Initiative2:G"] && form.dbVariableStore["G:FI_DEC_Initiative1:G"] != 0) {
                        this.errorMessage = "You cannot select an initiative twice.";
                    }
                }
            } else if (this.props.contentModel.id == "ProgressButton_178") {
                if (form.dbVariableStore["G:FI_RES_TransUnitsToRefineryR1P1:G"] > form.dbVariableStore["G:FI_TRANS_TotCapacityR1P1:G"] || form.dbVariableStore["G:FI_RES_TransUnitsToRefineryR1P2:G"] > form.dbVariableStore["G:FI_TRANS_TotCapacityR1P2:G"] || form.dbVariableStore["G:FI_RES_TransUnitsToRefineryR2P1:G"] > form.dbVariableStore["G:FI_TRANS_TotCapacityR2P1:G"] || form.dbVariableStore["G:FI_RES_TransUnitsToRefineryR2P2:G"] > form.dbVariableStore["G:FI_TRANS_TotCapacityR2P2:G"]) {
                    this.errorMessage = "Transportation cannot exceed capacity.";
                }
            }

            var variable = this.props.contentModel.variable;
            if (!this.props.form || !variable || typeof this.props.form.dbVariableStore[variable] === 'undefined') {
                return;
            }

            this.value = this.props.form.dbVariableStore[variable];
            if (this.value == 1) {
                this.disableFields();
            } else {
                var dropdownField = null;

                if (this.props.contentModel.action == "commit-1") {
                    for (var _i3 = 0; _i3 < form.controls.length; ++_i3) {
                        if (form.controls[_i3].props.contentModel.id == "NumberInputField_ExplorationField18") {
                            form.controls[_i3].props.contentModel.disabled = false;
                        }
                        if (form.controls[_i3].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                            dropdownField = form.controls[_i3];
                        }
                    }
                } else if (this.props.contentModel.action == "commit-2") {
                    for (var _i4 = 0; _i4 < form.controls.length; ++_i4) {
                        if (form.controls[_i4].props.contentModel.id == "NumberInputField_ExplorationField39") {
                            form.controls[_i4].props.contentModel.disabled = false;
                        }
                        if (form.controls[_i4].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                            dropdownField = form.controls[_i4];
                        }
                    }
                } else if (this.props.contentModel.action == "commit-3") {
                    for (var _i5 = 0; _i5 < form.controls.length; ++_i5) {
                        if (form.controls[_i5].props.contentModel.id == "NumberInputField_ExplorationField61") {
                            form.controls[_i5].props.contentModel.disabled = false;
                        }
                        if (form.controls[_i5].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                            dropdownField = form.controls[_i5];
                        }
                    }
                } else if (this.props.contentModel.action == "commit-4") {
                    for (var _i6 = 0; _i6 < form.controls.length; ++_i6) {
                        if (form.controls[_i6].props.contentModel.id == "NumberInputField_ExplorationField81") {
                            form.controls[_i6].props.contentModel.disabled = false;
                        }
                        if (form.controls[_i6].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                            dropdownField = form.controls[_i6];
                        }
                    }
                }

                if (dropdownField) {
                    if (this.props.form.dbVariableStore["G:FI_RES_RunExplorationR1P1:G"] != 1 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR1P2:G"] != 1 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR2P1:G"] != 1 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR2P2:G"] != 1) {
                        dropdownField.props.contentModel.disabled = false;
                    }
                }
            }
        }
    }, {
        key: "disableFields",
        value: function disableFields() {
            this.props.contentModel.disabled = true;
            this.isClicked = true;
            this.value = 1;
            this.errorMessage = "";

            var form = this.props.form;
            if (!form) {
                return;
            }

            if (this.props.contentModel.action == "commit-1") {
                for (var i = 0; i < form.controls.length; ++i) {
                    if (form.controls[i].props.contentModel.id == "NumberInputField_ExplorationField18" || form.controls[i].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                        form.controls[i].props.contentModel.disabled = true;
                    }
                }
            } else if (this.props.contentModel.action == "commit-2") {
                for (var _i7 = 0; _i7 < form.controls.length; ++_i7) {
                    if (form.controls[_i7].props.contentModel.id == "NumberInputField_ExplorationField39" || form.controls[_i7].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                        form.controls[_i7].props.contentModel.disabled = true;
                    }
                }
            } else if (this.props.contentModel.action == "commit-3") {
                for (var _i8 = 0; _i8 < form.controls.length; ++_i8) {
                    if (form.controls[_i8].props.contentModel.id == "NumberInputField_ExplorationField61" || form.controls[_i8].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                        form.controls[_i8].props.contentModel.disabled = true;
                    }
                }
            } else if (this.props.contentModel.action == "commit-4") {
                for (var _i9 = 0; _i9 < form.controls.length; ++_i9) {
                    if (form.controls[_i9].props.contentModel.id == "NumberInputField_ExplorationField81" || form.controls[_i9].props.contentModel.id == "DropDownInputField_ExplorationFIeld4") {
                        form.controls[_i9].props.contentModel.disabled = true;
                    }
                }
            }
        }
    }, {
        key: "invalid",
        get: function get() {
            var invalid = {};
            return invalid;
        }
    }]);
    return ButtonViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isClicked", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClick", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "onClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableFields", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "disableFields"), _class.prototype)), _class));
var ProgressButtonViewStore = exports.ProgressButtonViewStore = (_dec5 = _mobx.action.bound, (_class3 = function (_ButtonViewStore) {
    (0, _inherits3.default)(ProgressButtonViewStore, _ButtonViewStore);

    function ProgressButtonViewStore() {
        var _ref;

        var _temp, _this2, _ret;

        (0, _classCallCheck3.default)(this, ProgressButtonViewStore);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = ProgressButtonViewStore.__proto__ || (0, _getPrototypeOf2.default)(ProgressButtonViewStore)).call.apply(_ref, [this].concat(args))), _this2), _initDefineProp(_this2, "progress", _descriptor3, _this2), _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
    }

    (0, _createClass3.default)(ProgressButtonViewStore, [{
        key: "lateUpdate",
        value: function lateUpdate() {
            var form = this.props.form;
        }
    }]);
    return ProgressButtonViewStore;
}(ButtonViewStore), (_descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "progress", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _applyDecoratedDescriptor(_class3.prototype, "lateUpdate", [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, "lateUpdate"), _class3.prototype)), _class3));
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ButtonViewStore, "ButtonViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/buttons/viewstore.js");

    __REACT_HOT_LOADER__.register(ProgressButtonViewStore, "ProgressButtonViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/buttons/viewstore.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/forms/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormComponent = exports.ControlGroupComponent = undefined;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _viewstore = __webpack_require__("./app_modules/form-control-activity/forms/viewstore.js");

var _contentmodel = __webpack_require__("./app_modules/form-control-activity/forms/contentmodel.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names


//@editable // this makes the view editable via authoring tool via data-editable
var ControlGroupComponent = exports.ControlGroupComponent = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
    (0, _inherits3.default)(ControlGroupComponent, _BaseComponent);

    function ControlGroupComponent() {
        (0, _classCallCheck3.default)(this, ControlGroupComponent);
        return (0, _possibleConstructorReturn3.default)(this, (ControlGroupComponent.__proto__ || (0, _getPrototypeOf2.default)(ControlGroupComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(ControlGroupComponent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                currentView = _props.currentView,
                contentModel = _props.contentModel,
                form = _props.form,
                lastCm = _props.lastCm,
                viewBreadcrumbs = _props.viewBreadcrumbs,
                insideEditor = _props.insideEditor;
            var label = contentModel.label,
                css = contentModel.css,
                controls = contentModel.controls; // this contentModel's properties

            var _viewStore = this.viewStore,
                invalid = _viewStore.invalid,
                save = _viewStore.save; // this component's viewStore.  Will have actions and UI properties

            var elements = [];
            for (var i = 0; i < controls.length; ++i) {
                var props = {
                    currentView: { contentModel: contentModel },
                    options: { contentModel: controls[i] },
                    contentModel: controls[i],
                    lastCm: lastCm,
                    viewBreadcrumbs: viewBreadcrumbs,
                    insideEditor: insideEditor,
                    form: form,
                    key: i
                };
                elements.push(_react2.default.createElement(controls[i].Component, props));
            }

            return _react2.default.createElement(
                "div",
                { className: "control-group " + css },
                _react2.default.createElement("div", { className: "control-group-title", dangerouslySetInnerHTML: { __html: label } }),
                elements
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.ControlGroupViewStore;
        }
    }]);
    return ControlGroupComponent;
}(_baseComponent2.default)) || _class;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var FormComponent = exports.FormComponent = (0, _mobxReact.observer)(_class2 = function (_BaseComponent2) {
    (0, _inherits3.default)(FormComponent, _BaseComponent2);

    function FormComponent() {
        (0, _classCallCheck3.default)(this, FormComponent);
        return (0, _possibleConstructorReturn3.default)(this, (FormComponent.__proto__ || (0, _getPrototypeOf2.default)(FormComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(FormComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.viewStore.createVariables();
            this.viewStore.startAutoUpdate();
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.viewStore.stopAutoUpdate();
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                currentView = _props2.currentView,
                contentModel = _props2.contentModel,
                lastCm = _props2.lastCm,
                viewBreadcrumbs = _props2.viewBreadcrumbs,
                insideEditor = _props2.insideEditor;
            var title = contentModel.title,
                css = contentModel.css,
                controls = contentModel.controls; // this contentModel's properties

            var _viewStore2 = this.viewStore,
                invalid = _viewStore2.invalid,
                save = _viewStore2.save; // this component's viewStore.  Will have actions and UI properties

            var elements = [];
            for (var i = 0; i < controls.length; ++i) {
                var props = {
                    currentView: { contentModel: contentModel },
                    options: { contentModel: controls[i] },
                    contentModel: controls[i],
                    lastCm: lastCm,
                    viewBreadcrumbs: viewBreadcrumbs,
                    insideEditor: insideEditor,
                    form: this.viewStore,
                    key: i
                };
                elements.push(_react2.default.createElement(controls[i].Component, props));
            }

            return _react2.default.createElement(
                "div",
                { className: "form " + css },
                elements
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.FormViewStore;
        }
    }]);
    return FormComponent;
}(_baseComponent2.default)) || _class2;

var _default = FormComponent;
exports.default = _default; //need to export top level component as "default"

;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ControlGroupComponent, "ControlGroupComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/forms/component.js");

    __REACT_HOT_LOADER__.register(FormComponent, "FormComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/forms/component.js");

    __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/forms/component.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/forms/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormContentModel = exports.ControlGroupContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _dec2, _desc2, _value2, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _contentmodel = __webpack_require__("./app_modules/form-control-activity/inputFields/contentmodel.js");

var _contentmodel2 = __webpack_require__("./app_modules/form-control-activity/layouts/contentmodel.js");

var _contentmodel3 = __webpack_require__("./app_modules/form-control-activity/static/contentmodel.js");

var _contentmodel4 = __webpack_require__("./app_modules/form-control-activity/buttons/contentmodel.js");

var _component = __webpack_require__("./app_modules/form-control-activity/forms/component.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ControlGroupContentModel = exports.ControlGroupContentModel = (_dec = _mobx.observable.shallow, (_class = function (_BaseContentModel) {
    (0, _inherits3.default)(ControlGroupContentModel, _BaseContentModel);

    function ControlGroupContentModel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ControlGroupContentModel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ControlGroupContentModel.__proto__ || (0, _getPrototypeOf2.default)(ControlGroupContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.Component = _component.ControlGroupComponent, _initDefineProp(_this, 'label', _descriptor, _this), _initDefineProp(_this, 'css', _descriptor2, _this), _initDefineProp(_this, 'controls', _descriptor3, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ControlGroupContentModel, null, [{
        key: '_slots',
        get: function get() {
            return {
                label: "",
                css: "",
                controls: [_contentmodel.InputFieldContentModel]
            };
        }
    }, {
        key: '_defaults',
        get: function get() {
            return {
                label: "",
                css: "",
                controls: []
            };
        }
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return ControlGroupContentModel;
}(_baseContentmodel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'label', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'css', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'controls', [_dec], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), _class));
var FormContentModel = exports.FormContentModel = (_dec2 = _mobx.observable.shallow, (_class3 = function (_BaseContentModel2) {
    (0, _inherits3.default)(FormContentModel, _BaseContentModel2);

    function FormContentModel() {
        var _ref2;

        var _temp2, _this2, _ret2;

        (0, _classCallCheck3.default)(this, FormContentModel);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = FormContentModel.__proto__ || (0, _getPrototypeOf2.default)(FormContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _this2.Component = _component.FormComponent, _initDefineProp(_this2, 'label', _descriptor4, _this2), _initDefineProp(_this2, 'css', _descriptor5, _this2), _initDefineProp(_this2, 'controls', _descriptor6, _this2), _initDefineProp(_this2, 'autoUpdate', _descriptor7, _this2), _initDefineProp(_this2, 'updateAction', _descriptor8, _this2), _initDefineProp(_this2, 'submitAction', _descriptor9, _this2), _initDefineProp(_this2, 'isSubmitted', _descriptor10, _this2), _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
    }

    (0, _createClass3.default)(FormContentModel, null, [{
        key: '_slots',
        get: function get() {
            return {
                title: "",
                css: "",
                controls: [_baseContentmodel2.default],
                autoUpdate: true,
                updateAction: "",
                submitAction: ""
            };
        }
    }, {
        key: '_defaults',
        get: function get() {
            return {
                label: "",
                css: "",
                autoUpdate: true,
                controls: [_contentmodel.InputFieldContentModel, _contentmodel2.LayoutContentModel, _contentmodel3.StaticContentModel, ControlGroupContentModel, _contentmodel4.ButtonContentModel],
                updateAction: "",
                submitAction: ""
            };
        }
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return FormContentModel;
}(_baseContentmodel2.default), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'label', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'css', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'controls', [_dec2], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, 'autoUpdate', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return true;
    }
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'updateAction', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "runProformaModel";
    }
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'submitAction', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, 'isSubmitted', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
})), _class3));
var _default = FormContentModel;
exports.default = _default;
;

var _temp3 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ControlGroupContentModel, 'ControlGroupContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/forms/contentmodel.js');

    __REACT_HOT_LOADER__.register(FormContentModel, 'FormContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/forms/contentmodel.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/forms/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/forms/viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormViewStore = exports.ControlGroupViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _desc2, _value2, _class2, _descriptor, _descriptor2;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _contentmodel = __webpack_require__("./app_modules/form-control-activity/inputFields/contentmodel.js");

var _utils = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var ControlGroupViewStore = exports.ControlGroupViewStore = (_dec = _mobx.action.bound, (_class = function (_BaseViewStore) {
    (0, _inherits3.default)(ControlGroupViewStore, _BaseViewStore);

    function ControlGroupViewStore() {
        (0, _classCallCheck3.default)(this, ControlGroupViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (ControlGroupViewStore.__proto__ || (0, _getPrototypeOf2.default)(ControlGroupViewStore)).apply(this, arguments));
    }

    (0, _createClass3.default)(ControlGroupViewStore, [{
        key: "save",
        value: function save() {}
    }, {
        key: "isValid",
        get: function get() {
            return true;
        }
    }, {
        key: "hasChanged",
        get: function get() {
            return this.props.contentModel.value != lastValue;
        }

        // validation is a derivation

    }, {
        key: "invalid",
        get: function get() {
            var invalid = {};
            /*const {
                contentModel,
                inputStore: {
                    getInput,
                    setInput
                }
            } = this.props;
              const userInputValue = getInput(contentModel, "userInput")
              if(!userInputValue) invalid.userInput = "User, please provide a value!"*/

            return invalid;
        }
    }]);
    return ControlGroupViewStore;
}(_baseViewstore2.default), (_applyDecoratedDescriptor(_class.prototype, "isValid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasChanged", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "hasChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype)), _class));
var FormViewStore = exports.FormViewStore = (_dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, (_class2 = function (_BaseViewStore2) {
    (0, _inherits3.default)(FormViewStore, _BaseViewStore2);

    function FormViewStore(props) {
        (0, _classCallCheck3.default)(this, FormViewStore);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (FormViewStore.__proto__ || (0, _getPrototypeOf2.default)(FormViewStore)).call(this, props));

        _initDefineProp(_this2, "valid", _descriptor, _this2);

        _initDefineProp(_this2, "updating", _descriptor2, _this2);

        _this2.dbVariableStore = {};
        _this2.updatedValues = {};
        _this2.isSubmitting = false;
        _this2.controls = [];
        _this2.lastUpdate = 0;
        _this2.updateTimer = 0;
        return _this2;
    }

    (0, _createClass3.default)(FormViewStore, [{
        key: "update",
        value: function update() {
            var valid = true;

            var variables = {};

            for (var i = 0; i < this.controls.length; ++i) {
                var control = this.controls[i];
                if (control && typeof control.valid !== 'undefined' && control.props.contentModel.required) {
                    valid = valid && control.valid;
                }
            }

            this.valid = valid;

            if (this.valid) {
                this.save();
            }
        }

        // validation is a derivation

    }, {
        key: "save",
        value: function save() {
            var self = this;
            var _props = this.props,
                contentModel = _props.contentModel,
                inputStore = _props.inputStore;


            for (var i = 0; i < this.controls.length; ++i) {
                var control = this.controls[i];
                if (control.props.contentModel.variable && control.valid) {
                    if (this.dbVariableStore[control.props.contentModel.variable] != control.value) {
                        var base = control.props.contentModel.variable.substring(0, control.props.contentModel.variable.lastIndexOf(":"));
                        self.updatedValues[base + ":" + window.application.dataModel.domainStore.context.team.num5] = control.value;
                        this.dbVariableStore[control.props.contentModel.variable] = control.value;
                    }
                }
                /*if(control.props.contentModel.variables && control.valid) {
                    for(let j in control.props.contentModel.variables) {
                        if(this.dbVariableStore[j] != control.props.contentModel.variables[j]) {
                            self.updatedValues[j] = control.props.contentModel.variables[j];
                            this.dbVariableStore[j] = control.props.contentModel.variables[j];
                        }
                    }
                }*/
            }

            this.lastUpdate = new Date().getTime();
            if (this.isSubmitting) {
                self.runSubmitAction();
            } else {
                self.runUpdateAction();
            }
        }
    }, {
        key: "runUpdateAction",
        value: function runUpdateAction() {
            var self = this;
            var _props2 = this.props,
                contentModel = _props2.contentModel,
                inputStore = _props2.inputStore;


            if (this.updating) {
                console.log("Blocked");
                setTimeout(function () {
                    self.runUpdateAction();
                }, 100);
                return;
            }

            this.updating = true;
            if (!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId) {
                self.updateVariables({});
                return;
            }

            if (!self.updatedValues || (0, _keys2.default)(self.updatedValues).length == 0 || contentModel.isSubmitted) {
                self.updateVariables({});
                return;
            }

            var tempValues = (0, _assign2.default)({}, self.updatedValues);
            self.updatedValues = {};

            if (contentModel.updateAction == "runProformaModel") {
                inputStore.simgate.runModel({
                    model: "DIOGModel",
                    select: "*",
                    mode: "Proforma",
                    saveOutputs: true,
                    period: window.application.dataModel.domainStore.context.team.num5,
                    teamnumber: 1,
                    actors: [{
                        id: window.application.dataModel.domainStore.context.team.pathId,
                        inputs: tempValues,
                        isTeam: true
                    }]
                }).then(function (result) {
                    var data = result.outputs && result.outputs[window.application.dataModel.domainStore.context.team.pathId] || {};
                    self.updateVariables(data);
                }).catch(function (result) {
                    alert(result);
                    self.updateVariables({});
                }).always(function () {});
            } else {
                self.updateVariables({});
            }
        }
    }, {
        key: "runSubmitAction",
        value: function runSubmitAction() {
            var self = this;
            var _props3 = this.props,
                contentModel = _props3.contentModel,
                inputStore = _props3.inputStore;


            if (this.updating) {
                setTimeout(function () {
                    self.runSubmitAction();
                }, 100);
                return;
            }
            this.updating = true;
            if (!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId) {
                self.updateVariables({});
                return;
            }

            var tempValues = (0, _assign2.default)({}, self.updatedValues);
            self.updatedValues = {};

            contentModel.isSubmitted = true;

            if (contentModel.submitAction == "proceed") {
                var _window$application$s = window.application.shell,
                    viewMap = _window$application$s.viewMap,
                    selectView = _window$application$s.selectView;


                var first = null;
                var home = null;
                var resources = null;
                var financials = null;
                for (var i in viewMap) {
                    var view = viewMap[i];

                    if (!home) {
                        home = view;
                    } else if (!resources) {
                        resources = view;
                    } else if (!financials) {
                        financials = view;
                    }
                    if ((!first || first == home || first == resources || first == financials) && !view.contentModel.activity.isSubmitted) {
                        first = view;
                    }
                }

                if (first) {
                    selectView(first, viewMap);
                }
            }

            var set = {};
            set[contentModel.id + "_isCompleted"] = true;
            set[contentModel.id + "_isSubmitted"] = true;
            inputStore.simgate.updateData({
                path: window.application.dataModel.domainStore.context.team.pathId,
                set: set
            }).then((0, _mobx.action)("loadData-callback", function (res) {
                var data = res.updated || {};
                console.log("Form complete");
                self.isSubmitting = false;
                self.updateControls();
            })).catch((0, _mobx.action)("loadData-error", function (err) {
                debugger;
                alert("There was a problem saving your data - " + err);
            }));
        }
    }, {
        key: "updateVariables",
        value: function updateVariables(data) {
            var self = this;
            var _props4 = this.props,
                contentModel = _props4.contentModel,
                inputStore = _props4.inputStore;


            for (var i in data) {
                var value = data[i];
                if (value !== undefined) {
                    if (!isNaN(parseFloat(value))) {
                        value = parseFloat(value);
                        var rounded = Math.round(value);
                        if (value >= 0.999 && Math.abs(rounded - value) < 0.01) {
                            value = rounded;
                        }
                    }
                    var base = i.substring(0, i.lastIndexOf(":"));
                    var rangeText = i.substring(i.lastIndexOf(":") + 1);
                    var start = parseInt(rangeText.charAt(0));

                    if (base == "G:FI_DEC_DividendPercent" || base == "G:FI_RES_SumCapitalAllocationPercent") {
                        value *= 100;
                    }

                    if (self.dbVariableStore[i] !== undefined) {
                        self.dbVariableStore[i] = value;
                    }
                    if (start == window.application.dataModel.domainStore.context.team.num5 && self.dbVariableStore[base + ":G"] !== undefined) {
                        self.dbVariableStore[base + ":G"] = value;
                    }

                    var end = rangeText.charAt(rangeText.length - 1);
                    if (end == "M") {
                        end = window.application.dataModel.domainStore.context.team.num5;
                    } else {
                        end = parseInt(end);
                    }
                    for (var r = start; r <= end; ++r) {
                        if (self.dbVariableStore[base + ":" + r] !== undefined) {
                            self.dbVariableStore[base + ":" + r] = value;
                        }
                        var diff = r - window.application.dataModel.domainStore.context.team.num5;
                        if (diff < 0 && self.dbVariableStore[base + ":" + diff] !== undefined) {
                            self.dbVariableStore[base + ":" + diff] = value;
                        } else if (self.dbVariableStore[base + ":+" + diff] !== undefined) {
                            self.dbVariableStore[base + ":+" + diff] = value;
                        }
                    }
                }
            }

            if (this.dbVariableStore["G:FI_HSEC_Index:G"]) {
                this.props.contentModel.HSEIndex = this.dbVariableStore["G:FI_HSEC_Index:G"];
            }
            self.updateControls();
        }
    }, {
        key: "updateControls",
        value: function updateControls() {
            var _props5 = this.props,
                contentModel = _props5.contentModel,
                inputStore = _props5.inputStore;


            try {
                var lateUpdate = [];
                for (var i = 0; i < this.controls.length; ++i) {
                    var control = this.controls[i];
                    if (control.update) {
                        control.update();
                    }
                    if (control.lateUpdate) {
                        lateUpdate.push(control);
                    }
                }
                for (var _i = 0; _i < lateUpdate.length; ++_i) {
                    if (lateUpdate[_i].lateUpdate) {
                        lateUpdate[_i].lateUpdate();
                    }
                }
            } catch (e) {
                console.error(e);
            }

            this.updating = false;
        }
    }, {
        key: "createVariables",
        value: function createVariables() {
            var self = this;
            var _props6 = this.props,
                contentModel = _props6.contentModel,
                inputStore = _props6.inputStore;


            this.updating = true;
            var inputs = [];

            for (var i = 0; i < this.controls.length; ++i) {
                var control = this.controls[i];
                if (control.props.contentModel.variable) {
                    this.dbVariableStore[control.props.contentModel.variable] = control.value;

                    if (control.props.contentModel.variable.indexOf(":-1") >= 0) {
                        inputs.push(control.props.contentModel.variable.replace(":-1", ":" + (window.application.dataModel.domainStore.context.team.num5 - 1)));
                    } else if (control.props.contentModel.variable.indexOf(":+0") >= 0) {
                        inputs.push(control.props.contentModel.variable.replace(":+0", ":" + window.application.dataModel.domainStore.context.team.num5));
                    } else if (control.props.contentModel.variable.indexOf(":G") >= 0) {
                        inputs.push(control.props.contentModel.variable.replace(":G", ":" + window.application.dataModel.domainStore.context.team.num5));
                    } else {
                        inputs.push(control.props.contentModel.variable);
                    }
                }
                if (control.props.contentModel.variables) {
                    var variables = control.props.contentModel.variables;
                    for (var j in variables) {
                        this.dbVariableStore[j] = variables[j];

                        if (j.indexOf(":G") >= 0) {
                            inputs.push(j.replace(":G", ":" + window.application.dataModel.domainStore.context.team.num5));
                        } else {
                            inputs.push(j);
                        }
                    }
                }
            }

            if (window.application.dataModel.domainStore.context.team.num5 >= 2) {
                this.dbVariableStore["G:FI_DEC_Initiative1:1"] = -1;
                this.dbVariableStore["G:FI_DEC_Initiative2:1"] = -1;
                inputs.push("G:FI_DEC_Initiative1:1");
                inputs.push("G:FI_DEC_Initiative2:1");
            }
            if (window.application.dataModel.domainStore.context.team.num5 >= 3) {
                this.dbVariableStore["G:FI_DEC_Initiative1:2"] = -1;
                this.dbVariableStore["G:FI_DEC_Initiative2:2"] = -1;
                inputs.push("G:FI_DEC_Initiative1:2");
                inputs.push("G:FI_DEC_Initiative2:2");
            }

            this.isLoading = true;

            if (!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId || inputs.length == 0) {
                self.updateVariables({});
                return;
            }

            var taskArgs = [inputStore.simgate.selectData, {
                select: inputs,
                path: window.application.dataModel.domainStore.context.team.pathId
            }, {
                //wrap in action for mobx transaction purposes (only refresh views after complete)
                onSuccess: (0, _mobx.action)("loadData-callback", function (res) {

                    var data = res.selected && res.selected.data || {};
                    self.updateVariables(data);
                    self.isLoading = false;
                }),
                onFailure: (0, _mobx.action)("loadData-error", function (err) {
                    debugger;
                    alert("There was a problem loading your data - " + err);
                })
            }];

            if (inputStore.simgate.runTask) {
                var _inputStore$simgate;

                (_inputStore$simgate = inputStore.simgate).runTask.apply(_inputStore$simgate, taskArgs);
            } else if (inputStore.simgate.AsyncTask) {
                var asyncTask = new inputStore.simgate.AsyncTask();
                asyncTask.runTask.apply(asyncTask, taskArgs);
            } else {
                inputStore.simgate.selectData(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
            }
        }
    }, {
        key: "startAutoUpdate",
        value: function startAutoUpdate() {
            if (!this.props.contentModel.autoUpdate) {
                return;
            }
            var self = this;
            this.updateTimer = setInterval(function () {
                self.autoUpdate();
            }, 30000); // 30 seconds
        }
    }, {
        key: "stopAutoUpdate",
        value: function stopAutoUpdate() {
            clearInterval(this.updateTimer);
            this.updateTimer = 0;
        }
    }, {
        key: "autoUpdate",
        value: function autoUpdate() {
            var self = this;
            var _props7 = this.props,
                contentModel = _props7.contentModel,
                inputStore = _props7.inputStore;

            // if last update was less than 10 seconds ago then don't update now

            if (this.lastUpdate >= new Date().getTime() - 10000) {
                return;
            }
            this.lastUpdate = new Date().getTime();

            var inputs = [];

            for (var i = 0; i < this.controls.length; ++i) {
                var control = this.controls[i];
                if (control.props.contentModel.variable) {
                    if (control.props.contentModel.variable.indexOf(":-1") >= 0) {
                        inputs.push(control.props.contentModel.variable.replace(":-1", ":" + (window.application.dataModel.domainStore.context.team.num5 - 1)));
                    } else if (control.props.contentModel.variable.indexOf(":+0") >= 0) {
                        inputs.push(control.props.contentModel.variable.replace(":+0", ":" + window.application.dataModel.domainStore.context.team.num5));
                    } else if (control.props.contentModel.variable.indexOf(":G") >= 0) {
                        inputs.push(control.props.contentModel.variable.replace(":G", ":" + window.application.dataModel.domainStore.context.team.num5));
                    } else {
                        inputs.push(control.props.contentModel.variable);
                    }
                }
                if (control.props.contentModel.variables) {
                    var variables = control.props.contentModel.variables;
                    for (var j in variables) {
                        if (j.indexOf(":G") >= 0) {
                            inputs.push(j.replace(":G", ":" + window.application.dataModel.domainStore.context.team.num5));
                        } else {
                            inputs.push(j);
                        }
                    }
                }
            }

            this.updating = true;

            if (!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId || inputs.length == 0) {
                self.updateVariables({});
                return;
            }

            var taskArgs = [inputStore.simgate.selectData, {
                select: inputs,
                path: window.application.dataModel.domainStore.context.team.pathId
            }, {
                //wrap in action for mobx transaction purposes (only refresh views after complete)
                onSuccess: (0, _mobx.action)("loadData-callback", function (res) {

                    var data = res.selected && res.selected.data || {};
                    self.updateVariables(data);
                }),
                onFailure: (0, _mobx.action)("loadData-error", function (err) {
                    debugger;
                    alert("There was a problem loading your data - " + err);
                })
            }];

            if (inputStore.simgate.runTask) {
                var _inputStore$simgate2;

                (_inputStore$simgate2 = inputStore.simgate).runTask.apply(_inputStore$simgate2, taskArgs);
            } else if (inputStore.simgate.AsyncTask) {
                var asyncTask = new inputStore.simgate.AsyncTask();
                asyncTask.runTask.apply(asyncTask, taskArgs);
            } else {
                inputStore.simgate.selectData(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
            }
        }
    }, {
        key: "invalid",
        get: function get() {
            var invalid = {};
            return invalid;
        }
    }]);
    return FormViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "valid", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "updating", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _applyDecoratedDescriptor(_class2.prototype, "update", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "update"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "invalid"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "save", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "save"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "runUpdateAction", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "runUpdateAction"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "runSubmitAction", [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "runSubmitAction"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateVariables", [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "updateVariables"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateControls", [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "updateControls"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createVariables", [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "createVariables"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "startAutoUpdate", [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "startAutoUpdate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "stopAutoUpdate", [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "stopAutoUpdate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "autoUpdate", [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, "autoUpdate"), _class2.prototype)), _class2));
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ControlGroupViewStore, "ControlGroupViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/forms/viewstore.js");

    __REACT_HOT_LOADER__.register(FormViewStore, "FormViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/forms/viewstore.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./app_modules/form-control-activity/inputFields/contentmodel.js");

var _contentmodel2 = __webpack_require__("./app_modules/form-control-activity/buttons/contentmodel.js");

var _contentmodel3 = __webpack_require__("./app_modules/form-control-activity/progress/contentmodel.js");

var _contentmodel4 = __webpack_require__("./app_modules/form-control-activity/forms/contentmodel.js");

var _contentmodel5 = __webpack_require__("./app_modules/form-control-activity/static/contentmodel.js");

var _contentmodel6 = __webpack_require__("./app_modules/form-control-activity/layouts/contentmodel.js");

var _style = __webpack_require__("./app_modules/form-control-activity/style.css");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentModels = exports.ContentModels = {
	TextInputFieldContentModel: _contentmodel.TextInputFieldContentModel,
	NumberInputFieldContentModel: _contentmodel.NumberInputFieldContentModel,
	SliderInputFieldContentModel: _contentmodel.SliderInputFieldContentModel,
	CheckboxInputFieldContentModel: _contentmodel.CheckboxInputFieldContentModel,
	PasswordInputFieldContentModel: _contentmodel.PasswordInputFieldContentModel,
	RadioInputFieldContentModel: _contentmodel.RadioInputFieldContentModel,
	RadioInputFieldOptionContentModel: _contentmodel.RadioInputFieldOptionContentModel,
	DropDownInputFieldContentModel: _contentmodel.DropDownInputFieldContentModel,
	DropDownInputFieldOptionContentModel: _contentmodel.DropDownInputFieldOptionContentModel,
	//TextAreaInputFieldContentModel: TextAreaInputFieldContentModel,

	ProgressBarContentModel: _contentmodel3.ProgressBarContentModel,
	ButtonContentModel: _contentmodel2.ButtonContentModel,
	ProgressButtonContentModel: _contentmodel2.ProgressButtonContentModel,
	ControlGroupContentModel: _contentmodel4.ControlGroupContentModel,
	SingleLayoutContentModel: _contentmodel6.SingleLayoutContentModel,
	ColumnLayoutContentModel: _contentmodel6.ColumnLayoutContentModel,
	RowLayoutContentModel: _contentmodel6.RowLayoutContentModel,
	TableLayoutContentModel: _contentmodel6.TableLayoutContentModel,
	StaticTextContentModel: _contentmodel5.StaticTextContentModel,
	StaticImageContentModel: _contentmodel5.StaticImageContentModel,
	FormContentModel: _contentmodel4.FormContentModel
};

var ContentModel = exports.ContentModel = _contentmodel4.FormContentModel;

//export const InputFieldContentModel = InputFieldContentModel;
//export const LayoutContentModel = LayoutContentModel;

var description = exports.description = "Generic form component. This can be connected to an Excel model.";
var instructions = exports.instructions = "";
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/index.js');

	__REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/index.js');

	__REACT_HOT_LOADER__.register(description, 'description', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/index.js');

	__REACT_HOT_LOADER__.register(instructions, 'instructions', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/index.js');
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/inputFields/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextAreaInputFieldComponent = exports.DropDownInputFieldComponent = exports.RadioInputFieldComponent = exports.PasswordInputFieldComponent = exports.CheckboxInputFieldComponent = exports.SliderInputFieldComponent = exports.NumberInputFieldComponent = exports.TextInputFieldComponent = exports.InputFieldComponent = undefined;

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");

var _get3 = _interopRequireDefault(_get2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _class3, _class4, _class5, _class6, _class7, _class8, _class9;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _numeral = __webpack_require__("./node_modules/numeral/numeral.js");

var _numeral2 = _interopRequireDefault(_numeral);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _viewstore = __webpack_require__("./app_modules/form-control-activity/inputFields/viewstore.js");

var _contentmodel = __webpack_require__("./app_modules/form-control-activity/inputFields/contentmodel.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names


//@editable // this makes the view editable via authoring tool via data-editable
var InputFieldComponent = exports.InputFieldComponent = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
    (0, _inherits3.default)(InputFieldComponent, _BaseComponent);

    function InputFieldComponent() {
        (0, _classCallCheck3.default)(this, InputFieldComponent);
        return (0, _possibleConstructorReturn3.default)(this, (InputFieldComponent.__proto__ || (0, _getPrototypeOf2.default)(InputFieldComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(InputFieldComponent, [{
        key: "inputElement",
        value: function inputElement(props) {
            return _react2.default.createElement("input", props);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                currentView = _props.currentView,
                contentModel = _props.contentModel;
            var label = contentModel.label,
                placeholder = contentModel.placeholder,
                tooltip = contentModel.tooltip,
                variable = contentModel.variable,
                errorMessage = contentModel.errorMessage,
                disabled = contentModel.disabled,
                isReadOnly = contentModel.isReadOnly,
                required = contentModel.required,
                css = contentModel.css,
                tabindex = contentModel.tabindex; // this contentModel's properties

            var _viewStore = this.viewStore,
                attributes = _viewStore.attributes,
                events = _viewStore.events,
                value = _viewStore.value,
                hovering = _viewStore.hovering,
                onChange = _viewStore.onChange,
                onFocus = _viewStore.onFocus,
                onBlur = _viewStore.onBlur,
                onMouseEnter = _viewStore.onMouseEnter,
                onMouseLeave = _viewStore.onMouseLeave,
                onKeyUp = _viewStore.onKeyUp,
                valid = _viewStore.valid,
                hasChanged = _viewStore.hasChanged; // this component's viewStore.  Will have actions and UI properties

            //if(isLoading) return <div>Loading...</div>

            attributes.value = value;
            attributes.placeholder = placeholder;
            attributes.disabled = disabled || this.props.form.props.contentModel.isSubmitted;
            attributes.readOnly = isReadOnly;
            attributes.required = required;
            attributes.tabIndex = tabindex;

            var props = {};
            for (var i in attributes) {
                if (attributes[i] != null) {
                    props[i] = attributes[i];
                }
            }
            for (var i in events) {
                if (events[i] != null) {
                    props[i] = events[i];
                }
            }

            var self = this;
            if (!props.onChange) {
                props.onChange = function (e) {
                    onChange(e.target.value);
                };
            }
            if (!props.onFocus) {
                props.onFocus = onFocus;
            }
            if (!props.onBlur) {
                props.onBlur = onBlur;
            }
            if (!props.onMouseEnter) {
                props.onMouseEnter = onMouseEnter;
            }
            if (!props.onMouseLeave) {
                props.onMouseLeave = onMouseLeave;
            }
            if (!props.onKeyUp) {
                props.onKeyUp = onKeyUp;
            }

            var showError = hasChanged && !valid;

            return _react2.default.createElement(
                "div",
                { className: "input-field " + css + (showError ? " error" : "") },
                tooltip && _react2.default.createElement("div", { className: "tooltip", dangerouslySetInnerHTML: { __html: tooltip } }),
                _react2.default.createElement("span", { className: "input-label", dangerouslySetInnerHTML: { __html: label } }),
                this.inputElement(props),
                _react2.default.createElement(
                    "div",
                    { className: "error-message" },
                    _react2.default.createElement("i", { className: "fa fa-fw fa-exclamation-circle" }),
                    _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: errorMessage ? errorMessage : "Enter a valid value for this field." } })
                )
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.InputFieldViewStore;
        }
    }]);
    return InputFieldComponent;
}(_baseComponent2.default)) || _class;

var _default = InputFieldComponent;
exports.default = _default; //need to export top level component as "default"


//@editable // this makes the view editable via authoring tool via data-editable

// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var TextInputFieldComponent = exports.TextInputFieldComponent = (0, _mobxReact.observer)(_class2 = function (_InputFieldComponent) {
    (0, _inherits3.default)(TextInputFieldComponent, _InputFieldComponent);

    function TextInputFieldComponent() {
        (0, _classCallCheck3.default)(this, TextInputFieldComponent);
        return (0, _possibleConstructorReturn3.default)(this, (TextInputFieldComponent.__proto__ || (0, _getPrototypeOf2.default)(TextInputFieldComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(TextInputFieldComponent, [{
        key: "render",
        value: function render() {
            var _props2 = this.props,
                currentView = _props2.currentView,
                contentModel = _props2.contentModel;
            var minLength = contentModel.minLength,
                maxLength = contentModel.maxLength,
                validationRegex = contentModel.validationRegex; // this contentModel's properties

            this.viewStore.attributes.type = "text";
            if (maxLength > 0) {
                this.viewStore.attributes.maxLength = maxLength;
            }

            return (0, _get3.default)(TextInputFieldComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(TextInputFieldComponent.prototype), "render", this).call(this);
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.TextInputFieldViewStore;
        }
    }]);
    return TextInputFieldComponent;
}(InputFieldComponent)) || _class2;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var NumberInputFieldComponent = exports.NumberInputFieldComponent = (0, _mobxReact.observer)(_class3 = function (_InputFieldComponent2) {
    (0, _inherits3.default)(NumberInputFieldComponent, _InputFieldComponent2);

    function NumberInputFieldComponent() {
        (0, _classCallCheck3.default)(this, NumberInputFieldComponent);
        return (0, _possibleConstructorReturn3.default)(this, (NumberInputFieldComponent.__proto__ || (0, _getPrototypeOf2.default)(NumberInputFieldComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(NumberInputFieldComponent, [{
        key: "inputElement",
        value: function inputElement(props) {
            var _viewStore2 = this.viewStore,
                value = _viewStore2.value,
                hasFocus = _viewStore2.hasFocus;


            var format = this.props.contentModel.displayformat;
            var className = "number";

            try {
                var number = parseFloat(value);
                if (!hasFocus && format && !isNaN(number)) {
                    if (format.indexOf("%") >= 0 && number >= 1) {
                        number /= 100;
                    }
                    if (number < 0) {
                        className += " negative";
                    }
                    if (format.indexOf("$0") >= 0) {
                        props.value = (0, _numeral2.default)(number).format("(" + format + ")");
                    } else {
                        props.value = (0, _numeral2.default)(number).format(format);
                    }
                }

                if (!hasFocus && isNaN(number)) {
                    props.value = "";
                }
            } catch (e) {}

            return _react2.default.createElement("input", (0, _extends3.default)({ className: className }, props));
        }
    }, {
        key: "render",
        value: function render() {
            var _props3 = this.props,
                currentView = _props3.currentView,
                contentModel = _props3.contentModel;
            var min = contentModel.min,
                max = contentModel.max,
                decimals = contentModel.decimals,
                displayFormat = contentModel.displayFormat; // this contentModel's properties

            this.viewStore.attributes.type = "text";

            return (0, _get3.default)(NumberInputFieldComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(NumberInputFieldComponent.prototype), "render", this).call(this);
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.NumberInputFieldViewStore;
        }
    }]);
    return NumberInputFieldComponent;
}(InputFieldComponent)) || _class3;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var SliderInputFieldComponent = exports.SliderInputFieldComponent = (0, _mobxReact.observer)(_class4 = function (_InputFieldComponent3) {
    (0, _inherits3.default)(SliderInputFieldComponent, _InputFieldComponent3);

    function SliderInputFieldComponent() {
        (0, _classCallCheck3.default)(this, SliderInputFieldComponent);
        return (0, _possibleConstructorReturn3.default)(this, (SliderInputFieldComponent.__proto__ || (0, _getPrototypeOf2.default)(SliderInputFieldComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(SliderInputFieldComponent, [{
        key: "inputElement",
        value: function inputElement(props) {
            var _props$contentModel = this.props.contentModel,
                min = _props$contentModel.min,
                max = _props$contentModel.max,
                ticks = _props$contentModel.ticks;


            if (ticks > 0) {
                var range = max - min;
                var offset = Math.round(range / ticks);

                if (!range || !offset) {
                    return _react2.default.createElement("input", (0, _extends3.default)({ className: "slider" }, props));
                }

                var options = [];
                for (var counter = 0; counter <= max; counter += offset) {
                    options.push(_react2.default.createElement(
                        "option",
                        { key: counter },
                        counter
                    ));
                }
                return [_react2.default.createElement("input", (0, _extends3.default)({ key: "SliderInputFieldInput", className: "slider has-ticks", list: this.props.contentModel.id + "-TickList" }, props)), _react2.default.createElement(
                    "datalist",
                    { key: "SliderInputFieldInputDataList", id: this.props.contentModel.id + "-TickList" },
                    options
                )];
            }
            return _react2.default.createElement("input", (0, _extends3.default)({ className: "slider" }, props));
        }
    }, {
        key: "render",
        value: function render() {
            var _props4 = this.props,
                currentView = _props4.currentView,
                contentModel = _props4.contentModel;
            var min = contentModel.min,
                max = contentModel.max,
                step = contentModel.step,
                ticks = contentModel.ticks; // this contentModel's properties

            this.viewStore.attributes.type = "range";
            this.viewStore.attributes.min = min;
            this.viewStore.attributes.max = max;
            this.viewStore.attributes.step = step;

            return (0, _get3.default)(SliderInputFieldComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(SliderInputFieldComponent.prototype), "render", this).call(this);
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.SliderInputFieldViewStore;
        }
    }]);
    return SliderInputFieldComponent;
}(InputFieldComponent)) || _class4;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var CheckboxInputFieldComponent = exports.CheckboxInputFieldComponent = (0, _mobxReact.observer)(_class5 = function (_InputFieldComponent4) {
    (0, _inherits3.default)(CheckboxInputFieldComponent, _InputFieldComponent4);

    function CheckboxInputFieldComponent() {
        (0, _classCallCheck3.default)(this, CheckboxInputFieldComponent);
        return (0, _possibleConstructorReturn3.default)(this, (CheckboxInputFieldComponent.__proto__ || (0, _getPrototypeOf2.default)(CheckboxInputFieldComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(CheckboxInputFieldComponent, [{
        key: "render",
        value: function render() {
            var _props5 = this.props,
                currentView = _props5.currentView,
                contentModel = _props5.contentModel;


            this.viewStore.attributes.type = "checkbox";
            this.viewStore.attributes.checked = this.viewStore.checked;

            return (0, _get3.default)(CheckboxInputFieldComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(CheckboxInputFieldComponent.prototype), "render", this).call(this);
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.CheckboxInputFieldViewStore;
        }
    }]);
    return CheckboxInputFieldComponent;
}(InputFieldComponent)) || _class5;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var PasswordInputFieldComponent = exports.PasswordInputFieldComponent = (0, _mobxReact.observer)(_class6 = function (_InputFieldComponent5) {
    (0, _inherits3.default)(PasswordInputFieldComponent, _InputFieldComponent5);

    function PasswordInputFieldComponent() {
        (0, _classCallCheck3.default)(this, PasswordInputFieldComponent);
        return (0, _possibleConstructorReturn3.default)(this, (PasswordInputFieldComponent.__proto__ || (0, _getPrototypeOf2.default)(PasswordInputFieldComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(PasswordInputFieldComponent, [{
        key: "render",
        value: function render() {
            var _props6 = this.props,
                currentView = _props6.currentView,
                contentModel = _props6.contentModel;
            var minLength = contentModel.minLength,
                maxLength = contentModel.maxLength,
                validationRegex = contentModel.validationRegex; // this contentModel's properties

            this.viewStore.attributes.type = "password";
            if (maxLength > 0) {
                this.viewStore.attributes.maxLength = maxLength;
            }
            if (validationRegex && validationRegex.length > 0) {
                this.viewStore.attributes.pattern = validationRegex;
            }

            return (0, _get3.default)(PasswordInputFieldComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(PasswordInputFieldComponent.prototype), "render", this).call(this);
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.PasswordInputFieldViewStore;
        }
    }]);
    return PasswordInputFieldComponent;
}(InputFieldComponent)) || _class6;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var RadioInputFieldComponent = exports.RadioInputFieldComponent = (0, _mobxReact.observer)(_class7 = function (_InputFieldComponent6) {
    (0, _inherits3.default)(RadioInputFieldComponent, _InputFieldComponent6);

    function RadioInputFieldComponent() {
        (0, _classCallCheck3.default)(this, RadioInputFieldComponent);
        return (0, _possibleConstructorReturn3.default)(this, (RadioInputFieldComponent.__proto__ || (0, _getPrototypeOf2.default)(RadioInputFieldComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(RadioInputFieldComponent, [{
        key: "inputElement",
        value: function inputElement(props) {
            var _props$contentModel2 = this.props.contentModel,
                id = _props$contentModel2.id,
                options = _props$contentModel2.options;


            var value = this.viewStore.value;

            delete props.value;

            var buttons = [];
            for (var i = 0; i < options.length; ++i) {
                buttons.push(_react2.default.createElement(
                    "div",
                    { className: "radio-button", key: id + "-RadioButtonOption" + i },
                    _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: options[i].label } }),
                    " ",
                    _react2.default.createElement("input", (0, _extends3.default)({ name: id + "-RadioButtonGroup", value: options[i].value, checked: options[i].value == value }, props))
                ));
            }
            return _react2.default.createElement(
                "div",
                { className: "radio-button-group" },
                buttons
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _props7 = this.props,
                currentView = _props7.currentView,
                contentModel = _props7.contentModel;


            return (0, _get3.default)(RadioInputFieldComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(RadioInputFieldComponent.prototype), "render", this).call(this);
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.RadioInputFieldViewStore;
        }
    }]);
    return RadioInputFieldComponent;
}(InputFieldComponent)) || _class7;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var DropDownInputFieldComponent = exports.DropDownInputFieldComponent = (0, _mobxReact.observer)(_class8 = function (_InputFieldComponent7) {
    (0, _inherits3.default)(DropDownInputFieldComponent, _InputFieldComponent7);

    function DropDownInputFieldComponent() {
        (0, _classCallCheck3.default)(this, DropDownInputFieldComponent);
        return (0, _possibleConstructorReturn3.default)(this, (DropDownInputFieldComponent.__proto__ || (0, _getPrototypeOf2.default)(DropDownInputFieldComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(DropDownInputFieldComponent, [{
        key: "inputElement",
        value: function inputElement(props) {
            var _props$contentModel3 = this.props.contentModel,
                id = _props$contentModel3.id,
                options = _props$contentModel3.options,
                placeholder = _props$contentModel3.placeholder;


            var value = this.viewStore.value;

            var entries = [];
            var hasZero = false;
            for (var i = 0; i < options.length; ++i) {
                if (options[i].value == "0") {
                    hasZero = true;
                }
                entries.push(_react2.default.createElement("option", { className: "drop-down-option", key: id + "-DropDownOption" + i, value: options[i].value, dangerouslySetInnerHTML: { __html: options[i].label } }));
            }
            if (!hasZero) {
                entries.unshift(_react2.default.createElement("option", { className: "drop-down-option-placeholder", key: id + "-DropDownPlaceholder", value: null, dangerouslySetInnerHTML: { __html: placeholder }, disabled: true }));
            }
            return [_react2.default.createElement(
                "select",
                (0, _extends3.default)({ key: "select-1", className: 'drop-down' + (!hasZero && (!value || value.length == 0) ? " unselected" : "") }, props),
                entries
            ), _react2.default.createElement("div", { key: "select-2", className: "input-selector" })];
        }
    }, {
        key: "render",
        value: function render() {
            var _props8 = this.props,
                currentView = _props8.currentView,
                contentModel = _props8.contentModel;


            return (0, _get3.default)(DropDownInputFieldComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropDownInputFieldComponent.prototype), "render", this).call(this);
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.DropDownInputFieldViewStore;
        }
    }]);
    return DropDownInputFieldComponent;
}(InputFieldComponent)) || _class8;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var TextAreaInputFieldComponent = exports.TextAreaInputFieldComponent = (0, _mobxReact.observer)(_class9 = function (_InputFieldComponent8) {
    (0, _inherits3.default)(TextAreaInputFieldComponent, _InputFieldComponent8);

    function TextAreaInputFieldComponent() {
        (0, _classCallCheck3.default)(this, TextAreaInputFieldComponent);
        return (0, _possibleConstructorReturn3.default)(this, (TextAreaInputFieldComponent.__proto__ || (0, _getPrototypeOf2.default)(TextAreaInputFieldComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(TextAreaInputFieldComponent, [{
        key: "render",
        value: function render() {
            var _props9 = this.props,
                currentView = _props9.currentView,
                contentModel = _props9.contentModel;
            var minLength = contentModel.minLength,
                maxLength = contentModel.maxLength,
                validationRegex = contentModel.validationRegex; // this contentModel's properties

            this.viewStore.attributes.type = "textarea";
            if (maxLength > 0) {
                this.viewStore.attributes.maxLength = maxLength;
            }
            if (validationRegex && validationRegex.length > 0) {
                this.viewStore.attributes.pattern = validationRegex;
            }

            return (0, _get3.default)(TextAreaInputFieldComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(TextAreaInputFieldComponent.prototype), "render", this).call(this);
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.TextAreaInputFieldViewStore;
        }
    }]);
    return TextAreaInputFieldComponent;
}(InputFieldComponent)) || _class9;

;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(InputFieldComponent, "InputFieldComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");

    __REACT_HOT_LOADER__.register(TextInputFieldComponent, "TextInputFieldComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");

    __REACT_HOT_LOADER__.register(NumberInputFieldComponent, "NumberInputFieldComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");

    __REACT_HOT_LOADER__.register(SliderInputFieldComponent, "SliderInputFieldComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");

    __REACT_HOT_LOADER__.register(CheckboxInputFieldComponent, "CheckboxInputFieldComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");

    __REACT_HOT_LOADER__.register(PasswordInputFieldComponent, "PasswordInputFieldComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");

    __REACT_HOT_LOADER__.register(RadioInputFieldComponent, "RadioInputFieldComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");

    __REACT_HOT_LOADER__.register(DropDownInputFieldComponent, "DropDownInputFieldComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");

    __REACT_HOT_LOADER__.register(TextAreaInputFieldComponent, "TextAreaInputFieldComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");

    __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/component.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/inputFields/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextAreaInputFieldContentModel = exports.DropDownInputFieldContentModel = exports.DropDownInputFieldOptionContentModel = exports.RadioInputFieldContentModel = exports.RadioInputFieldOptionContentModel = exports.PasswordInputFieldContentModel = exports.CheckboxInputFieldContentModel = exports.SliderInputFieldContentModel = exports.NumberInputFieldContentModel = exports.TextInputFieldContentModel = exports.InputFieldContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _desc2, _value2, _class3, _descriptor12, _descriptor13, _descriptor14, _desc3, _value3, _class5, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _desc4, _value4, _class7, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _desc5, _value5, _class10, _descriptor23, _descriptor24, _descriptor25, _desc6, _value6, _class12, _descriptor26, _descriptor27, _dec, _desc7, _value7, _class14, _descriptor28, _desc8, _value8, _class16, _descriptor29, _descriptor30, _dec2, _desc9, _value9, _class18, _descriptor31, _desc10, _value10, _class20, _descriptor32, _descriptor33, _descriptor34, _descriptor35;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _component = __webpack_require__("./app_modules/form-control-activity/inputFields/component.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var InputFieldContentModel = exports.InputFieldContentModel = (_class = function (_BaseContentModel) {
    (0, _inherits3.default)(InputFieldContentModel, _BaseContentModel);

    function InputFieldContentModel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, InputFieldContentModel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = InputFieldContentModel.__proto__ || (0, _getPrototypeOf2.default)(InputFieldContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'label', _descriptor, _this), _initDefineProp(_this, 'value', _descriptor2, _this), _initDefineProp(_this, 'placeholder', _descriptor3, _this), _initDefineProp(_this, 'tooltip', _descriptor4, _this), _initDefineProp(_this, 'variable', _descriptor5, _this), _initDefineProp(_this, 'errorMessage', _descriptor6, _this), _initDefineProp(_this, 'disabled', _descriptor7, _this), _initDefineProp(_this, 'isReadOnly', _descriptor8, _this), _initDefineProp(_this, 'required', _descriptor9, _this), _initDefineProp(_this, 'css', _descriptor10, _this), _initDefineProp(_this, 'tabindex', _descriptor11, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(InputFieldContentModel, null, [{
        key: '_slots',
        get: function get() {
            return {
                label: "",
                value: "",
                placeholder: "",
                tooltip: "",
                variable: "",
                errorMessage: "",
                disabled: false,
                isReadOnly: false,
                required: false,
                css: "",
                tabindex: 0
            };
        }
    }, {
        key: '_defaults',
        get: function get() {
            return {
                label: "Input Field Label",
                value: "",
                placeholder: "Placeholder Text",
                tooltip: "This is a helpful tooltip",
                variable: "G:UserInputField_Sample:G",
                errorMessage: "This variable is not valid.",
                disabled: false,
                isReadOnly: false,
                required: true,
                css: "",
                tabindex: 0
            };
        }
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return InputFieldContentModel;
}(_baseContentmodel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'label', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'value', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'placeholder', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'tooltip', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'variable', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'errorMessage', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'disabled', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'isReadOnly', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'required', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'css', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'tabindex', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
})), _class);
var TextInputFieldContentModel = exports.TextInputFieldContentModel = (_class3 = function (_InputFieldContentMod) {
    (0, _inherits3.default)(TextInputFieldContentModel, _InputFieldContentMod);

    function TextInputFieldContentModel() {
        var _ref2;

        var _temp2, _this2, _ret2;

        (0, _classCallCheck3.default)(this, TextInputFieldContentModel);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = TextInputFieldContentModel.__proto__ || (0, _getPrototypeOf2.default)(TextInputFieldContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _this2.Component = _component.TextInputFieldComponent, _initDefineProp(_this2, 'minLength', _descriptor12, _this2), _initDefineProp(_this2, 'maxLength', _descriptor13, _this2), _initDefineProp(_this2, 'validationRegex', _descriptor14, _this2), _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
    }

    (0, _createClass3.default)(TextInputFieldContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._slots, {
                minLength: 0,
                maxLength: 0,
                validationRegex: ""
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._defaults, {
                minLength: 0,
                maxLength: 100,
                validationRegex: ""
            });
        }

        // define the default Component (Sim) view of this component

        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return TextInputFieldContentModel;
}(InputFieldContentModel), (_descriptor12 = _applyDecoratedDescriptor(_class3.prototype, 'minLength', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor13 = _applyDecoratedDescriptor(_class3.prototype, 'maxLength', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor14 = _applyDecoratedDescriptor(_class3.prototype, 'validationRegex', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
})), _class3);
var NumberInputFieldContentModel = exports.NumberInputFieldContentModel = (_class5 = function (_InputFieldContentMod2) {
    (0, _inherits3.default)(NumberInputFieldContentModel, _InputFieldContentMod2);

    function NumberInputFieldContentModel() {
        var _ref3;

        var _temp3, _this3, _ret3;

        (0, _classCallCheck3.default)(this, NumberInputFieldContentModel);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = NumberInputFieldContentModel.__proto__ || (0, _getPrototypeOf2.default)(NumberInputFieldContentModel)).call.apply(_ref3, [this].concat(args))), _this3), _this3.Component = _component.NumberInputFieldComponent, _initDefineProp(_this3, 'min', _descriptor15, _this3), _initDefineProp(_this3, 'max', _descriptor16, _this3), _initDefineProp(_this3, 'decimals', _descriptor17, _this3), _initDefineProp(_this3, 'displayformat', _descriptor18, _this3), _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
    }

    (0, _createClass3.default)(NumberInputFieldContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._slots, {
                min: 0,
                max: 0,
                decimals: 0,
                displayformat: ""
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._defaults, {
                min: 0,
                max: 100,
                decimals: 2,
                displayformat: "$0,0.00"
            });
        }

        // define the default Component (Sim) view of this component

        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return NumberInputFieldContentModel;
}(InputFieldContentModel), (_descriptor15 = _applyDecoratedDescriptor(_class5.prototype, 'min', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor16 = _applyDecoratedDescriptor(_class5.prototype, 'max', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor17 = _applyDecoratedDescriptor(_class5.prototype, 'decimals', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor18 = _applyDecoratedDescriptor(_class5.prototype, 'displayformat', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
})), _class5);
var SliderInputFieldContentModel = exports.SliderInputFieldContentModel = (_class7 = function (_InputFieldContentMod3) {
    (0, _inherits3.default)(SliderInputFieldContentModel, _InputFieldContentMod3);

    function SliderInputFieldContentModel() {
        var _ref4;

        var _temp4, _this4, _ret4;

        (0, _classCallCheck3.default)(this, SliderInputFieldContentModel);

        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return _ret4 = (_temp4 = (_this4 = (0, _possibleConstructorReturn3.default)(this, (_ref4 = SliderInputFieldContentModel.__proto__ || (0, _getPrototypeOf2.default)(SliderInputFieldContentModel)).call.apply(_ref4, [this].concat(args))), _this4), _this4.Component = _component.SliderInputFieldComponent, _initDefineProp(_this4, 'min', _descriptor19, _this4), _initDefineProp(_this4, 'max', _descriptor20, _this4), _initDefineProp(_this4, 'step', _descriptor21, _this4), _initDefineProp(_this4, 'ticks', _descriptor22, _this4), _temp4), (0, _possibleConstructorReturn3.default)(_this4, _ret4);
    }

    (0, _createClass3.default)(SliderInputFieldContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._slots, {
                min: 0,
                max: 0,
                step: 0,
                ticks: 0
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._defaults, {
                min: 0,
                max: 100,
                step: 0.25,
                ticks: 11
            });
        }

        // define the default Component (Sim) view of this component

        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return SliderInputFieldContentModel;
}(InputFieldContentModel), (_descriptor19 = _applyDecoratedDescriptor(_class7.prototype, 'min', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor20 = _applyDecoratedDescriptor(_class7.prototype, 'max', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 100;
    }
}), _descriptor21 = _applyDecoratedDescriptor(_class7.prototype, 'step', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 1;
    }
}), _descriptor22 = _applyDecoratedDescriptor(_class7.prototype, 'ticks', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
})), _class7);

var CheckboxInputFieldContentModel = exports.CheckboxInputFieldContentModel = function (_InputFieldContentMod4) {
    (0, _inherits3.default)(CheckboxInputFieldContentModel, _InputFieldContentMod4);

    function CheckboxInputFieldContentModel() {
        var _ref5;

        var _temp5, _this5, _ret5;

        (0, _classCallCheck3.default)(this, CheckboxInputFieldContentModel);

        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        return _ret5 = (_temp5 = (_this5 = (0, _possibleConstructorReturn3.default)(this, (_ref5 = CheckboxInputFieldContentModel.__proto__ || (0, _getPrototypeOf2.default)(CheckboxInputFieldContentModel)).call.apply(_ref5, [this].concat(args))), _this5), _this5.Component = _component.CheckboxInputFieldComponent, _temp5), (0, _possibleConstructorReturn3.default)(_this5, _ret5);
    }

    (0, _createClass3.default)(CheckboxInputFieldContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._slots);
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._defaults);
        }

        // define the default Component (Sim) view of this component

    }]);
    return CheckboxInputFieldContentModel;
}(InputFieldContentModel);

var PasswordInputFieldContentModel = exports.PasswordInputFieldContentModel = (_class10 = function (_InputFieldContentMod5) {
    (0, _inherits3.default)(PasswordInputFieldContentModel, _InputFieldContentMod5);

    function PasswordInputFieldContentModel() {
        var _ref6;

        var _temp6, _this6, _ret6;

        (0, _classCallCheck3.default)(this, PasswordInputFieldContentModel);

        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }

        return _ret6 = (_temp6 = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref6 = PasswordInputFieldContentModel.__proto__ || (0, _getPrototypeOf2.default)(PasswordInputFieldContentModel)).call.apply(_ref6, [this].concat(args))), _this6), _this6.Component = _component.PasswordInputFieldComponent, _initDefineProp(_this6, 'minLength', _descriptor23, _this6), _initDefineProp(_this6, 'maxLength', _descriptor24, _this6), _initDefineProp(_this6, 'validationRegex', _descriptor25, _this6), _temp6), (0, _possibleConstructorReturn3.default)(_this6, _ret6);
    }

    (0, _createClass3.default)(PasswordInputFieldContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._slots, {
                minLength: 0,
                maxLength: 0,
                validationRegex: ""
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._defaults, {
                minLength: 0,
                maxLength: 100,
                validationRegex: ""
            });
        }

        // define the default Component (Sim) view of this component

        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return PasswordInputFieldContentModel;
}(InputFieldContentModel), (_descriptor23 = _applyDecoratedDescriptor(_class10.prototype, 'minLength', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor24 = _applyDecoratedDescriptor(_class10.prototype, 'maxLength', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor25 = _applyDecoratedDescriptor(_class10.prototype, 'validationRegex', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
})), _class10);
var RadioInputFieldOptionContentModel = exports.RadioInputFieldOptionContentModel = (_class12 = function (_BaseContentModel2) {
    (0, _inherits3.default)(RadioInputFieldOptionContentModel, _BaseContentModel2);

    function RadioInputFieldOptionContentModel() {
        var _ref7;

        var _temp7, _this7, _ret7;

        (0, _classCallCheck3.default)(this, RadioInputFieldOptionContentModel);

        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
        }

        return _ret7 = (_temp7 = (_this7 = (0, _possibleConstructorReturn3.default)(this, (_ref7 = RadioInputFieldOptionContentModel.__proto__ || (0, _getPrototypeOf2.default)(RadioInputFieldOptionContentModel)).call.apply(_ref7, [this].concat(args))), _this7), _initDefineProp(_this7, 'value', _descriptor26, _this7), _initDefineProp(_this7, 'label', _descriptor27, _this7), _temp7), (0, _possibleConstructorReturn3.default)(_this7, _ret7);
    }

    (0, _createClass3.default)(RadioInputFieldOptionContentModel, null, [{
        key: '_slots',
        get: function get() {
            return {
                value: "",
                label: ""
            };
        }
    }, {
        key: '_defaults',
        get: function get() {
            return {
                value: "1",
                label: "Default Label"
            };
        }
        /* @slot */
        /* @slot */
    }]);
    return RadioInputFieldOptionContentModel;
}(_baseContentmodel2.default), (_descriptor26 = _applyDecoratedDescriptor(_class12.prototype, 'value', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "1";
    }
}), _descriptor27 = _applyDecoratedDescriptor(_class12.prototype, 'label', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "1";
    }
})), _class12);
var RadioInputFieldContentModel = exports.RadioInputFieldContentModel = (_dec = _mobx.observable.shallow, (_class14 = function (_InputFieldContentMod6) {
    (0, _inherits3.default)(RadioInputFieldContentModel, _InputFieldContentMod6);

    function RadioInputFieldContentModel() {
        var _ref8;

        var _temp8, _this8, _ret8;

        (0, _classCallCheck3.default)(this, RadioInputFieldContentModel);

        for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            args[_key8] = arguments[_key8];
        }

        return _ret8 = (_temp8 = (_this8 = (0, _possibleConstructorReturn3.default)(this, (_ref8 = RadioInputFieldContentModel.__proto__ || (0, _getPrototypeOf2.default)(RadioInputFieldContentModel)).call.apply(_ref8, [this].concat(args))), _this8), _this8.Component = _component.RadioInputFieldComponent, _initDefineProp(_this8, 'options', _descriptor28, _this8), _temp8), (0, _possibleConstructorReturn3.default)(_this8, _ret8);
    }

    (0, _createClass3.default)(RadioInputFieldContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._slots, {
                options: [RadioInputFieldOptionContentModel]
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._defaults, {
                options: [new RadioInputFieldOptionContentModel({ value: 1, label: "Radio Button 1" }), new RadioInputFieldOptionContentModel({ value: 2, label: "Radio Button 2" }), new RadioInputFieldOptionContentModel({ value: 3, label: "Radio Button 3" })]
            });
        }

        // define the default Component (Sim) view of this component

        /* @slot */
    }]);
    return RadioInputFieldContentModel;
}(InputFieldContentModel), (_descriptor28 = _applyDecoratedDescriptor(_class14.prototype, 'options', [_dec], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), _class14));
var DropDownInputFieldOptionContentModel = exports.DropDownInputFieldOptionContentModel = (_class16 = function (_BaseContentModel3) {
    (0, _inherits3.default)(DropDownInputFieldOptionContentModel, _BaseContentModel3);

    function DropDownInputFieldOptionContentModel() {
        var _ref9;

        var _temp9, _this9, _ret9;

        (0, _classCallCheck3.default)(this, DropDownInputFieldOptionContentModel);

        for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            args[_key9] = arguments[_key9];
        }

        return _ret9 = (_temp9 = (_this9 = (0, _possibleConstructorReturn3.default)(this, (_ref9 = DropDownInputFieldOptionContentModel.__proto__ || (0, _getPrototypeOf2.default)(DropDownInputFieldOptionContentModel)).call.apply(_ref9, [this].concat(args))), _this9), _initDefineProp(_this9, 'value', _descriptor29, _this9), _initDefineProp(_this9, 'label', _descriptor30, _this9), _temp9), (0, _possibleConstructorReturn3.default)(_this9, _ret9);
    }

    (0, _createClass3.default)(DropDownInputFieldOptionContentModel, null, [{
        key: '_slots',
        get: function get() {
            return {
                value: "",
                label: ""
            };
        }
    }, {
        key: '_defaults',
        get: function get() {
            return {
                value: "1",
                label: "Default Label"
            };
        }
        /* @slot */
        /* @slot */
    }]);
    return DropDownInputFieldOptionContentModel;
}(_baseContentmodel2.default), (_descriptor29 = _applyDecoratedDescriptor(_class16.prototype, 'value', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "1";
    }
}), _descriptor30 = _applyDecoratedDescriptor(_class16.prototype, 'label', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "Option 1";
    }
})), _class16);
var DropDownInputFieldContentModel = exports.DropDownInputFieldContentModel = (_dec2 = _mobx.observable.shallow, (_class18 = function (_InputFieldContentMod7) {
    (0, _inherits3.default)(DropDownInputFieldContentModel, _InputFieldContentMod7);

    function DropDownInputFieldContentModel() {
        var _ref10;

        var _temp10, _this10, _ret10;

        (0, _classCallCheck3.default)(this, DropDownInputFieldContentModel);

        for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            args[_key10] = arguments[_key10];
        }

        return _ret10 = (_temp10 = (_this10 = (0, _possibleConstructorReturn3.default)(this, (_ref10 = DropDownInputFieldContentModel.__proto__ || (0, _getPrototypeOf2.default)(DropDownInputFieldContentModel)).call.apply(_ref10, [this].concat(args))), _this10), _this10.Component = _component.DropDownInputFieldComponent, _initDefineProp(_this10, 'options', _descriptor31, _this10), _temp10), (0, _possibleConstructorReturn3.default)(_this10, _ret10);
    }

    (0, _createClass3.default)(DropDownInputFieldContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._slots, {
                options: [DropDownInputFieldOptionContentModel]
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._defaults, {
                options: [new DropDownInputFieldOptionContentModel({ value: 1, label: "Option 1" }), new DropDownInputFieldOptionContentModel({ value: 2, label: "Option 2" }), new DropDownInputFieldOptionContentModel({ value: 3, label: "Option 3" })]
            });
        }

        // define the default Component (Sim) view of this component

        /* @slot */
    }]);
    return DropDownInputFieldContentModel;
}(InputFieldContentModel), (_descriptor31 = _applyDecoratedDescriptor(_class18.prototype, 'options', [_dec2], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), _class18));
var TextAreaInputFieldContentModel = exports.TextAreaInputFieldContentModel = (_class20 = function (_InputFieldContentMod8) {
    (0, _inherits3.default)(TextAreaInputFieldContentModel, _InputFieldContentMod8);

    function TextAreaInputFieldContentModel() {
        var _ref11;

        var _temp11, _this11, _ret11;

        (0, _classCallCheck3.default)(this, TextAreaInputFieldContentModel);

        for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
            args[_key11] = arguments[_key11];
        }

        return _ret11 = (_temp11 = (_this11 = (0, _possibleConstructorReturn3.default)(this, (_ref11 = TextAreaInputFieldContentModel.__proto__ || (0, _getPrototypeOf2.default)(TextAreaInputFieldContentModel)).call.apply(_ref11, [this].concat(args))), _this11), _this11.Component = TextAreaInputFieldComponent, _initDefineProp(_this11, 'minLength', _descriptor32, _this11), _initDefineProp(_this11, 'maxLength', _descriptor33, _this11), _initDefineProp(_this11, 'showCounter', _descriptor34, _this11), _initDefineProp(_this11, 'validationRegex', _descriptor35, _this11), _temp11), (0, _possibleConstructorReturn3.default)(_this11, _ret11);
    }

    (0, _createClass3.default)(TextAreaInputFieldContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._slots, {
                minLength: 0,
                maxLength: 0,
                showCounter: false,
                validationRegex: ""
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, InputFieldContentModel._defaults, {
                minLength: 0,
                maxLength: 100,
                showCounter: true,
                validationRegex: ""
            });
        }

        // define the default Component (Sim) view of this component

        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return TextAreaInputFieldContentModel;
}(InputFieldContentModel), (_descriptor32 = _applyDecoratedDescriptor(_class20.prototype, 'minLength', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor33 = _applyDecoratedDescriptor(_class20.prototype, 'maxLength', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor34 = _applyDecoratedDescriptor(_class20.prototype, 'showCounter', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return true;
    }
}), _descriptor35 = _applyDecoratedDescriptor(_class20.prototype, 'validationRegex', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
})), _class20);

/*export class DateInputFieldContentModel extends InputFieldContentModel {

    static get _slots() {
        return Object.assign({}, InputFieldContentModel._slots, {
        });
    }

    static get _defaults() {
        return Object.assign({}, InputFieldContentModel._defaults, {
        });
    }
}*/

var _default = TextInputFieldContentModel;
exports.default = _default;
;

var _temp12 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(InputFieldContentModel, 'InputFieldContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(TextInputFieldContentModel, 'TextInputFieldContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(NumberInputFieldContentModel, 'NumberInputFieldContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(SliderInputFieldContentModel, 'SliderInputFieldContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(CheckboxInputFieldContentModel, 'CheckboxInputFieldContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(PasswordInputFieldContentModel, 'PasswordInputFieldContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(RadioInputFieldOptionContentModel, 'RadioInputFieldOptionContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(RadioInputFieldContentModel, 'RadioInputFieldContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(DropDownInputFieldOptionContentModel, 'DropDownInputFieldOptionContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(DropDownInputFieldContentModel, 'DropDownInputFieldContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(TextAreaInputFieldContentModel, 'TextAreaInputFieldContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/inputFields/viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextAreaInputFieldViewStore = exports.DropDownInputFieldViewStore = exports.RadioInputFieldViewStore = exports.PasswordInputFieldViewStore = exports.CheckboxInputFieldViewStore = exports.SliderInputFieldViewStore = exports.NumberInputFieldViewStore = exports.TextInputFieldViewStore = exports.InputFieldViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _dec8, _desc2, _value2, _class3, _dec9, _dec10, _desc3, _value3, _class4, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _desc4, _value4, _class5, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _desc5, _value5, _class6, _dec24, _desc6, _value6, _class7, _dec25, _dec26, _dec27, _dec28, _desc7, _value7, _class8, _dec29, _dec30, _dec31, _dec32, _desc8, _value8, _class9;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var InputFieldViewStore = exports.InputFieldViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, (_class = function (_BaseViewStore) {
    (0, _inherits3.default)(InputFieldViewStore, _BaseViewStore);

    function InputFieldViewStore(props) {
        (0, _classCallCheck3.default)(this, InputFieldViewStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InputFieldViewStore.__proto__ || (0, _getPrototypeOf2.default)(InputFieldViewStore)).call(this, props));

        _this.attributes = {
            accept: null,
            align: null,
            alt: null,
            autoComplete: null,
            autoFocus: null,
            checked: null,
            disabled: null,
            list: null,
            max: null,
            maxLength: null,
            min: null,
            name: null,
            pattern: null,
            placeholder: null,
            readOnly: null,
            required: null,
            step: null,
            type: null,
            value: null,
            tabIndex: null
        };
        _this.events = {
            onCopy: null,
            onCut: null,
            onPaste: null,
            onKeyDown: null,
            onKeyUp: null,
            onKeyPress: null,
            onFocus: null,
            onBlur: null,
            onChange: null,
            onClick: null,
            onDoubleClick: null,
            onMouseDown: null,
            onMouseEnter: null,
            onMouseLeave: null,
            onMouseOut: null,
            onMouseOver: null,
            onMouseUp: null,
            onSelect: null,
            onWheel: null,
            onScroll: null
        };

        _initDefineProp(_this, "lastValue", _descriptor, _this);

        _initDefineProp(_this, "value", _descriptor2, _this);

        _initDefineProp(_this, "valid", _descriptor3, _this);

        _initDefineProp(_this, "hasFocus", _descriptor4, _this);

        _initDefineProp(_this, "hovering", _descriptor5, _this);

        _this.waitingForHover = false;


        _this.value = _this.props.contentModel.value;
        _this.lastValue = _this.value;

        if (_this.props.form) {
            _this.props.form.controls.push(_this);
        }

        _this.validate();
        return _this;
    }

    (0, _createClass3.default)(InputFieldViewStore, [{
        key: "validate",
        value: function validate() {

            var value = this.value;
            this.valid = value !== undefined && value != "" && value != null;
        }
    }, {
        key: "onChange",
        value: function onChange(value) {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.value = value;
        }
    }, {
        key: "onFocus",
        value: function onFocus() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = true;
        }
    }, {
        key: "onBlur",
        value: function onBlur() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = false;

            this.validate();

            if (this.props.form) {
                this.props.form.update();
            }
        }
    }, {
        key: "onKeyUp",
        value: function onKeyUp(e) {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }

            if (e.key == "Enter" && this.hasFocus) {
                e.currentTarget.blur();
            }
        }

        // validation is a derivation

    }, {
        key: "save",
        value: function save() {
            this.props.contentModel.value = this.value;
        }
    }, {
        key: "update",
        value: function update() {

            if (!this.props.form || !this.props.contentModel.variable || typeof this.props.form.dbVariableStore[this.props.contentModel.variable] === 'undefined' || this.hasFocus) {
                return;
            }

            if (['NumberInputField_ExplorationField67', 'NumberInputField_ExplorationField68', 'NumberInputField_ExplorationField69'].indexOf(this.props.contentModel.id) >= 0 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR1P1:G"] != 1) {
                this.value = "";
            } else if (['NumberInputField_ExplorationField46', 'NumberInputField_ExplorationField47', 'NumberInputField_ExplorationField48'].indexOf(this.props.contentModel.id) >= 0 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR1P2:G"] != 1) {
                this.value = "";
            } else if (['NumberInputField_411', 'NumberInputField_305', 'NumberInputField_681'].indexOf(this.props.contentModel.id) >= 0 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR2P1:G"] != 1) {
                this.value = "";
            } else if (['NumberInputField_ExplorationField88', 'NumberInputField_ExplorationField89', 'NumberInputField_ExplorationField90'].indexOf(this.props.contentModel.id) >= 0 && this.props.form.dbVariableStore["G:FI_RES_RunExplorationR2P2:G"] != 1) {
                this.value = "";
            } else if (this.props.contentModel.id == "NumberInputField_ProductionField35") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_RES_UpstreamRevenue:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_UpstreamOpProfit:G"]);
            } else if (this.props.contentModel.id == "NumberInputField_54") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_RES_IncomeFromOps:G"]) / parseFloat(this.props.form.dbVariableStore["G:FI_RES_TotRevenue:G"]);
            } else if (this.props.contentModel.id == "NumberInputField_732") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR1P1:G"]) * (parseFloat(this.props.form.dbVariableStore["G:FI_DEC_PercentToDevelopLevelR1P1:G"]) * 0.02);
            } else if (this.props.contentModel.id == "NumberInputField_162") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR1P2:G"]) * (parseFloat(this.props.form.dbVariableStore["G:FI_DEC_PercentToDevelopLevelR1P2:G"]) * 0.02);
            } else if (this.props.contentModel.id == "NumberInputField_274") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR2P1:G"]) * (parseFloat(this.props.form.dbVariableStore["G:FI_DEC_PercentToDevelopLevelR2P1:G"]) * 0.02);
            } else if (this.props.contentModel.id == "NumberInputField_678") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR2P2:G"]) * (parseFloat(this.props.form.dbVariableStore["G:FI_DEC_PercentToDevelopLevelR2P2:G"]) * 0.02);
            } else if (this.props.contentModel.variable == "G:FI_RES_StartingUndevReservesR1P1:G") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR1P1:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_NewUndevReservesR1P1:G"]);
            } else if (this.props.contentModel.variable == "G:FI_RES_StartingUndevReservesR1P2:G") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR1P2:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_NewUndevReservesR1P2:G"]);
            } else if (this.props.contentModel.variable == "G:FI_RES_StartingUndevReservesR2P1:G") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR2P1:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_NewUndevReservesR2P1:G"]);
            } else if (this.props.contentModel.variable == "G:FI_RES_StartingUndevReservesR2P2:G") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_DEV_TotalUndevReservesR2P2:G"]) - parseFloat(this.props.form.dbVariableStore["G:FI_RES_NewUndevReservesR2P2:G"]);
            } else if (this.props.contentModel.variable == "G:FI_RES_AvgGlobalRefinedProdMktPrice:G") {
                this.value = parseFloat(this.props.form.dbVariableStore["G:FI_RES_AvgGlobalRefinedProdMktPrice:G"]) * 42;
            } else if (this.props.contentModel.variable == "G:FI_RES_AvgGlobalRefinedProdMktPriceR2:G") {
                var price = 2.21;
                if (window.application.dataModel.domainStore.context.team.num5 >= 2) {
                    price = 2.15;
                }
                if (window.application.dataModel.domainStore.context.team.num5 >= 3) {
                    price = 2.25;
                }
                this.value = price * 42;
            } else if (this.props.contentModel.id == "FormAccordionTop_MarketShare") {
                this.value = (this.props.form.dbVariableStore["G:FI_RES_ForecastedMktShareR1:G"] + this.props.form.dbVariableStore["G:FI_RES_ForecastedMktShareR2:G"]) / 2;
            } else {
                this.value = this.props.form.dbVariableStore[this.props.contentModel.variable];
            }

            if (this.props.contentModel.id == "NumberInputField_ExplorationField18") {
                this.props.contentModel.max = parseInt(this.props.form.dbVariableStore["G:FI_RES_TotBlocksAvailR1P1:G"]);
            } else if (this.props.contentModel.id == "NumberInputField_ExplorationField39") {
                this.props.contentModel.max = parseInt(this.props.form.dbVariableStore["G:FI_RES_TotBlocksAvailR1P2:G"]);
            } else if (this.props.contentModel.id == "NumberInputField_ExplorationField61") {
                this.props.contentModel.max = parseInt(this.props.form.dbVariableStore["G:FI_RES_TotBlocksAvailR2P1:G"]);
            } else if (this.props.contentModel.id == "NumberInputField_ExplorationField81") {
                this.props.contentModel.max = parseInt(this.props.form.dbVariableStore["G:FI_RES_TotBlocksAvailR2P2:G"]);
            }

            if (["DropDownInputField_539", "DropDownInputField_194"].indexOf(this.props.contentModel.id) >= 0) {
                var used = [];
                if (window.application.dataModel.domainStore.context.team.num5 >= 2) {
                    used.push(this.props.form.dbVariableStore["G:FI_DEC_Initiative1:1"]);
                    used.push(this.props.form.dbVariableStore["G:FI_DEC_Initiative2:1"]);
                }
                if (window.application.dataModel.domainStore.context.team.num5 >= 3) {
                    used.push(this.props.form.dbVariableStore["G:FI_DEC_Initiative1:2"]);
                    used.push(this.props.form.dbVariableStore["G:FI_DEC_Initiative2:2"]);
                }
                if (used.length >= 0) {
                    for (var u = 0; u < used.length; ++u) {
                        for (var i = 0; i < this.props.contentModel.options.length; ++i) {
                            if (this.props.contentModel.options[i].value == used[u]) {
                                this.props.contentModel.options.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
            }

            this.save();
            this.validate();
        }
    }, {
        key: "hasChanged",
        get: function get() {
            return this.props.contentModel.value != this.value;
        }
    }, {
        key: "invalid",
        get: function get() {
            var invalid = {};
            return invalid;
        }
    }]);
    return InputFieldViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "lastValue", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "value", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "valid", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasFocus", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hovering", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _applyDecoratedDescriptor(_class.prototype, "validate", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "validate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasChanged", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "hasChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onFocus", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "onFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBlur", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "onBlur"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeyUp", [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "onKeyUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "update"), _class.prototype)), _class));
var TextInputFieldViewStore = exports.TextInputFieldViewStore = (_dec8 = _mobx.action.bound, (_class3 = function (_InputFieldViewStore) {
    (0, _inherits3.default)(TextInputFieldViewStore, _InputFieldViewStore);

    function TextInputFieldViewStore() {
        (0, _classCallCheck3.default)(this, TextInputFieldViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (TextInputFieldViewStore.__proto__ || (0, _getPrototypeOf2.default)(TextInputFieldViewStore)).apply(this, arguments));
    }

    (0, _createClass3.default)(TextInputFieldViewStore, [{
        key: "validate",
        value: function validate() {
            var _props$contentModel = this.props.contentModel,
                minLength = _props$contentModel.minLength,
                maxLength = _props$contentModel.maxLength,
                validationRegex = _props$contentModel.validationRegex; // this contentModel's properties

            var value = this.value;

            try {
                this.valid = value && value.length >= minLength && value.length <= maxLength && (!validationRegex || new RegExp(validationRegex).test(value));
            } catch (err) {
                console.error("There was an error executing the regex " + validationRegex + ". " + err.message);
                debugger;
                this.valid = false;
            }
        }
    }]);
    return TextInputFieldViewStore;
}(InputFieldViewStore), (_applyDecoratedDescriptor(_class3.prototype, "validate", [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, "validate"), _class3.prototype)), _class3));
var NumberInputFieldViewStore = exports.NumberInputFieldViewStore = (_dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, (_class4 = function (_InputFieldViewStore2) {
    (0, _inherits3.default)(NumberInputFieldViewStore, _InputFieldViewStore2);

    function NumberInputFieldViewStore() {
        (0, _classCallCheck3.default)(this, NumberInputFieldViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (NumberInputFieldViewStore.__proto__ || (0, _getPrototypeOf2.default)(NumberInputFieldViewStore)).apply(this, arguments));
    }

    (0, _createClass3.default)(NumberInputFieldViewStore, [{
        key: "validate",
        value: function validate() {
            var _props$contentModel2 = this.props.contentModel,
                min = _props$contentModel2.min,
                max = _props$contentModel2.max,
                decimals = _props$contentModel2.decimals; // this contentModel's properties

            var value = this.value;

            try {
                var number = parseFloat(value);
                this.valid = !isNaN(number) && number >= min && number <= max;
            } catch (err) {
                this.valid = false;
            }
        }
    }, {
        key: "onBlur",
        value: function onBlur() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            var _props$contentModel3 = this.props.contentModel,
                min = _props$contentModel3.min,
                max = _props$contentModel3.max,
                decimals = _props$contentModel3.decimals; // this contentModel's properties

            this.hasFocus = false;

            try {
                var number = parseFloat(this.value);
                if (isNaN(number) && this.value != this.lastValue) {
                    // don't show the number, just return to the previous value;
                    this.value = this.lastValue;
                    this.onBlur();
                    return;
                }

                if (decimals <= 0) {
                    number = Math.floor(number);
                } else {
                    var ex = Math.pow(10, decimals);
                    number = Math.floor(number * ex) / ex;
                }

                this.value = number + "";

                this.validate();

                if (this.props.form) {
                    this.props.form.update();
                }

                return;
            } catch (err) {
                // there was an error, don't change the value
                this.value = this.lastValue;
            }
        }
    }]);
    return NumberInputFieldViewStore;
}(InputFieldViewStore), (_applyDecoratedDescriptor(_class4.prototype, "validate", [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, "validate"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "onBlur", [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, "onBlur"), _class4.prototype)), _class4));
var SliderInputFieldViewStore = exports.SliderInputFieldViewStore = (_dec11 = _mobx.action.bound, _dec12 = _mobx.action.bound, _dec13 = _mobx.action.bound, _dec14 = _mobx.action.bound, _dec15 = _mobx.action.bound, _dec16 = _mobx.action.bound, (_class5 = function (_InputFieldViewStore3) {
    (0, _inherits3.default)(SliderInputFieldViewStore, _InputFieldViewStore3);

    function SliderInputFieldViewStore() {
        (0, _classCallCheck3.default)(this, SliderInputFieldViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (SliderInputFieldViewStore.__proto__ || (0, _getPrototypeOf2.default)(SliderInputFieldViewStore)).apply(this, arguments));
    }

    (0, _createClass3.default)(SliderInputFieldViewStore, [{
        key: "validate",
        value: function validate() {
            var _props$contentModel4 = this.props.contentModel,
                min = _props$contentModel4.min,
                max = _props$contentModel4.max,
                step = _props$contentModel4.step; // this contentModel's properties

            var value = this.value;

            try {
                var number = parseFloat(value);
                this.valid = !isNaN(number) && number >= min && number <= max; // && (number % step == 0);
            } catch (err) {
                this.valid = false;
            }

            this.events.onMouseUp = this.onMouseUp;
            this.events.onKeyUp = this.onKeyUp;
        }
    }, {
        key: "onChange",
        value: function onChange(value) {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.value = value;

            this.validate();
        }
    }, {
        key: "onFocus",
        value: function onFocus() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = true;
        }
    }, {
        key: "onBlur",
        value: function onBlur() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = false;
        }
    }, {
        key: "onMouseUp",
        value: function onMouseUp() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }

            if (this.props.form) {
                this.props.form.update();
            }
        }
    }, {
        key: "onKeyUp",
        value: function onKeyUp() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }

            if (this.props.form) {
                this.props.form.update();
            }
        }
    }]);
    return SliderInputFieldViewStore;
}(InputFieldViewStore), (_applyDecoratedDescriptor(_class5.prototype, "validate", [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, "validate"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "onChange", [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, "onChange"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "onFocus", [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, "onFocus"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "onBlur", [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, "onBlur"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "onMouseUp", [_dec15], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, "onMouseUp"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "onKeyUp", [_dec16], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, "onKeyUp"), _class5.prototype)), _class5));
var CheckboxInputFieldViewStore = exports.CheckboxInputFieldViewStore = (_dec17 = _mobx.action.bound, _dec18 = _mobx.action.bound, _dec19 = _mobx.action.bound, _dec20 = _mobx.action.bound, _dec21 = _mobx.action.bound, _dec22 = _mobx.action.bound, _dec23 = _mobx.action.bound, (_class6 = function (_InputFieldViewStore4) {
    (0, _inherits3.default)(CheckboxInputFieldViewStore, _InputFieldViewStore4);

    function CheckboxInputFieldViewStore() {
        (0, _classCallCheck3.default)(this, CheckboxInputFieldViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (CheckboxInputFieldViewStore.__proto__ || (0, _getPrototypeOf2.default)(CheckboxInputFieldViewStore)).apply(this, arguments));
    }

    (0, _createClass3.default)(CheckboxInputFieldViewStore, [{
        key: "check",
        value: function check() {
            this.value = "1";
        }
    }, {
        key: "uncheck",
        value: function uncheck() {
            this.value = "0";
        }
    }, {
        key: "toggle",
        value: function toggle() {
            this.value = this.checked ? "0" : "1";
        }
    }, {
        key: "validate",
        value: function validate() {
            this.valid = !this.props.contentModel.required || this.checked;
        }
    }, {
        key: "onChange",
        value: function onChange(value) {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.toggle();

            this.validate();

            if (this.props.form) {
                this.props.form.update();
            }
        }
    }, {
        key: "onFocus",
        value: function onFocus() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = true;
        }
    }, {
        key: "onBlur",
        value: function onBlur() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = false;
        }
    }, {
        key: "checked",
        get: function get() {
            return this.value == "1";
        }
    }]);
    return CheckboxInputFieldViewStore;
}(InputFieldViewStore), (_applyDecoratedDescriptor(_class6.prototype, "checked", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, "checked"), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, "check", [_dec17], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, "check"), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, "uncheck", [_dec18], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, "uncheck"), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, "toggle", [_dec19], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, "toggle"), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, "validate", [_dec20], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, "validate"), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, "onChange", [_dec21], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, "onChange"), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, "onFocus", [_dec22], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, "onFocus"), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, "onBlur", [_dec23], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, "onBlur"), _class6.prototype)), _class6));
var PasswordInputFieldViewStore = exports.PasswordInputFieldViewStore = (_dec24 = _mobx.action.bound, (_class7 = function (_InputFieldViewStore5) {
    (0, _inherits3.default)(PasswordInputFieldViewStore, _InputFieldViewStore5);

    function PasswordInputFieldViewStore() {
        (0, _classCallCheck3.default)(this, PasswordInputFieldViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (PasswordInputFieldViewStore.__proto__ || (0, _getPrototypeOf2.default)(PasswordInputFieldViewStore)).apply(this, arguments));
    }

    (0, _createClass3.default)(PasswordInputFieldViewStore, [{
        key: "validate",
        value: function validate() {
            var _props$contentModel5 = this.props.contentModel,
                minLength = _props$contentModel5.minLength,
                maxLength = _props$contentModel5.maxLength,
                validationRegex = _props$contentModel5.validationRegex; // this contentModel's properties

            var value = this.value;

            try {
                this.valid = value.length >= minLength && value.length <= maxLength && (!validationRegex || new RegExp(validationRegex).test(value));
            } catch (err) {
                console.error("There was an error executing the regex " + validationRegex + ". " + err.message);
                debugger;
                this.valid = false;
            }
        }
    }]);
    return PasswordInputFieldViewStore;
}(InputFieldViewStore), (_applyDecoratedDescriptor(_class7.prototype, "validate", [_dec24], (0, _getOwnPropertyDescriptor2.default)(_class7.prototype, "validate"), _class7.prototype)), _class7));
var RadioInputFieldViewStore = exports.RadioInputFieldViewStore = (_dec25 = _mobx.action.bound, _dec26 = _mobx.action.bound, _dec27 = _mobx.action.bound, _dec28 = _mobx.action.bound, (_class8 = function (_InputFieldViewStore6) {
    (0, _inherits3.default)(RadioInputFieldViewStore, _InputFieldViewStore6);

    function RadioInputFieldViewStore() {
        (0, _classCallCheck3.default)(this, RadioInputFieldViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (RadioInputFieldViewStore.__proto__ || (0, _getPrototypeOf2.default)(RadioInputFieldViewStore)).apply(this, arguments));
    }

    (0, _createClass3.default)(RadioInputFieldViewStore, [{
        key: "validate",
        value: function validate() {
            this.valid = this.value !== undefined;
        }
    }, {
        key: "onChange",
        value: function onChange(value) {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.value = value;

            this.validate();

            if (this.props.form) {
                this.props.form.update();
            }
        }
    }, {
        key: "onFocus",
        value: function onFocus() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = true;
        }
    }, {
        key: "onBlur",
        value: function onBlur() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = false;
        }
    }]);
    return RadioInputFieldViewStore;
}(InputFieldViewStore), (_applyDecoratedDescriptor(_class8.prototype, "validate", [_dec25], (0, _getOwnPropertyDescriptor2.default)(_class8.prototype, "validate"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "onChange", [_dec26], (0, _getOwnPropertyDescriptor2.default)(_class8.prototype, "onChange"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "onFocus", [_dec27], (0, _getOwnPropertyDescriptor2.default)(_class8.prototype, "onFocus"), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, "onBlur", [_dec28], (0, _getOwnPropertyDescriptor2.default)(_class8.prototype, "onBlur"), _class8.prototype)), _class8));
var DropDownInputFieldViewStore = exports.DropDownInputFieldViewStore = (_dec29 = _mobx.action.bound, _dec30 = _mobx.action.bound, _dec31 = _mobx.action.bound, _dec32 = _mobx.action.bound, (_class9 = function (_InputFieldViewStore7) {
    (0, _inherits3.default)(DropDownInputFieldViewStore, _InputFieldViewStore7);

    function DropDownInputFieldViewStore() {
        (0, _classCallCheck3.default)(this, DropDownInputFieldViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (DropDownInputFieldViewStore.__proto__ || (0, _getPrototypeOf2.default)(DropDownInputFieldViewStore)).apply(this, arguments));
    }

    (0, _createClass3.default)(DropDownInputFieldViewStore, [{
        key: "validate",
        value: function validate() {
            var options = this.props.contentModel.options;
            this.valid = false;
            for (var i = 0; i < options.length; ++i) {
                if (options[i].value == this.value) {
                    this.valid = true;
                    break;
                }
            }
        }
    }, {
        key: "onChange",
        value: function onChange(value) {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.value = value;

            this.validate();

            if (this.props.form) {
                this.props.form.update();
            }
        }
    }, {
        key: "onFocus",
        value: function onFocus() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = true;
        }
    }, {
        key: "onBlur",
        value: function onBlur() {
            if (this.props.contentModel.isReadOnly || this.props.contentModel.disabled || this.props.form.props.contentModel.isSubmitted) {
                return;
            }
            this.hasFocus = false;
        }
    }]);
    return DropDownInputFieldViewStore;
}(InputFieldViewStore), (_applyDecoratedDescriptor(_class9.prototype, "validate", [_dec29], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, "validate"), _class9.prototype), _applyDecoratedDescriptor(_class9.prototype, "onChange", [_dec30], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, "onChange"), _class9.prototype), _applyDecoratedDescriptor(_class9.prototype, "onFocus", [_dec31], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, "onFocus"), _class9.prototype), _applyDecoratedDescriptor(_class9.prototype, "onBlur", [_dec32], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, "onBlur"), _class9.prototype)), _class9));

var TextAreaInputFieldViewStore = exports.TextAreaInputFieldViewStore = function (_InputFieldViewStore8) {
    (0, _inherits3.default)(TextAreaInputFieldViewStore, _InputFieldViewStore8);

    function TextAreaInputFieldViewStore() {
        (0, _classCallCheck3.default)(this, TextAreaInputFieldViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (TextAreaInputFieldViewStore.__proto__ || (0, _getPrototypeOf2.default)(TextAreaInputFieldViewStore)).apply(this, arguments));
    }

    return TextAreaInputFieldViewStore;
}(InputFieldViewStore);

;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(InputFieldViewStore, "InputFieldViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/viewstore.js");

    __REACT_HOT_LOADER__.register(TextInputFieldViewStore, "TextInputFieldViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/viewstore.js");

    __REACT_HOT_LOADER__.register(NumberInputFieldViewStore, "NumberInputFieldViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/viewstore.js");

    __REACT_HOT_LOADER__.register(SliderInputFieldViewStore, "SliderInputFieldViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/viewstore.js");

    __REACT_HOT_LOADER__.register(CheckboxInputFieldViewStore, "CheckboxInputFieldViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/viewstore.js");

    __REACT_HOT_LOADER__.register(PasswordInputFieldViewStore, "PasswordInputFieldViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/viewstore.js");

    __REACT_HOT_LOADER__.register(RadioInputFieldViewStore, "RadioInputFieldViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/viewstore.js");

    __REACT_HOT_LOADER__.register(DropDownInputFieldViewStore, "DropDownInputFieldViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/viewstore.js");

    __REACT_HOT_LOADER__.register(TextAreaInputFieldViewStore, "TextAreaInputFieldViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/inputFields/viewstore.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/layouts/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableLayoutComponent = exports.RowLayoutComponent = exports.ColumnsWithTitleLayoutComponent = exports.ColumnLayoutComponent = exports.SingleLayoutComponent = exports.LayoutComponent = undefined;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _class3, _class4, _class5, _class6;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _viewstore = __webpack_require__("./app_modules/form-control-activity/layouts/viewstore.js");

var _contentmodel = __webpack_require__("./app_modules/form-control-activity/layouts/contentmodel.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names


//@editable // this makes the view editable via authoring tool via data-editable
var LayoutComponent = exports.LayoutComponent = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
    (0, _inherits3.default)(LayoutComponent, _BaseComponent);

    function LayoutComponent() {
        (0, _classCallCheck3.default)(this, LayoutComponent);
        return (0, _possibleConstructorReturn3.default)(this, (LayoutComponent.__proto__ || (0, _getPrototypeOf2.default)(LayoutComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(LayoutComponent, [{
        key: "render",
        value: function render() {

            alert("Render should not be called on base LayoutComponent.");
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.LayoutViewStore;
        }
    }]);
    return LayoutComponent;
}(_baseComponent2.default)) || _class;

var _default = LayoutComponent;
exports.default = _default; //need to export top level component as "default"


//@editable // this makes the view editable via authoring tool via data-editable

// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var SingleLayoutComponent = exports.SingleLayoutComponent = (0, _mobxReact.observer)(_class2 = function (_LayoutComponent) {
    (0, _inherits3.default)(SingleLayoutComponent, _LayoutComponent);

    function SingleLayoutComponent() {
        (0, _classCallCheck3.default)(this, SingleLayoutComponent);
        return (0, _possibleConstructorReturn3.default)(this, (SingleLayoutComponent.__proto__ || (0, _getPrototypeOf2.default)(SingleLayoutComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(SingleLayoutComponent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                currentView = _props.currentView,
                contentModel = _props.contentModel,
                form = _props.form,
                lastCm = _props.lastCm,
                viewBreadcrumbs = _props.viewBreadcrumbs,
                insideEditor = _props.insideEditor;
            var includeWrapperDivs = contentModel.includeWrapperDivs,
                css = contentModel.css,
                child = contentModel.child; // this contentModel's properties

            var props = {
                currentView: { contentModel: contentModel },
                options: { contentModel: child },
                contentModel: child,
                lastCm: lastCm,
                viewBreadcrumbs: viewBreadcrumbs,
                insideEditor: insideEditor,
                form: form
            };
            var element = child && child.Component ? _react2.default.createElement(child.Component, props) : _react2.default.createElement(
                "div",
                null,
                "No Child Provided"
            );

            if (includeWrapperDivs) {
                return _react2.default.createElement(
                    "div",
                    { className: "layout single " + css },
                    element
                );
            } else {
                return { element: element };
            }
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.SingleLayoutViewStore;
        }
    }]);
    return SingleLayoutComponent;
}(LayoutComponent)) || _class2;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var ColumnLayoutComponent = exports.ColumnLayoutComponent = (0, _mobxReact.observer)(_class3 = function (_LayoutComponent2) {
    (0, _inherits3.default)(ColumnLayoutComponent, _LayoutComponent2);

    function ColumnLayoutComponent() {
        (0, _classCallCheck3.default)(this, ColumnLayoutComponent);
        return (0, _possibleConstructorReturn3.default)(this, (ColumnLayoutComponent.__proto__ || (0, _getPrototypeOf2.default)(ColumnLayoutComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(ColumnLayoutComponent, [{
        key: "render",
        value: function render() {
            var _props2 = this.props,
                currentView = _props2.currentView,
                contentModel = _props2.contentModel,
                form = _props2.form,
                lastCm = _props2.lastCm,
                viewBreadcrumbs = _props2.viewBreadcrumbs,
                insideEditor = _props2.insideEditor;
            var includeWrapperDivs = contentModel.includeWrapperDivs,
                css = contentModel.css,
                children = contentModel.children; // this contentModel's properties

            var elements = [];
            for (var i = 0; i < children.length; ++i) {
                var props = {
                    currentView: { contentModel: contentModel },
                    options: { contentModel: children[i] },
                    contentModel: children[i],
                    lastCm: lastCm,
                    viewBreadcrumbs: viewBreadcrumbs,
                    insideEditor: insideEditor,
                    form: form,
                    key: i
                };
                if (includeWrapperDivs) {
                    elements.push(_react2.default.createElement(
                        "div",
                        { className: "column", key: "column-" + i },
                        _react2.default.createElement(children[i].Component, props)
                    ));
                } else {
                    elements.push(_react2.default.createElement(children[i].Component, props));
                }
            }

            return _react2.default.createElement(
                "div",
                { className: "layout columns " + css },
                elements
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.ColumnLayoutViewStore;
        }
    }]);
    return ColumnLayoutComponent;
}(LayoutComponent)) || _class3;
//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var ColumnsWithTitleLayoutComponent = exports.ColumnsWithTitleLayoutComponent = (0, _mobxReact.observer)(_class4 = function (_LayoutComponent3) {
    (0, _inherits3.default)(ColumnsWithTitleLayoutComponent, _LayoutComponent3);

    function ColumnsWithTitleLayoutComponent() {
        (0, _classCallCheck3.default)(this, ColumnsWithTitleLayoutComponent);
        return (0, _possibleConstructorReturn3.default)(this, (ColumnsWithTitleLayoutComponent.__proto__ || (0, _getPrototypeOf2.default)(ColumnsWithTitleLayoutComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(ColumnsWithTitleLayoutComponent, [{
        key: "render",
        value: function render() {
            var _props3 = this.props,
                currentView = _props3.currentView,
                contentModel = _props3.contentModel,
                form = _props3.form,
                lastCm = _props3.lastCm,
                viewBreadcrumbs = _props3.viewBreadcrumbs,
                insideEditor = _props3.insideEditor;
            var includeWrapperDivs = contentModel.includeWrapperDivs,
                css = contentModel.css,
                title = contentModel.title,
                children = contentModel.children; // this contentModel's properties

            var elements = [];
            for (var i = 0; i < children.length; ++i) {
                var props = {
                    currentView: { contentModel: contentModel },
                    options: { contentModel: children[i] },
                    contentModel: children[i],
                    lastCm: lastCm,
                    viewBreadcrumbs: viewBreadcrumbs,
                    insideEditor: insideEditor,
                    form: form,
                    key: i
                };
                if (includeWrapperDivs) {
                    elements.push(_react2.default.createElement(
                        "div",
                        { className: "column", key: "column-" + i },
                        _react2.default.createElement(children[i].Component, props)
                    ));
                } else {
                    elements.push(_react2.default.createElement(children[i].Component, props));
                }
            }

            return _react2.default.createElement(
                "div",
                { className: "layout rows " + css },
                _react2.default.createElement("div", { className: "row layout-columns-title", dangerouslySetInnerHTML: { __html: title } }),
                _react2.default.createElement(
                    "div",
                    { className: "row" },
                    _react2.default.createElement(
                        "div",
                        { className: "layout columns " + css },
                        elements
                    )
                )
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.ColumnsWithTitleLayoutViewStore;
        }
    }]);
    return ColumnsWithTitleLayoutComponent;
}(LayoutComponent)) || _class4;
//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var RowLayoutComponent = exports.RowLayoutComponent = (0, _mobxReact.observer)(_class5 = function (_LayoutComponent4) {
    (0, _inherits3.default)(RowLayoutComponent, _LayoutComponent4);

    function RowLayoutComponent() {
        (0, _classCallCheck3.default)(this, RowLayoutComponent);
        return (0, _possibleConstructorReturn3.default)(this, (RowLayoutComponent.__proto__ || (0, _getPrototypeOf2.default)(RowLayoutComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(RowLayoutComponent, [{
        key: "render",
        value: function render() {
            var _props4 = this.props,
                currentView = _props4.currentView,
                contentModel = _props4.contentModel,
                form = _props4.form,
                lastCm = _props4.lastCm,
                viewBreadcrumbs = _props4.viewBreadcrumbs,
                insideEditor = _props4.insideEditor;
            var includeWrapperDivs = contentModel.includeWrapperDivs,
                css = contentModel.css,
                children = contentModel.children; // this contentModel's properties

            var elements = [];
            for (var i = 0; i < children.length; ++i) {
                var props = {
                    currentView: { contentModel: contentModel },
                    options: { contentModel: children[i] },
                    contentModel: children[i],
                    lastCm: lastCm,
                    viewBreadcrumbs: viewBreadcrumbs,
                    insideEditor: insideEditor,
                    form: form,
                    key: i
                };
                if (includeWrapperDivs) {
                    elements.push(_react2.default.createElement(
                        "div",
                        { className: "row", key: "row-" + i },
                        _react2.default.createElement(children[i].Component, props)
                    ));
                } else {
                    elements.push(_react2.default.createElement(children[i].Component, props));
                }
            }

            return _react2.default.createElement(
                "div",
                { className: "layout rows " + css },
                elements
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.RowsLayoutViewStore;
        }
    }]);
    return RowLayoutComponent;
}(LayoutComponent)) || _class5;
//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var TableLayoutComponent = exports.TableLayoutComponent = (0, _mobxReact.observer)(_class6 = function (_LayoutComponent5) {
    (0, _inherits3.default)(TableLayoutComponent, _LayoutComponent5);

    function TableLayoutComponent() {
        (0, _classCallCheck3.default)(this, TableLayoutComponent);
        return (0, _possibleConstructorReturn3.default)(this, (TableLayoutComponent.__proto__ || (0, _getPrototypeOf2.default)(TableLayoutComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(TableLayoutComponent, [{
        key: "render",
        value: function render() {
            var _props5 = this.props,
                currentView = _props5.currentView,
                contentModel = _props5.contentModel,
                form = _props5.form,
                lastCm = _props5.lastCm,
                viewBreadcrumbs = _props5.viewBreadcrumbs,
                insideEditor = _props5.insideEditor;
            var css = contentModel.css,
                rows = contentModel.rows,
                columns = contentModel.columns,
                children = contentModel.children; // this contentModel's properties

            var elements = [];
            var rowElements = [];
            var currentRow = 0;
            for (var i = 0; i < rows * columns; ++i) {
                var row = Math.floor(i / columns);
                var column = i % columns;

                var cell = null;
                if (i < children.length) {
                    var props = {
                        currentView: { contentModel: contentModel },
                        options: { contentModel: children[i] },
                        contentModel: children[i],
                        lastCm: lastCm,
                        viewBreadcrumbs: viewBreadcrumbs,
                        insideEditor: insideEditor,
                        form: form,
                        key: i
                    };
                    cell = _react2.default.createElement(
                        "div",
                        { className: "cell", key: "cell-" + i },
                        _react2.default.createElement(children[i].Component, props)
                    );
                } else {
                    cell = _react2.default.createElement("div", { className: "cell", key: "cell-" + i });
                }

                if (row != currentRow) {
                    elements.push(_react2.default.createElement(
                        "div",
                        { className: "row", key: "row-" + currentRow },
                        rowElements
                    ));
                    currentRow = row;
                    rowElements = [];
                }

                rowElements.push(cell);
            }
            elements.push(_react2.default.createElement(
                "div",
                { className: "row", key: "row-" + currentRow },
                rowElements
            ));
            currentRow = row;
            rowElements = [];

            return _react2.default.createElement(
                "div",
                { className: "layout table " + css },
                elements
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.TableLayoutViewStore;
        }
    }]);
    return TableLayoutComponent;
}(LayoutComponent)) || _class6;

;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(LayoutComponent, "LayoutComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/component.js");

    __REACT_HOT_LOADER__.register(SingleLayoutComponent, "SingleLayoutComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/component.js");

    __REACT_HOT_LOADER__.register(ColumnLayoutComponent, "ColumnLayoutComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/component.js");

    __REACT_HOT_LOADER__.register(ColumnsWithTitleLayoutComponent, "ColumnsWithTitleLayoutComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/component.js");

    __REACT_HOT_LOADER__.register(RowLayoutComponent, "RowLayoutComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/component.js");

    __REACT_HOT_LOADER__.register(TableLayoutComponent, "TableLayoutComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/component.js");

    __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/component.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/layouts/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableLayoutContentModel = exports.RowLayoutContentModel = exports.ColumnsWithTitleLayoutContentModel = exports.ColumnLayoutContentModel = exports.SingleLayoutContentModel = exports.LayoutContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _desc2, _value2, _class3, _descriptor3, _dec, _desc3, _value3, _class5, _descriptor4, _dec2, _desc4, _value4, _class7, _descriptor5, _descriptor6, _dec3, _desc5, _value5, _class9, _descriptor7, _dec4, _desc6, _value6, _class11, _descriptor8, _descriptor9, _descriptor10;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _component = __webpack_require__("./app_modules/form-control-activity/layouts/component.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var LayoutContentModel = exports.LayoutContentModel = (_class = function (_BaseContentModel) {
    (0, _inherits3.default)(LayoutContentModel, _BaseContentModel);

    function LayoutContentModel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LayoutContentModel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LayoutContentModel.__proto__ || (0, _getPrototypeOf2.default)(LayoutContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.Component = _component.LayoutComponent, _initDefineProp(_this, 'includeWrapperDivs', _descriptor, _this), _initDefineProp(_this, 'css', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(LayoutContentModel, null, [{
        key: '_slots',
        get: function get() {
            return {
                includeWrapperDivs: true,
                css: ""
            };
        }
    }, {
        key: '_defaults',
        get: function get() {
            return {
                includeWrapperDivs: true,
                css: ""
            };
        }
        /* @slot */
        /* @slot */
    }]);
    return LayoutContentModel;
}(_baseContentmodel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'includeWrapperDivs', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return true;
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'css', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
})), _class);
var SingleLayoutContentModel = exports.SingleLayoutContentModel = (_class3 = function (_LayoutContentModel) {
    (0, _inherits3.default)(SingleLayoutContentModel, _LayoutContentModel);

    function SingleLayoutContentModel() {
        var _ref2;

        var _temp2, _this2, _ret2;

        (0, _classCallCheck3.default)(this, SingleLayoutContentModel);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = SingleLayoutContentModel.__proto__ || (0, _getPrototypeOf2.default)(SingleLayoutContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _this2.Component = _component.SingleLayoutComponent, _initDefineProp(_this2, 'child', _descriptor3, _this2), _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
    }

    (0, _createClass3.default)(SingleLayoutContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._slots, {
                child: _baseContentmodel2.default
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._defaults, {
                child: null
            });
        }
        /* @slot */
    }]);
    return SingleLayoutContentModel;
}(LayoutContentModel), (_descriptor3 = _applyDecoratedDescriptor(_class3.prototype, 'child', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
})), _class3);
var ColumnLayoutContentModel = exports.ColumnLayoutContentModel = (_dec = _mobx.observable.shallow, (_class5 = function (_LayoutContentModel2) {
    (0, _inherits3.default)(ColumnLayoutContentModel, _LayoutContentModel2);

    function ColumnLayoutContentModel() {
        var _ref3;

        var _temp3, _this3, _ret3;

        (0, _classCallCheck3.default)(this, ColumnLayoutContentModel);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = ColumnLayoutContentModel.__proto__ || (0, _getPrototypeOf2.default)(ColumnLayoutContentModel)).call.apply(_ref3, [this].concat(args))), _this3), _this3.Component = _component.ColumnLayoutComponent, _initDefineProp(_this3, 'children', _descriptor4, _this3), _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
    }

    (0, _createClass3.default)(ColumnLayoutContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._slots, {
                children: [_baseContentmodel2.default]
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._defaults, {
                children: null
            });
        }
        /* @slot */
    }]);
    return ColumnLayoutContentModel;
}(LayoutContentModel), (_descriptor4 = _applyDecoratedDescriptor(_class5.prototype, 'children', [_dec], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), _class5));
var ColumnsWithTitleLayoutContentModel = exports.ColumnsWithTitleLayoutContentModel = (_dec2 = _mobx.observable.shallow, (_class7 = function (_LayoutContentModel3) {
    (0, _inherits3.default)(ColumnsWithTitleLayoutContentModel, _LayoutContentModel3);

    function ColumnsWithTitleLayoutContentModel() {
        var _ref4;

        var _temp4, _this4, _ret4;

        (0, _classCallCheck3.default)(this, ColumnsWithTitleLayoutContentModel);

        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return _ret4 = (_temp4 = (_this4 = (0, _possibleConstructorReturn3.default)(this, (_ref4 = ColumnsWithTitleLayoutContentModel.__proto__ || (0, _getPrototypeOf2.default)(ColumnsWithTitleLayoutContentModel)).call.apply(_ref4, [this].concat(args))), _this4), _this4.Component = _component.ColumnsWithTitleLayoutComponent, _initDefineProp(_this4, 'title', _descriptor5, _this4), _initDefineProp(_this4, 'children', _descriptor6, _this4), _temp4), (0, _possibleConstructorReturn3.default)(_this4, _ret4);
    }

    (0, _createClass3.default)(ColumnsWithTitleLayoutContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._slots, {
                title: "",
                children: [_baseContentmodel2.default]
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._defaults, {
                title: "",
                children: null
            });
        }
        /* @slot */
        /* @slot */
    }]);
    return ColumnsWithTitleLayoutContentModel;
}(LayoutContentModel), (_descriptor5 = _applyDecoratedDescriptor(_class7.prototype, 'title', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor6 = _applyDecoratedDescriptor(_class7.prototype, 'children', [_dec2], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), _class7));
var RowLayoutContentModel = exports.RowLayoutContentModel = (_dec3 = _mobx.observable.shallow, (_class9 = function (_LayoutContentModel4) {
    (0, _inherits3.default)(RowLayoutContentModel, _LayoutContentModel4);

    function RowLayoutContentModel() {
        var _ref5;

        var _temp5, _this5, _ret5;

        (0, _classCallCheck3.default)(this, RowLayoutContentModel);

        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        return _ret5 = (_temp5 = (_this5 = (0, _possibleConstructorReturn3.default)(this, (_ref5 = RowLayoutContentModel.__proto__ || (0, _getPrototypeOf2.default)(RowLayoutContentModel)).call.apply(_ref5, [this].concat(args))), _this5), _this5.Component = _component.RowLayoutComponent, _initDefineProp(_this5, 'children', _descriptor7, _this5), _temp5), (0, _possibleConstructorReturn3.default)(_this5, _ret5);
    }

    (0, _createClass3.default)(RowLayoutContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._slots, {
                children: [_baseContentmodel2.default]
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._defaults, {
                children: null
            });
        }
        /* @slot */
    }]);
    return RowLayoutContentModel;
}(LayoutContentModel), (_descriptor7 = _applyDecoratedDescriptor(_class9.prototype, 'children', [_dec3], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), _class9));
var TableLayoutContentModel = exports.TableLayoutContentModel = (_dec4 = _mobx.observable.shallow, (_class11 = function (_LayoutContentModel5) {
    (0, _inherits3.default)(TableLayoutContentModel, _LayoutContentModel5);

    function TableLayoutContentModel() {
        var _ref6;

        var _temp6, _this6, _ret6;

        (0, _classCallCheck3.default)(this, TableLayoutContentModel);

        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }

        return _ret6 = (_temp6 = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref6 = TableLayoutContentModel.__proto__ || (0, _getPrototypeOf2.default)(TableLayoutContentModel)).call.apply(_ref6, [this].concat(args))), _this6), _this6.Component = _component.TableLayoutComponent, _initDefineProp(_this6, 'rows', _descriptor8, _this6), _initDefineProp(_this6, 'columns', _descriptor9, _this6), _initDefineProp(_this6, 'children', _descriptor10, _this6), _temp6), (0, _possibleConstructorReturn3.default)(_this6, _ret6);
    }

    (0, _createClass3.default)(TableLayoutContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._slots, {
                rows: 0,
                columns: 0,
                children: [_baseContentmodel2.default]
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, LayoutContentModel._defaults, {
                rows: 0,
                columns: 0,
                children: null
            });
        }
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return TableLayoutContentModel;
}(LayoutContentModel), (_descriptor8 = _applyDecoratedDescriptor(_class11.prototype, 'rows', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor9 = _applyDecoratedDescriptor(_class11.prototype, 'columns', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor10 = _applyDecoratedDescriptor(_class11.prototype, 'children', [_dec4], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), _class11));
var _default = LayoutContentModel;
exports.default = _default;
;

var _temp7 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(LayoutContentModel, 'LayoutContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/contentmodel.js');

    __REACT_HOT_LOADER__.register(SingleLayoutContentModel, 'SingleLayoutContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/contentmodel.js');

    __REACT_HOT_LOADER__.register(ColumnLayoutContentModel, 'ColumnLayoutContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/contentmodel.js');

    __REACT_HOT_LOADER__.register(ColumnsWithTitleLayoutContentModel, 'ColumnsWithTitleLayoutContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/contentmodel.js');

    __REACT_HOT_LOADER__.register(RowLayoutContentModel, 'RowLayoutContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/contentmodel.js');

    __REACT_HOT_LOADER__.register(TableLayoutContentModel, 'TableLayoutContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/contentmodel.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/layouts/viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableLayoutViewStore = exports.RowsLayoutViewStore = exports.ColumnsWithTitleLayoutViewStore = exports.ColumnLayoutViewStore = exports.SingleLayoutViewStore = exports.LayoutViewStore = undefined;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayoutViewStore = exports.LayoutViewStore = function (_BaseViewStore) {
  (0, _inherits3.default)(LayoutViewStore, _BaseViewStore);

  function LayoutViewStore() {
    (0, _classCallCheck3.default)(this, LayoutViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (LayoutViewStore.__proto__ || (0, _getPrototypeOf2.default)(LayoutViewStore)).apply(this, arguments));
  }

  return LayoutViewStore;
}(_baseViewstore2.default);

var SingleLayoutViewStore = exports.SingleLayoutViewStore = function (_BaseViewStore2) {
  (0, _inherits3.default)(SingleLayoutViewStore, _BaseViewStore2);

  function SingleLayoutViewStore() {
    (0, _classCallCheck3.default)(this, SingleLayoutViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (SingleLayoutViewStore.__proto__ || (0, _getPrototypeOf2.default)(SingleLayoutViewStore)).apply(this, arguments));
  }

  return SingleLayoutViewStore;
}(_baseViewstore2.default);

var ColumnLayoutViewStore = exports.ColumnLayoutViewStore = function (_BaseViewStore3) {
  (0, _inherits3.default)(ColumnLayoutViewStore, _BaseViewStore3);

  function ColumnLayoutViewStore() {
    (0, _classCallCheck3.default)(this, ColumnLayoutViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (ColumnLayoutViewStore.__proto__ || (0, _getPrototypeOf2.default)(ColumnLayoutViewStore)).apply(this, arguments));
  }

  return ColumnLayoutViewStore;
}(_baseViewstore2.default);

var ColumnsWithTitleLayoutViewStore = exports.ColumnsWithTitleLayoutViewStore = function (_BaseViewStore4) {
  (0, _inherits3.default)(ColumnsWithTitleLayoutViewStore, _BaseViewStore4);

  function ColumnsWithTitleLayoutViewStore() {
    (0, _classCallCheck3.default)(this, ColumnsWithTitleLayoutViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (ColumnsWithTitleLayoutViewStore.__proto__ || (0, _getPrototypeOf2.default)(ColumnsWithTitleLayoutViewStore)).apply(this, arguments));
  }

  return ColumnsWithTitleLayoutViewStore;
}(_baseViewstore2.default);

var RowsLayoutViewStore = exports.RowsLayoutViewStore = function (_BaseViewStore5) {
  (0, _inherits3.default)(RowsLayoutViewStore, _BaseViewStore5);

  function RowsLayoutViewStore() {
    (0, _classCallCheck3.default)(this, RowsLayoutViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (RowsLayoutViewStore.__proto__ || (0, _getPrototypeOf2.default)(RowsLayoutViewStore)).apply(this, arguments));
  }

  return RowsLayoutViewStore;
}(_baseViewstore2.default);

var TableLayoutViewStore = exports.TableLayoutViewStore = function (_BaseViewStore6) {
  (0, _inherits3.default)(TableLayoutViewStore, _BaseViewStore6);

  function TableLayoutViewStore() {
    (0, _classCallCheck3.default)(this, TableLayoutViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (TableLayoutViewStore.__proto__ || (0, _getPrototypeOf2.default)(TableLayoutViewStore)).apply(this, arguments));
  }

  return TableLayoutViewStore;
}(_baseViewstore2.default);

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LayoutViewStore, "LayoutViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/viewstore.js");

  __REACT_HOT_LOADER__.register(SingleLayoutViewStore, "SingleLayoutViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/viewstore.js");

  __REACT_HOT_LOADER__.register(ColumnLayoutViewStore, "ColumnLayoutViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/viewstore.js");

  __REACT_HOT_LOADER__.register(ColumnsWithTitleLayoutViewStore, "ColumnsWithTitleLayoutViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/viewstore.js");

  __REACT_HOT_LOADER__.register(RowsLayoutViewStore, "RowsLayoutViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/viewstore.js");

  __REACT_HOT_LOADER__.register(TableLayoutViewStore, "TableLayoutViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/layouts/viewstore.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/progress/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgressBarComponent = undefined;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _viewstore = __webpack_require__("./app_modules/form-control-activity/progress/viewstore.js");

var _contentmodel = __webpack_require__("./app_modules/form-control-activity/progress/contentmodel.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names


//@editable // this makes the view editable via authoring tool via data-editable
var ProgressBarComponent = exports.ProgressBarComponent = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
    (0, _inherits3.default)(ProgressBarComponent, _BaseComponent);

    function ProgressBarComponent() {
        (0, _classCallCheck3.default)(this, ProgressBarComponent);
        return (0, _possibleConstructorReturn3.default)(this, (ProgressBarComponent.__proto__ || (0, _getPrototypeOf2.default)(ProgressBarComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(ProgressBarComponent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                currentView = _props.currentView,
                contentModel = _props.contentModel;
            var label = contentModel.label,
                css = contentModel.css; // this contentModel's properties

            var width = this.viewStore.value * 100 + "%";
            return _react2.default.createElement(
                "div",
                { className: "progress-bar " + css },
                _react2.default.createElement(
                    "div",
                    { className: "progress-bar-container" },
                    _react2.default.createElement("div", { className: "progress-bar-bar", style: { width: width } })
                ),
                _react2.default.createElement("span", { className: "progress-bar-label", dangerouslySetInnerHTML: { __html: label } })
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.ProgressBarViewStore;
        }
    }]);
    return ProgressBarComponent;
}(_baseComponent2.default)) || _class;

var _default = ProgressBarComponent;
exports.default = _default; //need to export top level component as "default"

;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ProgressBarComponent, "ProgressBarComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/progress/component.js");

    __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/progress/component.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/progress/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgressBarContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _component = __webpack_require__("./app_modules/form-control-activity/progress/component.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ProgressBarContentModel = exports.ProgressBarContentModel = (_class = function (_BaseContentModel) {
    (0, _inherits3.default)(ProgressBarContentModel, _BaseContentModel);

    function ProgressBarContentModel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ProgressBarContentModel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProgressBarContentModel.__proto__ || (0, _getPrototypeOf2.default)(ProgressBarContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.Component = _component.ProgressBarComponent, _initDefineProp(_this, 'label', _descriptor, _this), _initDefineProp(_this, 'value', _descriptor2, _this), _initDefineProp(_this, 'variable', _descriptor3, _this), _initDefineProp(_this, 'css', _descriptor4, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ProgressBarContentModel, null, [{
        key: '_slots',
        get: function get() {
            return {
                label: "",
                value: "",
                variable: "",
                css: ""
            };
        }
    }, {
        key: '_defaults',
        get: function get() {
            return {
                label: "Input Field Label",
                value: "G:UserInputField_Sample:G",
                variable: "",
                css: ""
            };
        }
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return ProgressBarContentModel;
}(_baseContentmodel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'label', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'value', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'variable', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'css', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
})), _class);
var _default = ProgressBarContentModel;
exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ProgressBarContentModel, 'ProgressBarContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/progress/contentmodel.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/progress/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/progress/viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgressBarViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _desc, _value, _class, _descriptor;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _numeral = __webpack_require__("./node_modules/numeral/numeral.js");

var _numeral2 = _interopRequireDefault(_numeral);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ProgressBarViewStore = exports.ProgressBarViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, (_class = function (_BaseViewStore) {
    (0, _inherits3.default)(ProgressBarViewStore, _BaseViewStore);

    function ProgressBarViewStore(props) {
        (0, _classCallCheck3.default)(this, ProgressBarViewStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ProgressBarViewStore.__proto__ || (0, _getPrototypeOf2.default)(ProgressBarViewStore)).call(this, props));

        _initDefineProp(_this, "value", _descriptor, _this);

        if (_this.props.form) {
            _this.props.form.controls.push(_this);
        }

        _this.update();
        return _this;
    }

    // validation is a derivation


    (0, _createClass3.default)(ProgressBarViewStore, [{
        key: "save",
        value: function save() {}
    }, {
        key: "update",
        value: function update() {

            var val = this.props.contentModel.value;
            if (this.props.form && this.props.contentModel.variable && typeof this.props.form.dbVariableStore[this.props.contentModel.variable] !== 'undefined') {
                val = this.props.form.dbVariableStore[this.props.contentModel.variable];
            }

            try {
                val = (0, _numeral2.default)(val).value();
                if (isNaN(val)) {
                    val = 0;
                } else if (val < 0) {
                    val = 0;
                } else if (val > 1) {
                    val = val / 100;
                }
            } catch (e) {
                val = 0;
            }
            if (val > 1) {
                val = 1;
            }
            this.value = val;
        }
    }, {
        key: "invalid",
        get: function get() {
            var invalid = {};
            return invalid;
        }
    }]);
    return ProgressBarViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "value", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "update"), _class.prototype)), _class));
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ProgressBarViewStore, "ProgressBarViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/progress/viewstore.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/static/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StaticImageComponent = exports.StaticTextComponent = exports.StaticComponent = undefined;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _class3;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _viewstore = __webpack_require__("./app_modules/form-control-activity/static/viewstore.js");

var _contentmodel = __webpack_require__("./app_modules/form-control-activity/static/contentmodel.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names


//@editable // this makes the view editable via authoring tool via data-editable
var StaticComponent = exports.StaticComponent = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
    (0, _inherits3.default)(StaticComponent, _BaseComponent);

    function StaticComponent() {
        (0, _classCallCheck3.default)(this, StaticComponent);
        return (0, _possibleConstructorReturn3.default)(this, (StaticComponent.__proto__ || (0, _getPrototypeOf2.default)(StaticComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(StaticComponent, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                null,
                "Not Implemented"
            );
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.StaticViewStore;
        }
    }]);
    return StaticComponent;
}(_baseComponent2.default)) || _class;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var StaticTextComponent = exports.StaticTextComponent = (0, _mobxReact.observer)(_class2 = function (_BaseComponent2) {
    (0, _inherits3.default)(StaticTextComponent, _BaseComponent2);

    function StaticTextComponent() {
        (0, _classCallCheck3.default)(this, StaticTextComponent);
        return (0, _possibleConstructorReturn3.default)(this, (StaticTextComponent.__proto__ || (0, _getPrototypeOf2.default)(StaticTextComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(StaticTextComponent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                currentView = _props.currentView,
                contentModel = _props.contentModel;
            var css = contentModel.css,
                content = contentModel.content; // this contentModel's properties

            return _react2.default.createElement("div", { className: "static-content " + css, dangerouslySetInnerHTML: { __html: content } });
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.StaticTextViewStore;
        }
    }]);
    return StaticTextComponent;
}(_baseComponent2.default)) || _class2;

//@editable // this makes the view editable via authoring tool via data-editable


// mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
var StaticImageComponent = exports.StaticImageComponent = (0, _mobxReact.observer)(_class3 = function (_BaseComponent3) {
    (0, _inherits3.default)(StaticImageComponent, _BaseComponent3);

    function StaticImageComponent() {
        (0, _classCallCheck3.default)(this, StaticImageComponent);
        return (0, _possibleConstructorReturn3.default)(this, (StaticImageComponent.__proto__ || (0, _getPrototypeOf2.default)(StaticImageComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(StaticImageComponent, [{
        key: "render",
        value: function render() {
            var _props2 = this.props,
                currentView = _props2.currentView,
                contentModel = _props2.contentModel;
            var css = contentModel.css,
                source = contentModel.source,
                alternate = contentModel.alternate,
                width = contentModel.width,
                height = contentModel.height; // this contentModel's properties

            return _react2.default.createElement("img", { className: "static-image " + css, src: source, alt: alternate, width: width, height: height });
        }
    }], [{
        key: "ViewStore",
        get: function get() {
            return _viewstore.StaticImageViewStore;
        }
    }]);
    return StaticImageComponent;
}(_baseComponent2.default)) || _class3;

var _default = StaticTextComponent;
exports.default = _default; //need to export top level component as "default"

;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(StaticComponent, "StaticComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/component.js");

    __REACT_HOT_LOADER__.register(StaticTextComponent, "StaticTextComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/component.js");

    __REACT_HOT_LOADER__.register(StaticImageComponent, "StaticImageComponent", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/component.js");

    __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/component.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/static/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StaticImageContentModel = exports.StaticTextContentModel = exports.StaticContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _desc2, _value2, _class3, _descriptor2, _desc3, _value3, _class5, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _component = __webpack_require__("./app_modules/form-control-activity/static/component.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var StaticContentModel = exports.StaticContentModel = (_class = function (_BaseContentModel) {
    (0, _inherits3.default)(StaticContentModel, _BaseContentModel);

    function StaticContentModel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StaticContentModel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StaticContentModel.__proto__ || (0, _getPrototypeOf2.default)(StaticContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'css', _descriptor, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(StaticContentModel, null, [{
        key: '_slots',
        get: function get() {
            return {
                css: ""
            };
        }
    }, {
        key: '_defaults',
        get: function get() {
            return {
                css: ""
            };
        }
        /* @slot */
    }]);
    return StaticContentModel;
}(_baseContentmodel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'css', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
})), _class);
var StaticTextContentModel = exports.StaticTextContentModel = (_class3 = function (_StaticContentModel) {
    (0, _inherits3.default)(StaticTextContentModel, _StaticContentModel);

    function StaticTextContentModel() {
        var _ref2;

        var _temp2, _this2, _ret2;

        (0, _classCallCheck3.default)(this, StaticTextContentModel);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = StaticTextContentModel.__proto__ || (0, _getPrototypeOf2.default)(StaticTextContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _this2.Component = _component.StaticTextComponent, _initDefineProp(_this2, 'content', _descriptor2, _this2), _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
    }

    (0, _createClass3.default)(StaticTextContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, StaticContentModel._slots, {
                content: "RichText"
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, StaticContentModel._defaults, {
                content: ""
            });
        }
        /* @slot */
    }]);
    return StaticTextContentModel;
}(StaticContentModel), (_descriptor2 = _applyDecoratedDescriptor(_class3.prototype, 'content', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
})), _class3);
var StaticImageContentModel = exports.StaticImageContentModel = (_class5 = function (_StaticContentModel2) {
    (0, _inherits3.default)(StaticImageContentModel, _StaticContentModel2);

    function StaticImageContentModel() {
        var _ref3;

        var _temp3, _this3, _ret3;

        (0, _classCallCheck3.default)(this, StaticImageContentModel);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = StaticImageContentModel.__proto__ || (0, _getPrototypeOf2.default)(StaticImageContentModel)).call.apply(_ref3, [this].concat(args))), _this3), _this3.Component = _component.StaticImageComponent, _initDefineProp(_this3, 'source', _descriptor3, _this3), _initDefineProp(_this3, 'alternate', _descriptor4, _this3), _initDefineProp(_this3, 'width', _descriptor5, _this3), _initDefineProp(_this3, 'height', _descriptor6, _this3), _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
    }

    (0, _createClass3.default)(StaticImageContentModel, null, [{
        key: '_slots',
        get: function get() {
            return (0, _assign2.default)({}, StaticContentModel._slots, {
                source: "",
                alternate: "",
                width: "",
                height: ""
            });
        }
    }, {
        key: '_defaults',
        get: function get() {
            return (0, _assign2.default)({}, StaticContentModel._defaults, {
                source: "",
                alternate: "",
                width: "auto",
                height: "auto"
            });
        }
        /* @slot */
        /* @slot */
        /* @slot */
        /* @slot */
    }]);
    return StaticImageContentModel;
}(StaticContentModel), (_descriptor3 = _applyDecoratedDescriptor(_class5.prototype, 'source', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class5.prototype, 'alternate', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "";
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class5.prototype, 'width', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "auto";
    }
}), _descriptor6 = _applyDecoratedDescriptor(_class5.prototype, 'height', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "auto";
    }
})), _class5);
var _default = StaticTextContentModel;
exports.default = _default;
;

var _temp4 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(StaticContentModel, 'StaticContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/contentmodel.js');

    __REACT_HOT_LOADER__.register(StaticTextContentModel, 'StaticTextContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/contentmodel.js');

    __REACT_HOT_LOADER__.register(StaticImageContentModel, 'StaticImageContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/contentmodel.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/static/viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StaticImageViewStore = exports.StaticTextViewStore = exports.StaticViewStore = undefined;

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var StaticViewStore = exports.StaticViewStore = (_dec = _mobx.action.bound, (_class = function (_BaseViewStore) {
    (0, _inherits3.default)(StaticViewStore, _BaseViewStore);

    function StaticViewStore() {
        (0, _classCallCheck3.default)(this, StaticViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (StaticViewStore.__proto__ || (0, _getPrototypeOf2.default)(StaticViewStore)).apply(this, arguments));
    }

    (0, _createClass3.default)(StaticViewStore, [{
        key: "save",
        value: function save() {}
    }, {
        key: "invalid",
        get: function get() {
            var invalid = {};
            return invalid;
        }
    }]);
    return StaticViewStore;
}(_baseViewstore2.default), (_applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype)), _class));

var StaticTextViewStore = exports.StaticTextViewStore = function (_StaticViewStore) {
    (0, _inherits3.default)(StaticTextViewStore, _StaticViewStore);

    function StaticTextViewStore() {
        (0, _classCallCheck3.default)(this, StaticTextViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (StaticTextViewStore.__proto__ || (0, _getPrototypeOf2.default)(StaticTextViewStore)).apply(this, arguments));
    }

    return StaticTextViewStore;
}(StaticViewStore);

var StaticImageViewStore = exports.StaticImageViewStore = function (_StaticViewStore2) {
    (0, _inherits3.default)(StaticImageViewStore, _StaticViewStore2);

    function StaticImageViewStore() {
        (0, _classCallCheck3.default)(this, StaticImageViewStore);
        return (0, _possibleConstructorReturn3.default)(this, (StaticImageViewStore.__proto__ || (0, _getPrototypeOf2.default)(StaticImageViewStore)).apply(this, arguments));
    }

    return StaticImageViewStore;
}(StaticViewStore);

;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(StaticViewStore, "StaticViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/viewstore.js");

    __REACT_HOT_LOADER__.register(StaticTextViewStore, "StaticTextViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/viewstore.js");

    __REACT_HOT_LOADER__.register(StaticImageViewStore, "StaticImageViewStore", "D:/VSTS/agent/_work/24/s/app_modules/form-control-activity/static/viewstore.js");
}();

;

/***/ }),

/***/ "./app_modules/form-control-activity/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app_modules/graph-activity/package-lock.json":
/***/ (function(module, exports) {

module.exports = {"name":"graph-activity","version":"1.0.0","lockfileVersion":1,"requires":true,"dependencies":{"acorn":{"version":"5.2.1","resolved":"https://registry.npmjs.org/acorn/-/acorn-5.2.1.tgz","integrity":"sha512-jG0u7c4Ly+3QkkW18V+NRDN+4bWHdln30NL1ZL2AvFZZmQe/BfopYCtghCKKVBUSetZ4QKcyA0pY6/4Gw8Pv8w==","dev":true},"acorn-dynamic-import":{"version":"2.0.2","resolved":"https://registry.npmjs.org/acorn-dynamic-import/-/acorn-dynamic-import-2.0.2.tgz","integrity":"sha1-x1K9IQvvZ5UBtsbLf8hPj0cVjMQ=","dev":true,"requires":{"acorn":"4.0.13"},"dependencies":{"acorn":{"version":"4.0.13","resolved":"https://registry.npmjs.org/acorn/-/acorn-4.0.13.tgz","integrity":"sha1-EFSVrlNh1pe9GVyCUZLhrX8lN4c=","dev":true}}},"aggregate-error":{"version":"1.0.0","resolved":"https://registry.npmjs.org/aggregate-error/-/aggregate-error-1.0.0.tgz","integrity":"sha1-iINE2tAiCnLjr1CQYRf0h3GSX6w=","dev":true,"requires":{"clean-stack":"1.3.0","indent-string":"3.2.0"}},"ajv":{"version":"4.11.8","resolved":"https://registry.npmjs.org/ajv/-/ajv-4.11.8.tgz","integrity":"sha1-gv+wKynmYq5TvcIK8VlHcGc5xTY=","dev":true,"requires":{"co":"4.6.0","json-stable-stringify":"1.0.1"}},"ajv-keywords":{"version":"1.5.1","resolved":"https://registry.npmjs.org/ajv-keywords/-/ajv-keywords-1.5.1.tgz","integrity":"sha1-MU3QpLM2j609/NxU7eYXG4htrzw=","dev":true},"align-text":{"version":"0.1.4","resolved":"https://registry.npmjs.org/align-text/-/align-text-0.1.4.tgz","integrity":"sha1-DNkKVhCT810KmSVsIrcGlDP60Rc=","dev":true,"requires":{"kind-of":"3.2.2","longest":"1.0.1","repeat-string":"1.6.1"}},"amdefine":{"version":"1.0.1","resolved":"https://registry.npmjs.org/amdefine/-/amdefine-1.0.1.tgz","integrity":"sha1-SlKCrBZHKek2Gbz9OtFR+BfOkfU=","dev":true},"ansi-regex":{"version":"2.1.1","resolved":"https://registry.npmjs.org/ansi-regex/-/ansi-regex-2.1.1.tgz","integrity":"sha1-w7M6te42DYbg5ijwRorn7yfWVN8="},"ansi-styles":{"version":"2.2.1","resolved":"https://registry.npmjs.org/ansi-styles/-/ansi-styles-2.2.1.tgz","integrity":"sha1-tDLdM1i2NM914eRmQ2gkBTPB3b4="},"anymatch":{"version":"1.3.2","resolved":"https://registry.npmjs.org/anymatch/-/anymatch-1.3.2.tgz","integrity":"sha512-0XNayC8lTHQ2OI8aljNCN3sSx6hsr/1+rlcDAotXJR7C1oZZHCNsfpbKwMjRA3Uqb5tF1Rae2oloTr4xpq+WjA==","requires":{"micromatch":"2.3.11","normalize-path":"2.1.1"}},"app-module-path":{"version":"2.2.0","resolved":"https://registry.npmjs.org/app-module-path/-/app-module-path-2.2.0.tgz","integrity":"sha1-ZBqlXft9am8KgUHEucCqULbCTdU=","dev":true},"arr-diff":{"version":"2.0.0","resolved":"https://registry.npmjs.org/arr-diff/-/arr-diff-2.0.0.tgz","integrity":"sha1-jzuCf5Vai9ZpaX5KQlasPOrjVs8=","requires":{"arr-flatten":"1.1.0"}},"arr-flatten":{"version":"1.1.0","resolved":"https://registry.npmjs.org/arr-flatten/-/arr-flatten-1.1.0.tgz","integrity":"sha512-L3hKV5R/p5o81R7O02IGnwpDmkp6E982XhtbuwSe3O4qOtMMMtodicASA1Cny2U+aCXcNpml+m4dPsvsJ3jatg=="},"array-find-index":{"version":"1.0.2","resolved":"https://registry.npmjs.org/array-find-index/-/array-find-index-1.0.2.tgz","integrity":"sha1-3wEKoSh+Fku9pvlyOwqWoexBh6E=","dev":true},"array-union":{"version":"1.0.2","resolved":"https://registry.npmjs.org/array-union/-/array-union-1.0.2.tgz","integrity":"sha1-mjRBDk9OPaI96jdb5b5w8kd47Dk=","dev":true,"requires":{"array-uniq":"1.0.3"}},"array-uniq":{"version":"1.0.3","resolved":"https://registry.npmjs.org/array-uniq/-/array-uniq-1.0.3.tgz","integrity":"sha1-r2rId6Jcx/dOBYiUdThY39sk/bY=","dev":true},"array-unique":{"version":"0.2.1","resolved":"https://registry.npmjs.org/array-unique/-/array-unique-0.2.1.tgz","integrity":"sha1-odl8yvy8JiXMcPrc6zalDFiwGlM="},"arrify":{"version":"1.0.1","resolved":"https://registry.npmjs.org/arrify/-/arrify-1.0.1.tgz","integrity":"sha1-iYUI2iIm84DfkEcoRWhJwVAaSw0=","dev":true},"asap":{"version":"2.0.6","resolved":"https://registry.npmjs.org/asap/-/asap-2.0.6.tgz","integrity":"sha1-5QNHYR1+aQlDIIu9r+vLwvuGbUY="},"asn1.js":{"version":"4.9.2","resolved":"https://registry.npmjs.org/asn1.js/-/asn1.js-4.9.2.tgz","integrity":"sha512-b/OsSjvWEo8Pi8H0zsDd2P6Uqo2TK2pH8gNLSJtNLM2Db0v2QaAZ0pBQJXVjAn4gBuugeVDr7s63ZogpUIwWDg==","dev":true,"requires":{"bn.js":"4.11.8","inherits":"2.0.3","minimalistic-assert":"1.0.0"}},"assert":{"version":"1.4.1","resolved":"https://registry.npmjs.org/assert/-/assert-1.4.1.tgz","integrity":"sha1-mZEtWRg2tab1s0XA8H7vwI/GXZE=","dev":true,"requires":{"util":"0.10.3"}},"async":{"version":"1.5.2","resolved":"https://registry.npmjs.org/async/-/async-1.5.2.tgz","integrity":"sha1-7GphrlZIDAw8skHJVhjiCJL5Zyo=","dev":true},"async-each":{"version":"1.0.1","resolved":"https://registry.npmjs.org/async-each/-/async-each-1.0.1.tgz","integrity":"sha1-GdOGodntxufByF04iu28xW0zYC0="},"atob":{"version":"1.1.3","resolved":"https://registry.npmjs.org/atob/-/atob-1.1.3.tgz","integrity":"sha1-lfE2KbEsOlGl0hWr3OKqnzL4B3M=","dev":true},"babel-cli":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-cli/-/babel-cli-6.26.0.tgz","integrity":"sha1-UCq1SHTX24itALiHoGODzgPQAvE=","requires":{"babel-core":"6.26.0","babel-polyfill":"6.26.0","babel-register":"6.26.0","babel-runtime":"6.26.0","chokidar":"1.7.0","commander":"2.11.0","convert-source-map":"1.5.0","fs-readdir-recursive":"1.0.0","glob":"7.1.2","lodash":"4.17.4","output-file-sync":"1.1.2","path-is-absolute":"1.0.1","slash":"1.0.0","source-map":"0.5.7","v8flags":"2.1.1"}},"babel-code-frame":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-code-frame/-/babel-code-frame-6.26.0.tgz","integrity":"sha1-Y/1D99weO7fONZR9uP42mj9Yx0s=","requires":{"chalk":"1.1.3","esutils":"2.0.2","js-tokens":"3.0.2"}},"babel-core":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-core/-/babel-core-6.26.0.tgz","integrity":"sha1-rzL3izGm/O8RnIew/Y2XU/A6C7g=","requires":{"babel-code-frame":"6.26.0","babel-generator":"6.26.0","babel-helpers":"6.24.1","babel-messages":"6.23.0","babel-register":"6.26.0","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0","babylon":"6.18.0","convert-source-map":"1.5.0","debug":"2.6.9","json5":"0.5.1","lodash":"4.17.4","minimatch":"3.0.4","path-is-absolute":"1.0.1","private":"0.1.8","slash":"1.0.0","source-map":"0.5.7"}},"babel-generator":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-generator/-/babel-generator-6.26.0.tgz","integrity":"sha1-rBriAHC3n248odMmlhMFN3TyDcU=","requires":{"babel-messages":"6.23.0","babel-runtime":"6.26.0","babel-types":"6.26.0","detect-indent":"4.0.0","jsesc":"1.3.0","lodash":"4.17.4","source-map":"0.5.7","trim-right":"1.0.1"}},"babel-helper-bindify-decorators":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-bindify-decorators/-/babel-helper-bindify-decorators-6.24.1.tgz","integrity":"sha1-FMGeXxQte0fxmlJDHlKxzLxAozA=","requires":{"babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-builder-binary-assignment-operator-visitor":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-builder-binary-assignment-operator-visitor/-/babel-helper-builder-binary-assignment-operator-visitor-6.24.1.tgz","integrity":"sha1-zORReto1b0IgvK6KAsKzRvmlZmQ=","requires":{"babel-helper-explode-assignable-expression":"6.24.1","babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-helper-builder-react-jsx":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-helper-builder-react-jsx/-/babel-helper-builder-react-jsx-6.26.0.tgz","integrity":"sha1-Of+DE7dci2Xc7/HzHTg+D/KkCKA=","requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0","esutils":"2.0.2"}},"babel-helper-call-delegate":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-call-delegate/-/babel-helper-call-delegate-6.24.1.tgz","integrity":"sha1-7Oaqzdx25Bw0YfiL/Fdb0Nqi340=","requires":{"babel-helper-hoist-variables":"6.24.1","babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-define-map":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-helper-define-map/-/babel-helper-define-map-6.26.0.tgz","integrity":"sha1-pfVtq0GiX5fstJjH66ypgZ+Vvl8=","requires":{"babel-helper-function-name":"6.24.1","babel-runtime":"6.26.0","babel-types":"6.26.0","lodash":"4.17.4"}},"babel-helper-explode-assignable-expression":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-explode-assignable-expression/-/babel-helper-explode-assignable-expression-6.24.1.tgz","integrity":"sha1-8luCz33BBDPFX3BZLVdGQArCLKo=","requires":{"babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-explode-class":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-explode-class/-/babel-helper-explode-class-6.24.1.tgz","integrity":"sha1-fcKjkQ3uAHBW4eMdZAztPVTqqes=","requires":{"babel-helper-bindify-decorators":"6.24.1","babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-function-name":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-function-name/-/babel-helper-function-name-6.24.1.tgz","integrity":"sha1-00dbjAPtmCQqJbSDUasYOZ01gKk=","requires":{"babel-helper-get-function-arity":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-get-function-arity":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-get-function-arity/-/babel-helper-get-function-arity-6.24.1.tgz","integrity":"sha1-j3eCqpNAfEHTqlCQj4mwMbG2hT0=","requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-helper-hoist-variables":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-hoist-variables/-/babel-helper-hoist-variables-6.24.1.tgz","integrity":"sha1-HssnaJydJVE+rbyZFKc/VAi+enY=","requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-helper-optimise-call-expression":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-optimise-call-expression/-/babel-helper-optimise-call-expression-6.24.1.tgz","integrity":"sha1-96E0J7qfc/j0+pk8VKl4gtEkQlc=","requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-helper-regex":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-helper-regex/-/babel-helper-regex-6.26.0.tgz","integrity":"sha1-MlxZ+QL4LyS3T6zu0DY5VPZJXnI=","requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0","lodash":"4.17.4"}},"babel-helper-remap-async-to-generator":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-remap-async-to-generator/-/babel-helper-remap-async-to-generator-6.24.1.tgz","integrity":"sha1-XsWBgnrXI/7N04HxySg5BnbkVRs=","requires":{"babel-helper-function-name":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helper-replace-supers":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helper-replace-supers/-/babel-helper-replace-supers-6.24.1.tgz","integrity":"sha1-v22/5Dk40XNpohPKiov3S2qQqxo=","requires":{"babel-helper-optimise-call-expression":"6.24.1","babel-messages":"6.23.0","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-helpers":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-helpers/-/babel-helpers-6.24.1.tgz","integrity":"sha1-NHHenK7DiOXIUOWX5Yom3fN2ArI=","requires":{"babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-loader":{"version":"6.4.1","resolved":"https://registry.npmjs.org/babel-loader/-/babel-loader-6.4.1.tgz","integrity":"sha1-CzQRLVsHSKjc2/Uaz2+b1C1QuMo=","requires":{"find-cache-dir":"0.1.1","loader-utils":"0.2.17","mkdirp":"0.5.1","object-assign":"4.1.1"}},"babel-messages":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-messages/-/babel-messages-6.23.0.tgz","integrity":"sha1-8830cDhYA1sqKVHG7F7fbGLyYw4=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-check-es2015-constants":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-check-es2015-constants/-/babel-plugin-check-es2015-constants-6.22.0.tgz","integrity":"sha1-NRV7EBQm/S/9PaP3XH0ekYNbv4o=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-dynamic-import-webpack":{"version":"1.0.1","resolved":"https://registry.npmjs.org/babel-plugin-dynamic-import-webpack/-/babel-plugin-dynamic-import-webpack-1.0.1.tgz","integrity":"sha1-JsJKHByb9JGEsw1YZ1YqTL+lMNE=","requires":{"babel-plugin-syntax-dynamic-import":"6.18.0","babel-template":"6.26.0"}},"babel-plugin-resolver":{"version":"1.1.0","resolved":"https://registry.npmjs.org/babel-plugin-resolver/-/babel-plugin-resolver-1.1.0.tgz","integrity":"sha1-5nwcHVZ/uQVDTLWHy9tJ+m5t0Jk=","dev":true,"requires":{"babel-resolver":"1.1.0","lodash":"4.17.4"}},"babel-plugin-syntax-async-functions":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-async-functions/-/babel-plugin-syntax-async-functions-6.13.0.tgz","integrity":"sha1-ytnK0RkbWtY0vzCuCHI5HgZHvpU="},"babel-plugin-syntax-async-generators":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-async-generators/-/babel-plugin-syntax-async-generators-6.13.0.tgz","integrity":"sha1-a8lj67FuzLrmuStZbrfzXDQqi5o="},"babel-plugin-syntax-class-constructor-call":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-class-constructor-call/-/babel-plugin-syntax-class-constructor-call-6.18.0.tgz","integrity":"sha1-nLnTn+Q8hgC+yBRkVt3L1OGnZBY="},"babel-plugin-syntax-class-properties":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-class-properties/-/babel-plugin-syntax-class-properties-6.13.0.tgz","integrity":"sha1-1+sjt5oxf4VDlixQW4J8fWysJ94="},"babel-plugin-syntax-decorators":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-decorators/-/babel-plugin-syntax-decorators-6.13.0.tgz","integrity":"sha1-MSVjtNvePMgGzuPkFszurd0RrAs="},"babel-plugin-syntax-dynamic-import":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-dynamic-import/-/babel-plugin-syntax-dynamic-import-6.18.0.tgz","integrity":"sha1-jWomIpyDdFqZgqRBBRVyyqF5sdo="},"babel-plugin-syntax-exponentiation-operator":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-exponentiation-operator/-/babel-plugin-syntax-exponentiation-operator-6.13.0.tgz","integrity":"sha1-nufoM3KQ2pUoggGmpX9BcDF4MN4="},"babel-plugin-syntax-export-extensions":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-export-extensions/-/babel-plugin-syntax-export-extensions-6.13.0.tgz","integrity":"sha1-cKFITw+QiaToStRLrDU8lbmxJyE="},"babel-plugin-syntax-flow":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-flow/-/babel-plugin-syntax-flow-6.18.0.tgz","integrity":"sha1-TDqyCiryaqIM0lmVw5jE63AxDI0="},"babel-plugin-syntax-jsx":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-jsx/-/babel-plugin-syntax-jsx-6.18.0.tgz","integrity":"sha1-CvMqmm4Tyno/1QaeYtew9Y0NiUY="},"babel-plugin-syntax-object-rest-spread":{"version":"6.13.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-object-rest-spread/-/babel-plugin-syntax-object-rest-spread-6.13.0.tgz","integrity":"sha1-/WU28rzhODb/o6VFjEkDpZe7O/U="},"babel-plugin-syntax-trailing-function-commas":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-syntax-trailing-function-commas/-/babel-plugin-syntax-trailing-function-commas-6.22.0.tgz","integrity":"sha1-ugNgk3+NBuQBgKQ/4NVhb/9TLPM="},"babel-plugin-transform-async-generator-functions":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-async-generator-functions/-/babel-plugin-transform-async-generator-functions-6.24.1.tgz","integrity":"sha1-8FiQAUX9PpkHpt3yjaWfIVJYpds=","requires":{"babel-helper-remap-async-to-generator":"6.24.1","babel-plugin-syntax-async-generators":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-async-to-generator":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-async-to-generator/-/babel-plugin-transform-async-to-generator-6.24.1.tgz","integrity":"sha1-ZTbjeK/2yx1VF6wOQOs+n8jQh2E=","requires":{"babel-helper-remap-async-to-generator":"6.24.1","babel-plugin-syntax-async-functions":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-class-constructor-call":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-class-constructor-call/-/babel-plugin-transform-class-constructor-call-6.24.1.tgz","integrity":"sha1-gNwoVQWsBn3LjWxl4vbxGrd2Xvk=","requires":{"babel-plugin-syntax-class-constructor-call":"6.18.0","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-class-properties":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-class-properties/-/babel-plugin-transform-class-properties-6.24.1.tgz","integrity":"sha1-anl2PqYdM9NvN7YRqp3vgagbRqw=","requires":{"babel-helper-function-name":"6.24.1","babel-plugin-syntax-class-properties":"6.13.0","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-css-import-to-string":{"version":"0.0.2","resolved":"https://registry.npmjs.org/babel-plugin-transform-css-import-to-string/-/babel-plugin-transform-css-import-to-string-0.0.2.tgz","integrity":"sha1-3WjzJjrtPe7vrTpluN5Ip++88Lo=","dev":true,"requires":{"rework":"1.0.1","rework-import":"2.1.0"}},"babel-plugin-transform-decorators":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-decorators/-/babel-plugin-transform-decorators-6.24.1.tgz","integrity":"sha1-eIAT2PjGtSIr33s0Q5Df13Vp4k0=","requires":{"babel-helper-explode-class":"6.24.1","babel-plugin-syntax-decorators":"6.13.0","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-decorators-legacy":{"version":"1.3.4","resolved":"https://registry.npmjs.org/babel-plugin-transform-decorators-legacy/-/babel-plugin-transform-decorators-legacy-1.3.4.tgz","integrity":"sha1-dBtY9sW86eYCfgiC2cmU8E82aSU=","requires":{"babel-plugin-syntax-decorators":"6.13.0","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-arrow-functions":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-arrow-functions/-/babel-plugin-transform-es2015-arrow-functions-6.22.0.tgz","integrity":"sha1-RSaSy3EdX3ncf4XkQM5BufJE0iE=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-block-scoped-functions":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-block-scoped-functions/-/babel-plugin-transform-es2015-block-scoped-functions-6.22.0.tgz","integrity":"sha1-u8UbSflk1wy42OC5ToICRs46YUE=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-block-scoping":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-block-scoping/-/babel-plugin-transform-es2015-block-scoping-6.26.0.tgz","integrity":"sha1-1w9SmcEwjQXBL0Y4E7CgnnOxiV8=","requires":{"babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0","lodash":"4.17.4"}},"babel-plugin-transform-es2015-classes":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-classes/-/babel-plugin-transform-es2015-classes-6.24.1.tgz","integrity":"sha1-WkxYpQyclGHlZLSyo7+ryXolhNs=","requires":{"babel-helper-define-map":"6.26.0","babel-helper-function-name":"6.24.1","babel-helper-optimise-call-expression":"6.24.1","babel-helper-replace-supers":"6.24.1","babel-messages":"6.23.0","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-computed-properties":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-computed-properties/-/babel-plugin-transform-es2015-computed-properties-6.24.1.tgz","integrity":"sha1-b+Ko0WiV1WNPTNmZttNICjCBWbM=","requires":{"babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-destructuring":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-destructuring/-/babel-plugin-transform-es2015-destructuring-6.23.0.tgz","integrity":"sha1-mXux8auWf2gtKwh2/jWNYOdlxW0=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-duplicate-keys":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-duplicate-keys/-/babel-plugin-transform-es2015-duplicate-keys-6.24.1.tgz","integrity":"sha1-c+s9MQypaePvnskcU3QabxV2Qj4=","requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-for-of":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-for-of/-/babel-plugin-transform-es2015-for-of-6.23.0.tgz","integrity":"sha1-9HyVsrYT3x0+zC/bdXNiPHUkhpE=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-function-name":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-function-name/-/babel-plugin-transform-es2015-function-name-6.24.1.tgz","integrity":"sha1-g0yJhTvDaxrw86TF26qU/Y6sqos=","requires":{"babel-helper-function-name":"6.24.1","babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-literals":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-literals/-/babel-plugin-transform-es2015-literals-6.22.0.tgz","integrity":"sha1-T1SgLWzWbPkVKAAZox0xklN3yi4=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-modules-amd":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-modules-amd/-/babel-plugin-transform-es2015-modules-amd-6.24.1.tgz","integrity":"sha1-Oz5UAXI5hC1tGcMBHEvS8AoA0VQ=","requires":{"babel-plugin-transform-es2015-modules-commonjs":"6.26.0","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-modules-commonjs":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-modules-commonjs/-/babel-plugin-transform-es2015-modules-commonjs-6.26.0.tgz","integrity":"sha1-DYOUApt9xqvhqX7xgeAHWN0uXYo=","requires":{"babel-plugin-transform-strict-mode":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-modules-systemjs":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-modules-systemjs/-/babel-plugin-transform-es2015-modules-systemjs-6.24.1.tgz","integrity":"sha1-/4mhQrkRmpBhlfXxBuzzBdlAfSM=","requires":{"babel-helper-hoist-variables":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-modules-umd":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-modules-umd/-/babel-plugin-transform-es2015-modules-umd-6.24.1.tgz","integrity":"sha1-rJl+YoXNGO1hdq22B9YCNErThGg=","requires":{"babel-plugin-transform-es2015-modules-amd":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0"}},"babel-plugin-transform-es2015-object-super":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-object-super/-/babel-plugin-transform-es2015-object-super-6.24.1.tgz","integrity":"sha1-JM72muIcuDp/hgPa0CH1cusnj40=","requires":{"babel-helper-replace-supers":"6.24.1","babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-parameters":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-parameters/-/babel-plugin-transform-es2015-parameters-6.24.1.tgz","integrity":"sha1-V6w1GrScrxSpfNE7CfZv3wpiXys=","requires":{"babel-helper-call-delegate":"6.24.1","babel-helper-get-function-arity":"6.24.1","babel-runtime":"6.26.0","babel-template":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-shorthand-properties":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-shorthand-properties/-/babel-plugin-transform-es2015-shorthand-properties-6.24.1.tgz","integrity":"sha1-JPh11nIch2YbvZmkYi5R8U3jiqA=","requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-spread":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-spread/-/babel-plugin-transform-es2015-spread-6.22.0.tgz","integrity":"sha1-1taKmfia7cRTbIGlQujdnxdG+NE=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-sticky-regex":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-sticky-regex/-/babel-plugin-transform-es2015-sticky-regex-6.24.1.tgz","integrity":"sha1-AMHNsaynERLN8M9hJsLta0V8zbw=","requires":{"babel-helper-regex":"6.26.0","babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-plugin-transform-es2015-template-literals":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-template-literals/-/babel-plugin-transform-es2015-template-literals-6.22.0.tgz","integrity":"sha1-qEs0UPfp+PH2g51taH2oS7EjbY0=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-typeof-symbol":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-typeof-symbol/-/babel-plugin-transform-es2015-typeof-symbol-6.23.0.tgz","integrity":"sha1-3sCfHN3/lLUqxz1QXITfWdzOs3I=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-es2015-unicode-regex":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-es2015-unicode-regex/-/babel-plugin-transform-es2015-unicode-regex-6.24.1.tgz","integrity":"sha1-04sS9C6nMj9yk4fxinxa4frrNek=","requires":{"babel-helper-regex":"6.26.0","babel-runtime":"6.26.0","regexpu-core":"2.0.0"}},"babel-plugin-transform-exponentiation-operator":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-exponentiation-operator/-/babel-plugin-transform-exponentiation-operator-6.24.1.tgz","integrity":"sha1-KrDJx/MJj6SJB3cruBP+QejeOg4=","requires":{"babel-helper-builder-binary-assignment-operator-visitor":"6.24.1","babel-plugin-syntax-exponentiation-operator":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-export-extensions":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-export-extensions/-/babel-plugin-transform-export-extensions-6.22.0.tgz","integrity":"sha1-U3OLR+deghhYnuqUbLvTkQm75lM=","requires":{"babel-plugin-syntax-export-extensions":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-flow-strip-types":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-flow-strip-types/-/babel-plugin-transform-flow-strip-types-6.22.0.tgz","integrity":"sha1-hMtnKTXUNxT9wyvOhFaNh0Qc988=","requires":{"babel-plugin-syntax-flow":"6.18.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-object-rest-spread":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-object-rest-spread/-/babel-plugin-transform-object-rest-spread-6.26.0.tgz","integrity":"sha1-DzZpLVD+9rfi1LOsFHgTepY7ewY=","requires":{"babel-plugin-syntax-object-rest-spread":"6.13.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-react-display-name":{"version":"6.25.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-react-display-name/-/babel-plugin-transform-react-display-name-6.25.0.tgz","integrity":"sha1-Z+K/Hx6ck6sI25Z5LgU5K/LMKNE=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-react-jsx":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-react-jsx/-/babel-plugin-transform-react-jsx-6.24.1.tgz","integrity":"sha1-hAoCjn30YN/DotKfDA2R9jduZqM=","requires":{"babel-helper-builder-react-jsx":"6.26.0","babel-plugin-syntax-jsx":"6.18.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-react-jsx-self":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-react-jsx-self/-/babel-plugin-transform-react-jsx-self-6.22.0.tgz","integrity":"sha1-322AqdomEqEh5t3XVYvL7PBuY24=","requires":{"babel-plugin-syntax-jsx":"6.18.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-react-jsx-source":{"version":"6.22.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-react-jsx-source/-/babel-plugin-transform-react-jsx-source-6.22.0.tgz","integrity":"sha1-ZqwSFT9c0tF7PBkmj0vwGX9E7NY=","requires":{"babel-plugin-syntax-jsx":"6.18.0","babel-runtime":"6.26.0"}},"babel-plugin-transform-regenerator":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-regenerator/-/babel-plugin-transform-regenerator-6.26.0.tgz","integrity":"sha1-4HA2lvveJ/Cj78rPi03KL3s6jy8=","requires":{"regenerator-transform":"0.10.1"}},"babel-plugin-transform-require-ignore":{"version":"0.1.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-require-ignore/-/babel-plugin-transform-require-ignore-0.1.1.tgz","integrity":"sha512-A7EmlVd3ZYWJI3eg3dklAXn1yfq8Y5omHMQgAUo0FwGLYRuL5daLR6+LtCVHi4f9+fStr7HuPkW9rmKtcmY67w=="},"babel-plugin-transform-runtime":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-plugin-transform-runtime/-/babel-plugin-transform-runtime-6.23.0.tgz","integrity":"sha1-iEkNRGUC6puOfvsP4J7E2ZR5se4=","requires":{"babel-runtime":"6.26.0"}},"babel-plugin-transform-strict-mode":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-plugin-transform-strict-mode/-/babel-plugin-transform-strict-mode-6.24.1.tgz","integrity":"sha1-1fr3qleKZbvlkc9e2uBKDGcCB1g=","requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0"}},"babel-polyfill":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-polyfill/-/babel-polyfill-6.26.0.tgz","integrity":"sha1-N5k3q8Z9eJWXCtxiHyhM2WbPIVM=","requires":{"babel-runtime":"6.26.0","core-js":"2.5.1","regenerator-runtime":"0.10.5"},"dependencies":{"regenerator-runtime":{"version":"0.10.5","resolved":"https://registry.npmjs.org/regenerator-runtime/-/regenerator-runtime-0.10.5.tgz","integrity":"sha1-M2w+/BIgrc7dosn6tntaeVWjNlg="}}},"babel-preset-es2015":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-es2015/-/babel-preset-es2015-6.24.1.tgz","integrity":"sha1-1EBQ1rwsn+6nAqrzjXJ6AhBTiTk=","requires":{"babel-plugin-check-es2015-constants":"6.22.0","babel-plugin-transform-es2015-arrow-functions":"6.22.0","babel-plugin-transform-es2015-block-scoped-functions":"6.22.0","babel-plugin-transform-es2015-block-scoping":"6.26.0","babel-plugin-transform-es2015-classes":"6.24.1","babel-plugin-transform-es2015-computed-properties":"6.24.1","babel-plugin-transform-es2015-destructuring":"6.23.0","babel-plugin-transform-es2015-duplicate-keys":"6.24.1","babel-plugin-transform-es2015-for-of":"6.23.0","babel-plugin-transform-es2015-function-name":"6.24.1","babel-plugin-transform-es2015-literals":"6.22.0","babel-plugin-transform-es2015-modules-amd":"6.24.1","babel-plugin-transform-es2015-modules-commonjs":"6.26.0","babel-plugin-transform-es2015-modules-systemjs":"6.24.1","babel-plugin-transform-es2015-modules-umd":"6.24.1","babel-plugin-transform-es2015-object-super":"6.24.1","babel-plugin-transform-es2015-parameters":"6.24.1","babel-plugin-transform-es2015-shorthand-properties":"6.24.1","babel-plugin-transform-es2015-spread":"6.22.0","babel-plugin-transform-es2015-sticky-regex":"6.24.1","babel-plugin-transform-es2015-template-literals":"6.22.0","babel-plugin-transform-es2015-typeof-symbol":"6.23.0","babel-plugin-transform-es2015-unicode-regex":"6.24.1","babel-plugin-transform-regenerator":"6.26.0"}},"babel-preset-flow":{"version":"6.23.0","resolved":"https://registry.npmjs.org/babel-preset-flow/-/babel-preset-flow-6.23.0.tgz","integrity":"sha1-5xIYiHCFrpoktb5Baa/7WZgWxJ0=","requires":{"babel-plugin-transform-flow-strip-types":"6.22.0"}},"babel-preset-react":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-react/-/babel-preset-react-6.24.1.tgz","integrity":"sha1-umnfrqRfw+xjm2pOzqbhdwLJE4A=","requires":{"babel-plugin-syntax-jsx":"6.18.0","babel-plugin-transform-react-display-name":"6.25.0","babel-plugin-transform-react-jsx":"6.24.1","babel-plugin-transform-react-jsx-self":"6.22.0","babel-plugin-transform-react-jsx-source":"6.22.0","babel-preset-flow":"6.23.0"}},"babel-preset-stage-1":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-stage-1/-/babel-preset-stage-1-6.24.1.tgz","integrity":"sha1-dpLNfc1oSZB+auSgqFWJz7niv7A=","requires":{"babel-plugin-transform-class-constructor-call":"6.24.1","babel-plugin-transform-export-extensions":"6.22.0","babel-preset-stage-2":"6.24.1"}},"babel-preset-stage-2":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-stage-2/-/babel-preset-stage-2-6.24.1.tgz","integrity":"sha1-2eKWD7PXEYfw5k7sYrwHdnIZvcE=","requires":{"babel-plugin-syntax-dynamic-import":"6.18.0","babel-plugin-transform-class-properties":"6.24.1","babel-plugin-transform-decorators":"6.24.1","babel-preset-stage-3":"6.24.1"}},"babel-preset-stage-3":{"version":"6.24.1","resolved":"https://registry.npmjs.org/babel-preset-stage-3/-/babel-preset-stage-3-6.24.1.tgz","integrity":"sha1-g2raCp56f6N8sTj7kyb4eTSkg5U=","requires":{"babel-plugin-syntax-trailing-function-commas":"6.22.0","babel-plugin-transform-async-generator-functions":"6.24.1","babel-plugin-transform-async-to-generator":"6.24.1","babel-plugin-transform-exponentiation-operator":"6.24.1","babel-plugin-transform-object-rest-spread":"6.26.0"}},"babel-register":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-register/-/babel-register-6.26.0.tgz","integrity":"sha1-btAhFz4vy0htestFxgCahW9kcHE=","requires":{"babel-core":"6.26.0","babel-runtime":"6.26.0","core-js":"2.5.1","home-or-tmp":"2.0.0","lodash":"4.17.4","mkdirp":"0.5.1","source-map-support":"0.4.18"}},"babel-resolver":{"version":"1.1.0","resolved":"https://registry.npmjs.org/babel-resolver/-/babel-resolver-1.1.0.tgz","integrity":"sha1-rXBdGmc0WECDnsNqszoCOPMH/EE=","dev":true},"babel-runtime":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-runtime/-/babel-runtime-6.26.0.tgz","integrity":"sha1-llxwWGaOgrVde/4E/yM3vItWR/4=","requires":{"core-js":"2.5.1","regenerator-runtime":"0.11.0"}},"babel-template":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-template/-/babel-template-6.26.0.tgz","integrity":"sha1-3gPi0WOWsGn0bdn/+FIfsaDjXgI=","requires":{"babel-runtime":"6.26.0","babel-traverse":"6.26.0","babel-types":"6.26.0","babylon":"6.18.0","lodash":"4.17.4"}},"babel-traverse":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-traverse/-/babel-traverse-6.26.0.tgz","integrity":"sha1-RqnL1+3MYsjlwGTi0tjQ9ANXZu4=","requires":{"babel-code-frame":"6.26.0","babel-messages":"6.23.0","babel-runtime":"6.26.0","babel-types":"6.26.0","babylon":"6.18.0","debug":"2.6.9","globals":"9.18.0","invariant":"2.2.2","lodash":"4.17.4"}},"babel-types":{"version":"6.26.0","resolved":"https://registry.npmjs.org/babel-types/-/babel-types-6.26.0.tgz","integrity":"sha1-o7Bz+Uq0nrb6Vc1lInozQ4BjJJc=","requires":{"babel-runtime":"6.26.0","esutils":"2.0.2","lodash":"4.17.4","to-fast-properties":"1.0.3"}},"babylon":{"version":"6.18.0","resolved":"https://registry.npmjs.org/babylon/-/babylon-6.18.0.tgz","integrity":"sha512-q/UEjfGJ2Cm3oKV71DJz9d25TPnq5rhBVL2Q4fA5wcC3jcrdn7+SssEybFIxwAvvP+YCsCYNKughoF33GxgycQ=="},"balanced-match":{"version":"1.0.0","resolved":"https://registry.npmjs.org/balanced-match/-/balanced-match-1.0.0.tgz","integrity":"sha1-ibTRmasr7kneFk6gK4nORi1xt2c="},"base-store":{"version":"git+https://gitlab.com/regiscompany/base-store.git#f672064eda7d24e625efc81905650454b8f3bf37","dev":true,"requires":{"cloner":"git+https://github.com/cellvia/cloner.git#0d896e0d8aa875a6007971ddd34c84218d898309","deep-bind-decorator":"git+https://gitlab.com/regiscompany/deep-bind-decorator.git#1f0d4e74054afaae21ebb9685a39ac5792847de1","extend-observable-decorator":"git+https://gitlab.com/regiscompany/extend-observable-decorator.git#0b9ec0685c7e78e190d9d944803866d9c0d31986","traverse":"0.6.6"}},"base64-js":{"version":"1.2.1","resolved":"https://registry.npmjs.org/base64-js/-/base64-js-1.2.1.tgz","integrity":"sha512-dwVUVIXsBZXwTuwnXI9RK8sBmgq09NDHzyR9SAph9eqk76gKK2JSQmZARC2zRC81JC2QTtxD0ARU5qTS25gIGw==","dev":true},"big.js":{"version":"3.2.0","resolved":"https://registry.npmjs.org/big.js/-/big.js-3.2.0.tgz","integrity":"sha512-+hN/Zh2D08Mx65pZ/4g5bsmNiZUuChDiQfTUQ7qJr4/kuopCr88xZsAXv6mBoZEsUI4OuGHlX59qE94K2mMW8Q=="},"binary-extensions":{"version":"1.10.0","resolved":"https://registry.npmjs.org/binary-extensions/-/binary-extensions-1.10.0.tgz","integrity":"sha1-muuabF6IY4qtFx4Wf1kAq+JINdA="},"bn.js":{"version":"4.11.8","resolved":"https://registry.npmjs.org/bn.js/-/bn.js-4.11.8.tgz","integrity":"sha512-ItfYfPLkWHUjckQCk8xC+LwxgK8NYcXywGigJgSwOP8Y2iyWT4f2vsZnoOXTTbo+o5yXmIUJ4gn5538SO5S3gA==","dev":true},"boolbase":{"version":"1.0.0","resolved":"https://registry.npmjs.org/boolbase/-/boolbase-1.0.0.tgz","integrity":"sha1-aN/1++YMUes3cl6p4+0xDcwed24=","dev":true},"brace-expansion":{"version":"1.1.8","resolved":"https://registry.npmjs.org/brace-expansion/-/brace-expansion-1.1.8.tgz","integrity":"sha1-wHshHHyVLsH479Uad+8NHTmQopI=","requires":{"balanced-match":"1.0.0","concat-map":"0.0.1"}},"braces":{"version":"1.8.5","resolved":"https://registry.npmjs.org/braces/-/braces-1.8.5.tgz","integrity":"sha1-uneWLhLf+WnWt2cR6RS3N4V79qc=","requires":{"expand-range":"1.8.2","preserve":"0.2.0","repeat-element":"1.1.2"}},"brorand":{"version":"1.1.0","resolved":"https://registry.npmjs.org/brorand/-/brorand-1.1.0.tgz","integrity":"sha1-EsJe/kCkXjwyPrhnWgoM5XsiNx8=","dev":true},"browserify-aes":{"version":"1.1.1","resolved":"https://registry.npmjs.org/browserify-aes/-/browserify-aes-1.1.1.tgz","integrity":"sha512-UGnTYAnB2a3YuYKIRy1/4FB2HdM866E0qC46JXvVTYKlBlZlnvfpSfY6OKfXZAkv70eJ2a1SqzpAo5CRhZGDFg==","dev":true,"requires":{"buffer-xor":"1.0.3","cipher-base":"1.0.4","create-hash":"1.1.3","evp_bytestokey":"1.0.3","inherits":"2.0.3","safe-buffer":"5.1.1"}},"browserify-cipher":{"version":"1.0.0","resolved":"https://registry.npmjs.org/browserify-cipher/-/browserify-cipher-1.0.0.tgz","integrity":"sha1-mYgkSHS/XtTijalWZtzWasj8Njo=","dev":true,"requires":{"browserify-aes":"1.1.1","browserify-des":"1.0.0","evp_bytestokey":"1.0.3"}},"browserify-des":{"version":"1.0.0","resolved":"https://registry.npmjs.org/browserify-des/-/browserify-des-1.0.0.tgz","integrity":"sha1-2qJ3cXRwki7S/hhZQRihdUOXId0=","dev":true,"requires":{"cipher-base":"1.0.4","des.js":"1.0.0","inherits":"2.0.3"}},"browserify-rsa":{"version":"4.0.1","resolved":"https://registry.npmjs.org/browserify-rsa/-/browserify-rsa-4.0.1.tgz","integrity":"sha1-IeCr+vbyApzy+vsTNWenAdQTVSQ=","dev":true,"requires":{"bn.js":"4.11.8","randombytes":"2.0.5"}},"browserify-sign":{"version":"4.0.4","resolved":"https://registry.npmjs.org/browserify-sign/-/browserify-sign-4.0.4.tgz","integrity":"sha1-qk62jl17ZYuqa/alfmMMvXqT0pg=","dev":true,"requires":{"bn.js":"4.11.8","browserify-rsa":"4.0.1","create-hash":"1.1.3","create-hmac":"1.1.6","elliptic":"6.4.0","inherits":"2.0.3","parse-asn1":"5.1.0"}},"browserify-zlib":{"version":"0.1.4","resolved":"https://registry.npmjs.org/browserify-zlib/-/browserify-zlib-0.1.4.tgz","integrity":"sha1-uzX4pRn2AOD6a4SFJByXnQFB+y0=","dev":true,"requires":{"pako":"0.2.9"}},"buffer":{"version":"4.9.1","resolved":"https://registry.npmjs.org/buffer/-/buffer-4.9.1.tgz","integrity":"sha1-bRu2AbB6TvztlwlBMgkwJ8lbwpg=","dev":true,"requires":{"base64-js":"1.2.1","ieee754":"1.1.8","isarray":"1.0.0"}},"buffer-xor":{"version":"1.0.3","resolved":"https://registry.npmjs.org/buffer-xor/-/buffer-xor-1.0.3.tgz","integrity":"sha1-JuYe0UIvtw3ULm42cp7VHYVf6Nk=","dev":true},"builtin-modules":{"version":"1.1.1","resolved":"https://registry.npmjs.org/builtin-modules/-/builtin-modules-1.1.1.tgz","integrity":"sha1-Jw8HbFpywC9bZaR9+Uxf46J4iS8=","dev":true},"builtin-status-codes":{"version":"3.0.0","resolved":"https://registry.npmjs.org/builtin-status-codes/-/builtin-status-codes-3.0.0.tgz","integrity":"sha1-hZgoeOIbmOHGZCXgPQF0eI9Wnug=","dev":true},"c3":{"version":"0.4.18","resolved":"https://registry.npmjs.org/c3/-/c3-0.4.18.tgz","integrity":"sha512-37TiFeCrbe69gg7SxFpTBOLDwulnk+opKp1AFDi43mONtErpRoUIZfGSimGiSYQmNu6Zh9W2yNOx0066UikqSg==","requires":{"d3":"3.5.17"}},"camelcase":{"version":"2.1.1","resolved":"https://registry.npmjs.org/camelcase/-/camelcase-2.1.1.tgz","integrity":"sha1-fB0W1nmhu+WcoCys7PsBHiAfWh8=","dev":true},"camelcase-keys":{"version":"2.1.0","resolved":"https://registry.npmjs.org/camelcase-keys/-/camelcase-keys-2.1.0.tgz","integrity":"sha1-MIvur/3ygRkFHvodkyITyRuPkuc=","dev":true,"requires":{"camelcase":"2.1.1","map-obj":"1.0.1"}},"center-align":{"version":"0.1.3","resolved":"https://registry.npmjs.org/center-align/-/center-align-0.1.3.tgz","integrity":"sha1-qg0yYptu6XIgBBHL1EYckHvCt60=","dev":true,"requires":{"align-text":"0.1.4","lazy-cache":"1.0.4"}},"chalk":{"version":"1.1.3","resolved":"https://registry.npmjs.org/chalk/-/chalk-1.1.3.tgz","integrity":"sha1-qBFcVeSnAv5NFQq9OHKCKn4J/Jg=","requires":{"ansi-styles":"2.2.1","escape-string-regexp":"1.0.5","has-ansi":"2.0.0","strip-ansi":"3.0.1","supports-color":"2.0.0"}},"cheerio":{"version":"0.22.0","resolved":"https://registry.npmjs.org/cheerio/-/cheerio-0.22.0.tgz","integrity":"sha1-qbqoYKP5tZWmuBsahocxIe06Jp4=","dev":true,"requires":{"css-select":"1.2.0","dom-serializer":"0.1.0","entities":"1.1.1","htmlparser2":"3.9.2","lodash.assignin":"4.2.0","lodash.bind":"4.2.1","lodash.defaults":"4.2.0","lodash.filter":"4.6.0","lodash.flatten":"4.4.0","lodash.foreach":"4.5.0","lodash.map":"4.6.0","lodash.merge":"4.6.0","lodash.pick":"4.4.0","lodash.reduce":"4.6.0","lodash.reject":"4.6.0","lodash.some":"4.6.0"}},"chokidar":{"version":"1.7.0","resolved":"https://registry.npmjs.org/chokidar/-/chokidar-1.7.0.tgz","integrity":"sha1-eY5ol3gVHIB2tLNg5e3SjNortGg=","requires":{"anymatch":"1.3.2","async-each":"1.0.1","glob-parent":"2.0.0","inherits":"2.0.3","is-binary-path":"1.0.1","is-glob":"2.0.1","path-is-absolute":"1.0.1","readdirp":"2.1.0"}},"cipher-base":{"version":"1.0.4","resolved":"https://registry.npmjs.org/cipher-base/-/cipher-base-1.0.4.tgz","integrity":"sha512-Kkht5ye6ZGmwv40uUDZztayT2ThLQGfnj/T71N/XzeZeo3nf8foyW7zGTsPYkEya3m5f3cAypH+qe7YOrM1U2Q==","dev":true,"requires":{"inherits":"2.0.3","safe-buffer":"5.1.1"}},"clean-stack":{"version":"1.3.0","resolved":"https://registry.npmjs.org/clean-stack/-/clean-stack-1.3.0.tgz","integrity":"sha1-noIVAa6XmYbEax1m0tQy2y/UrjE=","dev":true},"cliui":{"version":"2.1.0","resolved":"https://registry.npmjs.org/cliui/-/cliui-2.1.0.tgz","integrity":"sha1-S0dXYP+AJkx2LDoXGQMukcf+oNE=","dev":true,"requires":{"center-align":"0.1.3","right-align":"0.1.3","wordwrap":"0.0.2"}},"cloner":{"version":"git+https://github.com/cellvia/cloner.git#0d896e0d8aa875a6007971ddd34c84218d898309","dev":true},"co":{"version":"4.6.0","resolved":"https://registry.npmjs.org/co/-/co-4.6.0.tgz","integrity":"sha1-bqa989hTrlTMuOR7+gvz+QMfsYQ=","dev":true},"code-point-at":{"version":"1.1.0","resolved":"https://registry.npmjs.org/code-point-at/-/code-point-at-1.1.0.tgz","integrity":"sha1-DQcLTQQ6W+ozovGkDi7bPZpMz3c=","dev":true},"commander":{"version":"2.11.0","resolved":"https://registry.npmjs.org/commander/-/commander-2.11.0.tgz","integrity":"sha512-b0553uYA5YAEGgyYIGYROzKQ7X5RAqedkfjiZxwi0kL1g3bOaBNNZfYkzt/CL0umgD5wc9Jec2FbB98CjkMRvQ=="},"commondir":{"version":"1.0.1","resolved":"https://registry.npmjs.org/commondir/-/commondir-1.0.1.tgz","integrity":"sha1-3dgA2gxmEnOTzKWVDqloo6rxJTs="},"component-testing-tools":{"version":"git+https://gitlab.com/regiscompany/component-testing-tools.git#9f3e80ab4e1a3bf01d2b0010c384c32737abb2fa","dev":true},"concat-map":{"version":"0.0.1","resolved":"https://registry.npmjs.org/concat-map/-/concat-map-0.0.1.tgz","integrity":"sha1-2Klr13/Wjfd5OnMDajug1UBdR3s="},"console-browserify":{"version":"1.1.0","resolved":"https://registry.npmjs.org/console-browserify/-/console-browserify-1.1.0.tgz","integrity":"sha1-8CQcRXMKn8YyOyBtvzjtx0HQuxA=","dev":true,"requires":{"date-now":"0.1.4"}},"constants-browserify":{"version":"1.0.0","resolved":"https://registry.npmjs.org/constants-browserify/-/constants-browserify-1.0.0.tgz","integrity":"sha1-wguW2MYXdIqvHBYCF2DNJ/y4y3U=","dev":true},"convert-source-map":{"version":"1.5.0","resolved":"https://registry.npmjs.org/convert-source-map/-/convert-source-map-1.5.0.tgz","integrity":"sha1-ms1whRxtXf3ZPZKC5e35SgP/RrU="},"copyfiles":{"version":"1.2.0","resolved":"https://registry.npmjs.org/copyfiles/-/copyfiles-1.2.0.tgz","integrity":"sha1-qNo6xBqiIgrim9PFi2mEKU8sWTw=","dev":true,"requires":{"glob":"7.1.2","ltcdr":"2.2.1","minimatch":"3.0.4","mkdirp":"0.5.1","noms":"0.0.0","through2":"2.0.3"}},"core-js":{"version":"2.5.1","resolved":"https://registry.npmjs.org/core-js/-/core-js-2.5.1.tgz","integrity":"sha1-rmh03GaTd4m4B1T/VCjfZoGcpQs="},"core-util-is":{"version":"1.0.2","resolved":"https://registry.npmjs.org/core-util-is/-/core-util-is-1.0.2.tgz","integrity":"sha1-tf1UIgqivFq1eqtxQMlAdUUDwac="},"create-ecdh":{"version":"4.0.0","resolved":"https://registry.npmjs.org/create-ecdh/-/create-ecdh-4.0.0.tgz","integrity":"sha1-iIxyNZbN92EvZJgjPuvXo1MBc30=","dev":true,"requires":{"bn.js":"4.11.8","elliptic":"6.4.0"}},"create-hash":{"version":"1.1.3","resolved":"https://registry.npmjs.org/create-hash/-/create-hash-1.1.3.tgz","integrity":"sha1-YGBCrIuSYnUPSDyt2rD1gZFy2P0=","dev":true,"requires":{"cipher-base":"1.0.4","inherits":"2.0.3","ripemd160":"2.0.1","sha.js":"2.4.9"}},"create-hmac":{"version":"1.1.6","resolved":"https://registry.npmjs.org/create-hmac/-/create-hmac-1.1.6.tgz","integrity":"sha1-rLniIaThe9sHbpBlfEK5PjcmzwY=","dev":true,"requires":{"cipher-base":"1.0.4","create-hash":"1.1.3","inherits":"2.0.3","ripemd160":"2.0.1","safe-buffer":"5.1.1","sha.js":"2.4.9"}},"create-react-class":{"version":"15.6.2","resolved":"https://registry.npmjs.org/create-react-class/-/create-react-class-15.6.2.tgz","integrity":"sha1-zx7RXxKq1/FO9fLf4F5sQvke8Co=","requires":{"fbjs":"0.8.16","loose-envify":"1.3.1","object-assign":"4.1.1"}},"cross-env":{"version":"5.1.1","resolved":"https://registry.npmjs.org/cross-env/-/cross-env-5.1.1.tgz","integrity":"sha512-Wtvr+z0Z06KO1JxjfRRsPC+df7biIOiuV4iZ73cThjFGkH+ULBZq1MkBdywEcJC4cTDbO6c8IjgRjfswx3YTBA==","dev":true,"requires":{"cross-spawn":"5.1.0","is-windows":"1.0.1"}},"cross-spawn":{"version":"5.1.0","resolved":"https://registry.npmjs.org/cross-spawn/-/cross-spawn-5.1.0.tgz","integrity":"sha1-6L0O/uWPz/b4+UUQoKVUu/ojVEk=","dev":true,"requires":{"lru-cache":"4.1.1","shebang-command":"1.2.0","which":"1.3.0"}},"crypto-browserify":{"version":"3.12.0","resolved":"https://registry.npmjs.org/crypto-browserify/-/crypto-browserify-3.12.0.tgz","integrity":"sha512-fz4spIh+znjO2VjL+IdhEpRJ3YN6sMzITSBijk6FK2UvTqruSQW+/cCZTSNsMiZNvUeq0CqurF+dAbyiGOY6Wg==","dev":true,"requires":{"browserify-cipher":"1.0.0","browserify-sign":"4.0.4","create-ecdh":"4.0.0","create-hash":"1.1.3","create-hmac":"1.1.6","diffie-hellman":"5.0.2","inherits":"2.0.3","pbkdf2":"3.0.14","public-encrypt":"4.0.0","randombytes":"2.0.5","randomfill":"1.0.3"}},"css":{"version":"2.2.1","resolved":"https://registry.npmjs.org/css/-/css-2.2.1.tgz","integrity":"sha1-c6TIHehdtmTU7mdPfUcIXjstVdw=","dev":true,"requires":{"inherits":"2.0.3","source-map":"0.1.43","source-map-resolve":"0.3.1","urix":"0.1.0"},"dependencies":{"source-map":{"version":"0.1.43","resolved":"https://registry.npmjs.org/source-map/-/source-map-0.1.43.tgz","integrity":"sha1-wkvBRspRfBRx9drL4lcbK3+eM0Y=","dev":true,"requires":{"amdefine":"1.0.1"}}}},"css-select":{"version":"1.2.0","resolved":"https://registry.npmjs.org/css-select/-/css-select-1.2.0.tgz","integrity":"sha1-KzoRBTnFNV8c2NMUYj6HCxIeyFg=","dev":true,"requires":{"boolbase":"1.0.0","css-what":"2.1.0","domutils":"1.5.1","nth-check":"1.0.1"}},"css-what":{"version":"2.1.0","resolved":"https://registry.npmjs.org/css-what/-/css-what-2.1.0.tgz","integrity":"sha1-lGfQMsOM+u+58teVASUwYvh/ob0=","dev":true},"currently-unhandled":{"version":"0.4.1","resolved":"https://registry.npmjs.org/currently-unhandled/-/currently-unhandled-0.4.1.tgz","integrity":"sha1-mI3zP+qxke95mmE2nddsF635V+o=","dev":true,"requires":{"array-find-index":"1.0.2"}},"d3":{"version":"3.5.17","resolved":"https://registry.npmjs.org/d3/-/d3-3.5.17.tgz","integrity":"sha1-vEZ0gAQ3iyGjYMn8fPUjF5B2L7g="},"date-now":{"version":"0.1.4","resolved":"https://registry.npmjs.org/date-now/-/date-now-0.1.4.tgz","integrity":"sha1-6vQ5/U1ISK105cx9vvIAZyueNFs=","dev":true},"debug":{"version":"2.6.9","resolved":"https://registry.npmjs.org/debug/-/debug-2.6.9.tgz","integrity":"sha512-bC7ElrdJaJnPbAP+1EotYvqZsb3ecl5wi6Bfi6BJTUcNowp6cvspg0jXznRTKDjm/E7AdgFBVeAPVMNcKGsHMA==","requires":{"ms":"2.0.0"}},"decamelize":{"version":"1.2.0","resolved":"https://registry.npmjs.org/decamelize/-/decamelize-1.2.0.tgz","integrity":"sha1-9lNNFRSCabIDUue+4m9QH5oZEpA=","dev":true},"decompress-response":{"version":"3.3.0","resolved":"https://registry.npmjs.org/decompress-response/-/decompress-response-3.3.0.tgz","integrity":"sha1-gKTdMjdIOEv6JICDYirt7Jgq3/M=","dev":true,"requires":{"mimic-response":"1.0.0"}},"deep-bind-decorator":{"version":"git+https://gitlab.com/regiscompany/deep-bind-decorator.git#1f0d4e74054afaae21ebb9685a39ac5792847de1","dev":true,"requires":{"cloner":"git+https://github.com/cellvia/cloner.git#0d896e0d8aa875a6007971ddd34c84218d898309","traverse":"0.6.6"}},"deep-equal":{"version":"1.0.1","resolved":"https://registry.npmjs.org/deep-equal/-/deep-equal-1.0.1.tgz","integrity":"sha1-9dJgKStmDghO/0zbyfCK0yR0SLU=","dev":true},"deep-extend":{"version":"0.5.0","resolved":"https://registry.npmjs.org/deep-extend/-/deep-extend-0.5.0.tgz","integrity":"sha1-bvSgmwX5iw41jW2T1Mo8rsZnKAM=","dev":true},"define-properties":{"version":"1.1.2","resolved":"https://registry.npmjs.org/define-properties/-/define-properties-1.1.2.tgz","integrity":"sha1-g6c/L+pWmJj7c3GTyPhzyvbUXJQ=","dev":true,"requires":{"foreach":"2.0.5","object-keys":"1.0.11"}},"defined":{"version":"1.0.0","resolved":"https://registry.npmjs.org/defined/-/defined-1.0.0.tgz","integrity":"sha1-yY2bzvdWdBiOEQlpFRGZ45sfppM=","dev":true},"des.js":{"version":"1.0.0","resolved":"https://registry.npmjs.org/des.js/-/des.js-1.0.0.tgz","integrity":"sha1-wHTS4qpqipoH29YfmhXCzYPsjsw=","dev":true,"requires":{"inherits":"2.0.3","minimalistic-assert":"1.0.0"}},"detect-indent":{"version":"4.0.0","resolved":"https://registry.npmjs.org/detect-indent/-/detect-indent-4.0.0.tgz","integrity":"sha1-920GQ1LN9Docts5hnE7jqUdd4gg=","requires":{"repeating":"2.0.1"}},"diffie-hellman":{"version":"5.0.2","resolved":"https://registry.npmjs.org/diffie-hellman/-/diffie-hellman-5.0.2.tgz","integrity":"sha1-tYNXOScM/ias9jIJn97SoH8gnl4=","dev":true,"requires":{"bn.js":"4.11.8","miller-rabin":"4.0.1","randombytes":"2.0.5"}},"dom-serializer":{"version":"0.1.0","resolved":"https://registry.npmjs.org/dom-serializer/-/dom-serializer-0.1.0.tgz","integrity":"sha1-BzxpdUbOB4DOI75KKOKT5AvDDII=","dev":true,"requires":{"domelementtype":"1.1.3","entities":"1.1.1"},"dependencies":{"domelementtype":{"version":"1.1.3","resolved":"https://registry.npmjs.org/domelementtype/-/domelementtype-1.1.3.tgz","integrity":"sha1-vSh3PiZCiBrsUVRJJCmcXNgiGFs=","dev":true}}},"dom-walk":{"version":"0.1.1","resolved":"https://registry.npmjs.org/dom-walk/-/dom-walk-0.1.1.tgz","integrity":"sha1-ZyIm3HTI95mtNTB9+TaroRrNYBg="},"domain-browser":{"version":"1.1.7","resolved":"https://registry.npmjs.org/domain-browser/-/domain-browser-1.1.7.tgz","integrity":"sha1-hnqksJP6oF8d4IwG9NeyH9+GmLw=","dev":true},"domelementtype":{"version":"1.3.0","resolved":"https://registry.npmjs.org/domelementtype/-/domelementtype-1.3.0.tgz","integrity":"sha1-sXrtguirWeUt2cGbF1bg/BhyBMI=","dev":true},"domhandler":{"version":"2.4.1","resolved":"https://registry.npmjs.org/domhandler/-/domhandler-2.4.1.tgz","integrity":"sha1-iS5HAAqZvlW783dP/qBWHYh5wlk=","dev":true,"requires":{"domelementtype":"1.3.0"}},"domutils":{"version":"1.5.1","resolved":"https://registry.npmjs.org/domutils/-/domutils-1.5.1.tgz","integrity":"sha1-3NhIiib1Y9YQeeSMn3t+Mjc2gs8=","dev":true,"requires":{"dom-serializer":"0.1.0","domelementtype":"1.3.0"}},"duplexer3":{"version":"0.1.4","resolved":"https://registry.npmjs.org/duplexer3/-/duplexer3-0.1.4.tgz","integrity":"sha1-7gHdHKwO08vH/b6jfcCo8c4ALOI=","dev":true},"elliptic":{"version":"6.4.0","resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","dev":true,"requires":{"bn.js":"4.11.8","brorand":"1.1.0","hash.js":"1.1.3","hmac-drbg":"1.0.1","inherits":"2.0.3","minimalistic-assert":"1.0.0","minimalistic-crypto-utils":"1.0.1"}},"emojis-list":{"version":"2.1.0","resolved":"https://registry.npmjs.org/emojis-list/-/emojis-list-2.1.0.tgz","integrity":"sha1-TapNnbAPmBmIDHn6RXrlsJof04k="},"encoding":{"version":"0.1.12","resolved":"https://registry.npmjs.org/encoding/-/encoding-0.1.12.tgz","integrity":"sha1-U4tm8+5izRq1HsMjgp0flIDHS+s=","requires":{"iconv-lite":"0.4.19"}},"enhanced-resolve":{"version":"3.4.1","resolved":"https://registry.npmjs.org/enhanced-resolve/-/enhanced-resolve-3.4.1.tgz","integrity":"sha1-BCHjOf1xQZs9oT0Smzl5BAIwR24=","dev":true,"requires":{"graceful-fs":"4.1.11","memory-fs":"0.4.1","object-assign":"4.1.1","tapable":"0.2.8"}},"entities":{"version":"1.1.1","resolved":"https://registry.npmjs.org/entities/-/entities-1.1.1.tgz","integrity":"sha1-blwtClYhtdra7O+AuQ7ftc13cvA=","dev":true},"enzyme":{"version":"2.9.1","resolved":"https://registry.npmjs.org/enzyme/-/enzyme-2.9.1.tgz","integrity":"sha1-B9XOaRJBJA+4F78sSxjW5TAkDfY=","dev":true,"requires":{"cheerio":"0.22.0","function.prototype.name":"1.0.3","is-subset":"0.1.1","lodash":"4.17.4","object-is":"1.0.1","object.assign":"4.0.4","object.entries":"1.0.4","object.values":"1.0.4","prop-types":"15.6.0","uuid":"3.1.0"}},"errno":{"version":"0.1.4","resolved":"https://registry.npmjs.org/errno/-/errno-0.1.4.tgz","integrity":"sha1-uJbiOp5ei6M4cfyZar02NfyaHH0=","dev":true,"requires":{"prr":"0.0.0"}},"error-ex":{"version":"1.3.1","resolved":"https://registry.npmjs.org/error-ex/-/error-ex-1.3.1.tgz","integrity":"sha1-+FWobOYa3E6GIcPNoh56dhLDqNw=","dev":true,"requires":{"is-arrayish":"0.2.1"}},"error-stack-parser":{"version":"1.3.6","resolved":"https://registry.npmjs.org/error-stack-parser/-/error-stack-parser-1.3.6.tgz","integrity":"sha1-4Oc7k+QXE40c18C3RrGkoUhUwpI=","requires":{"stackframe":"0.3.1"}},"es-abstract":{"version":"1.9.0","resolved":"https://registry.npmjs.org/es-abstract/-/es-abstract-1.9.0.tgz","integrity":"sha512-kk3IJoKo7A3pWJc0OV8yZ/VEX2oSUytfekrJiqoxBlKJMFAJVJVpGdHClCCTdv+Fn2zHfpDHHIelMFhZVfef3Q==","dev":true,"requires":{"es-to-primitive":"1.1.1","function-bind":"1.1.1","has":"1.0.1","is-callable":"1.1.3","is-regex":"1.0.4"}},"es-to-primitive":{"version":"1.1.1","resolved":"https://registry.npmjs.org/es-to-primitive/-/es-to-primitive-1.1.1.tgz","integrity":"sha1-RTVSSKiJeQNLZ5Lhm7gfK3l13Q0=","dev":true,"requires":{"is-callable":"1.1.3","is-date-object":"1.0.1","is-symbol":"1.0.1"}},"escape-string-regexp":{"version":"1.0.5","resolved":"https://registry.npmjs.org/escape-string-regexp/-/escape-string-regexp-1.0.5.tgz","integrity":"sha1-G2HAViGQqN/2rjuyzwIAyhMLhtQ="},"esutils":{"version":"2.0.2","resolved":"https://registry.npmjs.org/esutils/-/esutils-2.0.2.tgz","integrity":"sha1-Cr9PHKpbyx96nYrMbepPqqBLrJs="},"events":{"version":"1.1.1","resolved":"https://registry.npmjs.org/events/-/events-1.1.1.tgz","integrity":"sha1-nr23Y1rQmccNzEwqH1AEKI6L2SQ=","dev":true},"evp_bytestokey":{"version":"1.0.3","resolved":"https://registry.npmjs.org/evp_bytestokey/-/evp_bytestokey-1.0.3.tgz","integrity":"sha512-/f2Go4TognH/KvCISP7OUsHn85hT9nUkxxA9BEWxFn+Oj9o8ZNLm/40hdlgSLyuOimsrTKLUMEorQexp/aPQeA==","dev":true,"requires":{"md5.js":"1.3.4","safe-buffer":"5.1.1"}},"expand-brackets":{"version":"0.1.5","resolved":"https://registry.npmjs.org/expand-brackets/-/expand-brackets-0.1.5.tgz","integrity":"sha1-3wcoTjQqgHzXM6xa9yQR5YHRF3s=","requires":{"is-posix-bracket":"0.1.1"}},"expand-range":{"version":"1.8.2","resolved":"https://registry.npmjs.org/expand-range/-/expand-range-1.8.2.tgz","integrity":"sha1-opnv/TNf4nIeuujiV+x5ZE/IUzc=","requires":{"fill-range":"2.2.3"}},"extend-observable-decorator":{"version":"git+https://gitlab.com/regiscompany/extend-observable-decorator.git#0b9ec0685c7e78e190d9d944803866d9c0d31986","dev":true,"requires":{"cloner":"git+https://github.com/cellvia/cloner.git#0d896e0d8aa875a6007971ddd34c84218d898309"}},"extglob":{"version":"0.3.2","resolved":"https://registry.npmjs.org/extglob/-/extglob-0.3.2.tgz","integrity":"sha1-Lhj/PS9JqydlzskCPwEdqo2DSaE=","requires":{"is-extglob":"1.0.0"}},"fbjs":{"version":"0.8.16","resolved":"https://registry.npmjs.org/fbjs/-/fbjs-0.8.16.tgz","integrity":"sha1-XmdDL1UNxBtXK/VYR7ispk5TN9s=","requires":{"core-js":"1.2.7","isomorphic-fetch":"2.2.1","loose-envify":"1.3.1","object-assign":"4.1.1","promise":"7.3.1","setimmediate":"1.0.5","ua-parser-js":"0.7.17"},"dependencies":{"core-js":{"version":"1.2.7","resolved":"https://registry.npmjs.org/core-js/-/core-js-1.2.7.tgz","integrity":"sha1-ZSKUwUZR2yj6k70tX/KYOk8IxjY="}}},"filename-regex":{"version":"2.0.1","resolved":"https://registry.npmjs.org/filename-regex/-/filename-regex-2.0.1.tgz","integrity":"sha1-wcS5vuPglyXdsQa3XB4wH+LxiyY="},"fill-range":{"version":"2.2.3","resolved":"https://registry.npmjs.org/fill-range/-/fill-range-2.2.3.tgz","integrity":"sha1-ULd9/X5Gm8dJJHCWNpn+eoSFpyM=","requires":{"is-number":"2.1.0","isobject":"2.1.0","randomatic":"1.1.7","repeat-element":"1.1.2","repeat-string":"1.6.1"}},"find-cache-dir":{"version":"0.1.1","resolved":"https://registry.npmjs.org/find-cache-dir/-/find-cache-dir-0.1.1.tgz","integrity":"sha1-yN765XyKUqinhPnjHFfHQumToLk=","requires":{"commondir":"1.0.1","mkdirp":"0.5.1","pkg-dir":"1.0.0"}},"find-up":{"version":"1.1.2","resolved":"https://registry.npmjs.org/find-up/-/find-up-1.1.2.tgz","integrity":"sha1-ay6YIrGizgpgq2TWEOzK1TyyTQ8=","requires":{"path-exists":"2.1.0","pinkie-promise":"2.0.1"}},"for-in":{"version":"1.0.2","resolved":"https://registry.npmjs.org/for-in/-/for-in-1.0.2.tgz","integrity":"sha1-gQaNKVqBQuwKxybG4iAMMPttXoA="},"for-own":{"version":"0.1.5","resolved":"https://registry.npmjs.org/for-own/-/for-own-0.1.5.tgz","integrity":"sha1-UmXGgaTylNq78XyVCbZ2OqhFEM4=","requires":{"for-in":"1.0.2"}},"foreach":{"version":"2.0.5","resolved":"https://registry.npmjs.org/foreach/-/foreach-2.0.5.tgz","integrity":"sha1-C+4AUBiusmDQo6865ljdATbsG5k=","dev":true},"fs-readdir-recursive":{"version":"1.0.0","resolved":"https://registry.npmjs.org/fs-readdir-recursive/-/fs-readdir-recursive-1.0.0.tgz","integrity":"sha1-jNF0XItPiinIyuw5JHaSG6GV9WA="},"fs.realpath":{"version":"1.0.0","resolved":"https://registry.npmjs.org/fs.realpath/-/fs.realpath-1.0.0.tgz","integrity":"sha1-FQStJSMVjKpA20onh8sBQRmU6k8="},"function-bind":{"version":"1.1.1","resolved":"https://registry.npmjs.org/function-bind/-/function-bind-1.1.1.tgz","integrity":"sha512-yIovAzMX49sF8Yl58fSCWJ5svSLuaibPxXQJFLmBObTuCr0Mf1KiPopGM9NiFjiYBCbfaa2Fh6breQ6ANVTI0A==","dev":true},"function.prototype.name":{"version":"1.0.3","resolved":"https://registry.npmjs.org/function.prototype.name/-/function.prototype.name-1.0.3.tgz","integrity":"sha512-5EblxZUdioXi2JiMZ9FUbwYj40eQ9MFHyzFLBSPdlRl3SO8l7SLWuAnQ/at/1Wi4hjJwME/C5WpF2ZfAc8nGNw==","dev":true,"requires":{"define-properties":"1.1.2","function-bind":"1.1.1","is-callable":"1.1.3"}},"get-caller-file":{"version":"1.0.2","resolved":"https://registry.npmjs.org/get-caller-file/-/get-caller-file-1.0.2.tgz","integrity":"sha1-9wLmMSfn4jHBYKgMFVSstw1QR+U=","dev":true},"get-imports":{"version":"1.0.0","resolved":"https://registry.npmjs.org/get-imports/-/get-imports-1.0.0.tgz","integrity":"sha1-R8C07piTUWQsVJdxk79Pyqv1N48=","dev":true,"requires":{"array-uniq":"1.0.3","import-regex":"1.1.0"}},"get-stdin":{"version":"4.0.1","resolved":"https://registry.npmjs.org/get-stdin/-/get-stdin-4.0.1.tgz","integrity":"sha1-uWjGsKBDhDJJAui/Gl3zJXmkUP4=","dev":true},"get-stream":{"version":"3.0.0","resolved":"https://registry.npmjs.org/get-stream/-/get-stream-3.0.0.tgz","integrity":"sha1-jpQ9E1jcN1VQVOy+LtsFqhdO3hQ=","dev":true},"git-tag":{"version":"git+https://github.com/cellvia/git-tag.git#26d931a1a6fe7f4f0f655ea36081bb6db447bae7","dev":true,"requires":{"semver":"4.2.2"},"dependencies":{"semver":{"version":"4.2.2","resolved":"https://registry.npmjs.org/semver/-/semver-4.2.2.tgz","integrity":"sha1-pqpqxqY8Dcev9+pI1UVa4rk6MGI=","dev":true}}},"glob":{"version":"7.1.2","resolved":"https://registry.npmjs.org/glob/-/glob-7.1.2.tgz","integrity":"sha512-MJTUg1kjuLeQCJ+ccE4Vpa6kKVXkPYJ2mOCQyUuKLcLQsdrMCpBPUi8qVE6+YuaJkozeA9NusTAw3hLr8Xe5EQ==","requires":{"fs.realpath":"1.0.0","inflight":"1.0.6","inherits":"2.0.3","minimatch":"3.0.4","once":"1.4.0","path-is-absolute":"1.0.1"}},"glob-base":{"version":"0.3.0","resolved":"https://registry.npmjs.org/glob-base/-/glob-base-0.3.0.tgz","integrity":"sha1-27Fk9iIbHAscz4Kuoyi0l98Oo8Q=","requires":{"glob-parent":"2.0.0","is-glob":"2.0.1"}},"glob-parent":{"version":"2.0.0","resolved":"https://registry.npmjs.org/glob-parent/-/glob-parent-2.0.0.tgz","integrity":"sha1-gTg9ctsFT8zPUzbaqQLxgvbtuyg=","requires":{"is-glob":"2.0.1"}},"global":{"version":"4.3.2","resolved":"https://registry.npmjs.org/global/-/global-4.3.2.tgz","integrity":"sha1-52mJJopsdMOJCLEwWxD8DjlOnQ8=","requires":{"min-document":"2.19.0","process":"0.5.2"}},"globals":{"version":"9.18.0","resolved":"https://registry.npmjs.org/globals/-/globals-9.18.0.tgz","integrity":"sha512-S0nG3CLEQiY/ILxqtztTWH/3iRRdyBLw6KMDxnKMchrtbj2OFmehVh0WUCfW3DUrIgx/qFrJPICrq4Z4sTR9UQ=="},"globby":{"version":"2.1.0","resolved":"https://registry.npmjs.org/globby/-/globby-2.1.0.tgz","integrity":"sha1-npGSvNM/Srak+JTl5+qLcTITxII=","dev":true,"requires":{"array-union":"1.0.2","async":"1.5.2","glob":"5.0.15","object-assign":"3.0.0"},"dependencies":{"glob":{"version":"5.0.15","resolved":"https://registry.npmjs.org/glob/-/glob-5.0.15.tgz","integrity":"sha1-G8k2ueAvSmA/zCIuz3Yz0wuLk7E=","dev":true,"requires":{"inflight":"1.0.6","inherits":"2.0.3","minimatch":"3.0.4","once":"1.4.0","path-is-absolute":"1.0.1"}},"object-assign":{"version":"3.0.0","resolved":"https://registry.npmjs.org/object-assign/-/object-assign-3.0.0.tgz","integrity":"sha1-m+3VygiXlJvKR+f/QIBi1Un1h/I=","dev":true}}},"got":{"version":"7.1.0","resolved":"https://registry.npmjs.org/got/-/got-7.1.0.tgz","integrity":"sha512-Y5WMo7xKKq1muPsxD+KmrR8DH5auG7fBdDVueZwETwV6VytKyU9OX/ddpq2/1hp1vIPvVb4T81dKQz3BivkNLw==","dev":true,"requires":{"decompress-response":"3.3.0","duplexer3":"0.1.4","get-stream":"3.0.0","is-plain-obj":"1.1.0","is-retry-allowed":"1.1.0","is-stream":"1.1.0","isurl":"1.0.0","lowercase-keys":"1.0.0","p-cancelable":"0.3.0","p-timeout":"1.2.0","safe-buffer":"5.1.1","timed-out":"4.0.1","url-parse-lax":"1.0.0","url-to-options":"1.0.1"}},"graceful-fs":{"version":"4.1.11","resolved":"https://registry.npmjs.org/graceful-fs/-/graceful-fs-4.1.11.tgz","integrity":"sha1-Dovf5NHduIVNZOBOp8AOKgJuVlg="},"has":{"version":"1.0.1","resolved":"https://registry.npmjs.org/has/-/has-1.0.1.tgz","integrity":"sha1-hGFzP1OLCDfJNh45qauelwTcLyg=","dev":true,"requires":{"function-bind":"1.1.1"}},"has-ansi":{"version":"2.0.0","resolved":"https://registry.npmjs.org/has-ansi/-/has-ansi-2.0.0.tgz","integrity":"sha1-NPUEnOHs3ysGSa8+8k5F7TVBbZE=","requires":{"ansi-regex":"2.1.1"}},"has-flag":{"version":"1.0.0","resolved":"https://registry.npmjs.org/has-flag/-/has-flag-1.0.0.tgz","integrity":"sha1-nZ55MWXOAXoA8AQYxD+UKnsdEfo=","dev":true},"has-symbol-support-x":{"version":"1.4.1","resolved":"https://registry.npmjs.org/has-symbol-support-x/-/has-symbol-support-x-1.4.1.tgz","integrity":"sha512-JkaetveU7hFbqnAC1EV1sF4rlojU2D4Usc5CmS69l6NfmPDnpnFUegzFg33eDkkpNCxZ0mQp65HwUDrNFS/8MA==","dev":true},"has-to-string-tag-x":{"version":"1.4.1","resolved":"https://registry.npmjs.org/has-to-string-tag-x/-/has-to-string-tag-x-1.4.1.tgz","integrity":"sha512-vdbKfmw+3LoOYVr+mtxHaX5a96+0f3DljYd8JOqvOLsf5mw2Otda2qCDT9qRqLAhrjyQ0h7ual5nOiASpsGNFw==","dev":true,"requires":{"has-symbol-support-x":"1.4.1"}},"hash-base":{"version":"2.0.2","resolved":"https://registry.npmjs.org/hash-base/-/hash-base-2.0.2.tgz","integrity":"sha1-ZuodhW206KVHDK32/OI65SRO8uE=","dev":true,"requires":{"inherits":"2.0.3"}},"hash.js":{"version":"1.1.3","resolved":"https://registry.npmjs.org/hash.js/-/hash.js-1.1.3.tgz","integrity":"sha512-/UETyP0W22QILqS+6HowevwhEFJ3MBJnwTf75Qob9Wz9t0DPuisL8kW8YZMK62dHAKE1c1p+gY1TtOLY+USEHA==","dev":true,"requires":{"inherits":"2.0.3","minimalistic-assert":"1.0.0"}},"hmac-drbg":{"version":"1.0.1","resolved":"https://registry.npmjs.org/hmac-drbg/-/hmac-drbg-1.0.1.tgz","integrity":"sha1-0nRXAQJabHdabFRXk+1QL8DGSaE=","dev":true,"requires":{"hash.js":"1.1.3","minimalistic-assert":"1.0.0","minimalistic-crypto-utils":"1.0.1"}},"hoist-non-react-statics":{"version":"2.3.1","resolved":"https://registry.npmjs.org/hoist-non-react-statics/-/hoist-non-react-statics-2.3.1.tgz","integrity":"sha1-ND24TGAYxlB3iJgkATWhQg7iLOA="},"home-or-tmp":{"version":"2.0.0","resolved":"https://registry.npmjs.org/home-or-tmp/-/home-or-tmp-2.0.0.tgz","integrity":"sha1-42w/LSyufXRqhX440Y1fMqeILbg=","requires":{"os-homedir":"1.0.2","os-tmpdir":"1.0.2"}},"hosted-git-info":{"version":"2.5.0","resolved":"https://registry.npmjs.org/hosted-git-info/-/hosted-git-info-2.5.0.tgz","integrity":"sha512-pNgbURSuab90KbTqvRPsseaTxOJCZBD0a7t+haSN33piP9cCM4l0CqdzAif2hUqm716UovKB2ROmiabGAKVXyg==","dev":true},"htmlparser2":{"version":"3.9.2","resolved":"https://registry.npmjs.org/htmlparser2/-/htmlparser2-3.9.2.tgz","integrity":"sha1-G9+HrMoPP55T+k/M6w9LTLsAszg=","dev":true,"requires":{"domelementtype":"1.3.0","domhandler":"2.4.1","domutils":"1.5.1","entities":"1.1.1","inherits":"2.0.3","readable-stream":"2.3.3"}},"https-browserify":{"version":"0.0.1","resolved":"https://registry.npmjs.org/https-browserify/-/https-browserify-0.0.1.tgz","integrity":"sha1-P5E2XKvmC3ftDruiS0VOPgnZWoI=","dev":true},"iconv-lite":{"version":"0.4.19","resolved":"https://registry.npmjs.org/iconv-lite/-/iconv-lite-0.4.19.tgz","integrity":"sha512-oTZqweIP51xaGPI4uPa56/Pri/480R+mo7SeU+YETByQNhDG55ycFyNLIgta9vXhILrxXDmF7ZGhqZIcuN0gJQ=="},"ieee754":{"version":"1.1.8","resolved":"https://registry.npmjs.org/ieee754/-/ieee754-1.1.8.tgz","integrity":"sha1-vjPUCsEO8ZJnAfbwii2G+/0a0+Q=","dev":true},"ignore-styles":{"version":"5.0.1","resolved":"https://registry.npmjs.org/ignore-styles/-/ignore-styles-5.0.1.tgz","integrity":"sha1-tJ7yJ0va/NikiAqWa/440aC/RnE=","dev":true},"import-regex":{"version":"1.1.0","resolved":"https://registry.npmjs.org/import-regex/-/import-regex-1.1.0.tgz","integrity":"sha1-pVxS5McFx2XKIQ6SQqBrvMiqf2Y=","dev":true},"indent-string":{"version":"3.2.0","resolved":"https://registry.npmjs.org/indent-string/-/indent-string-3.2.0.tgz","integrity":"sha1-Sl/W0nzDMvN+VBmlBNu4NxBckok=","dev":true},"indexof":{"version":"0.0.1","resolved":"https://registry.npmjs.org/indexof/-/indexof-0.0.1.tgz","integrity":"sha1-gtwzbSMrkGIXnQWrMpOmYFn9Q10=","dev":true},"inflight":{"version":"1.0.6","resolved":"https://registry.npmjs.org/inflight/-/inflight-1.0.6.tgz","integrity":"sha1-Sb1jMdfQLQwJvJEKEHW6gWW1bfk=","requires":{"once":"1.4.0","wrappy":"1.0.2"}},"inherits":{"version":"2.0.3","resolved":"https://registry.npmjs.org/inherits/-/inherits-2.0.3.tgz","integrity":"sha1-Yzwsg+PaQqUC9SRmAiSA9CCCYd4="},"interpret":{"version":"1.0.4","resolved":"https://registry.npmjs.org/interpret/-/interpret-1.0.4.tgz","integrity":"sha1-ggzdWIuGj/sZGoCVBtbJyPISsbA=","dev":true},"invariant":{"version":"2.2.2","resolved":"https://registry.npmjs.org/invariant/-/invariant-2.2.2.tgz","integrity":"sha1-nh9WrArNtr8wMwbzOL47IErmA2A=","requires":{"loose-envify":"1.3.1"}},"invert-kv":{"version":"1.0.0","resolved":"https://registry.npmjs.org/invert-kv/-/invert-kv-1.0.0.tgz","integrity":"sha1-EEqOSqym09jNFXqO+L+rLXo//bY=","dev":true},"ip-regex":{"version":"1.0.3","resolved":"https://registry.npmjs.org/ip-regex/-/ip-regex-1.0.3.tgz","integrity":"sha1-3FiQdvZZ9BnCIgOaMzFvHHOH7/0=","dev":true},"is-arrayish":{"version":"0.2.1","resolved":"https://registry.npmjs.org/is-arrayish/-/is-arrayish-0.2.1.tgz","integrity":"sha1-d8mYQFJ6qOyxqLppe4BkWnqSap0=","dev":true},"is-binary-path":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-binary-path/-/is-binary-path-1.0.1.tgz","integrity":"sha1-dfFmQrSA8YenEcgUFh/TpKdlWJg=","requires":{"binary-extensions":"1.10.0"}},"is-buffer":{"version":"1.1.6","resolved":"https://registry.npmjs.org/is-buffer/-/is-buffer-1.1.6.tgz","integrity":"sha512-NcdALwpXkTm5Zvvbk7owOUSvVvBKDgKP5/ewfXEznmQFfs4ZRmanOeKBTjRVjka3QFoN6XJ+9F3USqfHqTaU5w=="},"is-builtin-module":{"version":"1.0.0","resolved":"https://registry.npmjs.org/is-builtin-module/-/is-builtin-module-1.0.0.tgz","integrity":"sha1-VAVy0096wxGfj3bDDLwbHgN6/74=","dev":true,"requires":{"builtin-modules":"1.1.1"}},"is-callable":{"version":"1.1.3","resolved":"https://registry.npmjs.org/is-callable/-/is-callable-1.1.3.tgz","integrity":"sha1-hut1OSgF3cM69xySoO7fdO52BLI=","dev":true},"is-date-object":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-date-object/-/is-date-object-1.0.1.tgz","integrity":"sha1-mqIOtq7rv/d/vTPnTKAbM1gdOhY=","dev":true},"is-dotfile":{"version":"1.0.3","resolved":"https://registry.npmjs.org/is-dotfile/-/is-dotfile-1.0.3.tgz","integrity":"sha1-pqLzL/0t+wT1yiXs0Pa4PPeYoeE="},"is-equal-shallow":{"version":"0.1.3","resolved":"https://registry.npmjs.org/is-equal-shallow/-/is-equal-shallow-0.1.3.tgz","integrity":"sha1-IjgJj8Ih3gvPpdnqxMRdY4qhxTQ=","requires":{"is-primitive":"2.0.0"}},"is-extendable":{"version":"0.1.1","resolved":"https://registry.npmjs.org/is-extendable/-/is-extendable-0.1.1.tgz","integrity":"sha1-YrEQ4omkcUGOPsNqYX1HLjAd/Ik="},"is-extglob":{"version":"1.0.0","resolved":"https://registry.npmjs.org/is-extglob/-/is-extglob-1.0.0.tgz","integrity":"sha1-rEaBd8SUNAWgkvyPKXYMb/xiBsA="},"is-finite":{"version":"1.0.2","resolved":"https://registry.npmjs.org/is-finite/-/is-finite-1.0.2.tgz","integrity":"sha1-zGZ3aVYCvlUO8R6LSqYwU0K20Ko=","requires":{"number-is-nan":"1.0.1"}},"is-fullwidth-code-point":{"version":"1.0.0","resolved":"https://registry.npmjs.org/is-fullwidth-code-point/-/is-fullwidth-code-point-1.0.0.tgz","integrity":"sha1-754xOG8DGn8NZDr4L95QxFfvAMs=","dev":true,"requires":{"number-is-nan":"1.0.1"}},"is-glob":{"version":"2.0.1","resolved":"https://registry.npmjs.org/is-glob/-/is-glob-2.0.1.tgz","integrity":"sha1-0Jb5JqPe1WAPP9/ZEZjLCIjC2GM=","requires":{"is-extglob":"1.0.0"}},"is-number":{"version":"2.1.0","resolved":"https://registry.npmjs.org/is-number/-/is-number-2.1.0.tgz","integrity":"sha1-Afy7s5NGOlSPL0ZszhbezknbkI8=","requires":{"kind-of":"3.2.2"}},"is-object":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-object/-/is-object-1.0.1.tgz","integrity":"sha1-iVJojF7C/9awPsyF52ngKQMINHA=","dev":true},"is-online":{"version":"6.1.0","resolved":"https://registry.npmjs.org/is-online/-/is-online-6.1.0.tgz","integrity":"sha1-g4ZpyVc1NaHF6advBLvEhSbz+AU=","dev":true,"requires":{"is-reachable":"2.3.3","random-item":"1.0.0","root-hints":"1.0.15"}},"is-online-cli":{"version":"2.0.0","resolved":"https://registry.npmjs.org/is-online-cli/-/is-online-cli-2.0.0.tgz","integrity":"sha1-5fmQwy+i52/obVtvJB3bucABdOA=","dev":true,"requires":{"is-online":"6.1.0","log-symbols":"1.0.2","meow":"3.7.0"}},"is-plain-obj":{"version":"1.1.0","resolved":"https://registry.npmjs.org/is-plain-obj/-/is-plain-obj-1.1.0.tgz","integrity":"sha1-caUMhCnfync8kqOQpKA7OfzVHT4=","dev":true},"is-port-reachable":{"version":"2.0.0","resolved":"https://registry.npmjs.org/is-port-reachable/-/is-port-reachable-2.0.0.tgz","integrity":"sha1-VNE9ZUkX60M64+4ty8N3TyzUTrI=","dev":true},"is-posix-bracket":{"version":"0.1.1","resolved":"https://registry.npmjs.org/is-posix-bracket/-/is-posix-bracket-0.1.1.tgz","integrity":"sha1-MzTceXdDaOkvAW5vvAqI9c1ua8Q="},"is-primitive":{"version":"2.0.0","resolved":"https://registry.npmjs.org/is-primitive/-/is-primitive-2.0.0.tgz","integrity":"sha1-IHurkWOEmcB7Kt8kCkGochADRXU="},"is-reachable":{"version":"2.3.3","resolved":"https://registry.npmjs.org/is-reachable/-/is-reachable-2.3.3.tgz","integrity":"sha512-C+bGulHckKAtG6jji9gXawYASctmcpTnQMfKR7CiTC4D4IWgilNkuHBu0QPpWHRawi0WFein9POBLduCdHSbVw==","dev":true,"requires":{"arrify":"1.0.1","got":"7.1.0","is-port-reachable":"2.0.0","p-any":"1.1.0","p-timeout":"1.2.0","pify":"3.0.0","port-numbers":"2.0.10","prepend-http":"1.0.4","router-ips":"1.0.0","url-parse":"1.2.0"}},"is-regex":{"version":"1.0.4","resolved":"https://registry.npmjs.org/is-regex/-/is-regex-1.0.4.tgz","integrity":"sha1-VRdIm1RwkbCTDglWVM7SXul+lJE=","dev":true,"requires":{"has":"1.0.1"}},"is-retry-allowed":{"version":"1.1.0","resolved":"https://registry.npmjs.org/is-retry-allowed/-/is-retry-allowed-1.1.0.tgz","integrity":"sha1-EaBgVotnM5REAz0BJaYaINVk+zQ=","dev":true},"is-stream":{"version":"1.1.0","resolved":"https://registry.npmjs.org/is-stream/-/is-stream-1.1.0.tgz","integrity":"sha1-EtSj3U5o4Lec6428hBc66A2RykQ="},"is-subset":{"version":"0.1.1","resolved":"https://registry.npmjs.org/is-subset/-/is-subset-0.1.1.tgz","integrity":"sha1-ilkRfZMt4d4A8kX83TnOQ/HpOaY=","dev":true},"is-symbol":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-symbol/-/is-symbol-1.0.1.tgz","integrity":"sha1-PMWfAAJRlLarLjjbrmaJJWtmBXI=","dev":true},"is-utf8":{"version":"0.2.1","resolved":"https://registry.npmjs.org/is-utf8/-/is-utf8-0.2.1.tgz","integrity":"sha1-Sw2hRCEE0bM2NA6AeX6GXPOffXI=","dev":true},"is-windows":{"version":"1.0.1","resolved":"https://registry.npmjs.org/is-windows/-/is-windows-1.0.1.tgz","integrity":"sha1-MQ23D3QtJZoWo2kgK1GvhCMzENk=","dev":true},"isarray":{"version":"1.0.0","resolved":"https://registry.npmjs.org/isarray/-/isarray-1.0.0.tgz","integrity":"sha1-u5NdSFgsuhaMBoNJV6VKPgcSTxE="},"isexe":{"version":"2.0.0","resolved":"https://registry.npmjs.org/isexe/-/isexe-2.0.0.tgz","integrity":"sha1-6PvzdNxVb/iUehDcsFctYz8s+hA=","dev":true},"isobject":{"version":"2.1.0","resolved":"https://registry.npmjs.org/isobject/-/isobject-2.1.0.tgz","integrity":"sha1-8GVWEJaj8dou9GJy+BXIQNh+DIk=","requires":{"isarray":"1.0.0"}},"isomorphic-fetch":{"version":"2.2.1","resolved":"https://registry.npmjs.org/isomorphic-fetch/-/isomorphic-fetch-2.2.1.tgz","integrity":"sha1-YRrhrPFPXoH3KVB0coGf6XM1WKk=","requires":{"node-fetch":"1.7.3","whatwg-fetch":"2.0.3"}},"isurl":{"version":"1.0.0","resolved":"https://registry.npmjs.org/isurl/-/isurl-1.0.0.tgz","integrity":"sha512-1P/yWsxPlDtn7QeRD+ULKQPaIaN6yF368GZ2vDfv0AL0NwpStafjWCDDdn0k8wgFMWpVAqG7oJhxHnlud42i9w==","dev":true,"requires":{"has-to-string-tag-x":"1.4.1","is-object":"1.0.1"}},"js-tokens":{"version":"3.0.2","resolved":"https://registry.npmjs.org/js-tokens/-/js-tokens-3.0.2.tgz","integrity":"sha1-mGbfOVECEw449/mWvOtlRDIJwls="},"jsesc":{"version":"1.3.0","resolved":"https://registry.npmjs.org/jsesc/-/jsesc-1.3.0.tgz","integrity":"sha1-RsP+yMGJKxKwgz25vHYiF226s0s="},"json-loader":{"version":"0.5.7","resolved":"https://registry.npmjs.org/json-loader/-/json-loader-0.5.7.tgz","integrity":"sha512-QLPs8Dj7lnf3e3QYS1zkCo+4ZwqOiF9d/nZnYozTISxXWCfNs9yuky5rJw4/W34s7POaNlbZmQGaB5NiXCbP4w==","dev":true},"json-stable-stringify":{"version":"1.0.1","resolved":"https://registry.npmjs.org/json-stable-stringify/-/json-stable-stringify-1.0.1.tgz","integrity":"sha1-mnWdOcXy/1A/1TAGRu1EX4jE+a8=","dev":true,"requires":{"jsonify":"0.0.0"}},"json5":{"version":"0.5.1","resolved":"https://registry.npmjs.org/json5/-/json5-0.5.1.tgz","integrity":"sha1-Hq3nrMASA0rYTiOWdn6tn6VJWCE="},"jsonify":{"version":"0.0.0","resolved":"https://registry.npmjs.org/jsonify/-/jsonify-0.0.0.tgz","integrity":"sha1-LHS27kHZPKUbe1qu6PUDYx0lKnM=","dev":true},"kind-of":{"version":"3.2.2","resolved":"https://registry.npmjs.org/kind-of/-/kind-of-3.2.2.tgz","integrity":"sha1-MeohpzS6ubuw8yRm2JOupR5KPGQ=","requires":{"is-buffer":"1.1.6"}},"lazy-cache":{"version":"1.0.4","resolved":"https://registry.npmjs.org/lazy-cache/-/lazy-cache-1.0.4.tgz","integrity":"sha1-odePw6UEdMuAhF07O24dpJpEbo4=","dev":true},"lcid":{"version":"1.0.0","resolved":"https://registry.npmjs.org/lcid/-/lcid-1.0.0.tgz","integrity":"sha1-MIrMr6C8SDo4Z7S28rlQYlHRuDU=","dev":true,"requires":{"invert-kv":"1.0.0"}},"load-json-file":{"version":"1.1.0","resolved":"https://registry.npmjs.org/load-json-file/-/load-json-file-1.1.0.tgz","integrity":"sha1-lWkFcI1YtLq0wiYbBPWfMcmTdMA=","dev":true,"requires":{"graceful-fs":"4.1.11","parse-json":"2.2.0","pify":"2.3.0","pinkie-promise":"2.0.1","strip-bom":"2.0.0"},"dependencies":{"pify":{"version":"2.3.0","resolved":"https://registry.npmjs.org/pify/-/pify-2.3.0.tgz","integrity":"sha1-7RQaasBDqEnqWISY59yosVMw6Qw=","dev":true}}},"loader-runner":{"version":"2.3.0","resolved":"https://registry.npmjs.org/loader-runner/-/loader-runner-2.3.0.tgz","integrity":"sha1-9IKuqC1UPgeSFwDVpG7yb9rGuKI=","dev":true},"loader-utils":{"version":"0.2.17","resolved":"https://registry.npmjs.org/loader-utils/-/loader-utils-0.2.17.tgz","integrity":"sha1-+G5jdNQyBabmxg6RlvF8Apm/s0g=","requires":{"big.js":"3.2.0","emojis-list":"2.1.0","json5":"0.5.1","object-assign":"4.1.1"}},"lodash":{"version":"4.17.4","resolved":"https://registry.npmjs.org/lodash/-/lodash-4.17.4.tgz","integrity":"sha1-eCA6TRwyiuHYbcpkYONptX9AVa4="},"lodash.assignin":{"version":"4.2.0","resolved":"https://registry.npmjs.org/lodash.assignin/-/lodash.assignin-4.2.0.tgz","integrity":"sha1-uo31+4QesKPoBEIysOJjqNxqKKI=","dev":true},"lodash.bind":{"version":"4.2.1","resolved":"https://registry.npmjs.org/lodash.bind/-/lodash.bind-4.2.1.tgz","integrity":"sha1-euMBfpOWIqwxt9fX3LGzTbFpDTU=","dev":true},"lodash.defaults":{"version":"4.2.0","resolved":"https://registry.npmjs.org/lodash.defaults/-/lodash.defaults-4.2.0.tgz","integrity":"sha1-0JF4cW/+pN3p5ft7N/bwgCJ0WAw=","dev":true},"lodash.filter":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.filter/-/lodash.filter-4.6.0.tgz","integrity":"sha1-ZosdSYFgOuHMWm+nYBQ+SAtMSs4=","dev":true},"lodash.flatten":{"version":"4.4.0","resolved":"https://registry.npmjs.org/lodash.flatten/-/lodash.flatten-4.4.0.tgz","integrity":"sha1-8xwiIlqWMtK7+OSt2+8kCqdlph8=","dev":true},"lodash.foreach":{"version":"4.5.0","resolved":"https://registry.npmjs.org/lodash.foreach/-/lodash.foreach-4.5.0.tgz","integrity":"sha1-Gmo16s5AEoDH8G3d7DUWWrJ+PlM=","dev":true},"lodash.map":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.map/-/lodash.map-4.6.0.tgz","integrity":"sha1-dx7Hg540c9nEzeKLGTlMNWL09tM=","dev":true},"lodash.merge":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.merge/-/lodash.merge-4.6.0.tgz","integrity":"sha1-aYhLoUSsM/5plzemCG3v+t0PicU=","dev":true},"lodash.pick":{"version":"4.4.0","resolved":"https://registry.npmjs.org/lodash.pick/-/lodash.pick-4.4.0.tgz","integrity":"sha1-UvBWEP/53tQiYRRB7R/BI6AwAbM=","dev":true},"lodash.reduce":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.reduce/-/lodash.reduce-4.6.0.tgz","integrity":"sha1-8atrg5KZrUj3hKu/R2WW8DuRTTs=","dev":true},"lodash.reject":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.reject/-/lodash.reject-4.6.0.tgz","integrity":"sha1-gNZJLcFHCGS79YNTO2UfQqn1JBU=","dev":true},"lodash.some":{"version":"4.6.0","resolved":"https://registry.npmjs.org/lodash.some/-/lodash.some-4.6.0.tgz","integrity":"sha1-G7nzFO9ri63tE7VJFpsqlF62jk0=","dev":true},"log-symbols":{"version":"1.0.2","resolved":"https://registry.npmjs.org/log-symbols/-/log-symbols-1.0.2.tgz","integrity":"sha1-N2/3tY6jCGoPCfrMdGF+ylAeGhg=","dev":true,"requires":{"chalk":"1.1.3"}},"longest":{"version":"1.0.1","resolved":"https://registry.npmjs.org/longest/-/longest-1.0.1.tgz","integrity":"sha1-MKCy2jj3N3DoKUoNIuZiXtd9AJc=","dev":true},"loose-envify":{"version":"1.3.1","resolved":"https://registry.npmjs.org/loose-envify/-/loose-envify-1.3.1.tgz","integrity":"sha1-0aitM/qc4OcT1l/dCsi3SNR4yEg=","requires":{"js-tokens":"3.0.2"}},"loud-rejection":{"version":"1.6.0","resolved":"https://registry.npmjs.org/loud-rejection/-/loud-rejection-1.6.0.tgz","integrity":"sha1-W0b4AUft7leIcPCG0Eghz5mOVR8=","dev":true,"requires":{"currently-unhandled":"0.4.1","signal-exit":"3.0.2"}},"lowercase-keys":{"version":"1.0.0","resolved":"https://registry.npmjs.org/lowercase-keys/-/lowercase-keys-1.0.0.tgz","integrity":"sha1-TjNms55/VFfjXxMkvfb4jQv8cwY=","dev":true},"lru-cache":{"version":"4.1.1","resolved":"https://registry.npmjs.org/lru-cache/-/lru-cache-4.1.1.tgz","integrity":"sha512-q4spe4KTfsAS1SUHLO0wz8Qiyf1+vMIAgpRYioFYDMNqKfHQbg+AVDH3i4fvpl71/P1L0dBl+fQi+P37UYf0ew==","dev":true,"requires":{"pseudomap":"1.0.2","yallist":"2.1.2"}},"ltcdr":{"version":"2.2.1","resolved":"https://registry.npmjs.org/ltcdr/-/ltcdr-2.2.1.tgz","integrity":"sha1-Wrh60dTB2rjowIu/A37gwZAih88=","dev":true},"map-obj":{"version":"1.0.1","resolved":"https://registry.npmjs.org/map-obj/-/map-obj-1.0.1.tgz","integrity":"sha1-2TPOuSBdgr3PSIb2dCvcK03qFG0=","dev":true},"md5.js":{"version":"1.3.4","resolved":"https://registry.npmjs.org/md5.js/-/md5.js-1.3.4.tgz","integrity":"sha1-6b296UogpawYsENA/Fdk1bCdkB0=","dev":true,"requires":{"hash-base":"3.0.4","inherits":"2.0.3"},"dependencies":{"hash-base":{"version":"3.0.4","resolved":"https://registry.npmjs.org/hash-base/-/hash-base-3.0.4.tgz","integrity":"sha1-X8hoaEfs1zSZQDMZprCj8/auSRg=","dev":true,"requires":{"inherits":"2.0.3","safe-buffer":"5.1.1"}}}},"memory-fs":{"version":"0.4.1","resolved":"https://registry.npmjs.org/memory-fs/-/memory-fs-0.4.1.tgz","integrity":"sha1-OpoguEYlI+RHz7x+i7gO1me/xVI=","dev":true,"requires":{"errno":"0.1.4","readable-stream":"2.3.3"}},"meow":{"version":"3.7.0","resolved":"https://registry.npmjs.org/meow/-/meow-3.7.0.tgz","integrity":"sha1-cstmi0JSKCkKu/qFaJJYcwioAfs=","dev":true,"requires":{"camelcase-keys":"2.1.0","decamelize":"1.2.0","loud-rejection":"1.6.0","map-obj":"1.0.1","minimist":"1.2.0","normalize-package-data":"2.4.0","object-assign":"4.1.1","read-pkg-up":"1.0.1","redent":"1.0.0","trim-newlines":"1.0.0"},"dependencies":{"minimist":{"version":"1.2.0","resolved":"https://registry.npmjs.org/minimist/-/minimist-1.2.0.tgz","integrity":"sha1-o1AIsg9BOD7sH7kU9M1d95omQoQ=","dev":true}}},"micromatch":{"version":"2.3.11","resolved":"https://registry.npmjs.org/micromatch/-/micromatch-2.3.11.tgz","integrity":"sha1-hmd8l9FyCzY0MdBNDRUpO9OMFWU=","requires":{"arr-diff":"2.0.0","array-unique":"0.2.1","braces":"1.8.5","expand-brackets":"0.1.5","extglob":"0.3.2","filename-regex":"2.0.1","is-extglob":"1.0.0","is-glob":"2.0.1","kind-of":"3.2.2","normalize-path":"2.1.1","object.omit":"2.0.1","parse-glob":"3.0.4","regex-cache":"0.4.4"}},"miller-rabin":{"version":"4.0.1","resolved":"https://registry.npmjs.org/miller-rabin/-/miller-rabin-4.0.1.tgz","integrity":"sha512-115fLhvZVqWwHPbClyntxEVfVDfl9DLLTuJvq3g2O/Oxi8AiNouAHvDSzHS0viUJc+V5vm3eq91Xwqn9dp4jRA==","dev":true,"requires":{"bn.js":"4.11.8","brorand":"1.1.0"}},"mimic-response":{"version":"1.0.0","resolved":"https://registry.npmjs.org/mimic-response/-/mimic-response-1.0.0.tgz","integrity":"sha1-3z02Uqc/3ta5sLJBRub9BSNTRY4=","dev":true},"min-document":{"version":"2.19.0","resolved":"https://registry.npmjs.org/min-document/-/min-document-2.19.0.tgz","integrity":"sha1-e9KC4/WELtKVu3SM3Z8f+iyCRoU=","requires":{"dom-walk":"0.1.1"}},"minimalistic-assert":{"version":"1.0.0","resolved":"https://registry.npmjs.org/minimalistic-assert/-/minimalistic-assert-1.0.0.tgz","integrity":"sha1-cCvi3aazf0g2vLP121ZkG2Sh09M=","dev":true},"minimalistic-crypto-utils":{"version":"1.0.1","resolved":"https://registry.npmjs.org/minimalistic-crypto-utils/-/minimalistic-crypto-utils-1.0.1.tgz","integrity":"sha1-9sAMHAsIIkblxNmd+4x8CDsrWCo=","dev":true},"minimatch":{"version":"3.0.4","resolved":"https://registry.npmjs.org/minimatch/-/minimatch-3.0.4.tgz","integrity":"sha512-yJHVQEhyqPLUTgt9B83PXu6W3rx4MvvHvSUvToogpwoGDOUQ+yDrR0HRot+yOCdCO7u4hX3pWft6kWBBcqh0UA==","requires":{"brace-expansion":"1.1.8"}},"minimist":{"version":"0.0.8","resolved":"https://registry.npmjs.org/minimist/-/minimist-0.0.8.tgz","integrity":"sha1-hX/Kv8M5fSYluCKCYuhqp6ARsF0="},"mkdirp":{"version":"0.5.1","resolved":"https://registry.npmjs.org/mkdirp/-/mkdirp-0.5.1.tgz","integrity":"sha1-MAV0OOrGz3+MR2fzhkjWaX11yQM=","requires":{"minimist":"0.0.8"}},"mobx":{"version":"3.3.1","resolved":"https://registry.npmjs.org/mobx/-/mobx-3.3.1.tgz","integrity":"sha1-w4/Booeg3aP11Lhe/hE3/t2dzfA="},"mobx-react":{"version":"4.3.4","resolved":"https://registry.npmjs.org/mobx-react/-/mobx-react-4.3.4.tgz","integrity":"sha1-WM2hBbgBj5v4e9beMzrF6w1cnf4=","requires":{"hoist-non-react-statics":"2.3.1"}},"ms":{"version":"2.0.0","resolved":"https://registry.npmjs.org/ms/-/ms-2.0.0.tgz","integrity":"sha1-VgiurfwAvmwpAd9fmGF4jeDVl8g="},"node-fetch":{"version":"1.7.3","resolved":"https://registry.npmjs.org/node-fetch/-/node-fetch-1.7.3.tgz","integrity":"sha512-NhZ4CsKx7cYm2vSrBAr2PvFOe6sWDf0UYLRqA6svUYg7+/TSfVAu49jYC4BvQ4Sms9SZgdqGBgroqfDhJdTyKQ==","requires":{"encoding":"0.1.12","is-stream":"1.1.0"}},"node-libs-browser":{"version":"2.0.0","resolved":"https://registry.npmjs.org/node-libs-browser/-/node-libs-browser-2.0.0.tgz","integrity":"sha1-o6WeyXAkmFtG6Vg3lkb5bEthZkY=","dev":true,"requires":{"assert":"1.4.1","browserify-zlib":"0.1.4","buffer":"4.9.1","console-browserify":"1.1.0","constants-browserify":"1.0.0","crypto-browserify":"3.12.0","domain-browser":"1.1.7","events":"1.1.1","https-browserify":"0.0.1","os-browserify":"0.2.1","path-browserify":"0.0.0","process":"0.11.10","punycode":"1.4.1","querystring-es3":"0.2.1","readable-stream":"2.3.3","stream-browserify":"2.0.1","stream-http":"2.7.2","string_decoder":"0.10.31","timers-browserify":"2.0.4","tty-browserify":"0.0.0","url":"0.11.0","util":"0.10.3","vm-browserify":"0.0.4"},"dependencies":{"process":{"version":"0.11.10","resolved":"https://registry.npmjs.org/process/-/process-0.11.10.tgz","integrity":"sha1-czIwDoQBYb2j5podHZGn1LwW8YI=","dev":true},"string_decoder":{"version":"0.10.31","resolved":"https://registry.npmjs.org/string_decoder/-/string_decoder-0.10.31.tgz","integrity":"sha1-YuIDvEF2bGwoyfyEMB2rHFMQ+pQ=","dev":true}}},"noms":{"version":"0.0.0","resolved":"https://registry.npmjs.org/noms/-/noms-0.0.0.tgz","integrity":"sha1-2o69nzr51nYJGbJ9nNyAkqczKFk=","dev":true,"requires":{"inherits":"2.0.3","readable-stream":"1.0.34"},"dependencies":{"isarray":{"version":"0.0.1","resolved":"https://registry.npmjs.org/isarray/-/isarray-0.0.1.tgz","integrity":"sha1-ihis/Kmo9Bd+Cav8YDiTmwXR7t8=","dev":true},"readable-stream":{"version":"1.0.34","resolved":"https://registry.npmjs.org/readable-stream/-/readable-stream-1.0.34.tgz","integrity":"sha1-Elgg40vIQtLyqq+v5MKRbuMsFXw=","dev":true,"requires":{"core-util-is":"1.0.2","inherits":"2.0.3","isarray":"0.0.1","string_decoder":"0.10.31"}},"string_decoder":{"version":"0.10.31","resolved":"https://registry.npmjs.org/string_decoder/-/string_decoder-0.10.31.tgz","integrity":"sha1-YuIDvEF2bGwoyfyEMB2rHFMQ+pQ=","dev":true}}},"normalize-package-data":{"version":"2.4.0","resolved":"https://registry.npmjs.org/normalize-package-data/-/normalize-package-data-2.4.0.tgz","integrity":"sha512-9jjUFbTPfEy3R/ad/2oNbKtW9Hgovl5O1FvFWKkKblNXoN/Oou6+9+KKohPK13Yc3/TyunyWhJp6gvRNR/PPAw==","dev":true,"requires":{"hosted-git-info":"2.5.0","is-builtin-module":"1.0.0","semver":"5.4.1","validate-npm-package-license":"3.0.1"}},"normalize-path":{"version":"2.1.1","resolved":"https://registry.npmjs.org/normalize-path/-/normalize-path-2.1.1.tgz","integrity":"sha1-GrKLVW4Zg2Oowab35vogE3/mrtk=","requires":{"remove-trailing-separator":"1.1.0"}},"nth-check":{"version":"1.0.1","resolved":"https://registry.npmjs.org/nth-check/-/nth-check-1.0.1.tgz","integrity":"sha1-mSms32KPwsQQmN6rgqxYDPFJquQ=","dev":true,"requires":{"boolbase":"1.0.0"}},"number-is-nan":{"version":"1.0.1","resolved":"https://registry.npmjs.org/number-is-nan/-/number-is-nan-1.0.1.tgz","integrity":"sha1-CXtgK1NCKlIsGvuHkDGDNpQaAR0="},"numeral":{"version":"2.0.6","resolved":"https://registry.npmjs.org/numeral/-/numeral-2.0.6.tgz","integrity":"sha1-StCAk21EPCVhrtnyGX7//iX05QY="},"object-assign":{"version":"4.1.1","resolved":"https://registry.npmjs.org/object-assign/-/object-assign-4.1.1.tgz","integrity":"sha1-IQmtx5ZYh8/AXLvUQsrIv7s2CGM="},"object-inspect":{"version":"1.1.0","resolved":"https://registry.npmjs.org/object-inspect/-/object-inspect-1.1.0.tgz","integrity":"sha1-NLymRKgPlPi6QaD50JhOr2Os8U0=","dev":true},"object-is":{"version":"1.0.1","resolved":"https://registry.npmjs.org/object-is/-/object-is-1.0.1.tgz","integrity":"sha1-CqYOyZiaCz7Xlc9NBvYs8a1lObY=","dev":true},"object-keys":{"version":"1.0.11","resolved":"https://registry.npmjs.org/object-keys/-/object-keys-1.0.11.tgz","integrity":"sha1-xUYBd4rVYPEULODgG8yotW0TQm0=","dev":true},"object.assign":{"version":"4.0.4","resolved":"https://registry.npmjs.org/object.assign/-/object.assign-4.0.4.tgz","integrity":"sha1-scnMBE7xuf5jYG/BQau7MuFHMMw=","dev":true,"requires":{"define-properties":"1.1.2","function-bind":"1.1.1","object-keys":"1.0.11"}},"object.entries":{"version":"1.0.4","resolved":"https://registry.npmjs.org/object.entries/-/object.entries-1.0.4.tgz","integrity":"sha1-G/mk3SKI9bM/Opk9JXZh8F0WGl8=","dev":true,"requires":{"define-properties":"1.1.2","es-abstract":"1.9.0","function-bind":"1.1.1","has":"1.0.1"}},"object.omit":{"version":"2.0.1","resolved":"https://registry.npmjs.org/object.omit/-/object.omit-2.0.1.tgz","integrity":"sha1-Gpx0SCnznbuFjHbKNXmuKlTr0fo=","requires":{"for-own":"0.1.5","is-extendable":"0.1.1"}},"object.values":{"version":"1.0.4","resolved":"https://registry.npmjs.org/object.values/-/object.values-1.0.4.tgz","integrity":"sha1-5STaCbT2b/Bd9FdUbscqyZ8TBpo=","dev":true,"requires":{"define-properties":"1.1.2","es-abstract":"1.9.0","function-bind":"1.1.1","has":"1.0.1"}},"once":{"version":"1.4.0","resolved":"https://registry.npmjs.org/once/-/once-1.4.0.tgz","integrity":"sha1-WDsap3WWHUsROsF9nFC6753Xa9E=","requires":{"wrappy":"1.0.2"}},"os-browserify":{"version":"0.2.1","resolved":"https://registry.npmjs.org/os-browserify/-/os-browserify-0.2.1.tgz","integrity":"sha1-Y/xMzuXS13Y9Jrv4YBB45sLgBE8=","dev":true},"os-homedir":{"version":"1.0.2","resolved":"https://registry.npmjs.org/os-homedir/-/os-homedir-1.0.2.tgz","integrity":"sha1-/7xJiDNuDoM94MFox+8VISGqf7M="},"os-locale":{"version":"1.4.0","resolved":"https://registry.npmjs.org/os-locale/-/os-locale-1.4.0.tgz","integrity":"sha1-IPnxeuKe00XoveWDsT0gCYA8FNk=","dev":true,"requires":{"lcid":"1.0.0"}},"os-tmpdir":{"version":"1.0.2","resolved":"https://registry.npmjs.org/os-tmpdir/-/os-tmpdir-1.0.2.tgz","integrity":"sha1-u+Z0BseaqFxc/sdm/lc0VV36EnQ="},"output-file-sync":{"version":"1.1.2","resolved":"https://registry.npmjs.org/output-file-sync/-/output-file-sync-1.1.2.tgz","integrity":"sha1-0KM+7+YaIF+suQCS6CZZjVJFznY=","requires":{"graceful-fs":"4.1.11","mkdirp":"0.5.1","object-assign":"4.1.1"}},"p-any":{"version":"1.1.0","resolved":"https://registry.npmjs.org/p-any/-/p-any-1.1.0.tgz","integrity":"sha512-Ef0tVa4CZ5pTAmKn+Cg3w8ABBXh+hHO1aV8281dKOoUHfX+3tjG2EaFcC+aZyagg9b4EYGsHEjz21DnEE8Og2g==","dev":true,"requires":{"p-some":"2.0.0"}},"p-cancelable":{"version":"0.3.0","resolved":"https://registry.npmjs.org/p-cancelable/-/p-cancelable-0.3.0.tgz","integrity":"sha512-RVbZPLso8+jFeq1MfNvgXtCRED2raz/dKpacfTNxsx6pLEpEomM7gah6VeHSYV3+vo0OAi4MkArtQcWWXuQoyw==","dev":true},"p-finally":{"version":"1.0.0","resolved":"https://registry.npmjs.org/p-finally/-/p-finally-1.0.0.tgz","integrity":"sha1-P7z7FbiZpEEjs0ttzBi3JDNqLK4=","dev":true},"p-some":{"version":"2.0.0","resolved":"https://registry.npmjs.org/p-some/-/p-some-2.0.0.tgz","integrity":"sha512-CsRc5gwQNJgSh+pNaGUtgBWBSh9btl8jYLbIdeqLgOLAATZmDDX7xTS5V0mqJk5Dw0gz8FF6s8sAF4D0MvxLhw==","dev":true,"requires":{"aggregate-error":"1.0.0"}},"p-timeout":{"version":"1.2.0","resolved":"https://registry.npmjs.org/p-timeout/-/p-timeout-1.2.0.tgz","integrity":"sha1-mCD5lDTFgXhotPNICe5SkWYNW2w=","dev":true,"requires":{"p-finally":"1.0.0"}},"pako":{"version":"0.2.9","resolved":"https://registry.npmjs.org/pako/-/pako-0.2.9.tgz","integrity":"sha1-8/dSL073gjSNqBYbrZ7P1Rv4OnU=","dev":true},"parse-asn1":{"version":"5.1.0","resolved":"https://registry.npmjs.org/parse-asn1/-/parse-asn1-5.1.0.tgz","integrity":"sha1-N8T5t+06tlx0gXtfJICTf7+XxxI=","dev":true,"requires":{"asn1.js":"4.9.2","browserify-aes":"1.1.1","create-hash":"1.1.3","evp_bytestokey":"1.0.3","pbkdf2":"3.0.14"}},"parse-glob":{"version":"3.0.4","resolved":"https://registry.npmjs.org/parse-glob/-/parse-glob-3.0.4.tgz","integrity":"sha1-ssN2z7EfNVE7rdFz7wu246OIORw=","requires":{"glob-base":"0.3.0","is-dotfile":"1.0.3","is-extglob":"1.0.0","is-glob":"2.0.1"}},"parse-import":{"version":"2.0.0","resolved":"https://registry.npmjs.org/parse-import/-/parse-import-2.0.0.tgz","integrity":"sha1-KyR0Aw4AirmNt2xLy/TbWucwb18=","dev":true,"requires":{"get-imports":"1.0.0"}},"parse-json":{"version":"2.2.0","resolved":"https://registry.npmjs.org/parse-json/-/parse-json-2.2.0.tgz","integrity":"sha1-9ID0BDTvgHQfhGkJn43qGPVaTck=","dev":true,"requires":{"error-ex":"1.3.1"}},"path-browserify":{"version":"0.0.0","resolved":"https://registry.npmjs.org/path-browserify/-/path-browserify-0.0.0.tgz","integrity":"sha1-oLhwcpquIUAFt9UDLsLLuw+0RRo=","dev":true},"path-exists":{"version":"2.1.0","resolved":"https://registry.npmjs.org/path-exists/-/path-exists-2.1.0.tgz","integrity":"sha1-D+tsZPD8UY2adU3V77YscCJ2H0s=","requires":{"pinkie-promise":"2.0.1"}},"path-is-absolute":{"version":"1.0.1","resolved":"https://registry.npmjs.org/path-is-absolute/-/path-is-absolute-1.0.1.tgz","integrity":"sha1-F0uSaHNVNP+8es5r9TpanhtcX18="},"path-type":{"version":"1.1.0","resolved":"https://registry.npmjs.org/path-type/-/path-type-1.1.0.tgz","integrity":"sha1-WcRPfuSR2nBNpBXaWkBwuk+P5EE=","dev":true,"requires":{"graceful-fs":"4.1.11","pify":"2.3.0","pinkie-promise":"2.0.1"},"dependencies":{"pify":{"version":"2.3.0","resolved":"https://registry.npmjs.org/pify/-/pify-2.3.0.tgz","integrity":"sha1-7RQaasBDqEnqWISY59yosVMw6Qw=","dev":true}}},"pbkdf2":{"version":"3.0.14","resolved":"https://registry.npmjs.org/pbkdf2/-/pbkdf2-3.0.14.tgz","integrity":"sha512-gjsZW9O34fm0R7PaLHRJmLLVfSoesxztjPjE9o6R+qtVJij90ltg1joIovN9GKrRW3t1PzhDDG3UMEMFfZ+1wA==","dev":true,"requires":{"create-hash":"1.1.3","create-hmac":"1.1.6","ripemd160":"2.0.1","safe-buffer":"5.1.1","sha.js":"2.4.9"}},"pify":{"version":"3.0.0","resolved":"https://registry.npmjs.org/pify/-/pify-3.0.0.tgz","integrity":"sha1-5aSs0sEB/fPZpNB/DbxNtJ3SgXY=","dev":true},"pinkie":{"version":"2.0.4","resolved":"https://registry.npmjs.org/pinkie/-/pinkie-2.0.4.tgz","integrity":"sha1-clVrgM+g1IqXToDnckjoDtT3+HA="},"pinkie-promise":{"version":"2.0.1","resolved":"https://registry.npmjs.org/pinkie-promise/-/pinkie-promise-2.0.1.tgz","integrity":"sha1-ITXW36ejWMBprJsXh3YogihFD/o=","requires":{"pinkie":"2.0.4"}},"pkg-dir":{"version":"1.0.0","resolved":"https://registry.npmjs.org/pkg-dir/-/pkg-dir-1.0.0.tgz","integrity":"sha1-ektQio1bstYp1EcFb/TpyTFM89Q=","requires":{"find-up":"1.1.2"}},"port-numbers":{"version":"2.0.10","resolved":"https://registry.npmjs.org/port-numbers/-/port-numbers-2.0.10.tgz","integrity":"sha512-Z7N66rFXnfSea13A2D9XegJR+93iF24Uc/6dO0DNFiN7VVCaDxQW4it6NxVnVJoDfib5xPNS+YG6DdXV/FXDuA==","dev":true},"prepend-http":{"version":"1.0.4","resolved":"https://registry.npmjs.org/prepend-http/-/prepend-http-1.0.4.tgz","integrity":"sha1-1PRWKwzjaW5BrFLQ4ALlemNdxtw=","dev":true},"preserve":{"version":"0.2.0","resolved":"https://registry.npmjs.org/preserve/-/preserve-0.2.0.tgz","integrity":"sha1-gV7R9uvGWSb4ZbMQwHE7yzMVzks="},"private":{"version":"0.1.8","resolved":"https://registry.npmjs.org/private/-/private-0.1.8.tgz","integrity":"sha512-VvivMrbvd2nKkiG38qjULzlc+4Vx4wm/whI9pQD35YrARNnhxeiRktSOhSukRLFNlzg6Br/cJPet5J/u19r/mg=="},"process":{"version":"0.5.2","resolved":"https://registry.npmjs.org/process/-/process-0.5.2.tgz","integrity":"sha1-FjjYqONML0QKkduVq5rrZ3/Bhc8="},"process-nextick-args":{"version":"1.0.7","resolved":"https://registry.npmjs.org/process-nextick-args/-/process-nextick-args-1.0.7.tgz","integrity":"sha1-FQ4gt1ZZCtP5EJPyWk8q2L/zC6M="},"promise":{"version":"7.3.1","resolved":"https://registry.npmjs.org/promise/-/promise-7.3.1.tgz","integrity":"sha512-nolQXZ/4L+bP/UGlkfaIujX9BKxGwmQ9OT4mOt5yvy8iK1h3wqTEJCijzGANTCCl9nWjY41juyAn2K3Q1hLLTg==","requires":{"asap":"2.0.6"}},"prop-types":{"version":"15.6.0","resolved":"https://registry.npmjs.org/prop-types/-/prop-types-15.6.0.tgz","integrity":"sha1-zq8IMCL8RrSjX2nhPvda7Q1jmFY=","requires":{"fbjs":"0.8.16","loose-envify":"1.3.1","object-assign":"4.1.1"}},"prr":{"version":"0.0.0","resolved":"https://registry.npmjs.org/prr/-/prr-0.0.0.tgz","integrity":"sha1-GoS4WQgyVQFBGFPQCB7j+obikmo=","dev":true},"pseudomap":{"version":"1.0.2","resolved":"https://registry.npmjs.org/pseudomap/-/pseudomap-1.0.2.tgz","integrity":"sha1-8FKijacOYYkX7wqKw0wa5aaChrM=","dev":true},"public-encrypt":{"version":"4.0.0","resolved":"https://registry.npmjs.org/public-encrypt/-/public-encrypt-4.0.0.tgz","integrity":"sha1-OfaZ86RlYN1eusvKaTyvfGXBjMY=","dev":true,"requires":{"bn.js":"4.11.8","browserify-rsa":"4.0.1","create-hash":"1.1.3","parse-asn1":"5.1.0","randombytes":"2.0.5"}},"punycode":{"version":"1.4.1","resolved":"https://registry.npmjs.org/punycode/-/punycode-1.4.1.tgz","integrity":"sha1-wNWmOycYgArY4esPpSachN1BhF4=","dev":true},"querystring":{"version":"0.2.0","resolved":"https://registry.npmjs.org/querystring/-/querystring-0.2.0.tgz","integrity":"sha1-sgmEkgO7Jd+CDadW50cAWHhSFiA=","dev":true},"querystring-es3":{"version":"0.2.1","resolved":"https://registry.npmjs.org/querystring-es3/-/querystring-es3-0.2.1.tgz","integrity":"sha1-nsYfeQSYdXB9aUFFlv2Qek1xHnM=","dev":true},"querystringify":{"version":"1.0.0","resolved":"https://registry.npmjs.org/querystringify/-/querystringify-1.0.0.tgz","integrity":"sha1-YoYkIRLFtxL6ZU5SZlK/ahP/Bcs=","dev":true},"random-item":{"version":"1.0.0","resolved":"https://registry.npmjs.org/random-item/-/random-item-1.0.0.tgz","integrity":"sha1-Fu4xYmywUMihaGpfD0KmuZoqrxE=","dev":true},"randomatic":{"version":"1.1.7","resolved":"https://registry.npmjs.org/randomatic/-/randomatic-1.1.7.tgz","integrity":"sha512-D5JUjPyJbaJDkuAazpVnSfVkLlpeO3wDlPROTMLGKG1zMFNFRgrciKo1ltz/AzNTkqE0HzDx655QOL51N06how==","requires":{"is-number":"3.0.0","kind-of":"4.0.0"},"dependencies":{"is-number":{"version":"3.0.0","resolved":"https://registry.npmjs.org/is-number/-/is-number-3.0.0.tgz","integrity":"sha1-JP1iAaR4LPUFYcgQJ2r8fRLXEZU=","requires":{"kind-of":"3.2.2"},"dependencies":{"kind-of":{"version":"3.2.2","resolved":"https://registry.npmjs.org/kind-of/-/kind-of-3.2.2.tgz","integrity":"sha1-MeohpzS6ubuw8yRm2JOupR5KPGQ=","requires":{"is-buffer":"1.1.6"}}}},"kind-of":{"version":"4.0.0","resolved":"https://registry.npmjs.org/kind-of/-/kind-of-4.0.0.tgz","integrity":"sha1-IIE989cSkosgc3hpGkUGb65y3Vc=","requires":{"is-buffer":"1.1.6"}}}},"randombytes":{"version":"2.0.5","resolved":"https://registry.npmjs.org/randombytes/-/randombytes-2.0.5.tgz","integrity":"sha512-8T7Zn1AhMsQ/HI1SjcCfT/t4ii3eAqco3yOcSzS4mozsOz69lHLsoMXmF9nZgnFanYscnSlUSgs8uZyKzpE6kg==","dev":true,"requires":{"safe-buffer":"5.1.1"}},"randomfill":{"version":"1.0.3","resolved":"https://registry.npmjs.org/randomfill/-/randomfill-1.0.3.tgz","integrity":"sha512-YL6GrhrWoic0Eq8rXVbMptH7dAxCs0J+mh5Y0euNekPPYaxEmdVGim6GdoxoRzKW2yJoU8tueifS7mYxvcFDEQ==","dev":true,"requires":{"randombytes":"2.0.5","safe-buffer":"5.1.1"}},"react":{"version":"15.6.2","resolved":"https://registry.npmjs.org/react/-/react-15.6.2.tgz","integrity":"sha1-26BDSrQ5z+gvEI8PURZjkIF5qnI=","requires":{"create-react-class":"15.6.2","fbjs":"0.8.16","loose-envify":"1.3.1","object-assign":"4.1.1","prop-types":"15.6.0"}},"react-deep-force-update":{"version":"2.1.1","resolved":"https://registry.npmjs.org/react-deep-force-update/-/react-deep-force-update-2.1.1.tgz","integrity":"sha1-jqQmPNZFWgULN0RbPwj9g52G6Qk="},"react-dom":{"version":"15.6.2","resolved":"https://registry.npmjs.org/react-dom/-/react-dom-15.6.2.tgz","integrity":"sha1-Qc+t9pO3V/rycIRDodH9WgK+9zA=","requires":{"fbjs":"0.8.16","loose-envify":"1.3.1","object-assign":"4.1.1","prop-types":"15.6.0"}},"react-hot-loader":{"version":"3.1.2","resolved":"https://registry.npmjs.org/react-hot-loader/-/react-hot-loader-3.1.2.tgz","integrity":"sha512-dYCpizEIJyXzoXThSNGnmgjMYLg+jceTK5awYKfKtyeadXse8aw5PDOTwDtL99K66WYr4XvJQw/G1a0o3X78Ew==","requires":{"global":"4.3.2","react-deep-force-update":"2.1.1","react-proxy":"3.0.0-alpha.1","redbox-react":"1.5.0","source-map":"0.6.1"},"dependencies":{"source-map":{"version":"0.6.1","resolved":"https://registry.npmjs.org/source-map/-/source-map-0.6.1.tgz","integrity":"sha512-UjgapumWlbMhkBgzT7Ykc5YXUT46F0iKu8SGXq0bcwP5dz/h0Plj6enJqjz1Zbq2l5WaqYnrVbwWOWMyF3F47g=="}}},"react-proxy":{"version":"3.0.0-alpha.1","resolved":"https://registry.npmjs.org/react-proxy/-/react-proxy-3.0.0-alpha.1.tgz","integrity":"sha1-RABCa8+oDKpnJMd1VpUxUgn6Swc=","requires":{"lodash":"4.17.4"}},"react-test-renderer":{"version":"15.6.2","resolved":"https://registry.npmjs.org/react-test-renderer/-/react-test-renderer-15.6.2.tgz","integrity":"sha1-0DM0NPwsQ4CSaWyncNpe1IA376g=","dev":true,"requires":{"fbjs":"0.8.16","object-assign":"4.1.1"}},"react-trix":{"version":"0.2.2","resolved":"https://registry.npmjs.org/react-trix/-/react-trix-0.2.2.tgz","integrity":"sha1-wR7sx02wiY+2zg1KJOIApOJyNvI=","requires":{"trix":"0.10.2"}},"read-pkg":{"version":"1.1.0","resolved":"https://registry.npmjs.org/read-pkg/-/read-pkg-1.1.0.tgz","integrity":"sha1-9f+qXs0pyzHAR0vKfXVra7KePyg=","dev":true,"requires":{"load-json-file":"1.1.0","normalize-package-data":"2.4.0","path-type":"1.1.0"}},"read-pkg-up":{"version":"1.0.1","resolved":"https://registry.npmjs.org/read-pkg-up/-/read-pkg-up-1.0.1.tgz","integrity":"sha1-nWPBMnbAZZGNV/ACpX9AobZD+wI=","dev":true,"requires":{"find-up":"1.1.2","read-pkg":"1.1.0"}},"readable-stream":{"version":"2.3.3","resolved":"https://registry.npmjs.org/readable-stream/-/readable-stream-2.3.3.tgz","integrity":"sha512-m+qzzcn7KUxEmd1gMbchF+Y2eIUbieUaxkWtptyHywrX0rE8QEYqPC07Vuy4Wm32/xE16NcdBctb8S0Xe/5IeQ==","requires":{"core-util-is":"1.0.2","inherits":"2.0.3","isarray":"1.0.0","process-nextick-args":"1.0.7","safe-buffer":"5.1.1","string_decoder":"1.0.3","util-deprecate":"1.0.2"}},"readdirp":{"version":"2.1.0","resolved":"https://registry.npmjs.org/readdirp/-/readdirp-2.1.0.tgz","integrity":"sha1-TtCtBg3zBzMAxIRANz9y0cxkLXg=","requires":{"graceful-fs":"4.1.11","minimatch":"3.0.4","readable-stream":"2.3.3","set-immediate-shim":"1.0.1"}},"redbox-react":{"version":"1.5.0","resolved":"https://registry.npmjs.org/redbox-react/-/redbox-react-1.5.0.tgz","integrity":"sha512-mdxArOI3sF8K5Nay5NG+lv/VW516TbXjjd4h1wcV1Iy4IMDQPnCayjoQXBAycAFSME4nyXRUXCjHxsw2rYpVRw==","requires":{"error-stack-parser":"1.3.6","object-assign":"4.1.1","prop-types":"15.6.0","sourcemapped-stacktrace":"1.1.7"}},"redent":{"version":"1.0.0","resolved":"https://registry.npmjs.org/redent/-/redent-1.0.0.tgz","integrity":"sha1-z5Fqsf1fHxbfsggi3W7H9zDCr94=","dev":true,"requires":{"indent-string":"2.1.0","strip-indent":"1.0.1"},"dependencies":{"indent-string":{"version":"2.1.0","resolved":"https://registry.npmjs.org/indent-string/-/indent-string-2.1.0.tgz","integrity":"sha1-ji1INIdCEhtKghi3oTfppSBJ3IA=","dev":true,"requires":{"repeating":"2.0.1"}}}},"regenerate":{"version":"1.3.3","resolved":"https://registry.npmjs.org/regenerate/-/regenerate-1.3.3.tgz","integrity":"sha512-jVpo1GadrDAK59t/0jRx5VxYWQEDkkEKi6+HjE3joFVLfDOh9Xrdh0dF1eSq+BI/SwvTQ44gSscJ8N5zYL61sg=="},"regenerator-runtime":{"version":"0.11.0","resolved":"https://registry.npmjs.org/regenerator-runtime/-/regenerator-runtime-0.11.0.tgz","integrity":"sha512-/aA0kLeRb5N9K0d4fw7ooEbI+xDe+DKD499EQqygGqeS8N3xto15p09uY2xj7ixP81sNPXvRLnAQIqdVStgb1A=="},"regenerator-transform":{"version":"0.10.1","resolved":"https://registry.npmjs.org/regenerator-transform/-/regenerator-transform-0.10.1.tgz","integrity":"sha512-PJepbvDbuK1xgIgnau7Y90cwaAmO/LCLMI2mPvaXq2heGMR3aWW5/BQvYrhJ8jgmQjXewXvBjzfqKcVOmhjZ6Q==","requires":{"babel-runtime":"6.26.0","babel-types":"6.26.0","private":"0.1.8"}},"regex-cache":{"version":"0.4.4","resolved":"https://registry.npmjs.org/regex-cache/-/regex-cache-0.4.4.tgz","integrity":"sha512-nVIZwtCjkC9YgvWkpM55B5rBhBYRZhAaJbgcFYXXsHnbZ9UZI9nnVWYZpBlCqv9ho2eZryPnWrZGsOdPwVWXWQ==","requires":{"is-equal-shallow":"0.1.3"}},"regexpu-core":{"version":"2.0.0","resolved":"https://registry.npmjs.org/regexpu-core/-/regexpu-core-2.0.0.tgz","integrity":"sha1-SdA4g3uNz4v6W5pCE5k45uoq4kA=","requires":{"regenerate":"1.3.3","regjsgen":"0.2.0","regjsparser":"0.1.5"}},"regjsgen":{"version":"0.2.0","resolved":"https://registry.npmjs.org/regjsgen/-/regjsgen-0.2.0.tgz","integrity":"sha1-bAFq3qxVT3WCP+N6wFuS1aTtsfc="},"regjsparser":{"version":"0.1.5","resolved":"https://registry.npmjs.org/regjsparser/-/regjsparser-0.1.5.tgz","integrity":"sha1-fuj4Tcb6eS0/0K4ijSS9lJ6tIFw=","requires":{"jsesc":"0.5.0"},"dependencies":{"jsesc":{"version":"0.5.0","resolved":"https://registry.npmjs.org/jsesc/-/jsesc-0.5.0.tgz","integrity":"sha1-597mbjXW/Bb3EP6R1c9p9w8IkR0="}}},"remove-trailing-separator":{"version":"1.1.0","resolved":"https://registry.npmjs.org/remove-trailing-separator/-/remove-trailing-separator-1.1.0.tgz","integrity":"sha1-wkvOKig62tW8P1jg1IJJuSN52O8="},"repeat-element":{"version":"1.1.2","resolved":"https://registry.npmjs.org/repeat-element/-/repeat-element-1.1.2.tgz","integrity":"sha1-7wiaF40Ug7quTZPrmLT55OEdmQo="},"repeat-string":{"version":"1.6.1","resolved":"https://registry.npmjs.org/repeat-string/-/repeat-string-1.6.1.tgz","integrity":"sha1-jcrkcOHIirwtYA//Sndihtp15jc="},"repeating":{"version":"2.0.1","resolved":"https://registry.npmjs.org/repeating/-/repeating-2.0.1.tgz","integrity":"sha1-UhTFOpJtNVJwdSf7q0FdvAjQbdo=","requires":{"is-finite":"1.0.2"}},"require-directory":{"version":"2.1.1","resolved":"https://registry.npmjs.org/require-directory/-/require-directory-2.1.1.tgz","integrity":"sha1-jGStX9MNqxyXbiNE/+f3kqam30I=","dev":true},"require-main-filename":{"version":"1.0.1","resolved":"https://registry.npmjs.org/require-main-filename/-/require-main-filename-1.0.1.tgz","integrity":"sha1-l/cXtp1IeE9fUmpsWqj/3aBVpNE=","dev":true},"requires-port":{"version":"1.0.0","resolved":"https://registry.npmjs.org/requires-port/-/requires-port-1.0.0.tgz","integrity":"sha1-kl0mAdOaxIXgkc8NpcbmlNw9yv8=","dev":true},"resolve":{"version":"1.1.7","resolved":"https://registry.npmjs.org/resolve/-/resolve-1.1.7.tgz","integrity":"sha1-IDEU2CrSxe2ejgQRs5ModeiJ6Xs=","dev":true},"resolve-url":{"version":"0.2.1","resolved":"https://registry.npmjs.org/resolve-url/-/resolve-url-0.2.1.tgz","integrity":"sha1-LGN/53yJOv0qZj/iGqkIAGjiBSo=","dev":true},"resumer":{"version":"0.0.0","resolved":"https://registry.npmjs.org/resumer/-/resumer-0.0.0.tgz","integrity":"sha1-8ej0YeQGS6Oegq883CqMiT0HZ1k=","dev":true,"requires":{"through":"2.3.8"}},"rework":{"version":"1.0.1","resolved":"https://registry.npmjs.org/rework/-/rework-1.0.1.tgz","integrity":"sha1-MIBqhBNCtUUQqkEQhQzUhTQUSqc=","dev":true,"requires":{"convert-source-map":"0.3.5","css":"2.2.1"},"dependencies":{"convert-source-map":{"version":"0.3.5","resolved":"https://registry.npmjs.org/convert-source-map/-/convert-source-map-0.3.5.tgz","integrity":"sha1-8dgClQr33SYxof6+BZZVDIarMZA=","dev":true}}},"rework-import":{"version":"2.1.0","resolved":"https://registry.npmjs.org/rework-import/-/rework-import-2.1.0.tgz","integrity":"sha1-wm7StTFZrHvi7GDaIj74lgPB7x8=","dev":true,"requires":{"css":"2.2.1","globby":"2.1.0","parse-import":"2.0.0","url-regex":"3.2.0"}},"right-align":{"version":"0.1.3","resolved":"https://registry.npmjs.org/right-align/-/right-align-0.1.3.tgz","integrity":"sha1-YTObci/mo1FWiSENJOFMlhSGE+8=","dev":true,"requires":{"align-text":"0.1.4"}},"ripemd160":{"version":"2.0.1","resolved":"https://registry.npmjs.org/ripemd160/-/ripemd160-2.0.1.tgz","integrity":"sha1-D0WEKVxTo2KK9+bXmsohzlfRxuc=","dev":true,"requires":{"hash-base":"2.0.2","inherits":"2.0.3"}},"root-hints":{"version":"1.0.15","resolved":"https://registry.npmjs.org/root-hints/-/root-hints-1.0.15.tgz","integrity":"sha1-+xF75MW/f8FQYg2rLIf4Dc8MwnI=","dev":true},"router-ips":{"version":"1.0.0","resolved":"https://registry.npmjs.org/router-ips/-/router-ips-1.0.0.tgz","integrity":"sha1-ROAIWOvrwBM9WOQLLNih+7BCA/U=","dev":true},"safe-buffer":{"version":"5.1.1","resolved":"https://registry.npmjs.org/safe-buffer/-/safe-buffer-5.1.1.tgz","integrity":"sha512-kKvNJn6Mm93gAczWVJg7wH+wGYWNrDHdWvpUmHyEsgCtIwwo3bqPtV4tR5tuPaUhTOo/kvhVwd8XwwOllGYkbg=="},"semver":{"version":"5.4.1","resolved":"https://registry.npmjs.org/semver/-/semver-5.4.1.tgz","integrity":"sha512-WfG/X9+oATh81XtllIo/I8gOiY9EXRdv1cQdyykeXK17YcUW3EXUAi2To4pcH6nZtJPr7ZOpM5OMyWJZm+8Rsg==","dev":true},"set-blocking":{"version":"2.0.0","resolved":"https://registry.npmjs.org/set-blocking/-/set-blocking-2.0.0.tgz","integrity":"sha1-BF+XgtARrppoA93TgrJDkrPYkPc=","dev":true},"set-immediate-shim":{"version":"1.0.1","resolved":"https://registry.npmjs.org/set-immediate-shim/-/set-immediate-shim-1.0.1.tgz","integrity":"sha1-SysbJ+uAip+NzEgaWOXlb1mfP2E="},"setimmediate":{"version":"1.0.5","resolved":"https://registry.npmjs.org/setimmediate/-/setimmediate-1.0.5.tgz","integrity":"sha1-KQy7Iy4waULX1+qbg3Mqt4VvgoU="},"sha.js":{"version":"2.4.9","resolved":"https://registry.npmjs.org/sha.js/-/sha.js-2.4.9.tgz","integrity":"sha512-G8zektVqbiPHrylgew9Zg1VRB1L/DtXNUVAM6q4QLy8NE3qtHlFXTf8VLL4k1Yl6c7NMjtZUTdXV+X44nFaT6A==","dev":true,"requires":{"inherits":"2.0.3","safe-buffer":"5.1.1"}},"shebang-command":{"version":"1.2.0","resolved":"https://registry.npmjs.org/shebang-command/-/shebang-command-1.2.0.tgz","integrity":"sha1-RKrGW2lbAzmJaMOfNj/uXer98eo=","dev":true,"requires":{"shebang-regex":"1.0.0"}},"shebang-regex":{"version":"1.0.0","resolved":"https://registry.npmjs.org/shebang-regex/-/shebang-regex-1.0.0.tgz","integrity":"sha1-2kL0l0DAtC2yypcoVxyxkMmO/qM=","dev":true},"signal-exit":{"version":"3.0.2","resolved":"https://registry.npmjs.org/signal-exit/-/signal-exit-3.0.2.tgz","integrity":"sha1-tf3AjxKH6hF4Yo5BXiUTK3NkbG0=","dev":true},"slash":{"version":"1.0.0","resolved":"https://registry.npmjs.org/slash/-/slash-1.0.0.tgz","integrity":"sha1-xB8vbDn8FtHNF61LXYlhFK5HDVU="},"source-list-map":{"version":"2.0.0","resolved":"https://registry.npmjs.org/source-list-map/-/source-list-map-2.0.0.tgz","integrity":"sha512-I2UmuJSRr/T8jisiROLU3A3ltr+swpniSmNPI4Ml3ZCX6tVnDsuZzK7F2hl5jTqbZBWCEKlj5HRQiPExXLgE8A==","dev":true},"source-map":{"version":"0.5.7","resolved":"https://registry.npmjs.org/source-map/-/source-map-0.5.7.tgz","integrity":"sha1-igOdLRAh0i0eoUyA2OpGi6LvP8w="},"source-map-resolve":{"version":"0.3.1","resolved":"https://registry.npmjs.org/source-map-resolve/-/source-map-resolve-0.3.1.tgz","integrity":"sha1-YQ9hIqRFuN1RU1oqcbeD38Ekh2E=","dev":true,"requires":{"atob":"1.1.3","resolve-url":"0.2.1","source-map-url":"0.3.0","urix":"0.1.0"}},"source-map-support":{"version":"0.4.18","resolved":"https://registry.npmjs.org/source-map-support/-/source-map-support-0.4.18.tgz","integrity":"sha512-try0/JqxPLF9nOjvSta7tVondkP5dwgyLDjVoyMDlmjugT2lRZ1OfsrYTkCd2hkDnJTKRbO/Rl3orm8vlsUzbA==","requires":{"source-map":"0.5.7"}},"source-map-url":{"version":"0.3.0","resolved":"https://registry.npmjs.org/source-map-url/-/source-map-url-0.3.0.tgz","integrity":"sha1-fsrxO1e80J2opAxdJp2zN5nUqvk=","dev":true},"sourcemapped-stacktrace":{"version":"1.1.7","resolved":"https://registry.npmjs.org/sourcemapped-stacktrace/-/sourcemapped-stacktrace-1.1.7.tgz","integrity":"sha512-pgHNUACbafkQ+M5zR00NSOtSKBc/i40prgN+SY07J/pghClwVNWNTTMa0JuXj4lriR2TvMKcPAHw5KN9tVFRhA==","requires":{"source-map":"0.5.6"},"dependencies":{"source-map":{"version":"0.5.6","resolved":"https://registry.npmjs.org/source-map/-/source-map-0.5.6.tgz","integrity":"sha1-dc449SvwczxafwwRjYEzSiu19BI="}}},"spdx-correct":{"version":"1.0.2","resolved":"https://registry.npmjs.org/spdx-correct/-/spdx-correct-1.0.2.tgz","integrity":"sha1-SzBz2TP/UfORLwOsVRlJikFQ20A=","dev":true,"requires":{"spdx-license-ids":"1.2.2"}},"spdx-expression-parse":{"version":"1.0.4","resolved":"https://registry.npmjs.org/spdx-expression-parse/-/spdx-expression-parse-1.0.4.tgz","integrity":"sha1-m98vIOH0DtRH++JzJmGR/O1RYmw=","dev":true},"spdx-license-ids":{"version":"1.2.2","resolved":"https://registry.npmjs.org/spdx-license-ids/-/spdx-license-ids-1.2.2.tgz","integrity":"sha1-yd96NCRZSt5r0RkA1ZZpbcBrrFc=","dev":true},"stackframe":{"version":"0.3.1","resolved":"https://registry.npmjs.org/stackframe/-/stackframe-0.3.1.tgz","integrity":"sha1-M6qE8Rd6VUjIk1Uzy/6zQgl19aQ="},"stream-browserify":{"version":"2.0.1","resolved":"https://registry.npmjs.org/stream-browserify/-/stream-browserify-2.0.1.tgz","integrity":"sha1-ZiZu5fm9uZQKTkUUyvtDu3Hlyds=","dev":true,"requires":{"inherits":"2.0.3","readable-stream":"2.3.3"}},"stream-http":{"version":"2.7.2","resolved":"https://registry.npmjs.org/stream-http/-/stream-http-2.7.2.tgz","integrity":"sha512-c0yTD2rbQzXtSsFSVhtpvY/vS6u066PcXOX9kBB3mSO76RiUQzL340uJkGBWnlBg4/HZzqiUXtaVA7wcRcJgEw==","dev":true,"requires":{"builtin-status-codes":"3.0.0","inherits":"2.0.3","readable-stream":"2.3.3","to-arraybuffer":"1.0.1","xtend":"4.0.1"}},"string_decoder":{"version":"1.0.3","resolved":"https://registry.npmjs.org/string_decoder/-/string_decoder-1.0.3.tgz","integrity":"sha512-4AH6Z5fzNNBcH+6XDMfA/BTt87skxqJlO0lAh3Dker5zThcAxG6mKz+iGu308UKoPPQ8Dcqx/4JhujzltRa+hQ==","requires":{"safe-buffer":"5.1.1"}},"string-width":{"version":"1.0.2","resolved":"https://registry.npmjs.org/string-width/-/string-width-1.0.2.tgz","integrity":"sha1-EYvfW4zcUaKn5w0hHgfisLmxB9M=","dev":true,"requires":{"code-point-at":"1.1.0","is-fullwidth-code-point":"1.0.0","strip-ansi":"3.0.1"}},"string.prototype.trim":{"version":"1.1.2","resolved":"https://registry.npmjs.org/string.prototype.trim/-/string.prototype.trim-1.1.2.tgz","integrity":"sha1-0E3iyJ4Tf019IG8Ia17S+ua+jOo=","dev":true,"requires":{"define-properties":"1.1.2","es-abstract":"1.9.0","function-bind":"1.1.1"}},"strip-ansi":{"version":"3.0.1","resolved":"https://registry.npmjs.org/strip-ansi/-/strip-ansi-3.0.1.tgz","integrity":"sha1-ajhfuIU9lS1f8F0Oiq+UJ43GPc8=","requires":{"ansi-regex":"2.1.1"}},"strip-bom":{"version":"2.0.0","resolved":"https://registry.npmjs.org/strip-bom/-/strip-bom-2.0.0.tgz","integrity":"sha1-YhmoVhZSBJHzV4i9vxRHqZx+aw4=","dev":true,"requires":{"is-utf8":"0.2.1"}},"strip-indent":{"version":"1.0.1","resolved":"https://registry.npmjs.org/strip-indent/-/strip-indent-1.0.1.tgz","integrity":"sha1-DHlipq3vp7vUrDZkYKY4VSrhoKI=","dev":true,"requires":{"get-stdin":"4.0.1"}},"supports-color":{"version":"2.0.0","resolved":"https://registry.npmjs.org/supports-color/-/supports-color-2.0.0.tgz","integrity":"sha1-U10EXOa2Nj+kARcIRimZXp3zJMc="},"tapable":{"version":"0.2.8","resolved":"https://registry.npmjs.org/tapable/-/tapable-0.2.8.tgz","integrity":"sha1-mTcqXJmb8t8WCvwNdL7U9HlIzSI=","dev":true},"tape":{"version":"4.5.1","resolved":"https://registry.npmjs.org/tape/-/tape-4.5.1.tgz","integrity":"sha1-K7PqGb3J9SJSF7P5fL95hsxMbow=","dev":true,"requires":{"deep-equal":"1.0.1","defined":"1.0.0","function-bind":"1.1.1","glob":"7.0.6","has":"1.0.1","inherits":"2.0.3","minimist":"1.2.0","object-inspect":"1.1.0","resolve":"1.1.7","resumer":"0.0.0","string.prototype.trim":"1.1.2","through":"2.3.8"},"dependencies":{"glob":{"version":"7.0.6","resolved":"https://registry.npmjs.org/glob/-/glob-7.0.6.tgz","integrity":"sha1-IRuvr0nlJbjNkyYNFKsTYVKz9Xo=","dev":true,"requires":{"fs.realpath":"1.0.0","inflight":"1.0.6","inherits":"2.0.3","minimatch":"3.0.4","once":"1.4.0","path-is-absolute":"1.0.1"}},"minimist":{"version":"1.2.0","resolved":"https://registry.npmjs.org/minimist/-/minimist-1.2.0.tgz","integrity":"sha1-o1AIsg9BOD7sH7kU9M1d95omQoQ=","dev":true}}},"through":{"version":"2.3.8","resolved":"https://registry.npmjs.org/through/-/through-2.3.8.tgz","integrity":"sha1-DdTJ/6q8NXlgsbckEV1+Doai4fU=","dev":true},"through2":{"version":"2.0.3","resolved":"https://registry.npmjs.org/through2/-/through2-2.0.3.tgz","integrity":"sha1-AARWmzfHx0ujnEPzzteNGtlBQL4=","dev":true,"requires":{"readable-stream":"2.3.3","xtend":"4.0.1"}},"timed-out":{"version":"4.0.1","resolved":"https://registry.npmjs.org/timed-out/-/timed-out-4.0.1.tgz","integrity":"sha1-8y6srFoXW+ol1/q1Zas+2HQe9W8=","dev":true},"timers-browserify":{"version":"2.0.4","resolved":"https://registry.npmjs.org/timers-browserify/-/timers-browserify-2.0.4.tgz","integrity":"sha512-uZYhyU3EX8O7HQP+J9fTVYwsq90Vr68xPEFo7yrVImIxYvHgukBEgOB/SgGoorWVTzGM/3Z+wUNnboA4M8jWrg==","dev":true,"requires":{"setimmediate":"1.0.5"}},"to-arraybuffer":{"version":"1.0.1","resolved":"https://registry.npmjs.org/to-arraybuffer/-/to-arraybuffer-1.0.1.tgz","integrity":"sha1-fSKbH8xjfkZsoIEYCDanqr/4P0M=","dev":true},"to-fast-properties":{"version":"1.0.3","resolved":"https://registry.npmjs.org/to-fast-properties/-/to-fast-properties-1.0.3.tgz","integrity":"sha1-uDVx+k2MJbguIxsG46MFXeTKGkc="},"traverse":{"version":"0.6.6","resolved":"https://registry.npmjs.org/traverse/-/traverse-0.6.6.tgz","integrity":"sha1-y99WD9e5r2MlAv7UD5GMFX6pcTc=","dev":true},"trc-debug-runner":{"version":"git+https://gitlab.com/regiscompany/trc-debug-runner.git#0943eaa2f97f3dc251d7044be1d344ce201cd30c","dev":true,"requires":{"ignore-styles":"5.0.1","minimist":"1.2.0"},"dependencies":{"minimist":{"version":"1.2.0","resolved":"https://registry.npmjs.org/minimist/-/minimist-1.2.0.tgz","integrity":"sha1-o1AIsg9BOD7sH7kU9M1d95omQoQ=","dev":true}}},"trc-tagme":{"version":"git+https://gitlab.com/regiscompany/trc-tagme.git#cae7e7da506a24aa087eb6dcab4f42aae32035d1","dev":true,"requires":{"git-tag":"git+https://github.com/cellvia/git-tag.git#26d931a1a6fe7f4f0f655ea36081bb6db447bae7"}},"trim-newlines":{"version":"1.0.0","resolved":"https://registry.npmjs.org/trim-newlines/-/trim-newlines-1.0.0.tgz","integrity":"sha1-WIeWa7WCpFA6QetST301ARgVphM=","dev":true},"trim-right":{"version":"1.0.1","resolved":"https://registry.npmjs.org/trim-right/-/trim-right-1.0.1.tgz","integrity":"sha1-yy4SAwZ+DI3h9hQJS5/kVwTqYAM="},"trix":{"version":"0.10.2","resolved":"https://registry.npmjs.org/trix/-/trix-0.10.2.tgz","integrity":"sha512-TsZvtVmJEOCQzQFauRTYZYAVkmTeOEUBTx3mCoTps2wUw7OTM7gla0nZue/ZYXFqZTOgGjRiCnfAsoY6IEj4qA=="},"tty-browserify":{"version":"0.0.0","resolved":"https://registry.npmjs.org/tty-browserify/-/tty-browserify-0.0.0.tgz","integrity":"sha1-oVe6QC2iTpv5V/mqadUk7tQpAaY=","dev":true},"ua-parser-js":{"version":"0.7.17","resolved":"https://registry.npmjs.org/ua-parser-js/-/ua-parser-js-0.7.17.tgz","integrity":"sha512-uRdSdu1oA1rncCQL7sCj8vSyZkgtL7faaw9Tc9rZ3mGgraQ7+Pdx7w5mnOSF3gw9ZNG6oc+KXfkon3bKuROm0g=="},"uglify-js":{"version":"2.8.29","resolved":"https://registry.npmjs.org/uglify-js/-/uglify-js-2.8.29.tgz","integrity":"sha1-KcVzMUgFe7Th913zW3qcty5qWd0=","dev":true,"requires":{"source-map":"0.5.7","uglify-to-browserify":"1.0.2","yargs":"3.10.0"},"dependencies":{"camelcase":{"version":"1.2.1","resolved":"https://registry.npmjs.org/camelcase/-/camelcase-1.2.1.tgz","integrity":"sha1-m7UwTS4LVmmLLHWLCKPqqdqlijk=","dev":true},"yargs":{"version":"3.10.0","resolved":"https://registry.npmjs.org/yargs/-/yargs-3.10.0.tgz","integrity":"sha1-9+572FfdfB0tOMDnTvvWgdFDH9E=","dev":true,"requires":{"camelcase":"1.2.1","cliui":"2.1.0","decamelize":"1.2.0","window-size":"0.1.0"}}}},"uglify-to-browserify":{"version":"1.0.2","resolved":"https://registry.npmjs.org/uglify-to-browserify/-/uglify-to-browserify-1.0.2.tgz","integrity":"sha1-bgkk1r2mta/jSeOabWMoUKD4grc=","dev":true,"optional":true},"urix":{"version":"0.1.0","resolved":"https://registry.npmjs.org/urix/-/urix-0.1.0.tgz","integrity":"sha1-2pN/emLiH+wf0Y1Js1wpNQZ6bHI=","dev":true},"url":{"version":"0.11.0","resolved":"https://registry.npmjs.org/url/-/url-0.11.0.tgz","integrity":"sha1-ODjpfPxgUh63PFJajlW/3Z4uKPE=","dev":true,"requires":{"punycode":"1.3.2","querystring":"0.2.0"},"dependencies":{"punycode":{"version":"1.3.2","resolved":"https://registry.npmjs.org/punycode/-/punycode-1.3.2.tgz","integrity":"sha1-llOgNvt8HuQjQvIyXM7v6jkmxI0=","dev":true}}},"url-parse":{"version":"1.2.0","resolved":"https://registry.npmjs.org/url-parse/-/url-parse-1.2.0.tgz","integrity":"sha512-DT1XbYAfmQP65M/mE6OALxmXzZ/z1+e5zk2TcSKe/KiYbNGZxgtttzC0mR/sjopbpOXcbniq7eIKmocJnUWlEw==","dev":true,"requires":{"querystringify":"1.0.0","requires-port":"1.0.0"}},"url-parse-lax":{"version":"1.0.0","resolved":"https://registry.npmjs.org/url-parse-lax/-/url-parse-lax-1.0.0.tgz","integrity":"sha1-evjzA2Rem9eaJy56FKxovAYJ2nM=","dev":true,"requires":{"prepend-http":"1.0.4"}},"url-regex":{"version":"3.2.0","resolved":"https://registry.npmjs.org/url-regex/-/url-regex-3.2.0.tgz","integrity":"sha1-260eDJ4p4QXdCx8J9oYvf9tIJyQ=","dev":true,"requires":{"ip-regex":"1.0.3"}},"url-to-options":{"version":"1.0.1","resolved":"https://registry.npmjs.org/url-to-options/-/url-to-options-1.0.1.tgz","integrity":"sha1-FQWgOiiaSMvXpDTvuu7FBV9WM6k=","dev":true},"user-home":{"version":"1.1.1","resolved":"https://registry.npmjs.org/user-home/-/user-home-1.1.1.tgz","integrity":"sha1-K1viOjK2Onyd640PKNSFcko98ZA="},"util":{"version":"0.10.3","resolved":"https://registry.npmjs.org/util/-/util-0.10.3.tgz","integrity":"sha1-evsa/lCAUkZInj23/g7TeTNqwPk=","dev":true,"requires":{"inherits":"2.0.1"},"dependencies":{"inherits":{"version":"2.0.1","resolved":"https://registry.npmjs.org/inherits/-/inherits-2.0.1.tgz","integrity":"sha1-sX0I0ya0Qj5Wjv9xn5GwscvfafE=","dev":true}}},"util-deprecate":{"version":"1.0.2","resolved":"https://registry.npmjs.org/util-deprecate/-/util-deprecate-1.0.2.tgz","integrity":"sha1-RQ1Nyfpw3nMnYvvS1KKJgUGaDM8="},"uuid":{"version":"3.1.0","resolved":"https://registry.npmjs.org/uuid/-/uuid-3.1.0.tgz","integrity":"sha512-DIWtzUkw04M4k3bf1IcpS2tngXEL26YUD2M0tMDUpnUrz2hgzUBlD55a4FjdLGPvfHxS6uluGWvaVEqgBcVa+g==","dev":true},"v8flags":{"version":"2.1.1","resolved":"https://registry.npmjs.org/v8flags/-/v8flags-2.1.1.tgz","integrity":"sha1-qrGh+jDUX4jdMhFIh1rALAtV5bQ=","requires":{"user-home":"1.1.1"}},"validate-npm-package-license":{"version":"3.0.1","resolved":"https://registry.npmjs.org/validate-npm-package-license/-/validate-npm-package-license-3.0.1.tgz","integrity":"sha1-KAS6vnEq0zeUWaz74kdGqywwP7w=","dev":true,"requires":{"spdx-correct":"1.0.2","spdx-expression-parse":"1.0.4"}},"vm-browserify":{"version":"0.0.4","resolved":"https://registry.npmjs.org/vm-browserify/-/vm-browserify-0.0.4.tgz","integrity":"sha1-XX6kW7755Kb/ZflUOOCofDV9WnM=","dev":true,"requires":{"indexof":"0.0.1"}},"watchpack":{"version":"1.4.0","resolved":"https://registry.npmjs.org/watchpack/-/watchpack-1.4.0.tgz","integrity":"sha1-ShRyvLuVK9Cpu0A2gB+VTfs5+qw=","dev":true,"requires":{"async":"2.6.0","chokidar":"1.7.0","graceful-fs":"4.1.11"},"dependencies":{"async":{"version":"2.6.0","resolved":"https://registry.npmjs.org/async/-/async-2.6.0.tgz","integrity":"sha512-xAfGg1/NTLBBKlHFmnd7PlmUW9KhVQIUuSrYem9xzFUZy13ScvtyGGejaae9iAVRiRq9+Cx7DPFaAAhCpyxyPw==","dev":true,"requires":{"lodash":"4.17.4"}}}},"webpack":{"version":"2.7.0","resolved":"https://registry.npmjs.org/webpack/-/webpack-2.7.0.tgz","integrity":"sha512-MjAA0ZqO1ba7ZQJRnoCdbM56mmFpipOPUv/vQpwwfSI42p5PVDdoiuK2AL2FwFUVgT859Jr43bFZXRg/LNsqvg==","dev":true,"requires":{"acorn":"5.2.1","acorn-dynamic-import":"2.0.2","ajv":"4.11.8","ajv-keywords":"1.5.1","async":"2.6.0","enhanced-resolve":"3.4.1","interpret":"1.0.4","json-loader":"0.5.7","json5":"0.5.1","loader-runner":"2.3.0","loader-utils":"0.2.17","memory-fs":"0.4.1","mkdirp":"0.5.1","node-libs-browser":"2.0.0","source-map":"0.5.7","supports-color":"3.2.3","tapable":"0.2.8","uglify-js":"2.8.29","watchpack":"1.4.0","webpack-sources":"1.0.2","yargs":"6.6.0"},"dependencies":{"async":{"version":"2.6.0","resolved":"https://registry.npmjs.org/async/-/async-2.6.0.tgz","integrity":"sha512-xAfGg1/NTLBBKlHFmnd7PlmUW9KhVQIUuSrYem9xzFUZy13ScvtyGGejaae9iAVRiRq9+Cx7DPFaAAhCpyxyPw==","dev":true,"requires":{"lodash":"4.17.4"}},"supports-color":{"version":"3.2.3","resolved":"https://registry.npmjs.org/supports-color/-/supports-color-3.2.3.tgz","integrity":"sha1-ZawFBLOVQXHYpklGsq48u4pfVPY=","dev":true,"requires":{"has-flag":"1.0.0"}}}},"webpack-sources":{"version":"1.0.2","resolved":"https://registry.npmjs.org/webpack-sources/-/webpack-sources-1.0.2.tgz","integrity":"sha512-Y7UddMCv6dGjy81nBv6nuQeFFIt5aalHm7uyDsAsW86nZwfOVPGRr3XMjEQLaT+WKo8rlzhC9qtbJvYKLtAwaw==","dev":true,"requires":{"source-list-map":"2.0.0","source-map":"0.6.1"},"dependencies":{"source-map":{"version":"0.6.1","resolved":"https://registry.npmjs.org/source-map/-/source-map-0.6.1.tgz","integrity":"sha512-UjgapumWlbMhkBgzT7Ykc5YXUT46F0iKu8SGXq0bcwP5dz/h0Plj6enJqjz1Zbq2l5WaqYnrVbwWOWMyF3F47g==","dev":true}}},"whatwg-fetch":{"version":"2.0.3","resolved":"https://registry.npmjs.org/whatwg-fetch/-/whatwg-fetch-2.0.3.tgz","integrity":"sha1-nITsLc9oGH/wC8ZOEnS0QhduHIQ="},"which":{"version":"1.3.0","resolved":"https://registry.npmjs.org/which/-/which-1.3.0.tgz","integrity":"sha512-xcJpopdamTuY5duC/KnTTNBraPK54YwpenP4lzxU8H91GudWpFv38u0CKjclE1Wi2EH2EDz5LRcHcKbCIzqGyg==","dev":true,"requires":{"isexe":"2.0.0"}},"which-module":{"version":"1.0.0","resolved":"https://registry.npmjs.org/which-module/-/which-module-1.0.0.tgz","integrity":"sha1-u6Y8qGGUiZT/MHc2CJ47lgJsKk8=","dev":true},"window-size":{"version":"0.1.0","resolved":"https://registry.npmjs.org/window-size/-/window-size-0.1.0.tgz","integrity":"sha1-VDjNLqk7IC76Ohn+iIeu58lPnJ0=","dev":true},"wordwrap":{"version":"0.0.2","resolved":"https://registry.npmjs.org/wordwrap/-/wordwrap-0.0.2.tgz","integrity":"sha1-t5Zpu0LstAn4PVg8rVLKF+qhZD8=","dev":true},"wrap-ansi":{"version":"2.1.0","resolved":"https://registry.npmjs.org/wrap-ansi/-/wrap-ansi-2.1.0.tgz","integrity":"sha1-2Pw9KE3QV5T+hJc8rs3Rz4JP3YU=","dev":true,"requires":{"string-width":"1.0.2","strip-ansi":"3.0.1"}},"wrappy":{"version":"1.0.2","resolved":"https://registry.npmjs.org/wrappy/-/wrappy-1.0.2.tgz","integrity":"sha1-tSQ9jz7BqjXxNkYFvA0QNuMKtp8="},"xtend":{"version":"4.0.1","resolved":"https://registry.npmjs.org/xtend/-/xtend-4.0.1.tgz","integrity":"sha1-pcbVMr5lbiPbgg77lDofBJmNY68=","dev":true},"y18n":{"version":"3.2.1","resolved":"https://registry.npmjs.org/y18n/-/y18n-3.2.1.tgz","integrity":"sha1-bRX7qITAhnnA136I53WegR4H+kE=","dev":true},"yallist":{"version":"2.1.2","resolved":"https://registry.npmjs.org/yallist/-/yallist-2.1.2.tgz","integrity":"sha1-HBH5IY8HYImkfdUS+TxmmaaoHVI=","dev":true},"yargs":{"version":"6.6.0","resolved":"https://registry.npmjs.org/yargs/-/yargs-6.6.0.tgz","integrity":"sha1-eC7CHvQDNF+DCoCMo9UTr1YGUgg=","dev":true,"requires":{"camelcase":"3.0.0","cliui":"3.2.0","decamelize":"1.2.0","get-caller-file":"1.0.2","os-locale":"1.4.0","read-pkg-up":"1.0.1","require-directory":"2.1.1","require-main-filename":"1.0.1","set-blocking":"2.0.0","string-width":"1.0.2","which-module":"1.0.0","y18n":"3.2.1","yargs-parser":"4.2.1"},"dependencies":{"camelcase":{"version":"3.0.0","resolved":"https://registry.npmjs.org/camelcase/-/camelcase-3.0.0.tgz","integrity":"sha1-MvxLn82vhF/N9+c7uXysImHwqwo=","dev":true},"cliui":{"version":"3.2.0","resolved":"https://registry.npmjs.org/cliui/-/cliui-3.2.0.tgz","integrity":"sha1-EgYBU3qRbSmUD5NNo7SNWFo5IT0=","dev":true,"requires":{"string-width":"1.0.2","strip-ansi":"3.0.1","wrap-ansi":"2.1.0"}}}},"yargs-parser":{"version":"4.2.1","resolved":"https://registry.npmjs.org/yargs-parser/-/yargs-parser-4.2.1.tgz","integrity":"sha1-KczqwNxPA8bIe0qfIX3RjJ90hxw=","dev":true,"requires":{"camelcase":"3.0.0"},"dependencies":{"camelcase":{"version":"3.0.0","resolved":"https://registry.npmjs.org/camelcase/-/camelcase-3.0.0.tgz","integrity":"sha1-MvxLn82vhF/N9+c7uXysImHwqwo=","dev":true}}}}}

/***/ }),

/***/ "./app_modules/graph-activity/package.json":
/***/ (function(module, exports) {

module.exports = {"name":"graph-activity","version":"1.0.0","description":"TRC dynamic graph creation tool","main":"dist/index.js","module":"src/index.js","files":["dist"],"scripts":{"test":"cross-env BABEL_ENV=test tape -r babel-register -r babel-polyfill tests/*.js","inspect":"node ./node_modules/.bin/trc-inspect --file ./tests/*.js","compile":"npm run test && npm run copy-css && npm run copy-json && npm run copy-xml && babel src -d dist","copy-css":"copyfiles -u 1 \"src/*.css\" dist && copyfiles -u 1 \"src/**/*.css\" dist","copy-json":"copyfiles -u 1 \"src/*.json\" dist && copyfiles -u 1 \"src/**/*.json\" dist","copy-xml":"copyfiles -u 1 \"src/*.xml\" dist && copyfiles -u 1 \"src/**/*.xml\" dist","publish-major":"npm run test && npm run compile && is-online && npm version major && trc-tagme && git push --follow-tags","publish-minor":"npm run test && npm run compile && is-online && npm version minor && trc-tagme && git push --follow-tags","publish":"npm run test && npm run compile && is-online && npm version patch && trc-tagme && git push --follow-tags","publish-patch":"npm run publish","build":"node_modules/.bin/webpack --config=node_modules/platform-client-bootstrap/dist/core_modules/authoring-application/webpack.config.js","build-mock":"npm run build -- --env.mockMode=true"},"peerDependencies":{},"devDependencies":{"app-module-path":"^2.2.0","babel-plugin-resolver":"^1.1.0","babel-plugin-transform-css-import-to-string":"0.0.2","base-store":"https://gitlab.com/regiscompany/base-store.git#v3.1.x","component-testing-tools":"git+https://gitlab.com/regiscompany/component-testing-tools.git","copyfiles":"1.2.0","cross-env":"^5.0.5","deep-extend":"^0.5.0","enzyme":"^2.9.1","is-online-cli":"^2.0.0","react-test-renderer":"^15.6.1","tape":"4.5.1","trc-debug-runner":"git+https://gitlab.com/regiscompany/trc-debug-runner.git","trc-tagme":"git+https://gitlab.com/regiscompany/trc-tagme.git","webpack":"^2.2.0"},"author":"","license":"ISC","directories":{"test":"tests"},"dependencies":{"deep-bind-decorator":"https://gitlab.com/regiscompany/deep-bind-decorator.git#v1.0.4","babel-cli":"^6.22.2","babel-loader":"^6.2.10","babel-plugin-dynamic-import-webpack":"^1.0.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-require-ignore":"^0.1.1","babel-plugin-transform-runtime":"^6.22.0","babel-preset-es2015":"^6.22.0","babel-preset-react":"^6.22.0","babel-preset-stage-1":"^6.22.0","c3":"^0.4.18","mobx":"^3.0.2","mobx-react":"^4.1.0","numeral":"^2.0.6","react":"^15.4.2","react-dom":"^15.4.2","react-hot-loader":"^3.0.0-beta.6","react-trix":"^0.2.1"},"repository":{"type":"git","url":"git+https://gitlab.com/regiscompany/graph-activity.git"},"//api":"simgate","//coreDist":"~/workgits/platform-client-bootstrap/src","supportedBrowsers":{"Chrome":50,"Edge":0,"IE":11,"Safari":9},"//browserNotSupportedMessage":"Sample Content (Optional)"}

/***/ }),

/***/ "./app_modules/graph-activity/src/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphComponent = exports.GraphViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor, _descriptor2, _class3, _class4, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _c = __webpack_require__("./node_modules/c3/c3.js");

var _c2 = _interopRequireDefault(_c);

var _numeral = __webpack_require__("./node_modules/numeral/numeral.js");

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var GraphViewStore = exports.GraphViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(GraphViewStore, _BaseViewStore);

  function GraphViewStore(props) {
    (0, _classCallCheck3.default)(this, GraphViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GraphViewStore.__proto__ || (0, _getPrototypeOf2.default)(GraphViewStore)).call(this, props));

    _initDefineProp(_this, "validContent", _descriptor, _this);

    _initDefineProp(_this, "contentModelErrors", _descriptor2, _this);

    _this.valid = true;
    _this.prevChartData = [];
    _this.chart = null;


    if (_this.props.form) {
      _this.props.form.controls.push(_this);
    }

    var contentModel = _this.props.contentModel;
    for (var i = 0; i < contentModel.datasets.length; ++i) {

      var newSet = [];
      var splitValues = contentModel.datasets[i].values.split(",");
      for (var j = 0; j < splitValues.length; ++j) {
        var value = splitValues[j].trim();
        if (value.indexOf("G:") == 0) {
          if (value.indexOf(":-1") >= 0) {
            value = value.replace(":-1", ":" + (window.application.dataModel.domainStore.context.team.num5 - 1));
          } else if (value.indexOf(":+0") >= 0) {
            value = value.replace(":+0", ":" + window.application.dataModel.domainStore.context.team.num5);
          }
        }
        newSet.push(value);
      }
      contentModel.datasets[i].values = newSet.join(",");
    }
    return _this;
  }

  // validation is a derivation


  (0, _createClass3.default)(GraphViewStore, [{
    key: "save",
    value: function save() {}
  }, {
    key: "update",
    value: function update() {

      if (!this.chart) {
        return;
      }

      var _props = this.props,
          contentModel = _props.contentModel,
          inputStore = _props.inputStore;
      var datasets = contentModel.datasets;


      self.validContent = true;
      self.contentModelErrors = "";

      var data = [];

      if (datasets.length == 0) {
        this.validContent = false;
        this.contentModelErrors = "Graph must have at least one dataset.";
        return;
      }

      var valueTotal = 0;
      for (var i = 0; i < datasets.length; ++i) {
        var dataset = datasets[i];

        var label = dataset.label || "data" + 1;

        var values = this.createColumn(label, dataset.values);
        if (!values) {
          return;
        }
        data.push(values);

        for (var j = 0; j < values.length; ++j) {
          if (!isNaN(parseFloat(values[j])) && isFinite(values[j])) {
            valueTotal += parseFloat(values[j]);
          }
        }
      }

      if (datasets[0].graphType == "donut") {
        var leftOver = 100 - valueTotal;
        if (leftOver <= 0) {
          leftOver = 0;
        }
        if (leftOver >= 100) {
          leftOver = 100;
        }
        data.push(["Unallocated", leftOver]);
      }

      var wasChanged = false;
      for (var _i = 0; _i < data.length; ++_i) {
        for (var _j = 0; _j < data[_i].length; ++_j) {
          if (!this.prevChartData[_i] || !this.prevChartData[_i][_j] || this.prevChartData[_i][_j] != data[_i][_j]) {
            wasChanged = true;
            break;
          }
        }
        if (wasChanged) {
          break;
        }
      }

      this.prevChartData = data;

      this.chart.load({
        columns: data
      });
    }
  }, {
    key: "createColumn",
    value: function createColumn(label, values) {

      var outValues = [label];
      var splitValues = values.split(",");
      for (var j = 0; j < splitValues.length; ++j) {
        var value = splitValues[j].trim();
        try {
          var number = parseFloat(value);
          if (!isNaN(number)) {
            value = number;
          } else if (this.props.form && this.props.form.dbVariableStore && this.props.form.dbVariableStore.hasOwnProperty(value)) {
            value = this.props.form.dbVariableStore[value];
          }
        } catch (e) {
          self.validContent = false;
          self.contentModelErrors = "Error while parsing dataset - " + e;
          return null;
        }

        outValues.push(value);
      }

      return outValues;
    }
  }, {
    key: "renderGraph",
    value: function renderGraph() {

      var self = this;

      var _props2 = this.props,
          contentModel = _props2.contentModel,
          inputStore = _props2.inputStore;
      var id = contentModel.id,
          title = contentModel.title,
          datasets = contentModel.datasets,
          yLabel = contentModel.yLabel,
          yTickFormat = contentModel.yTickFormat,
          xTickLabels = contentModel.xTickLabels,
          showLegend = contentModel.showLegend,
          showTooltip = contentModel.showTooltip,
          forceWidth = contentModel.forceWidth,
          forceHeight = contentModel.forceHeight;


      var config = {
        bindto: "#" + id + "-graph-element",
        data: {
          columns: [],
          types: {}
        }
      };

      self.validContent = true;
      self.contentModelErrors = "";

      if (datasets.length == 0) {
        this.validContent = false;
        this.contentModelErrors = "Graph must have at least one dataset.";
        return;
      }

      var valueTotal = 0;
      for (var i = 0; i < datasets.length; ++i) {
        var dataset = datasets[i];

        var label = dataset.label || "data" + 1;

        var values = this.createColumn(label, dataset.values);
        if (!values) {
          return;
        }
        config.data.columns.push(values);
        config.data.types[label] = dataset.graphType;

        for (var j = 0; j < values.length; ++j) {
          if (!isNaN(parseFloat(values[j])) && isFinite(values[j])) {
            valueTotal += parseFloat(values[j]);
          }
        }

        if (dataset.color && dataset.color != 'auto') {
          if (!config.data.colors) {
            config.data.colors = {};
          }

          config.data.colors[label] = dataset.color;
        }
      }

      if (datasets[0].graphType == "donut") {
        var leftOver = 100 - valueTotal;
        if (leftOver <= 100 && leftOver >= 0) {
          config.data.columns.push(["Unallocated", leftOver]);
          config.data.types["Unallocated"] = "donut";
          config.data.colors["Unallocated"] = "#d0d0d0";
        }
      }

      this.prevChartData = config.data;

      if (yLabel && yLabel.length > 0) {
        if (!config.axis) {
          config.axis = {};
        }
        if (!config.axis.y) {
          config.axis.y = {};
        }
        if (!config.axis.y.label) {
          config.axis.y.label = {};
        }

        config.axis.y.label.text = yLabel;
        config.axis.y.label.position = 'outer-middle';
      }

      if (yTickFormat && yTickFormat.length > 0 && yTickFormat != "numeral.js format") {
        if (!config.axis) {
          config.axis = {};
        }
        if (!config.axis.y) {
          config.axis.y = {};
        }
        if (!config.axis.y.tick) {
          config.axis.y.tick = {};
        }

        config.axis.y.tick.format = function (v) {
          if (yTickFormat.indexOf("%") >= 0) {
            v /= 100;
          }
          return (0, _numeral2.default)(v).format(yTickFormat);
        };
      }

      var yMin = parseFloat(contentModel.yMin);
      var yMax = parseFloat(contentModel.yMax);
      if (yMin != -1 && !isNaN(yMin)) {
        if (!config.axis) {
          config.axis = {};
        }
        if (!config.axis.y) {
          config.axis.y = {};
        }
        if (!config.axis.y.padding) {
          config.axis.y.padding = {};
        }

        config.axis.y.min = yMin;
        config.axis.y.padding.bottom = 0;
      }

      if (yMax != -1 && !isNaN(yMax) && (!(yMin != -1 && !isNaN(yMin)) || yMin < yMax)) {
        if (!config.axis) {
          config.axis = {};
        }
        if (!config.axis.y) {
          config.axis.y = {};
        }
        if (!config.axis.y.padding) {
          config.axis.y.padding = {};
        }

        config.axis.y.max = yMax;
        config.axis.y.padding.top = 0;
      }

      if (xTickLabels && xTickLabels.length > 0 && xTickLabels != "Comma separated values") {
        if (!config.axis) {
          config.axis = {};
        }
        if (!config.axis.x) {
          config.axis.x = {};
        }

        var _values = this.createColumn("x", xTickLabels);
        if (!_values) {
          return;
        }
        _values.shift(); // remove the label because we don't need it here

        config.axis.x.type = 'category';
        config.axis.x.categories = _values;
      }

      if (!showLegend) {
        if (!config.legend) {
          config.legend = {};
        }
        config.legend.show = false;

        if (datasets[0].graphType == "donut") {
          config.donut = {
            label: {
              show: false
            }
          };
        }
      }
      if (!showTooltip) {
        if (!config.tooltip) {
          config.tooltip = {};
        }
        config.tooltip.show = false;
      }

      if (forceWidth) {
        var width = parseFloat(forceWidth);
        if (!isNaN(width) && isFinite(width) && width > 0) {
          if (!config.size) {
            config.size = {};
          }
          config.size.width = width;
        }
      }
      if (forceHeight) {
        var height = parseFloat(forceHeight);
        if (!isNaN(height) && isFinite(height) && height > 0) {
          if (!config.size) {
            config.size = {};
          }
          config.size.height = height;
        }
      }

      this.chart = _c2.default.generate(config);
    }
  }, {
    key: "invalid",
    get: function get() {
      var invalid = {};
      return invalid;
    }
  }]);
  return GraphViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "validContent", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "contentModelErrors", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renderGraph", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "renderGraph"), _class.prototype)), _class));

// this automatically gives consistent `className`s to components using module and component names
var GraphComponent = exports.GraphComponent = (0, _simboxEditable.Decorator)(_class3 = (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = (_temp = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(GraphComponent, _BaseComponent);

  function GraphComponent() {
    (0, _classCallCheck3.default)(this, GraphComponent);
    return (0, _possibleConstructorReturn3.default)(this, (GraphComponent.__proto__ || (0, _getPrototypeOf2.default)(GraphComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(GraphComponent, [{
    key: "componentWillMount",
    //ViewStore gets auto-instantiated and attached to the component on creation

    value: function componentWillMount() {
      // TODO: load data from the database
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          currentView = _props3.currentView,
          contentModel = _props3.contentModel,
          inputStore = _props3.inputStore;
      var id = contentModel.id,
          css = contentModel.css,
          title = contentModel.title,
          datasets = contentModel.datasets;
      var _viewStore = this.viewStore,
          validContent = _viewStore.validContent,
          contentModelErrors = _viewStore.contentModelErrors,
          invalid = _viewStore.invalid,
          save = _viewStore.save; // this components viewStore.  Will have actions and UI properties

      var isDirty = inputStore && inputStore.isDirty;
      var isLoading = inputStore && inputStore.isLoading;
      var revert = inputStore ? inputStore.revert : function () {};

      if (isLoading) return _react2.default.createElement(
        "div",
        null,
        "Loading..."
      );
      if (!validContent) return _react2.default.createElement(
        "div",
        null,
        "Invalid content model. ",
        contentModelErrors
      );

      if (datasets && datasets[0] && title) {
        return _react2.default.createElement(
          "div",
          { className: "graph-activity " + css + " " + datasets[0].graphType },
          _react2.default.createElement("div", { className: "graph-title", dangerouslySetInnerHTML: { __html: title } }),
          _react2.default.createElement("div", { id: id + "-graph-element", className: "graph" })
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "graph-activity " + css },
        _react2.default.createElement("div", { id: id + "-graph-element", className: "graph" })
      );
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.viewStore.renderGraph();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }]);
  return GraphComponent;
}(_baseComponent2.default), _class4.ViewStore = GraphViewStore, _temp)) || _class3) || _class3) || _class3;

var _default = GraphComponent;
exports.default = _default; //need to export top level component as "default"

;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GraphViewStore, "GraphViewStore", "D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/component.js");

  __REACT_HOT_LOADER__.register(GraphComponent, "GraphComponent", "D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/component.js");
}();

;

/***/ }),

/***/ "./app_modules/graph-activity/src/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphContentModel = exports.GraphDataSetContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class2, _temp2, _dec, _desc2, _value2, _class3, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _class4, _temp4;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _deepBindDecorator = __webpack_require__("./node_modules/deep-bind-decorator/dist/deep-bind-decorator.js");

var _deepBindDecorator2 = _interopRequireDefault(_deepBindDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _component = __webpack_require__("./app_modules/graph-activity/src/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var GraphDataSetContentModel = exports.GraphDataSetContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(GraphDataSetContentModel, _BaseContentModel);

  function GraphDataSetContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GraphDataSetContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GraphDataSetContentModel.__proto__ || (0, _getPrototypeOf2.default)(GraphDataSetContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, '_options', _descriptor, _this), _initDefineProp(_this, 'values', _descriptor2, _this), _initDefineProp(_this, 'label', _descriptor3, _this), _initDefineProp(_this, 'color', _descriptor4, _this), _initDefineProp(_this, 'graphType', _descriptor5, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GraphDataSetContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return {};
    }
  }]);
  return GraphDataSetContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  values: "",
  label: "",
  color: "",
  graphType: ""
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, '_options', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get graphType() {
        return ["bar", "line", "spline", "step", "area", "area-spline", "area-step", "pie", "donut"];
      }
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'values', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "(Comma separated values or db variables names)";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'label', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Dataset Label";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'color', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "auto or #990000";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'graphType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
})), _class);
var GraphContentModel = exports.GraphContentModel = (_dec = _mobx.observable.shallow, (_class3 = (_temp4 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(GraphContentModel, _BaseContentModel2);

  function GraphContentModel() {
    var _ref2;

    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, GraphContentModel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = GraphContentModel.__proto__ || (0, _getPrototypeOf2.default)(GraphContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _this2.Component = _component2.default, _initDefineProp(_this2, 'title', _descriptor6, _this2), _initDefineProp(_this2, 'datasets', _descriptor7, _this2), _initDefineProp(_this2, 'yLabel', _descriptor8, _this2), _initDefineProp(_this2, 'yMin', _descriptor9, _this2), _initDefineProp(_this2, 'yMax', _descriptor10, _this2), _initDefineProp(_this2, 'yTickFormat', _descriptor11, _this2), _initDefineProp(_this2, 'xTickLabels', _descriptor12, _this2), _initDefineProp(_this2, 'showLegend', _descriptor13, _this2), _initDefineProp(_this2, 'showTooltip', _descriptor14, _this2), _initDefineProp(_this2, 'forceWidth', _descriptor15, _this2), _initDefineProp(_this2, 'forceHeight', _descriptor16, _this2), _initDefineProp(_this2, 'css', _descriptor17, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  (0, _createClass3.default)(GraphContentModel, [{
    key: 'variables',
    get: function get() {

      var vars = {};
      for (var i = 0; i < this.datasets.length; ++i) {

        var splitValues = this.datasets[i].values.split(",");
        for (var j = 0; j < splitValues.length; ++j) {
          var value = splitValues[j].trim();
          if (value.indexOf("G:") == 0) {
            if (value.indexOf(":-1") >= 0) {
              value = value.replace(":-1", ":" + (window.application.dataModel.domainStore.context.team.num5 - 1));
            } else if (value.indexOf(":+0") >= 0) {
              value = value.replace(":+0", ":" + window.application.dataModel.domainStore.context.team.num5);
            }
            vars[value] = 0;
          }
        }
      }
      return vars;
    }
  }], [{
    key: '_defaults',
    get: function get() {
      return {};
    }
  }]);
  return GraphContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  title: "",
  datasets: [GraphDataSetContentModel],
  yLabel: "",
  yMin: "",
  yMax: "",
  yTickFormat: "",
  xTickLabels: "",
  showLegend: true,
  showTooltip: true,
  forceWidth: "",
  forceHeight: "",
  css: ""
}, _temp4), (_descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'title', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Graph Title";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, 'datasets', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'yLabel', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Y-Axis Label";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'yMin', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return -1;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, 'yMax', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return -1;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, 'yTickFormat', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "numeral.js format";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class3.prototype, 'xTickLabels', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Comma separated values";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class3.prototype, 'showLegend', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class3.prototype, 'showTooltip', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class3.prototype, 'forceWidth', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return -1;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class3.prototype, 'forceHeight', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return -1;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class3.prototype, 'css', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'variables', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'variables'), _class3.prototype)), _class3));
var _default = GraphContentModel;
exports.default = _default;
;

var _temp5 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GraphDataSetContentModel, 'GraphDataSetContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/contentmodel.js');

  __REACT_HOT_LOADER__.register(GraphContentModel, 'GraphContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/graph-activity/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./app_modules/graph-activity/src/contentmodel.js");

var graphContentModels = _interopRequireWildcard(_contentmodel);

__webpack_require__("./app_modules/graph-activity/src/style.css");

__webpack_require__("./node_modules/c3/c3.min.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = graphContentModels;
var ContentModel = exports.ContentModel = graphContentModels.default;

var description = exports.description = "Generate a dynamic graph based on database variables.";
var instructions = exports.instructions = '';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/index.js');

  __REACT_HOT_LOADER__.register(description, 'description', 'D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/index.js');

  __REACT_HOT_LOADER__.register(instructions, 'instructions', 'D:/VSTS/agent/_work/24/s/app_modules/graph-activity/src/index.js');
}();

;

/***/ }),

/***/ "./app_modules/graph-activity/src/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app_modules/resources-activity/package.json":
/***/ (function(module, exports) {

module.exports = {"name":"cba-activity","version":"1.0.0","description":"TRC platform assessment activity","main":"dist/index.js","module":"src/index.js","files":["dist","CHANGELOG.md","README.md"],"scripts":{"test":"cross-env BABEL_ENV=test node ./node_modules/.bin/trc-test \"tests/*.js\"","inspect":"cross-env BABEL_ENV=test node ./node_modules/.bin/trc-inspect \"tests/*.js\"","compile":"npm run test && npm run copy-css && npm run copy-json && npm run copy-xml && babel src -d dist","copy-css":"copyfiles -u 1 \"src/*.css\" dist && copyfiles -u 1 \"src/**/*.css\" dist","copy-json":"copyfiles -u 1 \"src/*.json\" dist && copyfiles -u 1 \"src/**/*.json\" dist","copy-xml":"copyfiles -u 1 \"src/*.xml\" dist && copyfiles -u 1 \"src/**/*.xml\" dist","publish-major":"npm run test && npm run compile && is-online && npm version major && trc-tagme && git push --follow-tags","publish-minor":"npm run test && npm run compile && is-online && npm version minor && trc-tagme && git push --follow-tags","publish":"npm run test && npm run compile && is-online && npm version patch && trc-tagme && git push --follow-tags","publish-patch":"npm run publish"},"dependencies":{"deep-bind-decorator":"https://gitlab.com/regiscompany/deep-bind-decorator.git","mobx":"^3.0.2","mobx-react":"^4.1.0","react":"^15.4.2","react-dom":"^15.4.2"},"devDependencies":{"babel-cli":"^6.26.0","babel-plugin-module-resolver":"^3.0.0-beta.5","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-require-ignore":"^0.1.1","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.0","babel-preset-react":"^6.24.0","babel-preset-stage-1":"^6.24.0","component-testing-tools":"https://gitlab.com/regiscompany/component-testing-tools.git","copyfiles":"1.2.0","cross-env":"^5.0.5","deep-extend":"^0.5.0","enzyme":"^2.9.1","is-online-cli":"^2.0.0","react-test-renderer":"^15.6.1","tape":"4.5.1","trc-debug-runner":"https://gitlab.com/regiscompany/trc-debug-runner.git","trc-tagme":"https://gitlab.com/regiscompany/trc-tagme.git"},"author":"","license":"ISC","repository":{"type":"git","url":"git+https://gitlab.com/regiscompany/cba-activity.git"}}

/***/ }),

/***/ "./app_modules/resources-activity/src/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResourcesComponent = undefined;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _numeral = __webpack_require__("./node_modules/numeral/numeral.js");

var _numeral2 = _interopRequireDefault(_numeral);

var _viewstore = __webpack_require__("./app_modules/resources-activity/src/viewstore.js");

var _viewstore2 = _interopRequireDefault(_viewstore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourcesComponent = exports.ResourcesComponent = (0, _simboxEditable.Decorator)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_BaseComponent) {
    (0, _inherits3.default)(ResourcesComponent, _BaseComponent);

    function ResourcesComponent(props) {
        (0, _classCallCheck3.default)(this, ResourcesComponent);
        return (0, _possibleConstructorReturn3.default)(this, (ResourcesComponent.__proto__ || (0, _getPrototypeOf2.default)(ResourcesComponent)).call(this, props));
    }

    (0, _createClass3.default)(ResourcesComponent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                currentView = _props.currentView,
                contentModel = _props.contentModel,
                inputStore = _props.inputStore;
            var title = contentModel.title,
                resources = contentModel.resources;
            var _viewStore = this.viewStore,
                showDebrief = _viewStore.showDebrief,
                hideDebrief = _viewStore.hideDebrief,
                debriefRound = _viewStore.debriefRound,
                debriefVisible = _viewStore.debriefVisible,
                slide = _viewStore.slide,
                totalSlides = _viewStore.totalSlides,
                prevSlide = _viewStore.prevSlide,
                nextSlide = _viewStore.nextSlide,
                debriefLoading = _viewStore.debriefLoading;


            return _react2.default.createElement(
                "div",
                { className: "resources-activity" },
                _react2.default.createElement(
                    "div",
                    { className: "title" },
                    title
                ),
                _react2.default.createElement(
                    "div",
                    { className: "resources" },
                    resources.map(function (resource) {
                        if (resource.link == "debrief-1") {
                            return _react2.default.createElement(
                                "a",
                                { className: "resource", onClick: function onClick() {
                                        showDebrief(1);
                                    } },
                                _react2.default.createElement("i", { className: "fa fa-fw " + resource.icon }),
                                _react2.default.createElement("span", { className: "resource-name", dangerouslySetInnerHTML: { __html: resource.name } })
                            );
                        }
                        if (resource.link == "debrief-2") {
                            return _react2.default.createElement(
                                "a",
                                { className: "resource", onClick: function onClick() {
                                        showDebrief(2);
                                    } },
                                _react2.default.createElement("i", { className: "fa fa-fw " + resource.icon }),
                                _react2.default.createElement("span", { className: "resource-name", dangerouslySetInnerHTML: { __html: resource.name } })
                            );
                        }
                        return _react2.default.createElement(
                            "a",
                            { className: "resource", href: resource.link, target: "_blank" },
                            _react2.default.createElement("i", { className: "fa fa-fw " + resource.icon }),
                            _react2.default.createElement("span", { className: "resource-name", dangerouslySetInnerHTML: { __html: resource.name } })
                        );
                    })
                ),
                _react2.default.createElement(
                    "div",
                    { className: "debrief" + (debriefVisible ? " show" : "") + (debriefLoading ? " loading" : "") },
                    _react2.default.createElement("div", { className: "back-button", onClick: hideDebrief }),
                    _react2.default.createElement(
                        "div",
                        { className: "title" },
                        "Round ",
                        debriefRound,
                        " Debrief"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "loading" },
                        _react2.default.createElement("i", { className: "fa fa-spin fa-spinner" })
                    ),
                    _react2.default.createElement(
                        "div",
                        { id: "slideshow", className: "slideshow slide-" + slide + " round" + debriefRound },
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1", style: { textAlign: "center", background: "rgb(4,106,56)", color: "white" } },
                            _react2.default.createElement(
                                "h1",
                                { style: { marginTop: "20%" } },
                                "Deloitte Industries Oil & Gas"
                            ),
                            _react2.default.createElement(
                                "div",
                                { style: { textAlign: "left" } },
                                _react2.default.createElement(
                                    "h3",
                                    null,
                                    "Debrief Round 1"
                                ),
                                _react2.default.createElement(
                                    "ul",
                                    null,
                                    _react2.default.createElement(
                                        "li",
                                        null,
                                        "Reserve Replacement Ratio"
                                    ),
                                    _react2.default.createElement(
                                        "li",
                                        null,
                                        "Events"
                                    ),
                                    _react2.default.createElement(
                                        "li",
                                        null,
                                        "Simulation Results"
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1" },
                            _react2.default.createElement(
                                "h2",
                                null,
                                "Winning Metrics"
                            ),
                            _react2.default.createElement(
                                "span",
                                null,
                                "Balanced Scorecard"
                            ),
                            _react2.default.createElement(
                                "ul",
                                null,
                                _react2.default.createElement(
                                    "li",
                                    null,
                                    "Reserve Replacement Ratio (RRR) \u2013 30%"
                                ),
                                _react2.default.createElement(
                                    "li",
                                    null,
                                    "Market Share \u2013 30%"
                                ),
                                _react2.default.createElement(
                                    "li",
                                    null,
                                    "Return on Capital Employed (ROCE) \u2013 40%"
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1" },
                            _react2.default.createElement(
                                "h2",
                                null,
                                "Reserve Replacement Ratio (RRR)"
                            ),
                            _react2.default.createElement(
                                "div",
                                { style: { display: "flex" } },
                                _react2.default.createElement(
                                    "div",
                                    { style: { marginTop: "60px" } },
                                    "RRR = "
                                ),
                                _react2.default.createElement(
                                    "div",
                                    { style: { marginLeft: "20px" } },
                                    _react2.default.createElement(
                                        "p",
                                        { style: { borderBottom: "2px solid" } },
                                        "New Reserves Added"
                                    ),
                                    _react2.default.createElement(
                                        "p",
                                        { style: { marginTop: "-15px" } },
                                        "Reserves Depleted",
                                        _react2.default.createElement("br", null),
                                        "(production)"
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1" },
                            _react2.default.createElement(
                                "h2",
                                null,
                                "New Reserves Added"
                            ),
                            _react2.default.createElement(
                                "ul",
                                null,
                                _react2.default.createElement(
                                    "li",
                                    null,
                                    "Lease Management"
                                ),
                                _react2.default.createElement(
                                    "li",
                                    null,
                                    "Exploration"
                                ),
                                _react2.default.createElement(
                                    "li",
                                    null,
                                    "Development"
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Leases - Global North - Conventional Gas - Drivers"
                            ),
                            _react2.default.createElement("div", { id: "graph-1-2" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Leases - Global North - Conventional Gas"
                            ),
                            _react2.default.createElement("div", { id: "graph-1" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Global North - Conventional Gas Exploration"
                            ),
                            _react2.default.createElement("div", { id: "graph-5" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Total Developed Reserves - Gas"
                            ),
                            _react2.default.createElement("div", { id: "graph-9" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Production - Conventional and Unconventional Gas"
                            ),
                            _react2.default.createElement("div", { id: "graph-11" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1" },
                            _react2.default.createElement(
                                "table",
                                { style: { tableLayout: 'fixed', width: '90%', textAlign: 'center' } },
                                _react2.default.createElement(
                                    "thead",
                                    null,
                                    _react2.default.createElement("tr", { id: "rrr-header", style: { background: 'rgb(134,188,37)', color: "white" } })
                                ),
                                _react2.default.createElement(
                                    "tbody",
                                    null,
                                    _react2.default.createElement("tr", { id: "rrr-north-oil", style: { background: "rgb(217,231,205)" } }),
                                    _react2.default.createElement("tr", { id: "rrr-north-gas", style: { background: "rgb(237,244,232)" } }),
                                    _react2.default.createElement("tr", { id: "rrr-south-oil", style: { background: "rgb(217,231,205)" } }),
                                    _react2.default.createElement("tr", { id: "rrr-south-gas", style: { background: "rgb(237,244,232)" } })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round2", style: { textAlign: "center", background: "rgb(4,106,56)", color: "white" } },
                            _react2.default.createElement(
                                "h1",
                                { style: { marginTop: "20%" } },
                                "Deloitte Industries Oil & Gas"
                            ),
                            _react2.default.createElement(
                                "div",
                                { style: { textAlign: "left" } },
                                _react2.default.createElement(
                                    "h3",
                                    null,
                                    "Debrief Round 2"
                                ),
                                _react2.default.createElement(
                                    "ul",
                                    null,
                                    _react2.default.createElement(
                                        "li",
                                        null,
                                        "Market Share"
                                    ),
                                    _react2.default.createElement(
                                        "li",
                                        null,
                                        "Events"
                                    ),
                                    _react2.default.createElement(
                                        "li",
                                        null,
                                        "Simulation Results"
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round2" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Retail Market Share - Global North"
                            ),
                            _react2.default.createElement("div", { id: "graph-12" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round2" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Retail Market Share - Global North - Drivers"
                            ),
                            _react2.default.createElement("div", { id: "graph-12-2" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round2" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Retail Market Share - Global South"
                            ),
                            _react2.default.createElement("div", { id: "graph-13" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round2" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Retail Market Share - Global South - Drivers"
                            ),
                            _react2.default.createElement("div", { id: "graph-13-2" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round3", style: { textAlign: "center", background: "rgb(4,106,56)", color: "white" } },
                            _react2.default.createElement(
                                "h1",
                                { style: { marginTop: "20%" } },
                                "Deloitte Industries Oil & Gas"
                            ),
                            _react2.default.createElement(
                                "div",
                                { style: { textAlign: "left" } },
                                _react2.default.createElement(
                                    "h3",
                                    null,
                                    "Debrief Round 3"
                                ),
                                _react2.default.createElement(
                                    "ul",
                                    null,
                                    _react2.default.createElement(
                                        "li",
                                        null,
                                        "ROCE"
                                    ),
                                    _react2.default.createElement(
                                        "li",
                                        null,
                                        "Events"
                                    ),
                                    _react2.default.createElement(
                                        "li",
                                        null,
                                        "Simulation Results"
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round3" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "ROCE Tree"
                            ),
                            _react2.default.createElement("img", { src: "/assets/images/ROCE-Tree.png", style: { maxWidth: "100%" } })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round3" },
                            _react2.default.createElement(
                                "table",
                                { style: { tableLayout: 'fixed', width: '90%', textAlign: 'center' } },
                                _react2.default.createElement(
                                    "thead",
                                    null,
                                    _react2.default.createElement("tr", { id: "roce-header", style: { background: 'rgb(134,188,37)', color: "white" } })
                                ),
                                _react2.default.createElement(
                                    "tbody",
                                    null,
                                    _react2.default.createElement("tr", { id: "roce-earnings", style: { background: "rgb(217,231,205)" } }),
                                    _react2.default.createElement("tr", { id: "roce-capital", style: { background: "rgb(237,244,232)" } }),
                                    _react2.default.createElement("tr", { id: "roce-roce", style: { background: "rgb(217,231,205)" } })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round3" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "ROCE"
                            ),
                            _react2.default.createElement("div", { id: "graph-30" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "slide round1 round2 round3" },
                            _react2.default.createElement(
                                "h3",
                                null,
                                "Round Scores"
                            ),
                            _react2.default.createElement(
                                "table",
                                { style: { tableLayout: 'fixed', width: '90%', textAlign: 'center' } },
                                _react2.default.createElement(
                                    "thead",
                                    null,
                                    _react2.default.createElement("tr", { id: "scores-header" })
                                ),
                                _react2.default.createElement(
                                    "tbody",
                                    null,
                                    _react2.default.createElement("tr", { id: "scores-rrr" }),
                                    _react2.default.createElement("tr", { id: "scores-rrr-points" }),
                                    _react2.default.createElement("tr", { className: "scores-spacer", style: { height: "30px" } }),
                                    _react2.default.createElement("tr", { id: "scores-market" }),
                                    _react2.default.createElement("tr", { id: "scores-market-points" }),
                                    _react2.default.createElement("tr", { className: "scores-spacer", style: { height: "30px" } }),
                                    _react2.default.createElement("tr", { id: "scores-roce" }),
                                    _react2.default.createElement("tr", { id: "scores-roce-points" }),
                                    _react2.default.createElement("tr", { className: "scores-spacer", style: { height: "30px" } }),
                                    _react2.default.createElement("tr", { id: "scores-totals" }),
                                    _react2.default.createElement("tr", { className: "scores-spacer", style: { height: "30px" } }),
                                    _react2.default.createElement("tr", { className: "scores-spacer", style: { height: "30px" } }),
                                    _react2.default.createElement("tr", { id: "scores-combined" })
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { id: "slide-control-left", className: "slide-control left" + (slide <= 0 ? " disabled" : ""), onClick: prevSlide },
                        _react2.default.createElement("i", { className: "fa fa-chevron-left" })
                    ),
                    _react2.default.createElement(
                        "div",
                        { id: "slide-control-right", className: "slide-control right" + (slide >= totalSlides ? " disabled" : ""), onClick: nextSlide },
                        _react2.default.createElement("i", { className: "fa fa-chevron-right" })
                    ),
                    _react2.default.createElement(
                        "div",
                        { id: "slide-show-count", className: "slide-show-count" },
                        "Slide ",
                        slide + 1,
                        " of ",
                        totalSlides + 1
                    )
                )
            );
        }
    }]);
    return ResourcesComponent;
}(_baseComponent2.default), _class2.ViewStore = _viewstore2.default, _temp)) || _class) || _class;

var _default = ResourcesComponent;
exports.default = _default; //need to export top level component as "default"

;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ResourcesComponent, "ResourcesComponent", "D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/component.js");

    __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/component.js");
}();

;

/***/ }),

/***/ "./app_modules/resources-activity/src/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResourcesContentModel = exports.ResourceContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _class2, _temp2, _desc2, _value2, _class3, _descriptor4, _descriptor5, _class4, _temp3;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _deepBindDecorator = __webpack_require__("./node_modules/deep-bind-decorator/dist/deep-bind-decorator.js");

var _deepBindDecorator2 = _interopRequireDefault(_deepBindDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _component = __webpack_require__("./app_modules/resources-activity/src/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ResourceContentModel = exports.ResourceContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
    (0, _inherits3.default)(ResourceContentModel, _BaseContentModel);

    function ResourceContentModel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ResourceContentModel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResourceContentModel.__proto__ || (0, _getPrototypeOf2.default)(ResourceContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'icon', _descriptor, _this), _initDefineProp(_this, 'name', _descriptor2, _this), _initDefineProp(_this, 'link', _descriptor3, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ResourceContentModel, null, [{
        key: '_defaults',
        get: function get() {
            return {};
        }
    }]);
    return ResourceContentModel;
}(_baseContentmodel2.default), _class2._slots = {
    icon: "",
    name: "",
    link: ""
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'icon', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "fa-file-pdf-o";
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'name', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "Resource Name";
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'link', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "/assets/resources/resource.pdf";
    }
})), _class);
var ResourcesContentModel = exports.ResourcesContentModel = (_class3 = (_temp3 = _class4 = function (_BaseContentModel2) {
    (0, _inherits3.default)(ResourcesContentModel, _BaseContentModel2);
    (0, _createClass3.default)(ResourcesContentModel, null, [{
        key: '_defaults',
        get: function get() {
            return {};
        }
    }]);

    function ResourcesContentModel(props) {
        (0, _classCallCheck3.default)(this, ResourcesContentModel);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (ResourcesContentModel.__proto__ || (0, _getPrototypeOf2.default)(ResourcesContentModel)).call(this, props));

        _this2.Component = _component2.default;

        _initDefineProp(_this2, 'title', _descriptor4, _this2);

        _initDefineProp(_this2, 'resources', _descriptor5, _this2);

        return _this2;
    }

    return ResourcesContentModel;
}(_baseContentmodel2.default), _class4._slots = {
    title: "",
    resources: [ResourceContentModel]
}, _temp3), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'title', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return "Resources";
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'resources', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), _class3);
var _default = ResourcesContentModel;
exports.default = _default;
;

var _temp4 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ResourceContentModel, 'ResourceContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/contentmodel.js');

    __REACT_HOT_LOADER__.register(ResourcesContentModel, 'ResourcesContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/contentmodel.js');

    __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/resources-activity/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./app_modules/resources-activity/src/contentmodel.js");

var contentModels = _interopRequireWildcard(_contentmodel);

__webpack_require__("./app_modules/resources-activity/src/style.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = contentModels;
var ContentModel = exports.ContentModel = contentModels.default;

var description = exports.description = "This is the resources activity.";
var instructions = exports.instructions = '';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/index.js');

  __REACT_HOT_LOADER__.register(description, 'description', 'D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/index.js');

  __REACT_HOT_LOADER__.register(instructions, 'instructions', 'D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/index.js');
}();

;

/***/ }),

/***/ "./app_modules/resources-activity/src/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./app_modules/resources-activity/src/viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _c = __webpack_require__("./node_modules/c3/c3.js");

var _c2 = _interopRequireDefault(_c);

var _numeral = __webpack_require__("./node_modules/numeral/numeral.js");

var _numeral2 = _interopRequireDefault(_numeral);

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ResourcesViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class = function (_BaseViewStore) {
    (0, _inherits3.default)(ResourcesViewStore, _BaseViewStore);

    function ResourcesViewStore(props) {
        (0, _classCallCheck3.default)(this, ResourcesViewStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ResourcesViewStore.__proto__ || (0, _getPrototypeOf2.default)(ResourcesViewStore)).call(this, props));

        _initDefineProp(_this, "debriefVisible", _descriptor, _this);

        _initDefineProp(_this, "debriefLoading", _descriptor2, _this);

        _initDefineProp(_this, "debriefRound", _descriptor3, _this);

        _initDefineProp(_this, "slide", _descriptor4, _this);

        _initDefineProp(_this, "totalSlides", _descriptor5, _this);

        return _this;
    }

    (0, _createClass3.default)(ResourcesViewStore, [{
        key: "hideDebrief",
        value: function hideDebrief() {
            this.debriefVisible = false;
        }
    }, {
        key: "showDebrief",
        value: function showDebrief(round) {
            this.debriefRound = round;
            this.slide = 0;
            this.debriefLoading = true;
            this.debriefVisible = true;

            var self = this;
            window.simgate.execQuery({
                query: "custom-queries://getDebriefTeams",
                parameters: { sessionId: window.application.dataModel.domainStore.context.team.parentId }
            }).then(function (result) {
                var teams = [];
                var teamMap = {};
                for (var i = 0; i < result.data[0].length; ++i) {
                    teams.push({
                        name: result.data[0][i].Name,
                        path: result.data[0][i].PathId,
                        data: {}
                    });
                    teamMap[result.data[0][i].PathId] = teams[teams.length - 1];
                }
                window.simgate.execQuery({
                    query: "custom-queries://getDebriefData",
                    parameters: {
                        team1: teams[0] ? teams[0].path : -1,
                        team2: teams[1] ? teams[1].path : -1,
                        team3: teams[2] ? teams[2].path : -1,
                        team4: teams[3] ? teams[3].path : -1,
                        team5: teams[4] ? teams[4].path : -1,
                        team6: teams[5] ? teams[5].path : -1
                    }
                }).then(function (result) {
                    for (var _i = 0; _i < result.data[0].length; ++_i) {
                        var _data = result.data[0][_i];
                        if (teamMap[_data.PathID]) {
                            teamMap[_data.PathID].data[_data.Variable] = [_data.V0, _data.V1, _data.V2, _data.V3];
                        }
                    }

                    var data = [],
                        data2 = [],
                        data3 = [],
                        data4 = [],
                        data5 = [];
                    var labels = [];
                    var round = self.debriefRound;
                    self.totalSlides = [0, 10, 5, 4][round];

                    // graph 1
                    data = ["Political Influence"];
                    data2 = ["Bid Price"];
                    data3 = ["HSE Index"];
                    labels = [];
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["BiddingDriverScoreR1P2S1"] ? teams[i].data["BiddingDriverScoreR1P2S1"][round] : 0;
                        data.push(value);
                        value = teams[i].data["BiddingDriverScoreR1P2S2"] ? teams[i].data["BiddingDriverScoreR1P2S2"][round] : 0;
                        data2.push(value);
                        value = teams[i].data["BiddingDriverScoreR1P2S3"] ? teams[i].data["BiddingDriverScoreR1P2S3"][round] : 0;
                        data3.push(value);

                        labels.push(teams[i].name);
                    }
                    _c2.default.generate({
                        bindto: "#graph-1-2",
                        data: {
                            columns: [data, data2, data3],
                            type: 'bar'
                        },
                        axis: {
                            x: { type: 'category', categories: labels },
                            y: { show: false }
                        },
                        tooltip: {
                            format: {
                                value: function value(value, ratio, id, index) {
                                    if (id == "Political Influence") {
                                        var value = teams[index].data["FI_RES_PoliticalInfluenceRatingR1"] ? parseFloat(teams[index].data["FI_RES_PoliticalInfluenceRatingR1"][round]) : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    } else if (id == "Bid Price") {
                                        var value = teams[index].data["FI_DEC_LeaseBid_R1P2"] ? teams[index].data["FI_DEC_LeaseBid_R1P2"][round] : 0;
                                        return (0, _numeral2.default)(value).format("$0,0");
                                    } else if (id == "HSE Index") {
                                        var value = teams[index].data["Stored_HSEC_Index"] ? teams[index].data["Stored_HSEC_Index"][round] : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    }
                                }
                            }
                        }
                    });

                    data = ["Lease Won"];
                    labels = [];
                    var winner1 = -1;
                    var winner2 = -1;
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["FI_RES_BidStatusR1P2"] ? teams[i].data["FI_RES_BidStatusR1P2"][round] : 0;
                        var value2 = teams[i].data["BiddingDriverScoreR1P2"] ? teams[i].data["BiddingDriverScoreR1P2"][round] : 0;
                        if (value == 2) {
                            if (winner1 >= 0) {
                                winner2 = i;
                            } else {
                                winner1 = i;
                            }
                        }
                        data.push(value2);
                        labels.push(teams[i].name);
                    }
                    _c2.default.generate({
                        bindto: "#graph-1",
                        data: {
                            columns: [data],
                            type: 'bar'
                        },
                        axis: {
                            x: { type: 'category', categories: labels },
                            y: { min: 0, padding: { bottom: 0 }, show: false }
                        },
                        legend: { show: false },
                        tooltip: { show: false },
                        onrendered: function onrendered() {
                            if (winner1 >= 0) {
                                $('#graph-1 .c3-chart-bar .c3-shapes-Lease-Won path:nth-child(' + (winner1 + 1) + ')').css({ stroke: "rgb(44, 160, 44)", fill: "rgb(44, 160, 44)" });
                            }
                            if (winner2 >= 0) {
                                $('#graph-1 .c3-chart-bar .c3-shapes-Lease-Won path:nth-child(' + (winner2 + 1) + ')').css({ stroke: "rgb(44, 160, 44)", fill: "rgb(44, 160, 44)" });
                            }
                        }
                    });

                    // graph 5
                    data = ["Attempted Exploration"];
                    data2 = ["Successful Exploration"];
                    labels = [];
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["FI_DEC_BlocksToExploreR1P2"] ? teams[i].data["FI_DEC_BlocksToExploreR1P2"][round] : 0;
                        value *= teams[i].data["FI_WellsDrilledPerBlockR1P2"] ? teams[i].data["FI_WellsDrilledPerBlockR1P2"][round] : 0;
                        data.push(value);
                        value = Math.round(teams[i].data["FI_RES_NumberOfDiscoveriesR1P2"] ? teams[i].data["FI_RES_NumberOfDiscoveriesR1P2"][round] : 0);
                        data2.push(value);
                        labels.push(teams[i].name);
                    }
                    _c2.default.generate({
                        bindto: "#graph-5",
                        data: {
                            columns: [data, data2],
                            type: 'bar'
                        },
                        axis: { x: { type: 'category', categories: labels } }
                    });

                    // graph 9
                    data = ["Global North - Conventional Gas"];
                    data2 = ["Global South - Unconventional Gas"];
                    labels = [];
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["FI_RES_DevReservesR1P2"] ? teams[i].data["FI_RES_DevReservesR1P2"][round] : 0;
                        data.push(value);
                        value = teams[i].data["FI_RES_DevReservesR2P2"] ? teams[i].data["FI_RES_DevReservesR2P2"][round] : 0;
                        data2.push(value);
                        labels.push(teams[i].name);
                    }
                    _c2.default.generate({
                        bindto: "#graph-9",
                        data: {
                            columns: [data, data2],
                            type: 'bar'
                        },
                        axis: {
                            x: { type: 'category', categories: labels },
                            y: { tick: { format: function format(v) {
                                        return (0, _numeral2.default)(v).format("0,0");
                                    } } }
                        }
                    });

                    // graph 11
                    data = ["Global North - Conventional Gas"];
                    data2 = ["Global South - Unconventional Gas"];
                    labels = [];
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["FI_RES_ProductionBOEPerDayR1P2"] ? teams[i].data["FI_RES_ProductionBOEPerDayR1P2"][round] : 0;
                        data.push(value);
                        value = teams[i].data["FI_RES_ProductionBOEPerDayR2P2"] ? teams[i].data["FI_RES_ProductionBOEPerDayR2P2"][round] : 0;
                        data2.push(value);
                        labels.push(teams[i].name);
                    }
                    _c2.default.generate({
                        bindto: "#graph-11",
                        data: {
                            columns: [data, data2],
                            type: 'bar'
                        },
                        axis: {
                            x: { type: 'category', categories: labels },
                            y: { tick: { format: function format(v) {
                                        return (0, _numeral2.default)(v).format("0,0");
                                    } } }
                        }
                    });

                    // graph 12
                    data = ["Brand Index"];
                    data2 = ["Price Premium/Discount"];
                    data3 = ["Political Influence"];
                    data4 = ["HSE Index"];
                    data5 = ["Number of Outlets"];
                    labels = [];
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["MarketDriverScoreR1S1"] ? teams[i].data["MarketDriverScoreR1S1"][round] : 0;
                        data.push(value);
                        value = teams[i].data["MarketDriverScoreR1S2"] ? teams[i].data["MarketDriverScoreR1S2"][round] : 0;
                        data2.push(value);
                        value = teams[i].data["MarketDriverScoreR1S3"] ? teams[i].data["MarketDriverScoreR1S3"][round] : 0;
                        data3.push(value);
                        value = teams[i].data["MarketDriverScoreR1S4"] ? teams[i].data["MarketDriverScoreR1S4"][round] : 0;
                        data4.push(value);
                        value = teams[i].data["MarketDriverScoreR1S5"] ? teams[i].data["MarketDriverScoreR1S5"][round] : 0;
                        data5.push(value);

                        labels.push(teams[i].name);
                    }
                    _c2.default.generate({
                        bindto: "#graph-12-2",
                        data: {
                            columns: [data, data2, data3, data4, data5],
                            type: 'bar'
                        },
                        axis: {
                            x: { type: 'category', categories: labels },
                            y: { show: false }
                        },
                        tooltip: {
                            format: {
                                value: function value(value, ratio, id, index) {
                                    if (id == "Brand Index") {
                                        var value = teams[index].data["FI_RES_EndingBrandIndex"] ? parseFloat(teams[index].data["FI_RES_EndingBrandIndex"][round]) : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    } else if (id == "Price Premium/Discount") {
                                        var value = teams[index].data["FI_RES_PricePremDiscountR1"] ? teams[index].data["FI_RES_PricePremDiscountR1"][round] : 0;
                                        return (0, _numeral2.default)(parseFloat(value) / 100).format("+0,0%");
                                    } else if (id == "Political Influence") {
                                        var value = teams[index].data["FI_RES_PoliticalInfluenceRatingR1"] ? teams[index].data["FI_RES_PoliticalInfluenceRatingR1"][round] : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    } else if (id == "HSE Index") {
                                        var value = teams[index].data["FI_HSEC_Index"] ? teams[index].data["FI_HSEC_Index"][round] : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    } else if (id == "Number of Outlets") {
                                        var value = teams[index].data["FI_RES_TotalOutletsR1"] ? teams[index].data["FI_RES_TotalOutletsR1"][round] : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    }
                                }
                            }
                        }
                    });
                    data = [];
                    labels = [];
                    var total = 0;
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["FI_RES_MktShareR1"] ? teams[i].data["FI_RES_MktShareR1"][round] : 0;
                        total += parseFloat(value);
                        data.push([teams[i].name, value]);
                    }
                    data.push(["Rest of World", 1 - total]);
                    _c2.default.generate({
                        bindto: "#graph-12",
                        data: {
                            columns: data,
                            type: 'pie'
                        }
                    });

                    // graph 13
                    data = ["Brand Index"];
                    data2 = ["Price Premium/Discount"];
                    data3 = ["Political Influence"];
                    data4 = ["HSE Index"];
                    data5 = ["Number of Outlets"];
                    labels = [];
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["MarketDriverScoreR2S1"] ? teams[i].data["MarketDriverScoreR2S1"][round] : 0;
                        data.push(value);
                        value = teams[i].data["MarketDriverScoreR2S2"] ? teams[i].data["MarketDriverScoreR2S2"][round] : 0;
                        data2.push(value);
                        value = teams[i].data["MarketDriverScoreR2S3"] ? teams[i].data["MarketDriverScoreR2S3"][round] : 0;
                        data3.push(value);
                        value = teams[i].data["MarketDriverScoreR2S4"] ? teams[i].data["MarketDriverScoreR2S4"][round] : 0;
                        data4.push(value);
                        value = teams[i].data["MarketDriverScoreR2S5"] ? teams[i].data["MarketDriverScoreR2S5"][round] : 0;
                        data5.push(value);

                        labels.push(teams[i].name);
                    }
                    _c2.default.generate({
                        bindto: "#graph-13-2",
                        data: {
                            columns: [data, data2, data3, data4, data5],
                            type: 'bar'
                        },
                        axis: {
                            x: { type: 'category', categories: labels },
                            y: { show: false }
                        },
                        tooltip: {
                            format: {
                                value: function value(value, ratio, id, index) {
                                    if (id == "Brand Index") {
                                        var value = teams[index].data["FI_RES_EndingBrandIndex"] ? parseFloat(teams[index].data["FI_RES_EndingBrandIndex"][round]) : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    } else if (id == "Price Premium/Discount") {
                                        var value = teams[index].data["FI_RES_PricePremDiscountR1"] ? teams[index].data["FI_RES_PricePremDiscountR1"][round] : 0;
                                        return (0, _numeral2.default)(parseFloat(value) / 100).format("+0,0%");
                                    } else if (id == "Political Influence") {
                                        var value = teams[index].data["FI_RES_PoliticalInfluenceRatingR2"] ? teams[index].data["FI_RES_PoliticalInfluenceRatingR2"][round] : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    } else if (id == "HSE Index") {
                                        var value = teams[index].data["FI_HSEC_Index"] ? teams[index].data["FI_HSEC_Index"][round] : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    } else if (id == "Number of Outlets") {
                                        var value = teams[index].data["FI_RES_TotalOutletsR2"] ? teams[index].data["FI_RES_TotalOutletsR2"][round] : 0;
                                        return (0, _numeral2.default)(value).format("0,0");
                                    }
                                }
                            }
                        }
                    });
                    data = [];
                    labels = [];
                    total = 0;
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["FI_RES_MktShareR2"] ? teams[i].data["FI_RES_MktShareR2"][round] : 0;
                        total += parseFloat(value);
                        data.push([teams[i].name, value]);
                    }
                    data.push(["Rest of World", 1 - total]);
                    _c2.default.generate({
                        bindto: "#graph-13",
                        data: {
                            columns: data,
                            type: 'pie'
                        }
                    });

                    // graph 30
                    var columns = [];
                    labels = ["Period 0", "Period 1", "Period 2", "Period 3"];
                    for (var i = 0; i < teams.length; ++i) {
                        var value = teams[i].data["FI_RES_ProductionBOEPerDayR1P1"] ? teams[i].data["FI_RES_ProductionBOEPerDayR1P1"][round] : 0;
                        columns[i] = [teams[i].name, parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][0] : 0), parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][1] : 0), parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][2] : 0), parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][3] : 0)];
                    }
                    _c2.default.generate({
                        bindto: "#graph-30",
                        data: {
                            columns: columns,
                            type: 'line'
                        },
                        axis: {
                            x: { type: 'category', categories: labels },
                            y: { tick: { format: function format(v) {
                                        return (0, _numeral2.default)(v).format("0,0.0%");
                                    } } }
                        }
                    });

                    var rrrTable = {
                        header: "<th style='border-bottom: 1px solid;padding: 10px;'>RRR</th>",
                        "north-oil": "<td style='text-align: left;padding: 10px;'><b>Global North Oil</b></td>",
                        "north-gas": "<td style='text-align: left;padding: 10px;'><b>Global North Gas</b></td>",
                        "south-oil": "<td style='text-align: left;padding: 10px;'><b>Global South Oil</b></td>",
                        "south-gas": "<td style='text-align: left;padding: 10px;'><b>Global South Gas</b></td>"
                    };

                    for (var i = 0; i < teams.length; ++i) {

                        var rrr1 = parseFloat(teams[i].data["FI_RES_RRRR1P1"] ? teams[i].data["FI_RES_RRRR1P1"][round] : 0);
                        var rrr2 = parseFloat(teams[i].data["FI_RES_RRRR1P2"] ? teams[i].data["FI_RES_RRRR1P2"][round] : 0);
                        var rrr3 = parseFloat(teams[i].data["FI_RES_RRRR2P1"] ? teams[i].data["FI_RES_RRRR2P1"][round] : 0);
                        var rrr4 = parseFloat(teams[i].data["FI_RES_RRRR2P2"] ? teams[i].data["FI_RES_RRRR2P2"][round] : 0);

                        rrrTable["header"] += "<th style='border-bottom: 1px solid;padding: 10px;'>" + teams[i].name + "</th>";
                        rrrTable["north-oil"] += "<td style='padding: 10px;'>" + (0, _numeral2.default)(rrr1).format("0.0") + "</td>";
                        rrrTable["north-gas"] += "<td style='padding: 10px;'>" + (0, _numeral2.default)(rrr2).format("0.0") + "</td>";
                        rrrTable["south-oil"] += "<td style='padding: 10px;'>" + (0, _numeral2.default)(rrr3).format("0.0") + "</td>";
                        rrrTable["south-gas"] += "<td style='padding: 10px;'>" + (0, _numeral2.default)(rrr4).format("0.0") + "</td>";
                    }

                    for (var j in rrrTable) {
                        document.getElementById("rrr-" + j).innerHTML = rrrTable[j];
                    }

                    var roceTable = {
                        header: "<th style='border-bottom: 1px solid;padding: 10px;'>ROCE</th>",
                        "earnings": "<td style='text-align: left;padding: 10px;'><b>Earnings</b></td>",
                        "capital": "<td style='text-align: left;padding: 10px;'><b>Capital Employed</b></td>",
                        "roce": "<td style='text-align: left;padding: 10px;'><b>ROCE</b></td>"
                    };

                    for (var i = 0; i < teams.length; ++i) {

                        var roce1 = parseFloat(teams[i].data["FI_RES_IncomeFromOps"] ? teams[i].data["FI_RES_IncomeFromOps"][round] : 0);
                        var roce2 = parseFloat(teams[i].data["FI_TotAssets"] ? teams[i].data["FI_TotAssets"][round] : 0);
                        var roce3 = parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][round] : 0);

                        roceTable["header"] += "<th style='border-bottom: 1px solid;padding: 10px;'>" + teams[i].name + "</th>";
                        roceTable["earnings"] += "<td style='padding: 10px;'>" + (0, _numeral2.default)(roce1).format("$0,0") + "</td>";
                        roceTable["capital"] += "<td style='padding: 10px;'>" + (0, _numeral2.default)(roce2).format("$0,0") + "</td>";
                        roceTable["roce"] += "<td style='padding: 10px;'>" + (0, _numeral2.default)(roce3).format("0.0%") + "</td>";
                    }

                    for (var j in roceTable) {
                        document.getElementById("roce-" + j).innerHTML = roceTable[j];
                    }

                    var table = {
                        "header": "<th style='border-bottom: 1px solid;'>&nbsp;</th>",
                        "rrr": "<td style='text-align: left'><b>RRR</b></td>",
                        "rrr-points": "<td style='text-align: left'>Weighted Points</td>",
                        "market": "<td style='text-align: left'><b>Market Share</b></td>",
                        "market-points": "<td style='text-align: left'>Weighted Points</td>",
                        "roce": "<td style='text-align: left'><b>ROCE</b></td>",
                        "roce-points": "<td style='text-align: left'>Weighted Points</td>",
                        "totals": "<td style='text-align: left; border-top: 1px solid;'><b>Sub Total</b></td>",
                        "combined": "<td style='text-align: left;'><b>TOTAL POINTS</b></td>"
                    };

                    for (var i = 0; i < teams.length; ++i) {
                        teams[i].combinedScore = 0;
                    }

                    for (var r = 1; r <= round; ++r) {
                        var rrr = [];
                        var market = [];
                        var roce = [];
                        for (var i = 0; i < teams.length; ++i) {
                            var rr = parseFloat(teams[i].data["FI_RES_AvgRRR"] ? teams[i].data["FI_RES_AvgRRR"][r] : 0);
                            var m = (parseFloat(teams[i].data["FI_RES_MktShareR2"] ? teams[i].data["FI_RES_MktShareR2"][r] : 0) + parseFloat(teams[i].data["FI_RES_MktShareR1"] ? teams[i].data["FI_RES_MktShareR1"][r] : 0)) / 2;
                            var ro = parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][r] : 0);
                            if (r == round) {
                                table["header"] += "<th style='border-bottom: 1px solid;'>" + teams[i].name + "</th>";
                                table["rrr"] += "<td>" + (0, _numeral2.default)(rr).format("0.00") + "</td>";
                                table["market"] += "<td>" + (0, _numeral2.default)(m).format("0.00%") + "</td>";
                                table["roce"] += "<td>" + (0, _numeral2.default)(ro).format("0.00%") + "</td>";
                            }
                            teams[i].temp = {
                                r: rr,
                                m: m,
                                ro: ro
                            };
                            teams[i].scores = {
                                r: 0,
                                m: 0,
                                ro: 0
                            };
                            rrr.push(teams[i]);
                            market.push(teams[i]);
                            roce.push(teams[i]);
                        }

                        rrr.sort(function (a, b) {
                            return Math.abs(1 - a.temp.r) - Math.abs(1 - b.temp.r);
                        });
                        market.sort(function (a, b) {
                            return b.temp.m - a.temp.m;
                        });
                        roce.sort(function (a, b) {
                            return b.temp.ro - a.temp.ro;
                        });
                        var points = [10, 8, 6, 4, 2, 1, 0, 0, 0];
                        for (var i = 0; i < rrr.length; ++i) {
                            if (rrr[i].temp.r == 0) {
                                continue;
                            }
                            rrr[i].scores.r = points[i] * 0.3;
                        }
                        for (var i = 0; i < market.length; ++i) {
                            if (market[i].temp.m == 0) {
                                continue;
                            }
                            market[i].scores.m = points[i] * 0.3;
                        }
                        for (var i = 0; i < roce.length; ++i) {
                            if (roce[i].temp.ro == 0) {
                                continue;
                            }
                            roce[i].scores.ro = points[i] * 0.4;
                        }
                        for (var i = 0; i < teams.length; ++i) {
                            teams[i].combinedScore += teams[i].scores.r + teams[i].scores.m + teams[i].scores.ro;
                        }
                        if (r == round) {
                            for (var i = 0; i < teams.length; ++i) {
                                table["rrr-points"] += "<td>" + (0, _numeral2.default)(teams[i].scores.r).format("0.0") + "</td>";
                                table["market-points"] += "<td>" + (0, _numeral2.default)(teams[i].scores.m).format("0.0") + "</td>";
                                table["roce-points"] += "<td>" + (0, _numeral2.default)(teams[i].scores.ro).format("0.0") + "</td>";
                                table["totals"] += "<td style='border-top: 1px solid;'><b>" + (0, _numeral2.default)(teams[i].scores.r + teams[i].scores.m + teams[i].scores.ro).format("0.0") + "</b></td>";
                                table["combined"] += "<td style='border-top: 1px solid;'><b>" + (0, _numeral2.default)(teams[i].combinedScore).format("0.0") + "</b></td>";
                            }
                        }
                    }

                    for (var j in table) {
                        document.getElementById("scores-" + j).innerHTML = table[j];
                    }
                }, function (error) {
                    console.log(error);
                }).always(function () {
                    self.debriefLoading = false;
                });
            }, function (error) {
                alert(error);
                self.debriefLoading = false;
            }).always(function () {});
        }
    }, {
        key: "nextSlide",
        value: function nextSlide() {
            ++this.slide;
            if (this.slide > this.totalSlides) {
                this.slide = this.totalSlides;
            }
        }
    }, {
        key: "prevSlide",
        value: function prevSlide() {
            --this.slide;
            if (this.slide < 0) {
                this.slide = 0;
            }
        }
    }]);
    return ResourcesViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "debriefVisible", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "debriefLoading", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "debriefRound", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 1;
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "slide", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "totalSlides", [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return 27;
    }
}), _applyDecoratedDescriptor(_class.prototype, "hideDebrief", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "hideDebrief"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDebrief", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "showDebrief"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextSlide", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "nextSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "prevSlide", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "prevSlide"), _class.prototype)), _class));
exports.default = ResourcesViewStore;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ResourcesViewStore, "ResourcesViewStore", "D:/VSTS/agent/_work/24/s/app_modules/resources-activity/src/viewstore.js");
}();

;

/***/ }),

/***/ "./app_modules/simgate-auth-strategy/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChooseSession = exports.SignUp = exports.SignIn = exports.SimgateAuthViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _dec5, _dec6, _class3, _class4, _temp, _class5, _class6;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SimgateAuthViewStore = exports.SimgateAuthViewStore = (_dec = _mobx.observable.ref, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class = function (_mix$with) {
  (0, _inherits3.default)(SimgateAuthViewStore, _mix$with);

  function SimgateAuthViewStore() {
    (0, _classCallCheck3.default)(this, SimgateAuthViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SimgateAuthViewStore.__proto__ || (0, _getPrototypeOf2.default)(SimgateAuthViewStore)).apply(this, arguments));

    _initDefineProp(_this, "role", _descriptor, _this);

    _initDefineProp(_this, "claim", _descriptor2, _this);

    _initDefineProp(_this, "warning", _descriptor3, _this);

    var _this$props = _this.props,
        contentModel = _this$props.contentModel,
        projectDomainStore = _this$props.dataModel.domainStore,
        route = _this$props.currentView.route,
        modalViewStore = _this$props.modalViewStore;

    //just in case we're already signed in :-)

    if (!(process && __webpack_require__.i({"api":"simgate","NODE_ENV":"production","localMode":false}) && __webpack_require__.i({"api":"simgate","NODE_ENV":"production","localMode":false}).mockMode)) projectDomainStore.refreshContext();

    // tempoarary until we actually get this in place
    setTimeout(function () {
      projectDomainStore.context.simParentPathId = 3;
    }, 1000);
    // set up condition for this auth strategy being "done""
    (0, _mobx.when)(function () {
      return projectDomainStore.context.simParentPathId > 0 //we have user's future team paths' parent path
      && projectDomainStore.context.user.roleID && route.roles.some(function (r) {
        return r.roleId === projectDomainStore.context.user.roleID;
      });
    }, //user context reflects they are allowed in to this route
    function () {
      projectDomainStore.signOut = (0, _mobx.action)(function () {
        var dirtyEntities = contentModel.$parent.entities.values().filter(function (ent) {
          return ent.isDirty;
        });
        modalViewStore.setModal({
          title: "Would you like to log out?",
          message: dirtyEntities.length ? "You will lose " + dirtyEntities.length + " unsaved changes." : "",
          confirmLabel: 'Logout',
          confirmBtnClass: 'green check-a',
          cancelLabel: 'Cancel',
          cancelBtnClass: 'red times-b',
          onConfirmFunc: function onConfirmFunc() {
            return projectDomainStore._signOut(function () {
              return window.location.reload();
            });
          }
        });
      });
      contentModel.done = true;
    });

    return _this;
  }

  (0, _createClass3.default)(SimgateAuthViewStore, [{
    key: "handleSignIn",
    value: function handleSignIn(e) {
      var _this2 = this;

      e && e.preventDefault && e.preventDefault();
      var domainStore = this.props.dataModel.domainStore;

      domainStore.signIn(this.claim, null, function (err) {
        return err && (_this2.warning = err.message);
      });
    }
  }, {
    key: "handleSignUp",
    value: function handleSignUp(e) {
      var _this3 = this;

      e.preventDefault();
      var _props = this.props,
          domainStore = _props.dataModel.domainStore,
          _props$contentModel = _props.contentModel,
          allowSignupFor = _props$contentModel.allowSignupFor,
          authCode = _props$contentModel.authCode;


      domainStore.createUser((0, _extends3.default)({
        roleID: allowSignupFor.roleId,
        firstName: this.claim.loginName,
        email: this.claim.loginName
      }, this.claim), function () {
        return _this3.handleSignIn();
      });
    }
  }, {
    key: "updateClaim",
    value: function updateClaim(which, val) {
      this.claim[which] = val;
    }
  }, {
    key: "viewMap",
    get: function get() {
      return {
        "signup": {
          id: "signup",
          Component: SignUp,
          contentModel: this.props.contentModel
        },
        "chooseSession": {
          id: "chooseSession",
          Component: ChooseSession,
          contentModel: this.props.contentModel
        }
      };
    }
  }, {
    key: "invalidSignUp",
    get: function get() {
      var invalid = {};
      var authCode = this.props.contentModel.authCode;


      if (!this.claim.loginName) invalid.email = "*Please enter email";
      if (!this.claim.password) invalid.password = "*Please enter password";
      // @TODO use encryption to make this worth something
      if (this.claim.authCode !== authCode) invalid.authCode = "*Invalid auth code";
      return invalid;
    }
  }, {
    key: "invalidSignIn",
    get: function get() {
      var domainStore = this.props.dataModel.domainStore;
      var _props2 = this.props,
          roles = _props2.currentView.route.roles,
          authCode = _props2.contentModel.authCode;


      var invalid = {};

      if (!this.claim.loginName) invalid.email = "*Please enter email";
      if (!this.claim.password) invalid.password = "*Please enter password";
      if (domainStore.context.user.roleID && !roles.some(function (r) {
        return r.roleId === domainStore.context.user.roleID;
      })) invalid.notAuthorized = "Not authorized.";
      return invalid;
    }
  }]);
  return SimgateAuthViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "role", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "claim", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      loginName: "",
      password: "",
      authCode: ""
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "viewMap", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "viewMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalidSignUp", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalidSignUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalidSignIn", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalidSignIn"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "warning", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleSignIn", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "handleSignIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSignUp", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "handleSignUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateClaim", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "updateClaim"), _class.prototype)), _class));
var SignIn = exports.SignIn = (_dec5 = (0, _mobxReact.inject)("dataModel"), _dec6 = (0, _mobxReact.inject)("modalViewStore"), (0, _simboxEditable.Decorator)(_class3 = _dec5(_class3 = _dec6(_class3 = (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = (_temp = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(SignIn, _BaseComponent);

  function SignIn() {
    (0, _classCallCheck3.default)(this, SignIn);
    return (0, _possibleConstructorReturn3.default)(this, (SignIn.__proto__ || (0, _getPrototypeOf2.default)(SignIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(SignIn, [{
    key: "render",
    value: function render() {
      var _props3 = this.props,
          domainStore = _props3.dataModel.domainStore,
          authContentModel = _props3.contentModel;
      var title = authContentModel.title,
          headerMessage = authContentModel.headerMessage,
          welcomeMessage = authContentModel.welcomeMessage,
          allowSignupFor = authContentModel.allowSignupFor;
      var _viewStore = this.viewStore,
          SelectedView = _viewStore.SelectedView,
          clearView = _viewStore.clearView,
          selectView = _viewStore.selectView,
          handleSignIn = _viewStore.handleSignIn,
          invalid = _viewStore.invalidSignIn,
          claim = _viewStore.claim,
          updateClaim = _viewStore.updateClaim,
          warning = _viewStore.warning;


      if (invalid.notAuthorized) {
        return _react2.default.createElement(
          "div",
          null,
          invalid.notAuthorized,
          _react2.default.createElement(
            "button",
            { onClick: function onClick() {
                return domainStore.signOut(function () {
                  return window.location.reload();
                });
              } },
            "Reload"
          )
        );
      }

      if (SelectedView) return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(SelectedView, { viewStore: this.viewStore })
      );

      //actual sign in view    
      return _react2.default.createElement(
        "div",
        { className: "sign-on-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "input-box sign-on" },
          _react2.default.createElement(
            "form",
            { "data-editable": authContentModel },
            _react2.default.createElement(
              "div",
              { className: "role-title" },
              title
            ),
            _react2.default.createElement(
              "div",
              { className: "messages" },
              !!headerMessage && _react2.default.createElement(
                "h2",
                { className: "header-message" },
                headerMessage
              ),
              !!welcomeMessage && _react2.default.createElement(
                "div",
                { className: "welcome-message" },
                welcomeMessage
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "inputs" },
              _react2.default.createElement("input", { className: "email", type: "text", value: claim.loginName, placeholder: "Email Address", onChange: function onChange(e) {
                  return updateClaim("loginName", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.email
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "password", type: "password", value: claim.password, placeholder: "Password", onChange: function onChange(e) {
                  return updateClaim("password", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.password
              ),
              _react2.default.createElement("br", null),
              !!warning && _react2.default.createElement(
                "h2",
                null,
                warning
              ),
              _react2.default.createElement(
                "div",
                { className: "sign-in-actions" },
                _react2.default.createElement(
                  "button",
                  { disabled: (0, _keys2.default)(invalid).length, className: "btn red sign-in-b", onClick: handleSignIn },
                  "Sign In"
                )
              )
            ),
            !!allowSignupFor && _react2.default.createElement(
              "div",
              { className: "sign-up-container" },
              _react2.default.createElement(
                "span",
                { className: "nr-text" },
                "Not Registered?"
              ),
              _react2.default.createElement(
                "span",
                { className: "nr-link", onClick: function onClick(e) {
                    e.preventDefault();selectView("signup", { role: allowSignupFor });
                  } },
                "Sign Up"
              )
            )
          )
        )
      );
    }
  }]);
  return SignIn;
}(_baseComponent2.default), _class4.ViewStore = SimgateAuthViewStore, _temp)) || _class3) || _class3) || _class3) || _class3) || _class3);
var _default = SignIn;
exports.default = _default;

var SignUp = exports.SignUp = (0, _simboxEditable.Decorator)(_class5 = (0, _mobxReact.observer)(_class5 = (0, _autoclassDecorator2.default)(_class5 = function (_BaseComponent2) {
  (0, _inherits3.default)(SignUp, _BaseComponent2);

  function SignUp() {
    (0, _classCallCheck3.default)(this, SignUp);
    return (0, _possibleConstructorReturn3.default)(this, (SignUp.__proto__ || (0, _getPrototypeOf2.default)(SignUp)).apply(this, arguments));
  }

  (0, _createClass3.default)(SignUp, [{
    key: "render",
    value: function render() {
      var _props4 = this.props,
          contentModel = _props4.contentModel,
          _props4$contentModel = _props4.contentModel,
          signUpMessage = _props4$contentModel.signUpMessage,
          allowSignupFor = _props4$contentModel.allowSignupFor,
          title = _props4$contentModel.title,
          _props4$viewStore = _props4.viewStore,
          handleSignUp = _props4$viewStore.handleSignUp,
          claim = _props4$viewStore.claim,
          updateClaim = _props4$viewStore.updateClaim,
          invalid = _props4$viewStore.invalidSignUp,
          clearView = _props4$viewStore.clearView;


      return _react2.default.createElement(
        "div",
        { className: "sign-on-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "input-box sign-on" },
          _react2.default.createElement(
            "form",
            null,
            !!contentModel.title && _react2.default.createElement(
              "div",
              { className: "role-title" },
              contentModel.title
            ),
            !!signUpMessage && _react2.default.createElement(
              "div",
              { className: "messages" },
              !!signUpMessage && _react2.default.createElement(
                "div",
                { className: "welcome-message" },
                signUpMessage
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "inputs" },
              _react2.default.createElement("input", { className: "email", type: "text", value: claim.loginName, placeholder: "Email Address", onChange: function onChange(e) {
                  return updateClaim("loginName", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.email
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "password", type: "password", value: claim.password, placeholder: "Password", onChange: function onChange(e) {
                  return updateClaim("password", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.password
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "auth-code", type: "password", value: claim.authCode, placeholder: "Authorization Code", onChange: function onChange(e) {
                  return updateClaim("authCode", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.authCode
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "div",
                { className: "sign-in-actions" },
                _react2.default.createElement(
                  "span",
                  { className: "btn red sign-up-b", disabled: !!(0, _keys2.default)(invalid).length, onClick: handleSignUp },
                  "Sign Up"
                )
              )
            ),
            !!allowSignupFor && _react2.default.createElement(
              "div",
              { className: "sign-up-container" },
              _react2.default.createElement(
                "span",
                { className: "nr-text" },
                "Already Registered?"
              ),
              _react2.default.createElement(
                "span",
                { className: "nr-link", onClick: function onClick(e) {
                    return clearView();
                  } },
                "Sign In"
              )
            )
          )
        )
      );
    }
  }]);
  return SignUp;
}(_baseComponent2.default)) || _class5) || _class5) || _class5;

var ChooseSession = exports.ChooseSession = (0, _simboxEditable.Decorator)(_class6 = (0, _mobxReact.observer)(_class6 = (0, _autoclassDecorator2.default)(_class6 = function (_BaseComponent3) {
  (0, _inherits3.default)(ChooseSession, _BaseComponent3);

  function ChooseSession() {
    (0, _classCallCheck3.default)(this, ChooseSession);
    return (0, _possibleConstructorReturn3.default)(this, (ChooseSession.__proto__ || (0, _getPrototypeOf2.default)(ChooseSession)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChooseSession, [{
    key: "render",
    value: function render() {
      var _props5 = this.props,
          contentModel = _props5.contentModel,
          signUpMessage = _props5.contentModel.signUpMessage,
          handleSignUp = _props5.handleSignUp,
          claim = _props5.claim,
          updateClaim = _props5.updateClaim,
          invalid = _props5.invalid;


      return _react2.default.createElement(
        "div",
        { className: "sign-on-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "input-box sign-on" },
          _react2.default.createElement(
            "form",
            { "data-editable": contentModel },
            !!signUpMessage && _react2.default.createElement(
              "div",
              { className: "messages" },
              !!signUpMessage && _react2.default.createElement(
                "div",
                { className: "signup-message" },
                signUpMessage
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "inputs" },
              _react2.default.createElement("input", { className: "email", type: "text", value: claim.loginName, placeholder: "Email Address", onChange: function onChange(e) {
                  return updateClaim("loginName", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.email
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement("input", { className: "password", type: "password", value: claim.password, placeholder: "Password", onChange: function onChange(e) {
                  return updateClaim("password", e.target.value);
                } }),
              _react2.default.createElement(
                "span",
                { className: "validation-error" },
                invalid.password
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "div",
                { className: "sign-in-actions" },
                _react2.default.createElement(
                  "span",
                  { className: "btn red sign-up-b", onClick: handleSignUp },
                  "Sign Up"
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ChooseSession;
}(_baseComponent2.default)) || _class6) || _class6) || _class6;

;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimgateAuthViewStore, "SimgateAuthViewStore", "D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/component.js");

  __REACT_HOT_LOADER__.register(SignIn, "SignIn", "D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/component.js");

  __REACT_HOT_LOADER__.register(SignUp, "SignUp", "D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/component.js");

  __REACT_HOT_LOADER__.register(ChooseSession, "ChooseSession", "D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/component.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./app_modules/simgate-auth-strategy/component.localmode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class2, _temp;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _component = __webpack_require__("./app_modules/simgate-auth-strategy/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this mock component mixin is necessary when a superclass is "injected", ie when @editable is used
// it merges statics onto the wrappedComponent so they are still accessible
var MockComponentMixin = (0, _mixwith.Mixin)(function (superclass) {
  return function (_superclass) {
    (0, _inherits3.default)(_class, _superclass);

    function _class() {
      (0, _classCallCheck3.default)(this, _class);

      var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));

      if (superclass.wrappedComponent) {
        (0, _keys2.default)(_this.constructor).forEach(function (k) {
          superclass.wrappedComponent[k] = _this.constructor[k];
        });
      }
      return _this;
    }

    return _class;
  }(superclass);
});

var SimgateAuthMock = (_temp = _class2 = function (_mix$with) {
  (0, _inherits3.default)(SimgateAuthMock, _mix$with);

  function SimgateAuthMock() {
    (0, _classCallCheck3.default)(this, SimgateAuthMock);
    return (0, _possibleConstructorReturn3.default)(this, (SimgateAuthMock.__proto__ || (0, _getPrototypeOf2.default)(SimgateAuthMock)).apply(this, arguments));
  }

  return SimgateAuthMock;
}((0, _mixwith.mix)(_component2.default).with(MockComponentMixin)), _class2.setUpMock = function (context) {
  var _context$props = context.props,
      domainStore = _context$props.dataModel.domainStore,
      _context$props$conten = _context$props.contentModel,
      apiUrl = _context$props$conten.apiUrl,
      applicationId = _context$props$conten.applicationId,
      route = _context$props.currentView.route;


  domainStore.mockRoleId = route.role.roleId;
}, _temp);
exports.default = SimgateAuthMock;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MockComponentMixin, 'MockComponentMixin', 'D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/component.localmode.js');

  __REACT_HOT_LOADER__.register(SimgateAuthMock, 'SimgateAuthMock', 'D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/component.localmode.js');
}();

;

/***/ }),

/***/ "./app_modules/simgate-auth-strategy/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimgateAuthContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class2, _temp2;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _component = __webpack_require__("./app_modules/simgate-auth-strategy/component.js");

var _component2 = _interopRequireDefault(_component);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/contentmodel.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SimgateAuthContentModel = exports.SimgateAuthContentModel = (_dec = _mobx.observable.ref, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(SimgateAuthContentModel, _BaseContentModel);

  function SimgateAuthContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SimgateAuthContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SimgateAuthContentModel.__proto__ || (0, _getPrototypeOf2.default)(SimgateAuthContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.Component = _component2.default, _initDefineProp(_this, 'title', _descriptor, _this), _initDefineProp(_this, 'welcomeMessage', _descriptor2, _this), _initDefineProp(_this, 'headerMessage', _descriptor3, _this), _initDefineProp(_this, 'signUpMessage', _descriptor4, _this), _initDefineProp(_this, 'allowSignupFor', _descriptor5, _this), _initDefineProp(_this, 'authCode', _descriptor6, _this), _initDefineProp(_this, 'done', _descriptor7, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* @slot */
  /* @slot */
  /* @slot */
  /* @slot */
  /* @slot */

  return SimgateAuthContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  title: "",
  welcomeMessage: "",
  headerMessage: "",
  signUpMessage: "",
  allowSignupFor: _contentmodel.RoleContentModel,
  authCode: ""
}, _class2._meta = {
  allowSignupFor: {
    // @TODO actually implement :-)
    hideMenu: ["add"]
  }
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'title', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'welcomeMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'headerMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'signUpMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'allowSignupFor', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'authCode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Regis123";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'done', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class));
var _default = SimgateAuthContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimgateAuthContentModel, 'SimgateAuthContentModel', 'D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/contentmodel.js');
}();

;

/***/ }),

/***/ "./app_modules/simgate-auth-strategy/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = exports.description = undefined;

var _contentmodel = __webpack_require__("./app_modules/simgate-auth-strategy/contentmodel.js");

var simgateAuthContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// // in local context, style will be loaded via normal webpack require (direct insert into head)
// // in remote context, webpack will compile this as a string, and export as "stylesheet" from module
// import style from './style.css';

var description = exports.description = "Simgate auth strategy is the default way to authorize via simgate.";
var ContentModels = exports.ContentModels = simgateAuthContentModels;
var ContentModel = exports.ContentModel = simgateAuthContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(description, "description", "D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/index.js");

  __REACT_HOT_LOADER__.register(ContentModels, "ContentModels", "D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/index.js");

  __REACT_HOT_LOADER__.register(ContentModel, "ContentModel", "D:/VSTS/agent/_work/24/s/app_modules/simgate-auth-strategy/index.js");
}();

;

/***/ }),

/***/ "./css/app.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules recursive ^\\.\\/[a-zA-Z0-9\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(src|node_modules|tests)).*\\.(js|jsx|css|json)$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./trc-example-activity/coverage/coverage-summary.json": "./node_modules/trc-example-activity/coverage/coverage-summary.json",
	"./trc-example-activity/dist/component.js": "./node_modules/trc-example-activity/dist/component.js",
	"./trc-example-activity/dist/contentmodel.js": "./node_modules/trc-example-activity/dist/contentmodel.js",
	"./trc-example-activity/dist/index.js": "./node_modules/trc-example-activity/dist/index.js",
	"./trc-example-activity/dist/style.css": "./node_modules/trc-example-activity/dist/style.css",
	"./trc-example-activity/package.json": "./node_modules/trc-example-activity/package.json"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules recursive ^\\.\\/[a-zA-Z0-9\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(src|node_modules|tests)).*\\.(js|jsx|css|json)$";

/***/ }),

/***/ "./node_modules/ag-grid-react/lib/agGridReact.js":
/***/ (function(module, exports, __webpack_require__) {

// ag-grid-react v7.2.0
/// <reference path="../typings/tsd"/>
var reactFrameworkFactory_1 = __webpack_require__("./node_modules/ag-grid-react/lib/reactFrameworkFactory.js");
var React = __webpack_require__("./node_modules/react/react.js");
var ReactDOM = __webpack_require__("./node_modules/react-dom/index.js");
var AgGrid = __webpack_require__("./node_modules/ag-grid/main.js");
exports.AgGridReact = React.createClass({
    render: function () {
        return React.DOM.div({
            style: this.createStyleForDiv()
        });
    },
    createStyleForDiv: function () {
        var style = { height: '100%' };
        // allow user to override styles
        var containerStyle = this.props.containerStyle;
        if (containerStyle) {
            Object.keys(containerStyle).forEach(function (key) {
                var value = containerStyle[key];
                style[key] = value;
            });
        }
        return style;
    },
    componentDidMount: function () {
        var reactFrameworkFactory = new reactFrameworkFactory_1.ReactFrameworkFactory(this);
        var gridParams = { frameworkFactory: reactFrameworkFactory };
        var domNode = ReactDOM.findDOMNode(this);
        this.gridOptions = AgGrid.ComponentUtil.copyAttributesToGridOptions(this.props.gridOptions, this.props);
        new AgGrid.Grid(domNode, this.gridOptions, gridParams);
        this.api = this.gridOptions.api;
        this.columnApi = this.gridOptions.columnApi;
    },
    shouldComponentUpdate: function () {
        // we want full control of the dom, as ag-Grid doesn't use React internally,
        // so for performance reasons we tell React we don't need render called after
        // property changes.
        return false;
    },
    componentWillReceiveProps: function (nextProps) {
        var _this = this;
        // keeping consistent with web components, put changing
        // values in currentValue and previousValue pairs and
        // not include items that have not changed.
        var changes = {};
        AgGrid.ComponentUtil.ALL_PROPERTIES.forEach(function (propKey) {
            if (_this.props[propKey] !== nextProps[propKey]) {
                changes[propKey] = {
                    previousValue: _this.props[propKey],
                    currentValue: nextProps[propKey]
                };
            }
        });
        AgGrid.ComponentUtil.getEventCallbacks().forEach(function (funcName) {
            if (_this.props[funcName] !== nextProps[funcName]) {
                changes[funcName] = {
                    previousValue: _this.props[funcName],
                    currentValue: nextProps[funcName]
                };
            }
        });
        AgGrid.ComponentUtil.processOnChange(changes, this.gridOptions, this.api, this.columnApi);
    },
    componentWillUnmount: function () {
        this.api.destroy();
    }
});
exports.AgGridReact.propTypes = {
    gridOptions: React.PropTypes.object,
};
addProperties(AgGrid.ComponentUtil.getEventCallbacks(), React.PropTypes.func);
addProperties(AgGrid.ComponentUtil.BOOLEAN_PROPERTIES, React.PropTypes.bool);
addProperties(AgGrid.ComponentUtil.STRING_PROPERTIES, React.PropTypes.string);
addProperties(AgGrid.ComponentUtil.OBJECT_PROPERTIES, React.PropTypes.object);
addProperties(AgGrid.ComponentUtil.ARRAY_PROPERTIES, React.PropTypes.array);
addProperties(AgGrid.ComponentUtil.NUMBER_PROPERTIES, React.PropTypes.number);
addProperties(AgGrid.ComponentUtil.FUNCTION_PROPERTIES, React.PropTypes.func);
function addProperties(listOfProps, propType) {
    listOfProps.forEach(function (propKey) {
        exports.AgGridReact[propKey] = propType;
    });
}


/***/ }),

/***/ "./node_modules/ag-grid-react/lib/agReactComponent.js":
/***/ (function(module, exports, __webpack_require__) {

// ag-grid-react v7.2.0
var React = __webpack_require__("./node_modules/react/react.js");
var ReactDOM = __webpack_require__("./node_modules/react-dom/index.js");
var AgGrid = __webpack_require__("./node_modules/ag-grid/main.js");
var AgReactComponent = (function () {
    function AgReactComponent(reactComponent, parentComponent) {
        this.reactComponent = reactComponent;
        this.parentComponent = parentComponent;
    }
    AgReactComponent.prototype.getFrameworkComponentInstance = function () {
        return this.componentRef;
    };
    AgReactComponent.prototype.init = function (params) {
        this.eParentElement = document.createElement('div');
        AgGrid.Utils.addCssClass(this.eParentElement, 'ag-react-container');
        // so user can have access to the react container,
        // to add css class or style
        params.reactContainer = this.eParentElement;
        var ReactComponent = React.createElement(this.reactComponent, params);
        if (!this.parentComponent) {
            this.componentRef = ReactDOM.render(ReactComponent, this.eParentElement);
        }
        else {
            this.componentRef = ReactDOM.unstable_renderSubtreeIntoContainer(this.parentComponent, ReactComponent, this.eParentElement);
        }
    };
    AgReactComponent.prototype.getGui = function () {
        return this.eParentElement;
    };
    AgReactComponent.prototype.destroy = function () {
        ReactDOM.unmountComponentAtNode(this.eParentElement);
    };
    return AgReactComponent;
})();
exports.AgReactComponent = AgReactComponent;


/***/ }),

/***/ "./node_modules/ag-grid-react/lib/reactCellEditorFactory.js":
/***/ (function(module, exports, __webpack_require__) {

// ag-grid-react v7.2.0
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var agReactComponent_1 = __webpack_require__("./node_modules/ag-grid-react/lib/agReactComponent.js");
function reactCellEditorFactory(reactComponent, parentComponent) {
    var ReactCellEditor = (function (_super) {
        __extends(ReactCellEditor, _super);
        function ReactCellEditor() {
            _super.call(this, reactComponent, parentComponent);
        }
        ReactCellEditor.prototype.getValue = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.getValue) {
                return componentRef.getValue();
            }
            else {
                console.log("ag-Grid: React cellEditor is missing the mandatory method getValue() method");
                return null;
            }
        };
        ReactCellEditor.prototype.afterGuiAttached = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.afterGuiAttached) {
                componentRef.afterGuiAttached();
            }
        };
        ReactCellEditor.prototype.isPopup = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.isPopup) {
                return componentRef.isPopup();
            }
            else {
                return false;
            }
        };
        ReactCellEditor.prototype.isCancelBeforeStart = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.isCancelBeforeStart) {
                return componentRef.isCancelBeforeStart();
            }
            else {
                return false;
            }
        };
        ReactCellEditor.prototype.isCancelAfterEnd = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.isCancelAfterEnd) {
                return componentRef.isCancelAfterEnd();
            }
            else {
                return false;
            }
        };
        ReactCellEditor.prototype.focusIn = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.focusIn) {
                componentRef.focusIn();
            }
        };
        ReactCellEditor.prototype.focusOut = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.focusOut) {
                componentRef.focusOut();
            }
        };
        return ReactCellEditor;
    })(agReactComponent_1.AgReactComponent);
    return ReactCellEditor;
}
exports.reactCellEditorFactory = reactCellEditorFactory;


/***/ }),

/***/ "./node_modules/ag-grid-react/lib/reactCellRendererFactory.js":
/***/ (function(module, exports, __webpack_require__) {

// ag-grid-react v7.2.0
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ag_grid_1 = __webpack_require__("./node_modules/ag-grid/main.js");
var agReactComponent_1 = __webpack_require__("./node_modules/ag-grid-react/lib/agReactComponent.js");
function reactCellRendererFactory(reactComponent, parentComponent) {
    var ReactCellRenderer = (function (_super) {
        __extends(ReactCellRenderer, _super);
        function ReactCellRenderer() {
            _super.call(this, reactComponent, parentComponent);
        }
        ReactCellRenderer.prototype.refresh = function (params) {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.refresh) {
                componentRef.refresh(params);
            }
            else {
                throw new ag_grid_1.MethodNotImplementedException();
            }
        };
        return ReactCellRenderer;
    })(agReactComponent_1.AgReactComponent);
    return ReactCellRenderer;
}
exports.reactCellRendererFactory = reactCellRendererFactory;


/***/ }),

/***/ "./node_modules/ag-grid-react/lib/reactFilterFactory.js":
/***/ (function(module, exports, __webpack_require__) {

// ag-grid-react v7.2.0
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var agReactComponent_1 = __webpack_require__("./node_modules/ag-grid-react/lib/agReactComponent.js");
var React = __webpack_require__("./node_modules/react/react.js");
// wraps the provided React filter component
function reactFilterFactory(reactComponent, parentComponent) {
    var ReactFilter = (function (_super) {
        __extends(ReactFilter, _super);
        function ReactFilter() {
            _super.call(this, reactComponent, parentComponent);
        }
        ReactFilter.prototype.init = function (params) {
            _super.prototype.init.call(this, params);
        };
        ReactFilter.prototype.isFilterActive = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.isFilterActive) {
                return componentRef.isFilterActive();
            }
            else {
                console.error("ag-Grid: React filter is missing the mandatory method isFilterActive()");
                return false;
            }
        };
        ReactFilter.prototype.doesFilterPass = function (params) {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.doesFilterPass) {
                return componentRef.doesFilterPass(params);
            }
            else {
                console.error("ag-Grid: React filter is missing the mandatory method doesFilterPass()");
                return false;
            }
        };
        ReactFilter.prototype.getModel = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.getModel) {
                return componentRef.getModel();
            }
            else {
                console.error("ag-Grid: React filter is missing the mandatory method getModel()");
                return null;
            }
        };
        /** Restores the filter state. */
        ReactFilter.prototype.setModel = function (model) {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.setModel) {
                componentRef.setModel(model);
            }
            else {
                console.error("ag-Grid: React filter is missing the mandatory method setModel()");
            }
        };
        ReactFilter.prototype.afterGuiAttached = function (params) {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.afterGuiAttached) {
                componentRef.afterGuiAttached(params);
            }
        };
        ReactFilter.prototype.onNewRowsLoaded = function () {
            var componentRef = this.getFrameworkComponentInstance();
            if (componentRef.onNewRowsLoaded) {
                componentRef.onNewRowsLoaded();
            }
        };
        return ReactFilter;
    })(agReactComponent_1.AgReactComponent);
    return ReactFilter;
}
exports.reactFilterFactory = reactFilterFactory;


/***/ }),

/***/ "./node_modules/ag-grid-react/lib/reactFrameworkFactory.js":
/***/ (function(module, exports, __webpack_require__) {

// ag-grid-react v7.2.0
var ag_grid_1 = __webpack_require__("./node_modules/ag-grid/main.js");
var reactCellRendererFactory_1 = __webpack_require__("./node_modules/ag-grid-react/lib/reactCellRendererFactory.js");
var reactCellEditorFactory_1 = __webpack_require__("./node_modules/ag-grid-react/lib/reactCellEditorFactory.js");
var reactFilterFactory_1 = __webpack_require__("./node_modules/ag-grid-react/lib/reactFilterFactory.js");
var ReactFrameworkFactory = (function () {
    function ReactFrameworkFactory(agGridReact) {
        this.baseFrameworkFactory = new ag_grid_1.BaseFrameworkFactory();
        this.agGridReact = agGridReact;
    }
    ReactFrameworkFactory.prototype.colDefFilter = function (colDef) {
        if (ag_grid_1.Utils.exists(colDef.filterFramework)) {
            return reactFilterFactory_1.reactFilterFactory(colDef.filterFramework, this.agGridReact);
        }
        else {
            return this.baseFrameworkFactory.colDefFilter(colDef);
        }
    };
    ReactFrameworkFactory.prototype.colDefFloatingCellRenderer = function (colDef) {
        if (ag_grid_1.Utils.exists(colDef.floatingCellRendererFramework)) {
            return reactCellRendererFactory_1.reactCellRendererFactory(colDef.floatingCellRendererFramework, this.agGridReact);
        }
        else {
            return this.baseFrameworkFactory.colDefFloatingCellRenderer(colDef);
        }
    };
    ReactFrameworkFactory.prototype.colDefCellRenderer = function (colDef) {
        if (ag_grid_1.Utils.exists(colDef.cellRendererFramework)) {
            return reactCellRendererFactory_1.reactCellRendererFactory(colDef.cellRendererFramework, this.agGridReact);
        }
        else {
            return this.baseFrameworkFactory.colDefCellRenderer(colDef);
        }
    };
    ReactFrameworkFactory.prototype.colDefCellEditor = function (colDef) {
        if (ag_grid_1.Utils.exists(colDef.cellEditorFramework)) {
            return reactCellEditorFactory_1.reactCellEditorFactory(colDef.cellEditorFramework, this.agGridReact);
        }
        else {
            return this.baseFrameworkFactory.colDefCellEditor(colDef);
        }
    };
    ReactFrameworkFactory.prototype.gridOptionsFullWidthCellRenderer = function (gridOptions) {
        if (ag_grid_1.Utils.exists(gridOptions.fullWidthCellRendererFramework)) {
            return reactCellRendererFactory_1.reactCellRendererFactory(gridOptions.fullWidthCellRendererFramework, this.agGridReact);
        }
        else {
            return this.baseFrameworkFactory.gridOptionsFullWidthCellRenderer(gridOptions);
        }
    };
    ReactFrameworkFactory.prototype.gridOptionsGroupRowRenderer = function (gridOptions) {
        if (ag_grid_1.Utils.exists(gridOptions.groupRowRendererFramework)) {
            return reactCellRendererFactory_1.reactCellRendererFactory(gridOptions.groupRowRendererFramework, this.agGridReact);
        }
        else {
            return this.baseFrameworkFactory.gridOptionsGroupRowRenderer(gridOptions);
        }
    };
    ReactFrameworkFactory.prototype.gridOptionsGroupRowInnerRenderer = function (gridOptions) {
        if (ag_grid_1.Utils.exists(gridOptions.groupRowInnerRendererFramework)) {
            return reactCellRendererFactory_1.reactCellRendererFactory(gridOptions.groupRowInnerRendererFramework, this.agGridReact);
        }
        else {
            return this.baseFrameworkFactory.gridOptionsGroupRowInnerRenderer(gridOptions);
        }
    };
    ReactFrameworkFactory.prototype.setTimeout = function (action, timeout) {
        this.baseFrameworkFactory.setTimeout(action, timeout);
    };
    return ReactFrameworkFactory;
})();
exports.ReactFrameworkFactory = ReactFrameworkFactory;


/***/ }),

/***/ "./node_modules/ag-grid-react/main.js":
/***/ (function(module, exports, __webpack_require__) {


exports.AgGridReact = __webpack_require__("./node_modules/ag-grid-react/lib/agGridReact.js").AgGridReact;
exports.reactCellRendererFactory = __webpack_require__("./node_modules/ag-grid-react/lib/reactCellRendererFactory.js").reactCellRendererFactory;
exports.reactFilterFactory = __webpack_require__("./node_modules/ag-grid-react/lib/reactFilterFactory.js").reactFilterFactory;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/baseFrameworkFactory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

/** The base frameworks, eg React & Angular 2, override this bean with implementations specific to their requirement. */
var BaseFrameworkFactory = (function () {
    function BaseFrameworkFactory() {
    }
    BaseFrameworkFactory.prototype.colDefFloatingCellRenderer = function (colDef) {
        return colDef.floatingCellRenderer;
    };
    BaseFrameworkFactory.prototype.colDefCellRenderer = function (colDef) {
        return colDef.cellRenderer;
    };
    BaseFrameworkFactory.prototype.colDefCellEditor = function (colDef) {
        return colDef.cellEditor;
    };
    BaseFrameworkFactory.prototype.colDefFilter = function (colDef) {
        return colDef.filter;
    };
    BaseFrameworkFactory.prototype.gridOptionsFullWidthCellRenderer = function (gridOptions) {
        return gridOptions.fullWidthCellRenderer;
    };
    BaseFrameworkFactory.prototype.gridOptionsGroupRowRenderer = function (gridOptions) {
        return gridOptions.groupRowRenderer;
    };
    BaseFrameworkFactory.prototype.gridOptionsGroupRowInnerRenderer = function (gridOptions) {
        return gridOptions.groupRowInnerRenderer;
    };
    BaseFrameworkFactory.prototype.setTimeout = function (action, timeout) {
        setTimeout(action, timeout);
    };
    return BaseFrameworkFactory;
}());
exports.BaseFrameworkFactory = BaseFrameworkFactory;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/cellNavigationService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var floatingRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/floatingRowModel.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridRow_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridRow.js");
var gridCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridCell.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var CellNavigationService = (function () {
    function CellNavigationService() {
    }
    CellNavigationService.prototype.getNextCellToFocus = function (key, lastCellToFocus) {
        switch (key) {
            case constants_1.Constants.KEY_UP: return this.getCellAbove(lastCellToFocus);
            case constants_1.Constants.KEY_DOWN: return this.getCellBelow(lastCellToFocus);
            case constants_1.Constants.KEY_RIGHT:
                if (this.gridOptionsWrapper.isEnableRtl()) {
                    return this.getCellToLeft(lastCellToFocus);
                }
                else {
                    return this.getCellToRight(lastCellToFocus);
                }
            case constants_1.Constants.KEY_LEFT:
                if (this.gridOptionsWrapper.isEnableRtl()) {
                    return this.getCellToRight(lastCellToFocus);
                }
                else {
                    return this.getCellToLeft(lastCellToFocus);
                }
            default: console.log('ag-Grid: unknown key for navigation ' + key);
        }
    };
    CellNavigationService.prototype.getCellToLeft = function (lastCell) {
        var colToLeft = this.columnController.getDisplayedColBefore(lastCell.column);
        if (!colToLeft) {
            return null;
        }
        else {
            var gridCellDef = { rowIndex: lastCell.rowIndex, column: colToLeft, floating: lastCell.floating };
            return new gridCell_1.GridCell(gridCellDef);
        }
    };
    CellNavigationService.prototype.getCellToRight = function (lastCell) {
        var colToRight = this.columnController.getDisplayedColAfter(lastCell.column);
        // if already on right, do nothing
        if (!colToRight) {
            return null;
        }
        else {
            var gridCellDef = { rowIndex: lastCell.rowIndex, column: colToRight, floating: lastCell.floating };
            return new gridCell_1.GridCell(gridCellDef);
        }
    };
    CellNavigationService.prototype.getRowBelow = function (lastRow) {
        // if already on top row, do nothing
        if (this.isLastRowInContainer(lastRow)) {
            if (lastRow.isFloatingBottom()) {
                return null;
            }
            else if (lastRow.isNotFloating()) {
                if (this.floatingRowModel.isRowsToRender(constants_1.Constants.FLOATING_BOTTOM)) {
                    return new gridRow_1.GridRow(0, constants_1.Constants.FLOATING_BOTTOM);
                }
                else {
                    return null;
                }
            }
            else {
                if (this.rowModel.isRowsToRender()) {
                    return new gridRow_1.GridRow(0, null);
                }
                else if (this.floatingRowModel.isRowsToRender(constants_1.Constants.FLOATING_BOTTOM)) {
                    return new gridRow_1.GridRow(0, constants_1.Constants.FLOATING_BOTTOM);
                }
                else {
                    return null;
                }
            }
        }
        else {
            return new gridRow_1.GridRow(lastRow.rowIndex + 1, lastRow.floating);
        }
    };
    CellNavigationService.prototype.getCellBelow = function (lastCell) {
        var rowBelow = this.getRowBelow(lastCell.getGridRow());
        if (rowBelow) {
            var gridCellDef = { rowIndex: rowBelow.rowIndex, column: lastCell.column, floating: rowBelow.floating };
            return new gridCell_1.GridCell(gridCellDef);
        }
        else {
            return null;
        }
    };
    CellNavigationService.prototype.isLastRowInContainer = function (gridRow) {
        if (gridRow.isFloatingTop()) {
            var lastTopIndex = this.floatingRowModel.getFloatingTopRowData().length - 1;
            return lastTopIndex === gridRow.rowIndex;
        }
        else if (gridRow.isFloatingBottom()) {
            var lastBottomIndex = this.floatingRowModel.getFloatingBottomRowData().length - 1;
            return lastBottomIndex === gridRow.rowIndex;
        }
        else {
            var lastBodyIndex = this.rowModel.getRowCount() - 1;
            return lastBodyIndex === gridRow.rowIndex;
        }
    };
    CellNavigationService.prototype.getRowAbove = function (lastRow) {
        // if already on top row, do nothing
        if (lastRow.rowIndex === 0) {
            if (lastRow.isFloatingTop()) {
                return null;
            }
            else if (lastRow.isNotFloating()) {
                if (this.floatingRowModel.isRowsToRender(constants_1.Constants.FLOATING_TOP)) {
                    return this.getLastFloatingTopRow();
                }
                else {
                    return null;
                }
            }
            else {
                // last floating bottom
                if (this.rowModel.isRowsToRender()) {
                    return this.getLastBodyCell();
                }
                else if (this.floatingRowModel.isRowsToRender(constants_1.Constants.FLOATING_TOP)) {
                    return this.getLastFloatingTopRow();
                }
                else {
                    return null;
                }
            }
        }
        else {
            return new gridRow_1.GridRow(lastRow.rowIndex - 1, lastRow.floating);
        }
    };
    CellNavigationService.prototype.getCellAbove = function (lastCell) {
        var rowAbove = this.getRowAbove(lastCell.getGridRow());
        if (rowAbove) {
            var gridCellDef = { rowIndex: rowAbove.rowIndex, column: lastCell.column, floating: rowAbove.floating };
            return new gridCell_1.GridCell(gridCellDef);
        }
        else {
            return null;
        }
    };
    CellNavigationService.prototype.getLastBodyCell = function () {
        var lastBodyRow = this.rowModel.getRowCount() - 1;
        return new gridRow_1.GridRow(lastBodyRow, null);
    };
    CellNavigationService.prototype.getLastFloatingTopRow = function () {
        var lastFloatingRow = this.floatingRowModel.getFloatingTopRowData().length - 1;
        return new gridRow_1.GridRow(lastFloatingRow, constants_1.Constants.FLOATING_TOP);
    };
    CellNavigationService.prototype.getNextTabbedCell = function (gridCell, backwards) {
        if (backwards) {
            return this.getNextTabbedCellBackwards(gridCell);
        }
        else {
            return this.getNextTabbedCellForwards(gridCell);
        }
    };
    CellNavigationService.prototype.getNextTabbedCellForwards = function (gridCell) {
        var displayedColumns = this.columnController.getAllDisplayedColumns();
        var newRowIndex = gridCell.rowIndex;
        var newFloating = gridCell.floating;
        // move along to the next cell
        var newColumn = this.columnController.getDisplayedColAfter(gridCell.column);
        // check if end of the row, and if so, go forward a row
        if (!newColumn) {
            newColumn = displayedColumns[0];
            var rowBelow = this.getRowBelow(gridCell.getGridRow());
            if (utils_1.Utils.missing(rowBelow)) {
                return;
            }
            newRowIndex = rowBelow.rowIndex;
            newFloating = rowBelow.floating;
        }
        var gridCellDef = { rowIndex: newRowIndex, column: newColumn, floating: newFloating };
        return new gridCell_1.GridCell(gridCellDef);
    };
    CellNavigationService.prototype.getNextTabbedCellBackwards = function (gridCell) {
        var displayedColumns = this.columnController.getAllDisplayedColumns();
        var newRowIndex = gridCell.rowIndex;
        var newFloating = gridCell.floating;
        // move along to the next cell
        var newColumn = this.columnController.getDisplayedColBefore(gridCell.column);
        // check if end of the row, and if so, go forward a row
        if (!newColumn) {
            newColumn = displayedColumns[displayedColumns.length - 1];
            var rowAbove = this.getRowAbove(gridCell.getGridRow());
            if (utils_1.Utils.missing(rowAbove)) {
                return;
            }
            newRowIndex = rowAbove.rowIndex;
            newFloating = rowAbove.floating;
        }
        var gridCellDef = { rowIndex: newRowIndex, column: newColumn, floating: newFloating };
        return new gridCell_1.GridCell(gridCellDef);
    };
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], CellNavigationService.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], CellNavigationService.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('floatingRowModel'), 
        __metadata('design:type', floatingRowModel_1.FloatingRowModel)
    ], CellNavigationService.prototype, "floatingRowModel", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], CellNavigationService.prototype, "gridOptionsWrapper", void 0);
    CellNavigationService = __decorate([
        context_1.Bean('cellNavigationService'), 
        __metadata('design:paramtypes', [])
    ], CellNavigationService);
    return CellNavigationService;
}());
exports.CellNavigationService = CellNavigationService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/clientExports.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var grid_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/grid.js");
var gridApi_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridApi.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var componentUtil_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/components/componentUtil.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var agGridNg1_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/components/agGridNg1.js");
var agGridWebComponent_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/components/agGridWebComponent.js");
var gridCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridCell.js");
var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var originalColumnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/originalColumnGroup.js");
var columnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/columnGroup.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var focusedCellController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/focusedCellController.js");
var functions_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/functions.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var balancedColumnTreeBuilder_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/balancedColumnTreeBuilder.js");
var columnKeyCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnKeyCreator.js");
var columnUtils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnUtils.js");
var displayedGroupCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/displayedGroupCreator.js");
var groupInstanceIdCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/groupInstanceIdCreator.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var dragAndDropService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragAndDropService.js");
var dragService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragService.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var numberFilter_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/numberFilter.js");
var textFilter_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/textFilter.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var mouseEventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/mouseEventService.js");
var cssClassApplier_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/cssClassApplier.js");
var headerContainer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerContainer.js");
var headerRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerRenderer.js");
var headerTemplateLoader_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerTemplateLoader.js");
var horizontalDragService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/horizontalDragService.js");
var moveColumnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/moveColumnController.js");
var renderedHeaderCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/renderedHeaderCell.js");
var renderedHeaderGroupCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/renderedHeaderGroupCell.js");
var standardMenu_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/standardMenu.js");
var borderLayout_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/layout/borderLayout.js");
var tabbedLayout_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/layout/tabbedLayout.js");
var verticalStack_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/layout/verticalStack.js");
var autoWidthCalculator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/autoWidthCalculator.js");
var renderedRow_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/renderedRow.js");
var rowRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/rowRenderer.js");
var filterStage_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/filterStage.js");
var flattenStage_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/flattenStage.js");
var sortStage_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/sortStage.js");
var floatingRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/floatingRowModel.js");
var paginationController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/paginationController.js");
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var cellNavigationService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/cellNavigationService.js");
var columnChangeEvent_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnChangeEvent.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var csvCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/csvCreator.js");
var downloader_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/downloader.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var expressionService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/expressionService.js");
var gridCore_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridCore.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var masterSlaveService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/masterSlaveService.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var sortController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/sortController.js");
var svgFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/svgFactory.js");
var templateService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/templateService.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var valueService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/valueService.js");
var popupService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/popupService.js");
var gridRow_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridRow.js");
var inMemoryRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/inMemoryRowModel.js");
var virtualPageRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/virtualPagination/virtualPageRowModel.js");
var animateSlideCellRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRenderers/animateSlideCellRenderer.js");
var cellEditorFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditorFactory.js");
var popupEditorWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/popupEditorWrapper.js");
var popupSelectCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/popupSelectCellEditor.js");
var popupTextCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/popupTextCellEditor.js");
var selectCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/selectCellEditor.js");
var textCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/textCellEditor.js");
var largeTextCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/largeTextCellEditor.js");
var cellRendererFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererFactory.js");
var groupCellRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRenderers/groupCellRenderer.js");
var cellRendererService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererService.js");
var valueFormatterService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/valueFormatterService.js");
var checkboxSelectionComponent_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/checkboxSelectionComponent.js");
var componentAnnotations_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/componentAnnotations.js");
var agCheckbox_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/agCheckbox.js");
var bodyDropPivotTarget_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/bodyDropPivotTarget.js");
var bodyDropTarget_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/bodyDropTarget.js");
var focusService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/misc/focusService.js");
var setLeftFeature_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/features/setLeftFeature.js");
var renderedCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/renderedCell.js");
var headerRowComp_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerRowComp.js");
var animateShowChangeCellRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRenderers/animateShowChangeCellRenderer.js");
var inMemoryNodeManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/inMemoryNodeManager.js");
var virtualPageCache_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/virtualPagination/virtualPageCache.js");
var virtualPage_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/virtualPagination/virtualPage.js");
var baseFrameworkFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/baseFrameworkFactory.js");
var methodNotImplementedException_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/misc/methodNotImplementedException.js");
var touchListener_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/touchListener.js");
var scrollVisibleService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/scrollVisibleService.js");
var xmlFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/xmlFactory.js");
var beanStub_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/beanStub.js");
var gridSerializer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridSerializer.js");
var stylingService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/styling/stylingService.js");
function populateClientExports(exports) {
    // columnController
    exports.BalancedColumnTreeBuilder = balancedColumnTreeBuilder_1.BalancedColumnTreeBuilder;
    exports.ColumnController = columnController_1.ColumnController;
    exports.ColumnKeyCreator = columnKeyCreator_1.ColumnKeyCreator;
    exports.ColumnUtils = columnUtils_1.ColumnUtils;
    exports.DisplayedGroupCreator = displayedGroupCreator_1.DisplayedGroupCreator;
    exports.GroupInstanceIdCreator = groupInstanceIdCreator_1.GroupInstanceIdCreator;
    // components
    exports.ComponentUtil = componentUtil_1.ComponentUtil;
    exports.initialiseAgGridWithAngular1 = agGridNg1_1.initialiseAgGridWithAngular1;
    exports.initialiseAgGridWithWebComponents = agGridWebComponent_1.initialiseAgGridWithWebComponents;
    // context
    exports.BeanStub = beanStub_1.BeanStub;
    exports.Context = context_1.Context;
    exports.Autowired = context_1.Autowired;
    exports.PostConstruct = context_1.PostConstruct;
    exports.PreDestroy = context_1.PreDestroy;
    exports.Optional = context_1.Optional;
    exports.Bean = context_1.Bean;
    exports.Qualifier = context_1.Qualifier;
    exports.Listener = componentAnnotations_1.Listener;
    exports.QuerySelector = componentAnnotations_1.QuerySelector;
    // dragAndDrop
    exports.HDirection = dragAndDropService_1.HDirection;
    exports.VDirection = dragAndDropService_1.VDirection;
    exports.DragAndDropService = dragAndDropService_1.DragAndDropService;
    exports.DragService = dragService_1.DragService;
    exports.DragSourceType = dragAndDropService_1.DragSourceType;
    // entities
    exports.Column = column_1.Column;
    exports.ColumnGroup = columnGroup_1.ColumnGroup;
    exports.GridCell = gridCell_1.GridCell;
    exports.GridRow = gridRow_1.GridRow;
    exports.OriginalColumnGroup = originalColumnGroup_1.OriginalColumnGroup;
    exports.RowNode = rowNode_1.RowNode;
    // filter
    exports.FilterManager = filterManager_1.FilterManager;
    exports.NumberFilter = numberFilter_1.NumberFilter;
    exports.TextFilter = textFilter_1.TextFilter;
    // gridPanel
    exports.GridPanel = gridPanel_1.GridPanel;
    exports.ScrollVisibleService = scrollVisibleService_1.ScrollVisibleService;
    exports.MouseEventService = mouseEventService_1.MouseEventService;
    // headerRendering
    exports.BodyDropPivotTarget = bodyDropPivotTarget_1.BodyDropPivotTarget;
    exports.BodyDropTarget = bodyDropTarget_1.BodyDropTarget;
    exports.CssClassApplier = cssClassApplier_1.CssClassApplier;
    exports.HeaderContainer = headerContainer_1.HeaderContainer;
    exports.HeaderRenderer = headerRenderer_1.HeaderRenderer;
    exports.HeaderRowComp = headerRowComp_1.HeaderRowComp;
    exports.HeaderTemplateLoader = headerTemplateLoader_1.HeaderTemplateLoader;
    exports.HorizontalDragService = horizontalDragService_1.HorizontalDragService;
    exports.MoveColumnController = moveColumnController_1.MoveColumnController;
    exports.RenderedHeaderCell = renderedHeaderCell_1.RenderedHeaderCell;
    exports.RenderedHeaderGroupCell = renderedHeaderGroupCell_1.RenderedHeaderGroupCell;
    exports.StandardMenuFactory = standardMenu_1.StandardMenuFactory;
    // layout
    exports.BorderLayout = borderLayout_1.BorderLayout;
    exports.TabbedLayout = tabbedLayout_1.TabbedLayout;
    exports.VerticalStack = verticalStack_1.VerticalStack;
    // misc
    exports.FocusService = focusService_1.FocusService;
    exports.MethodNotImplementedException = methodNotImplementedException_1.MethodNotImplementedException;
    // rendering / cellEditors
    exports.LargeTextCellEditor = largeTextCellEditor_1.LargeTextCellEditor;
    exports.PopupEditorWrapper = popupEditorWrapper_1.PopupEditorWrapper;
    exports.PopupSelectCellEditor = popupSelectCellEditor_1.PopupSelectCellEditor;
    exports.PopupTextCellEditor = popupTextCellEditor_1.PopupTextCellEditor;
    exports.SelectCellEditor = selectCellEditor_1.SelectCellEditor;
    exports.TextCellEditor = textCellEditor_1.TextCellEditor;
    // rendering / cellRenderers
    exports.AnimateShowChangeCellRenderer = animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer;
    exports.AnimateSlideCellRenderer = animateSlideCellRenderer_1.AnimateSlideCellRenderer;
    exports.GroupCellRenderer = groupCellRenderer_1.GroupCellRenderer;
    // features
    exports.SetLeftFeature = setLeftFeature_1.SetLeftFeature;
    // rendering
    exports.AutoWidthCalculator = autoWidthCalculator_1.AutoWidthCalculator;
    exports.CellEditorFactory = cellEditorFactory_1.CellEditorFactory;
    exports.RenderedHeaderCell = renderedHeaderCell_1.RenderedHeaderCell;
    exports.CellRendererFactory = cellRendererFactory_1.CellRendererFactory;
    exports.CellRendererService = cellRendererService_1.CellRendererService;
    exports.CheckboxSelectionComponent = checkboxSelectionComponent_1.CheckboxSelectionComponent;
    exports.RenderedCell = renderedCell_1.RenderedCell;
    exports.RenderedRow = renderedRow_1.RenderedRow;
    exports.RowRenderer = rowRenderer_1.RowRenderer;
    exports.ValueFormatterService = valueFormatterService_1.ValueFormatterService;
    // rowControllers/inMemory
    exports.FilterStage = filterStage_1.FilterStage;
    exports.FlattenStage = flattenStage_1.FlattenStage;
    exports.InMemoryRowModel = inMemoryRowModel_1.InMemoryRowModel;
    exports.SortStage = sortStage_1.SortStage;
    exports.InMemoryNodeManager = inMemoryNodeManager_1.InMemoryNodeManager;
    // rowControllers
    exports.FloatingRowModel = floatingRowModel_1.FloatingRowModel;
    exports.PaginationController = paginationController_1.PaginationController;
    exports.VirtualPageRowModel = virtualPageRowModel_1.VirtualPageRowModel;
    exports.VirtualPageCache = virtualPageCache_1.VirtualPageCache;
    exports.VirtualPage = virtualPage_1.VirtualPage;
    //styling
    exports.StylingService = stylingService_1.StylingService;
    // widgets
    exports.AgCheckbox = agCheckbox_1.AgCheckbox;
    exports.Component = component_1.Component;
    exports.PopupService = popupService_1.PopupService;
    exports.Listener = componentAnnotations_1.Listener;
    exports.QuerySelector = componentAnnotations_1.QuerySelector;
    exports.TouchListener = touchListener_1.TouchListener;
    // root
    exports.BaseFrameworkFactory = baseFrameworkFactory_1.BaseFrameworkFactory;
    exports.CellNavigationService = cellNavigationService_1.CellNavigationService;
    exports.ColumnChangeEvent = columnChangeEvent_1.ColumnChangeEvent;
    exports.Constants = constants_1.Constants;
    exports.CsvCreator = csvCreator_1.CsvCreator;
    exports.Downloader = downloader_1.Downloader;
    exports.Events = events_1.Events;
    exports.EventService = eventService_1.EventService;
    exports.ExpressionService = expressionService_1.ExpressionService;
    exports.FocusedCellController = focusedCellController_1.FocusedCellController;
    exports.defaultGroupComparator = functions_1.defaultGroupComparator;
    exports.Grid = grid_1.Grid;
    exports.GridApi = gridApi_1.GridApi;
    exports.GridCore = gridCore_1.GridCore;
    exports.GridOptionsWrapper = gridOptionsWrapper_1.GridOptionsWrapper;
    exports.Logger = logger_1.Logger;
    exports.MasterSlaveService = masterSlaveService_1.MasterSlaveService;
    exports.SelectionController = selectionController_1.SelectionController;
    exports.CheckboxSelectionComponent = checkboxSelectionComponent_1.CheckboxSelectionComponent;
    exports.SortController = sortController_1.SortController;
    exports.SvgFactory = svgFactory_1.SvgFactory;
    exports.TemplateService = templateService_1.TemplateService;
    exports.Utils = utils_1.Utils;
    exports.NumberSequence = utils_1.NumberSequence;
    exports.ValueService = valueService_1.ValueService;
    exports.XmlFactory = xmlFactory_1.XmlFactory;
    exports.GridSerializer = gridSerializer_1.GridSerializer;
    exports.BaseGridSerializingSession = gridSerializer_1.BaseGridSerializingSession;
    exports.RowType = gridSerializer_1.RowType;
}
exports.populateClientExports = populateClientExports;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/columnChangeEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var ColumnChangeEvent = (function () {
    function ColumnChangeEvent(type) {
        this.type = type;
    }
    ColumnChangeEvent.prototype.toString = function () {
        var result = 'ColumnChangeEvent {type: ' + this.type;
        if (this.column) {
            result += ', column: ' + this.column.getColId();
        }
        if (this.columnGroup) {
            result +=  true ? this.columnGroup.getColGroupDef().headerName : '(not defined]';
        }
        if (this.toIndex) {
            result += ', toIndex: ' + this.toIndex;
        }
        if (this.visible) {
            result += ', visible: ' + this.visible;
        }
        if (this.pinned) {
            result += ', pinned: ' + this.pinned;
        }
        if (typeof this.finished == 'boolean') {
            result += ', finished: ' + this.finished;
        }
        result += '}';
        return result;
    };
    ColumnChangeEvent.prototype.withPinned = function (pinned) {
        this.pinned = pinned;
        return this;
    };
    ColumnChangeEvent.prototype.withVisible = function (visible) {
        this.visible = visible;
        return this;
    };
    ColumnChangeEvent.prototype.isVisible = function () {
        return this.visible;
    };
    ColumnChangeEvent.prototype.getPinned = function () {
        return this.pinned;
    };
    ColumnChangeEvent.prototype.withColumn = function (column) {
        this.column = column;
        return this;
    };
    ColumnChangeEvent.prototype.withColumns = function (columns) {
        this.columns = columns;
        return this;
    };
    ColumnChangeEvent.prototype.withFinished = function (finished) {
        this.finished = finished;
        return this;
    };
    ColumnChangeEvent.prototype.withColumnGroup = function (columnGroup) {
        this.columnGroup = columnGroup;
        return this;
    };
    ColumnChangeEvent.prototype.withToIndex = function (toIndex) {
        this.toIndex = toIndex;
        return this;
    };
    ColumnChangeEvent.prototype.getToIndex = function () {
        return this.toIndex;
    };
    ColumnChangeEvent.prototype.getType = function () {
        return this.type;
    };
    ColumnChangeEvent.prototype.getColumn = function () {
        return this.column;
    };
    ColumnChangeEvent.prototype.getColumns = function () {
        return this.columns;
    };
    ColumnChangeEvent.prototype.getColumnGroup = function () {
        return this.columnGroup;
    };
    ColumnChangeEvent.prototype.isFinished = function () {
        return this.finished;
    };
    return ColumnChangeEvent;
}());
exports.ColumnChangeEvent = ColumnChangeEvent;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/columnController/balancedColumnTreeBuilder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var columnUtils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnUtils.js");
var columnKeyCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnKeyCreator.js");
var originalColumnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/originalColumnGroup.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_3 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_4 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
// takes in a list of columns, as specified by the column definitions, and returns column groups
var BalancedColumnTreeBuilder = (function () {
    function BalancedColumnTreeBuilder() {
    }
    BalancedColumnTreeBuilder.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('BalancedColumnTreeBuilder');
    };
    BalancedColumnTreeBuilder.prototype.createBalancedColumnGroups = function (abstractColDefs, primaryColumns) {
        // column key creator dishes out unique column id's in a deterministic way,
        // so if we have two grids (that cold be master/slave) with same column definitions,
        // then this ensures the two grids use identical id's.
        var columnKeyCreator = new columnKeyCreator_1.ColumnKeyCreator();
        // create am unbalanced tree that maps the provided definitions
        var unbalancedTree = this.recursivelyCreateColumns(abstractColDefs, 0, columnKeyCreator, primaryColumns);
        var treeDept = this.findMaxDept(unbalancedTree, 0);
        this.logger.log('Number of levels for grouped columns is ' + treeDept);
        var balancedTree = this.balanceColumnTree(unbalancedTree, 0, treeDept, columnKeyCreator);
        this.columnUtils.depthFirstOriginalTreeSearch(balancedTree, function (child) {
            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
                child.calculateExpandable();
            }
        });
        return {
            balancedTree: balancedTree,
            treeDept: treeDept
        };
    };
    BalancedColumnTreeBuilder.prototype.balanceColumnTree = function (unbalancedTree, currentDept, columnDept, columnKeyCreator) {
        var _this = this;
        var result = [];
        // go through each child, for groups, recurse a level deeper,
        // for columns we need to pad
        unbalancedTree.forEach(function (child) {
            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
                var originalGroup = child;
                var newChildren = _this.balanceColumnTree(originalGroup.getChildren(), currentDept + 1, columnDept, columnKeyCreator);
                originalGroup.setChildren(newChildren);
                result.push(originalGroup);
            }
            else {
                var newChild = child;
                for (var i = columnDept - 1; i >= currentDept; i--) {
                    var newColId = columnKeyCreator.getUniqueKey(null, null);
                    var colGroupDefMerged = _this.createMergedColGroupDef(null);
                    var paddedGroup = new originalColumnGroup_1.OriginalColumnGroup(colGroupDefMerged, newColId, true);
                    paddedGroup.setChildren([newChild]);
                    newChild = paddedGroup;
                }
                result.push(newChild);
            }
        });
        return result;
    };
    BalancedColumnTreeBuilder.prototype.findMaxDept = function (treeChildren, dept) {
        var maxDeptThisLevel = dept;
        for (var i = 0; i < treeChildren.length; i++) {
            var abstractColumn = treeChildren[i];
            if (abstractColumn instanceof originalColumnGroup_1.OriginalColumnGroup) {
                var originalGroup = abstractColumn;
                var newDept = this.findMaxDept(originalGroup.getChildren(), dept + 1);
                if (maxDeptThisLevel < newDept) {
                    maxDeptThisLevel = newDept;
                }
            }
        }
        return maxDeptThisLevel;
    };
    BalancedColumnTreeBuilder.prototype.recursivelyCreateColumns = function (abstractColDefs, level, columnKeyCreator, primaryColumns) {
        var _this = this;
        var result = [];
        if (!abstractColDefs) {
            return result;
        }
        abstractColDefs.forEach(function (abstractColDef) {
            var newGroupOrColumn;
            if (_this.isColumnGroup(abstractColDef)) {
                newGroupOrColumn = _this.createColumnGroup(columnKeyCreator, primaryColumns, abstractColDef, level);
            }
            else {
                newGroupOrColumn = _this.createColumn(columnKeyCreator, primaryColumns, abstractColDef);
            }
            result.push(newGroupOrColumn);
        });
        return result;
    };
    BalancedColumnTreeBuilder.prototype.createColumnGroup = function (columnKeyCreator, primaryColumns, colGroupDef, level) {
        var colGroupDefMerged = this.createMergedColGroupDef(colGroupDef);
        var groupId = columnKeyCreator.getUniqueKey(colGroupDefMerged.groupId, null);
        var originalGroup = new originalColumnGroup_1.OriginalColumnGroup(colGroupDefMerged, groupId, false);
        var children = this.recursivelyCreateColumns(colGroupDefMerged.children, level + 1, columnKeyCreator, primaryColumns);
        originalGroup.setChildren(children);
        return originalGroup;
    };
    BalancedColumnTreeBuilder.prototype.createMergedColGroupDef = function (colGroupDef) {
        var colGroupDefMerged = {};
        utils_1.Utils.assign(colGroupDefMerged, this.gridOptionsWrapper.getDefaultColGroupDef());
        utils_1.Utils.assign(colGroupDefMerged, colGroupDef);
        this.checkForDeprecatedItems(colGroupDefMerged);
        return colGroupDefMerged;
    };
    BalancedColumnTreeBuilder.prototype.createColumn = function (columnKeyCreator, primaryColumns, colDef3) {
        var colDefMerged = {};
        utils_1.Utils.assign(colDefMerged, this.gridOptionsWrapper.getDefaultColDef());
        utils_1.Utils.assign(colDefMerged, colDef3);
        this.checkForDeprecatedItems(colDefMerged);
        var colId = columnKeyCreator.getUniqueKey(colDefMerged.colId, colDefMerged.field);
        var column = new column_1.Column(colDefMerged, colId, primaryColumns);
        this.context.wireBean(column);
        return column;
    };
    BalancedColumnTreeBuilder.prototype.checkForDeprecatedItems = function (colDef) {
        if (colDef) {
            var colDefNoType = colDef; // take out the type, so we can access attributes not defined in the type
            if (colDefNoType.group !== undefined) {
                console.warn('ag-grid: colDef.group is invalid, please check documentation on how to do grouping as it changed in version 3');
            }
            if (colDefNoType.headerGroup !== undefined) {
                console.warn('ag-grid: colDef.headerGroup is invalid, please check documentation on how to do grouping as it changed in version 3');
            }
            if (colDefNoType.headerGroupShow !== undefined) {
                console.warn('ag-grid: colDef.headerGroupShow is invalid, should be columnGroupShow, please check documentation on how to do grouping as it changed in version 3');
            }
            if (colDefNoType.suppressRowGroup !== undefined) {
                console.warn('ag-grid: colDef.suppressRowGroup is deprecated, please use colDef.type instead');
            }
            if (colDefNoType.suppressAggregation !== undefined) {
                console.warn('ag-grid: colDef.suppressAggregation is deprecated, please use colDef.type instead');
            }
            if (colDefNoType.suppressRowGroup || colDefNoType.suppressAggregation) {
                console.warn('ag-grid: colDef.suppressAggregation and colDef.suppressRowGroup are deprecated, use allowRowGroup, allowPivot and allowValue instead');
            }
            if (colDefNoType.displayName) {
                console.warn("ag-grid: Found displayName " + colDefNoType.displayName + ", please use headerName instead, displayName is deprecated.");
                colDefNoType.headerName = colDefNoType.displayName;
            }
        }
    };
    // if object has children, we assume it's a group
    BalancedColumnTreeBuilder.prototype.isColumnGroup = function (abstractColDef) {
        return abstractColDef.children !== undefined;
    };
    __decorate([
        context_3.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], BalancedColumnTreeBuilder.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_3.Autowired('columnUtils'), 
        __metadata('design:type', columnUtils_1.ColumnUtils)
    ], BalancedColumnTreeBuilder.prototype, "columnUtils", void 0);
    __decorate([
        context_3.Autowired('context'), 
        __metadata('design:type', context_4.Context)
    ], BalancedColumnTreeBuilder.prototype, "context", void 0);
    __decorate([
        __param(0, context_2.Qualifier('loggerFactory')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory]), 
        __metadata('design:returntype', void 0)
    ], BalancedColumnTreeBuilder.prototype, "setBeans", null);
    BalancedColumnTreeBuilder = __decorate([
        context_1.Bean('balancedColumnTreeBuilder'), 
        __metadata('design:paramtypes', [])
    ], BalancedColumnTreeBuilder);
    return BalancedColumnTreeBuilder;
}());
exports.BalancedColumnTreeBuilder = BalancedColumnTreeBuilder;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/columnController/columnController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var columnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/columnGroup.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var expressionService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/expressionService.js");
var balancedColumnTreeBuilder_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/balancedColumnTreeBuilder.js");
var displayedGroupCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/displayedGroupCreator.js");
var autoWidthCalculator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/autoWidthCalculator.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var columnUtils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnUtils.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var columnChangeEvent_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnChangeEvent.js");
var originalColumnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/originalColumnGroup.js");
var groupInstanceIdCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/groupInstanceIdCreator.js");
var functions_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/functions.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var ColumnApi = (function () {
    function ColumnApi() {
    }
    ColumnApi.prototype.sizeColumnsToFit = function (gridWidth) { this._columnController.sizeColumnsToFit(gridWidth); };
    ColumnApi.prototype.setColumnGroupOpened = function (group, newValue, instanceId) { this._columnController.setColumnGroupOpened(group, newValue, instanceId); };
    ColumnApi.prototype.getColumnGroup = function (name, instanceId) { return this._columnController.getColumnGroup(name, instanceId); };
    ColumnApi.prototype.getDisplayNameForColumn = function (column, location) { return this._columnController.getDisplayNameForColumn(column, location); };
    ColumnApi.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) { return this._columnController.getDisplayNameForColumnGroup(columnGroup, location); };
    ColumnApi.prototype.getColumn = function (key) { return this._columnController.getPrimaryColumn(key); };
    ColumnApi.prototype.setColumnState = function (columnState) { return this._columnController.setColumnState(columnState); };
    ColumnApi.prototype.getColumnState = function () { return this._columnController.getColumnState(); };
    ColumnApi.prototype.resetColumnState = function () { this._columnController.resetColumnState(); };
    ColumnApi.prototype.isPinning = function () { return this._columnController.isPinningLeft() || this._columnController.isPinningRight(); };
    ColumnApi.prototype.isPinningLeft = function () { return this._columnController.isPinningLeft(); };
    ColumnApi.prototype.isPinningRight = function () { return this._columnController.isPinningRight(); };
    ColumnApi.prototype.getDisplayedColAfter = function (col) { return this._columnController.getDisplayedColAfter(col); };
    ColumnApi.prototype.getDisplayedColBefore = function (col) { return this._columnController.getDisplayedColBefore(col); };
    ColumnApi.prototype.setColumnVisible = function (key, visible) { this._columnController.setColumnVisible(key, visible); };
    ColumnApi.prototype.setColumnsVisible = function (keys, visible) { this._columnController.setColumnsVisible(keys, visible); };
    ColumnApi.prototype.setColumnPinned = function (key, pinned) { this._columnController.setColumnPinned(key, pinned); };
    ColumnApi.prototype.setColumnsPinned = function (keys, pinned) { this._columnController.setColumnsPinned(keys, pinned); };
    ColumnApi.prototype.getAllColumns = function () { return this._columnController.getAllPrimaryColumns(); };
    ColumnApi.prototype.getAllGridColumns = function () { return this._columnController.getAllGridColumns(); };
    ColumnApi.prototype.getDisplayedLeftColumns = function () { return this._columnController.getDisplayedLeftColumns(); };
    ColumnApi.prototype.getDisplayedCenterColumns = function () { return this._columnController.getDisplayedCenterColumns(); };
    ColumnApi.prototype.getDisplayedRightColumns = function () { return this._columnController.getDisplayedRightColumns(); };
    ColumnApi.prototype.getAllDisplayedColumns = function () { return this._columnController.getAllDisplayedColumns(); };
    ColumnApi.prototype.getAllDisplayedVirtualColumns = function () { return this._columnController.getAllDisplayedVirtualColumns(); };
    ColumnApi.prototype.moveColumn = function (key, toIndex) {
        if (typeof key === 'number') {
            // moveColumn used to take indexes, so this is advising user who hasn't moved to new method name
            console.log('ag-Grid: you are using moveColumn(fromIndex, toIndex) - moveColumn takes a column key and a destination index, not two indexes, to move with indexes use moveColumnByIndex(from,to) instead');
            this._columnController.moveColumnByIndex(key, toIndex);
        }
        else {
            this._columnController.moveColumn(key, toIndex);
        }
    };
    ColumnApi.prototype.moveColumnByIndex = function (fromIndex, toIndex) { this._columnController.moveColumnByIndex(fromIndex, toIndex); };
    ColumnApi.prototype.moveColumns = function (columnsToMoveKeys, toIndex) { this._columnController.moveColumns(columnsToMoveKeys, toIndex); };
    ColumnApi.prototype.moveRowGroupColumn = function (fromIndex, toIndex) { this._columnController.moveRowGroupColumn(fromIndex, toIndex); };
    ColumnApi.prototype.setColumnAggFunc = function (column, aggFunc) { this._columnController.setColumnAggFunc(column, aggFunc); };
    ColumnApi.prototype.setColumnWidth = function (key, newWidth, finished) {
        if (finished === void 0) { finished = true; }
        this._columnController.setColumnWidth(key, newWidth, finished);
    };
    ColumnApi.prototype.setPivotMode = function (pivotMode) { this._columnController.setPivotMode(pivotMode); };
    ColumnApi.prototype.isPivotMode = function () { return this._columnController.isPivotMode(); };
    ColumnApi.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) { return this._columnController.getSecondaryPivotColumn(pivotKeys, valueColKey); };
    ColumnApi.prototype.setValueColumns = function (colKeys) { this._columnController.setValueColumns(colKeys); };
    ColumnApi.prototype.getValueColumns = function () { return this._columnController.getValueColumns(); };
    ColumnApi.prototype.removeValueColumn = function (colKey) { this._columnController.removeValueColumn(colKey); };
    ColumnApi.prototype.removeValueColumns = function (colKeys) { this._columnController.removeValueColumns(colKeys); };
    ColumnApi.prototype.addValueColumn = function (colKey) { this._columnController.addValueColumn(colKey); };
    ColumnApi.prototype.addValueColumns = function (colKeys) { this._columnController.addValueColumns(colKeys); };
    ColumnApi.prototype.setRowGroupColumns = function (colKeys) { this._columnController.setRowGroupColumns(colKeys); };
    ColumnApi.prototype.removeRowGroupColumn = function (colKey) { this._columnController.removeRowGroupColumn(colKey); };
    ColumnApi.prototype.removeRowGroupColumns = function (colKeys) { this._columnController.removeRowGroupColumns(colKeys); };
    ColumnApi.prototype.addRowGroupColumn = function (colKey) { this._columnController.addRowGroupColumn(colKey); };
    ColumnApi.prototype.addRowGroupColumns = function (colKeys) { this._columnController.addRowGroupColumns(colKeys); };
    ColumnApi.prototype.getRowGroupColumns = function () { return this._columnController.getRowGroupColumns(); };
    ColumnApi.prototype.setPivotColumns = function (colKeys) { this._columnController.setPivotColumns(colKeys); };
    ColumnApi.prototype.removePivotColumn = function (colKey) { this._columnController.removePivotColumn(colKey); };
    ColumnApi.prototype.removePivotColumns = function (colKeys) { this._columnController.removePivotColumns(colKeys); };
    ColumnApi.prototype.addPivotColumn = function (colKey) { this._columnController.addPivotColumn(colKey); };
    ColumnApi.prototype.addPivotColumns = function (colKeys) { this._columnController.addPivotColumns(colKeys); };
    ColumnApi.prototype.getPivotColumns = function () { return this._columnController.getPivotColumns(); };
    ColumnApi.prototype.getLeftDisplayedColumnGroups = function () { return this._columnController.getLeftDisplayedColumnGroups(); };
    ColumnApi.prototype.getCenterDisplayedColumnGroups = function () { return this._columnController.getCenterDisplayedColumnGroups(); };
    ColumnApi.prototype.getRightDisplayedColumnGroups = function () { return this._columnController.getRightDisplayedColumnGroups(); };
    ColumnApi.prototype.getAllDisplayedColumnGroups = function () { return this._columnController.getAllDisplayedColumnGroups(); };
    ColumnApi.prototype.autoSizeColumn = function (key) { return this._columnController.autoSizeColumn(key); };
    ColumnApi.prototype.autoSizeColumns = function (keys) { return this._columnController.autoSizeColumns(keys); };
    ColumnApi.prototype.autoSizeAllColumns = function () { this._columnController.autoSizeAllColumns(); };
    ColumnApi.prototype.setSecondaryColumns = function (colDefs) { this._columnController.setSecondaryColumns(colDefs); };
    // below goes through deprecated items, prints message to user, then calls the new version of the same method
    ColumnApi.prototype.columnGroupOpened = function (group, newValue) {
        console.error('ag-Grid: columnGroupOpened no longer exists, use setColumnGroupOpened');
        this.setColumnGroupOpened(group, newValue);
    };
    ColumnApi.prototype.hideColumns = function (colIds, hide) {
        console.error('ag-Grid: hideColumns is deprecated, use setColumnsVisible');
        this._columnController.setColumnsVisible(colIds, !hide);
    };
    ColumnApi.prototype.hideColumn = function (colId, hide) {
        console.error('ag-Grid: hideColumn is deprecated, use setColumnVisible');
        this._columnController.setColumnVisible(colId, !hide);
    };
    ColumnApi.prototype.setState = function (columnState) {
        console.error('ag-Grid: setState is deprecated, use setColumnState');
        return this.setColumnState(columnState);
    };
    ColumnApi.prototype.getState = function () {
        console.error('ag-Grid: getState is deprecated, use getColumnState');
        return this.getColumnState();
    };
    ColumnApi.prototype.resetState = function () {
        console.error('ag-Grid: resetState is deprecated, use resetColumnState');
        this.resetColumnState();
    };
    ColumnApi.prototype.getAggregationColumns = function () {
        console.error('ag-Grid: getAggregationColumns is deprecated, use getValueColumns');
        return this._columnController.getValueColumns();
    };
    ColumnApi.prototype.removeAggregationColumn = function (colKey) {
        console.error('ag-Grid: removeAggregationColumn is deprecated, use removeValueColumn');
        this._columnController.removeValueColumn(colKey);
    };
    ColumnApi.prototype.removeAggregationColumns = function (colKeys) {
        console.error('ag-Grid: removeAggregationColumns is deprecated, use removeValueColumns');
        this._columnController.removeValueColumns(colKeys);
    };
    ColumnApi.prototype.addAggregationColumn = function (colKey) {
        console.error('ag-Grid: addAggregationColumn is deprecated, use addValueColumn');
        this._columnController.addValueColumn(colKey);
    };
    ColumnApi.prototype.addAggregationColumns = function (colKeys) {
        console.error('ag-Grid: addAggregationColumns is deprecated, use addValueColumns');
        this._columnController.addValueColumns(colKeys);
    };
    ColumnApi.prototype.setColumnAggFunction = function (column, aggFunc) {
        console.error('ag-Grid: setColumnAggFunction is deprecated, use setColumnAggFunc');
        this._columnController.setColumnAggFunc(column, aggFunc);
    };
    ColumnApi.prototype.getDisplayNameForCol = function (column) {
        console.error('ag-Grid: getDisplayNameForCol is deprecated, use getDisplayNameForColumn');
        return this.getDisplayNameForColumn(column, null);
    };
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', ColumnController)
    ], ColumnApi.prototype, "_columnController", void 0);
    ColumnApi = __decorate([
        context_1.Bean('columnApi'), 
        __metadata('design:paramtypes', [])
    ], ColumnApi);
    return ColumnApi;
}());
exports.ColumnApi = ColumnApi;
var ColumnController = (function () {
    function ColumnController() {
        // header row count, based on user provided columns
        this.primaryHeaderRowCount = 0;
        this.secondaryHeaderRowCount = 0;
        this.secondaryColumnsPresent = false;
        // header row count, either above, or based on pivoting if we are pivoting
        this.gridHeaderRowCount = 0;
        // these are the lists used by the rowRenderer to render nodes. almost the leaf nodes of the above
        // displayed trees, however it also takes into account if the groups are open or not.
        this.displayedLeftColumns = [];
        this.displayedRightColumns = [];
        this.displayedCenterColumns = [];
        // all three lists above combined
        this.allDisplayedColumns = [];
        // same as above, except trimmed down to only columns within the viewport
        this.allDisplayedVirtualColumns = [];
        this.rowGroupColumns = [];
        this.valueColumns = [];
        this.pivotColumns = [];
        this.ready = false;
        this.pivotMode = false;
        this.bodyWidth = 0;
        this.leftWidth = 0;
        this.rightWidth = 0;
        this.bodyWidthDirty = true;
    }
    ColumnController.prototype.init = function () {
        this.pivotMode = this.gridOptionsWrapper.isPivotMode();
        if (this.gridOptionsWrapper.getColumnDefs()) {
            this.setColumnDefs(this.gridOptionsWrapper.getColumnDefs());
        }
    };
    ColumnController.prototype.setVirtualViewportLeftAndRight = function () {
        if (this.gridOptionsWrapper.isEnableRtl()) {
            this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth;
            this.viewportRight = this.bodyWidth - this.scrollPosition;
        }
        else {
            this.viewportLeft = this.scrollPosition;
            this.viewportRight = this.scrollWidth + this.scrollPosition;
        }
    };
    // used by clipboard service, to know what columns to paste into
    ColumnController.prototype.getDisplayedColumnsStartingAt = function (column) {
        var currentColumn = column;
        var result = [];
        while (utils_1.Utils.exists(currentColumn)) {
            result.push(currentColumn);
            currentColumn = this.getDisplayedColAfter(currentColumn);
        }
        return result;
    };
    // checks what columns are currently displayed due to column virtualisation. fires an event
    // if the list of columns has changed.
    // + setColumnWidth(), setVirtualViewportPosition(), setColumnDefs(), sizeColumnsToFit()
    ColumnController.prototype.checkDisplayedVirtualColumns = function () {
        // check displayCenterColumnTree exists first, as it won't exist when grid is initialising
        if (utils_1.Utils.exists(this.displayedCenterColumns)) {
            var hashBefore = this.allDisplayedVirtualColumns.map(function (column) { return column.getId(); }).join('#');
            this.updateVirtualSets();
            var hashAfter = this.allDisplayedVirtualColumns.map(function (column) { return column.getId(); }).join('#');
            if (hashBefore !== hashAfter) {
                this.eventService.dispatchEvent(events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED);
            }
        }
    };
    ColumnController.prototype.setVirtualViewportPosition = function (scrollWidth, scrollPosition) {
        if (scrollWidth !== this.scrollWidth || scrollPosition !== this.scrollPosition || this.bodyWidthDirty) {
            this.scrollWidth = scrollWidth;
            this.scrollPosition = scrollPosition;
            // we need to call setVirtualViewportLeftAndRight() at least once after the body width changes,
            // as the viewport can stay the same, but in RTL, if body width changes, we need to work out the
            // virtual columns again
            this.bodyWidthDirty = true;
            this.setVirtualViewportLeftAndRight();
            if (this.ready) {
                this.checkDisplayedVirtualColumns();
            }
        }
    };
    ColumnController.prototype.isPivotMode = function () {
        return this.pivotMode;
    };
    ColumnController.prototype.setPivotMode = function (pivotMode) {
        if (pivotMode === this.pivotMode) {
            return;
        }
        this.pivotMode = pivotMode;
        this.updateDisplayedColumns();
        var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED);
        this.eventService.dispatchEvent(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, event);
    };
    ColumnController.prototype.getSecondaryPivotColumn = function (pivotKeys, valueColKey) {
        if (!this.secondaryColumnsPresent) {
            return null;
        }
        var valueColumnToFind = this.getPrimaryColumn(valueColKey);
        var foundColumn = null;
        this.secondaryColumns.forEach(function (column) {
            var thisPivotKeys = column.getColDef().pivotKeys;
            var pivotValueColumn = column.getColDef().pivotValueColumn;
            var pivotKeyMatches = utils_1.Utils.compareArrays(thisPivotKeys, pivotKeys);
            var pivotValueMatches = pivotValueColumn === valueColumnToFind;
            if (pivotKeyMatches && pivotValueMatches) {
                foundColumn = column;
            }
        });
        return foundColumn;
    };
    ColumnController.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('ColumnController');
    };
    ColumnController.prototype.setFirstRightAndLastLeftPinned = function () {
        var lastLeft;
        var firstRight;
        if (this.gridOptionsWrapper.isEnableRtl()) {
            lastLeft = this.displayedLeftColumns ? this.displayedLeftColumns[0] : null;
            firstRight = this.displayedRightColumns ? this.displayedRightColumns[this.displayedRightColumns.length - 1] : null;
        }
        else {
            lastLeft = this.displayedLeftColumns ? this.displayedLeftColumns[this.displayedLeftColumns.length - 1] : null;
            firstRight = this.displayedRightColumns ? this.displayedRightColumns[0] : null;
        }
        this.gridColumns.forEach(function (column) {
            column.setLastLeftPinned(column === lastLeft);
            column.setFirstRightPinned(column === firstRight);
        });
    };
    ColumnController.prototype.autoSizeColumns = function (keys) {
        // because of column virtualisation, we can only do this function on columns that are
        // actually rendered, as non-rendered columns (outside the viewport and not rendered
        // due to column virtualisation) are not present. this can result in all rendered columns
        // getting narrowed, which in turn introduces more rendered columns on the RHS which
        // did not get autosized in the original run, leaving the visible grid with columns on
        // the LHS sized, but RHS no. so we keep looping through teh visible columns until
        // no more cols are available (rendered) to be resized
        var _this = this;
        // keep track of which cols we have resized in here
        var columnsAutosized = [];
        // initialise with anything except 0 so that while loop executs at least once
        var changesThisTimeAround = -1;
        while (changesThisTimeAround !== 0) {
            changesThisTimeAround = 0;
            this.actionOnGridColumns(keys, function (column) {
                // if already autosized, skip it
                if (columnsAutosized.indexOf(column) >= 0) {
                    return;
                }
                // get how wide this col should be
                var preferredWidth = _this.autoWidthCalculator.getPreferredWidthForColumn(column);
                // preferredWidth = -1 if this col is not on the screen
                if (preferredWidth > 0) {
                    var newWidth = _this.normaliseColumnWidth(column, preferredWidth);
                    column.setActualWidth(newWidth);
                    columnsAutosized.push(column);
                    changesThisTimeAround++;
                }
                return true;
            }, function () {
                return new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_RESIZED).withFinished(true);
            });
        }
    };
    ColumnController.prototype.autoSizeColumn = function (key) {
        this.autoSizeColumns([key]);
    };
    ColumnController.prototype.autoSizeAllColumns = function () {
        var allDisplayedColumns = this.getAllDisplayedColumns();
        this.autoSizeColumns(allDisplayedColumns);
    };
    ColumnController.prototype.getColumnsFromTree = function (rootColumns) {
        var result = [];
        recursiveFindColumns(rootColumns);
        return result;
        function recursiveFindColumns(childColumns) {
            for (var i = 0; i < childColumns.length; i++) {
                var child = childColumns[i];
                if (child instanceof column_1.Column) {
                    result.push(child);
                }
                else if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
                    recursiveFindColumns(child.getChildren());
                }
            }
        }
    };
    ColumnController.prototype.getAllDisplayedColumnGroups = function () {
        if (this.displayedLeftColumnTree && this.displayedRightColumnTree && this.displayedCentreColumnTree) {
            return this.displayedLeftColumnTree
                .concat(this.displayedCentreColumnTree)
                .concat(this.displayedRightColumnTree);
        }
        else {
            return null;
        }
    };
    // + columnSelectPanel
    ColumnController.prototype.getPrimaryColumnTree = function () {
        return this.primaryBalancedTree;
    };
    // + gridPanel -> for resizing the body and setting top margin
    ColumnController.prototype.getHeaderRowCount = function () {
        return this.gridHeaderRowCount;
    };
    // + headerRenderer -> setting pinned body width
    ColumnController.prototype.getLeftDisplayedColumnGroups = function () {
        return this.displayedLeftColumnTree;
    };
    // + headerRenderer -> setting pinned body width
    ColumnController.prototype.getRightDisplayedColumnGroups = function () {
        return this.displayedRightColumnTree;
    };
    // + headerRenderer -> setting pinned body width
    ColumnController.prototype.getCenterDisplayedColumnGroups = function () {
        return this.displayedCentreColumnTree;
    };
    ColumnController.prototype.getDisplayedColumnGroups = function (type) {
        switch (type) {
            case column_1.Column.PINNED_LEFT: return this.getLeftDisplayedColumnGroups();
            case column_1.Column.PINNED_RIGHT: return this.getRightDisplayedColumnGroups();
            default: return this.getCenterDisplayedColumnGroups();
        }
    };
    // gridPanel -> ensureColumnVisible
    ColumnController.prototype.isColumnDisplayed = function (column) {
        return this.getAllDisplayedColumns().indexOf(column) >= 0;
    };
    // + csvCreator
    ColumnController.prototype.getAllDisplayedColumns = function () {
        return this.allDisplayedColumns;
    };
    // + rowRenderer
    ColumnController.prototype.getAllDisplayedVirtualColumns = function () {
        return this.allDisplayedVirtualColumns;
    };
    // used by:
    // + angularGrid -> setting pinned body width
    // todo: this needs to be cached
    ColumnController.prototype.getPinnedLeftContainerWidth = function () {
        return this.getWidthOfColsInList(this.displayedLeftColumns);
    };
    // todo: this needs to be cached
    ColumnController.prototype.getPinnedRightContainerWidth = function () {
        return this.getWidthOfColsInList(this.displayedRightColumns);
    };
    ColumnController.prototype.updatePrimaryColumnList = function (keys, masterList, actionIsAdd, columnCallback, eventType) {
        var _this = this;
        if (utils_1.Utils.missingOrEmpty(keys)) {
            return;
        }
        var atLeastOne = false;
        keys.forEach(function (key) {
            var columnToAdd = _this.getPrimaryColumn(key);
            if (!columnToAdd) {
                return;
            }
            if (actionIsAdd) {
                if (masterList.indexOf(columnToAdd) >= 0) {
                    return;
                }
                masterList.push(columnToAdd);
            }
            else {
                if (masterList.indexOf(columnToAdd) < 0) {
                    return;
                }
                utils_1.Utils.removeFromArray(masterList, columnToAdd);
            }
            columnCallback(columnToAdd);
            atLeastOne = true;
        });
        if (!atLeastOne) {
            return;
        }
        this.updateDisplayedColumns();
        var event = new columnChangeEvent_1.ColumnChangeEvent(eventType).withColumns(masterList);
        this.eventService.dispatchEvent(event.getType(), event);
    };
    ColumnController.prototype.setRowGroupColumns = function (colKeys) {
        this.setPrimaryColumnList(colKeys, this.rowGroupColumns, events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.setRowGroupActive.bind(this));
    };
    ColumnController.prototype.setRowGroupActive = function (active, column) {
        if (active === column.isRowGroupActive()) {
            return;
        }
        column.setRowGroupActive(active);
        if (!active) {
            column.setVisible(true);
        }
    };
    ColumnController.prototype.addRowGroupColumn = function (key) {
        this.addRowGroupColumns([key]);
    };
    ColumnController.prototype.addRowGroupColumns = function (keys) {
        this.updatePrimaryColumnList(keys, this.rowGroupColumns, true, this.setRowGroupActive.bind(this, true), events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED);
    };
    ColumnController.prototype.removeRowGroupColumns = function (keys) {
        this.updatePrimaryColumnList(keys, this.rowGroupColumns, false, this.setRowGroupActive.bind(this, false), events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED);
    };
    ColumnController.prototype.removeRowGroupColumn = function (key) {
        this.removeRowGroupColumns([key]);
    };
    ColumnController.prototype.addPivotColumns = function (keys) {
        this.updatePrimaryColumnList(keys, this.pivotColumns, true, function (column) { return column.setPivotActive(true); }, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED);
    };
    ColumnController.prototype.setPivotColumns = function (colKeys) {
        this.setPrimaryColumnList(colKeys, this.pivotColumns, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, function (added, column) {
            column.setPivotActive(added);
        });
    };
    ColumnController.prototype.addPivotColumn = function (key) {
        this.addPivotColumns([key]);
    };
    ColumnController.prototype.removePivotColumns = function (keys) {
        this.updatePrimaryColumnList(keys, this.pivotColumns, false, function (column) { return column.setPivotActive(false); }, events_1.Events.EVENT_COLUMN_PIVOT_CHANGED);
    };
    ColumnController.prototype.removePivotColumn = function (key) {
        this.removePivotColumns([key]);
    };
    ColumnController.prototype.setPrimaryColumnList = function (colKeys, masterList, eventName, columnCallback) {
        var _this = this;
        masterList.length = 0;
        if (utils_1.Utils.exists(colKeys)) {
            colKeys.forEach(function (key) {
                var column = _this.getPrimaryColumn(key);
                masterList.push(column);
            });
        }
        this.primaryColumns.forEach(function (column) {
            var added = masterList.indexOf(column) >= 0;
            columnCallback(added, column);
        });
        this.updateDisplayedColumns();
        var event = new columnChangeEvent_1.ColumnChangeEvent(eventName)
            .withColumns(masterList);
        this.eventService.dispatchEvent(event.getType(), event);
    };
    ColumnController.prototype.setValueColumns = function (colKeys) {
        this.setPrimaryColumnList(colKeys, this.valueColumns, events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.setValueActive.bind(this));
    };
    ColumnController.prototype.setValueActive = function (active, column) {
        if (active === column.isValueActive()) {
            return;
        }
        column.setValueActive(active);
        if (active && !column.getAggFunc()) {
            var defaultAggFunc = this.aggFuncService.getDefaultAggFunc();
            column.setAggFunc(defaultAggFunc);
        }
    };
    ColumnController.prototype.addValueColumns = function (keys) {
        this.updatePrimaryColumnList(keys, this.valueColumns, true, this.setValueActive.bind(this, true), events_1.Events.EVENT_COLUMN_VALUE_CHANGED);
    };
    ColumnController.prototype.addValueColumn = function (colKey) {
        this.addValueColumns([colKey]);
    };
    ColumnController.prototype.removeValueColumn = function (colKey) {
        this.removeValueColumns([colKey]);
    };
    ColumnController.prototype.removeValueColumns = function (keys) {
        this.updatePrimaryColumnList(keys, this.valueColumns, false, this.setValueActive.bind(this, false), events_1.Events.EVENT_COLUMN_VALUE_CHANGED);
    };
    // returns the width we can set to this col, taking into consideration min and max widths
    ColumnController.prototype.normaliseColumnWidth = function (column, newWidth) {
        if (newWidth < column.getMinWidth()) {
            newWidth = column.getMinWidth();
        }
        if (column.isGreaterThanMax(newWidth)) {
            newWidth = column.getMaxWidth();
        }
        return newWidth;
    };
    ColumnController.prototype.getPrimaryOrGridColumn = function (key) {
        var column = this.getPrimaryColumn(key);
        if (column) {
            return column;
        }
        else {
            return this.getGridColumn(key);
        }
    };
    ColumnController.prototype.setColumnWidth = function (key, newWidth, finished) {
        var column = this.getPrimaryOrGridColumn(key);
        if (!column) {
            return;
        }
        newWidth = this.normaliseColumnWidth(column, newWidth);
        var widthChanged = column.getActualWidth() !== newWidth;
        if (widthChanged) {
            column.setActualWidth(newWidth);
            this.setLeftValues();
        }
        this.updateBodyWidths();
        this.checkDisplayedVirtualColumns();
        // check for change first, to avoid unnecessary firing of events
        // however we always fire 'finished' events. this is important
        // when groups are resized, as if the group is changing slowly,
        // eg 1 pixel at a time, then each change will fire change events
        // in all the columns in the group, but only one with get the pixel.
        if (finished || widthChanged) {
            var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_RESIZED).withColumn(column).withFinished(finished);
            this.eventService.dispatchEvent(events_1.Events.EVENT_COLUMN_RESIZED, event);
        }
    };
    ColumnController.prototype.setColumnAggFunc = function (column, aggFunc) {
        column.setAggFunc(aggFunc);
        var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_VALUE_CHANGED).withColumn(column);
        this.eventService.dispatchEvent(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, event);
    };
    ColumnController.prototype.moveRowGroupColumn = function (fromIndex, toIndex) {
        var column = this.rowGroupColumns[fromIndex];
        this.rowGroupColumns.splice(fromIndex, 1);
        this.rowGroupColumns.splice(toIndex, 0, column);
        var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED);
        this.eventService.dispatchEvent(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, event);
    };
    ColumnController.prototype.moveColumns = function (columnsToMoveKeys, toIndex) {
        if (toIndex > this.gridColumns.length - columnsToMoveKeys.length) {
            console.warn('ag-Grid: tried to insert columns in invalid location, toIndex = ' + toIndex);
            console.warn('ag-Grid: remember that you should not count the moving columns when calculating the new index');
            return;
        }
        // we want to pull all the columns out first and put them into an ordered list
        var columnsToMove = this.getGridColumns(columnsToMoveKeys);
        var failedRules = !this.doesMovePassRules(columnsToMove, toIndex);
        if (failedRules) {
            return;
        }
        this.gridPanel.turnOnAnimationForABit();
        utils_1.Utils.moveInArray(this.gridColumns, columnsToMove, toIndex);
        this.updateDisplayedColumns();
        var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_MOVED)
            .withToIndex(toIndex)
            .withColumns(columnsToMove);
        if (columnsToMove.length === 1) {
            event.withColumn(columnsToMove[0]);
        }
        this.eventService.dispatchEvent(events_1.Events.EVENT_COLUMN_MOVED, event);
    };
    ColumnController.prototype.doesMovePassRules = function (columnsToMove, toIndex) {
        var allColumnsCopy = this.gridColumns.slice();
        utils_1.Utils.moveInArray(allColumnsCopy, columnsToMove, toIndex);
        // look for broken groups, ie stray columns from groups that should be married
        for (var index = 0; index < (allColumnsCopy.length - 1); index++) {
            var thisColumn = allColumnsCopy[index];
            var nextColumn = allColumnsCopy[index + 1];
            // skip hidden columns
            if (!nextColumn.isVisible()) {
                continue;
            }
            var thisPath = this.columnUtils.getOriginalPathForColumn(thisColumn, this.gridBalancedTree);
            var nextPath = this.columnUtils.getOriginalPathForColumn(nextColumn, this.gridBalancedTree);
            if (!nextPath || !thisPath) {
                console.log('next path is missing');
            }
            // start at the top of the path and work down
            for (var dept = 0; dept < thisPath.length; dept++) {
                var thisOriginalGroup = thisPath[dept];
                var nextOriginalGroup = nextPath[dept];
                var lastColInGroup = thisOriginalGroup !== nextOriginalGroup;
                // a runaway is a column from this group that left the group, and the group has it's children marked as married
                var colGroupDef = thisOriginalGroup.getColGroupDef();
                var marryChildren = colGroupDef && colGroupDef.marryChildren;
                var needToCheckForRunaways = lastColInGroup && marryChildren;
                if (needToCheckForRunaways) {
                    for (var tailIndex = index + 1; tailIndex < allColumnsCopy.length; tailIndex++) {
                        var tailColumn = allColumnsCopy[tailIndex];
                        var tailPath = this.columnUtils.getOriginalPathForColumn(tailColumn, this.gridBalancedTree);
                        var tailOriginalGroup = tailPath[dept];
                        if (tailOriginalGroup === thisOriginalGroup) {
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    };
    ColumnController.prototype.moveColumn = function (key, toIndex) {
        this.moveColumns([key], toIndex);
    };
    ColumnController.prototype.moveColumnByIndex = function (fromIndex, toIndex) {
        var column = this.gridColumns[fromIndex];
        this.moveColumn(column, toIndex);
    };
    // used by:
    // + angularGrid -> for setting body width
    // + rowController -> setting main row widths (when inserting and resizing)
    // need to cache this
    ColumnController.prototype.getBodyContainerWidth = function () {
        return this.bodyWidth;
    };
    ColumnController.prototype.getContainerWidth = function (pinned) {
        switch (pinned) {
            case column_1.Column.PINNED_LEFT: return this.leftWidth;
            case column_1.Column.PINNED_RIGHT: return this.rightWidth;
            default: return this.bodyWidth;
        }
    };
    // after setColumnWidth or updateGroupsAndDisplayedColumns
    ColumnController.prototype.updateBodyWidths = function () {
        var newBodyWidth = this.getWidthOfColsInList(this.displayedCenterColumns);
        var newLeftWidth = this.getWidthOfColsInList(this.displayedLeftColumns);
        var newRightWidth = this.getWidthOfColsInList(this.displayedRightColumns);
        // this is used by virtual col calculation, for RTL only, as a change to body width can impact displayed
        // columns, due to RTL inverting the y coordinates
        this.bodyWidthDirty = this.bodyWidth !== newBodyWidth;
        var atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
        if (atLeastOneChanged) {
            this.bodyWidth = newBodyWidth;
            this.leftWidth = newLeftWidth;
            this.rightWidth = newRightWidth;
            // when this fires, it is picked up by the gridPanel, which ends up in
            // gridPanel calling setWidthAndScrollPosition(), which in turn calls setVirtualViewportPosition()
            this.eventService.dispatchEvent(events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED);
        }
    };
    // + rowController
    ColumnController.prototype.getValueColumns = function () {
        return this.valueColumns ? this.valueColumns : [];
    };
    // + rowController
    ColumnController.prototype.getPivotColumns = function () {
        return this.pivotColumns ? this.pivotColumns : [];
    };
    // + inMemoryRowModel
    ColumnController.prototype.isPivotActive = function () {
        return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
    };
    // + toolPanel
    ColumnController.prototype.getRowGroupColumns = function () {
        return this.rowGroupColumns ? this.rowGroupColumns : [];
    };
    // + rowController -> while inserting rows
    ColumnController.prototype.getDisplayedCenterColumns = function () {
        return this.displayedCenterColumns.slice(0);
    };
    // + rowController -> while inserting rows
    ColumnController.prototype.getDisplayedLeftColumns = function () {
        return this.displayedLeftColumns.slice(0);
    };
    ColumnController.prototype.getDisplayedRightColumns = function () {
        return this.displayedRightColumns.slice(0);
    };
    ColumnController.prototype.getDisplayedColumns = function (type) {
        switch (type) {
            case column_1.Column.PINNED_LEFT: return this.getDisplayedLeftColumns();
            case column_1.Column.PINNED_RIGHT: return this.getDisplayedRightColumns();
            default: return this.getDisplayedCenterColumns();
        }
    };
    // used by:
    // + inMemoryRowController -> sorting, building quick filter text
    // + headerRenderer -> sorting (clearing icon)
    ColumnController.prototype.getAllPrimaryColumns = function () {
        return this.primaryColumns;
    };
    // + moveColumnController
    ColumnController.prototype.getAllGridColumns = function () {
        return this.gridColumns;
    };
    ColumnController.prototype.isEmpty = function () {
        return utils_1.Utils.missingOrEmpty(this.gridColumns);
    };
    ColumnController.prototype.isRowGroupEmpty = function () {
        return utils_1.Utils.missingOrEmpty(this.rowGroupColumns);
    };
    ColumnController.prototype.setColumnVisible = function (key, visible) {
        this.setColumnsVisible([key], visible);
    };
    ColumnController.prototype.setColumnsVisible = function (keys, visible) {
        this.gridPanel.turnOnAnimationForABit();
        this.actionOnGridColumns(keys, function (column) {
            column.setVisible(visible);
            return true;
        }, function () {
            return new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_VISIBLE).withVisible(visible);
        });
    };
    ColumnController.prototype.setColumnPinned = function (key, pinned) {
        this.setColumnsPinned([key], pinned);
    };
    ColumnController.prototype.setColumnsPinned = function (keys, pinned) {
        this.gridPanel.turnOnAnimationForABit();
        var actualPinned;
        if (pinned === true || pinned === column_1.Column.PINNED_LEFT) {
            actualPinned = column_1.Column.PINNED_LEFT;
        }
        else if (pinned === column_1.Column.PINNED_RIGHT) {
            actualPinned = column_1.Column.PINNED_RIGHT;
        }
        else {
            actualPinned = null;
        }
        this.actionOnGridColumns(keys, function (column) {
            column.setPinned(actualPinned);
            return true;
        }, function () {
            return new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_PINNED).withPinned(actualPinned);
        });
    };
    // does an action on a set of columns. provides common functionality for looking up the
    // columns based on key, getting a list of effected columns, and then updated the event
    // with either one column (if it was just one col) or a list of columns
    // used by: autoResize, setVisible, setPinned
    ColumnController.prototype.actionOnGridColumns = function (// the column keys this action will be on
        keys, 
        // the action to do - if this returns false, the column was skipped
        // and won't be included in the event
        action, 
        // should return back a column event of the right type
        createEvent) {
        var _this = this;
        if (utils_1.Utils.missingOrEmpty(keys)) {
            return;
        }
        var updatedColumns = [];
        keys.forEach(function (key) {
            var column = _this.getGridColumn(key);
            if (!column) {
                return;
            }
            // need to check for false with type (ie !== instead of !=)
            // as not returning anything (undefined) would also be false
            var resultOfAction = action(column);
            if (resultOfAction !== false) {
                updatedColumns.push(column);
            }
        });
        if (updatedColumns.length === 0) {
            return;
        }
        this.updateDisplayedColumns();
        var event = createEvent();
        event.withColumns(updatedColumns);
        if (updatedColumns.length === 1) {
            event.withColumn(updatedColumns[0]);
        }
        this.eventService.dispatchEvent(event.getType(), event);
    };
    ColumnController.prototype.getDisplayedColBefore = function (col) {
        var allDisplayedColumns = this.getAllDisplayedColumns();
        var oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex > 0) {
            return allDisplayedColumns[oldIndex - 1];
        }
        else {
            return null;
        }
    };
    // used by:
    // + rowRenderer -> for navigation
    ColumnController.prototype.getDisplayedColAfter = function (col) {
        var allDisplayedColumns = this.getAllDisplayedColumns();
        var oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex < (allDisplayedColumns.length - 1)) {
            return allDisplayedColumns[oldIndex + 1];
        }
        else {
            return null;
        }
    };
    ColumnController.prototype.isPinningLeft = function () {
        return this.displayedLeftColumns.length > 0;
    };
    ColumnController.prototype.isPinningRight = function () {
        return this.displayedRightColumns.length > 0;
    };
    ColumnController.prototype.getPrimaryAndSecondaryAndAutoColumns = function () {
        var result = this.primaryColumns ? this.primaryColumns.slice(0) : [];
        if (this.groupAutoColumnActive) {
            result.push(this.groupAutoColumn);
        }
        if (this.secondaryColumnsPresent) {
            this.secondaryColumns.forEach(function (column) { return result.push(column); });
        }
        return result;
    };
    ColumnController.prototype.createStateItemFromColumn = function (column) {
        var rowGroupIndex = column.isRowGroupActive() ? this.rowGroupColumns.indexOf(column) : null;
        var pivotIndex = column.isPivotActive() ? this.pivotColumns.indexOf(column) : null;
        var aggFunc = column.isValueActive() ? column.getAggFunc() : null;
        var resultItem = {
            colId: column.getColId(),
            hide: !column.isVisible(),
            aggFunc: aggFunc,
            width: column.getActualWidth(),
            pivotIndex: pivotIndex,
            pinned: column.getPinned(),
            rowGroupIndex: rowGroupIndex
        };
        return resultItem;
    };
    ColumnController.prototype.getColumnState = function () {
        if (utils_1.Utils.missing(this.primaryColumns)) {
            return [];
        }
        var columnStateList = this.primaryColumns.map(this.createStateItemFromColumn.bind(this));
        if (!this.pivotMode) {
            this.orderColumnStateList(columnStateList);
        }
        return columnStateList;
    };
    ColumnController.prototype.orderColumnStateList = function (columnStateList) {
        var gridColumnIds = this.gridColumns.map(function (column) { return column.getColId(); });
        columnStateList.sort(function (itemA, itemB) {
            var posA = gridColumnIds.indexOf(itemA.colId);
            var posB = gridColumnIds.indexOf(itemB.colId);
            return posA - posB;
        });
    };
    ColumnController.prototype.resetColumnState = function () {
        // we can't use 'allColumns' as the order might of messed up, so get the primary ordered list
        var primaryColumns = this.getColumnsFromTree(this.primaryBalancedTree);
        var state = [];
        if (primaryColumns) {
            primaryColumns.forEach(function (column) {
                state.push({
                    colId: column.getColId(),
                    aggFunc: column.getColDef().aggFunc,
                    hide: column.getColDef().hide,
                    pinned: column.getColDef().pinned,
                    rowGroupIndex: column.getColDef().rowGroupIndex,
                    pivotIndex: column.getColDef().pivotIndex,
                    width: column.getColDef().width
                });
            });
        }
        this.setColumnState(state);
    };
    ColumnController.prototype.setColumnState = function (columnState) {
        var _this = this;
        if (utils_1.Utils.missingOrEmpty(this.primaryColumns)) {
            return false;
        }
        // at the end below, this list will have all columns we got no state for
        var columnsWithNoState = this.primaryColumns.slice();
        this.rowGroupColumns = [];
        this.valueColumns = [];
        this.pivotColumns = [];
        var success = true;
        var rowGroupIndexes = {};
        var pivotIndexes = {};
        if (columnState) {
            columnState.forEach(function (stateItem) {
                var column = _this.getPrimaryColumn(stateItem.colId);
                if (!column) {
                    console.warn('ag-grid: column ' + stateItem.colId + ' not found');
                    success = false;
                }
                else {
                    _this.syncColumnWithStateItem(column, stateItem, rowGroupIndexes, pivotIndexes);
                    utils_1.Utils.removeFromArray(columnsWithNoState, column);
                }
            });
        }
        // anything left over, we got no data for, so add in the column as non-value, non-rowGroup and hidden
        columnsWithNoState.forEach(this.syncColumnWithNoState.bind(this));
        // sort the lists according to the indexes that were provided
        this.rowGroupColumns.sort(this.sortColumnListUsingIndexes.bind(this, rowGroupIndexes));
        this.pivotColumns.sort(this.sortColumnListUsingIndexes.bind(this, pivotIndexes));
        this.copyDownGridColumns();
        var orderOfColIds = columnState.map(function (stateItem) { return stateItem.colId; });
        this.gridColumns.sort(function (colA, colB) {
            var indexA = orderOfColIds.indexOf(colA.getId());
            var indexB = orderOfColIds.indexOf(colB.getId());
            return indexA - indexB;
        });
        this.updateDisplayedColumns();
        var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED);
        this.eventService.dispatchEvent(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, event);
        return success;
    };
    ColumnController.prototype.sortColumnListUsingIndexes = function (indexes, colA, colB) {
        var indexA = indexes[colA.getId()];
        var indexB = indexes[colB.getId()];
        return indexA - indexB;
    };
    ColumnController.prototype.syncColumnWithNoState = function (column) {
        column.setVisible(false);
        column.setAggFunc(null);
        column.setPinned(null);
        column.setRowGroupActive(false);
        column.setPivotActive(false);
        column.setValueActive(false);
    };
    ColumnController.prototype.syncColumnWithStateItem = function (column, stateItem, rowGroupIndexes, pivotIndexes) {
        // following ensures we are left with boolean true or false, eg converts (null, undefined, 0) all to true
        column.setVisible(!stateItem.hide);
        // sets pinned to 'left' or 'right'
        column.setPinned(stateItem.pinned);
        // if width provided and valid, use it, otherwise stick with the old width
        if (stateItem.width >= this.gridOptionsWrapper.getMinColWidth()) {
            column.setActualWidth(stateItem.width);
        }
        if (typeof stateItem.aggFunc === 'string') {
            column.setAggFunc(stateItem.aggFunc);
            column.setValueActive(true);
            this.valueColumns.push(column);
        }
        else {
            if (utils_1.Utils.exists(stateItem.aggFunc)) {
                console.warn('ag-Grid: stateItem.aggFunc must be a string. if using your own aggregation ' +
                    'functions, register the functions first before using them in get/set state. This is because it is' +
                    'intended for the column state to be stored and retrieved as simple JSON.');
            }
            column.setAggFunc(null);
            column.setValueActive(false);
        }
        if (typeof stateItem.rowGroupIndex === 'number') {
            this.rowGroupColumns.push(column);
            column.setRowGroupActive(true);
            rowGroupIndexes[column.getId()] = stateItem.rowGroupIndex;
        }
        else {
            column.setRowGroupActive(false);
        }
        if (typeof stateItem.pivotIndex === 'number') {
            this.pivotColumns.push(column);
            column.setPivotActive(true);
            pivotIndexes[column.getId()] = stateItem.pivotIndex;
        }
        else {
            column.setPivotActive(false);
        }
    };
    ColumnController.prototype.getGridColumns = function (keys) {
        return this.getColumns(keys, this.getGridColumn.bind(this));
    };
    ColumnController.prototype.getColumns = function (keys, columnLookupCallback) {
        var foundColumns = [];
        if (keys) {
            keys.forEach(function (key) {
                var column = columnLookupCallback(key);
                if (column) {
                    foundColumns.push(column);
                }
            });
        }
        return foundColumns;
    };
    // used by growGroupPanel
    ColumnController.prototype.getColumnWithValidation = function (key) {
        var column = this.getPrimaryColumn(key);
        if (!column) {
            console.warn('ag-Grid: could not find column ' + column);
        }
        return column;
    };
    ColumnController.prototype.getPrimaryColumn = function (key) {
        return this.getColumn(key, this.primaryColumns);
    };
    ColumnController.prototype.getGridColumn = function (key) {
        return this.getColumn(key, this.gridColumns);
    };
    ColumnController.prototype.getColumn = function (key, columnList) {
        if (!key) {
            return null;
        }
        for (var i = 0; i < columnList.length; i++) {
            if (colMatches(columnList[i])) {
                return columnList[i];
            }
        }
        if (this.groupAutoColumnActive && colMatches(this.groupAutoColumn)) {
            return this.groupAutoColumn;
        }
        function colMatches(column) {
            var columnMatches = column === key;
            var colDefMatches = column.getColDef() === key;
            var idMatches = column.getColId() == key;
            return columnMatches || colDefMatches || idMatches;
        }
        return null;
    };
    ColumnController.prototype.getDisplayNameForColumn = function (column, location, includeAggFunc) {
        if (includeAggFunc === void 0) { includeAggFunc = false; }
        var headerName = this.getHeaderName(column.getColDef(), column, null, location);
        if (includeAggFunc) {
            return this.wrapHeaderNameWithAggFunc(column, headerName);
        }
        else {
            return headerName;
        }
    };
    ColumnController.prototype.getDisplayNameForColumnGroup = function (columnGroup, location) {
        var colGroupDef = columnGroup.getOriginalColumnGroup().getColGroupDef();
        if (colGroupDef) {
            return this.getHeaderName(colGroupDef, null, columnGroup, location);
        }
        else {
            return null;
        }
    };
    // location is where the column is going to appear, ie who is calling us
    ColumnController.prototype.getHeaderName = function (colDef, column, columnGroup, location) {
        var headerValueGetter = colDef.headerValueGetter;
        if (headerValueGetter) {
            var params = {
                colDef: colDef,
                column: column,
                columnGroup: columnGroup,
                location: location,
                api: this.gridOptionsWrapper.getApi(),
                context: this.gridOptionsWrapper.getContext()
            };
            if (typeof headerValueGetter === 'function') {
                // valueGetter is a function, so just call it
                return headerValueGetter(params);
            }
            else if (typeof headerValueGetter === 'string') {
                // valueGetter is an expression, so execute the expression
                return this.expressionService.evaluate(headerValueGetter, params);
            }
            else {
                console.warn('ag-grid: headerValueGetter must be a function or a string');
                return '';
            }
        }
        else {
            return colDef.headerName;
        }
    };
    /*
        private getHeaderGroupName(columnGroup: ColumnGroup): string {
            var colGroupDef = columnGroup.getOriginalColumnGroup().getColGroupDef();
            var headerValueGetter = colGroupDef.headerValueGetter;

            if (headerValueGetter) {
                var params = {
                    columnGroup: columnGroup,
                    colDef: colGroupDef,
                    api: this.gridOptionsWrapper.getApi(),
                    context: this.gridOptionsWrapper.getContext()
                };

                if (typeof headerValueGetter === 'function') {
                    // valueGetter is a function, so just call it
                    return headerValueGetter(params);
                } else if (typeof headerValueGetter === 'string') {
                    // valueGetter is an expression, so execute the expression
                    return this.expressionService.evaluate(headerValueGetter, params);
                } else {
                    console.warn('ag-grid: headerValueGetter must be a function or a string');
                    return '';
                }
            } else {
                return colGroupDef.headerName;
            }
        }
    */
    ColumnController.prototype.wrapHeaderNameWithAggFunc = function (column, headerName) {
        if (this.gridOptionsWrapper.isSuppressAggFuncInHeader()) {
            return headerName;
        }
        // only columns with aggregation active can have aggregations
        var pivotValueColumn = column.getColDef().pivotValueColumn;
        var pivotActiveOnThisColumn = utils_1.Utils.exists(pivotValueColumn);
        var aggFunc = null;
        var aggFuncFound;
        // otherwise we have a measure that is active, and we are doing aggregation on it
        if (pivotActiveOnThisColumn) {
            aggFunc = pivotValueColumn.getAggFunc();
            aggFuncFound = true;
        }
        else {
            var measureActive = column.isValueActive();
            var aggregationPresent = this.pivotMode || !this.isRowGroupEmpty();
            if (measureActive && aggregationPresent) {
                aggFunc = column.getAggFunc();
                aggFuncFound = true;
            }
            else {
                aggFuncFound = false;
            }
        }
        if (aggFuncFound) {
            var aggFuncString = (typeof aggFunc === 'string') ? aggFunc : 'func';
            return aggFuncString + "(" + headerName + ")";
        }
        else {
            return headerName;
        }
    };
    // returns the group with matching colId and instanceId. If instanceId is missing,
    // matches only on the colId.
    ColumnController.prototype.getColumnGroup = function (colId, instanceId) {
        if (!colId) {
            return null;
        }
        if (colId instanceof columnGroup_1.ColumnGroup) {
            return colId;
        }
        var allColumnGroups = this.getAllDisplayedColumnGroups();
        var checkInstanceId = typeof instanceId === 'number';
        var result = null;
        this.columnUtils.depthFirstAllColumnTreeSearch(allColumnGroups, function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                var columnGroup = child;
                var matched;
                if (checkInstanceId) {
                    matched = colId === columnGroup.getGroupId() && instanceId === columnGroup.getInstanceId();
                }
                else {
                    matched = colId === columnGroup.getGroupId();
                }
                if (matched) {
                    result = columnGroup;
                }
            }
        });
        return result;
    };
    ColumnController.prototype.setColumnDefs = function (columnDefs) {
        var balancedTreeResult = this.balancedColumnTreeBuilder.createBalancedColumnGroups(columnDefs, true);
        this.primaryBalancedTree = balancedTreeResult.balancedTree;
        this.primaryHeaderRowCount = balancedTreeResult.treeDept + 1;
        this.primaryColumns = this.getColumnsFromTree(this.primaryBalancedTree);
        this.extractRowGroupColumns();
        this.extractPivotColumns();
        this.createValueColumns();
        this.copyDownGridColumns();
        this.updateDisplayedColumns();
        this.checkDisplayedVirtualColumns();
        this.ready = true;
        var everythingChangedEvent = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED);
        this.eventService.dispatchEvent(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, everythingChangedEvent);
        this.eventService.dispatchEvent(events_1.Events.EVENT_NEW_COLUMNS_LOADED);
    };
    ColumnController.prototype.isReady = function () {
        return this.ready;
    };
    ColumnController.prototype.extractRowGroupColumns = function () {
        var _this = this;
        this.rowGroupColumns.forEach(function (column) { return column.setRowGroupActive(false); });
        this.rowGroupColumns = [];
        // pull out the columns
        this.primaryColumns.forEach(function (column) {
            if (typeof column.getColDef().rowGroupIndex === 'number') {
                _this.rowGroupColumns.push(column);
                column.setRowGroupActive(true);
            }
        });
        // then sort them
        this.rowGroupColumns.sort(function (colA, colB) {
            return colA.getColDef().rowGroupIndex - colB.getColDef().rowGroupIndex;
        });
    };
    ColumnController.prototype.extractPivotColumns = function () {
        var _this = this;
        this.pivotColumns.forEach(function (column) { return column.setPivotActive(false); });
        this.pivotColumns = [];
        // pull out the columns
        this.primaryColumns.forEach(function (column) {
            if (typeof column.getColDef().pivotIndex === 'number') {
                _this.pivotColumns.push(column);
                column.setPivotActive(true);
            }
        });
        // then sort them
        this.pivotColumns.sort(function (colA, colB) {
            return colA.getColDef().pivotIndex - colB.getColDef().pivotIndex;
        });
    };
    // called by headerRenderer - when a header is opened or closed
    ColumnController.prototype.setColumnGroupOpened = function (passedGroup, newValue, instanceId) {
        var groupToUse = this.getColumnGroup(passedGroup, instanceId);
        if (!groupToUse) {
            return;
        }
        this.logger.log('columnGroupOpened(' + groupToUse.getGroupId() + ',' + newValue + ')');
        groupToUse.setExpanded(newValue);
        // if doing RTL, we don't animate open / close as due to how the pixels are inverted,
        // the animation moves all the row the the right rather than to the left (ie it's the static
        // columns that actually get their coordinates updated)
        if (!this.gridOptionsWrapper.isEnableRtl()) {
            this.gridPanel.turnOnAnimationForABit();
        }
        this.updateGroupsAndDisplayedColumns();
        var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_GROUP_OPENED).withColumnGroup(groupToUse);
        this.eventService.dispatchEvent(events_1.Events.EVENT_COLUMN_GROUP_OPENED, event);
    };
    // used by updateModel
    ColumnController.prototype.getColumnGroupState = function () {
        var groupState = {};
        this.columnUtils.depthFirstDisplayedColumnTreeSearch(this.getAllDisplayedColumnGroups(), function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                var columnGroup = child;
                var key = columnGroup.getGroupId();
                // if more than one instance of the group, we only record the state of the first item
                if (!groupState.hasOwnProperty(key)) {
                    groupState[key] = columnGroup.isExpanded();
                }
            }
        });
        return groupState;
    };
    // used by updateModel
    ColumnController.prototype.setColumnGroupState = function (groupState) {
        this.columnUtils.depthFirstDisplayedColumnTreeSearch(this.getAllDisplayedColumnGroups(), function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                var columnGroup = child;
                var key = columnGroup.getGroupId();
                var shouldExpandGroup = groupState[key] === true && columnGroup.isExpandable();
                if (shouldExpandGroup) {
                    columnGroup.setExpanded(true);
                }
            }
        });
    };
    ColumnController.prototype.calculateColumnsForDisplay = function () {
        var columnsForDisplay;
        if (this.pivotMode && !this.secondaryColumnsPresent) {
            // pivot mode is on, but we are not pivoting, so we only
            // show columns we are aggregating on
            columnsForDisplay = this.createColumnsToDisplayFromValueColumns();
        }
        else {
            // otherwise continue as normal. this can be working on the primary
            // or secondary columns, whatever the gridColumns are set to
            columnsForDisplay = utils_1.Utils.filter(this.gridColumns, function (column) { return column.isVisible(); });
        }
        this.createGroupAutoColumn();
        if (this.groupAutoColumnActive) {
            columnsForDisplay.unshift(this.groupAutoColumn);
        }
        return columnsForDisplay;
    };
    ColumnController.prototype.createColumnsToDisplayFromValueColumns = function () {
        var _this = this;
        // make a copy of the value columns, so we have to side effects
        var result = this.valueColumns.slice();
        // order the columns as per the grid columns. having the order is
        // important as without it, reordering of columns would have no impact
        result.sort(function (colA, colB) {
            return _this.gridColumns.indexOf(colA) - _this.gridColumns.indexOf(colB);
        });
        return result;
    };
    ColumnController.prototype.updateDisplayedColumns = function () {
        // save opened / closed state
        var oldGroupState = this.getColumnGroupState();
        var columnsForDisplay = this.calculateColumnsForDisplay();
        this.buildDisplayedTrees(columnsForDisplay);
        // restore opened / closed state
        this.setColumnGroupState(oldGroupState);
        // this is also called when a group is opened or closed
        this.updateGroupsAndDisplayedColumns();
        this.setFirstRightAndLastLeftPinned();
    };
    ColumnController.prototype.isSecondaryColumnsPresent = function () {
        return this.secondaryColumnsPresent;
    };
    ColumnController.prototype.setSecondaryColumns = function (colDefs) {
        var newColsPresent = colDefs && colDefs.length > 0;
        // if not cols passed, and we had to cols anyway, then do nothing
        if (!newColsPresent && !this.secondaryColumnsPresent) {
            return;
        }
        if (newColsPresent) {
            this.processSecondaryColumnDefinitions(colDefs);
            var balancedTreeResult = this.balancedColumnTreeBuilder.createBalancedColumnGroups(colDefs, false);
            this.secondaryBalancedTree = balancedTreeResult.balancedTree;
            this.secondaryHeaderRowCount = balancedTreeResult.treeDept + 1;
            this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree);
            this.secondaryColumnsPresent = true;
        }
        else {
            this.secondaryBalancedTree = null;
            this.secondaryHeaderRowCount = -1;
            this.secondaryColumns = null;
            this.secondaryColumnsPresent = false;
        }
        this.copyDownGridColumns();
        this.updateDisplayedColumns();
    };
    ColumnController.prototype.processSecondaryColumnDefinitions = function (colDefs) {
        var columnCallback = this.gridOptionsWrapper.getProcessSecondaryColDefFunc();
        var groupCallback = this.gridOptionsWrapper.getProcessSecondaryColGroupDefFunc();
        if (!columnCallback && !groupCallback) {
            return;
        }
        searchForColDefs(colDefs);
        function searchForColDefs(colDefs2) {
            colDefs2.forEach(function (abstractColDef) {
                var isGroup = utils_1.Utils.exists(abstractColDef.children);
                if (isGroup) {
                    var colGroupDef = abstractColDef;
                    if (groupCallback) {
                        groupCallback(colGroupDef);
                    }
                    searchForColDefs(colGroupDef.children);
                }
                else {
                    var colDef = abstractColDef;
                    if (columnCallback) {
                        columnCallback(colDef);
                    }
                }
            });
        }
    };
    // called from: setColumnState, setColumnDefs, setAlternativeColumnDefs
    ColumnController.prototype.copyDownGridColumns = function () {
        if (this.secondaryColumns) {
            this.gridBalancedTree = this.secondaryBalancedTree.slice();
            this.gridHeaderRowCount = this.secondaryHeaderRowCount;
            this.gridColumns = this.secondaryColumns.slice();
        }
        else {
            this.gridBalancedTree = this.primaryBalancedTree.slice();
            this.gridHeaderRowCount = this.primaryHeaderRowCount;
            this.gridColumns = this.primaryColumns.slice();
        }
        this.clearDisplayedColumns();
        var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_GRID_COLUMNS_CHANGED);
        this.eventService.dispatchEvent(events_1.Events.EVENT_GRID_COLUMNS_CHANGED, event);
    };
    // gets called after we copy down grid columns, to make sure any part of the gui
    // that tries to draw, eg the header, it will get empty lists of columns rather
    // than stale columns. for example, the header will received gridColumnsChanged
    // event, so will try and draw, but it will draw successfully when it acts on the
    // virtualColumnsChanged event
    ColumnController.prototype.clearDisplayedColumns = function () {
        this.displayedLeftColumnTree = [];
        this.displayedRightColumnTree = [];
        this.displayedCentreColumnTree = [];
        this.displayedLeftHeaderRows = {};
        this.displayedRightHeaderRows = {};
        this.displayedCentreHeaderRows = {};
        this.displayedLeftColumns = [];
        this.displayedRightColumns = [];
        this.displayedCenterColumns = [];
        this.allDisplayedColumns = [];
        this.allDisplayedVirtualColumns = [];
    };
    ColumnController.prototype.updateGroupsAndDisplayedColumns = function () {
        this.updateGroups();
        this.updateDisplayedColumnsFromTrees();
        this.updateVirtualSets();
        this.updateBodyWidths();
        // this event is picked up by the gui, headerRenderer and rowRenderer, to recalculate what columns to display
        var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED);
        this.eventService.dispatchEvent(events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, event);
    };
    ColumnController.prototype.updateDisplayedColumnsFromTrees = function () {
        this.addToDisplayedColumns(this.displayedLeftColumnTree, this.displayedLeftColumns);
        this.addToDisplayedColumns(this.displayedCentreColumnTree, this.displayedCenterColumns);
        this.addToDisplayedColumns(this.displayedRightColumnTree, this.displayedRightColumns);
        this.setupAllDisplayedColumns();
        this.setLeftValues();
    };
    ColumnController.prototype.setupAllDisplayedColumns = function () {
        if (this.gridOptionsWrapper.isEnableRtl()) {
            this.allDisplayedColumns = this.displayedRightColumns
                .concat(this.displayedCenterColumns)
                .concat(this.displayedLeftColumns);
        }
        else {
            this.allDisplayedColumns = this.displayedLeftColumns
                .concat(this.displayedCenterColumns)
                .concat(this.displayedRightColumns);
        }
    };
    // sets the left pixel position of each column
    ColumnController.prototype.setLeftValues = function () {
        this.setLeftValuesOfColumns();
        this.setLeftValuesOfGroups();
    };
    ColumnController.prototype.setLeftValuesOfColumns = function () {
        var _this = this;
        // go through each list of displayed columns
        var allColumns = this.primaryColumns.slice(0);
        // let totalColumnWidth = this.getWidthOfColsInList()
        var doingRtl = this.gridOptionsWrapper.isEnableRtl();
        [this.displayedLeftColumns, this.displayedRightColumns, this.displayedCenterColumns].forEach(function (columns) {
            if (doingRtl) {
                // when doing RTL, we start at the top most pixel (ie RHS) and work backwards
                var left_1 = _this.getWidthOfColsInList(columns);
                columns.forEach(function (column) {
                    left_1 -= column.getActualWidth();
                    column.setLeft(left_1);
                });
            }
            else {
                // otherwise normal LTR, we start at zero
                var left_2 = 0;
                columns.forEach(function (column) {
                    column.setLeft(left_2);
                    left_2 += column.getActualWidth();
                });
            }
            utils_1.Utils.removeAllFromArray(allColumns, columns);
        });
        // items left in allColumns are columns not displayed, so remove the left position. this is
        // important for the rows, as if a col is made visible, then taken out, then made visible again,
        // we don't want the animation of the cell floating in from the old position, whatever that was.
        allColumns.forEach(function (column) {
            column.setLeft(null);
        });
    };
    ColumnController.prototype.setLeftValuesOfGroups = function () {
        // a groups left value is the lest left value of it's children
        [this.displayedLeftColumnTree, this.displayedRightColumnTree, this.displayedCentreColumnTree].forEach(function (columns) {
            columns.forEach(function (column) {
                if (column instanceof columnGroup_1.ColumnGroup) {
                    var columnGroup = column;
                    columnGroup.checkLeft();
                }
            });
        });
    };
    ColumnController.prototype.addToDisplayedColumns = function (displayedColumnTree, displayedColumns) {
        displayedColumns.length = 0;
        this.columnUtils.depthFirstDisplayedColumnTreeSearch(displayedColumnTree, function (child) {
            if (child instanceof column_1.Column) {
                displayedColumns.push(child);
            }
        });
    };
    ColumnController.prototype.updateDisplayedCenterVirtualColumns = function () {
        var filteredCenterColumns;
        var skipVirtualisation = this.gridOptionsWrapper.isSuppressColumnVirtualisation() || this.gridOptionsWrapper.isForPrint();
        if (skipVirtualisation) {
            // no virtualisation, so don't filter
            filteredCenterColumns = this.displayedCenterColumns;
        }
        else {
            // filter out what should be visible
            filteredCenterColumns = this.filterOutColumnsWithinViewport(this.displayedCenterColumns);
        }
        this.allDisplayedVirtualColumns = filteredCenterColumns
            .concat(this.displayedLeftColumns)
            .concat(this.displayedRightColumns);
        // return map of virtual col id's, for easy lookup when building the groups.
        // the map will be colId=>true, ie col id's mapping to 'true'.
        var result = {};
        this.allDisplayedVirtualColumns.forEach(function (col) {
            result[col.getId()] = true;
        });
        return result;
    };
    ColumnController.prototype.getVirtualHeaderGroupRow = function (type, dept) {
        var result;
        switch (type) {
            case column_1.Column.PINNED_LEFT:
                result = this.displayedLeftHeaderRows[dept];
                break;
            case column_1.Column.PINNED_RIGHT:
                result = this.displayedRightHeaderRows[dept];
                break;
            default:
                result = this.displayedCentreHeaderRows[dept];
                break;
        }
        if (utils_1.Utils.missing(result)) {
            result = [];
        }
        return result;
    };
    ColumnController.prototype.updateDisplayedVirtualGroups = function (virtualColIds) {
        // go through each group, see if any of it's cols are displayed, and if yes,
        // then this group is included
        this.displayedLeftHeaderRows = {};
        this.displayedRightHeaderRows = {};
        this.displayedCentreHeaderRows = {};
        testGroup(this.displayedLeftColumnTree, this.displayedLeftHeaderRows, 0);
        testGroup(this.displayedRightColumnTree, this.displayedRightHeaderRows, 0);
        testGroup(this.displayedCentreColumnTree, this.displayedCentreHeaderRows, 0);
        function testGroup(children, result, dept) {
            var returnValue = false;
            for (var i = 0; i < children.length; i++) {
                // see if this item is within viewport
                var child = children[i];
                var addThisItem;
                if (child instanceof column_1.Column) {
                    // for column, test if column is included
                    addThisItem = virtualColIds[child.getId()] === true;
                }
                else {
                    // if group, base decision on children
                    var columnGroup = child;
                    addThisItem = testGroup(columnGroup.getDisplayedChildren(), result, dept + 1);
                }
                if (addThisItem) {
                    returnValue = true;
                    if (!result[dept]) {
                        result[dept] = [];
                    }
                    result[dept].push(child);
                }
            }
            return returnValue;
        }
    };
    ColumnController.prototype.updateVirtualSets = function () {
        var virtualColIds = this.updateDisplayedCenterVirtualColumns();
        this.updateDisplayedVirtualGroups(virtualColIds);
    };
    ColumnController.prototype.filterOutColumnsWithinViewport = function (columns) {
        var _this = this;
        var result = utils_1.Utils.filter(columns, function (column) {
            // only out if both sides of columns are to the left or to the right of the boundary
            var columnLeft = column.getLeft();
            var columnRight = column.getLeft() + column.getActualWidth();
            var columnToMuchLeft = columnLeft < _this.viewportLeft && columnRight < _this.viewportLeft;
            var columnToMuchRight = columnLeft > _this.viewportRight && columnRight > _this.viewportRight;
            var includeThisCol = !columnToMuchLeft && !columnToMuchRight;
            return includeThisCol;
        });
        return result;
    };
    // called from api
    ColumnController.prototype.sizeColumnsToFit = function (gridWidth) {
        var _this = this;
        // avoid divide by zero
        var allDisplayedColumns = this.getAllDisplayedColumns();
        if (gridWidth <= 0 || allDisplayedColumns.length === 0) {
            return;
        }
        var colsToNotSpread = utils_1.Utils.filter(allDisplayedColumns, function (column) {
            return column.getColDef().suppressSizeToFit === true;
        });
        var colsToSpread = utils_1.Utils.filter(allDisplayedColumns, function (column) {
            return column.getColDef().suppressSizeToFit !== true;
        });
        // make a copy of the cols that are going to be resized
        var colsToFireEventFor = colsToSpread.slice(0);
        var finishedResizing = false;
        while (!finishedResizing) {
            finishedResizing = true;
            var availablePixels = gridWidth - this.getWidthOfColsInList(colsToNotSpread);
            if (availablePixels <= 0) {
                // no width, set everything to minimum
                colsToSpread.forEach(function (column) {
                    column.setMinimum();
                });
            }
            else {
                var scale = availablePixels / this.getWidthOfColsInList(colsToSpread);
                // we set the pixels for the last col based on what's left, as otherwise
                // we could be a pixel or two short or extra because of rounding errors.
                var pixelsForLastCol = availablePixels;
                // backwards through loop, as we are removing items as we go
                for (var i = colsToSpread.length - 1; i >= 0; i--) {
                    var column = colsToSpread[i];
                    var newWidth = Math.round(column.getActualWidth() * scale);
                    if (newWidth < column.getMinWidth()) {
                        column.setMinimum();
                        moveToNotSpread(column);
                        finishedResizing = false;
                    }
                    else if (column.isGreaterThanMax(newWidth)) {
                        column.setActualWidth(column.getMaxWidth());
                        moveToNotSpread(column);
                        finishedResizing = false;
                    }
                    else {
                        var onLastCol = i === 0;
                        if (onLastCol) {
                            column.setActualWidth(pixelsForLastCol);
                        }
                        else {
                            column.setActualWidth(newWidth);
                        }
                    }
                    pixelsForLastCol -= newWidth;
                }
            }
        }
        this.setLeftValues();
        this.updateBodyWidths();
        // widths set, refresh the gui
        colsToFireEventFor.forEach(function (column) {
            var event = new columnChangeEvent_1.ColumnChangeEvent(events_1.Events.EVENT_COLUMN_RESIZED).withColumn(column);
            _this.eventService.dispatchEvent(events_1.Events.EVENT_COLUMN_RESIZED, event);
        });
        function moveToNotSpread(column) {
            utils_1.Utils.removeFromArray(colsToSpread, column);
            colsToNotSpread.push(column);
        }
    };
    ColumnController.prototype.buildDisplayedTrees = function (visibleColumns) {
        var leftVisibleColumns = utils_1.Utils.filter(visibleColumns, function (column) {
            return column.getPinned() === 'left';
        });
        var rightVisibleColumns = utils_1.Utils.filter(visibleColumns, function (column) {
            return column.getPinned() === 'right';
        });
        var centerVisibleColumns = utils_1.Utils.filter(visibleColumns, function (column) {
            return column.getPinned() !== 'left' && column.getPinned() !== 'right';
        });
        var groupInstanceIdCreator = new groupInstanceIdCreator_1.GroupInstanceIdCreator();
        this.displayedLeftColumnTree = this.displayedGroupCreator.createDisplayedGroups(leftVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator);
        this.displayedRightColumnTree = this.displayedGroupCreator.createDisplayedGroups(rightVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator);
        this.displayedCentreColumnTree = this.displayedGroupCreator.createDisplayedGroups(centerVisibleColumns, this.gridBalancedTree, groupInstanceIdCreator);
    };
    ColumnController.prototype.updateGroups = function () {
        var allGroups = this.getAllDisplayedColumnGroups();
        this.columnUtils.depthFirstAllColumnTreeSearch(allGroups, function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                var group = child;
                group.calculateDisplayedColumns();
            }
        });
    };
    ColumnController.prototype.createGroupAutoColumn = function () {
        // see if we need to insert the default grouping column
        var needAGroupColumn = this.rowGroupColumns.length > 0
            && !this.gridOptionsWrapper.isGroupSuppressAutoColumn()
            && !this.gridOptionsWrapper.isGroupUseEntireRow()
            && !this.gridOptionsWrapper.isGroupSuppressRow();
        this.groupAutoColumnActive = needAGroupColumn;
        // lazy create group auto-column
        if (needAGroupColumn && !this.groupAutoColumn) {
            // if one provided by user, use it, otherwise create one
            var autoColDef = this.gridOptionsWrapper.getGroupColumnDef();
            if (!autoColDef) {
                var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
                autoColDef = {
                    headerName: localeTextFunc('group', 'Group'),
                    comparator: functions_1.defaultGroupComparator,
                    valueGetter: function (params) {
                        if (params.node.group) {
                            return params.node.key;
                        }
                        else if (params.data && params.colDef.field) {
                            return params.data[params.colDef.field];
                        }
                        else {
                            return null;
                        }
                    },
                    cellRenderer: 'group'
                };
            }
            // we never allow moving the group column
            autoColDef.suppressMovable = true;
            var colId = ColumnController.GROUP_AUTO_COLUMN_ID;
            this.groupAutoColumn = new column_1.Column(autoColDef, colId, true);
            this.context.wireBean(this.groupAutoColumn);
        }
    };
    ColumnController.prototype.createValueColumns = function () {
        this.valueColumns.forEach(function (column) { return column.setValueActive(false); });
        this.valueColumns = [];
        // override with columns that have the aggFunc specified explicitly
        for (var i = 0; i < this.primaryColumns.length; i++) {
            var column = this.primaryColumns[i];
            if (column.getColDef().aggFunc) {
                column.setAggFunc(column.getColDef().aggFunc);
                this.valueColumns.push(column);
                column.setValueActive(true);
            }
        }
    };
    ColumnController.prototype.getWidthOfColsInList = function (columnList) {
        var result = 0;
        for (var i = 0; i < columnList.length; i++) {
            result += columnList[i].getActualWidth();
        }
        return result;
    };
    ColumnController.prototype.getGridBalancedTree = function () {
        return this.gridBalancedTree;
    };
    ColumnController.GROUP_AUTO_COLUMN_ID = 'ag-Grid-AutoColumn';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], ColumnController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'), 
        __metadata('design:type', expressionService_1.ExpressionService)
    ], ColumnController.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('balancedColumnTreeBuilder'), 
        __metadata('design:type', balancedColumnTreeBuilder_1.BalancedColumnTreeBuilder)
    ], ColumnController.prototype, "balancedColumnTreeBuilder", void 0);
    __decorate([
        context_1.Autowired('displayedGroupCreator'), 
        __metadata('design:type', displayedGroupCreator_1.DisplayedGroupCreator)
    ], ColumnController.prototype, "displayedGroupCreator", void 0);
    __decorate([
        context_1.Autowired('autoWidthCalculator'), 
        __metadata('design:type', autoWidthCalculator_1.AutoWidthCalculator)
    ], ColumnController.prototype, "autoWidthCalculator", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], ColumnController.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('columnUtils'), 
        __metadata('design:type', columnUtils_1.ColumnUtils)
    ], ColumnController.prototype, "columnUtils", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], ColumnController.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], ColumnController.prototype, "context", void 0);
    __decorate([
        context_1.Optional('aggFuncService'), 
        __metadata('design:type', Object)
    ], ColumnController.prototype, "aggFuncService", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], ColumnController.prototype, "init", null);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory]), 
        __metadata('design:returntype', void 0)
    ], ColumnController.prototype, "setBeans", null);
    ColumnController = __decorate([
        context_1.Bean('columnController'), 
        __metadata('design:paramtypes', [])
    ], ColumnController);
    return ColumnController;
}());
exports.ColumnController = ColumnController;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/columnController/columnKeyCreator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

// class returns a unique id to use for the column. it checks the existing columns, and if the requested
// id is already taken, it will start appending numbers until it gets a unique id.
// eg, if the col field is 'name', it will try ids: {name, name_1, name_2...}
// if no field or id provided in the col, it will try the ids of natural numbers
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var ColumnKeyCreator = (function () {
    function ColumnKeyCreator() {
        this.existingKeys = [];
    }
    ColumnKeyCreator.prototype.getUniqueKey = function (colId, colField) {
        // in case user passed in number for colId, convert to string
        colId = utils_1.Utils.toStringOrNull(colId);
        var count = 0;
        while (true) {
            var idToTry;
            if (colId) {
                idToTry = colId;
                if (count !== 0) {
                    idToTry += '_' + count;
                }
            }
            else if (colField) {
                idToTry = colField;
                if (count !== 0) {
                    idToTry += '_' + count;
                }
            }
            else {
                idToTry = '' + count;
            }
            if (this.existingKeys.indexOf(idToTry) < 0) {
                this.existingKeys.push(idToTry);
                return idToTry;
            }
            count++;
        }
    };
    return ColumnKeyCreator;
}());
exports.ColumnKeyCreator = ColumnKeyCreator;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/columnController/columnUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/columnGroup.js");
var originalColumnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/originalColumnGroup.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
// takes in a list of columns, as specified by the column definitions, and returns column groups
var ColumnUtils = (function () {
    function ColumnUtils() {
    }
    ColumnUtils.prototype.calculateColInitialWidth = function (colDef) {
        if (!colDef.width) {
            // if no width defined in colDef, use default
            return this.gridOptionsWrapper.getColWidth();
        }
        else if (colDef.width < this.gridOptionsWrapper.getMinColWidth()) {
            // if width in col def to small, set to min width
            return this.gridOptionsWrapper.getMinColWidth();
        }
        else {
            // otherwise use the provided width
            return colDef.width;
        }
    };
    ColumnUtils.prototype.getOriginalPathForColumn = function (column, originalBalancedTree) {
        var result = [];
        var found = false;
        recursePath(originalBalancedTree, 0);
        // we should always find the path, but in case there is a bug somewhere, returning null
        // will make it fail rather than provide a 'hard to track down' bug
        if (found) {
            return result;
        }
        else {
            return null;
        }
        function recursePath(balancedColumnTree, dept) {
            for (var i = 0; i < balancedColumnTree.length; i++) {
                if (found) {
                    // quit the search, so 'result' is kept with the found result
                    return;
                }
                var node = balancedColumnTree[i];
                if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
                    var nextNode = node;
                    recursePath(nextNode.getChildren(), dept + 1);
                    result[dept] = node;
                }
                else {
                    if (node === column) {
                        found = true;
                    }
                }
            }
        }
    };
    /*    public getPathForColumn(column: Column, allDisplayedColumnGroups: ColumnGroupChild[]): ColumnGroup[] {
            var result: ColumnGroup[] = [];
            var found = false;
    
            recursePath(allDisplayedColumnGroups, 0);
    
            // we should always find the path, but in case there is a bug somewhere, returning null
            // will make it fail rather than provide a 'hard to track down' bug
            if (found) {
                return result;
            } else {
                return null;
            }
    
            function recursePath(balancedColumnTree: ColumnGroupChild[], dept: number): void {
    
                for (var i = 0; i<balancedColumnTree.length; i++) {
                    if (found) {
                        // quit the search, so 'result' is kept with the found result
                        return;
                    }
                    var node = balancedColumnTree[i];
                    if (node instanceof ColumnGroup) {
                        var nextNode = <ColumnGroup> node;
                        recursePath(nextNode.getChildren(), dept+1);
                        result[dept] = node;
                    } else {
                        if (node === column) {
                            found = true;
                        }
                    }
                }
            }
        }*/
    ColumnUtils.prototype.depthFirstOriginalTreeSearch = function (tree, callback) {
        var _this = this;
        if (!tree) {
            return;
        }
        tree.forEach(function (child) {
            if (child instanceof originalColumnGroup_1.OriginalColumnGroup) {
                _this.depthFirstOriginalTreeSearch(child.getChildren(), callback);
            }
            callback(child);
        });
    };
    ColumnUtils.prototype.depthFirstAllColumnTreeSearch = function (tree, callback) {
        var _this = this;
        if (!tree) {
            return;
        }
        tree.forEach(function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                _this.depthFirstAllColumnTreeSearch(child.getChildren(), callback);
            }
            callback(child);
        });
    };
    ColumnUtils.prototype.depthFirstDisplayedColumnTreeSearch = function (tree, callback) {
        var _this = this;
        if (!tree) {
            return;
        }
        tree.forEach(function (child) {
            if (child instanceof columnGroup_1.ColumnGroup) {
                _this.depthFirstDisplayedColumnTreeSearch(child.getDisplayedChildren(), callback);
            }
            callback(child);
        });
    };
    __decorate([
        context_2.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], ColumnUtils.prototype, "gridOptionsWrapper", void 0);
    ColumnUtils = __decorate([
        context_1.Bean('columnUtils'), 
        __metadata('design:paramtypes', [])
    ], ColumnUtils);
    return ColumnUtils;
}());
exports.ColumnUtils = ColumnUtils;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/columnController/displayedGroupCreator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var columnUtils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnUtils.js");
var columnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/columnGroup.js");
var originalColumnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/originalColumnGroup.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
// takes in a list of columns, as specified by the column definitions, and returns column groups
var DisplayedGroupCreator = (function () {
    function DisplayedGroupCreator() {
    }
    DisplayedGroupCreator.prototype.createDisplayedGroups = function (sortedVisibleColumns, balancedColumnTree, groupInstanceIdCreator) {
        var _this = this;
        var result = [];
        var previousRealPath;
        var previousOriginalPath;
        // go through each column, then do a bottom up comparison to the previous column, and start
        // to share groups if they converge at any point.
        sortedVisibleColumns.forEach(function (currentColumn) {
            var currentOriginalPath = _this.getOriginalPathForColumn(balancedColumnTree, currentColumn);
            var currentRealPath = [];
            var firstColumn = !previousOriginalPath;
            for (var i = 0; i < currentOriginalPath.length; i++) {
                if (firstColumn || currentOriginalPath[i] !== previousOriginalPath[i]) {
                    // new group needed
                    var originalGroup = currentOriginalPath[i];
                    var groupId = originalGroup.getGroupId();
                    var instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
                    var newGroup = new columnGroup_1.ColumnGroup(originalGroup, groupId, instanceId);
                    _this.context.wireBean(newGroup);
                    currentRealPath[i] = newGroup;
                    // if top level, add to result, otherwise add to parent
                    if (i == 0) {
                        result.push(newGroup);
                    }
                    else {
                        currentRealPath[i - 1].addChild(newGroup);
                    }
                }
                else {
                    // reuse old group
                    currentRealPath[i] = previousRealPath[i];
                }
            }
            var noColumnGroups = currentRealPath.length === 0;
            if (noColumnGroups) {
                // if we are not grouping, then the result of the above is an empty
                // path (no groups), and we just add the column to the root list.
                result.push(currentColumn);
            }
            else {
                var leafGroup = currentRealPath[currentRealPath.length - 1];
                leafGroup.addChild(currentColumn);
            }
            previousRealPath = currentRealPath;
            previousOriginalPath = currentOriginalPath;
        });
        this.setupParentsIntoColumns(result, null);
        return result;
    };
    DisplayedGroupCreator.prototype.setupParentsIntoColumns = function (columnsOrGroups, parent) {
        var _this = this;
        columnsOrGroups.forEach(function (columnsOrGroup) {
            columnsOrGroup.setParent(parent);
            if (columnsOrGroup instanceof columnGroup_1.ColumnGroup) {
                var columnGroup = columnsOrGroup;
                _this.setupParentsIntoColumns(columnGroup.getChildren(), columnGroup);
            }
        });
    };
    DisplayedGroupCreator.prototype.createFakePath = function (balancedColumnTree) {
        var result = [];
        var currentChildren = balancedColumnTree;
        // this while look does search on the balanced tree, so our result is the right length
        var index = 0;
        while (currentChildren && currentChildren[0] && currentChildren[0] instanceof originalColumnGroup_1.OriginalColumnGroup) {
            // putting in a deterministic fake id, in case the API in the future needs to reference the col
            result.push(new originalColumnGroup_1.OriginalColumnGroup(null, 'FAKE_PATH_' + index, true));
            currentChildren = currentChildren[0].getChildren();
            index++;
        }
        return result;
    };
    DisplayedGroupCreator.prototype.getOriginalPathForColumn = function (balancedColumnTree, column) {
        var result = [];
        var found = false;
        recursePath(balancedColumnTree, 0);
        // it's possible we didn't find a path. this happens if the column is generated
        // by the grid, in that the definition didn't come from the client. in this case,
        // we create a fake original path.
        if (found) {
            return result;
        }
        else {
            return this.createFakePath(balancedColumnTree);
        }
        function recursePath(balancedColumnTree, dept) {
            for (var i = 0; i < balancedColumnTree.length; i++) {
                if (found) {
                    // quit the search, so 'result' is kept with the found result
                    return;
                }
                var node = balancedColumnTree[i];
                if (node instanceof originalColumnGroup_1.OriginalColumnGroup) {
                    var nextNode = node;
                    recursePath(nextNode.getChildren(), dept + 1);
                    result[dept] = node;
                }
                else {
                    if (node === column) {
                        found = true;
                    }
                }
            }
        }
    };
    __decorate([
        context_2.Autowired('columnUtils'), 
        __metadata('design:type', columnUtils_1.ColumnUtils)
    ], DisplayedGroupCreator.prototype, "columnUtils", void 0);
    __decorate([
        context_2.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], DisplayedGroupCreator.prototype, "context", void 0);
    DisplayedGroupCreator = __decorate([
        context_1.Bean('displayedGroupCreator'), 
        __metadata('design:paramtypes', [])
    ], DisplayedGroupCreator);
    return DisplayedGroupCreator;
}());
exports.DisplayedGroupCreator = DisplayedGroupCreator;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/columnController/groupInstanceIdCreator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

// class returns unique instance id's for columns.
// eg, the following calls (in this order) will result in:
//
// getInstanceIdForKey('country') => 0
// getInstanceIdForKey('country') => 1
// getInstanceIdForKey('country') => 2
// getInstanceIdForKey('country') => 3
// getInstanceIdForKey('age') => 0
// getInstanceIdForKey('age') => 1
// getInstanceIdForKey('country') => 4
var GroupInstanceIdCreator = (function () {
    function GroupInstanceIdCreator() {
        // this map contains keys to numbers, so we remember what the last call was
        this.existingIds = {};
    }
    GroupInstanceIdCreator.prototype.getInstanceIdForKey = function (key) {
        var lastResult = this.existingIds[key];
        var result;
        if (typeof lastResult !== 'number') {
            // first time this key
            result = 0;
        }
        else {
            result = lastResult + 1;
        }
        this.existingIds[key] = result;
        return result;
    };
    return GroupInstanceIdCreator;
}());
exports.GroupInstanceIdCreator = GroupInstanceIdCreator;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/components/agGridNg1.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var grid_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/grid.js");
function initialiseAgGridWithAngular1(angular) {
    var angularModule = angular.module("agGrid", []);
    angularModule.directive("agGrid", function () {
        return {
            restrict: "A",
            controller: ['$element', '$scope', '$compile', '$attrs', AngularDirectiveController],
            scope: true
        };
    });
}
exports.initialiseAgGridWithAngular1 = initialiseAgGridWithAngular1;
function AngularDirectiveController($element, $scope, $compile, $attrs) {
    var gridOptions;
    var quickFilterOnScope;
    var keyOfGridInScope = $attrs.agGrid;
    quickFilterOnScope = keyOfGridInScope + '.quickFilterText';
    gridOptions = $scope.$eval(keyOfGridInScope);
    if (!gridOptions) {
        console.warn("WARNING - grid options for ag-Grid not found. Please ensure the attribute ag-grid points to a valid object on the scope");
        return;
    }
    var eGridDiv = $element[0];
    var gridParams = {
        $scope: $scope,
        $compile: $compile,
        quickFilterOnScope: quickFilterOnScope
    };
    var grid = new grid_1.Grid(eGridDiv, gridOptions, gridParams);
    $scope.$on("$destroy", function () {
        grid.destroy();
    });
}


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/components/agGridWebComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var componentUtil_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/components/componentUtil.js");
var grid_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/grid.js");
var registered = false;
function initialiseAgGridWithWebComponents() {
    // only register to WebComponents once
    if (registered) {
        return;
    }
    registered = true;
    if (typeof document === 'undefined' || !document.registerElement) {
        console.error('ag-Grid: unable to find document.registerElement() function, unable to initialise ag-Grid as a Web Component');
    }
    // i don't think this type of extension is possible in TypeScript, so back to
    // plain Javascript to create this object
    var AgileGridProto = Object.create(HTMLElement.prototype);
    // wrap each property with a get and set method, so we can track when changes are done
    componentUtil_1.ComponentUtil.ALL_PROPERTIES.forEach(function (key) {
        Object.defineProperty(AgileGridProto, key, {
            set: function (v) {
                this.__agGridSetProperty(key, v);
            },
            get: function () {
                return this.__agGridGetProperty(key);
            }
        });
    });
    var agGridProtoNoType = AgileGridProto;
    agGridProtoNoType.__agGridSetProperty = function (key, value) {
        if (!this.__attributes) {
            this.__attributes = {};
        }
        this.__attributes[key] = value;
        // keeping this consistent with the ng2 onChange, so I can reuse the handling code
        var changeObject = {};
        changeObject[key] = { currentValue: value };
        this.onChange(changeObject);
    };
    agGridProtoNoType.onChange = function (changes) {
        if (this._initialised) {
            componentUtil_1.ComponentUtil.processOnChange(changes, this._gridOptions, this.api, this.columnApi);
        }
    };
    agGridProtoNoType.__agGridGetProperty = function (key) {
        if (!this.__attributes) {
            this.__attributes = {};
        }
        return this.__attributes[key];
    };
    agGridProtoNoType.setGridOptions = function (options) {
        var globalEventListener = this.globalEventListener.bind(this);
        this._gridOptions = componentUtil_1.ComponentUtil.copyAttributesToGridOptions(options, this);
        var gridParams = {
            globalEventListener: globalEventListener
        };
        this._agGrid = new grid_1.Grid(this, this._gridOptions, gridParams);
        this.api = options.api;
        this.columnApi = options.columnApi;
        this._initialised = true;
    };
    // copies all the attributes into this object
    agGridProtoNoType.createdCallback = function () {
        for (var i = 0; i < this.attributes.length; i++) {
            var attribute = this.attributes[i];
            this.setPropertyFromAttribute(attribute);
        }
    };
    agGridProtoNoType.setPropertyFromAttribute = function (attribute) {
        var name = toCamelCase(attribute.nodeName);
        var value = attribute.nodeValue;
        if (componentUtil_1.ComponentUtil.ALL_PROPERTIES.indexOf(name) >= 0) {
            this[name] = value;
        }
    };
    agGridProtoNoType.attachedCallback = function (params) { };
    agGridProtoNoType.detachedCallback = function (params) { };
    agGridProtoNoType.attributeChangedCallback = function (attributeName) {
        var attribute = this.attributes[attributeName];
        this.setPropertyFromAttribute(attribute);
    };
    agGridProtoNoType.globalEventListener = function (eventType, event) {
        var eventLowerCase = eventType.toLowerCase();
        var browserEvent = new Event(eventLowerCase);
        var browserEventNoType = browserEvent;
        browserEventNoType.agGridDetails = event;
        this.dispatchEvent(browserEvent);
        var callbackMethod = 'on' + eventLowerCase;
        if (typeof this[callbackMethod] === 'function') {
            this[callbackMethod](browserEvent);
        }
    };
    // finally, register
    document.registerElement('ag-grid', { prototype: AgileGridProto });
}
exports.initialiseAgGridWithWebComponents = initialiseAgGridWithWebComponents;
function toCamelCase(myString) {
    if (typeof myString === 'string') {
        var result = myString.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
        return result;
    }
    else {
        return myString;
    }
}


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/components/componentUtil.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var ComponentUtil = (function () {
    function ComponentUtil() {
    }
    ComponentUtil.getEventCallbacks = function () {
        if (!ComponentUtil.EVENT_CALLBACKS) {
            ComponentUtil.EVENT_CALLBACKS = [];
            ComponentUtil.EVENTS.forEach(function (eventName) {
                ComponentUtil.EVENT_CALLBACKS.push(ComponentUtil.getCallbackForEvent(eventName));
            });
        }
        return ComponentUtil.EVENT_CALLBACKS;
    };
    ComponentUtil.copyAttributesToGridOptions = function (gridOptions, component) {
        checkForDeprecated(component);
        // create empty grid options if none were passed
        if (typeof gridOptions !== 'object') {
            gridOptions = {};
        }
        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
        var pGridOptions = gridOptions;
        // add in all the simple properties
        ComponentUtil.ARRAY_PROPERTIES
            .concat(ComponentUtil.STRING_PROPERTIES)
            .concat(ComponentUtil.OBJECT_PROPERTIES)
            .concat(ComponentUtil.FUNCTION_PROPERTIES)
            .forEach(function (key) {
            if (typeof (component)[key] !== 'undefined') {
                pGridOptions[key] = component[key];
            }
        });
        ComponentUtil.BOOLEAN_PROPERTIES.forEach(function (key) {
            if (typeof (component)[key] !== 'undefined') {
                pGridOptions[key] = ComponentUtil.toBoolean(component[key]);
            }
        });
        ComponentUtil.NUMBER_PROPERTIES.forEach(function (key) {
            if (typeof (component)[key] !== 'undefined') {
                pGridOptions[key] = ComponentUtil.toNumber(component[key]);
            }
        });
        ComponentUtil.getEventCallbacks().forEach(function (funcName) {
            if (typeof (component)[funcName] !== 'undefined') {
                pGridOptions[funcName] = component[funcName];
            }
        });
        return gridOptions;
    };
    ComponentUtil.getCallbackForEvent = function (eventName) {
        if (!eventName || eventName.length < 2) {
            return eventName;
        }
        else {
            return 'on' + eventName[0].toUpperCase() + eventName.substr(1);
        }
    };
    // change this method, the caller should know if it's initialised or not, plus 'initialised'
    // is not relevant for all component types. maybe pass in the api and columnApi instead???
    ComponentUtil.processOnChange = function (changes, gridOptions, api, columnApi) {
        //if (!component._initialised || !changes) { return; }
        if (!changes) {
            return;
        }
        checkForDeprecated(changes);
        // to allow array style lookup in TypeScript, take type away from 'this' and 'gridOptions'
        var pGridOptions = gridOptions;
        // check if any change for the simple types, and if so, then just copy in the new value
        ComponentUtil.ARRAY_PROPERTIES
            .concat(ComponentUtil.OBJECT_PROPERTIES)
            .concat(ComponentUtil.STRING_PROPERTIES)
            .forEach(function (key) {
            if (changes[key]) {
                pGridOptions[key] = changes[key].currentValue;
            }
        });
        ComponentUtil.BOOLEAN_PROPERTIES.forEach(function (key) {
            if (changes[key]) {
                pGridOptions[key] = ComponentUtil.toBoolean(changes[key].currentValue);
            }
        });
        ComponentUtil.NUMBER_PROPERTIES.forEach(function (key) {
            if (changes[key]) {
                pGridOptions[key] = ComponentUtil.toNumber(changes[key].currentValue);
            }
        });
        ComponentUtil.getEventCallbacks().forEach(function (funcName) {
            if (changes[funcName]) {
                pGridOptions[funcName] = changes[funcName].currentValue;
            }
        });
        if (changes.showToolPanel) {
            api.showToolPanel(ComponentUtil.toBoolean(changes.showToolPanel.currentValue));
        }
        if (changes.quickFilterText) {
            api.setQuickFilter(changes.quickFilterText.currentValue);
        }
        if (changes.rowData) {
            api.setRowData(changes.rowData.currentValue);
        }
        if (changes.floatingTopRowData) {
            api.setFloatingTopRowData(changes.floatingTopRowData.currentValue);
        }
        if (changes.floatingBottomRowData) {
            api.setFloatingBottomRowData(changes.floatingBottomRowData.currentValue);
        }
        if (changes.columnDefs) {
            api.setColumnDefs(changes.columnDefs.currentValue);
        }
        if (changes.datasource) {
            api.setDatasource(changes.datasource.currentValue);
        }
        if (changes.headerHeight) {
            api.setHeaderHeight(ComponentUtil.toNumber(changes.headerHeight.currentValue));
        }
        if (changes.pivotMode) {
            columnApi.setPivotMode(ComponentUtil.toBoolean(changes.pivotMode.currentValue));
        }
    };
    ComponentUtil.toBoolean = function (value) {
        if (typeof value === 'boolean') {
            return value;
        }
        else if (typeof value === 'string') {
            // for boolean, compare to empty String to allow attributes appearing with
            // not value to be treated as 'true'
            return value.toUpperCase() === 'TRUE' || value == '';
        }
        else {
            return false;
        }
    };
    ComponentUtil.toNumber = function (value) {
        if (typeof value === 'number') {
            return value;
        }
        else if (typeof value === 'string') {
            return Number(value);
        }
        else {
            return undefined;
        }
    };
    // all the events are populated in here AFTER this class (at the bottom of the file).
    ComponentUtil.EVENTS = [];
    ComponentUtil.STRING_PROPERTIES = [
        'sortingOrder', 'rowClass', 'rowSelection', 'overlayLoadingTemplate',
        'overlayNoRowsTemplate', 'headerCellTemplate', 'quickFilterText', 'rowModelType',
        'editType'];
    ComponentUtil.OBJECT_PROPERTIES = [
        'rowStyle', 'context', 'groupColumnDef', 'localeText', 'icons', 'datasource', 'viewportDatasource',
        'groupRowRendererParams', 'aggFuncs', 'fullWidthCellRendererParams', 'defaultColGroupDef', 'defaultColDef'
    ];
    ComponentUtil.ARRAY_PROPERTIES = [
        'slaveGrids', 'rowData', 'floatingTopRowData', 'floatingBottomRowData', 'columnDefs', 'excelStyles'
    ];
    ComponentUtil.NUMBER_PROPERTIES = [
        'rowHeight', 'rowBuffer', 'colWidth', 'headerHeight', 'groupDefaultExpanded',
        'minColWidth', 'maxColWidth', 'viewportRowModelPageSize', 'viewportRowModelBufferSize',
        'layoutInterval', 'autoSizePadding', 'maxPagesInCache', 'maxConcurrentDatasourceRequests',
        'paginationOverflowSize', 'paginationPageSize', 'paginationInitialRowCount', 'scrollbarWidth'
    ];
    ComponentUtil.BOOLEAN_PROPERTIES = [
        'toolPanelSuppressRowGroups', 'toolPanelSuppressValues', 'toolPanelSuppressPivots', 'toolPanelSuppressPivotMode',
        'suppressRowClickSelection', 'suppressCellSelection', 'suppressHorizontalScroll', 'debug',
        'enableColResize', 'enableCellExpressions', 'enableSorting', 'enableServerSideSorting',
        'enableFilter', 'enableServerSideFilter', 'angularCompileRows', 'angularCompileFilters',
        'angularCompileHeaders', 'groupSuppressAutoColumn', 'groupSelectsChildren',
        'groupIncludeFooter', 'groupUseEntireRow', 'groupSuppressRow', 'groupSuppressBlankHeader', 'forPrint',
        'suppressMenuHide', 'rowDeselection', 'unSortIcon', 'suppressMultiSort', 'suppressScrollLag',
        'singleClickEdit', 'suppressLoadingOverlay', 'suppressNoRowsOverlay', 'suppressAutoSize',
        'suppressParentsInRowNodes', 'showToolPanel', 'suppressColumnMoveAnimation', 'suppressMovableColumns',
        'suppressFieldDotNotation', 'enableRangeSelection', 'suppressEnterprise', 'rowGroupPanelShow',
        'pivotPanelShow', 'suppressTouch',
        'suppressContextMenu', 'suppressMenuFilterPanel', 'suppressMenuMainPanel', 'suppressMenuColumnPanel',
        'enableStatusBar', 'rememberGroupStateWhenNewData', 'enableCellChangeFlash', 'suppressDragLeaveHidesColumns',
        'suppressMiddleClickScrolls', 'suppressPreventDefaultOnMouseWheel', 'suppressUseColIdForGroups',
        'suppressCopyRowsToClipboard', 'pivotMode', 'suppressAggFuncInHeader', 'suppressColumnVirtualisation',
        'suppressFocusAfterRefresh', 'functionsPassive', 'functionsReadOnly', 'suppressRowHoverClass',
        'animateRows', 'groupSelectsFiltered', 'groupRemoveSingleChildren', 'enableRtl', 'suppressClickEdit',
        'enableGroupEdit', 'embedFullWidthRows'
    ];
    ComponentUtil.FUNCTION_PROPERTIES = ['headerCellRenderer', 'localeTextFunc', 'groupRowInnerRenderer', 'groupRowInnerRendererFramework',
        'dateComponent', 'groupRowRenderer', 'groupRowRendererFramework', 'isScrollLag', 'isExternalFilterPresent', 'getRowHeight',
        'doesExternalFilterPass', 'getRowClass', 'getRowStyle', 'getHeaderCellTemplate', 'traverseNode',
        'getContextMenuItems', 'getMainMenuItems', 'processRowPostCreate', 'processCellForClipboard',
        'getNodeChildDetails', 'groupRowAggNodes', 'getRowNodeId', 'isFullWidthCell', 'fullWidthCellRenderer',
        'fullWidthCellRendererFramework', 'doesDataFlower', 'processSecondaryColDef', 'processSecondaryColGroupDef',
        'getBusinessKeyForNode', 'checkboxSelection', 'sendToClipboard', 'navigateToNextCell', 'tabToNextCell',
        'processCellFromClipboard', 'getDocument'];
    ComponentUtil.ALL_PROPERTIES = ComponentUtil.ARRAY_PROPERTIES
        .concat(ComponentUtil.OBJECT_PROPERTIES)
        .concat(ComponentUtil.STRING_PROPERTIES)
        .concat(ComponentUtil.NUMBER_PROPERTIES)
        .concat(ComponentUtil.FUNCTION_PROPERTIES)
        .concat(ComponentUtil.BOOLEAN_PROPERTIES);
    return ComponentUtil;
}());
exports.ComponentUtil = ComponentUtil;
utils_1.Utils.iterateObject(events_1.Events, function (key, value) {
    ComponentUtil.EVENTS.push(value);
});
function checkForDeprecated(changes) {
    if (changes.ready || changes.onReady) {
        console.warn('ag-grid: as of v3.3 ready event is now called gridReady, so the callback should be onGridReady');
    }
    if (changes.rowDeselected || changes.onRowDeselected) {
        console.warn('ag-grid: as of v3.4 rowDeselected no longer exists. Please check the docs.');
    }
}


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var Constants = (function () {
    function Constants() {
    }
    Constants.STEP_EVERYTHING = 0;
    Constants.STEP_FILTER = 1;
    Constants.STEP_SORT = 2;
    Constants.STEP_MAP = 3;
    Constants.STEP_AGGREGATE = 4;
    Constants.STEP_PIVOT = 5;
    Constants.ROW_BUFFER_SIZE = 10;
    Constants.LAYOUT_INTERVAL = 500;
    Constants.KEY_BACKSPACE = 8;
    Constants.KEY_TAB = 9;
    Constants.KEY_ENTER = 13;
    Constants.KEY_SHIFT = 16;
    Constants.KEY_ESCAPE = 27;
    Constants.KEY_SPACE = 32;
    Constants.KEY_LEFT = 37;
    Constants.KEY_UP = 38;
    Constants.KEY_RIGHT = 39;
    Constants.KEY_DOWN = 40;
    Constants.KEY_DELETE = 46;
    Constants.KEY_A = 65;
    Constants.KEY_C = 67;
    Constants.KEY_V = 86;
    Constants.KEY_D = 68;
    Constants.KEY_F2 = 113;
    Constants.ROW_MODEL_TYPE_PAGINATION = 'pagination';
    Constants.ROW_MODEL_TYPE_VIRTUAL = 'virtual';
    Constants.ROW_MODEL_TYPE_VIEWPORT = 'viewport';
    Constants.ROW_MODEL_TYPE_NORMAL = 'normal';
    Constants.ALWAYS = 'always';
    Constants.ONLY_WHEN_GROUPING = 'onlyWhenGrouping';
    Constants.FLOATING_TOP = 'top';
    Constants.FLOATING_BOTTOM = 'bottom';
    return Constants;
}());
exports.Constants = Constants;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/context/beanStub.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var BeanStub = (function () {
    function BeanStub() {
        this.destroyFunctions = [];
    }
    BeanStub.prototype.destroy = function () {
        this.destroyFunctions.forEach(function (func) { return func(); });
        this.destroyFunctions.length = 0;
    };
    BeanStub.prototype.addEventListener = function (eventType, listener) {
        if (!this.localEventService) {
            this.localEventService = new eventService_1.EventService();
        }
        this.localEventService.addEventListener(eventType, listener);
    };
    BeanStub.prototype.removeEventListener = function (eventType, listener) {
        if (this.localEventService) {
            this.localEventService.removeEventListener(eventType, listener);
        }
    };
    BeanStub.prototype.dispatchEventAsync = function (eventType, event) {
        var _this = this;
        setTimeout(function () { return _this.dispatchEvent(eventType, event); }, 0);
    };
    BeanStub.prototype.dispatchEvent = function (eventType, event) {
        if (this.localEventService) {
            this.localEventService.dispatchEvent(eventType, event);
        }
    };
    BeanStub.prototype.addDestroyableEventListener = function (eElement, event, listener) {
        if (eElement instanceof HTMLElement) {
            eElement.addEventListener(event, listener);
        }
        else if (eElement instanceof gridOptionsWrapper_1.GridOptionsWrapper) {
            eElement.addEventListener(event, listener);
        }
        else {
            eElement.addEventListener(event, listener);
        }
        this.destroyFunctions.push(function () {
            if (eElement instanceof HTMLElement) {
                eElement.removeEventListener(event, listener);
            }
            else if (eElement instanceof gridOptionsWrapper_1.GridOptionsWrapper) {
                eElement.removeEventListener(event, listener);
            }
            else {
                eElement.removeEventListener(event, listener);
            }
        });
    };
    BeanStub.prototype.addDestroyFunc = function (func) {
        this.destroyFunctions.push(func);
    };
    return BeanStub;
}());
exports.BeanStub = BeanStub;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/context/context.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var Context = (function () {
    function Context(params) {
        this.beans = {};
        this.componentsMappedByName = {};
        this.destroyed = false;
        if (!params || !params.beans) {
            return;
        }
        this.contextParams = params;
        this.logger = new logger_1.Logger('Context', this.contextParams.debug);
        this.logger.log('>> creating ag-Application Context');
        this.setupComponents();
        this.createBeans();
        var beans = utils_1.Utils.mapObject(this.beans, function (beanEntry) { return beanEntry.beanInstance; });
        this.wireBeans(beans);
        this.logger.log('>> ag-Application Context ready - component is alive');
    }
    Context.prototype.setupComponents = function () {
        var _this = this;
        if (this.contextParams.components) {
            this.contextParams.components.forEach(function (componentMeta) { return _this.addComponent(componentMeta); });
        }
    };
    Context.prototype.addComponent = function (componentMeta) {
        // get name of the class as a string
        // var className = _.getNameOfClass(ComponentClass);
        // insert a dash after every capital letter
        // var classEscaped = className.replace(/([A-Z])/g, "-$1").toLowerCase();
        var classEscaped = componentMeta.componentName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        // put all to upper case
        var classUpperCase = classEscaped.toUpperCase();
        // finally store
        this.componentsMappedByName[classUpperCase] = componentMeta.theClass;
    };
    Context.prototype.createComponent = function (element) {
        var key = element.nodeName;
        if (this.componentsMappedByName && this.componentsMappedByName[key]) {
            var newComponent = new this.componentsMappedByName[key];
            this.wireBean(newComponent);
            this.copyAttributesFromNode(element, newComponent.getGui());
            newComponent.attributesSet();
            return newComponent;
        }
        else {
            return null;
        }
    };
    Context.prototype.copyAttributesFromNode = function (fromNode, toNode) {
        if (fromNode.attributes) {
            var count = fromNode.attributes.length;
            for (var i = 0; i < count; i++) {
                var attr = fromNode.attributes[i];
                toNode.setAttribute(attr.name, attr.value);
            }
        }
    };
    Context.prototype.wireBean = function (bean) {
        this.wireBeans([bean]);
    };
    Context.prototype.wireBeans = function (beans) {
        this.autoWireBeans(beans);
        this.methodWireBeans(beans);
        this.postConstruct(beans);
    };
    Context.prototype.createBeans = function () {
        var _this = this;
        // register all normal beans
        this.contextParams.beans.forEach(this.createBeanEntry.bind(this));
        // register override beans, these will overwrite beans above of same name
        if (this.contextParams.overrideBeans) {
            this.contextParams.overrideBeans.forEach(this.createBeanEntry.bind(this));
        }
        // instantiate all beans - overridden beans will be left out
        utils_1.Utils.iterateObject(this.beans, function (key, beanEntry) {
            var constructorParamsMeta;
            if (beanEntry.bean.prototype.__agBeanMetaData
                && beanEntry.bean.prototype.__agBeanMetaData.autowireMethods
                && beanEntry.bean.prototype.__agBeanMetaData.autowireMethods.agConstructor) {
                constructorParamsMeta = beanEntry.bean.prototype.__agBeanMetaData.autowireMethods.agConstructor;
            }
            var constructorParams = _this.getBeansForParameters(constructorParamsMeta, beanEntry.beanName);
            var newInstance = applyToConstructor(beanEntry.bean, constructorParams);
            beanEntry.beanInstance = newInstance;
            _this.logger.log('bean ' + _this.getBeanName(newInstance) + ' created');
        });
    };
    Context.prototype.createBeanEntry = function (Bean) {
        var metaData = Bean.prototype.__agBeanMetaData;
        if (!metaData) {
            var beanName;
            if (Bean.prototype.constructor) {
                beanName = Bean.prototype.constructor.name;
            }
            else {
                beanName = '' + Bean;
            }
            console.error('context item ' + beanName + ' is not a bean');
            return;
        }
        var beanEntry = {
            bean: Bean,
            beanInstance: null,
            beanName: metaData.beanName
        };
        this.beans[metaData.beanName] = beanEntry;
    };
    Context.prototype.autoWireBeans = function (beans) {
        var _this = this;
        beans.forEach(function (bean) { return _this.autoWireBean(bean); });
    };
    Context.prototype.methodWireBeans = function (beans) {
        var _this = this;
        beans.forEach(function (bean) { return _this.methodWireBean(bean); });
    };
    Context.prototype.autoWireBean = function (bean) {
        var _this = this;
        if (!bean
            || !bean.__agBeanMetaData
            || !bean.__agBeanMetaData.agClassAttributes) {
            return;
        }
        var attributes = bean.__agBeanMetaData.agClassAttributes;
        if (!attributes) {
            return;
        }
        var beanName = this.getBeanName(bean);
        attributes.forEach(function (attribute) {
            var otherBean = _this.lookupBeanInstance(beanName, attribute.beanName, attribute.optional);
            bean[attribute.attributeName] = otherBean;
        });
    };
    Context.prototype.getBeanName = function (bean) {
        var constructorString = bean.constructor.toString();
        var beanName = constructorString.substring(9, constructorString.indexOf('('));
        return beanName;
    };
    Context.prototype.methodWireBean = function (bean) {
        var _this = this;
        var autowiredMethods;
        if (bean.__agBeanMetaData) {
            autowiredMethods = bean.__agBeanMetaData.autowireMethods;
        }
        utils_1.Utils.iterateObject(autowiredMethods, function (methodName, wireParams) {
            // skip constructor, as this is dealt with elsewhere
            if (methodName === 'agConstructor') {
                return;
            }
            var beanName = _this.getBeanName(bean);
            var initParams = _this.getBeansForParameters(wireParams, beanName);
            bean[methodName].apply(bean, initParams);
        });
    };
    Context.prototype.getBeansForParameters = function (parameters, beanName) {
        var _this = this;
        var beansList = [];
        if (parameters) {
            utils_1.Utils.iterateObject(parameters, function (paramIndex, otherBeanName) {
                var otherBean = _this.lookupBeanInstance(beanName, otherBeanName);
                beansList[Number(paramIndex)] = otherBean;
            });
        }
        return beansList;
    };
    Context.prototype.lookupBeanInstance = function (wiringBean, beanName, optional) {
        if (optional === void 0) { optional = false; }
        if (beanName === 'context') {
            return this;
        }
        else if (this.contextParams.seed && this.contextParams.seed.hasOwnProperty(beanName)) {
            return this.contextParams.seed[beanName];
        }
        else {
            var beanEntry = this.beans[beanName];
            if (beanEntry) {
                return beanEntry.beanInstance;
            }
            if (!optional) {
                console.error('ag-Grid: unable to find bean reference ' + beanName + ' while initialising ' + wiringBean);
            }
            return null;
        }
    };
    Context.prototype.postConstruct = function (beans) {
        beans.forEach(function (bean) {
            // try calling init methods
            if (bean.__agBeanMetaData && bean.__agBeanMetaData.postConstructMethods) {
                bean.__agBeanMetaData.postConstructMethods.forEach(function (methodName) { return bean[methodName](); });
            }
        });
    };
    Context.prototype.getBean = function (name) {
        return this.lookupBeanInstance('getBean', name, true);
    };
    Context.prototype.destroy = function () {
        // should only be able to destroy once
        if (this.destroyed) {
            return;
        }
        this.logger.log('>> Shutting down ag-Application Context');
        // try calling destroy methods
        utils_1.Utils.iterateObject(this.beans, function (key, beanEntry) {
            var bean = beanEntry.beanInstance;
            if (bean.__agBeanMetaData && bean.__agBeanMetaData.preDestroyMethods) {
                bean.__agBeanMetaData.preDestroyMethods.forEach(function (methodName) { return bean[methodName](); });
            }
        });
        this.destroyed = true;
        this.logger.log('>> ag-Application Context shut down - component is dead');
    };
    return Context;
}());
exports.Context = Context;
// taken from: http://stackoverflow.com/questions/3362471/how-can-i-call-a-javascript-constructor-using-call-or-apply
// allows calling 'apply' on a constructor
function applyToConstructor(constructor, argArray) {
    var args = [null].concat(argArray);
    var factoryFunction = constructor.bind.apply(constructor, args);
    return new factoryFunction();
}
function PostConstruct(target, methodName, descriptor) {
    var props = getOrCreateProps(target);
    if (!props.postConstructMethods) {
        props.postConstructMethods = [];
    }
    props.postConstructMethods.push(methodName);
}
exports.PostConstruct = PostConstruct;
function PreDestroy(target, methodName, descriptor) {
    var props = getOrCreateProps(target);
    if (!props.preDestroyMethods) {
        props.preDestroyMethods = [];
    }
    props.preDestroyMethods.push(methodName);
}
exports.PreDestroy = PreDestroy;
function Bean(beanName) {
    return function (classConstructor) {
        var props = getOrCreateProps(classConstructor.prototype);
        props.beanName = beanName;
    };
}
exports.Bean = Bean;
function Autowired(name) {
    return autowiredFunc.bind(this, name, false);
}
exports.Autowired = Autowired;
function Optional(name) {
    return autowiredFunc.bind(this, name, true);
}
exports.Optional = Optional;
function autowiredFunc(name, optional, classPrototype, methodOrAttributeName, index) {
    if (name === null) {
        console.error('ag-Grid: Autowired name should not be null');
        return;
    }
    if (typeof index === 'number') {
        console.error('ag-Grid: Autowired should be on an attribute');
        return;
    }
    // it's an attribute on the class
    var props = getOrCreateProps(classPrototype);
    if (!props.agClassAttributes) {
        props.agClassAttributes = [];
    }
    props.agClassAttributes.push({
        attributeName: methodOrAttributeName,
        beanName: name,
        optional: optional
    });
}
function Qualifier(name) {
    return function (classPrototype, methodOrAttributeName, index) {
        var props;
        if (typeof index === 'number') {
            // it's a parameter on a method
            var methodName;
            if (methodOrAttributeName) {
                props = getOrCreateProps(classPrototype);
                methodName = methodOrAttributeName;
            }
            else {
                props = getOrCreateProps(classPrototype.prototype);
                methodName = 'agConstructor';
            }
            if (!props.autowireMethods) {
                props.autowireMethods = {};
            }
            if (!props.autowireMethods[methodName]) {
                props.autowireMethods[methodName] = {};
            }
            props.autowireMethods[methodName][index] = name;
        }
    };
}
exports.Qualifier = Qualifier;
function getOrCreateProps(target) {
    var props = target.__agBeanMetaData;
    if (!props) {
        props = {};
        target.__agBeanMetaData = props;
    }
    return props;
}


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/csvCreator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridSerializer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridSerializer.js");
var downloader_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/downloader.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var valueService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/valueService.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var LINE_SEPARATOR = '\r\n';
var CsvSerializingSession = (function (_super) {
    __extends(CsvSerializingSession, _super);
    function CsvSerializingSession(columnController, valueService, gridOptionsWrapper, processCellCallback, processHeaderCallback, suppressQuotes, columnSeparator) {
        _super.call(this, columnController, valueService, gridOptionsWrapper, processCellCallback, processHeaderCallback);
        this.suppressQuotes = suppressQuotes;
        this.columnSeparator = columnSeparator;
        this.result = '';
        this.lineOpened = false;
    }
    CsvSerializingSession.prototype.prepare = function (columnsToExport) {
    };
    CsvSerializingSession.prototype.addCustomHeader = function (customHeader) {
        if (!customHeader)
            return;
        this.result += customHeader + LINE_SEPARATOR;
    };
    CsvSerializingSession.prototype.addCustomFooter = function (customFooter) {
        if (!customFooter)
            return;
        this.result += customFooter + LINE_SEPARATOR;
    };
    CsvSerializingSession.prototype.onNewHeaderGroupingRow = function () {
        if (this.lineOpened)
            this.result += LINE_SEPARATOR;
        return {
            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
        };
    };
    CsvSerializingSession.prototype.onNewHeaderGroupingRowColumn = function (header, index, span) {
        if (index != 0) {
            this.result += this.columnSeparator;
        }
        this.result += header;
        for (var i = 1; i <= span; i++) {
            this.result += this.columnSeparator + this.putInQuotes("", this.suppressQuotes);
        }
        this.lineOpened = true;
    };
    CsvSerializingSession.prototype.onNewHeaderRow = function () {
        if (this.lineOpened)
            this.result += LINE_SEPARATOR;
        return {
            onColumn: this.onNewHeaderRowColumn.bind(this)
        };
    };
    CsvSerializingSession.prototype.onNewHeaderRowColumn = function (column, index, node) {
        if (index != 0) {
            this.result += this.columnSeparator;
        }
        this.result += this.putInQuotes(this.extractHeaderValue(column), this.suppressQuotes);
        this.lineOpened = true;
    };
    CsvSerializingSession.prototype.onNewBodyRow = function () {
        if (this.lineOpened)
            this.result += LINE_SEPARATOR;
        return {
            onColumn: this.onNewBodyRowColumn.bind(this)
        };
    };
    CsvSerializingSession.prototype.onNewBodyRowColumn = function (column, index, node) {
        if (index != 0) {
            this.result += this.columnSeparator;
        }
        this.result += this.putInQuotes(this.extractRowCellValue(column, index, node), this.suppressQuotes);
        this.lineOpened = true;
    };
    CsvSerializingSession.prototype.putInQuotes = function (value, suppressQuotes) {
        if (suppressQuotes) {
            return value;
        }
        if (value === null || value === undefined) {
            return '""';
        }
        var stringValue;
        if (typeof value === 'string') {
            stringValue = value;
        }
        else if (typeof value.toString === 'function') {
            stringValue = value.toString();
        }
        else {
            console.warn('unknown value type during csv conversion');
            stringValue = '';
        }
        // replace each " with "" (ie two sets of double quotes is how to do double quotes in csv)
        var valueEscaped = stringValue.replace(/"/g, "\"\"");
        return '"' + valueEscaped + '"';
    };
    CsvSerializingSession.prototype.parse = function () {
        return this.result;
    };
    return CsvSerializingSession;
}(gridSerializer_1.BaseGridSerializingSession));
exports.CsvSerializingSession = CsvSerializingSession;
var CsvCreator = (function () {
    function CsvCreator() {
    }
    CsvCreator.prototype.exportDataAsCsv = function (params) {
        var fileNamePresent = params && params.fileName && params.fileName.length !== 0;
        var fileName = fileNamePresent ? params.fileName : 'export.csv';
        var dataAsCsv = this.getDataAsCsv(params);
        this.downloader.download(fileName, dataAsCsv, "text/csv;charset=utf-8;");
        return dataAsCsv;
    };
    CsvCreator.prototype.getDataAsCsv = function (params) {
        return this.gridSerializer.serialize(new CsvSerializingSession(this.columnController, this.valueService, this.gridOptionsWrapper, params.processCellCallback, params.processHeaderCallback, params && params.suppressQuotes, (params && params.columnSeparator) || ','), params);
    };
    __decorate([
        context_1.Autowired('downloader'), 
        __metadata('design:type', downloader_1.Downloader)
    ], CsvCreator.prototype, "downloader", void 0);
    __decorate([
        context_1.Autowired('gridSerializer'), 
        __metadata('design:type', gridSerializer_1.GridSerializer)
    ], CsvCreator.prototype, "gridSerializer", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], CsvCreator.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('valueService'), 
        __metadata('design:type', valueService_1.ValueService)
    ], CsvCreator.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], CsvCreator.prototype, "gridOptionsWrapper", void 0);
    CsvCreator = __decorate([
        context_1.Bean('csvCreator'), 
        __metadata('design:paramtypes', [])
    ], CsvCreator);
    return CsvCreator;
}());
exports.CsvCreator = CsvCreator;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/downloader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var Downloader = (function () {
    function Downloader() {
    }
    Downloader.prototype.download = function (fileName, content, mimeType) {
        // for Excel, we need \ufeff at the start
        // http://stackoverflow.com/questions/17879198/adding-utf-8-bom-to-string-blob
        var blobObject = new Blob(["\ufeff", content], {
            type: mimeType
        });
        // Internet Explorer
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blobObject, fileName);
        }
        else {
            // Chrome
            var downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(blobObject);
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };
    Downloader = __decorate([
        context_1.Bean('downloader'), 
        __metadata('design:paramtypes', [])
    ], Downloader);
    return Downloader;
}());
exports.Downloader = Downloader;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/dragAndDrop/dragAndDropService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var svgFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/svgFactory.js");
var dragService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragService.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var svgFactory = svgFactory_1.SvgFactory.getInstance();
(function (DragSourceType) {
    DragSourceType[DragSourceType["ToolPanel"] = 0] = "ToolPanel";
    DragSourceType[DragSourceType["HeaderCell"] = 1] = "HeaderCell";
})(exports.DragSourceType || (exports.DragSourceType = {}));
var DragSourceType = exports.DragSourceType;
(function (VDirection) {
    VDirection[VDirection["Up"] = 0] = "Up";
    VDirection[VDirection["Down"] = 1] = "Down";
})(exports.VDirection || (exports.VDirection = {}));
var VDirection = exports.VDirection;
(function (HDirection) {
    HDirection[HDirection["Left"] = 0] = "Left";
    HDirection[HDirection["Right"] = 1] = "Right";
})(exports.HDirection || (exports.HDirection = {}));
var HDirection = exports.HDirection;
var DragAndDropService = (function () {
    function DragAndDropService() {
        this.dragSourceAndParamsList = [];
        this.dropTargets = [];
    }
    DragAndDropService.prototype.init = function () {
        this.ePinnedIcon = utils_1.Utils.createIcon('columnMovePin', this.gridOptionsWrapper, null, svgFactory.createPinIcon);
        this.ePlusIcon = utils_1.Utils.createIcon('columnMoveAdd', this.gridOptionsWrapper, null, svgFactory.createPlusIcon);
        this.eHiddenIcon = utils_1.Utils.createIcon('columnMoveHide', this.gridOptionsWrapper, null, svgFactory.createColumnHiddenIcon);
        this.eMoveIcon = utils_1.Utils.createIcon('columnMoveMove', this.gridOptionsWrapper, null, svgFactory.createMoveIcon);
        this.eLeftIcon = utils_1.Utils.createIcon('columnMoveLeft', this.gridOptionsWrapper, null, svgFactory.createLeftIcon);
        this.eRightIcon = utils_1.Utils.createIcon('columnMoveRight', this.gridOptionsWrapper, null, svgFactory.createRightIcon);
        this.eGroupIcon = utils_1.Utils.createIcon('columnMoveGroup', this.gridOptionsWrapper, null, svgFactory.createGroupIcon);
        this.eAggregateIcon = utils_1.Utils.createIcon('columnMoveValue', this.gridOptionsWrapper, null, svgFactory.createAggregationIcon);
        this.ePivotIcon = utils_1.Utils.createIcon('columnMovePivot', this.gridOptionsWrapper, null, svgFactory.createPivotIcon);
        this.eDropNotAllowedIcon = utils_1.Utils.createIcon('dropNotAllowed', this.gridOptionsWrapper, null, svgFactory.createDropNotAllowedIcon);
    };
    DragAndDropService.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('OldToolPanelDragAndDropService');
    };
    DragAndDropService.prototype.addDragSource = function (dragSource, allowTouch) {
        if (allowTouch === void 0) { allowTouch = false; }
        var params = {
            eElement: dragSource.eElement,
            onDragStart: this.onDragStart.bind(this, dragSource),
            onDragStop: this.onDragStop.bind(this),
            onDragging: this.onDragging.bind(this)
        };
        this.dragSourceAndParamsList.push({ params: params, dragSource: dragSource });
        this.dragService.addDragSource(params, allowTouch);
    };
    DragAndDropService.prototype.removeDragSource = function (dragSource) {
        var sourceAndParams = utils_1.Utils.find(this.dragSourceAndParamsList, function (item) { return item.dragSource === dragSource; });
        if (sourceAndParams) {
            this.dragService.removeDragSource(sourceAndParams.params);
            utils_1.Utils.removeFromArray(this.dragSourceAndParamsList, sourceAndParams);
        }
    };
    DragAndDropService.prototype.destroy = function () {
        var _this = this;
        this.dragSourceAndParamsList.forEach(function (sourceAndParams) {
            _this.dragService.removeDragSource(sourceAndParams.params);
        });
        this.dragSourceAndParamsList.length = 0;
    };
    DragAndDropService.prototype.nudge = function () {
        if (this.dragging) {
            this.onDragging(this.eventLastTime, true);
        }
    };
    DragAndDropService.prototype.onDragStart = function (dragSource, mouseEvent) {
        this.dragging = true;
        this.dragSource = dragSource;
        this.eventLastTime = mouseEvent;
        this.dragSource.dragItem.forEach(function (column) { return column.setMoving(true); });
        this.dragItem = this.dragSource.dragItem;
        this.lastDropTarget = this.dragSource.dragSourceDropTarget;
        this.createGhost();
    };
    DragAndDropService.prototype.onDragStop = function (mouseEvent) {
        this.eventLastTime = null;
        this.dragging = false;
        this.dragItem.forEach(function (column) { return column.setMoving(false); });
        if (this.lastDropTarget && this.lastDropTarget.onDragStop) {
            var draggingEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, null, null, false);
            this.lastDropTarget.onDragStop(draggingEvent);
        }
        this.lastDropTarget = null;
        this.dragItem = null;
        this.removeGhost();
    };
    DragAndDropService.prototype.onDragging = function (mouseEvent, fromNudge) {
        var hDirection = this.workOutHDirection(mouseEvent);
        var vDirection = this.workOutVDirection(mouseEvent);
        this.eventLastTime = mouseEvent;
        this.positionGhost(mouseEvent);
        // check if mouseEvent intersects with any of the drop targets
        var dropTarget = utils_1.Utils.find(this.dropTargets, this.isMouseOnDropTarget.bind(this, mouseEvent));
        if (dropTarget !== this.lastDropTarget) {
            this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
            this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            this.lastDropTarget = dropTarget;
        }
        else if (dropTarget) {
            var draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragging(draggingEvent);
        }
    };
    DragAndDropService.prototype.enterDragTargetIfExists = function (dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
        if (!dropTarget) {
            return;
        }
        var dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
        dropTarget.onDragEnter(dragEnterEvent);
        this.setGhostIcon(dropTarget.getIconName ? dropTarget.getIconName() : null);
    };
    DragAndDropService.prototype.leaveLastTargetIfExists = function (mouseEvent, hDirection, vDirection, fromNudge) {
        if (!this.lastDropTarget) {
            return;
        }
        var dragLeaveEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
        this.lastDropTarget.onDragLeave(dragLeaveEvent);
        this.setGhostIcon(null);
    };
    DragAndDropService.prototype.getAllContainersFromDropTarget = function (dropTarget) {
        var containers = [dropTarget.getContainer()];
        var secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
        if (secondaryContainers) {
            containers = containers.concat(secondaryContainers);
        }
        return containers;
    };
    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
    DragAndDropService.prototype.isMouseOnDropTarget = function (mouseEvent, dropTarget) {
        var allContainers = this.getAllContainersFromDropTarget(dropTarget);
        var gotMatch = false;
        allContainers.forEach(function (eContainer) {
            if (!eContainer) {
                return;
            } // secondary can be missing
            var rect = eContainer.getBoundingClientRect();
            // if element is not visible, then width and height are zero
            if (rect.width === 0 || rect.height === 0) {
                return;
            }
            var horizontalFit = mouseEvent.clientX >= rect.left && mouseEvent.clientX <= rect.right;
            var verticalFit = mouseEvent.clientY >= rect.top && mouseEvent.clientY <= rect.bottom;
            //console.log(`rect.width = ${rect.width} || rect.height = ${rect.height} ## verticalFit = ${verticalFit}, horizontalFit = ${horizontalFit}, `);
            if (horizontalFit && verticalFit) {
                gotMatch = true;
            }
        });
        return gotMatch;
    };
    DragAndDropService.prototype.addDropTarget = function (dropTarget) {
        this.dropTargets.push(dropTarget);
    };
    DragAndDropService.prototype.workOutHDirection = function (event) {
        if (this.eventLastTime.clientX > event.clientX) {
            return HDirection.Left;
        }
        else if (this.eventLastTime.clientX < event.clientX) {
            return HDirection.Right;
        }
        else {
            return null;
        }
    };
    DragAndDropService.prototype.workOutVDirection = function (event) {
        if (this.eventLastTime.clientY > event.clientY) {
            return VDirection.Up;
        }
        else if (this.eventLastTime.clientY < event.clientY) {
            return VDirection.Down;
        }
        else {
            return null;
        }
    };
    DragAndDropService.prototype.createDropTargetEvent = function (dropTarget, event, hDirection, vDirection, fromNudge) {
        // localise x and y to the target component
        var rect = dropTarget.getContainer().getBoundingClientRect();
        var x = event.clientX - rect.left;
        var y = event.clientY - rect.top;
        var dropTargetEvent = {
            event: event,
            x: x,
            y: y,
            vDirection: vDirection,
            hDirection: hDirection,
            dragSource: this.dragSource,
            fromNudge: fromNudge
        };
        return dropTargetEvent;
    };
    DragAndDropService.prototype.positionGhost = function (event) {
        var ghostRect = this.eGhost.getBoundingClientRect();
        var ghostHeight = ghostRect.height;
        // for some reason, without the '-2', it still overlapped by 1 or 2 pixels, which
        // then brought in scrollbars to the browser. no idea why, but putting in -2 here
        // works around it which is good enough for me.
        var browserWidth = utils_1.Utils.getBodyWidth() - 2;
        var browserHeight = utils_1.Utils.getBodyHeight() - 2;
        // put ghost vertically in middle of cursor
        var top = event.pageY - (ghostHeight / 2);
        // horizontally, place cursor just right of icon
        var left = event.pageX - 30;
        var usrDocument = this.gridOptionsWrapper.getDocument();
        var windowScrollY = window.pageYOffset || usrDocument.documentElement.scrollTop;
        var windowScrollX = window.pageXOffset || usrDocument.documentElement.scrollLeft;
        // check ghost is not positioned outside of the browser
        if (browserWidth > 0) {
            if ((left + this.eGhost.clientWidth) > (browserWidth + windowScrollX)) {
                left = browserWidth + windowScrollX - this.eGhost.clientWidth;
            }
        }
        if (left < 0) {
            left = 0;
        }
        if (browserHeight > 0) {
            if ((top + this.eGhost.clientHeight) > (browserHeight + windowScrollY)) {
                top = browserHeight + windowScrollY - this.eGhost.clientHeight;
            }
        }
        if (top < 0) {
            top = 0;
        }
        this.eGhost.style.left = left + 'px';
        this.eGhost.style.top = top + 'px';
    };
    DragAndDropService.prototype.removeGhost = function () {
        if (this.eGhost && this.eGhostParent) {
            this.eGhostParent.removeChild(this.eGhost);
        }
        this.eGhost = null;
    };
    DragAndDropService.prototype.createGhost = function () {
        this.eGhost = utils_1.Utils.loadTemplate(DragAndDropService.GHOST_TEMPLATE);
        this.eGhostIcon = this.eGhost.querySelector('.ag-dnd-ghost-icon');
        this.setGhostIcon(null);
        var eText = this.eGhost.querySelector('.ag-dnd-ghost-label');
        eText.innerHTML = this.dragSource.dragItemName;
        this.eGhost.style.height = this.gridOptionsWrapper.getHeaderHeight() + 'px';
        this.eGhost.style.top = '20px';
        this.eGhost.style.left = '20px';
        var usrDocument = this.gridOptionsWrapper.getDocument();
        this.eGhostParent = usrDocument.querySelector('body');
        if (!this.eGhostParent) {
            console.warn('ag-Grid: could not find document body, it is needed for dragging columns');
        }
        else {
            this.eGhostParent.appendChild(this.eGhost);
        }
    };
    DragAndDropService.prototype.setGhostIcon = function (iconName, shake) {
        if (shake === void 0) { shake = false; }
        utils_1.Utils.removeAllChildren(this.eGhostIcon);
        var eIcon;
        switch (iconName) {
            case DragAndDropService.ICON_ADD:
                eIcon = this.ePlusIcon;
                break;
            case DragAndDropService.ICON_PINNED:
                eIcon = this.ePinnedIcon;
                break;
            case DragAndDropService.ICON_MOVE:
                eIcon = this.eMoveIcon;
                break;
            case DragAndDropService.ICON_LEFT:
                eIcon = this.eLeftIcon;
                break;
            case DragAndDropService.ICON_RIGHT:
                eIcon = this.eRightIcon;
                break;
            case DragAndDropService.ICON_GROUP:
                eIcon = this.eGroupIcon;
                break;
            case DragAndDropService.ICON_AGGREGATE:
                eIcon = this.eAggregateIcon;
                break;
            case DragAndDropService.ICON_PIVOT:
                eIcon = this.ePivotIcon;
                break;
            case DragAndDropService.ICON_NOT_ALLOWED:
                eIcon = this.eDropNotAllowedIcon;
                break;
            default:
                eIcon = this.eHiddenIcon;
                break;
        }
        this.eGhostIcon.appendChild(eIcon);
        utils_1.Utils.addOrRemoveCssClass(this.eGhostIcon, 'ag-shake-left-to-right', shake);
    };
    DragAndDropService.ICON_PINNED = 'pinned';
    DragAndDropService.ICON_ADD = 'add';
    DragAndDropService.ICON_MOVE = 'move';
    DragAndDropService.ICON_LEFT = 'left';
    DragAndDropService.ICON_RIGHT = 'right';
    DragAndDropService.ICON_GROUP = 'group';
    DragAndDropService.ICON_AGGREGATE = 'aggregate';
    DragAndDropService.ICON_PIVOT = 'pivot';
    DragAndDropService.ICON_NOT_ALLOWED = 'notAllowed';
    DragAndDropService.GHOST_TEMPLATE = '<div class="ag-dnd-ghost">' +
        '  <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>' +
        '  <div class="ag-dnd-ghost-label">' +
        '  </div>' +
        '</div>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], DragAndDropService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('dragService'), 
        __metadata('design:type', dragService_1.DragService)
    ], DragAndDropService.prototype, "dragService", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], DragAndDropService.prototype, "columnController", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], DragAndDropService.prototype, "init", null);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory]), 
        __metadata('design:returntype', void 0)
    ], DragAndDropService.prototype, "setBeans", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], DragAndDropService.prototype, "destroy", null);
    DragAndDropService = __decorate([
        context_1.Bean('dragAndDropService'), 
        __metadata('design:paramtypes', [])
    ], DragAndDropService);
    return DragAndDropService;
}());
exports.DragAndDropService = DragAndDropService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/dragAndDrop/dragService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
/** Adds drag listening onto an element. In ag-Grid this is used twice, first is resizing columns,
 * second is moving the columns and column groups around (ie the 'drag' part of Drag and Drop. */
var DragService = (function () {
    function DragService() {
        this.onMouseUpListener = this.onMouseUp.bind(this);
        this.onMouseMoveListener = this.onMouseMove.bind(this);
        this.onTouchEndListener = this.onTouchUp.bind(this);
        this.onTouchMoveListener = this.onTouchMove.bind(this);
        this.dragEndFunctions = [];
        this.dragSources = [];
    }
    DragService.prototype.init = function () {
        this.logger = this.loggerFactory.create('DragService');
    };
    DragService.prototype.destroy = function () {
        this.dragSources.forEach(this.removeListener.bind(this));
        this.dragSources.length = 0;
    };
    DragService.prototype.removeListener = function (dragSourceAndListener) {
        var element = dragSourceAndListener.dragSource.eElement;
        var mouseDownListener = dragSourceAndListener.mouseDownListener;
        element.removeEventListener('mousedown', mouseDownListener);
        // remove touch listener only if it exists
        if (dragSourceAndListener.touchEnabled) {
            var touchStartListener = dragSourceAndListener.touchStartListener;
            element.removeEventListener('touchstart', touchStartListener);
        }
    };
    DragService.prototype.removeDragSource = function (params) {
        var dragSourceAndListener = utils_1.Utils.find(this.dragSources, function (item) { return item.dragSource === params; });
        if (!dragSourceAndListener) {
            return;
        }
        this.removeListener(dragSourceAndListener);
        utils_1.Utils.removeFromArray(this.dragSources, dragSourceAndListener);
    };
    DragService.prototype.setNoSelectToBody = function (noSelect) {
        var usrDocument = this.gridOptionsWrapper.getDocument();
        var eBody = usrDocument.querySelector('body');
        if (utils_1.Utils.exists(eBody)) {
            utils_1.Utils.addOrRemoveCssClass(eBody, 'ag-body-no-select', noSelect);
        }
    };
    DragService.prototype.addDragSource = function (params, includeTouch) {
        if (includeTouch === void 0) { includeTouch = false; }
        var mouseListener = this.onMouseDown.bind(this, params);
        params.eElement.addEventListener('mousedown', mouseListener);
        var touchListener = null;
        var suppressTouch = this.gridOptionsWrapper.isSuppressTouch();
        var reallyIncludeTouch = includeTouch && !suppressTouch;
        if (reallyIncludeTouch) {
            touchListener = this.onTouchStart.bind(this, params);
            params.eElement.addEventListener('touchstart', touchListener);
        }
        this.dragSources.push({
            dragSource: params,
            mouseDownListener: mouseListener,
            touchStartListener: touchListener,
            touchEnabled: includeTouch
        });
    };
    // gets called whenever mouse down on any drag source
    DragService.prototype.onTouchStart = function (params, touchEvent) {
        var _this = this;
        this.currentDragParams = params;
        this.dragging = false;
        var touch = touchEvent.touches[0];
        this.touchLastTime = touch;
        this.touchStart = touch;
        touchEvent.preventDefault();
        // we temporally add these listeners, for the duration of the drag, they
        // are removed in touch end handling.
        params.eElement.addEventListener('touchmove', this.onTouchMoveListener);
        params.eElement.addEventListener('touchend', this.onTouchEndListener);
        params.eElement.addEventListener('touchcancel', this.onTouchEndListener);
        this.dragEndFunctions.push(function () {
            params.eElement.removeEventListener('touchmove', _this.onTouchMoveListener);
            params.eElement.removeEventListener('touchend', _this.onTouchEndListener);
            params.eElement.removeEventListener('touchcancel', _this.onTouchEndListener);
        });
        // see if we want to start dragging straight away
        if (params.dragStartPixels === 0) {
            this.onCommonMove(touch, this.touchStart);
        }
    };
    // gets called whenever mouse down on any drag source
    DragService.prototype.onMouseDown = function (params, mouseEvent) {
        var _this = this;
        // only interested in left button clicks
        if (mouseEvent.button !== 0) {
            return;
        }
        this.currentDragParams = params;
        this.dragging = false;
        this.mouseEventLastTime = mouseEvent;
        this.mouseStartEvent = mouseEvent;
        var usrDocument = this.gridOptionsWrapper.getDocument();
        // we temporally add these listeners, for the duration of the drag, they
        // are removed in mouseup handling.
        usrDocument.addEventListener('mousemove', this.onMouseMoveListener);
        usrDocument.addEventListener('mouseup', this.onMouseUpListener);
        this.dragEndFunctions.push(function () {
            usrDocument.removeEventListener('mousemove', _this.onMouseMoveListener);
            usrDocument.removeEventListener('mouseup', _this.onMouseUpListener);
        });
        // see if we want to start dragging straight away
        if (params.dragStartPixels === 0) {
            this.onMouseMove(mouseEvent);
        }
    };
    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
    DragService.prototype.isEventNearStartEvent = function (currentEvent, startEvent) {
        // by default, we wait 4 pixels before starting the drag
        var requiredPixelDiff = utils_1.Utils.exists(this.currentDragParams.dragStartPixels) ? this.currentDragParams.dragStartPixels : 4;
        return utils_1.Utils.areEventsNear(currentEvent, startEvent, requiredPixelDiff);
    };
    DragService.prototype.getFirstActiveTouch = function (touchList) {
        for (var i = 0; i < touchList.length; i++) {
            var matches = touchList[i].identifier === this.touchStart.identifier;
            if (matches) {
                return touchList[i];
            }
        }
        return null;
    };
    DragService.prototype.onCommonMove = function (currentEvent, startEvent) {
        if (!this.dragging) {
            // if mouse hasn't travelled from the start position enough, do nothing
            var toEarlyToDrag = !this.dragging && this.isEventNearStartEvent(currentEvent, startEvent);
            if (toEarlyToDrag) {
                return;
            }
            else {
                // alert(`started`);
                this.dragging = true;
                this.eventService.dispatchEvent(events_1.Events.EVENT_DRAG_STARTED);
                this.currentDragParams.onDragStart(startEvent);
                this.setNoSelectToBody(true);
            }
        }
        this.currentDragParams.onDragging(currentEvent);
    };
    DragService.prototype.onTouchMove = function (touchEvent) {
        var touch = this.getFirstActiveTouch(touchEvent.touches);
        if (!touch) {
            return;
        }
        // this.___statusBar.setInfoText(Math.random() + ' onTouchMove preventDefault stopPropagation');
        this.onCommonMove(touch, this.touchStart);
    };
    // only gets called after a mouse down - as this is only added after mouseDown
    // and is removed when mouseUp happens
    DragService.prototype.onMouseMove = function (mouseEvent) {
        this.onCommonMove(mouseEvent, this.mouseStartEvent);
    };
    DragService.prototype.onTouchUp = function (touchEvent) {
        var touch = this.getFirstActiveTouch(touchEvent.targetTouches);
        // i haven't worked this out yet, but there is no matching touch
        // when we get the touch up event. to get around this, we swap in
        // the last touch. this is a hack to 'get it working' while we
        // figure out what's going on, why we are not getting a touch in
        // current event.
        if (!touch) {
            touch = this.touchLastTime;
        }
        // if mouse was left up before we started to move, then this is a tap.
        // we check this before onUpCommon as onUpCommon resets the dragging
        // var tap = !this.dragging;
        // var tapTarget = this.currentDragParams.eElement;
        this.onUpCommon(touch);
        // if tap, tell user
        // console.log(`${Math.random()} tap = ${tap}`);
        // if (tap) {
        //     tapTarget.click();
        // }
    };
    DragService.prototype.onMouseUp = function (mouseEvent) {
        this.onUpCommon(mouseEvent);
    };
    DragService.prototype.onUpCommon = function (eventOrTouch) {
        if (this.dragging) {
            this.dragging = false;
            this.currentDragParams.onDragStop(eventOrTouch);
            this.eventService.dispatchEvent(events_1.Events.EVENT_DRAG_STOPPED);
        }
        this.setNoSelectToBody(false);
        this.mouseStartEvent = null;
        this.mouseEventLastTime = null;
        this.touchStart = null;
        this.touchLastTime = null;
        this.currentDragParams = null;
        this.dragEndFunctions.forEach(function (func) { return func(); });
        this.dragEndFunctions.length = 0;
    };
    __decorate([
        context_1.Autowired('loggerFactory'), 
        __metadata('design:type', logger_1.LoggerFactory)
    ], DragService.prototype, "loggerFactory", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], DragService.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], DragService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], DragService.prototype, "init", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], DragService.prototype, "destroy", null);
    DragService = __decorate([
        context_1.Bean('dragService'), 
        __metadata('design:paramtypes', [])
    ], DragService);
    return DragService;
}());
exports.DragService = DragService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/entities/column.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnUtils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnUtils.js");
// Wrapper around a user provide column definition. The grid treats the column definition as ready only.
// This class contains all the runtime information about a column, plus some logic (the definition has no logic).
// This class implements both interfaces ColumnGroupChild and OriginalColumnGroupChild as the class can
// appear as a child of either the original tree or the displayed tree. However the relevant group classes
// for each type only implements one, as each group can only appear in it's associated tree (eg OriginalColumnGroup
// can only appear in OriginalColumn tree).
var Column = (function () {
    function Column(colDef, colId, primary) {
        this.moving = false;
        this.filterActive = false;
        this.eventService = new eventService_1.EventService();
        this.rowGroupActive = false;
        this.pivotActive = false;
        this.aggregationActive = false;
        this.colDef = colDef;
        this.visible = !colDef.hide;
        this.sort = colDef.sort;
        this.sortedAt = colDef.sortedAt;
        this.colId = colId;
        this.primary = primary;
    }
    Column.prototype.setParent = function (parent) {
        this.parent = parent;
    };
    Column.prototype.getParent = function () {
        return this.parent;
    };
    // this is done after constructor as it uses gridOptionsWrapper
    Column.prototype.initialise = function () {
        this.floatingCellRenderer = this.frameworkFactory.colDefFloatingCellRenderer(this.colDef);
        this.cellRenderer = this.frameworkFactory.colDefCellRenderer(this.colDef);
        this.cellEditor = this.frameworkFactory.colDefCellEditor(this.colDef);
        this.filter = this.frameworkFactory.colDefFilter(this.colDef);
        this.setPinned(this.colDef.pinned);
        var minColWidth = this.gridOptionsWrapper.getMinColWidth();
        var maxColWidth = this.gridOptionsWrapper.getMaxColWidth();
        if (this.colDef.minWidth) {
            this.minWidth = this.colDef.minWidth;
        }
        else {
            this.minWidth = minColWidth;
        }
        if (this.colDef.maxWidth) {
            this.maxWidth = this.colDef.maxWidth;
        }
        else {
            this.maxWidth = maxColWidth;
        }
        this.actualWidth = this.columnUtils.calculateColInitialWidth(this.colDef);
        var suppressDotNotation = this.gridOptionsWrapper.isSuppressFieldDotNotation();
        this.fieldContainsDots = utils_1.Utils.exists(this.colDef.field) && this.colDef.field.indexOf('.') >= 0 && !suppressDotNotation;
        this.tooltipFieldContainsDots = utils_1.Utils.exists(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf('.') >= 0 && !suppressDotNotation;
        this.validate();
    };
    Column.prototype.getCellRenderer = function () {
        return this.cellRenderer;
    };
    Column.prototype.getCellEditor = function () {
        return this.cellEditor;
    };
    Column.prototype.getFloatingCellRenderer = function () {
        return this.floatingCellRenderer;
    };
    Column.prototype.getFilter = function () {
        return this.filter;
    };
    Column.prototype.getUniqueId = function () {
        return this.getId();
    };
    Column.prototype.isPrimary = function () {
        return this.primary;
    };
    Column.prototype.isFilterAllowed = function () {
        return this.primary && !this.colDef.suppressFilter;
    };
    Column.prototype.isFieldContainsDots = function () {
        return this.fieldContainsDots;
    };
    Column.prototype.isTooltipFieldContainsDots = function () {
        return this.tooltipFieldContainsDots;
    };
    Column.prototype.validate = function () {
        if (!this.gridOptionsWrapper.isEnterprise()) {
            if (utils_1.Utils.exists(this.colDef.aggFunc)) {
                console.warn('ag-Grid: aggFunc is only valid in ag-Grid-Enterprise');
            }
            if (utils_1.Utils.exists(this.colDef.rowGroupIndex)) {
                console.warn('ag-Grid: rowGroupIndex is only valid in ag-Grid-Enterprise');
            }
        }
        if (utils_1.Utils.exists(this.colDef.width) && typeof this.colDef.width !== 'number') {
            console.warn('ag-Grid: colDef.width should be a number, not ' + typeof this.colDef.width);
        }
    };
    Column.prototype.addEventListener = function (eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    };
    Column.prototype.removeEventListener = function (eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    };
    Column.prototype.createIsColumnFuncParams = function (rowNode) {
        return {
            node: rowNode,
            column: this,
            colDef: this.colDef,
            context: this.gridOptionsWrapper.getContext(),
            api: this.gridOptionsWrapper.getApi(),
            columnApi: this.gridOptionsWrapper.getColumnApi()
        };
    };
    Column.prototype.isSuppressNavigable = function (rowNode) {
        // if boolean set, then just use it
        if (typeof this.colDef.suppressNavigable === 'boolean') {
            return this.colDef.suppressNavigable;
        }
        // if function, then call the function to find out
        if (typeof this.colDef.suppressNavigable === 'function') {
            var params = this.createIsColumnFuncParams(rowNode);
            var suppressNaviableFunc = this.colDef.suppressNavigable;
            return suppressNaviableFunc(params);
        }
        return false;
    };
    Column.prototype.isCellEditable = function (rowNode) {
        // if boolean set, then just use it
        if (typeof this.colDef.editable === 'boolean') {
            return this.colDef.editable;
        }
        // if function, then call the function to find out
        if (typeof this.colDef.editable === 'function') {
            var params = this.createIsColumnFuncParams(rowNode);
            var editableFunc = this.colDef.editable;
            return editableFunc(params);
        }
        return false;
    };
    Column.prototype.setMoving = function (moving) {
        this.moving = moving;
        this.eventService.dispatchEvent(Column.EVENT_MOVING_CHANGED);
    };
    Column.prototype.isMoving = function () {
        return this.moving;
    };
    Column.prototype.getSort = function () {
        return this.sort;
    };
    Column.prototype.setSort = function (sort) {
        if (this.sort !== sort) {
            this.sort = sort;
            this.eventService.dispatchEvent(Column.EVENT_SORT_CHANGED);
        }
    };
    Column.prototype.isSortAscending = function () {
        return this.sort === Column.SORT_ASC;
    };
    Column.prototype.isSortDescending = function () {
        return this.sort === Column.SORT_DESC;
    };
    Column.prototype.isSortNone = function () {
        return utils_1.Utils.missing(this.sort);
    };
    Column.prototype.getSortedAt = function () {
        return this.sortedAt;
    };
    Column.prototype.setSortedAt = function (sortedAt) {
        this.sortedAt = sortedAt;
    };
    Column.prototype.setAggFunc = function (aggFunc) {
        this.aggFunc = aggFunc;
    };
    Column.prototype.getAggFunc = function () {
        return this.aggFunc;
    };
    Column.prototype.getLeft = function () {
        return this.left;
    };
    Column.prototype.getRight = function () {
        return this.left + this.actualWidth;
    };
    Column.prototype.setLeft = function (left) {
        if (this.left !== left) {
            this.left = left;
            this.eventService.dispatchEvent(Column.EVENT_LEFT_CHANGED);
        }
    };
    Column.prototype.isFilterActive = function () {
        return this.filterActive;
    };
    Column.prototype.setFilterActive = function (active) {
        if (this.filterActive !== active) {
            this.filterActive = active;
            this.eventService.dispatchEvent(Column.EVENT_FILTER_CHANGED);
        }
    };
    Column.prototype.setPinned = function (pinned) {
        // pinning is not allowed when doing 'forPrint'
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        if (pinned === true || pinned === Column.PINNED_LEFT) {
            this.pinned = Column.PINNED_LEFT;
        }
        else if (pinned === Column.PINNED_RIGHT) {
            this.pinned = Column.PINNED_RIGHT;
        }
        else {
            this.pinned = null;
        }
        // console.log(`setColumnsPinned ${this.getColId()} ${this.pinned}`);
    };
    Column.prototype.setFirstRightPinned = function (firstRightPinned) {
        if (this.firstRightPinned !== firstRightPinned) {
            this.firstRightPinned = firstRightPinned;
            this.eventService.dispatchEvent(Column.EVENT_FIRST_RIGHT_PINNED_CHANGED);
        }
    };
    Column.prototype.setLastLeftPinned = function (lastLeftPinned) {
        if (this.lastLeftPinned !== lastLeftPinned) {
            this.lastLeftPinned = lastLeftPinned;
            this.eventService.dispatchEvent(Column.EVENT_LAST_LEFT_PINNED_CHANGED);
        }
    };
    Column.prototype.isFirstRightPinned = function () {
        return this.firstRightPinned;
    };
    Column.prototype.isLastLeftPinned = function () {
        return this.lastLeftPinned;
    };
    Column.prototype.isPinned = function () {
        return this.pinned === Column.PINNED_LEFT || this.pinned === Column.PINNED_RIGHT;
    };
    Column.prototype.isPinnedLeft = function () {
        return this.pinned === Column.PINNED_LEFT;
    };
    Column.prototype.isPinnedRight = function () {
        return this.pinned === Column.PINNED_RIGHT;
    };
    Column.prototype.getPinned = function () {
        return this.pinned;
    };
    Column.prototype.setVisible = function (visible) {
        var newValue = visible === true;
        if (this.visible !== newValue) {
            this.visible = newValue;
            this.eventService.dispatchEvent(Column.EVENT_VISIBLE_CHANGED);
        }
    };
    Column.prototype.isVisible = function () {
        return this.visible;
    };
    Column.prototype.getColDef = function () {
        return this.colDef;
    };
    Column.prototype.getColumnGroupShow = function () {
        return this.colDef.columnGroupShow;
    };
    Column.prototype.getColId = function () {
        return this.colId;
    };
    Column.prototype.getId = function () {
        return this.getColId();
    };
    Column.prototype.getDefinition = function () {
        return this.colDef;
    };
    Column.prototype.getActualWidth = function () {
        return this.actualWidth;
    };
    Column.prototype.setActualWidth = function (actualWidth) {
        if (this.actualWidth !== actualWidth) {
            this.actualWidth = actualWidth;
            this.eventService.dispatchEvent(Column.EVENT_WIDTH_CHANGED);
        }
    };
    Column.prototype.isGreaterThanMax = function (width) {
        if (this.maxWidth) {
            return width > this.maxWidth;
        }
        else {
            return false;
        }
    };
    Column.prototype.getMinWidth = function () {
        return this.minWidth;
    };
    Column.prototype.getMaxWidth = function () {
        return this.maxWidth;
    };
    Column.prototype.setMinimum = function () {
        this.setActualWidth(this.minWidth);
    };
    Column.prototype.setRowGroupActive = function (rowGroup) {
        if (this.rowGroupActive !== rowGroup) {
            this.rowGroupActive = rowGroup;
            this.eventService.dispatchEvent(Column.EVENT_ROW_GROUP_CHANGED, this);
        }
    };
    Column.prototype.isRowGroupActive = function () {
        return this.rowGroupActive;
    };
    Column.prototype.setPivotActive = function (pivot) {
        if (this.pivotActive !== pivot) {
            this.pivotActive = pivot;
            this.eventService.dispatchEvent(Column.EVENT_PIVOT_CHANGED, this);
        }
    };
    Column.prototype.isPivotActive = function () {
        return this.pivotActive;
    };
    Column.prototype.isAnyFunctionActive = function () {
        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    };
    Column.prototype.isAnyFunctionAllowed = function () {
        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    };
    Column.prototype.setValueActive = function (value) {
        if (this.aggregationActive !== value) {
            this.aggregationActive = value;
            this.eventService.dispatchEvent(Column.EVENT_VALUE_CHANGED, this);
        }
    };
    Column.prototype.isValueActive = function () {
        return this.aggregationActive;
    };
    Column.prototype.isAllowPivot = function () {
        return this.colDef.enablePivot === true;
    };
    Column.prototype.isAllowValue = function () {
        return this.colDef.enableValue === true;
    };
    Column.prototype.isAllowRowGroup = function () {
        return this.colDef.enableRowGroup === true;
    };
    // + renderedHeaderCell - for making header cell transparent when moving
    Column.EVENT_MOVING_CHANGED = 'movingChanged';
    // + renderedCell - changing left position
    Column.EVENT_LEFT_CHANGED = 'leftChanged';
    // + renderedCell - changing width
    Column.EVENT_WIDTH_CHANGED = 'widthChanged';
    // + renderedCell - for changing pinned classes
    Column.EVENT_LAST_LEFT_PINNED_CHANGED = 'lastLeftPinnedChanged';
    Column.EVENT_FIRST_RIGHT_PINNED_CHANGED = 'firstRightPinnedChanged';
    // + renderedColumn - for changing visibility icon
    Column.EVENT_VISIBLE_CHANGED = 'visibleChanged';
    // + renderedHeaderCell - marks the header with filter icon
    Column.EVENT_FILTER_CHANGED = 'filterChanged';
    // + renderedHeaderCell - marks the header with sort icon
    Column.EVENT_SORT_CHANGED = 'sortChanged';
    // + toolpanel, for gui updates
    Column.EVENT_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
    // + toolpanel, for gui updates
    Column.EVENT_PIVOT_CHANGED = 'columnPivotChanged';
    // + toolpanel, for gui updates
    Column.EVENT_VALUE_CHANGED = 'columnValueChanged';
    Column.PINNED_RIGHT = 'right';
    Column.PINNED_LEFT = 'left';
    Column.SORT_ASC = 'asc';
    Column.SORT_DESC = 'desc';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], Column.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnUtils'), 
        __metadata('design:type', columnUtils_1.ColumnUtils)
    ], Column.prototype, "columnUtils", void 0);
    __decorate([
        context_1.Autowired('frameworkFactory'), 
        __metadata('design:type', Object)
    ], Column.prototype, "frameworkFactory", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], Column.prototype, "initialise", null);
    return Column;
}());
exports.Column = Column;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/entities/columnGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var ColumnGroup = (function () {
    function ColumnGroup(originalColumnGroup, groupId, instanceId) {
        // depends on the open/closed state of the group, only displaying columns are stored here
        this.displayedChildren = [];
        this.moving = false;
        this.eventService = new eventService_1.EventService();
        this.groupId = groupId;
        this.instanceId = instanceId;
        this.originalColumnGroup = originalColumnGroup;
    }
    ColumnGroup.prototype.getParent = function () {
        return this.parent;
    };
    ColumnGroup.prototype.setParent = function (parent) {
        this.parent = parent;
    };
    ColumnGroup.prototype.getUniqueId = function () {
        return this.groupId + '_' + this.instanceId;
    };
    ColumnGroup.prototype.checkLeft = function () {
        // first get all children to setLeft, as it impacts our decision below
        this.displayedChildren.forEach(function (child) {
            if (child instanceof ColumnGroup) {
                child.checkLeft();
            }
        });
        // set our left based on first displayed column
        if (this.displayedChildren.length > 0) {
            if (this.gridOptionsWrapper.isEnableRtl()) {
                var lastChild = this.displayedChildren[this.displayedChildren.length - 1];
                var lastChildLeft = lastChild.getLeft();
                this.setLeft(lastChildLeft);
            }
            else {
                var firstChildLeft = this.displayedChildren[0].getLeft();
                this.setLeft(firstChildLeft);
            }
        }
        else {
            // this should never happen, as if we have no displayed columns, then
            // this groups should not even exist.
            this.setLeft(null);
        }
    };
    ColumnGroup.prototype.getLeft = function () {
        return this.left;
    };
    ColumnGroup.prototype.setLeft = function (left) {
        if (this.left !== left) {
            this.left = left;
            this.eventService.dispatchEvent(ColumnGroup.EVENT_LEFT_CHANGED);
        }
    };
    ColumnGroup.prototype.addEventListener = function (eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    };
    ColumnGroup.prototype.removeEventListener = function (eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    };
    ColumnGroup.prototype.setMoving = function (moving) {
        this.getDisplayedLeafColumns().forEach(function (column) { return column.setMoving(moving); });
    };
    ColumnGroup.prototype.isMoving = function () {
        return this.moving;
    };
    ColumnGroup.prototype.getGroupId = function () {
        return this.groupId;
    };
    ColumnGroup.prototype.getInstanceId = function () {
        return this.instanceId;
    };
    ColumnGroup.prototype.isChildInThisGroupDeepSearch = function (wantedChild) {
        var result = false;
        this.children.forEach(function (foundChild) {
            if (wantedChild === foundChild) {
                result = true;
            }
            if (foundChild instanceof ColumnGroup) {
                if (foundChild.isChildInThisGroupDeepSearch(wantedChild)) {
                    result = true;
                }
            }
        });
        return result;
    };
    ColumnGroup.prototype.getActualWidth = function () {
        var groupActualWidth = 0;
        if (this.displayedChildren) {
            this.displayedChildren.forEach(function (child) {
                groupActualWidth += child.getActualWidth();
            });
        }
        return groupActualWidth;
    };
    ColumnGroup.prototype.getMinWidth = function () {
        var result = 0;
        this.displayedChildren.forEach(function (groupChild) {
            result += groupChild.getMinWidth();
        });
        return result;
    };
    ColumnGroup.prototype.addChild = function (child) {
        if (!this.children) {
            this.children = [];
        }
        this.children.push(child);
    };
    ColumnGroup.prototype.getDisplayedChildren = function () {
        return this.displayedChildren;
    };
    ColumnGroup.prototype.getLeafColumns = function () {
        var result = [];
        this.addLeafColumns(result);
        return result;
    };
    ColumnGroup.prototype.getDisplayedLeafColumns = function () {
        var result = [];
        this.addDisplayedLeafColumns(result);
        return result;
    };
    // why two methods here doing the same thing?
    ColumnGroup.prototype.getDefinition = function () {
        return this.originalColumnGroup.getColGroupDef();
    };
    ColumnGroup.prototype.getColGroupDef = function () {
        return this.originalColumnGroup.getColGroupDef();
    };
    ColumnGroup.prototype.isPadding = function () {
        return this.originalColumnGroup.isPadding();
    };
    ColumnGroup.prototype.isExpandable = function () {
        return this.originalColumnGroup.isExpandable();
    };
    ColumnGroup.prototype.isExpanded = function () {
        return this.originalColumnGroup.isExpanded();
    };
    ColumnGroup.prototype.setExpanded = function (expanded) {
        this.originalColumnGroup.setExpanded(expanded);
    };
    ColumnGroup.prototype.addDisplayedLeafColumns = function (leafColumns) {
        this.displayedChildren.forEach(function (child) {
            if (child instanceof column_1.Column) {
                leafColumns.push(child);
            }
            else if (child instanceof ColumnGroup) {
                child.addDisplayedLeafColumns(leafColumns);
            }
        });
    };
    ColumnGroup.prototype.addLeafColumns = function (leafColumns) {
        this.children.forEach(function (child) {
            if (child instanceof column_1.Column) {
                leafColumns.push(child);
            }
            else if (child instanceof ColumnGroup) {
                child.addLeafColumns(leafColumns);
            }
        });
    };
    ColumnGroup.prototype.getChildren = function () {
        return this.children;
    };
    ColumnGroup.prototype.getColumnGroupShow = function () {
        return this.originalColumnGroup.getColumnGroupShow();
    };
    ColumnGroup.prototype.getOriginalColumnGroup = function () {
        return this.originalColumnGroup;
    };
    ColumnGroup.prototype.calculateDisplayedColumns = function () {
        // clear out last time we calculated
        this.displayedChildren = [];
        // it not expandable, everything is visible
        if (!this.originalColumnGroup.isExpandable()) {
            this.displayedChildren = this.children;
            return;
        }
        // and calculate again
        for (var i = 0, j = this.children.length; i < j; i++) {
            var abstractColumn = this.children[i];
            var headerGroupShow = abstractColumn.getColumnGroupShow();
            switch (headerGroupShow) {
                case ColumnGroup.HEADER_GROUP_SHOW_OPEN:
                    // when set to open, only show col if group is open
                    if (this.originalColumnGroup.isExpanded()) {
                        this.displayedChildren.push(abstractColumn);
                    }
                    break;
                case ColumnGroup.HEADER_GROUP_SHOW_CLOSED:
                    // when set to open, only show col if group is open
                    if (!this.originalColumnGroup.isExpanded()) {
                        this.displayedChildren.push(abstractColumn);
                    }
                    break;
                default:
                    // default is always show the column
                    this.displayedChildren.push(abstractColumn);
                    break;
            }
        }
    };
    ColumnGroup.HEADER_GROUP_SHOW_OPEN = 'open';
    ColumnGroup.HEADER_GROUP_SHOW_CLOSED = 'closed';
    ColumnGroup.EVENT_LEFT_CHANGED = 'leftChanged';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], ColumnGroup.prototype, "gridOptionsWrapper", void 0);
    return ColumnGroup;
}());
exports.ColumnGroup = ColumnGroup;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/entities/gridCell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridRow_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridRow.js");
var GridCell = (function () {
    function GridCell(gridCellDef) {
        this.rowIndex = gridCellDef.rowIndex;
        this.column = gridCellDef.column;
        this.floating = utils_1.Utils.makeNull(gridCellDef.floating);
    }
    GridCell.prototype.getGridCellDef = function () {
        return {
            rowIndex: this.rowIndex,
            column: this.column,
            floating: this.floating
        };
    };
    GridCell.prototype.getGridRow = function () {
        return new gridRow_1.GridRow(this.rowIndex, this.floating);
    };
    GridCell.prototype.toString = function () {
        return "rowIndex = " + this.rowIndex + ", floating = " + this.floating + ", column = " + (this.column ? this.column.getId() : null);
    };
    GridCell.prototype.createId = function () {
        return this.rowIndex + "." + this.floating + "." + this.column.getId();
    };
    return GridCell;
}());
exports.GridCell = GridCell;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/entities/gridRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridCell.js");
var GridRow = (function () {
    function GridRow(rowIndex, floating) {
        this.rowIndex = rowIndex;
        this.floating = utils_1.Utils.makeNull(floating);
    }
    GridRow.prototype.isFloatingTop = function () {
        return this.floating === constants_1.Constants.FLOATING_TOP;
    };
    GridRow.prototype.isFloatingBottom = function () {
        return this.floating === constants_1.Constants.FLOATING_BOTTOM;
    };
    GridRow.prototype.isNotFloating = function () {
        return !this.isFloatingBottom() && !this.isFloatingTop();
    };
    GridRow.prototype.equals = function (otherSelection) {
        return this.rowIndex === otherSelection.rowIndex
            && this.floating === otherSelection.floating;
    };
    GridRow.prototype.toString = function () {
        return "rowIndex = " + this.rowIndex + ", floating = " + this.floating;
    };
    GridRow.prototype.getGridCell = function (column) {
        var gridCellDef = { rowIndex: this.rowIndex, floating: this.floating, column: column };
        return new gridCell_1.GridCell(gridCellDef);
    };
    // tests if this row selection is before the other row selection
    GridRow.prototype.before = function (otherSelection) {
        var otherFloating = otherSelection.floating;
        switch (this.floating) {
            case constants_1.Constants.FLOATING_TOP:
                // we we are floating top, and other isn't, then we are always before
                if (otherFloating !== constants_1.Constants.FLOATING_TOP) {
                    return true;
                }
                break;
            case constants_1.Constants.FLOATING_BOTTOM:
                // if we are floating bottom, and the other isn't, then we are never before
                if (otherFloating !== constants_1.Constants.FLOATING_BOTTOM) {
                    return false;
                }
                break;
            default:
                // if we are not floating, but the other one is floating...
                if (utils_1.Utils.exists(otherFloating)) {
                    if (otherFloating === constants_1.Constants.FLOATING_TOP) {
                        // we are not floating, other is floating top, we are first
                        return false;
                    }
                    else {
                        // we are not floating, other is floating bottom, we are always first
                        return true;
                    }
                }
                break;
        }
        return this.rowIndex <= otherSelection.rowIndex;
    };
    return GridRow;
}());
exports.GridRow = GridRow;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/entities/originalColumnGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var columnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/columnGroup.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var OriginalColumnGroup = (function () {
    function OriginalColumnGroup(colGroupDef, groupId, padding) {
        this.expandable = false;
        this.colGroupDef = colGroupDef;
        this.groupId = groupId;
        this.expanded = colGroupDef && !!colGroupDef.openByDefault;
        this.padding = padding;
    }
    OriginalColumnGroup.prototype.isPadding = function () {
        return this.padding;
    };
    OriginalColumnGroup.prototype.setExpanded = function (expanded) {
        this.expanded = expanded;
    };
    OriginalColumnGroup.prototype.isExpandable = function () {
        return this.expandable;
    };
    OriginalColumnGroup.prototype.isExpanded = function () {
        return this.expanded;
    };
    OriginalColumnGroup.prototype.getGroupId = function () {
        return this.groupId;
    };
    OriginalColumnGroup.prototype.getId = function () {
        return this.getGroupId();
    };
    OriginalColumnGroup.prototype.setChildren = function (children) {
        this.children = children;
    };
    OriginalColumnGroup.prototype.getChildren = function () {
        return this.children;
    };
    OriginalColumnGroup.prototype.getColGroupDef = function () {
        return this.colGroupDef;
    };
    OriginalColumnGroup.prototype.getLeafColumns = function () {
        var result = [];
        this.addLeafColumns(result);
        return result;
    };
    OriginalColumnGroup.prototype.addLeafColumns = function (leafColumns) {
        this.children.forEach(function (child) {
            if (child instanceof column_1.Column) {
                leafColumns.push(child);
            }
            else if (child instanceof OriginalColumnGroup) {
                child.addLeafColumns(leafColumns);
            }
        });
    };
    OriginalColumnGroup.prototype.getColumnGroupShow = function () {
        if (!this.padding) {
            return this.colGroupDef.columnGroupShow;
        }
        else {
            // if this is padding we have exactly only child. we then
            // take the value from the child and push it up, making
            // this group 'invisible'.
            return this.children[0].getColumnGroupShow();
        }
    };
    // need to check that this group has at least one col showing when both expanded and contracted.
    // if not, then we don't allow expanding and contracting on this group
    OriginalColumnGroup.prototype.calculateExpandable = function () {
        // want to make sure the group doesn't disappear when it's open
        var atLeastOneShowingWhenOpen = false;
        // want to make sure the group doesn't disappear when it's closed
        var atLeastOneShowingWhenClosed = false;
        // want to make sure the group has something to show / hide
        var atLeastOneChangeable = false;
        for (var i = 0, j = this.children.length; i < j; i++) {
            var abstractColumn = this.children[i];
            // if the abstractColumn is a grid generated group, there will be no colDef
            var headerGroupShow = abstractColumn.getColumnGroupShow();
            if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_SHOW_OPEN) {
                atLeastOneShowingWhenOpen = true;
                atLeastOneChangeable = true;
            }
            else if (headerGroupShow === columnGroup_1.ColumnGroup.HEADER_GROUP_SHOW_CLOSED) {
                atLeastOneShowingWhenClosed = true;
                atLeastOneChangeable = true;
            }
            else {
                atLeastOneShowingWhenOpen = true;
                atLeastOneShowingWhenClosed = true;
            }
        }
        this.expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
    };
    return OriginalColumnGroup;
}());
exports.OriginalColumnGroup = OriginalColumnGroup;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/entities/rowNode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var valueService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/valueService.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var RowNode = (function () {
    function RowNode() {
        /** Children mapped by the pivot columns */
        this.childrenMapped = {};
        this.selected = false;
    }
    RowNode.prototype.setData = function (data) {
        var oldData = this.data;
        this.data = data;
        var event = { oldData: oldData, newData: data };
        this.dispatchLocalEvent(RowNode.EVENT_DATA_CHANGED, event);
    };
    RowNode.prototype.createDaemonNode = function () {
        var oldNode = new RowNode();
        this.context.wireBean(oldNode);
        // just copy the id and data, this is enough for the node to be used
        // in the selection controller (the selection controller is the only
        // place where daemon nodes can live).
        oldNode.id = this.id;
        oldNode.data = this.data;
        oldNode.daemon = true;
        oldNode.selected = this.selected;
        oldNode.level = this.level;
        return oldNode;
    };
    RowNode.prototype.setDataAndId = function (data, id) {
        var oldNode = utils_1.Utils.exists(this.id) ? this.createDaemonNode() : null;
        var oldData = this.data;
        this.data = data;
        this.setId(id);
        this.selectionController.syncInRowNode(this, oldNode);
        var event = { oldData: oldData, newData: data };
        this.dispatchLocalEvent(RowNode.EVENT_DATA_CHANGED, event);
    };
    RowNode.prototype.setId = function (id) {
        // see if user is providing the id's
        var getRowNodeId = this.gridOptionsWrapper.getRowNodeIdFunc();
        if (getRowNodeId) {
            // if user is providing the id's, then we set the id only after the data has been set.
            // this is important for virtual pagination and viewport, where empty rows exist.
            if (this.data) {
                this.id = getRowNodeId(this.data);
            }
            else {
                // this can happen if user has set blank into the rowNode after the row previously
                // having data. this happens in virtual page row model, when data is delete and
                // the page is refreshed.
                this.id = undefined;
            }
        }
        else {
            this.id = id;
        }
    };
    RowNode.prototype.clearRowTop = function () {
        this.oldRowTop = this.rowTop;
        this.setRowTop(null);
    };
    RowNode.prototype.setRowTop = function (rowTop) {
        if (this.rowTop === rowTop) {
            return;
        }
        this.rowTop = rowTop;
        if (this.eventService) {
            this.eventService.dispatchEvent(RowNode.EVENT_TOP_CHANGED);
        }
    };
    RowNode.prototype.setRowHeight = function (rowHeight) {
        this.rowHeight = rowHeight;
        if (this.eventService) {
            this.eventService.dispatchEvent(RowNode.EVENT_HEIGHT_CHANGED);
        }
    };
    RowNode.prototype.setRowIndex = function (rowIndex) {
        this.rowIndex = rowIndex;
        if (this.eventService) {
            this.eventService.dispatchEvent(RowNode.EVENT_ROW_INDEX_CHANGED);
        }
    };
    RowNode.prototype.setExpanded = function (expanded) {
        if (this.expanded === expanded) {
            return;
        }
        this.expanded = expanded;
        if (this.eventService) {
            this.eventService.dispatchEvent(RowNode.EVENT_EXPANDED_CHANGED);
        }
        var event = { node: this };
        this.mainEventService.dispatchEvent(events_1.Events.EVENT_ROW_GROUP_OPENED, event);
    };
    RowNode.prototype.dispatchLocalEvent = function (eventName, event) {
        if (this.eventService) {
            this.eventService.dispatchEvent(eventName, event);
        }
    };
    // we also allow editing the value via the editors. when it is done via
    // the editors, no 'cell changed' event gets fired, as it's assumed that
    // the cell knows about the change given it's in charge of the editing.
    // this method is for the client to call, so the cell listens for the change
    // event, and also flashes the cell when the change occurs.
    RowNode.prototype.setDataValue = function (colKey, newValue) {
        var column = this.columnController.getGridColumn(colKey);
        this.valueService.setValue(this, column, newValue);
        var event = { column: column, newValue: newValue };
        this.dispatchLocalEvent(RowNode.EVENT_CELL_CHANGED, event);
    };
    RowNode.prototype.resetQuickFilterAggregateText = function () {
        this.quickFilterAggregateText = null;
    };
    RowNode.prototype.isExpandable = function () {
        return this.group || this.canFlower;
    };
    RowNode.prototype.isSelected = function () {
        // for footers, we just return what our sibling selected state is, as cannot select a footer
        if (this.footer) {
            return this.sibling.isSelected();
        }
        return this.selected;
    };
    RowNode.prototype.depthFirstSearch = function (callback) {
        if (this.childrenAfterGroup) {
            this.childrenAfterGroup.forEach(function (child) { return child.depthFirstSearch(callback); });
        }
        callback(this);
    };
    // + rowController.updateGroupsInSelection()
    RowNode.prototype.calculateSelectedFromChildren = function () {
        var atLeastOneSelected = false;
        var atLeastOneDeSelected = false;
        var atLeastOneMixed = false;
        var newSelectedValue;
        if (this.childrenAfterGroup) {
            for (var i = 0; i < this.childrenAfterGroup.length; i++) {
                var childState = this.childrenAfterGroup[i].isSelected();
                switch (childState) {
                    case true:
                        atLeastOneSelected = true;
                        break;
                    case false:
                        atLeastOneDeSelected = true;
                        break;
                    default:
                        atLeastOneMixed = true;
                        break;
                }
            }
        }
        if (atLeastOneMixed) {
            newSelectedValue = undefined;
        }
        else if (atLeastOneSelected && !atLeastOneDeSelected) {
            newSelectedValue = true;
        }
        else if (!atLeastOneSelected && atLeastOneDeSelected) {
            newSelectedValue = false;
        }
        else {
            newSelectedValue = undefined;
        }
        this.selectThisNode(newSelectedValue);
    };
    RowNode.prototype.calculateSelectedFromChildrenBubbleUp = function () {
        this.calculateSelectedFromChildren();
        if (this.parent) {
            this.parent.calculateSelectedFromChildrenBubbleUp();
        }
    };
    RowNode.prototype.setSelectedInitialValue = function (selected) {
        this.selected = selected;
    };
    RowNode.prototype.setSelected = function (newValue, clearSelection, tailingNodeInSequence) {
        if (clearSelection === void 0) { clearSelection = false; }
        if (tailingNodeInSequence === void 0) { tailingNodeInSequence = false; }
        this.setSelectedParams({
            newValue: newValue,
            clearSelection: clearSelection,
            tailingNodeInSequence: tailingNodeInSequence,
            rangeSelect: false
        });
    };
    // to make calling code more readable, this is the same method as setSelected except it takes names parameters
    RowNode.prototype.setSelectedParams = function (params) {
        var groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
        var newValue = params.newValue === true;
        var clearSelection = params.clearSelection === true;
        var tailingNodeInSequence = params.tailingNodeInSequence === true;
        var rangeSelect = params.rangeSelect === true;
        // groupSelectsFiltered only makes sense when group selects children
        var groupSelectsFiltered = groupSelectsChildren && (params.groupSelectsFiltered === true);
        if (this.id === undefined) {
            console.warn('ag-Grid: cannot select node until id for node is known');
            return 0;
        }
        if (this.floating) {
            console.log('ag-Grid: cannot select floating rows');
            return 0;
        }
        // if we are a footer, we don't do selection, just pass the info
        // to the sibling (the parent of the group)
        if (this.footer) {
            var count = this.sibling.setSelectedParams(params);
            return count;
        }
        if (rangeSelect) {
            var rowModelNormal = this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_NORMAL;
            var newRowClicked = this.selectionController.getLastSelectedNode() !== this;
            var allowMultiSelect = this.gridOptionsWrapper.isRowSelectionMulti();
            if (rowModelNormal && newRowClicked && allowMultiSelect) {
                return this.doRowRangeSelection();
            }
        }
        var updatedCount = 0;
        // when groupSelectsFiltered, then this node may end up intermediate despite
        // trying to set it to true / false. this group will be calculated further on
        // down when we call calculatedSelectedForAllGroupNodes(). we need to skip it
        // here, otherwise the updatedCount would include it.
        var skipThisNode = groupSelectsFiltered && this.group;
        if (!skipThisNode) {
            var thisNodeWasSelected = this.selectThisNode(newValue);
            if (thisNodeWasSelected) {
                updatedCount++;
            }
        }
        if (groupSelectsChildren && this.group) {
            updatedCount += this.selectChildNodes(newValue, groupSelectsFiltered);
        }
        // clear other nodes if not doing multi select
        var actionWasOnThisNode = !tailingNodeInSequence;
        if (actionWasOnThisNode) {
            if (newValue && (clearSelection || !this.gridOptionsWrapper.isRowSelectionMulti())) {
                updatedCount += this.selectionController.clearOtherNodes(this);
            }
            // only if we selected something, then update groups and fire events
            if (updatedCount > 0) {
                // update groups
                if (groupSelectsFiltered) {
                    // if the group was selecting filtered, then all nodes above and or below
                    // this node could have check, unchecked or intermediate, so easiest is to
                    // recalculate selected state for all group nodes
                    this.calculatedSelectedForAllGroupNodes();
                }
                else {
                    // if no selecting filtered, then everything below the group node was either
                    // selected or not selected, no intermediate, so no need to check items below
                    // this one, just the parents all the way up to the root
                    if (groupSelectsChildren && this.parent) {
                        this.parent.calculateSelectedFromChildrenBubbleUp();
                    }
                }
                // fire events
                // this is the very end of the 'action node', so we are finished all the updates,
                // include any parent / child changes that this method caused
                this.mainEventService.dispatchEvent(events_1.Events.EVENT_SELECTION_CHANGED);
            }
            // so if user next does shift-select, we know where to start the selection from
            if (newValue) {
                this.selectionController.setLastSelectedNode(this);
            }
        }
        return updatedCount;
    };
    // selects all rows between this node and the last selected node (or the top if this is the first selection).
    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
    // holding down 'shift'.
    RowNode.prototype.doRowRangeSelection = function () {
        var _this = this;
        var lastSelectedNode = this.selectionController.getLastSelectedNode();
        // if lastSelectedNode is missing, we start at the first row
        var firstRowHit = !lastSelectedNode;
        var lastRowHit = false;
        var lastRow;
        var groupsSelectChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
        var updatedCount = 0;
        var inMemoryRowModel = this.rowModel;
        inMemoryRowModel.forEachNodeAfterFilterAndSort(function (rowNode) {
            var lookingForLastRow = firstRowHit && !lastRowHit;
            // check if we need to flip the select switch
            if (!firstRowHit) {
                if (rowNode === lastSelectedNode || rowNode === _this) {
                    firstRowHit = true;
                }
            }
            var skipThisGroupNode = rowNode.group && groupsSelectChildren;
            if (!skipThisGroupNode) {
                var inRange = firstRowHit && !lastRowHit;
                var childOfLastRow = rowNode.isParentOfNode(lastRow);
                var nodeWasSelected = rowNode.selectThisNode(inRange || childOfLastRow);
                if (nodeWasSelected) {
                    updatedCount++;
                }
            }
            if (lookingForLastRow) {
                if (rowNode === lastSelectedNode || rowNode === _this) {
                    lastRowHit = true;
                    if (rowNode === lastSelectedNode) {
                        lastRow = lastSelectedNode;
                    }
                    else {
                        lastRow = _this;
                    }
                }
            }
        });
        if (groupsSelectChildren) {
            this.calculatedSelectedForAllGroupNodes();
        }
        this.mainEventService.dispatchEvent(events_1.Events.EVENT_SELECTION_CHANGED);
        return updatedCount;
    };
    RowNode.prototype.isParentOfNode = function (potentialParent) {
        var parentNode = this.parent;
        while (parentNode) {
            if (parentNode === potentialParent) {
                return true;
            }
            parentNode = parentNode.parent;
        }
        return false;
    };
    RowNode.prototype.calculatedSelectedForAllGroupNodes = function () {
        // we have to make sure we do this dept first, as parent nodes
        // will have dependencies on the children having correct values
        var inMemoryRowModel = this.rowModel;
        inMemoryRowModel.getTopLevelNodes().forEach(function (topLevelNode) {
            if (topLevelNode.group) {
                topLevelNode.depthFirstSearch(function (childNode) {
                    if (childNode.group) {
                        childNode.calculateSelectedFromChildren();
                    }
                });
                topLevelNode.calculateSelectedFromChildren();
            }
        });
    };
    RowNode.prototype.selectThisNode = function (newValue) {
        if (this.selected === newValue) {
            return false;
        }
        this.selected = newValue;
        if (this.eventService) {
            this.dispatchLocalEvent(RowNode.EVENT_ROW_SELECTED);
        }
        var event = { node: this };
        this.mainEventService.dispatchEvent(events_1.Events.EVENT_ROW_SELECTED, event);
        return true;
    };
    RowNode.prototype.selectChildNodes = function (newValue, groupSelectsFiltered) {
        var children = groupSelectsFiltered ? this.childrenAfterFilter : this.childrenAfterGroup;
        var updatedCount = 0;
        if (utils_1.Utils.missing(children)) {
            return;
        }
        for (var i = 0; i < children.length; i++) {
            updatedCount += children[i].setSelectedParams({
                newValue: newValue,
                clearSelection: false,
                tailingNodeInSequence: true
            });
        }
        return updatedCount;
    };
    RowNode.prototype.addEventListener = function (eventType, listener) {
        if (!this.eventService) {
            this.eventService = new eventService_1.EventService();
        }
        this.eventService.addEventListener(eventType, listener);
    };
    RowNode.prototype.removeEventListener = function (eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    };
    RowNode.prototype.onMouseEnter = function () {
        this.dispatchLocalEvent(RowNode.EVENT_MOUSE_ENTER);
    };
    RowNode.prototype.onMouseLeave = function () {
        this.dispatchLocalEvent(RowNode.EVENT_MOUSE_LEAVE);
    };
    RowNode.EVENT_ROW_SELECTED = 'rowSelected';
    RowNode.EVENT_DATA_CHANGED = 'dataChanged';
    RowNode.EVENT_CELL_CHANGED = 'cellChanged';
    RowNode.EVENT_MOUSE_ENTER = 'mouseEnter';
    RowNode.EVENT_MOUSE_LEAVE = 'mouseLeave';
    RowNode.EVENT_HEIGHT_CHANGED = 'heightChanged';
    RowNode.EVENT_TOP_CHANGED = 'topChanged';
    RowNode.EVENT_ROW_INDEX_CHANGED = 'rowIndexChanged';
    RowNode.EVENT_EXPANDED_CHANGED = 'expandedChanged';
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], RowNode.prototype, "mainEventService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], RowNode.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('selectionController'), 
        __metadata('design:type', selectionController_1.SelectionController)
    ], RowNode.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], RowNode.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('valueService'), 
        __metadata('design:type', valueService_1.ValueService)
    ], RowNode.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], RowNode.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], RowNode.prototype, "context", void 0);
    return RowNode;
}());
exports.RowNode = RowNode;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/eventService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var EventService = (function () {
    function EventService() {
        this.allListeners = {};
        this.globalListeners = [];
    }
    EventService.prototype.agWire = function (loggerFactory, globalEventListener) {
        if (globalEventListener === void 0) { globalEventListener = null; }
        this.logger = loggerFactory.create('EventService');
        if (globalEventListener) {
            this.addGlobalListener(globalEventListener);
        }
    };
    EventService.prototype.getListenerList = function (eventType) {
        var listenerList = this.allListeners[eventType];
        if (!listenerList) {
            listenerList = [];
            this.allListeners[eventType] = listenerList;
        }
        return listenerList;
    };
    EventService.prototype.addEventListener = function (eventType, listener) {
        var listenerList = this.getListenerList(eventType);
        if (listenerList.indexOf(listener) < 0) {
            listenerList.push(listener);
        }
    };
    // for some events, it's important that the model gets to hear about them before the view,
    // as the model may need to update before the view works on the info. if you register
    // via this method, you get notified before the view parts
    EventService.prototype.addModalPriorityEventListener = function (eventType, listener) {
        this.addEventListener(eventType + EventService.PRIORITY, listener);
    };
    EventService.prototype.addGlobalListener = function (listener) {
        this.globalListeners.push(listener);
    };
    EventService.prototype.removeEventListener = function (eventType, listener) {
        var listenerList = this.getListenerList(eventType);
        utils_1.Utils.removeFromArray(listenerList, listener);
    };
    EventService.prototype.removeGlobalListener = function (listener) {
        utils_1.Utils.removeFromArray(this.globalListeners, listener);
    };
    // why do we pass the type here? the type is in ColumnChangeEvent, so unless the
    // type is not in other types of events???
    EventService.prototype.dispatchEvent = function (eventType, event) {
        if (!event) {
            event = {};
        }
        // console.log(`dispatching ${eventType}: ${event}`);
        // this allows the columnController to get events before anyone else
        var p1ListenerList = this.getListenerList(eventType + EventService.PRIORITY);
        p1ListenerList.forEach(function (listener) {
            listener(event);
        });
        var listenerList = this.getListenerList(eventType);
        listenerList.forEach(function (listener) {
            listener(event);
        });
        this.globalListeners.forEach(function (listener) {
            listener(eventType, event);
        });
    };
    // this is an old idea niall had, should really take it out, was to do with ordering who gets to process
    // events first, to give model and service objects preference over the view
    EventService.PRIORITY = '-P1';
    __decorate([
        __param(0, context_2.Qualifier('loggerFactory')),
        __param(1, context_2.Qualifier('globalEventListener')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory, Function]), 
        __metadata('design:returntype', void 0)
    ], EventService.prototype, "agWire", null);
    EventService = __decorate([
        context_1.Bean('eventService'), 
        __metadata('design:paramtypes', [])
    ], EventService);
    return EventService;
}());
exports.EventService = EventService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/events.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var Events = (function () {
    function Events() {
    }
    /** Everything has changed with the columns. Either complete new set of columns set, or user called setState()*/
    Events.EVENT_COLUMN_EVERYTHING_CHANGED = 'columnEverythingChanged';
    /** User has set in new columns. */
    Events.EVENT_NEW_COLUMNS_LOADED = 'newColumnsLoaded';
    /** The pivot mode flag was changed */
    Events.EVENT_COLUMN_PIVOT_MODE_CHANGED = 'columnPivotModeChanged';
    /** A row group column was added, removed or order changed. */
    Events.EVENT_COLUMN_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
    /** A pivot column was added, removed or order changed. */
    Events.EVENT_COLUMN_PIVOT_CHANGED = 'columnPivotChanged';
    /** The list of grid columns has changed. */
    Events.EVENT_GRID_COLUMNS_CHANGED = 'gridColumnsChanged';
    /** A value column was added, removed or agg function was changed. */
    Events.EVENT_COLUMN_VALUE_CHANGED = 'columnValueChanged';
    /** A column was moved */
    Events.EVENT_COLUMN_MOVED = 'columnMoved';
    /** One or more columns was shown / hidden */
    Events.EVENT_COLUMN_VISIBLE = 'columnVisible';
    /** One or more columns was pinned / unpinned*/
    Events.EVENT_COLUMN_PINNED = 'columnPinned';
    /** A column group was opened / closed */
    Events.EVENT_COLUMN_GROUP_OPENED = 'columnGroupOpened';
    /** One or more columns was resized. If just one, the column in the event is set. */
    Events.EVENT_COLUMN_RESIZED = 'columnResized';
    /** The list of displayed columns has changed, can result from columns open / close, column move, pivot, group, etc */
    Events.EVENT_DISPLAYED_COLUMNS_CHANGED = 'displayedColumnsChanged';
    /** The list of virtual columns has changed, results from viewport changing */
    Events.EVENT_VIRTUAL_COLUMNS_CHANGED = 'virtualColumnsChanged';
    /** A row group was opened / closed */
    Events.EVENT_ROW_GROUP_OPENED = 'rowGroupOpened';
    /** The client has set new data into the grid */
    Events.EVENT_ROW_DATA_CHANGED = 'rowDataChanged';
    /** The client has set new floating data into the grid */
    Events.EVENT_FLOATING_ROW_DATA_CHANGED = 'floatingRowDataChanged';
    /** Range selection has changed */
    Events.EVENT_RANGE_SELECTION_CHANGED = 'rangeSelectionChanged';
    /** Model was updated - grid updates the drawn rows when this happens */
    Events.EVENT_MODEL_UPDATED = 'modelUpdated';
    Events.EVENT_CELL_CLICKED = 'cellClicked';
    Events.EVENT_CELL_DOUBLE_CLICKED = 'cellDoubleClicked';
    Events.EVENT_CELL_CONTEXT_MENU = 'cellContextMenu';
    Events.EVENT_CELL_VALUE_CHANGED = 'cellValueChanged';
    Events.EVENT_ROW_VALUE_CHANGED = 'rowValueChanged';
    Events.EVENT_CELL_FOCUSED = 'cellFocused';
    Events.EVENT_ROW_SELECTED = 'rowSelected';
    Events.EVENT_SELECTION_CHANGED = 'selectionChanged';
    /** 3 events for filtering. The grid LISTENS for filterChanged, and does the filter here. The before and after
     * are for the client, if it wants to do something before or after the filter getting applied. */
    Events.EVENT_BEFORE_FILTER_CHANGED = 'beforeFilterChanged';
    Events.EVENT_FILTER_CHANGED = 'filterChanged';
    Events.EVENT_AFTER_FILTER_CHANGED = 'afterFilterChanged';
    /** Filter was change but not applied. Only useful if apply buttons are used in filters. */
    Events.EVENT_FILTER_MODIFIED = 'filterModified';
    /** 3 events for sorting. The grid LISTENS for sortChanged, and does the filter here. The before and after
     * are for the client, if it wants to do something before or after the sort getting applied. */
    Events.EVENT_BEFORE_SORT_CHANGED = 'beforeSortChanged';
    Events.EVENT_SORT_CHANGED = 'sortChanged';
    Events.EVENT_AFTER_SORT_CHANGED = 'afterSortChanged';
    /** A row was removed from the dom, for any reason. Use to clean up resources (if any) used by the row. */
    Events.EVENT_VIRTUAL_ROW_REMOVED = 'virtualRowRemoved';
    Events.EVENT_ROW_CLICKED = 'rowClicked';
    Events.EVENT_ROW_DOUBLE_CLICKED = 'rowDoubleClicked';
    /** Gets called once after the grid has finished initialising. */
    Events.EVENT_GRID_READY = 'gridReady';
    /** Width of height of the main grid div has changed. Grid listens for this and does layout of grid if it's
     * changed, so always filling the space it was given.  */
    Events.EVENT_GRID_SIZE_CHANGED = 'gridSizeChanged';
    /** The indexes of the rows rendered has changed, eg user has scrolled to a new vertical position. */
    Events.EVENT_VIEWPORT_CHANGED = 'viewportChanged';
    /** A column drag has started, either resizing a column or moving a column. */
    Events.EVENT_DRAG_STARTED = 'dragStarted';
    /** A column drag has stopped */
    Events.EVENT_DRAG_STOPPED = 'dragStopped';
    Events.EVENT_ROW_EDITING_STARTED = 'rowEditingStarted';
    Events.EVENT_ROW_EDITING_STOPPED = 'rowEditingStopped';
    Events.EVENT_CELL_EDITING_STARTED = 'cellEditingStarted';
    Events.EVENT_CELL_EDITING_STOPPED = 'cellEditingStopped';
    /** Client added a new row. */
    Events.EVENT_ITEMS_ADDED = 'itemsAdded';
    /** Client removed a row. */
    Events.EVENT_ITEMS_REMOVED = 'itemsRemoved';
    /** Main body of grid has scrolled, either horizontally or vertically */
    Events.EVENT_BODY_SCROLL = 'bodyScroll';
    /** All items from here down are used internally by the grid, not intended for external use. */
    Events.EVENT_FLASH_CELLS = 'flashCells';
    /** All the events from here down are experimental, should not be documented or used by ag-Grid customers */
    // not documented, as it's experimental, don't want people with dependencies on this
    Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = 'displayedColumnsWidthChanged';
    Events.EVENT_SCROLL_VISIBILITY_CHANGED = 'scrollVisibilityChanged';
    // these are used for server side group and agg - only used by CS with Viewport Row Model - intention is
    // to design these better around server side functions and then release to general public when fully working with
    // all the row models.
    Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = 'columnRowGroupChangeRequest';
    Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = 'columnPivotChangeRequest';
    Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST = 'columnValueChangeRequest';
    Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = 'columnAggFuncChangeRequest';
    return Events;
}());
exports.Events = Events;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/expressionService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var ExpressionService = (function () {
    function ExpressionService() {
        this.expressionToFunctionCache = {};
    }
    ExpressionService.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('ExpressionService');
    };
    ExpressionService.prototype.evaluate = function (expression, params) {
        try {
            var javaScriptFunction = this.createExpressionFunction(expression);
            var result = javaScriptFunction(params.value, params.context, params.node, params.data, params.colDef, params.rowIndex, params.api, params.getValue, params.column, params.columnGroup);
            return result;
        }
        catch (e) {
            // the expression failed, which can happen, as it's the client that
            // provides the expression. so print a nice message
            this.logger.log('Processing of the expression failed');
            this.logger.log('Expression = ' + expression);
            this.logger.log('Exception = ' + e);
            return null;
        }
    };
    ExpressionService.prototype.createExpressionFunction = function (expression) {
        // check cache first
        if (this.expressionToFunctionCache[expression]) {
            return this.expressionToFunctionCache[expression];
        }
        // if not found in cache, return the function
        var functionBody = this.createFunctionBody(expression);
        var theFunction = new Function('x, ctx, node, data, colDef, rowIndex, api, getValue, column, columnGroup', functionBody);
        // store in cache
        this.expressionToFunctionCache[expression] = theFunction;
        return theFunction;
    };
    ExpressionService.prototype.createFunctionBody = function (expression) {
        // if the expression has the 'return' word in it, then use as is,
        // if not, then wrap it with return and ';' to make a function
        if (expression.indexOf('return') >= 0) {
            return expression;
        }
        else {
            return 'return ' + expression + ';';
        }
    };
    __decorate([
        __param(0, context_2.Qualifier('loggerFactory')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory]), 
        __metadata('design:returntype', void 0)
    ], ExpressionService.prototype, "setBeans", null);
    ExpressionService = __decorate([
        context_1.Bean('expressionService'), 
        __metadata('design:paramtypes', [])
    ], ExpressionService);
    return ExpressionService;
}());
exports.ExpressionService = ExpressionService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/filter/dateFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var componentAnnotations_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/componentAnnotations.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var DateFilter = (function (_super) {
    __extends(DateFilter, _super);
    function DateFilter() {
        _super.apply(this, arguments);
        this.filter = 'equals';
    }
    DateFilter.prototype.init = function (params) {
        this.filterParams = params;
        this.applyActive = params.apply === true;
        this.newRowsActionKeep = params.newRowsAction === 'keep';
        this.setTemplate(this.generateTemplate());
        if (this.applyActive) {
            this.addDestroyableEventListener(this.eApplyButton, "click", this.filterParams.filterChangedCallback);
        }
        else {
            this.getGui().removeChild(this.eApplyPanel);
        }
        var UserDateComponent = this.gridOptionsWrapper.getDateComponent();
        var DateComponent = UserDateComponent ? UserDateComponent : DefaultDateComponent;
        this.dateToComponent = new DateComponent();
        this.dateFromComponent = new DateComponent();
        var dateComponentParams = {
            onDateChanged: this.onDateChanged.bind(this)
        };
        this.dateFromComponent.init(dateComponentParams);
        this.dateToComponent.init(dateComponentParams);
        this.addInDateComponents();
        this.setVisibilityOnDateToPanel();
        this.instantiate(this.context);
        this.addDestroyableEventListener(this.eTypeSelector, "change", this.onFilterTypeChanged.bind(this));
    };
    DateFilter.prototype.generateTemplate = function () {
        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
        return "<div>\n                    <div>\n                        <select class=\"ag-filter-select\" id=\"filterType\">\n                            <option value=\"" + DateFilter.EQUALS + "\">" + translate('equals', 'Equals') + "</option>\n                            <option value=\"" + DateFilter.NOT_EQUAL + "\">" + translate('notEqual', 'Not equal') + "</option>\n                            <option value=\"" + DateFilter.LESS_THAN + "\">" + translate('lessThan', 'Less than') + "</option>\n                            <option value=\"" + DateFilter.GREATER_THAN + "\">" + translate('greaterThan', 'Greater than') + "</option>\n                            <option value=\"" + DateFilter.IN_RANGE + "\">" + translate('inRange', 'In range') + "</option>\n                        </select>\n                    </div>\n                    <div class=\"ag-filter-date-from\" id=\"filterDateFromPanel\">\n                    </div>\n                    <div class=\"ag-filter-date-to\" id=\"filterDateToPanel\">\n                    </div>\n                    <div class=\"ag-filter-apply-panel\" id=\"applyPanel\">\n                        <button type=\"button\" id=\"applyButton\">" + translate('applyFilter', 'Apply Filter') + "</button>\n                    </div>\n                </div>";
    };
    DateFilter.prototype.onNewRowsLoaded = function () {
        if (!this.newRowsActionKeep) {
            this.setFilterType(DateFilter.EQUALS);
            this.setDateFrom(null);
            this.setDateTo(null);
        }
    };
    DateFilter.prototype.onDateChanged = function () {
        this.dateFrom = this.removeTimezone(this.dateFromComponent.getDate());
        this.dateTo = this.removeTimezone(this.dateToComponent.getDate());
        this.filterParams.filterModifiedCallback();
        if (!this.applyActive) {
            this.filterParams.filterChangedCallback();
        }
    };
    DateFilter.prototype.onFilterTypeChanged = function () {
        this.filter = this.eTypeSelector.value;
        this.setVisibilityOnDateToPanel();
        this.filterParams.filterModifiedCallback();
        if (!this.applyActive) {
            this.filterParams.filterChangedCallback();
        }
    };
    DateFilter.prototype.setVisibilityOnDateToPanel = function () {
        var visible = this.filter === DateFilter.IN_RANGE;
        utils_1.Utils.setVisible(this.eDateToPanel, visible);
    };
    DateFilter.prototype.addInDateComponents = function () {
        this.eDateFromPanel.appendChild(this.dateFromComponent.getGui());
        this.eDateToPanel.appendChild(this.dateToComponent.getGui());
        if (this.dateFromComponent.afterGuiAttached) {
            this.dateFromComponent.afterGuiAttached();
        }
        if (this.dateToComponent.afterGuiAttached) {
            this.dateToComponent.afterGuiAttached();
        }
    };
    DateFilter.prototype.isFilterActive = function () {
        if (this.filter === DateFilter.IN_RANGE) {
            return this.dateFrom != null && this.dateTo != null;
        }
        else {
            return this.dateFrom != null;
        }
    };
    DateFilter.prototype.doesFilterPass = function (params) {
        var value = this.filterParams.valueGetter(params.node);
        var comparator = null;
        if (this.filterParams.comparator) {
            comparator = this.filterParams.comparator;
        }
        else {
            comparator = this.defaultComparator.bind(this);
        }
        var compareDateFromResult = comparator(this.dateFrom, value);
        if (this.filter === DateFilter.EQUALS) {
            return compareDateFromResult === 0;
        }
        if (this.filter === DateFilter.GREATER_THAN) {
            return compareDateFromResult > 0;
        }
        if (this.filter === DateFilter.LESS_THAN) {
            return compareDateFromResult < 0;
        }
        if (this.filter === DateFilter.NOT_EQUAL) {
            return compareDateFromResult != 0;
        }
        //From now on the type is a range
        var compareDateToResult = comparator(this.dateTo, value);
        if (this.filter === DateFilter.IN_RANGE) {
            return compareDateFromResult > 0 && compareDateToResult < 0;
        }
        throw new Error('Unexpected type of date filter!: ' + this.filter);
    };
    DateFilter.prototype.defaultComparator = function (filterDate, cellValue) {
        //The default comparator assumes that the cellValue is a date
        var cellAsDate = cellValue;
        if (cellAsDate < filterDate) {
            return -1;
        }
        if (cellAsDate > filterDate) {
            return 1;
        }
        return 0;
    };
    DateFilter.prototype.getModel = function () {
        if (this.isFilterActive()) {
            return {
                dateTo: utils_1.Utils.serializeDateToYyyyMmDd(this.dateToComponent.getDate(), "-"),
                dateFrom: utils_1.Utils.serializeDateToYyyyMmDd(this.dateFromComponent.getDate(), "-"),
                type: this.filter
            };
        }
        else {
            return null;
        }
    };
    // not used by ag-Grid, but exposed as part of the filter API for the client if they want it
    DateFilter.prototype.getDateFrom = function () {
        return utils_1.Utils.serializeDateToYyyyMmDd(this.dateFromComponent.getDate(), "-");
    };
    // not used by ag-Grid, but exposed as part of the filter API for the client if they want it
    DateFilter.prototype.getDateTo = function () {
        return utils_1.Utils.serializeDateToYyyyMmDd(this.dateToComponent.getDate(), "-");
    };
    // not used by ag-Grid, but exposed as part of the filter API for the client if they want it
    DateFilter.prototype.getFilterType = function () {
        return this.filter;
    };
    DateFilter.prototype.setDateFrom = function (date) {
        this.dateFrom = utils_1.Utils.parseYyyyMmDdToDate(date, "-");
        this.dateFromComponent.setDate(this.dateFrom);
    };
    DateFilter.prototype.setDateTo = function (date) {
        this.dateTo = utils_1.Utils.parseYyyyMmDdToDate(date, "-");
        this.dateToComponent.setDate(this.dateTo);
    };
    DateFilter.prototype.setFilterType = function (filterType) {
        this.filter = filterType;
        this.eTypeSelector.value = filterType;
    };
    DateFilter.prototype.setModel = function (model) {
        if (model) {
            this.setDateFrom(model.dateFrom);
            this.setDateTo(model.dateTo);
            this.setFilterType(model.type);
        }
        else {
            this.setDateFrom(null);
            this.setDateTo(null);
            this.setFilterType("equals");
        }
    };
    DateFilter.prototype.removeTimezone = function (from) {
        if (!from)
            return null;
        return new Date(from.getFullYear(), from.getMonth(), from.getDate());
    };
    DateFilter.EQUALS = 'equals';
    DateFilter.NOT_EQUAL = 'notEqual';
    DateFilter.LESS_THAN = 'lessThan';
    DateFilter.GREATER_THAN = 'greaterThan';
    DateFilter.IN_RANGE = 'inRange';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], DateFilter.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], DateFilter.prototype, "context", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#filterDateFromPanel'), 
        __metadata('design:type', HTMLElement)
    ], DateFilter.prototype, "eDateFromPanel", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#filterDateToPanel'), 
        __metadata('design:type', HTMLElement)
    ], DateFilter.prototype, "eDateToPanel", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#applyPanel'), 
        __metadata('design:type', HTMLElement)
    ], DateFilter.prototype, "eApplyPanel", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#applyButton'), 
        __metadata('design:type', HTMLElement)
    ], DateFilter.prototype, "eApplyButton", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('#filterType'), 
        __metadata('design:type', HTMLSelectElement)
    ], DateFilter.prototype, "eTypeSelector", void 0);
    return DateFilter;
}(component_1.Component));
exports.DateFilter = DateFilter;
var DefaultDateComponent = (function (_super) {
    __extends(DefaultDateComponent, _super);
    function DefaultDateComponent() {
        _super.call(this, "<input class=\"ag-filter-filter\" type=\"text\" placeholder=\"yyyy-mm-dd\">");
    }
    DefaultDateComponent.prototype.init = function (params) {
        this.eDateInput = this.getGui();
        if (utils_1.Utils.isBrowserChrome()) {
            this.eDateInput.type = 'date';
        }
        this.listener = params.onDateChanged;
        this.addGuiEventListener('input', this.listener);
    };
    DefaultDateComponent.prototype.getDate = function () {
        return utils_1.Utils.parseYyyyMmDdToDate(this.eDateInput.value, "-");
    };
    DefaultDateComponent.prototype.setDate = function (date) {
        this.eDateInput.value = utils_1.Utils.serializeDateToYyyyMmDd(date, "-");
    };
    return DefaultDateComponent;
}(component_1.Component));
exports.DefaultDateComponent = DefaultDateComponent;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/filter/filterManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var popupService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/popupService.js");
var valueService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/valueService.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var textFilter_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/textFilter.js");
var numberFilter_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/numberFilter.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var dateFilter_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/dateFilter.js");
var FilterManager = (function () {
    function FilterManager() {
        this.allFilters = {};
        this.quickFilter = null;
        this.availableFilters = {
            'text': textFilter_1.TextFilter,
            'number': numberFilter_1.NumberFilter,
            'date': dateFilter_1.DateFilter
        };
    }
    FilterManager.prototype.init = function () {
        this.eventService.addEventListener(events_1.Events.EVENT_ROW_DATA_CHANGED, this.onNewRowsLoaded.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
        this.quickFilter = this.parseQuickFilter(this.gridOptionsWrapper.getQuickFilterText());
        // check this here, in case there is a filter from the start
        this.checkExternalFilter();
    };
    FilterManager.prototype.registerFilter = function (key, Filter) {
        this.availableFilters[key] = Filter;
    };
    FilterManager.prototype.setFilterModel = function (model) {
        var _this = this;
        if (model) {
            // mark the filters as we set them, so any active filters left over we stop
            var modelKeys = Object.keys(model);
            utils_1.Utils.iterateObject(this.allFilters, function (colId, filterWrapper) {
                utils_1.Utils.removeFromArray(modelKeys, colId);
                var newModel = model[colId];
                _this.setModelOnFilterWrapper(filterWrapper.filter, newModel);
            });
            // at this point, processedFields contains data for which we don't have a filter working yet
            utils_1.Utils.iterateArray(modelKeys, function (colId) {
                var column = _this.columnController.getPrimaryColumn(colId);
                if (!column) {
                    console.warn('Warning ag-grid setFilterModel - no column found for colId ' + colId);
                    return;
                }
                var filterWrapper = _this.getOrCreateFilterWrapper(column);
                _this.setModelOnFilterWrapper(filterWrapper.filter, model[colId]);
            });
        }
        else {
            utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
                _this.setModelOnFilterWrapper(filterWrapper.filter, null);
            });
        }
        this.onFilterChanged();
    };
    FilterManager.prototype.setModelOnFilterWrapper = function (filter, newModel) {
        if (typeof filter.setModel !== 'function') {
            console.warn('Warning ag-grid - filter missing setModel method, which is needed for setFilterModel');
            return;
        }
        filter.setModel(newModel);
    };
    FilterManager.prototype.getFilterModel = function () {
        var result = {};
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            // because user can provide filters, we provide useful error checking and messages
            var filter = filterWrapper.filter;
            if (typeof filter.getModel !== 'function') {
                console.warn('Warning ag-grid - filter API missing getModel method, which is needed for getFilterModel');
                return;
            }
            var model = filter.getModel();
            if (utils_1.Utils.exists(model)) {
                result[key] = model;
            }
        });
        return result;
    };
    // returns true if any advanced filter (ie not quick filter) active
    FilterManager.prototype.isAdvancedFilterPresent = function () {
        return this.advancedFilterPresent;
    };
    FilterManager.prototype.setAdvancedFilterPresent = function () {
        var atLeastOneActive = false;
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            if (filterWrapper.filter.isFilterActive()) {
                atLeastOneActive = true;
            }
        });
        this.advancedFilterPresent = atLeastOneActive;
    };
    FilterManager.prototype.updateFilterFlagInColumns = function () {
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            var filterActive = filterWrapper.filter.isFilterActive();
            filterWrapper.column.setFilterActive(filterActive);
        });
    };
    // returns true if quickFilter or advancedFilter
    FilterManager.prototype.isAnyFilterPresent = function () {
        return this.isQuickFilterPresent() || this.advancedFilterPresent || this.externalFilterPresent;
    };
    FilterManager.prototype.doesFilterPass = function (node, filterToSkip) {
        var data = node.data;
        var colKeys = Object.keys(this.allFilters);
        for (var i = 0, l = colKeys.length; i < l; i++) {
            var colId = colKeys[i];
            var filterWrapper = this.allFilters[colId];
            // if no filter, always pass
            if (filterWrapper === undefined) {
                continue;
            }
            if (filterWrapper.filter === filterToSkip) {
                continue;
            }
            // don't bother with filters that are not active
            if (!filterWrapper.filter.isFilterActive()) {
                continue;
            }
            if (!filterWrapper.filter.doesFilterPass) {
                console.error('Filter is missing method doesFilterPass');
            }
            var params = {
                node: node,
                data: data
            };
            if (!filterWrapper.filter.doesFilterPass(params)) {
                return false;
            }
        }
        // all filters passed
        return true;
    };
    FilterManager.prototype.parseQuickFilter = function (newFilter) {
        if (utils_1.Utils.missing(newFilter) || newFilter === "") {
            return null;
        }
        if (this.gridOptionsWrapper.isRowModelVirtual()) {
            console.warn('ag-grid: cannot do quick filtering when doing virtual paging');
            return null;
        }
        return newFilter.toUpperCase();
    };
    // returns true if it has changed (not just same value again)
    FilterManager.prototype.setQuickFilter = function (newFilter) {
        var parsedFilter = this.parseQuickFilter(newFilter);
        if (this.quickFilter !== parsedFilter) {
            this.quickFilter = parsedFilter;
            this.onFilterChanged();
        }
    };
    FilterManager.prototype.checkExternalFilter = function () {
        this.externalFilterPresent = this.gridOptionsWrapper.isExternalFilterPresent();
    };
    FilterManager.prototype.onFilterChanged = function () {
        this.eventService.dispatchEvent(events_1.Events.EVENT_BEFORE_FILTER_CHANGED);
        this.setAdvancedFilterPresent();
        this.updateFilterFlagInColumns();
        this.checkExternalFilter();
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            if (filterWrapper.filter.onAnyFilterChanged) {
                filterWrapper.filter.onAnyFilterChanged();
            }
        });
        this.eventService.dispatchEvent(events_1.Events.EVENT_FILTER_CHANGED);
        this.eventService.dispatchEvent(events_1.Events.EVENT_AFTER_FILTER_CHANGED);
    };
    FilterManager.prototype.isQuickFilterPresent = function () {
        return this.quickFilter !== null;
    };
    FilterManager.prototype.doesRowPassOtherFilters = function (filterToSkip, node) {
        return this.doesRowPassFilter(node, filterToSkip);
    };
    FilterManager.prototype.doesRowPassFilter = function (node, filterToSkip) {
        //first up, check quick filter
        if (this.isQuickFilterPresent()) {
            if (!node.quickFilterAggregateText) {
                this.aggregateRowForQuickFilter(node);
            }
            if (node.quickFilterAggregateText.indexOf(this.quickFilter) < 0) {
                //quick filter fails, so skip item
                return false;
            }
        }
        //secondly, give the client a chance to reject this row
        if (this.externalFilterPresent) {
            if (!this.gridOptionsWrapper.doesExternalFilterPass(node)) {
                return false;
            }
        }
        //lastly, check our internal advanced filter
        if (this.advancedFilterPresent) {
            if (!this.doesFilterPass(node, filterToSkip)) {
                return false;
            }
        }
        //got this far, all filters pass
        return true;
    };
    FilterManager.prototype.aggregateRowForQuickFilter = function (node) {
        var _this = this;
        var stringParts = [];
        var columns = this.columnController.getAllPrimaryColumns();
        columns.forEach(function (column) {
            var value = _this.valueService.getValue(column, node);
            var valueAfterCallback;
            var colDef = column.getColDef();
            if (column.getColDef().getQuickFilterText) {
                var params = {
                    value: value,
                    node: node,
                    data: node.data,
                    column: column,
                    colDef: colDef
                };
                valueAfterCallback = column.getColDef().getQuickFilterText(params);
            }
            else {
                valueAfterCallback = value;
            }
            if (valueAfterCallback && valueAfterCallback !== '') {
                stringParts.push(valueAfterCallback.toString().toUpperCase());
            }
        });
        node.quickFilterAggregateText = stringParts.join('_');
    };
    FilterManager.prototype.onNewRowsLoaded = function () {
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            if (filterWrapper.filter.onNewRowsLoaded) {
                filterWrapper.filter.onNewRowsLoaded();
            }
        });
        this.updateFilterFlagInColumns();
        this.setAdvancedFilterPresent();
    };
    FilterManager.prototype.createValueGetter = function (column) {
        var that = this;
        return function valueGetter(node) {
            return that.valueService.getValue(column, node);
        };
    };
    FilterManager.prototype.getFilterComponent = function (column) {
        var filterWrapper = this.getOrCreateFilterWrapper(column);
        return filterWrapper.filter;
    };
    FilterManager.prototype.getOrCreateFilterWrapper = function (column) {
        var filterWrapper = this.allFilters[column.getColId()];
        if (!filterWrapper) {
            filterWrapper = this.createFilterWrapper(column);
            this.allFilters[column.getColId()] = filterWrapper;
        }
        return filterWrapper;
    };
    FilterManager.prototype.createFilterInstance = function (column) {
        var filter = column.getFilter();
        var filterIsComponent = typeof filter === 'function';
        var filterIsName = utils_1.Utils.missing(filter) || typeof filter === 'string';
        var FilterClass;
        if (filterIsComponent) {
            // if user provided a filter, just use it
            FilterClass = filter;
            // now create filter (had to cast to any to get 'new' working)
            this.assertMethodHasNoParameters(FilterClass);
        }
        else if (filterIsName) {
            var filterName = filter;
            FilterClass = this.getFilterFromCache(filterName);
        }
        else {
            console.error('ag-Grid: colDef.filter should be function or a string');
            return null;
        }
        var filterInstance = new FilterClass();
        this.checkFilterHasAllMandatoryMethods(filterInstance, column);
        this.context.wireBean(filterInstance);
        return filterInstance;
    };
    FilterManager.prototype.checkFilterHasAllMandatoryMethods = function (filterInstance, column) {
        // help the user, check the mandatory methods exist
        ['getGui', 'isFilterActive', 'doesFilterPass', 'getModel', 'setModel'].forEach(function (methodName) {
            var methodIsMissing = !filterInstance[methodName];
            if (methodIsMissing) {
                throw "Filter for column " + column.getColId() + " is missing method " + methodName;
            }
        });
    };
    FilterManager.prototype.createParams = function (filterWrapper) {
        var _this = this;
        var filterChangedCallback = this.onFilterChanged.bind(this);
        var filterModifiedCallback = function () { return _this.eventService.dispatchEvent(events_1.Events.EVENT_FILTER_MODIFIED); };
        var doesRowPassOtherFilters = this.doesRowPassOtherFilters.bind(this, filterWrapper.filter);
        var colDef = filterWrapper.column.getColDef();
        var params = {
            column: filterWrapper.column,
            colDef: colDef,
            rowModel: this.rowModel,
            filterChangedCallback: filterChangedCallback,
            filterModifiedCallback: filterModifiedCallback,
            valueGetter: this.createValueGetter(filterWrapper.column),
            doesRowPassOtherFilter: doesRowPassOtherFilters,
            context: this.gridOptionsWrapper.getContext(),
            $scope: filterWrapper.scope
        };
        if (colDef.filterParams) {
            utils_1.Utils.assign(params, colDef.filterParams);
        }
        return params;
    };
    FilterManager.prototype.createFilterWrapper = function (column) {
        var filterWrapper = {
            column: column,
            filter: null,
            scope: null,
            gui: null
        };
        filterWrapper.filter = this.createFilterInstance(column);
        this.initialiseFilterAndPutIntoGui(filterWrapper);
        return filterWrapper;
    };
    FilterManager.prototype.initialiseFilterAndPutIntoGui = function (filterWrapper) {
        // first up, create child scope if needed
        if (this.gridOptionsWrapper.isAngularCompileFilters()) {
            filterWrapper.scope = this.$scope.$new();
            filterWrapper.scope.context = this.gridOptionsWrapper.getContext();
        }
        var params = this.createParams(filterWrapper);
        filterWrapper.filter.init(params);
        var eFilterGui = document.createElement('div');
        eFilterGui.className = 'ag-filter';
        var guiFromFilter = filterWrapper.filter.getGui();
        if (utils_1.Utils.isNodeOrElement(guiFromFilter)) {
            //a dom node or element was returned, so add child
            eFilterGui.appendChild(guiFromFilter);
        }
        else {
            //otherwise assume it was html, so just insert
            var eTextSpan = document.createElement('span');
            eTextSpan.innerHTML = guiFromFilter;
            eFilterGui.appendChild(eTextSpan);
        }
        if (filterWrapper.scope) {
            filterWrapper.gui = this.$compile(eFilterGui)(filterWrapper.scope)[0];
        }
        else {
            filterWrapper.gui = eFilterGui;
        }
    };
    FilterManager.prototype.getFilterFromCache = function (filterType) {
        var defaultFilterType = this.enterprise ? 'set' : 'text';
        var defaultFilter = this.availableFilters[defaultFilterType];
        if (utils_1.Utils.missing(filterType)) {
            return defaultFilter;
        }
        if (!this.enterprise && filterType === 'set') {
            console.warn('ag-Grid: Set filter is only available in Enterprise ag-Grid');
            filterType = 'text';
        }
        if (this.availableFilters[filterType]) {
            return this.availableFilters[filterType];
        }
        else {
            console.error('ag-Grid: Could not find filter type ' + filterType);
            return this.availableFilters[defaultFilter];
        }
    };
    FilterManager.prototype.onNewColumnsLoaded = function () {
        this.destroy();
    };
    // destroys the filter, so it not longer takes part
    FilterManager.prototype.destroyFilter = function (column) {
        var filterWrapper = this.allFilters[column.getColId()];
        if (filterWrapper) {
            this.disposeFilterWrapper(filterWrapper);
            this.onFilterChanged();
        }
    };
    FilterManager.prototype.disposeFilterWrapper = function (filterWrapper) {
        if (filterWrapper.filter.destroy) {
            filterWrapper.filter.destroy();
        }
        filterWrapper.column.setFilterActive(false);
        delete this.allFilters[filterWrapper.column.getColId()];
    };
    FilterManager.prototype.destroy = function () {
        var _this = this;
        utils_1.Utils.iterateObject(this.allFilters, function (key, filterWrapper) {
            _this.disposeFilterWrapper(filterWrapper);
        });
    };
    FilterManager.prototype.assertMethodHasNoParameters = function (theMethod) {
        var getRowsParams = utils_1.Utils.getFunctionParameters(theMethod);
        if (getRowsParams.length > 0) {
            console.warn('ag-grid: It looks like your filter is of the old type and expecting parameters in the constructor.');
            console.warn('ag-grid: From ag-grid 1.14, the constructor should take no parameters and init() used instead.');
        }
    };
    __decorate([
        context_1.Autowired('$compile'), 
        __metadata('design:type', Object)
    ], FilterManager.prototype, "$compile", void 0);
    __decorate([
        context_1.Autowired('$scope'), 
        __metadata('design:type', Object)
    ], FilterManager.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], FilterManager.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('gridCore'), 
        __metadata('design:type', Object)
    ], FilterManager.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('popupService'), 
        __metadata('design:type', popupService_1.PopupService)
    ], FilterManager.prototype, "popupService", void 0);
    __decorate([
        context_1.Autowired('valueService'), 
        __metadata('design:type', valueService_1.ValueService)
    ], FilterManager.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], FilterManager.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], FilterManager.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], FilterManager.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('enterprise'), 
        __metadata('design:type', Boolean)
    ], FilterManager.prototype, "enterprise", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], FilterManager.prototype, "context", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], FilterManager.prototype, "init", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], FilterManager.prototype, "destroy", null);
    FilterManager = __decorate([
        context_1.Bean('filterManager'), 
        __metadata('design:paramtypes', [])
    ], FilterManager);
    return FilterManager;
}());
exports.FilterManager = FilterManager;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/filter/numberFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var NumberFilter = (function () {
    function NumberFilter() {
    }
    NumberFilter.prototype.init = function (params) {
        this.filterParams = params;
        this.applyActive = params.apply === true;
        this.newRowsActionKeep = params.newRowsAction === 'keep';
        this.filterNumber = null;
        this.filterType = NumberFilter.EQUALS;
        this.createGui();
    };
    NumberFilter.prototype.onNewRowsLoaded = function () {
        if (!this.newRowsActionKeep) {
            this.setType(NumberFilter.EQUALS);
            this.setFilter(null);
        }
    };
    NumberFilter.prototype.afterGuiAttached = function () {
        this.eFilterTextField.focus();
    };
    NumberFilter.prototype.doesFilterPass = function (params) {
        if (this.filterNumber === null) {
            return true;
        }
        var value = this.filterParams.valueGetter(params.node);
        if (!value && value !== 0) {
            return false;
        }
        var valueAsNumber;
        if (typeof value === 'number') {
            valueAsNumber = value;
        }
        else {
            valueAsNumber = parseFloat(value);
        }
        switch (this.filterType) {
            case NumberFilter.EQUALS:
                return valueAsNumber === this.filterNumber;
            case NumberFilter.LESS_THAN:
                return valueAsNumber < this.filterNumber;
            case NumberFilter.GREATER_THAN:
                return valueAsNumber > this.filterNumber;
            case NumberFilter.LESS_THAN_OR_EQUAL:
                return valueAsNumber <= this.filterNumber;
            case NumberFilter.GREATER_THAN_OR_EQUAL:
                return valueAsNumber >= this.filterNumber;
            case NumberFilter.NOT_EQUAL:
                return valueAsNumber != this.filterNumber;
            default:
                // should never happen
                console.warn('invalid filter type ' + this.filterType);
                return false;
        }
    };
    NumberFilter.prototype.getGui = function () {
        return this.eGui;
    };
    NumberFilter.prototype.isFilterActive = function () {
        return this.filterNumber !== null;
    };
    NumberFilter.prototype.createTemplate = function () {
        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
        return "<div>\n                    <div>\n                        <select class=\"ag-filter-select\" id=\"filterType\">\n                            <option value=\"" + NumberFilter.EQUALS + "\">" + translate('equals', 'Equals') + "</option>\n                            <option value=\"" + NumberFilter.NOT_EQUAL + "\">" + translate('notEqual', 'Not equal') + "</option>\n                            <option value=\"" + NumberFilter.LESS_THAN + "\">" + translate('lessThan', 'Less than') + "</option>\n                            <option value=\"" + NumberFilter.LESS_THAN_OR_EQUAL + "\">" + translate('lessThanOrEqual', 'Less than or equal') + "</option>\n                            <option value=\"" + NumberFilter.GREATER_THAN + "\">" + translate('greaterThan', 'Greater than') + "</option>\n                            <option value=\"" + NumberFilter.GREATER_THAN_OR_EQUAL + "\">" + translate('greaterThanOrEqual', 'Greater than or equal') + "</option>\n                        </select>\n                    </div>\n                    <div>\n                        <input class=\"ag-filter-filter\" id=\"filterText\" type=\"text\" placeholder=\"" + translate('filterOoo', 'Filter...') + "\"/>\n                    </div>\n                    <div class=\"ag-filter-apply-panel\" id=\"applyPanel\">\n                        <button type=\"button\" id=\"applyButton\">" + translate('applyFilter', 'Apply Filter') + "</button>\n                    </div>\n                </div>";
    };
    NumberFilter.prototype.createGui = function () {
        this.eGui = utils_1.Utils.loadTemplate(this.createTemplate());
        this.eFilterTextField = this.eGui.querySelector("#filterText");
        this.eTypeSelect = this.eGui.querySelector("#filterType");
        utils_1.Utils.addChangeListener(this.eFilterTextField, this.onFilterChanged.bind(this));
        this.eTypeSelect.addEventListener("change", this.onTypeChanged.bind(this));
        this.setupApply();
    };
    NumberFilter.prototype.setupApply = function () {
        var _this = this;
        if (this.applyActive) {
            this.eApplyButton = this.eGui.querySelector('#applyButton');
            this.eApplyButton.addEventListener('click', function () {
                _this.filterParams.filterChangedCallback();
            });
        }
        else {
            utils_1.Utils.removeElement(this.eGui, '#applyPanel');
        }
    };
    NumberFilter.prototype.onTypeChanged = function () {
        this.filterType = this.eTypeSelect.value;
        this.filterChanged();
    };
    NumberFilter.prototype.filterChanged = function () {
        this.filterParams.filterModifiedCallback();
        if (!this.applyActive) {
            this.filterParams.filterChangedCallback();
        }
    };
    NumberFilter.prototype.onFilterChanged = function () {
        var filterText = utils_1.Utils.makeNull(this.eFilterTextField.value);
        if (filterText && filterText.trim() === '') {
            filterText = null;
        }
        var newFilter;
        if (filterText !== null && filterText !== undefined) {
            newFilter = parseFloat(filterText);
        }
        else {
            newFilter = null;
        }
        if (this.filterNumber !== newFilter) {
            this.filterNumber = newFilter;
            this.filterChanged();
        }
    };
    NumberFilter.prototype.setType = function (type) {
        this.filterType = type;
        this.eTypeSelect.value = type;
    };
    NumberFilter.prototype.setFilter = function (filter) {
        filter = utils_1.Utils.makeNull(filter);
        if (filter !== null && !(typeof filter === 'number')) {
            filter = parseFloat(filter);
        }
        this.filterNumber = filter;
        this.eFilterTextField.value = filter;
    };
    NumberFilter.prototype.getFilter = function () {
        return this.filterNumber;
    };
    NumberFilter.prototype.getModel = function () {
        if (this.isFilterActive()) {
            return {
                type: this.filterType,
                filter: this.filterNumber
            };
        }
        else {
            return null;
        }
    };
    NumberFilter.prototype.setModel = function (model) {
        if (model) {
            this.setType(model.type);
            this.setFilter(model.filter);
        }
        else {
            this.setFilter(null);
        }
    };
    NumberFilter.EQUALS = 'equals'; // 1;
    NumberFilter.NOT_EQUAL = 'notEqual'; //2;
    NumberFilter.LESS_THAN = 'lessThan'; //3;
    NumberFilter.LESS_THAN_OR_EQUAL = 'lessThanOrEqual'; //4;
    NumberFilter.GREATER_THAN = 'greaterThan'; //5;
    NumberFilter.GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual'; //6;
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], NumberFilter.prototype, "gridOptionsWrapper", void 0);
    return NumberFilter;
}());
exports.NumberFilter = NumberFilter;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/filter/textFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var TextFilter = (function () {
    function TextFilter() {
    }
    TextFilter.prototype.init = function (params) {
        this.filterParams = params;
        this.applyActive = params.apply === true;
        this.newRowsActionKeep = params.newRowsAction === 'keep';
        this.filterText = null;
        this.filterType = TextFilter.CONTAINS;
        this.createGui();
    };
    TextFilter.prototype.onNewRowsLoaded = function () {
        if (!this.newRowsActionKeep) {
            this.setType(TextFilter.CONTAINS);
            this.setFilter(null);
        }
    };
    TextFilter.prototype.afterGuiAttached = function () {
        this.eFilterTextField.focus();
    };
    TextFilter.prototype.doesFilterPass = function (params) {
        if (!this.filterText) {
            return true;
        }
        var value = this.filterParams.valueGetter(params.node);
        if (!value) {
            if (this.filterType === TextFilter.NOT_EQUALS) {
                // if there is no value, but the filter type was 'not equals',
                // then it should pass, as a missing value is not equal whatever
                // the user is filtering on
                return true;
            }
            else {
                // otherwise it's some type of comparison, to which empty value
                // will always fail
                return false;
            }
        }
        var valueLowerCase = value.toString().toLowerCase();
        switch (this.filterType) {
            case TextFilter.CONTAINS:
                return valueLowerCase.indexOf(this.filterText) >= 0;
            case TextFilter.EQUALS:
                return valueLowerCase === this.filterText;
            case TextFilter.NOT_EQUALS:
                return valueLowerCase != this.filterText;
            case TextFilter.STARTS_WITH:
                return valueLowerCase.indexOf(this.filterText) === 0;
            case TextFilter.ENDS_WITH:
                var index = valueLowerCase.lastIndexOf(this.filterText);
                return index >= 0 && index === (valueLowerCase.length - this.filterText.length);
            default:
                // should never happen
                console.warn('invalid filter type ' + this.filterType);
                return false;
        }
    };
    TextFilter.prototype.getGui = function () {
        return this.eGui;
    };
    TextFilter.prototype.isFilterActive = function () {
        return this.filterText !== null;
    };
    TextFilter.prototype.createTemplate = function () {
        var translate = this.gridOptionsWrapper.getLocaleTextFunc();
        return "<div>\n                    <div>\n                        <select class=\"ag-filter-select\" id=\"filterType\">\n                        <option value=\"" + TextFilter.CONTAINS + "\">" + translate('contains', 'Contains') + "</option>\n                        <option value=\"" + TextFilter.EQUALS + "\">" + translate('equals', 'Equals') + "</option>\n                        <option value=\"" + TextFilter.NOT_EQUALS + "\">" + translate('notEquals', 'Not equals') + "</option>\n                        <option value=\"" + TextFilter.STARTS_WITH + "\">" + translate('startsWith', 'Starts with') + "</option>\n                        <option value=\"" + TextFilter.ENDS_WITH + "\">" + translate('endsWith', 'Ends with') + "</option>\n                        </select>\n                    </div>\n                    <div>\n                        <input class=\"ag-filter-filter\" id=\"filterText\" type=\"text\" placeholder=\"" + translate('filterOoo', 'Filter...') + "\"/>\n                    </div>\n                    <div class=\"ag-filter-apply-panel\" id=\"applyPanel\">\n                        <button type=\"button\" id=\"applyButton\">" + translate('applyFilter', 'Apply Filter') + "</button>\n                    </div>\n                </div>";
    };
    TextFilter.prototype.createGui = function () {
        this.eGui = utils_1.Utils.loadTemplate(this.createTemplate());
        this.eFilterTextField = this.eGui.querySelector("#filterText");
        this.eTypeSelect = this.eGui.querySelector("#filterType");
        utils_1.Utils.addChangeListener(this.eFilterTextField, this.onFilterChanged.bind(this));
        this.eTypeSelect.addEventListener("change", this.onTypeChanged.bind(this));
        this.setupApply();
    };
    TextFilter.prototype.setupApply = function () {
        var _this = this;
        if (this.applyActive) {
            this.eApplyButton = this.eGui.querySelector('#applyButton');
            this.eApplyButton.addEventListener('click', function () {
                _this.filterParams.filterChangedCallback();
            });
        }
        else {
            utils_1.Utils.removeElement(this.eGui, '#applyPanel');
        }
    };
    TextFilter.prototype.onTypeChanged = function () {
        this.filterType = this.eTypeSelect.value;
        this.filterChanged();
    };
    TextFilter.prototype.onFilterChanged = function () {
        var filterText = utils_1.Utils.makeNull(this.eFilterTextField.value);
        if (filterText && filterText.trim() === '') {
            filterText = null;
        }
        var newFilterText;
        if (filterText !== null && filterText !== undefined) {
            newFilterText = filterText.toLowerCase();
        }
        else {
            newFilterText = null;
        }
        if (this.filterText !== newFilterText) {
            this.filterText = newFilterText;
            this.filterChanged();
        }
    };
    TextFilter.prototype.filterChanged = function () {
        this.filterParams.filterModifiedCallback();
        if (!this.applyActive) {
            this.filterParams.filterChangedCallback();
        }
    };
    TextFilter.prototype.setType = function (type) {
        this.filterType = type;
        this.eTypeSelect.value = type;
    };
    TextFilter.prototype.setFilter = function (filter) {
        filter = utils_1.Utils.makeNull(filter);
        if (filter) {
            this.filterText = filter.toLowerCase();
            this.eFilterTextField.value = filter;
        }
        else {
            this.filterText = null;
            this.eFilterTextField.value = null;
        }
    };
    TextFilter.prototype.getType = function () {
        return this.filterType;
    };
    TextFilter.prototype.getFilter = function () {
        return this.filterText;
    };
    TextFilter.prototype.getModel = function () {
        if (this.isFilterActive()) {
            return {
                type: this.filterType,
                filter: this.filterText
            };
        }
        else {
            return null;
        }
    };
    TextFilter.prototype.setModel = function (model) {
        if (model) {
            this.setType(model.type);
            this.setFilter(model.filter);
        }
        else {
            this.setFilter(null);
        }
    };
    TextFilter.CONTAINS = 'contains'; //1;
    TextFilter.EQUALS = 'equals'; //2;
    TextFilter.NOT_EQUALS = 'notEquals'; //3;
    TextFilter.STARTS_WITH = 'startsWith'; //4;
    TextFilter.ENDS_WITH = 'endsWith'; //5;
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], TextFilter.prototype, "gridOptionsWrapper", void 0);
    return TextFilter;
}());
exports.TextFilter = TextFilter;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/focusedCellController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridCell.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var FocusedCellController = (function () {
    function FocusedCellController() {
    }
    FocusedCellController.prototype.init = function () {
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_GROUP_OPENED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_MOVED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PINNED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearFocusedCell.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VISIBLE, this.clearFocusedCell.bind(this));
    };
    FocusedCellController.prototype.clearFocusedCell = function () {
        this.focusedCell = null;
        this.onCellFocused(false);
    };
    FocusedCellController.prototype.getFocusedCell = function () {
        return this.focusedCell;
    };
    // we check if the browser is focusing something, and if it is, and
    // it's the cell we think is focused, then return the cell. so this
    // methods returns the cell if a) we think it has focus and b) the
    // browser thinks it has focus. this then returns nothing if we
    // first focus a cell, then second click outside the grid, as then the
    // grid cell will still be focused as far as the grid is concerned,
    // however the browser focus will have moved somewhere else.
    FocusedCellController.prototype.getFocusCellToUseAfterRefresh = function () {
        if (this.gridOptionsWrapper.isSuppressFocusAfterRefresh()) {
            return null;
        }
        if (!this.focusedCell) {
            return null;
        }
        var browserFocusedCell = this.getGridCellForDomElement(document.activeElement);
        if (!browserFocusedCell) {
            return null;
        }
        var gridFocusId = this.focusedCell.createId();
        var browserFocusId = browserFocusedCell.createId();
        if (gridFocusId === browserFocusId) {
            return this.focusedCell;
        }
        else {
            return null;
        }
    };
    FocusedCellController.prototype.getGridCellForDomElement = function (eBrowserCell) {
        if (!eBrowserCell) {
            return null;
        }
        var column = null;
        var row = null;
        var floating = null;
        var that = this;
        while (eBrowserCell) {
            checkRow(eBrowserCell);
            checkColumn(eBrowserCell);
            eBrowserCell = eBrowserCell.parentNode;
        }
        if (utils_1.Utils.exists(column) && utils_1.Utils.exists(row)) {
            var gridCell = new gridCell_1.GridCell({ rowIndex: row, floating: floating, column: column });
            return gridCell;
        }
        else {
            return null;
        }
        function checkRow(eTarget) {
            // match the column by checking a) it has a valid colId and b) it has the 'ag-cell' class
            var rowId = utils_1.Utils.getElementAttribute(eTarget, 'row');
            if (utils_1.Utils.exists(rowId) && utils_1.Utils.containsClass(eTarget, 'ag-row')) {
                if (rowId.indexOf('ft') === 0) {
                    floating = constants_1.Constants.FLOATING_TOP;
                    rowId = rowId.substr(3);
                }
                else if (rowId.indexOf('fb') === 0) {
                    floating = constants_1.Constants.FLOATING_BOTTOM;
                    rowId = rowId.substr(3);
                }
                else {
                    floating = null;
                }
                row = parseInt(rowId);
            }
        }
        function checkColumn(eTarget) {
            // match the column by checking a) it has a valid colId and b) it has the 'ag-cell' class
            var colId = utils_1.Utils.getElementAttribute(eTarget, 'colid');
            if (utils_1.Utils.exists(colId) && utils_1.Utils.containsClass(eTarget, 'ag-cell')) {
                var foundColumn = that.columnController.getGridColumn(colId);
                if (foundColumn) {
                    column = foundColumn;
                }
            }
        }
    };
    FocusedCellController.prototype.setFocusedCell = function (rowIndex, colKey, floating, forceBrowserFocus) {
        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
        if (this.gridOptionsWrapper.isSuppressCellSelection()) {
            return;
        }
        var column = utils_1.Utils.makeNull(this.columnController.getGridColumn(colKey));
        this.focusedCell = new gridCell_1.GridCell({ rowIndex: rowIndex,
            floating: utils_1.Utils.makeNull(floating),
            column: column });
        this.onCellFocused(forceBrowserFocus);
    };
    FocusedCellController.prototype.isCellFocused = function (gridCell) {
        if (utils_1.Utils.missing(this.focusedCell)) {
            return false;
        }
        return this.focusedCell.column === gridCell.column && this.isRowFocused(gridCell.rowIndex, gridCell.floating);
    };
    FocusedCellController.prototype.isRowFocused = function (rowIndex, floating) {
        if (utils_1.Utils.missing(this.focusedCell)) {
            return false;
        }
        var floatingOrNull = utils_1.Utils.makeNull(floating);
        return this.focusedCell.rowIndex === rowIndex && this.focusedCell.floating === floatingOrNull;
    };
    FocusedCellController.prototype.onCellFocused = function (forceBrowserFocus) {
        var event = {
            rowIndex: null,
            column: null,
            floating: null,
            forceBrowserFocus: forceBrowserFocus
        };
        if (this.focusedCell) {
            event.rowIndex = this.focusedCell.rowIndex;
            event.column = this.focusedCell.column;
            event.floating = this.focusedCell.floating;
        }
        this.eventService.dispatchEvent(events_1.Events.EVENT_CELL_FOCUSED, event);
    };
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], FocusedCellController.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], FocusedCellController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], FocusedCellController.prototype, "columnController", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], FocusedCellController.prototype, "init", null);
    FocusedCellController = __decorate([
        context_1.Bean('focusedCellController'), 
        __metadata('design:paramtypes', [])
    ], FocusedCellController);
    return FocusedCellController;
}());
exports.FocusedCellController = FocusedCellController;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/functions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
function defaultGroupComparator(valueA, valueB, nodeA, nodeB) {
    var nodeAIsGroup = utils_1.Utils.exists(nodeA) && nodeA.group;
    var nodeBIsGroup = utils_1.Utils.exists(nodeB) && nodeB.group;
    var bothAreGroups = nodeAIsGroup && nodeBIsGroup;
    var bothAreNormal = !nodeAIsGroup && !nodeBIsGroup;
    if (bothAreGroups) {
        return utils_1.Utils.defaultComparator(nodeA.key, nodeB.key);
    }
    else if (bothAreNormal) {
        return utils_1.Utils.defaultComparator(valueA, valueB);
    }
    else if (nodeAIsGroup) {
        return 1;
    }
    else {
        return -1;
    }
}
exports.defaultGroupComparator = defaultGroupComparator;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/grid.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var paginationController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/paginationController.js");
var floatingRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/floatingRowModel.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var rowRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/rowRenderer.js");
var headerRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerRenderer.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var valueService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/valueService.js");
var masterSlaveService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/masterSlaveService.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var gridApi_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridApi.js");
var headerTemplateLoader_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerTemplateLoader.js");
var balancedColumnTreeBuilder_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/balancedColumnTreeBuilder.js");
var displayedGroupCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/displayedGroupCreator.js");
var expressionService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/expressionService.js");
var templateService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/templateService.js");
var popupService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/popupService.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var columnUtils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnUtils.js");
var autoWidthCalculator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/autoWidthCalculator.js");
var horizontalDragService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/horizontalDragService.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var csvCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/csvCreator.js");
var gridCore_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridCore.js");
var standardMenu_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/standardMenu.js");
var dragAndDropService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragAndDropService.js");
var dragService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragService.js");
var sortController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/sortController.js");
var focusedCellController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/focusedCellController.js");
var mouseEventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/mouseEventService.js");
var cellNavigationService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/cellNavigationService.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var filterStage_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/filterStage.js");
var sortStage_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/sortStage.js");
var flattenStage_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/flattenStage.js");
var focusService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/misc/focusService.js");
var cellEditorFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditorFactory.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var virtualPageRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/virtualPagination/virtualPageRowModel.js");
var inMemoryRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/inMemoryRowModel.js");
var cellRendererFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererFactory.js");
var cellRendererService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererService.js");
var valueFormatterService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/valueFormatterService.js");
var agCheckbox_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/agCheckbox.js");
var baseFrameworkFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/baseFrameworkFactory.js");
var scrollVisibleService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/scrollVisibleService.js");
var downloader_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/downloader.js");
var xmlFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/xmlFactory.js");
var gridSerializer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridSerializer.js");
var stylingService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/styling/stylingService.js");
var Grid = (function () {
    function Grid(eGridDiv, gridOptions, params) {
        if (!eGridDiv) {
            console.error('ag-Grid: no div element provided to the grid');
        }
        if (!gridOptions) {
            console.error('ag-Grid: no gridOptions provided to the grid');
        }
        var rowModelClass = this.getRowModelClass(gridOptions);
        var enterprise = utils_1.Utils.exists(Grid.enterpriseBeans);
        var frameworkFactory = params ? params.frameworkFactory : null;
        if (utils_1.Utils.missing(frameworkFactory)) {
            frameworkFactory = new baseFrameworkFactory_1.BaseFrameworkFactory();
        }
        this.context = new context_1.Context({
            overrideBeans: Grid.enterpriseBeans,
            seed: {
                enterprise: enterprise,
                gridOptions: gridOptions,
                eGridDiv: eGridDiv,
                $scope: params ? params.$scope : null,
                $compile: params ? params.$compile : null,
                quickFilterOnScope: params ? params.quickFilterOnScope : null,
                globalEventListener: params ? params.globalEventListener : null,
                frameworkFactory: frameworkFactory
            },
            beans: [rowModelClass, cellRendererFactory_1.CellRendererFactory, horizontalDragService_1.HorizontalDragService, headerTemplateLoader_1.HeaderTemplateLoader, floatingRowModel_1.FloatingRowModel, dragService_1.DragService,
                displayedGroupCreator_1.DisplayedGroupCreator, eventService_1.EventService, gridOptionsWrapper_1.GridOptionsWrapper, selectionController_1.SelectionController,
                filterManager_1.FilterManager, columnController_1.ColumnController, rowRenderer_1.RowRenderer,
                headerRenderer_1.HeaderRenderer, expressionService_1.ExpressionService, balancedColumnTreeBuilder_1.BalancedColumnTreeBuilder, csvCreator_1.CsvCreator, downloader_1.Downloader, xmlFactory_1.XmlFactory,
                gridSerializer_1.GridSerializer, templateService_1.TemplateService, gridPanel_1.GridPanel, popupService_1.PopupService, valueService_1.ValueService, masterSlaveService_1.MasterSlaveService,
                logger_1.LoggerFactory, columnUtils_1.ColumnUtils, autoWidthCalculator_1.AutoWidthCalculator, gridApi_1.GridApi,
                paginationController_1.PaginationController, popupService_1.PopupService, gridCore_1.GridCore, standardMenu_1.StandardMenuFactory,
                dragAndDropService_1.DragAndDropService, sortController_1.SortController, columnController_1.ColumnApi, focusedCellController_1.FocusedCellController, mouseEventService_1.MouseEventService,
                cellNavigationService_1.CellNavigationService, filterStage_1.FilterStage, sortStage_1.SortStage, flattenStage_1.FlattenStage, focusService_1.FocusService,
                cellEditorFactory_1.CellEditorFactory, cellRendererService_1.CellRendererService, valueFormatterService_1.ValueFormatterService, stylingService_1.StylingService, scrollVisibleService_1.ScrollVisibleService],
            components: [
                { componentName: 'AgCheckbox', theClass: agCheckbox_1.AgCheckbox }
            ],
            debug: !!gridOptions.debug
        });
        var eventService = this.context.getBean('eventService');
        var readyEvent = {
            api: gridOptions.api,
            columnApi: gridOptions.columnApi
        };
        eventService.dispatchEvent(events_1.Events.EVENT_GRID_READY, readyEvent);
        if (gridOptions.debug) {
            console.log('ag-Grid -> initialised successfully, enterprise = ' + enterprise);
        }
    }
    Grid.setEnterpriseBeans = function (enterpriseBeans, rowModelClasses) {
        this.enterpriseBeans = enterpriseBeans;
        // the enterprise can inject additional row models. this is how it injects the viewportRowModel
        utils_1.Utils.iterateObject(rowModelClasses, function (key, value) { return Grid.RowModelClasses[key] = value; });
    };
    Grid.prototype.getRowModelClass = function (gridOptions) {
        var rowModelType = gridOptions.rowModelType;
        if (utils_1.Utils.exists(rowModelType)) {
            var rowModelClass = Grid.RowModelClasses[rowModelType];
            if (utils_1.Utils.exists(rowModelClass)) {
                return rowModelClass;
            }
            else {
                console.error('ag-Grid: count not find matching row model for rowModelType ' + rowModelType);
                if (rowModelType === 'viewport') {
                    console.error('ag-Grid: rowModelType viewport is only available in ag-Grid Enterprise');
                }
            }
        }
        return inMemoryRowModel_1.InMemoryRowModel;
    };
    ;
    Grid.prototype.destroy = function () {
        this.context.destroy();
    };
    // the default is InMemoryRowModel, which is also used for pagination.
    // the enterprise adds viewport to this list.
    Grid.RowModelClasses = {
        virtual: virtualPageRowModel_1.VirtualPageRowModel,
        pagination: inMemoryRowModel_1.InMemoryRowModel,
        normal: inMemoryRowModel_1.InMemoryRowModel
    };
    return Grid;
}());
exports.Grid = Grid;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/gridApi.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var csvCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/csvCreator.js");
var rowRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/rowRenderer.js");
var headerRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerRenderer.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var valueService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/valueService.js");
var masterSlaveService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/masterSlaveService.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var floatingRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/floatingRowModel.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridCore_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridCore.js");
var sortController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/sortController.js");
var paginationController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/paginationController.js");
var focusedCellController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/focusedCellController.js");
var gridCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridCell.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var cellRendererFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererFactory.js");
var cellEditorFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditorFactory.js");
var GridApi = (function () {
    function GridApi() {
    }
    GridApi.prototype.init = function () {
        switch (this.rowModel.getType()) {
            case constants_1.Constants.ROW_MODEL_TYPE_NORMAL:
            case constants_1.Constants.ROW_MODEL_TYPE_PAGINATION:
                this.inMemoryRowModel = this.rowModel;
                break;
            case constants_1.Constants.ROW_MODEL_TYPE_VIRTUAL:
                this.virtualPageRowModel = this.rowModel;
                break;
        }
    };
    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */
    GridApi.prototype.__getMasterSlaveService = function () {
        return this.masterSlaveService;
    };
    GridApi.prototype.getFirstRenderedRow = function () {
        return this.rowRenderer.getFirstVirtualRenderedRow();
    };
    GridApi.prototype.getLastRenderedRow = function () {
        return this.rowRenderer.getLastVirtualRenderedRow();
    };
    GridApi.prototype.getDataAsCsv = function (params) {
        return this.csvCreator.getDataAsCsv(params);
    };
    GridApi.prototype.exportDataAsCsv = function (params) {
        this.csvCreator.exportDataAsCsv(params);
    };
    GridApi.prototype.getDataAsExcel = function (params) {
        if (!this.excelCreator) {
            console.warn('ag-Grid: Excel export is only available in ag-Grid Enterprise');
        }
        return this.excelCreator.getDataAsExcelXml(params);
    };
    GridApi.prototype.exportDataAsExcel = function (params) {
        if (!this.excelCreator) {
            console.warn('ag-Grid: Excel export is only available in ag-Grid Enterprise');
        }
        this.excelCreator.exportDataAsExcel(params);
    };
    GridApi.prototype.setDatasource = function (datasource) {
        if (this.gridOptionsWrapper.isRowModelPagination()) {
            this.paginationController.setDatasource(datasource);
        }
        else if (this.gridOptionsWrapper.isRowModelVirtual()) {
            this.rowModel.setDatasource(datasource);
        }
        else {
            console.warn("ag-Grid: you can only use a datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_VIRTUAL + "' or '" + constants_1.Constants.ROW_MODEL_TYPE_PAGINATION + "'");
        }
    };
    GridApi.prototype.setViewportDatasource = function (viewportDatasource) {
        if (this.gridOptionsWrapper.isRowModelViewport()) {
            // this is bad coding, because it's using an interface that's exposed in the enterprise.
            // really we should create an interface in the core for viewportDatasource and let
            // the enterprise implement it, rather than casting to 'any' here
            this.rowModel.setViewportDatasource(viewportDatasource);
        }
        else {
            console.warn("ag-Grid: you can only use a viewport datasource when gridOptions.rowModelType is '" + constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT + "'");
        }
    };
    GridApi.prototype.setRowData = function (rowData) {
        if (this.gridOptionsWrapper.isRowModelDefault()) {
            this.selectionController.reset();
            this.inMemoryRowModel.setRowData(rowData, true);
        }
        else {
            console.log('cannot call setRowData unless using normal row model');
        }
    };
    GridApi.prototype.setFloatingTopRowData = function (rows) {
        this.floatingRowModel.setFloatingTopRowData(rows);
    };
    GridApi.prototype.setFloatingBottomRowData = function (rows) {
        this.floatingRowModel.setFloatingBottomRowData(rows);
    };
    GridApi.prototype.getFloatingTopRowCount = function () {
        return this.floatingRowModel.getFloatingTopRowCount();
    };
    GridApi.prototype.getFloatingBottomRowCount = function () {
        return this.floatingRowModel.getFloatingBottomRowCount();
    };
    GridApi.prototype.getFloatingTopRow = function (index) {
        return this.floatingRowModel.getFloatingTopRow(index);
    };
    GridApi.prototype.getFloatingBottomRow = function (index) {
        return this.floatingRowModel.getFloatingBottomRow(index);
    };
    GridApi.prototype.setColumnDefs = function (colDefs) {
        this.columnController.setColumnDefs(colDefs);
    };
    GridApi.prototype.refreshRows = function (rowNodes) {
        this.rowRenderer.refreshRows(rowNodes);
    };
    GridApi.prototype.refreshCells = function (rowNodes, colIds, animate) {
        if (animate === void 0) { animate = false; }
        this.rowRenderer.refreshCells(rowNodes, colIds, animate);
    };
    GridApi.prototype.rowDataChanged = function (rows) {
        console.log('ag-Grid: rowDataChanged is deprecated, either call refreshView() to refresh everything, or call rowNode.setRowData(newData) to set value on a particular node');
        this.refreshView();
    };
    GridApi.prototype.refreshView = function () {
        this.rowRenderer.refreshView();
    };
    GridApi.prototype.setFunctionsReadOnly = function (readOnly) {
        this.gridOptionsWrapper.setProperty('functionsReadOnly', readOnly);
    };
    GridApi.prototype.softRefreshView = function () {
        this.rowRenderer.softRefreshView();
    };
    GridApi.prototype.refreshGroupRows = function () {
        this.rowRenderer.refreshGroupRows();
    };
    GridApi.prototype.refreshHeader = function () {
        // need to review this - the refreshHeader should also refresh all icons in the header
        this.headerRenderer.refreshHeader();
    };
    GridApi.prototype.isAnyFilterPresent = function () {
        return this.filterManager.isAnyFilterPresent();
    };
    GridApi.prototype.isAdvancedFilterPresent = function () {
        return this.filterManager.isAdvancedFilterPresent();
    };
    GridApi.prototype.isQuickFilterPresent = function () {
        return this.filterManager.isQuickFilterPresent();
    };
    GridApi.prototype.getModel = function () {
        return this.rowModel;
    };
    GridApi.prototype.onGroupExpandedOrCollapsed = function (deprecated_refreshFromIndex) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('ag-Grid: cannot call onGroupExpandedOrCollapsed unless using normal row model');
        }
        if (utils_1.Utils.exists(deprecated_refreshFromIndex)) {
            console.log('ag-Grid: api.onGroupExpandedOrCollapsed - refreshFromIndex parameter is not longer used, the grid will refresh all rows');
        }
        // we don't really want the user calling this if one one rowNode was expanded, instead they should be
        // calling rowNode.setExpanded(boolean) - this way we do a 'keepRenderedRows=false' so that the whole
        // grid gets refreshed again - otherwise the row with the rowNodes that were changed won't get updated,
        // and thus the expand icon in the group cell won't get 'opened' or 'closed'.
        this.inMemoryRowModel.refreshModel({ step: constants_1.Constants.STEP_MAP });
    };
    GridApi.prototype.refreshInMemoryRowModel = function () {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call refreshInMemoryRowModel unless using normal row model');
        }
        this.inMemoryRowModel.refreshModel({ step: constants_1.Constants.STEP_EVERYTHING });
    };
    GridApi.prototype.expandAll = function () {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call expandAll unless using normal row model');
        }
        this.inMemoryRowModel.expandOrCollapseAll(true);
    };
    GridApi.prototype.collapseAll = function () {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call collapseAll unless using normal row model');
        }
        this.inMemoryRowModel.expandOrCollapseAll(false);
    };
    GridApi.prototype.addVirtualRowListener = function (eventName, rowIndex, callback) {
        if (typeof eventName !== 'string') {
            console.log('ag-Grid: addVirtualRowListener is deprecated, please use addRenderedRowListener.');
        }
        this.addRenderedRowListener(eventName, rowIndex, callback);
    };
    GridApi.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
        if (eventName === 'virtualRowRemoved') {
            console.log('ag-Grid: event virtualRowRemoved is deprecated, now called renderedRowRemoved');
            eventName = '' +
                '';
        }
        if (eventName === 'virtualRowSelected') {
            console.log('ag-Grid: event virtualRowSelected is deprecated, to register for individual row ' +
                'selection events, add a listener directly to the row node.');
        }
        this.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
    };
    GridApi.prototype.setQuickFilter = function (newFilter) {
        this.filterManager.setQuickFilter(newFilter);
    };
    GridApi.prototype.selectIndex = function (index, tryMulti, suppressEvents) {
        console.log('ag-Grid: do not use api for selection, call node.setSelected(value) instead');
        if (suppressEvents) {
            console.log('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
        }
        this.selectionController.selectIndex(index, tryMulti);
    };
    GridApi.prototype.deselectIndex = function (index, suppressEvents) {
        if (suppressEvents === void 0) { suppressEvents = false; }
        console.log('ag-Grid: do not use api for selection, call node.setSelected(value) instead');
        if (suppressEvents) {
            console.log('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
        }
        this.selectionController.deselectIndex(index);
    };
    GridApi.prototype.selectNode = function (node, tryMulti, suppressEvents) {
        if (tryMulti === void 0) { tryMulti = false; }
        if (suppressEvents === void 0) { suppressEvents = false; }
        console.log('ag-Grid: API for selection is deprecated, call node.setSelected(value) instead');
        if (suppressEvents) {
            console.log('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
        }
        node.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
    };
    GridApi.prototype.deselectNode = function (node, suppressEvents) {
        if (suppressEvents === void 0) { suppressEvents = false; }
        console.log('ag-Grid: API for selection is deprecated, call node.setSelected(value) instead');
        if (suppressEvents) {
            console.log('ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it');
        }
        node.setSelectedParams({ newValue: false });
    };
    GridApi.prototype.selectAll = function () {
        this.selectionController.selectAllRowNodes();
    };
    GridApi.prototype.deselectAll = function () {
        this.selectionController.deselectAllRowNodes();
    };
    GridApi.prototype.recomputeAggregates = function () {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call recomputeAggregates unless using normal row model');
        }
        this.inMemoryRowModel.refreshModel({ step: constants_1.Constants.STEP_AGGREGATE });
    };
    GridApi.prototype.sizeColumnsToFit = function () {
        if (this.gridOptionsWrapper.isForPrint()) {
            console.warn('ag-grid: sizeColumnsToFit does not work when forPrint=true');
            return;
        }
        this.gridPanel.sizeColumnsToFit();
    };
    GridApi.prototype.showLoadingOverlay = function () {
        this.gridPanel.showLoadingOverlay();
    };
    GridApi.prototype.showNoRowsOverlay = function () {
        this.gridPanel.showNoRowsOverlay();
    };
    GridApi.prototype.hideOverlay = function () {
        this.gridPanel.hideOverlay();
    };
    GridApi.prototype.isNodeSelected = function (node) {
        console.log('ag-Grid: no need to call api.isNodeSelected(), just call node.isSelected() instead');
        return node.isSelected();
    };
    GridApi.prototype.getSelectedNodesById = function () {
        console.error('ag-Grid: since version 3.4, getSelectedNodesById no longer exists, use getSelectedNodes() instead');
        return null;
    };
    GridApi.prototype.getSelectedNodes = function () {
        return this.selectionController.getSelectedNodes();
    };
    GridApi.prototype.getSelectedRows = function () {
        return this.selectionController.getSelectedRows();
    };
    GridApi.prototype.getBestCostNodeSelection = function () {
        return this.selectionController.getBestCostNodeSelection();
    };
    GridApi.prototype.getRenderedNodes = function () {
        return this.rowRenderer.getRenderedNodes();
    };
    GridApi.prototype.ensureColIndexVisible = function (index) {
        console.warn('ag-Grid: ensureColIndexVisible(index) no longer supported, use ensureColumnVisible(colKey) instead.');
    };
    GridApi.prototype.ensureColumnVisible = function (key) {
        this.gridPanel.ensureColumnVisible(key);
    };
    GridApi.prototype.ensureIndexVisible = function (index) {
        this.gridPanel.ensureIndexVisible(index);
    };
    GridApi.prototype.ensureNodeVisible = function (comparator) {
        this.gridCore.ensureNodeVisible(comparator);
    };
    GridApi.prototype.forEachLeafNode = function (callback) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call forEachNodeAfterFilter unless using normal row model');
        }
        this.inMemoryRowModel.forEachLeafNode(callback);
    };
    GridApi.prototype.forEachNode = function (callback) {
        this.rowModel.forEachNode(callback);
    };
    GridApi.prototype.forEachNodeAfterFilter = function (callback) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call forEachNodeAfterFilter unless using normal row model');
        }
        this.inMemoryRowModel.forEachNodeAfterFilter(callback);
    };
    GridApi.prototype.forEachNodeAfterFilterAndSort = function (callback) {
        if (utils_1.Utils.missing(this.inMemoryRowModel)) {
            console.log('cannot call forEachNodeAfterFilterAndSort unless using normal row model');
        }
        this.inMemoryRowModel.forEachNodeAfterFilterAndSort(callback);
    };
    GridApi.prototype.getFilterApiForColDef = function (colDef) {
        console.warn('ag-grid API method getFilterApiForColDef deprecated, use getFilterApi instead');
        return this.getFilterInstance(colDef);
    };
    GridApi.prototype.getFilterInstance = function (key) {
        var column = this.columnController.getPrimaryColumn(key);
        if (column) {
            return this.filterManager.getFilterComponent(column);
        }
    };
    GridApi.prototype.getFilterApi = function (key) {
        console.warn('ag-Grid: getFilterApi is deprecated, use getFilterInstance instead');
        return this.getFilterInstance(key);
    };
    GridApi.prototype.destroyFilter = function (key) {
        var column = this.columnController.getPrimaryColumn(key);
        if (column) {
            return this.filterManager.destroyFilter(column);
        }
    };
    GridApi.prototype.getColumnDef = function (key) {
        var column = this.columnController.getPrimaryColumn(key);
        if (column) {
            return column.getColDef();
        }
        else {
            return null;
        }
    };
    GridApi.prototype.onFilterChanged = function () {
        this.filterManager.onFilterChanged();
    };
    GridApi.prototype.onSortChanged = function () {
        this.sortController.onSortChanged();
    };
    GridApi.prototype.setSortModel = function (sortModel) {
        this.sortController.setSortModel(sortModel);
    };
    GridApi.prototype.getSortModel = function () {
        return this.sortController.getSortModel();
    };
    GridApi.prototype.setFilterModel = function (model) {
        this.filterManager.setFilterModel(model);
    };
    GridApi.prototype.getFilterModel = function () {
        return this.filterManager.getFilterModel();
    };
    GridApi.prototype.getFocusedCell = function () {
        return this.focusedCellController.getFocusedCell();
    };
    GridApi.prototype.clearFocusedCell = function () {
        return this.focusedCellController.clearFocusedCell();
    };
    GridApi.prototype.setFocusedCell = function (rowIndex, colKey, floating) {
        this.focusedCellController.setFocusedCell(rowIndex, colKey, floating, true);
    };
    GridApi.prototype.setHeaderHeight = function (headerHeight) {
        this.gridOptionsWrapper.setProperty(gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, headerHeight);
    };
    GridApi.prototype.showToolPanel = function (show) {
        this.gridCore.showToolPanel(show);
    };
    GridApi.prototype.isToolPanelShowing = function () {
        return this.gridCore.isToolPanelShowing();
    };
    GridApi.prototype.doLayout = function () {
        this.gridCore.doLayout();
    };
    GridApi.prototype.resetRowHeights = function () {
        if (utils_1.Utils.exists(this.inMemoryRowModel)) {
            this.inMemoryRowModel.resetRowHeights();
        }
    };
    GridApi.prototype.onRowHeightChanged = function () {
        if (utils_1.Utils.exists(this.inMemoryRowModel)) {
            this.inMemoryRowModel.onRowHeightChanged();
        }
    };
    GridApi.prototype.getValue = function (colKey, rowNode) {
        var column = this.columnController.getPrimaryColumn(colKey);
        if (utils_1.Utils.missing(column)) {
            column = this.columnController.getGridColumn(colKey);
        }
        if (utils_1.Utils.missing(column)) {
            return null;
        }
        else {
            return this.valueService.getValue(column, rowNode);
        }
    };
    GridApi.prototype.addEventListener = function (eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    };
    GridApi.prototype.addGlobalListener = function (listener) {
        this.eventService.addGlobalListener(listener);
    };
    GridApi.prototype.removeEventListener = function (eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    };
    GridApi.prototype.removeGlobalListener = function (listener) {
        this.eventService.removeGlobalListener(listener);
    };
    GridApi.prototype.dispatchEvent = function (eventType, event) {
        this.eventService.dispatchEvent(eventType, event);
    };
    GridApi.prototype.destroy = function () {
        this.context.destroy();
    };
    GridApi.prototype.resetQuickFilter = function () {
        this.rowModel.forEachNode(function (node) { return node.quickFilterAggregateText = null; });
    };
    GridApi.prototype.getRangeSelections = function () {
        if (this.rangeController) {
            return this.rangeController.getCellRanges();
        }
        else {
            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
            return null;
        }
    };
    GridApi.prototype.addRangeSelection = function (rangeSelection) {
        if (!this.rangeController) {
            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
        }
        this.rangeController.addRange(rangeSelection);
    };
    GridApi.prototype.clearRangeSelection = function () {
        if (!this.rangeController) {
            console.warn('ag-Grid: cell range selection is only available in ag-Grid Enterprise');
        }
        this.rangeController.clearSelection();
    };
    GridApi.prototype.copySelectedRowsToClipboard = function (includeHeader, columnKeys) {
        if (!this.clipboardService) {
            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
        }
        var column = null;
        this.clipboardService.copySelectedRowsToClipboard(includeHeader, columnKeys);
    };
    GridApi.prototype.copySelectedRangeToClipboard = function (includeHeader) {
        if (!this.clipboardService) {
            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
        }
        this.clipboardService.copySelectedRangeToClipboard(includeHeader);
    };
    GridApi.prototype.copySelectedRangeDown = function () {
        if (!this.clipboardService) {
            console.warn('ag-Grid: clipboard is only available in ag-Grid Enterprise');
        }
        this.clipboardService.copyRangeDown();
    };
    GridApi.prototype.showColumnMenuAfterButtonClick = function (colKey, buttonElement) {
        var column = this.columnController.getPrimaryColumn(colKey);
        this.menuFactory.showMenuAfterButtonClick(column, buttonElement);
    };
    GridApi.prototype.showColumnMenuAfterMouseClick = function (colKey, mouseEvent) {
        var column = this.columnController.getPrimaryColumn(colKey);
        this.menuFactory.showMenuAfterMouseEvent(column, mouseEvent);
    };
    GridApi.prototype.tabToNextCell = function () {
        return this.rowRenderer.tabToNextCell(false);
    };
    GridApi.prototype.tabToPreviousCell = function () {
        return this.rowRenderer.tabToNextCell(true);
    };
    GridApi.prototype.stopEditing = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        this.rowRenderer.stopEditing(cancel);
    };
    GridApi.prototype.startEditingCell = function (params) {
        var column = this.columnController.getGridColumn(params.colKey);
        var gridCellDef = { rowIndex: params.rowIndex, floating: null, column: column };
        var gridCell = new gridCell_1.GridCell(gridCellDef);
        this.rowRenderer.startEditingCell(gridCell, params.keyPress, params.charPress);
    };
    GridApi.prototype.addAggFunc = function (key, aggFunc) {
        if (this.aggFuncService) {
            this.aggFuncService.addAggFunc(key, aggFunc);
        }
    };
    GridApi.prototype.addAggFuncs = function (aggFuncs) {
        if (this.aggFuncService) {
            this.aggFuncService.addAggFuncs(aggFuncs);
        }
    };
    GridApi.prototype.clearAggFuncs = function () {
        if (this.aggFuncService) {
            this.aggFuncService.clear();
        }
    };
    GridApi.prototype.insertItemsAtIndex = function (index, items) {
        this.rowModel.insertItemsAtIndex(index, items);
    };
    GridApi.prototype.removeItems = function (rowNodes) {
        this.rowModel.removeItems(rowNodes);
    };
    GridApi.prototype.addItems = function (items) {
        this.rowModel.addItems(items);
    };
    GridApi.prototype.refreshVirtualPageCache = function () {
        if (this.virtualPageRowModel) {
            this.virtualPageRowModel.refreshVirtualPageCache();
        }
        else {
            console.warn("ag-Grid: api.refreshVirtualPageCache is only available when rowModelType='virtual'.");
        }
    };
    GridApi.prototype.purgeVirtualPageCache = function () {
        if (this.virtualPageRowModel) {
            this.virtualPageRowModel.purgeVirtualPageCache();
        }
        else {
            console.warn("ag-Grid: api.refreshVirtualPageCache is only available when rowModelType='virtual'.");
        }
    };
    GridApi.prototype.getVirtualRowCount = function () {
        if (this.virtualPageRowModel) {
            return this.virtualPageRowModel.getVirtualRowCount();
        }
        else {
            console.warn("ag-Grid: api.getVirtualRowCount is only available when rowModelType='virtual'.");
        }
    };
    GridApi.prototype.isMaxRowFound = function () {
        if (this.virtualPageRowModel) {
            return this.virtualPageRowModel.isMaxRowFound();
        }
        else {
            console.warn("ag-Grid: api.isMaxRowFound is only available when rowModelType='virtual'.");
        }
    };
    GridApi.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
        if (this.virtualPageRowModel) {
            this.virtualPageRowModel.setVirtualRowCount(rowCount, maxRowFound);
        }
        else {
            console.warn("ag-Grid: api.setVirtualRowCount is only available when rowModelType='virtual'.");
        }
    };
    GridApi.prototype.getVirtualPageState = function () {
        if (this.virtualPageRowModel) {
            return this.virtualPageRowModel.getVirtualPageState();
        }
        else {
            console.warn("ag-Grid: api.getVirtualPageState is only available when rowModelType='virtual'.");
        }
    };
    GridApi.prototype.checkGridSize = function () {
        this.gridPanel.setBodyAndHeaderHeights();
    };
    __decorate([
        context_1.Autowired('csvCreator'), 
        __metadata('design:type', csvCreator_1.CsvCreator)
    ], GridApi.prototype, "csvCreator", void 0);
    __decorate([
        context_1.Optional('excelCreator'), 
        __metadata('design:type', Object)
    ], GridApi.prototype, "excelCreator", void 0);
    __decorate([
        context_1.Autowired('gridCore'), 
        __metadata('design:type', gridCore_1.GridCore)
    ], GridApi.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'), 
        __metadata('design:type', rowRenderer_1.RowRenderer)
    ], GridApi.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('headerRenderer'), 
        __metadata('design:type', headerRenderer_1.HeaderRenderer)
    ], GridApi.prototype, "headerRenderer", void 0);
    __decorate([
        context_1.Autowired('filterManager'), 
        __metadata('design:type', filterManager_1.FilterManager)
    ], GridApi.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], GridApi.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('selectionController'), 
        __metadata('design:type', selectionController_1.SelectionController)
    ], GridApi.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], GridApi.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], GridApi.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('valueService'), 
        __metadata('design:type', valueService_1.ValueService)
    ], GridApi.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('masterSlaveService'), 
        __metadata('design:type', masterSlaveService_1.MasterSlaveService)
    ], GridApi.prototype, "masterSlaveService", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], GridApi.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('floatingRowModel'), 
        __metadata('design:type', floatingRowModel_1.FloatingRowModel)
    ], GridApi.prototype, "floatingRowModel", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], GridApi.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], GridApi.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('sortController'), 
        __metadata('design:type', sortController_1.SortController)
    ], GridApi.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('paginationController'), 
        __metadata('design:type', paginationController_1.PaginationController)
    ], GridApi.prototype, "paginationController", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'), 
        __metadata('design:type', focusedCellController_1.FocusedCellController)
    ], GridApi.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Optional('rangeController'), 
        __metadata('design:type', Object)
    ], GridApi.prototype, "rangeController", void 0);
    __decorate([
        context_1.Optional('clipboardService'), 
        __metadata('design:type', Object)
    ], GridApi.prototype, "clipboardService", void 0);
    __decorate([
        context_1.Optional('aggFuncService'), 
        __metadata('design:type', Object)
    ], GridApi.prototype, "aggFuncService", void 0);
    __decorate([
        context_1.Autowired('menuFactory'), 
        __metadata('design:type', Object)
    ], GridApi.prototype, "menuFactory", void 0);
    __decorate([
        context_1.Autowired('cellRendererFactory'), 
        __metadata('design:type', cellRendererFactory_1.CellRendererFactory)
    ], GridApi.prototype, "cellRendererFactory", void 0);
    __decorate([
        context_1.Autowired('cellEditorFactory'), 
        __metadata('design:type', cellEditorFactory_1.CellEditorFactory)
    ], GridApi.prototype, "cellEditorFactory", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], GridApi.prototype, "init", null);
    GridApi = __decorate([
        context_1.Bean('gridApi'), 
        __metadata('design:paramtypes', [])
    ], GridApi);
    return GridApi;
}());
exports.GridApi = GridApi;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/gridCore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var paginationController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/paginationController.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var rowRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/rowRenderer.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var popupService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/popupService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var borderLayout_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/layout/borderLayout.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var focusedCellController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/focusedCellController.js");
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var GridCore = (function () {
    function GridCore(loggerFactory) {
        this.destroyFunctions = [];
        this.logger = loggerFactory.create('GridCore');
    }
    GridCore.prototype.init = function () {
        var _this = this;
        var eSouthPanel = this.createSouthPanel();
        var eastPanel;
        var westPanel;
        if (this.toolPanel && !this.gridOptionsWrapper.isForPrint()) {
            // if we are doing RTL, then the tool panel appears on the left
            if (this.gridOptionsWrapper.isEnableRtl()) {
                westPanel = this.toolPanel.getGui();
            }
            else {
                eastPanel = this.toolPanel.getGui();
            }
        }
        var createTopPanelGui = this.createNorthPanel();
        this.eRootPanel = new borderLayout_1.BorderLayout({
            center: this.gridPanel.getLayout(),
            east: eastPanel,
            west: westPanel,
            north: createTopPanelGui,
            south: eSouthPanel,
            dontFill: this.gridOptionsWrapper.isForPrint(),
            name: 'eRootPanel'
        });
        // see what the grid options are for default of toolbar
        this.showToolPanel(this.gridOptionsWrapper.isShowToolPanel());
        this.eGridDiv.appendChild(this.eRootPanel.getGui());
        // if using angular, watch for quickFilter changes
        if (this.$scope) {
            this.$scope.$watch(this.quickFilterOnScope, function (newFilter) { return _this.filterManager.setQuickFilter(newFilter); });
        }
        if (!this.gridOptionsWrapper.isForPrint()) {
            this.addWindowResizeListener();
        }
        // important to set rtl before doLayout, as setting the RTL class impacts the scroll position,
        // which doLayout indirectly depends on
        this.addRtlSupport();
        this.doLayout();
        this.finished = false;
        this.periodicallyDoLayout();
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onRowGroupChanged.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.onRowGroupChanged.bind(this));
        this.onRowGroupChanged();
        this.logger.log('ready');
    };
    GridCore.prototype.addRtlSupport = function () {
        if (this.gridOptionsWrapper.isEnableRtl()) {
            utils_1.Utils.addCssClass(this.eRootPanel.getGui(), 'ag-rtl');
        }
        else {
            utils_1.Utils.addCssClass(this.eRootPanel.getGui(), 'ag-ltr');
        }
    };
    GridCore.prototype.createNorthPanel = function () {
        var _this = this;
        if (!this.gridOptionsWrapper.isEnterprise()) {
            return null;
        }
        var topPanelGui = document.createElement('div');
        var dropPanelVisibleListener = this.onDropPanelVisible.bind(this);
        this.rowGroupComp = this.rowGroupCompFactory.create();
        this.pivotComp = this.pivotCompFactory.create();
        topPanelGui.appendChild(this.rowGroupComp.getGui());
        topPanelGui.appendChild(this.pivotComp.getGui());
        this.rowGroupComp.addEventListener(component_1.Component.EVENT_VISIBLE_CHANGED, dropPanelVisibleListener);
        this.pivotComp.addEventListener(component_1.Component.EVENT_VISIBLE_CHANGED, dropPanelVisibleListener);
        this.destroyFunctions.push(function () {
            _this.rowGroupComp.removeEventListener(component_1.Component.EVENT_VISIBLE_CHANGED, dropPanelVisibleListener);
            _this.pivotComp.removeEventListener(component_1.Component.EVENT_VISIBLE_CHANGED, dropPanelVisibleListener);
        });
        this.onDropPanelVisible();
        return topPanelGui;
    };
    GridCore.prototype.onDropPanelVisible = function () {
        var bothVisible = this.rowGroupComp.isVisible() && this.pivotComp.isVisible();
        this.rowGroupComp.addOrRemoveCssClass('ag-width-half', bothVisible);
        this.pivotComp.addOrRemoveCssClass('ag-width-half', bothVisible);
    };
    GridCore.prototype.getRootGui = function () {
        return this.eRootPanel.getGui();
    };
    GridCore.prototype.createSouthPanel = function () {
        if (!this.statusBar && this.gridOptionsWrapper.isEnableStatusBar()) {
            console.warn('ag-Grid: status bar is only available in ag-Grid-Enterprise');
        }
        var statusBarEnabled = this.statusBar && this.gridOptionsWrapper.isEnableStatusBar();
        var paginationPanelEnabled = this.gridOptionsWrapper.isRowModelPagination() && !this.gridOptionsWrapper.isForPrint();
        if (!statusBarEnabled && !paginationPanelEnabled) {
            return null;
        }
        var eSouthPanel = document.createElement('div');
        if (statusBarEnabled) {
            eSouthPanel.appendChild(this.statusBar.getGui());
        }
        if (paginationPanelEnabled) {
            eSouthPanel.appendChild(this.paginationController.getGui());
        }
        return eSouthPanel;
    };
    GridCore.prototype.onRowGroupChanged = function () {
        if (!this.rowGroupComp) {
            return;
        }
        var rowGroupPanelShow = this.gridOptionsWrapper.getRowGroupPanelShow();
        if (rowGroupPanelShow === constants_1.Constants.ALWAYS) {
            this.rowGroupComp.setVisible(true);
        }
        else if (rowGroupPanelShow === constants_1.Constants.ONLY_WHEN_GROUPING) {
            var grouping = !this.columnController.isRowGroupEmpty();
            this.rowGroupComp.setVisible(grouping);
        }
        else {
            this.rowGroupComp.setVisible(false);
        }
        this.eRootPanel.doLayout();
    };
    GridCore.prototype.addWindowResizeListener = function () {
        var eventListener = this.doLayout.bind(this);
        window.addEventListener('resize', eventListener);
        this.destroyFunctions.push(function () { return window.removeEventListener('resize', eventListener); });
    };
    GridCore.prototype.periodicallyDoLayout = function () {
        var _this = this;
        if (!this.finished) {
            var intervalMillis = this.gridOptionsWrapper.getLayoutInterval();
            // if interval is negative, this stops the layout from happening
            if (intervalMillis > 0) {
                this.frameworkFactory.setTimeout(function () {
                    _this.doLayout();
                    _this.gridPanel.periodicallyCheck();
                    _this.periodicallyDoLayout();
                }, intervalMillis);
            }
            else {
                // if user provided negative number, we still do the check every 5 seconds,
                // in case the user turns the number positive again
                this.frameworkFactory.setTimeout(function () {
                    _this.periodicallyDoLayout();
                }, 5000);
            }
        }
    };
    GridCore.prototype.showToolPanel = function (show) {
        if (show && !this.toolPanel) {
            console.warn('ag-Grid: toolPanel is only available in ag-Grid Enterprise');
            this.toolPanelShowing = false;
            return;
        }
        this.toolPanelShowing = show;
        if (this.toolPanel) {
            this.toolPanel.setVisible(show);
            this.eRootPanel.doLayout();
        }
    };
    GridCore.prototype.isToolPanelShowing = function () {
        return this.toolPanelShowing;
    };
    GridCore.prototype.destroy = function () {
        this.finished = true;
        this.eGridDiv.removeChild(this.eRootPanel.getGui());
        this.logger.log('Grid DOM removed');
        this.destroyFunctions.forEach(function (func) { return func(); });
    };
    GridCore.prototype.ensureNodeVisible = function (comparator) {
        if (this.doingVirtualPaging) {
            throw 'Cannot use ensureNodeVisible when doing virtual paging, as we cannot check rows that are not in memory';
        }
        // look for the node index we want to display
        var rowCount = this.rowModel.getRowCount();
        var comparatorIsAFunction = typeof comparator === 'function';
        var indexToSelect = -1;
        // go through all the nodes, find the one we want to show
        for (var i = 0; i < rowCount; i++) {
            var node = this.rowModel.getRow(i);
            if (comparatorIsAFunction) {
                if (comparator(node)) {
                    indexToSelect = i;
                    break;
                }
            }
            else {
                // check object equality against node and data
                if (comparator === node || comparator === node.data) {
                    indexToSelect = i;
                    break;
                }
            }
        }
        if (indexToSelect >= 0) {
            this.gridPanel.ensureIndexVisible(indexToSelect);
        }
    };
    GridCore.prototype.doLayout = function () {
        // need to do layout first, as drawVirtualRows and setPinnedColHeight
        // need to know the result of the resizing of the panels.
        var sizeChanged = this.eRootPanel.doLayout();
        // both of the two below should be done in gridPanel, the gridPanel should register 'resize' to the panel
        if (sizeChanged) {
            this.rowRenderer.drawVirtualRowsWithLock();
            var event = {
                clientWidth: this.eRootPanel.getGui().clientWidth,
                clientHeight: this.eRootPanel.getGui().clientHeight
            };
            this.eventService.dispatchEvent(events_1.Events.EVENT_GRID_SIZE_CHANGED, event);
        }
    };
    __decorate([
        context_1.Autowired('gridOptions'), 
        __metadata('design:type', Object)
    ], GridCore.prototype, "gridOptions", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], GridCore.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('paginationController'), 
        __metadata('design:type', paginationController_1.PaginationController)
    ], GridCore.prototype, "paginationController", void 0);
    __decorate([
        context_1.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], GridCore.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('frameworkFactory'), 
        __metadata('design:type', Object)
    ], GridCore.prototype, "frameworkFactory", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], GridCore.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'), 
        __metadata('design:type', rowRenderer_1.RowRenderer)
    ], GridCore.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('filterManager'), 
        __metadata('design:type', filterManager_1.FilterManager)
    ], GridCore.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], GridCore.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], GridCore.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('eGridDiv'), 
        __metadata('design:type', HTMLElement)
    ], GridCore.prototype, "eGridDiv", void 0);
    __decorate([
        context_1.Autowired('$scope'), 
        __metadata('design:type', Object)
    ], GridCore.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('quickFilterOnScope'), 
        __metadata('design:type', String)
    ], GridCore.prototype, "quickFilterOnScope", void 0);
    __decorate([
        context_1.Autowired('popupService'), 
        __metadata('design:type', popupService_1.PopupService)
    ], GridCore.prototype, "popupService", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'), 
        __metadata('design:type', focusedCellController_1.FocusedCellController)
    ], GridCore.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Optional('rowGroupCompFactory'), 
        __metadata('design:type', Object)
    ], GridCore.prototype, "rowGroupCompFactory", void 0);
    __decorate([
        context_1.Optional('pivotCompFactory'), 
        __metadata('design:type', Object)
    ], GridCore.prototype, "pivotCompFactory", void 0);
    __decorate([
        context_1.Optional('toolPanel'), 
        __metadata('design:type', component_1.Component)
    ], GridCore.prototype, "toolPanel", void 0);
    __decorate([
        context_1.Optional('statusBar'), 
        __metadata('design:type', component_1.Component)
    ], GridCore.prototype, "statusBar", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], GridCore.prototype, "init", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], GridCore.prototype, "destroy", null);
    GridCore = __decorate([
        context_1.Bean('gridCore'),
        __param(0, context_1.Qualifier('loggerFactory')), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory])
    ], GridCore);
    return GridCore;
}());
exports.GridCore = GridCore;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var componentUtil_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/components/componentUtil.js");
var gridApi_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridApi.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var DEFAULT_ROW_HEIGHT = 25;
var DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE = 5;
var DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE = 5;
function isTrue(value) {
    return value === true || value === 'true';
}
function positiveNumberOrZero(value, defaultValue) {
    if (value > 0) {
        return value;
    }
    else {
        // zero gets returned if number is missing or the wrong type
        return defaultValue;
    }
}
var GridOptionsWrapper = (function () {
    function GridOptionsWrapper() {
        this.propertyEventService = new eventService_1.EventService();
        this.domDataKey = '__AG_' + Math.random().toString;
    }
    GridOptionsWrapper.prototype.agWire = function (gridApi, columnApi) {
        this.gridOptions.api = gridApi;
        this.gridOptions.columnApi = columnApi;
        this.checkForDeprecated();
    };
    GridOptionsWrapper.prototype.destroy = function () {
        // need to remove these, as we don't own the lifecycle of the gridOptions, we need to
        // remove the references in case the user keeps the grid options, we want the rest
        // of the grid to be picked up by the garbage collector
        this.gridOptions.api = null;
        this.gridOptions.columnApi = null;
    };
    GridOptionsWrapper.prototype.init = function () {
        this.eventService.addGlobalListener(this.globalEventHandler.bind(this));
        this.setupCellRenderers();
        if (this.isGroupSelectsChildren() && this.isSuppressParentsInRowNodes()) {
            console.warn('ag-Grid: groupSelectsChildren does not work wth suppressParentsInRowNodes, this selection method needs the part in rowNode to work');
        }
        if (this.isGroupSelectsChildren() && !this.isRowSelectionMulti()) {
            console.warn('ag-Grid: rowSelectionMulti must be true for groupSelectsChildren to make sense');
        }
    };
    GridOptionsWrapper.prototype.setupCellRenderers = function () {
        this.fullWidthCellRenderer = this.frameworkFactory.gridOptionsFullWidthCellRenderer(this.gridOptions);
        this.groupRowRenderer = this.frameworkFactory.gridOptionsGroupRowRenderer(this.gridOptions);
        this.groupRowInnerRenderer = this.frameworkFactory.gridOptionsGroupRowInnerRenderer(this.gridOptions);
    };
    GridOptionsWrapper.prototype.getDomDataKey = function () {
        return this.domDataKey;
    };
    // the cellRenderers come from the instances for this class, not from gridOptions, which allows
    // the baseFrameworkFactory to replace with framework specific ones
    GridOptionsWrapper.prototype.getFullWidthCellRenderer = function () { return this.fullWidthCellRenderer; };
    GridOptionsWrapper.prototype.getGroupRowRenderer = function () { return this.groupRowRenderer; };
    GridOptionsWrapper.prototype.getGroupRowInnerRenderer = function () { return this.groupRowInnerRenderer; };
    GridOptionsWrapper.prototype.isEnterprise = function () { return this.enterprise; };
    GridOptionsWrapper.prototype.isRowSelection = function () { return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple"; };
    GridOptionsWrapper.prototype.isRowDeselection = function () { return isTrue(this.gridOptions.rowDeselection); };
    GridOptionsWrapper.prototype.isRowSelectionMulti = function () { return this.gridOptions.rowSelection === 'multiple'; };
    GridOptionsWrapper.prototype.getContext = function () { return this.gridOptions.context; };
    GridOptionsWrapper.prototype.isPivotMode = function () { return isTrue(this.gridOptions.pivotMode); };
    GridOptionsWrapper.prototype.isRowModelPagination = function () { return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_PAGINATION; };
    GridOptionsWrapper.prototype.isRowModelVirtual = function () { return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_VIRTUAL; };
    GridOptionsWrapper.prototype.isRowModelViewport = function () { return this.gridOptions.rowModelType === constants_1.Constants.ROW_MODEL_TYPE_VIEWPORT; };
    GridOptionsWrapper.prototype.isRowModelDefault = function () { return !(this.isRowModelPagination() || this.isRowModelVirtual() || this.isRowModelViewport()); };
    GridOptionsWrapper.prototype.isFullRowEdit = function () { return this.gridOptions.editType === 'fullRow'; };
    GridOptionsWrapper.prototype.isSuppressFocusAfterRefresh = function () { return isTrue(this.gridOptions.suppressFocusAfterRefresh); };
    GridOptionsWrapper.prototype.isShowToolPanel = function () { return isTrue(this.gridOptions.showToolPanel); };
    GridOptionsWrapper.prototype.isToolPanelSuppressRowGroups = function () { return isTrue(this.gridOptions.toolPanelSuppressRowGroups); };
    GridOptionsWrapper.prototype.isToolPanelSuppressValues = function () { return isTrue(this.gridOptions.toolPanelSuppressValues); };
    GridOptionsWrapper.prototype.isToolPanelSuppressPivots = function () { return isTrue(this.gridOptions.toolPanelSuppressPivots); };
    GridOptionsWrapper.prototype.isToolPanelSuppressPivotMode = function () { return isTrue(this.gridOptions.toolPanelSuppressPivotMode); };
    GridOptionsWrapper.prototype.isSuppressTouch = function () { return isTrue(this.gridOptions.suppressTouch); };
    GridOptionsWrapper.prototype.isEnableCellChangeFlash = function () { return isTrue(this.gridOptions.enableCellChangeFlash); };
    GridOptionsWrapper.prototype.isGroupSelectsChildren = function () { return isTrue(this.gridOptions.groupSelectsChildren); };
    GridOptionsWrapper.prototype.isGroupSelectsFiltered = function () { return isTrue(this.gridOptions.groupSelectsFiltered); };
    GridOptionsWrapper.prototype.isGroupRemoveSingleChildren = function () { return isTrue(this.gridOptions.groupRemoveSingleChildren); };
    GridOptionsWrapper.prototype.isGroupIncludeFooter = function () { return isTrue(this.gridOptions.groupIncludeFooter); };
    GridOptionsWrapper.prototype.isGroupSuppressBlankHeader = function () { return isTrue(this.gridOptions.groupSuppressBlankHeader); };
    GridOptionsWrapper.prototype.isSuppressRowClickSelection = function () { return isTrue(this.gridOptions.suppressRowClickSelection); };
    GridOptionsWrapper.prototype.isSuppressCellSelection = function () { return isTrue(this.gridOptions.suppressCellSelection); };
    GridOptionsWrapper.prototype.isSuppressMultiSort = function () { return isTrue(this.gridOptions.suppressMultiSort); };
    GridOptionsWrapper.prototype.isGroupSuppressAutoColumn = function () { return isTrue(this.gridOptions.groupSuppressAutoColumn); };
    GridOptionsWrapper.prototype.isSuppressDragLeaveHidesColumns = function () { return isTrue(this.gridOptions.suppressDragLeaveHidesColumns); };
    GridOptionsWrapper.prototype.isForPrint = function () { return isTrue(this.gridOptions.forPrint); };
    GridOptionsWrapper.prototype.isSuppressHorizontalScroll = function () { return isTrue(this.gridOptions.suppressHorizontalScroll); };
    GridOptionsWrapper.prototype.isSuppressLoadingOverlay = function () { return isTrue(this.gridOptions.suppressLoadingOverlay); };
    GridOptionsWrapper.prototype.isSuppressNoRowsOverlay = function () { return isTrue(this.gridOptions.suppressNoRowsOverlay); };
    GridOptionsWrapper.prototype.isSuppressFieldDotNotation = function () { return isTrue(this.gridOptions.suppressFieldDotNotation); };
    GridOptionsWrapper.prototype.getFloatingTopRowData = function () { return this.gridOptions.floatingTopRowData; };
    GridOptionsWrapper.prototype.getFloatingBottomRowData = function () { return this.gridOptions.floatingBottomRowData; };
    GridOptionsWrapper.prototype.isFunctionsPassive = function () { return isTrue(this.gridOptions.functionsPassive); };
    GridOptionsWrapper.prototype.isSuppressRowHoverClass = function () { return isTrue(this.gridOptions.suppressRowHoverClass); };
    GridOptionsWrapper.prototype.getQuickFilterText = function () { return this.gridOptions.quickFilterText; };
    GridOptionsWrapper.prototype.isUnSortIcon = function () { return isTrue(this.gridOptions.unSortIcon); };
    GridOptionsWrapper.prototype.isSuppressMenuHide = function () { return isTrue(this.gridOptions.suppressMenuHide); };
    GridOptionsWrapper.prototype.getRowStyle = function () { return this.gridOptions.rowStyle; };
    GridOptionsWrapper.prototype.getRowClass = function () { return this.gridOptions.rowClass; };
    GridOptionsWrapper.prototype.getRowStyleFunc = function () { return this.gridOptions.getRowStyle; };
    GridOptionsWrapper.prototype.getRowClassFunc = function () { return this.gridOptions.getRowClass; };
    GridOptionsWrapper.prototype.getDoesDataFlowerFunc = function () { return this.gridOptions.doesDataFlower; };
    GridOptionsWrapper.prototype.getIsFullWidthCellFunc = function () { return this.gridOptions.isFullWidthCell; };
    GridOptionsWrapper.prototype.getFullWidthCellRendererParams = function () { return this.gridOptions.fullWidthCellRendererParams; };
    GridOptionsWrapper.prototype.isEmbedFullWidthRows = function () { return isTrue(this.gridOptions.embedFullWidthRows); };
    GridOptionsWrapper.prototype.getBusinessKeyForNodeFunc = function () { return this.gridOptions.getBusinessKeyForNode; };
    GridOptionsWrapper.prototype.getHeaderCellRenderer = function () { return this.gridOptions.headerCellRenderer; };
    GridOptionsWrapper.prototype.getApi = function () { return this.gridOptions.api; };
    GridOptionsWrapper.prototype.getColumnApi = function () { return this.gridOptions.columnApi; };
    GridOptionsWrapper.prototype.isEnableColResize = function () { return isTrue(this.gridOptions.enableColResize); };
    GridOptionsWrapper.prototype.isSingleClickEdit = function () { return isTrue(this.gridOptions.singleClickEdit); };
    GridOptionsWrapper.prototype.isSuppressClickEdit = function () { return isTrue(this.gridOptions.suppressClickEdit); };
    GridOptionsWrapper.prototype.getGroupDefaultExpanded = function () { return this.gridOptions.groupDefaultExpanded; };
    GridOptionsWrapper.prototype.getAutoSizePadding = function () { return this.gridOptions.autoSizePadding; };
    GridOptionsWrapper.prototype.getMaxConcurrentDatasourceRequests = function () { return this.gridOptions.maxConcurrentDatasourceRequests; };
    GridOptionsWrapper.prototype.getMaxPagesInCache = function () { return this.gridOptions.maxPagesInCache; };
    GridOptionsWrapper.prototype.getPaginationOverflowSize = function () { return this.gridOptions.paginationOverflowSize; };
    GridOptionsWrapper.prototype.getPaginationPageSize = function () { return this.gridOptions.paginationPageSize; };
    GridOptionsWrapper.prototype.getPaginationInitialRowCount = function () { return this.gridOptions.paginationInitialRowCount; };
    GridOptionsWrapper.prototype.getDateComponent = function () { return this.gridOptions.dateComponent; };
    GridOptionsWrapper.prototype.getRowData = function () { return this.gridOptions.rowData; };
    GridOptionsWrapper.prototype.isGroupUseEntireRow = function () { return isTrue(this.gridOptions.groupUseEntireRow); };
    GridOptionsWrapper.prototype.isEnableRtl = function () { return isTrue(this.gridOptions.enableRtl); };
    GridOptionsWrapper.prototype.getGroupColumnDef = function () { return this.gridOptions.groupColumnDef; };
    GridOptionsWrapper.prototype.isGroupSuppressRow = function () { return isTrue(this.gridOptions.groupSuppressRow); };
    GridOptionsWrapper.prototype.getRowGroupPanelShow = function () { return this.gridOptions.rowGroupPanelShow; };
    GridOptionsWrapper.prototype.getPivotPanelShow = function () { return this.gridOptions.pivotPanelShow; };
    GridOptionsWrapper.prototype.isAngularCompileRows = function () { return isTrue(this.gridOptions.angularCompileRows); };
    GridOptionsWrapper.prototype.isAngularCompileFilters = function () { return isTrue(this.gridOptions.angularCompileFilters); };
    GridOptionsWrapper.prototype.isAngularCompileHeaders = function () { return isTrue(this.gridOptions.angularCompileHeaders); };
    GridOptionsWrapper.prototype.isDebug = function () { return isTrue(this.gridOptions.debug); };
    GridOptionsWrapper.prototype.getColumnDefs = function () { return this.gridOptions.columnDefs; };
    GridOptionsWrapper.prototype.getDatasource = function () { return this.gridOptions.datasource; };
    GridOptionsWrapper.prototype.getViewportDatasource = function () { return this.gridOptions.viewportDatasource; };
    GridOptionsWrapper.prototype.isEnableSorting = function () { return isTrue(this.gridOptions.enableSorting) || isTrue(this.gridOptions.enableServerSideSorting); };
    GridOptionsWrapper.prototype.isEnableCellExpressions = function () { return isTrue(this.gridOptions.enableCellExpressions); };
    GridOptionsWrapper.prototype.isEnableGroupEdit = function () { return isTrue(this.gridOptions.enableGroupEdit); };
    GridOptionsWrapper.prototype.isSuppressMiddleClickScrolls = function () { return isTrue(this.gridOptions.suppressMiddleClickScrolls); };
    GridOptionsWrapper.prototype.isSuppressPreventDefaultOnMouseWheel = function () { return isTrue(this.gridOptions.suppressPreventDefaultOnMouseWheel); };
    GridOptionsWrapper.prototype.isEnableServerSideSorting = function () { return isTrue(this.gridOptions.enableServerSideSorting); };
    GridOptionsWrapper.prototype.isSuppressColumnVirtualisation = function () { return isTrue(this.gridOptions.suppressColumnVirtualisation); };
    GridOptionsWrapper.prototype.isSuppressContextMenu = function () { return isTrue(this.gridOptions.suppressContextMenu); };
    GridOptionsWrapper.prototype.isSuppressCopyRowsToClipboard = function () { return isTrue(this.gridOptions.suppressCopyRowsToClipboard); };
    GridOptionsWrapper.prototype.isEnableFilter = function () { return isTrue(this.gridOptions.enableFilter) || isTrue(this.gridOptions.enableServerSideFilter); };
    GridOptionsWrapper.prototype.isEnableServerSideFilter = function () { return this.gridOptions.enableServerSideFilter; };
    GridOptionsWrapper.prototype.isSuppressScrollLag = function () { return isTrue(this.gridOptions.suppressScrollLag); };
    GridOptionsWrapper.prototype.isSuppressMovableColumns = function () { return isTrue(this.gridOptions.suppressMovableColumns); };
    GridOptionsWrapper.prototype.isAnimateRows = function () { return isTrue(this.gridOptions.animateRows); };
    GridOptionsWrapper.prototype.isSuppressColumnMoveAnimation = function () { return isTrue(this.gridOptions.suppressColumnMoveAnimation); };
    GridOptionsWrapper.prototype.isSuppressMenuColumnPanel = function () { return isTrue(this.gridOptions.suppressMenuColumnPanel); };
    GridOptionsWrapper.prototype.isSuppressMenuFilterPanel = function () { return isTrue(this.gridOptions.suppressMenuFilterPanel); };
    GridOptionsWrapper.prototype.isSuppressUseColIdForGroups = function () { return isTrue(this.gridOptions.suppressUseColIdForGroups); };
    GridOptionsWrapper.prototype.isSuppressAggFuncInHeader = function () { return isTrue(this.gridOptions.suppressAggFuncInHeader); };
    GridOptionsWrapper.prototype.isSuppressMenuMainPanel = function () { return isTrue(this.gridOptions.suppressMenuMainPanel); };
    GridOptionsWrapper.prototype.isEnableRangeSelection = function () { return isTrue(this.gridOptions.enableRangeSelection); };
    GridOptionsWrapper.prototype.isRememberGroupStateWhenNewData = function () { return isTrue(this.gridOptions.rememberGroupStateWhenNewData); };
    GridOptionsWrapper.prototype.getIcons = function () { return this.gridOptions.icons; };
    GridOptionsWrapper.prototype.getAggFuncs = function () { return this.gridOptions.aggFuncs; };
    GridOptionsWrapper.prototype.getIsScrollLag = function () { return this.gridOptions.isScrollLag; };
    GridOptionsWrapper.prototype.getSortingOrder = function () { return this.gridOptions.sortingOrder; };
    GridOptionsWrapper.prototype.getSlaveGrids = function () { return this.gridOptions.slaveGrids; };
    GridOptionsWrapper.prototype.getGroupRowRendererParams = function () { return this.gridOptions.groupRowRendererParams; };
    GridOptionsWrapper.prototype.getOverlayLoadingTemplate = function () { return this.gridOptions.overlayLoadingTemplate; };
    GridOptionsWrapper.prototype.getOverlayNoRowsTemplate = function () { return this.gridOptions.overlayNoRowsTemplate; };
    GridOptionsWrapper.prototype.getCheckboxSelection = function () { return this.gridOptions.checkboxSelection; };
    GridOptionsWrapper.prototype.isSuppressAutoSize = function () { return isTrue(this.gridOptions.suppressAutoSize); };
    GridOptionsWrapper.prototype.isSuppressParentsInRowNodes = function () { return isTrue(this.gridOptions.suppressParentsInRowNodes); };
    GridOptionsWrapper.prototype.isEnableStatusBar = function () { return isTrue(this.gridOptions.enableStatusBar); };
    GridOptionsWrapper.prototype.isFunctionsReadOnly = function () { return isTrue(this.gridOptions.functionsReadOnly); };
    GridOptionsWrapper.prototype.getDefaultColDef = function () { return this.gridOptions.defaultColDef; };
    GridOptionsWrapper.prototype.getDefaultColGroupDef = function () { return this.gridOptions.defaultColGroupDef; };
    GridOptionsWrapper.prototype.getHeaderCellTemplate = function () { return this.gridOptions.headerCellTemplate; };
    GridOptionsWrapper.prototype.getHeaderCellTemplateFunc = function () { return this.gridOptions.getHeaderCellTemplate; };
    GridOptionsWrapper.prototype.getNodeChildDetailsFunc = function () { return this.gridOptions.getNodeChildDetails; };
    GridOptionsWrapper.prototype.getGroupRowAggNodesFunc = function () { return this.gridOptions.groupRowAggNodes; };
    GridOptionsWrapper.prototype.getContextMenuItemsFunc = function () { return this.gridOptions.getContextMenuItems; };
    GridOptionsWrapper.prototype.getMainMenuItemsFunc = function () { return this.gridOptions.getMainMenuItems; };
    GridOptionsWrapper.prototype.getRowNodeIdFunc = function () { return this.gridOptions.getRowNodeId; };
    GridOptionsWrapper.prototype.getNavigateToNextCellFunc = function () { return this.gridOptions.navigateToNextCell; };
    GridOptionsWrapper.prototype.getTabToNextCellFunc = function () { return this.gridOptions.tabToNextCell; };
    GridOptionsWrapper.prototype.getProcessSecondaryColDefFunc = function () { return this.gridOptions.processSecondaryColDef; };
    GridOptionsWrapper.prototype.getProcessSecondaryColGroupDefFunc = function () { return this.gridOptions.processSecondaryColGroupDef; };
    GridOptionsWrapper.prototype.getSendToClipboardFunc = function () { return this.gridOptions.sendToClipboard; };
    GridOptionsWrapper.prototype.getProcessCellForClipboardFunc = function () { return this.gridOptions.processCellForClipboard; };
    GridOptionsWrapper.prototype.getProcessCellFromClipboardFunc = function () { return this.gridOptions.processCellFromClipboard; };
    GridOptionsWrapper.prototype.getViewportRowModelPageSize = function () { return positiveNumberOrZero(this.gridOptions.viewportRowModelPageSize, DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE); };
    GridOptionsWrapper.prototype.getViewportRowModelBufferSize = function () { return positiveNumberOrZero(this.gridOptions.viewportRowModelBufferSize, DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE); };
    // public getCellRenderers(): {[key: string]: {new(): ICellRenderer} | ICellRendererFunc} { return this.gridOptions.cellRenderers; }
    // public getCellEditors(): {[key: string]: {new(): ICellEditor}} { return this.gridOptions.cellEditors; }
    GridOptionsWrapper.prototype.setProperty = function (key, value) {
        var gridOptionsNoType = this.gridOptions;
        var previousValue = gridOptionsNoType[key];
        gridOptionsNoType[key] = value;
        this.propertyEventService.dispatchEvent(key, { currentValue: value, previousValue: previousValue });
    };
    GridOptionsWrapper.prototype.addEventListener = function (key, listener) {
        this.propertyEventService.addEventListener(key, listener);
    };
    GridOptionsWrapper.prototype.removeEventListener = function (key, listener) {
        this.propertyEventService.removeEventListener(key, listener);
    };
    GridOptionsWrapper.prototype.executeProcessRowPostCreateFunc = function (params) {
        if (this.gridOptions.processRowPostCreate) {
            this.gridOptions.processRowPostCreate(params);
        }
    };
    // properties
    GridOptionsWrapper.prototype.getHeaderHeight = function () {
        if (typeof this.gridOptions.headerHeight === 'number') {
            return this.gridOptions.headerHeight;
        }
        else {
            return 25;
        }
    };
    GridOptionsWrapper.prototype.isExternalFilterPresent = function () {
        if (typeof this.gridOptions.isExternalFilterPresent === 'function') {
            return this.gridOptions.isExternalFilterPresent();
        }
        else {
            return false;
        }
    };
    GridOptionsWrapper.prototype.doesExternalFilterPass = function (node) {
        if (typeof this.gridOptions.doesExternalFilterPass === 'function') {
            return this.gridOptions.doesExternalFilterPass(node);
        }
        else {
            return false;
        }
    };
    GridOptionsWrapper.prototype.getDocument = function () {
        // if user is providing document, we use the users one,
        // otherwise we use the document on the global namespace.
        var result;
        if (utils_1.Utils.exists(this.gridOptions.getDocument)) {
            result = this.gridOptions.getDocument();
        }
        if (utils_1.Utils.exists(result)) {
            return result;
        }
        else {
            return document;
        }
    };
    GridOptionsWrapper.prototype.getLayoutInterval = function () {
        if (typeof this.gridOptions.layoutInterval === 'number') {
            return this.gridOptions.layoutInterval;
        }
        else {
            return constants_1.Constants.LAYOUT_INTERVAL;
        }
    };
    GridOptionsWrapper.prototype.getMinColWidth = function () {
        if (this.gridOptions.minColWidth > GridOptionsWrapper.MIN_COL_WIDTH) {
            return this.gridOptions.minColWidth;
        }
        else {
            return GridOptionsWrapper.MIN_COL_WIDTH;
        }
    };
    GridOptionsWrapper.prototype.getMaxColWidth = function () {
        if (this.gridOptions.maxColWidth > GridOptionsWrapper.MIN_COL_WIDTH) {
            return this.gridOptions.maxColWidth;
        }
        else {
            return null;
        }
    };
    GridOptionsWrapper.prototype.getColWidth = function () {
        if (typeof this.gridOptions.colWidth !== 'number' || this.gridOptions.colWidth < GridOptionsWrapper.MIN_COL_WIDTH) {
            return 200;
        }
        else {
            return this.gridOptions.colWidth;
        }
    };
    GridOptionsWrapper.prototype.getRowBuffer = function () {
        if (typeof this.gridOptions.rowBuffer === 'number') {
            if (this.gridOptions.rowBuffer < 0) {
                console.warn('ag-Grid: rowBuffer should not be negative');
            }
            return this.gridOptions.rowBuffer;
        }
        else {
            return constants_1.Constants.ROW_BUFFER_SIZE;
        }
    };
    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
    // allow the user to provide the scroll width before we work it out.
    GridOptionsWrapper.prototype.getScrollbarWidth = function () {
        var scrollbarWidth = this.gridOptions.scrollbarWidth;
        if (typeof scrollbarWidth !== 'number' || scrollbarWidth < 0) {
            scrollbarWidth = utils_1.Utils.getScrollbarWidth();
        }
        return scrollbarWidth;
    };
    GridOptionsWrapper.prototype.checkForDeprecated = function () {
        // casting to generic object, so typescript compiles even though
        // we are looking for attributes that don't exist
        var options = this.gridOptions;
        if (options.suppressUnSort) {
            console.warn('ag-grid: as of v1.12.4 suppressUnSort is not used. Please use sortOrder instead.');
        }
        if (options.suppressDescSort) {
            console.warn('ag-grid: as of v1.12.4 suppressDescSort is not used. Please use sortOrder instead.');
        }
        if (options.groupAggFields) {
            console.warn('ag-grid: as of v3 groupAggFields is not used. Please add appropriate agg fields to your columns.');
        }
        if (options.groupHidePivotColumns) {
            console.warn('ag-grid: as of v3 groupHidePivotColumns is not used as pivot columns are now called rowGroup columns. Please refer to the documentation');
        }
        if (options.groupKeys) {
            console.warn('ag-grid: as of v3 groupKeys is not used. You need to set rowGroupIndex on the columns to group. Please refer to the documentation');
        }
        if (options.ready || options.onReady) {
            console.warn('ag-grid: as of v3.3 ready event is now called gridReady, so the callback should be onGridReady');
        }
        if (typeof options.groupDefaultExpanded === 'boolean') {
            console.warn('ag-grid: groupDefaultExpanded can no longer be boolean. for groupDefaultExpanded=true, use groupDefaultExpanded=9999 instead, to expand all the groups');
        }
        if (options.onRowDeselected || options.rowDeselected) {
            console.warn('ag-grid: since version 3.4 event rowDeselected no longer exists, please check the docs');
        }
        if (options.rowsAlreadyGrouped) {
            console.warn('ag-grid: since version 3.4 rowsAlreadyGrouped no longer exists, please use getNodeChildDetails() instead');
        }
        if (options.groupAggFunction) {
            console.warn('ag-grid: since version 4.3.x groupAggFunction is now called groupRowAggNodes');
        }
    };
    GridOptionsWrapper.prototype.getLocaleTextFunc = function () {
        if (this.gridOptions.localeTextFunc) {
            return this.gridOptions.localeTextFunc;
        }
        var that = this;
        return function (key, defaultValue) {
            var localeText = that.gridOptions.localeText;
            if (localeText && localeText[key]) {
                return localeText[key];
            }
            else {
                return defaultValue;
            }
        };
    };
    // responsible for calling the onXXX functions on gridOptions
    GridOptionsWrapper.prototype.globalEventHandler = function (eventName, event) {
        var callbackMethodName = componentUtil_1.ComponentUtil.getCallbackForEvent(eventName);
        if (typeof this.gridOptions[callbackMethodName] === 'function') {
            this.gridOptions[callbackMethodName](event);
        }
    };
    // we don't allow dynamic row height for virtual paging
    GridOptionsWrapper.prototype.getRowHeightAsNumber = function () {
        var rowHeight = this.gridOptions.rowHeight;
        if (utils_1.Utils.missing(rowHeight)) {
            return DEFAULT_ROW_HEIGHT;
        }
        else if (this.isNumeric(this.gridOptions.rowHeight)) {
            return this.gridOptions.rowHeight;
        }
        else {
            console.warn('ag-Grid row height must be a number if not using standard row model');
            return DEFAULT_ROW_HEIGHT;
        }
    };
    GridOptionsWrapper.prototype.getRowHeightForNode = function (rowNode) {
        // check the function first, in case use set both function and
        // number, when using virtual pagination then function can be
        // used for floating rows and the number for the body rows.
        if (typeof this.gridOptions.getRowHeight === 'function') {
            var params = {
                node: rowNode,
                data: rowNode.data,
                api: this.gridOptions.api,
                context: this.gridOptions.context
            };
            return this.gridOptions.getRowHeight(params);
        }
        else if (this.isNumeric(this.gridOptions.rowHeight)) {
            return this.gridOptions.rowHeight;
        }
        else {
            return DEFAULT_ROW_HEIGHT;
        }
    };
    GridOptionsWrapper.prototype.isNumeric = function (value) {
        return !isNaN(value) && typeof value === 'number';
    };
    GridOptionsWrapper.MIN_COL_WIDTH = 10;
    GridOptionsWrapper.PROP_HEADER_HEIGHT = 'headerHeight';
    __decorate([
        context_1.Autowired('gridOptions'), 
        __metadata('design:type', Object)
    ], GridOptionsWrapper.prototype, "gridOptions", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], GridOptionsWrapper.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], GridOptionsWrapper.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('enterprise'), 
        __metadata('design:type', Boolean)
    ], GridOptionsWrapper.prototype, "enterprise", void 0);
    __decorate([
        context_1.Autowired('frameworkFactory'), 
        __metadata('design:type', Object)
    ], GridOptionsWrapper.prototype, "frameworkFactory", void 0);
    __decorate([
        __param(0, context_1.Qualifier('gridApi')),
        __param(1, context_1.Qualifier('columnApi')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [gridApi_1.GridApi, columnController_1.ColumnApi]), 
        __metadata('design:returntype', void 0)
    ], GridOptionsWrapper.prototype, "agWire", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], GridOptionsWrapper.prototype, "destroy", null);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], GridOptionsWrapper.prototype, "init", null);
    GridOptionsWrapper = __decorate([
        context_1.Bean('gridOptionsWrapper'), 
        __metadata('design:paramtypes', [])
    ], GridOptionsWrapper);
    return GridOptionsWrapper;
}());
exports.GridOptionsWrapper = GridOptionsWrapper;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var masterSlaveService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/masterSlaveService.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var rowRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/rowRenderer.js");
var floatingRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/floatingRowModel.js");
var borderLayout_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/layout/borderLayout.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var dragService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragService.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var csvCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/csvCreator.js");
var mouseEventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/mouseEventService.js");
var focusedCellController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/focusedCellController.js");
var scrollVisibleService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/scrollVisibleService.js");
var beanStub_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/beanStub.js");
var rowContainerComponent_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/rowContainerComponent.js");
// in the html below, it is important that there are no white space between some of the divs, as if there is white space,
// it won't render correctly in safari, as safari renders white space as a gap
var gridHtml = '<div class="ag-root ag-font-style">' +
    // header
    '<div class="ag-header">' +
    '<div class="ag-pinned-left-header"></div>' +
    '<div class="ag-pinned-right-header"></div>' +
    '<div class="ag-header-viewport">' +
    '<div class="ag-header-container"></div>' +
    '</div>' +
    '<div class="ag-header-overlay"></div>' +
    '</div>' +
    // floating top
    '<div class="ag-floating-top">' +
    '<div class="ag-pinned-left-floating-top"></div>' +
    '<div class="ag-pinned-right-floating-top"></div>' +
    '<div class="ag-floating-top-viewport">' +
    '<div class="ag-floating-top-container"></div>' +
    '</div>' +
    '<div class="ag-floating-top-full-width-container"></div>' +
    '</div>' +
    // floating bottom
    '<div class="ag-floating-bottom">' +
    '<div class="ag-pinned-left-floating-bottom"></div>' +
    '<div class="ag-pinned-right-floating-bottom"></div>' +
    '<div class="ag-floating-bottom-viewport">' +
    '<div class="ag-floating-bottom-container"></div>' +
    '</div>' +
    '<div class="ag-floating-bottom-full-width-container"></div>' +
    '</div>' +
    // body
    '<div class="ag-body">' +
    '<div class="ag-pinned-left-cols-viewport">' +
    '<div class="ag-pinned-left-cols-container"></div>' +
    '</div>' +
    '<div class="ag-pinned-right-cols-viewport">' +
    '<div class="ag-pinned-right-cols-container"></div>' +
    '</div>' +
    '<div class="ag-body-viewport-wrapper">' +
    '<div class="ag-body-viewport">' +
    '<div class="ag-body-container"></div>' +
    '</div>' +
    '</div>' +
    '<div class="ag-full-width-viewport">' +
    '<div class="ag-full-width-container"></div>' +
    '</div>' +
    '</div>' +
    '</div>';
var gridForPrintHtml = '<div class="ag-root ag-font-style">' +
    // header
    '<div class="ag-header-container"></div>' +
    // floating
    '<div class="ag-floating-top-container"></div>' +
    // body
    '<div class="ag-body-container"></div>' +
    // floating bottom
    '<div class="ag-floating-bottom-container"></div>' +
    '</div>';
// wrapping in outer div, and wrapper, is needed to center the loading icon
// The idea for centering came from here: http://www.vanseodesign.com/css/vertical-centering/
var mainOverlayTemplate = '<div class="ag-overlay-panel">' +
    '<div class="ag-overlay-wrapper ag-overlay-[OVERLAY_NAME]-wrapper">[OVERLAY_TEMPLATE]</div>' +
    '</div>';
var defaultLoadingOverlayTemplate = '<span class="ag-overlay-loading-center">[LOADING...]</span>';
var defaultNoRowsOverlayTemplate = '<span class="ag-overlay-no-rows-center">[NO_ROWS_TO_SHOW]</span>';
var GridPanel = (function (_super) {
    __extends(GridPanel, _super);
    function GridPanel() {
        _super.apply(this, arguments);
        this.requestAnimationFrameExists = typeof requestAnimationFrame === 'function';
        this.scrollLagCounter = 0;
        this.scrollLagTicking = false;
        this.lastLeftPosition = -1;
        this.lastTopPosition = -1;
        this.animationThreadCount = 0;
    }
    GridPanel.prototype.agWire = function (loggerFactory) {
        this.logger = loggerFactory.create('GridPanel');
        // makes code below more readable if we pull 'forPrint' out
        this.forPrint = this.gridOptionsWrapper.isForPrint();
        this.scrollWidth = this.gridOptionsWrapper.getScrollbarWidth();
        this.useScrollLag = this.isUseScrollLag();
        this.enableRtl = this.gridOptionsWrapper.isEnableRtl();
        this.loadTemplate();
        this.findElements();
    };
    GridPanel.prototype.getVerticalPixelRange = function () {
        var container;
        if (this.enableRtl) {
            if (this.columnController.isPinningLeft()) {
                container = this.ePinnedLeftColsViewport;
            }
            else {
                container = this.eBodyViewport;
            }
        }
        else {
            if (this.columnController.isPinningRight()) {
                container = this.ePinnedRightColsViewport;
            }
            else {
                container = this.eBodyViewport;
            }
        }
        var result = {
            top: container.scrollTop,
            bottom: container.scrollTop + container.offsetHeight
        };
        return result;
    };
    // we override this, as the base class is missing the annotation
    GridPanel.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    GridPanel.prototype.onRowDataChanged = function () {
        this.showOrHideOverlay();
    };
    GridPanel.prototype.showOrHideOverlay = function () {
        if (this.rowModel.isEmpty() && !this.gridOptionsWrapper.isSuppressNoRowsOverlay()) {
            this.showNoRowsOverlay();
        }
        else {
            this.hideOverlay();
        }
    };
    GridPanel.prototype.getLayout = function () {
        return this.layout;
    };
    GridPanel.prototype.init = function () {
        this.addEventListeners();
        this.addDragListeners();
        this.layout = new borderLayout_1.BorderLayout({
            overlays: {
                loading: utils_1.Utils.loadTemplate(this.createLoadingOverlayTemplate()),
                noRows: utils_1.Utils.loadTemplate(this.createNoRowsOverlayTemplate())
            },
            center: this.eRoot,
            dontFill: this.forPrint,
            name: 'eGridPanel'
        });
        this.layout.addSizeChangeListener(this.setBodyAndHeaderHeights.bind(this));
        this.layout.addSizeChangeListener(this.setLeftAndRightBounds.bind(this));
        this.addScrollListener();
        if (this.gridOptionsWrapper.isSuppressHorizontalScroll()) {
            this.eBodyViewport.style.overflowX = 'hidden';
        }
        if (this.gridOptionsWrapper.isRowModelDefault() && !this.gridOptionsWrapper.getRowData()) {
            this.showLoadingOverlay();
        }
        this.setPinnedContainersVisible();
        this.setBodyAndHeaderHeights();
        this.disableBrowserDragging();
        this.addShortcutKeyListeners();
        this.addMouseEvents();
        this.addKeyboardEvents();
        this.addBodyViewportListener();
        if (this.$scope) {
            this.addAngularApplyCheck();
        }
        this.onDisplayedColumnsWidthChanged();
    };
    GridPanel.prototype.addAngularApplyCheck = function () {
        var _this = this;
        // this makes sure if we queue up requests, we only execute oe
        var applyTriggered = false;
        var listener = function () {
            // only need to do one apply at a time
            if (applyTriggered) {
                return;
            }
            applyTriggered = true; // mark 'need apply' to true
            setTimeout(function () {
                applyTriggered = false;
                _this.$scope.$apply();
            }, 0);
        };
        // these are the events we need to do an apply after - these are the ones that can end up
        // with columns added or removed
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, listener);
    };
    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
    GridPanel.prototype.disableBrowserDragging = function () {
        this.eRoot.addEventListener('dragstart', function (event) {
            if (event.target instanceof HTMLImageElement) {
                event.preventDefault();
                return false;
            }
        });
    };
    GridPanel.prototype.addEventListeners = function () {
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_FLOATING_ROW_DATA_CHANGED, this.setBodyAndHeaderHeights.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_ROW_DATA_CHANGED, this.onRowDataChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_ITEMS_ADDED, this.onRowDataChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_ITEMS_REMOVED, this.onRowDataChanged.bind(this));
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, this.setBodyAndHeaderHeights.bind(this));
    };
    GridPanel.prototype.addDragListeners = function () {
        var _this = this;
        if (this.forPrint // no range select when doing 'for print'
            || !this.gridOptionsWrapper.isEnableRangeSelection() // no range selection if no property
            || utils_1.Utils.missing(this.rangeController)) {
            return;
        }
        var containers = [this.ePinnedLeftColsContainer, this.ePinnedRightColsContainer, this.eBodyContainer,
            this.eFloatingTop, this.eFloatingBottom];
        containers.forEach(function (container) {
            var params = {
                dragStartPixels: 0,
                eElement: container,
                onDragStart: _this.rangeController.onDragStart.bind(_this.rangeController),
                onDragStop: _this.rangeController.onDragStop.bind(_this.rangeController),
                onDragging: _this.rangeController.onDragging.bind(_this.rangeController)
            };
            _this.dragService.addDragSource(params);
            _this.addDestroyFunc(function () { return _this.dragService.removeDragSource(params); });
        });
    };
    GridPanel.prototype.addMouseEvents = function () {
        var _this = this;
        var eventNames = ['click', 'mousedown', 'dblclick', 'contextmenu'];
        eventNames.forEach(function (eventName) {
            var listener = _this.processMouseEvent.bind(_this, eventName);
            _this.eAllCellContainers.forEach(function (container) {
                container.addEventListener(eventName, listener);
                _this.addDestroyFunc(function () { return container.removeEventListener(eventName, listener); });
            });
        });
    };
    GridPanel.prototype.addKeyboardEvents = function () {
        var _this = this;
        var eventNames = ['keydown', 'keypress'];
        eventNames.forEach(function (eventName) {
            var listener = _this.processKeyboardEvent.bind(_this, eventName);
            _this.eAllCellContainers.forEach(function (container) {
                _this.addDestroyableEventListener(container, eventName, listener);
            });
        });
    };
    GridPanel.prototype.addBodyViewportListener = function () {
        var _this = this;
        // we never add this when doing 'forPrint'
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        // we want to listen for clicks directly on the eBodyViewport, so the user has a way of showing
        // the context menu if no rows are displayed, or user simply clicks outside of a cell
        var listener = function (mouseEvent) {
            var target = utils_1.Utils.getTarget(mouseEvent);
            if (target === _this.eBodyViewport) {
                // show it
                _this.onContextMenu(mouseEvent);
                _this.preventDefaultOnContextMenu(mouseEvent);
            }
        };
        this.addDestroyableEventListener(this.eBodyViewport, 'contextmenu', listener);
    };
    GridPanel.prototype.getRowForEvent = function (event) {
        var domDataKey = this.gridOptionsWrapper.getDomDataKey();
        var sourceElement = utils_1.Utils.getTarget(event);
        while (sourceElement) {
            var domData = sourceElement[domDataKey];
            if (domData && domData.renderedRow) {
                return domData.renderedRow;
            }
            sourceElement = sourceElement.parentElement;
        }
        return null;
    };
    GridPanel.prototype.processKeyboardEvent = function (eventName, keyboardEvent) {
        var renderedCell = this.mouseEventService.getRenderedCellForEvent(keyboardEvent);
        if (renderedCell) {
            switch (eventName) {
                case 'keydown':
                    renderedCell.onKeyDown(keyboardEvent);
                    break;
                case 'keypress':
                    renderedCell.onKeyPress(keyboardEvent);
                    break;
            }
        }
    };
    GridPanel.prototype.processMouseEvent = function (eventName, mouseEvent) {
        var renderedCell = this.mouseEventService.getRenderedCellForEvent(mouseEvent);
        if (renderedCell) {
            renderedCell.onMouseEvent(eventName, mouseEvent);
        }
        var renderedRow = this.getRowForEvent(mouseEvent);
        if (renderedRow) {
            renderedRow.onMouseEvent(eventName, mouseEvent);
        }
        this.preventDefaultOnContextMenu(mouseEvent);
    };
    GridPanel.prototype.onContextMenu = function (mouseEvent) {
        // to allow us to debug in chrome, we ignore the event if ctrl is pressed,
        // thus the normal menu is displayed
        if (mouseEvent.ctrlKey || mouseEvent.metaKey) {
            return;
        }
        if (this.contextMenuFactory && !this.gridOptionsWrapper.isSuppressContextMenu()) {
            this.contextMenuFactory.showMenu(null, null, null, mouseEvent);
            mouseEvent.preventDefault();
        }
    };
    GridPanel.prototype.preventDefaultOnContextMenu = function (mouseEvent) {
        // if we don't do this, then middle click will never result in a 'click' event, as 'mousedown'
        // will be consumed by the browser to mean 'scroll' (as you can scroll with the middle mouse
        // button in the browser). so this property allows the user to receive middle button clicks if
        // they want.
        if (this.gridOptionsWrapper.isSuppressMiddleClickScrolls() && mouseEvent.which === 2) {
            mouseEvent.preventDefault();
        }
    };
    GridPanel.prototype.addShortcutKeyListeners = function () {
        var _this = this;
        this.eAllCellContainers.forEach(function (container) {
            container.addEventListener('keydown', function (event) {
                // if the cell the event came from is editing, then we do not
                // want to do the default shortcut keys, otherwise the editor
                // (eg a text field) would not be able to do the normal cut/copy/paste
                var renderedCell = _this.mouseEventService.getRenderedCellForEvent(event);
                if (renderedCell && renderedCell.isEditing()) {
                    return;
                }
                if (event.ctrlKey || event.metaKey) {
                    switch (event.which) {
                        case constants_1.Constants.KEY_A: return _this.onCtrlAndA(event);
                        case constants_1.Constants.KEY_C: return _this.onCtrlAndC(event);
                        case constants_1.Constants.KEY_V: return _this.onCtrlAndV(event);
                        case constants_1.Constants.KEY_D: return _this.onCtrlAndD(event);
                    }
                }
            });
        });
    };
    GridPanel.prototype.onCtrlAndA = function (event) {
        if (this.rangeController && this.rowModel.isRowsToRender()) {
            var rowEnd;
            var floatingStart;
            var floatingEnd;
            if (this.floatingRowModel.isEmpty(constants_1.Constants.FLOATING_TOP)) {
                floatingStart = null;
            }
            else {
                floatingStart = constants_1.Constants.FLOATING_TOP;
            }
            if (this.floatingRowModel.isEmpty(constants_1.Constants.FLOATING_BOTTOM)) {
                floatingEnd = null;
                rowEnd = this.rowModel.getRowCount() - 1;
            }
            else {
                floatingEnd = constants_1.Constants.FLOATING_BOTTOM;
                rowEnd = this.floatingRowModel.getFloatingBottomRowData().length = 1;
            }
            var allDisplayedColumns = this.columnController.getAllDisplayedColumns();
            if (utils_1.Utils.missingOrEmpty(allDisplayedColumns)) {
                return;
            }
            this.rangeController.setRange({
                rowStart: 0,
                floatingStart: floatingStart,
                rowEnd: rowEnd,
                floatingEnd: floatingEnd,
                columnStart: allDisplayedColumns[0],
                columnEnd: allDisplayedColumns[allDisplayedColumns.length - 1]
            });
        }
        event.preventDefault();
        return false;
    };
    GridPanel.prototype.onCtrlAndC = function (event) {
        if (!this.clipboardService) {
            return;
        }
        var focusedCell = this.focusedCellController.getFocusedCell();
        this.clipboardService.copyToClipboard();
        event.preventDefault();
        // the copy operation results in loosing focus on the cell,
        // because of the trickery the copy logic uses with a temporary
        // widget. so we set it back again.
        if (focusedCell) {
            this.focusedCellController.setFocusedCell(focusedCell.rowIndex, focusedCell.column, focusedCell.floating, true);
        }
        return false;
    };
    GridPanel.prototype.onCtrlAndV = function (event) {
        if (!this.rangeController) {
            return;
        }
        this.clipboardService.pasteFromClipboard();
        return false;
    };
    GridPanel.prototype.onCtrlAndD = function (event) {
        if (!this.clipboardService) {
            return;
        }
        this.clipboardService.copyRangeDown();
        event.preventDefault();
        return false;
    };
    GridPanel.prototype.createOverlayTemplate = function (name, defaultTemplate, userProvidedTemplate) {
        var template = mainOverlayTemplate
            .replace('[OVERLAY_NAME]', name);
        if (userProvidedTemplate) {
            template = template.replace('[OVERLAY_TEMPLATE]', userProvidedTemplate);
        }
        else {
            template = template.replace('[OVERLAY_TEMPLATE]', defaultTemplate);
        }
        return template;
    };
    GridPanel.prototype.createLoadingOverlayTemplate = function () {
        var userProvidedTemplate = this.gridOptionsWrapper.getOverlayLoadingTemplate();
        var templateNotLocalised = this.createOverlayTemplate('loading', defaultLoadingOverlayTemplate, userProvidedTemplate);
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var templateLocalised = templateNotLocalised.replace('[LOADING...]', localeTextFunc('loadingOoo', 'Loading...'));
        return templateLocalised;
    };
    GridPanel.prototype.createNoRowsOverlayTemplate = function () {
        var userProvidedTemplate = this.gridOptionsWrapper.getOverlayNoRowsTemplate();
        var templateNotLocalised = this.createOverlayTemplate('no-rows', defaultNoRowsOverlayTemplate, userProvidedTemplate);
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        var templateLocalised = templateNotLocalised.replace('[NO_ROWS_TO_SHOW]', localeTextFunc('noRowsToShow', 'No Rows To Show'));
        return templateLocalised;
    };
    GridPanel.prototype.ensureIndexVisible = function (index) {
        this.logger.log('ensureIndexVisible: ' + index);
        var lastRow = this.rowModel.getRowCount();
        if (typeof index !== 'number' || index < 0 || index >= lastRow) {
            console.warn('invalid row index for ensureIndexVisible: ' + index);
            return;
        }
        var nodeAtIndex = this.rowModel.getRow(index);
        var rowTopPixel = nodeAtIndex.rowTop;
        var rowBottomPixel = rowTopPixel + nodeAtIndex.rowHeight;
        var vRange = this.getVerticalPixelRange();
        var vRangeTop = vRange.top;
        var vRangeBottom = vRange.bottom;
        var scrollShowing = this.isHorizontalScrollShowing();
        if (scrollShowing) {
            vRangeBottom -= this.scrollWidth;
        }
        var viewportScrolledPastRow = vRangeTop > rowTopPixel;
        var viewportScrolledBeforeRow = vRangeBottom < rowBottomPixel;
        var eViewportToScroll = this.getPrimaryScrollViewport();
        if (viewportScrolledPastRow) {
            // if row is before, scroll up with row at top
            eViewportToScroll.scrollTop = rowTopPixel;
            this.rowRenderer.drawVirtualRowsWithLock();
        }
        else if (viewportScrolledBeforeRow) {
            // if row is below, scroll down with row at bottom
            var viewportHeight = vRangeBottom - vRangeTop;
            var newScrollPosition = rowBottomPixel - viewportHeight;
            eViewportToScroll.scrollTop = newScrollPosition;
            this.rowRenderer.drawVirtualRowsWithLock();
        }
        // otherwise, row is already in view, so do nothing
    };
    GridPanel.prototype.getPrimaryScrollViewport = function () {
        if (this.enableRtl && this.columnController.isPinningLeft()) {
            return this.ePinnedLeftColsViewport;
        }
        else if (!this.enableRtl && this.columnController.isPinningRight()) {
            return this.ePinnedRightColsViewport;
        }
        else {
            return this.eBodyViewport;
        }
    };
    // + moveColumnController
    GridPanel.prototype.getCenterWidth = function () {
        return this.eBodyViewport.clientWidth;
    };
    GridPanel.prototype.isHorizontalScrollShowing = function () {
        var result = utils_1.Utils.isHorizontalScrollShowing(this.eBodyViewport);
        return result;
    };
    GridPanel.prototype.isVerticalScrollShowing = function () {
        if (this.columnController.isPinningRight()) {
            return utils_1.Utils.isVerticalScrollShowing(this.ePinnedRightColsViewport);
        }
        else {
            return utils_1.Utils.isVerticalScrollShowing(this.eBodyViewport);
        }
    };
    GridPanel.prototype.isBodyVerticalScrollShowing = function () {
        // if the scroll is on the pinned panel, then it is never in the center panel.
        // if LRT, then pinning right means scroll NOT on center
        if (!this.enableRtl && this.columnController.isPinningRight()) {
            return false;
        }
        // if RTL, then pinning left means scroll NOT on center
        if (this.enableRtl && this.columnController.isPinningLeft()) {
            return false;
        }
        return utils_1.Utils.isVerticalScrollShowing(this.eBodyViewport);
    };
    // gets called every 500 ms. we use this to set padding on right pinned column
    GridPanel.prototype.periodicallyCheck = function () {
        if (this.forPrint) {
            return;
        }
        this.setBottomPaddingOnPinnedRight();
        this.setMarginOnFullWidthCellContainer();
        this.setScrollShowing();
    };
    GridPanel.prototype.setScrollShowing = function () {
        var params = {
            vBody: false,
            hBody: false,
            vPinnedLeft: false,
            vPinnedRight: false
        };
        if (this.enableRtl) {
            if (this.columnController.isPinningLeft()) {
                params.vPinnedLeft = this.forPrint ? false : utils_1.Utils.isVerticalScrollShowing(this.ePinnedLeftColsViewport);
            }
            else {
                params.vBody = utils_1.Utils.isVerticalScrollShowing(this.eBodyViewport);
            }
        }
        else {
            if (this.columnController.isPinningRight()) {
                params.vPinnedRight = this.forPrint ? false : utils_1.Utils.isVerticalScrollShowing(this.ePinnedRightColsViewport);
            }
            else {
                params.vBody = utils_1.Utils.isVerticalScrollShowing(this.eBodyViewport);
            }
        }
        params.hBody = utils_1.Utils.isHorizontalScrollShowing(this.eBodyViewport);
        this.scrollVisibleService.setScrollsVisible(params);
    };
    // the pinned container needs extra space at the bottom, some blank space, otherwise when
    // vertically scrolled all the way down, the last row will be hidden behind the scrolls.
    // this extra padding allows the last row to be lifted above the bottom scrollbar.
    GridPanel.prototype.setBottomPaddingOnPinnedRight = function () {
        if (this.forPrint) {
            return;
        }
        if (this.columnController.isPinningRight()) {
            var bodyHorizontalScrollShowing = this.eBodyViewport.clientWidth < this.eBodyViewport.scrollWidth;
            if (bodyHorizontalScrollShowing) {
                this.ePinnedRightColsContainer.style.marginBottom = this.scrollWidth + 'px';
            }
            else {
                this.ePinnedRightColsContainer.style.marginBottom = '';
            }
        }
    };
    GridPanel.prototype.setMarginOnFullWidthCellContainer = function () {
        if (this.forPrint) {
            return;
        }
        // if either right or bottom scrollbars are showing, we need to make sure the
        // fullWidthCell panel isn't covering the scrollbars. originally i tried to do this using
        // margin, but the overflow was not getting clipped and going into the margin,
        // so used border instead. dunno why it works, trial and error found the solution.
        if (this.enableRtl) {
            if (this.isVerticalScrollShowing()) {
                this.eFullWidthCellViewport.style.borderLeft = this.scrollWidth + 'px solid transparent';
            }
            else {
                this.eFullWidthCellViewport.style.borderLeft = '';
            }
        }
        else {
            if (this.isVerticalScrollShowing()) {
                this.eFullWidthCellViewport.style.borderRight = this.scrollWidth + 'px solid transparent';
            }
            else {
                this.eFullWidthCellViewport.style.borderRight = '';
            }
        }
        if (this.isHorizontalScrollShowing()) {
            this.eFullWidthCellViewport.style.borderBottom = this.scrollWidth + 'px solid transparent';
        }
        else {
            this.eFullWidthCellViewport.style.borderBottom = '';
        }
    };
    GridPanel.prototype.ensureColumnVisible = function (key) {
        var column = this.columnController.getGridColumn(key);
        if (!column) {
            return;
        }
        if (column.isPinned()) {
            console.warn('calling ensureIndexVisible on a ' + column.getPinned() + ' pinned column doesn\'t make sense for column ' + column.getColId());
            return;
        }
        if (!this.columnController.isColumnDisplayed(column)) {
            console.warn('column is not currently visible');
            return;
        }
        var colLeftPixel = column.getLeft();
        var colRightPixel = colLeftPixel + column.getActualWidth();
        var viewportWidth = this.eBodyViewport.clientWidth;
        var scrollPosition = this.getBodyViewportScrollLeft();
        var bodyWidth = this.columnController.getBodyContainerWidth();
        var viewportLeftPixel;
        var viewportRightPixel;
        // the logic of working out left and right viewport px is both here and in the ColumnController,
        // need to refactor it out to one place
        if (this.enableRtl) {
            viewportLeftPixel = bodyWidth - scrollPosition - viewportWidth;
            viewportRightPixel = bodyWidth - scrollPosition;
        }
        else {
            viewportLeftPixel = scrollPosition;
            viewportRightPixel = viewportWidth + scrollPosition;
        }
        var viewportScrolledPastCol = viewportLeftPixel > colLeftPixel;
        var viewportScrolledBeforeCol = viewportRightPixel < colRightPixel;
        if (viewportScrolledPastCol) {
            // if viewport's left side is after col's left side, scroll right to pull col into viewport at left
            if (this.enableRtl) {
                var newScrollPosition = bodyWidth - viewportWidth - colLeftPixel;
                this.setBodyViewportScrollLeft(newScrollPosition);
            }
            else {
                this.setBodyViewportScrollLeft(colLeftPixel);
            }
        }
        else if (viewportScrolledBeforeCol) {
            // if viewport's right side is before col's right side, scroll left to pull col into viewport at right
            if (this.enableRtl) {
                var newScrollPosition = bodyWidth - colRightPixel;
                this.setBodyViewportScrollLeft(newScrollPosition);
            }
            else {
                var newScrollPosition = colRightPixel - viewportWidth;
                this.setBodyViewportScrollLeft(newScrollPosition);
            }
        }
        else {
        }
        // this will happen anyway, as the move will cause a 'scroll' event on the body, however
        // it is possible that the ensureColumnVisible method is called from within ag-Grid and
        // the caller will need to have the columns rendered to continue, which will be before
        // the event has been worked on (which is the case for cell navigation).
        this.setLeftAndRightBounds();
    };
    GridPanel.prototype.showLoadingOverlay = function () {
        if (!this.gridOptionsWrapper.isSuppressLoadingOverlay()) {
            this.layout.showOverlay('loading');
        }
    };
    GridPanel.prototype.showNoRowsOverlay = function () {
        if (!this.gridOptionsWrapper.isSuppressNoRowsOverlay()) {
            this.layout.showOverlay('noRows');
        }
    };
    GridPanel.prototype.hideOverlay = function () {
        this.layout.hideOverlay();
    };
    GridPanel.prototype.getWidthForSizeColsToFit = function () {
        var availableWidth = this.eBody.clientWidth;
        // if pinning right, then the scroll bar can show, however for some reason
        // it overlays the grid and doesn't take space. so we are only interested
        // in the body scroll showing.
        var removeScrollWidth = this.isBodyVerticalScrollShowing();
        if (removeScrollWidth) {
            availableWidth -= this.scrollWidth;
        }
        return availableWidth;
    };
    // method will call itself if no available width. this covers if the grid
    // isn't visible, but is just about to be visible.
    GridPanel.prototype.sizeColumnsToFit = function (nextTimeout) {
        var _this = this;
        var availableWidth = this.getWidthForSizeColsToFit();
        if (availableWidth > 0) {
            this.columnController.sizeColumnsToFit(availableWidth);
        }
        else {
            if (nextTimeout === undefined) {
                setTimeout(function () {
                    _this.sizeColumnsToFit(100);
                }, 0);
            }
            else if (nextTimeout === 100) {
                setTimeout(function () {
                    _this.sizeColumnsToFit(-1);
                }, 100);
            }
            else {
                console.log('ag-Grid: tried to call sizeColumnsToFit() but the grid is coming back with ' +
                    'zero width, maybe the grid is not visible yet on the screen?');
            }
        }
    };
    GridPanel.prototype.getBodyContainer = function () {
        return this.eBodyContainer;
    };
    GridPanel.prototype.getDropTargetBodyContainers = function () {
        if (this.forPrint) {
            return [this.eBodyContainer, this.eFloatingTopContainer, this.eFloatingBottomContainer];
        }
        else {
            return [this.eBodyViewport, this.eFloatingTopViewport, this.eFloatingBottomViewport];
        }
    };
    GridPanel.prototype.getBodyViewport = function () {
        return this.eBodyViewport;
    };
    GridPanel.prototype.getDropTargetLeftContainers = function () {
        if (this.forPrint) {
            return [];
        }
        else {
            return [this.ePinnedLeftColsViewport, this.ePinnedLeftFloatingBottom, this.ePinnedLeftFloatingTop];
        }
    };
    GridPanel.prototype.getDropTargetPinnedRightContainers = function () {
        if (this.forPrint) {
            return [];
        }
        else {
            return [this.ePinnedRightColsViewport, this.ePinnedRightFloatingBottom, this.ePinnedRightFloatingTop];
        }
    };
    GridPanel.prototype.getHeaderContainer = function () {
        return this.eHeaderContainer;
    };
    GridPanel.prototype.getHeaderOverlay = function () {
        return this.eHeaderOverlay;
    };
    GridPanel.prototype.getRoot = function () {
        return this.eRoot;
    };
    GridPanel.prototype.getPinnedLeftHeader = function () {
        return this.ePinnedLeftHeader;
    };
    GridPanel.prototype.getPinnedRightHeader = function () {
        return this.ePinnedRightHeader;
    };
    GridPanel.prototype.queryHtmlElement = function (selector) {
        return this.eRoot.querySelector(selector);
    };
    GridPanel.prototype.loadTemplate = function () {
        // the template we use is different when doing 'for print'
        var template = this.forPrint ? gridForPrintHtml : gridHtml;
        this.eRoot = utils_1.Utils.loadTemplate(template);
        // parts of the CSS need to know if we are in 'for print' mode or not,
        // so we add a class to allow applying CSS based on this.
        var scrollClass = this.forPrint ? 'ag-no-scrolls' : 'ag-scrolls';
        utils_1.Utils.addCssClass(this.eRoot, scrollClass);
    };
    GridPanel.prototype.findElements = function () {
        if (this.forPrint) {
            this.eHeaderContainer = this.queryHtmlElement('.ag-header-container');
            this.eBodyContainer = this.queryHtmlElement('.ag-body-container');
            this.eFloatingTopContainer = this.queryHtmlElement('.ag-floating-top-container');
            this.eFloatingBottomContainer = this.queryHtmlElement('.ag-floating-bottom-container');
            this.eAllCellContainers = [this.eBodyContainer, this.eFloatingTopContainer, this.eFloatingBottomContainer];
            var containers = {
                body: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eBodyContainer, useDocumentFragment: true }),
                fullWidth: null,
                pinnedLeft: null,
                pinnedRight: null,
                floatingTop: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingTopContainer }),
                floatingTopPinnedLeft: null,
                floatingTopPinnedRight: null,
                floatingTopFullWidth: null,
                floatingBottom: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingBottomContainer }),
                floatingBottomPinnedLeft: null,
                floatingBottomPinnedRight: null,
                floatingBottomFullWith: null
            };
            this.rowContainerComponents = containers;
            // when doing forPrint, we don't have any fullWidth containers, instead we add directly to the main
            // containers. this works in forPrint only as there are no pinned columns (no need for fullWidth to
            // span pinned columns) and the rows are already the full width of the grid (the reason for fullWidth)
            containers.fullWidth = containers.body;
            containers.floatingBottomFullWith = containers.floatingBottom;
            containers.floatingTopFullWidth = containers.floatingTop;
        }
        else {
            this.eBody = this.queryHtmlElement('.ag-body');
            this.eBodyContainer = this.queryHtmlElement('.ag-body-container');
            this.eBodyViewport = this.queryHtmlElement('.ag-body-viewport');
            this.eBodyViewportWrapper = this.queryHtmlElement('.ag-body-viewport-wrapper');
            this.eFullWidthCellContainer = this.queryHtmlElement('.ag-full-width-container');
            this.eFullWidthCellViewport = this.queryHtmlElement('.ag-full-width-viewport');
            this.ePinnedLeftColsContainer = this.queryHtmlElement('.ag-pinned-left-cols-container');
            this.ePinnedRightColsContainer = this.queryHtmlElement('.ag-pinned-right-cols-container');
            this.ePinnedLeftColsViewport = this.queryHtmlElement('.ag-pinned-left-cols-viewport');
            this.ePinnedRightColsViewport = this.queryHtmlElement('.ag-pinned-right-cols-viewport');
            this.ePinnedLeftHeader = this.queryHtmlElement('.ag-pinned-left-header');
            this.ePinnedRightHeader = this.queryHtmlElement('.ag-pinned-right-header');
            this.eHeader = this.queryHtmlElement('.ag-header');
            this.eHeaderContainer = this.queryHtmlElement('.ag-header-container');
            this.eHeaderOverlay = this.queryHtmlElement('.ag-header-overlay');
            this.eHeaderViewport = this.queryHtmlElement('.ag-header-viewport');
            this.eFloatingTop = this.queryHtmlElement('.ag-floating-top');
            this.ePinnedLeftFloatingTop = this.queryHtmlElement('.ag-pinned-left-floating-top');
            this.ePinnedRightFloatingTop = this.queryHtmlElement('.ag-pinned-right-floating-top');
            this.eFloatingTopContainer = this.queryHtmlElement('.ag-floating-top-container');
            this.eFloatingTopViewport = this.queryHtmlElement('.ag-floating-top-viewport');
            this.eFloatingTopFullWidthCellContainer = this.queryHtmlElement('.ag-floating-top-full-width-container');
            this.eFloatingBottom = this.queryHtmlElement('.ag-floating-bottom');
            this.ePinnedLeftFloatingBottom = this.queryHtmlElement('.ag-pinned-left-floating-bottom');
            this.ePinnedRightFloatingBottom = this.queryHtmlElement('.ag-pinned-right-floating-bottom');
            this.eFloatingBottomContainer = this.queryHtmlElement('.ag-floating-bottom-container');
            this.eFloatingBottomViewport = this.queryHtmlElement('.ag-floating-bottom-viewport');
            this.eFloatingBottomFullWidthCellContainer = this.queryHtmlElement('.ag-floating-bottom-full-width-container');
            this.eAllCellContainers = [
                this.ePinnedLeftColsContainer, this.ePinnedRightColsContainer, this.eBodyContainer,
                this.eFloatingTop, this.eFloatingBottom, this.eFullWidthCellContainer];
            this.rowContainerComponents = {
                body: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eBodyContainer, eViewport: this.eBodyViewport, useDocumentFragment: true }),
                fullWidth: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFullWidthCellContainer, hideWhenNoChildren: true, eViewport: this.eFullWidthCellViewport }),
                pinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedLeftColsContainer, eViewport: this.ePinnedLeftColsViewport, useDocumentFragment: true }),
                pinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedRightColsContainer, eViewport: this.ePinnedRightColsViewport, useDocumentFragment: true }),
                floatingTop: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingTopContainer }),
                floatingTopPinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedLeftFloatingTop }),
                floatingTopPinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedRightFloatingTop }),
                floatingTopFullWidth: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingTopFullWidthCellContainer, hideWhenNoChildren: true }),
                floatingBottom: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingBottomContainer }),
                floatingBottomPinnedLeft: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedLeftFloatingBottom }),
                floatingBottomPinnedRight: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.ePinnedRightFloatingBottom }),
                floatingBottomFullWith: new rowContainerComponent_1.RowContainerComponent({ eContainer: this.eFloatingBottomFullWidthCellContainer, hideWhenNoChildren: true }),
            };
            this.addMouseWheelEventListeners();
        }
    };
    GridPanel.prototype.getRowContainers = function () {
        return this.rowContainerComponents;
    };
    GridPanel.prototype.addMouseWheelEventListeners = function () {
        // IE9, Chrome, Safari, Opera use 'mousewheel', Firefox uses 'DOMMouseScroll'
        this.addDestroyableEventListener(this.eBodyViewport, 'mousewheel', this.centerMouseWheelListener.bind(this));
        this.addDestroyableEventListener(this.eBodyViewport, 'DOMMouseScroll', this.centerMouseWheelListener.bind(this));
        if (this.enableRtl) {
            this.addDestroyableEventListener(this.ePinnedRightColsViewport, 'mousewheel', this.genericMouseWheelListener.bind(this));
            this.addDestroyableEventListener(this.ePinnedRightColsViewport, 'DOMMouseScroll', this.genericMouseWheelListener.bind(this));
        }
        else {
            this.addDestroyableEventListener(this.ePinnedLeftColsViewport, 'mousewheel', this.genericMouseWheelListener.bind(this));
            this.addDestroyableEventListener(this.ePinnedLeftColsViewport, 'DOMMouseScroll', this.genericMouseWheelListener.bind(this));
        }
    };
    GridPanel.prototype.getHeaderViewport = function () {
        return this.eHeaderViewport;
    };
    GridPanel.prototype.centerMouseWheelListener = function (event) {
        // we are only interested in mimicking the mouse wheel if we are not scrolling on the middle,
        // otherwise the body has scrolls and the mouse wheel works for free
        var bodyVScrollShowing = this.isBodyVerticalScrollActive();
        if (!bodyVScrollShowing) {
            var targetPanel = this.enableRtl ? this.ePinnedLeftColsViewport : this.ePinnedRightColsViewport;
            return this.generalMouseWheelListener(event, targetPanel);
        }
    };
    // used for listening to mouse wheel events on 1) left pinned and also the 2) fullWidthCell components.
    // the fullWidthCell listener is added in renderedRow, hence public.
    GridPanel.prototype.genericMouseWheelListener = function (event) {
        var targetPanel;
        var bodyVScrollActive = this.isBodyVerticalScrollActive();
        if (bodyVScrollActive) {
            targetPanel = this.eBodyViewport;
        }
        else {
            targetPanel = this.enableRtl ? this.ePinnedLeftColsViewport : this.ePinnedRightColsViewport;
        }
        return this.generalMouseWheelListener(event, targetPanel);
    };
    GridPanel.prototype.generalMouseWheelListener = function (event, targetPanel) {
        var wheelEvent = utils_1.Utils.normalizeWheel(event);
        // we need to detect in which direction scroll is happening to allow trackpads scroll horizontally
        // horizontal scroll
        if (Math.abs(wheelEvent.pixelX) > Math.abs(wheelEvent.pixelY)) {
            var newLeftPosition = this.eBodyViewport.scrollLeft + wheelEvent.pixelX;
            this.eBodyViewport.scrollLeft = newLeftPosition;
        }
        else {
            var newTopPosition = targetPanel.scrollTop + wheelEvent.pixelY;
            targetPanel.scrollTop = newTopPosition;
        }
        // allow the option to pass mouse wheel events to the browser
        // https://github.com/ceolter/ag-grid/issues/800
        // in the future, this should be tied in with 'forPrint' option, or have an option 'no vertical scrolls'
        if (!this.gridOptionsWrapper.isSuppressPreventDefaultOnMouseWheel()) {
            // if we don't prevent default, then the whole browser will scroll also as well as the grid
            event.preventDefault();
        }
        return false;
    };
    GridPanel.prototype.onDisplayedColumnsChanged = function () {
        this.setPinnedContainersVisible();
        this.setBodyAndHeaderHeights();
        this.setLeftAndRightBounds();
    };
    GridPanel.prototype.onDisplayedColumnsWidthChanged = function () {
        this.setWidthsOfContainers();
        this.setLeftAndRightBounds();
        if (this.enableRtl) {
            // because RTL is all backwards, a change in the width of the row
            // can cause a change in the scroll position, without a scroll event,
            // because the scroll position in RTL is a function that depends on
            // the width. to be convinced of this, take out this line, enable RTL,
            // scroll all the way to the left and then resize a column
            this.horizontallyScrollHeaderCenterAndFloatingCenter();
        }
    };
    GridPanel.prototype.onScrollVisibilityChanged = function () {
        this.setWidthsOfContainers();
    };
    GridPanel.prototype.setWidthsOfContainers = function () {
        var mainRowWidth = this.columnController.getBodyContainerWidth() + 'px';
        this.eBodyContainer.style.width = mainRowWidth;
        if (this.forPrint) {
            // pinned col doesn't exist when doing forPrint
            return;
        }
        this.eFloatingBottomContainer.style.width = mainRowWidth;
        this.eFloatingTopContainer.style.width = mainRowWidth;
        this.setPinnedLeftWidth();
        this.setPinnedRightWidth();
    };
    GridPanel.prototype.setPinnedLeftWidth = function () {
        var pinnedLeftWidth = this.scrollVisibleService.getPinnedLeftWidth() + 'px';
        var pinnedLeftWidthWithScroll = this.scrollVisibleService.getPinnedLeftWithScrollWidth() + 'px';
        this.ePinnedLeftColsViewport.style.width = pinnedLeftWidthWithScroll;
        this.eBodyViewportWrapper.style.marginLeft = pinnedLeftWidthWithScroll;
        this.ePinnedLeftFloatingBottom.style.width = pinnedLeftWidthWithScroll;
        this.ePinnedLeftFloatingTop.style.width = pinnedLeftWidthWithScroll;
        this.ePinnedLeftColsContainer.style.width = pinnedLeftWidth;
    };
    GridPanel.prototype.setPinnedRightWidth = function () {
        var pinnedRightWidth = this.scrollVisibleService.getPinnedRightWidth() + 'px';
        var pinnedRightWidthWithScroll = this.scrollVisibleService.getPinnedRightWithScrollWidth() + 'px';
        this.ePinnedRightColsViewport.style.width = pinnedRightWidthWithScroll;
        this.eBodyViewportWrapper.style.marginRight = pinnedRightWidthWithScroll;
        this.ePinnedRightFloatingBottom.style.width = pinnedRightWidthWithScroll;
        this.ePinnedRightFloatingTop.style.width = pinnedRightWidthWithScroll;
        this.ePinnedRightColsContainer.style.width = pinnedRightWidth;
    };
    GridPanel.prototype.setPinnedContainersVisible = function () {
        // no need to do this if not using scrolls
        if (this.forPrint) {
            return;
        }
        var changeDetected = false;
        var showLeftPinned = this.columnController.isPinningLeft();
        if (showLeftPinned !== this.pinningLeft) {
            this.pinningLeft = showLeftPinned;
            this.ePinnedLeftHeader.style.display = showLeftPinned ? 'inline-block' : 'none';
            this.ePinnedLeftColsViewport.style.display = showLeftPinned ? 'inline' : 'none';
            changeDetected = true;
        }
        var showRightPinned = this.columnController.isPinningRight();
        if (showRightPinned !== this.pinningRight) {
            this.pinningRight = showRightPinned;
            this.ePinnedRightHeader.style.display = showRightPinned ? 'inline-block' : 'none';
            this.ePinnedRightColsViewport.style.display = showRightPinned ? 'inline' : 'none';
            changeDetected = true;
        }
        if (changeDetected) {
            var bodyVScrollActive = this.isBodyVerticalScrollActive();
            this.eBodyViewport.style.overflowY = bodyVScrollActive ? 'auto' : 'hidden';
            // if we are v scrolling, then one of these will have the scroll position
            var scrollTop = Math.max(this.eBodyViewport.scrollTop, this.ePinnedLeftColsViewport.scrollTop, this.ePinnedRightColsViewport.scrollTop);
            // the body either uses it's scroll (when scrolling) or it's style.top
            // (when following the scroll of a pinned section), so we need to set it
            // back when changing from one to the other
            if (bodyVScrollActive) {
                this.eBodyContainer.style.top = '0px';
            }
            else {
                this.eBodyViewport.scrollTop = 0;
            }
            // when changing the primary scroll viewport, we copy over the scroll position,
            // eg if body was getting scrolled and we were at position 100px, then we start
            // pinning and pinned viewport is now the primary, we need to set it to 100px
            var primaryScrollViewport = this.getPrimaryScrollViewport();
            primaryScrollViewport.scrollTop = scrollTop;
            // this adjusts the scroll position of all the faking panels. they should already
            // be correct except body which has potentially just turned to be fake.
            this.fakeVerticalScroll(scrollTop);
        }
    };
    // init, layoutChanged, floatingDataChanged, headerHeightChanged
    GridPanel.prototype.setBodyAndHeaderHeights = function () {
        if (this.forPrint) {
            // if doing 'for print', then the header and footers are laid
            // out naturally by the browser. it whatever size that's needed to fit.
            return;
        }
        var heightOfContainer = this.layout.getCentreHeight();
        if (!heightOfContainer) {
            return;
        }
        var headerHeight = this.gridOptionsWrapper.getHeaderHeight();
        var numberOfRowsInHeader = this.columnController.getHeaderRowCount();
        var totalHeaderHeight = headerHeight * numberOfRowsInHeader;
        this.eHeader.style['height'] = totalHeaderHeight + 'px';
        // padding top covers the header and the floating rows on top
        var floatingTopHeight = this.floatingRowModel.getFloatingTopTotalHeight();
        var paddingTop = totalHeaderHeight + floatingTopHeight;
        // bottom is just the bottom floating rows
        var floatingBottomHeight = this.floatingRowModel.getFloatingBottomTotalHeight();
        var floatingBottomTop = heightOfContainer - floatingBottomHeight;
        var heightOfCentreRows = heightOfContainer - totalHeaderHeight - floatingBottomHeight - floatingTopHeight;
        this.eBody.style.top = paddingTop + 'px';
        this.eBody.style.height = heightOfCentreRows + 'px';
        this.eFloatingTop.style.top = totalHeaderHeight + 'px';
        this.eFloatingTop.style.height = floatingTopHeight + 'px';
        this.eFloatingBottom.style.height = floatingBottomHeight + 'px';
        this.eFloatingBottom.style.top = floatingBottomTop + 'px';
        this.ePinnedLeftColsViewport.style.height = heightOfCentreRows + 'px';
        this.ePinnedRightColsViewport.style.height = heightOfCentreRows + 'px';
    };
    GridPanel.prototype.setHorizontalScrollPosition = function (hScrollPosition) {
        this.eBodyViewport.scrollLeft = hScrollPosition;
    };
    // tries to scroll by pixels, but returns what the result actually was
    GridPanel.prototype.scrollHorizontally = function (pixels) {
        var oldScrollPosition = this.eBodyViewport.scrollLeft;
        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
        var newScrollPosition = this.eBodyViewport.scrollLeft;
        return newScrollPosition - oldScrollPosition;
    };
    GridPanel.prototype.turnOnAnimationForABit = function () {
        var _this = this;
        if (this.gridOptionsWrapper.isSuppressColumnMoveAnimation()) {
            return;
        }
        this.animationThreadCount++;
        var animationThreadCountCopy = this.animationThreadCount;
        utils_1.Utils.addCssClass(this.eRoot, 'ag-column-moving');
        setTimeout(function () {
            if (_this.animationThreadCount === animationThreadCountCopy) {
                utils_1.Utils.removeCssClass(_this.eRoot, 'ag-column-moving');
            }
        }, 300);
    };
    GridPanel.prototype.addScrollListener = function () {
        var _this = this;
        // if printing, then no scrolling, so no point in listening for scroll events
        if (this.forPrint) {
            return;
        }
        var wrapWithDebounce = function (func) {
            if (_this.useScrollLag) {
                return _this.debounce.bind(_this, func);
            }
            else {
                return func;
            }
        };
        var bodyScrollListener = wrapWithDebounce(this.onBodyScroll.bind(this));
        this.addDestroyableEventListener(this.eBodyViewport, 'scroll', bodyScrollListener);
        // below we add two things:
        // pinnedScrollListener -> when pinned panel with scrollbar gets scrolled, it updates body and other pinned
        // suppressScroll -> stops scrolling when pinned panel was moved - which can only happen when user is navigating
        //     in the pinned container, as the pinned col should never scroll. so we rollback the scroll on the pinned.
        var onPinnedLeftVerticalScroll = this.onVerticalScroll.bind(this, this.ePinnedLeftColsViewport);
        var onPinnedRightVerticalScroll = this.onVerticalScroll.bind(this, this.ePinnedRightColsViewport);
        if (this.enableRtl) {
            var pinnedScrollListener = wrapWithDebounce(onPinnedLeftVerticalScroll);
            this.addDestroyableEventListener(this.ePinnedLeftColsViewport, 'scroll', pinnedScrollListener);
            var suppressScroll = function () { return _this.ePinnedRightColsViewport.scrollTop = 0; };
            this.addDestroyableEventListener(this.ePinnedRightColsViewport, 'scroll', suppressScroll);
        }
        else {
            var pinnedScrollListener = wrapWithDebounce(onPinnedRightVerticalScroll);
            this.addDestroyableEventListener(this.ePinnedRightColsViewport, 'scroll', pinnedScrollListener);
            var suppressScroll = function () { return _this.ePinnedLeftColsViewport.scrollTop = 0; };
            this.addDestroyableEventListener(this.ePinnedLeftColsViewport, 'scroll', suppressScroll);
        }
        this.addIEPinFix(onPinnedRightVerticalScroll, onPinnedLeftVerticalScroll);
    };
    GridPanel.prototype.onBodyScroll = function () {
        this.onBodyHorizontalScroll();
        this.onBodyVerticalScroll();
    };
    GridPanel.prototype.onBodyHorizontalScroll = function () {
        var newLeftPosition = this.eBodyViewport.scrollLeft;
        if (newLeftPosition !== this.lastLeftPosition) {
            this.eventService.dispatchEvent(events_1.Events.EVENT_BODY_SCROLL, { direction: 'horizontal' });
            this.lastLeftPosition = newLeftPosition;
            this.horizontallyScrollHeaderCenterAndFloatingCenter();
            this.masterSlaveService.fireHorizontalScrollEvent(newLeftPosition);
            this.setLeftAndRightBounds();
        }
    };
    GridPanel.prototype.onBodyVerticalScroll = function () {
        var bodyVScrollActive = this.isBodyVerticalScrollActive();
        if (bodyVScrollActive) {
            this.onVerticalScroll(this.eBodyViewport);
        }
    };
    GridPanel.prototype.onVerticalScroll = function (sourceElement) {
        var newTopPosition = sourceElement.scrollTop;
        if (newTopPosition !== this.lastTopPosition) {
            this.eventService.dispatchEvent(events_1.Events.EVENT_BODY_SCROLL, { direction: 'vertical' });
            this.lastTopPosition = newTopPosition;
            this.fakeVerticalScroll(newTopPosition);
            this.rowRenderer.drawVirtualRowsWithLock();
        }
    };
    // if LTR, we hide body scroll if pinning right (as scroll is in right pinned),
    // if RTL, we hide body scroll if pinning left (as scroll is in left pinned)
    GridPanel.prototype.isBodyVerticalScrollActive = function () {
        var pinningRight = this.columnController.isPinningRight();
        var pinningLeft = this.columnController.isPinningLeft();
        var centerHasScroll = this.enableRtl ? !pinningLeft : !pinningRight;
        return centerHasScroll;
    };
    // this bit is a fix / hack for IE due to this:
    // https://www.ag-grid.com/forum/showthread.php?tid=4303
    // it gets the left panel to reposition itself after a model change
    GridPanel.prototype.addIEPinFix = function (onPinnedRightScroll, onPinnedLeftScroll) {
        var _this = this;
        var listener = function () {
            if (_this.columnController.isPinningRight()) {
                setTimeout(function () {
                    if (_this.enableRtl) {
                        onPinnedLeftScroll();
                    }
                    else {
                        onPinnedRightScroll();
                    }
                }, 0);
            }
        };
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_MODEL_UPDATED, listener);
    };
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    GridPanel.prototype.setLeftAndRightBounds = function () {
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        var scrollWidth = this.eBodyViewport.clientWidth;
        var scrollPosition = this.getBodyViewportScrollLeft();
        this.columnController.setVirtualViewportPosition(scrollWidth, scrollPosition);
    };
    GridPanel.prototype.isUseScrollLag = function () {
        // if we are in IE or Safari, then we only redraw if there was no scroll event
        // in the 50ms following this scroll event. without this, these browsers have
        // a bad scrolling feel, where the redraws clog the scroll experience
        // (makes the scroll clunky and sticky). this method is like throttling
        // the scroll events.
        // let the user override scroll lag option
        if (this.gridOptionsWrapper.isSuppressScrollLag()) {
            return false;
        }
        else if (this.gridOptionsWrapper.getIsScrollLag()) {
            return this.gridOptionsWrapper.getIsScrollLag()();
        }
        else {
            return utils_1.Utils.isBrowserIE() || utils_1.Utils.isBrowserSafari();
        }
    };
    GridPanel.prototype.debounce = function (callback) {
        var _this = this;
        if (this.requestAnimationFrameExists && utils_1.Utils.isBrowserSafari()) {
            if (!this.scrollLagTicking) {
                this.scrollLagTicking = true;
                requestAnimationFrame(function () {
                    callback();
                    _this.scrollLagTicking = false;
                });
            }
        }
        else {
            this.scrollLagCounter++;
            var scrollLagCounterCopy = this.scrollLagCounter;
            setTimeout(function () {
                if (_this.scrollLagCounter === scrollLagCounterCopy) {
                    callback();
                }
            }, 50);
        }
    };
    GridPanel.prototype.getBodyViewportScrollLeft = function () {
        if (this.forPrint) {
            return 0;
        }
        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
        return utils_1.Utils.getScrollLeft(this.eBodyViewport, this.enableRtl);
    };
    GridPanel.prototype.setBodyViewportScrollLeft = function (value) {
        if (this.forPrint) {
            return;
        }
        // we defer to a util, as how you calculated scrollLeft when doing RTL depends on the browser
        utils_1.Utils.setScrollLeft(this.eBodyViewport, value, this.enableRtl);
    };
    GridPanel.prototype.horizontallyScrollHeaderCenterAndFloatingCenter = function () {
        var scrollLeft = this.getBodyViewportScrollLeft();
        var offset = this.enableRtl ? scrollLeft : -scrollLeft;
        this.eHeaderContainer.style.left = offset + 'px';
        this.eFloatingBottomContainer.style.left = offset + 'px';
        this.eFloatingTopContainer.style.left = offset + 'px';
    };
    // we say fake scroll as only one panel (left, right or body) has scrolls,
    // the other panels mimic the scroll by getting it's top position updated.
    GridPanel.prototype.fakeVerticalScroll = function (position) {
        if (this.enableRtl) {
            // RTL
            // if pinning left, then body scroll is faking
            var pinningLeft = this.columnController.isPinningLeft();
            if (pinningLeft) {
                this.eBodyContainer.style.top = -position + 'px';
            }
            // right is always faking
            this.ePinnedRightColsContainer.style.top = -position + 'px';
        }
        else {
            // LTR
            // if pinning right, then body scroll is faking
            var pinningRight = this.columnController.isPinningRight();
            if (pinningRight) {
                this.eBodyContainer.style.top = -position + 'px';
            }
            // left is always faking
            this.ePinnedLeftColsContainer.style.top = -position + 'px';
        }
        // always scroll fullWidth container, as this is never responsible for a scroll
        this.eFullWidthCellContainer.style.top = -position + 'px';
    };
    GridPanel.prototype.addScrollEventListener = function (listener) {
        this.eBodyViewport.addEventListener('scroll', listener);
    };
    GridPanel.prototype.removeScrollEventListener = function (listener) {
        this.eBodyViewport.removeEventListener('scroll', listener);
    };
    __decorate([
        context_1.Autowired('masterSlaveService'), 
        __metadata('design:type', masterSlaveService_1.MasterSlaveService)
    ], GridPanel.prototype, "masterSlaveService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], GridPanel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], GridPanel.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'), 
        __metadata('design:type', rowRenderer_1.RowRenderer)
    ], GridPanel.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('floatingRowModel'), 
        __metadata('design:type', floatingRowModel_1.FloatingRowModel)
    ], GridPanel.prototype, "floatingRowModel", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], GridPanel.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], GridPanel.prototype, "rowModel", void 0);
    __decorate([
        context_1.Optional('rangeController'), 
        __metadata('design:type', Object)
    ], GridPanel.prototype, "rangeController", void 0);
    __decorate([
        context_1.Autowired('dragService'), 
        __metadata('design:type', dragService_1.DragService)
    ], GridPanel.prototype, "dragService", void 0);
    __decorate([
        context_1.Autowired('selectionController'), 
        __metadata('design:type', selectionController_1.SelectionController)
    ], GridPanel.prototype, "selectionController", void 0);
    __decorate([
        context_1.Optional('clipboardService'), 
        __metadata('design:type', Object)
    ], GridPanel.prototype, "clipboardService", void 0);
    __decorate([
        context_1.Autowired('csvCreator'), 
        __metadata('design:type', csvCreator_1.CsvCreator)
    ], GridPanel.prototype, "csvCreator", void 0);
    __decorate([
        context_1.Autowired('mouseEventService'), 
        __metadata('design:type', mouseEventService_1.MouseEventService)
    ], GridPanel.prototype, "mouseEventService", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'), 
        __metadata('design:type', focusedCellController_1.FocusedCellController)
    ], GridPanel.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Autowired('$scope'), 
        __metadata('design:type', Object)
    ], GridPanel.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('scrollVisibleService'), 
        __metadata('design:type', scrollVisibleService_1.ScrollVisibleService)
    ], GridPanel.prototype, "scrollVisibleService", void 0);
    __decorate([
        context_1.Optional('contextMenuFactory'), 
        __metadata('design:type', Object)
    ], GridPanel.prototype, "contextMenuFactory", void 0);
    __decorate([
        context_1.Autowired('frameworkFactory'), 
        __metadata('design:type', Object)
    ], GridPanel.prototype, "frameworkFactory", void 0);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory]), 
        __metadata('design:returntype', void 0)
    ], GridPanel.prototype, "agWire", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], GridPanel.prototype, "destroy", null);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], GridPanel.prototype, "init", null);
    GridPanel = __decorate([
        context_1.Bean('gridPanel'), 
        __metadata('design:paramtypes', [])
    ], GridPanel);
    return GridPanel;
}(beanStub_1.BeanStub));
exports.GridPanel = GridPanel;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/gridPanel/mouseEventService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var MouseEventService = (function () {
    function MouseEventService() {
    }
    MouseEventService.prototype.getRenderedCellForEvent = function (event) {
        var domDataKey = this.gridOptionsWrapper.getDomDataKey();
        var sourceElement = utils_1.Utils.getTarget(event);
        while (sourceElement) {
            var domData = sourceElement[domDataKey];
            if (domData && domData.renderedCell) {
                var renderedCell = domData.renderedCell;
                return renderedCell;
            }
            sourceElement = sourceElement.parentElement;
        }
        return null;
    };
    MouseEventService.prototype.getGridCellForEvent = function (event) {
        var renderedCell = this.getRenderedCellForEvent(event);
        return renderedCell ? renderedCell.getGridCell() : null;
    };
    __decorate([
        context_2.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], MouseEventService.prototype, "gridOptionsWrapper", void 0);
    MouseEventService = __decorate([
        context_1.Bean('mouseEventService'), 
        __metadata('design:paramtypes', [])
    ], MouseEventService);
    return MouseEventService;
}());
exports.MouseEventService = MouseEventService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/gridPanel/scrollVisibleService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var ScrollVisibleService = (function () {
    function ScrollVisibleService() {
    }
    ScrollVisibleService.prototype.setScrollsVisible = function (params) {
        var atLeastOneDifferent = this.vBody !== params.vBody
            || this.hBody !== params.hBody
            || this.vPinnedLeft !== params.vPinnedLeft
            || this.vPinnedRight !== params.vPinnedRight;
        if (atLeastOneDifferent) {
            this.vBody = params.vBody;
            this.hBody = params.hBody;
            this.vPinnedLeft = params.vPinnedLeft;
            this.vPinnedRight = params.vPinnedRight;
            this.eventService.dispatchEvent(events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED);
        }
    };
    ScrollVisibleService.prototype.isVBodyShowing = function () {
        return this.vBody;
    };
    ScrollVisibleService.prototype.isHBodyShowing = function () {
        return this.hBody;
    };
    ScrollVisibleService.prototype.isVPinnedLeftShowing = function () {
        return this.vPinnedLeft;
    };
    ScrollVisibleService.prototype.isVPinnedRightShowing = function () {
        return this.vPinnedRight;
    };
    ScrollVisibleService.prototype.getPinnedLeftWidth = function () {
        return this.columnController.getPinnedLeftContainerWidth();
    };
    ScrollVisibleService.prototype.getPinnedLeftWithScrollWidth = function () {
        var result = this.getPinnedLeftWidth();
        if (this.vPinnedLeft) {
            result += utils_1.Utils.getScrollbarWidth();
        }
        return result;
    };
    ScrollVisibleService.prototype.getPinnedRightWidth = function () {
        return this.columnController.getPinnedRightContainerWidth();
    };
    ScrollVisibleService.prototype.getPinnedRightWithScrollWidth = function () {
        var result = this.getPinnedRightWidth();
        if (this.vPinnedRight) {
            result += utils_1.Utils.getScrollbarWidth();
        }
        return result;
    };
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], ScrollVisibleService.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], ScrollVisibleService.prototype, "columnController", void 0);
    ScrollVisibleService = __decorate([
        context_1.Bean('scrollVisibleService'), 
        __metadata('design:paramtypes', [])
    ], ScrollVisibleService);
    return ScrollVisibleService;
}());
exports.ScrollVisibleService = ScrollVisibleService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/gridSerializer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var floatingRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/floatingRowModel.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var displayedGroupCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/displayedGroupCreator.js");
var balancedColumnTreeBuilder_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/balancedColumnTreeBuilder.js");
var groupInstanceIdCreator_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/groupInstanceIdCreator.js");
var columnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/columnGroup.js");
var BaseGridSerializingSession = (function () {
    function BaseGridSerializingSession(columnController, valueService, gridOptionsWrapper, processCellCallback, processHeaderCallback) {
        this.columnController = columnController;
        this.valueService = valueService;
        this.gridOptionsWrapper = gridOptionsWrapper;
        this.processCellCallback = processCellCallback;
        this.processHeaderCallback = processHeaderCallback;
    }
    BaseGridSerializingSession.prototype.extractHeaderValue = function (column) {
        var nameForCol = this.getHeaderName(this.processHeaderCallback, column);
        if (nameForCol === null || nameForCol === undefined) {
            nameForCol = '';
        }
        return nameForCol;
    };
    BaseGridSerializingSession.prototype.extractRowCellValue = function (column, index, node) {
        var isRowGrouping = this.columnController.getRowGroupColumns().length > 0;
        var valueForCell;
        if (node.group && isRowGrouping && index === 0) {
            valueForCell = this.createValueForGroupNode(node);
        }
        else {
            valueForCell = this.valueService.getValue(column, node);
        }
        valueForCell = this.processCell(node, column, valueForCell, this.processCellCallback);
        if (valueForCell === null || valueForCell === undefined) {
            valueForCell = '';
        }
        return valueForCell;
    };
    BaseGridSerializingSession.prototype.getHeaderName = function (callback, column) {
        if (callback) {
            return callback({
                column: column,
                api: this.gridOptionsWrapper.getApi(),
                columnApi: this.gridOptionsWrapper.getColumnApi(),
                context: this.gridOptionsWrapper.getContext()
            });
        }
        else {
            return this.columnController.getDisplayNameForColumn(column, 'csv', true);
        }
    };
    BaseGridSerializingSession.prototype.createValueForGroupNode = function (node) {
        var keys = [node.key];
        while (node.parent) {
            node = node.parent;
            keys.push(node.key);
        }
        return keys.reverse().join(' -> ');
    };
    BaseGridSerializingSession.prototype.processCell = function (rowNode, column, value, processCellCallback) {
        if (processCellCallback) {
            return processCellCallback({
                column: column,
                node: rowNode,
                value: value,
                api: this.gridOptionsWrapper.getApi(),
                columnApi: this.gridOptionsWrapper.getColumnApi(),
                context: this.gridOptionsWrapper.getContext()
            });
        }
        else {
            return value;
        }
    };
    return BaseGridSerializingSession;
}());
exports.BaseGridSerializingSession = BaseGridSerializingSession;
var GridSerializer = (function () {
    function GridSerializer() {
    }
    GridSerializer.prototype.serialize = function (gridSerializingSession, params) {
        var skipGroups = params && params.skipGroups;
        var skipHeader = params && params.skipHeader;
        var columnGroups = params && params.columnGroups;
        var skipFooters = params && params.skipFooters;
        var skipFloatingTop = params && params.skipFloatingTop;
        var skipFloatingBottom = params && params.skipFloatingBottom;
        var includeCustomHeader = params && params.customHeader;
        var includeCustomFooter = params && params.customFooter;
        var allColumns = params && params.allColumns;
        var onlySelected = params && params.onlySelected;
        var columnKeys = params && params.columnKeys;
        var onlySelectedAllPages = params && params.onlySelectedAllPages;
        // when in pivot mode, we always render cols on screen, never 'all columns'
        var isPivotMode = this.columnController.isPivotMode();
        var rowModelNormal = this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_NORMAL;
        var onlySelectedNonStandardModel = !rowModelNormal && onlySelected;
        // we can only export if it's a normal row model - unless we are exporting
        // selected only, as this way we don't use the selected nodes rather than
        // the row model to get the rows
        if (!rowModelNormal && !onlySelected) {
            console.log('ag-Grid: getDataAsCsv is only available for standard row model');
            return '';
        }
        var inMemoryRowModel = this.rowModel;
        var columnsToExport;
        if (utils_1.Utils.existsAndNotEmpty(columnKeys)) {
            columnsToExport = this.columnController.getGridColumns(columnKeys);
        }
        else if (allColumns && !isPivotMode) {
            columnsToExport = this.columnController.getAllPrimaryColumns();
        }
        else {
            columnsToExport = this.columnController.getAllDisplayedColumns();
        }
        if (!columnsToExport || columnsToExport.length === 0) {
            return '';
        }
        gridSerializingSession.prepare(columnsToExport);
        if (includeCustomHeader) {
            gridSerializingSession.addCustomHeader(params.customHeader);
        }
        // first pass, put in the header names of the cols
        if (!skipHeader) {
            var groupInstanceIdCreator = new groupInstanceIdCreator_1.GroupInstanceIdCreator();
            var displayedGroups = this.displayedGroupCreator.createDisplayedGroups(columnsToExport, this.columnController.getGridBalancedTree(), groupInstanceIdCreator);
            if (columnGroups && displayedGroups.length > 0 && displayedGroups[0] instanceof columnGroup_1.ColumnGroup) {
                var gridRowIterator_1 = gridSerializingSession.onNewHeaderGroupingRow();
                var columnIndex_1 = 0;
                displayedGroups.forEach(function (it) {
                    var casted = it;
                    gridRowIterator_1.onColumn(casted.getDefinition().headerName, columnIndex_1++, casted.getChildren().length - 1);
                });
            }
            var gridRowIterator_2 = gridSerializingSession.onNewHeaderRow();
            columnsToExport.forEach(function (column, index) {
                gridRowIterator_2.onColumn(column, index, null);
            });
        }
        this.floatingRowModel.forEachFloatingTopRow(processRow);
        if (isPivotMode) {
            inMemoryRowModel.forEachPivotNode(processRow);
        }
        else {
            // onlySelectedAllPages: user doing pagination and wants selected items from
            // other pages, so cannot use the standard row model as it won't have rows from
            // other pages.
            // onlySelectedNonStandardModel: if user wants selected in non standard row model
            // (eg viewport) then again rowmodel cannot be used, so need to use selected instead.
            if (onlySelectedAllPages || onlySelectedNonStandardModel) {
                var selectedNodes = this.selectionController.getSelectedNodes();
                selectedNodes.forEach(function (node) {
                    processRow(node);
                });
            }
            else {
                // here is everything else - including standard row model and selected. we don't use
                // the selection model even when just using selected, so that the result is the order
                // of the rows appearing on the screen.
                inMemoryRowModel.forEachNodeAfterFilterAndSort(processRow);
            }
        }
        this.floatingRowModel.forEachFloatingBottomRow(processRow);
        if (includeCustomFooter) {
            gridSerializingSession.addCustomFooter(params.customFooter);
        }
        function processRow(node) {
            if (skipGroups && node.group) {
                return;
            }
            if (skipFooters && node.footer) {
                return;
            }
            if (onlySelected && !node.isSelected()) {
                return;
            }
            if (skipFloatingTop && node.floating === 'top') {
                return;
            }
            if (skipFloatingBottom && node.floating === 'bottom') {
                return;
            }
            // if we are in pivotMode, then the grid will show the root node only
            // if it's not a leaf group
            var nodeIsRootNode = node.level === -1;
            if (nodeIsRootNode && !node.leafGroup) {
                return;
            }
            var rowAccumulator = gridSerializingSession.onNewBodyRow();
            columnsToExport.forEach(function (column, index) {
                rowAccumulator.onColumn(column, index, node);
            });
        }
        return gridSerializingSession.parse();
    };
    __decorate([
        context_1.Autowired('displayedGroupCreator'), 
        __metadata('design:type', displayedGroupCreator_1.DisplayedGroupCreator)
    ], GridSerializer.prototype, "displayedGroupCreator", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], GridSerializer.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], GridSerializer.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('floatingRowModel'), 
        __metadata('design:type', floatingRowModel_1.FloatingRowModel)
    ], GridSerializer.prototype, "floatingRowModel", void 0);
    __decorate([
        context_1.Autowired('selectionController'), 
        __metadata('design:type', selectionController_1.SelectionController)
    ], GridSerializer.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('balancedColumnTreeBuilder'), 
        __metadata('design:type', balancedColumnTreeBuilder_1.BalancedColumnTreeBuilder)
    ], GridSerializer.prototype, "balancedColumnTreeBuilder", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], GridSerializer.prototype, "gridOptionsWrapper", void 0);
    GridSerializer = __decorate([
        context_1.Bean("gridSerializer"), 
        __metadata('design:paramtypes', [])
    ], GridSerializer);
    return GridSerializer;
}());
exports.GridSerializer = GridSerializer;
(function (RowType) {
    RowType[RowType["HEADER_GROUPING"] = 0] = "HEADER_GROUPING";
    RowType[RowType["HEADER"] = 1] = "HEADER";
    RowType[RowType["BODY"] = 2] = "BODY";
})(exports.RowType || (exports.RowType = {}));
var RowType = exports.RowType;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/bodyDropPivotTarget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var dragAndDropService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragAndDropService.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var BodyDropPivotTarget = (function () {
    function BodyDropPivotTarget(pinned) {
        this.columnsToAggregate = [];
        this.columnsToGroup = [];
        this.columnsToPivot = [];
        this.pinned = pinned;
    }
    /** Callback for when drag enters */
    BodyDropPivotTarget.prototype.onDragEnter = function (draggingEvent) {
        var _this = this;
        this.clearColumnsList();
        // in pivot mode, we don't accept any drops if functions are read only
        if (this.gridOptionsWrapper.isFunctionsReadOnly()) {
            return;
        }
        var dragColumns = draggingEvent.dragSource.dragItem;
        dragColumns.forEach(function (column) {
            // we don't allow adding secondary columns
            if (!column.isPrimary()) {
                return;
            }
            if (column.isAnyFunctionActive()) {
                return;
            }
            if (column.isAllowValue()) {
                _this.columnsToAggregate.push(column);
            }
            else if (column.isAllowRowGroup()) {
                _this.columnsToGroup.push(column);
            }
            else if (column.isAllowRowGroup()) {
                _this.columnsToPivot.push(column);
            }
        });
    };
    BodyDropPivotTarget.prototype.getIconName = function () {
        var totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
        if (totalColumns > 0) {
            return this.pinned ? dragAndDropService_1.DragAndDropService.ICON_PINNED : dragAndDropService_1.DragAndDropService.ICON_MOVE;
        }
        else {
            return null;
        }
    };
    /** Callback for when drag leaves */
    BodyDropPivotTarget.prototype.onDragLeave = function (draggingEvent) {
        // if we are taking columns out of the center, then we remove them from the report
        this.clearColumnsList();
    };
    BodyDropPivotTarget.prototype.clearColumnsList = function () {
        this.columnsToAggregate.length = 0;
        this.columnsToGroup.length = 0;
        this.columnsToPivot.length = 0;
    };
    /** Callback for when dragging */
    BodyDropPivotTarget.prototype.onDragging = function (draggingEvent) {
    };
    /** Callback for when drag stops */
    BodyDropPivotTarget.prototype.onDragStop = function (draggingEvent) {
        if (this.columnsToAggregate.length > 0) {
            this.columnController.addValueColumns(this.columnsToAggregate);
        }
        if (this.columnsToGroup.length > 0) {
            this.columnController.addRowGroupColumns(this.columnsToGroup);
        }
        if (this.columnsToPivot.length > 0) {
            this.columnController.addPivotColumns(this.columnsToPivot);
        }
    };
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], BodyDropPivotTarget.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], BodyDropPivotTarget.prototype, "gridOptionsWrapper", void 0);
    return BodyDropPivotTarget;
}());
exports.BodyDropPivotTarget = BodyDropPivotTarget;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/bodyDropTarget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var dragAndDropService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragAndDropService.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var moveColumnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/moveColumnController.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var bodyDropPivotTarget_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/bodyDropPivotTarget.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var BodyDropTarget = (function () {
    function BodyDropTarget(pinned, eContainer) {
        this.pinned = pinned;
        this.eContainer = eContainer;
    }
    BodyDropTarget.prototype.getSecondaryContainers = function () {
        return this.eSecondaryContainers;
    };
    BodyDropTarget.prototype.getContainer = function () {
        return this.eContainer;
    };
    BodyDropTarget.prototype.init = function () {
        this.moveColumnController = new moveColumnController_1.MoveColumnController(this.pinned, this.eContainer);
        this.context.wireBean(this.moveColumnController);
        this.bodyDropPivotTarget = new bodyDropPivotTarget_1.BodyDropPivotTarget(this.pinned);
        this.context.wireBean(this.bodyDropPivotTarget);
        switch (this.pinned) {
            case column_1.Column.PINNED_LEFT:
                this.eSecondaryContainers = this.gridPanel.getDropTargetLeftContainers();
                break;
            case column_1.Column.PINNED_RIGHT:
                this.eSecondaryContainers = this.gridPanel.getDropTargetPinnedRightContainers();
                break;
            default:
                this.eSecondaryContainers = this.gridPanel.getDropTargetBodyContainers();
                break;
        }
        this.dragAndDropService.addDropTarget(this);
    };
    BodyDropTarget.prototype.getIconName = function () {
        return this.currentDropListener.getIconName();
    };
    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
    // dropped into the grid's body.
    BodyDropTarget.prototype.isUseBodyDropPivotTarget = function (draggingEvent) {
        // if not in pivot mode, then we never use the pivot drop target
        if (!this.columnController.isPivotMode()) {
            return false;
        }
        // otherwise we use the drop target if the column came from the toolPanel (ie not reordering)
        return draggingEvent.dragSource.type === dragAndDropService_1.DragSourceType.ToolPanel;
    };
    BodyDropTarget.prototype.onDragEnter = function (draggingEvent) {
        // we pick the drop listener depending on whether we are in pivot mode are not. if we are
        // in pivot mode, then dropping cols changes the row group, pivot, value stats. otherwise
        // we change visibility state and position.
        // if (this.columnController.isPivotMode()) {
        var useBodyDropPivotTarget = this.isUseBodyDropPivotTarget(draggingEvent);
        if (useBodyDropPivotTarget) {
            this.currentDropListener = this.bodyDropPivotTarget;
        }
        else {
            this.currentDropListener = this.moveColumnController;
        }
        this.currentDropListener.onDragEnter(draggingEvent);
    };
    BodyDropTarget.prototype.onDragLeave = function (params) {
        this.currentDropListener.onDragLeave(params);
    };
    BodyDropTarget.prototype.onDragging = function (params) {
        this.currentDropListener.onDragging(params);
    };
    BodyDropTarget.prototype.onDragStop = function (params) {
        this.currentDropListener.onDragStop(params);
    };
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], BodyDropTarget.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], BodyDropTarget.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'), 
        __metadata('design:type', dragAndDropService_1.DragAndDropService)
    ], BodyDropTarget.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], BodyDropTarget.prototype, "columnController", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], BodyDropTarget.prototype, "init", null);
    return BodyDropTarget;
}());
exports.BodyDropTarget = BodyDropTarget;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/cssClassApplier.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var CssClassApplier = (function () {
    function CssClassApplier() {
    }
    CssClassApplier.addHeaderClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
        if (utils_1.Utils.missing(abstractColDef)) {
            return;
        }
        this.addColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
    };
    CssClassApplier.addToolPanelClassesFromColDef = function (abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
        if (utils_1.Utils.missing(abstractColDef)) {
            return;
        }
        this.addColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup);
    };
    CssClassApplier.addColumnClassesFromCollDef = function (classesOrFunc, abstractColDef, eHeaderCell, gridOptionsWrapper, column, columnGroup) {
        if (utils_1.Utils.missing(classesOrFunc)) {
            return;
        }
        var classToUse;
        if (typeof classesOrFunc === 'function') {
            var params = {
                // bad naming, as colDef here can be a group or a column,
                // however most people won't appreciate the difference,
                // so keeping it as colDef to avoid confusion.
                colDef: abstractColDef,
                column: column,
                columnGroup: columnGroup,
                context: gridOptionsWrapper.getContext(),
                api: gridOptionsWrapper.getApi()
            };
            var headerClassFunc = classesOrFunc;
            classToUse = headerClassFunc(params);
        }
        else {
            classToUse = classesOrFunc;
        }
        if (typeof classToUse === 'string') {
            utils_1.Utils.addCssClass(eHeaderCell, classToUse);
        }
        else if (Array.isArray(classToUse)) {
            classToUse.forEach(function (cssClassItem) {
                utils_1.Utils.addCssClass(eHeaderCell, cssClassItem);
            });
        }
    };
    return CssClassApplier;
}());
exports.CssClassApplier = CssClassApplier;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/headerContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var dragAndDropService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragAndDropService.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var headerRowComp_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerRowComp.js");
var bodyDropTarget_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/bodyDropTarget.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var scrollVisibleService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/scrollVisibleService.js");
var HeaderContainer = (function () {
    function HeaderContainer(eContainer, eViewport, eRoot, pinned) {
        this.headerRowComps = [];
        this.eContainer = eContainer;
        this.eRoot = eRoot;
        this.pinned = pinned;
        this.eViewport = eViewport;
    }
    HeaderContainer.prototype.forEachHeaderElement = function (callback) {
        this.headerRowComps.forEach(function (headerRowComp) { return headerRowComp.forEachHeaderElement(callback); });
    };
    HeaderContainer.prototype.init = function () {
        this.setupDragAndDrop();
        // if value changes, then if not pivoting, we at least need to change the label eg from sum() to avg(),
        // if pivoting, then the columns have changed
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onGridColumnsChanged.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
    };
    HeaderContainer.prototype.onColumnResized = function () {
        this.setWidthIfPinnedContainer();
    };
    HeaderContainer.prototype.onDisplayedColumnsChanged = function () {
        this.setWidthIfPinnedContainer();
    };
    HeaderContainer.prototype.onScrollVisibilityChanged = function () {
        this.setWidthIfPinnedContainer();
    };
    HeaderContainer.prototype.setWidthIfPinnedContainer = function () {
        if (this.pinned === column_1.Column.PINNED_LEFT) {
            var pinnedLeftWidthWithScroll = this.scrollVisibleService.getPinnedLeftWithScrollWidth();
            this.eContainer.style.width = pinnedLeftWidthWithScroll + 'px';
        }
        else if (this.pinned === column_1.Column.PINNED_RIGHT) {
            var pinnedRightWidthWithScroll = this.scrollVisibleService.getPinnedRightWithScrollWidth();
            this.eContainer.style.width = pinnedRightWidthWithScroll + 'px';
        }
    };
    HeaderContainer.prototype.destroy = function () {
        this.removeHeaderRowComps();
    };
    // grid cols have changed - this also means the number of rows in the header can have
    // changed. so we remove all the old rows and insert new ones for a complete refresh
    HeaderContainer.prototype.onGridColumnsChanged = function () {
        this.removeHeaderRowComps();
        this.createHeaderRowComps();
    };
    // we expose this for gridOptions.api.refreshHeader() to call
    HeaderContainer.prototype.refresh = function () {
        this.onGridColumnsChanged();
    };
    HeaderContainer.prototype.setupDragAndDrop = function () {
        var dropContainer = this.eViewport ? this.eViewport : this.eContainer;
        var bodyDropTarget = new bodyDropTarget_1.BodyDropTarget(this.pinned, dropContainer);
        this.context.wireBean(bodyDropTarget);
    };
    HeaderContainer.prototype.removeHeaderRowComps = function () {
        this.headerRowComps.forEach(function (headerRowComp) {
            headerRowComp.destroy();
        });
        this.headerRowComps.length = 0;
        utils_1.Utils.removeAllChildren(this.eContainer);
    };
    HeaderContainer.prototype.createHeaderRowComps = function () {
        // if we are displaying header groups, then we have many rows here.
        // go through each row of the header, one by one.
        var rowCount = this.columnController.getHeaderRowCount();
        for (var dept = 0; dept < rowCount; dept++) {
            var groupRow = dept !== (rowCount - 1);
            var headerRowComp = new headerRowComp_1.HeaderRowComp(dept, groupRow, this.pinned, this.eRoot, this.dropTarget);
            this.context.wireBean(headerRowComp);
            this.headerRowComps.push(headerRowComp);
            this.eContainer.appendChild(headerRowComp.getGui());
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderContainer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], HeaderContainer.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('$scope'), 
        __metadata('design:type', Object)
    ], HeaderContainer.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'), 
        __metadata('design:type', dragAndDropService_1.DragAndDropService)
    ], HeaderContainer.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], HeaderContainer.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], HeaderContainer.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], HeaderContainer.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('scrollVisibleService'), 
        __metadata('design:type', scrollVisibleService_1.ScrollVisibleService)
    ], HeaderContainer.prototype, "scrollVisibleService", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], HeaderContainer.prototype, "init", null);
    return HeaderContainer;
}());
exports.HeaderContainer = HeaderContainer;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/headerRenderer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var headerContainer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerContainer.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var scrollVisibleService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/scrollVisibleService.js");
var HeaderRenderer = (function () {
    function HeaderRenderer() {
    }
    HeaderRenderer.prototype.init = function () {
        var _this = this;
        this.eHeaderViewport = this.gridPanel.getHeaderViewport();
        this.eRoot = this.gridPanel.getRoot();
        this.eHeaderOverlay = this.gridPanel.getHeaderOverlay();
        this.centerContainer = new headerContainer_1.HeaderContainer(this.gridPanel.getHeaderContainer(), this.gridPanel.getHeaderViewport(), this.eRoot, null);
        this.childContainers = [this.centerContainer];
        if (!this.gridOptionsWrapper.isForPrint()) {
            this.pinnedLeftContainer = new headerContainer_1.HeaderContainer(this.gridPanel.getPinnedLeftHeader(), null, this.eRoot, column_1.Column.PINNED_LEFT);
            this.pinnedRightContainer = new headerContainer_1.HeaderContainer(this.gridPanel.getPinnedRightHeader(), null, this.eRoot, column_1.Column.PINNED_RIGHT);
            this.childContainers.push(this.pinnedLeftContainer);
            this.childContainers.push(this.pinnedRightContainer);
        }
        this.childContainers.forEach(function (container) { return _this.context.wireBean(container); });
        // when grid columns change, it means the number of rows in the header has changed and it's all new columns
        this.eventService.addEventListener(events_1.Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
        // shotgun way to get labels to change, eg from sum(amount) to avg(amount)
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.refreshHeader.bind(this));
        // for resized, the individual cells take care of this, so don't need to refresh everything
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.setPinnedColContainerWidth.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.setPinnedColContainerWidth.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        if (this.columnController.isReady()) {
            this.refreshHeader();
        }
    };
    HeaderRenderer.prototype.onScrollVisibilityChanged = function () {
        this.setPinnedColContainerWidth();
    };
    HeaderRenderer.prototype.forEachHeaderElement = function (callback) {
        this.childContainers.forEach(function (childContainer) { return childContainer.forEachHeaderElement(callback); });
    };
    HeaderRenderer.prototype.destroy = function () {
        this.childContainers.forEach(function (container) { return container.destroy(); });
    };
    HeaderRenderer.prototype.onGridColumnsChanged = function () {
        this.setHeight();
    };
    // this is called from the API and refreshes everything, should be broken out
    // into refresh everything vs just something changed
    HeaderRenderer.prototype.refreshHeader = function () {
        this.setHeight();
        this.childContainers.forEach(function (container) { return container.refresh(); });
        this.setPinnedColContainerWidth();
    };
    HeaderRenderer.prototype.setHeight = function () {
        // if forPrint, overlay is missing
        if (this.eHeaderOverlay) {
            var rowHeight = this.gridOptionsWrapper.getHeaderHeight();
            // we can probably get rid of this when we no longer need the overlay
            var dept = this.columnController.getHeaderRowCount();
            this.eHeaderOverlay.style.height = rowHeight + 'px';
            this.eHeaderOverlay.style.top = ((dept - 1) * rowHeight) + 'px';
        }
    };
    HeaderRenderer.prototype.setPinnedColContainerWidth = function () {
        // pinned col doesn't exist when doing forPrint
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        var pinnedLeftWidthWithScroll = this.scrollVisibleService.getPinnedLeftWithScrollWidth();
        var pinnedRightWidthWithScroll = this.scrollVisibleService.getPinnedRightWithScrollWidth();
        this.eHeaderViewport.style.marginLeft = pinnedLeftWidthWithScroll + 'px';
        this.eHeaderViewport.style.marginRight = pinnedRightWidthWithScroll + 'px';
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderRenderer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], HeaderRenderer.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], HeaderRenderer.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], HeaderRenderer.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], HeaderRenderer.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('scrollVisibleService'), 
        __metadata('design:type', scrollVisibleService_1.ScrollVisibleService)
    ], HeaderRenderer.prototype, "scrollVisibleService", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], HeaderRenderer.prototype, "init", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], HeaderRenderer.prototype, "destroy", null);
    HeaderRenderer = __decorate([
        context_1.Bean('headerRenderer'), 
        __metadata('design:paramtypes', [])
    ], HeaderRenderer);
    return HeaderRenderer;
}());
exports.HeaderRenderer = HeaderRenderer;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/headerRowComp.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnGroup_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/columnGroup.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var renderedHeaderGroupCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/renderedHeaderGroupCell.js");
var renderedHeaderCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/renderedHeaderCell.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var HeaderRowComp = (function (_super) {
    __extends(HeaderRowComp, _super);
    function HeaderRowComp(dept, showingGroups, pinned, eRoot, dropTarget) {
        _super.call(this, "<div class=\"ag-header-row\"/>");
        this.headerElements = {};
        this.dept = dept;
        this.showingGroups = showingGroups;
        this.pinned = pinned;
        this.eRoot = eRoot;
        this.dropTarget = dropTarget;
    }
    HeaderRowComp.prototype.forEachHeaderElement = function (callback) {
        var _this = this;
        Object.keys(this.headerElements).forEach(function (key) {
            var headerElement = _this.headerElements[key];
            callback(headerElement);
        });
    };
    HeaderRowComp.prototype.destroy = function () {
        var idsOfAllChildren = Object.keys(this.headerElements);
        this.removeAndDestroyChildComponents(idsOfAllChildren);
        _super.prototype.destroy.call(this);
    };
    HeaderRowComp.prototype.removeAndDestroyChildComponents = function (idsToDestroy) {
        var _this = this;
        idsToDestroy.forEach(function (id) {
            var child = _this.headerElements[id];
            _this.getGui().removeChild(child.getGui());
            child.destroy();
            delete _this.headerElements[id];
        });
    };
    HeaderRowComp.prototype.onRowHeightChanged = function () {
        var rowHeight = this.gridOptionsWrapper.getHeaderHeight();
        this.getGui().style.top = (this.dept * rowHeight) + 'px';
        this.getGui().style.height = rowHeight + 'px';
    };
    HeaderRowComp.prototype.init = function () {
        this.onRowHeightChanged();
        this.onVirtualColumnsChanged();
        this.setWidth();
        this.addDestroyableEventListener(this.gridOptionsWrapper, gridOptionsWrapper_1.GridOptionsWrapper.PROP_HEADER_HEIGHT, this.onRowHeightChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
    };
    HeaderRowComp.prototype.onColumnResized = function () {
        this.setWidth();
    };
    HeaderRowComp.prototype.setWidth = function () {
        var mainRowWidth = this.columnController.getContainerWidth(this.pinned) + 'px';
        this.getGui().style.width = mainRowWidth;
    };
    HeaderRowComp.prototype.onDisplayedColumnsChanged = function () {
        // because column groups are created and destroyed on the fly as groups are opened / closed and columns are moved,
        // we have to throw away all of the components when columns are changed, as the references to the old groups
        // are no longer value. this is not true for columns where columns do not get destroyed between open / close
        // or moving actions.
        if (this.showingGroups) {
            var idsOfAllChildren = Object.keys(this.headerElements);
            this.removeAndDestroyChildComponents(idsOfAllChildren);
        }
        this.onVirtualColumnsChanged();
        this.setWidth();
    };
    HeaderRowComp.prototype.onVirtualColumnsChanged = function () {
        var _this = this;
        var currentChildIds = Object.keys(this.headerElements);
        var nodesAtDept = this.columnController.getVirtualHeaderGroupRow(this.pinned, this.dept);
        nodesAtDept.forEach(function (child) {
            var idOfChild = child.getUniqueId();
            // if we already have this cell rendered, do nothing
            if (currentChildIds.indexOf(idOfChild) >= 0) {
                utils_1.Utils.removeFromArray(currentChildIds, idOfChild);
                return;
            }
            // skip groups that have no displayed children. this can happen when the group is broken,
            // and this section happens to have nothing to display for the open / closed state.
            // (PS niall note - i can't remember what i meant by the above exactly, what's a broken group???)
            if (child instanceof columnGroup_1.ColumnGroup && child.getDisplayedChildren().length === 0) {
                return;
            }
            var renderedHeaderElement = _this.createHeaderElement(child);
            _this.headerElements[idOfChild] = renderedHeaderElement;
            _this.getGui().appendChild(renderedHeaderElement.getGui());
        });
        // at this point, anything left in currentChildIds is an element that is no longer in the viewport
        this.removeAndDestroyChildComponents(currentChildIds);
    };
    HeaderRowComp.prototype.createHeaderElement = function (columnGroupChild) {
        var result;
        if (columnGroupChild instanceof columnGroup_1.ColumnGroup) {
            result = new renderedHeaderGroupCell_1.RenderedHeaderGroupCell(columnGroupChild, this.eRoot, this.dropTarget, this.pinned);
        }
        else {
            result = new renderedHeaderCell_1.RenderedHeaderCell(columnGroupChild, this.eRoot, this.dropTarget, this.pinned);
        }
        this.context.wireBean(result);
        return result;
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderRowComp.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], HeaderRowComp.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], HeaderRowComp.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], HeaderRowComp.prototype, "eventService", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], HeaderRowComp.prototype, "init", null);
    return HeaderRowComp;
}(component_1.Component));
exports.HeaderRowComp = HeaderRowComp;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/headerTemplateLoader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var svgFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/svgFactory.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var svgFactory = svgFactory_1.SvgFactory.getInstance();
var HeaderTemplateLoader = (function () {
    function HeaderTemplateLoader() {
    }
    HeaderTemplateLoader.prototype.createHeaderElement = function (column) {
        var params = {
            column: column,
            colDef: column.getColDef,
            context: this.gridOptionsWrapper.getContext(),
            api: this.gridOptionsWrapper.getApi()
        };
        // option 1 - see if user provided a template in colDef
        var userProvidedTemplate = column.getColDef().headerCellTemplate;
        if (typeof userProvidedTemplate === 'function') {
            var colDefFunc = userProvidedTemplate;
            userProvidedTemplate = colDefFunc(params);
        }
        // option 2 - check the gridOptions for cellTemplate
        if (!userProvidedTemplate && this.gridOptionsWrapper.getHeaderCellTemplate()) {
            userProvidedTemplate = this.gridOptionsWrapper.getHeaderCellTemplate();
        }
        // option 3 - check the gridOptions for templateFunction
        if (!userProvidedTemplate && this.gridOptionsWrapper.getHeaderCellTemplateFunc()) {
            var gridOptionsFunc = this.gridOptionsWrapper.getHeaderCellTemplateFunc();
            userProvidedTemplate = gridOptionsFunc(params);
        }
        // finally, if still no template, use the default
        if (!userProvidedTemplate) {
            userProvidedTemplate = this.createDefaultHeaderElement(column);
        }
        // template can be a string or a dom element, if string we need to convert to a dom element
        var result;
        if (typeof userProvidedTemplate === 'string') {
            result = utils_1.Utils.loadTemplate(userProvidedTemplate);
        }
        else if (utils_1.Utils.isNodeOrElement(userProvidedTemplate)) {
            result = userProvidedTemplate;
        }
        else {
            console.error('ag-Grid: header template must be a string or an HTML element');
        }
        return result;
    };
    HeaderTemplateLoader.prototype.createDefaultHeaderElement = function (column) {
        var eTemplate = utils_1.Utils.loadTemplate(HeaderTemplateLoader.HEADER_CELL_TEMPLATE);
        this.addInIcon(eTemplate, 'sortAscending', '#agSortAsc', column, svgFactory.createArrowUpSvg);
        this.addInIcon(eTemplate, 'sortDescending', '#agSortDesc', column, svgFactory.createArrowDownSvg);
        this.addInIcon(eTemplate, 'sortUnSort', '#agNoSort', column, svgFactory.createArrowUpDownSvg);
        this.addInIcon(eTemplate, 'menu', '#agMenu', column, svgFactory.createMenuSvg);
        this.addInIcon(eTemplate, 'filter', '#agFilter', column, svgFactory.createFilterSvg);
        return eTemplate;
    };
    HeaderTemplateLoader.prototype.addInIcon = function (eTemplate, iconName, cssSelector, column, defaultIconFactory) {
        var eIcon = utils_1.Utils.createIconNoSpan(iconName, this.gridOptionsWrapper, column, defaultIconFactory);
        eTemplate.querySelector(cssSelector).appendChild(eIcon);
    };
    HeaderTemplateLoader.HEADER_CELL_TEMPLATE = '<div class="ag-header-cell">' +
        '  <div id="agResizeBar" class="ag-header-cell-resize"></div>' +
        '  <span id="agMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
        '  <div id="agHeaderCellLabel" class="ag-header-cell-label">' +
        '    <span id="agSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
        '    <span id="agSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
        '    <span id="agNoSort" class="ag-header-icon ag-sort-none-icon"></span>' +
        '    <span id="agFilter" class="ag-header-icon ag-filter-icon"></span>' +
        '    <span id="agText" class="ag-header-cell-text"></span>' +
        '  </div>' +
        '</div>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], HeaderTemplateLoader.prototype, "gridOptionsWrapper", void 0);
    HeaderTemplateLoader = __decorate([
        context_1.Bean('headerTemplateLoader'), 
        __metadata('design:paramtypes', [])
    ], HeaderTemplateLoader);
    return HeaderTemplateLoader;
}());
exports.HeaderTemplateLoader = HeaderTemplateLoader;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/horizontalDragService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var HorizontalDragService = (function () {
    function HorizontalDragService() {
    }
    HorizontalDragService.prototype.addDragHandling = function (params) {
        params.eDraggableElement.addEventListener('mousedown', function (startEvent) {
            new DragInstance(params, startEvent);
        });
    };
    HorizontalDragService = __decorate([
        context_1.Bean('horizontalDragService'), 
        __metadata('design:paramtypes', [])
    ], HorizontalDragService);
    return HorizontalDragService;
}());
exports.HorizontalDragService = HorizontalDragService;
var DragInstance = (function () {
    function DragInstance(params, startEvent) {
        this.mouseMove = this.onMouseMove.bind(this);
        this.mouseUp = this.onMouseUp.bind(this);
        this.mouseLeave = this.onMouseLeave.bind(this);
        this.lastDelta = 0;
        this.params = params;
        this.eDragParent = document.querySelector('body');
        this.dragStartX = startEvent.clientX;
        this.startEvent = startEvent;
        this.eDragParent.addEventListener('mousemove', this.mouseMove);
        this.eDragParent.addEventListener('mouseup', this.mouseUp);
        this.eDragParent.addEventListener('mouseleave', this.mouseLeave);
        this.draggingStarted = false;
        var startAfterPixelsExist = typeof params.startAfterPixels === 'number' && params.startAfterPixels > 0;
        if (!startAfterPixelsExist) {
            this.startDragging();
        }
    }
    DragInstance.prototype.startDragging = function () {
        this.draggingStarted = true;
        this.oldBodyCursor = this.params.eBody.style.cursor;
        this.oldParentCursor = this.eDragParent.style.cursor;
        this.oldMsUserSelect = this.eDragParent.style.msUserSelect;
        this.oldWebkitUserSelect = this.eDragParent.style.webkitUserSelect;
        // change the body cursor, so when drag moves out of the drag bar, the cursor is still 'resize' (or 'move'
        this.params.eBody.style.cursor = this.params.cursor;
        // same for outside the grid, we want to keep the resize (or move) cursor
        this.eDragParent.style.cursor = this.params.cursor;
        // we don't want text selection outside the grid (otherwise it looks weird as text highlights when we move)
        this.eDragParent.style.msUserSelect = 'none';
        this.eDragParent.style.webkitUserSelect = 'none';
        this.params.onDragStart(this.startEvent);
    };
    DragInstance.prototype.onMouseMove = function (moveEvent) {
        var newX = moveEvent.clientX;
        this.lastDelta = newX - this.dragStartX;
        if (!this.draggingStarted) {
            var dragExceededStartAfterPixels = Math.abs(this.lastDelta) >= this.params.startAfterPixels;
            if (dragExceededStartAfterPixels) {
                this.startDragging();
            }
        }
        if (this.draggingStarted) {
            this.params.onDragging(this.lastDelta, false);
        }
    };
    DragInstance.prototype.onMouseUp = function () {
        this.stopDragging();
    };
    DragInstance.prototype.onMouseLeave = function () {
        this.stopDragging();
    };
    DragInstance.prototype.stopDragging = function () {
        // reset cursor back to original cursor, if they were changed in the first place
        if (this.draggingStarted) {
            this.params.eBody.style.cursor = this.oldBodyCursor;
            this.eDragParent.style.cursor = this.oldParentCursor;
            this.eDragParent.style.msUserSelect = this.oldMsUserSelect;
            this.eDragParent.style.webkitUserSelect = this.oldWebkitUserSelect;
            this.params.onDragging(this.lastDelta, true);
        }
        // always remove the listeners, as these are always added
        this.eDragParent.removeEventListener('mousemove', this.mouseMove);
        this.eDragParent.removeEventListener('mouseup', this.mouseUp);
        this.eDragParent.removeEventListener('mouseleave', this.mouseLeave);
    };
    return DragInstance;
}());


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/moveColumnController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var dragAndDropService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragAndDropService.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var MoveColumnController = (function () {
    function MoveColumnController(pinned, eContainer) {
        this.needToMoveLeft = false;
        this.needToMoveRight = false;
        this.pinned = pinned;
        this.eContainer = eContainer;
        this.centerContainer = !utils_1.Utils.exists(pinned);
    }
    MoveColumnController.prototype.init = function () {
        this.logger = this.loggerFactory.create('MoveColumnController');
    };
    MoveColumnController.prototype.getIconName = function () {
        return this.pinned ? dragAndDropService_1.DragAndDropService.ICON_PINNED : dragAndDropService_1.DragAndDropService.ICON_MOVE;
    };
    MoveColumnController.prototype.onDragEnter = function (draggingEvent) {
        // we do dummy drag, so make sure column appears in the right location when first placed
        var columns = draggingEvent.dragSource.dragItem;
        this.columnController.setColumnsVisible(columns, true);
        this.columnController.setColumnsPinned(columns, this.pinned);
        this.onDragging(draggingEvent, true);
    };
    MoveColumnController.prototype.onDragLeave = function (draggingEvent) {
        var hideColumnOnExit = !this.gridOptionsWrapper.isSuppressDragLeaveHidesColumns() && !draggingEvent.fromNudge;
        if (hideColumnOnExit) {
            var columns = draggingEvent.dragSource.dragItem;
            this.columnController.setColumnsVisible(columns, false);
        }
        this.ensureIntervalCleared();
    };
    MoveColumnController.prototype.onDragStop = function () {
        this.ensureIntervalCleared();
    };
    MoveColumnController.prototype.normaliseX = function (x) {
        // flip the coordinate if doing RTL
        var flipHorizontallyForRtl = this.gridOptionsWrapper.isEnableRtl();
        if (flipHorizontallyForRtl) {
            var clientWidth = this.eContainer.clientWidth;
            x = clientWidth - x;
        }
        // adjust for scroll only if centre container (the pinned containers dont scroll)
        var adjustForScroll = this.centerContainer;
        if (adjustForScroll) {
            x += this.gridPanel.getBodyViewportScrollLeft();
        }
        return x;
    };
    MoveColumnController.prototype.workOutNewIndex = function (displayedColumns, allColumns, dragColumn, hDirection, xAdjustedForScroll) {
        if (hDirection === dragAndDropService_1.HDirection.Left) {
            return this.getNewIndexForColMovingLeft(displayedColumns, allColumns, dragColumn, xAdjustedForScroll);
        }
        else {
            return this.getNewIndexForColMovingRight(displayedColumns, allColumns, dragColumn, xAdjustedForScroll);
        }
    };
    MoveColumnController.prototype.checkCenterForScrolling = function (xAdjustedForScroll) {
        if (this.centerContainer) {
            // scroll if the mouse has gone outside the grid (or just outside the scrollable part if pinning)
            // putting in 50 buffer, so even if user gets to edge of grid, a scroll will happen
            var firstVisiblePixel = this.gridPanel.getBodyViewportScrollLeft();
            var lastVisiblePixel = firstVisiblePixel + this.gridPanel.getCenterWidth();
            if (this.gridOptionsWrapper.isEnableRtl()) {
                this.needToMoveRight = xAdjustedForScroll < (firstVisiblePixel + 50);
                this.needToMoveLeft = xAdjustedForScroll > (lastVisiblePixel - 50);
            }
            else {
                this.needToMoveLeft = xAdjustedForScroll < (firstVisiblePixel + 50);
                this.needToMoveRight = xAdjustedForScroll > (lastVisiblePixel - 50);
            }
            if (this.needToMoveLeft || this.needToMoveRight) {
                this.ensureIntervalStarted();
            }
            else {
                this.ensureIntervalCleared();
            }
        }
    };
    MoveColumnController.prototype.onDragging = function (draggingEvent, fromEnter) {
        if (fromEnter === void 0) { fromEnter = false; }
        this.lastDraggingEvent = draggingEvent;
        // if moving up or down (ie not left or right) then do nothing
        if (utils_1.Utils.missing(draggingEvent.hDirection)) {
            return;
        }
        var xNormalised = this.normaliseX(draggingEvent.x);
        // if the user is dragging into the panel, ie coming from the side panel into the main grid,
        // we don't want to scroll the grid this time, it would appear like the table is jumping
        // each time a column is dragged in.
        if (!fromEnter) {
            this.checkCenterForScrolling(xNormalised);
        }
        var hDirectionNormalised = this.normaliseDirection(draggingEvent.hDirection);
        var columnsToMove = draggingEvent.dragSource.dragItem;
        this.attemptMoveColumns(columnsToMove, hDirectionNormalised, xNormalised, fromEnter);
    };
    MoveColumnController.prototype.normaliseDirection = function (hDirection) {
        if (this.gridOptionsWrapper.isEnableRtl()) {
            switch (hDirection) {
                case dragAndDropService_1.HDirection.Left: return dragAndDropService_1.HDirection.Right;
                case dragAndDropService_1.HDirection.Right: return dragAndDropService_1.HDirection.Left;
                default: console.error("ag-Grid: Unknown direction " + hDirection);
            }
        }
        else {
            return hDirection;
        }
    };
    MoveColumnController.prototype.attemptMoveColumns = function (allMovingColumns, hDirection, xAdjusted, fromEnter) {
        var displayedColumns = this.columnController.getDisplayedColumns(this.pinned);
        var gridColumns = this.columnController.getAllGridColumns();
        var draggingLeft = hDirection === dragAndDropService_1.HDirection.Left;
        var draggingRight = hDirection === dragAndDropService_1.HDirection.Right;
        var dragColumn;
        var displayedMovingColumns = utils_1.Utils.filter(allMovingColumns, function (column) { return displayedColumns.indexOf(column) >= 0; });
        // if dragging left, we want to use the left most column, ie move the left most column to
        // under the mouse pointer
        if (draggingLeft) {
            dragColumn = displayedMovingColumns[0];
        }
        else {
            dragColumn = displayedMovingColumns[displayedMovingColumns.length - 1];
        }
        var newIndex = this.workOutNewIndex(displayedColumns, gridColumns, dragColumn, hDirection, xAdjusted);
        var oldIndex = gridColumns.indexOf(dragColumn);
        // the two check below stop an error when the user grabs a group my a middle column, then
        // it is possible the mouse pointer is to the right of a column while been dragged left.
        // so we need to make sure that the mouse pointer is actually left of the left most column
        // if moving left, and right of the right most column if moving right
        // we check 'fromEnter' below so we move the column to the new spot if the mouse is coming from
        // outside the grid, eg if the column is moving from side panel, mouse is moving left, then we should
        // place the column to the RHS even if the mouse is moving left and the column is already on
        // the LHS. otherwise we stick to the rule described above.
        // only allow left drag if this column is moving left
        if (!fromEnter && draggingLeft && newIndex >= oldIndex) {
            return;
        }
        // only allow right drag if this column is moving right
        if (!fromEnter && draggingRight && newIndex <= oldIndex) {
            return;
        }
        // if moving right, the new index is the index of the right most column, so adjust to first column
        if (draggingRight) {
            newIndex = newIndex - allMovingColumns.length + 1;
        }
        this.columnController.moveColumns(allMovingColumns, newIndex);
    };
    MoveColumnController.prototype.getNewIndexForColMovingLeft = function (displayedColumns, allColumns, dragColumn, x) {
        var usedX = 0;
        var leftColumn = null;
        for (var i = 0; i < displayedColumns.length; i++) {
            var currentColumn = displayedColumns[i];
            if (currentColumn === dragColumn) {
                continue;
            }
            usedX += currentColumn.getActualWidth();
            if (usedX > x) {
                break;
            }
            leftColumn = currentColumn;
        }
        var newIndex;
        if (leftColumn) {
            newIndex = allColumns.indexOf(leftColumn) + 1;
            var oldIndex = allColumns.indexOf(dragColumn);
            if (oldIndex < newIndex) {
                newIndex--;
            }
        }
        else {
            newIndex = 0;
        }
        return newIndex;
    };
    MoveColumnController.prototype.getNewIndexForColMovingRight = function (displayedColumns, allColumns, dragColumnOrGroup, x) {
        var dragColumn = dragColumnOrGroup;
        var usedX = dragColumn.getActualWidth();
        var leftColumn = null;
        for (var i = 0; i < displayedColumns.length; i++) {
            if (usedX > x) {
                break;
            }
            var currentColumn = displayedColumns[i];
            if (currentColumn === dragColumn) {
                continue;
            }
            usedX += currentColumn.getActualWidth();
            leftColumn = currentColumn;
        }
        var newIndex;
        if (leftColumn) {
            newIndex = allColumns.indexOf(leftColumn) + 1;
            var oldIndex = allColumns.indexOf(dragColumn);
            if (oldIndex < newIndex) {
                newIndex--;
            }
        }
        else {
            newIndex = 0;
        }
        return newIndex;
    };
    MoveColumnController.prototype.ensureIntervalStarted = function () {
        if (!this.movingIntervalId) {
            this.intervalCount = 0;
            this.failedMoveAttempts = 0;
            this.movingIntervalId = setInterval(this.moveInterval.bind(this), 100);
            if (this.needToMoveLeft) {
                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_LEFT, true);
            }
            else {
                this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_RIGHT, true);
            }
        }
    };
    MoveColumnController.prototype.ensureIntervalCleared = function () {
        if (this.moveInterval) {
            clearInterval(this.movingIntervalId);
            this.movingIntervalId = null;
            this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_MOVE);
        }
    };
    MoveColumnController.prototype.moveInterval = function () {
        var pixelsToMove;
        this.intervalCount++;
        pixelsToMove = 10 + (this.intervalCount * 5);
        if (pixelsToMove > 100) {
            pixelsToMove = 100;
        }
        var pixelsMoved;
        if (this.needToMoveLeft) {
            pixelsMoved = this.gridPanel.scrollHorizontally(-pixelsToMove);
        }
        else if (this.needToMoveRight) {
            pixelsMoved = this.gridPanel.scrollHorizontally(pixelsToMove);
        }
        if (pixelsMoved !== 0) {
            this.onDragging(this.lastDraggingEvent);
            this.failedMoveAttempts = 0;
        }
        else {
            this.failedMoveAttempts++;
            this.dragAndDropService.setGhostIcon(dragAndDropService_1.DragAndDropService.ICON_PINNED);
            if (this.failedMoveAttempts > 7) {
                var columns = this.lastDraggingEvent.dragSource.dragItem;
                var pinType = this.needToMoveLeft ? column_1.Column.PINNED_LEFT : column_1.Column.PINNED_RIGHT;
                this.columnController.setColumnsPinned(columns, pinType);
                this.dragAndDropService.nudge();
            }
        }
    };
    __decorate([
        context_1.Autowired('loggerFactory'), 
        __metadata('design:type', logger_1.LoggerFactory)
    ], MoveColumnController.prototype, "loggerFactory", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], MoveColumnController.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], MoveColumnController.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'), 
        __metadata('design:type', dragAndDropService_1.DragAndDropService)
    ], MoveColumnController.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], MoveColumnController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], MoveColumnController.prototype, "init", null);
    return MoveColumnController;
}());
exports.MoveColumnController = MoveColumnController;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/renderedHeaderCell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var headerTemplateLoader_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerTemplateLoader.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var horizontalDragService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/horizontalDragService.js");
var gridCore_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridCore.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var cssClassApplier_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/cssClassApplier.js");
var dragAndDropService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragAndDropService.js");
var sortController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/sortController.js");
var setLeftFeature_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/features/setLeftFeature.js");
var touchListener_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/touchListener.js");
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var RenderedHeaderCell = (function (_super) {
    __extends(RenderedHeaderCell, _super);
    function RenderedHeaderCell(column, eRoot, dragSourceDropTarget, pinned) {
        _super.call(this);
        this.column = column;
        this.eRoot = eRoot;
        this.dragSourceDropTarget = dragSourceDropTarget;
        this.pinned = pinned;
    }
    RenderedHeaderCell.prototype.getColumn = function () {
        return this.column;
    };
    RenderedHeaderCell.prototype.init = function () {
        var eGui = this.headerTemplateLoader.createHeaderElement(this.column);
        this.setGui(eGui);
        utils_1.Utils.addCssClass(eGui, 'ag-header-cell');
        this.createScope();
        this.addAttributes();
        cssClassApplier_1.CssClassApplier.addHeaderClassesFromColDef(this.column.getColDef(), eGui, this.gridOptionsWrapper, this.column, null);
        // label div
        var eHeaderCellLabel = eGui.querySelector('#agHeaderCellLabel');
        this.displayName = this.columnController.getDisplayNameForColumn(this.column, 'header', true);
        this.setupMovingCss();
        this.setupTooltip();
        this.setupResize();
        this.setupTap();
        this.setupMove(eHeaderCellLabel);
        this.setupMenu();
        this.setupSort(eHeaderCellLabel);
        this.setupFilterIcon();
        this.setupText();
        this.setupWidth();
        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.column, eGui);
        this.addDestroyFunc(function () { return setLeftFeature.destroy(); });
    };
    RenderedHeaderCell.prototype.setupTooltip = function () {
        var colDef = this.column.getColDef();
        // add tooltip if exists
        if (colDef.headerTooltip) {
            this.getGui().title = colDef.headerTooltip;
        }
    };
    RenderedHeaderCell.prototype.setupText = function () {
        var colDef = this.column.getColDef();
        // render the cell, use a renderer if one is provided
        var headerCellRenderer;
        if (colDef.headerCellRenderer) {
            headerCellRenderer = colDef.headerCellRenderer;
        }
        else if (this.gridOptionsWrapper.getHeaderCellRenderer()) {
            headerCellRenderer = this.gridOptionsWrapper.getHeaderCellRenderer();
        }
        var eText = this.queryForHtmlElement('#agText');
        if (eText) {
            if (headerCellRenderer) {
                this.useRenderer(this.displayName, headerCellRenderer, eText);
            }
            else {
                // no renderer, default text render
                eText.innerHTML = this.displayName;
                // i don't remember why this is here, take it out???
                utils_1.Utils.addCssClass(eText, 'ag-header-cell-text');
            }
        }
    };
    RenderedHeaderCell.prototype.setupFilterIcon = function () {
        this.eFilterIcon = this.queryForHtmlElement('#agFilter');
        if (!this.eFilterIcon) {
            return;
        }
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.onFilterChanged();
    };
    RenderedHeaderCell.prototype.onFilterChanged = function () {
        var filterPresent = this.column.isFilterActive();
        utils_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-filtered', filterPresent);
        utils_1.Utils.addOrRemoveCssClass(this.eFilterIcon, 'ag-hidden', !filterPresent);
    };
    RenderedHeaderCell.prototype.setupWidth = function () {
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_WIDTH_CHANGED, this.onColumnWidthChanged.bind(this));
        this.onColumnWidthChanged();
    };
    RenderedHeaderCell.prototype.onColumnWidthChanged = function () {
        this.getGui().style.width = this.column.getActualWidth() + 'px';
    };
    RenderedHeaderCell.prototype.createScope = function () {
        var _this = this;
        if (this.gridOptionsWrapper.isAngularCompileHeaders()) {
            this.childScope = this.$scope.$new();
            this.childScope.colDef = this.column.getColDef();
            this.childScope.colDefWrapper = this.column;
            this.childScope.context = this.gridOptionsWrapper.getContext();
            this.addDestroyFunc(function () {
                _this.childScope.$destroy();
            });
        }
    };
    RenderedHeaderCell.prototype.addAttributes = function () {
        this.getGui().setAttribute("colId", this.column.getColId());
    };
    RenderedHeaderCell.prototype.setupMenu = function () {
        var _this = this;
        var eMenu = this.queryForHtmlElement('#agMenu');
        // if no menu provided in template, do nothing
        if (!eMenu) {
            return;
        }
        var skipMenu = !this.menuFactory.isMenuEnabled(this.column) || this.column.getColDef().suppressMenu;
        if (skipMenu) {
            utils_1.Utils.removeFromParent(eMenu);
            return;
        }
        eMenu.addEventListener('click', function () { return _this.showMenu(eMenu); });
        if (!this.gridOptionsWrapper.isSuppressMenuHide()) {
            eMenu.style.opacity = '0';
            this.addGuiEventListener('mouseover', function () {
                eMenu.style.opacity = '1';
            });
            this.addGuiEventListener('mouseout', function () {
                eMenu.style.opacity = '0';
            });
        }
        var style = eMenu.style;
        style['transition'] = 'opacity 0.2s, border 0.2s';
        style['-webkit-transition'] = 'opacity 0.2s, border 0.2s';
    };
    RenderedHeaderCell.prototype.showMenu = function (eventSource) {
        this.menuFactory.showMenuAfterButtonClick(this.column, eventSource);
    };
    RenderedHeaderCell.prototype.setupMovingCss = function () {
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_MOVING_CHANGED, this.onColumnMovingChanged.bind(this));
        this.onColumnMovingChanged();
    };
    RenderedHeaderCell.prototype.onColumnMovingChanged = function () {
        // this function adds or removes the moving css, based on if the col is moving.
        // this is what makes the header go dark when it is been moved (gives impression to
        // user that the column was picked up).
        if (this.column.isMoving()) {
            utils_1.Utils.addCssClass(this.getGui(), 'ag-header-cell-moving');
        }
        else {
            utils_1.Utils.removeCssClass(this.getGui(), 'ag-header-cell-moving');
        }
    };
    RenderedHeaderCell.prototype.setupMove = function (eHeaderCellLabel) {
        var _this = this;
        var suppressMove = this.gridOptionsWrapper.isSuppressMovableColumns()
            || this.column.getColDef().suppressMovable
            || this.gridOptionsWrapper.isForPrint();
        if (suppressMove) {
            return;
        }
        if (eHeaderCellLabel) {
            var dragSource = {
                type: dragAndDropService_1.DragSourceType.HeaderCell,
                eElement: eHeaderCellLabel,
                dragItem: [this.column],
                dragItemName: this.displayName,
                dragSourceDropTarget: this.dragSourceDropTarget
            };
            this.dragAndDropService.addDragSource(dragSource, true);
            this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource); });
        }
    };
    RenderedHeaderCell.prototype.setupTap = function () {
        var _this = this;
        if (this.gridOptionsWrapper.isSuppressTouch()) {
            return;
        }
        var touchListener = new touchListener_1.TouchListener(this.getGui());
        var tapListener = function () {
            _this.sortController.progressSort(_this.column, false);
        };
        var longTapListener = function (touch) {
            _this.gridOptionsWrapper.getApi().showColumnMenuAfterMouseClick(_this.column, touch);
        };
        this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_TAP, tapListener);
        this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_LONG_TAP, longTapListener);
        this.addDestroyFunc(function () { return touchListener.destroy(); });
    };
    RenderedHeaderCell.prototype.setupResize = function () {
        var _this = this;
        var colDef = this.column.getColDef();
        var eResize = this.queryForHtmlElement('#agResizeBar');
        // if no eResize in template, do nothing
        if (!eResize) {
            return;
        }
        var weWantResize = this.gridOptionsWrapper.isEnableColResize() && !colDef.suppressResize;
        if (!weWantResize) {
            utils_1.Utils.removeFromParent(eResize);
            return;
        }
        this.horizontalDragService.addDragHandling({
            eDraggableElement: eResize,
            eBody: this.eRoot,
            cursor: 'col-resize',
            startAfterPixels: 0,
            onDragStart: this.onDragStart.bind(this),
            onDragging: this.onDragging.bind(this)
        });
        var weWantAutoSize = !this.gridOptionsWrapper.isSuppressAutoSize() && !colDef.suppressAutoSize;
        if (weWantAutoSize) {
            this.addDestroyableEventListener(eResize, 'dblclick', function () {
                _this.columnController.autoSizeColumn(_this.column);
            });
        }
    };
    RenderedHeaderCell.prototype.useRenderer = function (headerNameValue, headerCellRenderer, eText) {
        // renderer provided, use it
        var cellRendererParams = {
            colDef: this.column.getColDef(),
            $scope: this.childScope,
            context: this.gridOptionsWrapper.getContext(),
            value: headerNameValue,
            api: this.gridOptionsWrapper.getApi(),
            eHeaderCell: this.getGui()
        };
        var cellRendererResult = headerCellRenderer(cellRendererParams);
        var childToAppend;
        if (utils_1.Utils.isNodeOrElement(cellRendererResult)) {
            // a dom node or element was returned, so add child
            childToAppend = cellRendererResult;
        }
        else {
            // otherwise assume it was html, so just insert
            var eTextSpan = document.createElement("span");
            eTextSpan.innerHTML = cellRendererResult;
            childToAppend = eTextSpan;
        }
        // angular compile header if option is turned on
        if (this.gridOptionsWrapper.isAngularCompileHeaders()) {
            var childToAppendCompiled = this.$compile(childToAppend)(this.childScope)[0];
            eText.appendChild(childToAppendCompiled);
        }
        else {
            eText.appendChild(childToAppend);
        }
    };
    RenderedHeaderCell.prototype.setupSort = function (eHeaderCellLabel) {
        var _this = this;
        var enableSorting = this.gridOptionsWrapper.isEnableSorting() && !this.column.getColDef().suppressSorting;
        var eGui = this.getGui();
        if (!enableSorting) {
            utils_1.Utils.removeFromParent(eGui.querySelector('#agSortAsc'));
            utils_1.Utils.removeFromParent(eGui.querySelector('#agSortDesc'));
            utils_1.Utils.removeFromParent(eGui.querySelector('#agNoSort'));
            return;
        }
        // add sortable class for styling
        utils_1.Utils.addCssClass(eGui, 'ag-header-cell-sortable');
        // add the event on the header, so when clicked, we do sorting
        if (eHeaderCellLabel) {
            eHeaderCellLabel.addEventListener("click", function (event) {
                _this.sortController.progressSort(_this.column, event.shiftKey);
            });
        }
        // add listener for sort changing, and update the icons accordingly
        this.eSortAsc = this.queryForHtmlElement('#agSortAsc');
        this.eSortDesc = this.queryForHtmlElement('#agSortDesc');
        this.eSortNone = this.queryForHtmlElement('#agNoSort');
        this.addDestroyableEventListener(this.column, column_1.Column.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.onSortChanged();
    };
    RenderedHeaderCell.prototype.onSortChanged = function () {
        utils_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-asc', this.column.isSortAscending());
        utils_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-desc', this.column.isSortDescending());
        utils_1.Utils.addOrRemoveCssClass(this.getGui(), 'ag-header-cell-sorted-none', this.column.isSortNone());
        if (this.eSortAsc) {
            utils_1.Utils.addOrRemoveCssClass(this.eSortAsc, 'ag-hidden', !this.column.isSortAscending());
        }
        if (this.eSortDesc) {
            utils_1.Utils.addOrRemoveCssClass(this.eSortDesc, 'ag-hidden', !this.column.isSortDescending());
        }
        if (this.eSortNone) {
            var alwaysHideNoSort = !this.column.getColDef().unSortIcon && !this.gridOptionsWrapper.isUnSortIcon();
            utils_1.Utils.addOrRemoveCssClass(this.eSortNone, 'ag-hidden', alwaysHideNoSort || !this.column.isSortNone());
        }
    };
    RenderedHeaderCell.prototype.onDragStart = function () {
        this.startWidth = this.column.getActualWidth();
    };
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
    RenderedHeaderCell.prototype.normaliseDragChange = function (dragChange) {
        var result = dragChange;
        if (this.gridOptionsWrapper.isEnableRtl()) {
            // for RTL, dragging left makes the col bigger, except when pinning left
            if (this.pinned !== column_1.Column.PINNED_LEFT) {
                result *= -1;
            }
        }
        else {
            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
            if (this.pinned === column_1.Column.PINNED_RIGHT) {
                result *= -1;
            }
        }
        return result;
    };
    RenderedHeaderCell.prototype.onDragging = function (dragChange, finished) {
        var dragChangeNormalised = this.normaliseDragChange(dragChange);
        var newWidth = this.startWidth + dragChangeNormalised;
        this.columnController.setColumnWidth(this.column, newWidth, finished);
    };
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], RenderedHeaderCell.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('filterManager'), 
        __metadata('design:type', filterManager_1.FilterManager)
    ], RenderedHeaderCell.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], RenderedHeaderCell.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('$compile'), 
        __metadata('design:type', Object)
    ], RenderedHeaderCell.prototype, "$compile", void 0);
    __decorate([
        context_1.Autowired('gridCore'), 
        __metadata('design:type', gridCore_1.GridCore)
    ], RenderedHeaderCell.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('headerTemplateLoader'), 
        __metadata('design:type', headerTemplateLoader_1.HeaderTemplateLoader)
    ], RenderedHeaderCell.prototype, "headerTemplateLoader", void 0);
    __decorate([
        context_1.Autowired('horizontalDragService'), 
        __metadata('design:type', horizontalDragService_1.HorizontalDragService)
    ], RenderedHeaderCell.prototype, "horizontalDragService", void 0);
    __decorate([
        context_1.Autowired('menuFactory'), 
        __metadata('design:type', Object)
    ], RenderedHeaderCell.prototype, "menuFactory", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], RenderedHeaderCell.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'), 
        __metadata('design:type', dragAndDropService_1.DragAndDropService)
    ], RenderedHeaderCell.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.Autowired('sortController'), 
        __metadata('design:type', sortController_1.SortController)
    ], RenderedHeaderCell.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('$scope'), 
        __metadata('design:type', Object)
    ], RenderedHeaderCell.prototype, "$scope", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], RenderedHeaderCell.prototype, "init", null);
    return RenderedHeaderCell;
}(component_1.Component));
exports.RenderedHeaderCell = RenderedHeaderCell;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/renderedHeaderGroupCell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var svgFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/svgFactory.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var horizontalDragService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/horizontalDragService.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var cssClassApplier_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/cssClassApplier.js");
var dragAndDropService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/dragAndDrop/dragAndDropService.js");
var setLeftFeature_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/features/setLeftFeature.js");
var touchListener_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/touchListener.js");
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var svgFactory = svgFactory_1.SvgFactory.getInstance();
var RenderedHeaderGroupCell = (function (_super) {
    __extends(RenderedHeaderGroupCell, _super);
    function RenderedHeaderGroupCell(columnGroup, eRoot, dragSourceDropTarget, pinned) {
        _super.call(this, "<div/>");
        this.columnGroup = columnGroup;
        this.eRoot = eRoot;
        this.dragSourceDropTarget = dragSourceDropTarget;
        this.pinned = pinned;
    }
    RenderedHeaderGroupCell.prototype.init = function () {
        cssClassApplier_1.CssClassApplier.addHeaderClassesFromColDef(this.columnGroup.getColGroupDef(), this.getGui(), this.gridOptionsWrapper, null, this.columnGroup);
        // this.displayName = this.columnGroup.getHeaderName();
        this.displayName = this.columnController.getDisplayNameForColumnGroup(this.columnGroup, 'header');
        this.setupResize();
        this.addClasses();
        this.setupLabel();
        this.setupMove();
        this.setWidth();
        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.columnGroup, this.getGui());
        this.addDestroyFunc(function () { return setLeftFeature.destroy(); });
    };
    RenderedHeaderGroupCell.prototype.setupLabel = function () {
        // no renderer, default text render
        if (this.displayName && this.displayName !== '') {
            var eGroupCellLabel = document.createElement("div");
            eGroupCellLabel.className = 'ag-header-group-cell-label';
            this.getGui().appendChild(eGroupCellLabel);
            if (utils_1.Utils.isBrowserSafari()) {
                eGroupCellLabel.style.display = 'table-cell';
            }
            var eInnerText = document.createElement("span");
            eInnerText.className = 'ag-header-group-text';
            eInnerText.innerHTML = this.displayName;
            eGroupCellLabel.appendChild(eInnerText);
            if (this.columnGroup.isExpandable()) {
                this.addGroupExpandIcon(eGroupCellLabel);
            }
        }
    };
    RenderedHeaderGroupCell.prototype.addClasses = function () {
        utils_1.Utils.addCssClass(this.getGui(), 'ag-header-group-cell');
        // having different classes below allows the style to not have a bottom border
        // on the group header, if no group is specified
        // columnGroup.getColGroupDef
        if (this.columnGroup.isPadding()) {
            utils_1.Utils.addCssClass(this.getGui(), 'ag-header-group-cell-no-group');
        }
        else {
            utils_1.Utils.addCssClass(this.getGui(), 'ag-header-group-cell-with-group');
        }
    };
    RenderedHeaderGroupCell.prototype.setupResize = function () {
        var _this = this;
        if (!this.gridOptionsWrapper.isEnableColResize()) {
            return;
        }
        this.eHeaderCellResize = document.createElement("div");
        this.eHeaderCellResize.className = "ag-header-cell-resize";
        this.getGui().appendChild(this.eHeaderCellResize);
        this.dragService.addDragHandling({
            eDraggableElement: this.eHeaderCellResize,
            eBody: this.eRoot,
            cursor: 'col-resize',
            startAfterPixels: 0,
            onDragStart: this.onDragStart.bind(this),
            onDragging: this.onDragging.bind(this)
        });
        if (!this.gridOptionsWrapper.isSuppressAutoSize()) {
            this.eHeaderCellResize.addEventListener('dblclick', function (event) {
                // get list of all the column keys we are responsible for
                var keys = [];
                _this.columnGroup.getDisplayedLeafColumns().forEach(function (column) {
                    // not all cols in the group may be participating with auto-resize
                    if (!column.getColDef().suppressAutoSize) {
                        keys.push(column.getColId());
                    }
                });
                if (keys.length > 0) {
                    _this.columnController.autoSizeColumns(keys);
                }
            });
        }
    };
    RenderedHeaderGroupCell.prototype.isSuppressMoving = function () {
        // if any child is fixed, then don't allow moving
        var childSuppressesMoving = false;
        this.columnGroup.getLeafColumns().forEach(function (column) {
            if (column.getColDef().suppressMovable) {
                childSuppressesMoving = true;
            }
        });
        var result = childSuppressesMoving
            || this.gridOptionsWrapper.isSuppressMovableColumns()
            || this.gridOptionsWrapper.isForPrint();
        return result;
    };
    RenderedHeaderGroupCell.prototype.setupMove = function () {
        var _this = this;
        var eLabel = this.queryForHtmlElement('.ag-header-group-cell-label');
        if (!eLabel) {
            return;
        }
        if (this.isSuppressMoving()) {
            return;
        }
        if (eLabel) {
            var dragSource = {
                type: dragAndDropService_1.DragSourceType.HeaderCell,
                eElement: eLabel,
                dragItemName: this.displayName,
                // we add in the original group leaf columns, so we move both visible and non-visible items
                dragItem: this.getAllColumnsInThisGroup(),
                dragSourceDropTarget: this.dragSourceDropTarget
            };
            this.dragAndDropService.addDragSource(dragSource, true);
            this.addDestroyFunc(function () { return _this.dragAndDropService.removeDragSource(dragSource); });
        }
    };
    // when moving the columns, we want to move all the columns in this group in one go, and in the order they
    // are currently in the screen.
    RenderedHeaderGroupCell.prototype.getAllColumnsInThisGroup = function () {
        var allColumnsOriginalOrder = this.columnGroup.getOriginalColumnGroup().getLeafColumns();
        var allColumnsCurrentOrder = [];
        this.columnController.getAllDisplayedColumns().forEach(function (column) {
            if (allColumnsOriginalOrder.indexOf(column) >= 0) {
                allColumnsCurrentOrder.push(column);
                utils_1.Utils.removeFromArray(allColumnsOriginalOrder, column);
            }
        });
        // we are left with non-visible columns, stick these in at the end
        allColumnsOriginalOrder.forEach(function (column) { return allColumnsCurrentOrder.push(column); });
        return allColumnsCurrentOrder;
    };
    RenderedHeaderGroupCell.prototype.setWidth = function () {
        var _this = this;
        this.columnGroup.getLeafColumns().forEach(function (column) {
            return _this.addDestroyableEventListener(column, column_1.Column.EVENT_WIDTH_CHANGED, _this.onWidthChanged.bind(_this));
        });
        this.onWidthChanged();
    };
    RenderedHeaderGroupCell.prototype.onWidthChanged = function () {
        this.getGui().style.width = this.columnGroup.getActualWidth() + 'px';
    };
    RenderedHeaderGroupCell.prototype.addGroupExpandIcon = function (eGroupCellLabel) {
        var _this = this;
        var eGroupIcon;
        if (this.columnGroup.isExpanded()) {
            eGroupIcon = utils_1.Utils.createIcon('columnGroupOpened', this.gridOptionsWrapper, null, svgFactory.createGroupContractedIcon);
            utils_1.Utils.addCssClass(eGroupIcon, 'ag-header-expand-icon-expanded');
        }
        else {
            eGroupIcon = utils_1.Utils.createIcon('columnGroupClosed', this.gridOptionsWrapper, null, svgFactory.createGroupExpandedIcon);
            utils_1.Utils.addCssClass(eGroupIcon, 'ag-header-expand-icon-collapsed');
        }
        utils_1.Utils.addCssClass(eGroupIcon, 'ag-header-expand-icon');
        eGroupCellLabel.appendChild(eGroupIcon);
        var expandAction = function () {
            var newExpandedValue = !_this.columnGroup.isExpanded();
            _this.columnController.setColumnGroupOpened(_this.columnGroup, newExpandedValue);
        };
        this.addDestroyableEventListener(eGroupIcon, 'click', expandAction);
        var touchListener = new touchListener_1.TouchListener(eGroupIcon);
        this.addDestroyableEventListener(touchListener, touchListener_1.TouchListener.EVENT_TAP, expandAction);
        this.addDestroyFunc(function () { return touchListener.destroy(); });
    };
    RenderedHeaderGroupCell.prototype.onDragStart = function () {
        var _this = this;
        this.groupWidthStart = this.columnGroup.getActualWidth();
        this.childrenWidthStarts = [];
        this.columnGroup.getDisplayedLeafColumns().forEach(function (column) {
            _this.childrenWidthStarts.push(column.getActualWidth());
        });
    };
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
    RenderedHeaderGroupCell.prototype.normaliseDragChange = function (dragChange) {
        var result = dragChange;
        if (this.gridOptionsWrapper.isEnableRtl()) {
            // for RTL, dragging left makes the col bigger, except when pinning left
            if (this.pinned !== column_1.Column.PINNED_LEFT) {
                result *= -1;
            }
        }
        else {
            // for LTR (ie normal), dragging left makes the col smaller, except when pinning right
            if (this.pinned === column_1.Column.PINNED_RIGHT) {
                result *= -1;
            }
        }
        return result;
    };
    RenderedHeaderGroupCell.prototype.onDragging = function (dragChange, finished) {
        var _this = this;
        var dragChangeNormalised = this.normaliseDragChange(dragChange);
        var newWidth = this.groupWidthStart + dragChangeNormalised;
        var minWidth = this.columnGroup.getMinWidth();
        if (newWidth < minWidth) {
            newWidth = minWidth;
        }
        // distribute the new width to the child headers
        var changeRatio = newWidth / this.groupWidthStart;
        // keep track of pixels used, and last column gets the remaining,
        // to cater for rounding errors, and min width adjustments
        var pixelsToDistribute = newWidth;
        var displayedColumns = this.columnGroup.getDisplayedLeafColumns();
        displayedColumns.forEach(function (column, index) {
            var notLastCol = index !== (displayedColumns.length - 1);
            var newChildSize;
            if (notLastCol) {
                // if not the last col, calculate the column width as normal
                var startChildSize = _this.childrenWidthStarts[index];
                newChildSize = startChildSize * changeRatio;
                if (newChildSize < column.getMinWidth()) {
                    newChildSize = column.getMinWidth();
                }
                pixelsToDistribute -= newChildSize;
            }
            else {
                // if last col, give it the remaining pixels
                newChildSize = pixelsToDistribute;
            }
            _this.columnController.setColumnWidth(column, newChildSize, finished);
        });
    };
    __decorate([
        context_1.Autowired('filterManager'), 
        __metadata('design:type', filterManager_1.FilterManager)
    ], RenderedHeaderGroupCell.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], RenderedHeaderGroupCell.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('horizontalDragService'), 
        __metadata('design:type', horizontalDragService_1.HorizontalDragService)
    ], RenderedHeaderGroupCell.prototype, "dragService", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], RenderedHeaderGroupCell.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('dragAndDropService'), 
        __metadata('design:type', dragAndDropService_1.DragAndDropService)
    ], RenderedHeaderGroupCell.prototype, "dragAndDropService", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], RenderedHeaderGroupCell.prototype, "init", null);
    return RenderedHeaderGroupCell;
}(component_1.Component));
exports.RenderedHeaderGroupCell = RenderedHeaderGroupCell;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/headerRendering/standardMenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var popupService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/popupService.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var StandardMenuFactory = (function () {
    function StandardMenuFactory() {
    }
    StandardMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent) {
        var _this = this;
        this.showPopup(column, function (eMenu) {
            _this.popupService.positionPopupUnderMouseEvent({
                mouseEvent: mouseEvent,
                ePopup: eMenu
            });
        });
    };
    StandardMenuFactory.prototype.showMenuAfterButtonClick = function (column, eventSource) {
        var _this = this;
        this.showPopup(column, function (eMenu) {
            _this.popupService.positionPopupUnderComponent({ eventSource: eventSource, ePopup: eMenu, keepWithinBounds: true });
        });
    };
    StandardMenuFactory.prototype.showPopup = function (column, positionCallback) {
        var _this = this;
        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(column);
        var eMenu = document.createElement('div');
        utils_1.Utils.addCssClass(eMenu, 'ag-menu');
        eMenu.appendChild(filterWrapper.gui);
        var hidePopup;
        var bodyScrollListener = function (event) {
            // if h scroll, popup is no longer over the column
            if (event.direction === 'horizontal') {
                hidePopup();
            }
        };
        this.eventService.addEventListener('bodyScroll', bodyScrollListener);
        var closedCallback = function () {
            _this.eventService.removeEventListener('bodyScroll', bodyScrollListener);
        };
        // need to show filter before positioning, as only after filter
        // is visible can we find out what the width of it is
        hidePopup = this.popupService.addAsModalPopup(eMenu, true, closedCallback);
        positionCallback(eMenu);
        if (filterWrapper.filter.afterGuiAttached) {
            var params = {
                hidePopup: hidePopup
            };
            filterWrapper.filter.afterGuiAttached(params);
        }
    };
    StandardMenuFactory.prototype.isMenuEnabled = function (column) {
        // for standard, we show menu if filter is enabled, and he menu is not suppressed
        return this.gridOptionsWrapper.isEnableFilter() && column.isFilterAllowed();
    };
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], StandardMenuFactory.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('filterManager'), 
        __metadata('design:type', filterManager_1.FilterManager)
    ], StandardMenuFactory.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('popupService'), 
        __metadata('design:type', popupService_1.PopupService)
    ], StandardMenuFactory.prototype, "popupService", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], StandardMenuFactory.prototype, "gridOptionsWrapper", void 0);
    StandardMenuFactory = __decorate([
        context_1.Bean('menuFactory'), 
        __metadata('design:paramtypes', [])
    ], StandardMenuFactory);
    return StandardMenuFactory;
}());
exports.StandardMenuFactory = StandardMenuFactory;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/layout/borderLayout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var BorderLayout = (function () {
    function BorderLayout(params) {
        this.centerHeightLastTime = -1;
        this.centerWidthLastTime = -1;
        this.centerLeftMarginLastTime = -1;
        this.visibleLastTime = false;
        this.sizeChangeListeners = [];
        this.isLayoutPanel = true;
        this.fullHeight = !params.north && !params.south;
        var template;
        if (!params.dontFill) {
            if (this.fullHeight) {
                template = BorderLayout.TEMPLATE_FULL_HEIGHT;
            }
            else {
                template = BorderLayout.TEMPLATE_NORMAL;
            }
            this.layoutActive = true;
        }
        else {
            template = BorderLayout.TEMPLATE_DONT_FILL;
            this.layoutActive = false;
        }
        this.eGui = utils_1.Utils.loadTemplate(template);
        this.id = 'borderLayout';
        if (params.name) {
            this.id += '_' + params.name;
        }
        this.eGui.setAttribute('id', this.id);
        this.childPanels = [];
        if (params) {
            this.setupPanels(params);
        }
        this.overlays = params.overlays;
        this.setupOverlays();
    }
    BorderLayout.prototype.addSizeChangeListener = function (listener) {
        this.sizeChangeListeners.push(listener);
    };
    BorderLayout.prototype.fireSizeChanged = function () {
        this.sizeChangeListeners.forEach(function (listener) {
            listener();
        });
    };
    BorderLayout.prototype.setupPanels = function (params) {
        this.eNorthWrapper = this.eGui.querySelector('#north');
        this.eSouthWrapper = this.eGui.querySelector('#south');
        this.eEastWrapper = this.eGui.querySelector('#east');
        this.eWestWrapper = this.eGui.querySelector('#west');
        this.eCenterWrapper = this.eGui.querySelector('#center');
        this.eOverlayWrapper = this.eGui.querySelector('#overlay');
        this.eCenterRow = this.eGui.querySelector('#centerRow');
        this.eNorthChildLayout = this.setupPanel(params.north, this.eNorthWrapper);
        this.eSouthChildLayout = this.setupPanel(params.south, this.eSouthWrapper);
        this.eEastChildLayout = this.setupPanel(params.east, this.eEastWrapper);
        this.eWestChildLayout = this.setupPanel(params.west, this.eWestWrapper);
        this.eCenterChildLayout = this.setupPanel(params.center, this.eCenterWrapper);
    };
    BorderLayout.prototype.setupPanel = function (content, ePanel) {
        if (!ePanel) {
            return;
        }
        if (content) {
            if (content.isLayoutPanel) {
                this.childPanels.push(content);
                ePanel.appendChild(content.getGui());
                return content;
            }
            else {
                ePanel.appendChild(content);
                return null;
            }
        }
        else {
            ePanel.parentNode.removeChild(ePanel);
            return null;
        }
    };
    BorderLayout.prototype.getGui = function () {
        return this.eGui;
    };
    // returns true if any item changed size, otherwise returns false
    BorderLayout.prototype.doLayout = function () {
        var _this = this;
        var isVisible = utils_1.Utils.isVisible(this.eGui);
        if (!isVisible) {
            this.visibleLastTime = false;
            return false;
        }
        var atLeastOneChanged = false;
        if (this.visibleLastTime !== isVisible) {
            atLeastOneChanged = true;
        }
        this.visibleLastTime = true;
        var childLayouts = [this.eNorthChildLayout, this.eSouthChildLayout, this.eEastChildLayout, this.eWestChildLayout];
        childLayouts.forEach(function (childLayout) {
            var childChangedSize = _this.layoutChild(childLayout);
            if (childChangedSize) {
                atLeastOneChanged = true;
            }
        });
        if (this.layoutActive) {
            var ourHeightChanged = this.layoutHeight();
            var ourWidthChanged = this.layoutWidth();
            if (ourHeightChanged || ourWidthChanged) {
                atLeastOneChanged = true;
            }
        }
        var centerChanged = this.layoutChild(this.eCenterChildLayout);
        if (centerChanged) {
            atLeastOneChanged = true;
        }
        if (atLeastOneChanged) {
            this.fireSizeChanged();
        }
        return atLeastOneChanged;
    };
    BorderLayout.prototype.layoutChild = function (childPanel) {
        if (childPanel) {
            return childPanel.doLayout();
        }
        else {
            return false;
        }
    };
    BorderLayout.prototype.layoutHeight = function () {
        if (this.fullHeight) {
            return this.layoutHeightFullHeight();
        }
        else {
            return this.layoutHeightNormal();
        }
    };
    // full height never changes the height, because the center is always 100%,
    // however we do check for change, to inform the listeners
    BorderLayout.prototype.layoutHeightFullHeight = function () {
        var centerHeight = utils_1.Utils.offsetHeight(this.eGui);
        if (centerHeight < 0) {
            centerHeight = 0;
        }
        if (this.centerHeightLastTime !== centerHeight) {
            this.centerHeightLastTime = centerHeight;
            return true;
        }
        else {
            return false;
        }
    };
    BorderLayout.prototype.layoutHeightNormal = function () {
        var totalHeight = utils_1.Utils.offsetHeight(this.eGui);
        var northHeight = utils_1.Utils.offsetHeight(this.eNorthWrapper);
        var southHeight = utils_1.Utils.offsetHeight(this.eSouthWrapper);
        var centerHeight = totalHeight - northHeight - southHeight;
        if (centerHeight < 0) {
            centerHeight = 0;
        }
        if (this.centerHeightLastTime !== centerHeight) {
            this.eCenterRow.style.height = centerHeight + 'px';
            this.centerHeightLastTime = centerHeight;
            return true; // return true because there was a change
        }
        else {
            return false;
        }
    };
    BorderLayout.prototype.getCentreHeight = function () {
        return this.centerHeightLastTime;
    };
    BorderLayout.prototype.layoutWidth = function () {
        var totalWidth = utils_1.Utils.offsetWidth(this.eGui);
        var eastWidth = utils_1.Utils.offsetWidth(this.eEastWrapper);
        var westWidth = utils_1.Utils.offsetWidth(this.eWestWrapper);
        var centerWidth = totalWidth - eastWidth - westWidth;
        if (centerWidth < 0) {
            centerWidth = 0;
        }
        var atLeastOneChanged = false;
        if (this.centerLeftMarginLastTime !== westWidth) {
            this.centerLeftMarginLastTime = westWidth;
            this.eCenterWrapper.style.marginLeft = westWidth + 'px';
            atLeastOneChanged = true;
        }
        if (this.centerWidthLastTime !== centerWidth) {
            this.centerWidthLastTime = centerWidth;
            this.eCenterWrapper.style.width = centerWidth + 'px';
            atLeastOneChanged = true;
        }
        return atLeastOneChanged;
    };
    BorderLayout.prototype.setEastVisible = function (visible) {
        if (this.eEastWrapper) {
            this.eEastWrapper.style.display = visible ? '' : 'none';
        }
        this.doLayout();
    };
    BorderLayout.prototype.setupOverlays = function () {
        // if no overlays, just remove the panel
        if (!this.overlays) {
            this.eOverlayWrapper.parentNode.removeChild(this.eOverlayWrapper);
            return;
        }
        this.hideOverlay();
    };
    BorderLayout.prototype.hideOverlay = function () {
        utils_1.Utils.removeAllChildren(this.eOverlayWrapper);
        this.eOverlayWrapper.style.display = 'none';
    };
    BorderLayout.prototype.showOverlay = function (key) {
        var overlay = this.overlays ? this.overlays[key] : null;
        if (overlay) {
            utils_1.Utils.removeAllChildren(this.eOverlayWrapper);
            this.eOverlayWrapper.style.display = '';
            this.eOverlayWrapper.appendChild(overlay);
        }
        else {
            console.log('ag-Grid: unknown overlay');
            this.hideOverlay();
        }
    };
    BorderLayout.TEMPLATE_FULL_HEIGHT = '<div class="ag-bl ag-bl-full-height">' +
        '  <div class="ag-bl-west ag-bl-full-height-west" id="west"></div>' +
        '  <div class="ag-bl-east ag-bl-full-height-east" id="east"></div>' +
        '  <div class="ag-bl-center ag-bl-full-height-center" id="center"></div>' +
        '  <div class="ag-bl-overlay" id="overlay"></div>' +
        '</div>';
    BorderLayout.TEMPLATE_NORMAL = '<div class="ag-bl ag-bl-normal">' +
        '  <div id="north"></div>' +
        '  <div class="ag-bl-center-row ag-bl-normal-center-row" id="centerRow">' +
        '    <div class="ag-bl-west ag-bl-normal-west" id="west"></div>' +
        '    <div class="ag-bl-east ag-bl-normal-east" id="east"></div>' +
        '    <div class="ag-bl-center ag-bl-normal-center" id="center"></div>' +
        '  </div>' +
        '  <div id="south"></div>' +
        '  <div class="ag-bl-overlay" id="overlay"></div>' +
        '</div>';
    BorderLayout.TEMPLATE_DONT_FILL = '<div class="ag-bl ag-bl-dont-fill">' +
        '  <div id="north"></div>' +
        '  <div id="centerRow">' +
        '    <div id="west"></div>' +
        '    <div id="east"></div>' +
        '    <div id="center"></div>' +
        '  </div>' +
        '  <div id="south"></div>' +
        '  <div class="ag-bl-overlay" id="overlay"></div>' +
        '</div>';
    return BorderLayout;
}());
exports.BorderLayout = BorderLayout;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/layout/tabbedLayout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var TabbedLayout = (function () {
    function TabbedLayout(params) {
        var _this = this;
        this.items = [];
        this.params = params;
        this.eGui = document.createElement('div');
        this.eGui.innerHTML = TabbedLayout.TEMPLATE;
        this.eHeader = this.eGui.querySelector('#tabHeader');
        this.eBody = this.eGui.querySelector('#tabBody');
        utils_1.Utils.addCssClass(this.eGui, params.cssClass);
        if (params.items) {
            params.items.forEach(function (item) { return _this.addItem(item); });
        }
    }
    TabbedLayout.prototype.setAfterAttachedParams = function (params) {
        this.afterAttachedParams = params;
    };
    TabbedLayout.prototype.getMinWidth = function () {
        var eDummyContainer = document.createElement('span');
        // position fixed, so it isn't restricted to the boundaries of the parent
        eDummyContainer.style.position = 'fixed';
        // we put the dummy into the body container, so it will inherit all the
        // css styles that the real cells are inheriting
        this.eGui.appendChild(eDummyContainer);
        var minWidth = 0;
        this.items.forEach(function (itemWrapper) {
            utils_1.Utils.removeAllChildren(eDummyContainer);
            var eClone = itemWrapper.tabbedItem.body.cloneNode(true);
            eDummyContainer.appendChild(eClone);
            if (minWidth < eDummyContainer.offsetWidth) {
                minWidth = eDummyContainer.offsetWidth;
            }
        });
        this.eGui.removeChild(eDummyContainer);
        return minWidth;
    };
    TabbedLayout.prototype.showFirstItem = function () {
        if (this.items.length > 0) {
            this.showItemWrapper(this.items[0]);
        }
    };
    TabbedLayout.prototype.addItem = function (item) {
        var eHeaderButton = document.createElement('span');
        eHeaderButton.appendChild(item.title);
        utils_1.Utils.addCssClass(eHeaderButton, 'ag-tab');
        this.eHeader.appendChild(eHeaderButton);
        var wrapper = {
            tabbedItem: item,
            eHeaderButton: eHeaderButton
        };
        this.items.push(wrapper);
        eHeaderButton.addEventListener('click', this.showItemWrapper.bind(this, wrapper));
    };
    TabbedLayout.prototype.showItem = function (tabbedItem) {
        var itemWrapper = utils_1.Utils.find(this.items, function (itemWrapper) {
            return itemWrapper.tabbedItem === tabbedItem;
        });
        if (itemWrapper) {
            this.showItemWrapper(itemWrapper);
        }
    };
    TabbedLayout.prototype.showItemWrapper = function (wrapper) {
        if (this.params.onItemClicked) {
            this.params.onItemClicked({ item: wrapper.tabbedItem });
        }
        if (this.activeItem === wrapper) {
            utils_1.Utils.callIfPresent(this.params.onActiveItemClicked);
            return;
        }
        utils_1.Utils.removeAllChildren(this.eBody);
        this.eBody.appendChild(wrapper.tabbedItem.body);
        if (this.activeItem) {
            utils_1.Utils.removeCssClass(this.activeItem.eHeaderButton, 'ag-tab-selected');
        }
        utils_1.Utils.addCssClass(wrapper.eHeaderButton, 'ag-tab-selected');
        this.activeItem = wrapper;
        if (wrapper.tabbedItem.afterAttachedCallback) {
            wrapper.tabbedItem.afterAttachedCallback(this.afterAttachedParams);
        }
    };
    TabbedLayout.prototype.getGui = function () {
        return this.eGui;
    };
    TabbedLayout.TEMPLATE = '<div>' +
        '<div id="tabHeader" class="ag-tab-header"></div>' +
        '<div id="tabBody" class="ag-tab-body"></div>' +
        '</div>';
    return TabbedLayout;
}());
exports.TabbedLayout = TabbedLayout;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/layout/verticalStack.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var VerticalStack = (function () {
    function VerticalStack() {
        this.isLayoutPanel = true;
        this.childPanels = [];
        this.eGui = document.createElement('div');
        this.eGui.style.height = '100%';
    }
    VerticalStack.prototype.addPanel = function (panel, height) {
        var component;
        if (panel.isLayoutPanel) {
            this.childPanels.push(panel);
            component = panel.getGui();
        }
        else {
            component = panel;
        }
        if (height) {
            component.style.height = height;
        }
        this.eGui.appendChild(component);
    };
    VerticalStack.prototype.getGui = function () {
        return this.eGui;
    };
    VerticalStack.prototype.doLayout = function () {
        for (var i = 0; i < this.childPanels.length; i++) {
            this.childPanels[i].doLayout();
        }
    };
    return VerticalStack;
}());
exports.VerticalStack = VerticalStack;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/logger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var LoggerFactory = (function () {
    function LoggerFactory() {
    }
    LoggerFactory.prototype.setBeans = function (gridOptionsWrapper) {
        this.logging = gridOptionsWrapper.isDebug();
    };
    LoggerFactory.prototype.create = function (name) {
        return new Logger(name, this.logging);
    };
    __decorate([
        __param(0, context_2.Qualifier('gridOptionsWrapper')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [gridOptionsWrapper_1.GridOptionsWrapper]), 
        __metadata('design:returntype', void 0)
    ], LoggerFactory.prototype, "setBeans", null);
    LoggerFactory = __decorate([
        context_1.Bean('loggerFactory'), 
        __metadata('design:paramtypes', [])
    ], LoggerFactory);
    return LoggerFactory;
}());
exports.LoggerFactory = LoggerFactory;
var Logger = (function () {
    function Logger(name, logging) {
        this.name = name;
        this.logging = logging;
    }
    Logger.prototype.log = function (message) {
        if (this.logging) {
            console.log('ag-Grid.' + this.name + ': ' + message);
        }
    };
    return Logger;
}());
exports.Logger = Logger;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/masterSlaveService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_3 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_4 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var MasterSlaveService = (function () {
    function MasterSlaveService() {
        // flag to mark if we are consuming. to avoid cyclic events (ie slave firing back to master
        // while processing a master event) we mark this if consuming an event, and if we are, then
        // we don't fire back any events.
        this.consuming = false;
    }
    MasterSlaveService.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('MasterSlaveService');
    };
    MasterSlaveService.prototype.init = function () {
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this));
        this.eventService.addEventListener(events_1.Events.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this));
    };
    // common logic across all the fire methods
    MasterSlaveService.prototype.fireEvent = function (callback) {
        // if we are already consuming, then we are acting on an event from a master,
        // so we don't cause a cyclic firing of events
        if (this.consuming) {
            return;
        }
        // iterate through the slave grids, and pass each slave service to the callback
        var slaveGrids = this.gridOptionsWrapper.getSlaveGrids();
        if (slaveGrids) {
            slaveGrids.forEach(function (slaveGridOptions) {
                if (slaveGridOptions.api) {
                    var slaveService = slaveGridOptions.api.__getMasterSlaveService();
                    callback(slaveService);
                }
            });
        }
    };
    // common logic across all consume methods. very little common logic, however extracting
    // guarantees consistency across the methods.
    MasterSlaveService.prototype.onEvent = function (callback) {
        this.consuming = true;
        callback();
        this.consuming = false;
    };
    MasterSlaveService.prototype.fireColumnEvent = function (event) {
        this.fireEvent(function (slaveService) {
            slaveService.onColumnEvent(event);
        });
    };
    MasterSlaveService.prototype.fireHorizontalScrollEvent = function (horizontalScroll) {
        this.fireEvent(function (slaveService) {
            slaveService.onScrollEvent(horizontalScroll);
        });
    };
    MasterSlaveService.prototype.onScrollEvent = function (horizontalScroll) {
        var _this = this;
        this.onEvent(function () {
            _this.gridPanel.setHorizontalScrollPosition(horizontalScroll);
        });
    };
    MasterSlaveService.prototype.getMasterColumns = function (event) {
        var result = [];
        if (event.getColumn()) {
            result.push(event.getColumn());
        }
        if (event.getColumns()) {
            event.getColumns().forEach(function (column) {
                result.push(column);
            });
        }
        return result;
    };
    MasterSlaveService.prototype.getColumnIds = function (event) {
        var result = [];
        if (event.getColumn()) {
            result.push(event.getColumn().getColId());
        }
        else if (event.getColumns()) {
            event.getColumns().forEach(function (column) {
                result.push(column.getColId());
            });
        }
        return result;
    };
    MasterSlaveService.prototype.onColumnEvent = function (event) {
        var _this = this;
        this.onEvent(function () {
            // the column in the event is from the master grid. need to
            // look up the equivalent from this (slave) grid
            var masterColumn = event.getColumn();
            var slaveColumn;
            if (masterColumn) {
                slaveColumn = _this.columnController.getPrimaryColumn(masterColumn.getColId());
            }
            // if event was with respect to a master column, that is not present in this
            // grid, then we ignore the event
            if (masterColumn && !slaveColumn) {
                return;
            }
            // likewise for column group
            var masterColumnGroup = event.getColumnGroup();
            var slaveColumnGroup;
            if (masterColumnGroup) {
                var colId = masterColumnGroup.getGroupId();
                var instanceId = masterColumnGroup.getInstanceId();
                slaveColumnGroup = _this.columnController.getColumnGroup(colId, instanceId);
            }
            if (masterColumnGroup && !slaveColumnGroup) {
                return;
            }
            // in time, all the methods below should use the column ids, it's a more generic way
            // of handling columns, and also allows for single or multi column events
            var columnIds = _this.getColumnIds(event);
            var masterColumns = _this.getMasterColumns(event);
            switch (event.getType()) {
                case events_1.Events.EVENT_COLUMN_PIVOT_CHANGED:
                    // we cannot support pivoting with master / slave as the columns will be out of sync as the
                    // grids will have columns created based on the row data of the grid.
                    console.warn('ag-Grid: pivoting is not supported with Master / Slave grids. ' +
                        'You can only use one of these features at a time in a grid.');
                    break;
                case events_1.Events.EVENT_COLUMN_MOVED:
                    _this.logger.log('onColumnEvent-> processing ' + event + ' toIndex = ' + event.getToIndex());
                    _this.columnController.moveColumns(columnIds, event.getToIndex());
                    break;
                case events_1.Events.EVENT_COLUMN_VISIBLE:
                    _this.logger.log('onColumnEvent-> processing ' + event + ' visible = ' + event.isVisible());
                    _this.columnController.setColumnsVisible(columnIds, event.isVisible());
                    break;
                case events_1.Events.EVENT_COLUMN_PINNED:
                    _this.logger.log('onColumnEvent-> processing ' + event + ' pinned = ' + event.getPinned());
                    _this.columnController.setColumnsPinned(columnIds, event.getPinned());
                    break;
                case events_1.Events.EVENT_COLUMN_GROUP_OPENED:
                    _this.logger.log('onColumnEvent-> processing ' + event + ' expanded = ' + masterColumnGroup.isExpanded());
                    _this.columnController.setColumnGroupOpened(slaveColumnGroup, masterColumnGroup.isExpanded());
                    break;
                case events_1.Events.EVENT_COLUMN_RESIZED:
                    masterColumns.forEach(function (masterColumn) {
                        _this.logger.log('onColumnEvent-> processing ' + event + ' actualWidth = ' + masterColumn.getActualWidth());
                        _this.columnController.setColumnWidth(masterColumn.getColId(), masterColumn.getActualWidth(), event.isFinished());
                    });
                    break;
            }
        });
    };
    __decorate([
        context_3.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], MasterSlaveService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_3.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], MasterSlaveService.prototype, "columnController", void 0);
    __decorate([
        context_3.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], MasterSlaveService.prototype, "gridPanel", void 0);
    __decorate([
        context_3.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], MasterSlaveService.prototype, "eventService", void 0);
    __decorate([
        __param(0, context_2.Qualifier('loggerFactory')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory]), 
        __metadata('design:returntype', void 0)
    ], MasterSlaveService.prototype, "setBeans", null);
    __decorate([
        context_4.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], MasterSlaveService.prototype, "init", null);
    MasterSlaveService = __decorate([
        context_1.Bean('masterSlaveService'), 
        __metadata('design:paramtypes', [])
    ], MasterSlaveService);
    return MasterSlaveService;
}());
exports.MasterSlaveService = MasterSlaveService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/misc/focusService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridCore_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridCore.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var gridCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridCell.js");
// tracks when focus goes into a cell. cells listen to this, so they know to stop editing
// if focus goes into another cell.
/** THIS IS NOT USED - it was something Niall was working on, but doesn't work well with popup editors */
var FocusService = (function () {
    function FocusService() {
        this.destroyMethods = [];
        this.listeners = [];
    }
    FocusService.prototype.addListener = function (listener) {
        this.listeners.push(listener);
    };
    FocusService.prototype.removeListener = function (listener) {
        utils_1.Utils.removeFromArray(this.listeners, listener);
    };
    FocusService.prototype.init = function () {
        var focusListener = this.onFocus.bind(this);
        var eRootGui = this.gridCore.getRootGui();
        eRootGui.addEventListener('focus', focusListener, true);
        this.destroyMethods.push(function () {
            eRootGui.removeEventListener('focus', focusListener);
        });
    };
    FocusService.prototype.onFocus = function (focusEvent) {
        var gridCell = this.getCellForFocus(focusEvent);
        if (gridCell) {
            this.informListeners({ gridCell: gridCell });
        }
    };
    FocusService.prototype.getCellForFocus = function (focusEvent) {
        var column = null;
        var row = null;
        var floating = null;
        var that = this;
        var eTarget = focusEvent.target;
        while (eTarget) {
            checkRow(eTarget);
            checkColumn(eTarget);
            eTarget = eTarget.parentNode;
        }
        if (utils_1.Utils.exists(column) && utils_1.Utils.exists(row)) {
            var gridCell = new gridCell_1.GridCell({ rowIndex: row, floating: floating, column: column });
            return gridCell;
        }
        else {
            return null;
        }
        function checkRow(eTarget) {
            // match the column by checking a) it has a valid colId and b) it has the 'ag-cell' class
            var rowId = utils_1.Utils.getElementAttribute(eTarget, 'row');
            if (utils_1.Utils.exists(rowId) && utils_1.Utils.containsClass(eTarget, 'ag-row')) {
                if (rowId.indexOf('ft') === 0) {
                    floating = constants_1.Constants.FLOATING_TOP;
                    rowId = rowId.substr(3);
                }
                else if (rowId.indexOf('fb') === 0) {
                    floating = constants_1.Constants.FLOATING_BOTTOM;
                    rowId = rowId.substr(3);
                }
                else {
                    floating = null;
                }
                row = parseInt(rowId);
            }
        }
        function checkColumn(eTarget) {
            // match the column by checking a) it has a valid colId and b) it has the 'ag-cell' class
            var colId = utils_1.Utils.getElementAttribute(eTarget, 'colid');
            if (utils_1.Utils.exists(colId) && utils_1.Utils.containsClass(eTarget, 'ag-cell')) {
                var foundColumn = that.columnController.getGridColumn(colId);
                if (foundColumn) {
                    column = foundColumn;
                }
            }
        }
    };
    FocusService.prototype.informListeners = function (event) {
        this.listeners.forEach(function (listener) { return listener(event); });
    };
    FocusService.prototype.destroy = function () {
        this.destroyMethods.forEach(function (destroyMethod) { return destroyMethod(); });
    };
    __decorate([
        context_1.Autowired('gridCore'), 
        __metadata('design:type', gridCore_1.GridCore)
    ], FocusService.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], FocusService.prototype, "columnController", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], FocusService.prototype, "init", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], FocusService.prototype, "destroy", null);
    FocusService = __decorate([
        context_1.Bean('focusService'), 
        __metadata('design:paramtypes', [])
    ], FocusService);
    return FocusService;
}());
exports.FocusService = FocusService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/misc/methodNotImplementedException.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var MethodNotImplementedException = (function () {
    function MethodNotImplementedException() {
    }
    return MethodNotImplementedException;
}());
exports.MethodNotImplementedException = MethodNotImplementedException;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/autoWidthCalculator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var rowRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/rowRenderer.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var headerRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/headerRenderer.js");
var renderedHeaderCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/headerRendering/renderedHeaderCell.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var AutoWidthCalculator = (function () {
    function AutoWidthCalculator() {
    }
    // this is the trick: we create a dummy container and clone all the cells
    // into the dummy, then check the dummy's width. then destroy the dummy
    // as we don't need it any more.
    // drawback: only the cells visible on the screen are considered
    AutoWidthCalculator.prototype.getPreferredWidthForColumn = function (column) {
        var renderedHeaderCell = this.getHeaderCellForColumn(column);
        // cell isn't visible
        if (!renderedHeaderCell) {
            return -1;
        }
        var eDummyContainer = document.createElement('span');
        // position fixed, so it isn't restricted to the boundaries of the parent
        eDummyContainer.style.position = 'fixed';
        // we put the dummy into the body container, so it will inherit all the
        // css styles that the real cells are inheriting
        var eBodyContainer = this.gridPanel.getBodyContainer();
        eBodyContainer.appendChild(eDummyContainer);
        // get all the cells that are currently displayed (this only brings back
        // rendered cells, rows not rendered due to row visualisation will not be here)
        this.putRowCellsIntoDummyContainer(column, eDummyContainer);
        // also put header cell in
        // we only consider the lowest level cell, not the group cell. in 99% of the time, this
        // will be enough. if we consider groups, then it gets to complicated for what it's worth,
        // as the groups can span columns and this class only considers one column at a time.
        this.cloneItemIntoDummy(renderedHeaderCell.getGui(), eDummyContainer);
        // at this point, all the clones are lined up vertically with natural widths. the dummy
        // container will have a width wide enough just to fit the largest.
        var dummyContainerWidth = eDummyContainer.offsetWidth;
        // we are finished with the dummy container, so get rid of it
        eBodyContainer.removeChild(eDummyContainer);
        // we add padding as I found without it, the gui still put '...' after some of the texts
        var autoSizePadding = this.gridOptionsWrapper.getAutoSizePadding();
        if (typeof autoSizePadding !== 'number' || autoSizePadding < 0) {
            autoSizePadding = 4;
        }
        return dummyContainerWidth + autoSizePadding;
    };
    AutoWidthCalculator.prototype.getHeaderCellForColumn = function (column) {
        var renderedHeaderCell = null;
        // find the rendered header cell
        this.headerRenderer.forEachHeaderElement(function (headerElement) {
            if (headerElement instanceof renderedHeaderCell_1.RenderedHeaderCell) {
                var currentCell = headerElement;
                if (currentCell.getColumn() === column) {
                    renderedHeaderCell = currentCell;
                }
            }
        });
        return renderedHeaderCell;
    };
    AutoWidthCalculator.prototype.putRowCellsIntoDummyContainer = function (column, eDummyContainer) {
        var _this = this;
        var eOriginalCells = this.rowRenderer.getAllCellsForColumn(column);
        eOriginalCells.forEach(function (eCell, index) {
            _this.cloneItemIntoDummy(eCell, eDummyContainer);
        });
    };
    AutoWidthCalculator.prototype.cloneItemIntoDummy = function (eCell, eDummyContainer) {
        // make a deep clone of the cell
        var eCellClone = eCell.cloneNode(true);
        // the original has a fixed width, we remove this to allow the natural width based on content
        eCellClone.style.width = '';
        // the original has position = absolute, we need to remove this so it's positioned normally
        eCellClone.style.position = 'static';
        eCellClone.style.left = '';
        // we put the cell into a containing div, as otherwise the cells would just line up
        // on the same line, standard flow layout, by putting them into divs, they are laid
        // out one per line
        var eCloneParent = document.createElement('div');
        // table-row, so that each cell is on a row. i also tried display='block', but this
        // didn't work in IE
        eCloneParent.style.display = 'table-row';
        // the twig on the branch, the branch on the tree, the tree in the hole,
        // the hole in the bog, the bog in the clone, the clone in the parent,
        // the parent in the dummy, and the dummy down in the vall-e-ooo, OOOOOOOOO! Oh row the rattling bog....
        eCloneParent.appendChild(eCellClone);
        eDummyContainer.appendChild(eCloneParent);
    };
    __decorate([
        context_2.Autowired('rowRenderer'), 
        __metadata('design:type', rowRenderer_1.RowRenderer)
    ], AutoWidthCalculator.prototype, "rowRenderer", void 0);
    __decorate([
        context_2.Autowired('headerRenderer'), 
        __metadata('design:type', headerRenderer_1.HeaderRenderer)
    ], AutoWidthCalculator.prototype, "headerRenderer", void 0);
    __decorate([
        context_2.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], AutoWidthCalculator.prototype, "gridPanel", void 0);
    __decorate([
        context_2.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], AutoWidthCalculator.prototype, "gridOptionsWrapper", void 0);
    AutoWidthCalculator = __decorate([
        context_1.Bean('autoWidthCalculator'), 
        __metadata('design:paramtypes', [])
    ], AutoWidthCalculator);
    return AutoWidthCalculator;
}());
exports.AutoWidthCalculator = AutoWidthCalculator;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellEditorFactory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var textCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/textCellEditor.js");
var selectCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/selectCellEditor.js");
var popupEditorWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/popupEditorWrapper.js");
var popupTextCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/popupTextCellEditor.js");
var popupSelectCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/popupSelectCellEditor.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var largeTextCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/largeTextCellEditor.js");
var CellEditorFactory = (function () {
    function CellEditorFactory() {
        this.cellEditorMap = {};
    }
    CellEditorFactory.prototype.init = function () {
        this.cellEditorMap[CellEditorFactory.TEXT] = textCellEditor_1.TextCellEditor;
        this.cellEditorMap[CellEditorFactory.SELECT] = selectCellEditor_1.SelectCellEditor;
        this.cellEditorMap[CellEditorFactory.POPUP_TEXT] = popupTextCellEditor_1.PopupTextCellEditor;
        this.cellEditorMap[CellEditorFactory.POPUP_SELECT] = popupSelectCellEditor_1.PopupSelectCellEditor;
        this.cellEditorMap[CellEditorFactory.LARGE_TEXT] = largeTextCellEditor_1.LargeTextCellEditor;
    };
    CellEditorFactory.prototype.addCellEditor = function (key, cellEditor) {
        this.cellEditorMap[key] = cellEditor;
    };
    // private registerEditorsFromGridOptions(): void {
    //     var userProvidedCellEditors = this.gridOptionsWrapper.getCellEditors();
    //     _.iterateObject(userProvidedCellEditors, (key: string, cellEditor: {new(): ICellEditor})=> {
    //         this.addCellEditor(key, cellEditor);
    //     });
    // }
    CellEditorFactory.prototype.createCellEditor = function (key, params) {
        var CellEditorClass;
        if (utils_1.Utils.missing(key)) {
            CellEditorClass = this.cellEditorMap[CellEditorFactory.TEXT];
        }
        else if (typeof key === 'string') {
            CellEditorClass = this.cellEditorMap[key];
            if (utils_1.Utils.missing(CellEditorClass)) {
                console.warn('ag-Grid: unable to find cellEditor for key ' + key);
                CellEditorClass = this.cellEditorMap[CellEditorFactory.TEXT];
            }
        }
        else {
            CellEditorClass = key;
        }
        var cellEditor = new CellEditorClass();
        this.context.wireBean(cellEditor);
        // we have to call init first, otherwise when using the frameworks, the wrapper
        // classes won't be set up
        if (cellEditor.init) {
            cellEditor.init(params);
        }
        if (cellEditor.isPopup && cellEditor.isPopup()) {
            if (this.gridOptionsWrapper.isFullRowEdit()) {
                console.warn('ag-Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both ' +
                    '- either turn off fullRowEdit, or stop using popup editors.');
            }
            cellEditor = new popupEditorWrapper_1.PopupEditorWrapper(cellEditor);
            cellEditor.init(params);
        }
        return cellEditor;
    };
    CellEditorFactory.TEXT = 'text';
    CellEditorFactory.SELECT = 'select';
    CellEditorFactory.POPUP_TEXT = 'popupText';
    CellEditorFactory.POPUP_SELECT = 'popupSelect';
    CellEditorFactory.LARGE_TEXT = 'largeText';
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], CellEditorFactory.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], CellEditorFactory.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], CellEditorFactory.prototype, "init", null);
    CellEditorFactory = __decorate([
        context_1.Bean('cellEditorFactory'), 
        __metadata('design:paramtypes', [])
    ], CellEditorFactory);
    return CellEditorFactory;
}());
exports.CellEditorFactory = CellEditorFactory;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellEditors/largeTextCellEditor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var LargeTextCellEditor = (function (_super) {
    __extends(LargeTextCellEditor, _super);
    function LargeTextCellEditor() {
        _super.call(this, LargeTextCellEditor.TEMPLATE);
    }
    LargeTextCellEditor.prototype.init = function (params) {
        this.params = params;
        this.focusAfterAttached = params.cellStartedEdit;
        this.textarea = document.createElement("textarea");
        this.textarea.maxLength = params.maxLength ? params.maxLength : "200";
        this.textarea.cols = params.cols ? params.cols : "60";
        this.textarea.rows = params.rows ? params.rows : "10";
        if (utils_1.Utils.exists(params.value)) {
            this.textarea.value = params.value.toString();
        }
        this.getGui().querySelector('.ag-large-textarea').appendChild(this.textarea);
        this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
    };
    LargeTextCellEditor.prototype.onKeyDown = function (event) {
        var key = event.which || event.keyCode;
        if (key == constants_1.Constants.KEY_LEFT ||
            key == constants_1.Constants.KEY_UP ||
            key == constants_1.Constants.KEY_RIGHT ||
            key == constants_1.Constants.KEY_DOWN ||
            (event.shiftKey && key == constants_1.Constants.KEY_ENTER)) {
            event.stopPropagation();
        }
    };
    LargeTextCellEditor.prototype.afterGuiAttached = function () {
        if (this.focusAfterAttached) {
            this.textarea.focus();
        }
    };
    LargeTextCellEditor.prototype.getValue = function () {
        return this.textarea.value;
    };
    LargeTextCellEditor.prototype.isPopup = function () {
        return true;
    };
    LargeTextCellEditor.TEMPLATE = 
    // tab index is needed so we can focus, which is needed for keyboard events
    '<div class="ag-large-text" tabindex="0">' +
        '<div class="ag-large-textarea"></div>' +
        '</div>';
    return LargeTextCellEditor;
}(component_1.Component));
exports.LargeTextCellEditor = LargeTextCellEditor;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellEditors/popupEditorWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var PopupEditorWrapper = (function (_super) {
    __extends(PopupEditorWrapper, _super);
    function PopupEditorWrapper(cellEditor) {
        _super.call(this, '<div class="ag-popup-editor"/>');
        this.getGuiCalledOnChild = false;
        this.cellEditor = cellEditor;
        this.addDestroyFunc(function () { return cellEditor.destroy(); });
        this.addDestroyableEventListener(
        // this needs to be 'super' and not 'this' as if we call 'this',
        // it ends up called 'getGui()' on the child before 'init' was called,
        // which is not good
        _super.prototype.getGui.call(this), 'keydown', this.onKeyDown.bind(this));
    }
    PopupEditorWrapper.prototype.onKeyDown = function (event) {
        this.params.onKeyDown(event);
    };
    PopupEditorWrapper.prototype.getGui = function () {
        // we call getGui() on child here (rather than in the constructor)
        // as we should wait for 'init' to be called on child first.
        if (!this.getGuiCalledOnChild) {
            this.appendChild(this.cellEditor.getGui());
            this.getGuiCalledOnChild = true;
        }
        return _super.prototype.getGui.call(this);
    };
    PopupEditorWrapper.prototype.init = function (params) {
        this.params = params;
    };
    PopupEditorWrapper.prototype.afterGuiAttached = function () {
        if (this.cellEditor.afterGuiAttached) {
            this.cellEditor.afterGuiAttached();
        }
    };
    PopupEditorWrapper.prototype.getValue = function () {
        return this.cellEditor.getValue();
    };
    PopupEditorWrapper.prototype.isPopup = function () {
        return true;
    };
    PopupEditorWrapper.prototype.isCancelBeforeStart = function () {
        if (this.cellEditor.isCancelBeforeStart) {
            return this.cellEditor.isCancelBeforeStart();
        }
    };
    PopupEditorWrapper.prototype.isCancelAfterEnd = function () {
        if (this.cellEditor.isCancelAfterEnd) {
            return this.cellEditor.isCancelAfterEnd();
        }
    };
    PopupEditorWrapper.prototype.focusIn = function () {
        if (this.cellEditor.focusIn) {
            this.cellEditor.focusIn();
        }
    };
    PopupEditorWrapper.prototype.focusOut = function () {
        if (this.cellEditor.focusOut) {
            this.cellEditor.focusOut();
        }
    };
    return PopupEditorWrapper;
}(component_1.Component));
exports.PopupEditorWrapper = PopupEditorWrapper;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellEditors/popupSelectCellEditor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var selectCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/selectCellEditor.js");
var PopupSelectCellEditor = (function (_super) {
    __extends(PopupSelectCellEditor, _super);
    function PopupSelectCellEditor() {
        _super.apply(this, arguments);
    }
    PopupSelectCellEditor.prototype.isPopup = function () {
        return true;
    };
    return PopupSelectCellEditor;
}(selectCellEditor_1.SelectCellEditor));
exports.PopupSelectCellEditor = PopupSelectCellEditor;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellEditors/popupTextCellEditor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var textCellEditor_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditors/textCellEditor.js");
var PopupTextCellEditor = (function (_super) {
    __extends(PopupTextCellEditor, _super);
    function PopupTextCellEditor() {
        _super.apply(this, arguments);
    }
    PopupTextCellEditor.prototype.isPopup = function () {
        return true;
    };
    return PopupTextCellEditor;
}(textCellEditor_1.TextCellEditor));
exports.PopupTextCellEditor = PopupTextCellEditor;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellEditors/selectCellEditor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var SelectCellEditor = (function (_super) {
    __extends(SelectCellEditor, _super);
    function SelectCellEditor() {
        _super.call(this, '<div class="ag-cell-edit-input"><select class="ag-cell-edit-input"/></div>');
        this.eSelect = this.getGui().querySelector('select');
    }
    SelectCellEditor.prototype.init = function (params) {
        var _this = this;
        this.focusAfterAttached = params.cellStartedEdit;
        if (utils_1.Utils.missing(params.values)) {
            console.log('ag-Grid: no values found for select cellEditor');
            return;
        }
        params.values.forEach(function (value) {
            var option = document.createElement('option');
            option.value = value;
            option.text = value;
            if (params.value === value) {
                option.selected = true;
            }
            _this.eSelect.appendChild(option);
        });
        this.addDestroyableEventListener(this.eSelect, 'change', function () { return params.stopEditing(); });
        this.addDestroyableEventListener(this.eSelect, 'keydown', function (event) {
            var isNavigationKey = event.keyCode === constants_1.Constants.KEY_UP || event.keyCode === constants_1.Constants.KEY_DOWN;
            if (isNavigationKey) {
                event.stopPropagation();
            }
        });
        this.addDestroyableEventListener(this.eSelect, 'mousedown', function (event) {
            event.stopPropagation();
        });
    };
    SelectCellEditor.prototype.afterGuiAttached = function () {
        if (this.focusAfterAttached) {
            this.eSelect.focus();
        }
    };
    SelectCellEditor.prototype.focusIn = function () {
        this.eSelect.focus();
    };
    SelectCellEditor.prototype.getValue = function () {
        return this.eSelect.value;
    };
    return SelectCellEditor;
}(component_1.Component));
exports.SelectCellEditor = SelectCellEditor;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellEditors/textCellEditor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var TextCellEditor = (function (_super) {
    __extends(TextCellEditor, _super);
    function TextCellEditor() {
        _super.call(this, TextCellEditor.TEMPLATE);
    }
    TextCellEditor.prototype.init = function (params) {
        var eInput = this.getGui();
        var startValue;
        // cellStartedEdit is only false if we are doing fullRow editing
        if (params.cellStartedEdit) {
            this.focusAfterAttached = true;
            var keyPressBackspaceOrDelete = params.keyPress === constants_1.Constants.KEY_BACKSPACE
                || params.keyPress === constants_1.Constants.KEY_DELETE;
            if (keyPressBackspaceOrDelete) {
                startValue = '';
            }
            else if (params.charPress) {
                startValue = params.charPress;
            }
            else {
                startValue = params.value;
                if (params.keyPress !== constants_1.Constants.KEY_F2) {
                    this.highlightAllOnFocus = true;
                }
            }
        }
        else {
            this.focusAfterAttached = false;
            startValue = params.value;
        }
        if (utils_1.Utils.exists(startValue)) {
            eInput.value = startValue;
        }
        this.addDestroyableEventListener(eInput, 'keydown', function (event) {
            var isNavigationKey = event.keyCode === constants_1.Constants.KEY_LEFT || event.keyCode === constants_1.Constants.KEY_RIGHT;
            if (isNavigationKey) {
                event.stopPropagation();
            }
        });
    };
    TextCellEditor.prototype.afterGuiAttached = function () {
        if (!this.focusAfterAttached) {
            return;
        }
        var eInput = this.getGui();
        eInput.focus();
        if (this.highlightAllOnFocus) {
            eInput.select();
        }
        else {
            // when we started editing, we want the carot at the end, not the start.
            // this comes into play in two scenarios: a) when user hits F2 and b)
            // when user hits a printable character, then on IE (and only IE) the carot
            // was placed after the first character, thus 'apply' would end up as 'pplea'
            var length = eInput.value ? eInput.value.length : 0;
            if (length > 0) {
                eInput.setSelectionRange(length, length);
            }
        }
    };
    // gets called when tabbing trough cells and in full row edit mode
    TextCellEditor.prototype.focusIn = function () {
        var eInput = this.getGui();
        eInput.focus();
        eInput.select();
    };
    TextCellEditor.prototype.getValue = function () {
        var eInput = this.getGui();
        return eInput.value;
    };
    TextCellEditor.TEMPLATE = '<input class="ag-cell-edit-input" type="text"/>';
    return TextCellEditor;
}(component_1.Component));
exports.TextCellEditor = TextCellEditor;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellRendererFactory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var expressionService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/expressionService.js");
var animateSlideCellRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRenderers/animateSlideCellRenderer.js");
var animateShowChangeCellRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRenderers/animateShowChangeCellRenderer.js");
var groupCellRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRenderers/groupCellRenderer.js");
var CellRendererFactory = (function () {
    function CellRendererFactory() {
        this.cellRendererMap = {};
    }
    CellRendererFactory.prototype.init = function () {
        this.cellRendererMap[CellRendererFactory.ANIMATE_SLIDE] = animateSlideCellRenderer_1.AnimateSlideCellRenderer;
        this.cellRendererMap[CellRendererFactory.ANIMATE_SHOW_CHANGE] = animateShowChangeCellRenderer_1.AnimateShowChangeCellRenderer;
        this.cellRendererMap[CellRendererFactory.GROUP] = groupCellRenderer_1.GroupCellRenderer;
        // this.registerRenderersFromGridOptions();
    };
    // private registerRenderersFromGridOptions(): void {
    //     var userProvidedCellRenderers = this.gridOptionsWrapper.getCellRenderers();
    //     _.iterateObject(userProvidedCellRenderers, (key: string, cellRenderer: {new(): ICellRenderer} | ICellRendererFunc)=> {
    //         this.addCellRenderer(key, cellRenderer);
    //     });
    // }
    CellRendererFactory.prototype.addCellRenderer = function (key, cellRenderer) {
        this.cellRendererMap[key] = cellRenderer;
    };
    CellRendererFactory.prototype.getCellRenderer = function (key) {
        var result = this.cellRendererMap[key];
        if (utils_1.Utils.missing(result)) {
            console.warn('ag-Grid: unable to find cellRenderer for key ' + key);
            return null;
        }
        return result;
    };
    CellRendererFactory.ANIMATE_SLIDE = 'animateSlide';
    CellRendererFactory.ANIMATE_SHOW_CHANGE = 'animateShowChange';
    CellRendererFactory.GROUP = 'group';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], CellRendererFactory.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'), 
        __metadata('design:type', expressionService_1.ExpressionService)
    ], CellRendererFactory.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], CellRendererFactory.prototype, "eventService", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], CellRendererFactory.prototype, "init", null);
    CellRendererFactory = __decorate([
        context_1.Bean('cellRendererFactory'), 
        __metadata('design:paramtypes', [])
    ], CellRendererFactory);
    return CellRendererFactory;
}());
exports.CellRendererFactory = CellRendererFactory;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellRendererService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var cellRendererFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererFactory.js");
/** Class to use a cellRenderer. */
var CellRendererService = (function () {
    function CellRendererService() {
    }
    /** Uses a cellRenderer, and returns the cellRenderer object if it is a class implementing ICellRenderer.
     * @cellRendererKey: The cellRenderer to use. Can be: a) a class that we call 'new' on b) a function we call
     *                   or c) a string that we use to look up the cellRenderer.
     * @params: The params to pass to the cell renderer if it's a function or a class.
     * @eTarget: The DOM element we will put the results of the html element into *
     * @return: If options a, it returns the created class instance */
    CellRendererService.prototype.useCellRenderer = function (cellRendererKey, eTarget, params) {
        var cellRenderer = this.lookUpCellRenderer(cellRendererKey);
        if (utils_1.Utils.missing(cellRenderer)) {
            // this is a bug in users config, they specified a cellRenderer that doesn't exist,
            // the factory already printed to console, so here we just skip
            return;
        }
        var resultFromRenderer;
        var iCellRendererInstance = null;
        this.checkForDeprecatedItems(cellRenderer);
        // we check if the class has the 'getGui' method to know if it's a component
        var rendererIsAComponent = this.doesImplementICellRenderer(cellRenderer);
        // if it's a component, we create and initialise it
        if (rendererIsAComponent) {
            var CellRendererClass = cellRenderer;
            iCellRendererInstance = new CellRendererClass();
            this.context.wireBean(iCellRendererInstance);
            if (iCellRendererInstance.init) {
                iCellRendererInstance.init(params);
            }
            resultFromRenderer = iCellRendererInstance.getGui();
        }
        else {
            // otherwise it's a function, so we just use it
            var cellRendererFunc = cellRenderer;
            resultFromRenderer = cellRendererFunc(params);
        }
        if (resultFromRenderer === null || resultFromRenderer === '') {
            return;
        }
        if (utils_1.Utils.isNodeOrElement(resultFromRenderer)) {
            // a dom node or element was returned, so add child
            eTarget.appendChild(resultFromRenderer);
        }
        else {
            // otherwise assume it was html, so just insert
            eTarget.innerHTML = resultFromRenderer;
        }
        return iCellRendererInstance;
    };
    CellRendererService.prototype.checkForDeprecatedItems = function (cellRenderer) {
        if (cellRenderer && cellRenderer.renderer) {
            console.warn('ag-grid: colDef.cellRenderer should not be an object, it should be a string, function or class. this ' +
                'changed in v4.1.x, please check the documentation on Cell Rendering, or if you are doing grouping, look at the grouping examples.');
        }
    };
    CellRendererService.prototype.doesImplementICellRenderer = function (cellRenderer) {
        // see if the class has a prototype that defines a getGui method. this is very rough,
        // but javascript doesn't have types, so is the only way!
        return cellRenderer.prototype && 'getGui' in cellRenderer.prototype;
    };
    CellRendererService.prototype.lookUpCellRenderer = function (cellRendererKey) {
        if (typeof cellRendererKey === 'string') {
            return this.cellRendererFactory.getCellRenderer(cellRendererKey);
        }
        else {
            return cellRendererKey;
        }
    };
    __decorate([
        context_1.Autowired('cellRendererFactory'), 
        __metadata('design:type', cellRendererFactory_1.CellRendererFactory)
    ], CellRendererService.prototype, "cellRendererFactory", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], CellRendererService.prototype, "context", void 0);
    CellRendererService = __decorate([
        context_1.Bean('cellRendererService'), 
        __metadata('design:paramtypes', [])
    ], CellRendererService);
    return CellRendererService;
}());
exports.CellRendererService = CellRendererService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellRenderers/animateShowChangeCellRenderer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var ARROW_UP = '&#65514;';
var ARROW_DOWN = '&#65516;';
var AnimateShowChangeCellRenderer = (function (_super) {
    __extends(AnimateShowChangeCellRenderer, _super);
    function AnimateShowChangeCellRenderer() {
        _super.call(this, AnimateShowChangeCellRenderer.TEMPLATE);
        this.refreshCount = 0;
    }
    AnimateShowChangeCellRenderer.prototype.init = function (params) {
        this.params = params;
        this.eValue = this.queryForHtmlElement('.ag-value-change-value');
        this.eDelta = this.queryForHtmlElement('.ag-value-change-delta');
        this.refresh(params);
    };
    AnimateShowChangeCellRenderer.prototype.showDelta = function (params, delta) {
        var absDelta = Math.abs(delta);
        var valueFormatted = params.formatValue(absDelta);
        var valueToUse = utils_1.Utils.exists(valueFormatted) ? valueFormatted : absDelta;
        var deltaUp = (delta >= 0);
        if (deltaUp) {
            this.eDelta.innerHTML = ARROW_UP + valueToUse;
        }
        else {
            // because negative, use ABS to remove sign
            this.eDelta.innerHTML = ARROW_DOWN + valueToUse;
        }
        // class makes it green (in ag-fresh)
        utils_1.Utils.addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-up', deltaUp);
        // class makes it red (in ag-fresh)
        utils_1.Utils.addOrRemoveCssClass(this.eDelta, 'ag-value-change-delta-down', !deltaUp);
    };
    AnimateShowChangeCellRenderer.prototype.setTimerToRemoveDelta = function () {
        var _this = this;
        // the refreshCount makes sure that if the value updates again while
        // the below timer is waiting, then the below timer will realise it
        // is not the most recent and will not try to remove the delta value.
        this.refreshCount++;
        var refreshCountCopy = this.refreshCount;
        setTimeout(function () {
            if (refreshCountCopy === _this.refreshCount) {
                _this.hideDeltaValue();
            }
        }, 2000);
    };
    AnimateShowChangeCellRenderer.prototype.hideDeltaValue = function () {
        utils_1.Utils.removeCssClass(this.eValue, 'ag-value-change-value-highlight');
        this.eDelta.innerHTML = '';
    };
    AnimateShowChangeCellRenderer.prototype.refresh = function (params) {
        var value = params.value;
        if (value === this.lastValue) {
            return;
        }
        if (utils_1.Utils.exists(params.valueFormatted)) {
            this.eValue.innerHTML = params.valueFormatted;
        }
        else if (utils_1.Utils.exists(params.value)) {
            this.eValue.innerHTML = value;
        }
        else {
            this.eValue.innerHTML = '';
        }
        if (typeof value === 'number' && typeof this.lastValue === 'number') {
            var delta = value - this.lastValue;
            this.showDelta(params, delta);
        }
        // highlight the current value, but only if it's not new, otherwise it
        // would get highlighted first time the value is shown
        if (this.lastValue) {
            utils_1.Utils.addCssClass(this.eValue, 'ag-value-change-value-highlight');
        }
        this.setTimerToRemoveDelta();
        this.lastValue = value;
    };
    AnimateShowChangeCellRenderer.TEMPLATE = '<span>' +
        '<span class="ag-value-change-delta"></span>' +
        '<span class="ag-value-change-value"></span>' +
        '</span>';
    return AnimateShowChangeCellRenderer;
}(component_1.Component));
exports.AnimateShowChangeCellRenderer = AnimateShowChangeCellRenderer;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellRenderers/animateSlideCellRenderer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var AnimateSlideCellRenderer = (function (_super) {
    __extends(AnimateSlideCellRenderer, _super);
    function AnimateSlideCellRenderer() {
        _super.call(this, AnimateSlideCellRenderer.TEMPLATE);
        this.refreshCount = 0;
        this.eCurrent = this.queryForHtmlElement('.ag-value-slide-current');
    }
    AnimateSlideCellRenderer.prototype.init = function (params) {
        this.params = params;
        this.refresh(params);
    };
    AnimateSlideCellRenderer.prototype.addSlideAnimation = function () {
        var _this = this;
        this.refreshCount++;
        // below we keep checking this, and stop working on the animation
        // if it no longer matches - this means another animation has started
        // and this one is stale.
        var refreshCountCopy = this.refreshCount;
        // if old animation, remove it
        if (this.ePrevious) {
            this.getGui().removeChild(this.ePrevious);
        }
        this.ePrevious = utils_1.Utils.loadTemplate('<span class="ag-value-slide-previous ag-value-slide-out"></span>');
        this.ePrevious.innerHTML = this.eCurrent.innerHTML;
        this.getGui().insertBefore(this.ePrevious, this.eCurrent);
        // having timeout of 0 allows use to skip to the next css turn,
        // so we know the previous css classes have been applied. so the
        // complex set of setTimeout below creates the animation
        setTimeout(function () {
            if (refreshCountCopy !== _this.refreshCount) {
                return;
            }
            utils_1.Utils.addCssClass(_this.ePrevious, 'ag-value-slide-out-end');
        }, 50);
        setTimeout(function () {
            if (refreshCountCopy !== _this.refreshCount) {
                return;
            }
            _this.getGui().removeChild(_this.ePrevious);
            _this.ePrevious = null;
        }, 3000);
    };
    AnimateSlideCellRenderer.prototype.refresh = function (params) {
        var value = params.value;
        if (utils_1.Utils.missing(value)) {
            value = '';
        }
        if (value === this.lastValue) {
            return;
        }
        this.addSlideAnimation();
        this.lastValue = value;
        if (utils_1.Utils.exists(params.valueFormatted)) {
            this.eCurrent.innerHTML = params.valueFormatted;
        }
        else if (utils_1.Utils.exists(params.value)) {
            this.eCurrent.innerHTML = value;
        }
        else {
            this.eCurrent.innerHTML = '';
        }
    };
    AnimateSlideCellRenderer.TEMPLATE = '<span>' +
        '<span class="ag-value-slide-current"></span>' +
        '</span>';
    return AnimateSlideCellRenderer;
}(component_1.Component));
exports.AnimateSlideCellRenderer = AnimateSlideCellRenderer;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/cellRenderers/groupCellRenderer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var svgFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/svgFactory.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var expressionService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/expressionService.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var cellRendererService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererService.js");
var valueFormatterService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/valueFormatterService.js");
var checkboxSelectionComponent_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/checkboxSelectionComponent.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var svgFactory = svgFactory_1.SvgFactory.getInstance();
var GroupCellRenderer = (function (_super) {
    __extends(GroupCellRenderer, _super);
    function GroupCellRenderer() {
        _super.call(this, GroupCellRenderer.TEMPLATE);
        this.eExpanded = this.queryForHtmlElement('.ag-group-expanded');
        this.eContracted = this.queryForHtmlElement('.ag-group-contracted');
        this.eCheckbox = this.queryForHtmlElement('.ag-group-checkbox');
        this.eValue = this.queryForHtmlElement('.ag-group-value');
        this.eChildCount = this.queryForHtmlElement('.ag-group-child-count');
    }
    GroupCellRenderer.prototype.init = function (params) {
        this.rowNode = params.node;
        this.rowIndex = params.rowIndex;
        this.gridApi = params.api;
        if (this.isLeaveCellBlank(params)) {
            return;
        }
        this.addExpandAndContract(params.eGridCell);
        this.addCheckboxIfNeeded(params);
        this.addValueElement(params);
        this.addPadding(params);
    };
    // if we are doing embedded full width rows, we only show the renderer when
    // in the body, or if pinning in the pinned section, or if pinning and RTL,
    // in the right section. otherwise we would have the cell repeated in each section.
    GroupCellRenderer.prototype.isLeaveCellBlank = function (params) {
        if (this.gridOptionsWrapper.isEmbedFullWidthRows()) {
            var pinnedLeftCell = params.pinned === column_1.Column.PINNED_LEFT;
            var pinnedRightCell = params.pinned === column_1.Column.PINNED_RIGHT;
            var bodyCell = !pinnedLeftCell && !pinnedRightCell;
            if (this.gridOptionsWrapper.isEnableRtl()) {
                if (this.columnController.isPinningLeft()) {
                    return !pinnedRightCell;
                }
                else {
                    return !bodyCell;
                }
            }
            else {
                if (this.columnController.isPinningLeft()) {
                    return !pinnedLeftCell;
                }
                else {
                    return !bodyCell;
                }
            }
        }
    };
    GroupCellRenderer.prototype.addPadding = function (params) {
        // only do this if an indent - as this overwrites the padding that
        // the theme set, which will make things look 'not aligned' for the
        // first group level.
        var node = this.rowNode;
        var suppressPadding = params.suppressPadding;
        if (!suppressPadding && (node.footer || node.level > 0)) {
            var paddingFactor;
            if (params.colDef && params.padding >= 0) {
                paddingFactor = params.padding;
            }
            else {
                paddingFactor = 10;
            }
            var paddingPx = node.level * paddingFactor;
            var reducedLeafNode = this.columnController.isPivotMode() && this.rowNode.leafGroup;
            if (node.footer) {
                paddingPx += 15;
            }
            else if (!node.isExpandable() || reducedLeafNode) {
                paddingPx += 10;
            }
            if (this.gridOptionsWrapper.isEnableRtl()) {
                // if doing rtl, padding is on the right
                this.getGui().style.paddingRight = paddingPx + 'px';
            }
            else {
                // otherwise it is on the left
                this.getGui().style.paddingLeft = paddingPx + 'px';
            }
        }
    };
    GroupCellRenderer.prototype.addValueElement = function (params) {
        if (params.innerRenderer) {
            this.createFromInnerRenderer(params);
        }
        else if (this.rowNode.footer) {
            this.createFooterCell(params);
        }
        else if (this.rowNode.group) {
            this.createGroupCell(params);
            this.addChildCount(params);
        }
        else {
            this.createLeafCell(params);
        }
    };
    GroupCellRenderer.prototype.createFromInnerRenderer = function (params) {
        var innerComponent = this.cellRendererService.useCellRenderer(params.innerRenderer, this.eValue, params);
        this.addDestroyFunc(function () {
            if (innerComponent && innerComponent.destroy) {
                innerComponent.destroy();
            }
        });
    };
    GroupCellRenderer.prototype.createFooterCell = function (params) {
        var footerValue;
        var groupName = this.getGroupName(params);
        if (params.footerValueGetter) {
            var footerValueGetter = params.footerValueGetter;
            // params is same as we were given, except we set the value as the item to display
            var paramsClone = utils_1.Utils.cloneObject(params);
            paramsClone.value = groupName;
            if (typeof footerValueGetter === 'function') {
                footerValue = footerValueGetter(paramsClone);
            }
            else if (typeof footerValueGetter === 'string') {
                footerValue = this.expressionService.evaluate(footerValueGetter, paramsClone);
            }
            else {
                console.warn('ag-Grid: footerValueGetter should be either a function or a string (expression)');
            }
        }
        else {
            footerValue = 'Total ' + groupName;
        }
        this.eValue.innerHTML = footerValue;
    };
    GroupCellRenderer.prototype.createGroupCell = function (params) {
        // pull out the column that the grouping is on
        var rowGroupColumns = params.columnApi.getRowGroupColumns();
        // if we are using in memory grid grouping, then we try to look up the column that
        // we did the grouping on. however if it is not possible (happens when user provides
        // the data already grouped) then we just the current col, ie use cellrenderer of current col
        var columnOfGroupedCol = rowGroupColumns[params.node.rowGroupIndex];
        if (utils_1.Utils.missing(columnOfGroupedCol)) {
            columnOfGroupedCol = params.column;
        }
        var colDefOfGroupedCol = columnOfGroupedCol.getColDef();
        var groupName = this.getGroupName(params);
        var valueFormatted = this.valueFormatterService.formatValue(columnOfGroupedCol, params.node, params.scope, this.rowIndex, groupName);
        // reuse the params but change the value
        if (colDefOfGroupedCol && typeof colDefOfGroupedCol.cellRenderer === 'function') {
            // reuse the params but change the value
            params.value = groupName;
            params.valueFormatted = valueFormatted;
            // because we are talking about the different column to the original, any user provided params
            // are for the wrong column, so need to copy them in again.
            if (colDefOfGroupedCol.cellRendererParams) {
                utils_1.Utils.assign(params, colDefOfGroupedCol.cellRendererParams);
            }
            this.cellRendererService.useCellRenderer(colDefOfGroupedCol.cellRenderer, this.eValue, params);
        }
        else {
            var valueToRender = utils_1.Utils.exists(valueFormatted) ? valueFormatted : groupName;
            if (utils_1.Utils.exists(valueToRender) && valueToRender !== '') {
                this.eValue.appendChild(document.createTextNode(valueToRender));
            }
        }
    };
    GroupCellRenderer.prototype.addChildCount = function (params) {
        var _this = this;
        // only include the child count if it's included, eg if user doing custom aggregation,
        // then this could be left out, or set to -1, ie no child count
        if (params.suppressCount) {
            return;
        }
        var listener = function () {
            if (params.node.allChildrenCount >= 0) {
                _this.eChildCount.innerHTML = "(" + params.node.allChildrenCount + ")";
            }
            else {
                _this.eChildCount.innerHTML = '';
            }
        };
        // filtering changes the child count, so need to cater for it
        this.addDestroyableEventListener(this.eventService, events_1.Events.EVENT_AFTER_FILTER_CHANGED, listener);
        listener();
    };
    GroupCellRenderer.prototype.getGroupName = function (params) {
        if (params.keyMap && typeof params.keyMap === 'object') {
            var valueFromMap = params.keyMap[params.node.key];
            if (valueFromMap) {
                return valueFromMap;
            }
            else {
                return params.node.key;
            }
        }
        else {
            return params.node.key;
        }
    };
    GroupCellRenderer.prototype.createLeafCell = function (params) {
        if (utils_1.Utils.exists(params.value)) {
            this.eValue.innerHTML = params.value;
        }
    };
    GroupCellRenderer.prototype.isUserWantsSelected = function (params) {
        if (typeof params.checkbox === 'function') {
            return params.checkbox(params);
        }
        else {
            return params.checkbox === true;
        }
    };
    GroupCellRenderer.prototype.addCheckboxIfNeeded = function (params) {
        var checkboxNeeded = this.isUserWantsSelected(params)
            && !this.rowNode.footer
            && !this.rowNode.floating
            && !this.rowNode.flower;
        if (checkboxNeeded) {
            var cbSelectionComponent = new checkboxSelectionComponent_1.CheckboxSelectionComponent();
            this.context.wireBean(cbSelectionComponent);
            cbSelectionComponent.init({ rowNode: this.rowNode });
            this.eCheckbox.appendChild(cbSelectionComponent.getGui());
            this.addDestroyFunc(function () { return cbSelectionComponent.destroy(); });
        }
    };
    GroupCellRenderer.prototype.addExpandAndContract = function (eGroupCell) {
        var eExpandedIcon = utils_1.Utils.createIconNoSpan('groupExpanded', this.gridOptionsWrapper, null, svgFactory.createGroupContractedIcon);
        var eContractedIcon = utils_1.Utils.createIconNoSpan('groupContracted', this.gridOptionsWrapper, null, svgFactory.createGroupExpandedIcon);
        this.eExpanded.appendChild(eExpandedIcon);
        this.eContracted.appendChild(eContractedIcon);
        this.addDestroyableEventListener(this.eExpanded, 'click', this.onExpandOrContract.bind(this));
        this.addDestroyableEventListener(this.eContracted, 'click', this.onExpandOrContract.bind(this));
        // if editing groups, then double click is to start editing
        if (!this.gridOptionsWrapper.isEnableGroupEdit()) {
            this.addDestroyableEventListener(eGroupCell, 'dblclick', this.onExpandOrContract.bind(this));
        }
        // expand / contract as the user hits enter
        this.addDestroyableEventListener(eGroupCell, 'keydown', this.onKeyDown.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this));
        this.showExpandAndContractIcons();
    };
    GroupCellRenderer.prototype.onKeyDown = function (event) {
        if (utils_1.Utils.isKeyPressed(event, constants_1.Constants.KEY_ENTER)) {
            this.onExpandOrContract();
            event.preventDefault();
        }
    };
    GroupCellRenderer.prototype.onExpandOrContract = function () {
        this.rowNode.setExpanded(!this.rowNode.expanded);
        if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
            this.gridApi.refreshRows([this.rowNode]);
        }
    };
    GroupCellRenderer.prototype.showExpandAndContractIcons = function () {
        var reducedLeafNode = this.columnController.isPivotMode() && this.rowNode.leafGroup;
        var expandable = this.rowNode.isExpandable() && !this.rowNode.footer && !reducedLeafNode;
        if (expandable) {
            // if expandable, show one based on expand state
            utils_1.Utils.setVisible(this.eExpanded, this.rowNode.expanded);
            utils_1.Utils.setVisible(this.eContracted, !this.rowNode.expanded);
        }
        else {
            // it not expandable, show neither
            utils_1.Utils.setVisible(this.eExpanded, false);
            utils_1.Utils.setVisible(this.eContracted, false);
        }
    };
    GroupCellRenderer.TEMPLATE = '<span>' +
        '<span class="ag-group-expanded"></span>' +
        '<span class="ag-group-contracted"></span>' +
        '<span class="ag-group-checkbox"></span>' +
        '<span class="ag-group-value"></span>' +
        '<span class="ag-group-child-count"></span>' +
        '</span>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], GroupCellRenderer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'), 
        __metadata('design:type', expressionService_1.ExpressionService)
    ], GroupCellRenderer.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], GroupCellRenderer.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('cellRendererService'), 
        __metadata('design:type', cellRendererService_1.CellRendererService)
    ], GroupCellRenderer.prototype, "cellRendererService", void 0);
    __decorate([
        context_1.Autowired('valueFormatterService'), 
        __metadata('design:type', valueFormatterService_1.ValueFormatterService)
    ], GroupCellRenderer.prototype, "valueFormatterService", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], GroupCellRenderer.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], GroupCellRenderer.prototype, "columnController", void 0);
    return GroupCellRenderer;
}(component_1.Component));
exports.GroupCellRenderer = GroupCellRenderer;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/checkboxSelectionComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var svgFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/svgFactory.js");
var svgFactory = svgFactory_1.SvgFactory.getInstance();
var CheckboxSelectionComponent = (function (_super) {
    __extends(CheckboxSelectionComponent, _super);
    function CheckboxSelectionComponent() {
        _super.call(this, "<span class=\"ag-selection-checkbox\"/>");
    }
    CheckboxSelectionComponent.prototype.createAndAddIcons = function () {
        this.eCheckedIcon = utils_1.Utils.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, null, svgFactory.createCheckboxCheckedIcon);
        this.eUncheckedIcon = utils_1.Utils.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, null, svgFactory.createCheckboxUncheckedIcon);
        this.eIndeterminateIcon = utils_1.Utils.createIconNoSpan('checkboxIndeterminate', this.gridOptionsWrapper, null, svgFactory.createCheckboxIndeterminateIcon);
        var eGui = this.getGui();
        eGui.appendChild(this.eCheckedIcon);
        eGui.appendChild(this.eUncheckedIcon);
        eGui.appendChild(this.eIndeterminateIcon);
    };
    CheckboxSelectionComponent.prototype.onSelectionChanged = function () {
        var state = this.rowNode.isSelected();
        utils_1.Utils.setVisible(this.eCheckedIcon, state === true);
        utils_1.Utils.setVisible(this.eUncheckedIcon, state === false);
        utils_1.Utils.setVisible(this.eIndeterminateIcon, typeof state !== 'boolean');
    };
    CheckboxSelectionComponent.prototype.onCheckedClicked = function () {
        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
        var updatedCount = this.rowNode.setSelectedParams({ newValue: false, groupSelectsFiltered: groupSelectsFiltered });
        return updatedCount;
    };
    CheckboxSelectionComponent.prototype.onUncheckedClicked = function (event) {
        var groupSelectsFiltered = this.gridOptionsWrapper.isGroupSelectsFiltered();
        var updatedCount = this.rowNode.setSelectedParams({ newValue: true, rangeSelect: event.shiftKey, groupSelectsFiltered: groupSelectsFiltered });
        return updatedCount;
    };
    CheckboxSelectionComponent.prototype.onIndeterminateClicked = function (event) {
        var result = this.onUncheckedClicked(event);
        if (result === 0) {
            this.onCheckedClicked();
        }
    };
    CheckboxSelectionComponent.prototype.init = function (params) {
        this.createAndAddIcons();
        this.rowNode = params.rowNode;
        this.onSelectionChanged();
        // we don't want the row clicked event to fire when selecting the checkbox, otherwise the row
        // would possibly get selected twice
        this.addGuiEventListener('click', function (event) { return event.stopPropagation(); });
        // likewise we don't want double click on this icon to open a group
        this.addGuiEventListener('dblclick', function (event) { return event.stopPropagation(); });
        this.addDestroyableEventListener(this.eCheckedIcon, 'click', this.onCheckedClicked.bind(this));
        this.addDestroyableEventListener(this.eUncheckedIcon, 'click', this.onUncheckedClicked.bind(this));
        this.addDestroyableEventListener(this.eIndeterminateIcon, 'click', this.onIndeterminateClicked.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this));
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], CheckboxSelectionComponent.prototype, "gridOptionsWrapper", void 0);
    return CheckboxSelectionComponent;
}(component_1.Component));
exports.CheckboxSelectionComponent = CheckboxSelectionComponent;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/features/setLeftFeature.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var beanStub_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/beanStub.js");
var SetLeftFeature = (function (_super) {
    __extends(SetLeftFeature, _super);
    function SetLeftFeature(columnOrGroup, eCell) {
        _super.call(this);
        this.columnOrGroup = columnOrGroup;
        this.eCell = eCell;
        this.init();
    }
    SetLeftFeature.prototype.init = function () {
        this.addDestroyableEventListener(this.columnOrGroup, column_1.Column.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
        this.onLeftChanged();
    };
    SetLeftFeature.prototype.onLeftChanged = function () {
        var newLeft = this.columnOrGroup.getLeft();
        if (utils_1.Utils.exists(newLeft)) {
            this.eCell.style.left = this.columnOrGroup.getLeft() + 'px';
        }
        else {
            this.eCell.style.left = '';
        }
    };
    return SetLeftFeature;
}(beanStub_1.BeanStub));
exports.SetLeftFeature = SetLeftFeature;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/renderedCell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var expressionService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/expressionService.js");
var rowRenderer_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/rowRenderer.js");
var templateService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/templateService.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var valueService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/valueService.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridApi_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridApi.js");
var focusedCellController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/focusedCellController.js");
var gridCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridCell.js");
var focusService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/misc/focusService.js");
var cellEditorFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellEditorFactory.js");
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var popupService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/popupService.js");
var cellRendererFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererFactory.js");
var cellRendererService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererService.js");
var valueFormatterService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/valueFormatterService.js");
var checkboxSelectionComponent_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/checkboxSelectionComponent.js");
var setLeftFeature_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/features/setLeftFeature.js");
var methodNotImplementedException_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/misc/methodNotImplementedException.js");
var stylingService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/styling/stylingService.js");
var RenderedCell = (function (_super) {
    __extends(RenderedCell, _super);
    function RenderedCell(column, node, scope, renderedRow) {
        _super.call(this, '<div/>');
        // set to null, not false, as we need to set 'ag-cell-no-focus' first time around
        this.cellFocused = null;
        this.firstRightPinned = false;
        this.lastLeftPinned = false;
        // because we reference eGridCell everywhere in this class,
        // we keep a local reference
        this.eGridCell = this.getGui();
        this.column = column;
        this.node = node;
        this.scope = scope;
        this.renderedRow = renderedRow;
        this.setupGridCell();
    }
    RenderedCell.prototype.createGridCell = function () {
        var gridCellDef = {
            rowIndex: this.node.rowIndex,
            floating: this.node.floating,
            column: this.column
        };
        this.gridCell = new gridCell_1.GridCell(gridCellDef);
    };
    RenderedCell.prototype.setupGridCell = function () {
        var _this = this;
        var listener = function () {
            // when index changes, this influences items that need the index, so we update the
            // grid cell so they are working off the new index.
            _this.createGridCell();
            // when the index of the row changes, ie means the cell may have lost of gained focus
            _this.checkCellFocused();
        };
        this.addDestroyableEventListener(this.node, rowNode_1.RowNode.EVENT_ROW_INDEX_CHANGED, listener);
        this.createGridCell();
    };
    RenderedCell.prototype.getGridCell = function () {
        return this.gridCell;
    };
    RenderedCell.prototype.setFocusInOnEditor = function () {
        if (this.editingCell && this.cellEditor && this.cellEditor.focusIn) {
            this.cellEditor.focusIn();
        }
    };
    RenderedCell.prototype.setFocusOutOnEditor = function () {
        if (this.editingCell && this.cellEditor && this.cellEditor.focusOut) {
            this.cellEditor.focusOut();
        }
    };
    RenderedCell.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (this.cellEditor && this.cellEditor.destroy) {
            this.cellEditor.destroy();
        }
        if (this.cellRenderer && this.cellRenderer.destroy) {
            this.cellRenderer.destroy();
        }
    };
    RenderedCell.prototype.setPinnedClasses = function () {
        var _this = this;
        var firstPinnedChangedListener = function () {
            if (_this.firstRightPinned !== _this.column.isFirstRightPinned()) {
                _this.firstRightPinned = _this.column.isFirstRightPinned();
                utils_1.Utils.addOrRemoveCssClass(_this.eGridCell, 'ag-cell-first-right-pinned', _this.firstRightPinned);
            }
            if (_this.lastLeftPinned !== _this.column.isLastLeftPinned()) {
                _this.lastLeftPinned = _this.column.isLastLeftPinned();
                utils_1.Utils.addOrRemoveCssClass(_this.eGridCell, 'ag-cell-last-left-pinned', _this.lastLeftPinned);
            }
        };
        this.column.addEventListener(column_1.Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstPinnedChangedListener);
        this.column.addEventListener(column_1.Column.EVENT_LAST_LEFT_PINNED_CHANGED, firstPinnedChangedListener);
        this.addDestroyFunc(function () {
            _this.column.removeEventListener(column_1.Column.EVENT_FIRST_RIGHT_PINNED_CHANGED, firstPinnedChangedListener);
            _this.column.removeEventListener(column_1.Column.EVENT_LAST_LEFT_PINNED_CHANGED, firstPinnedChangedListener);
        });
        firstPinnedChangedListener();
    };
    RenderedCell.prototype.getParentRow = function () {
        return this.eParentRow;
    };
    RenderedCell.prototype.setParentRow = function (eParentRow) {
        this.eParentRow = eParentRow;
    };
    RenderedCell.prototype.calculateCheckboxSelection = function () {
        // never allow selection on floating rows
        if (this.node.floating) {
            return false;
        }
        // if boolean set, then just use it
        var colDef = this.column.getColDef();
        if (typeof colDef.checkboxSelection === 'boolean') {
            return colDef.checkboxSelection;
        }
        // if function, then call the function to find out. we first check colDef for
        // a function, and if missing then check gridOptions, so colDef has precedence
        var selectionFunc;
        if (typeof colDef.checkboxSelection === 'function') {
            selectionFunc = colDef.checkboxSelection;
        }
        if (!selectionFunc && this.gridOptionsWrapper.getCheckboxSelection()) {
            selectionFunc = this.gridOptionsWrapper.getCheckboxSelection();
        }
        if (selectionFunc) {
            var params = this.createParams();
            return selectionFunc(params);
        }
        return false;
    };
    RenderedCell.prototype.getColumn = function () {
        return this.column;
    };
    RenderedCell.prototype.getValue = function () {
        var data = this.getDataForRow();
        return this.valueService.getValueUsingSpecificData(this.column, data, this.node);
    };
    RenderedCell.prototype.getDataForRow = function () {
        if (this.node.footer) {
            // if footer, we always show the data
            return this.node.data;
        }
        else if (this.node.group) {
            // if header and header is expanded, we show data in footer only
            var footersEnabled = this.gridOptionsWrapper.isGroupIncludeFooter();
            var suppressHideHeader = this.gridOptionsWrapper.isGroupSuppressBlankHeader();
            if (this.node.expanded && footersEnabled && !suppressHideHeader) {
                return undefined;
            }
            else {
                return this.node.data;
            }
        }
        else {
            // otherwise it's a normal node, just return data as normal
            return this.node.data;
        }
    };
    RenderedCell.prototype.addRangeSelectedListener = function () {
        var _this = this;
        if (!this.rangeController) {
            return;
        }
        var rangeCountLastTime = 0;
        var rangeSelectedListener = function () {
            var rangeCount = _this.rangeController.getCellRangeCount(_this.gridCell);
            if (rangeCountLastTime !== rangeCount) {
                utils_1.Utils.addOrRemoveCssClass(_this.eGridCell, 'ag-cell-range-selected', rangeCount !== 0);
                utils_1.Utils.addOrRemoveCssClass(_this.eGridCell, 'ag-cell-range-selected-1', rangeCount === 1);
                utils_1.Utils.addOrRemoveCssClass(_this.eGridCell, 'ag-cell-range-selected-2', rangeCount === 2);
                utils_1.Utils.addOrRemoveCssClass(_this.eGridCell, 'ag-cell-range-selected-3', rangeCount === 3);
                utils_1.Utils.addOrRemoveCssClass(_this.eGridCell, 'ag-cell-range-selected-4', rangeCount >= 4);
                rangeCountLastTime = rangeCount;
            }
        };
        this.eventService.addEventListener(events_1.Events.EVENT_RANGE_SELECTION_CHANGED, rangeSelectedListener);
        this.addDestroyFunc(function () {
            _this.eventService.removeEventListener(events_1.Events.EVENT_RANGE_SELECTION_CHANGED, rangeSelectedListener);
        });
        rangeSelectedListener();
    };
    RenderedCell.prototype.addHighlightListener = function () {
        var _this = this;
        if (!this.rangeController) {
            return;
        }
        var clipboardListener = function (event) {
            var cellId = _this.gridCell.createId();
            var shouldFlash = event.cells[cellId];
            if (shouldFlash) {
                _this.animateCellWithHighlight();
            }
        };
        this.eventService.addEventListener(events_1.Events.EVENT_FLASH_CELLS, clipboardListener);
        this.addDestroyFunc(function () {
            _this.eventService.removeEventListener(events_1.Events.EVENT_FLASH_CELLS, clipboardListener);
        });
    };
    RenderedCell.prototype.addChangeListener = function () {
        var _this = this;
        var cellChangeListener = function (event) {
            if (event.column === _this.column) {
                _this.refreshCell();
                _this.animateCellWithDataChanged();
            }
        };
        this.addDestroyableEventListener(this.node, rowNode_1.RowNode.EVENT_CELL_CHANGED, cellChangeListener);
    };
    RenderedCell.prototype.animateCellWithDataChanged = function () {
        if (this.gridOptionsWrapper.isEnableCellChangeFlash() || this.column.getColDef().enableCellChangeFlash) {
            this.animateCell('data-changed');
        }
    };
    RenderedCell.prototype.animateCellWithHighlight = function () {
        this.animateCell('highlight');
    };
    RenderedCell.prototype.animateCell = function (cssName) {
        var _this = this;
        var fullName = 'ag-cell-' + cssName;
        var animationFullName = 'ag-cell-' + cssName + '-animation';
        // we want to highlight the cells, without any animation
        utils_1.Utils.addCssClass(this.eGridCell, fullName);
        utils_1.Utils.removeCssClass(this.eGridCell, animationFullName);
        // then once that is applied, we remove the highlight with animation
        setTimeout(function () {
            utils_1.Utils.removeCssClass(_this.eGridCell, fullName);
            utils_1.Utils.addCssClass(_this.eGridCell, animationFullName);
            setTimeout(function () {
                // and then to leave things as we got them, we remove the animation
                utils_1.Utils.removeCssClass(_this.eGridCell, animationFullName);
            }, 1000);
        }, 500);
    };
    RenderedCell.prototype.addCellFocusedListener = function () {
        var _this = this;
        var cellFocusedListener = this.checkCellFocused.bind(this);
        this.eventService.addEventListener(events_1.Events.EVENT_CELL_FOCUSED, cellFocusedListener);
        this.addDestroyFunc(function () {
            _this.eventService.removeEventListener(events_1.Events.EVENT_CELL_FOCUSED, cellFocusedListener);
        });
        cellFocusedListener();
    };
    RenderedCell.prototype.checkCellFocused = function (event) {
        var cellFocused = this.focusedCellController.isCellFocused(this.gridCell);
        // see if we need to change the classes on this cell
        if (cellFocused !== this.cellFocused) {
            utils_1.Utils.addOrRemoveCssClass(this.eGridCell, 'ag-cell-focus', cellFocused);
            utils_1.Utils.addOrRemoveCssClass(this.eGridCell, 'ag-cell-no-focus', !cellFocused);
            this.cellFocused = cellFocused;
        }
        // if this cell was just focused, see if we need to force browser focus, his can
        // happen if focus is programmatically set.
        if (cellFocused && event && event.forceBrowserFocus) {
            this.eGridCell.focus();
        }
        // if another cell was focused, and we are editing, then stop editing
        var fullRowEdit = this.gridOptionsWrapper.isFullRowEdit();
        if (!cellFocused && !fullRowEdit && this.editingCell) {
            this.stopRowOrCellEdit();
        }
    };
    RenderedCell.prototype.setWidthOnCell = function () {
        var _this = this;
        var widthChangedListener = function () {
            _this.eGridCell.style.width = _this.column.getActualWidth() + "px";
        };
        this.column.addEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
        this.addDestroyFunc(function () {
            _this.column.removeEventListener(column_1.Column.EVENT_WIDTH_CHANGED, widthChangedListener);
        });
        widthChangedListener();
    };
    RenderedCell.prototype.init = function () {
        this.value = this.getValue();
        this.checkboxSelection = this.calculateCheckboxSelection();
        this.setWidthOnCell();
        this.setPinnedClasses();
        this.addRangeSelectedListener();
        this.addHighlightListener();
        this.addChangeListener();
        this.addCellFocusedListener();
        this.addDomData();
        // this.addSuppressShortcutKeyListenersWhileEditing();
        var setLeftFeature = new setLeftFeature_1.SetLeftFeature(this.column, this.eGridCell);
        this.addDestroyFunc(setLeftFeature.destroy.bind(setLeftFeature));
        // only set tab index if cell selection is enabled
        if (!this.gridOptionsWrapper.isSuppressCellSelection()) {
            this.eGridCell.setAttribute("tabindex", "-1");
        }
        // these are the grid styles, don't change between soft refreshes
        this.addClasses();
        this.setInlineEditingClass();
        this.createParentOfValue();
        this.populateCell();
    };
    RenderedCell.prototype.addDomData = function () {
        var domDataKey = this.gridOptionsWrapper.getDomDataKey();
        var gridCellNoType = this.eGridCell;
        gridCellNoType[domDataKey] = {
            renderedCell: this
        };
        this.addDestroyFunc(function () { return gridCellNoType[domDataKey] = null; });
    };
    RenderedCell.prototype.onEnterKeyDown = function () {
        if (this.editingCell) {
            this.stopRowOrCellEdit();
            this.focusCell(true);
        }
        else {
            this.startRowOrCellEdit(constants_1.Constants.KEY_ENTER);
        }
    };
    RenderedCell.prototype.onF2KeyDown = function () {
        if (!this.editingCell) {
            this.startRowOrCellEdit(constants_1.Constants.KEY_F2);
        }
    };
    RenderedCell.prototype.onEscapeKeyDown = function () {
        if (this.editingCell) {
            this.stopRowOrCellEdit(true);
            this.focusCell(true);
        }
    };
    RenderedCell.prototype.onPopupEditorClosed = function () {
        // we only call stopEditing if we are editing, as
        // it's possible the popup called 'stop editing'
        // before this, eg if 'enter key' was pressed on
        // the editor.
        if (this.editingCell) {
            // note: this only happens when use clicks outside of the grid. if use clicks on another
            // cell, then the editing will have already stopped on this cell
            this.stopRowOrCellEdit();
            // we only focus cell again if this cell is still focused. it is possible
            // it is not focused if the user cancelled the edit by clicking on another
            // cell outside of this one
            if (this.focusedCellController.isCellFocused(this.gridCell)) {
                this.focusCell(true);
            }
        }
    };
    RenderedCell.prototype.isEditing = function () {
        return this.editingCell;
    };
    RenderedCell.prototype.onTabKeyDown = function (event) {
        this.rowRenderer.onTabKeyDown(this, event);
    };
    RenderedCell.prototype.onBackspaceOrDeleteKeyPressed = function (key) {
        if (!this.editingCell) {
            this.startRowOrCellEdit(key);
        }
    };
    RenderedCell.prototype.onSpaceKeyPressed = function (event) {
        if (!this.editingCell && this.gridOptionsWrapper.isRowSelection()) {
            var selected = this.node.isSelected();
            this.node.setSelected(!selected);
        }
        // prevent default as space key, by default, moves browser scroll down
        event.preventDefault();
    };
    RenderedCell.prototype.onNavigationKeyPressed = function (event, key) {
        if (this.editingCell) {
            this.stopRowOrCellEdit();
        }
        this.rowRenderer.navigateToNextCell(key, this.gridCell.rowIndex, this.column, this.node.floating);
        // if we don't prevent default, the grid will scroll with the navigation keys
        event.preventDefault();
    };
    RenderedCell.prototype.onKeyPress = function (event) {
        // check this, in case focus is on a (for example) a text field inside the cell,
        // in which cse we should not be listening for these key pressed
        var eventTarget = utils_1.Utils.getTarget(event);
        var eventOnChildComponent = eventTarget !== this.getGui();
        if (eventOnChildComponent) {
            return;
        }
        if (!this.editingCell) {
            var pressedChar = String.fromCharCode(event.charCode);
            if (pressedChar === ' ') {
                this.onSpaceKeyPressed(event);
            }
            else {
                if (RenderedCell.PRINTABLE_CHARACTERS.indexOf(pressedChar) >= 0) {
                    this.startRowOrCellEdit(null, pressedChar);
                    // if we don't prevent default, then the keypress also gets applied to the text field
                    // (at least when doing the default editor), but we need to allow the editor to decide
                    // what it wants to do. we only do this IF editing was started - otherwise it messes
                    // up when the use is not doing editing, but using rendering with text fields in cellRenderer
                    // (as it would block the the user from typing into text fields).
                    event.preventDefault();
                }
            }
        }
    };
    RenderedCell.prototype.onKeyDown = function (event) {
        var key = event.which || event.keyCode;
        switch (key) {
            case constants_1.Constants.KEY_ENTER:
                this.onEnterKeyDown();
                break;
            case constants_1.Constants.KEY_F2:
                this.onF2KeyDown();
                break;
            case constants_1.Constants.KEY_ESCAPE:
                this.onEscapeKeyDown();
                break;
            case constants_1.Constants.KEY_TAB:
                this.onTabKeyDown(event);
                break;
            case constants_1.Constants.KEY_BACKSPACE:
            case constants_1.Constants.KEY_DELETE:
                this.onBackspaceOrDeleteKeyPressed(key);
                break;
            case constants_1.Constants.KEY_DOWN:
            case constants_1.Constants.KEY_UP:
            case constants_1.Constants.KEY_RIGHT:
            case constants_1.Constants.KEY_LEFT:
                this.onNavigationKeyPressed(event, key);
                break;
        }
    };
    RenderedCell.prototype.createCellEditorParams = function (keyPress, charPress, cellStartedEdit) {
        var params = {
            value: this.getValue(),
            keyPress: keyPress,
            charPress: charPress,
            column: this.column,
            rowIndex: this.gridCell.rowIndex,
            node: this.node,
            api: this.gridOptionsWrapper.getApi(),
            cellStartedEdit: cellStartedEdit,
            columnApi: this.gridOptionsWrapper.getColumnApi(),
            context: this.gridOptionsWrapper.getContext(),
            $scope: this.scope,
            onKeyDown: this.onKeyDown.bind(this),
            stopEditing: this.stopEditingAndFocus.bind(this),
            eGridCell: this.eGridCell
        };
        var colDef = this.column.getColDef();
        if (colDef.cellEditorParams) {
            utils_1.Utils.assign(params, colDef.cellEditorParams);
        }
        return params;
    };
    RenderedCell.prototype.createCellEditor = function (keyPress, charPress, cellStartedEdit) {
        var params = this.createCellEditorParams(keyPress, charPress, cellStartedEdit);
        var cellEditor = this.cellEditorFactory.createCellEditor(this.column.getCellEditor(), params);
        return cellEditor;
    };
    // cell editors call this, when they want to stop for reasons other
    // than what we pick up on. eg selecting from a dropdown ends editing.
    RenderedCell.prototype.stopEditingAndFocus = function () {
        this.stopRowOrCellEdit();
        this.focusCell(true);
    };
    // called by rowRenderer when user navigates via tab key
    RenderedCell.prototype.startRowOrCellEdit = function (keyPress, charPress) {
        if (this.gridOptionsWrapper.isFullRowEdit()) {
            this.renderedRow.startRowEditing(keyPress, charPress, this);
        }
        else {
            this.startEditingIfEnabled(keyPress, charPress, true);
        }
    };
    // either called internally if single cell editing, or called by rowRenderer if row editing
    RenderedCell.prototype.startEditingIfEnabled = function (keyPress, charPress, cellStartedEdit) {
        if (keyPress === void 0) { keyPress = null; }
        if (charPress === void 0) { charPress = null; }
        if (cellStartedEdit === void 0) { cellStartedEdit = false; }
        // don't do it if not editable
        if (!this.isCellEditable()) {
            return;
        }
        // don't do it if already editing
        if (this.editingCell) {
            return;
        }
        var cellEditor = this.createCellEditor(keyPress, charPress, cellStartedEdit);
        if (cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart()) {
            if (cellEditor.destroy) {
                cellEditor.destroy();
            }
            return false;
        }
        if (!cellEditor.getGui) {
            console.warn("ag-Grid: cellEditor for column " + this.column.getId() + " is missing getGui() method");
            // no getGui, for React guys, see if they attached a react component directly
            if (cellEditor.render) {
                console.warn("ag-Grid: we found 'render' on the component, are you trying to set a React renderer but added it as colDef.cellEditor instead of colDef.cellEditorFmk?");
            }
            return false;
        }
        this.cellEditor = cellEditor;
        this.editingCell = true;
        this.cellEditorInPopup = this.cellEditor.isPopup && this.cellEditor.isPopup();
        this.setInlineEditingClass();
        if (this.cellEditorInPopup) {
            this.addPopupCellEditor();
        }
        else {
            this.addInCellEditor();
        }
        if (cellEditor.afterGuiAttached) {
            cellEditor.afterGuiAttached();
        }
        this.eventService.dispatchEvent(events_1.Events.EVENT_CELL_EDITING_STARTED, this.createParams());
        return true;
    };
    RenderedCell.prototype.addInCellEditor = function () {
        utils_1.Utils.removeAllChildren(this.eGridCell);
        this.eGridCell.appendChild(this.cellEditor.getGui());
        if (this.gridOptionsWrapper.isAngularCompileRows()) {
            this.$compile(this.eGridCell)(this.scope);
        }
    };
    RenderedCell.prototype.addPopupCellEditor = function () {
        var _this = this;
        var ePopupGui = this.cellEditor.getGui();
        this.hideEditorPopup = this.popupService.addAsModalPopup(ePopupGui, true, 
        // callback for when popup disappears
        function () {
            _this.onPopupEditorClosed();
        });
        this.popupService.positionPopupOverComponent({
            eventSource: this.eGridCell,
            ePopup: ePopupGui,
            keepWithinBounds: true
        });
        if (this.gridOptionsWrapper.isAngularCompileRows()) {
            this.$compile(ePopupGui)(this.scope);
        }
    };
    RenderedCell.prototype.focusCell = function (forceBrowserFocus) {
        if (forceBrowserFocus === void 0) { forceBrowserFocus = false; }
        this.focusedCellController.setFocusedCell(this.gridCell.rowIndex, this.column, this.node.floating, forceBrowserFocus);
    };
    // pass in 'true' to cancel the editing.
    RenderedCell.prototype.stopRowOrCellEdit = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        if (this.gridOptionsWrapper.isFullRowEdit()) {
            this.renderedRow.stopRowEditing(cancel);
        }
        else {
            this.stopEditing(cancel);
        }
    };
    RenderedCell.prototype.stopEditing = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        if (!this.editingCell) {
            return;
        }
        this.editingCell = false;
        if (!cancel) {
            // also have another option here to cancel after editing, so for example user could have a popup editor and
            // it is closed by user clicking outside the editor. then the editor will close automatically (with false
            // passed above) and we need to see if the editor wants to accept the new value.
            var userWantsToCancel = this.cellEditor.isCancelAfterEnd && this.cellEditor.isCancelAfterEnd();
            if (!userWantsToCancel) {
                var newValue = this.cellEditor.getValue();
                this.valueService.setValue(this.node, this.column, newValue);
                this.value = this.getValue();
            }
        }
        if (this.cellEditor.destroy) {
            this.cellEditor.destroy();
        }
        if (this.cellEditorInPopup) {
            this.hideEditorPopup();
            this.hideEditorPopup = null;
        }
        else {
            utils_1.Utils.removeAllChildren(this.eGridCell);
            // put the cell back the way it was before editing
            if (this.checkboxSelection) {
                // if wrapper, then put the wrapper back
                this.eGridCell.appendChild(this.eCellWrapper);
            }
            else {
                // if cellRenderer, then put the gui back in. if the renderer has
                // a refresh, it will be called. however if it doesn't, then later
                // the renderer will be destroyed and a new one will be created.
                if (this.cellRenderer) {
                    this.eGridCell.appendChild(this.cellRenderer.getGui());
                }
            }
        }
        this.setInlineEditingClass();
        this.refreshCell();
        this.eventService.dispatchEvent(events_1.Events.EVENT_CELL_EDITING_STOPPED, this.createParams());
    };
    RenderedCell.prototype.createParams = function () {
        var params = {
            node: this.node,
            data: this.node.data,
            value: this.value,
            rowIndex: this.gridCell.rowIndex,
            column: this.column,
            colDef: this.column.getColDef(),
            $scope: this.scope,
            context: this.gridOptionsWrapper.getContext(),
            api: this.gridApi,
            columnApi: this.columnApi
        };
        return params;
    };
    RenderedCell.prototype.createEvent = function (event) {
        var agEvent = this.createParams();
        agEvent.event = event;
        return agEvent;
    };
    RenderedCell.prototype.getRenderedRow = function () {
        return this.renderedRow;
    };
    RenderedCell.prototype.isSuppressNavigable = function () {
        return this.column.isSuppressNavigable(this.node);
    };
    RenderedCell.prototype.isCellEditable = function () {
        // only allow editing of groups if the user has this option enabled
        if (this.node.group && !this.gridOptionsWrapper.isEnableGroupEdit()) {
            return false;
        }
        return this.column.isCellEditable(this.node);
    };
    RenderedCell.prototype.onMouseEvent = function (eventName, mouseEvent) {
        switch (eventName) {
            case 'click':
                this.onCellClicked(mouseEvent);
                break;
            case 'mousedown':
                this.onMouseDown();
                break;
            case 'dblclick':
                this.onCellDoubleClicked(mouseEvent);
                break;
            case 'contextmenu':
                this.onContextMenu(mouseEvent);
                break;
        }
    };
    RenderedCell.prototype.onContextMenu = function (mouseEvent) {
        // to allow us to debug in chrome, we ignore the event if ctrl is pressed,
        // thus the normal menu is displayed
        if (mouseEvent.ctrlKey || mouseEvent.metaKey) {
            return;
        }
        var colDef = this.column.getColDef();
        var agEvent = this.createEvent(mouseEvent);
        this.eventService.dispatchEvent(events_1.Events.EVENT_CELL_CONTEXT_MENU, agEvent);
        if (colDef.onCellContextMenu) {
            colDef.onCellContextMenu(agEvent);
        }
        if (this.contextMenuFactory && !this.gridOptionsWrapper.isSuppressContextMenu()) {
            this.contextMenuFactory.showMenu(this.node, this.column, this.value, mouseEvent);
            mouseEvent.preventDefault();
        }
    };
    RenderedCell.prototype.onCellDoubleClicked = function (mouseEvent) {
        var colDef = this.column.getColDef();
        // always dispatch event to eventService
        var agEvent = this.createEvent(mouseEvent);
        this.eventService.dispatchEvent(events_1.Events.EVENT_CELL_DOUBLE_CLICKED, agEvent);
        // check if colDef also wants to handle event
        if (typeof colDef.onCellDoubleClicked === 'function') {
            colDef.onCellDoubleClicked(agEvent);
        }
        var editOnDoubleClick = !this.gridOptionsWrapper.isSingleClickEdit()
            && !this.gridOptionsWrapper.isSuppressClickEdit();
        if (editOnDoubleClick) {
            this.startRowOrCellEdit();
        }
    };
    RenderedCell.prototype.onMouseDown = function () {
        // we pass false to focusCell, as we don't want the cell to focus
        // also get the browser focus. if we did, then the cellRenderer could
        // have a text field in it, for example, and as the user clicks on the
        // text field, the text field, the focus doesn't get to the text
        // field, instead to goes to the div behind, making it impossible to
        // select the text field.
        this.focusCell(false);
        // if it's a right click, then if the cell is already in range,
        // don't change the range, however if the cell is not in a range,
        // we set a new range
        if (this.rangeController) {
            var thisCell = this.gridCell;
            var cellAlreadyInRange = this.rangeController.isCellInAnyRange(thisCell);
            if (!cellAlreadyInRange) {
                this.rangeController.setRangeToCell(thisCell);
            }
        }
    };
    RenderedCell.prototype.onCellClicked = function (mouseEvent) {
        var agEvent = this.createEvent(mouseEvent);
        this.eventService.dispatchEvent(events_1.Events.EVENT_CELL_CLICKED, agEvent);
        var colDef = this.column.getColDef();
        if (colDef.onCellClicked) {
            colDef.onCellClicked(agEvent);
        }
        var editOnSingleClick = this.gridOptionsWrapper.isSingleClickEdit()
            && !this.gridOptionsWrapper.isSuppressClickEdit();
        if (editOnSingleClick) {
            this.startRowOrCellEdit();
        }
        this.doIeFocusHack();
    };
    // https://ag-grid.com/forum/showthread.php?tid=4362
    // when in IE or Edge, when you are editing a cell, then click on another cell,
    // the other cell doesn't keep focus, so navigation keys, type to start edit etc
    // don't work. appears that when you update the dom in IE it looses focus
    RenderedCell.prototype.doIeFocusHack = function () {
        if (utils_1.Utils.isBrowserIE() || utils_1.Utils.isBrowserEdge()) {
            if (utils_1.Utils.missing(document.activeElement) || document.activeElement === document.body) {
                // console.log('missing focus');
                this.getGui().focus();
            }
        }
    };
    // if we are editing inline, then we don't have the padding in the cell (set in the themes)
    // to allow the text editor full access to the entire cell
    RenderedCell.prototype.setInlineEditingClass = function () {
        var editingInline = this.editingCell && !this.cellEditorInPopup;
        utils_1.Utils.addOrRemoveCssClass(this.eGridCell, 'ag-cell-inline-editing', editingInline);
        utils_1.Utils.addOrRemoveCssClass(this.eGridCell, 'ag-cell-not-inline-editing', !editingInline);
    };
    RenderedCell.prototype.populateCell = function () {
        // populate
        this.putDataIntoCell();
        // style
        this.addStylesFromColDef();
        this.addClassesFromColDef();
        this.addClassesFromRules();
    };
    RenderedCell.prototype.addStylesFromColDef = function () {
        var colDef = this.column.getColDef();
        if (colDef.cellStyle) {
            var cssToUse;
            if (typeof colDef.cellStyle === 'function') {
                var cellStyleParams = {
                    value: this.value,
                    data: this.node.data,
                    node: this.node,
                    colDef: colDef,
                    column: this.column,
                    $scope: this.scope,
                    context: this.gridOptionsWrapper.getContext(),
                    api: this.gridOptionsWrapper.getApi()
                };
                var cellStyleFunc = colDef.cellStyle;
                cssToUse = cellStyleFunc(cellStyleParams);
            }
            else {
                cssToUse = colDef.cellStyle;
            }
            if (cssToUse) {
                utils_1.Utils.addStylesToElement(this.eGridCell, cssToUse);
            }
        }
    };
    RenderedCell.prototype.addClassesFromColDef = function () {
        var _this = this;
        var colDef = this.column.getColDef();
        if (colDef.cellClass) {
            var classToUse;
            if (typeof colDef.cellClass === 'function') {
                var cellClassParams = {
                    value: this.value,
                    data: this.node.data,
                    node: this.node,
                    colDef: colDef,
                    $scope: this.scope,
                    context: this.gridOptionsWrapper.getContext(),
                    api: this.gridOptionsWrapper.getApi()
                };
                var cellClassFunc = colDef.cellClass;
                classToUse = cellClassFunc(cellClassParams);
            }
            else {
                classToUse = colDef.cellClass;
            }
            if (typeof classToUse === 'string') {
                utils_1.Utils.addCssClass(this.eGridCell, classToUse);
            }
            else if (Array.isArray(classToUse)) {
                classToUse.forEach(function (cssClassItem) {
                    utils_1.Utils.addCssClass(_this.eGridCell, cssClassItem);
                });
            }
        }
    };
    RenderedCell.prototype.createParentOfValue = function () {
        if (this.checkboxSelection) {
            this.eCellWrapper = document.createElement('span');
            utils_1.Utils.addCssClass(this.eCellWrapper, 'ag-cell-wrapper');
            this.eGridCell.appendChild(this.eCellWrapper);
            var cbSelectionComponent = new checkboxSelectionComponent_1.CheckboxSelectionComponent();
            this.context.wireBean(cbSelectionComponent);
            cbSelectionComponent.init({ rowNode: this.node });
            this.addDestroyFunc(function () { return cbSelectionComponent.destroy(); });
            // eventually we call eSpanWithValue.innerHTML = xxx, so cannot include the checkbox (above) in this span
            this.eSpanWithValue = document.createElement('span');
            utils_1.Utils.addCssClass(this.eSpanWithValue, 'ag-cell-value');
            this.eCellWrapper.appendChild(cbSelectionComponent.getGui());
            this.eCellWrapper.appendChild(this.eSpanWithValue);
            this.eParentOfValue = this.eSpanWithValue;
        }
        else {
            utils_1.Utils.addCssClass(this.eGridCell, 'ag-cell-value');
            this.eParentOfValue = this.eGridCell;
        }
    };
    RenderedCell.prototype.isVolatile = function () {
        return this.column.getColDef().volatile;
    };
    RenderedCell.prototype.refreshCell = function (animate, newData) {
        if (animate === void 0) { animate = false; }
        if (newData === void 0) { newData = false; }
        this.value = this.getValue();
        var refreshFailed = false;
        var that = this;
        // if it's 'new data', then we don't refresh the cellRenderer, even if refresh method is available.
        // this is because if the whole data is new (ie we are showing stock price 'BBA' now and not 'SSD')
        // then we are not showing a movement in the stock price, rather we are showing different stock.
        var attemptRefresh = !newData && this.cellRenderer && this.cellRenderer.refresh;
        if (attemptRefresh) {
            try {
                doRefresh();
            }
            catch (e) {
                if (e instanceof methodNotImplementedException_1.MethodNotImplementedException) {
                    refreshFailed = true;
                }
                else {
                    throw e;
                }
            }
        }
        // we do the replace if not doing refresh, or if refresh was unsuccessful.
        // the refresh can be unsuccessful if we are using a framework (eg ng2 or react) and the framework
        // wrapper has the refresh method, but the underlying component doesn't
        if (!attemptRefresh || refreshFailed) {
            doReplace();
        }
        if (animate) {
            this.animateCellWithDataChanged();
        }
        function doRefresh() {
            // if the cell renderer has a refresh method, we call this instead of doing a refresh
            // note: should pass in params here instead of value?? so that client has formattedValue
            var valueFormatted = that.formatValue(that.value);
            var cellRendererParams = that.column.getColDef().cellRendererParams;
            var params = that.createRendererAndRefreshParams(valueFormatted, cellRendererParams);
            that.cellRenderer.refresh(params);
            // need to check rules. note, we ignore colDef classes and styles, these are assumed to be static
            that.addClassesFromRules();
        }
        function doReplace() {
            // otherwise we rip out the cell and replace it
            utils_1.Utils.removeAllChildren(that.eParentOfValue);
            // remove old renderer component if it exists
            if (that.cellRenderer && that.cellRenderer.destroy) {
                that.cellRenderer.destroy();
            }
            that.cellRenderer = null;
            that.populateCell();
            // if angular compiling, then need to also compile the cell again (angular compiling sucks, please wait...)
            if (that.gridOptionsWrapper.isAngularCompileRows()) {
                that.$compile(that.eGridCell)(that.scope);
            }
        }
    };
    RenderedCell.prototype.addClassesFromRules = function () {
        var _this = this;
        this.stylingService.processCellClassRules(this.column.getColDef(), {
            value: this.value,
            data: this.node.data,
            node: this.node,
            colDef: this.column.getColDef(),
            rowIndex: this.gridCell.rowIndex,
            api: this.gridOptionsWrapper.getApi(),
            context: this.gridOptionsWrapper.getContext()
        }, function (className) {
            utils_1.Utils.addCssClass(_this.eGridCell, className);
        }, function (className) {
            utils_1.Utils.removeCssClass(_this.eGridCell, className);
        });
    };
    RenderedCell.prototype.putDataIntoCell = function () {
        // template gets preference, then cellRenderer, then do it ourselves
        var colDef = this.column.getColDef();
        var cellRenderer = this.column.getCellRenderer();
        var floatingCellRenderer = this.column.getFloatingCellRenderer();
        var valueFormatted = this.valueFormatterService.formatValue(this.column, this.node, this.scope, this.gridCell.rowIndex, this.value);
        if (colDef.template) {
            // template is really only used for angular 1 - as people using ng1 are used to providing templates with
            // bindings in it. in ng2, people will hopefully want to provide components, not templates.
            this.eParentOfValue.innerHTML = colDef.template;
        }
        else if (colDef.templateUrl) {
            // likewise for templateUrl - it's for ng1 really - when we move away from ng1, we can take these out.
            // niall was pro angular 1 when writing template and templateUrl, if writing from scratch now, would
            // not do these, but would follow a pattern that was friendly towards components, not templates.
            var template = this.templateService.getTemplate(colDef.templateUrl, this.refreshCell.bind(this, true));
            if (template) {
                this.eParentOfValue.innerHTML = template;
            }
        }
        else if (floatingCellRenderer && this.node.floating) {
            // if floating, then give preference to floating cell renderer
            this.useCellRenderer(floatingCellRenderer, colDef.floatingCellRendererParams, valueFormatted);
        }
        else if (cellRenderer) {
            // use normal cell renderer
            this.useCellRenderer(cellRenderer, colDef.cellRendererParams, valueFormatted);
        }
        else {
            // if we insert undefined, then it displays as the string 'undefined', ugly!
            var valueFormattedExits = valueFormatted !== null && valueFormatted !== undefined;
            var valueToRender = valueFormattedExits ? valueFormatted : this.value;
            if (utils_1.Utils.exists(valueToRender) && valueToRender !== '') {
                // not using innerHTML to prevent injection of HTML
                // https://developer.mozilla.org/en-US/docs/Web/API/Element/innerHTML#Security_considerations
                this.eParentOfValue.textContent = valueToRender.toString();
            }
        }
        if (colDef.tooltipField) {
            var data = this.getDataForRow();
            if (utils_1.Utils.exists(data)) {
                var tooltip = utils_1.Utils.getValueUsingField(data, colDef.tooltipField, this.column.isTooltipFieldContainsDots());
                if (utils_1.Utils.exists(tooltip)) {
                    this.eParentOfValue.setAttribute('title', tooltip);
                }
            }
        }
    };
    RenderedCell.prototype.formatValue = function (value) {
        return this.valueFormatterService.formatValue(this.column, this.node, this.scope, this.gridCell.rowIndex, value);
    };
    RenderedCell.prototype.createRendererAndRefreshParams = function (valueFormatted, cellRendererParams) {
        var params = {
            value: this.value,
            valueFormatted: valueFormatted,
            valueGetter: this.getValue,
            formatValue: this.formatValue.bind(this),
            data: this.node.data,
            node: this.node,
            colDef: this.column.getColDef(),
            column: this.column,
            $scope: this.scope,
            rowIndex: this.gridCell.rowIndex,
            api: this.gridOptionsWrapper.getApi(),
            columnApi: this.gridOptionsWrapper.getColumnApi(),
            context: this.gridOptionsWrapper.getContext(),
            refreshCell: this.refreshCell.bind(this),
            eGridCell: this.eGridCell,
            eParentOfValue: this.eParentOfValue,
            addRenderedRowListener: this.renderedRow.addEventListener.bind(this.renderedRow)
        };
        if (cellRendererParams) {
            utils_1.Utils.assign(params, cellRendererParams);
        }
        return params;
    };
    RenderedCell.prototype.useCellRenderer = function (cellRendererKey, cellRendererParams, valueFormatted) {
        var params = this.createRendererAndRefreshParams(valueFormatted, cellRendererParams);
        this.cellRenderer = this.cellRendererService.useCellRenderer(cellRendererKey, this.eParentOfValue, params);
    };
    RenderedCell.prototype.addClasses = function () {
        utils_1.Utils.addCssClass(this.eGridCell, 'ag-cell');
        this.eGridCell.setAttribute("colId", this.column.getColId());
        if (this.node.group && this.node.footer) {
            utils_1.Utils.addCssClass(this.eGridCell, 'ag-footer-cell');
        }
        if (this.node.group && !this.node.footer) {
            utils_1.Utils.addCssClass(this.eGridCell, 'ag-group-cell');
        }
    };
    RenderedCell.PRINTABLE_CHARACTERS = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890!"£$%^&*()_+-=[];\'#,./\|<>?:@~{}';
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], RenderedCell.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnApi'), 
        __metadata('design:type', columnController_1.ColumnApi)
    ], RenderedCell.prototype, "columnApi", void 0);
    __decorate([
        context_1.Autowired('gridApi'), 
        __metadata('design:type', gridApi_1.GridApi)
    ], RenderedCell.prototype, "gridApi", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], RenderedCell.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'), 
        __metadata('design:type', expressionService_1.ExpressionService)
    ], RenderedCell.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('rowRenderer'), 
        __metadata('design:type', rowRenderer_1.RowRenderer)
    ], RenderedCell.prototype, "rowRenderer", void 0);
    __decorate([
        context_1.Autowired('$compile'), 
        __metadata('design:type', Object)
    ], RenderedCell.prototype, "$compile", void 0);
    __decorate([
        context_1.Autowired('templateService'), 
        __metadata('design:type', templateService_1.TemplateService)
    ], RenderedCell.prototype, "templateService", void 0);
    __decorate([
        context_1.Autowired('valueService'), 
        __metadata('design:type', valueService_1.ValueService)
    ], RenderedCell.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], RenderedCell.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], RenderedCell.prototype, "columnController", void 0);
    __decorate([
        context_1.Optional('rangeController'), 
        __metadata('design:type', Object)
    ], RenderedCell.prototype, "rangeController", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'), 
        __metadata('design:type', focusedCellController_1.FocusedCellController)
    ], RenderedCell.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Optional('contextMenuFactory'), 
        __metadata('design:type', Object)
    ], RenderedCell.prototype, "contextMenuFactory", void 0);
    __decorate([
        context_1.Autowired('focusService'), 
        __metadata('design:type', focusService_1.FocusService)
    ], RenderedCell.prototype, "focusService", void 0);
    __decorate([
        context_1.Autowired('cellEditorFactory'), 
        __metadata('design:type', cellEditorFactory_1.CellEditorFactory)
    ], RenderedCell.prototype, "cellEditorFactory", void 0);
    __decorate([
        context_1.Autowired('cellRendererFactory'), 
        __metadata('design:type', cellRendererFactory_1.CellRendererFactory)
    ], RenderedCell.prototype, "cellRendererFactory", void 0);
    __decorate([
        context_1.Autowired('popupService'), 
        __metadata('design:type', popupService_1.PopupService)
    ], RenderedCell.prototype, "popupService", void 0);
    __decorate([
        context_1.Autowired('cellRendererService'), 
        __metadata('design:type', cellRendererService_1.CellRendererService)
    ], RenderedCell.prototype, "cellRendererService", void 0);
    __decorate([
        context_1.Autowired('valueFormatterService'), 
        __metadata('design:type', valueFormatterService_1.ValueFormatterService)
    ], RenderedCell.prototype, "valueFormatterService", void 0);
    __decorate([
        context_1.Autowired('stylingService'), 
        __metadata('design:type', stylingService_1.StylingService)
    ], RenderedCell.prototype, "stylingService", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], RenderedCell.prototype, "init", null);
    return RenderedCell;
}(component_1.Component));
exports.RenderedCell = RenderedCell;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/renderedRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var renderedCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/renderedCell.js");
var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var focusedCellController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/focusedCellController.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var cellRendererService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererService.js");
var cellRendererFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/cellRendererFactory.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var beanStub_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/beanStub.js");
var RenderedRow = (function (_super) {
    __extends(RenderedRow, _super);
    function RenderedRow(parentScope, rowRenderer, bodyContainerComp, fullWidthContainerComp, pinnedLeftContainerComp, pinnedRightContainerComp, node, animateIn) {
        _super.call(this);
        this.eAllRowContainers = [];
        this.renderedCells = {};
        // for animations, there are bits we want done in the next VM turn, to all DOM to update first.
        // instead of each row doing a setTimeout(func,0), we put the functions here and the rowRenderer
        // executes them all in one timeout
        this.nextVmTurnFunctions = [];
        // for animations, these functions get called 400ms after the row is cleared, called by the rowRenderer
        // so each row isn't setting up it's own timeout
        this.delayedDestroyFunctions = [];
        // these get called before the row is destroyed - they set up the DOM for the remove animation (ie they
        // set the DOM up for the animation), then the delayedDestroyFunctions get called when the animation is
        // complete (ie removes from the dom).
        this.startRemoveAnimationFunctions = [];
        this.editingRow = false;
        this.initialised = false;
        this.parentScope = parentScope;
        this.rowRenderer = rowRenderer;
        this.bodyContainerComp = bodyContainerComp;
        this.fullWidthContainerComp = fullWidthContainerComp;
        this.pinnedLeftContainerComp = pinnedLeftContainerComp;
        this.pinnedRightContainerComp = pinnedRightContainerComp;
        this.rowNode = node;
        this.animateIn = animateIn;
    }
    RenderedRow.prototype.setupRowContainers = function (animateInRowTop) {
        var isFullWidthCellFunc = this.gridOptionsWrapper.getIsFullWidthCellFunc();
        var isFullWidthCell = isFullWidthCellFunc ? isFullWidthCellFunc(this.rowNode) : false;
        var isGroupSpanningRow = this.rowNode.group && this.gridOptionsWrapper.isGroupUseEntireRow();
        if (isFullWidthCell) {
            this.setupFullWidthContainers(animateInRowTop);
        }
        else if (isGroupSpanningRow) {
            this.setupFullWidthGroupContainers(animateInRowTop);
        }
        else {
            this.setupNormalContainers(animateInRowTop);
        }
    };
    /*    private createGroupSpanningEntireRowCell(padding: boolean): HTMLElement {
            var eRow: HTMLElement = document.createElement('span');
            // padding means we are on the right hand side of a pinned table, ie
            // in the main body.
            if (!padding) {
    
                var params = this.createFullWidthParams(eRow, null);
    
                var cellComponent = this.cellRendererService.useCellRenderer(this.fullWidthCellRenderer, eRow, params);
    
                if (cellComponent && cellComponent.destroy) {
                    this.addDestroyFunc( () => cellComponent.destroy() );
                }
            }
    
            if (this.rowNode.footer) {
                _.addCssClass(eRow, 'ag-footer-cell-entire-row');
            } else {
                _.addCssClass(eRow, 'ag-group-cell-entire-row');
            }
    
            return eRow;
        }*/
    // we clear so that the functions are never executed twice
    RenderedRow.prototype.getAndClearDelayedDestroyFunctions = function () {
        var result = this.delayedDestroyFunctions;
        this.delayedDestroyFunctions = [];
        return result;
    };
    // we clear so that the functions are never executed twice
    RenderedRow.prototype.getAndClearNextVMTurnFunctions = function () {
        var result = this.nextVmTurnFunctions;
        this.nextVmTurnFunctions = [];
        return result;
    };
    RenderedRow.prototype.addDomData = function (eRowContainer) {
        var domDataKey = this.gridOptionsWrapper.getDomDataKey();
        var gridCellNoType = eRowContainer;
        gridCellNoType[domDataKey] = {
            renderedRow: this
        };
        this.addDestroyFunc(function () { gridCellNoType[domDataKey] = null; });
    };
    RenderedRow.prototype.setupFullWidthContainers = function (animateInRowTop) {
        this.fullWidthRow = true;
        this.fullWidthCellRenderer = this.gridOptionsWrapper.getFullWidthCellRenderer();
        this.fullWidthCellRendererParams = this.gridOptionsWrapper.getFullWidthCellRendererParams();
        if (utils_1.Utils.missing(this.fullWidthCellRenderer)) {
            console.warn("ag-Grid: you need to provide a fullWidthCellRenderer if using isFullWidthCell()");
        }
        this.createFullWidthRow(animateInRowTop);
    };
    RenderedRow.prototype.addMouseWheelListenerToFullWidthRow = function () {
        var mouseWheelListener = this.gridPanel.genericMouseWheelListener.bind(this.gridPanel);
        // IE9, Chrome, Safari, Opera
        this.addDestroyableEventListener(this.eFullWidthRow, 'mousewheel', mouseWheelListener);
        // Firefox
        this.addDestroyableEventListener(this.eFullWidthRow, 'DOMMouseScroll', mouseWheelListener);
    };
    RenderedRow.prototype.setupFullWidthGroupContainers = function (animateInRowTop) {
        this.fullWidthRow = true;
        this.fullWidthCellRenderer = this.gridOptionsWrapper.getGroupRowRenderer();
        this.fullWidthCellRendererParams = this.gridOptionsWrapper.getGroupRowRendererParams();
        if (!this.fullWidthCellRenderer) {
            this.fullWidthCellRenderer = cellRendererFactory_1.CellRendererFactory.GROUP;
            this.fullWidthCellRendererParams = {
                innerRenderer: this.gridOptionsWrapper.getGroupRowInnerRenderer()
            };
        }
        this.createFullWidthRow(animateInRowTop);
    };
    RenderedRow.prototype.createFullWidthRow = function (animateInRowTop) {
        var embedFullWidthRows = this.gridOptionsWrapper.isEmbedFullWidthRows();
        if (embedFullWidthRows) {
            // if embedding the full width, it gets added to the body, left and right
            this.eFullWidthRowBody = this.createRowContainer(this.bodyContainerComp, animateInRowTop);
            this.eFullWidthRowLeft = this.createRowContainer(this.pinnedLeftContainerComp, animateInRowTop);
            this.eFullWidthRowRight = this.createRowContainer(this.pinnedRightContainerComp, animateInRowTop);
            utils_1.Utils.addCssClass(this.eFullWidthRowLeft, 'ag-cell-last-left-pinned');
            utils_1.Utils.addCssClass(this.eFullWidthRowRight, 'ag-cell-first-right-pinned');
        }
        else {
            // otherwise we add to the fullWidth container as normal
            this.eFullWidthRow = this.createRowContainer(this.fullWidthContainerComp, animateInRowTop);
            // and fake the mouse wheel for the fullWidth container
            if (!this.gridOptionsWrapper.isForPrint()) {
                this.addMouseWheelListenerToFullWidthRow();
            }
        }
    };
    RenderedRow.prototype.setupNormalContainers = function (animateInRowTop) {
        this.fullWidthRow = false;
        this.eBodyRow = this.createRowContainer(this.bodyContainerComp, animateInRowTop);
        if (!this.gridOptionsWrapper.isForPrint()) {
            this.ePinnedLeftRow = this.createRowContainer(this.pinnedLeftContainerComp, animateInRowTop);
            this.ePinnedRightRow = this.createRowContainer(this.pinnedRightContainerComp, animateInRowTop);
        }
    };
    RenderedRow.prototype.init = function () {
        var animateInRowTop = this.animateIn && utils_1.Utils.exists(this.rowNode.oldRowTop);
        this.setupRowContainers(animateInRowTop);
        this.scope = this.createChildScopeOrNull(this.rowNode.data);
        if (this.fullWidthRow) {
            this.refreshFullWidthComponent();
        }
        else {
            this.refreshCellsIntoRow();
        }
        this.addGridClasses();
        this.addExpandedAndContractedClasses();
        this.addStyleFromRowStyle();
        this.addStyleFromRowStyleFunc();
        this.addClassesFromRowClass();
        this.addClassesFromRowClassFunc();
        this.addRowIndexes();
        this.addRowIds();
        this.setupTop(animateInRowTop);
        this.setHeight();
        this.addRowSelectedListener();
        this.addCellFocusedListener();
        this.addNodeDataChangedListener();
        this.addColumnListener();
        this.addHoverFunctionality();
        this.gridOptionsWrapper.executeProcessRowPostCreateFunc({
            eRow: this.eBodyRow,
            ePinnedLeftRow: this.ePinnedLeftRow,
            ePinnedRightRow: this.ePinnedRightRow,
            node: this.rowNode,
            api: this.gridOptionsWrapper.getApi(),
            rowIndex: this.rowNode.rowIndex,
            addRenderedRowListener: this.addEventListener.bind(this),
            columnApi: this.gridOptionsWrapper.getColumnApi(),
            context: this.gridOptionsWrapper.getContext()
        });
        this.addDataChangedListener();
        this.initialised = true;
    };
    RenderedRow.prototype.stopRowEditing = function (cancel) {
        this.stopEditing(cancel);
    };
    RenderedRow.prototype.stopEditing = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        this.forEachRenderedCell(function (renderedCell) {
            renderedCell.stopEditing(cancel);
        });
        if (this.editingRow) {
            if (!cancel) {
                var event = {
                    node: this.rowNode,
                    data: this.rowNode.data,
                    api: this.gridOptionsWrapper.getApi(),
                    context: this.gridOptionsWrapper.getContext()
                };
                this.mainEventService.dispatchEvent(events_1.Events.EVENT_ROW_VALUE_CHANGED, event);
            }
            this.setEditingRow(false);
        }
    };
    RenderedRow.prototype.startRowEditing = function (keyPress, charPress, sourceRenderedCell) {
        if (keyPress === void 0) { keyPress = null; }
        if (charPress === void 0) { charPress = null; }
        if (sourceRenderedCell === void 0) { sourceRenderedCell = null; }
        // don't do it if already editing
        if (this.editingRow) {
            return;
        }
        this.forEachRenderedCell(function (renderedCell) {
            var cellStartedEdit = renderedCell === sourceRenderedCell;
            if (cellStartedEdit) {
                renderedCell.startEditingIfEnabled(keyPress, charPress, cellStartedEdit);
            }
            else {
                renderedCell.startEditingIfEnabled(null, null, cellStartedEdit);
            }
        });
        this.setEditingRow(true);
    };
    RenderedRow.prototype.setEditingRow = function (value) {
        this.editingRow = value;
        this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addOrRemoveCssClass(row, 'ag-row-editing', value); });
        var event = value ? events_1.Events.EVENT_ROW_EDITING_STARTED : events_1.Events.EVENT_ROW_EDITING_STOPPED;
        this.mainEventService.dispatchEvent(event, { node: this.rowNode });
    };
    // because data can change, especially in virtual pagination and viewport row models, need to allow setting
    // styles and classes after the data has changed
    RenderedRow.prototype.addDataChangedListener = function () {
        var _this = this;
        var dataChangedListener = function () {
            _this.addStyleFromRowStyleFunc();
            _this.addClassesFromRowClass();
        };
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, dataChangedListener);
    };
    RenderedRow.prototype.angular1Compile = function (element) {
        if (this.scope) {
            this.$compile(element)(this.scope);
        }
    };
    RenderedRow.prototype.addColumnListener = function () {
        var columnListener = this.onDisplayedColumnsChanged.bind(this);
        var virtualListener = this.onVirtualColumnsChanged.bind(this);
        var gridColumnsChangedListener = this.onGridColumnsChanged.bind(this);
        this.addDestroyableEventListener(this.mainEventService, events_1.Events.EVENT_DISPLAYED_COLUMNS_CHANGED, columnListener);
        this.addDestroyableEventListener(this.mainEventService, events_1.Events.EVENT_VIRTUAL_COLUMNS_CHANGED, virtualListener);
        this.addDestroyableEventListener(this.mainEventService, events_1.Events.EVENT_COLUMN_RESIZED, columnListener);
        this.addDestroyableEventListener(this.mainEventService, events_1.Events.EVENT_GRID_COLUMNS_CHANGED, gridColumnsChangedListener);
    };
    RenderedRow.prototype.onDisplayedColumnsChanged = function () {
        // if row is a group row that spans, then it's not impacted by column changes, with exception of pinning
        if (this.fullWidthRow) {
            if (this.gridOptionsWrapper.isEmbedFullWidthRows()) {
                var leftMismatch = this.fullWidthPinnedLeftLastTime !== this.columnController.isPinningLeft();
                var rightMismatch = this.fullWidthPinnedRightLastTime !== this.columnController.isPinningRight();
                // if either of the pinned panels has shown / hidden, then need to redraw the fullWidth bits when
                // embedded, as what appears in each section depends on whether we are pinned or not
                if (leftMismatch || rightMismatch) {
                    this.refreshFullWidthComponent();
                }
            }
            else {
            }
        }
        else {
            this.refreshCellsIntoRow();
        }
    };
    RenderedRow.prototype.onVirtualColumnsChanged = function (event) {
        // if row is a group row that spans, then it's not impacted by column changes, with exception of pinning
        if (!this.fullWidthRow) {
            this.refreshCellsIntoRow();
        }
    };
    // when grid columns change, then all cells should be cleaned out,
    // as the new columns could have same id as the previous columns and may conflict
    RenderedRow.prototype.onGridColumnsChanged = function () {
        var allRenderedCellIds = Object.keys(this.renderedCells);
        this.removeRenderedCells(allRenderedCellIds);
    };
    // method makes sure the right cells are present, and are in the right container. so when this gets called for
    // the first time, it sets up all the cells. but then over time the cells might appear / dissappear or move
    // container (ie into pinned)
    RenderedRow.prototype.refreshCellsIntoRow = function () {
        var _this = this;
        var columns = this.columnController.getAllDisplayedVirtualColumns();
        var renderedCellKeys = Object.keys(this.renderedCells);
        columns.forEach(function (column) {
            var renderedCell = _this.getOrCreateCell(column);
            _this.ensureCellInCorrectRow(renderedCell);
            utils_1.Utils.removeFromArray(renderedCellKeys, column.getColId());
        });
        // remove old cells from gui, but we don't destroy them, we might use them again
        this.removeRenderedCells(renderedCellKeys);
    };
    RenderedRow.prototype.removeRenderedCells = function (colIds) {
        var _this = this;
        colIds.forEach(function (key) {
            var renderedCell = _this.renderedCells[key];
            // could be old reference, ie removed cell
            if (utils_1.Utils.missing(renderedCell)) {
                return;
            }
            if (renderedCell.getParentRow()) {
                renderedCell.getParentRow().removeChild(renderedCell.getGui());
                renderedCell.setParentRow(null);
            }
            renderedCell.destroy();
            _this.renderedCells[key] = null;
        });
    };
    RenderedRow.prototype.ensureCellInCorrectRow = function (renderedCell) {
        var eRowGui = renderedCell.getGui();
        var column = renderedCell.getColumn();
        var rowWeWant;
        switch (column.getPinned()) {
            case column_1.Column.PINNED_LEFT:
                rowWeWant = this.ePinnedLeftRow;
                break;
            case column_1.Column.PINNED_RIGHT:
                rowWeWant = this.ePinnedRightRow;
                break;
            default:
                rowWeWant = this.eBodyRow;
                break;
        }
        // if in wrong container, remove it
        var oldRow = renderedCell.getParentRow();
        var inWrongRow = oldRow !== rowWeWant;
        if (inWrongRow) {
            // take out from old row
            if (oldRow) {
                oldRow.removeChild(eRowGui);
            }
            rowWeWant.appendChild(eRowGui);
            renderedCell.setParentRow(rowWeWant);
        }
    };
    RenderedRow.prototype.getOrCreateCell = function (column) {
        var colId = column.getColId();
        if (this.renderedCells[colId]) {
            return this.renderedCells[colId];
        }
        else {
            var renderedCell = new renderedCell_1.RenderedCell(column, this.rowNode, this.scope, this);
            this.context.wireBean(renderedCell);
            this.renderedCells[colId] = renderedCell;
            this.angular1Compile(renderedCell.getGui());
            // if we are editing the row, then the cell needs to turn
            // into edit mode
            if (this.editingRow) {
                renderedCell.startEditingIfEnabled();
            }
            return renderedCell;
        }
    };
    RenderedRow.prototype.onRowSelected = function () {
        var selected = this.rowNode.isSelected();
        this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addOrRemoveCssClass(row, 'ag-row-selected', selected); });
    };
    RenderedRow.prototype.addRowSelectedListener = function () {
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
    };
    RenderedRow.prototype.onMouseEvent = function (eventName, mouseEvent) {
        switch (eventName) {
            case 'dblclick':
                this.onRowDblClick(mouseEvent);
                break;
            case 'click':
                this.onRowClick(mouseEvent);
                break;
        }
    };
    RenderedRow.prototype.addHoverFunctionality = function () {
        var _this = this;
        // because we are adding listeners to the row, we give the user the choice to not add
        // the hover class, as it slows things down, especially in IE, when you add listeners
        // to each row. we cannot do the trick of adding one listener to the GridPanel (like we
        // do for other mouse events) as these events don't propogate
        if (this.gridOptionsWrapper.isSuppressRowHoverClass()) {
            return;
        }
        var onGuiMouseEnter = this.rowNode.onMouseEnter.bind(this.rowNode);
        var onGuiMouseLeave = this.rowNode.onMouseLeave.bind(this.rowNode);
        this.eAllRowContainers.forEach(function (eRow) {
            _this.addDestroyableEventListener(eRow, 'mouseenter', onGuiMouseEnter);
            _this.addDestroyableEventListener(eRow, 'mouseleave', onGuiMouseLeave);
        });
        var onNodeMouseEnter = this.addHoverClass.bind(this, true);
        var onNodeMouseLeave = this.addHoverClass.bind(this, false);
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_MOUSE_ENTER, onNodeMouseEnter);
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_MOUSE_LEAVE, onNodeMouseLeave);
    };
    RenderedRow.prototype.addHoverClass = function (hover) {
        this.eAllRowContainers.forEach(function (eRow) { return utils_1.Utils.addOrRemoveCssClass(eRow, 'ag-row-hover', hover); });
    };
    RenderedRow.prototype.setRowFocusClasses = function () {
        var rowFocused = this.focusedCellController.isRowFocused(this.rowNode.rowIndex, this.rowNode.floating);
        if (rowFocused !== this.rowFocusedLastTime) {
            this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addOrRemoveCssClass(row, 'ag-row-focus', rowFocused); });
            this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addOrRemoveCssClass(row, 'ag-row-no-focus', !rowFocused); });
            this.rowFocusedLastTime = rowFocused;
        }
        if (!rowFocused && this.editingRow) {
            this.stopEditing(false);
        }
    };
    RenderedRow.prototype.addCellFocusedListener = function () {
        this.addDestroyableEventListener(this.mainEventService, events_1.Events.EVENT_CELL_FOCUSED, this.setRowFocusClasses.bind(this));
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_INDEX_CHANGED, this.setRowFocusClasses.bind(this));
        this.setRowFocusClasses();
    };
    RenderedRow.prototype.forEachRenderedCell = function (callback) {
        utils_1.Utils.iterateObject(this.renderedCells, function (key, renderedCell) {
            if (renderedCell) {
                callback(renderedCell);
            }
        });
    };
    RenderedRow.prototype.addNodeDataChangedListener = function () {
        var _this = this;
        var nodeDataChangedListener = function () {
            var animate = false;
            var newData = true;
            _this.forEachRenderedCell(function (renderedCell) { return renderedCell.refreshCell(animate, newData); });
            // check for selected also, as this could be after lazy loading of the row data, in which csae
            // the id might of just gotten set inside the row and the row selected state may of changed
            // as a result. this is what happens when selected rows are loaded in virtual pagination.
            _this.onRowSelected();
        };
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_DATA_CHANGED, nodeDataChangedListener);
    };
    RenderedRow.prototype.onTopChanged = function () {
        // console.log(`top changed for ${this.rowNode.id} = ${this.rowNode.rowTop}`);
        this.setRowTop(this.rowNode.rowTop);
    };
    RenderedRow.prototype.setRowTop = function (pixels) {
        // need to make sure rowTop is not null, as this can happen if the node was once
        // visible (ie parent group was expanded) but is now not visible
        if (utils_1.Utils.exists(pixels)) {
            var topPx = pixels + "px";
            this.eAllRowContainers.forEach(function (row) { return row.style.top = topPx; });
        }
    };
    RenderedRow.prototype.setupTop = function (animateInRowTop) {
        if (this.gridOptionsWrapper.isForPrint()) {
            return;
        }
        var topChangedListener = this.onTopChanged.bind(this);
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_TOP_CHANGED, topChangedListener);
        if (!animateInRowTop) {
            this.onTopChanged();
        }
    };
    RenderedRow.prototype.setHeight = function () {
        var _this = this;
        var setHeightListener = function () {
            // check for exists first - if the user is resetting the row height, then
            // it will be null (or undefined) momentarily until the next time the flatten
            // stage is called where the row will then update again with a new height
            if (utils_1.Utils.exists(_this.rowNode.rowHeight)) {
                var heightPx = _this.rowNode.rowHeight + 'px';
                _this.eAllRowContainers.forEach(function (row) { return row.style.height = heightPx; });
            }
        };
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_HEIGHT_CHANGED, setHeightListener);
        setHeightListener();
    };
    RenderedRow.prototype.addRowIndexes = function () {
        var _this = this;
        var rowIndexListener = function () {
            var rowStr = _this.rowNode.rowIndex.toString();
            if (_this.rowNode.floating === constants_1.Constants.FLOATING_BOTTOM) {
                rowStr = 'fb-' + rowStr;
            }
            else if (_this.rowNode.floating === constants_1.Constants.FLOATING_TOP) {
                rowStr = 'ft-' + rowStr;
            }
            _this.eAllRowContainers.forEach(function (eRow) {
                eRow.setAttribute('row', rowStr);
                var rowIsEven = _this.rowNode.rowIndex % 2 === 0;
                utils_1.Utils.addOrRemoveCssClass(eRow, 'ag-row-even', rowIsEven);
                utils_1.Utils.addOrRemoveCssClass(eRow, 'ag-row-odd', !rowIsEven);
            });
        };
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_ROW_INDEX_CHANGED, rowIndexListener);
        rowIndexListener();
    };
    // adds in row and row-id attributes to the row
    RenderedRow.prototype.addRowIds = function () {
        if (typeof this.gridOptionsWrapper.getBusinessKeyForNodeFunc() === 'function') {
            var businessKey = this.gridOptionsWrapper.getBusinessKeyForNodeFunc()(this.rowNode);
            if (typeof businessKey === 'string' || typeof businessKey === 'number') {
                this.eAllRowContainers.forEach(function (row) { return row.setAttribute('row-id', businessKey); });
            }
        }
    };
    RenderedRow.prototype.addEventListener = function (eventType, listener) {
        if (!this.renderedRowEventService) {
            this.renderedRowEventService = new eventService_1.EventService();
        }
        this.renderedRowEventService.addEventListener(eventType, listener);
    };
    RenderedRow.prototype.removeEventListener = function (eventType, listener) {
        this.renderedRowEventService.removeEventListener(eventType, listener);
    };
    RenderedRow.prototype.getRenderedCellForColumn = function (column) {
        return this.renderedCells[column.getColId()];
    };
    RenderedRow.prototype.getCellForCol = function (column) {
        var renderedCell = this.renderedCells[column.getColId()];
        if (renderedCell) {
            return renderedCell.getGui();
        }
        else {
            return null;
        }
    };
    RenderedRow.prototype.destroy = function (animate) {
        if (animate === void 0) { animate = false; }
        _super.prototype.destroy.call(this);
        // why do we have this method? shouldn't everything below be added as a destroy func beside
        // the corresponding create logic?
        this.destroyScope();
        this.destroyFullWidthComponent();
        this.forEachRenderedCell(function (renderedCell) { return renderedCell.destroy(); });
        if (animate) {
            this.startRemoveAnimationFunctions.forEach(function (func) { return func(); });
        }
        else {
            // we are not animating, so execute the second stage of removal now.
            // we call getAndClear, so that they are only called once
            var delayedDestroyFunctions = this.getAndClearDelayedDestroyFunctions();
            delayedDestroyFunctions.forEach(function (func) { return func(); });
        }
        if (this.renderedRowEventService) {
            this.renderedRowEventService.dispatchEvent(RenderedRow.EVENT_RENDERED_ROW_REMOVED, { node: this.rowNode });
        }
        var event = { node: this.rowNode, rowIndex: this.rowNode.rowIndex };
        this.mainEventService.dispatchEvent(events_1.Events.EVENT_VIRTUAL_ROW_REMOVED, event);
    };
    RenderedRow.prototype.destroyScope = function () {
        if (this.scope) {
            this.scope.$destroy();
            this.scope = null;
        }
    };
    RenderedRow.prototype.isGroup = function () {
        return this.rowNode.group === true;
    };
    RenderedRow.prototype.refreshFullWidthComponent = function () {
        this.destroyFullWidthComponent();
        this.createFullWidthComponent();
    };
    RenderedRow.prototype.createFullWidthComponent = function () {
        this.fullWidthPinnedLeftLastTime = this.columnController.isPinningLeft();
        this.fullWidthPinnedRightLastTime = this.columnController.isPinningRight();
        if (this.eFullWidthRow) {
            var params = this.createFullWidthParams(this.eFullWidthRow, null);
            this.fullWidthRowComponent = this.cellRendererService.useCellRenderer(this.fullWidthCellRenderer, this.eFullWidthRow, params);
            this.angular1Compile(this.eFullWidthRow);
        }
        if (this.eFullWidthRowBody) {
            var params = this.createFullWidthParams(this.eFullWidthRowBody, null);
            this.fullWidthRowComponentBody = this.cellRendererService.useCellRenderer(this.fullWidthCellRenderer, this.eFullWidthRowBody, params);
            this.angular1Compile(this.eFullWidthRowBody);
        }
        if (this.eFullWidthRowLeft) {
            var params = this.createFullWidthParams(this.eFullWidthRowLeft, column_1.Column.PINNED_LEFT);
            this.fullWidthRowComponentLeft = this.cellRendererService.useCellRenderer(this.fullWidthCellRenderer, this.eFullWidthRowLeft, params);
            this.angular1Compile(this.eFullWidthRowLeft);
        }
        if (this.eFullWidthRowRight) {
            var params = this.createFullWidthParams(this.eFullWidthRowRight, column_1.Column.PINNED_RIGHT);
            this.fullWidthRowComponentRight = this.cellRendererService.useCellRenderer(this.fullWidthCellRenderer, this.eFullWidthRowRight, params);
            this.angular1Compile(this.eFullWidthRowRight);
        }
    };
    RenderedRow.prototype.destroyFullWidthComponent = function () {
        if (this.fullWidthRowComponent) {
            if (this.fullWidthRowComponent.destroy) {
                this.fullWidthRowComponent.destroy();
            }
            this.fullWidthRowComponent = null;
        }
        if (this.fullWidthRowComponentBody) {
            if (this.fullWidthRowComponentBody.destroy) {
                this.fullWidthRowComponentBody.destroy();
            }
            this.fullWidthRowComponent = null;
        }
        if (this.fullWidthRowComponentLeft) {
            if (this.fullWidthRowComponentLeft.destroy) {
                this.fullWidthRowComponentLeft.destroy();
            }
            this.fullWidthRowComponentLeft = null;
        }
        if (this.fullWidthRowComponentRight) {
            if (this.fullWidthRowComponentRight.destroy) {
                this.fullWidthRowComponentRight.destroy();
            }
            this.fullWidthRowComponent = null;
        }
        if (this.eFullWidthRow) {
            utils_1.Utils.removeAllChildren(this.eFullWidthRow);
        }
        if (this.eFullWidthRowBody) {
            utils_1.Utils.removeAllChildren(this.eFullWidthRowBody);
        }
        if (this.eFullWidthRowLeft) {
            utils_1.Utils.removeAllChildren(this.eFullWidthRowLeft);
        }
        if (this.eFullWidthRowRight) {
            utils_1.Utils.removeAllChildren(this.eFullWidthRowRight);
        }
    };
    RenderedRow.prototype.createFullWidthParams = function (eRow, pinned) {
        var params = {
            data: this.rowNode.data,
            node: this.rowNode,
            $scope: this.scope,
            rowIndex: this.rowNode.rowIndex,
            api: this.gridOptionsWrapper.getApi(),
            columnApi: this.gridOptionsWrapper.getColumnApi(),
            context: this.gridOptionsWrapper.getContext(),
            eGridCell: eRow,
            eParentOfValue: eRow,
            pinned: pinned,
            addRenderedRowListener: this.addEventListener.bind(this),
            colDef: {
                cellRenderer: this.fullWidthCellRenderer,
                cellRendererParams: this.fullWidthCellRendererParams
            }
        };
        if (this.fullWidthCellRendererParams) {
            utils_1.Utils.assign(params, this.fullWidthCellRendererParams);
        }
        return params;
    };
    RenderedRow.prototype.createChildScopeOrNull = function (data) {
        if (this.gridOptionsWrapper.isAngularCompileRows()) {
            var newChildScope = this.parentScope.$new();
            newChildScope.data = data;
            newChildScope.rowNode = this.rowNode;
            newChildScope.context = this.gridOptionsWrapper.getContext();
            return newChildScope;
        }
        else {
            return null;
        }
    };
    RenderedRow.prototype.addStyleFromRowStyle = function () {
        var rowStyle = this.gridOptionsWrapper.getRowStyle();
        if (rowStyle) {
            if (typeof rowStyle === 'function') {
                console.log('ag-Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead');
            }
            else {
                this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addStylesToElement(row, rowStyle); });
            }
        }
    };
    RenderedRow.prototype.addStyleFromRowStyleFunc = function () {
        var rowStyleFunc = this.gridOptionsWrapper.getRowStyleFunc();
        if (rowStyleFunc) {
            var params = {
                data: this.rowNode.data,
                node: this.rowNode,
                api: this.gridOptionsWrapper.getApi(),
                context: this.gridOptionsWrapper.getContext(),
                $scope: this.scope
            };
            var cssToUseFromFunc = rowStyleFunc(params);
            this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addStylesToElement(row, cssToUseFromFunc); });
        }
    };
    RenderedRow.prototype.createParams = function () {
        var params = {
            node: this.rowNode,
            data: this.rowNode.data,
            rowIndex: this.rowNode.rowIndex,
            $scope: this.scope,
            context: this.gridOptionsWrapper.getContext(),
            api: this.gridOptionsWrapper.getApi()
        };
        return params;
    };
    RenderedRow.prototype.createEvent = function (event, eventSource) {
        var agEvent = this.createParams();
        agEvent.event = event;
        agEvent.eventSource = eventSource;
        return agEvent;
    };
    RenderedRow.prototype.createRowContainer = function (rowContainerComp, slideRowIn) {
        var _this = this;
        var eRow = document.createElement('div');
        this.addDomData(eRow);
        rowContainerComp.appendRowElement(eRow);
        this.eAllRowContainers.push(eRow);
        this.delayedDestroyFunctions.push(function () {
            rowContainerComp.removeRowElement(eRow);
        });
        this.startRemoveAnimationFunctions.push(function () {
            utils_1.Utils.addCssClass(eRow, 'ag-opacity-zero');
            if (utils_1.Utils.exists(_this.rowNode.rowTop)) {
                var rowTop = _this.roundRowTopToBounds(_this.rowNode.rowTop);
                _this.setRowTop(rowTop);
            }
            // _.prepend(eParent, eRow);
        });
        if (this.animateIn) {
            this.animateRowIn(eRow, slideRowIn);
        }
        return eRow;
    };
    // puts animation into the row by setting start state and then final state in another VM turn
    // (another VM turn so the rendering engine will kick off once with start state, and then transition
    // into the end state)
    RenderedRow.prototype.animateRowIn = function (eRow, slideRowIn) {
        if (slideRowIn) {
            // for sliding the row in, we position the row in it's old position first
            var rowTop = this.roundRowTopToBounds(this.rowNode.oldRowTop);
            this.setRowTop(rowTop);
            // and then update the position to it's new position
            this.nextVmTurnFunctions.push(this.onTopChanged.bind(this));
        }
        else {
            // for fading in, we first set it invisible
            utils_1.Utils.addCssClass(eRow, 'ag-opacity-zero');
            // and then transition to visible
            this.nextVmTurnFunctions.push(function () { return utils_1.Utils.removeCssClass(eRow, 'ag-opacity-zero'); });
        }
    };
    // for animation, we don't want to animate entry or exit to a very far away pixel,
    // otherwise the row would move so fast, it would appear to disappear. so this method
    // moves the row closer to the viewport if it is far away, so the row slide in / out
    // at a speed the user can see.
    RenderedRow.prototype.roundRowTopToBounds = function (rowTop) {
        var range = this.gridPanel.getVerticalPixelRange();
        var minPixel = range.top - 100;
        var maxPixel = range.bottom + 100;
        if (rowTop < minPixel) {
            return minPixel;
        }
        else if (rowTop > maxPixel) {
            return maxPixel;
        }
        else {
            return rowTop;
        }
    };
    RenderedRow.prototype.onRowDblClick = function (event) {
        var agEvent = this.createEvent(event, this);
        this.mainEventService.dispatchEvent(events_1.Events.EVENT_ROW_DOUBLE_CLICKED, agEvent);
    };
    RenderedRow.prototype.onRowClick = function (event) {
        var agEvent = this.createEvent(event, this);
        this.mainEventService.dispatchEvent(events_1.Events.EVENT_ROW_CLICKED, agEvent);
        // ctrlKey for windows, metaKey for Apple
        var multiSelectKeyPressed = event.ctrlKey || event.metaKey;
        var shiftKeyPressed = event.shiftKey;
        // we do not allow selecting groups by clicking (as the click here expands the group)
        // so return if it's a group row
        if (this.rowNode.group) {
            return;
        }
        // we also don't allow selection of floating rows
        if (this.rowNode.floating) {
            return;
        }
        // making local variables to make the below more readable
        var gridOptionsWrapper = this.gridOptionsWrapper;
        // if no selection method enabled, do nothing
        if (!gridOptionsWrapper.isRowSelection()) {
            return;
        }
        // if click selection suppressed, do nothing
        if (gridOptionsWrapper.isSuppressRowClickSelection()) {
            return;
        }
        if (this.rowNode.isSelected()) {
            if (multiSelectKeyPressed) {
                if (gridOptionsWrapper.isRowDeselection()) {
                    this.rowNode.setSelectedParams({ newValue: false });
                }
            }
            else {
                // selected with no multi key, must make sure anything else is unselected
                this.rowNode.setSelectedParams({ newValue: true, clearSelection: true });
            }
        }
        else {
            this.rowNode.setSelectedParams({ newValue: true, clearSelection: !multiSelectKeyPressed, rangeSelect: shiftKeyPressed });
        }
    };
    RenderedRow.prototype.getRowNode = function () {
        return this.rowNode;
    };
    RenderedRow.prototype.refreshCells = function (colIds, animate) {
        if (!colIds) {
            return;
        }
        var columnsToRefresh = this.columnController.getGridColumns(colIds);
        this.forEachRenderedCell(function (renderedCell) {
            var colForCel = renderedCell.getColumn();
            if (columnsToRefresh.indexOf(colForCel) >= 0) {
                renderedCell.refreshCell(animate);
            }
        });
    };
    RenderedRow.prototype.addClassesFromRowClassFunc = function () {
        var _this = this;
        var classes = [];
        var gridOptionsRowClassFunc = this.gridOptionsWrapper.getRowClassFunc();
        if (gridOptionsRowClassFunc) {
            var params = {
                node: this.rowNode,
                data: this.rowNode.data,
                rowIndex: this.rowNode.rowIndex,
                context: this.gridOptionsWrapper.getContext(),
                api: this.gridOptionsWrapper.getApi()
            };
            var classToUseFromFunc = gridOptionsRowClassFunc(params);
            if (classToUseFromFunc) {
                if (typeof classToUseFromFunc === 'string') {
                    classes.push(classToUseFromFunc);
                }
                else if (Array.isArray(classToUseFromFunc)) {
                    classToUseFromFunc.forEach(function (classItem) {
                        classes.push(classItem);
                    });
                }
            }
        }
        classes.forEach(function (classStr) {
            _this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addCssClass(row, classStr); });
        });
    };
    RenderedRow.prototype.addGridClasses = function () {
        var _this = this;
        var classes = [];
        classes.push('ag-row');
        classes.push('ag-row-no-focus');
        if (this.gridOptionsWrapper.isAnimateRows()) {
            classes.push('ag-row-animation');
        }
        else {
            classes.push('ag-row-no-animation');
        }
        if (this.rowNode.isSelected()) {
            classes.push('ag-row-selected');
        }
        if (this.rowNode.group) {
            classes.push('ag-row-group');
            // if a group, put the level of the group in
            classes.push('ag-row-level-' + this.rowNode.level);
            if (this.rowNode.footer) {
                classes.push('ag-row-footer');
            }
        }
        else {
            // if a leaf, and a parent exists, put a level of the parent, else put level of 0 for top level item
            if (this.rowNode.parent) {
                classes.push('ag-row-level-' + (this.rowNode.parent.level + 1));
            }
            else {
                classes.push('ag-row-level-0');
            }
        }
        if (this.fullWidthRow) {
            classes.push('ag-full-width-row');
        }
        classes.forEach(function (classStr) {
            _this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addCssClass(row, classStr); });
        });
    };
    RenderedRow.prototype.addExpandedAndContractedClasses = function () {
        var _this = this;
        var isGroupNode = this.rowNode.group && !this.rowNode.footer;
        if (!isGroupNode) {
            return;
        }
        var listener = function () {
            var expanded = _this.rowNode.expanded;
            _this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addOrRemoveCssClass(row, 'ag-row-group-expanded', expanded); });
            _this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addOrRemoveCssClass(row, 'ag-row-group-contracted', !expanded); });
        };
        this.addDestroyableEventListener(this.rowNode, rowNode_1.RowNode.EVENT_EXPANDED_CHANGED, listener);
    };
    RenderedRow.prototype.addClassesFromRowClass = function () {
        var _this = this;
        var classes = [];
        // add in extra classes provided by the config
        var gridOptionsRowClass = this.gridOptionsWrapper.getRowClass();
        if (gridOptionsRowClass) {
            if (typeof gridOptionsRowClass === 'function') {
                console.warn('ag-Grid: rowClass should not be a function, please use getRowClass instead');
            }
            else {
                if (typeof gridOptionsRowClass === 'string') {
                    classes.push(gridOptionsRowClass);
                }
                else if (Array.isArray(gridOptionsRowClass)) {
                    gridOptionsRowClass.forEach(function (classItem) {
                        classes.push(classItem);
                    });
                }
            }
        }
        classes.forEach(function (classStr) {
            _this.eAllRowContainers.forEach(function (row) { return utils_1.Utils.addCssClass(row, classStr); });
        });
    };
    RenderedRow.EVENT_RENDERED_ROW_REMOVED = 'renderedRowRemoved';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], RenderedRow.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], RenderedRow.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('$compile'), 
        __metadata('design:type', Object)
    ], RenderedRow.prototype, "$compile", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], RenderedRow.prototype, "mainEventService", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], RenderedRow.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'), 
        __metadata('design:type', focusedCellController_1.FocusedCellController)
    ], RenderedRow.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Autowired('cellRendererService'), 
        __metadata('design:type', cellRendererService_1.CellRendererService)
    ], RenderedRow.prototype, "cellRendererService", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], RenderedRow.prototype, "gridPanel", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], RenderedRow.prototype, "init", null);
    return RenderedRow;
}(beanStub_1.BeanStub));
exports.RenderedRow = RenderedRow;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/rowContainerComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
/**
 * There are many instances of this component covering each of the areas a row can be entered
 * eg body, pinned left, fullWidth. The component differs from others in that it's given the
 * elements, there is no template. All of the elements are part of the GridPanel.
 */
var RowContainerComponent = (function () {
    function RowContainerComponent(params) {
        this.childCount = 0;
        this.eContainer = params.eContainer;
        this.eViewport = params.eViewport;
        if (params.useDocumentFragment) {
            this.setupDocumentFragment();
        }
        this.hideWhenNoChildren = params.hideWhenNoChildren;
        this.checkVisibility();
    }
    RowContainerComponent.prototype.setupDocumentFragment = function () {
        var browserSupportsDocumentFragment = !!document.createDocumentFragment;
        if (browserSupportsDocumentFragment) {
            this.eDocumentFragment = document.createDocumentFragment();
        }
    };
    RowContainerComponent.prototype.setHeight = function (height) {
        this.eContainer.style.height = height + "px";
    };
    RowContainerComponent.prototype.appendRowElement = function (eRow) {
        var eTarget = this.eDocumentFragment ? this.eDocumentFragment : this.eContainer;
        eTarget.appendChild(eRow);
        this.childCount++;
        this.checkVisibility();
    };
    RowContainerComponent.prototype.removeRowElement = function (eRow) {
        this.eContainer.removeChild(eRow);
        this.childCount--;
        this.checkVisibility();
    };
    RowContainerComponent.prototype.flushDocumentFragment = function () {
        if (utils_1.Utils.exists(this.eDocumentFragment)) {
            // we prepend rather than append so that new rows appear under current rows. this way the new
            // rows are not over the current rows which will get animation as they slid to new position
            utils_1.Utils.prependDC(this.eContainer, this.eDocumentFragment);
        }
    };
    RowContainerComponent.prototype.checkVisibility = function () {
        if (!this.hideWhenNoChildren) {
            return;
        }
        var eGui = this.eViewport ? this.eViewport : this.eContainer;
        var visible = this.childCount > 0;
        if (this.visible !== visible) {
            this.visible = visible;
            utils_1.Utils.setVisible(eGui, visible);
        }
    };
    return RowContainerComponent;
}());
exports.RowContainerComponent = RowContainerComponent;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/rowRenderer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var expressionService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/expressionService.js");
var templateService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/templateService.js");
var valueService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/valueService.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var floatingRowModel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/floatingRowModel.js");
var renderedRow_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rendering/renderedRow.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridCore_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridCore.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var focusedCellController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/focusedCellController.js");
var cellNavigationService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/cellNavigationService.js");
var gridCell_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/gridCell.js");
var RowRenderer = (function () {
    function RowRenderer() {
        // map of row ids to row objects. keeps track of which elements
        // are rendered for which rows in the dom.
        this.renderedRows = {};
        this.renderedTopFloatingRows = [];
        this.renderedBottomFloatingRows = [];
        // we only allow one refresh at a time, otherwise the internal memory structure here
        // will get messed up. this can happen if the user has a cellRenderer, and inside the
        // renderer they call an API method that results in another pass of the refresh,
        // then it will be trying to draw rows in the middle of a refresh.
        this.refreshInProgress = false;
        this.destroyFunctions = [];
    }
    RowRenderer.prototype.agWire = function (loggerFactory) {
        this.logger = loggerFactory.create('RowRenderer');
    };
    RowRenderer.prototype.init = function () {
        var _this = this;
        this.rowContainers = this.gridPanel.getRowContainers();
        var modelUpdatedListener = this.onModelUpdated.bind(this);
        var floatingRowDataChangedListener = this.onFloatingRowDataChanged.bind(this);
        this.eventService.addEventListener(events_1.Events.EVENT_MODEL_UPDATED, modelUpdatedListener);
        this.eventService.addEventListener(events_1.Events.EVENT_FLOATING_ROW_DATA_CHANGED, floatingRowDataChangedListener);
        this.destroyFunctions.push(function () {
            _this.eventService.removeEventListener(events_1.Events.EVENT_MODEL_UPDATED, modelUpdatedListener);
            _this.eventService.removeEventListener(events_1.Events.EVENT_FLOATING_ROW_DATA_CHANGED, floatingRowDataChangedListener);
        });
        this.refreshView();
    };
    RowRenderer.prototype.getAllCellsForColumn = function (column) {
        var eCells = [];
        utils_1.Utils.iterateObject(this.renderedRows, callback);
        utils_1.Utils.iterateObject(this.renderedBottomFloatingRows, callback);
        utils_1.Utils.iterateObject(this.renderedTopFloatingRows, callback);
        function callback(key, renderedRow) {
            var eCell = renderedRow.getCellForCol(column);
            if (eCell) {
                eCells.push(eCell);
            }
        }
        return eCells;
    };
    RowRenderer.prototype.refreshAllFloatingRows = function () {
        this.refreshFloatingRows(this.renderedTopFloatingRows, this.floatingRowModel.getFloatingTopRowData(), this.rowContainers.floatingTopPinnedLeft, this.rowContainers.floatingTopPinnedRight, this.rowContainers.floatingTop, this.rowContainers.floatingTopFullWidth);
        this.refreshFloatingRows(this.renderedBottomFloatingRows, this.floatingRowModel.getFloatingBottomRowData(), this.rowContainers.floatingBottomPinnedLeft, this.rowContainers.floatingBottomPinnedRight, this.rowContainers.floatingBottom, this.rowContainers.floatingBottomFullWith);
    };
    RowRenderer.prototype.refreshFloatingRows = function (renderedRows, rowNodes, pinnedLeftContainerComp, pinnedRightContainerComp, bodyContainerComp, fullWidthContainerComp) {
        var _this = this;
        renderedRows.forEach(function (row) {
            row.destroy();
        });
        renderedRows.length = 0;
        // if no cols, don't draw row - can we get rid of this???
        var columns = this.columnController.getAllDisplayedColumns();
        if (utils_1.Utils.missingOrEmpty(columns)) {
            return;
        }
        if (rowNodes) {
            rowNodes.forEach(function (node) {
                var renderedRow = new renderedRow_1.RenderedRow(_this.$scope, _this, bodyContainerComp, fullWidthContainerComp, pinnedLeftContainerComp, pinnedRightContainerComp, node, false);
                _this.context.wireBean(renderedRow);
                renderedRows.push(renderedRow);
            });
        }
    };
    RowRenderer.prototype.onFloatingRowDataChanged = function () {
        this.refreshView();
    };
    RowRenderer.prototype.onModelUpdated = function (refreshEvent) {
        this.refreshView(refreshEvent.keepRenderedRows, refreshEvent.animate);
    };
    // if the row nodes are not rendered, no index is returned
    RowRenderer.prototype.getRenderedIndexesForRowNodes = function (rowNodes) {
        var result = [];
        if (utils_1.Utils.missing(rowNodes)) {
            return result;
        }
        utils_1.Utils.iterateObject(this.renderedRows, function (key, renderedRow) {
            var rowNode = renderedRow.getRowNode();
            if (rowNodes.indexOf(rowNode) >= 0) {
                result.push(key);
            }
        });
        return result;
    };
    RowRenderer.prototype.refreshRows = function (rowNodes) {
        if (!rowNodes || rowNodes.length == 0) {
            return;
        }
        // we only need to be worried about rendered rows, as this method is
        // called to whats rendered. if the row isn't rendered, we don't care
        var indexesToRemove = this.getRenderedIndexesForRowNodes(rowNodes);
        // remove the rows
        this.removeVirtualRows(indexesToRemove);
        // add draw them again
        this.refreshView(true, false);
    };
    RowRenderer.prototype.refreshView = function (keepRenderedRows, animate) {
        if (keepRenderedRows === void 0) { keepRenderedRows = false; }
        if (animate === void 0) { animate = false; }
        this.logger.log('refreshView');
        this.getLockOnRefresh();
        var focusedCell = this.focusedCellController.getFocusCellToUseAfterRefresh();
        if (!this.gridOptionsWrapper.isForPrint()) {
            var containerHeight = this.rowModel.getRowCombinedHeight();
            // we need at least 1 pixel for the horizontal scroll to work. so if there are now rows,
            // we still want the scroll to be present, otherwise there would be no way to access the columns
            // on the RHS - and if that was where the filter was that cause no rows to be presented, there
            // is no way to remove the filter.
            if (containerHeight === 0) {
                containerHeight = 1;
            }
            this.rowContainers.body.setHeight(containerHeight);
            this.rowContainers.fullWidth.setHeight(containerHeight);
            this.rowContainers.pinnedLeft.setHeight(containerHeight);
            this.rowContainers.pinnedRight.setHeight(containerHeight);
        }
        this.refreshAllVirtualRows(keepRenderedRows, animate);
        this.refreshAllFloatingRows();
        this.restoreFocusedCell(focusedCell);
        this.releaseLockOnRefresh();
    };
    RowRenderer.prototype.getLockOnRefresh = function () {
        if (this.refreshInProgress) {
            throw 'ag-Grid: cannot get grid to draw rows when it is in the middle of drawing rows. ' +
                'Your code probably called a grid API method while the grid was in the render stage. To overcome ' +
                'this, put the API call into a timeout, eg instead of api.refreshView(), ' +
                'call setTimeout(function(){api.refreshView(),0}). To see what part of your code ' +
                'that caused the refresh check this stacktrace.';
        }
        this.refreshInProgress = true;
    };
    RowRenderer.prototype.releaseLockOnRefresh = function () {
        this.refreshInProgress = false;
    };
    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
    // edited cell).
    RowRenderer.prototype.restoreFocusedCell = function (gridCell) {
        if (gridCell) {
            this.focusedCellController.setFocusedCell(gridCell.rowIndex, gridCell.column, gridCell.floating, true);
        }
    };
    RowRenderer.prototype.softRefreshView = function () {
        var focusedCell = this.focusedCellController.getFocusCellToUseAfterRefresh();
        this.forEachRenderedCell(function (renderedCell) {
            if (renderedCell.isVolatile()) {
                renderedCell.refreshCell();
            }
        });
        this.restoreFocusedCell(focusedCell);
    };
    RowRenderer.prototype.stopEditing = function (cancel) {
        if (cancel === void 0) { cancel = false; }
        this.forEachRenderedRow(function (key, renderedRow) {
            renderedRow.stopEditing(cancel);
        });
    };
    RowRenderer.prototype.forEachRenderedCell = function (callback) {
        utils_1.Utils.iterateObject(this.renderedRows, function (key, renderedRow) {
            renderedRow.forEachRenderedCell(callback);
        });
    };
    RowRenderer.prototype.forEachRenderedRow = function (callback) {
        utils_1.Utils.iterateObject(this.renderedRows, callback);
        utils_1.Utils.iterateObject(this.renderedTopFloatingRows, callback);
        utils_1.Utils.iterateObject(this.renderedBottomFloatingRows, callback);
    };
    RowRenderer.prototype.addRenderedRowListener = function (eventName, rowIndex, callback) {
        var renderedRow = this.renderedRows[rowIndex];
        renderedRow.addEventListener(eventName, callback);
    };
    RowRenderer.prototype.refreshCells = function (rowNodes, colIds, animate) {
        if (animate === void 0) { animate = false; }
        if (!rowNodes || rowNodes.length == 0) {
            return;
        }
        // we only need to be worried about rendered rows, as this method is
        // called to whats rendered. if the row isn't rendered, we don't care
        utils_1.Utils.iterateObject(this.renderedRows, function (key, renderedRow) {
            var rowNode = renderedRow.getRowNode();
            if (rowNodes.indexOf(rowNode) >= 0) {
                renderedRow.refreshCells(colIds, animate);
            }
        });
    };
    RowRenderer.prototype.destroy = function () {
        this.destroyFunctions.forEach(function (func) { return func(); });
        var rowsToRemove = Object.keys(this.renderedRows);
        this.removeVirtualRows(rowsToRemove);
    };
    RowRenderer.prototype.refreshAllVirtualRows = function (keepRenderedRows, animate) {
        var _this = this;
        var rowsToRemove;
        var oldRowsByNodeId = {};
        if (keepRenderedRows) {
            rowsToRemove = [];
            utils_1.Utils.iterateObject(this.renderedRows, function (index, renderedRow) {
                var rowNode = renderedRow.getRowNode();
                if (utils_1.Utils.exists(rowNode.id)) {
                    oldRowsByNodeId[rowNode.id] = renderedRow;
                    delete _this.renderedRows[index];
                }
                else {
                    rowsToRemove.push(index);
                }
            });
        }
        else {
            rowsToRemove = Object.keys(this.renderedRows);
        }
        this.removeVirtualRows(rowsToRemove);
        this.drawVirtualRows(oldRowsByNodeId, animate);
    };
    // public - removes the group rows and then redraws them again
    RowRenderer.prototype.refreshGroupRows = function () {
        var _this = this;
        // find all the group rows
        var rowsToRemove = [];
        Object.keys(this.renderedRows).forEach(function (index) {
            var renderedRow = _this.renderedRows[index];
            if (renderedRow.isGroup()) {
                rowsToRemove.push(index);
            }
        });
        // remove the rows
        this.removeVirtualRows(rowsToRemove);
        // and draw them back again
        this.ensureRowsRendered();
    };
    // takes array of row indexes
    RowRenderer.prototype.removeVirtualRows = function (rowsToRemove) {
        var _this = this;
        // if no fromIndex then set to -1, which will refresh everything
        // var realFromIndex = -1;
        rowsToRemove.forEach(function (indexToRemove) {
            var renderedRow = _this.renderedRows[indexToRemove];
            renderedRow.destroy();
            delete _this.renderedRows[indexToRemove];
        });
    };
    // gets called when rows don't change, but viewport does, so after:
    // 1) size of grid changed
    // 2) grid scrolled to new position
    // 3) ensure index visible (which is a scroll)
    RowRenderer.prototype.drawVirtualRowsWithLock = function () {
        this.getLockOnRefresh();
        this.drawVirtualRows();
        this.releaseLockOnRefresh();
    };
    RowRenderer.prototype.drawVirtualRows = function (oldRowsByNodeId, animate) {
        if (animate === void 0) { animate = false; }
        this.workOutFirstAndLastRowsToRender();
        this.ensureRowsRendered(oldRowsByNodeId, animate);
    };
    RowRenderer.prototype.workOutFirstAndLastRowsToRender = function () {
        var newFirst;
        var newLast;
        if (!this.rowModel.isRowsToRender()) {
            newFirst = 0;
            newLast = -1; // setting to -1 means nothing in range
        }
        else {
            var rowCount = this.rowModel.getRowCount();
            if (this.gridOptionsWrapper.isForPrint()) {
                newFirst = 0;
                newLast = rowCount;
            }
            else {
                var bodyVRange = this.gridPanel.getVerticalPixelRange();
                var topPixel = bodyVRange.top;
                var bottomPixel = bodyVRange.bottom;
                var first = this.rowModel.getRowIndexAtPixel(topPixel);
                var last = this.rowModel.getRowIndexAtPixel(bottomPixel);
                //add in buffer
                var buffer = this.gridOptionsWrapper.getRowBuffer();
                first = first - buffer;
                last = last + buffer;
                // adjust, in case buffer extended actual size
                if (first < 0) {
                    first = 0;
                }
                if (last > rowCount - 1) {
                    last = rowCount - 1;
                }
                newFirst = first;
                newLast = last;
            }
        }
        var firstDiffers = newFirst !== this.firstRenderedRow;
        var lastDiffers = newLast !== this.lastRenderedRow;
        if (firstDiffers || lastDiffers) {
            this.firstRenderedRow = newFirst;
            this.lastRenderedRow = newLast;
            var event = { firstRow: newFirst, lastRow: newLast };
            this.eventService.dispatchEvent(events_1.Events.EVENT_VIEWPORT_CHANGED, event);
        }
    };
    RowRenderer.prototype.getFirstVirtualRenderedRow = function () {
        return this.firstRenderedRow;
    };
    RowRenderer.prototype.getLastVirtualRenderedRow = function () {
        return this.lastRenderedRow;
    };
    RowRenderer.prototype.ensureRowsRendered = function (oldRenderedRowsByNodeId, animate) {
        // var timer = new Timer();
        var _this = this;
        if (animate === void 0) { animate = false; }
        // at the end, this array will contain the items we need to remove
        var rowsToRemove = Object.keys(this.renderedRows);
        // add in new rows
        var delayedCreateFunctions = [];
        for (var rowIndex = this.firstRenderedRow; rowIndex <= this.lastRenderedRow; rowIndex++) {
            // see if item already there, and if yes, take it out of the 'to remove' array
            if (rowsToRemove.indexOf(rowIndex.toString()) >= 0) {
                rowsToRemove.splice(rowsToRemove.indexOf(rowIndex.toString()), 1);
                continue;
            }
            // check this row actually exists (in case overflow buffer window exceeds real data)
            var node = this.rowModel.getRow(rowIndex);
            if (node) {
                var renderedRow = this.getOrCreateRenderedRow(node, oldRenderedRowsByNodeId, animate);
                utils_1.Utils.pushAll(delayedCreateFunctions, renderedRow.getAndClearNextVMTurnFunctions());
                this.renderedRows[rowIndex] = renderedRow;
            }
        }
        setTimeout(function () {
            delayedCreateFunctions.forEach(function (func) { return func(); });
        }, 0);
        // timer.print('creating template');
        // at this point, everything in our 'rowsToRemove' is an old index that needs to be removed
        this.removeVirtualRows(rowsToRemove);
        // and everything in our oldRenderedRowsByNodeId is an old row that is no longer used
        var delayedDestroyFunctions = [];
        utils_1.Utils.iterateObject(oldRenderedRowsByNodeId, function (nodeId, renderedRow) {
            renderedRow.destroy(animate);
            renderedRow.getAndClearDelayedDestroyFunctions().forEach(function (func) { return delayedDestroyFunctions.push(func); });
            delete oldRenderedRowsByNodeId[nodeId];
        });
        setTimeout(function () {
            delayedDestroyFunctions.forEach(function (func) { return func(); });
        }, 400);
        // timer.print('removing');
        this.rowContainers.body.flushDocumentFragment();
        if (!this.gridOptionsWrapper.isForPrint()) {
            this.rowContainers.pinnedLeft.flushDocumentFragment();
            this.rowContainers.pinnedRight.flushDocumentFragment();
        }
        // if we are doing angular compiling, then do digest the scope here
        if (this.gridOptionsWrapper.isAngularCompileRows()) {
            // we do it in a timeout, in case we are already in an apply
            setTimeout(function () { _this.$scope.$apply(); }, 0);
        }
        // timer.print('total');
    };
    RowRenderer.prototype.getOrCreateRenderedRow = function (rowNode, oldRowsByNodeId, animate) {
        var renderedRow;
        if (utils_1.Utils.exists(oldRowsByNodeId) && oldRowsByNodeId[rowNode.id]) {
            renderedRow = oldRowsByNodeId[rowNode.id];
            delete oldRowsByNodeId[rowNode.id];
        }
        else {
            renderedRow = new renderedRow_1.RenderedRow(this.$scope, this, this.rowContainers.body, this.rowContainers.fullWidth, this.rowContainers.pinnedLeft, this.rowContainers.pinnedRight, rowNode, animate);
            this.context.wireBean(renderedRow);
        }
        return renderedRow;
    };
    RowRenderer.prototype.getRenderedNodes = function () {
        var renderedRows = this.renderedRows;
        return Object.keys(renderedRows).map(function (key) {
            return renderedRows[key].getRowNode();
        });
    };
    // we use index for rows, but column object for columns, as the next column (by index) might not
    // be visible (header grouping) so it's not reliable, so using the column object instead.
    RowRenderer.prototype.navigateToNextCell = function (key, rowIndex, column, floating) {
        var previousCell = new gridCell_1.GridCell({ rowIndex: rowIndex, floating: floating, column: column });
        var nextCell = previousCell;
        // we keep searching for a next cell until we find one. this is how the group rows get skipped
        while (true) {
            nextCell = this.cellNavigationService.getNextCellToFocus(key, nextCell);
            if (utils_1.Utils.missing(nextCell)) {
                break;
            }
            var skipGroupRows = this.gridOptionsWrapper.isGroupUseEntireRow();
            if (skipGroupRows) {
                var rowNode = this.rowModel.getRow(nextCell.rowIndex);
                if (!rowNode.group) {
                    break;
                }
            }
            else {
                break;
            }
        }
        // allow user to override what cell to go to next
        var userFunc = this.gridOptionsWrapper.getNavigateToNextCellFunc();
        if (utils_1.Utils.exists(userFunc)) {
            var params = {
                key: key,
                previousCellDef: previousCell,
                nextCellDef: nextCell ? nextCell.getGridCellDef() : null
            };
            var nextCellDef = userFunc(params);
            if (utils_1.Utils.exists(nextCellDef)) {
                nextCell = new gridCell_1.GridCell(nextCellDef);
            }
            else {
                nextCell = null;
            }
        }
        // no next cell means we have reached a grid boundary, eg left, right, top or bottom of grid
        if (!nextCell) {
            return;
        }
        // this scrolls the row into view
        if (utils_1.Utils.missing(nextCell.floating)) {
            this.gridPanel.ensureIndexVisible(nextCell.rowIndex);
        }
        if (!nextCell.column.isPinned()) {
            this.gridPanel.ensureColumnVisible(nextCell.column);
        }
        // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
        // floating cell, the scrolls get out of sync
        this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter();
        this.focusedCellController.setFocusedCell(nextCell.rowIndex, nextCell.column, nextCell.floating, true);
        if (this.rangeController) {
            var gridCell = new gridCell_1.GridCell({ rowIndex: nextCell.rowIndex, floating: nextCell.floating, column: nextCell.column });
            this.rangeController.setRangeToCell(gridCell);
        }
    };
    RowRenderer.prototype.startEditingCell = function (gridCell, keyPress, charPress) {
        var cell = this.getComponentForCell(gridCell);
        cell.startRowOrCellEdit(keyPress, charPress);
    };
    RowRenderer.prototype.getComponentForCell = function (gridCell) {
        var rowComponent;
        switch (gridCell.floating) {
            case constants_1.Constants.FLOATING_TOP:
                rowComponent = this.renderedTopFloatingRows[gridCell.rowIndex];
                break;
            case constants_1.Constants.FLOATING_BOTTOM:
                rowComponent = this.renderedBottomFloatingRows[gridCell.rowIndex];
                break;
            default:
                rowComponent = this.renderedRows[gridCell.rowIndex];
                break;
        }
        if (!rowComponent) {
            return null;
        }
        var cellComponent = rowComponent.getRenderedCellForColumn(gridCell.column);
        return cellComponent;
    };
    RowRenderer.prototype.onTabKeyDown = function (previousRenderedCell, keyboardEvent) {
        var backwards = keyboardEvent.shiftKey;
        var success = this.moveToCellAfter(previousRenderedCell, backwards);
        if (success) {
            keyboardEvent.preventDefault();
        }
    };
    RowRenderer.prototype.tabToNextCell = function (backwards) {
        var focusedCell = this.focusedCellController.getFocusedCell();
        // if no focus, then cannot navigate
        if (utils_1.Utils.missing(focusedCell)) {
            return false;
        }
        var renderedCell = this.getComponentForCell(focusedCell);
        // if cell is not rendered, means user has scrolled away from the cell
        if (utils_1.Utils.missing(renderedCell)) {
            return false;
        }
        var result = this.moveToCellAfter(renderedCell, backwards);
        return result;
    };
    // returns true if moving to next cell was successful
    RowRenderer.prototype.moveToCellAfter = function (previousRenderedCell, backwards) {
        var editing = previousRenderedCell.isEditing();
        var gridCell = previousRenderedCell.getGridCell();
        // find the next cell to start editing
        var nextRenderedCell = this.findNextCellToFocusOn(gridCell, backwards, editing);
        var foundCell = utils_1.Utils.exists(nextRenderedCell);
        // only prevent default if we found a cell. so if user is on last cell and hits tab, then we default
        // to the normal tabbing so user can exit the grid.
        if (foundCell) {
            if (editing) {
                if (this.gridOptionsWrapper.isFullRowEdit()) {
                    this.moveEditToNextRow(previousRenderedCell, nextRenderedCell);
                }
                else {
                    this.moveEditToNextCell(previousRenderedCell, nextRenderedCell);
                }
            }
            else {
                nextRenderedCell.focusCell(true);
            }
            return true;
        }
        else {
            return false;
        }
    };
    RowRenderer.prototype.moveEditToNextCell = function (previousRenderedCell, nextRenderedCell) {
        previousRenderedCell.stopEditing();
        nextRenderedCell.startEditingIfEnabled(null, null, true);
        nextRenderedCell.focusCell(false);
    };
    RowRenderer.prototype.moveEditToNextRow = function (previousRenderedCell, nextRenderedCell) {
        var pGridCell = previousRenderedCell.getGridCell();
        var nGridCell = nextRenderedCell.getGridCell();
        var rowsMatch = (pGridCell.rowIndex === nGridCell.rowIndex)
            && (pGridCell.floating === nGridCell.floating);
        if (rowsMatch) {
            // same row, so we don't start / stop editing, we just move the focus along
            previousRenderedCell.setFocusOutOnEditor();
            nextRenderedCell.setFocusInOnEditor();
        }
        else {
            var pRow = previousRenderedCell.getRenderedRow();
            var nRow = nextRenderedCell.getRenderedRow();
            previousRenderedCell.setFocusOutOnEditor();
            pRow.stopEditing();
            nRow.startRowEditing();
            nextRenderedCell.setFocusInOnEditor();
        }
        nextRenderedCell.focusCell();
    };
    // called by the cell, when tab is pressed while editing.
    // @return: RenderedCell when navigation successful, otherwise null
    RowRenderer.prototype.findNextCellToFocusOn = function (gridCell, backwards, startEditing) {
        var nextCell = gridCell;
        while (true) {
            nextCell = this.cellNavigationService.getNextTabbedCell(nextCell, backwards);
            // allow user to override what cell to go to next
            var userFunc = this.gridOptionsWrapper.getTabToNextCellFunc();
            if (utils_1.Utils.exists(userFunc)) {
                var params = {
                    backwards: backwards,
                    editing: startEditing,
                    previousCellDef: gridCell.getGridCellDef(),
                    nextCellDef: nextCell ? nextCell.getGridCellDef() : null
                };
                var nextCellDef = userFunc(params);
                if (utils_1.Utils.exists(nextCellDef)) {
                    nextCell = new gridCell_1.GridCell(nextCellDef);
                }
                else {
                    nextCell = null;
                }
            }
            // if no 'next cell', means we have got to last cell of grid, so nothing to move to,
            // so bottom right cell going forwards, or top left going backwards
            if (!nextCell) {
                return null;
            }
            // this scrolls the row into view
            var cellIsNotFloating = utils_1.Utils.missing(nextCell.floating);
            if (cellIsNotFloating) {
                this.gridPanel.ensureIndexVisible(nextCell.rowIndex);
            }
            this.gridPanel.ensureColumnVisible(nextCell.column);
            // need to nudge the scrolls for the floating items. otherwise when we set focus on a non-visible
            // floating cell, the scrolls get out of sync
            this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter();
            // we have to call this after ensureColumnVisible - otherwise it could be a virtual column
            // or row that is not currently in view, hence the renderedCell would not exist
            var nextRenderedCell = this.getComponentForCell(nextCell);
            // if editing, but cell not editable, skip cell
            if (startEditing && !nextRenderedCell.isCellEditable()) {
                continue;
            }
            if (nextRenderedCell.isSuppressNavigable()) {
                continue;
            }
            // by default, when we click a cell, it gets selected into a range, so to keep keyboard navigation
            // consistent, we set into range here also.
            if (this.rangeController) {
                var gridCell_2 = new gridCell_1.GridCell({ rowIndex: nextCell.rowIndex, floating: nextCell.floating, column: nextCell.column });
                this.rangeController.setRangeToCell(gridCell_2);
            }
            // we successfully tabbed onto a grid cell, so return true
            return nextRenderedCell;
        }
    };
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], RowRenderer.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], RowRenderer.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('gridCore'), 
        __metadata('design:type', gridCore_1.GridCore)
    ], RowRenderer.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], RowRenderer.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('$compile'), 
        __metadata('design:type', Object)
    ], RowRenderer.prototype, "$compile", void 0);
    __decorate([
        context_1.Autowired('$scope'), 
        __metadata('design:type', Object)
    ], RowRenderer.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('expressionService'), 
        __metadata('design:type', expressionService_1.ExpressionService)
    ], RowRenderer.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('templateService'), 
        __metadata('design:type', templateService_1.TemplateService)
    ], RowRenderer.prototype, "templateService", void 0);
    __decorate([
        context_1.Autowired('valueService'), 
        __metadata('design:type', valueService_1.ValueService)
    ], RowRenderer.prototype, "valueService", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], RowRenderer.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('floatingRowModel'), 
        __metadata('design:type', floatingRowModel_1.FloatingRowModel)
    ], RowRenderer.prototype, "floatingRowModel", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], RowRenderer.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('loggerFactory'), 
        __metadata('design:type', logger_1.LoggerFactory)
    ], RowRenderer.prototype, "loggerFactory", void 0);
    __decorate([
        context_1.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], RowRenderer.prototype, "rowModel", void 0);
    __decorate([
        context_1.Autowired('focusedCellController'), 
        __metadata('design:type', focusedCellController_1.FocusedCellController)
    ], RowRenderer.prototype, "focusedCellController", void 0);
    __decorate([
        context_1.Optional('rangeController'), 
        __metadata('design:type', Object)
    ], RowRenderer.prototype, "rangeController", void 0);
    __decorate([
        context_1.Autowired('cellNavigationService'), 
        __metadata('design:type', cellNavigationService_1.CellNavigationService)
    ], RowRenderer.prototype, "cellNavigationService", void 0);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory]), 
        __metadata('design:returntype', void 0)
    ], RowRenderer.prototype, "agWire", null);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], RowRenderer.prototype, "init", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], RowRenderer.prototype, "destroy", null);
    RowRenderer = __decorate([
        context_1.Bean('rowRenderer'), 
        __metadata('design:paramtypes', [])
    ], RowRenderer);
    return RowRenderer;
}());
exports.RowRenderer = RowRenderer;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rendering/valueFormatterService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var ValueFormatterService = (function () {
    function ValueFormatterService() {
    }
    ValueFormatterService.prototype.formatValue = function (column, rowNode, $scope, rowIndex, value) {
        var formatter;
        var colDef = column.getColDef();
        // if floating, give preference to the floating formatter
        if (rowNode.floating) {
            formatter = colDef.floatingCellFormatter ? colDef.floatingCellFormatter : colDef.cellFormatter;
        }
        else {
            formatter = colDef.cellFormatter;
        }
        var result = null;
        if (formatter) {
            var params = {
                value: value,
                node: rowNode,
                column: column,
                $scope: $scope,
                rowIndex: rowIndex,
                api: this.gridOptionsWrapper.getApi(),
                context: this.gridOptionsWrapper.getContext()
            };
            result = formatter(params);
        }
        return result;
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], ValueFormatterService.prototype, "gridOptionsWrapper", void 0);
    ValueFormatterService = __decorate([
        context_1.Bean('valueFormatterService'), 
        __metadata('design:paramtypes', [])
    ], ValueFormatterService);
    return ValueFormatterService;
}());
exports.ValueFormatterService = ValueFormatterService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/floatingRowModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var context_3 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var FloatingRowModel = (function () {
    function FloatingRowModel() {
    }
    FloatingRowModel.prototype.init = function () {
        this.setFloatingTopRowData(this.gridOptionsWrapper.getFloatingTopRowData());
        this.setFloatingBottomRowData(this.gridOptionsWrapper.getFloatingBottomRowData());
    };
    FloatingRowModel.prototype.isEmpty = function (floating) {
        var rows = floating === constants_1.Constants.FLOATING_TOP ? this.floatingTopRows : this.floatingBottomRows;
        return utils_1.Utils.missingOrEmpty(rows);
    };
    FloatingRowModel.prototype.isRowsToRender = function (floating) {
        return !this.isEmpty(floating);
    };
    FloatingRowModel.prototype.getRowAtPixel = function (pixel, floating) {
        var rows = floating === constants_1.Constants.FLOATING_TOP ? this.floatingTopRows : this.floatingBottomRows;
        if (utils_1.Utils.missingOrEmpty(rows)) {
            return 0; // this should never happen, just in case, 0 is graceful failure
        }
        for (var i = 0; i < rows.length; i++) {
            var rowNode = rows[i];
            var rowTopPixel = rowNode.rowTop + rowNode.rowHeight - 1;
            // only need to range check against the top pixel, as we are going through the list
            // in order, first row to hit the pixel wins
            if (rowTopPixel >= pixel) {
                return i;
            }
        }
        return rows.length - 1;
    };
    FloatingRowModel.prototype.setFloatingTopRowData = function (rowData) {
        this.floatingTopRows = this.createNodesFromData(rowData, true);
        this.eventService.dispatchEvent(events_1.Events.EVENT_FLOATING_ROW_DATA_CHANGED);
    };
    FloatingRowModel.prototype.setFloatingBottomRowData = function (rowData) {
        this.floatingBottomRows = this.createNodesFromData(rowData, false);
        this.eventService.dispatchEvent(events_1.Events.EVENT_FLOATING_ROW_DATA_CHANGED);
    };
    FloatingRowModel.prototype.createNodesFromData = function (allData, isTop) {
        var _this = this;
        var rowNodes = [];
        if (allData) {
            var nextRowTop = 0;
            allData.forEach(function (dataItem, index) {
                var rowNode = new rowNode_1.RowNode();
                _this.context.wireBean(rowNode);
                rowNode.data = dataItem;
                rowNode.floating = isTop ? constants_1.Constants.FLOATING_TOP : constants_1.Constants.FLOATING_BOTTOM;
                rowNode.setRowTop(nextRowTop);
                rowNode.setRowHeight(_this.gridOptionsWrapper.getRowHeightForNode(rowNode));
                rowNode.setRowIndex(index);
                nextRowTop += rowNode.rowHeight;
                rowNodes.push(rowNode);
            });
        }
        return rowNodes;
    };
    FloatingRowModel.prototype.getFloatingTopRowData = function () {
        return this.floatingTopRows;
    };
    FloatingRowModel.prototype.getFloatingBottomRowData = function () {
        return this.floatingBottomRows;
    };
    FloatingRowModel.prototype.getFloatingTopTotalHeight = function () {
        return this.getTotalHeight(this.floatingTopRows);
    };
    FloatingRowModel.prototype.getFloatingTopRowCount = function () {
        return this.floatingTopRows ? this.floatingTopRows.length : 0;
    };
    FloatingRowModel.prototype.getFloatingBottomRowCount = function () {
        return this.floatingBottomRows ? this.floatingBottomRows.length : 0;
    };
    FloatingRowModel.prototype.getFloatingTopRow = function (index) {
        return this.floatingTopRows[index];
    };
    FloatingRowModel.prototype.getFloatingBottomRow = function (index) {
        return this.floatingBottomRows[index];
    };
    FloatingRowModel.prototype.forEachFloatingTopRow = function (callback) {
        if (utils_1.Utils.missingOrEmpty(this.floatingTopRows)) {
            return;
        }
        this.floatingTopRows.forEach(callback);
    };
    FloatingRowModel.prototype.forEachFloatingBottomRow = function (callback) {
        if (utils_1.Utils.missingOrEmpty(this.floatingBottomRows)) {
            return;
        }
        this.floatingBottomRows.forEach(callback);
    };
    FloatingRowModel.prototype.getFloatingBottomTotalHeight = function () {
        return this.getTotalHeight(this.floatingBottomRows);
    };
    FloatingRowModel.prototype.getTotalHeight = function (rowNodes) {
        if (!rowNodes || rowNodes.length === 0) {
            return 0;
        }
        else {
            var lastNode = rowNodes[rowNodes.length - 1];
            return lastNode.rowTop + lastNode.rowHeight;
        }
    };
    __decorate([
        context_2.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], FloatingRowModel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_2.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], FloatingRowModel.prototype, "eventService", void 0);
    __decorate([
        context_2.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], FloatingRowModel.prototype, "context", void 0);
    __decorate([
        context_3.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], FloatingRowModel.prototype, "init", null);
    FloatingRowModel = __decorate([
        context_1.Bean('floatingRowModel'), 
        __metadata('design:paramtypes', [])
    ], FloatingRowModel);
    return FloatingRowModel;
}());
exports.FloatingRowModel = FloatingRowModel;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/inMemory/filterStage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var FilterStage = (function () {
    function FilterStage() {
    }
    FilterStage.prototype.execute = function (rowNode) {
        var filterActive;
        if (this.gridOptionsWrapper.isEnableServerSideFilter()) {
            filterActive = false;
        }
        else {
            filterActive = this.filterManager.isAnyFilterPresent();
        }
        this.recursivelyFilter(rowNode, filterActive);
    };
    FilterStage.prototype.recursivelyFilter = function (rowNode, filterActive) {
        var _this = this;
        // recursively get all children that are groups to also filter
        rowNode.childrenAfterGroup.forEach(function (child) {
            if (child.group) {
                _this.recursivelyFilter(child, filterActive);
            }
        });
        // result of filter for this node
        var filterResult;
        if (filterActive) {
            filterResult = [];
            rowNode.childrenAfterGroup.forEach(function (childNode) {
                if (childNode.group) {
                    // a group is included in the result if it has any children of it's own.
                    // by this stage, the child groups are already filtered
                    if (childNode.childrenAfterFilter.length > 0) {
                        filterResult.push(childNode);
                    }
                }
                else {
                    // a leaf level node is included if it passes the filter
                    if (_this.filterManager.doesRowPassFilter(childNode)) {
                        filterResult.push(childNode);
                    }
                }
            });
        }
        else {
            // if not filtering, the result is the original list
            filterResult = rowNode.childrenAfterGroup;
        }
        rowNode.childrenAfterFilter = filterResult;
        this.setAllChildrenCount(rowNode);
    };
    FilterStage.prototype.setAllChildrenCount = function (rowNode) {
        var allChildrenCount = 0;
        rowNode.childrenAfterFilter.forEach(function (child) {
            if (child.group) {
                allChildrenCount += child.allChildrenCount;
            }
            else {
                allChildrenCount++;
            }
        });
        rowNode.allChildrenCount = allChildrenCount;
    };
    __decorate([
        context_2.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], FilterStage.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_2.Autowired('filterManager'), 
        __metadata('design:type', filterManager_1.FilterManager)
    ], FilterStage.prototype, "filterManager", void 0);
    FilterStage = __decorate([
        context_1.Bean('filterStage'), 
        __metadata('design:paramtypes', [])
    ], FilterStage);
    return FilterStage;
}());
exports.FilterStage = FilterStage;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/inMemory/flattenStage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var FlattenStage = (function () {
    function FlattenStage() {
    }
    FlattenStage.prototype.execute = function (rootNode) {
        // even if not doing grouping, we do the mapping, as the client might
        // of passed in data that already has a grouping in it somewhere
        var result = [];
        // putting value into a wrapper so it's passed by reference
        var nextRowTop = { value: 0 };
        var pivotMode = this.columnController.isPivotMode();
        // if we are reducing, and not grouping, then we want to show the root node, as that
        // is where the pivot values are
        var showRootNode = pivotMode && rootNode.leafGroup;
        var topList = showRootNode ? [rootNode] : rootNode.childrenAfterSort;
        // set all row tops to null, then set row tops on all visible rows. if we don't
        // do this, then the algorithm below only sets row tops, old row tops from old rows
        // will still lie around
        this.resetRowTops(rootNode);
        this.recursivelyAddToRowsToDisplay(topList, result, nextRowTop, pivotMode);
        return result;
    };
    FlattenStage.prototype.resetRowTops = function (rowNode) {
        rowNode.clearRowTop();
        if (rowNode.group) {
            if (rowNode.childrenAfterGroup) {
                for (var i = 0; i < rowNode.childrenAfterGroup.length; i++) {
                    this.resetRowTops(rowNode.childrenAfterGroup[i]);
                }
            }
            if (rowNode.sibling) {
                rowNode.sibling.clearRowTop();
            }
        }
    };
    FlattenStage.prototype.recursivelyAddToRowsToDisplay = function (rowsToFlatten, result, nextRowTop, reduce) {
        if (utils_1.Utils.missingOrEmpty(rowsToFlatten)) {
            return;
        }
        var groupSuppressRow = this.gridOptionsWrapper.isGroupSuppressRow();
        for (var i = 0; i < rowsToFlatten.length; i++) {
            var rowNode = rowsToFlatten[i];
            var skipBecauseSuppressRow = groupSuppressRow && rowNode.group;
            var skipBecauseReduce = reduce && !rowNode.group;
            var skipGroupNode = skipBecauseReduce || skipBecauseSuppressRow;
            if (!skipGroupNode) {
                this.addRowNodeToRowsToDisplay(rowNode, result, nextRowTop);
            }
            if (rowNode.group) {
                if (rowNode.expanded) {
                    this.recursivelyAddToRowsToDisplay(rowNode.childrenAfterSort, result, nextRowTop, reduce);
                    // put a footer in if user is looking for it
                    if (this.gridOptionsWrapper.isGroupIncludeFooter()) {
                        this.ensureFooterNodeExists(rowNode);
                        this.addRowNodeToRowsToDisplay(rowNode.sibling, result, nextRowTop);
                    }
                }
            }
            if (rowNode.canFlower && rowNode.expanded) {
                var flowerNode = this.createFlowerNode(rowNode);
                this.addRowNodeToRowsToDisplay(flowerNode, result, nextRowTop);
            }
        }
    };
    // duplicated method, it's also in floatingRowModel
    FlattenStage.prototype.addRowNodeToRowsToDisplay = function (rowNode, result, nextRowTop) {
        result.push(rowNode);
        if (utils_1.Utils.missing(rowNode.rowHeight)) {
            var rowHeight = this.gridOptionsWrapper.getRowHeightForNode(rowNode);
            rowNode.setRowHeight(rowHeight);
        }
        rowNode.setRowTop(nextRowTop.value);
        rowNode.setRowIndex(result.length - 1);
        nextRowTop.value += rowNode.rowHeight;
    };
    FlattenStage.prototype.ensureFooterNodeExists = function (groupNode) {
        // only create footer node once, otherwise we have daemons and
        // the animate screws up with the daemons hanging around
        if (utils_1.Utils.exists(groupNode.sibling)) {
            return;
        }
        var footerNode = new rowNode_1.RowNode();
        this.context.wireBean(footerNode);
        Object.keys(groupNode).forEach(function (key) {
            footerNode[key] = groupNode[key];
        });
        footerNode.footer = true;
        footerNode.rowTop = null;
        footerNode.oldRowTop = null;
        if (utils_1.Utils.exists(footerNode.id)) {
            footerNode.id = 'rowGroupFooter_' + footerNode.id;
        }
        // get both header and footer to reference each other as siblings. this is never undone,
        // only overwritten. so if a group is expanded, then contracted, it will have a ghost
        // sibling - but that's fine, as we can ignore this if the header is contracted.
        footerNode.sibling = groupNode;
        groupNode.sibling = footerNode;
    };
    FlattenStage.prototype.createFlowerNode = function (parentNode) {
        if (utils_1.Utils.exists(parentNode.childFlower)) {
            return parentNode.childFlower;
        }
        else {
            var flowerNode = new rowNode_1.RowNode();
            this.context.wireBean(flowerNode);
            flowerNode.flower = true;
            flowerNode.parent = parentNode;
            if (utils_1.Utils.exists(parentNode.id)) {
                flowerNode.id = 'flowerNode_' + parentNode.id;
            }
            flowerNode.data = parentNode.data;
            flowerNode.level = parentNode.level + 1;
            parentNode.childFlower = flowerNode;
            return flowerNode;
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], FlattenStage.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('selectionController'), 
        __metadata('design:type', selectionController_1.SelectionController)
    ], FlattenStage.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], FlattenStage.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], FlattenStage.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], FlattenStage.prototype, "columnController", void 0);
    FlattenStage = __decorate([
        context_1.Bean('flattenStage'), 
        __metadata('design:paramtypes', [])
    ], FlattenStage);
    return FlattenStage;
}());
exports.FlattenStage = FlattenStage;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/inMemory/inMemoryNodeManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var InMemoryNodeManager = (function () {
    function InMemoryNodeManager(rootNode, gridOptionsWrapper, context, eventService) {
        this.nextId = 0;
        this.rootNode = rootNode;
        this.gridOptionsWrapper = gridOptionsWrapper;
        this.context = context;
        this.eventService = eventService;
        this.rootNode.group = true;
        this.rootNode.level = -1;
        this.rootNode.allLeafChildren = [];
        this.rootNode.childrenAfterGroup = [];
        this.rootNode.childrenAfterSort = [];
        this.rootNode.childrenAfterFilter = [];
    }
    InMemoryNodeManager.prototype.setRowData = function (rowData, firstId) {
        this.rootNode.childrenAfterFilter = null;
        this.rootNode.childrenAfterGroup = null;
        this.rootNode.childrenAfterSort = null;
        this.rootNode.childrenMapped = null;
        this.nextId = utils_1.Utils.exists(firstId) ? firstId : 0;
        if (!rowData) {
            this.rootNode.allLeafChildren = [];
            this.rootNode.childrenAfterGroup = [];
            return;
        }
        // func below doesn't have 'this' pointer, so need to pull out these bits
        this.getNodeChildDetails = this.gridOptionsWrapper.getNodeChildDetailsFunc();
        this.suppressParentsInRowNodes = this.gridOptionsWrapper.isSuppressParentsInRowNodes();
        this.doesDataFlower = this.gridOptionsWrapper.getDoesDataFlowerFunc();
        var rowsAlreadyGrouped = utils_1.Utils.exists(this.getNodeChildDetails);
        // kick off recursion
        var result = this.recursiveFunction(rowData, null, InMemoryNodeManager.TOP_LEVEL);
        if (rowsAlreadyGrouped) {
            this.rootNode.childrenAfterGroup = result;
            this.setLeafChildren(this.rootNode);
        }
        else {
            this.rootNode.allLeafChildren = result;
        }
    };
    InMemoryNodeManager.prototype.recursiveFunction = function (rowData, parent, level) {
        var _this = this;
        // make sure the rowData is an array and not a string of json - this was a commonly reported problem on the forum
        if (typeof rowData === 'string') {
            console.warn('ag-Grid: rowData must be an array, however you passed in a string. If you are loading JSON, make sure you convert the JSON string to JavaScript objects first');
            return;
        }
        var rowNodes = [];
        rowData.forEach(function (dataItem) {
            var node = _this.createNode(dataItem, parent, level);
            var nodeChildDetails = _this.getNodeChildDetails ? _this.getNodeChildDetails(dataItem) : null;
            if (nodeChildDetails && nodeChildDetails.group) {
                node.group = true;
                node.childrenAfterGroup = _this.recursiveFunction(nodeChildDetails.children, node, level + 1);
                node.expanded = nodeChildDetails.expanded === true;
                node.field = nodeChildDetails.field;
                node.key = nodeChildDetails.key;
                // pull out all the leaf children and add to our node
                _this.setLeafChildren(node);
            }
            rowNodes.push(node);
        });
        return rowNodes;
    };
    InMemoryNodeManager.prototype.createNode = function (dataItem, parent, level) {
        var node = new rowNode_1.RowNode();
        this.context.wireBean(node);
        var nodeChildDetails = this.getNodeChildDetails ? this.getNodeChildDetails(dataItem) : null;
        if (nodeChildDetails && nodeChildDetails.group) {
            node.group = true;
            node.childrenAfterGroup = this.recursiveFunction(nodeChildDetails.children, node, level + 1);
            node.expanded = nodeChildDetails.expanded === true;
            node.field = nodeChildDetails.field;
            node.key = nodeChildDetails.key;
            node.canFlower = false;
            // pull out all the leaf children and add to our node
            this.setLeafChildren(node);
        }
        else {
            node.group = false;
            node.canFlower = this.doesDataFlower ? this.doesDataFlower(dataItem) : false;
            if (node.canFlower) {
                node.expanded = false;
            }
        }
        if (parent && !this.suppressParentsInRowNodes) {
            node.parent = parent;
        }
        node.level = level;
        node.setDataAndId(dataItem, this.nextId.toString());
        this.nextId++;
        return node;
    };
    InMemoryNodeManager.prototype.setLeafChildren = function (node) {
        node.allLeafChildren = [];
        if (node.childrenAfterGroup) {
            node.childrenAfterGroup.forEach(function (childAfterGroup) {
                if (childAfterGroup.group) {
                    if (childAfterGroup.allLeafChildren) {
                        childAfterGroup.allLeafChildren.forEach(function (leafChild) { return node.allLeafChildren.push(leafChild); });
                    }
                }
                else {
                    node.allLeafChildren.push(childAfterGroup);
                }
            });
        }
    };
    InMemoryNodeManager.prototype.insertItemsAtIndex = function (index, rowData) {
        if (this.isRowsAlreadyGrouped()) {
            return null;
        }
        var nodeList = this.rootNode.allLeafChildren;
        if (index > nodeList.length) {
            console.warn("ag-Grid: invalid index " + index + ", max index is " + nodeList.length);
            return;
        }
        var newNodes = [];
        // go through the items backwards, otherwise they get added in reverse order
        for (var i = rowData.length - 1; i >= 0; i--) {
            var data = rowData[i];
            var newNode = this.createNode(data, null, InMemoryNodeManager.TOP_LEVEL);
            utils_1.Utils.insertIntoArray(nodeList, newNode, index);
            newNodes.push(newNode);
        }
        return newNodes.length > 0 ? newNodes : null;
    };
    InMemoryNodeManager.prototype.removeItems = function (rowNodes) {
        if (this.isRowsAlreadyGrouped()) {
            return;
        }
        var nodeList = this.rootNode.allLeafChildren;
        var removedNodes = [];
        rowNodes.forEach(function (rowNode) {
            var indexOfNode = nodeList.indexOf(rowNode);
            if (indexOfNode >= 0) {
                rowNode.setSelected(false);
                nodeList.splice(indexOfNode, 1);
            }
            removedNodes.push(rowNode);
        });
        return removedNodes.length > 0 ? removedNodes : null;
    };
    InMemoryNodeManager.prototype.addItems = function (items) {
        var nodeList = this.rootNode.allLeafChildren;
        return this.insertItemsAtIndex(nodeList.length, items);
    };
    InMemoryNodeManager.prototype.isRowsAlreadyGrouped = function () {
        var rowsAlreadyGrouped = utils_1.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
        if (rowsAlreadyGrouped) {
            console.warn('ag-Grid: adding and removing rows is not supported when using nodeChildDetailsFunc, ie it is not ' +
                'supported if providing groups');
            return true;
        }
        else {
            return false;
        }
    };
    InMemoryNodeManager.TOP_LEVEL = 0;
    return InMemoryNodeManager;
}());
exports.InMemoryNodeManager = InMemoryNodeManager;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/inMemory/inMemoryRowModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var inMemoryNodeManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/inMemory/inMemoryNodeManager.js");
var RecursionType;
(function (RecursionType) {
    RecursionType[RecursionType["Normal"] = 0] = "Normal";
    RecursionType[RecursionType["AfterFilter"] = 1] = "AfterFilter";
    RecursionType[RecursionType["AfterFilterAndSort"] = 2] = "AfterFilterAndSort";
    RecursionType[RecursionType["PivotNodes"] = 3] = "PivotNodes";
})(RecursionType || (RecursionType = {}));
;
var InMemoryRowModel = (function () {
    function InMemoryRowModel() {
    }
    InMemoryRowModel.prototype.init = function () {
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_EVERYTHING_CHANGED, this.refreshModel.bind(this, { step: constants_1.Constants.STEP_EVERYTHING }));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.refreshModel.bind(this, { step: constants_1.Constants.STEP_EVERYTHING }));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, { step: constants_1.Constants.STEP_PIVOT }));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.eventService.addModalPriorityEventListener(events_1.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.refreshModel.bind(this, { step: constants_1.Constants.STEP_PIVOT }));
        this.rootNode = new rowNode_1.RowNode();
        this.nodeManager = new inMemoryNodeManager_1.InMemoryNodeManager(this.rootNode, this.gridOptionsWrapper, this.context, this.eventService);
        this.context.wireBean(this.rootNode);
        if (this.gridOptionsWrapper.isRowModelDefault()) {
            this.setRowData(this.gridOptionsWrapper.getRowData(), this.columnController.isReady());
        }
    };
    InMemoryRowModel.prototype.onRowGroupOpened = function () {
        var animate = this.gridOptionsWrapper.isAnimateRows();
        this.refreshModel({ step: constants_1.Constants.STEP_MAP, keepRenderedRows: true, animate: animate });
    };
    InMemoryRowModel.prototype.onFilterChanged = function () {
        var animate = this.gridOptionsWrapper.isAnimateRows();
        this.refreshModel({ step: constants_1.Constants.STEP_FILTER, keepRenderedRows: true, animate: animate });
    };
    InMemoryRowModel.prototype.onSortChanged = function () {
        // we only act on the sort event here if the user is doing in grid sorting.
        // we ignore it if the sorting is happening on the server side.
        if (this.gridOptionsWrapper.isEnableServerSideSorting()) {
            return;
        }
        var animate = this.gridOptionsWrapper.isAnimateRows();
        this.refreshModel({ step: constants_1.Constants.STEP_SORT, keepRenderedRows: true, animate: animate });
    };
    InMemoryRowModel.prototype.getType = function () {
        return constants_1.Constants.ROW_MODEL_TYPE_NORMAL;
    };
    InMemoryRowModel.prototype.onValueChanged = function () {
        if (this.columnController.isPivotActive()) {
            this.refreshModel({ step: constants_1.Constants.STEP_PIVOT });
        }
        else {
            this.refreshModel({ step: constants_1.Constants.STEP_AGGREGATE });
        }
    };
    InMemoryRowModel.prototype.refreshModel = function (params) {
        // this goes through the pipeline of stages. what's in my head is similar
        // to the diagram on this page:
        // http://commons.apache.org/sandbox/commons-pipeline/pipeline_basics.html
        // however we want to keep the results of each stage, hence we manually call
        // each step rather than have them chain each other.
        var _this = this;
        // fallthrough in below switch is on purpose,
        // eg if STEP_FILTER, then all steps below this
        // step get done
        // var start: number;
        // console.log('======= start =======');
        switch (params.step) {
            case constants_1.Constants.STEP_EVERYTHING:
                // start = new Date().getTime();
                this.doRowGrouping(params.groupState);
            // console.log('rowGrouping = ' + (new Date().getTime() - start));
            case constants_1.Constants.STEP_FILTER:
                // start = new Date().getTime();
                this.doFilter();
            // console.log('filter = ' + (new Date().getTime() - start));
            case constants_1.Constants.STEP_PIVOT:
                this.doPivot();
            case constants_1.Constants.STEP_AGGREGATE:
                // start = new Date().getTime();
                this.doAggregate();
            // console.log('aggregation = ' + (new Date().getTime() - start));
            case constants_1.Constants.STEP_SORT:
                // start = new Date().getTime();
                this.doSort();
            // console.log('sort = ' + (new Date().getTime() - start));
            case constants_1.Constants.STEP_MAP:
                // start = new Date().getTime();
                this.doRowsToDisplay();
        }
        var event = { animate: params.animate, keepRenderedRows: params.keepRenderedRows };
        this.eventService.dispatchEvent(events_1.Events.EVENT_MODEL_UPDATED, event);
        if (this.$scope) {
            setTimeout(function () {
                _this.$scope.$apply();
            }, 0);
        }
    };
    InMemoryRowModel.prototype.isEmpty = function () {
        var rowsMissing;
        var rowsAlreadyGrouped = utils_1.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
        if (rowsAlreadyGrouped) {
            rowsMissing = utils_1.Utils.missing(this.rootNode.childrenAfterGroup) || this.rootNode.childrenAfterGroup.length === 0;
        }
        else {
            rowsMissing = utils_1.Utils.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
        }
        var empty = utils_1.Utils.missing(this.rootNode) || rowsMissing || !this.columnController.isReady();
        return empty;
    };
    InMemoryRowModel.prototype.isRowsToRender = function () {
        return utils_1.Utils.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
    };
    InMemoryRowModel.prototype.setDatasource = function (datasource) {
        console.error('ag-Grid: should never call setDatasource on inMemoryRowController');
    };
    InMemoryRowModel.prototype.getTopLevelNodes = function () {
        return this.rootNode ? this.rootNode.childrenAfterGroup : null;
    };
    InMemoryRowModel.prototype.getRow = function (index) {
        return this.rowsToDisplay[index];
    };
    InMemoryRowModel.prototype.getVirtualRowCount = function () {
        console.warn('ag-Grid: rowModel.getVirtualRowCount() is not longer a function, use rowModel.getRowCount() instead');
        return this.getRowCount();
    };
    InMemoryRowModel.prototype.getRowCount = function () {
        if (this.rowsToDisplay) {
            return this.rowsToDisplay.length;
        }
        else {
            return 0;
        }
    };
    InMemoryRowModel.prototype.getRowIndexAtPixel = function (pixelToMatch) {
        if (this.isEmpty()) {
            return -1;
        }
        // do binary search of tree
        // http://oli.me.uk/2013/06/08/searching-javascript-arrays-with-a-binary-search/
        var bottomPointer = 0;
        var topPointer = this.rowsToDisplay.length - 1;
        // quick check, if the pixel is out of bounds, then return last row
        if (pixelToMatch <= 0) {
            // if pixel is less than or equal zero, it's always the first row
            return 0;
        }
        var lastNode = this.rowsToDisplay[this.rowsToDisplay.length - 1];
        if (lastNode.rowTop <= pixelToMatch) {
            return this.rowsToDisplay.length - 1;
        }
        while (true) {
            var midPointer = Math.floor((bottomPointer + topPointer) / 2);
            var currentRowNode = this.rowsToDisplay[midPointer];
            if (this.isRowInPixel(currentRowNode, pixelToMatch)) {
                return midPointer;
            }
            else if (currentRowNode.rowTop < pixelToMatch) {
                bottomPointer = midPointer + 1;
            }
            else if (currentRowNode.rowTop > pixelToMatch) {
                topPointer = midPointer - 1;
            }
        }
    };
    InMemoryRowModel.prototype.isRowInPixel = function (rowNode, pixelToMatch) {
        var topPixel = rowNode.rowTop;
        var bottomPixel = rowNode.rowTop + rowNode.rowHeight;
        var pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
        return pixelInRow;
    };
    InMemoryRowModel.prototype.getRowCombinedHeight = function () {
        if (this.rowsToDisplay && this.rowsToDisplay.length > 0) {
            var lastRow = this.rowsToDisplay[this.rowsToDisplay.length - 1];
            var lastPixel = lastRow.rowTop + lastRow.rowHeight;
            return lastPixel;
        }
        else {
            return 0;
        }
    };
    InMemoryRowModel.prototype.forEachLeafNode = function (callback) {
        if (this.rootNode.allLeafChildren) {
            this.rootNode.allLeafChildren.forEach(function (rowNode, index) { return callback(rowNode, index); });
        }
    };
    InMemoryRowModel.prototype.forEachNode = function (callback) {
        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterGroup, callback, RecursionType.Normal, 0);
    };
    InMemoryRowModel.prototype.forEachNodeAfterFilter = function (callback) {
        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterFilter, callback, RecursionType.AfterFilter, 0);
    };
    InMemoryRowModel.prototype.forEachNodeAfterFilterAndSort = function (callback) {
        this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterSort, callback, RecursionType.AfterFilterAndSort, 0);
    };
    InMemoryRowModel.prototype.forEachPivotNode = function (callback) {
        this.recursivelyWalkNodesAndCallback([this.rootNode], callback, RecursionType.PivotNodes, 0);
    };
    // iterates through each item in memory, and calls the callback function
    // nodes - the rowNodes to traverse
    // callback - the user provided callback
    // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
    // index - works similar to the index in forEach in javascripts array function
    InMemoryRowModel.prototype.recursivelyWalkNodesAndCallback = function (nodes, callback, recursionType, index) {
        if (nodes) {
            for (var i = 0; i < nodes.length; i++) {
                var node = nodes[i];
                callback(node, index++);
                // go to the next level if it is a group
                if (node.group) {
                    // depending on the recursion type, we pick a difference set of children
                    var nodeChildren;
                    switch (recursionType) {
                        case RecursionType.Normal:
                            nodeChildren = node.childrenAfterGroup;
                            break;
                        case RecursionType.AfterFilter:
                            nodeChildren = node.childrenAfterFilter;
                            break;
                        case RecursionType.AfterFilterAndSort:
                            nodeChildren = node.childrenAfterSort;
                            break;
                        case RecursionType.PivotNodes:
                            // for pivot, we don't go below leafGroup levels
                            nodeChildren = !node.leafGroup ? node.childrenAfterSort : null;
                            break;
                    }
                    if (nodeChildren) {
                        index = this.recursivelyWalkNodesAndCallback(nodeChildren, callback, recursionType, index);
                    }
                }
            }
        }
        return index;
    };
    // it's possible to recompute the aggregate without doing the other parts
    // + gridApi.recomputeAggregates()
    InMemoryRowModel.prototype.doAggregate = function () {
        if (this.aggregationStage) {
            this.aggregationStage.execute(this.rootNode);
        }
    };
    // + gridApi.expandAll()
    // + gridApi.collapseAll()
    InMemoryRowModel.prototype.expandOrCollapseAll = function (expand) {
        if (this.rootNode) {
            recursiveExpandOrCollapse(this.rootNode.childrenAfterGroup);
        }
        function recursiveExpandOrCollapse(rowNodes) {
            if (!rowNodes) {
                return;
            }
            rowNodes.forEach(function (rowNode) {
                if (rowNode.group) {
                    rowNode.expanded = expand;
                    recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
                }
            });
        }
        this.refreshModel({ step: constants_1.Constants.STEP_MAP });
    };
    InMemoryRowModel.prototype.doSort = function () {
        this.sortStage.execute(this.rootNode);
    };
    InMemoryRowModel.prototype.doRowGrouping = function (groupState) {
        // grouping is enterprise only, so if service missing, skip the step
        var rowsAlreadyGrouped = utils_1.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
        if (rowsAlreadyGrouped) {
            return;
        }
        if (this.groupStage) {
            // remove old groups from the selection model, as we are about to replace them
            // with new groups
            this.selectionController.removeGroupsFromSelection();
            this.groupStage.execute(this.rootNode);
            this.restoreGroupState(groupState);
            if (this.gridOptionsWrapper.isGroupSelectsChildren()) {
                this.selectionController.updateGroupsFromChildrenSelections();
            }
        }
        else {
            this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren;
        }
    };
    InMemoryRowModel.prototype.restoreGroupState = function (groupState) {
        if (!groupState) {
            return;
        }
        utils_1.Utils.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) {
            // if the group was open last time, then open it this time. however
            // if was not open last time, then don't touch the group, so the 'groupDefaultExpanded'
            // setting will take effect.
            if (typeof groupState[key] === 'boolean') {
                node.expanded = groupState[key];
            }
        });
    };
    InMemoryRowModel.prototype.doFilter = function () {
        this.filterStage.execute(this.rootNode);
    };
    InMemoryRowModel.prototype.doPivot = function () {
        if (this.pivotStage) {
            this.pivotStage.execute(this.rootNode);
        }
    };
    InMemoryRowModel.prototype.getGroupState = function () {
        if (!this.rootNode.childrenAfterGroup || !this.gridOptionsWrapper.isRememberGroupStateWhenNewData()) {
            return null;
        }
        var result = {};
        utils_1.Utils.traverseNodesWithKey(this.rootNode.childrenAfterGroup, function (node, key) { return result[key] = node.expanded; });
        return result;
    };
    // rows: the rows to put into the model
    // firstId: the first id to use, used for paging, where we are not on the first page
    InMemoryRowModel.prototype.setRowData = function (rowData, refresh, firstId) {
        // remember group state, so we can expand groups that should be expanded
        var groupState = this.getGroupState();
        this.nodeManager.setRowData(rowData, firstId);
        // this event kicks off:
        // - clears selection
        // - updates filters
        // - shows 'no rows' overlay if needed
        this.eventService.dispatchEvent(events_1.Events.EVENT_ROW_DATA_CHANGED);
        if (refresh) {
            this.refreshModel({ step: constants_1.Constants.STEP_EVERYTHING, groupState: groupState });
        }
    };
    InMemoryRowModel.prototype.doRowsToDisplay = function () {
        this.rowsToDisplay = this.flattenStage.execute(this.rootNode);
    };
    InMemoryRowModel.prototype.insertItemsAtIndex = function (index, items) {
        // remember group state, so we can expand groups that should be expanded
        var groupState = this.getGroupState();
        var newNodes = this.nodeManager.insertItemsAtIndex(index, items);
        this.refreshAndFireEvent(events_1.Events.EVENT_ITEMS_ADDED, newNodes, groupState);
    };
    InMemoryRowModel.prototype.onRowHeightChanged = function () {
        this.refreshModel({ step: constants_1.Constants.STEP_MAP, keepRenderedRows: true });
    };
    InMemoryRowModel.prototype.resetRowHeights = function () {
        this.forEachNode(function (rowNode) { return rowNode.setRowHeight(null); });
        this.onRowHeightChanged();
    };
    InMemoryRowModel.prototype.removeItems = function (rowNodes) {
        var groupState = this.getGroupState();
        var removedNodes = this.nodeManager.removeItems(rowNodes);
        this.refreshAndFireEvent(events_1.Events.EVENT_ITEMS_REMOVED, removedNodes, groupState);
    };
    InMemoryRowModel.prototype.addItems = function (items) {
        var groupState = this.getGroupState();
        var newNodes = this.nodeManager.addItems(items);
        this.refreshAndFireEvent(events_1.Events.EVENT_ITEMS_ADDED, newNodes, groupState);
    };
    InMemoryRowModel.prototype.refreshAndFireEvent = function (eventName, rowNodes, groupState) {
        if (rowNodes) {
            this.refreshModel({ step: constants_1.Constants.STEP_EVERYTHING, groupState: groupState });
            this.eventService.dispatchEvent(eventName, { rowNodes: rowNodes });
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], InMemoryRowModel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], InMemoryRowModel.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('filterManager'), 
        __metadata('design:type', filterManager_1.FilterManager)
    ], InMemoryRowModel.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('$scope'), 
        __metadata('design:type', Object)
    ], InMemoryRowModel.prototype, "$scope", void 0);
    __decorate([
        context_1.Autowired('selectionController'), 
        __metadata('design:type', selectionController_1.SelectionController)
    ], InMemoryRowModel.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], InMemoryRowModel.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], InMemoryRowModel.prototype, "context", void 0);
    __decorate([
        context_1.Autowired('filterStage'), 
        __metadata('design:type', Object)
    ], InMemoryRowModel.prototype, "filterStage", void 0);
    __decorate([
        context_1.Autowired('sortStage'), 
        __metadata('design:type', Object)
    ], InMemoryRowModel.prototype, "sortStage", void 0);
    __decorate([
        context_1.Autowired('flattenStage'), 
        __metadata('design:type', Object)
    ], InMemoryRowModel.prototype, "flattenStage", void 0);
    __decorate([
        context_1.Optional('groupStage'), 
        __metadata('design:type', Object)
    ], InMemoryRowModel.prototype, "groupStage", void 0);
    __decorate([
        context_1.Optional('aggregationStage'), 
        __metadata('design:type', Object)
    ], InMemoryRowModel.prototype, "aggregationStage", void 0);
    __decorate([
        context_1.Optional('pivotStage'), 
        __metadata('design:type', Object)
    ], InMemoryRowModel.prototype, "pivotStage", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], InMemoryRowModel.prototype, "init", null);
    InMemoryRowModel = __decorate([
        context_1.Bean('rowModel'), 
        __metadata('design:paramtypes', [])
    ], InMemoryRowModel);
    return InMemoryRowModel;
}());
exports.InMemoryRowModel = InMemoryRowModel;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/inMemory/sortStage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var sortController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/sortController.js");
var valueService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/valueService.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var SortStage = (function () {
    function SortStage() {
    }
    SortStage.prototype.execute = function (rowNode) {
        var sortOptions;
        // if the sorting is already done by the server, then we should not do it here
        if (!this.gridOptionsWrapper.isEnableServerSideSorting()) {
            sortOptions = this.sortController.getSortForRowController();
        }
        this.sortRowNode(rowNode, sortOptions);
    };
    SortStage.prototype.sortRowNode = function (rowNode, sortOptions) {
        var _this = this;
        // sort any groups recursively
        rowNode.childrenAfterFilter.forEach(function (child) {
            if (child.group) {
                _this.sortRowNode(child, sortOptions);
            }
        });
        rowNode.childrenAfterSort = rowNode.childrenAfterFilter.slice(0);
        var sortActive = utils_1.Utils.exists(sortOptions) && sortOptions.length > 0;
        if (sortActive) {
            rowNode.childrenAfterSort.sort(this.compareRowNodes.bind(this, sortOptions));
        }
        this.updateChildIndexes(rowNode);
    };
    SortStage.prototype.compareRowNodes = function (sortOptions, nodeA, nodeB) {
        // Iterate columns, return the first that doesn't match
        for (var i = 0, len = sortOptions.length; i < len; i++) {
            var sortOption = sortOptions[i];
            // var compared = compare(nodeA, nodeB, sortOption.column, sortOption.inverter === -1);
            var isInverted = sortOption.inverter === -1;
            var valueA = this.valueService.getValue(sortOption.column, nodeA);
            var valueB = this.valueService.getValue(sortOption.column, nodeB);
            var comparatorResult;
            if (sortOption.column.getColDef().comparator) {
                //if comparator provided, use it
                comparatorResult = sortOption.column.getColDef().comparator(valueA, valueB, nodeA, nodeB, isInverted);
            }
            else {
                //otherwise do our own comparison
                comparatorResult = utils_1.Utils.defaultComparator(valueA, valueB);
            }
            if (comparatorResult !== 0) {
                return comparatorResult * sortOption.inverter;
            }
        }
        // All matched, these are identical as far as the sort is concerned:
        return 0;
    };
    SortStage.prototype.updateChildIndexes = function (rowNode) {
        if (utils_1.Utils.missing(rowNode.childrenAfterSort)) {
            return;
        }
        rowNode.childrenAfterSort.forEach(function (child, index) {
            child.firstChild = index === 0;
            child.lastChild = index === rowNode.childrenAfterSort.length - 1;
            child.childIndex = index;
        });
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], SortStage.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('sortController'), 
        __metadata('design:type', sortController_1.SortController)
    ], SortStage.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('valueService'), 
        __metadata('design:type', valueService_1.ValueService)
    ], SortStage.prototype, "valueService", void 0);
    SortStage = __decorate([
        context_1.Bean('sortStage'), 
        __metadata('design:paramtypes', [])
    ], SortStage);
    return SortStage;
}());
exports.SortStage = SortStage;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/paginationController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridPanel_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridPanel/gridPanel.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var sortController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/sortController.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var template = '<div class="ag-paging-panel ag-font-style">' +
    '<span id="pageRowSummaryPanel" class="ag-paging-row-summary-panel">' +
    '<span id="firstRowOnPage"></span>' +
    ' [TO] ' +
    '<span id="lastRowOnPage"></span>' +
    ' [OF] ' +
    '<span id="recordCount"></span>' +
    '</span>' +
    '<span class="ag-paging-page-summary-panel">' +
    '<button type="button" class="ag-paging-button" id="btFirst">[FIRST]</button>' +
    '<button type="button" class="ag-paging-button" id="btPrevious">[PREVIOUS]</button>' +
    '[PAGE] ' +
    '<span id="current"></span>' +
    ' [OF] ' +
    '<span id="total"></span>' +
    '<button type="button" class="ag-paging-button" id="btNext">[NEXT]</button>' +
    '<button type="button" class="ag-paging-button" id="btLast">[LAST]</button>' +
    '</span>' +
    '</div>';
var PaginationController = (function () {
    function PaginationController() {
    }
    PaginationController.prototype.init = function () {
        var _this = this;
        // if we are doing pagination, we are guaranteed that the model type
        // is normal. if it is not, then this paginationController service
        // will never be called.
        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_NORMAL) {
            this.inMemoryRowModel = this.rowModel;
        }
        this.setupComponents();
        this.callVersion = 0;
        var paginationEnabled = this.gridOptionsWrapper.isRowModelPagination();
        this.eventService.addEventListener(events_1.Events.EVENT_FILTER_CHANGED, function () {
            if (paginationEnabled && _this.gridOptionsWrapper.isEnableServerSideFilter()) {
                _this.reset(false);
            }
        });
        this.eventService.addEventListener(events_1.Events.EVENT_SORT_CHANGED, function () {
            if (paginationEnabled && _this.gridOptionsWrapper.isEnableServerSideSorting()) {
                _this.reset(false);
            }
        });
        if (paginationEnabled && this.gridOptionsWrapper.getDatasource()) {
            this.setDatasource(this.gridOptionsWrapper.getDatasource());
        }
    };
    PaginationController.prototype.setDatasource = function (datasource) {
        this.datasource = datasource;
        if (!datasource) {
            // only continue if we have a valid datasource to work with
            return;
        }
        this.reset(true);
    };
    PaginationController.prototype.checkForDeprecated = function () {
        var ds = this.datasource;
        if (utils_1.Utils.exists(ds.pageSize)) {
            console.error('ag-Grid: since version 5.1.x, pageSize is replaced with grid property paginationPageSize');
        }
    };
    PaginationController.prototype.reset = function (freshDatasource) {
        // important to return here, as the user could be setting filter or sort before
        // data-source is set
        if (utils_1.Utils.missing(this.datasource)) {
            return;
        }
        this.checkForDeprecated();
        // if user is providing id's, then this means we can keep the selection between datsource hits,
        // as the rows will keep their unique id's even if, for example, server side sorting or filtering
        // is done. if it's a new datasource, then always clear the selection.
        var userGeneratingRows = utils_1.Utils.exists(this.gridOptionsWrapper.getRowNodeIdFunc());
        var resetSelectionController = freshDatasource || !userGeneratingRows;
        if (resetSelectionController) {
            this.selectionController.reset();
        }
        // copy pageSize, to guard against it changing the the datasource between calls
        this.pageSize = this.gridOptionsWrapper.getPaginationPageSize();
        if (!(this.pageSize >= 1)) {
            this.pageSize = 100;
        }
        // see if we know the total number of pages, or if it's 'to be decided'
        if (typeof this.datasource.rowCount === 'number' && this.datasource.rowCount >= 0) {
            this.rowCount = this.datasource.rowCount;
            this.foundMaxRow = true;
            this.calculateTotalPages();
        }
        else {
            this.rowCount = 0;
            this.foundMaxRow = false;
            this.totalPages = null;
        }
        this.currentPage = 0;
        // hide the summary panel until something is loaded
        this.ePageRowSummaryPanel.style.visibility = 'hidden';
        this.setTotalLabels();
        this.loadPage();
    };
    // the native method number.toLocaleString(undefined, {minimumFractionDigits: 0}) puts in decimal places in IE
    PaginationController.prototype.myToLocaleString = function (input) {
        if (typeof input !== 'number') {
            return '';
        }
        else {
            // took this from: http://blog.tompawlak.org/number-currency-formatting-javascript
            return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
    };
    PaginationController.prototype.setTotalLabels = function () {
        if (this.foundMaxRow) {
            this.lbTotal.innerHTML = this.myToLocaleString(this.totalPages);
            this.lbRecordCount.innerHTML = this.myToLocaleString(this.rowCount);
        }
        else {
            var moreText = this.gridOptionsWrapper.getLocaleTextFunc()('more', 'more');
            this.lbTotal.innerHTML = moreText;
            this.lbRecordCount.innerHTML = moreText;
        }
    };
    PaginationController.prototype.calculateTotalPages = function () {
        this.totalPages = Math.floor((this.rowCount - 1) / this.pageSize) + 1;
    };
    PaginationController.prototype.pageLoaded = function (rows, lastRowIndex) {
        var firstId = this.currentPage * this.pageSize;
        this.inMemoryRowModel.setRowData(rows, true, firstId);
        // see if we hit the last row
        if (!this.foundMaxRow && typeof lastRowIndex === 'number' && lastRowIndex >= 0) {
            this.foundMaxRow = true;
            this.rowCount = lastRowIndex;
            this.calculateTotalPages();
            this.setTotalLabels();
            // if overshot pages, go back
            if (this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages - 1;
                this.loadPage();
            }
        }
        this.enableOrDisableButtons();
        this.updateRowLabels();
    };
    PaginationController.prototype.updateRowLabels = function () {
        var startRow;
        var endRow;
        if (this.isZeroPagesToDisplay()) {
            startRow = 0;
            endRow = 0;
        }
        else {
            startRow = (this.pageSize * this.currentPage) + 1;
            endRow = startRow + this.pageSize - 1;
            if (this.foundMaxRow && endRow > this.rowCount) {
                endRow = this.rowCount;
            }
        }
        this.lbFirstRowOnPage.innerHTML = this.myToLocaleString(startRow);
        this.lbLastRowOnPage.innerHTML = this.myToLocaleString(endRow);
        // show the summary panel, when first shown, this is blank
        this.ePageRowSummaryPanel.style.visibility = "";
    };
    PaginationController.prototype.loadPage = function () {
        var _this = this;
        this.enableOrDisableButtons();
        var startRow = this.currentPage * this.pageSize;
        var endRow = (this.currentPage + 1) * this.pageSize;
        this.lbCurrent.innerHTML = this.myToLocaleString(this.currentPage + 1);
        this.callVersion++;
        var callVersionCopy = this.callVersion;
        var that = this;
        this.gridPanel.showLoadingOverlay();
        var sortModel;
        if (this.gridOptionsWrapper.isEnableServerSideSorting()) {
            sortModel = this.sortController.getSortModel();
        }
        var filterModel;
        if (this.gridOptionsWrapper.isEnableServerSideFilter()) {
            filterModel = this.filterManager.getFilterModel();
        }
        var params = {
            startRow: startRow,
            endRow: endRow,
            successCallback: successCallback,
            failCallback: failCallback,
            sortModel: sortModel,
            filterModel: filterModel,
            context: this.gridOptionsWrapper.getContext()
        };
        // check if old version of datasource used
        var getRowsParams = utils_1.Utils.getFunctionParameters(this.datasource.getRows);
        if (getRowsParams.length > 1) {
            console.warn('ag-grid: It looks like your paging datasource is of the old type, taking more than one parameter.');
            console.warn('ag-grid: From ag-grid 1.9.0, now the getRows takes one parameter. See the documentation for details.');
        }
        // put in timeout, to force result to be async
        setTimeout(function () {
            _this.datasource.getRows(params);
        }, 0);
        function successCallback(rows, lastRowIndex) {
            if (that.isCallDaemon(callVersionCopy)) {
                return;
            }
            that.pageLoaded(rows, lastRowIndex);
        }
        function failCallback() {
            if (that.isCallDaemon(callVersionCopy)) {
                return;
            }
            // set in an empty set of rows, this will at
            // least get rid of the loading panel, and
            // stop blocking things
            that.inMemoryRowModel.setRowData([], true);
        }
    };
    PaginationController.prototype.isCallDaemon = function (versionCopy) {
        return versionCopy !== this.callVersion;
    };
    PaginationController.prototype.onBtNext = function () {
        this.currentPage++;
        this.loadPage();
    };
    PaginationController.prototype.onBtPrevious = function () {
        this.currentPage--;
        this.loadPage();
    };
    PaginationController.prototype.onBtFirst = function () {
        this.currentPage = 0;
        this.loadPage();
    };
    PaginationController.prototype.onBtLast = function () {
        this.currentPage = this.totalPages - 1;
        this.loadPage();
    };
    PaginationController.prototype.isZeroPagesToDisplay = function () {
        return this.foundMaxRow && this.totalPages === 0;
    };
    PaginationController.prototype.enableOrDisableButtons = function () {
        var disablePreviousAndFirst = this.currentPage === 0;
        this.btPrevious.disabled = disablePreviousAndFirst;
        this.btFirst.disabled = disablePreviousAndFirst;
        var zeroPagesToDisplay = this.isZeroPagesToDisplay();
        var onLastPage = this.foundMaxRow && this.currentPage === (this.totalPages - 1);
        var disableNext = onLastPage || zeroPagesToDisplay;
        this.btNext.disabled = disableNext;
        var disableLast = !this.foundMaxRow || zeroPagesToDisplay || this.currentPage === (this.totalPages - 1);
        this.btLast.disabled = disableLast;
    };
    PaginationController.prototype.createTemplate = function () {
        var localeTextFunc = this.gridOptionsWrapper.getLocaleTextFunc();
        return template
            .replace('[PAGE]', localeTextFunc('page', 'Page'))
            .replace('[TO]', localeTextFunc('to', 'to'))
            .replace('[OF]', localeTextFunc('of', 'of'))
            .replace('[OF]', localeTextFunc('of', 'of'))
            .replace('[FIRST]', localeTextFunc('first', 'First'))
            .replace('[PREVIOUS]', localeTextFunc('previous', 'Previous'))
            .replace('[NEXT]', localeTextFunc('next', 'Next'))
            .replace('[LAST]', localeTextFunc('last', 'Last'));
    };
    PaginationController.prototype.getGui = function () {
        return this.eGui;
    };
    PaginationController.prototype.setupComponents = function () {
        this.eGui = utils_1.Utils.loadTemplate(this.createTemplate());
        this.btNext = this.eGui.querySelector('#btNext');
        this.btPrevious = this.eGui.querySelector('#btPrevious');
        this.btFirst = this.eGui.querySelector('#btFirst');
        this.btLast = this.eGui.querySelector('#btLast');
        this.lbCurrent = this.eGui.querySelector('#current');
        this.lbTotal = this.eGui.querySelector('#total');
        this.lbRecordCount = this.eGui.querySelector('#recordCount');
        this.lbFirstRowOnPage = this.eGui.querySelector('#firstRowOnPage');
        this.lbLastRowOnPage = this.eGui.querySelector('#lastRowOnPage');
        this.ePageRowSummaryPanel = this.eGui.querySelector('#pageRowSummaryPanel');
        var that = this;
        this.btNext.addEventListener('click', function () {
            that.onBtNext();
        });
        this.btPrevious.addEventListener('click', function () {
            that.onBtPrevious();
        });
        this.btFirst.addEventListener('click', function () {
            that.onBtFirst();
        });
        this.btLast.addEventListener('click', function () {
            that.onBtLast();
        });
    };
    __decorate([
        context_1.Autowired('filterManager'), 
        __metadata('design:type', filterManager_1.FilterManager)
    ], PaginationController.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('gridPanel'), 
        __metadata('design:type', gridPanel_1.GridPanel)
    ], PaginationController.prototype, "gridPanel", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], PaginationController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('selectionController'), 
        __metadata('design:type', selectionController_1.SelectionController)
    ], PaginationController.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('sortController'), 
        __metadata('design:type', sortController_1.SortController)
    ], PaginationController.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], PaginationController.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], PaginationController.prototype, "rowModel", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], PaginationController.prototype, "init", null);
    PaginationController = __decorate([
        context_1.Bean('paginationController'), 
        __metadata('design:paramtypes', [])
    ], PaginationController);
    return PaginationController;
}());
exports.PaginationController = PaginationController;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/virtualPagination/virtualPage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var rowNode_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/rowNode.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var VirtualPage = (function () {
    function VirtualPage(pageNumber, cacheSettings) {
        this.state = VirtualPage.STATE_DIRTY;
        this.version = 0;
        this.localEventService = new eventService_1.EventService();
        this.pageNumber = pageNumber;
        this.cacheParams = cacheSettings;
        // we don't need to calculate these now, as the inputs don't change,
        // however it makes the code easier to read if we work them out up front
        this.startRow = pageNumber * cacheSettings.pageSize;
        this.endRow = this.startRow + cacheSettings.pageSize;
    }
    VirtualPage.prototype.setDirty = function () {
        // in case any current loads in progress, this will have their results ignored
        this.version++;
        this.state = VirtualPage.STATE_DIRTY;
    };
    VirtualPage.prototype.setDirtyAndPurge = function () {
        this.setDirty();
        this.rowNodes.forEach(function (rowNode) {
            rowNode.setData(null);
        });
    };
    VirtualPage.prototype.getStartRow = function () {
        return this.startRow;
    };
    VirtualPage.prototype.getEndRow = function () {
        return this.endRow;
    };
    VirtualPage.prototype.getPageNumber = function () {
        return this.pageNumber;
    };
    VirtualPage.prototype.addEventListener = function (eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    };
    VirtualPage.prototype.removeEventListener = function (eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    };
    VirtualPage.prototype.getLastAccessed = function () {
        return this.lastAccessed;
    };
    VirtualPage.prototype.getState = function () {
        return this.state;
    };
    VirtualPage.prototype.setRowNode = function (rowIndex, rowNode) {
        var localIndex = rowIndex - this.startRow;
        this.rowNodes[localIndex] = rowNode;
        rowNode.setRowIndex(rowIndex);
        this.setTopOnRowNode(rowNode, rowIndex);
    };
    VirtualPage.prototype.setBlankRowNode = function (rowIndex) {
        var localIndex = rowIndex - this.startRow;
        var newRowNode = this.createBlankRowNode(rowIndex);
        this.rowNodes[localIndex] = newRowNode;
        return newRowNode;
    };
    VirtualPage.prototype.setNewData = function (rowIndex, dataItem) {
        var newRowNode = this.setBlankRowNode(rowIndex);
        newRowNode.setDataAndId(dataItem, rowIndex.toString());
        return newRowNode;
    };
    VirtualPage.prototype.init = function () {
        this.createRowNodes();
    };
    // creates empty row nodes, data is missing as not loaded yet
    VirtualPage.prototype.createRowNodes = function () {
        this.rowNodes = [];
        for (var i = 0; i < this.cacheParams.pageSize; i++) {
            var rowIndex = this.startRow + i;
            var rowNode = this.createBlankRowNode(rowIndex);
            this.rowNodes.push(rowNode);
        }
    };
    VirtualPage.prototype.setTopOnRowNode = function (rowNode, rowIndex) {
        rowNode.rowTop = this.cacheParams.rowHeight * rowIndex;
    };
    VirtualPage.prototype.createBlankRowNode = function (rowIndex) {
        var rowNode = new rowNode_1.RowNode();
        this.context.wireBean(rowNode);
        rowNode.setRowHeight(this.cacheParams.rowHeight);
        rowNode.setRowIndex(rowIndex);
        this.setTopOnRowNode(rowNode, rowIndex);
        return rowNode;
    };
    VirtualPage.prototype.getRow = function (rowIndex) {
        this.lastAccessed = this.cacheParams.lastAccessedSequence.next();
        var localIndex = rowIndex - this.startRow;
        return this.rowNodes[localIndex];
    };
    VirtualPage.prototype.load = function () {
        var _this = this;
        this.state = VirtualPage.STATE_LOADING;
        var params = {
            startRow: this.startRow,
            endRow: this.endRow,
            successCallback: this.pageLoaded.bind(this, this.version),
            failCallback: this.pageLoadFailed.bind(this),
            sortModel: this.cacheParams.sortModel,
            filterModel: this.cacheParams.filterModel,
            context: this.gridOptionsWrapper.getContext()
        };
        if (utils_1.Utils.missing(this.cacheParams.datasource.getRows)) {
            console.warn("ag-Grid: datasource is missing getRows method");
            return;
        }
        // check if old version of datasource used
        var getRowsParams = utils_1.Utils.getFunctionParameters(this.cacheParams.datasource.getRows);
        if (getRowsParams.length > 1) {
            console.warn('ag-grid: It looks like your paging datasource is of the old type, taking more than one parameter.');
            console.warn('ag-grid: From ag-grid 1.9.0, now the getRows takes one parameter. See the documentation for details.');
        }
        // put in timeout, to force result to be async
        setTimeout(function () {
            _this.cacheParams.datasource.getRows(params);
        }, 0);
    };
    VirtualPage.prototype.pageLoadFailed = function () {
        this.state = VirtualPage.STATE_FAILED;
        var event = { success: true, page: this };
        this.localEventService.dispatchEvent(VirtualPage.EVENT_LOAD_COMPLETE, event);
    };
    VirtualPage.prototype.populateWithRowData = function (rows) {
        var _this = this;
        this.rowNodes.forEach(function (rowNode, index) {
            var data = rows[index];
            if (utils_1.Utils.exists(data)) {
                // this means if the user is not providing id's we just use the
                // index for the row. this will allow selection to work (that is based
                // on index) as long user is not inserting or deleting rows,
                // or wanting to keep selection between server side sorting or filtering
                var indexOfRow = _this.startRow + index;
                rowNode.setDataAndId(data, indexOfRow.toString());
            }
            else {
                rowNode.setDataAndId(undefined, undefined);
            }
        });
    };
    VirtualPage.prototype.pageLoaded = function (version, rows, lastRow) {
        // we need to check the version, in case there was an old request
        // from the server that was sent before we refreshed the cache,
        // if the load was done as a result of a cache refresh
        if (version === this.version) {
            this.state = VirtualPage.STATE_LOADED;
            this.populateWithRowData(rows);
        }
        // check here if lastrow should be set
        var event = { success: true, page: this, lastRow: lastRow };
        this.localEventService.dispatchEvent(VirtualPage.EVENT_LOAD_COMPLETE, event);
    };
    VirtualPage.EVENT_LOAD_COMPLETE = 'loadComplete';
    VirtualPage.STATE_DIRTY = 'dirty';
    VirtualPage.STATE_LOADING = 'loading';
    VirtualPage.STATE_LOADED = 'loaded';
    VirtualPage.STATE_FAILED = 'failed';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], VirtualPage.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], VirtualPage.prototype, "context", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], VirtualPage.prototype, "init", null);
    return VirtualPage;
}());
exports.VirtualPage = VirtualPage;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/virtualPagination/virtualPageCache.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var virtualPage_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/virtualPagination/virtualPage.js");
var VirtualPageCache = (function () {
    function VirtualPageCache(cacheSettings) {
        this.pages = {};
        this.activePageLoadsCount = 0;
        this.pagesInCacheCount = 0;
        this.maxRowFound = false;
        this.active = true;
        this.cacheParams = cacheSettings;
        this.virtualRowCount = cacheSettings.paginationInitialRowCount;
    }
    VirtualPageCache.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('VirtualPageCache');
    };
    VirtualPageCache.prototype.init = function () {
        // start load of data, as the virtualRowCount will remain at 0 otherwise,
        // so we need this to kick things off, otherwise grid would never call getRow()
        this.getRow(0);
    };
    VirtualPageCache.prototype.getRowCombinedHeight = function () {
        return this.virtualRowCount * this.cacheParams.rowHeight;
    };
    VirtualPageCache.prototype.forEachNode = function (callback) {
        var _this = this;
        var index = 0;
        utils_1.Utils.iterateObject(this.pages, function (key, cachePage) {
            var start = cachePage.getStartRow();
            var end = cachePage.getEndRow();
            for (var rowIndex = start; rowIndex < end; rowIndex++) {
                // we check against virtualRowCount as this page may be the last one, and if it is, then
                // it's probable that the last rows are not part of the set
                if (rowIndex < _this.virtualRowCount) {
                    var rowNode = cachePage.getRow(rowIndex);
                    callback(rowNode, index);
                    index++;
                }
            }
        });
    };
    VirtualPageCache.prototype.getRowIndexAtPixel = function (pixel) {
        if (this.cacheParams.rowHeight !== 0) {
            var rowIndexForPixel = Math.floor(pixel / this.cacheParams.rowHeight);
            if (rowIndexForPixel >= this.virtualRowCount) {
                return this.virtualRowCount - 1;
            }
            else {
                return rowIndexForPixel;
            }
        }
        else {
            return 0;
        }
    };
    VirtualPageCache.prototype.moveItemsDown = function (page, moveFromIndex, moveCount) {
        var startRow = page.getStartRow();
        var endRow = page.getEndRow();
        var indexOfLastRowToMove = moveFromIndex + moveCount;
        // all rows need to be moved down below the insertion index
        for (var currentRowIndex = endRow - 1; currentRowIndex >= startRow; currentRowIndex--) {
            // don't move rows at or before the insertion index
            if (currentRowIndex < indexOfLastRowToMove) {
                continue;
            }
            var indexOfNodeWeWant = currentRowIndex - moveCount;
            var nodeForThisIndex = this.getRow(indexOfNodeWeWant, true);
            if (nodeForThisIndex) {
                page.setRowNode(currentRowIndex, nodeForThisIndex);
            }
            else {
                page.setBlankRowNode(currentRowIndex);
                page.setDirty();
            }
        }
    };
    VirtualPageCache.prototype.insertItems = function (page, indexToInsert, items) {
        var pageStartRow = page.getStartRow();
        var pageEndRow = page.getEndRow();
        var newRowNodes = [];
        // next stage is insert the rows into this page, if applicable
        for (var index = 0; index < items.length; index++) {
            var rowIndex = indexToInsert + index;
            var currentRowInThisPage = rowIndex >= pageStartRow && rowIndex < pageEndRow;
            if (currentRowInThisPage) {
                var dataItem = items[index];
                var newRowNode = page.setNewData(rowIndex, dataItem);
                newRowNodes.push(newRowNode);
            }
        }
        return newRowNodes;
    };
    VirtualPageCache.prototype.insertItemsAtIndex = function (indexToInsert, items) {
        var _this = this;
        // get all page id's as NUMBERS (not strings, as we need to sort as numbers) and in descending order
        var pageIds = Object.keys(this.pages).map(function (str) { return parseInt(str); }).sort().reverse();
        var newNodes = [];
        pageIds.forEach(function (pageId) {
            var page = _this.pages[pageId];
            var pageEndRow = page.getEndRow();
            // if the insertion is after this page, then this page is not impacted
            if (pageEndRow <= indexToInsert) {
                return;
            }
            _this.moveItemsDown(page, indexToInsert, items.length);
            var newNodesThisPage = _this.insertItems(page, indexToInsert, items);
            newNodesThisPage.forEach(function (rowNode) { return newNodes.push(rowNode); });
        });
        if (this.maxRowFound) {
            this.virtualRowCount += items.length;
        }
        this.dispatchModelUpdated();
        this.eventService.dispatchEvent(events_1.Events.EVENT_ITEMS_ADDED, newNodes);
    };
    VirtualPageCache.prototype.getRowCount = function () {
        return this.virtualRowCount;
    };
    VirtualPageCache.prototype.onPageLoaded = function (event) {
        // if we are not active, then we ignore all events, otherwise we could end up getting the
        // grid to refresh even though we are no longer the active cache
        if (!this.active) {
            return;
        }
        this.logger.log("onPageLoaded: page = " + event.page.getPageNumber() + ", lastRow = " + event.lastRow);
        this.activePageLoadsCount--;
        this.checkPageToLoad();
        if (event.success) {
            this.checkVirtualRowCount(event.page, event.lastRow);
        }
    };
    // as we are not a context managed bean, we cannot use @PreDestroy
    VirtualPageCache.prototype.destroy = function () {
        this.active = false;
    };
    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
    // it will want new pages in teh cache as it asks for rows. only when we are inserting /
    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
    VirtualPageCache.prototype.getRow = function (rowIndex, dontCreatePage) {
        if (dontCreatePage === void 0) { dontCreatePage = false; }
        var pageNumber = Math.floor(rowIndex / this.cacheParams.pageSize);
        var page = this.pages[pageNumber];
        if (!page) {
            if (dontCreatePage) {
                return null;
            }
            else {
                page = this.createPage(pageNumber);
            }
        }
        return page.getRow(rowIndex);
    };
    VirtualPageCache.prototype.createPage = function (pageNumber) {
        var newPage = new virtualPage_1.VirtualPage(pageNumber, this.cacheParams);
        this.context.wireBean(newPage);
        newPage.addEventListener(virtualPage_1.VirtualPage.EVENT_LOAD_COMPLETE, this.onPageLoaded.bind(this));
        this.pages[pageNumber] = newPage;
        this.pagesInCacheCount++;
        var needToPurge = utils_1.Utils.exists(this.cacheParams.maxPagesInCache)
            && this.pagesInCacheCount > this.cacheParams.maxPagesInCache;
        if (needToPurge) {
            var lruPage = this.findLeastRecentlyUsedPage(newPage);
            this.removePageFromCache(lruPage);
        }
        this.checkPageToLoad();
        return newPage;
    };
    VirtualPageCache.prototype.removePageFromCache = function (pageToRemove) {
        if (!pageToRemove) {
            return;
        }
        delete this.pages[pageToRemove.getPageNumber()];
        this.pagesInCacheCount--;
        // we do not want to remove the 'loaded' event listener, as the
        // concurrent loads count needs to be updated when the load is complete
        // if the purged page is in loading state
    };
    VirtualPageCache.prototype.printCacheStatus = function () {
        this.logger.log("checkPageToLoad: activePageLoadsCount = " + this.activePageLoadsCount + ", pages = " + JSON.stringify(this.getPageState()));
    };
    VirtualPageCache.prototype.checkPageToLoad = function () {
        this.printCacheStatus();
        if (this.activePageLoadsCount >= this.cacheParams.maxConcurrentDatasourceRequests) {
            this.logger.log("checkPageToLoad: max loads exceeded");
            return;
        }
        var pageToLoad = null;
        utils_1.Utils.iterateObject(this.pages, function (key, cachePage) {
            if (cachePage.getState() === virtualPage_1.VirtualPage.STATE_DIRTY) {
                pageToLoad = cachePage;
            }
        });
        if (pageToLoad) {
            pageToLoad.load();
            this.activePageLoadsCount++;
            this.logger.log("checkPageToLoad: loading page " + pageToLoad.getPageNumber());
            this.printCacheStatus();
        }
        else {
            this.logger.log("checkPageToLoad: no pages to load");
        }
    };
    VirtualPageCache.prototype.findLeastRecentlyUsedPage = function (pageToExclude) {
        var lruPage = null;
        utils_1.Utils.iterateObject(this.pages, function (key, page) {
            // we exclude checking for the page just created, as this has yet to be accessed and hence
            // the lastAccessed stamp will not be updated for the first time yet
            if (page === pageToExclude) {
                return;
            }
            if (utils_1.Utils.missing(lruPage) || page.getLastAccessed() < lruPage.getLastAccessed()) {
                lruPage = page;
            }
        });
        return lruPage;
    };
    VirtualPageCache.prototype.checkVirtualRowCount = function (page, lastRow) {
        // if client provided a last row, we always use it, as it could change between server calls
        // if user deleted data and then called refresh on the grid.
        if (typeof lastRow === 'number' && lastRow >= 0) {
            this.virtualRowCount = lastRow;
            this.maxRowFound = true;
            this.dispatchModelUpdated();
        }
        else if (!this.maxRowFound) {
            // otherwise, see if we need to add some virtual rows
            var lastRowIndex = (page.getPageNumber() + 1) * this.cacheParams.pageSize;
            var lastRowIndexPlusOverflow = lastRowIndex + this.cacheParams.paginationOverflowSize;
            if (this.virtualRowCount < lastRowIndexPlusOverflow) {
                this.virtualRowCount = lastRowIndexPlusOverflow;
                this.dispatchModelUpdated();
            }
        }
    };
    VirtualPageCache.prototype.dispatchModelUpdated = function () {
        if (this.active) {
            this.eventService.dispatchEvent(events_1.Events.EVENT_MODEL_UPDATED);
        }
    };
    VirtualPageCache.prototype.getPageState = function () {
        var result = [];
        utils_1.Utils.iterateObject(this.pages, function (pageNumber, page) {
            result.push({ pageNumber: pageNumber, startRow: page.getStartRow(), endRow: page.getEndRow(), pageStatus: page.getState() });
        });
        return result;
    };
    VirtualPageCache.prototype.refreshVirtualPageCache = function () {
        utils_1.Utils.iterateObject(this.pages, function (pageId, page) {
            page.setDirty();
        });
        this.checkPageToLoad();
    };
    VirtualPageCache.prototype.purgeVirtualPageCache = function () {
        var _this = this;
        var pagesList = utils_1.Utils.values(this.pages);
        pagesList.forEach(function (virtualPage) { return _this.removePageFromCache(virtualPage); });
        this.dispatchModelUpdated();
    };
    VirtualPageCache.prototype.getVirtualRowCount = function () {
        return this.virtualRowCount;
    };
    VirtualPageCache.prototype.isMaxRowFound = function () {
        return this.maxRowFound;
    };
    VirtualPageCache.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
        this.virtualRowCount = rowCount;
        // if undefined is passed, we do not set this value, if one of {true,false}
        // is passed, we do set the value.
        if (utils_1.Utils.exists(maxRowFound)) {
            this.maxRowFound = maxRowFound;
        }
        // if we are still searching, then the row count must not end at the end
        // of a particular page, otherwise the searching will not pop into the
        // next page
        if (!this.maxRowFound) {
            if (this.virtualRowCount % this.cacheParams.pageSize === 0) {
                this.virtualRowCount++;
            }
        }
        this.dispatchModelUpdated();
    };
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], VirtualPageCache.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], VirtualPageCache.prototype, "context", void 0);
    __decorate([
        __param(0, context_1.Qualifier('loggerFactory')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory]), 
        __metadata('design:returntype', void 0)
    ], VirtualPageCache.prototype, "setBeans", null);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], VirtualPageCache.prototype, "init", null);
    return VirtualPageCache;
}());
exports.VirtualPageCache = VirtualPageCache;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/rowControllers/virtualPagination/virtualPageRowModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var selectionController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/selectionController.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var sortController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/sortController.js");
var filterManager_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/filter/filterManager.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var virtualPageCache_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/rowControllers/virtualPagination/virtualPageCache.js");
var VirtualPageRowModel = (function () {
    function VirtualPageRowModel() {
        this.destroyFunctions = [];
    }
    VirtualPageRowModel.prototype.init = function () {
        if (!this.gridOptionsWrapper.isRowModelVirtual()) {
            return;
        }
        this.addEventListeners();
        this.setDatasource(this.gridOptionsWrapper.getDatasource());
    };
    VirtualPageRowModel.prototype.addEventListeners = function () {
        var _this = this;
        var onSortChangedListener = this.onSortChanged.bind(this);
        var onFilterChangedListener = this.onFilterChanged.bind(this);
        this.eventService.addEventListener(events_1.Events.EVENT_FILTER_CHANGED, onFilterChangedListener);
        this.eventService.addEventListener(events_1.Events.EVENT_SORT_CHANGED, onSortChangedListener);
        this.destroyFunctions.push(function () {
            _this.eventService.removeEventListener(events_1.Events.EVENT_FILTER_CHANGED, onFilterChangedListener);
            _this.eventService.removeEventListener(events_1.Events.EVENT_SORT_CHANGED, onSortChangedListener);
        });
    };
    VirtualPageRowModel.prototype.onFilterChanged = function () {
        if (this.gridOptionsWrapper.isEnableServerSideFilter()) {
            this.reset();
        }
    };
    VirtualPageRowModel.prototype.onSortChanged = function () {
        if (this.gridOptionsWrapper.isEnableServerSideSorting()) {
            this.reset();
        }
    };
    VirtualPageRowModel.prototype.destroy = function () {
        this.destroyFunctions.forEach(function (func) { return func(); });
    };
    VirtualPageRowModel.prototype.getType = function () {
        return constants_1.Constants.ROW_MODEL_TYPE_VIRTUAL;
    };
    VirtualPageRowModel.prototype.setDatasource = function (datasource) {
        this.datasource = datasource;
        // only reset if we have a valid datasource to working with
        if (datasource) {
            this.checkForDeprecated();
            this.reset();
        }
    };
    VirtualPageRowModel.prototype.checkForDeprecated = function () {
        var ds = this.datasource;
        // the number of concurrent loads we are allowed to the server
        if (utils_1.Utils.exists(ds.maxConcurrentRequests)) {
            console.error('ag-Grid: since version 5.1.x, maxConcurrentRequests is replaced with grid property maxConcurrentDatasourceRequests');
        }
        if (utils_1.Utils.exists(ds.maxPagesInCache)) {
            console.error('ag-Grid: since version 5.1.x, maxPagesInCache is replaced with grid property maxPagesInPaginationCache');
        }
        if (utils_1.Utils.exists(ds.overflowSize)) {
            console.error('ag-Grid: since version 5.1.x, overflowSize is replaced with grid property paginationOverflowSize');
        }
        if (utils_1.Utils.exists(ds.pageSize)) {
            console.error('ag-Grid: since version 5.1.x, pageSize is replaced with grid property paginationPageSize');
        }
    };
    VirtualPageRowModel.prototype.isEmpty = function () {
        return utils_1.Utils.missing(this.virtualPageCache);
    };
    VirtualPageRowModel.prototype.isRowsToRender = function () {
        return utils_1.Utils.exists(this.virtualPageCache);
    };
    VirtualPageRowModel.prototype.reset = function () {
        // important to return here, as the user could be setting filter or sort before
        // data-source is set
        if (utils_1.Utils.missing(this.datasource)) {
            return;
        }
        // if user is providing id's, then this means we can keep the selection between datsource hits,
        // as the rows will keep their unique id's even if, for example, server side sorting or filtering
        // is done.
        var userGeneratingRows = utils_1.Utils.exists(this.gridOptionsWrapper.getRowNodeIdFunc());
        if (!userGeneratingRows) {
            this.selectionController.reset();
        }
        this.resetCache();
        this.eventService.dispatchEvent(events_1.Events.EVENT_MODEL_UPDATED);
    };
    VirtualPageRowModel.prototype.resetCache = function () {
        var cacheSettings = {
            // the user provided datasource
            datasource: this.datasource,
            // sort and filter model
            filterModel: this.filterManager.getFilterModel(),
            sortModel: this.sortController.getSortModel(),
            // properties - this way we take a snapshot of them, so if user changes any, they will be
            // used next time we create a new cache, which is generally after a filter or sort change,
            // or a new datasource is set
            maxConcurrentDatasourceRequests: this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests(),
            paginationOverflowSize: this.gridOptionsWrapper.getPaginationOverflowSize(),
            paginationInitialRowCount: this.gridOptionsWrapper.getPaginationInitialRowCount(),
            maxPagesInCache: this.gridOptionsWrapper.getMaxPagesInCache(),
            pageSize: this.gridOptionsWrapper.getPaginationPageSize(),
            rowHeight: this.gridOptionsWrapper.getRowHeightAsNumber(),
            // the cache could create this, however it is also used by the pages, so handy to create it
            // here as the settings are also passed to the pages
            lastAccessedSequence: new utils_1.NumberSequence()
        };
        // set defaults
        if (!(cacheSettings.maxConcurrentDatasourceRequests >= 1)) {
            cacheSettings.maxConcurrentDatasourceRequests = 2;
        }
        // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
        // server for one page at a time. so the default if not specified is 100.
        if (!(cacheSettings.pageSize >= 1)) {
            cacheSettings.pageSize = 100;
        }
        // if user doesn't give initial rows to display, we assume zero
        if (!(cacheSettings.paginationInitialRowCount >= 1)) {
            cacheSettings.paginationInitialRowCount = 0;
        }
        // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
        // the current page and request first row of next page
        if (!(cacheSettings.paginationOverflowSize >= 1)) {
            cacheSettings.paginationOverflowSize = 1;
        }
        // if not first time creating a cache, need to destroy the old one
        if (this.virtualPageCache) {
            this.virtualPageCache.destroy();
        }
        this.virtualPageCache = new virtualPageCache_1.VirtualPageCache(cacheSettings);
        this.context.wireBean(this.virtualPageCache);
    };
    VirtualPageRowModel.prototype.getRow = function (rowIndex) {
        return this.virtualPageCache ? this.virtualPageCache.getRow(rowIndex) : null;
    };
    VirtualPageRowModel.prototype.forEachNode = function (callback) {
        if (this.virtualPageCache) {
            this.virtualPageCache.forEachNode(callback);
        }
    };
    VirtualPageRowModel.prototype.getRowCombinedHeight = function () {
        return this.virtualPageCache ? this.virtualPageCache.getRowCombinedHeight() : 0;
    };
    VirtualPageRowModel.prototype.getRowIndexAtPixel = function (pixel) {
        return this.virtualPageCache ? this.virtualPageCache.getRowIndexAtPixel(pixel) : -1;
    };
    VirtualPageRowModel.prototype.getRowCount = function () {
        return this.virtualPageCache ? this.virtualPageCache.getRowCount() : 0;
    };
    VirtualPageRowModel.prototype.insertItemsAtIndex = function (index, items) {
        if (this.virtualPageCache) {
            this.virtualPageCache.insertItemsAtIndex(index, items);
        }
    };
    VirtualPageRowModel.prototype.removeItems = function (rowNodes) {
        console.log('ag-Grid: it is not possible to removeItems when using virtual pagination. Instead use the ' +
            'API to refresh the cache');
    };
    VirtualPageRowModel.prototype.addItems = function (items) {
        console.log('ag-Grid: it is not possible to add items when using virtual pagination as the grid does not ' +
            'know that last index of your data - instead either use insertItemsAtIndex OR refresh the cache.');
    };
    VirtualPageRowModel.prototype.refreshVirtualPageCache = function () {
        if (this.virtualPageCache) {
            this.virtualPageCache.refreshVirtualPageCache();
        }
    };
    VirtualPageRowModel.prototype.purgeVirtualPageCache = function () {
        if (this.virtualPageCache) {
            this.virtualPageCache.purgeVirtualPageCache();
        }
    };
    VirtualPageRowModel.prototype.getVirtualRowCount = function () {
        if (this.virtualPageCache) {
            return this.virtualPageCache.getVirtualRowCount();
        }
        else {
            return null;
        }
    };
    VirtualPageRowModel.prototype.isMaxRowFound = function () {
        if (this.virtualPageCache) {
            return this.virtualPageCache.isMaxRowFound();
        }
    };
    VirtualPageRowModel.prototype.setVirtualRowCount = function (rowCount, maxRowFound) {
        if (this.virtualPageCache) {
            this.virtualPageCache.setVirtualRowCount(rowCount, maxRowFound);
        }
    };
    VirtualPageRowModel.prototype.getVirtualPageState = function () {
        if (this.virtualPageCache) {
            return this.virtualPageCache.getPageState();
        }
        else {
            return null;
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], VirtualPageRowModel.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('filterManager'), 
        __metadata('design:type', filterManager_1.FilterManager)
    ], VirtualPageRowModel.prototype, "filterManager", void 0);
    __decorate([
        context_1.Autowired('sortController'), 
        __metadata('design:type', sortController_1.SortController)
    ], VirtualPageRowModel.prototype, "sortController", void 0);
    __decorate([
        context_1.Autowired('selectionController'), 
        __metadata('design:type', selectionController_1.SelectionController)
    ], VirtualPageRowModel.prototype, "selectionController", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], VirtualPageRowModel.prototype, "eventService", void 0);
    __decorate([
        context_1.Autowired('context'), 
        __metadata('design:type', context_1.Context)
    ], VirtualPageRowModel.prototype, "context", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], VirtualPageRowModel.prototype, "init", null);
    __decorate([
        context_1.PreDestroy, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], VirtualPageRowModel.prototype, "destroy", null);
    VirtualPageRowModel = __decorate([
        context_1.Bean('rowModel'), 
        __metadata('design:paramtypes', [])
    ], VirtualPageRowModel);
    return VirtualPageRowModel;
}());
exports.VirtualPageRowModel = VirtualPageRowModel;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/selectionController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var logger_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/logger.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var context_3 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var context_4 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var SelectionController = (function () {
    function SelectionController() {
    }
    SelectionController.prototype.setBeans = function (loggerFactory) {
        this.logger = loggerFactory.create('SelectionController');
        this.reset();
        if (this.gridOptionsWrapper.isRowModelDefault()) {
            this.eventService.addEventListener(events_1.Events.EVENT_ROW_DATA_CHANGED, this.reset.bind(this));
        }
        else {
            this.logger.log('dont know what to do here');
        }
    };
    SelectionController.prototype.init = function () {
        this.groupSelectsChildren = this.gridOptionsWrapper.isGroupSelectsChildren();
        this.eventService.addEventListener(events_1.Events.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
    };
    SelectionController.prototype.setLastSelectedNode = function (rowNode) {
        this.lastSelectedNode = rowNode;
    };
    SelectionController.prototype.getLastSelectedNode = function () {
        return this.lastSelectedNode;
    };
    SelectionController.prototype.getSelectedNodes = function () {
        var selectedNodes = [];
        utils_1.Utils.iterateObject(this.selectedNodes, function (key, rowNode) {
            if (rowNode) {
                selectedNodes.push(rowNode);
            }
        });
        return selectedNodes;
    };
    SelectionController.prototype.getSelectedRows = function () {
        var selectedRows = [];
        utils_1.Utils.iterateObject(this.selectedNodes, function (key, rowNode) {
            if (rowNode) {
                selectedRows.push(rowNode.data);
            }
        });
        return selectedRows;
    };
    SelectionController.prototype.removeGroupsFromSelection = function () {
        var _this = this;
        utils_1.Utils.iterateObject(this.selectedNodes, function (key, rowNode) {
            if (rowNode && rowNode.group) {
                _this.selectedNodes[rowNode.id] = undefined;
            }
        });
    };
    // should only be called if groupSelectsChildren=true
    SelectionController.prototype.updateGroupsFromChildrenSelections = function () {
        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_NORMAL) {
            console.warn('updateGroupsFromChildrenSelections not available when rowModel is not normal');
        }
        var inMemoryRowModel = this.rowModel;
        inMemoryRowModel.getTopLevelNodes().forEach(function (rowNode) {
            rowNode.depthFirstSearch(function (rowNode) {
                if (rowNode.group) {
                    rowNode.calculateSelectedFromChildren();
                }
            });
        });
    };
    SelectionController.prototype.getNodeForIdIfSelected = function (id) {
        return this.selectedNodes[id];
    };
    SelectionController.prototype.clearOtherNodes = function (rowNodeToKeepSelected) {
        var _this = this;
        var groupsToRefresh = {};
        var updatedCount = 0;
        utils_1.Utils.iterateObject(this.selectedNodes, function (key, otherRowNode) {
            if (otherRowNode && otherRowNode.id !== rowNodeToKeepSelected.id) {
                var rowNode = _this.selectedNodes[otherRowNode.id];
                updatedCount += rowNode.setSelectedParams({ newValue: false, clearSelection: false, tailingNodeInSequence: true });
                if (_this.groupSelectsChildren && otherRowNode.parent) {
                    groupsToRefresh[otherRowNode.parent.id] = otherRowNode.parent;
                }
            }
        });
        utils_1.Utils.iterateObject(groupsToRefresh, function (key, group) {
            group.calculateSelectedFromChildren();
        });
        return updatedCount;
    };
    SelectionController.prototype.onRowSelected = function (event) {
        var rowNode = event.node;
        // we do not store the group rows when the groups select children
        if (this.groupSelectsChildren && rowNode.group) {
            return;
        }
        if (rowNode.isSelected()) {
            this.selectedNodes[rowNode.id] = rowNode;
        }
        else {
            this.selectedNodes[rowNode.id] = undefined;
        }
    };
    SelectionController.prototype.syncInRowNode = function (rowNode, oldNode) {
        this.syncInOldRowNode(rowNode, oldNode);
        this.syncInNewRowNode(rowNode);
    };
    // if the id has changed for the node, then this means the rowNode
    // is getting used for a different data item, which breaks
    // our selectedNodes, as the node now is mapped by the old id
    // which is inconsistent. so to keep the old node as selected,
    // we swap in the clone (with the old id and old data). this means
    // the oldNode is effectively a daemon we keep a reference to,
    // so if client calls api.getSelectedNodes(), it gets the daemon
    // in the result. when the client un-selects, the reference to the
    // daemon is removed. the daemon, because it's an oldNode, is not
    // used by the grid for rendering, it's a copy of what the node used
    // to be like before the id was changed.
    SelectionController.prototype.syncInOldRowNode = function (rowNode, oldNode) {
        var oldNodeHasDifferentId = utils_1.Utils.exists(oldNode) && (rowNode.id !== oldNode.id);
        if (oldNodeHasDifferentId) {
            var oldNodeSelected = utils_1.Utils.exists(this.selectedNodes[oldNode.id]);
            if (oldNodeSelected) {
                this.selectedNodes[oldNode.id] = oldNode;
            }
        }
    };
    SelectionController.prototype.syncInNewRowNode = function (rowNode) {
        if (utils_1.Utils.exists(this.selectedNodes[rowNode.id])) {
            rowNode.setSelectedInitialValue(true);
            this.selectedNodes[rowNode.id] = rowNode;
        }
        else {
            rowNode.setSelectedInitialValue(false);
        }
    };
    SelectionController.prototype.reset = function () {
        this.logger.log('reset');
        this.selectedNodes = {};
        this.lastSelectedNode = null;
    };
    // returns a list of all nodes at 'best cost' - a feature to be used
    // with groups / trees. if a group has all it's children selected,
    // then the group appears in the result, but not the children.
    // Designed for use with 'children' as the group selection type,
    // where groups don't actually appear in the selection normally.
    SelectionController.prototype.getBestCostNodeSelection = function () {
        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_NORMAL) {
            console.warn('getBestCostNodeSelection is only avilable when using normal row model');
        }
        var inMemoryRowModel = this.rowModel;
        var topLevelNodes = inMemoryRowModel.getTopLevelNodes();
        if (topLevelNodes === null) {
            console.warn('selectAll not available doing rowModel=virtual');
            return;
        }
        var result = [];
        // recursive function, to find the selected nodes
        function traverse(nodes) {
            for (var i = 0, l = nodes.length; i < l; i++) {
                var node = nodes[i];
                if (node.isSelected()) {
                    result.push(node);
                }
                else {
                    // if not selected, then if it's a group, and the group
                    // has children, continue to search for selections
                    if (node.group && node.children) {
                        traverse(node.children);
                    }
                }
            }
        }
        traverse(topLevelNodes);
        return result;
    };
    SelectionController.prototype.setRowModel = function (rowModel) {
        this.rowModel = rowModel;
    };
    SelectionController.prototype.isEmpty = function () {
        var count = 0;
        utils_1.Utils.iterateObject(this.selectedNodes, function (nodeId, rowNode) {
            if (rowNode) {
                count++;
            }
        });
        return count === 0;
    };
    SelectionController.prototype.deselectAllRowNodes = function () {
        utils_1.Utils.iterateObject(this.selectedNodes, function (nodeId, rowNode) {
            if (rowNode) {
                rowNode.selectThisNode(false);
            }
        });
        // the above does not clean up the parent rows if they are selected
        if (this.rowModel.getType() === constants_1.Constants.ROW_MODEL_TYPE_NORMAL && this.groupSelectsChildren) {
            this.updateGroupsFromChildrenSelections();
        }
        // we should not have to do this, as deselecting the nodes fires events
        // that we pick up, however it's good to clean it down, as we are still
        // left with entries pointing to 'undefined'
        this.selectedNodes = {};
        this.eventService.dispatchEvent(events_1.Events.EVENT_SELECTION_CHANGED);
    };
    SelectionController.prototype.selectAllRowNodes = function () {
        if (this.rowModel.getType() !== constants_1.Constants.ROW_MODEL_TYPE_NORMAL) {
            throw 'selectAll only available with normal row model, ie not virtual pagination';
        }
        this.rowModel.forEachNode(function (rowNode) {
            rowNode.selectThisNode(true);
        });
        this.eventService.dispatchEvent(events_1.Events.EVENT_SELECTION_CHANGED);
    };
    // Deprecated method
    SelectionController.prototype.selectNode = function (rowNode, tryMulti) {
        rowNode.setSelectedParams({ newValue: true, clearSelection: !tryMulti });
    };
    // Deprecated method
    SelectionController.prototype.deselectIndex = function (rowIndex) {
        var node = this.rowModel.getRow(rowIndex);
        this.deselectNode(node);
    };
    // Deprecated method
    SelectionController.prototype.deselectNode = function (rowNode) {
        rowNode.setSelectedParams({ newValue: false, clearSelection: false });
    };
    // Deprecated method
    SelectionController.prototype.selectIndex = function (index, tryMulti) {
        var node = this.rowModel.getRow(index);
        this.selectNode(node, tryMulti);
    };
    __decorate([
        context_3.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], SelectionController.prototype, "eventService", void 0);
    __decorate([
        context_3.Autowired('rowModel'), 
        __metadata('design:type', Object)
    ], SelectionController.prototype, "rowModel", void 0);
    __decorate([
        context_3.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], SelectionController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        __param(0, context_2.Qualifier('loggerFactory')), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [logger_1.LoggerFactory]), 
        __metadata('design:returntype', void 0)
    ], SelectionController.prototype, "setBeans", null);
    __decorate([
        context_4.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], SelectionController.prototype, "init", null);
    SelectionController = __decorate([
        context_1.Bean('selectionController'), 
        __metadata('design:paramtypes', [])
    ], SelectionController);
    return SelectionController;
}());
exports.SelectionController = SelectionController;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/sortController.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var column_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/entities/column.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var SortController = (function () {
    function SortController() {
    }
    SortController.prototype.progressSort = function (column, multiSort) {
        // update sort on current col
        column.setSort(this.getNextSortDirection(column));
        // sortedAt used for knowing order of cols when multi-col sort
        if (column.getSort()) {
            var sortedAt = Number(new Date().valueOf());
            column.setSortedAt(sortedAt);
        }
        else {
            column.setSortedAt(null);
        }
        var doingMultiSort = multiSort && !this.gridOptionsWrapper.isSuppressMultiSort();
        // clear sort on all columns except this one, and update the icons
        if (!doingMultiSort) {
            this.clearSortBarThisColumn(column);
        }
        this.dispatchSortChangedEvents();
    };
    // gets called by API, so if data changes, use can call this, which will end up
    // working out the sort order again of the rows.
    SortController.prototype.onSortChanged = function () {
        this.dispatchSortChangedEvents();
    };
    SortController.prototype.dispatchSortChangedEvents = function () {
        this.eventService.dispatchEvent(events_1.Events.EVENT_BEFORE_SORT_CHANGED);
        this.eventService.dispatchEvent(events_1.Events.EVENT_SORT_CHANGED);
        this.eventService.dispatchEvent(events_1.Events.EVENT_AFTER_SORT_CHANGED);
    };
    SortController.prototype.clearSortBarThisColumn = function (columnToSkip) {
        this.columnController.getPrimaryAndSecondaryAndAutoColumns().forEach(function (columnToClear) {
            // Do not clear if either holding shift, or if column in question was clicked
            if (!(columnToClear === columnToSkip)) {
                columnToClear.setSort(null);
            }
        });
    };
    SortController.prototype.getNextSortDirection = function (column) {
        var sortingOrder;
        if (column.getColDef().sortingOrder) {
            sortingOrder = column.getColDef().sortingOrder;
        }
        else if (this.gridOptionsWrapper.getSortingOrder()) {
            sortingOrder = this.gridOptionsWrapper.getSortingOrder();
        }
        else {
            sortingOrder = SortController.DEFAULT_SORTING_ORDER;
        }
        if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) {
            console.warn('ag-grid: sortingOrder must be an array with at least one element, currently it\'s ' + sortingOrder);
            return;
        }
        var currentIndex = sortingOrder.indexOf(column.getSort());
        var notInArray = currentIndex < 0;
        var lastItemInArray = currentIndex == sortingOrder.length - 1;
        var result;
        if (notInArray || lastItemInArray) {
            result = sortingOrder[0];
        }
        else {
            result = sortingOrder[currentIndex + 1];
        }
        // verify the sort type exists, as the user could provide the sortOrder, need to make sure it's valid
        if (SortController.DEFAULT_SORTING_ORDER.indexOf(result) < 0) {
            console.warn('ag-grid: invalid sort type ' + result);
            return null;
        }
        return result;
    };
    // used by the public api, for saving the sort model
    SortController.prototype.getSortModel = function () {
        var columnsWithSorting = this.getColumnsWithSortingOrdered();
        return utils_1.Utils.map(columnsWithSorting, function (column) {
            return {
                colId: column.getColId(),
                sort: column.getSort()
            };
        });
    };
    SortController.prototype.setSortModel = function (sortModel) {
        if (!this.gridOptionsWrapper.isEnableSorting()) {
            console.warn('ag-grid: You are setting the sort model on a grid that does not have sorting enabled');
            return;
        }
        // first up, clear any previous sort
        var sortModelProvided = sortModel && sortModel.length > 0;
        var allColumnsIncludingAuto = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
        allColumnsIncludingAuto.forEach(function (column) {
            var sortForCol = null;
            var sortedAt = -1;
            if (sortModelProvided && !column.getColDef().suppressSorting) {
                for (var j = 0; j < sortModel.length; j++) {
                    var sortModelEntry = sortModel[j];
                    if (typeof sortModelEntry.colId === 'string'
                        && typeof column.getColId() === 'string'
                        && sortModelEntry.colId === column.getColId()) {
                        sortForCol = sortModelEntry.sort;
                        sortedAt = j;
                    }
                }
            }
            if (sortForCol) {
                column.setSort(sortForCol);
                column.setSortedAt(sortedAt);
            }
            else {
                column.setSort(null);
                column.setSortedAt(null);
            }
        });
        this.dispatchSortChangedEvents();
    };
    SortController.prototype.getColumnsWithSortingOrdered = function () {
        // pull out all the columns that have sorting set
        var allColumnsIncludingAuto = this.columnController.getPrimaryAndSecondaryAndAutoColumns();
        var columnsWithSorting = utils_1.Utils.filter(allColumnsIncludingAuto, function (column) { return !!column.getSort(); });
        // put the columns in order of which one got sorted first
        columnsWithSorting.sort(function (a, b) { return a.sortedAt - b.sortedAt; });
        return columnsWithSorting;
    };
    // used by row controller, when doing the sorting
    SortController.prototype.getSortForRowController = function () {
        var columnsWithSorting = this.getColumnsWithSortingOrdered();
        return utils_1.Utils.map(columnsWithSorting, function (column) {
            var ascending = column.getSort() === column_1.Column.SORT_ASC;
            return {
                inverter: ascending ? 1 : -1,
                column: column
            };
        });
    };
    SortController.DEFAULT_SORTING_ORDER = [column_1.Column.SORT_ASC, column_1.Column.SORT_DESC, null];
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], SortController.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], SortController.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], SortController.prototype, "eventService", void 0);
    SortController = __decorate([
        context_2.Bean('sortController'), 
        __metadata('design:paramtypes', [])
    ], SortController);
    return SortController;
}());
exports.SortController = SortController;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/styling/stylingService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var expressionService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/expressionService.js");
var StylingService = (function () {
    function StylingService() {
    }
    StylingService.prototype.processCellClassRules = function (colDef, params, onApplicableClass, onNotApplicableClass) {
        var classRules = colDef.cellClassRules;
        if (typeof classRules === 'object' && classRules !== null) {
            var classNames = Object.keys(classRules);
            for (var i = 0; i < classNames.length; i++) {
                var className = classNames[i];
                var rule = classRules[className];
                var resultOfRule;
                if (typeof rule === 'string') {
                    resultOfRule = this.expressionService.evaluate(rule, params);
                }
                else if (typeof rule === 'function') {
                    resultOfRule = rule(params);
                }
                if (resultOfRule) {
                    onApplicableClass(className);
                }
                else if (onNotApplicableClass) {
                    onNotApplicableClass(className);
                }
            }
        }
    };
    __decorate([
        context_1.Autowired('expressionService'), 
        __metadata('design:type', expressionService_1.ExpressionService)
    ], StylingService.prototype, "expressionService", void 0);
    StylingService = __decorate([
        context_1.Bean('stylingService'), 
        __metadata('design:paramtypes', [])
    ], StylingService);
    return StylingService;
}());
exports.StylingService = StylingService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/svgFactory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var SVG_NS = "http://www.w3.org/2000/svg";
var SvgFactory = (function () {
    function SvgFactory() {
    }
    SvgFactory.getInstance = function () {
        if (!this.theInstance) {
            this.theInstance = new SvgFactory();
        }
        return this.theInstance;
    };
    SvgFactory.prototype.createFilterSvg = function () {
        var eSvg = createIconSvg();
        var eFunnel = document.createElementNS(SVG_NS, "polygon");
        eFunnel.setAttribute("points", "0,0 4,4 4,10 6,10 6,4 10,0");
        eFunnel.setAttribute("class", "ag-header-icon");
        eSvg.appendChild(eFunnel);
        return eSvg;
    };
    SvgFactory.prototype.createFilterSvg12 = function () {
        var eSvg = createIconSvg(12);
        var eFunnel = document.createElementNS(SVG_NS, "polygon");
        eFunnel.setAttribute("points", "0,0 5,5 5,12 7,12 7,5 12,0");
        eFunnel.setAttribute("class", "ag-header-icon");
        eSvg.appendChild(eFunnel);
        return eSvg;
    };
    SvgFactory.prototype.createMenuSvg = function () {
        var eSvg = document.createElementNS(SVG_NS, "svg");
        var size = "12";
        eSvg.setAttribute("width", size);
        eSvg.setAttribute("height", size);
        ["0", "5", "10"].forEach(function (y) {
            var eLine = document.createElementNS(SVG_NS, "rect");
            eLine.setAttribute("y", y);
            eLine.setAttribute("width", size);
            eLine.setAttribute("height", "2");
            eLine.setAttribute("class", "ag-header-icon");
            eSvg.appendChild(eLine);
        });
        return eSvg;
    };
    SvgFactory.prototype.createColumnsSvg12 = function () {
        var eSvg = createIconSvg(12);
        [0, 4, 8].forEach(function (y) {
            [0, 7].forEach(function (x) {
                var eBar = document.createElementNS(SVG_NS, "rect");
                eBar.setAttribute("y", y.toString());
                eBar.setAttribute("x", x.toString());
                eBar.setAttribute("width", "5");
                eBar.setAttribute("height", "3");
                eBar.setAttribute("class", "ag-header-icon");
                eSvg.appendChild(eBar);
            });
        });
        return eSvg;
    };
    SvgFactory.prototype.createArrowUpSvg = function () {
        return createPolygonSvg("0,10 5,0 10,10");
    };
    SvgFactory.prototype.createArrowLeftSvg = function () {
        return createPolygonSvg("10,0 0,5 10,10");
    };
    SvgFactory.prototype.createArrowDownSvg = function () {
        return createPolygonSvg("0,0 5,10 10,0");
    };
    SvgFactory.prototype.createArrowRightSvg = function () {
        return createPolygonSvg("0,0 10,5 0,10");
    };
    SvgFactory.prototype.createSmallArrowRightSvg = function () {
        return createPolygonSvg("0,0 6,3 0,6", 6);
    };
    SvgFactory.prototype.createSmallArrowLeftSvg = function () {
        return createPolygonSvg("6,0 0,3 6,6", 6);
    };
    SvgFactory.prototype.createSmallArrowDownSvg = function () {
        return createPolygonSvg("0,0 3,6 6,0", 6);
    };
    //public createOpenSvg() {
    //    return createPlusMinus(true);
    //}
    //
    //public createCloseSvg() {
    //    return createPlusMinus(false);
    //}
    // UnSort Icon SVG
    SvgFactory.prototype.createArrowUpDownSvg = function () {
        var svg = createIconSvg();
        var eAscIcon = document.createElementNS(SVG_NS, "polygon");
        eAscIcon.setAttribute("points", '0,4 5,0 10,4');
        svg.appendChild(eAscIcon);
        var eDescIcon = document.createElementNS(SVG_NS, "polygon");
        eDescIcon.setAttribute("points", '0,6 5,10 10,6');
        svg.appendChild(eDescIcon);
        return svg;
    };
    //public createFolderOpen(size: number): HTMLElement {
    //    var svg = `<svg width="${size}" height="${size}" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1717 931q0-35-53-35h-1088q-40 0-85.5 21.5t-71.5 52.5l-294 363q-18 24-18 40 0 35 53 35h1088q40 0 86-22t71-53l294-363q18-22 18-39zm-1141-163h768v-160q0-40-28-68t-68-28h-576q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v853l256-315q44-53 116-87.5t140-34.5zm1269 163q0 62-46 120l-295 363q-43 53-116 87.5t-140 34.5h-1088q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158v160h192q54 0 99 24.5t67 70.5q15 32 15 68z"/></svg>`;
    //    return _.loadTemplate(svg);
    //}
    //
    //public createFolderClosed(size: number): HTMLElement {
    //    var svg = `<svg width="${size}" height="${size}" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1600 1312v-704q0-40-28-68t-68-28h-704q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v960q0 40 28 68t68 28h1216q40 0 68-28t28-68zm128-704v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"/></svg>`;
    //    return _.loadTemplate(svg);
    //}
    SvgFactory.getFromCacheOrCreate = function (key, data) {
        // return document.createElement('img');
        var eCachedImg = this.imageCache[key];
        if (!eCachedImg) {
            eCachedImg = document.createElement('img');
            eCachedImg.src = data;
            this.imageCache[key] = eCachedImg;
        }
        return eCachedImg.cloneNode();
    };
    SvgFactory.prototype.createFolderOpen = function () {
        return SvgFactory.getFromCacheOrCreate('FolderOpen', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAZpJREFUeNqkU0tLQkEUPjN3ShAzF66CaNGiaNEviFpLgbSpXf2ACIqgFkELaVFhtAratQ8qokU/oFVbMQtJvWpWGvYwtet9TWfu1QorvOGBb84M5/WdOTOEcw7tCKHBlT8sMIhr4BfLGXC4BrALM8QUoveHG9oPQ/NhwVCQbOjp0C5F6zDiwE7Aed/p5tKWruufTlY8bkqliqVN8wvH6wvhydWd5UYdkYCqqgaKotQTCEewnJuDBSqVmshOrWhKgCJVqeHcKtiGKdqTgGIOQmwGum7AxVUKinXKzX1/1y5Xp6g8gpe8iBxuGZhcKjyXQZIkmBkfczS62YnRQCKX75/b3t8QDNhD8QX83V5Ipe7Bybug2Pt5NJ7A4nEqGOQKT+Bzu0HTDNB1syUYYxCJy0kwzIRogb0rKjAiQVXXHLVQrqqvsZtsFu8hbyXwe73WeMQtO5GonJGxuiyeC+Oa4fF5PEirw9nbx9FdxtN5eMwkzcgRnoeCa9DVM/CvH/R2l+axkz3clQguOFjw1f+FUzEQCqJG2v3OHwIMAOW1JPnAAAJxAAAAAElFTkSuQmCC');
    };
    SvgFactory.prototype.createFolderClosed = function () {
        return SvgFactory.getFromCacheOrCreate('FolderClosed', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARlJREFUeNqsUz1PwzAUPDtOUASpYKkQVWcQA/+DhbLA32CoKAMSTAwgFsQfQWLoX4GRDFXGIiqiyk4e7wUWmg8phJPOtvzunc6WrYgIXaD06KKhij0eD2uqUxBeDC9OmcNKCYd7ujm7ryodXz5ong6UPpqcP9+O76y1vwS+7yOOY1jr0OttlQyiaB0n148TAyK9XFqkaboiSTEYDNnkDUkyKxkkiSQkzQbwsiyHcBXz+Tv6/W1m+QiSEDT1igTO5RBWYbH4rNwPw/AnQU5ek0EdCj33SgLjHEHYzoAkgfmHBDmZuktsQqHPvxN0MyCbbWjtIQjWWhlIj/QqtT+6QrSz+6ef9DF7VTwFzE2madnu5K2prt/5S4ABADcIlSf6Ag8YAAAAAElFTkSuQmCC');
    };
    SvgFactory.prototype.createColumnIcon = function () {
        return SvgFactory.getFromCacheOrCreate('ColumnIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAOCAYAAAAMn20lAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTcwQ0JFMzlENjZEMTFFNUFEQ0U5RDRCNjFFRENGMUMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTcwQ0JFM0FENjZEMTFFNUFEQ0U5RDRCNjFFRENGMUMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFNzBDQkUzN0Q2NkQxMUU1QURDRTlENEI2MUVEQ0YxQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFNzBDQkUzOEQ2NkQxMUU1QURDRTlENEI2MUVEQ0YxQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PqDOrJYAAABxSURBVHjalJBBDsAgCAQXxXvj2/o/X9Cvmd4lUpV4MXroJMTAuihQSklVMSCysxSBW4uWKzjG6zZLDxrlWis5EVEThoWmi3N+nxAYs2WnXQY34L3HisMWPQlHB+2FPtNW6D/8+ziBRcroOXc0B/wEGABY6TPS1FU0bwAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createColumnsIcon = function () {
        return SvgFactory.getFromCacheOrCreate('ColumnsIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OENFQkI4NDhENzJDMTFFNUJDNEVFRjgwRDI3MkU1Q0EiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OENFQkI4NDlENzJDMTFFNUJDNEVFRjgwRDI3MkU1Q0EiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4Q0VCQjg0NkQ3MkMxMUU1QkM0RUVGODBEMjcyRTVDQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4Q0VCQjg0N0Q3MkMxMUU1QkM0RUVGODBEMjcyRTVDQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pj6ozGQAAAAuSURBVHjaYmRgYPjPgBswQml8anBK/idGDQsxNpCghnTAOBoGo2EwGgZgABBgAHbrH/l4grETAAAAAElFTkSuQmCC');
    };
    SvgFactory.prototype.createPinIcon = function () {
        return SvgFactory.getFromCacheOrCreate('PinIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAedJREFUeNqkUktLG1EYPTN31CIN0oWbIAWhKJR0FXcG6gOqkKGKVvEXCKULC91YSBcK7jXgQoIbFxn3ErFgFlIfCxUsQsCoIJYEm9LWNsGmJjPTM+Oo44Aa6IUzd+bec77H+UYyTRP/s5SsLFfCCxEjOhD9CXw64ccXJj7nLleYaMSvaa/+Au9Y73P3RUUBDIuXyaAxGu35A7xnkM57A7icCZXIO8/nkVleRn1/f9cv0xzjfVclFdi9N8ZivfnDQxQKBTwoFvFicLCVQSesJIpHMEY8dSqQWa54Eov1fF9ZQVHXsZNMblhnNE/wPmJPIX1zjOG2+fkgslnozHR2eopLcSIe3yoD48y45FbIxoVJNjimyMehoW3T58PvdBq53V18zeWwFo+vUfyBlCVvj0Li4/M1DnaAUtXCQkNDR4f/294eaoTAwdHRCROMWlzJZfC+1cKcJF07b5o+btWvV1eDyVBouyUcDj5UFDg924tVYtERpz0mCkmSulOp1GQgEIj0yvKPYiKBlwMDQXfPU47walEEmb8z0a5p2qaiKMPEoz6ezQLdM8DWNDDzltym24YthHimquoshSoDicvzZkK9S+h48pjCN4ZhrBPHTptlD0qevezwdCtAHVHrMti4A7rr3eb+E2AAoGnGkgkzpg8AAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createPlusIcon = function () {
        return SvgFactory.getFromCacheOrCreate('PlusIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAatJREFUeNqkU71KA0EQ/vaiib+lWCiordidpSg+QHwDBSt7n8DGhwhYCPoEgqCCINomARuLVIqgYKFG5f6z68xOzrvzYuXA3P7MzLffN7unjDH4jw3xx91bQXuxU4woNDjUX7VgsFOIH3/BnHgC0J65AzwFjDpZgoG7vb7lMsPDq6MiuK+B+kjGwFpCUjwK1DIQ3/dl0ssVh5TTM0UJP8aBgBKGleSGIWyP0oKYRm3KPSgYJ0Q0EpEgCASA2WmWZQY3kazBmjP9UhBFEbTWAgA0f9W2yHeG+vrd+tqGy5r5xNTT9erSqpvfdxwHN7fXOQZ0QhzH1oWArLsfXXieJ/KTGEZLcbVaTVn9ALTOLk9L+mYX5lxd0Xh6eGyVgspK6APwI8n3x9hmNpORJOuBo5ah8GcTc7dAHmkhNpYQlpHr47Hq2NspA1yEwHkoO/MVYLMmWJNarjEUQBzQw7rPvardFC8tZuOEwwB4p9PHqXgCdm738sUDJPB8mnwKj7qCTtJ527+XyAs6tOf2Bb6SP0OeGxRTVMp2h9nweWMoKS20l3+QT/vwqfZbgAEAUCrnlLQ+w4QAAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createMinusIcon = function () {
        return SvgFactory.getFromCacheOrCreate('MinusIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKVJREFUeNpi/P//PwMlgImBQjBqAAMDy3JGRgZGBoaZQGxMikZg3J0F4nSWHxC+cUBamvHXr18Zfv36Bca/f/8G43///oExKLphmImJieHagQMQF7QDiSwg/vnzJ8P3799RDPj79y+KRhhmBLr6I1DPNJABtxkYZM4xMFx7uXAhSX5/CtQD0gv0OgMfyCAgZgViZiL1/wXi30D8h3E0KVNuAECAAQDr51qtGxzf1wAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createMoveIcon = function () {
        return SvgFactory.getFromCacheOrCreate('MoveIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoZJREFUeNpsU81rE0EUf7uzu2lNVJL6Eb0IBWusepqcKm3wEFkvxqDgQbwUtYeeg5cccwj4F7QKChEPipRcdMGDiaAoJAexLYViwYsfbU1JYkx3Zz98b8220Wbg7ez7vXm/mffmN9Kh1G2QGQOmMDiRyYEkSaCoKjDGdAAooOUdxzFsIcDzPPhSvgeO7YDrOLBRmQdlJHULVE0DNRSCvqFjUuHqhWP8+etvhR5m0CeengVhmiAsywdl2Dt03K1wZSrO220XaCaf8AFrQel32s0mrDcaWfovrq3Vc9OTvHj/Tb0Xzh6JxQwNyxtIgPXpqqJk94fDM+1Oh6CaEF4QTiIOGJ/DdQtBObsEmGxbll/rkCyDPDwMzW4XhHD88EH0NcRxDUeX4/qdnsi0s8Aas+kEp8Zg82pMkmpDigKbjSbQTD7hFL94/jin9ZRHBNLo3Wrt+uUkbzQsiEZVMPGKfv76DaawodnahkhY86+PNnXxs77ZgVOjMahWVuufi1NJRZhWvvT0beHGtQn++Nm7en+DzqXO8vfVxX+wsYnT/JWxWEe95P0eILsvkkdPKn4PUEBJmunILab5992PLVU++skoNmOniT7JX2Fkt5GM1EjqbMohXzQmqo7KwCQ6zYKiabu30PpQAnZ0HKSRMcMRwnBddw4ZOO4GLRYKFFdDhrrteTMMdWB9/QTdH8sIp0EKmNT4GWDjGZAPJ3TcrbBv+ibfwtwDqBvzYck/truxYjjLZRDflwLt7JUmEoAymdPV7INa5IXn0Uw+4f8PIqATMLQIWpQ0E/RFTmQ4nLx0B1Zfzrsr5eAmbLQW2hYpHwkcqfegNBJhzwY9sGC4aCZaF81CAvePAAMAcwtApJX/Wo0AAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createLeftIcon = function () {
        return SvgFactory.getFromCacheOrCreate('LeftIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAe9JREFUeNqkUz1oE2EYfu7uuyRKLCFt6g+4VNQWWod+mQRRR1En0UFOHKoNCMKNju4SEQsOzsFNcRGl4CS42AzaKhKcsqhk0Etj7u+773y/6+USbOLSF5574b33eX+e906L4xh7MaYeC/c/IFcowMznEzDTBGPMoldnqEFtkPy708mIqvHHe0s7BcaYJYSwRwPu9vbYRH1XJI4tEYb2jYtHOHko9LvdxE9cYZQcBoF9+9oJ7jgRQt+HFAJSyv9rkO6UkGvXF3mr9QelkpkUINsYR6T8Jrkay8i+b9+5yfnmppMmSFw6e4yrIynBBsdS3jQ1PH/zeTiBIt+9dZpvbTlZh1+Oh/Z3F33XRUj7R1GUxA3DwMx0EYHnDUUMPe9Rfe1tc26uiL6M8aXno+UH6O7PIShPIapMQx6sQMxW4JbL+MkKCKhwNgGN2FD7Pnz82j63coF/aoc4ekDHtxfrzUniaZrW/FfEBomI9Scv7fnVq7zdBwIqajBWpeTd99d3vgBNCaQSzMOLyJ+6ApSPWxSzD61a/MfThupSjVuvxk2A3sazYYGBGbML0OcvW9rMyeRLFO8eVGXnKyacMiug5ikSplLs05dXzqNQWpbv6/URjpK+m6JH3GhQQI2QI+RTmBO0EwQ/RUBcqe31d/4rwAB0lPTXqN6HzgAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createRightIcon = function () {
        return SvgFactory.getFromCacheOrCreate('RightIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAfBJREFUeNqkUz1s00AU/hwSh1SEhiFCYuhCVSExgHRiYKjEVCEyMMGAsjCxZunesWM7dIgEA8JISPyoUhFDFoZOSE2GgtrSIAYWSEPb1HUS23c+8+7iuE5/JKQ+6fOdz/e+970fG2EY4jyWVo9b819hGEZ8WCgW4z2dV2lZFUJYgnNwz9PwXRebc3cGBMfN6XSQy+eHryyCMuv43dRpBCpSz7b1qlB+cI3RWkEYlv+LQFkgBLxuV8s9OAhQLk0w7vsnSHQKVMhqQuYRSRBouK5AqyXwpHSdvfywUYkKb8UEFIU9fXybOY6A+jbszGAP7O/7RBKg2eR4dH+KvV5ej0k0gaqobXO0214c3acUDnt99Pp9cKqDUqLsx68LuHd3gtU+b1eOCOiSaaZQKJjgMsSOy7EnJcSYCZnLwKbojic1weTVMXz81KhTexeSKdSXqrUzh2X84Qxr9SQmx1P48q6mnTPZrJUs4jMp5QlHlSd1Y203fRGFK8DPV28HzqZpjXShW3+D00bamCrpNU9DuvvcGsjea1rO+nvw39+AxRCGckyO8ciQFG8gPT27ptX8/b4gt1asYGdzRGE6MVCXCJcj5NShbG9B/NnYhttpyMYL5XmTYEdw1KgMFSgJJiEbIXNGPQXBi+CTrzTO+zv/E2AA3Y8Nbp4Kn1sAAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createColumnVisibleIcon = function () {
        return SvgFactory.getFromCacheOrCreate('ColumnVisibleIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAdhJREFUeNrUk01LAlEUhu845QdRUxZBhIIWtFBso2AwRAVNLqKltHCb63b9A/9AixZCELhyYdAmEyYCBcOlNa1CSQoxog/DMY3x9p5B27Zw1YGH8XrO+55759wROOdsmLCwIWNoAwFh/ugfZQKsAQV4gbNf9woqIAeuQHOgGxgIMNix2Wx7iqIsxmKxWU3TxgqFgpWSsix3fT5fK5VKPedyuftOp5OE7oz60hHsYD8UCh3k83k5k8ksGYYx5XK5rK2WzgiIrPQf5aiGakljakVRjKDrZaPR6Oi6zglVVTlFMnnMZXmdK8o2x674IE+1pCHtCFx2w+GwE9u3drtd81yJRAKdDXZ4eGSuFxb87PHxjg3yVEsaNNolg5NSqTTVbDaX7Agq8Hg8TFWLbGVl0xTY7TY2Our5NfhCQPNAWtFisdSr1WqvWCwawWBwRpKkcZyXadoN83qXmSQ50V1jGxurpnGlUqnH4/FzvItTmoo5ApjQNMIOh2MrEon4o9Gov1arzZXL5XHKBwKBT7fbXU+n07fZbPa23W5f4BVd93o9TgYimATTMHHCbB5PN9ZSf0LmrsEHRDWInvB8w/oFvAv920iFDkBzF/64fHTjvoFOxsL//5h+BBgAwjbgRLl5ImwAAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createColumnHiddenIcon = function () {
        return SvgFactory.getFromCacheOrCreate('ColumnHiddenIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N0ZGNDRBMkJENkU3MTFFNUIwOTBGRTc0MTA3OTI2OEYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6N0ZGNDRBMkNENkU3MTFFNUIwOTBGRTc0MTA3OTI2OEYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3RkY0NEEyOUQ2RTcxMUU1QjA5MEZFNzQxMDc5MjY4RiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3RkY0NEEyQUQ2RTcxMUU1QjA5MEZFNzQxMDc5MjY4RiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjQ0mkwAAACISURBVHjaYvz//z8DJYCJgUIwDAxgKSwspMwAIOYDYlcgtgNiJSBWBGJhIGaHyoHAJyD+CcRvgfg+EN8D4kNAvBtkwGEg1iNgkSCUlgBibSg7D4gvgwywRXKBChArALEIELMCsQBU8Qcg/g3Eb4D4ARDfBeKDMBeAnLcWikkGjKMpcRAYABBgACqXGpPEq63VAAAAAElFTkSuQmCC');
    };
    SvgFactory.prototype.createColumnIndeterminateIcon = function () {
        return SvgFactory.getFromCacheOrCreate('ColumnIndeterminateIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OUY1QTkyNDUxRTkzMTFFNkFEQzVDNjE1NDE4RDlEQUMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OUY1QTkyNDYxRTkzMTFFNkFEQzVDNjE1NDE4RDlEQUMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5RjVBOTI0MzFFOTMxMUU2QURDNUM2MTU0MThEOURBQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5RjVBOTI0NDFFOTMxMUU2QURDNUM2MTU0MThEOURBQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Por9Q7gAAAGzSURBVHja1JOxSwJRHMffqXcqSoVBQ0FDNN7iIBxO5WA3NYoEjm0u/T2Bkw2ONZlgNEk4Bw6GiGiippmRnp76+n4PbWhpcOoHH57P+36/7/e8n4qUUmxSLrFhbRygoJwPq6tsgRMQB0cgtNINQA0UwCMYrX3rAAUB516v9zIejx+nUqm90WgUDIfDaq1WE9PpdK6q6mc2m+0WCoUX7K/hu+O5TPCBq0gkUiqXy0PbtqVlWXK5XDqwuE4mEzmfzyU11NJDr3C73SZOfeh0OtPxeCyR7oixlzhdVqtV2ev1nCB+Tw219NDrQRtJwzBCaF+bzWbsSGQyGVEsFoWmacLj8YjBYCBisZhIp9MC3Qhq6YEmyQ5OTdO8bTQak263K8m69d+FIOc5tfTQywAvTrmIRqM3pVLptd1uy3q9/nN3slgsZLPZlHxGDbX00Ou8ApfLxbdh+P3+MyTriURC7/f7+7hCsFKpCF3XvwKBQCuXyz3n8/ln/Bb3yH9iOAPcYAfsIiSEsAOsh9hvA99qDizwAVMDphbWd+zfwFBZTSOFfqBxJv4YPk6cDcYMVv7/n+lbgAEAtdcjOjP715MAAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createGroupIcon = function () {
        return SvgFactory.getFromCacheOrCreate('GroupIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NUVCNUI1OUNENkYwMTFFNThGNjJDNUE3ODIwMEZERDciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NUVCNUI1OURENkYwMTFFNThGNjJDNUE3ODIwMEZERDciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1RUI1QjU5QUQ2RjAxMUU1OEY2MkM1QTc4MjAwRkRENyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo1RUI1QjU5QkQ2RjAxMUU1OEY2MkM1QTc4MjAwRkRENyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlkCTGoAAACDSURBVHjaYmRgYPjPgBswQun/+BT8X3x5DoZErG4KCj/3/DcMNZMNuRiYGPADRiRX4HYBJV5AB0QrhAGW//8hehgZES6FiaGLYzUAq7sxNf0nxQCsinHFAguegCPKBYxoYfAfWQxNnPgwINJVYMDEQCEYfLHASGoKRQlxPN7BqQggwAAN+SopPnDCwgAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createPivotIcon = function () {
        return SvgFactory.getFromCacheOrCreate('PivotIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAitJREFUeNqcU01rE1EUPfPVJjFqdYw2pJQkNS2hYhQUiwj+AaugKFYUBWutG3HjokgNrroRKYKbglBBFF0o1IW404qClGIDxpYKTQgULZJmmpiYkPnwvmtNspPmweOcmXnnvPPufSOdjsf7AfjR3PiOU6OjV50mh9CqtmVJDlkNjWU3tPXEiA6hlS3Lkm3HQbFYxO5hnTF0pQ3Bwa3MAxc98F9wMd95TsOOswpzoRFa1TJNyaKHtTUD07cNdv9wx6jtNDNW53N369xyOiC0qmmanMAwcjh+/yimrr/D28kjf8WLizjY3c38YzKJw729zKcTCU4gtLUE+Xwejy+94gWfl5agKQr8uo4Eccu2USr48SWVQq5QWE/gcAJZuIgF5XIF5yf7GfcGg9Cos4O3UoiFw2jFLrx+/wtRet+3nkJoOAEbkJtty5g484I+yUivrODekxb4tmuInZhCuFPHyHAXZubnUTXNWgKhlc1qlY+gaZsw9PwkY4fPhxsDXvxcrWL25TE8G+8DFAOxSAQHotG6AWlrRXS52vD08ifGr5kM1+BBPIBkOo3flQpaNA2zCwug+8MGdkMCPoLbvQ0DDw8xRgIBBNvbsUoF6yK+h+pQJpN91JH9PT2NCWS1Ui4rNhtswZubPxi/LS9TTWxemKTK/9t1jtramEBo1Vw226pRvEfj3oaL6v3vVRYaoZXcodA12ePpbOZXtEuljEToprmZprpBvehn4Y8AAwDB0mLL0M405wAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createAggregationIcon = function () {
        return SvgFactory.getFromCacheOrCreate('AggregationIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMZJREFUeNpi/P//PwMlgImBQjDwBrCgmMYENq8RiLVxqL8KxPX//v1DiIACEYYZGRlBmBOIe4B4PRDrQMUYoGyQGIoebAbADJkAxFuAWA9JXJdYA0CYC4inAPFOINZHlkPWgxKIcFMhQA0aFveB+DbOUERxDhQAbTEC4qNAPBfqEmRx3F6AAhOgojNAvBikGckumDiKHhY0B3ECcTVQQhRIg/B1NNeeB1IgQ7/BXYvmdE6oAnYcPv4NxF+BerAbMDTzAkCAAQChYIl8b86M1gAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createDropNotAllowedIcon = function () {
        return SvgFactory.getFromCacheOrCreate('DropNotAllowedIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjUyQ0MxNDY0NjBDMTFFNkEzMUVGQUE3NkQzQzU4MjYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjUyQ0MxNDc0NjBDMTFFNkEzMUVGQUE3NkQzQzU4MjYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyNTJDQzE0NDQ2MEMxMUU2QTMxRUZBQTc2RDNDNTgyNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyNTJDQzE0NTQ2MEMxMUU2QTMxRUZBQTc2RDNDNTgyNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PstpFisAAAGLSURBVHjalJNPKERRFMbnvRmKpAnjhURKWXjJLNQsqDE7KxI1NhYU2cjKxtbGZpSNqSFT/qxkYafmLWyU2LElCwYLo0SS8J36rk7XbJz61f33nXPuuec6ad8PWdYHJsEAaOPaDTgGeXCqD0cs8TqYCf21bjIHsmC2nIMCGOT4C3yCV44rQRXPS4BOkNIOchTL4RI4A0fggvtdYAj0g2qeFc10hKlNUXwF1sAOeALfdHCuxMZEsyoOFrjwTK8bTN3YMGvjcf7BzF3RukxHIl2DfSVuALvgQIn3wCJ44zwpDpqY/i2458YouARpzmV9BEyAExWk2RTRARUgxiuMqytsg3nWRCzMgL/PWATtoJfVr+PeHd/70OoJ6bxajotyhYCTmBJv8XVssdRljD0hFoiDDCcyfgcrjFyyxFGwBBI8K5YJ+573iEEriHOjBdSr55KoSbDM4ppekFrlHPWZCupJpcoP4IWCRt7bRA5MK7sqxRQ/irxIDegAPez7qDqbNeJyv1Huvvmf7/wjwABtLlYtICx9HQAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createGroupIcon12 = function () {
        return SvgFactory.getFromCacheOrCreate('GroupIcon12', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTNFQzE0NTdEOTk1MTFFNUI4MjJGMjBFRDk4MkMxNjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTNFQzE0NThEOTk1MTFFNUI4MjJGMjBFRDk4MkMxNjAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxM0VDMTQ1NUQ5OTUxMUU1QjgyMkYyMEVEOTgyQzE2MCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxM0VDMTQ1NkQ5OTUxMUU1QjgyMkYyMEVEOTgyQzE2MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PiInRbAAAAEjSURBVHjaYuTi5XqkpKvI9/fXHwZWDlaGZ/eeM7x59raDAQj4pOQrBBUVGP78+MfAzMbE8PLKhU8Mhnb6/6//P/f/8N/d/x8AWUn1cf+BaleCsFPt5P/T/v//3/zj//8JQFrB1vM/I5IN3EAbfgBt+Au0QRBqw3sMG0DiQMwPxFuB2BzKZmLAAViA+BOU/QOI7wPxRyhfCIhT0NT/ZETi7AZiZiD+DOXL6EdlGdkWFzF8evaDgUuIg2F9eiTYBrhuIJ4NxHegfDsgnobuJGQbNgBxMRDfhfLFgDgB3UnInPVALMxAACDbcBGItwDxAyhfCRismejBiuyHiUBsDMQmUL6cSXIJf0hTDsNboEN42RkYJth58TPisV0eaMNFdBsAAgwANVJzd8zQrUcAAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createCutIcon = function () {
        return SvgFactory.getFromCacheOrCreate('CutIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlRJREFUeNqkU09okmEcfj6ThNRhjUEJDhxDZ1t4sI3lDrKDhESHpC6x6yBoh52GfcdBJDvtElEUdKhOSq1JjF0SabSton9OmIeRxVKIrUgdU5xvv8e+hXXYpRcefv+e5/mh7/tpSin8z9Gi0Sg0TTsv+edarfa+Wq2iUqmgXC6DudVqhd1uh81ma+UWi8Uv3G5ZPJ9MJmGq1+twOBynBOek6T9oG+fkkU8djymVSiGTyWBiYuL6QSb7YvLIp679+D0ej57NZpX8JD0QCPj7+vrgcrnAyJp9zskj3zD928Tr9er5fF5FIhFdiH4aMLJmn/N98R+Dq5qGSUFQwKFs1AuFggqFQrrT6bzIyJp9zoMGn7qWQU6ST4JNQeK3kd/n8+nFYlGFw+HFdDqtWLOfMHjk5wwDjckRwGYGeJVnBMdXgaNrbveJKysr/etu91pHtVo8BnyXWUnwsgHM7wAVX7MJ0cEmjWvW4eGzjpGRXnNnZ8cFeRi9pRI+dnXtjMbj/cLp57rG1tbPH0tLwd3l5QHp3RBU8E7Txr4MDb1V8bh60tOzfhN4vTc9rRYkCm4tGDX7nJNHPnWt/+CFpt1rF9emptScxKfA2DNZwThn9NtNWjoxMH1Tqru+va02NzbK47FY4PHMzJtdYPYD8OChGDCyZp9z8sinrnWXt4E7q4ODRbrelw0x2Xjyn1fImn3OySOfutYt+IDRSeCycAZeAYm7wKLkshR87A1+cILDAss4EDkNXJI8Ows8yin1nENn+5MXNA3hnpHzHBKYjWhqe4lffwkwAMRcPMqRQZ4vAAAAAElFTkSuQmCC');
    };
    SvgFactory.prototype.createCopyIcon = function () {
        return SvgFactory.getFromCacheOrCreate('CopyIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAgBJREFUeNqMk79rFEEcxd/M7V2QAzVFEOMFGwNiIGCjEdIEhYODmEawsFf8G4QQSCPYyqUWCdhY2qSQECSpInvFJYT8Ki6dZO8Sb2P29pfvu+4sm+UKv/AYZna/b95ndla9WFyEUmoewG0Mr+9hGB5EYYhypZIseO0fCHa3sP/LhxVFkazd+by0tOIFAQac+3w5imPYto1Pa2tv+VxR+8bRuv8EevIRxn5uQoszpWI2RjSIBgMMLi/hui76/T6+Li+v8Pkz9k0Wo409pFHAJooUCiWqYlk46nTQ2ttD+/gY75pNPKjVmmfd7gf2vKbu5U0sMWBpzWatNcAkv7n789lZ1GdmMqQ3cbxApIUikg58H5S0JgkSE/L/L1JmoNJmMZEDzCNdK5cxwtFxHHxcXcXTqalm27Zf7rRaRKBBhkAhxcgjiYlUo16HfKlqtYpv29u95Az81EClCFLyaQ0SCib/dtNJ6qsGfDmJnRqoXIKiyVUDz8sSSGy5VnI3ikh5k1KplBnog/V19BxnRCZmV15dGCSdO1wziphcS3rrT7d71zk5Ob8+Pf3eMN4aH3/8qtGYM0hp7iyJbO0bBOrMPTz8kl6OpGoTEzEncwapaCLrRNfu6Wli0Etl6mbfdb0MiYrlXsjZyAUTE0qwOxsbo9aQ3/dGEWlYRRcX5xxG/wowAC8cIjzfyA4lAAAAAElFTkSuQmCC');
    };
    SvgFactory.prototype.createPasteIcon = function () {
        return SvgFactory.getFromCacheOrCreate('PasteIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAadJREFUeNpinGLPAAaMjAxwcJ9Tk+0Bt7YPkCkKFXqt8PXqFsXv13/B1Pz/D6FZENoYZgKxMYgh9OI6i567q5hFUp4kiH9i3qTnT3auqWPgZ/gDVXsWiNPBFk+2hxtwxi0syfjy5csM0vFzGTg42Bj4+XnAEh8/fmH48eMXw9OFyQy6uroMu1bNAxlgAnbB338IJ6hlzWU4uXgJw6FDO4Ga+Rl4eXkZWFlZGb58/crw6eNHBjG7Iga1yAiG7SvmwfWw/P2LMADkraiYaIb79+4xYAOKSkpgNch6UFzwFxgy//79Y5BTUMBqwF+g3H8mJgZkPSgu+Ac04M+/fwz4AAswulBc8Ocfqg1/kGWxAEagAch6WP78RfUCIQOYmJkZ/qC44A+qAb8JeIEZZMkfXC4gwgsQNUgG/CbRC2BXIhvw8AsDgzQnkgEEvACxBMJ++h0YJmufMTA8ABry8xckGkFOxIdBakBqQXpAekGZiXPTSwbeUAEgB5hsObm58acDoJp3nxkYNn1gEANyP4MNAGKxh18ZbsXxsjMQA97/Z7gF0gPEfwACDAB/y9xB1I3/FQAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createMenuIcon = function () {
        return SvgFactory.getFromCacheOrCreate('MenuIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjM3MUVBMzlERkJEMTFFNUEwMjFFNDJDMDlCMUY3OTciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjM3MUVBM0FERkJEMTFFNUEwMjFFNDJDMDlCMUY3OTciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCMzcxRUEzN0RGQkQxMUU1QTAyMUU0MkMwOUIxRjc5NyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCMzcxRUEzOERGQkQxMUU1QTAyMUU0MkMwOUIxRjc5NyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pux7nZcAAAGtSURBVHjalFM9a8JQFL0veYkfYJUQEYuIIF07uToVpGuHOgid3dJN+i+K4C6CXQqFjplcCoKbXZ0EqRUFP/CTxCS9NzTdNOmBx32P3Nx3zj33sXq9/tRqtbRYLCaLomhBANi2La5WK7NSqTRYNpt1LMsCLACO47iLMXY2CoIAm80GZFkGoVQqfWy3WzBNE6gQVveNhmHAbreDYrHYZaPRKKTr+i0ykTDBPnUzgfYEvFkYDAZWoVDQWb/fB9QD6XQajscjBCkQDodhOBzCcrkEVq1WXfoEL9EPlEdSZrMZ8Pl8frVYLO7QgRB+sPx+/GUk4qUGNvOdYSO+JpPJJdHyc8ADnUluIpH45vv9XiFbiFIQC71IjuBe5ZlM5gYlPHLOL7C4AcEgofXbXC7X4PF4vKuqahf+AWJxOBwgEokA6/V67kFRFFcGLU/SqShJkusATSNbr9fQ6XSuU6mUQP3BBIaJZyM6BuPx2Mnn85+sVqu9ttvt+2QyGXgOqInT6RTK5fIbwwl0iFI0Gv2btCA9QPdcOVzTtOdms/mAnnKkaAexES0UcG/hc375EWAA94tOP0vEOEcAAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createCheckboxCheckedIcon = function () {
        return SvgFactory.getFromCacheOrCreate('CheckboxCheckedIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpFQ0VGQkU3ODM4MTFFNjExQjlCQzhERUVDNkNGMzFDMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBRkJCRDU1MTEyM0ExMUU2ODE4MUUyOTNBNTRGQkIxNyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBRkJCRDU1MDEyM0ExMUU2ODE4MUUyOTNBNTRGQkIxNyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjIzMkM4M0M1M0MxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVDRUZCRTc4MzgxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+riMaEQAAAL5JREFUeNqUks0JhDAQhSd7tgtLMDUIyTXF2IdNWIE3c0ruYg9LtgcPzvpEF8SfHR8MGR75hpcwRERmrjQXCyutDKUQAkuFu2AUpsyiJ1JK0UtycRgGMsbsPBFYVRVZaw/+7Zu895znOY/j+PPWT7oGp2lirTU3TbPz/4IAAGLALeic47Ztlx7RELHrusPAAwgoy7LlrOuay7I8TXIadYOLouC+7+XgBiP2lTbw0crFGAF9ANq1kS75G8xXgAEAiqu9OeWZ/voAAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createCheckboxCheckedReadOnlyIcon = function () {
        return SvgFactory.getFromCacheOrCreate('CheckboxCheckedReadOnlyIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTZENDVDNkY0NDVFMTFFNkI1MjZCRkJDQ0FEMUEyNDMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTZENDVDNzA0NDVFMTFFNkI1MjZCRkJDQ0FEMUEyNDMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1NkQ0NUM2RDQ0NUUxMUU2QjUyNkJGQkNDQUQxQTI0MyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo1NkQ0NUM2RTQ0NUUxMUU2QjUyNkJGQkNDQUQxQTI0MyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PiE1TFsAAAGLSURBVHjadJI9a8JQFIbfSFBBakDaDg5O0nay4OSPsEFoCq4JODhUShd3F9emFreKqJOlS6Xg4OB/cIkZijjXwRa/uthzLokESS683I+cJ+fec15pv9/DHfP5/JSmR1KedOEcW6QP0nMqlfp2YyUXJOiWpleSAv/xQzIIfudNyAO9+UHr9Rrtdhuz2SzOMU4sQrQ4o7nF2f3SDIdD1Ot19Ho9ODEtYs454z0p7gdNp1OYpontdot0Ou0ec+wDgyrvlsslxuPxAdpsNmg0GnxFVCoVaJrm/WeewSte9ft9lMtljEYj8YWvNhgMkMvloOs6ZFn2gpeHnaIoohDNZhO73Q7dbhfRaBTVahWJROL4FX+y06frQqGAyWSCTqcDy7KwWq1Qq9WQzWb9nv8VcpqLcDgsrprJZASkqiqKxWJAS/HJ4IvTXCSTSRiGISpYKpUQiUSCjPAknOMxgLRYLGDbtsgci8WOIbbZHbvHaznNMcJJwPV+SbprOSnA5Ddccq4eyeY3kUyvyf8FGAAA/p3KIKgjXwAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createCheckboxUncheckedIcon = function () {
        return SvgFactory.getFromCacheOrCreate('CheckboxUncheckedIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpFQ0VGQkU3ODM4MTFFNjExQjlCQzhERUVDNkNGMzFDMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2MkU1Rjk1NDExNDExMUU2ODhEQkMyRTJGOUNGODYyQyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2MkU1Rjk1MzExNDExMUU2ODhEQkMyRTJGOUNGODYyQyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI1MkM4M0M1M0MxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVDRUZCRTc4MzgxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+t+CXswAAAFBJREFUeNrsksENwDAIA023a9YGNqlItkixlAFIn1VOMv5wvACAOxOZWUwsB6Gqswp36QivJNhBRHDhI0f8j9jNrCy4O2twNMobT/7QeQUYAFaKU1yE2OfhAAAAAElFTkSuQmCC');
    };
    SvgFactory.prototype.createCheckboxUncheckedReadOnlyIcon = function () {
        return SvgFactory.getFromCacheOrCreate('CheckboxUncheckedReadOnlyIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjE4MjE1MTc0NDVFMTFFNjgyNzA5QzQ5MjBBRTM0QTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjE4MjE1MTg0NDVFMTFFNjgyNzA5QzQ5MjBBRTM0QTkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTgyMTUxNTQ0NUUxMUU2ODI3MDlDNDkyMEFFMzRBOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2MTgyMTUxNjQ0NUUxMUU2ODI3MDlDNDkyMEFFMzRBOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoIZc5kAAADFSURBVHjaYvz//z8DDDx69EgESBUBsQ8Qq0GFbwDxJiCeJCcn9wamlhGmEagpGEjNBWJ+BuzgExAnATWvhWuEaloN4jPgByBbQkGaGR8+fCgK5NwBYj4G4gDIZlUmIJFLgiYGqNoCkEY/BtKBD0ijBhka1ZkYyAO/mKDxRCq4xwSNXFLBVlB0iAEZt0mODmBkvgKlCGjkMhCRAECp5xU4cKDJKAyIP+PR9BmWalDSKloi9wUFOSj0gPgWyE9APBE5kQMEGAD0/UBfnjaiGAAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createCheckboxIndeterminateIcon = function () {
        return SvgFactory.getFromCacheOrCreate('CheckboxIndeterminateIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpFQ0VGQkU3ODM4MTFFNjExQjlCQzhERUVDNkNGMzFDMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGMjU4MzhGQjEyM0ExMUU2QjAxM0Q2QjZFQ0IzNzM4NiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGMjU4MzhGQTEyM0ExMUU2QjAxM0Q2QjZFQ0IzNzM4NiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjIzMkM4M0M1M0MxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVDRUZCRTc4MzgxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+2Xml2QAAAGBJREFUeNpiYGBg8ATiZ0D8n0j8DKqH4dnhw4f/EwtAakF6GEGmAAEDKYCRkZGBiYFMQH+NLNjcjw2ghwMLIQWDx48Do/H5kSNHiNZw9OhREPUCRHiBNJOQyJ+A9AAEGACqkFldNkPUwwAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createCheckboxIndeterminateReadOnlyIcon = function () {
        return SvgFactory.getFromCacheOrCreate('CheckboxIndeterminateReadOnlyIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Nzg3RjczNTA0NDVFMTFFNkE4Q0NDN0E3NUI3Qjk5QjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Nzg3RjczNTE0NDVFMTFFNkE4Q0NDN0E3NUI3Qjk5QjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3ODdGNzM0RTQ0NUUxMUU2QThDQ0M3QTc1QjdCOTlCMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3ODdGNzM0RjQ0NUUxMUU2QThDQ0M3QTc1QjdCOTlCMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhD2+R8AAADRSURBVHjaYvz//z8DDDx69EgESBUBsQ8Qq0GFbwDxJiCeJCcn9wamlhGmEagpGEjNBWJ+BuzgExAnATWvhWuEaloN4jPgByBbQkGaGR8+fCgK5NwBYj4G4gDIZlUmIJFLgiYGqNoCkEY/BtKBDwuQ0IDx5OXl8aoGegvGVGdiIA/8YoHGkz6aiYTAPSZo5JIKtoKiQwzIuE1ydAAj8xUoRUAjl4GIBABKPa/AgQNNRmFA/BmPps+wVIOSVtESuS8oyEGhB8S3QH4C4onIiRwgwABzikY1hHfO+QAAAABJRU5ErkJggg==');
    };
    SvgFactory.prototype.createGroupExpandedIcon = function () {
        return SvgFactory.getFromCacheOrCreate('GroupExpandedIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzBBODQ4M0ExMjM4MTFFNkFDNEJDMjUzQUJBQ0I2QjkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzBBODQ4M0IxMjM4MTFFNkFDNEJDMjUzQUJBQ0I2QjkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3MEE4NDgzODEyMzgxMUU2QUM0QkMyNTNBQkFDQjZCOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3MEE4NDgzOTEyMzgxMUU2QUM0QkMyNTNBQkFDQjZCOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhKAo60AAADVSURBVHjajFC9DkRgEJzzFhqiligURKcjR+UFJK7wGN7jOq+glXgCvSgUCnyVn47GHsVdcURsss3s7OzOPEzTdB3HeTPGeMMw0DQNOI4Dz/PI8xyWZSGO4y4MwxeSJGnruqarGseRNE1r4fv+YSgIwgErioJwpgrggHmeR7Bt+xZ5GAbCNE2/0zvpv78v6bpOUFX1lvK6roQz92dkWZYJiqLcSmOeZ9qDb6uqusx5WRaSJIlBFEUnTdNuC536vifXdaksSwqCgLIsoyiKdnNs23l+BBgAK/54I/P5bhMAAAAASUVORK5CYII=');
    };
    SvgFactory.prototype.createGroupContractedIcon = function () {
        return SvgFactory.getFromCacheOrCreate('GroupContractedIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N0U2QUVBRDYxMjM4MTFFNjk3NjVBRUM0MUJDRjFCODgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6N0U2QUVBRDcxMjM4MTFFNjk3NjVBRUM0MUJDRjFCODgiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3RTZBRUFENDEyMzgxMUU2OTc2NUFFQzQxQkNGMUI4OCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3RTZBRUFENTEyMzgxMUU2OTc2NUFFQzQxQkNGMUI4OCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhjzsKsAAADSSURBVHjajJAvioVgFMXPuAuLYhYMBsVmU54mNyA4wWW4j2luwSq4ArsYDAZ9X/JP0+KZ58CkgTffD264l3MPnPPh+34cRdGXEEL1PA/TNEFRFKiqirZtEQQByrJ85nn+iaqq5nEc+Y5t2+g4zow0TSlD13XEf66/JElChGEoJV7Xldj3/WfRNI0A/sx9v3Fdl7BtW8r5ui6CkpimSViWJSU+joN38fMwDG+F53nSMAwBXdejuq6fr9K5LAvjOGbf98yyjE3TsCiKO5x4/Ty+BRgA3R6JXc/jqsQAAAAASUVORK5CYII=');
    };
    SvgFactory.imageCache = {};
    return SvgFactory;
}());
exports.SvgFactory = SvgFactory;
// i couldn't figure out how to not make these blurry
/*function createPlusMinus(plus: boolean) {
    var eSvg = document.createElementNS(SVG_NS, "svg");
    var size = "14";
    eSvg.setAttribute("width", size);
    eSvg.setAttribute("height", size);

    var eRect = document.createElementNS(SVG_NS, "rect");
    eRect.setAttribute('x', '1');
    eRect.setAttribute('y', '1');
    eRect.setAttribute('width', '12');
    eRect.setAttribute('height', '12');
    eRect.setAttribute('rx', '2');
    eRect.setAttribute('ry', '2');
    eRect.setAttribute('fill', 'none');
    eRect.setAttribute('stroke', 'black');
    eRect.setAttribute('stroke-width', '1');
    eRect.setAttribute('stroke-linecap', 'butt');
    eSvg.appendChild(eRect);

    var eLineAcross = document.createElementNS(SVG_NS, "line");
    eLineAcross.setAttribute('x1','2');
    eLineAcross.setAttribute('x2','12');
    eLineAcross.setAttribute('y1','7');
    eLineAcross.setAttribute('y2','7');
    eLineAcross.setAttribute('stroke','black');
    eLineAcross.setAttribute('stroke-width', '1');
    eLineAcross.setAttribute('stroke-linecap', 'butt');
    eSvg.appendChild(eLineAcross);

    if (plus) {
        var eLineDown = document.createElementNS(SVG_NS, "line");
        eLineDown.setAttribute('x1','7');
        eLineDown.setAttribute('x2','7');
        eLineDown.setAttribute('y1','2');
        eLineDown.setAttribute('y2','12');
        eLineDown.setAttribute('stroke','black');
        eLineDown.setAttribute('stroke-width', '1');
        eLineDown.setAttribute('stroke-linecap', 'butt');
        eSvg.appendChild(eLineDown);
    }

    return eSvg;
}*/
function createPolygonSvg(points, width) {
    var eSvg = createIconSvg(width);
    var eDescIcon = document.createElementNS(SVG_NS, "polygon");
    eDescIcon.setAttribute("points", points);
    eSvg.appendChild(eDescIcon);
    return eSvg;
}
// util function for the above
function createIconSvg(width) {
    var eSvg = document.createElementNS(SVG_NS, "svg");
    if (width > 0) {
        eSvg.setAttribute("width", width);
        eSvg.setAttribute("height", width);
    }
    else {
        eSvg.setAttribute("width", "10");
        eSvg.setAttribute("height", "10");
    }
    return eSvg;
}
function createCircle(fill) {
    var eSvg = createIconSvg();
    var eCircle = document.createElementNS(SVG_NS, "circle");
    eCircle.setAttribute("cx", "5");
    eCircle.setAttribute("cy", "5");
    eCircle.setAttribute("r", "5");
    eCircle.setAttribute("stroke", "black");
    eCircle.setAttribute("stroke-width", "2");
    if (fill) {
        eCircle.setAttribute("fill", "black");
    }
    else {
        eCircle.setAttribute("fill", "none");
    }
    eSvg.appendChild(eCircle);
    return eSvg;
}


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/templateService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var context_2 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var TemplateService = (function () {
    function TemplateService() {
        this.templateCache = {};
        this.waitingCallbacks = {};
    }
    // returns the template if it is loaded, or null if it is not loaded
    // but will call the callback when it is loaded
    TemplateService.prototype.getTemplate = function (url, callback) {
        var templateFromCache = this.templateCache[url];
        if (templateFromCache) {
            return templateFromCache;
        }
        var callbackList = this.waitingCallbacks[url];
        var that = this;
        if (!callbackList) {
            // first time this was called, so need a new list for callbacks
            callbackList = [];
            this.waitingCallbacks[url] = callbackList;
            // and also need to do the http request
            var client = new XMLHttpRequest();
            client.onload = function () {
                that.handleHttpResult(this, url);
            };
            client.open("GET", url);
            client.send();
        }
        // add this callback
        if (callback) {
            callbackList.push(callback);
        }
        // caller needs to wait for template to load, so return null
        return null;
    };
    TemplateService.prototype.handleHttpResult = function (httpResult, url) {
        if (httpResult.status !== 200 || httpResult.response === null) {
            console.warn('Unable to get template error ' + httpResult.status + ' - ' + url);
            return;
        }
        // response success, so process it
        // in IE9 the response is in - responseText
        this.templateCache[url] = httpResult.response || httpResult.responseText;
        // inform all listeners that this is now in the cache
        var callbacks = this.waitingCallbacks[url];
        for (var i = 0; i < callbacks.length; i++) {
            var callback = callbacks[i];
            // we could pass the callback the response, however we know the client of this code
            // is the cell renderer, and it passes the 'cellRefresh' method in as the callback
            // which doesn't take any parameters.
            callback();
        }
        if (this.$scope) {
            var that = this;
            setTimeout(function () {
                that.$scope.$apply();
            }, 0);
        }
    };
    __decorate([
        context_2.Autowired('$scope'), 
        __metadata('design:type', Object)
    ], TemplateService.prototype, "$scope", void 0);
    TemplateService = __decorate([
        context_1.Bean('templateService'), 
        __metadata('design:paramtypes', [])
    ], TemplateService);
    return TemplateService;
}());
exports.TemplateService = TemplateService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var FUNCTION_STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var FUNCTION_ARGUMENT_NAMES = /([^\s,]+)/g;
// util class, only used when debugging, for printing time to console
var Timer = (function () {
    function Timer() {
        this.timestamp = new Date().getTime();
    }
    Timer.prototype.print = function (msg) {
        var duration = (new Date().getTime()) - this.timestamp;
        console.log(msg + " = " + duration);
        this.timestamp = new Date().getTime();
    };
    return Timer;
}());
exports.Timer = Timer;
var Utils = (function () {
    function Utils() {
    }
    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
    Utils.areEventsNear = function (e1, e2, pixelCount) {
        // by default, we wait 4 pixels before starting the drag
        if (pixelCount === 0) {
            return false;
        }
        var diffX = Math.abs(e1.clientX - e2.clientX);
        var diffY = Math.abs(e1.clientY - e2.clientY);
        return Math.max(diffX, diffY) <= pixelCount;
    };
    Utils.shallowCompare = function (arr1, arr2) {
        // if both are missing, then they are the same
        if (this.missing(arr1) && this.missing(arr2)) {
            return true;
        }
        // if one is present, but other is missing, then then are different
        if (this.missing(arr1) || this.missing(arr2)) {
            return false;
        }
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    };
    Utils.getNameOfClass = function (TheClass) {
        var funcNameRegex = /function (.{1,})\(/;
        var funcAsString = TheClass.toString();
        var results = (funcNameRegex).exec(funcAsString);
        return (results && results.length > 1) ? results[1] : "";
    };
    Utils.values = function (object) {
        var result = [];
        this.iterateObject(object, function (key, value) {
            result.push(value);
        });
        return result;
    };
    Utils.getValueUsingField = function (data, field, fieldContainsDots) {
        if (!field || !data) {
            return;
        }
        // if no '.', then it's not a deep value
        if (!fieldContainsDots) {
            return data[field];
        }
        else {
            // otherwise it is a deep value, so need to dig for it
            var fields = field.split('.');
            var currentObject = data;
            for (var i = 0; i < fields.length; i++) {
                currentObject = currentObject[fields[i]];
                if (this.missing(currentObject)) {
                    return null;
                }
            }
            return currentObject;
        }
    };
    Utils.getScrollLeft = function (element, rtl) {
        var scrollLeft = element.scrollLeft;
        if (rtl) {
            // Absolute value - for FF that reports RTL scrolls in negative numbers
            scrollLeft = Math.abs(scrollLeft);
            // Get Chrome and Safari to return the same value as well
            if (this.isBrowserSafari() || this.isBrowserChrome()) {
                scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
            }
        }
        return scrollLeft;
    };
    Utils.setScrollLeft = function (element, value, rtl) {
        if (rtl) {
            // Chrome and Safari when doing RTL have the END position of the scroll as zero, not the start
            if (this.isBrowserSafari() || this.isBrowserChrome()) {
                value = element.scrollWidth - element.clientWidth - value;
            }
            // Firefox uses negative numbers when doing RTL scrolling
            if (this.isBrowserFirefox()) {
                value *= -1;
            }
        }
        element.scrollLeft = value;
    };
    Utils.iterateObject = function (object, callback) {
        if (this.missing(object)) {
            return;
        }
        var keys = Object.keys(object);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = object[key];
            callback(key, value);
        }
    };
    Utils.cloneObject = function (object) {
        var copy = {};
        var keys = Object.keys(object);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = object[key];
            copy[key] = value;
        }
        return copy;
    };
    Utils.map = function (array, callback) {
        var result = [];
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            var mappedItem = callback(item);
            result.push(mappedItem);
        }
        return result;
    };
    Utils.mapObject = function (object, callback) {
        var result = [];
        Utils.iterateObject(object, function (key, value) {
            result.push(callback(value));
        });
        return result;
    };
    Utils.forEach = function (array, callback) {
        if (!array) {
            return;
        }
        for (var i = 0; i < array.length; i++) {
            var value = array[i];
            callback(value, i);
        }
    };
    Utils.filter = function (array, callback) {
        var result = [];
        array.forEach(function (item) {
            if (callback(item)) {
                result.push(item);
            }
        });
        return result;
    };
    Utils.mergeDeep = function (object, source) {
        if (this.exists(source)) {
            this.iterateObject(source, function (key, value) {
                var currentValue = object[key];
                var target = source[key];
                if (currentValue == null) {
                    object[key] = value;
                }
                if (typeof currentValue === 'object') {
                    if (target) {
                        this.mergeDeep(object[key], target);
                    }
                }
                if (target) {
                    object[key] = target;
                }
            });
        }
    };
    Utils.assign = function (object, source) {
        if (this.exists(source)) {
            this.iterateObject(source, function (key, value) {
                object[key] = value;
            });
        }
    };
    Utils.parseYyyyMmDdToDate = function (yyyyMmDd, separator) {
        try {
            if (!yyyyMmDd)
                return null;
            if (yyyyMmDd.indexOf(separator) === -1)
                return null;
            var fields = yyyyMmDd.split(separator);
            if (fields.length != 3)
                return null;
            return new Date(Number(fields[0]), Number(fields[1]) - 1, Number(fields[2]));
        }
        catch (e) {
            return null;
        }
    };
    Utils.serializeDateToYyyyMmDd = function (date, separator) {
        if (!date)
            return null;
        return date.getFullYear() + separator + Utils.pad(date.getMonth() + 1, 2) + separator + Utils.pad(date.getDate(), 2);
    };
    Utils.pad = function (num, totalStringSize) {
        var asString = num + "";
        while (asString.length < totalStringSize)
            asString = "0" + asString;
        return asString;
    };
    Utils.pushAll = function (target, source) {
        if (this.missing(source) || this.missing(target)) {
            return;
        }
        source.forEach(function (func) { return target.push(func); });
    };
    Utils.getFunctionParameters = function (func) {
        var fnStr = func.toString().replace(FUNCTION_STRIP_COMMENTS, '');
        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(FUNCTION_ARGUMENT_NAMES);
        if (result === null) {
            return [];
        }
        else {
            return result;
        }
    };
    Utils.find = function (collection, predicate, value) {
        if (collection === null || collection === undefined) {
            return null;
        }
        var firstMatchingItem;
        for (var i = 0; i < collection.length; i++) {
            var item = collection[i];
            if (typeof predicate === 'string') {
                if (item[predicate] === value) {
                    firstMatchingItem = item;
                    break;
                }
            }
            else {
                var callback = predicate;
                if (callback(item)) {
                    firstMatchingItem = item;
                    break;
                }
            }
        }
        return firstMatchingItem;
    };
    Utils.toStrings = function (array) {
        return this.map(array, function (item) {
            if (item === undefined || item === null || !item.toString) {
                return null;
            }
            else {
                return item.toString();
            }
        });
    };
    Utils.iterateArray = function (array, callback) {
        for (var index = 0; index < array.length; index++) {
            var value = array[index];
            callback(value, index);
        }
    };
    //Returns true if it is a DOM node
    //taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
    Utils.isNode = function (o) {
        return (typeof Node === "function" ? o instanceof Node :
            o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string");
    };
    //Returns true if it is a DOM element
    //taken from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
    Utils.isElement = function (o) {
        return (typeof HTMLElement === "function" ? o instanceof HTMLElement :
            o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string");
    };
    Utils.isNodeOrElement = function (o) {
        return this.isNode(o) || this.isElement(o);
    };
    //adds all type of change listeners to an element, intended to be a text field
    Utils.addChangeListener = function (element, listener) {
        element.addEventListener("changed", listener);
        element.addEventListener("paste", listener);
        element.addEventListener("input", listener);
        // IE doesn't fire changed for special keys (eg delete, backspace), so need to
        // listen for this further ones
        element.addEventListener("keydown", listener);
        element.addEventListener("keyup", listener);
    };
    //if value is undefined, null or blank, returns null, otherwise returns the value
    Utils.makeNull = function (value) {
        if (value === null || value === undefined || value === "") {
            return null;
        }
        else {
            return value;
        }
    };
    Utils.missing = function (value) {
        return !this.exists(value);
    };
    Utils.missingOrEmpty = function (value) {
        return this.missing(value) || value.length === 0;
    };
    Utils.missingOrEmptyObject = function (value) {
        return this.missing(value) || Object.keys(value).length === 0;
    };
    Utils.exists = function (value) {
        if (value === null || value === undefined || value === '') {
            return false;
        }
        else {
            return true;
        }
    };
    Utils.existsAndNotEmpty = function (value) {
        return this.exists(value) && value.length > 0;
    };
    Utils.removeAllChildren = function (node) {
        if (node) {
            while (node.hasChildNodes()) {
                node.removeChild(node.lastChild);
            }
        }
    };
    Utils.removeElement = function (parent, cssSelector) {
        this.removeFromParent(parent.querySelector(cssSelector));
    };
    Utils.removeFromParent = function (node) {
        if (node && node.parentNode) {
            node.parentNode.removeChild(node);
        }
    };
    Utils.isVisible = function (element) {
        return (element.offsetParent !== null);
    };
    /**
     * loads the template and returns it as an element. makes up for no simple way in
     * the dom api to load html directly, eg we cannot do this: document.createElement(template)
     */
    Utils.loadTemplate = function (template) {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = template;
        return tempDiv.firstChild;
    };
    Utils.addOrRemoveCssClass = function (element, className, addOrRemove) {
        if (addOrRemove) {
            this.addCssClass(element, className);
        }
        else {
            this.removeCssClass(element, className);
        }
    };
    Utils.callIfPresent = function (func) {
        if (func) {
            func();
        }
    };
    Utils.addCssClass = function (element, className) {
        var _this = this;
        if (!className || className.length === 0) {
            return;
        }
        if (className.indexOf(' ') >= 0) {
            className.split(' ').forEach(function (value) { return _this.addCssClass(element, value); });
            return;
        }
        if (element.classList) {
            element.classList.add(className);
        }
        else {
            if (element.className && element.className.length > 0) {
                var cssClasses = element.className.split(' ');
                if (cssClasses.indexOf(className) < 0) {
                    cssClasses.push(className);
                    element.className = cssClasses.join(' ');
                }
            }
            else {
                element.className = className;
            }
        }
    };
    Utils.containsClass = function (element, className) {
        if (element.classList) {
            // for modern browsers
            return element.classList.contains(className);
        }
        else if (element.className) {
            // for older browsers, check against the string of class names
            // if only one class, can check for exact match
            var onlyClass = element.className === className;
            // if many classes, check for class name, we have to pad with ' ' to stop other
            // class names that are a substring of this class
            var contains = element.className.indexOf(' ' + className + ' ') >= 0;
            // the padding above then breaks when it's the first or last class names
            var startsWithClass = element.className.indexOf(className + ' ') === 0;
            var endsWithClass = element.className.lastIndexOf(' ' + className) === (element.className.length - className.length - 1);
            return onlyClass || contains || startsWithClass || endsWithClass;
        }
        else {
            // if item is not a node
            return false;
        }
    };
    Utils.getElementAttribute = function (element, attributeName) {
        if (element.attributes) {
            if (element.attributes[attributeName]) {
                var attribute = element.attributes[attributeName];
                return attribute.value;
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    Utils.offsetHeight = function (element) {
        return element && element.clientHeight ? element.clientHeight : 0;
    };
    Utils.offsetWidth = function (element) {
        return element && element.clientWidth ? element.clientWidth : 0;
    };
    Utils.removeCssClass = function (element, className) {
        if (element.className && element.className.length > 0) {
            var cssClasses = element.className.split(' ');
            var index = cssClasses.indexOf(className);
            if (index >= 0) {
                cssClasses.splice(index, 1);
                element.className = cssClasses.join(' ');
            }
        }
    };
    Utils.removeRepeatsFromArray = function (array, object) {
        if (!array) {
            return;
        }
        for (var index = array.length - 2; index >= 0; index--) {
            var thisOneMatches = array[index] === object;
            var nextOneMatches = array[index + 1] === object;
            if (thisOneMatches && nextOneMatches) {
                array.splice(index + 1, 1);
            }
        }
    };
    Utils.removeFromArray = function (array, object) {
        if (array.indexOf(object) >= 0) {
            array.splice(array.indexOf(object), 1);
        }
    };
    Utils.removeAllFromArray = function (array, toRemove) {
        toRemove.forEach(function (item) {
            if (array.indexOf(item) >= 0) {
                array.splice(array.indexOf(item), 1);
            }
        });
    };
    Utils.insertIntoArray = function (array, object, toIndex) {
        array.splice(toIndex, 0, object);
    };
    Utils.insertArrayIntoArray = function (dest, src, toIndex) {
        if (this.missing(dest) || this.missing(src)) {
            return;
        }
        // put items in backwards, otherwise inserted items end up in reverse order
        for (var i = src.length - 1; i >= 0; i--) {
            var item = src[i];
            this.insertIntoArray(dest, item, toIndex);
        }
    };
    Utils.moveInArray = function (array, objectsToMove, toIndex) {
        var _this = this;
        // first take out it items from the array
        objectsToMove.forEach(function (obj) {
            _this.removeFromArray(array, obj);
        });
        // now add the objects, in same order as provided to us, that means we start at the end
        // as the objects will be pushed to the right as they are inserted
        objectsToMove.slice().reverse().forEach(function (obj) {
            _this.insertIntoArray(array, obj, toIndex);
        });
    };
    Utils.defaultComparator = function (valueA, valueB) {
        var valueAMissing = valueA === null || valueA === undefined;
        var valueBMissing = valueB === null || valueB === undefined;
        if (valueAMissing && valueBMissing) {
            return 0;
        }
        if (valueAMissing) {
            return -1;
        }
        if (valueBMissing) {
            return 1;
        }
        if (typeof valueA === "string") {
            try {
                // using local compare also allows chinese comparisons
                return valueA.localeCompare(valueB);
            }
            catch (e) {
            }
        }
        if (valueA < valueB) {
            return -1;
        }
        else if (valueA > valueB) {
            return 1;
        }
        else {
            return 0;
        }
    };
    Utils.compareArrays = function (array1, array2) {
        if (this.missing(array1) && this.missing(array2)) {
            return true;
        }
        if (this.missing(array1) || this.missing(array2)) {
            return false;
        }
        if (array1.length !== array2.length) {
            return false;
        }
        for (var i = 0; i < array1.length; i++) {
            if (array1[i] !== array2[i]) {
                return false;
            }
        }
        return true;
    };
    Utils.toStringOrNull = function (value) {
        if (this.exists(value) && value.toString) {
            return value.toString();
        }
        else {
            return null;
        }
    };
    Utils.formatWidth = function (width) {
        if (typeof width === "number") {
            return width + "px";
        }
        else {
            return width;
        }
    };
    Utils.formatNumberTwoDecimalPlacesAndCommas = function (value) {
        // took this from: http://blog.tompawlak.org/number-currency-formatting-javascript
        if (typeof value === 'number') {
            return (Math.round(value * 100) / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
        else {
            return '';
        }
    };
    Utils.prependDC = function (parent, documentFragment) {
        if (this.exists(parent.firstChild)) {
            parent.insertBefore(documentFragment, parent.firstChild);
        }
        else {
            parent.appendChild(documentFragment);
        }
    };
    // static prepend(parent: HTMLElement, child: HTMLElement): void {
    //     if (this.exists(parent.firstChild)) {
    //         parent.insertBefore(child, parent.firstChild);
    //     } else {
    //         parent.appendChild(child);
    //     }
    // }
    /**
     * If icon provided, use this (either a string, or a function callback).
     * if not, then use the second parameter, which is the svgFactory function
     */
    Utils.createIcon = function (iconName, gridOptionsWrapper, column, svgFactoryFunc) {
        var eResult = document.createElement('span');
        eResult.appendChild(this.createIconNoSpan(iconName, gridOptionsWrapper, column, svgFactoryFunc));
        return eResult;
    };
    Utils.createIconNoSpan = function (iconName, gridOptionsWrapper, column, svgFactoryFunc) {
        var userProvidedIcon;
        // check col for icon first
        if (column && column.getColDef().icons) {
            userProvidedIcon = column.getColDef().icons[iconName];
        }
        // it not in col, try grid options
        if (!userProvidedIcon && gridOptionsWrapper.getIcons()) {
            userProvidedIcon = gridOptionsWrapper.getIcons()[iconName];
        }
        // now if user provided, use it
        if (userProvidedIcon) {
            var rendererResult;
            if (typeof userProvidedIcon === 'function') {
                rendererResult = userProvidedIcon();
            }
            else if (typeof userProvidedIcon === 'string') {
                rendererResult = userProvidedIcon;
            }
            else {
                throw 'icon from grid options needs to be a string or a function';
            }
            if (typeof rendererResult === 'string') {
                return this.loadTemplate(rendererResult);
            }
            else if (this.isNodeOrElement(rendererResult)) {
                return rendererResult;
            }
            else {
                throw 'iconRenderer should return back a string or a dom object';
            }
        }
        else {
            // otherwise we use the built in icon
            if (svgFactoryFunc) {
                return svgFactoryFunc();
            }
            else {
                return null;
            }
        }
    };
    Utils.addStylesToElement = function (eElement, styles) {
        if (!styles) {
            return;
        }
        Object.keys(styles).forEach(function (key) {
            eElement.style[key] = styles[key];
        });
    };
    Utils.isHorizontalScrollShowing = function (element) {
        return element.clientWidth < element.scrollWidth;
    };
    Utils.isVerticalScrollShowing = function (element) {
        return element.clientHeight < element.scrollHeight;
    };
    Utils.getScrollbarWidth = function () {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
        document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";
        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        // remove divs
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    };
    Utils.isKeyPressed = function (event, keyToCheck) {
        var pressedKey = event.which || event.keyCode;
        return pressedKey === keyToCheck;
    };
    Utils.setVisible = function (element, visible) {
        this.addOrRemoveCssClass(element, 'ag-hidden', !visible);
    };
    Utils.isBrowserIE = function () {
        if (this.isIE === undefined) {
            this.isIE = false || !!document.documentMode; // At least IE6
        }
        return this.isIE;
    };
    Utils.isBrowserEdge = function () {
        if (this.isEdge === undefined) {
            this.isEdge = !this.isBrowserIE() && !!window.StyleMedia;
        }
        return this.isEdge;
    };
    Utils.isBrowserSafari = function () {
        if (this.isSafari === undefined) {
            var anyWindow = window;
            // taken from https://github.com/ceolter/ag-grid/issues/550
            this.isSafari = Object.prototype.toString.call(anyWindow.HTMLElement).indexOf('Constructor') > 0
                || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!anyWindow.safari || anyWindow.safari.pushNotification);
        }
        return this.isSafari;
    };
    Utils.isBrowserChrome = function () {
        if (this.isChrome === undefined) {
            var anyWindow = window;
            this.isChrome = !!anyWindow.chrome && !!anyWindow.chrome.webstore;
        }
        return this.isChrome;
    };
    Utils.isBrowserFirefox = function () {
        if (this.isFirefox === undefined) {
            var anyWindow = window;
            this.isFirefox = typeof anyWindow.InstallTrigger !== 'undefined';
            ;
        }
        return this.isFirefox;
    };
    // srcElement is only available in IE. In all other browsers it is target
    // http://stackoverflow.com/questions/5301643/how-can-i-make-event-srcelement-work-in-firefox-and-what-does-it-mean
    Utils.getTarget = function (event) {
        var eventNoType = event;
        return eventNoType.target || eventNoType.srcElement;
    };
    // taken from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
    Utils.getBodyWidth = function () {
        if (document.body) {
            return document.body.clientWidth;
        }
        if (window.innerHeight) {
            return window.innerWidth;
        }
        if (document.documentElement && document.documentElement.clientWidth) {
            return document.documentElement.clientWidth;
        }
        return -1;
    };
    // taken from: http://stackoverflow.com/questions/1038727/how-to-get-browser-width-using-javascript-code
    Utils.getBodyHeight = function () {
        if (document.body) {
            return document.body.clientHeight;
        }
        if (window.innerHeight) {
            return window.innerHeight;
        }
        if (document.documentElement && document.documentElement.clientHeight) {
            return document.documentElement.clientHeight;
        }
        return -1;
    };
    Utils.setCheckboxState = function (eCheckbox, state) {
        if (typeof state === 'boolean') {
            eCheckbox.checked = state;
            eCheckbox.indeterminate = false;
        }
        else {
            // isNodeSelected returns back undefined if it's a group and the children
            // are a mix of selected and unselected
            eCheckbox.indeterminate = true;
        }
    };
    Utils.traverseNodesWithKey = function (nodes, callback) {
        var keyParts = [];
        recursiveSearchNodes(nodes);
        function recursiveSearchNodes(nodes) {
            nodes.forEach(function (node) {
                if (node.group) {
                    keyParts.push(node.key);
                    var key = keyParts.join('|');
                    callback(node, key);
                    recursiveSearchNodes(node.childrenAfterGroup);
                    keyParts.pop();
                }
            });
        }
    };
    Utils.isNumeric = function (value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    };
    // Taken from here: https://github.com/facebook/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
    /**
     * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
     * complicated, thus this doc is long and (hopefully) detailed enough to answer
     * your questions.
     *
     * If you need to react to the mouse wheel in a predictable way, this code is
     * like your bestest friend. * hugs *
     *
     * As of today, there are 4 DOM event types you can listen to:
     *
     *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
     *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
     *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
     *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
     *
     * So what to do?  The is the best:
     *
     *   normalizeWheel.getEventType();
     *
     * In your event callback, use this code to get sane interpretation of the
     * deltas.  This code will return an object with properties:
     *
     *   spinX   -- normalized spin speed (use for zoom) - x plane
     *   spinY   -- " - y plane
     *   pixelX  -- normalized distance (to pixels) - x plane
     *   pixelY  -- " - y plane
     *
     * Wheel values are provided by the browser assuming you are using the wheel to
     * scroll a web page by a number of lines or pixels (or pages).  Values can vary
     * significantly on different platforms and browsers, forgetting that you can
     * scroll at different speeds.  Some devices (like trackpads) emit more events
     * at smaller increments with fine granularity, and some emit massive jumps with
     * linear speed or acceleration.
     *
     * This code does its best to normalize the deltas for you:
     *
     *   - spin is trying to normalize how far the wheel was spun (or trackpad
     *     dragged).  This is super useful for zoom support where you want to
     *     throw away the chunky scroll steps on the PC and make those equal to
     *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
     *     resolve a single slow step on a wheel to 1.
     *
     *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
     *     get the crazy differences between browsers, but at least it'll be in
     *     pixels!
     *
     *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
     *     should translate to positive value zooming IN, negative zooming OUT.
     *     This matches the newer 'wheel' event.
     *
     * Why are there spinX, spinY (or pixels)?
     *
     *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
     *     with a mouse.  It results in side-scrolling in the browser by default.
     *
     *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
     *
     *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
     *     probably is by browsers in conjunction with fancy 3D controllers .. but
     *     you know.
     *
     * Implementation info:
     *
     * Examples of 'wheel' event if you scroll slowly (down) by one step with an
     * average mouse:
     *
     *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
     *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
     *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
     *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
     *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
     *
     * On the trackpad:
     *
     *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
     *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
     *
     * On other/older browsers.. it's more complicated as there can be multiple and
     * also missing delta values.
     *
     * The 'wheel' event is more standard:
     *
     * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
     *
     * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
     * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
     * backward compatibility with older events.  Those other values help us
     * better normalize spin speed.  Example of what the browsers provide:
     *
     *                          | event.wheelDelta | event.detail
     *        ------------------+------------------+--------------
     *          Safari v5/OS X  |       -120       |       0
     *          Safari v5/Win7  |       -120       |       0
     *         Chrome v17/OS X  |       -120       |       0
     *         Chrome v17/Win7  |       -120       |       0
     *                IE9/Win7  |       -120       |   undefined
     *         Firefox v4/OS X  |     undefined    |       1
     *         Firefox v4/Win7  |     undefined    |       3
     *
     */
    Utils.normalizeWheel = function (event) {
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        // spinX, spinY
        var sX = 0;
        var sY = 0;
        // pixelX, pixelY
        var pX = 0;
        var pY = 0;
        // Legacy
        if ('detail' in event) {
            sY = event.detail;
        }
        if ('wheelDelta' in event) {
            sY = -event.wheelDelta / 120;
        }
        if ('wheelDeltaY' in event) {
            sY = -event.wheelDeltaY / 120;
        }
        if ('wheelDeltaX' in event) {
            sX = -event.wheelDeltaX / 120;
        }
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in event) {
            pY = event.deltaY;
        }
        if ('deltaX' in event) {
            pX = event.deltaX;
        }
        if ((pX || pY) && event.deltaMode) {
            if (event.deltaMode == 1) {
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            }
            else {
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) {
            sX = (pX < 1) ? -1 : 1;
        }
        if (pY && !sY) {
            sY = (pY < 1) ? -1 : 1;
        }
        return { spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY };
    };
    return Utils;
}());
exports.Utils = Utils;
var NumberSequence = (function () {
    function NumberSequence(initValue, step) {
        if (initValue === void 0) { initValue = 0; }
        if (step === void 0) { step = 1; }
        this.nextValue = initValue;
        this.step = step;
    }
    NumberSequence.prototype.next = function () {
        var valToReturn = this.nextValue;
        this.nextValue += this.step;
        return valToReturn;
    };
    return NumberSequence;
}());
exports.NumberSequence = NumberSequence;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/valueService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var expressionService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/expressionService.js");
var columnController_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/columnController/columnController.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var events_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/events.js");
var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var ValueService = (function () {
    function ValueService() {
        this.initialised = false;
    }
    ValueService.prototype.init = function () {
        this.cellExpressions = this.gridOptionsWrapper.isEnableCellExpressions();
        this.userProvidedTheGroups = utils_1.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());
        this.suppressUseColIdForGroups = this.gridOptionsWrapper.isSuppressUseColIdForGroups();
        this.initialised = true;
    };
    ValueService.prototype.getValue = function (column, node) {
        return this.getValueUsingSpecificData(column, node.data, node);
    };
    ValueService.prototype.getValueUsingSpecificData = function (column, data, node) {
        // hack - the grid is getting refreshed before this bean gets initialised, race condition.
        // really should have a way so they get initialised in the right order???
        if (!this.initialised) {
            this.init();
        }
        var colDef = column.getColDef();
        var field = colDef.field;
        var result;
        // if there is a value getter, this gets precedence over a field
        // - need to revisit this, we check 'data' as this is the way for the grid to
        //   not render when on the footer row
        if (data && node.group && !this.userProvidedTheGroups && !this.suppressUseColIdForGroups) {
            result = node.data ? node.data[column.getId()] : undefined;
        }
        else if (colDef.valueGetter) {
            result = this.executeValueGetter(colDef.valueGetter, data, column, node);
        }
        else if (field && data) {
            result = utils_1.Utils.getValueUsingField(data, field, column.isFieldContainsDots());
        }
        else {
            result = undefined;
        }
        // the result could be an expression itself, if we are allowing cell values to be expressions
        if (this.cellExpressions && (typeof result === 'string') && result.indexOf('=') === 0) {
            var cellValueGetter = result.substring(1);
            result = this.executeValueGetter(cellValueGetter, data, column, node);
        }
        return result;
    };
    ValueService.prototype.setValue = function (rowNode, colKey, newValue) {
        var column = this.columnController.getPrimaryColumn(colKey);
        if (!rowNode || !column) {
            return;
        }
        // this will only happen if user is trying to paste into a group row, which doesn't make sense
        // the user should not be trying to paste into group rows
        var data = rowNode.data;
        if (utils_1.Utils.missing(data)) {
            return;
        }
        var field = column.getColDef().field;
        var newValueHandler = column.getColDef().newValueHandler;
        // need either a field or a newValueHandler for this to work
        if (utils_1.Utils.missing(field) && utils_1.Utils.missing(newValueHandler)) {
            console.warn("ag-Grid: you need either field or newValueHandler set on colDef for editing to work");
            return;
        }
        var paramsForCallbacks = {
            node: rowNode,
            data: rowNode.data,
            oldValue: this.getValue(column, rowNode),
            newValue: newValue,
            colDef: column.getColDef(),
            api: this.gridOptionsWrapper.getApi(),
            context: this.gridOptionsWrapper.getContext()
        };
        if (newValueHandler) {
            newValueHandler(paramsForCallbacks);
        }
        else {
            this.setValueUsingField(data, field, newValue, column.isFieldContainsDots());
        }
        // reset quick filter on this row
        rowNode.resetQuickFilterAggregateText();
        paramsForCallbacks.newValue = this.getValue(column, rowNode);
        if (typeof column.getColDef().onCellValueChanged === 'function') {
            column.getColDef().onCellValueChanged(paramsForCallbacks);
        }
        this.eventService.dispatchEvent(events_1.Events.EVENT_CELL_VALUE_CHANGED, paramsForCallbacks);
    };
    ValueService.prototype.setValueUsingField = function (data, field, newValue, isFieldContainsDots) {
        // if no '.', then it's not a deep value
        if (!isFieldContainsDots) {
            data[field] = newValue;
        }
        else {
            // otherwise it is a deep value, so need to dig for it
            var fieldPieces = field.split('.');
            var currentObject = data;
            while (fieldPieces.length > 0 && currentObject) {
                var fieldPiece = fieldPieces.shift();
                if (fieldPieces.length === 0) {
                    currentObject[fieldPiece] = newValue;
                }
                else {
                    currentObject = currentObject[fieldPiece];
                }
            }
        }
    };
    ValueService.prototype.executeValueGetter = function (valueGetter, data, column, node) {
        var context = this.gridOptionsWrapper.getContext();
        var api = this.gridOptionsWrapper.getApi();
        var params = {
            data: data,
            node: node,
            colDef: column.getColDef(),
            api: api,
            context: context,
            getValue: this.getValueCallback.bind(this, data, node)
        };
        if (typeof valueGetter === 'function') {
            // valueGetter is a function, so just call it
            return valueGetter(params);
        }
        else if (typeof valueGetter === 'string') {
            // valueGetter is an expression, so execute the expression
            return this.expressionService.evaluate(valueGetter, params);
        }
    };
    ValueService.prototype.getValueCallback = function (data, node, field) {
        var otherColumn = this.columnController.getPrimaryColumn(field);
        if (otherColumn) {
            return this.getValueUsingSpecificData(otherColumn, data, node);
        }
        else {
            return null;
        }
    };
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], ValueService.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        context_1.Autowired('expressionService'), 
        __metadata('design:type', expressionService_1.ExpressionService)
    ], ValueService.prototype, "expressionService", void 0);
    __decorate([
        context_1.Autowired('columnController'), 
        __metadata('design:type', columnController_1.ColumnController)
    ], ValueService.prototype, "columnController", void 0);
    __decorate([
        context_1.Autowired('eventService'), 
        __metadata('design:type', eventService_1.EventService)
    ], ValueService.prototype, "eventService", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], ValueService.prototype, "init", null);
    ValueService = __decorate([
        context_1.Bean('valueService'), 
        __metadata('design:paramtypes', [])
    ], ValueService);
    return ValueService;
}());
exports.ValueService = ValueService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/widgets/agCheckbox.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var component_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/component.js");
var componentAnnotations_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/widgets/componentAnnotations.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var svgFactory_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/svgFactory.js");
var svgFactory = svgFactory_1.SvgFactory.getInstance();
var AgCheckbox = (function (_super) {
    __extends(AgCheckbox, _super);
    function AgCheckbox() {
        _super.call(this);
        this.selected = false;
        this.readOnly = false;
        this.passive = false;
    }
    AgCheckbox.prototype.init = function () {
        this.setTemplate(AgCheckbox.TEMPLATE);
        this.loadIcons();
        this.updateIcons();
    };
    AgCheckbox.prototype.attributesSet = function () {
        _super.prototype.attributesSet.call(this);
        var label = this.getAttribute('label');
        if (label) {
            this.eLabel.innerText = label;
        }
    };
    AgCheckbox.prototype.loadIcons = function () {
        utils_1.Utils.removeAllChildren(this.eChecked);
        utils_1.Utils.removeAllChildren(this.eUnchecked);
        utils_1.Utils.removeAllChildren(this.eIndeterminate);
        if (this.readOnly) {
            this.eChecked.appendChild(utils_1.Utils.createIconNoSpan('checkboxCheckedReadOnly', this.gridOptionsWrapper, null, svgFactory.createCheckboxCheckedReadOnlyIcon));
            this.eUnchecked.appendChild(utils_1.Utils.createIconNoSpan('checkboxUncheckedReadOnly', this.gridOptionsWrapper, null, svgFactory.createCheckboxUncheckedReadOnlyIcon));
            this.eIndeterminate.appendChild(utils_1.Utils.createIconNoSpan('checkboxIndeterminateReadOnly', this.gridOptionsWrapper, null, svgFactory.createCheckboxIndeterminateReadOnlyIcon));
        }
        else {
            this.eChecked.appendChild(utils_1.Utils.createIconNoSpan('checkboxChecked', this.gridOptionsWrapper, null, svgFactory.createCheckboxCheckedIcon));
            this.eUnchecked.appendChild(utils_1.Utils.createIconNoSpan('checkboxUnchecked', this.gridOptionsWrapper, null, svgFactory.createCheckboxUncheckedIcon));
            this.eIndeterminate.appendChild(utils_1.Utils.createIconNoSpan('checkboxIndeterminate', this.gridOptionsWrapper, null, svgFactory.createCheckboxIndeterminateIcon));
        }
    };
    AgCheckbox.prototype.onClick = function () {
        if (!this.readOnly) {
            this.toggle();
        }
    };
    AgCheckbox.prototype.getNextValue = function () {
        if (this.selected === undefined) {
            return true;
        }
        else {
            return !this.selected;
        }
    };
    AgCheckbox.prototype.setPassive = function (passive) {
        this.passive = passive;
    };
    AgCheckbox.prototype.setReadOnly = function (readOnly) {
        this.readOnly = readOnly;
        this.loadIcons();
    };
    AgCheckbox.prototype.isReadOnly = function () {
        return this.readOnly;
    };
    AgCheckbox.prototype.isSelected = function () {
        return this.selected;
    };
    AgCheckbox.prototype.toggle = function () {
        var nextValue = this.getNextValue();
        if (this.passive) {
            this.dispatchEvent(AgCheckbox.EVENT_CHANGED, { selected: nextValue });
        }
        else {
            this.setSelected(nextValue);
        }
    };
    AgCheckbox.prototype.setSelected = function (selected) {
        if (this.selected === selected) {
            return;
        }
        if (selected === true) {
            this.selected = true;
        }
        else if (selected === false) {
            this.selected = false;
        }
        else {
            this.selected = undefined;
        }
        this.updateIcons();
        this.dispatchEvent(AgCheckbox.EVENT_CHANGED, { selected: this.selected });
    };
    AgCheckbox.prototype.updateIcons = function () {
        utils_1.Utils.setVisible(this.eChecked, this.selected === true);
        utils_1.Utils.setVisible(this.eUnchecked, this.selected === false);
        utils_1.Utils.setVisible(this.eIndeterminate, this.selected === undefined);
    };
    AgCheckbox.EVENT_CHANGED = 'change';
    AgCheckbox.TEMPLATE = '<span class="ag-checkbox">' +
        '  <span class="ag-checkbox-checked"></span>' +
        '  <span class="ag-checkbox-unchecked"></span>' +
        '  <span class="ag-checkbox-indeterminate"></span>' +
        '  <span class="ag-checkbox-label"></span>' +
        '</span>';
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], AgCheckbox.prototype, "gridOptionsWrapper", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('.ag-checkbox-checked'), 
        __metadata('design:type', HTMLElement)
    ], AgCheckbox.prototype, "eChecked", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('.ag-checkbox-unchecked'), 
        __metadata('design:type', HTMLElement)
    ], AgCheckbox.prototype, "eUnchecked", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('.ag-checkbox-indeterminate'), 
        __metadata('design:type', HTMLElement)
    ], AgCheckbox.prototype, "eIndeterminate", void 0);
    __decorate([
        componentAnnotations_1.QuerySelector('.ag-checkbox-label'), 
        __metadata('design:type', HTMLElement)
    ], AgCheckbox.prototype, "eLabel", void 0);
    __decorate([
        context_1.PostConstruct, 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], AgCheckbox.prototype, "init", null);
    __decorate([
        componentAnnotations_1.Listener('click'), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], AgCheckbox.prototype, "onClick", null);
    return AgCheckbox;
}(component_1.Component));
exports.AgCheckbox = AgCheckbox;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/widgets/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var beanStub_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/beanStub.js");
var Component = (function (_super) {
    __extends(Component, _super);
    function Component(template) {
        _super.call(this);
        this.childComponents = [];
        this.annotatedEventListeners = [];
        this.visible = true;
        if (template) {
            this.setTemplate(template);
        }
    }
    Component.prototype.instantiate = function (context) {
        this.instantiateRecurse(this.getGui(), context);
    };
    Component.prototype.instantiateRecurse = function (parentNode, context) {
        var childCount = parentNode.childNodes ? parentNode.childNodes.length : 0;
        for (var i = 0; i < childCount; i++) {
            var childNode = parentNode.childNodes[i];
            var newComponent = context.createComponent(childNode);
            if (newComponent) {
                this.swapComponentForNode(newComponent, parentNode, childNode);
            }
            else {
                if (childNode.childNodes) {
                    this.instantiateRecurse(childNode, context);
                }
            }
        }
    };
    Component.prototype.swapComponentForNode = function (newComponent, parentNode, childNode) {
        parentNode.replaceChild(newComponent.getGui(), childNode);
        this.childComponents.push(newComponent);
        this.swapInComponentForQuerySelectors(newComponent, childNode);
    };
    Component.prototype.swapInComponentForQuerySelectors = function (newComponent, childNode) {
        var metaData = this.__agComponentMetaData;
        if (!metaData || !metaData.querySelectors) {
            return;
        }
        var thisNoType = this;
        metaData.querySelectors.forEach(function (querySelector) {
            if (thisNoType[querySelector.attributeName] === childNode) {
                thisNoType[querySelector.attributeName] = newComponent;
            }
        });
    };
    Component.prototype.setTemplate = function (template) {
        this.eGui = utils_1.Utils.loadTemplate(template);
        this.eGui.__agComponent = this;
        this.addAnnotatedEventListeners();
        this.wireQuerySelectors();
    };
    Component.prototype.attributesSet = function () {
    };
    Component.prototype.wireQuerySelectors = function () {
        var _this = this;
        var metaData = this.__agComponentMetaData;
        if (!metaData || !metaData.querySelectors) {
            return;
        }
        if (!this.eGui) {
            return;
        }
        var thisNoType = this;
        metaData.querySelectors.forEach(function (querySelector) {
            var resultOfQuery = _this.eGui.querySelector(querySelector.querySelector);
            if (resultOfQuery) {
                var backingComponent = resultOfQuery.__agComponent;
                if (backingComponent) {
                    thisNoType[querySelector.attributeName] = backingComponent;
                }
                else {
                    thisNoType[querySelector.attributeName] = resultOfQuery;
                }
            }
            else {
            }
        });
    };
    Component.prototype.addAnnotatedEventListeners = function () {
        var _this = this;
        this.removeAnnotatedEventListeners();
        var metaData = this.__agComponentMetaData;
        if (!metaData || !metaData.listenerMethods) {
            return;
        }
        if (!this.eGui) {
            return;
        }
        if (!this.annotatedEventListeners) {
            this.annotatedEventListeners = [];
        }
        metaData.listenerMethods.forEach(function (eventListener) {
            var listener = _this[eventListener.methodName].bind(_this);
            _this.eGui.addEventListener(eventListener.eventName, listener);
            _this.annotatedEventListeners.push({ eventName: eventListener.eventName, listener: listener });
        });
    };
    Component.prototype.removeAnnotatedEventListeners = function () {
        var _this = this;
        if (!this.annotatedEventListeners) {
            return;
        }
        if (!this.eGui) {
            return;
        }
        this.annotatedEventListeners.forEach(function (eventListener) {
            _this.eGui.removeEventListener(eventListener.eventName, eventListener.listener);
        });
        this.annotatedEventListeners = null;
    };
    Component.prototype.getGui = function () {
        return this.eGui;
    };
    // this method is for older code, that wants to provide the gui element,
    // it is not intended for this to be in ag-Stack
    Component.prototype.setGui = function (eGui) {
        this.eGui = eGui;
    };
    Component.prototype.queryForHtmlElement = function (cssSelector) {
        return this.eGui.querySelector(cssSelector);
    };
    Component.prototype.queryForHtmlInputElement = function (cssSelector) {
        return this.eGui.querySelector(cssSelector);
    };
    Component.prototype.appendChild = function (newChild) {
        if (utils_1.Utils.isNodeOrElement(newChild)) {
            this.eGui.appendChild(newChild);
        }
        else {
            var childComponent = newChild;
            this.eGui.appendChild(childComponent.getGui());
            this.childComponents.push(childComponent);
        }
    };
    Component.prototype.isVisible = function () {
        return this.visible;
    };
    Component.prototype.setVisible = function (visible) {
        if (visible !== this.visible) {
            this.visible = visible;
            utils_1.Utils.addOrRemoveCssClass(this.eGui, 'ag-hidden', !visible);
            this.dispatchEvent(Component.EVENT_VISIBLE_CHANGED, { visible: this.visible });
        }
    };
    Component.prototype.addOrRemoveCssClass = function (className, addOrRemove) {
        utils_1.Utils.addOrRemoveCssClass(this.eGui, className, addOrRemove);
    };
    Component.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.childComponents.forEach(function (childComponent) { return childComponent.destroy(); });
        this.childComponents.length = 0;
        this.removeAnnotatedEventListeners();
    };
    Component.prototype.addGuiEventListener = function (event, listener) {
        var _this = this;
        this.getGui().addEventListener(event, listener);
        this.addDestroyFunc(function () { return _this.getGui().removeEventListener(event, listener); });
    };
    Component.prototype.addCssClass = function (className) {
        utils_1.Utils.addCssClass(this.getGui(), className);
    };
    Component.prototype.getAttribute = function (key) {
        var eGui = this.getGui();
        if (eGui) {
            return eGui.getAttribute(key);
        }
        else {
            return null;
        }
    };
    Component.EVENT_VISIBLE_CHANGED = 'visibleChanged';
    return Component;
}(beanStub_1.BeanStub));
exports.Component = Component;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/widgets/componentAnnotations.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

function QuerySelector(selector) {
    return querySelectorFunc.bind(this, selector);
}
exports.QuerySelector = QuerySelector;
function querySelectorFunc(selector, classPrototype, methodOrAttributeName, index) {
    if (selector === null) {
        console.error('ag-Grid: QuerySelector selector should not be null');
        return;
    }
    if (typeof index === 'number') {
        console.error('ag-Grid: QuerySelector should be on an attribute');
        return;
    }
    // it's an attribute on the class
    var props = getOrCreateProps(classPrototype);
    if (!props.querySelectors) {
        props.querySelectors = [];
    }
    props.querySelectors.push({
        attributeName: methodOrAttributeName,
        querySelector: selector
    });
}
function Listener(eventName) {
    return listenerFunc.bind(this, eventName);
}
exports.Listener = Listener;
function listenerFunc(eventName, target, methodName, descriptor) {
    if (eventName === null) {
        console.error('ag-Grid: EventListener eventName should not be null');
        return;
    }
    // it's an attribute on the class
    var props = getOrCreateProps(target);
    if (!props.listenerMethods) {
        props.listenerMethods = [];
    }
    props.listenerMethods.push({
        methodName: methodName,
        eventName: eventName
    });
}
function getOrCreateProps(target) {
    var props = target.__agComponentMetaData;
    if (!props) {
        props = {};
        target.__agComponentMetaData = props;
    }
    return props;
}


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/widgets/popupService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var constants_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/constants.js");
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var gridCore_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridCore.js");
var gridOptionsWrapper_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/gridOptionsWrapper.js");
var PopupService = (function () {
    function PopupService() {
    }
    // this.popupService.setPopupParent(this.eRootPanel.getGui());
    PopupService.prototype.getPopupParent = function () {
        return this.gridCore.getRootGui();
    };
    PopupService.prototype.positionPopupForMenu = function (params) {
        var sourceRect = params.eventSource.getBoundingClientRect();
        var parentRect = this.getPopupParent().getBoundingClientRect();
        var y = sourceRect.top - parentRect.top;
        var minWidth = (params.ePopup.clientWidth > 0) ? params.ePopup.clientWidth : 200;
        var widthOfParent = parentRect.right - parentRect.left;
        var maxX = widthOfParent - minWidth;
        // the x position of the popup depends on RTL or LTR. for normal cases, LTR, we put the child popup
        // to the right, unless it doesn't fit and we then put it to the left. for RTL it's the other way around,
        // we try place it first to the left, and then if not to the right.
        var x;
        if (this.gridOptionsWrapper.isEnableRtl()) {
            // for RTL, try left first
            x = xLeftPosition();
            if (x < 0) {
                x = xRightPosition();
            }
            if (x > maxX) {
                x = 0;
            }
        }
        else {
            // for LTR, try right first
            x = xRightPosition();
            if (x > maxX) {
                x = xLeftPosition();
            }
            if (x < 0) {
                x = 0;
            }
        }
        params.ePopup.style.left = x + "px";
        params.ePopup.style.top = y + "px";
        function xRightPosition() {
            return sourceRect.right - parentRect.left - 2;
        }
        function xLeftPosition() {
            return sourceRect.left - parentRect.left - minWidth;
        }
    };
    PopupService.prototype.positionPopupUnderMouseEvent = function (params) {
        var parentRect = this.getPopupParent().getBoundingClientRect();
        this.positionPopup({
            ePopup: params.ePopup,
            x: params.mouseEvent.clientX - parentRect.left,
            y: params.mouseEvent.clientY - parentRect.top,
            keepWithinBounds: true
        });
    };
    PopupService.prototype.positionPopupUnderComponent = function (params) {
        var sourceRect = params.eventSource.getBoundingClientRect();
        var parentRect = this.getPopupParent().getBoundingClientRect();
        this.positionPopup({
            ePopup: params.ePopup,
            minWidth: params.minWidth,
            nudgeX: params.nudgeX,
            nudgeY: params.nudgeY,
            x: sourceRect.left - parentRect.left,
            y: sourceRect.top - parentRect.top + sourceRect.height,
            keepWithinBounds: params.keepWithinBounds
        });
    };
    PopupService.prototype.positionPopupOverComponent = function (params) {
        var sourceRect = params.eventSource.getBoundingClientRect();
        var parentRect = this.getPopupParent().getBoundingClientRect();
        this.positionPopup({
            ePopup: params.ePopup,
            minWidth: params.minWidth,
            nudgeX: params.nudgeX,
            nudgeY: params.nudgeY,
            x: sourceRect.left - parentRect.left,
            y: sourceRect.top - parentRect.top,
            keepWithinBounds: params.keepWithinBounds
        });
    };
    PopupService.prototype.positionPopup = function (params) {
        var parentRect = this.getPopupParent().getBoundingClientRect();
        var x = params.x;
        var y = params.y;
        if (params.nudgeX) {
            x += params.nudgeX;
        }
        if (params.nudgeY) {
            y += params.nudgeY;
        }
        // if popup is overflowing to the bottom, move it up
        if (params.keepWithinBounds) {
            checkHorizontalOverflow();
            checkVerticalOverflow();
        }
        params.ePopup.style.left = x + "px";
        params.ePopup.style.top = y + "px";
        function checkHorizontalOverflow() {
            var minWidth;
            if (params.minWidth > 0) {
                minWidth = params.minWidth;
            }
            else if (params.ePopup.clientWidth > 0) {
                minWidth = params.ePopup.clientWidth;
            }
            else {
                minWidth = 200;
            }
            var widthOfParent = parentRect.right - parentRect.left;
            var maxX = widthOfParent - minWidth - 5;
            if (x > maxX) {
                x = maxX;
            }
            if (x < 0) {
                x = 0;
            }
        }
        function checkVerticalOverflow() {
            var minHeight;
            if (params.ePopup.clientHeight > 0) {
                minHeight = params.ePopup.clientHeight;
            }
            else {
                minHeight = 200;
            }
            var heightOfParent = parentRect.bottom - parentRect.top;
            var maxY = heightOfParent - minHeight - 5;
            if (y > maxY) {
                y = maxY;
            }
            if (y < 0) {
                y = 0;
            }
        }
    };
    //adds an element to a div, but also listens to background checking for clicks,
    //so that when the background is clicked, the child is removed again, giving
    //a model look to popups.
    PopupService.prototype.addAsModalPopup = function (eChild, closeOnEsc, closedCallback) {
        var eBody = document.body;
        if (!eBody) {
            console.warn('ag-grid: could not find the body of the document, document.body is empty');
            return;
        }
        eChild.style.top = '0px';
        eChild.style.left = '0px';
        var popupAlreadyShown = utils_1.Utils.isVisible(eChild);
        if (popupAlreadyShown) {
            return;
        }
        this.getPopupParent().appendChild(eChild);
        var that = this;
        var popupHidden = false;
        // if we add these listeners now, then the current mouse
        // click will be included, which we don't want
        setTimeout(function () {
            if (closeOnEsc) {
                eBody.addEventListener('keydown', hidePopupOnEsc);
            }
            eBody.addEventListener('click', hidePopup);
            eBody.addEventListener('touchstart', hidePopup);
            eBody.addEventListener('contextmenu', hidePopup);
            //eBody.addEventListener('mousedown', hidePopup);
            eChild.addEventListener('click', consumeMouseClick);
            eChild.addEventListener('touchstart', consumeTouchClick);
            //eChild.addEventListener('mousedown', consumeClick);
        }, 0);
        // var timeOfMouseEventOnChild = new Date().getTime();
        var childMouseClick = null;
        var childTouch = null;
        function hidePopupOnEsc(event) {
            var key = event.which || event.keyCode;
            if (key === constants_1.Constants.KEY_ESCAPE) {
                hidePopup(null);
            }
        }
        function hidePopup(event) {
            // we don't hide popup if the event was on the child
            if (event && event === childMouseClick) {
                return;
            }
            if (event && event === childTouch) {
                return;
            }
            // this method should only be called once. the client can have different
            // paths, each one wanting to close, so this method may be called multiple
            // times.
            if (popupHidden) {
                return;
            }
            popupHidden = true;
            that.getPopupParent().removeChild(eChild);
            eBody.removeEventListener('keydown', hidePopupOnEsc);
            //eBody.removeEventListener('mousedown', hidePopupOnEsc);
            eBody.removeEventListener('click', hidePopup);
            eBody.removeEventListener('touchstart', hidePopup);
            eBody.removeEventListener('contextmenu', hidePopup);
            eChild.removeEventListener('click', consumeMouseClick);
            eChild.removeEventListener('touchstart', consumeTouchClick);
            //eChild.removeEventListener('mousedown', consumeClick);
            if (closedCallback) {
                closedCallback();
            }
        }
        function consumeMouseClick(event) {
            childMouseClick = event;
        }
        function consumeTouchClick(event) {
            childTouch = event;
        }
        return hidePopup;
    };
    __decorate([
        context_1.Autowired('gridCore'), 
        __metadata('design:type', gridCore_1.GridCore)
    ], PopupService.prototype, "gridCore", void 0);
    __decorate([
        context_1.Autowired('gridOptionsWrapper'), 
        __metadata('design:type', gridOptionsWrapper_1.GridOptionsWrapper)
    ], PopupService.prototype, "gridOptionsWrapper", void 0);
    PopupService = __decorate([
        context_1.Bean('popupService'), 
        __metadata('design:paramtypes', [])
    ], PopupService);
    return PopupService;
}());
exports.PopupService = PopupService;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/widgets/touchListener.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var eventService_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/eventService.js");
var utils_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/utils.js");
var TouchListener = (function () {
    function TouchListener(eElement) {
        var _this = this;
        this.destroyFuncs = [];
        this.touching = false;
        this.eventService = new eventService_1.EventService();
        this.eElement = eElement;
        var startListener = this.onTouchStart.bind(this);
        var moveListener = this.onTouchMove.bind(this);
        var endListener = this.onTouchEnd.bind(this);
        this.eElement.addEventListener('touchstart', startListener);
        this.eElement.addEventListener('touchmove', moveListener);
        this.eElement.addEventListener('touchend', endListener);
        this.destroyFuncs.push(function () {
            _this.eElement.addEventListener('touchstart', startListener);
            _this.eElement.addEventListener('touchmove', moveListener);
            _this.eElement.addEventListener('touchend', endListener);
        });
    }
    TouchListener.prototype.getActiveTouch = function (touchList) {
        for (var i = 0; i < touchList.length; i++) {
            var matches = touchList[i].identifier === this.touchStart.identifier;
            if (matches) {
                return touchList[i];
            }
        }
        return null;
    };
    TouchListener.prototype.addEventListener = function (eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    };
    TouchListener.prototype.removeEventListener = function (eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    };
    TouchListener.prototype.onTouchStart = function (touchEvent) {
        var _this = this;
        // only looking at one touch point at any time
        if (this.touching) {
            return;
        }
        this.touchStart = touchEvent.touches[0];
        this.touching = true;
        this.moved = false;
        var touchStartCopy = this.touchStart;
        setTimeout(function () {
            var touchesMatch = _this.touchStart === touchStartCopy;
            if (_this.touching && touchesMatch && !_this.moved) {
                _this.moved = true;
                _this.eventService.dispatchEvent(TouchListener.EVENT_LONG_TAP, _this.touchStart);
            }
        }, 500);
    };
    TouchListener.prototype.onTouchMove = function (touchEvent) {
        if (!this.touching) {
            return;
        }
        var touch = this.getActiveTouch(touchEvent.touches);
        if (!touch) {
            return;
        }
        var eventIsFarAway = !utils_1.Utils.areEventsNear(touch, this.touchStart, 4);
        if (eventIsFarAway) {
            this.moved = true;
        }
    };
    TouchListener.prototype.onTouchEnd = function (touchEvent) {
        if (!this.touching) {
            return;
        }
        if (!this.moved) {
            this.eventService.dispatchEvent(TouchListener.EVENT_TAP, this.touchStart);
        }
        this.touching = false;
    };
    TouchListener.prototype.destroy = function () {
        this.destroyFuncs.forEach(function (func) { return func(); });
    };
    // private mostRecentTouch: Touch;
    TouchListener.EVENT_TAP = 'tap';
    TouchListener.EVENT_LONG_TAP = 'longTap';
    return TouchListener;
}());
exports.TouchListener = TouchListener;


/***/ }),

/***/ "./node_modules/ag-grid/dist/lib/xmlFactory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v7.2.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var context_1 = __webpack_require__("./node_modules/ag-grid/dist/lib/context/context.js");
var LINE_SEPARATOR = '\r\n';
var XmlFactory = (function () {
    function XmlFactory() {
    }
    XmlFactory.prototype.createXml = function (xmlElement) {
        var _this = this;
        var props = "";
        if (xmlElement.properties && xmlElement.properties.prefix && xmlElement.properties.prefixedMap) {
            Object.keys(xmlElement.properties.prefixedMap).forEach(function (key) {
                props += " " + xmlElement.properties.prefix + key + "=\"" + xmlElement.properties.prefixedMap[key] + "\"";
            });
        }
        if (xmlElement.properties && xmlElement.properties.rawMap) {
            Object.keys(xmlElement.properties.rawMap).forEach(function (key) {
                props += " " + key + "=\"" + xmlElement.properties.rawMap[key] + "\"";
            });
        }
        var result = "<" + xmlElement.name + props;
        if (!xmlElement.children && !xmlElement.textNode) {
            return result + "/>" + LINE_SEPARATOR;
        }
        if (xmlElement.textNode) {
            return result + ">" + xmlElement.textNode + "</" + xmlElement.name + ">" + LINE_SEPARATOR;
        }
        result += ">" + LINE_SEPARATOR;
        xmlElement.children.forEach(function (it) {
            result += _this.createXml(it);
        });
        return result + "</" + xmlElement.name + ">" + LINE_SEPARATOR;
    };
    XmlFactory = __decorate([
        context_1.Bean('xmlFactory'), 
        __metadata('design:paramtypes', [])
    ], XmlFactory);
    return XmlFactory;
}());
exports.XmlFactory = XmlFactory;


/***/ }),

/***/ "./node_modules/ag-grid/dist/styles/ag-grid.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/ag-grid/dist/styles/theme-fresh.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/ag-grid/main.js":
/***/ (function(module, exports, __webpack_require__) {


////////// MAKE SURE YOU EDIT main-webpack.js IF EDITING THIS FILE!!!

var populateClientExports = __webpack_require__("./node_modules/ag-grid/dist/lib/clientExports.js").populateClientExports;
populateClientExports(exports);


/***/ }),

/***/ "./node_modules/babel-runtime/core-js/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/array/from.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/get-iterator.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/json/stringify.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/get-own-property-names.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/values.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/promise.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/promise.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/set.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/set.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/symbol/has-instance.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/symbol/has-instance.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/defineEnumerableProperties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    (0, _defineProperty2.default)(obj, key, desc);
  }

  return obj;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/get.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/toConsumableArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "./node_modules/base64-js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("./node_modules/base64-js/index.js")
var ieee754 = __webpack_require__("./node_modules/ieee754/index.js")
var isArray = __webpack_require__("./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/c3/c3.js":
/***/ (function(module, exports, __webpack_require__) {

/* @license C3.js v0.4.24 | (c) C3 Team and other contributors | http://c3js.org/ */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.c3 = factory());
}(this, (function () { 'use strict';

    var CLASS = {
        target: 'c3-target',
        chart: 'c3-chart',
        chartLine: 'c3-chart-line',
        chartLines: 'c3-chart-lines',
        chartBar: 'c3-chart-bar',
        chartBars: 'c3-chart-bars',
        chartText: 'c3-chart-text',
        chartTexts: 'c3-chart-texts',
        chartArc: 'c3-chart-arc',
        chartArcs: 'c3-chart-arcs',
        chartArcsTitle: 'c3-chart-arcs-title',
        chartArcsBackground: 'c3-chart-arcs-background',
        chartArcsGaugeUnit: 'c3-chart-arcs-gauge-unit',
        chartArcsGaugeMax: 'c3-chart-arcs-gauge-max',
        chartArcsGaugeMin: 'c3-chart-arcs-gauge-min',
        selectedCircle: 'c3-selected-circle',
        selectedCircles: 'c3-selected-circles',
        eventRect: 'c3-event-rect',
        eventRects: 'c3-event-rects',
        eventRectsSingle: 'c3-event-rects-single',
        eventRectsMultiple: 'c3-event-rects-multiple',
        zoomRect: 'c3-zoom-rect',
        brush: 'c3-brush',
        focused: 'c3-focused',
        defocused: 'c3-defocused',
        region: 'c3-region',
        regions: 'c3-regions',
        title: 'c3-title',
        tooltipContainer: 'c3-tooltip-container',
        tooltip: 'c3-tooltip',
        tooltipName: 'c3-tooltip-name',
        shape: 'c3-shape',
        shapes: 'c3-shapes',
        line: 'c3-line',
        lines: 'c3-lines',
        bar: 'c3-bar',
        bars: 'c3-bars',
        circle: 'c3-circle',
        circles: 'c3-circles',
        arc: 'c3-arc',
        arcLabelLine: 'c3-arc-label-line',
        arcs: 'c3-arcs',
        area: 'c3-area',
        areas: 'c3-areas',
        empty: 'c3-empty',
        text: 'c3-text',
        texts: 'c3-texts',
        gaugeValue: 'c3-gauge-value',
        grid: 'c3-grid',
        gridLines: 'c3-grid-lines',
        xgrid: 'c3-xgrid',
        xgrids: 'c3-xgrids',
        xgridLine: 'c3-xgrid-line',
        xgridLines: 'c3-xgrid-lines',
        xgridFocus: 'c3-xgrid-focus',
        ygrid: 'c3-ygrid',
        ygrids: 'c3-ygrids',
        ygridLine: 'c3-ygrid-line',
        ygridLines: 'c3-ygrid-lines',
        axis: 'c3-axis',
        axisX: 'c3-axis-x',
        axisXLabel: 'c3-axis-x-label',
        axisY: 'c3-axis-y',
        axisYLabel: 'c3-axis-y-label',
        axisY2: 'c3-axis-y2',
        axisY2Label: 'c3-axis-y2-label',
        legendBackground: 'c3-legend-background',
        legendItem: 'c3-legend-item',
        legendItemEvent: 'c3-legend-item-event',
        legendItemTile: 'c3-legend-item-tile',
        legendItemHidden: 'c3-legend-item-hidden',
        legendItemFocused: 'c3-legend-item-focused',
        dragarea: 'c3-dragarea',
        EXPANDED: '_expanded_',
        SELECTED: '_selected_',
        INCLUDED: '_included_'
    };

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    var classCallCheck = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    var inherits = function (subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };

    var possibleConstructorReturn = function (self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };

    var isValue = function isValue(v) {
        return v || v === 0;
    };
    var isFunction = function isFunction(o) {
        return typeof o === 'function';
    };
    var isArray = function isArray(o) {
        return Array.isArray(o);
    };
    var isString = function isString(o) {
        return typeof o === 'string';
    };
    var isUndefined = function isUndefined(v) {
        return typeof v === 'undefined';
    };
    var isDefined = function isDefined(v) {
        return typeof v !== 'undefined';
    };
    var ceil10 = function ceil10(v) {
        return Math.ceil(v / 10) * 10;
    };
    var asHalfPixel = function asHalfPixel(n) {
        return Math.ceil(n) + 0.5;
    };
    var diffDomain = function diffDomain(d) {
        return d[1] - d[0];
    };
    var isEmpty = function isEmpty(o) {
        return typeof o === 'undefined' || o === null || isString(o) && o.length === 0 || (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && Object.keys(o).length === 0;
    };
    var notEmpty = function notEmpty(o) {
        return !c3_chart_internal_fn.isEmpty(o);
    };
    var getOption = function getOption(options, key, defaultValue) {
        return isDefined(options[key]) ? options[key] : defaultValue;
    };
    var hasValue = function hasValue(dict, value) {
        var found = false;
        Object.keys(dict).forEach(function (key) {
            if (dict[key] === value) {
                found = true;
            }
        });
        return found;
    };
    var sanitise = function sanitise(str) {
        return typeof str === 'string' ? str.replace(/</g, '&lt;').replace(/>/g, '&gt;') : str;
    };
    var getPathBox = function getPathBox(path) {
        var box = path.getBoundingClientRect(),
            items = [path.pathSegList.getItem(0), path.pathSegList.getItem(1)],
            minX = items[0].x,
            minY = Math.min(items[0].y, items[1].y);
        return { x: minX, y: minY, width: box.width, height: box.height };
    };

    var c3_axis_fn;
    var c3_axis_internal_fn;

    function AxisInternal(component, params) {
        var internal = this;
        internal.component = component;
        internal.params = params || {};

        internal.d3 = component.d3;
        internal.scale = internal.d3.scale.linear();
        internal.range;
        internal.orient = "bottom";
        internal.innerTickSize = 6;
        internal.outerTickSize = this.params.withOuterTick ? 6 : 0;
        internal.tickPadding = 3;
        internal.tickValues = null;
        internal.tickFormat;
        internal.tickArguments;

        internal.tickOffset = 0;
        internal.tickCulling = true;
        internal.tickCentered;
        internal.tickTextCharSize;
        internal.tickTextRotate = internal.params.tickTextRotate;
        internal.tickLength;

        internal.axis = internal.generateAxis();
    }
    c3_axis_internal_fn = AxisInternal.prototype;

    c3_axis_internal_fn.axisX = function (selection, x, tickOffset) {
        selection.attr("transform", function (d) {
            return "translate(" + Math.ceil(x(d) + tickOffset) + ", 0)";
        });
    };
    c3_axis_internal_fn.axisY = function (selection, y) {
        selection.attr("transform", function (d) {
            return "translate(0," + Math.ceil(y(d)) + ")";
        });
    };
    c3_axis_internal_fn.scaleExtent = function (domain) {
        var start = domain[0],
            stop = domain[domain.length - 1];
        return start < stop ? [start, stop] : [stop, start];
    };
    c3_axis_internal_fn.generateTicks = function (scale) {
        var internal = this;
        var i,
            domain,
            ticks = [];
        if (scale.ticks) {
            return scale.ticks.apply(scale, internal.tickArguments);
        }
        domain = scale.domain();
        for (i = Math.ceil(domain[0]); i < domain[1]; i++) {
            ticks.push(i);
        }
        if (ticks.length > 0 && ticks[0] > 0) {
            ticks.unshift(ticks[0] - (ticks[1] - ticks[0]));
        }
        return ticks;
    };
    c3_axis_internal_fn.copyScale = function () {
        var internal = this;
        var newScale = internal.scale.copy(),
            domain;
        if (internal.params.isCategory) {
            domain = internal.scale.domain();
            newScale.domain([domain[0], domain[1] - 1]);
        }
        return newScale;
    };
    c3_axis_internal_fn.textFormatted = function (v) {
        var internal = this,
            formatted = internal.tickFormat ? internal.tickFormat(v) : v;
        return typeof formatted !== 'undefined' ? formatted : '';
    };
    c3_axis_internal_fn.updateRange = function () {
        var internal = this;
        internal.range = internal.scale.rangeExtent ? internal.scale.rangeExtent() : internal.scaleExtent(internal.scale.range());
        return internal.range;
    };
    c3_axis_internal_fn.updateTickTextCharSize = function (tick) {
        var internal = this;
        if (internal.tickTextCharSize) {
            return internal.tickTextCharSize;
        }
        var size = {
            h: 11.5,
            w: 5.5
        };
        tick.select('text').text(function (d) {
            return internal.textFormatted(d);
        }).each(function (d) {
            var box = this.getBoundingClientRect(),
                text = internal.textFormatted(d),
                h = box.height,
                w = text ? box.width / text.length : undefined;
            if (h && w) {
                size.h = h;
                size.w = w;
            }
        }).text('');
        internal.tickTextCharSize = size;
        return size;
    };
    c3_axis_internal_fn.transitionise = function (selection) {
        return this.params.withoutTransition ? selection : this.d3.transition(selection);
    };
    c3_axis_internal_fn.isVertical = function () {
        return this.orient === 'left' || this.orient === 'right';
    };
    c3_axis_internal_fn.tspanData = function (d, i, ticks, scale) {
        var internal = this;
        var splitted = internal.params.tickMultiline ? internal.splitTickText(d, ticks, scale) : [].concat(internal.textFormatted(d));

        if (internal.params.tickMultiline && internal.params.tickMultilineMax > 0) {
            splitted = internal.ellipsify(splitted, internal.params.tickMultilineMax);
        }

        return splitted.map(function (s) {
            return { index: i, splitted: s, length: splitted.length };
        });
    };
    c3_axis_internal_fn.splitTickText = function (d, ticks, scale) {
        var internal = this,
            tickText = internal.textFormatted(d),
            maxWidth = internal.params.tickWidth,
            subtext,
            spaceIndex,
            textWidth,
            splitted = [];

        if (Object.prototype.toString.call(tickText) === "[object Array]") {
            return tickText;
        }

        if (!maxWidth || maxWidth <= 0) {
            maxWidth = internal.isVertical() ? 95 : internal.params.isCategory ? Math.ceil(scale(ticks[1]) - scale(ticks[0])) - 12 : 110;
        }

        function split(splitted, text) {
            spaceIndex = undefined;
            for (var i = 1; i < text.length; i++) {
                if (text.charAt(i) === ' ') {
                    spaceIndex = i;
                }
                subtext = text.substr(0, i + 1);
                textWidth = internal.tickTextCharSize.w * subtext.length;
                // if text width gets over tick width, split by space index or crrent index
                if (maxWidth < textWidth) {
                    return split(splitted.concat(text.substr(0, spaceIndex ? spaceIndex : i)), text.slice(spaceIndex ? spaceIndex + 1 : i));
                }
            }
            return splitted.concat(text);
        }

        return split(splitted, tickText + "");
    };
    c3_axis_internal_fn.ellipsify = function (splitted, max) {
        if (splitted.length <= max) {
            return splitted;
        }

        var ellipsified = splitted.slice(0, max);
        var remaining = 3;
        for (var i = max - 1; i >= 0; i--) {
            var available = ellipsified[i].length;

            ellipsified[i] = ellipsified[i].substr(0, available - remaining).padEnd(available, '.');

            remaining -= available;

            if (remaining <= 0) {
                break;
            }
        }

        return ellipsified;
    };
    c3_axis_internal_fn.updateTickLength = function () {
        var internal = this;
        internal.tickLength = Math.max(internal.innerTickSize, 0) + internal.tickPadding;
    };
    c3_axis_internal_fn.lineY2 = function (d) {
        var internal = this,
            tickPosition = internal.scale(d) + (internal.tickCentered ? 0 : internal.tickOffset);
        return internal.range[0] < tickPosition && tickPosition < internal.range[1] ? internal.innerTickSize : 0;
    };
    c3_axis_internal_fn.textY = function () {
        var internal = this,
            rotate = internal.tickTextRotate;
        return rotate ? 11.5 - 2.5 * (rotate / 15) * (rotate > 0 ? 1 : -1) : internal.tickLength;
    };
    c3_axis_internal_fn.textTransform = function () {
        var internal = this,
            rotate = internal.tickTextRotate;
        return rotate ? "rotate(" + rotate + ")" : "";
    };
    c3_axis_internal_fn.textTextAnchor = function () {
        var internal = this,
            rotate = internal.tickTextRotate;
        return rotate ? rotate > 0 ? "start" : "end" : "middle";
    };
    c3_axis_internal_fn.tspanDx = function () {
        var internal = this,
            rotate = internal.tickTextRotate;
        return rotate ? 8 * Math.sin(Math.PI * (rotate / 180)) : 0;
    };
    c3_axis_internal_fn.tspanDy = function (d, i) {
        var internal = this,
            dy = internal.tickTextCharSize.h;
        if (i === 0) {
            if (internal.isVertical()) {
                dy = -((d.length - 1) * (internal.tickTextCharSize.h / 2) - 3);
            } else {
                dy = ".71em";
            }
        }
        return dy;
    };

    c3_axis_internal_fn.generateAxis = function () {
        var internal = this,
            d3 = internal.d3,
            params = internal.params;
        function axis(g) {
            g.each(function () {
                var g = axis.g = d3.select(this);

                var scale0 = this.__chart__ || internal.scale,
                    scale1 = this.__chart__ = internal.copyScale();

                var ticks = internal.tickValues ? internal.tickValues : internal.generateTicks(scale1),
                    tick = g.selectAll(".tick").data(ticks, scale1),
                    tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", 1e-6),

                // MEMO: No exit transition. The reason is this transition affects max tick width calculation because old tick will be included in the ticks.
                tickExit = tick.exit().remove(),
                    tickUpdate = internal.transitionise(tick).style("opacity", 1),
                    tickTransform,
                    tickX,
                    tickY;

                if (params.isCategory) {
                    internal.tickOffset = Math.ceil((scale1(1) - scale1(0)) / 2);
                    tickX = internal.tickCentered ? 0 : internal.tickOffset;
                    tickY = internal.tickCentered ? internal.tickOffset : 0;
                } else {
                    internal.tickOffset = tickX = 0;
                }

                tickEnter.append("line");
                tickEnter.append("text");

                internal.updateRange();
                internal.updateTickLength();
                internal.updateTickTextCharSize(g.select('.tick'));

                var lineUpdate = tickUpdate.select("line"),
                    textUpdate = tickUpdate.select("text"),
                    tspanUpdate = tick.select("text").selectAll('tspan').data(function (d, i) {
                    return internal.tspanData(d, i, ticks, scale1);
                });

                tspanUpdate.enter().append('tspan');
                tspanUpdate.exit().remove();
                tspanUpdate.text(function (d) {
                    return d.splitted;
                });

                var path = g.selectAll(".domain").data([0]),
                    pathUpdate = (path.enter().append("path").attr("class", "domain"), internal.transitionise(path));

                // TODO: each attr should be one function and change its behavior by internal.orient, probably
                switch (internal.orient) {
                    case "bottom":
                        {
                            tickTransform = internal.axisX;
                            lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function (d, i) {
                                return internal.lineY2(d, i);
                            });
                            textUpdate.attr("x", 0).attr("y", function (d, i) {
                                return internal.textY(d, i);
                            }).attr("transform", function (d, i) {
                                return internal.textTransform(d, i);
                            }).style("text-anchor", function (d, i) {
                                return internal.textTextAnchor(d, i);
                            });
                            tspanUpdate.attr('x', 0).attr("dy", function (d, i) {
                                return internal.tspanDy(d, i);
                            }).attr('dx', function (d, i) {
                                return internal.tspanDx(d, i);
                            });
                            pathUpdate.attr("d", "M" + internal.range[0] + "," + internal.outerTickSize + "V0H" + internal.range[1] + "V" + internal.outerTickSize);
                            break;
                        }
                    case "top":
                        {
                            // TODO: rotated tick text
                            tickTransform = internal.axisX;
                            lineUpdate.attr("x1", tickX).attr("x2", tickX).attr("y2", function (d, i) {
                                return -1 * internal.lineY2(d, i);
                            });
                            textUpdate.attr("x", 0).attr("y", function (d, i) {
                                return -1 * internal.textY(d, i) - (params.isCategory ? 2 : internal.tickLength - 2);
                            }).attr("transform", function (d, i) {
                                return internal.textTransform(d, i);
                            }).style("text-anchor", function (d, i) {
                                return internal.textTextAnchor(d, i);
                            });
                            tspanUpdate.attr('x', 0).attr("dy", function (d, i) {
                                return internal.tspanDy(d, i);
                            }).attr('dx', function (d, i) {
                                return internal.tspanDx(d, i);
                            });
                            pathUpdate.attr("d", "M" + internal.range[0] + "," + -internal.outerTickSize + "V0H" + internal.range[1] + "V" + -internal.outerTickSize);
                            break;
                        }
                    case "left":
                        {
                            tickTransform = internal.axisY;
                            lineUpdate.attr("x2", -internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
                            textUpdate.attr("x", -internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "end");
                            tspanUpdate.attr('x', -internal.tickLength).attr("dy", function (d, i) {
                                return internal.tspanDy(d, i);
                            });
                            pathUpdate.attr("d", "M" + -internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + -internal.outerTickSize);
                            break;
                        }
                    case "right":
                        {
                            tickTransform = internal.axisY;
                            lineUpdate.attr("x2", internal.innerTickSize).attr("y1", tickY).attr("y2", tickY);
                            textUpdate.attr("x", internal.tickLength).attr("y", internal.tickOffset).style("text-anchor", "start");
                            tspanUpdate.attr('x', internal.tickLength).attr("dy", function (d, i) {
                                return internal.tspanDy(d, i);
                            });
                            pathUpdate.attr("d", "M" + internal.outerTickSize + "," + internal.range[0] + "H0V" + internal.range[1] + "H" + internal.outerTickSize);
                            break;
                        }
                }
                if (scale1.rangeBand) {
                    var x = scale1,
                        dx = x.rangeBand() / 2;
                    scale0 = scale1 = function scale1(d) {
                        return x(d) + dx;
                    };
                } else if (scale0.rangeBand) {
                    scale0 = scale1;
                } else {
                    tickExit.call(tickTransform, scale1, internal.tickOffset);
                }
                tickEnter.call(tickTransform, scale0, internal.tickOffset);
                tickUpdate.call(tickTransform, scale1, internal.tickOffset);
            });
        }
        axis.scale = function (x) {
            if (!arguments.length) {
                return internal.scale;
            }
            internal.scale = x;
            return axis;
        };
        axis.orient = function (x) {
            if (!arguments.length) {
                return internal.orient;
            }
            internal.orient = x in { top: 1, right: 1, bottom: 1, left: 1 } ? x + "" : "bottom";
            return axis;
        };
        axis.tickFormat = function (format) {
            if (!arguments.length) {
                return internal.tickFormat;
            }
            internal.tickFormat = format;
            return axis;
        };
        axis.tickCentered = function (isCentered) {
            if (!arguments.length) {
                return internal.tickCentered;
            }
            internal.tickCentered = isCentered;
            return axis;
        };
        axis.tickOffset = function () {
            return internal.tickOffset;
        };
        axis.tickInterval = function () {
            var interval, length;
            if (params.isCategory) {
                interval = internal.tickOffset * 2;
            } else {
                length = axis.g.select('path.domain').node().getTotalLength() - internal.outerTickSize * 2;
                interval = length / axis.g.selectAll('line').size();
            }
            return interval === Infinity ? 0 : interval;
        };
        axis.ticks = function () {
            if (!arguments.length) {
                return internal.tickArguments;
            }
            internal.tickArguments = arguments;
            return axis;
        };
        axis.tickCulling = function (culling) {
            if (!arguments.length) {
                return internal.tickCulling;
            }
            internal.tickCulling = culling;
            return axis;
        };
        axis.tickValues = function (x) {
            if (typeof x === 'function') {
                internal.tickValues = function () {
                    return x(internal.scale.domain());
                };
            } else {
                if (!arguments.length) {
                    return internal.tickValues;
                }
                internal.tickValues = x;
            }
            return axis;
        };
        return axis;
    };

    var Axis = function (_Component) {
        inherits(Axis, _Component);

        function Axis(owner) {
            classCallCheck(this, Axis);

            var fn = {
                fn: c3_axis_fn,
                internal: {
                    fn: c3_axis_internal_fn
                }
            };

            var _this = possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).call(this, owner, 'axis', fn));

            _this.d3 = owner.d3;
            _this.internal = AxisInternal;
            return _this;
        }

        return Axis;
    }(Component);

    c3_axis_fn = Axis.prototype;

    c3_axis_fn.init = function init() {
        var $$ = this.owner,
            config = $$.config,
            main = $$.main;
        $$.axes.x = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisX).attr("clip-path", config.axis_x_inner ? "" : $$.clipPathForXAxis).attr("transform", $$.getTranslate('x')).style("visibility", config.axis_x_show ? 'visible' : 'hidden');
        $$.axes.x.append("text").attr("class", CLASS.axisXLabel).attr("transform", config.axis_rotated ? "rotate(-90)" : "").style("text-anchor", this.textAnchorForXAxisLabel.bind(this));
        $$.axes.y = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisY).attr("clip-path", config.axis_y_inner ? "" : $$.clipPathForYAxis).attr("transform", $$.getTranslate('y')).style("visibility", config.axis_y_show ? 'visible' : 'hidden');
        $$.axes.y.append("text").attr("class", CLASS.axisYLabel).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForYAxisLabel.bind(this));

        $$.axes.y2 = main.append("g").attr("class", CLASS.axis + ' ' + CLASS.axisY2)
        // clip-path?
        .attr("transform", $$.getTranslate('y2')).style("visibility", config.axis_y2_show ? 'visible' : 'hidden');
        $$.axes.y2.append("text").attr("class", CLASS.axisY2Label).attr("transform", config.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForY2AxisLabel.bind(this));
    };
    c3_axis_fn.getXAxis = function getXAxis(scale, orient, tickFormat, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
        var $$ = this.owner,
            config = $$.config,
            axisParams = {
            isCategory: $$.isCategorized(),
            withOuterTick: withOuterTick,
            tickMultiline: config.axis_x_tick_multiline,
            tickMultilineMax: config.axis_x_tick_multiline ? Number(config.axis_x_tick_multilineMax) : 0,
            tickWidth: config.axis_x_tick_width,
            tickTextRotate: withoutRotateTickText ? 0 : config.axis_x_tick_rotate,
            withoutTransition: withoutTransition
        },
            axis = new this.internal(this, axisParams).axis.scale(scale).orient(orient);

        if ($$.isTimeSeries() && tickValues && typeof tickValues !== "function") {
            tickValues = tickValues.map(function (v) {
                return $$.parseDate(v);
            });
        }

        // Set tick
        axis.tickFormat(tickFormat).tickValues(tickValues);
        if ($$.isCategorized()) {
            axis.tickCentered(config.axis_x_tick_centered);
            if (isEmpty(config.axis_x_tick_culling)) {
                config.axis_x_tick_culling = false;
            }
        }

        return axis;
    };
    c3_axis_fn.updateXAxisTickValues = function updateXAxisTickValues(targets, axis) {
        var $$ = this.owner,
            config = $$.config,
            tickValues;
        if (config.axis_x_tick_fit || config.axis_x_tick_count) {
            tickValues = this.generateTickValues($$.mapTargetsToUniqueXs(targets), config.axis_x_tick_count, $$.isTimeSeries());
        }
        if (axis) {
            axis.tickValues(tickValues);
        } else {
            $$.xAxis.tickValues(tickValues);
            $$.subXAxis.tickValues(tickValues);
        }
        return tickValues;
    };
    c3_axis_fn.getYAxis = function getYAxis(scale, orient, tickFormat, tickValues, withOuterTick, withoutTransition, withoutRotateTickText) {
        var $$ = this.owner,
            config = $$.config,
            axisParams = {
            withOuterTick: withOuterTick,
            withoutTransition: withoutTransition,
            tickTextRotate: withoutRotateTickText ? 0 : config.axis_y_tick_rotate
        },
            axis = new this.internal(this, axisParams).axis.scale(scale).orient(orient).tickFormat(tickFormat);
        if ($$.isTimeSeriesY()) {
            axis.ticks($$.d3.time[config.axis_y_tick_time_value], config.axis_y_tick_time_interval);
        } else {
            axis.tickValues(tickValues);
        }
        return axis;
    };
    c3_axis_fn.getId = function getId(id) {
        var config = this.owner.config;
        return id in config.data_axes ? config.data_axes[id] : 'y';
    };
    c3_axis_fn.getXAxisTickFormat = function getXAxisTickFormat() {
        var $$ = this.owner,
            config = $$.config,
            format = $$.isTimeSeries() ? $$.defaultAxisTimeFormat : $$.isCategorized() ? $$.categoryName : function (v) {
            return v < 0 ? v.toFixed(0) : v;
        };
        if (config.axis_x_tick_format) {
            if (isFunction(config.axis_x_tick_format)) {
                format = config.axis_x_tick_format;
            } else if ($$.isTimeSeries()) {
                format = function format(date) {
                    return date ? $$.axisTimeFormat(config.axis_x_tick_format)(date) : "";
                };
            }
        }
        return isFunction(format) ? function (v) {
            return format.call($$, v);
        } : format;
    };
    c3_axis_fn.getTickValues = function getTickValues(tickValues, axis) {
        return tickValues ? tickValues : axis ? axis.tickValues() : undefined;
    };
    c3_axis_fn.getXAxisTickValues = function getXAxisTickValues() {
        return this.getTickValues(this.owner.config.axis_x_tick_values, this.owner.xAxis);
    };
    c3_axis_fn.getYAxisTickValues = function getYAxisTickValues() {
        return this.getTickValues(this.owner.config.axis_y_tick_values, this.owner.yAxis);
    };
    c3_axis_fn.getY2AxisTickValues = function getY2AxisTickValues() {
        return this.getTickValues(this.owner.config.axis_y2_tick_values, this.owner.y2Axis);
    };
    c3_axis_fn.getLabelOptionByAxisId = function getLabelOptionByAxisId(axisId) {
        var $$ = this.owner,
            config = $$.config,
            option;
        if (axisId === 'y') {
            option = config.axis_y_label;
        } else if (axisId === 'y2') {
            option = config.axis_y2_label;
        } else if (axisId === 'x') {
            option = config.axis_x_label;
        }
        return option;
    };
    c3_axis_fn.getLabelText = function getLabelText(axisId) {
        var option = this.getLabelOptionByAxisId(axisId);
        return isString(option) ? option : option ? option.text : null;
    };
    c3_axis_fn.setLabelText = function setLabelText(axisId, text) {
        var $$ = this.owner,
            config = $$.config,
            option = this.getLabelOptionByAxisId(axisId);
        if (isString(option)) {
            if (axisId === 'y') {
                config.axis_y_label = text;
            } else if (axisId === 'y2') {
                config.axis_y2_label = text;
            } else if (axisId === 'x') {
                config.axis_x_label = text;
            }
        } else if (option) {
            option.text = text;
        }
    };
    c3_axis_fn.getLabelPosition = function getLabelPosition(axisId, defaultPosition) {
        var option = this.getLabelOptionByAxisId(axisId),
            position = option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option.position ? option.position : defaultPosition;
        return {
            isInner: position.indexOf('inner') >= 0,
            isOuter: position.indexOf('outer') >= 0,
            isLeft: position.indexOf('left') >= 0,
            isCenter: position.indexOf('center') >= 0,
            isRight: position.indexOf('right') >= 0,
            isTop: position.indexOf('top') >= 0,
            isMiddle: position.indexOf('middle') >= 0,
            isBottom: position.indexOf('bottom') >= 0
        };
    };
    c3_axis_fn.getXAxisLabelPosition = function getXAxisLabelPosition() {
        return this.getLabelPosition('x', this.owner.config.axis_rotated ? 'inner-top' : 'inner-right');
    };
    c3_axis_fn.getYAxisLabelPosition = function getYAxisLabelPosition() {
        return this.getLabelPosition('y', this.owner.config.axis_rotated ? 'inner-right' : 'inner-top');
    };
    c3_axis_fn.getY2AxisLabelPosition = function getY2AxisLabelPosition() {
        return this.getLabelPosition('y2', this.owner.config.axis_rotated ? 'inner-right' : 'inner-top');
    };
    c3_axis_fn.getLabelPositionById = function getLabelPositionById(id) {
        return id === 'y2' ? this.getY2AxisLabelPosition() : id === 'y' ? this.getYAxisLabelPosition() : this.getXAxisLabelPosition();
    };
    c3_axis_fn.textForXAxisLabel = function textForXAxisLabel() {
        return this.getLabelText('x');
    };
    c3_axis_fn.textForYAxisLabel = function textForYAxisLabel() {
        return this.getLabelText('y');
    };
    c3_axis_fn.textForY2AxisLabel = function textForY2AxisLabel() {
        return this.getLabelText('y2');
    };
    c3_axis_fn.xForAxisLabel = function xForAxisLabel(forHorizontal, position) {
        var $$ = this.owner;
        if (forHorizontal) {
            return position.isLeft ? 0 : position.isCenter ? $$.width / 2 : $$.width;
        } else {
            return position.isBottom ? -$$.height : position.isMiddle ? -$$.height / 2 : 0;
        }
    };
    c3_axis_fn.dxForAxisLabel = function dxForAxisLabel(forHorizontal, position) {
        if (forHorizontal) {
            return position.isLeft ? "0.5em" : position.isRight ? "-0.5em" : "0";
        } else {
            return position.isTop ? "-0.5em" : position.isBottom ? "0.5em" : "0";
        }
    };
    c3_axis_fn.textAnchorForAxisLabel = function textAnchorForAxisLabel(forHorizontal, position) {
        if (forHorizontal) {
            return position.isLeft ? 'start' : position.isCenter ? 'middle' : 'end';
        } else {
            return position.isBottom ? 'start' : position.isMiddle ? 'middle' : 'end';
        }
    };
    c3_axis_fn.xForXAxisLabel = function xForXAxisLabel() {
        return this.xForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
    };
    c3_axis_fn.xForYAxisLabel = function xForYAxisLabel() {
        return this.xForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
    };
    c3_axis_fn.xForY2AxisLabel = function xForY2AxisLabel() {
        return this.xForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
    };
    c3_axis_fn.dxForXAxisLabel = function dxForXAxisLabel() {
        return this.dxForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
    };
    c3_axis_fn.dxForYAxisLabel = function dxForYAxisLabel() {
        return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
    };
    c3_axis_fn.dxForY2AxisLabel = function dxForY2AxisLabel() {
        return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
    };
    c3_axis_fn.dyForXAxisLabel = function dyForXAxisLabel() {
        var $$ = this.owner,
            config = $$.config,
            position = this.getXAxisLabelPosition();
        if (config.axis_rotated) {
            return position.isInner ? "1.2em" : -25 - ($$.config.axis_x_inner ? 0 : this.getMaxTickWidth('x'));
        } else {
            return position.isInner ? "-0.5em" : config.axis_x_height ? config.axis_x_height - 10 : "3em";
        }
    };
    c3_axis_fn.dyForYAxisLabel = function dyForYAxisLabel() {
        var $$ = this.owner,
            position = this.getYAxisLabelPosition();
        if ($$.config.axis_rotated) {
            return position.isInner ? "-0.5em" : "3em";
        } else {
            return position.isInner ? "1.2em" : -10 - ($$.config.axis_y_inner ? 0 : this.getMaxTickWidth('y') + 10);
        }
    };
    c3_axis_fn.dyForY2AxisLabel = function dyForY2AxisLabel() {
        var $$ = this.owner,
            position = this.getY2AxisLabelPosition();
        if ($$.config.axis_rotated) {
            return position.isInner ? "1.2em" : "-2.2em";
        } else {
            return position.isInner ? "-0.5em" : 15 + ($$.config.axis_y2_inner ? 0 : this.getMaxTickWidth('y2') + 15);
        }
    };
    c3_axis_fn.textAnchorForXAxisLabel = function textAnchorForXAxisLabel() {
        var $$ = this.owner;
        return this.textAnchorForAxisLabel(!$$.config.axis_rotated, this.getXAxisLabelPosition());
    };
    c3_axis_fn.textAnchorForYAxisLabel = function textAnchorForYAxisLabel() {
        var $$ = this.owner;
        return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getYAxisLabelPosition());
    };
    c3_axis_fn.textAnchorForY2AxisLabel = function textAnchorForY2AxisLabel() {
        var $$ = this.owner;
        return this.textAnchorForAxisLabel($$.config.axis_rotated, this.getY2AxisLabelPosition());
    };
    c3_axis_fn.getMaxTickWidth = function getMaxTickWidth(id, withoutRecompute) {
        var $$ = this.owner,
            config = $$.config,
            maxWidth = 0,
            targetsToShow,
            scale,
            axis,
            dummy,
            svg;
        if (withoutRecompute && $$.currentMaxTickWidths[id]) {
            return $$.currentMaxTickWidths[id];
        }
        if ($$.svg) {
            targetsToShow = $$.filterTargetsToShow($$.data.targets);
            if (id === 'y') {
                scale = $$.y.copy().domain($$.getYDomain(targetsToShow, 'y'));
                axis = this.getYAxis(scale, $$.yOrient, config.axis_y_tick_format, $$.yAxisTickValues, false, true, true);
            } else if (id === 'y2') {
                scale = $$.y2.copy().domain($$.getYDomain(targetsToShow, 'y2'));
                axis = this.getYAxis(scale, $$.y2Orient, config.axis_y2_tick_format, $$.y2AxisTickValues, false, true, true);
            } else {
                scale = $$.x.copy().domain($$.getXDomain(targetsToShow));
                axis = this.getXAxis(scale, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, false, true, true);
                this.updateXAxisTickValues(targetsToShow, axis);
            }
            dummy = $$.d3.select('body').append('div').classed('c3', true);
            svg = dummy.append("svg").style('visibility', 'hidden').style('position', 'fixed').style('top', 0).style('left', 0), svg.append('g').call(axis).each(function () {
                $$.d3.select(this).selectAll('text').each(function () {
                    var box = this.getBoundingClientRect();
                    if (maxWidth < box.width) {
                        maxWidth = box.width;
                    }
                });
                dummy.remove();
            });
        }
        $$.currentMaxTickWidths[id] = maxWidth <= 0 ? $$.currentMaxTickWidths[id] : maxWidth;
        return $$.currentMaxTickWidths[id];
    };

    c3_axis_fn.updateLabels = function updateLabels(withTransition) {
        var $$ = this.owner;
        var axisXLabel = $$.main.select('.' + CLASS.axisX + ' .' + CLASS.axisXLabel),
            axisYLabel = $$.main.select('.' + CLASS.axisY + ' .' + CLASS.axisYLabel),
            axisY2Label = $$.main.select('.' + CLASS.axisY2 + ' .' + CLASS.axisY2Label);
        (withTransition ? axisXLabel.transition() : axisXLabel).attr("x", this.xForXAxisLabel.bind(this)).attr("dx", this.dxForXAxisLabel.bind(this)).attr("dy", this.dyForXAxisLabel.bind(this)).text(this.textForXAxisLabel.bind(this));
        (withTransition ? axisYLabel.transition() : axisYLabel).attr("x", this.xForYAxisLabel.bind(this)).attr("dx", this.dxForYAxisLabel.bind(this)).attr("dy", this.dyForYAxisLabel.bind(this)).text(this.textForYAxisLabel.bind(this));
        (withTransition ? axisY2Label.transition() : axisY2Label).attr("x", this.xForY2AxisLabel.bind(this)).attr("dx", this.dxForY2AxisLabel.bind(this)).attr("dy", this.dyForY2AxisLabel.bind(this)).text(this.textForY2AxisLabel.bind(this));
    };
    c3_axis_fn.getPadding = function getPadding(padding, key, defaultValue, domainLength) {
        var p = typeof padding === 'number' ? padding : padding[key];
        if (!isValue(p)) {
            return defaultValue;
        }
        if (padding.unit === 'ratio') {
            return padding[key] * domainLength;
        }
        // assume padding is pixels if unit is not specified
        return this.convertPixelsToAxisPadding(p, domainLength);
    };
    c3_axis_fn.convertPixelsToAxisPadding = function convertPixelsToAxisPadding(pixels, domainLength) {
        var $$ = this.owner,
            length = $$.config.axis_rotated ? $$.width : $$.height;
        return domainLength * (pixels / length);
    };
    c3_axis_fn.generateTickValues = function generateTickValues(values, tickCount, forTimeSeries) {
        var tickValues = values,
            targetCount,
            start,
            end,
            count,
            interval,
            i,
            tickValue;
        if (tickCount) {
            targetCount = isFunction(tickCount) ? tickCount() : tickCount;
            // compute ticks according to tickCount
            if (targetCount === 1) {
                tickValues = [values[0]];
            } else if (targetCount === 2) {
                tickValues = [values[0], values[values.length - 1]];
            } else if (targetCount > 2) {
                count = targetCount - 2;
                start = values[0];
                end = values[values.length - 1];
                interval = (end - start) / (count + 1);
                // re-construct unique values
                tickValues = [start];
                for (i = 0; i < count; i++) {
                    tickValue = +start + interval * (i + 1);
                    tickValues.push(forTimeSeries ? new Date(tickValue) : tickValue);
                }
                tickValues.push(end);
            }
        }
        if (!forTimeSeries) {
            tickValues = tickValues.sort(function (a, b) {
                return a - b;
            });
        }
        return tickValues;
    };
    c3_axis_fn.generateTransitions = function generateTransitions(duration) {
        var $$ = this.owner,
            axes = $$.axes;
        return {
            axisX: duration ? axes.x.transition().duration(duration) : axes.x,
            axisY: duration ? axes.y.transition().duration(duration) : axes.y,
            axisY2: duration ? axes.y2.transition().duration(duration) : axes.y2,
            axisSubX: duration ? axes.subx.transition().duration(duration) : axes.subx
        };
    };
    c3_axis_fn.redraw = function redraw(transitions, isHidden) {
        var $$ = this.owner;
        $$.axes.x.style("opacity", isHidden ? 0 : 1);
        $$.axes.y.style("opacity", isHidden ? 0 : 1);
        $$.axes.y2.style("opacity", isHidden ? 0 : 1);
        $$.axes.subx.style("opacity", isHidden ? 0 : 1);
        transitions.axisX.call($$.xAxis);
        transitions.axisY.call($$.yAxis);
        transitions.axisY2.call($$.y2Axis);
        transitions.axisSubX.call($$.subXAxis);
    };

    var c3 = { version: "0.4.24" };

    var c3_chart_fn;
    var c3_chart_internal_fn;

    function Component(owner, componentKey, fn) {
        this.owner = owner;
        c3.chart.internal[componentKey] = fn;
    }

    function Chart(config) {
        var $$ = this.internal = new ChartInternal(this);
        $$.loadConfig(config);

        $$.beforeInit(config);
        $$.init();
        $$.afterInit(config);

        // bind "this" to nested API
        (function bindThis(fn, target, argThis) {
            Object.keys(fn).forEach(function (key) {
                target[key] = fn[key].bind(argThis);
                if (Object.keys(fn[key]).length > 0) {
                    bindThis(fn[key], target[key], argThis);
                }
            });
        })(c3_chart_fn, this, this);
    }

    function ChartInternal(api) {
        var $$ = this;
        $$.d3 = window.d3 ? window.d3 :  true ? __webpack_require__("./node_modules/d3/d3.js") : undefined;
        $$.api = api;
        $$.config = $$.getDefaultConfig();
        $$.data = {};
        $$.cache = {};
        $$.axes = {};
    }

    c3.generate = function (config) {
        return new Chart(config);
    };

    c3.chart = {
        fn: Chart.prototype,
        internal: {
            fn: ChartInternal.prototype
        }
    };
    c3_chart_fn = c3.chart.fn;
    c3_chart_internal_fn = c3.chart.internal.fn;

    c3_chart_internal_fn.beforeInit = function () {
        // can do something
    };
    c3_chart_internal_fn.afterInit = function () {
        // can do something
    };
    c3_chart_internal_fn.init = function () {
        var $$ = this,
            config = $$.config;

        $$.initParams();

        if (config.data_url) {
            $$.convertUrlToData(config.data_url, config.data_mimeType, config.data_headers, config.data_keys, $$.initWithData);
        } else if (config.data_json) {
            $$.initWithData($$.convertJsonToData(config.data_json, config.data_keys));
        } else if (config.data_rows) {
            $$.initWithData($$.convertRowsToData(config.data_rows));
        } else if (config.data_columns) {
            $$.initWithData($$.convertColumnsToData(config.data_columns));
        } else {
            throw Error('url or json or rows or columns is required.');
        }
    };

    c3_chart_internal_fn.initParams = function () {
        var $$ = this,
            d3 = $$.d3,
            config = $$.config;

        // MEMO: clipId needs to be unique because it conflicts when multiple charts exist
        $$.clipId = "c3-" + +new Date() + '-clip', $$.clipIdForXAxis = $$.clipId + '-xaxis', $$.clipIdForYAxis = $$.clipId + '-yaxis', $$.clipIdForGrid = $$.clipId + '-grid', $$.clipIdForSubchart = $$.clipId + '-subchart', $$.clipPath = $$.getClipPath($$.clipId), $$.clipPathForXAxis = $$.getClipPath($$.clipIdForXAxis), $$.clipPathForYAxis = $$.getClipPath($$.clipIdForYAxis);
        $$.clipPathForGrid = $$.getClipPath($$.clipIdForGrid), $$.clipPathForSubchart = $$.getClipPath($$.clipIdForSubchart), $$.dragStart = null;
        $$.dragging = false;
        $$.flowing = false;
        $$.cancelClick = false;
        $$.mouseover = false;
        $$.transiting = false;

        $$.color = $$.generateColor();
        $$.levelColor = $$.generateLevelColor();

        $$.dataTimeFormat = config.data_xLocaltime ? d3.time.format : d3.time.format.utc;
        $$.axisTimeFormat = config.axis_x_localtime ? d3.time.format : d3.time.format.utc;
        $$.defaultAxisTimeFormat = $$.axisTimeFormat.multi([[".%L", function (d) {
            return d.getMilliseconds();
        }], [":%S", function (d) {
            return d.getSeconds();
        }], ["%I:%M", function (d) {
            return d.getMinutes();
        }], ["%I %p", function (d) {
            return d.getHours();
        }], ["%-m/%-d", function (d) {
            return d.getDay() && d.getDate() !== 1;
        }], ["%-m/%-d", function (d) {
            return d.getDate() !== 1;
        }], ["%-m/%-d", function (d) {
            return d.getMonth();
        }], ["%Y/%-m/%-d", function () {
            return true;
        }]]);

        $$.hiddenTargetIds = [];
        $$.hiddenLegendIds = [];
        $$.focusedTargetIds = [];
        $$.defocusedTargetIds = [];

        $$.xOrient = config.axis_rotated ? config.axis_x_inner ? "right" : "left" : config.axis_x_inner ? "top" : "bottom";
        $$.yOrient = config.axis_rotated ? config.axis_y_inner ? "top" : "bottom" : config.axis_y_inner ? "right" : "left";
        $$.y2Orient = config.axis_rotated ? config.axis_y2_inner ? "bottom" : "top" : config.axis_y2_inner ? "left" : "right";
        $$.subXOrient = config.axis_rotated ? "left" : "bottom";

        $$.isLegendRight = config.legend_position === 'right';
        $$.isLegendInset = config.legend_position === 'inset';
        $$.isLegendTop = config.legend_inset_anchor === 'top-left' || config.legend_inset_anchor === 'top-right';
        $$.isLegendLeft = config.legend_inset_anchor === 'top-left' || config.legend_inset_anchor === 'bottom-left';
        $$.legendStep = 0;
        $$.legendItemWidth = 0;
        $$.legendItemHeight = 0;

        $$.currentMaxTickWidths = {
            x: 0,
            y: 0,
            y2: 0
        };

        $$.rotated_padding_left = 30;
        $$.rotated_padding_right = config.axis_rotated && !config.axis_x_show ? 0 : 30;
        $$.rotated_padding_top = 5;

        $$.withoutFadeIn = {};

        $$.intervalForObserveInserted = undefined;

        $$.axes.subx = d3.selectAll([]); // needs when excluding subchart.js
    };

    c3_chart_internal_fn.initChartElements = function () {
        if (this.initBar) {
            this.initBar();
        }
        if (this.initLine) {
            this.initLine();
        }
        if (this.initArc) {
            this.initArc();
        }
        if (this.initGauge) {
            this.initGauge();
        }
        if (this.initText) {
            this.initText();
        }
    };

    c3_chart_internal_fn.initWithData = function (data) {
        var $$ = this,
            d3 = $$.d3,
            config = $$.config;
        var defs,
            main,
            binding = true;

        $$.axis = new Axis($$);

        if ($$.initPie) {
            $$.initPie();
        }
        if ($$.initBrush) {
            $$.initBrush();
        }
        if ($$.initZoom) {
            $$.initZoom();
        }

        if (!config.bindto) {
            $$.selectChart = d3.selectAll([]);
        } else if (typeof config.bindto.node === 'function') {
            $$.selectChart = config.bindto;
        } else {
            $$.selectChart = d3.select(config.bindto);
        }
        if ($$.selectChart.empty()) {
            $$.selectChart = d3.select(document.createElement('div')).style('opacity', 0);
            $$.observeInserted($$.selectChart);
            binding = false;
        }
        $$.selectChart.html("").classed("c3", true);

        // Init data as targets
        $$.data.xs = {};
        $$.data.targets = $$.convertDataToTargets(data);

        if (config.data_filter) {
            $$.data.targets = $$.data.targets.filter(config.data_filter);
        }

        // Set targets to hide if needed
        if (config.data_hide) {
            $$.addHiddenTargetIds(config.data_hide === true ? $$.mapToIds($$.data.targets) : config.data_hide);
        }
        if (config.legend_hide) {
            $$.addHiddenLegendIds(config.legend_hide === true ? $$.mapToIds($$.data.targets) : config.legend_hide);
        }

        // Init sizes and scales
        $$.updateSizes();
        $$.updateScales();

        // Set domains for each scale
        $$.x.domain(d3.extent($$.getXDomain($$.data.targets)));
        $$.y.domain($$.getYDomain($$.data.targets, 'y'));
        $$.y2.domain($$.getYDomain($$.data.targets, 'y2'));
        $$.subX.domain($$.x.domain());
        $$.subY.domain($$.y.domain());
        $$.subY2.domain($$.y2.domain());

        // Save original x domain for zoom update
        $$.orgXDomain = $$.x.domain();

        // Set initialized scales to brush and zoom
        if ($$.brush) {
            $$.brush.scale($$.subX);
        }
        if (config.zoom_enabled) {
            $$.zoom.scale($$.x);
        }

        /*-- Basic Elements --*/

        // Define svgs
        $$.svg = $$.selectChart.append("svg").style("overflow", "hidden").on('mouseenter', function () {
            return config.onmouseover.call($$);
        }).on('mouseleave', function () {
            return config.onmouseout.call($$);
        });

        if ($$.config.svg_classname) {
            $$.svg.attr('class', $$.config.svg_classname);
        }

        // Define defs
        defs = $$.svg.append("defs");
        $$.clipChart = $$.appendClip(defs, $$.clipId);
        $$.clipXAxis = $$.appendClip(defs, $$.clipIdForXAxis);
        $$.clipYAxis = $$.appendClip(defs, $$.clipIdForYAxis);
        $$.clipGrid = $$.appendClip(defs, $$.clipIdForGrid);
        $$.clipSubchart = $$.appendClip(defs, $$.clipIdForSubchart);
        $$.updateSvgSize();

        // Define regions
        main = $$.main = $$.svg.append("g").attr("transform", $$.getTranslate('main'));

        if ($$.initSubchart) {
            $$.initSubchart();
        }
        if ($$.initTooltip) {
            $$.initTooltip();
        }
        if ($$.initLegend) {
            $$.initLegend();
        }
        if ($$.initTitle) {
            $$.initTitle();
        }

        /*-- Main Region --*/

        // text when empty
        main.append("text").attr("class", CLASS.text + ' ' + CLASS.empty).attr("text-anchor", "middle") // horizontal centering of text at x position in all browsers.
        .attr("dominant-baseline", "middle"); // vertical centering of text at y position in all browsers, except IE.

        // Regions
        $$.initRegion();

        // Grids
        $$.initGrid();

        // Define g for chart area
        main.append('g').attr("clip-path", $$.clipPath).attr('class', CLASS.chart);

        // Grid lines
        if (config.grid_lines_front) {
            $$.initGridLines();
        }

        // Cover whole with rects for events
        $$.initEventRect();

        // Define g for chart
        $$.initChartElements();

        // if zoom privileged, insert rect to forefront
        // TODO: is this needed?
        main.insert('rect', config.zoom_privileged ? null : 'g.' + CLASS.regions).attr('class', CLASS.zoomRect).attr('width', $$.width).attr('height', $$.height).style('opacity', 0).on("dblclick.zoom", null);

        // Set default extent if defined
        if (config.axis_x_extent) {
            $$.brush.extent($$.getDefaultExtent());
        }

        // Add Axis
        $$.axis.init();

        // Set targets
        $$.updateTargets($$.data.targets);

        // Draw with targets
        if (binding) {
            $$.updateDimension();
            $$.config.oninit.call($$);
            $$.redraw({
                withTransition: false,
                withTransform: true,
                withUpdateXDomain: true,
                withUpdateOrgXDomain: true,
                withTransitionForAxis: false
            });
        }

        // Bind resize event
        $$.bindResize();

        // export element of the chart
        $$.api.element = $$.selectChart.node();
    };

    c3_chart_internal_fn.smoothLines = function (el, type) {
        var $$ = this;
        if (type === 'grid') {
            el.each(function () {
                var g = $$.d3.select(this),
                    x1 = g.attr('x1'),
                    x2 = g.attr('x2'),
                    y1 = g.attr('y1'),
                    y2 = g.attr('y2');
                g.attr({
                    'x1': Math.ceil(x1),
                    'x2': Math.ceil(x2),
                    'y1': Math.ceil(y1),
                    'y2': Math.ceil(y2)
                });
            });
        }
    };

    c3_chart_internal_fn.updateSizes = function () {
        var $$ = this,
            config = $$.config;
        var legendHeight = $$.legend ? $$.getLegendHeight() : 0,
            legendWidth = $$.legend ? $$.getLegendWidth() : 0,
            legendHeightForBottom = $$.isLegendRight || $$.isLegendInset ? 0 : legendHeight,
            hasArc = $$.hasArcType(),
            xAxisHeight = config.axis_rotated || hasArc ? 0 : $$.getHorizontalAxisHeight('x'),
            subchartHeight = config.subchart_show && !hasArc ? config.subchart_size_height + xAxisHeight : 0;

        $$.currentWidth = $$.getCurrentWidth();
        $$.currentHeight = $$.getCurrentHeight();

        // for main
        $$.margin = config.axis_rotated ? {
            top: $$.getHorizontalAxisHeight('y2') + $$.getCurrentPaddingTop(),
            right: hasArc ? 0 : $$.getCurrentPaddingRight(),
            bottom: $$.getHorizontalAxisHeight('y') + legendHeightForBottom + $$.getCurrentPaddingBottom(),
            left: subchartHeight + (hasArc ? 0 : $$.getCurrentPaddingLeft())
        } : {
            top: 4 + $$.getCurrentPaddingTop(), // for top tick text
            right: hasArc ? 0 : $$.getCurrentPaddingRight(),
            bottom: xAxisHeight + subchartHeight + legendHeightForBottom + $$.getCurrentPaddingBottom(),
            left: hasArc ? 0 : $$.getCurrentPaddingLeft()
        };

        // for subchart
        $$.margin2 = config.axis_rotated ? {
            top: $$.margin.top,
            right: NaN,
            bottom: 20 + legendHeightForBottom,
            left: $$.rotated_padding_left
        } : {
            top: $$.currentHeight - subchartHeight - legendHeightForBottom,
            right: NaN,
            bottom: xAxisHeight + legendHeightForBottom,
            left: $$.margin.left
        };

        // for legend
        $$.margin3 = {
            top: 0,
            right: NaN,
            bottom: 0,
            left: 0
        };
        if ($$.updateSizeForLegend) {
            $$.updateSizeForLegend(legendHeight, legendWidth);
        }

        $$.width = $$.currentWidth - $$.margin.left - $$.margin.right;
        $$.height = $$.currentHeight - $$.margin.top - $$.margin.bottom;
        if ($$.width < 0) {
            $$.width = 0;
        }
        if ($$.height < 0) {
            $$.height = 0;
        }

        $$.width2 = config.axis_rotated ? $$.margin.left - $$.rotated_padding_left - $$.rotated_padding_right : $$.width;
        $$.height2 = config.axis_rotated ? $$.height : $$.currentHeight - $$.margin2.top - $$.margin2.bottom;
        if ($$.width2 < 0) {
            $$.width2 = 0;
        }
        if ($$.height2 < 0) {
            $$.height2 = 0;
        }

        // for arc
        $$.arcWidth = $$.width - ($$.isLegendRight ? legendWidth + 10 : 0);
        $$.arcHeight = $$.height - ($$.isLegendRight ? 0 : 10);
        if ($$.hasType('gauge') && !config.gauge_fullCircle) {
            $$.arcHeight += $$.height - $$.getGaugeLabelHeight();
        }
        if ($$.updateRadius) {
            $$.updateRadius();
        }

        if ($$.isLegendRight && hasArc) {
            $$.margin3.left = $$.arcWidth / 2 + $$.radiusExpanded * 1.1;
        }
    };

    c3_chart_internal_fn.updateTargets = function (targets) {
        var $$ = this;

        /*-- Main --*/

        //-- Text --//
        $$.updateTargetsForText(targets);

        //-- Bar --//
        $$.updateTargetsForBar(targets);

        //-- Line --//
        $$.updateTargetsForLine(targets);

        //-- Arc --//
        if ($$.hasArcType() && $$.updateTargetsForArc) {
            $$.updateTargetsForArc(targets);
        }

        /*-- Sub --*/

        if ($$.updateTargetsForSubchart) {
            $$.updateTargetsForSubchart(targets);
        }

        // Fade-in each chart
        $$.showTargets();
    };
    c3_chart_internal_fn.showTargets = function () {
        var $$ = this;
        $$.svg.selectAll('.' + CLASS.target).filter(function (d) {
            return $$.isTargetToShow(d.id);
        }).transition().duration($$.config.transition_duration).style("opacity", 1);
    };

    c3_chart_internal_fn.redraw = function (options, transitions) {
        var $$ = this,
            main = $$.main,
            d3 = $$.d3,
            config = $$.config;
        var areaIndices = $$.getShapeIndices($$.isAreaType),
            barIndices = $$.getShapeIndices($$.isBarType),
            lineIndices = $$.getShapeIndices($$.isLineType);
        var withY, withSubchart, withTransition, withTransitionForExit, withTransitionForAxis, withTransform, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain, withLegend, withEventRect, withDimension, withUpdateXAxis;
        var hideAxis = $$.hasArcType();
        var drawArea, drawBar, drawLine, xForText, yForText;
        var duration, durationForExit, durationForAxis;
        var waitForDraw, flow;
        var targetsToShow = $$.filterTargetsToShow($$.data.targets),
            tickValues,
            i,
            intervalForCulling,
            xDomainForZoom;
        var xv = $$.xv.bind($$),
            cx,
            cy;

        options = options || {};
        withY = getOption(options, "withY", true);
        withSubchart = getOption(options, "withSubchart", true);
        withTransition = getOption(options, "withTransition", true);
        withTransform = getOption(options, "withTransform", false);
        withUpdateXDomain = getOption(options, "withUpdateXDomain", false);
        withUpdateOrgXDomain = getOption(options, "withUpdateOrgXDomain", false);
        withTrimXDomain = getOption(options, "withTrimXDomain", true);
        withUpdateXAxis = getOption(options, "withUpdateXAxis", withUpdateXDomain);
        withLegend = getOption(options, "withLegend", false);
        withEventRect = getOption(options, "withEventRect", true);
        withDimension = getOption(options, "withDimension", true);
        withTransitionForExit = getOption(options, "withTransitionForExit", withTransition);
        withTransitionForAxis = getOption(options, "withTransitionForAxis", withTransition);

        duration = withTransition ? config.transition_duration : 0;
        durationForExit = withTransitionForExit ? duration : 0;
        durationForAxis = withTransitionForAxis ? duration : 0;

        transitions = transitions || $$.axis.generateTransitions(durationForAxis);

        // update legend and transform each g
        if (withLegend && config.legend_show) {
            $$.updateLegend($$.mapToIds($$.data.targets), options, transitions);
        } else if (withDimension) {
            // need to update dimension (e.g. axis.y.tick.values) because y tick values should change
            // no need to update axis in it because they will be updated in redraw()
            $$.updateDimension(true);
        }

        // MEMO: needed for grids calculation
        if ($$.isCategorized() && targetsToShow.length === 0) {
            $$.x.domain([0, $$.axes.x.selectAll('.tick').size()]);
        }

        if (targetsToShow.length) {
            $$.updateXDomain(targetsToShow, withUpdateXDomain, withUpdateOrgXDomain, withTrimXDomain);
            if (!config.axis_x_tick_values) {
                tickValues = $$.axis.updateXAxisTickValues(targetsToShow);
            }
        } else {
            $$.xAxis.tickValues([]);
            $$.subXAxis.tickValues([]);
        }

        if (config.zoom_rescale && !options.flow) {
            xDomainForZoom = $$.x.orgDomain();
        }

        $$.y.domain($$.getYDomain(targetsToShow, 'y', xDomainForZoom));
        $$.y2.domain($$.getYDomain(targetsToShow, 'y2', xDomainForZoom));

        if (!config.axis_y_tick_values && config.axis_y_tick_count) {
            $$.yAxis.tickValues($$.axis.generateTickValues($$.y.domain(), config.axis_y_tick_count));
        }
        if (!config.axis_y2_tick_values && config.axis_y2_tick_count) {
            $$.y2Axis.tickValues($$.axis.generateTickValues($$.y2.domain(), config.axis_y2_tick_count));
        }

        // axes
        $$.axis.redraw(transitions, hideAxis);

        // Update axis label
        $$.axis.updateLabels(withTransition);

        // show/hide if manual culling needed
        if ((withUpdateXDomain || withUpdateXAxis) && targetsToShow.length) {
            if (config.axis_x_tick_culling && tickValues) {
                for (i = 1; i < tickValues.length; i++) {
                    if (tickValues.length / i < config.axis_x_tick_culling_max) {
                        intervalForCulling = i;
                        break;
                    }
                }
                $$.svg.selectAll('.' + CLASS.axisX + ' .tick text').each(function (e) {
                    var index = tickValues.indexOf(e);
                    if (index >= 0) {
                        d3.select(this).style('display', index % intervalForCulling ? 'none' : 'block');
                    }
                });
            } else {
                $$.svg.selectAll('.' + CLASS.axisX + ' .tick text').style('display', 'block');
            }
        }

        // setup drawer - MEMO: these must be called after axis updated
        drawArea = $$.generateDrawArea ? $$.generateDrawArea(areaIndices, false) : undefined;
        drawBar = $$.generateDrawBar ? $$.generateDrawBar(barIndices) : undefined;
        drawLine = $$.generateDrawLine ? $$.generateDrawLine(lineIndices, false) : undefined;
        xForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, true);
        yForText = $$.generateXYForText(areaIndices, barIndices, lineIndices, false);

        // Update sub domain
        if (withY) {
            $$.subY.domain($$.getYDomain(targetsToShow, 'y'));
            $$.subY2.domain($$.getYDomain(targetsToShow, 'y2'));
        }

        // xgrid focus
        $$.updateXgridFocus();

        // Data empty label positioning and text.
        main.select("text." + CLASS.text + '.' + CLASS.empty).attr("x", $$.width / 2).attr("y", $$.height / 2).text(config.data_empty_label_text).transition().style('opacity', targetsToShow.length ? 0 : 1);

        // grid
        $$.updateGrid(duration);

        // rect for regions
        $$.updateRegion(duration);

        // bars
        $$.updateBar(durationForExit);

        // lines, areas and cricles
        $$.updateLine(durationForExit);
        $$.updateArea(durationForExit);
        $$.updateCircle();

        // text
        if ($$.hasDataLabel()) {
            $$.updateText(durationForExit);
        }

        // title
        if ($$.redrawTitle) {
            $$.redrawTitle();
        }

        // arc
        if ($$.redrawArc) {
            $$.redrawArc(duration, durationForExit, withTransform);
        }

        // subchart
        if ($$.redrawSubchart) {
            $$.redrawSubchart(withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices);
        }

        // circles for select
        main.selectAll('.' + CLASS.selectedCircles).filter($$.isBarType.bind($$)).selectAll('circle').remove();

        // event rects will redrawn when flow called
        if (config.interaction_enabled && !options.flow && withEventRect) {
            $$.redrawEventRect();
            if ($$.updateZoom) {
                $$.updateZoom();
            }
        }

        // update circleY based on updated parameters
        $$.updateCircleY();

        // generate circle x/y functions depending on updated params
        cx = ($$.config.axis_rotated ? $$.circleY : $$.circleX).bind($$);
        cy = ($$.config.axis_rotated ? $$.circleX : $$.circleY).bind($$);

        if (options.flow) {
            flow = $$.generateFlow({
                targets: targetsToShow,
                flow: options.flow,
                duration: options.flow.duration,
                drawBar: drawBar,
                drawLine: drawLine,
                drawArea: drawArea,
                cx: cx,
                cy: cy,
                xv: xv,
                xForText: xForText,
                yForText: yForText
            });
        }

        if ((duration || flow) && $$.isTabVisible()) {
            // Only use transition if tab visible. See #938.
            // transition should be derived from one transition
            d3.transition().duration(duration).each(function () {
                var transitionsToWait = [];

                // redraw and gather transitions
                [$$.redrawBar(drawBar, true), $$.redrawLine(drawLine, true), $$.redrawArea(drawArea, true), $$.redrawCircle(cx, cy, true), $$.redrawText(xForText, yForText, options.flow, true), $$.redrawRegion(true), $$.redrawGrid(true)].forEach(function (transitions) {
                    transitions.forEach(function (transition) {
                        transitionsToWait.push(transition);
                    });
                });

                // Wait for end of transitions to call flow and onrendered callback
                waitForDraw = $$.generateWait();
                transitionsToWait.forEach(function (t) {
                    waitForDraw.add(t);
                });
            }).call(waitForDraw, function () {
                if (flow) {
                    flow();
                }
                if (config.onrendered) {
                    config.onrendered.call($$);
                }
            });
        } else {
            $$.redrawBar(drawBar);
            $$.redrawLine(drawLine);
            $$.redrawArea(drawArea);
            $$.redrawCircle(cx, cy);
            $$.redrawText(xForText, yForText, options.flow);
            $$.redrawRegion();
            $$.redrawGrid();
            if (config.onrendered) {
                config.onrendered.call($$);
            }
        }

        // update fadein condition
        $$.mapToIds($$.data.targets).forEach(function (id) {
            $$.withoutFadeIn[id] = true;
        });
    };

    c3_chart_internal_fn.updateAndRedraw = function (options) {
        var $$ = this,
            config = $$.config,
            transitions;
        options = options || {};
        // same with redraw
        options.withTransition = getOption(options, "withTransition", true);
        options.withTransform = getOption(options, "withTransform", false);
        options.withLegend = getOption(options, "withLegend", false);
        // NOT same with redraw
        options.withUpdateXDomain = true;
        options.withUpdateOrgXDomain = true;
        options.withTransitionForExit = false;
        options.withTransitionForTransform = getOption(options, "withTransitionForTransform", options.withTransition);
        // MEMO: this needs to be called before updateLegend and it means this ALWAYS needs to be called)
        $$.updateSizes();
        // MEMO: called in updateLegend in redraw if withLegend
        if (!(options.withLegend && config.legend_show)) {
            transitions = $$.axis.generateTransitions(options.withTransitionForAxis ? config.transition_duration : 0);
            // Update scales
            $$.updateScales();
            $$.updateSvgSize();
            // Update g positions
            $$.transformAll(options.withTransitionForTransform, transitions);
        }
        // Draw with new sizes & scales
        $$.redraw(options, transitions);
    };
    c3_chart_internal_fn.redrawWithoutRescale = function () {
        this.redraw({
            withY: false,
            withSubchart: false,
            withEventRect: false,
            withTransitionForAxis: false
        });
    };

    c3_chart_internal_fn.isTimeSeries = function () {
        return this.config.axis_x_type === 'timeseries';
    };
    c3_chart_internal_fn.isCategorized = function () {
        return this.config.axis_x_type.indexOf('categor') >= 0;
    };
    c3_chart_internal_fn.isCustomX = function () {
        var $$ = this,
            config = $$.config;
        return !$$.isTimeSeries() && (config.data_x || notEmpty(config.data_xs));
    };

    c3_chart_internal_fn.isTimeSeriesY = function () {
        return this.config.axis_y_type === 'timeseries';
    };

    c3_chart_internal_fn.getTranslate = function (target) {
        var $$ = this,
            config = $$.config,
            x,
            y;
        if (target === 'main') {
            x = asHalfPixel($$.margin.left);
            y = asHalfPixel($$.margin.top);
        } else if (target === 'context') {
            x = asHalfPixel($$.margin2.left);
            y = asHalfPixel($$.margin2.top);
        } else if (target === 'legend') {
            x = $$.margin3.left;
            y = $$.margin3.top;
        } else if (target === 'x') {
            x = 0;
            y = config.axis_rotated ? 0 : $$.height;
        } else if (target === 'y') {
            x = 0;
            y = config.axis_rotated ? $$.height : 0;
        } else if (target === 'y2') {
            x = config.axis_rotated ? 0 : $$.width;
            y = config.axis_rotated ? 1 : 0;
        } else if (target === 'subx') {
            x = 0;
            y = config.axis_rotated ? 0 : $$.height2;
        } else if (target === 'arc') {
            x = $$.arcWidth / 2;
            y = $$.arcHeight / 2 - ($$.hasType('gauge') ? 6 : 0); // to prevent wrong display of min and max label
        }
        return "translate(" + x + "," + y + ")";
    };
    c3_chart_internal_fn.initialOpacity = function (d) {
        return d.value !== null && this.withoutFadeIn[d.id] ? 1 : 0;
    };
    c3_chart_internal_fn.initialOpacityForCircle = function (d) {
        return d.value !== null && this.withoutFadeIn[d.id] ? this.opacityForCircle(d) : 0;
    };
    c3_chart_internal_fn.opacityForCircle = function (d) {
        var isPointShouldBeShown = isFunction(this.config.point_show) ? this.config.point_show(d) : this.config.point_show;
        var opacity = isPointShouldBeShown ? 1 : 0;
        return isValue(d.value) ? this.isScatterType(d) ? 0.5 : opacity : 0;
    };
    c3_chart_internal_fn.opacityForText = function () {
        return this.hasDataLabel() ? 1 : 0;
    };
    c3_chart_internal_fn.xx = function (d) {
        return d ? this.x(d.x) : null;
    };
    c3_chart_internal_fn.xv = function (d) {
        var $$ = this,
            value = d.value;
        if ($$.isTimeSeries()) {
            value = $$.parseDate(d.value);
        } else if ($$.isCategorized() && typeof d.value === 'string') {
            value = $$.config.axis_x_categories.indexOf(d.value);
        }
        return Math.ceil($$.x(value));
    };
    c3_chart_internal_fn.yv = function (d) {
        var $$ = this,
            yScale = d.axis && d.axis === 'y2' ? $$.y2 : $$.y;
        return Math.ceil(yScale(d.value));
    };
    c3_chart_internal_fn.subxx = function (d) {
        return d ? this.subX(d.x) : null;
    };

    c3_chart_internal_fn.transformMain = function (withTransition, transitions) {
        var $$ = this,
            xAxis,
            yAxis,
            y2Axis;
        if (transitions && transitions.axisX) {
            xAxis = transitions.axisX;
        } else {
            xAxis = $$.main.select('.' + CLASS.axisX);
            if (withTransition) {
                xAxis = xAxis.transition();
            }
        }
        if (transitions && transitions.axisY) {
            yAxis = transitions.axisY;
        } else {
            yAxis = $$.main.select('.' + CLASS.axisY);
            if (withTransition) {
                yAxis = yAxis.transition();
            }
        }
        if (transitions && transitions.axisY2) {
            y2Axis = transitions.axisY2;
        } else {
            y2Axis = $$.main.select('.' + CLASS.axisY2);
            if (withTransition) {
                y2Axis = y2Axis.transition();
            }
        }
        (withTransition ? $$.main.transition() : $$.main).attr("transform", $$.getTranslate('main'));
        xAxis.attr("transform", $$.getTranslate('x'));
        yAxis.attr("transform", $$.getTranslate('y'));
        y2Axis.attr("transform", $$.getTranslate('y2'));
        $$.main.select('.' + CLASS.chartArcs).attr("transform", $$.getTranslate('arc'));
    };
    c3_chart_internal_fn.transformAll = function (withTransition, transitions) {
        var $$ = this;
        $$.transformMain(withTransition, transitions);
        if ($$.config.subchart_show) {
            $$.transformContext(withTransition, transitions);
        }
        if ($$.legend) {
            $$.transformLegend(withTransition);
        }
    };

    c3_chart_internal_fn.updateSvgSize = function () {
        var $$ = this,
            brush = $$.svg.select(".c3-brush .background");
        $$.svg.attr('width', $$.currentWidth).attr('height', $$.currentHeight);
        $$.svg.selectAll(['#' + $$.clipId, '#' + $$.clipIdForGrid]).select('rect').attr('width', $$.width).attr('height', $$.height);
        $$.svg.select('#' + $$.clipIdForXAxis).select('rect').attr('x', $$.getXAxisClipX.bind($$)).attr('y', $$.getXAxisClipY.bind($$)).attr('width', $$.getXAxisClipWidth.bind($$)).attr('height', $$.getXAxisClipHeight.bind($$));
        $$.svg.select('#' + $$.clipIdForYAxis).select('rect').attr('x', $$.getYAxisClipX.bind($$)).attr('y', $$.getYAxisClipY.bind($$)).attr('width', $$.getYAxisClipWidth.bind($$)).attr('height', $$.getYAxisClipHeight.bind($$));
        $$.svg.select('#' + $$.clipIdForSubchart).select('rect').attr('width', $$.width).attr('height', brush.size() ? brush.attr('height') : 0);
        $$.svg.select('.' + CLASS.zoomRect).attr('width', $$.width).attr('height', $$.height);
        // MEMO: parent div's height will be bigger than svg when <!DOCTYPE html>
        $$.selectChart.style('max-height', $$.currentHeight + "px");
    };

    c3_chart_internal_fn.updateDimension = function (withoutAxis) {
        var $$ = this;
        if (!withoutAxis) {
            if ($$.config.axis_rotated) {
                $$.axes.x.call($$.xAxis);
                $$.axes.subx.call($$.subXAxis);
            } else {
                $$.axes.y.call($$.yAxis);
                $$.axes.y2.call($$.y2Axis);
            }
        }
        $$.updateSizes();
        $$.updateScales();
        $$.updateSvgSize();
        $$.transformAll(false);
    };

    c3_chart_internal_fn.observeInserted = function (selection) {
        var $$ = this,
            observer;
        if (typeof MutationObserver === 'undefined') {
            window.console.error("MutationObserver not defined.");
            return;
        }
        observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList' && mutation.previousSibling) {
                    observer.disconnect();
                    // need to wait for completion of load because size calculation requires the actual sizes determined after that completion
                    $$.intervalForObserveInserted = window.setInterval(function () {
                        // parentNode will NOT be null when completed
                        if (selection.node().parentNode) {
                            window.clearInterval($$.intervalForObserveInserted);
                            $$.updateDimension();
                            if ($$.brush) {
                                $$.brush.update();
                            }
                            $$.config.oninit.call($$);
                            $$.redraw({
                                withTransform: true,
                                withUpdateXDomain: true,
                                withUpdateOrgXDomain: true,
                                withTransition: false,
                                withTransitionForTransform: false,
                                withLegend: true
                            });
                            selection.transition().style('opacity', 1);
                        }
                    }, 10);
                }
            });
        });
        observer.observe(selection.node(), { attributes: true, childList: true, characterData: true });
    };

    c3_chart_internal_fn.bindResize = function () {
        var $$ = this,
            config = $$.config;

        $$.resizeFunction = $$.generateResize(); // need to call .remove

        $$.resizeFunction.add(function () {
            config.onresize.call($$);
        });
        if (config.resize_auto) {
            $$.resizeFunction.add(function () {
                if ($$.resizeTimeout !== undefined) {
                    window.clearTimeout($$.resizeTimeout);
                }
                $$.resizeTimeout = window.setTimeout(function () {
                    delete $$.resizeTimeout;
                    $$.api.flush();
                }, 100);
            });
        }
        $$.resizeFunction.add(function () {
            config.onresized.call($$);
        });

        $$.resizeIfElementDisplayed = function () {
            // if element not displayed skip it
            if ($$.api == null || !$$.api.element.offsetParent) {
                return;
            }

            $$.resizeFunction();
        };

        if (window.attachEvent) {
            window.attachEvent('onresize', $$.resizeIfElementDisplayed);
        } else if (window.addEventListener) {
            window.addEventListener('resize', $$.resizeIfElementDisplayed, false);
        } else {
            // fallback to this, if this is a very old browser
            var wrapper = window.onresize;
            if (!wrapper) {
                // create a wrapper that will call all charts
                wrapper = $$.generateResize();
            } else if (!wrapper.add || !wrapper.remove) {
                // there is already a handler registered, make sure we call it too
                wrapper = $$.generateResize();
                wrapper.add(window.onresize);
            }
            // add this graph to the wrapper, we will be removed if the user calls destroy
            wrapper.add($$.resizeFunction);
            window.onresize = function () {
                // if element not displayed skip it
                if (!$$.api.element.offsetParent) {
                    return;
                }

                wrapper();
            };
        }
    };

    c3_chart_internal_fn.generateResize = function () {
        var resizeFunctions = [];
        function callResizeFunctions() {
            resizeFunctions.forEach(function (f) {
                f();
            });
        }
        callResizeFunctions.add = function (f) {
            resizeFunctions.push(f);
        };
        callResizeFunctions.remove = function (f) {
            for (var i = 0; i < resizeFunctions.length; i++) {
                if (resizeFunctions[i] === f) {
                    resizeFunctions.splice(i, 1);
                    break;
                }
            }
        };
        return callResizeFunctions;
    };

    c3_chart_internal_fn.endall = function (transition, callback) {
        var n = 0;
        transition.each(function () {
            ++n;
        }).each("end", function () {
            if (! --n) {
                callback.apply(this, arguments);
            }
        });
    };
    c3_chart_internal_fn.generateWait = function () {
        var transitionsToWait = [],
            f = function f(transition, callback) {
            var timer = setInterval(function () {
                var done = 0;
                transitionsToWait.forEach(function (t) {
                    if (t.empty()) {
                        done += 1;
                        return;
                    }
                    try {
                        t.transition();
                    } catch (e) {
                        done += 1;
                    }
                });
                if (done === transitionsToWait.length) {
                    clearInterval(timer);
                    if (callback) {
                        callback();
                    }
                }
            }, 10);
        };
        f.add = function (transition) {
            transitionsToWait.push(transition);
        };
        return f;
    };

    c3_chart_internal_fn.parseDate = function (date) {
        var $$ = this,
            parsedDate;
        if (date instanceof Date) {
            parsedDate = date;
        } else if (typeof date === 'string') {
            parsedDate = $$.dataTimeFormat($$.config.data_xFormat).parse(date);
        } else if ((typeof date === 'undefined' ? 'undefined' : _typeof(date)) === 'object') {
            parsedDate = new Date(+date);
        } else if (typeof date === 'number' && !isNaN(date)) {
            parsedDate = new Date(+date);
        }
        if (!parsedDate || isNaN(+parsedDate)) {
            window.console.error("Failed to parse x '" + date + "' to Date object");
        }
        return parsedDate;
    };

    c3_chart_internal_fn.isTabVisible = function () {
        var hidden;
        if (typeof document.hidden !== "undefined") {
            // Opera 12.10 and Firefox 18 and later support
            hidden = "hidden";
        } else if (typeof document.mozHidden !== "undefined") {
            hidden = "mozHidden";
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
        }

        return document[hidden] ? false : true;
    };

    c3_chart_internal_fn.isValue = isValue;
    c3_chart_internal_fn.isFunction = isFunction;
    c3_chart_internal_fn.isString = isString;
    c3_chart_internal_fn.isUndefined = isUndefined;
    c3_chart_internal_fn.isDefined = isDefined;
    c3_chart_internal_fn.ceil10 = ceil10;
    c3_chart_internal_fn.asHalfPixel = asHalfPixel;
    c3_chart_internal_fn.diffDomain = diffDomain;
    c3_chart_internal_fn.isEmpty = isEmpty;
    c3_chart_internal_fn.notEmpty = notEmpty;
    c3_chart_internal_fn.notEmpty = notEmpty;
    c3_chart_internal_fn.getOption = getOption;
    c3_chart_internal_fn.hasValue = hasValue;
    c3_chart_internal_fn.sanitise = sanitise;
    c3_chart_internal_fn.getPathBox = getPathBox;
    c3_chart_internal_fn.CLASS = CLASS;

    /* jshint ignore:start */

    // PhantomJS doesn't have support for Function.prototype.bind, which has caused confusion. Use
    // this polyfill to avoid the confusion.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill

    if (!Function.prototype.bind) {
        Function.prototype.bind = function (oThis) {
            if (typeof this !== 'function') {
                // closest thing possible to the ECMAScript 5
                // internal IsCallable function
                throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
            }

            var aArgs = Array.prototype.slice.call(arguments, 1),
                fToBind = this,
                fNOP = function fNOP() {},
                fBound = function fBound() {
                return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
            };

            fNOP.prototype = this.prototype;
            fBound.prototype = new fNOP();

            return fBound;
        };
    }

    // SVGPathSeg API polyfill
    // https://github.com/progers/pathseg
    //
    // This is a drop-in replacement for the SVGPathSeg and SVGPathSegList APIs that were removed from
    // SVG2 (https://lists.w3.org/Archives/Public/www-svg/2015Jun/0044.html), including the latest spec
    // changes which were implemented in Firefox 43 and Chrome 46.

    (function () {

        if (!("SVGPathSeg" in window)) {
            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSeg
            window.SVGPathSeg = function (type, typeAsLetter, owningPathSegList) {
                this.pathSegType = type;
                this.pathSegTypeAsLetter = typeAsLetter;
                this._owningPathSegList = owningPathSegList;
            };

            window.SVGPathSeg.prototype.classname = "SVGPathSeg";

            window.SVGPathSeg.PATHSEG_UNKNOWN = 0;
            window.SVGPathSeg.PATHSEG_CLOSEPATH = 1;
            window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2;
            window.SVGPathSeg.PATHSEG_MOVETO_REL = 3;
            window.SVGPathSeg.PATHSEG_LINETO_ABS = 4;
            window.SVGPathSeg.PATHSEG_LINETO_REL = 5;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9;
            window.SVGPathSeg.PATHSEG_ARC_ABS = 10;
            window.SVGPathSeg.PATHSEG_ARC_REL = 11;
            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12;
            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13;
            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14;
            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19;

            // Notify owning PathSegList on any changes so they can be synchronized back to the path element.
            window.SVGPathSeg.prototype._segmentChanged = function () {
                if (this._owningPathSegList) this._owningPathSegList.segmentChanged(this);
            };

            window.SVGPathSegClosePath = function (owningPathSegList) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", owningPathSegList);
            };
            window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegClosePath.prototype.toString = function () {
                return "[object SVGPathSegClosePath]";
            };
            window.SVGPathSegClosePath.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter;
            };
            window.SVGPathSegClosePath.prototype.clone = function () {
                return new window.SVGPathSegClosePath(undefined);
            };

            window.SVGPathSegMovetoAbs = function (owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegMovetoAbs.prototype.toString = function () {
                return "[object SVGPathSegMovetoAbs]";
            };
            window.SVGPathSegMovetoAbs.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegMovetoAbs.prototype.clone = function () {
                return new window.SVGPathSegMovetoAbs(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegMovetoRel = function (owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegMovetoRel.prototype.toString = function () {
                return "[object SVGPathSegMovetoRel]";
            };
            window.SVGPathSegMovetoRel.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegMovetoRel.prototype.clone = function () {
                return new window.SVGPathSegMovetoRel(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegLinetoAbs = function (owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoAbs.prototype.toString = function () {
                return "[object SVGPathSegLinetoAbs]";
            };
            window.SVGPathSegLinetoAbs.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegLinetoAbs.prototype.clone = function () {
                return new window.SVGPathSegLinetoAbs(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegLinetoRel = function (owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoRel.prototype.toString = function () {
                return "[object SVGPathSegLinetoRel]";
            };
            window.SVGPathSegLinetoRel.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegLinetoRel.prototype.clone = function () {
                return new window.SVGPathSegLinetoRel(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegCurvetoCubicAbs = function (owningPathSegList, x, y, x1, y1, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicAbs.prototype.toString = function () {
                return "[object SVGPathSegCurvetoCubicAbs]";
            };
            window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoCubicAbs.prototype.clone = function () {
                return new window.SVGPathSegCurvetoCubicAbs(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", { get: function get() {
                    return this._x1;
                }, set: function set(x1) {
                    this._x1 = x1;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", { get: function get() {
                    return this._y1;
                }, set: function set(y1) {
                    this._y1 = y1;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", { get: function get() {
                    return this._x2;
                }, set: function set(x2) {
                    this._x2 = x2;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", { get: function get() {
                    return this._y2;
                }, set: function set(y2) {
                    this._y2 = y2;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegCurvetoCubicRel = function (owningPathSegList, x, y, x1, y1, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicRel.prototype.toString = function () {
                return "[object SVGPathSegCurvetoCubicRel]";
            };
            window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoCubicRel.prototype.clone = function () {
                return new window.SVGPathSegCurvetoCubicRel(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", { get: function get() {
                    return this._x1;
                }, set: function set(x1) {
                    this._x1 = x1;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", { get: function get() {
                    return this._y1;
                }, set: function set(y1) {
                    this._y1 = y1;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", { get: function get() {
                    return this._x2;
                }, set: function set(x2) {
                    this._x2 = x2;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", { get: function get() {
                    return this._y2;
                }, set: function set(y2) {
                    this._y2 = y2;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegCurvetoQuadraticAbs = function (owningPathSegList, x, y, x1, y1) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
            };
            window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function () {
                return "[object SVGPathSegCurvetoQuadraticAbs]";
            };
            window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function () {
                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, this._x, this._y, this._x1, this._y1);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", { get: function get() {
                    return this._x1;
                }, set: function set(x1) {
                    this._x1 = x1;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", { get: function get() {
                    return this._y1;
                }, set: function set(y1) {
                    this._y1 = y1;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegCurvetoQuadraticRel = function (owningPathSegList, x, y, x1, y1) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
            };
            window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function () {
                return "[object SVGPathSegCurvetoQuadraticRel]";
            };
            window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function () {
                return new window.SVGPathSegCurvetoQuadraticRel(undefined, this._x, this._y, this._x1, this._y1);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", { get: function get() {
                    return this._x1;
                }, set: function set(x1) {
                    this._x1 = x1;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", { get: function get() {
                    return this._y1;
                }, set: function set(y1) {
                    this._y1 = y1;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegArcAbs = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", owningPathSegList);
                this._x = x;
                this._y = y;
                this._r1 = r1;
                this._r2 = r2;
                this._angle = angle;
                this._largeArcFlag = largeArcFlag;
                this._sweepFlag = sweepFlag;
            };
            window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegArcAbs.prototype.toString = function () {
                return "[object SVGPathSegArcAbs]";
            };
            window.SVGPathSegArcAbs.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
            };
            window.SVGPathSegArcAbs.prototype.clone = function () {
                return new window.SVGPathSegArcAbs(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
            };
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", { get: function get() {
                    return this._r1;
                }, set: function set(r1) {
                    this._r1 = r1;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", { get: function get() {
                    return this._r2;
                }, set: function set(r2) {
                    this._r2 = r2;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", { get: function get() {
                    return this._angle;
                }, set: function set(angle) {
                    this._angle = angle;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", { get: function get() {
                    return this._largeArcFlag;
                }, set: function set(largeArcFlag) {
                    this._largeArcFlag = largeArcFlag;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", { get: function get() {
                    return this._sweepFlag;
                }, set: function set(sweepFlag) {
                    this._sweepFlag = sweepFlag;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegArcRel = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", owningPathSegList);
                this._x = x;
                this._y = y;
                this._r1 = r1;
                this._r2 = r2;
                this._angle = angle;
                this._largeArcFlag = largeArcFlag;
                this._sweepFlag = sweepFlag;
            };
            window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegArcRel.prototype.toString = function () {
                return "[object SVGPathSegArcRel]";
            };
            window.SVGPathSegArcRel.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
            };
            window.SVGPathSegArcRel.prototype.clone = function () {
                return new window.SVGPathSegArcRel(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
            };
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", { get: function get() {
                    return this._r1;
                }, set: function set(r1) {
                    this._r1 = r1;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", { get: function get() {
                    return this._r2;
                }, set: function set(r2) {
                    this._r2 = r2;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", { get: function get() {
                    return this._angle;
                }, set: function set(angle) {
                    this._angle = angle;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", { get: function get() {
                    return this._largeArcFlag;
                }, set: function set(largeArcFlag) {
                    this._largeArcFlag = largeArcFlag;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", { get: function get() {
                    return this._sweepFlag;
                }, set: function set(sweepFlag) {
                    this._sweepFlag = sweepFlag;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegLinetoHorizontalAbs = function (owningPathSegList, x) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", owningPathSegList);
                this._x = x;
            };
            window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function () {
                return "[object SVGPathSegLinetoHorizontalAbs]";
            };
            window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x;
            };
            window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function () {
                return new window.SVGPathSegLinetoHorizontalAbs(undefined, this._x);
            };
            Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegLinetoHorizontalRel = function (owningPathSegList, x) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", owningPathSegList);
                this._x = x;
            };
            window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoHorizontalRel.prototype.toString = function () {
                return "[object SVGPathSegLinetoHorizontalRel]";
            };
            window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x;
            };
            window.SVGPathSegLinetoHorizontalRel.prototype.clone = function () {
                return new window.SVGPathSegLinetoHorizontalRel(undefined, this._x);
            };
            Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegLinetoVerticalAbs = function (owningPathSegList, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", owningPathSegList);
                this._y = y;
            };
            window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoVerticalAbs.prototype.toString = function () {
                return "[object SVGPathSegLinetoVerticalAbs]";
            };
            window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._y;
            };
            window.SVGPathSegLinetoVerticalAbs.prototype.clone = function () {
                return new window.SVGPathSegLinetoVerticalAbs(undefined, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegLinetoVerticalRel = function (owningPathSegList, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", owningPathSegList);
                this._y = y;
            };
            window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoVerticalRel.prototype.toString = function () {
                return "[object SVGPathSegLinetoVerticalRel]";
            };
            window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._y;
            };
            window.SVGPathSegLinetoVerticalRel.prototype.clone = function () {
                return new window.SVGPathSegLinetoVerticalRel(undefined, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegCurvetoCubicSmoothAbs = function (owningPathSegList, x, y, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function () {
                return "[object SVGPathSegCurvetoCubicSmoothAbs]";
            };
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function () {
                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, this._x, this._y, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", { get: function get() {
                    return this._x2;
                }, set: function set(x2) {
                    this._x2 = x2;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", { get: function get() {
                    return this._y2;
                }, set: function set(y2) {
                    this._y2 = y2;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegCurvetoCubicSmoothRel = function (owningPathSegList, x, y, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function () {
                return "[object SVGPathSegCurvetoCubicSmoothRel]";
            };
            window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function () {
                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, this._x, this._y, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", { get: function get() {
                    return this._x2;
                }, set: function set(x2) {
                    this._x2 = x2;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", { get: function get() {
                    return this._y2;
                }, set: function set(y2) {
                    this._y2 = y2;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegCurvetoQuadraticSmoothAbs = function (owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function () {
                return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
            };
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function () {
                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });

            window.SVGPathSegCurvetoQuadraticSmoothRel = function (owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function () {
                return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
            };
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function () {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function () {
                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", { get: function get() {
                    return this._x;
                }, set: function set(x) {
                    this._x = x;this._segmentChanged();
                }, enumerable: true });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", { get: function get() {
                    return this._y;
                }, set: function set(y) {
                    this._y = y;this._segmentChanged();
                }, enumerable: true });

            // Add createSVGPathSeg* functions to window.SVGPathElement.
            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-Interfacewindow.SVGPathElement.
            window.SVGPathElement.prototype.createSVGPathSegClosePath = function () {
                return new window.SVGPathSegClosePath(undefined);
            };
            window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function (x, y) {
                return new window.SVGPathSegMovetoAbs(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function (x, y) {
                return new window.SVGPathSegMovetoRel(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function (x, y) {
                return new window.SVGPathSegLinetoAbs(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function (x, y) {
                return new window.SVGPathSegLinetoRel(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function (x, y, x1, y1, x2, y2) {
                return new window.SVGPathSegCurvetoCubicAbs(undefined, x, y, x1, y1, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function (x, y, x1, y1, x2, y2) {
                return new window.SVGPathSegCurvetoCubicRel(undefined, x, y, x1, y1, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function (x, y, x1, y1) {
                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, x, y, x1, y1);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function (x, y, x1, y1) {
                return new window.SVGPathSegCurvetoQuadraticRel(undefined, x, y, x1, y1);
            };
            window.SVGPathElement.prototype.createSVGPathSegArcAbs = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                return new window.SVGPathSegArcAbs(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
            };
            window.SVGPathElement.prototype.createSVGPathSegArcRel = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                return new window.SVGPathSegArcRel(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function (x) {
                return new window.SVGPathSegLinetoHorizontalAbs(undefined, x);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function (x) {
                return new window.SVGPathSegLinetoHorizontalRel(undefined, x);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function (y) {
                return new window.SVGPathSegLinetoVerticalAbs(undefined, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function (y) {
                return new window.SVGPathSegLinetoVerticalRel(undefined, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function (x, y, x2, y2) {
                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, x, y, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function (x, y, x2, y2) {
                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, x, y, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function (x, y) {
                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function (x, y) {
                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, x, y);
            };

            if (!("getPathSegAtLength" in window.SVGPathElement.prototype)) {
                // Add getPathSegAtLength to SVGPathElement.
                // Spec: https://www.w3.org/TR/SVG11/single-page.html#paths-__svg__SVGPathElement__getPathSegAtLength
                // This polyfill requires SVGPathElement.getTotalLength to implement the distance-along-a-path algorithm.
                window.SVGPathElement.prototype.getPathSegAtLength = function (distance) {
                    if (distance === undefined || !isFinite(distance)) throw "Invalid arguments.";

                    var measurementElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    measurementElement.setAttribute("d", this.getAttribute("d"));
                    var lastPathSegment = measurementElement.pathSegList.numberOfItems - 1;

                    // If the path is empty, return 0.
                    if (lastPathSegment <= 0) return 0;

                    do {
                        measurementElement.pathSegList.removeItem(lastPathSegment);
                        if (distance > measurementElement.getTotalLength()) break;
                        lastPathSegment--;
                    } while (lastPathSegment > 0);
                    return lastPathSegment;
                };
            }
        }

        if (!("SVGPathSegList" in window)) {
            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSegList
            window.SVGPathSegList = function (pathElement) {
                this._pathElement = pathElement;
                this._list = this._parsePath(this._pathElement.getAttribute("d"));

                // Use a MutationObserver to catch changes to the path's "d" attribute.
                this._mutationObserverConfig = { "attributes": true, "attributeFilter": ["d"] };
                this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this));
                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
            };

            window.SVGPathSegList.prototype.classname = "SVGPathSegList";

            Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
                get: function get() {
                    this._checkPathSynchronizedToList();
                    return this._list.length;
                },
                enumerable: true
            });

            // Add the pathSegList accessors to window.SVGPathElement.
            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGAnimatedPathData
            Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
                get: function get() {
                    if (!this._pathSegList) this._pathSegList = new window.SVGPathSegList(this);
                    return this._pathSegList;
                },
                enumerable: true
            });
            // FIXME: The following are not implemented and simply return window.SVGPathElement.pathSegList.
            Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", { get: function get() {
                    return this.pathSegList;
                }, enumerable: true });
            Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", { get: function get() {
                    return this.pathSegList;
                }, enumerable: true });
            Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", { get: function get() {
                    return this.pathSegList;
                }, enumerable: true });

            // Process any pending mutations to the path element and update the list as needed.
            // This should be the first call of all public functions and is needed because
            // MutationObservers are not synchronous so we can have pending asynchronous mutations.
            window.SVGPathSegList.prototype._checkPathSynchronizedToList = function () {
                this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
            };

            window.SVGPathSegList.prototype._updateListFromPathMutations = function (mutationRecords) {
                if (!this._pathElement) return;
                var hasPathMutations = false;
                mutationRecords.forEach(function (record) {
                    if (record.attributeName == "d") hasPathMutations = true;
                });
                if (hasPathMutations) this._list = this._parsePath(this._pathElement.getAttribute("d"));
            };

            // Serialize the list and update the path's 'd' attribute.
            window.SVGPathSegList.prototype._writeListToPath = function () {
                this._pathElementMutationObserver.disconnect();
                this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list));
                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
            };

            // When a path segment changes the list needs to be synchronized back to the path element.
            window.SVGPathSegList.prototype.segmentChanged = function (pathSeg) {
                this._writeListToPath();
            };

            window.SVGPathSegList.prototype.clear = function () {
                this._checkPathSynchronizedToList();

                this._list.forEach(function (pathSeg) {
                    pathSeg._owningPathSegList = null;
                });
                this._list = [];
                this._writeListToPath();
            };

            window.SVGPathSegList.prototype.initialize = function (newItem) {
                this._checkPathSynchronizedToList();

                this._list = [newItem];
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };

            window.SVGPathSegList.prototype._checkValidIndex = function (index) {
                if (isNaN(index) || index < 0 || index >= this.numberOfItems) throw "INDEX_SIZE_ERR";
            };

            window.SVGPathSegList.prototype.getItem = function (index) {
                this._checkPathSynchronizedToList();

                this._checkValidIndex(index);
                return this._list[index];
            };

            window.SVGPathSegList.prototype.insertItemBefore = function (newItem, index) {
                this._checkPathSynchronizedToList();

                // Spec: If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
                if (index > this.numberOfItems) index = this.numberOfItems;
                if (newItem._owningPathSegList) {
                    // SVG2 spec says to make a copy.
                    newItem = newItem.clone();
                }
                this._list.splice(index, 0, newItem);
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };

            window.SVGPathSegList.prototype.replaceItem = function (newItem, index) {
                this._checkPathSynchronizedToList();

                if (newItem._owningPathSegList) {
                    // SVG2 spec says to make a copy.
                    newItem = newItem.clone();
                }
                this._checkValidIndex(index);
                this._list[index] = newItem;
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };

            window.SVGPathSegList.prototype.removeItem = function (index) {
                this._checkPathSynchronizedToList();

                this._checkValidIndex(index);
                var item = this._list[index];
                this._list.splice(index, 1);
                this._writeListToPath();
                return item;
            };

            window.SVGPathSegList.prototype.appendItem = function (newItem) {
                this._checkPathSynchronizedToList();

                if (newItem._owningPathSegList) {
                    // SVG2 spec says to make a copy.
                    newItem = newItem.clone();
                }
                this._list.push(newItem);
                newItem._owningPathSegList = this;
                // TODO: Optimize this to just append to the existing attribute.
                this._writeListToPath();
                return newItem;
            };

            window.SVGPathSegList._pathSegArrayAsString = function (pathSegArray) {
                var string = "";
                var first = true;
                pathSegArray.forEach(function (pathSeg) {
                    if (first) {
                        first = false;
                        string += pathSeg._asPathString();
                    } else {
                        string += " " + pathSeg._asPathString();
                    }
                });
                return string;
            };

            // This closely follows SVGPathParser::parsePath from Source/core/svg/SVGPathParser.cpp.
            window.SVGPathSegList.prototype._parsePath = function (string) {
                if (!string || string.length == 0) return [];

                var owningPathSegList = this;

                var Builder = function Builder() {
                    this.pathSegList = [];
                };

                Builder.prototype.appendSegment = function (pathSeg) {
                    this.pathSegList.push(pathSeg);
                };

                var Source = function Source(string) {
                    this._string = string;
                    this._currentIndex = 0;
                    this._endIndex = this._string.length;
                    this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN;

                    this._skipOptionalSpaces();
                };

                Source.prototype._isCurrentSpace = function () {
                    var character = this._string[this._currentIndex];
                    return character <= " " && (character == " " || character == "\n" || character == "\t" || character == "\r" || character == "\f");
                };

                Source.prototype._skipOptionalSpaces = function () {
                    while (this._currentIndex < this._endIndex && this._isCurrentSpace()) {
                        this._currentIndex++;
                    }return this._currentIndex < this._endIndex;
                };

                Source.prototype._skipOptionalSpacesOrDelimiter = function () {
                    if (this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != ",") return false;
                    if (this._skipOptionalSpaces()) {
                        if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ",") {
                            this._currentIndex++;
                            this._skipOptionalSpaces();
                        }
                    }
                    return this._currentIndex < this._endIndex;
                };

                Source.prototype.hasMoreData = function () {
                    return this._currentIndex < this._endIndex;
                };

                Source.prototype.peekSegmentType = function () {
                    var lookahead = this._string[this._currentIndex];
                    return this._pathSegTypeFromChar(lookahead);
                };

                Source.prototype._pathSegTypeFromChar = function (lookahead) {
                    switch (lookahead) {
                        case "Z":
                        case "z":
                            return window.SVGPathSeg.PATHSEG_CLOSEPATH;
                        case "M":
                            return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
                        case "m":
                            return window.SVGPathSeg.PATHSEG_MOVETO_REL;
                        case "L":
                            return window.SVGPathSeg.PATHSEG_LINETO_ABS;
                        case "l":
                            return window.SVGPathSeg.PATHSEG_LINETO_REL;
                        case "C":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
                        case "c":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
                        case "Q":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
                        case "q":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
                        case "A":
                            return window.SVGPathSeg.PATHSEG_ARC_ABS;
                        case "a":
                            return window.SVGPathSeg.PATHSEG_ARC_REL;
                        case "H":
                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
                        case "h":
                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
                        case "V":
                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
                        case "v":
                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
                        case "S":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
                        case "s":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
                        case "T":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
                        case "t":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
                        default:
                            return window.SVGPathSeg.PATHSEG_UNKNOWN;
                    }
                };

                Source.prototype._nextCommandHelper = function (lookahead, previousCommand) {
                    // Check for remaining coordinates in the current command.
                    if ((lookahead == "+" || lookahead == "-" || lookahead == "." || lookahead >= "0" && lookahead <= "9") && previousCommand != window.SVGPathSeg.PATHSEG_CLOSEPATH) {
                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_ABS) return window.SVGPathSeg.PATHSEG_LINETO_ABS;
                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_REL) return window.SVGPathSeg.PATHSEG_LINETO_REL;
                        return previousCommand;
                    }
                    return window.SVGPathSeg.PATHSEG_UNKNOWN;
                };

                Source.prototype.initialCommandIsMoveTo = function () {
                    // If the path is empty it is still valid, so return true.
                    if (!this.hasMoreData()) return true;
                    var command = this.peekSegmentType();
                    // Path must start with moveTo.
                    return command == window.SVGPathSeg.PATHSEG_MOVETO_ABS || command == window.SVGPathSeg.PATHSEG_MOVETO_REL;
                };

                // Parse a number from an SVG path. This very closely follows genericParseNumber(...) from Source/core/svg/SVGParserUtilities.cpp.
                // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-PathDataBNF
                Source.prototype._parseNumber = function () {
                    var exponent = 0;
                    var integer = 0;
                    var frac = 1;
                    var decimal = 0;
                    var sign = 1;
                    var expsign = 1;

                    var startIndex = this._currentIndex;

                    this._skipOptionalSpaces();

                    // Read the sign.
                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+") this._currentIndex++;else if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-") {
                        this._currentIndex++;
                        sign = -1;
                    }

                    if (this._currentIndex == this._endIndex || (this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != ".")
                        // The first character of a number must be one of [0-9+-.].
                        return undefined;

                    // Read the integer part, build right-to-left.
                    var startIntPartIndex = this._currentIndex;
                    while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
                        this._currentIndex++;
                    } // Advance to first non-digit.

                    if (this._currentIndex != startIntPartIndex) {
                        var scanIntPartIndex = this._currentIndex - 1;
                        var multiplier = 1;
                        while (scanIntPartIndex >= startIntPartIndex) {
                            integer += multiplier * (this._string.charAt(scanIntPartIndex--) - "0");
                            multiplier *= 10;
                        }
                    }

                    // Read the decimals.
                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
                        this._currentIndex++;

                        // There must be a least one digit following the .
                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;
                        while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
                            frac *= 10;
                            decimal += (this._string.charAt(this._currentIndex) - "0") / frac;
                            this._currentIndex += 1;
                        }
                    }

                    // Read the exponent part.
                    if (this._currentIndex != startIndex && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m") {
                        this._currentIndex++;

                        // Read the sign of the exponent.
                        if (this._string.charAt(this._currentIndex) == "+") {
                            this._currentIndex++;
                        } else if (this._string.charAt(this._currentIndex) == "-") {
                            this._currentIndex++;
                            expsign = -1;
                        }

                        // There must be an exponent.
                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;

                        while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
                            exponent *= 10;
                            exponent += this._string.charAt(this._currentIndex) - "0";
                            this._currentIndex++;
                        }
                    }

                    var number = integer + decimal;
                    number *= sign;

                    if (exponent) number *= Math.pow(10, expsign * exponent);

                    if (startIndex == this._currentIndex) return undefined;

                    this._skipOptionalSpacesOrDelimiter();

                    return number;
                };

                Source.prototype._parseArcFlag = function () {
                    if (this._currentIndex >= this._endIndex) return undefined;
                    var flag = false;
                    var flagChar = this._string.charAt(this._currentIndex++);
                    if (flagChar == "0") flag = false;else if (flagChar == "1") flag = true;else return undefined;

                    this._skipOptionalSpacesOrDelimiter();
                    return flag;
                };

                Source.prototype.parseSegment = function () {
                    var lookahead = this._string[this._currentIndex];
                    var command = this._pathSegTypeFromChar(lookahead);
                    if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) {
                        // Possibly an implicit command. Not allowed if this is the first command.
                        if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
                        command = this._nextCommandHelper(lookahead, this._previousCommand);
                        if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
                    } else {
                        this._currentIndex++;
                    }

                    this._previousCommand = command;

                    switch (command) {
                        case window.SVGPathSeg.PATHSEG_MOVETO_REL:
                            return new window.SVGPathSegMovetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
                            return new window.SVGPathSegMovetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_REL:
                            return new window.SVGPathSegLinetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_ABS:
                            return new window.SVGPathSegLinetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
                            return new window.SVGPathSegLinetoHorizontalRel(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
                            return new window.SVGPathSegLinetoHorizontalAbs(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
                            return new window.SVGPathSegLinetoVerticalRel(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
                            return new window.SVGPathSegLinetoVerticalAbs(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_CLOSEPATH:
                            this._skipOptionalSpaces();
                            return new window.SVGPathSegClosePath(owningPathSegList);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
                            return new window.SVGPathSegCurvetoCubicRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
                            return new window.SVGPathSegCurvetoCubicAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
                            var points = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
                            return new window.SVGPathSegCurvetoCubicSmoothRel(owningPathSegList, points.x, points.y, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
                            var points = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
                            return new window.SVGPathSegCurvetoCubicSmoothAbs(owningPathSegList, points.x, points.y, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
                            return new window.SVGPathSegCurvetoQuadraticRel(owningPathSegList, points.x, points.y, points.x1, points.y1);
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
                            return new window.SVGPathSegCurvetoQuadraticAbs(owningPathSegList, points.x, points.y, points.x1, points.y1);
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
                            return new window.SVGPathSegCurvetoQuadraticSmoothRel(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
                            return new window.SVGPathSegCurvetoQuadraticSmoothAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_ARC_REL:
                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
                            return new window.SVGPathSegArcRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
                        case window.SVGPathSeg.PATHSEG_ARC_ABS:
                            var points = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
                            return new window.SVGPathSegArcAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
                        default:
                            throw "Unknown path seg type.";
                    }
                };

                var builder = new Builder();
                var source = new Source(string);

                if (!source.initialCommandIsMoveTo()) return [];
                while (source.hasMoreData()) {
                    var pathSeg = source.parseSegment();
                    if (!pathSeg) return [];
                    builder.appendSegment(pathSeg);
                }

                return builder.pathSegList;
            };
        }
    })();

    // String.padEnd polyfill for IE11
    //
    // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd
    if (!String.prototype.padEnd) {
        String.prototype.padEnd = function padEnd(targetLength, padString) {
            targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
            padString = String(typeof padString !== 'undefined' ? padString : ' ');
            if (this.length > targetLength) {
                return String(this);
            } else {
                targetLength = targetLength - this.length;
                if (targetLength > padString.length) {
                    padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
                }
                return String(this) + padString.slice(0, targetLength);
            }
        };
    }

    /* jshint ignore:end */

    c3_chart_fn.axis = function () {};
    c3_chart_fn.axis.labels = function (labels) {
        var $$ = this.internal;
        if (arguments.length) {
            Object.keys(labels).forEach(function (axisId) {
                $$.axis.setLabelText(axisId, labels[axisId]);
            });
            $$.axis.updateLabels();
        }
        // TODO: return some values?
    };
    c3_chart_fn.axis.max = function (max) {
        var $$ = this.internal,
            config = $$.config;
        if (arguments.length) {
            if ((typeof max === 'undefined' ? 'undefined' : _typeof(max)) === 'object') {
                if (isValue(max.x)) {
                    config.axis_x_max = max.x;
                }
                if (isValue(max.y)) {
                    config.axis_y_max = max.y;
                }
                if (isValue(max.y2)) {
                    config.axis_y2_max = max.y2;
                }
            } else {
                config.axis_y_max = config.axis_y2_max = max;
            }
            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
        } else {
            return {
                x: config.axis_x_max,
                y: config.axis_y_max,
                y2: config.axis_y2_max
            };
        }
    };
    c3_chart_fn.axis.min = function (min) {
        var $$ = this.internal,
            config = $$.config;
        if (arguments.length) {
            if ((typeof min === 'undefined' ? 'undefined' : _typeof(min)) === 'object') {
                if (isValue(min.x)) {
                    config.axis_x_min = min.x;
                }
                if (isValue(min.y)) {
                    config.axis_y_min = min.y;
                }
                if (isValue(min.y2)) {
                    config.axis_y2_min = min.y2;
                }
            } else {
                config.axis_y_min = config.axis_y2_min = min;
            }
            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
        } else {
            return {
                x: config.axis_x_min,
                y: config.axis_y_min,
                y2: config.axis_y2_min
            };
        }
    };
    c3_chart_fn.axis.range = function (range) {
        if (arguments.length) {
            if (isDefined(range.max)) {
                this.axis.max(range.max);
            }
            if (isDefined(range.min)) {
                this.axis.min(range.min);
            }
        } else {
            return {
                max: this.axis.max(),
                min: this.axis.min()
            };
        }
    };

    c3_chart_fn.category = function (i, category) {
        var $$ = this.internal,
            config = $$.config;
        if (arguments.length > 1) {
            config.axis_x_categories[i] = category;
            $$.redraw();
        }
        return config.axis_x_categories[i];
    };
    c3_chart_fn.categories = function (categories) {
        var $$ = this.internal,
            config = $$.config;
        if (!arguments.length) {
            return config.axis_x_categories;
        }
        config.axis_x_categories = categories;
        $$.redraw();
        return config.axis_x_categories;
    };

    c3_chart_fn.resize = function (size) {
        var $$ = this.internal,
            config = $$.config;
        config.size_width = size ? size.width : null;
        config.size_height = size ? size.height : null;
        this.flush();
    };

    c3_chart_fn.flush = function () {
        var $$ = this.internal;
        $$.updateAndRedraw({ withLegend: true, withTransition: false, withTransitionForTransform: false });
    };

    c3_chart_fn.destroy = function () {
        var $$ = this.internal;

        window.clearInterval($$.intervalForObserveInserted);

        if ($$.resizeTimeout !== undefined) {
            window.clearTimeout($$.resizeTimeout);
        }

        if (window.detachEvent) {
            window.detachEvent('onresize', $$.resizeIfElementDisplayed);
        } else if (window.removeEventListener) {
            window.removeEventListener('resize', $$.resizeIfElementDisplayed);
        } else {
            var wrapper = window.onresize;
            // check if no one else removed our wrapper and remove our resizeFunction from it
            if (wrapper && wrapper.add && wrapper.remove) {
                wrapper.remove($$.resizeFunction);
            }
        }

        // remove the inner resize functions
        $$.resizeFunction.remove();

        $$.selectChart.classed('c3', false).html("");

        // MEMO: this is needed because the reference of some elements will not be released, then memory leak will happen.
        Object.keys($$).forEach(function (key) {
            $$[key] = null;
        });

        return null;
    };

    // TODO: fix
    c3_chart_fn.color = function (id) {
        var $$ = this.internal;
        return $$.color(id); // more patterns
    };

    c3_chart_fn.data = function (targetIds) {
        var targets = this.internal.data.targets;
        return typeof targetIds === 'undefined' ? targets : targets.filter(function (t) {
            return [].concat(targetIds).indexOf(t.id) >= 0;
        });
    };
    c3_chart_fn.data.shown = function (targetIds) {
        return this.internal.filterTargetsToShow(this.data(targetIds));
    };
    c3_chart_fn.data.values = function (targetId) {
        var targets,
            values = null;
        if (targetId) {
            targets = this.data(targetId);
            values = targets[0] ? targets[0].values.map(function (d) {
                return d.value;
            }) : null;
        }
        return values;
    };
    c3_chart_fn.data.names = function (names) {
        this.internal.clearLegendItemTextBoxCache();
        return this.internal.updateDataAttributes('names', names);
    };
    c3_chart_fn.data.colors = function (colors) {
        return this.internal.updateDataAttributes('colors', colors);
    };
    c3_chart_fn.data.axes = function (axes) {
        return this.internal.updateDataAttributes('axes', axes);
    };

    c3_chart_fn.flow = function (args) {
        var $$ = this.internal,
            targets,
            data,
            notfoundIds = [],
            orgDataCount = $$.getMaxDataCount(),
            dataCount,
            domain,
            baseTarget,
            baseValue,
            length = 0,
            tail = 0,
            diff,
            to;

        if (args.json) {
            data = $$.convertJsonToData(args.json, args.keys);
        } else if (args.rows) {
            data = $$.convertRowsToData(args.rows);
        } else if (args.columns) {
            data = $$.convertColumnsToData(args.columns);
        } else {
            return;
        }
        targets = $$.convertDataToTargets(data, true);

        // Update/Add data
        $$.data.targets.forEach(function (t) {
            var found = false,
                i,
                j;
            for (i = 0; i < targets.length; i++) {
                if (t.id === targets[i].id) {
                    found = true;

                    if (t.values[t.values.length - 1]) {
                        tail = t.values[t.values.length - 1].index + 1;
                    }
                    length = targets[i].values.length;

                    for (j = 0; j < length; j++) {
                        targets[i].values[j].index = tail + j;
                        if (!$$.isTimeSeries()) {
                            targets[i].values[j].x = tail + j;
                        }
                    }
                    t.values = t.values.concat(targets[i].values);

                    targets.splice(i, 1);
                    break;
                }
            }
            if (!found) {
                notfoundIds.push(t.id);
            }
        });

        // Append null for not found targets
        $$.data.targets.forEach(function (t) {
            var i, j;
            for (i = 0; i < notfoundIds.length; i++) {
                if (t.id === notfoundIds[i]) {
                    tail = t.values[t.values.length - 1].index + 1;
                    for (j = 0; j < length; j++) {
                        t.values.push({
                            id: t.id,
                            index: tail + j,
                            x: $$.isTimeSeries() ? $$.getOtherTargetX(tail + j) : tail + j,
                            value: null
                        });
                    }
                }
            }
        });

        // Generate null values for new target
        if ($$.data.targets.length) {
            targets.forEach(function (t) {
                var i,
                    missing = [];
                for (i = $$.data.targets[0].values[0].index; i < tail; i++) {
                    missing.push({
                        id: t.id,
                        index: i,
                        x: $$.isTimeSeries() ? $$.getOtherTargetX(i) : i,
                        value: null
                    });
                }
                t.values.forEach(function (v) {
                    v.index += tail;
                    if (!$$.isTimeSeries()) {
                        v.x += tail;
                    }
                });
                t.values = missing.concat(t.values);
            });
        }
        $$.data.targets = $$.data.targets.concat(targets); // add remained

        // check data count because behavior needs to change when it's only one
        dataCount = $$.getMaxDataCount();
        baseTarget = $$.data.targets[0];
        baseValue = baseTarget.values[0];

        // Update length to flow if needed
        if (isDefined(args.to)) {
            length = 0;
            to = $$.isTimeSeries() ? $$.parseDate(args.to) : args.to;
            baseTarget.values.forEach(function (v) {
                if (v.x < to) {
                    length++;
                }
            });
        } else if (isDefined(args.length)) {
            length = args.length;
        }

        // If only one data, update the domain to flow from left edge of the chart
        if (!orgDataCount) {
            if ($$.isTimeSeries()) {
                if (baseTarget.values.length > 1) {
                    diff = baseTarget.values[baseTarget.values.length - 1].x - baseValue.x;
                } else {
                    diff = baseValue.x - $$.getXDomain($$.data.targets)[0];
                }
            } else {
                diff = 1;
            }
            domain = [baseValue.x - diff, baseValue.x];
            $$.updateXDomain(null, true, true, false, domain);
        } else if (orgDataCount === 1) {
            if ($$.isTimeSeries()) {
                diff = (baseTarget.values[baseTarget.values.length - 1].x - baseValue.x) / 2;
                domain = [new Date(+baseValue.x - diff), new Date(+baseValue.x + diff)];
                $$.updateXDomain(null, true, true, false, domain);
            }
        }

        // Set targets
        $$.updateTargets($$.data.targets);

        // Redraw with new targets
        $$.redraw({
            flow: {
                index: baseValue.index,
                length: length,
                duration: isValue(args.duration) ? args.duration : $$.config.transition_duration,
                done: args.done,
                orgDataCount: orgDataCount
            },
            withLegend: true,
            withTransition: orgDataCount > 1,
            withTrimXDomain: false,
            withUpdateXAxis: true
        });
    };

    c3_chart_internal_fn.generateFlow = function (args) {
        var $$ = this,
            config = $$.config,
            d3 = $$.d3;

        return function () {
            var targets = args.targets,
                flow = args.flow,
                drawBar = args.drawBar,
                drawLine = args.drawLine,
                drawArea = args.drawArea,
                cx = args.cx,
                cy = args.cy,
                xv = args.xv,
                xForText = args.xForText,
                yForText = args.yForText,
                duration = args.duration;

            var translateX,
                scaleX = 1,
                transform,
                flowIndex = flow.index,
                flowLength = flow.length,
                flowStart = $$.getValueOnIndex($$.data.targets[0].values, flowIndex),
                flowEnd = $$.getValueOnIndex($$.data.targets[0].values, flowIndex + flowLength),
                orgDomain = $$.x.domain(),
                domain,
                durationForFlow = flow.duration || duration,
                done = flow.done || function () {},
                wait = $$.generateWait();

            var xgrid = $$.xgrid || d3.selectAll([]),
                xgridLines = $$.xgridLines || d3.selectAll([]),
                mainRegion = $$.mainRegion || d3.selectAll([]),
                mainText = $$.mainText || d3.selectAll([]),
                mainBar = $$.mainBar || d3.selectAll([]),
                mainLine = $$.mainLine || d3.selectAll([]),
                mainArea = $$.mainArea || d3.selectAll([]),
                mainCircle = $$.mainCircle || d3.selectAll([]);

            // set flag
            $$.flowing = true;

            // remove head data after rendered
            $$.data.targets.forEach(function (d) {
                d.values.splice(0, flowLength);
            });

            // update x domain to generate axis elements for flow
            domain = $$.updateXDomain(targets, true, true);
            // update elements related to x scale
            if ($$.updateXGrid) {
                $$.updateXGrid(true);
            }

            // generate transform to flow
            if (!flow.orgDataCount) {
                // if empty
                if ($$.data.targets[0].values.length !== 1) {
                    translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
                } else {
                    if ($$.isTimeSeries()) {
                        flowStart = $$.getValueOnIndex($$.data.targets[0].values, 0);
                        flowEnd = $$.getValueOnIndex($$.data.targets[0].values, $$.data.targets[0].values.length - 1);
                        translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
                    } else {
                        translateX = diffDomain(domain) / 2;
                    }
                }
            } else if (flow.orgDataCount === 1 || (flowStart && flowStart.x) === (flowEnd && flowEnd.x)) {
                translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
            } else {
                if ($$.isTimeSeries()) {
                    translateX = $$.x(orgDomain[0]) - $$.x(domain[0]);
                } else {
                    translateX = $$.x(flowStart.x) - $$.x(flowEnd.x);
                }
            }
            scaleX = diffDomain(orgDomain) / diffDomain(domain);
            transform = 'translate(' + translateX + ',0) scale(' + scaleX + ',1)';

            $$.hideXGridFocus();

            d3.transition().ease('linear').duration(durationForFlow).each(function () {
                wait.add($$.axes.x.transition().call($$.xAxis));
                wait.add(mainBar.transition().attr('transform', transform));
                wait.add(mainLine.transition().attr('transform', transform));
                wait.add(mainArea.transition().attr('transform', transform));
                wait.add(mainCircle.transition().attr('transform', transform));
                wait.add(mainText.transition().attr('transform', transform));
                wait.add(mainRegion.filter($$.isRegionOnX).transition().attr('transform', transform));
                wait.add(xgrid.transition().attr('transform', transform));
                wait.add(xgridLines.transition().attr('transform', transform));
            }).call(wait, function () {
                var i,
                    shapes = [],
                    texts = [],
                    eventRects = [];

                // remove flowed elements
                if (flowLength) {
                    for (i = 0; i < flowLength; i++) {
                        shapes.push('.' + CLASS.shape + '-' + (flowIndex + i));
                        texts.push('.' + CLASS.text + '-' + (flowIndex + i));
                        eventRects.push('.' + CLASS.eventRect + '-' + (flowIndex + i));
                    }
                    $$.svg.selectAll('.' + CLASS.shapes).selectAll(shapes).remove();
                    $$.svg.selectAll('.' + CLASS.texts).selectAll(texts).remove();
                    $$.svg.selectAll('.' + CLASS.eventRects).selectAll(eventRects).remove();
                    $$.svg.select('.' + CLASS.xgrid).remove();
                }

                // draw again for removing flowed elements and reverting attr
                xgrid.attr('transform', null).attr($$.xgridAttr);
                xgridLines.attr('transform', null);
                xgridLines.select('line').attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv);
                xgridLines.select('text').attr("x", config.axis_rotated ? $$.width : 0).attr("y", xv);
                mainBar.attr('transform', null).attr("d", drawBar);
                mainLine.attr('transform', null).attr("d", drawLine);
                mainArea.attr('transform', null).attr("d", drawArea);
                mainCircle.attr('transform', null).attr("cx", cx).attr("cy", cy);
                mainText.attr('transform', null).attr('x', xForText).attr('y', yForText).style('fill-opacity', $$.opacityForText.bind($$));
                mainRegion.attr('transform', null);
                mainRegion.select('rect').filter($$.isRegionOnX).attr("x", $$.regionX.bind($$)).attr("width", $$.regionWidth.bind($$));

                if (config.interaction_enabled) {
                    $$.redrawEventRect();
                }

                // callback for end of flow
                done();

                $$.flowing = false;
            });
        };
    };

    c3_chart_fn.focus = function (targetIds) {
        var $$ = this.internal,
            candidates;

        targetIds = $$.mapToTargetIds(targetIds);
        candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), this.revert();
        this.defocus();
        candidates.classed(CLASS.focused, true).classed(CLASS.defocused, false);
        if ($$.hasArcType()) {
            $$.expandArc(targetIds);
        }
        $$.toggleFocusLegend(targetIds, true);

        $$.focusedTargetIds = targetIds;
        $$.defocusedTargetIds = $$.defocusedTargetIds.filter(function (id) {
            return targetIds.indexOf(id) < 0;
        });
    };

    c3_chart_fn.defocus = function (targetIds) {
        var $$ = this.internal,
            candidates;

        targetIds = $$.mapToTargetIds(targetIds);
        candidates = $$.svg.selectAll($$.selectorTargets(targetIds.filter($$.isTargetToShow, $$))), candidates.classed(CLASS.focused, false).classed(CLASS.defocused, true);
        if ($$.hasArcType()) {
            $$.unexpandArc(targetIds);
        }
        $$.toggleFocusLegend(targetIds, false);

        $$.focusedTargetIds = $$.focusedTargetIds.filter(function (id) {
            return targetIds.indexOf(id) < 0;
        });
        $$.defocusedTargetIds = targetIds;
    };

    c3_chart_fn.revert = function (targetIds) {
        var $$ = this.internal,
            candidates;

        targetIds = $$.mapToTargetIds(targetIds);
        candidates = $$.svg.selectAll($$.selectorTargets(targetIds)); // should be for all targets

        candidates.classed(CLASS.focused, false).classed(CLASS.defocused, false);
        if ($$.hasArcType()) {
            $$.unexpandArc(targetIds);
        }
        if ($$.config.legend_show) {
            $$.showLegend(targetIds.filter($$.isLegendToShow.bind($$)));
            $$.legend.selectAll($$.selectorLegends(targetIds)).filter(function () {
                return $$.d3.select(this).classed(CLASS.legendItemFocused);
            }).classed(CLASS.legendItemFocused, false);
        }

        $$.focusedTargetIds = [];
        $$.defocusedTargetIds = [];
    };

    c3_chart_fn.xgrids = function (grids) {
        var $$ = this.internal,
            config = $$.config;
        if (!grids) {
            return config.grid_x_lines;
        }
        config.grid_x_lines = grids;
        $$.redrawWithoutRescale();
        return config.grid_x_lines;
    };
    c3_chart_fn.xgrids.add = function (grids) {
        var $$ = this.internal;
        return this.xgrids($$.config.grid_x_lines.concat(grids ? grids : []));
    };
    c3_chart_fn.xgrids.remove = function (params) {
        // TODO: multiple
        var $$ = this.internal;
        $$.removeGridLines(params, true);
    };

    c3_chart_fn.ygrids = function (grids) {
        var $$ = this.internal,
            config = $$.config;
        if (!grids) {
            return config.grid_y_lines;
        }
        config.grid_y_lines = grids;
        $$.redrawWithoutRescale();
        return config.grid_y_lines;
    };
    c3_chart_fn.ygrids.add = function (grids) {
        var $$ = this.internal;
        return this.ygrids($$.config.grid_y_lines.concat(grids ? grids : []));
    };
    c3_chart_fn.ygrids.remove = function (params) {
        // TODO: multiple
        var $$ = this.internal;
        $$.removeGridLines(params, false);
    };

    c3_chart_fn.groups = function (groups) {
        var $$ = this.internal,
            config = $$.config;
        if (isUndefined(groups)) {
            return config.data_groups;
        }
        config.data_groups = groups;
        $$.redraw();
        return config.data_groups;
    };

    c3_chart_fn.legend = function () {};
    c3_chart_fn.legend.show = function (targetIds) {
        var $$ = this.internal;
        $$.showLegend($$.mapToTargetIds(targetIds));
        $$.updateAndRedraw({ withLegend: true });
    };
    c3_chart_fn.legend.hide = function (targetIds) {
        var $$ = this.internal;
        $$.hideLegend($$.mapToTargetIds(targetIds));
        $$.updateAndRedraw({ withLegend: true });
    };

    c3_chart_fn.load = function (args) {
        var $$ = this.internal,
            config = $$.config;
        // update xs if specified
        if (args.xs) {
            $$.addXs(args.xs);
        }
        // update names if exists
        if ('names' in args) {
            c3_chart_fn.data.names.bind(this)(args.names);
        }
        // update classes if exists
        if ('classes' in args) {
            Object.keys(args.classes).forEach(function (id) {
                config.data_classes[id] = args.classes[id];
            });
        }
        // update categories if exists
        if ('categories' in args && $$.isCategorized()) {
            config.axis_x_categories = args.categories;
        }
        // update axes if exists
        if ('axes' in args) {
            Object.keys(args.axes).forEach(function (id) {
                config.data_axes[id] = args.axes[id];
            });
        }
        // update colors if exists
        if ('colors' in args) {
            Object.keys(args.colors).forEach(function (id) {
                config.data_colors[id] = args.colors[id];
            });
        }
        // use cache if exists
        if ('cacheIds' in args && $$.hasCaches(args.cacheIds)) {
            $$.load($$.getCaches(args.cacheIds), args.done);
            return;
        }
        // unload if needed
        if ('unload' in args) {
            // TODO: do not unload if target will load (included in url/rows/columns)
            $$.unload($$.mapToTargetIds(typeof args.unload === 'boolean' && args.unload ? null : args.unload), function () {
                $$.loadFromArgs(args);
            });
        } else {
            $$.loadFromArgs(args);
        }
    };

    c3_chart_fn.unload = function (args) {
        var $$ = this.internal;
        args = args || {};
        if (args instanceof Array) {
            args = { ids: args };
        } else if (typeof args === 'string') {
            args = { ids: [args] };
        }
        $$.unload($$.mapToTargetIds(args.ids), function () {
            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
            if (args.done) {
                args.done();
            }
        });
    };

    c3_chart_fn.regions = function (regions) {
        var $$ = this.internal,
            config = $$.config;
        if (!regions) {
            return config.regions;
        }
        config.regions = regions;
        $$.redrawWithoutRescale();
        return config.regions;
    };
    c3_chart_fn.regions.add = function (regions) {
        var $$ = this.internal,
            config = $$.config;
        if (!regions) {
            return config.regions;
        }
        config.regions = config.regions.concat(regions);
        $$.redrawWithoutRescale();
        return config.regions;
    };
    c3_chart_fn.regions.remove = function (options) {
        var $$ = this.internal,
            config = $$.config,
            duration,
            classes,
            regions;

        options = options || {};
        duration = $$.getOption(options, "duration", config.transition_duration);
        classes = $$.getOption(options, "classes", [CLASS.region]);

        regions = $$.main.select('.' + CLASS.regions).selectAll(classes.map(function (c) {
            return '.' + c;
        }));
        (duration ? regions.transition().duration(duration) : regions).style('opacity', 0).remove();

        config.regions = config.regions.filter(function (region) {
            var found = false;
            if (!region['class']) {
                return true;
            }
            region['class'].split(' ').forEach(function (c) {
                if (classes.indexOf(c) >= 0) {
                    found = true;
                }
            });
            return !found;
        });

        return config.regions;
    };

    c3_chart_fn.selected = function (targetId) {
        var $$ = this.internal,
            d3 = $$.d3;
        return d3.merge($$.main.selectAll('.' + CLASS.shapes + $$.getTargetSelectorSuffix(targetId)).selectAll('.' + CLASS.shape).filter(function () {
            return d3.select(this).classed(CLASS.SELECTED);
        }).map(function (d) {
            return d.map(function (d) {
                var data = d.__data__;return data.data ? data.data : data;
            });
        }));
    };
    c3_chart_fn.select = function (ids, indices, resetOther) {
        var $$ = this.internal,
            d3 = $$.d3,
            config = $$.config;
        if (!config.data_selection_enabled) {
            return;
        }
        $$.main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).each(function (d, i) {
            var shape = d3.select(this),
                id = d.data ? d.data.id : d.id,
                toggle = $$.getToggle(this, d).bind($$),
                isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0,
                isTargetIndex = !indices || indices.indexOf(i) >= 0,
                isSelected = shape.classed(CLASS.SELECTED);
            // line/area selection not supported yet
            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) {
                return;
            }
            if (isTargetId && isTargetIndex) {
                if (config.data_selection_isselectable(d) && !isSelected) {
                    toggle(true, shape.classed(CLASS.SELECTED, true), d, i);
                }
            } else if (isDefined(resetOther) && resetOther) {
                if (isSelected) {
                    toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
                }
            }
        });
    };
    c3_chart_fn.unselect = function (ids, indices) {
        var $$ = this.internal,
            d3 = $$.d3,
            config = $$.config;
        if (!config.data_selection_enabled) {
            return;
        }
        $$.main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).each(function (d, i) {
            var shape = d3.select(this),
                id = d.data ? d.data.id : d.id,
                toggle = $$.getToggle(this, d).bind($$),
                isTargetId = config.data_selection_grouped || !ids || ids.indexOf(id) >= 0,
                isTargetIndex = !indices || indices.indexOf(i) >= 0,
                isSelected = shape.classed(CLASS.SELECTED);
            // line/area selection not supported yet
            if (shape.classed(CLASS.line) || shape.classed(CLASS.area)) {
                return;
            }
            if (isTargetId && isTargetIndex) {
                if (config.data_selection_isselectable(d)) {
                    if (isSelected) {
                        toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
                    }
                }
            }
        });
    };

    c3_chart_fn.show = function (targetIds, options) {
        var $$ = this.internal,
            targets;

        targetIds = $$.mapToTargetIds(targetIds);
        options = options || {};

        $$.removeHiddenTargetIds(targetIds);
        targets = $$.svg.selectAll($$.selectorTargets(targetIds));

        targets.transition().style('opacity', 1, 'important').call($$.endall, function () {
            targets.style('opacity', null).style('opacity', 1);
        });

        if (options.withLegend) {
            $$.showLegend(targetIds);
        }

        $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
    };

    c3_chart_fn.hide = function (targetIds, options) {
        var $$ = this.internal,
            targets;

        targetIds = $$.mapToTargetIds(targetIds);
        options = options || {};

        $$.addHiddenTargetIds(targetIds);
        targets = $$.svg.selectAll($$.selectorTargets(targetIds));

        targets.transition().style('opacity', 0, 'important').call($$.endall, function () {
            targets.style('opacity', null).style('opacity', 0);
        });

        if (options.withLegend) {
            $$.hideLegend(targetIds);
        }

        $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });
    };

    c3_chart_fn.toggle = function (targetIds, options) {
        var that = this,
            $$ = this.internal;
        $$.mapToTargetIds(targetIds).forEach(function (targetId) {
            $$.isTargetToShow(targetId) ? that.hide(targetId, options) : that.show(targetId, options);
        });
    };

    c3_chart_fn.tooltip = function () {};
    c3_chart_fn.tooltip.show = function (args) {
        var $$ = this.internal,
            index,
            mouse;

        // determine mouse position on the chart
        if (args.mouse) {
            mouse = args.mouse;
        }

        // determine focus data
        if (args.data) {
            if ($$.isMultipleX()) {
                // if multiple xs, target point will be determined by mouse
                mouse = [$$.x(args.data.x), $$.getYScale(args.data.id)(args.data.value)];
                index = null;
            } else {
                // TODO: when tooltip_grouped = false
                index = isValue(args.data.index) ? args.data.index : $$.getIndexByX(args.data.x);
            }
        } else if (typeof args.x !== 'undefined') {
            index = $$.getIndexByX(args.x);
        } else if (typeof args.index !== 'undefined') {
            index = args.index;
        }

        // emulate mouse events to show
        $$.dispatchEvent('mouseover', index, mouse);
        $$.dispatchEvent('mousemove', index, mouse);

        $$.config.tooltip_onshow.call($$, args.data);
    };
    c3_chart_fn.tooltip.hide = function () {
        // TODO: get target data by checking the state of focus
        this.internal.dispatchEvent('mouseout', 0);

        this.internal.config.tooltip_onhide.call(this);
    };

    c3_chart_fn.transform = function (type, targetIds) {
        var $$ = this.internal,
            options = ['pie', 'donut'].indexOf(type) >= 0 ? { withTransform: true } : null;
        $$.transformTo(targetIds, type, options);
    };

    c3_chart_internal_fn.transformTo = function (targetIds, type, optionsForRedraw) {
        var $$ = this,
            withTransitionForAxis = !$$.hasArcType(),
            options = optionsForRedraw || { withTransitionForAxis: withTransitionForAxis };
        options.withTransitionForTransform = false;
        $$.transiting = false;
        $$.setTargetType(targetIds, type);
        $$.updateTargets($$.data.targets); // this is needed when transforming to arc
        $$.updateAndRedraw(options);
    };

    c3_chart_fn.x = function (x) {
        var $$ = this.internal;
        if (arguments.length) {
            $$.updateTargetX($$.data.targets, x);
            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
        }
        return $$.data.xs;
    };
    c3_chart_fn.xs = function (xs) {
        var $$ = this.internal;
        if (arguments.length) {
            $$.updateTargetXs($$.data.targets, xs);
            $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true });
        }
        return $$.data.xs;
    };

    c3_chart_fn.zoom = function (domain) {
        var $$ = this.internal;
        if (domain) {
            if ($$.isTimeSeries()) {
                domain = domain.map(function (x) {
                    return $$.parseDate(x);
                });
            }
            $$.brush.extent(domain);
            $$.redraw({ withUpdateXDomain: true, withY: $$.config.zoom_rescale });
            $$.config.zoom_onzoom.call(this, $$.x.orgDomain());
        }
        return $$.brush.extent();
    };
    c3_chart_fn.zoom.enable = function (enabled) {
        var $$ = this.internal;
        $$.config.zoom_enabled = enabled;
        $$.updateAndRedraw();
    };
    c3_chart_fn.unzoom = function () {
        var $$ = this.internal;
        $$.brush.clear().update();
        $$.redraw({ withUpdateXDomain: true });
    };

    c3_chart_fn.zoom.max = function (max) {
        var $$ = this.internal,
            config = $$.config,
            d3 = $$.d3;
        if (max === 0 || max) {
            config.zoom_x_max = d3.max([$$.orgXDomain[1], max]);
        } else {
            return config.zoom_x_max;
        }
    };

    c3_chart_fn.zoom.min = function (min) {
        var $$ = this.internal,
            config = $$.config,
            d3 = $$.d3;
        if (min === 0 || min) {
            config.zoom_x_min = d3.min([$$.orgXDomain[0], min]);
        } else {
            return config.zoom_x_min;
        }
    };

    c3_chart_fn.zoom.range = function (range) {
        if (arguments.length) {
            if (isDefined(range.max)) {
                this.domain.max(range.max);
            }
            if (isDefined(range.min)) {
                this.domain.min(range.min);
            }
        } else {
            return {
                max: this.domain.max(),
                min: this.domain.min()
            };
        }
    };

    c3_chart_internal_fn.initPie = function () {
        var $$ = this,
            d3 = $$.d3;
        $$.pie = d3.layout.pie().value(function (d) {
            return d.values.reduce(function (a, b) {
                return a + b.value;
            }, 0);
        });
        $$.pie.sort($$.getOrderFunction() || null);
    };

    c3_chart_internal_fn.updateRadius = function () {
        var $$ = this,
            config = $$.config,
            w = config.gauge_width || config.donut_width,
            gaugeArcWidth = $$.filterTargetsToShow($$.data.targets).length * $$.config.gauge_arcs_minWidth;
        $$.radiusExpanded = Math.min($$.arcWidth, $$.arcHeight) / 2 * ($$.hasType('gauge') ? 0.85 : 1);
        $$.radius = $$.radiusExpanded * 0.95;
        $$.innerRadiusRatio = w ? ($$.radius - w) / $$.radius : 0.6;
        $$.innerRadius = $$.hasType('donut') || $$.hasType('gauge') ? $$.radius * $$.innerRadiusRatio : 0;
        $$.gaugeArcWidth = w ? w : gaugeArcWidth <= $$.radius - $$.innerRadius ? $$.radius - $$.innerRadius : gaugeArcWidth <= $$.radius ? gaugeArcWidth : $$.radius;
    };

    c3_chart_internal_fn.updateArc = function () {
        var $$ = this;
        $$.svgArc = $$.getSvgArc();
        $$.svgArcExpanded = $$.getSvgArcExpanded();
        $$.svgArcExpandedSub = $$.getSvgArcExpanded(0.98);
    };

    c3_chart_internal_fn.updateAngle = function (d) {
        var $$ = this,
            config = $$.config,
            found = false,
            index = 0,
            gMin,
            gMax,
            gTic,
            gValue;

        if (!config) {
            return null;
        }

        $$.pie($$.filterTargetsToShow($$.data.targets)).forEach(function (t) {
            if (!found && t.data.id === d.data.id) {
                found = true;
                d = t;
                d.index = index;
            }
            index++;
        });
        if (isNaN(d.startAngle)) {
            d.startAngle = 0;
        }
        if (isNaN(d.endAngle)) {
            d.endAngle = d.startAngle;
        }
        if ($$.isGaugeType(d.data)) {
            gMin = config.gauge_min;
            gMax = config.gauge_max;
            gTic = Math.PI * (config.gauge_fullCircle ? 2 : 1) / (gMax - gMin);
            gValue = d.value < gMin ? 0 : d.value < gMax ? d.value - gMin : gMax - gMin;
            d.startAngle = config.gauge_startingAngle;
            d.endAngle = d.startAngle + gTic * gValue;
        }
        return found ? d : null;
    };

    c3_chart_internal_fn.getSvgArc = function () {
        var $$ = this,
            hasGaugeType = $$.hasType('gauge'),
            singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length,
            arc = $$.d3.svg.arc().outerRadius(function (d) {
            return hasGaugeType ? $$.radius - singleArcWidth * d.index : $$.radius;
        }).innerRadius(function (d) {
            return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
        }),
            newArc = function newArc(d, withoutUpdate) {
            var updated;
            if (withoutUpdate) {
                return arc(d);
            } // for interpolate
            updated = $$.updateAngle(d);
            return updated ? arc(updated) : "M 0 0";
        };
        // TODO: extends all function
        newArc.centroid = arc.centroid;
        return newArc;
    };

    c3_chart_internal_fn.getSvgArcExpanded = function (rate) {
        rate = rate || 1;
        var $$ = this,
            hasGaugeType = $$.hasType('gauge'),
            singleArcWidth = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length,
            expandWidth = Math.min($$.radiusExpanded * rate - $$.radius, singleArcWidth * 0.8 - (1 - rate) * 100),
            arc = $$.d3.svg.arc().outerRadius(function (d) {
            return hasGaugeType ? $$.radius - singleArcWidth * d.index + expandWidth : $$.radiusExpanded * rate;
        }).innerRadius(function (d) {
            return hasGaugeType ? $$.radius - singleArcWidth * (d.index + 1) : $$.innerRadius;
        });
        return function (d) {
            var updated = $$.updateAngle(d);
            return updated ? arc(updated) : "M 0 0";
        };
    };

    c3_chart_internal_fn.getArc = function (d, withoutUpdate, force) {
        return force || this.isArcType(d.data) ? this.svgArc(d, withoutUpdate) : "M 0 0";
    };

    c3_chart_internal_fn.transformForArcLabel = function (d) {
        var $$ = this,
            config = $$.config,
            updated = $$.updateAngle(d),
            c,
            x,
            y,
            h,
            ratio,
            translate = "",
            hasGauge = $$.hasType('gauge');
        if (updated && !hasGauge) {
            c = this.svgArc.centroid(updated);
            x = isNaN(c[0]) ? 0 : c[0];
            y = isNaN(c[1]) ? 0 : c[1];
            h = Math.sqrt(x * x + y * y);
            if ($$.hasType('donut') && config.donut_label_ratio) {
                ratio = isFunction(config.donut_label_ratio) ? config.donut_label_ratio(d, $$.radius, h) : config.donut_label_ratio;
            } else if ($$.hasType('pie') && config.pie_label_ratio) {
                ratio = isFunction(config.pie_label_ratio) ? config.pie_label_ratio(d, $$.radius, h) : config.pie_label_ratio;
            } else {
                ratio = $$.radius && h ? (36 / $$.radius > 0.375 ? 1.175 - 36 / $$.radius : 0.8) * $$.radius / h : 0;
            }
            translate = "translate(" + x * ratio + ',' + y * ratio + ")";
        } else if (updated && hasGauge && $$.filterTargetsToShow($$.data.targets).length > 1) {
            var y1 = Math.sin(updated.endAngle - Math.PI / 2);
            x = Math.cos(updated.endAngle - Math.PI / 2) * ($$.radiusExpanded + 25);
            y = y1 * ($$.radiusExpanded + 15 - Math.abs(y1 * 10)) + 3;
            translate = "translate(" + x + ',' + y + ")";
        }
        return translate;
    };

    c3_chart_internal_fn.getArcRatio = function (d) {
        var $$ = this,
            config = $$.config,
            whole = Math.PI * ($$.hasType('gauge') && !config.gauge_fullCircle ? 1 : 2);
        return d ? (d.endAngle - d.startAngle) / whole : null;
    };

    c3_chart_internal_fn.convertToArcData = function (d) {
        return this.addName({
            id: d.data.id,
            value: d.value,
            ratio: this.getArcRatio(d),
            index: d.index
        });
    };

    c3_chart_internal_fn.textForArcLabel = function (d) {
        var $$ = this,
            updated,
            value,
            ratio,
            id,
            format;
        if (!$$.shouldShowArcLabel()) {
            return "";
        }
        updated = $$.updateAngle(d);
        value = updated ? updated.value : null;
        ratio = $$.getArcRatio(updated);
        id = d.data.id;
        if (!$$.hasType('gauge') && !$$.meetsArcLabelThreshold(ratio)) {
            return "";
        }
        format = $$.getArcLabelFormat();
        return format ? format(value, ratio, id) : $$.defaultArcValueFormat(value, ratio);
    };

    c3_chart_internal_fn.textForGaugeMinMax = function (value, isMax) {
        var $$ = this,
            format = $$.getGaugeLabelExtents();

        return format ? format(value, isMax) : value;
    };

    c3_chart_internal_fn.expandArc = function (targetIds) {
        var $$ = this,
            interval;

        // MEMO: avoid to cancel transition
        if ($$.transiting) {
            interval = window.setInterval(function () {
                if (!$$.transiting) {
                    window.clearInterval(interval);
                    if ($$.legend.selectAll('.c3-legend-item-focused').size() > 0) {
                        $$.expandArc(targetIds);
                    }
                }
            }, 10);
            return;
        }

        targetIds = $$.mapToTargetIds(targetIds);

        $$.svg.selectAll($$.selectorTargets(targetIds, '.' + CLASS.chartArc)).each(function (d) {
            if (!$$.shouldExpand(d.data.id)) {
                return;
            }
            $$.d3.select(this).selectAll('path').transition().duration($$.expandDuration(d.data.id)).attr("d", $$.svgArcExpanded).transition().duration($$.expandDuration(d.data.id) * 2).attr("d", $$.svgArcExpandedSub).each(function (d) {
                if ($$.isDonutType(d.data)) ;
            });
        });
    };

    c3_chart_internal_fn.unexpandArc = function (targetIds) {
        var $$ = this;

        if ($$.transiting) {
            return;
        }

        targetIds = $$.mapToTargetIds(targetIds);

        $$.svg.selectAll($$.selectorTargets(targetIds, '.' + CLASS.chartArc)).selectAll('path').transition().duration(function (d) {
            return $$.expandDuration(d.data.id);
        }).attr("d", $$.svgArc);
        $$.svg.selectAll('.' + CLASS.arc);
    };

    c3_chart_internal_fn.expandDuration = function (id) {
        var $$ = this,
            config = $$.config;

        if ($$.isDonutType(id)) {
            return config.donut_expand_duration;
        } else if ($$.isGaugeType(id)) {
            return config.gauge_expand_duration;
        } else if ($$.isPieType(id)) {
            return config.pie_expand_duration;
        } else {
            return 50;
        }
    };

    c3_chart_internal_fn.shouldExpand = function (id) {
        var $$ = this,
            config = $$.config;
        return $$.isDonutType(id) && config.donut_expand || $$.isGaugeType(id) && config.gauge_expand || $$.isPieType(id) && config.pie_expand;
    };

    c3_chart_internal_fn.shouldShowArcLabel = function () {
        var $$ = this,
            config = $$.config,
            shouldShow = true;
        if ($$.hasType('donut')) {
            shouldShow = config.donut_label_show;
        } else if ($$.hasType('pie')) {
            shouldShow = config.pie_label_show;
        }
        // when gauge, always true
        return shouldShow;
    };

    c3_chart_internal_fn.meetsArcLabelThreshold = function (ratio) {
        var $$ = this,
            config = $$.config,
            threshold = $$.hasType('donut') ? config.donut_label_threshold : config.pie_label_threshold;
        return ratio >= threshold;
    };

    c3_chart_internal_fn.getArcLabelFormat = function () {
        var $$ = this,
            config = $$.config,
            format = config.pie_label_format;
        if ($$.hasType('gauge')) {
            format = config.gauge_label_format;
        } else if ($$.hasType('donut')) {
            format = config.donut_label_format;
        }
        return format;
    };

    c3_chart_internal_fn.getGaugeLabelExtents = function () {
        var $$ = this,
            config = $$.config;
        return config.gauge_label_extents;
    };

    c3_chart_internal_fn.getArcTitle = function () {
        var $$ = this;
        return $$.hasType('donut') ? $$.config.donut_title : "";
    };

    c3_chart_internal_fn.updateTargetsForArc = function (targets) {
        var $$ = this,
            main = $$.main,
            mainPieUpdate,
            mainPieEnter,
            classChartArc = $$.classChartArc.bind($$),
            classArcs = $$.classArcs.bind($$),
            classFocus = $$.classFocus.bind($$);
        mainPieUpdate = main.select('.' + CLASS.chartArcs).selectAll('.' + CLASS.chartArc).data($$.pie(targets)).attr("class", function (d) {
            return classChartArc(d) + classFocus(d.data);
        });
        mainPieEnter = mainPieUpdate.enter().append("g").attr("class", classChartArc);
        mainPieEnter.append('g').attr('class', classArcs);
        mainPieEnter.append("text").attr("dy", $$.hasType('gauge') ? "-.1em" : ".35em").style("opacity", 0).style("text-anchor", "middle").style("pointer-events", "none");
        // MEMO: can not keep same color..., but not bad to update color in redraw
        //mainPieUpdate.exit().remove();
    };

    c3_chart_internal_fn.initArc = function () {
        var $$ = this;
        $$.arcs = $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartArcs).attr("transform", $$.getTranslate('arc'));
        $$.arcs.append('text').attr('class', CLASS.chartArcsTitle).style("text-anchor", "middle").text($$.getArcTitle());
    };

    c3_chart_internal_fn.redrawArc = function (duration, durationForExit, withTransform) {
        var $$ = this,
            d3 = $$.d3,
            config = $$.config,
            main = $$.main,
            mainArc,
            backgroundArc,
            mainArcLabelLine,
            hasGaugeType = $$.hasType('gauge');
        mainArc = main.selectAll('.' + CLASS.arcs).selectAll('.' + CLASS.arc).data($$.arcData.bind($$));
        mainArc.enter().append('path').attr("class", $$.classArc.bind($$)).style("fill", function (d) {
            return $$.color(d.data);
        }).style("cursor", function (d) {
            return config.interaction_enabled && config.data_selection_isselectable(d) ? "pointer" : null;
        }).each(function (d) {
            if ($$.isGaugeType(d.data)) {
                d.startAngle = d.endAngle = config.gauge_startingAngle;
            }
            this._current = d;
        });
        if (hasGaugeType) {
            mainArcLabelLine = main.selectAll('.' + CLASS.arcs).selectAll('.' + CLASS.arcLabelLine).data($$.arcData.bind($$));
            mainArcLabelLine.enter().append('rect').attr("class", function (d) {
                return CLASS.arcLabelLine + ' ' + CLASS.target + ' ' + CLASS.target + '-' + d.data.id;
            });
            if ($$.filterTargetsToShow($$.data.targets).length === 1) {
                mainArcLabelLine.style("display", "none");
            } else {
                mainArcLabelLine.style("fill", function (d) {
                    return config.color_pattern.length > 0 ? $$.levelColor(d.data.values[0].value) : $$.color(d.data);
                }).style("display", config.gauge_labelLine_show ? "" : "none").each(function (d) {
                    var lineLength = 0,
                        lineThickness = 2,
                        x = 0,
                        y = 0,
                        transform = "";
                    if ($$.hiddenTargetIds.indexOf(d.data.id) < 0) {
                        var updated = $$.updateAngle(d),
                            innerLineLength = $$.gaugeArcWidth / $$.filterTargetsToShow($$.data.targets).length * (updated.index + 1),
                            lineAngle = updated.endAngle - Math.PI / 2,
                            arcInnerRadius = $$.radius - innerLineLength,
                            linePositioningAngle = lineAngle - (arcInnerRadius === 0 ? 0 : 1 / arcInnerRadius);
                        lineLength = $$.radiusExpanded - $$.radius + innerLineLength;
                        x = Math.cos(linePositioningAngle) * arcInnerRadius;
                        y = Math.sin(linePositioningAngle) * arcInnerRadius;
                        transform = "rotate(" + lineAngle * 180 / Math.PI + ", " + x + ", " + y + ")";
                    }
                    d3.select(this).attr({ x: x, y: y, width: lineLength, height: lineThickness, transform: transform }).style("stroke-dasharray", "0, " + (lineLength + lineThickness) + ", 0");
                });
            }
        }
        mainArc.attr("transform", function (d) {
            return !$$.isGaugeType(d.data) && withTransform ? "scale(0)" : "";
        }).on('mouseover', config.interaction_enabled ? function (d) {
            var updated, arcData;
            if ($$.transiting) {
                // skip while transiting
                return;
            }
            updated = $$.updateAngle(d);
            if (updated) {
                arcData = $$.convertToArcData(updated);
                // transitions
                $$.expandArc(updated.data.id);
                $$.api.focus(updated.data.id);
                $$.toggleFocusLegend(updated.data.id, true);
                $$.config.data_onmouseover(arcData, this);
            }
        } : null).on('mousemove', config.interaction_enabled ? function (d) {
            var updated = $$.updateAngle(d),
                arcData,
                selectedData;
            if (updated) {
                arcData = $$.convertToArcData(updated), selectedData = [arcData];
                $$.showTooltip(selectedData, this);
            }
        } : null).on('mouseout', config.interaction_enabled ? function (d) {
            var updated, arcData;
            if ($$.transiting) {
                // skip while transiting
                return;
            }
            updated = $$.updateAngle(d);
            if (updated) {
                arcData = $$.convertToArcData(updated);
                // transitions
                $$.unexpandArc(updated.data.id);
                $$.api.revert();
                $$.revertLegend();
                $$.hideTooltip();
                $$.config.data_onmouseout(arcData, this);
            }
        } : null).on('click', config.interaction_enabled ? function (d, i) {
            var updated = $$.updateAngle(d),
                arcData;
            if (updated) {
                arcData = $$.convertToArcData(updated);
                if ($$.toggleShape) {
                    $$.toggleShape(this, arcData, i);
                }
                $$.config.data_onclick.call($$.api, arcData, this);
            }
        } : null).each(function () {
            $$.transiting = true;
        }).transition().duration(duration).attrTween("d", function (d) {
            var updated = $$.updateAngle(d),
                interpolate;
            if (!updated) {
                return function () {
                    return "M 0 0";
                };
            }
            //                if (this._current === d) {
            //                    this._current = {
            //                        startAngle: Math.PI*2,
            //                        endAngle: Math.PI*2,
            //                    };
            //                }
            if (isNaN(this._current.startAngle)) {
                this._current.startAngle = 0;
            }
            if (isNaN(this._current.endAngle)) {
                this._current.endAngle = this._current.startAngle;
            }
            interpolate = d3.interpolate(this._current, updated);
            this._current = interpolate(0);
            return function (t) {
                var interpolated = interpolate(t);
                interpolated.data = d.data; // data.id will be updated by interporator
                return $$.getArc(interpolated, true);
            };
        }).attr("transform", withTransform ? "scale(1)" : "").style("fill", function (d) {
            return $$.levelColor ? $$.levelColor(d.data.values[0].value) : $$.color(d.data.id);
        }) // Where gauge reading color would receive customization.
        .call($$.endall, function () {
            $$.transiting = false;
        });
        mainArc.exit().transition().duration(durationForExit).style('opacity', 0).remove();
        main.selectAll('.' + CLASS.chartArc).select('text').style("opacity", 0).attr('class', function (d) {
            return $$.isGaugeType(d.data) ? CLASS.gaugeValue : '';
        }).text($$.textForArcLabel.bind($$)).attr("transform", $$.transformForArcLabel.bind($$)).style('font-size', function (d) {
            return $$.isGaugeType(d.data) && $$.filterTargetsToShow($$.data.targets).length === 1 ? Math.round($$.radius / 5) + 'px' : '';
        }).transition().duration(duration).style("opacity", function (d) {
            return $$.isTargetToShow(d.data.id) && $$.isArcType(d.data) ? 1 : 0;
        });
        main.select('.' + CLASS.chartArcsTitle).style("opacity", $$.hasType('donut') || hasGaugeType ? 1 : 0);

        if (hasGaugeType) {
            var index = 0;
            backgroundArc = $$.arcs.select('g.' + CLASS.chartArcsBackground).selectAll('path.' + CLASS.chartArcsBackground).data($$.data.targets);
            backgroundArc.enter().append("path");
            backgroundArc.attr("class", function (d, i) {
                return CLASS.chartArcsBackground + ' ' + CLASS.chartArcsBackground + '-' + i;
            }).attr("d", function (d1) {
                if ($$.hiddenTargetIds.indexOf(d1.id) >= 0) {
                    return "M 0 0";
                }

                var d = {
                    data: [{ value: config.gauge_max }],
                    startAngle: config.gauge_startingAngle,
                    endAngle: -1 * config.gauge_startingAngle * (config.gauge_fullCircle ? Math.PI : 1),
                    index: index++
                };
                return $$.getArc(d, true, true);
            });
            backgroundArc.exit().remove();

            $$.arcs.select('.' + CLASS.chartArcsGaugeUnit).attr("dy", ".75em").text(config.gauge_label_show ? config.gauge_units : '');
            $$.arcs.select('.' + CLASS.chartArcsGaugeMin).attr("dx", -1 * ($$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2)) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_min, false) : '');
            $$.arcs.select('.' + CLASS.chartArcsGaugeMax).attr("dx", $$.innerRadius + ($$.radius - $$.innerRadius) / (config.gauge_fullCircle ? 1 : 2) + "px").attr("dy", "1.2em").text(config.gauge_label_show ? $$.textForGaugeMinMax(config.gauge_max, true) : '');
        }
    };
    c3_chart_internal_fn.initGauge = function () {
        var arcs = this.arcs;
        if (this.hasType('gauge')) {
            arcs.append('g').attr("class", CLASS.chartArcsBackground);
            arcs.append("text").attr("class", CLASS.chartArcsGaugeUnit).style("text-anchor", "middle").style("pointer-events", "none");
            arcs.append("text").attr("class", CLASS.chartArcsGaugeMin).style("text-anchor", "middle").style("pointer-events", "none");
            arcs.append("text").attr("class", CLASS.chartArcsGaugeMax).style("text-anchor", "middle").style("pointer-events", "none");
        }
    };
    c3_chart_internal_fn.getGaugeLabelHeight = function () {
        return this.config.gauge_label_show ? 20 : 0;
    };

    c3_chart_internal_fn.hasCaches = function (ids) {
        for (var i = 0; i < ids.length; i++) {
            if (!(ids[i] in this.cache)) {
                return false;
            }
        }
        return true;
    };
    c3_chart_internal_fn.addCache = function (id, target) {
        this.cache[id] = this.cloneTarget(target);
    };
    c3_chart_internal_fn.getCaches = function (ids) {
        var targets = [],
            i;
        for (i = 0; i < ids.length; i++) {
            if (ids[i] in this.cache) {
                targets.push(this.cloneTarget(this.cache[ids[i]]));
            }
        }
        return targets;
    };

    c3_chart_internal_fn.categoryName = function (i) {
        var config = this.config;
        return i < config.axis_x_categories.length ? config.axis_x_categories[i] : i;
    };

    c3_chart_internal_fn.generateClass = function (prefix, targetId) {
        return " " + prefix + " " + prefix + this.getTargetSelectorSuffix(targetId);
    };
    c3_chart_internal_fn.classText = function (d) {
        return this.generateClass(CLASS.text, d.index);
    };
    c3_chart_internal_fn.classTexts = function (d) {
        return this.generateClass(CLASS.texts, d.id);
    };
    c3_chart_internal_fn.classShape = function (d) {
        return this.generateClass(CLASS.shape, d.index);
    };
    c3_chart_internal_fn.classShapes = function (d) {
        return this.generateClass(CLASS.shapes, d.id);
    };
    c3_chart_internal_fn.classLine = function (d) {
        return this.classShape(d) + this.generateClass(CLASS.line, d.id);
    };
    c3_chart_internal_fn.classLines = function (d) {
        return this.classShapes(d) + this.generateClass(CLASS.lines, d.id);
    };
    c3_chart_internal_fn.classCircle = function (d) {
        return this.classShape(d) + this.generateClass(CLASS.circle, d.index);
    };
    c3_chart_internal_fn.classCircles = function (d) {
        return this.classShapes(d) + this.generateClass(CLASS.circles, d.id);
    };
    c3_chart_internal_fn.classBar = function (d) {
        return this.classShape(d) + this.generateClass(CLASS.bar, d.index);
    };
    c3_chart_internal_fn.classBars = function (d) {
        return this.classShapes(d) + this.generateClass(CLASS.bars, d.id);
    };
    c3_chart_internal_fn.classArc = function (d) {
        return this.classShape(d.data) + this.generateClass(CLASS.arc, d.data.id);
    };
    c3_chart_internal_fn.classArcs = function (d) {
        return this.classShapes(d.data) + this.generateClass(CLASS.arcs, d.data.id);
    };
    c3_chart_internal_fn.classArea = function (d) {
        return this.classShape(d) + this.generateClass(CLASS.area, d.id);
    };
    c3_chart_internal_fn.classAreas = function (d) {
        return this.classShapes(d) + this.generateClass(CLASS.areas, d.id);
    };
    c3_chart_internal_fn.classRegion = function (d, i) {
        return this.generateClass(CLASS.region, i) + ' ' + ('class' in d ? d['class'] : '');
    };
    c3_chart_internal_fn.classEvent = function (d) {
        return this.generateClass(CLASS.eventRect, d.index);
    };
    c3_chart_internal_fn.classTarget = function (id) {
        var $$ = this;
        var additionalClassSuffix = $$.config.data_classes[id],
            additionalClass = '';
        if (additionalClassSuffix) {
            additionalClass = ' ' + CLASS.target + '-' + additionalClassSuffix;
        }
        return $$.generateClass(CLASS.target, id) + additionalClass;
    };
    c3_chart_internal_fn.classFocus = function (d) {
        return this.classFocused(d) + this.classDefocused(d);
    };
    c3_chart_internal_fn.classFocused = function (d) {
        return ' ' + (this.focusedTargetIds.indexOf(d.id) >= 0 ? CLASS.focused : '');
    };
    c3_chart_internal_fn.classDefocused = function (d) {
        return ' ' + (this.defocusedTargetIds.indexOf(d.id) >= 0 ? CLASS.defocused : '');
    };
    c3_chart_internal_fn.classChartText = function (d) {
        return CLASS.chartText + this.classTarget(d.id);
    };
    c3_chart_internal_fn.classChartLine = function (d) {
        return CLASS.chartLine + this.classTarget(d.id);
    };
    c3_chart_internal_fn.classChartBar = function (d) {
        return CLASS.chartBar + this.classTarget(d.id);
    };
    c3_chart_internal_fn.classChartArc = function (d) {
        return CLASS.chartArc + this.classTarget(d.data.id);
    };
    c3_chart_internal_fn.getTargetSelectorSuffix = function (targetId) {
        return targetId || targetId === 0 ? ('-' + targetId).replace(/[\s?!@#$%^&*()_=+,.<>'":;\[\]\/|~`{}\\]/g, '-') : '';
    };
    c3_chart_internal_fn.selectorTarget = function (id, prefix) {
        return (prefix || '') + '.' + CLASS.target + this.getTargetSelectorSuffix(id);
    };
    c3_chart_internal_fn.selectorTargets = function (ids, prefix) {
        var $$ = this;
        ids = ids || [];
        return ids.length ? ids.map(function (id) {
            return $$.selectorTarget(id, prefix);
        }) : null;
    };
    c3_chart_internal_fn.selectorLegend = function (id) {
        return '.' + CLASS.legendItem + this.getTargetSelectorSuffix(id);
    };
    c3_chart_internal_fn.selectorLegends = function (ids) {
        var $$ = this;
        return ids && ids.length ? ids.map(function (id) {
            return $$.selectorLegend(id);
        }) : null;
    };

    c3_chart_internal_fn.getClipPath = function (id) {
        var isIE9 = window.navigator.appVersion.toLowerCase().indexOf("msie 9.") >= 0;
        return "url(" + (isIE9 ? "" : document.URL.split('#')[0]) + "#" + id + ")";
    };
    c3_chart_internal_fn.appendClip = function (parent, id) {
        return parent.append("clipPath").attr("id", id).append("rect");
    };
    c3_chart_internal_fn.getAxisClipX = function (forHorizontal) {
        // axis line width + padding for left
        var left = Math.max(30, this.margin.left);
        return forHorizontal ? -(1 + left) : -(left - 1);
    };
    c3_chart_internal_fn.getAxisClipY = function (forHorizontal) {
        return forHorizontal ? -20 : -this.margin.top;
    };
    c3_chart_internal_fn.getXAxisClipX = function () {
        var $$ = this;
        return $$.getAxisClipX(!$$.config.axis_rotated);
    };
    c3_chart_internal_fn.getXAxisClipY = function () {
        var $$ = this;
        return $$.getAxisClipY(!$$.config.axis_rotated);
    };
    c3_chart_internal_fn.getYAxisClipX = function () {
        var $$ = this;
        return $$.config.axis_y_inner ? -1 : $$.getAxisClipX($$.config.axis_rotated);
    };
    c3_chart_internal_fn.getYAxisClipY = function () {
        var $$ = this;
        return $$.getAxisClipY($$.config.axis_rotated);
    };
    c3_chart_internal_fn.getAxisClipWidth = function (forHorizontal) {
        var $$ = this,
            left = Math.max(30, $$.margin.left),
            right = Math.max(30, $$.margin.right);
        // width + axis line width + padding for left/right
        return forHorizontal ? $$.width + 2 + left + right : $$.margin.left + 20;
    };
    c3_chart_internal_fn.getAxisClipHeight = function (forHorizontal) {
        // less than 20 is not enough to show the axis label 'outer' without legend
        return (forHorizontal ? this.margin.bottom : this.margin.top + this.height) + 20;
    };
    c3_chart_internal_fn.getXAxisClipWidth = function () {
        var $$ = this;
        return $$.getAxisClipWidth(!$$.config.axis_rotated);
    };
    c3_chart_internal_fn.getXAxisClipHeight = function () {
        var $$ = this;
        return $$.getAxisClipHeight(!$$.config.axis_rotated);
    };
    c3_chart_internal_fn.getYAxisClipWidth = function () {
        var $$ = this;
        return $$.getAxisClipWidth($$.config.axis_rotated) + ($$.config.axis_y_inner ? 20 : 0);
    };
    c3_chart_internal_fn.getYAxisClipHeight = function () {
        var $$ = this;
        return $$.getAxisClipHeight($$.config.axis_rotated);
    };

    c3_chart_internal_fn.generateColor = function () {
        var $$ = this,
            config = $$.config,
            d3 = $$.d3,
            colors = config.data_colors,
            pattern = notEmpty(config.color_pattern) ? config.color_pattern : d3.scale.category10().range(),
            callback = config.data_color,
            ids = [];

        return function (d) {
            var id = d.id || d.data && d.data.id || d,
                color;

            // if callback function is provided
            if (colors[id] instanceof Function) {
                color = colors[id](d);
            }
            // if specified, choose that color
            else if (colors[id]) {
                    color = colors[id];
                }
                // if not specified, choose from pattern
                else {
                        if (ids.indexOf(id) < 0) {
                            ids.push(id);
                        }
                        color = pattern[ids.indexOf(id) % pattern.length];
                        colors[id] = color;
                    }
            return callback instanceof Function ? callback(color, d) : color;
        };
    };
    c3_chart_internal_fn.generateLevelColor = function () {
        var $$ = this,
            config = $$.config,
            colors = config.color_pattern,
            threshold = config.color_threshold,
            asValue = threshold.unit === 'value',
            values = threshold.values && threshold.values.length ? threshold.values : [],
            max = threshold.max || 100;
        return notEmpty(config.color_threshold) ? function (value) {
            var i,
                v,
                color = colors[colors.length - 1];
            for (i = 0; i < values.length; i++) {
                v = asValue ? value : value * 100 / max;
                if (v < values[i]) {
                    color = colors[i];
                    break;
                }
            }
            return color;
        } : null;
    };

    c3_chart_internal_fn.getDefaultConfig = function () {
        var config = {
            bindto: '#chart',
            svg_classname: undefined,
            size_width: undefined,
            size_height: undefined,
            padding_left: undefined,
            padding_right: undefined,
            padding_top: undefined,
            padding_bottom: undefined,
            resize_auto: true,
            zoom_enabled: false,
            zoom_extent: undefined,
            zoom_privileged: false,
            zoom_rescale: false,
            zoom_onzoom: function zoom_onzoom() {},
            zoom_onzoomstart: function zoom_onzoomstart() {},
            zoom_onzoomend: function zoom_onzoomend() {},
            zoom_x_min: undefined,
            zoom_x_max: undefined,
            interaction_brighten: true,
            interaction_enabled: true,
            onmouseover: function onmouseover() {},
            onmouseout: function onmouseout() {},
            onresize: function onresize() {},
            onresized: function onresized() {},
            oninit: function oninit() {},
            onrendered: function onrendered() {},
            transition_duration: 350,
            data_x: undefined,
            data_xs: {},
            data_xFormat: '%Y-%m-%d',
            data_xLocaltime: true,
            data_xSort: true,
            data_idConverter: function data_idConverter(id) {
                return id;
            },
            data_names: {},
            data_classes: {},
            data_groups: [],
            data_axes: {},
            data_type: undefined,
            data_types: {},
            data_labels: {},
            data_order: 'desc',
            data_regions: {},
            data_color: undefined,
            data_colors: {},
            data_hide: false,
            data_filter: undefined,
            data_selection_enabled: false,
            data_selection_grouped: false,
            data_selection_isselectable: function data_selection_isselectable() {
                return true;
            },
            data_selection_multiple: true,
            data_selection_draggable: false,
            data_onclick: function data_onclick() {},
            data_onmouseover: function data_onmouseover() {},
            data_onmouseout: function data_onmouseout() {},
            data_onselected: function data_onselected() {},
            data_onunselected: function data_onunselected() {},
            data_url: undefined,
            data_headers: undefined,
            data_json: undefined,
            data_rows: undefined,
            data_columns: undefined,
            data_mimeType: undefined,
            data_keys: undefined,
            // configuration for no plot-able data supplied.
            data_empty_label_text: "",
            // subchart
            subchart_show: false,
            subchart_size_height: 60,
            subchart_axis_x_show: true,
            subchart_onbrush: function subchart_onbrush() {},
            // color
            color_pattern: [],
            color_threshold: {},
            // legend
            legend_show: true,
            legend_hide: false,
            legend_position: 'bottom',
            legend_inset_anchor: 'top-left',
            legend_inset_x: 10,
            legend_inset_y: 0,
            legend_inset_step: undefined,
            legend_item_onclick: undefined,
            legend_item_onmouseover: undefined,
            legend_item_onmouseout: undefined,
            legend_equally: false,
            legend_padding: 0,
            legend_item_tile_width: 10,
            legend_item_tile_height: 10,
            // axis
            axis_rotated: false,
            axis_x_show: true,
            axis_x_type: 'indexed',
            axis_x_localtime: true,
            axis_x_categories: [],
            axis_x_tick_centered: false,
            axis_x_tick_format: undefined,
            axis_x_tick_culling: {},
            axis_x_tick_culling_max: 10,
            axis_x_tick_count: undefined,
            axis_x_tick_fit: true,
            axis_x_tick_values: null,
            axis_x_tick_rotate: 0,
            axis_x_tick_outer: true,
            axis_x_tick_multiline: true,
            axis_x_tick_multilineMax: 0,
            axis_x_tick_width: null,
            axis_x_max: undefined,
            axis_x_min: undefined,
            axis_x_padding: {},
            axis_x_height: undefined,
            axis_x_extent: undefined,
            axis_x_label: {},
            axis_x_inner: undefined,
            axis_y_show: true,
            axis_y_type: undefined,
            axis_y_max: undefined,
            axis_y_min: undefined,
            axis_y_inverted: false,
            axis_y_center: undefined,
            axis_y_inner: undefined,
            axis_y_label: {},
            axis_y_tick_format: undefined,
            axis_y_tick_outer: true,
            axis_y_tick_values: null,
            axis_y_tick_rotate: 0,
            axis_y_tick_count: undefined,
            axis_y_tick_time_value: undefined,
            axis_y_tick_time_interval: undefined,
            axis_y_padding: {},
            axis_y_default: undefined,
            axis_y2_show: false,
            axis_y2_max: undefined,
            axis_y2_min: undefined,
            axis_y2_inverted: false,
            axis_y2_center: undefined,
            axis_y2_inner: undefined,
            axis_y2_label: {},
            axis_y2_tick_format: undefined,
            axis_y2_tick_outer: true,
            axis_y2_tick_values: null,
            axis_y2_tick_count: undefined,
            axis_y2_padding: {},
            axis_y2_default: undefined,
            // grid
            grid_x_show: false,
            grid_x_type: 'tick',
            grid_x_lines: [],
            grid_y_show: false,
            // not used
            // grid_y_type: 'tick',
            grid_y_lines: [],
            grid_y_ticks: 10,
            grid_focus_show: true,
            grid_lines_front: true,
            // point - point of each data
            point_show: true,
            point_r: 2.5,
            point_sensitivity: 10,
            point_focus_expand_enabled: true,
            point_focus_expand_r: undefined,
            point_select_r: undefined,
            // line
            line_connectNull: false,
            line_step_type: 'step',
            // bar
            bar_width: undefined,
            bar_width_ratio: 0.6,
            bar_width_max: undefined,
            bar_zerobased: true,
            bar_space: 0,
            // area
            area_zerobased: true,
            area_above: false,
            // pie
            pie_label_show: true,
            pie_label_format: undefined,
            pie_label_threshold: 0.05,
            pie_label_ratio: undefined,
            pie_expand: {},
            pie_expand_duration: 50,
            // gauge
            gauge_fullCircle: false,
            gauge_label_show: true,
            gauge_labelLine_show: true,
            gauge_label_format: undefined,
            gauge_min: 0,
            gauge_max: 100,
            gauge_startingAngle: -1 * Math.PI / 2,
            gauge_label_extents: undefined,
            gauge_units: undefined,
            gauge_width: undefined,
            gauge_arcs_minWidth: 5,
            gauge_expand: {},
            gauge_expand_duration: 50,
            // donut
            donut_label_show: true,
            donut_label_format: undefined,
            donut_label_threshold: 0.05,
            donut_label_ratio: undefined,
            donut_width: undefined,
            donut_title: "",
            donut_expand: {},
            donut_expand_duration: 50,
            // spline
            spline_interpolation_type: 'cardinal',
            // region - region to change style
            regions: [],
            // tooltip - show when mouseover on each data
            tooltip_show: true,
            tooltip_grouped: true,
            tooltip_order: undefined,
            tooltip_format_title: undefined,
            tooltip_format_name: undefined,
            tooltip_format_value: undefined,
            tooltip_position: undefined,
            tooltip_contents: function tooltip_contents(d, defaultTitleFormat, defaultValueFormat, color) {
                return this.getTooltipContent ? this.getTooltipContent(d, defaultTitleFormat, defaultValueFormat, color) : '';
            },
            tooltip_init_show: false,
            tooltip_init_x: 0,
            tooltip_init_position: { top: '0px', left: '50px' },
            tooltip_onshow: function tooltip_onshow() {},
            tooltip_onhide: function tooltip_onhide() {},
            // title
            title_text: undefined,
            title_padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            title_position: 'top-center'
        };

        Object.keys(this.additionalConfig).forEach(function (key) {
            config[key] = this.additionalConfig[key];
        }, this);

        return config;
    };
    c3_chart_internal_fn.additionalConfig = {};

    c3_chart_internal_fn.loadConfig = function (config) {
        var this_config = this.config,
            target,
            keys,
            read;
        function find() {
            var key = keys.shift();
            //        console.log("key =>", key, ", target =>", target);
            if (key && target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && key in target) {
                target = target[key];
                return find();
            } else if (!key) {
                return target;
            } else {
                return undefined;
            }
        }
        Object.keys(this_config).forEach(function (key) {
            target = config;
            keys = key.split('_');
            read = find();
            //        console.log("CONFIG : ", key, read);
            if (isDefined(read)) {
                this_config[key] = read;
            }
        });
    };

    c3_chart_internal_fn.convertUrlToData = function (url, mimeType, headers, keys, done) {
        var $$ = this,
            type = mimeType ? mimeType : 'csv';
        var req = $$.d3.xhr(url);
        if (headers) {
            Object.keys(headers).forEach(function (header) {
                req.header(header, headers[header]);
            });
        }
        req.get(function (error, data) {
            var d;
            var dataResponse = data.response || data.responseText; // Fixes IE9 XHR issue; see #1345
            if (!data) {
                throw new Error(error.responseURL + ' ' + error.status + ' (' + error.statusText + ')');
            }
            if (type === 'json') {
                d = $$.convertJsonToData(JSON.parse(dataResponse), keys);
            } else if (type === 'tsv') {
                d = $$.convertTsvToData(dataResponse);
            } else {
                d = $$.convertCsvToData(dataResponse);
            }
            done.call($$, d);
        });
    };
    c3_chart_internal_fn.convertXsvToData = function (xsv, parser) {
        var rows = parser.parseRows(xsv),
            d;
        if (rows.length === 1) {
            d = [{}];
            rows[0].forEach(function (id) {
                d[0][id] = null;
            });
        } else {
            d = parser.parse(xsv);
        }
        return d;
    };
    c3_chart_internal_fn.convertCsvToData = function (csv) {
        return this.convertXsvToData(csv, this.d3.csv);
    };
    c3_chart_internal_fn.convertTsvToData = function (tsv) {
        return this.convertXsvToData(tsv, this.d3.tsv);
    };
    c3_chart_internal_fn.convertJsonToData = function (json, keys) {
        var $$ = this,
            new_rows = [],
            targetKeys,
            data;
        if (keys) {
            // when keys specified, json would be an array that includes objects
            if (keys.x) {
                targetKeys = keys.value.concat(keys.x);
                $$.config.data_x = keys.x;
            } else {
                targetKeys = keys.value;
            }
            new_rows.push(targetKeys);
            json.forEach(function (o) {
                var new_row = [];
                targetKeys.forEach(function (key) {
                    // convert undefined to null because undefined data will be removed in convertDataToTargets()
                    var v = $$.findValueInJson(o, key);
                    if (isUndefined(v)) {
                        v = null;
                    }
                    new_row.push(v);
                });
                new_rows.push(new_row);
            });
            data = $$.convertRowsToData(new_rows);
        } else {
            Object.keys(json).forEach(function (key) {
                new_rows.push([key].concat(json[key]));
            });
            data = $$.convertColumnsToData(new_rows);
        }
        return data;
    };
    c3_chart_internal_fn.findValueInJson = function (object, path) {
        path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties (replace [] with .)
        path = path.replace(/^\./, ''); // strip a leading dot
        var pathArray = path.split('.');
        for (var i = 0; i < pathArray.length; ++i) {
            var k = pathArray[i];
            if (k in object) {
                object = object[k];
            } else {
                return;
            }
        }
        return object;
    };

    /**
     * Converts the rows to normalized data.
     * @param {any[][]} rows The row data
     * @return {Object[]}
     */
    c3_chart_internal_fn.convertRowsToData = function (rows) {
        var newRows = [];
        var keys = rows[0];

        for (var i = 1; i < rows.length; i++) {
            var newRow = {};
            for (var j = 0; j < rows[i].length; j++) {
                if (isUndefined(rows[i][j])) {
                    throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
                }
                newRow[keys[j]] = rows[i][j];
            }
            newRows.push(newRow);
        }
        return newRows;
    };

    /**
     * Converts the columns to normalized data.
     * @param {any[][]} columns The column data
     * @return {Object[]}
     */
    c3_chart_internal_fn.convertColumnsToData = function (columns) {
        var newRows = [];

        for (var i = 0; i < columns.length; i++) {
            var key = columns[i][0];
            for (var j = 1; j < columns[i].length; j++) {
                if (isUndefined(newRows[j - 1])) {
                    newRows[j - 1] = {};
                }
                if (isUndefined(columns[i][j])) {
                    throw new Error("Source data is missing a component at (" + i + "," + j + ")!");
                }
                newRows[j - 1][key] = columns[i][j];
            }
        }

        return newRows;
    };

    c3_chart_internal_fn.convertDataToTargets = function (data, appendXs) {
        var $$ = this,
            config = $$.config,
            ids = $$.d3.keys(data[0]).filter($$.isNotX, $$),
            xs = $$.d3.keys(data[0]).filter($$.isX, $$),
            targets;

        // save x for update data by load when custom x and c3.x API
        ids.forEach(function (id) {
            var xKey = $$.getXKey(id);

            if ($$.isCustomX() || $$.isTimeSeries()) {
                // if included in input data
                if (xs.indexOf(xKey) >= 0) {
                    $$.data.xs[id] = (appendXs && $$.data.xs[id] ? $$.data.xs[id] : []).concat(data.map(function (d) {
                        return d[xKey];
                    }).filter(isValue).map(function (rawX, i) {
                        return $$.generateTargetX(rawX, id, i);
                    }));
                }
                // if not included in input data, find from preloaded data of other id's x
                else if (config.data_x) {
                        $$.data.xs[id] = $$.getOtherTargetXs();
                    }
                    // if not included in input data, find from preloaded data
                    else if (notEmpty(config.data_xs)) {
                            $$.data.xs[id] = $$.getXValuesOfXKey(xKey, $$.data.targets);
                        }
                // MEMO: if no x included, use same x of current will be used
            } else {
                $$.data.xs[id] = data.map(function (d, i) {
                    return i;
                });
            }
        });

        // check x is defined
        ids.forEach(function (id) {
            if (!$$.data.xs[id]) {
                throw new Error('x is not defined for id = "' + id + '".');
            }
        });

        // convert to target
        targets = ids.map(function (id, index) {
            var convertedId = config.data_idConverter(id);
            return {
                id: convertedId,
                id_org: id,
                values: data.map(function (d, i) {
                    var xKey = $$.getXKey(id),
                        rawX = d[xKey],
                        value = d[id] !== null && !isNaN(d[id]) ? +d[id] : null,
                        x;
                    // use x as categories if custom x and categorized
                    if ($$.isCustomX() && $$.isCategorized() && !isUndefined(rawX)) {
                        if (index === 0 && i === 0) {
                            config.axis_x_categories = [];
                        }
                        x = config.axis_x_categories.indexOf(rawX);
                        if (x === -1) {
                            x = config.axis_x_categories.length;
                            config.axis_x_categories.push(rawX);
                        }
                    } else {
                        x = $$.generateTargetX(rawX, id, i);
                    }
                    // mark as x = undefined if value is undefined and filter to remove after mapped
                    if (isUndefined(d[id]) || $$.data.xs[id].length <= i) {
                        x = undefined;
                    }
                    return { x: x, value: value, id: convertedId };
                }).filter(function (v) {
                    return isDefined(v.x);
                })
            };
        });

        // finish targets
        targets.forEach(function (t) {
            var i;
            // sort values by its x
            if (config.data_xSort) {
                t.values = t.values.sort(function (v1, v2) {
                    var x1 = v1.x || v1.x === 0 ? v1.x : Infinity,
                        x2 = v2.x || v2.x === 0 ? v2.x : Infinity;
                    return x1 - x2;
                });
            }
            // indexing each value
            i = 0;
            t.values.forEach(function (v) {
                v.index = i++;
            });
            // this needs to be sorted because its index and value.index is identical
            $$.data.xs[t.id].sort(function (v1, v2) {
                return v1 - v2;
            });
        });

        // cache information about values
        $$.hasNegativeValue = $$.hasNegativeValueInTargets(targets);
        $$.hasPositiveValue = $$.hasPositiveValueInTargets(targets);

        // set target types
        if (config.data_type) {
            $$.setTargetType($$.mapToIds(targets).filter(function (id) {
                return !(id in config.data_types);
            }), config.data_type);
        }

        // cache as original id keyed
        targets.forEach(function (d) {
            $$.addCache(d.id_org, d);
        });

        return targets;
    };

    c3_chart_internal_fn.isX = function (key) {
        var $$ = this,
            config = $$.config;
        return config.data_x && key === config.data_x || notEmpty(config.data_xs) && hasValue(config.data_xs, key);
    };
    c3_chart_internal_fn.isNotX = function (key) {
        return !this.isX(key);
    };
    c3_chart_internal_fn.getXKey = function (id) {
        var $$ = this,
            config = $$.config;
        return config.data_x ? config.data_x : notEmpty(config.data_xs) ? config.data_xs[id] : null;
    };
    c3_chart_internal_fn.getXValuesOfXKey = function (key, targets) {
        var $$ = this,
            xValues,
            ids = targets && notEmpty(targets) ? $$.mapToIds(targets) : [];
        ids.forEach(function (id) {
            if ($$.getXKey(id) === key) {
                xValues = $$.data.xs[id];
            }
        });
        return xValues;
    };
    c3_chart_internal_fn.getIndexByX = function (x) {
        var $$ = this,
            data = $$.filterByX($$.data.targets, x);
        return data.length ? data[0].index : null;
    };
    c3_chart_internal_fn.getXValue = function (id, i) {
        var $$ = this;
        return id in $$.data.xs && $$.data.xs[id] && isValue($$.data.xs[id][i]) ? $$.data.xs[id][i] : i;
    };
    c3_chart_internal_fn.getOtherTargetXs = function () {
        var $$ = this,
            idsForX = Object.keys($$.data.xs);
        return idsForX.length ? $$.data.xs[idsForX[0]] : null;
    };
    c3_chart_internal_fn.getOtherTargetX = function (index) {
        var xs = this.getOtherTargetXs();
        return xs && index < xs.length ? xs[index] : null;
    };
    c3_chart_internal_fn.addXs = function (xs) {
        var $$ = this;
        Object.keys(xs).forEach(function (id) {
            $$.config.data_xs[id] = xs[id];
        });
    };
    c3_chart_internal_fn.hasMultipleX = function (xs) {
        return this.d3.set(Object.keys(xs).map(function (id) {
            return xs[id];
        })).size() > 1;
    };
    c3_chart_internal_fn.isMultipleX = function () {
        return notEmpty(this.config.data_xs) || !this.config.data_xSort || this.hasType('scatter');
    };
    c3_chart_internal_fn.addName = function (data) {
        var $$ = this,
            name;
        if (data) {
            name = $$.config.data_names[data.id];
            data.name = name !== undefined ? name : data.id;
        }
        return data;
    };
    c3_chart_internal_fn.getValueOnIndex = function (values, index) {
        var valueOnIndex = values.filter(function (v) {
            return v.index === index;
        });
        return valueOnIndex.length ? valueOnIndex[0] : null;
    };
    c3_chart_internal_fn.updateTargetX = function (targets, x) {
        var $$ = this;
        targets.forEach(function (t) {
            t.values.forEach(function (v, i) {
                v.x = $$.generateTargetX(x[i], t.id, i);
            });
            $$.data.xs[t.id] = x;
        });
    };
    c3_chart_internal_fn.updateTargetXs = function (targets, xs) {
        var $$ = this;
        targets.forEach(function (t) {
            if (xs[t.id]) {
                $$.updateTargetX([t], xs[t.id]);
            }
        });
    };
    c3_chart_internal_fn.generateTargetX = function (rawX, id, index) {
        var $$ = this,
            x;
        if ($$.isTimeSeries()) {
            x = rawX ? $$.parseDate(rawX) : $$.parseDate($$.getXValue(id, index));
        } else if ($$.isCustomX() && !$$.isCategorized()) {
            x = isValue(rawX) ? +rawX : $$.getXValue(id, index);
        } else {
            x = index;
        }
        return x;
    };
    c3_chart_internal_fn.cloneTarget = function (target) {
        return {
            id: target.id,
            id_org: target.id_org,
            values: target.values.map(function (d) {
                return { x: d.x, value: d.value, id: d.id };
            })
        };
    };
    c3_chart_internal_fn.updateXs = function () {
        var $$ = this;
        if ($$.data.targets.length) {
            $$.xs = [];
            $$.data.targets[0].values.forEach(function (v) {
                $$.xs[v.index] = v.x;
            });
        }
    };
    c3_chart_internal_fn.getPrevX = function (i) {
        var x = this.xs[i - 1];
        return typeof x !== 'undefined' ? x : null;
    };
    c3_chart_internal_fn.getNextX = function (i) {
        var x = this.xs[i + 1];
        return typeof x !== 'undefined' ? x : null;
    };
    c3_chart_internal_fn.getMaxDataCount = function () {
        var $$ = this;
        return $$.d3.max($$.data.targets, function (t) {
            return t.values.length;
        });
    };
    c3_chart_internal_fn.getMaxDataCountTarget = function (targets) {
        var length = targets.length,
            max = 0,
            maxTarget;
        if (length > 1) {
            targets.forEach(function (t) {
                if (t.values.length > max) {
                    maxTarget = t;
                    max = t.values.length;
                }
            });
        } else {
            maxTarget = length ? targets[0] : null;
        }
        return maxTarget;
    };
    c3_chart_internal_fn.getEdgeX = function (targets) {
        var $$ = this;
        return !targets.length ? [0, 0] : [$$.d3.min(targets, function (t) {
            return t.values[0].x;
        }), $$.d3.max(targets, function (t) {
            return t.values[t.values.length - 1].x;
        })];
    };
    c3_chart_internal_fn.mapToIds = function (targets) {
        return targets.map(function (d) {
            return d.id;
        });
    };
    c3_chart_internal_fn.mapToTargetIds = function (ids) {
        var $$ = this;
        return ids ? [].concat(ids) : $$.mapToIds($$.data.targets);
    };
    c3_chart_internal_fn.hasTarget = function (targets, id) {
        var ids = this.mapToIds(targets),
            i;
        for (i = 0; i < ids.length; i++) {
            if (ids[i] === id) {
                return true;
            }
        }
        return false;
    };
    c3_chart_internal_fn.isTargetToShow = function (targetId) {
        return this.hiddenTargetIds.indexOf(targetId) < 0;
    };
    c3_chart_internal_fn.isLegendToShow = function (targetId) {
        return this.hiddenLegendIds.indexOf(targetId) < 0;
    };
    c3_chart_internal_fn.filterTargetsToShow = function (targets) {
        var $$ = this;
        return targets.filter(function (t) {
            return $$.isTargetToShow(t.id);
        });
    };
    c3_chart_internal_fn.mapTargetsToUniqueXs = function (targets) {
        var $$ = this;
        var xs = $$.d3.set($$.d3.merge(targets.map(function (t) {
            return t.values.map(function (v) {
                return +v.x;
            });
        }))).values();
        xs = $$.isTimeSeries() ? xs.map(function (x) {
            return new Date(+x);
        }) : xs.map(function (x) {
            return +x;
        });
        return xs.sort(function (a, b) {
            return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
        });
    };
    c3_chart_internal_fn.addHiddenTargetIds = function (targetIds) {
        targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);
        for (var i = 0; i < targetIds.length; i++) {
            if (this.hiddenTargetIds.indexOf(targetIds[i]) < 0) {
                this.hiddenTargetIds = this.hiddenTargetIds.concat(targetIds[i]);
            }
        }
    };
    c3_chart_internal_fn.removeHiddenTargetIds = function (targetIds) {
        this.hiddenTargetIds = this.hiddenTargetIds.filter(function (id) {
            return targetIds.indexOf(id) < 0;
        });
    };
    c3_chart_internal_fn.addHiddenLegendIds = function (targetIds) {
        targetIds = targetIds instanceof Array ? targetIds : new Array(targetIds);
        for (var i = 0; i < targetIds.length; i++) {
            if (this.hiddenLegendIds.indexOf(targetIds[i]) < 0) {
                this.hiddenLegendIds = this.hiddenLegendIds.concat(targetIds[i]);
            }
        }
    };
    c3_chart_internal_fn.removeHiddenLegendIds = function (targetIds) {
        this.hiddenLegendIds = this.hiddenLegendIds.filter(function (id) {
            return targetIds.indexOf(id) < 0;
        });
    };
    c3_chart_internal_fn.getValuesAsIdKeyed = function (targets) {
        var ys = {};
        targets.forEach(function (t) {
            ys[t.id] = [];
            t.values.forEach(function (v) {
                ys[t.id].push(v.value);
            });
        });
        return ys;
    };
    c3_chart_internal_fn.checkValueInTargets = function (targets, checker) {
        var ids = Object.keys(targets),
            i,
            j,
            values;
        for (i = 0; i < ids.length; i++) {
            values = targets[ids[i]].values;
            for (j = 0; j < values.length; j++) {
                if (checker(values[j].value)) {
                    return true;
                }
            }
        }
        return false;
    };
    c3_chart_internal_fn.hasNegativeValueInTargets = function (targets) {
        return this.checkValueInTargets(targets, function (v) {
            return v < 0;
        });
    };
    c3_chart_internal_fn.hasPositiveValueInTargets = function (targets) {
        return this.checkValueInTargets(targets, function (v) {
            return v > 0;
        });
    };
    c3_chart_internal_fn.isOrderDesc = function () {
        var config = this.config;
        return typeof config.data_order === 'string' && config.data_order.toLowerCase() === 'desc';
    };
    c3_chart_internal_fn.isOrderAsc = function () {
        var config = this.config;
        return typeof config.data_order === 'string' && config.data_order.toLowerCase() === 'asc';
    };
    c3_chart_internal_fn.getOrderFunction = function () {
        var $$ = this,
            config = $$.config,
            orderAsc = $$.isOrderAsc(),
            orderDesc = $$.isOrderDesc();
        if (orderAsc || orderDesc) {
            return function (t1, t2) {
                var reducer = function reducer(p, c) {
                    return p + Math.abs(c.value);
                };
                var t1Sum = t1.values.reduce(reducer, 0),
                    t2Sum = t2.values.reduce(reducer, 0);
                return orderDesc ? t2Sum - t1Sum : t1Sum - t2Sum;
            };
        } else if (isFunction(config.data_order)) {
            return config.data_order;
        } else if (isArray(config.data_order)) {
            var order = config.data_order;
            return function (t1, t2) {
                return order.indexOf(t1.id) - order.indexOf(t2.id);
            };
        }
    };
    c3_chart_internal_fn.orderTargets = function (targets) {
        var fct = this.getOrderFunction();
        if (fct) {
            targets.sort(fct);
            if (this.isOrderAsc() || this.isOrderDesc()) {
                targets.reverse();
            }
        }
        return targets;
    };
    c3_chart_internal_fn.filterByX = function (targets, x) {
        return this.d3.merge(targets.map(function (t) {
            return t.values;
        })).filter(function (v) {
            return v.x - x === 0;
        });
    };
    c3_chart_internal_fn.filterRemoveNull = function (data) {
        return data.filter(function (d) {
            return isValue(d.value);
        });
    };
    c3_chart_internal_fn.filterByXDomain = function (targets, xDomain) {
        return targets.map(function (t) {
            return {
                id: t.id,
                id_org: t.id_org,
                values: t.values.filter(function (v) {
                    return xDomain[0] <= v.x && v.x <= xDomain[1];
                })
            };
        });
    };
    c3_chart_internal_fn.hasDataLabel = function () {
        var config = this.config;
        if (typeof config.data_labels === 'boolean' && config.data_labels) {
            return true;
        } else if (_typeof(config.data_labels) === 'object' && notEmpty(config.data_labels)) {
            return true;
        }
        return false;
    };
    c3_chart_internal_fn.getDataLabelLength = function (min, max, key) {
        var $$ = this,
            lengths = [0, 0],
            paddingCoef = 1.3;
        $$.selectChart.select('svg').selectAll('.dummy').data([min, max]).enter().append('text').text(function (d) {
            return $$.dataLabelFormat(d.id)(d);
        }).each(function (d, i) {
            lengths[i] = this.getBoundingClientRect()[key] * paddingCoef;
        }).remove();
        return lengths;
    };
    c3_chart_internal_fn.isNoneArc = function (d) {
        return this.hasTarget(this.data.targets, d.id);
    }, c3_chart_internal_fn.isArc = function (d) {
        return 'data' in d && this.hasTarget(this.data.targets, d.data.id);
    };
    c3_chart_internal_fn.findSameXOfValues = function (values, index) {
        var i,
            targetX = values[index].x,
            sames = [];
        for (i = index - 1; i >= 0; i--) {
            if (targetX !== values[i].x) {
                break;
            }
            sames.push(values[i]);
        }
        for (i = index; i < values.length; i++) {
            if (targetX !== values[i].x) {
                break;
            }
            sames.push(values[i]);
        }
        return sames;
    };

    c3_chart_internal_fn.findClosestFromTargets = function (targets, pos) {
        var $$ = this,
            candidates;

        // map to array of closest points of each target
        candidates = targets.map(function (target) {
            return $$.findClosest(target.values, pos);
        });

        // decide closest point and return
        return $$.findClosest(candidates, pos);
    };
    c3_chart_internal_fn.findClosest = function (values, pos) {
        var $$ = this,
            minDist = $$.config.point_sensitivity,
            closest;

        // find mouseovering bar
        values.filter(function (v) {
            return v && $$.isBarType(v.id);
        }).forEach(function (v) {
            var shape = $$.main.select('.' + CLASS.bars + $$.getTargetSelectorSuffix(v.id) + ' .' + CLASS.bar + '-' + v.index).node();
            if (!closest && $$.isWithinBar(shape)) {
                closest = v;
            }
        });

        // find closest point from non-bar
        values.filter(function (v) {
            return v && !$$.isBarType(v.id);
        }).forEach(function (v) {
            var d = $$.dist(v, pos);
            if (d < minDist) {
                minDist = d;
                closest = v;
            }
        });

        return closest;
    };
    c3_chart_internal_fn.dist = function (data, pos) {
        var $$ = this,
            config = $$.config,
            xIndex = config.axis_rotated ? 1 : 0,
            yIndex = config.axis_rotated ? 0 : 1,
            y = $$.circleY(data, data.index),
            x = $$.x(data.x);
        return Math.sqrt(Math.pow(x - pos[xIndex], 2) + Math.pow(y - pos[yIndex], 2));
    };
    c3_chart_internal_fn.convertValuesToStep = function (values) {
        var converted = [].concat(values),
            i;

        if (!this.isCategorized()) {
            return values;
        }

        for (i = values.length + 1; 0 < i; i--) {
            converted[i] = converted[i - 1];
        }

        converted[0] = {
            x: converted[0].x - 1,
            value: converted[0].value,
            id: converted[0].id
        };
        converted[values.length + 1] = {
            x: converted[values.length].x + 1,
            value: converted[values.length].value,
            id: converted[values.length].id
        };

        return converted;
    };
    c3_chart_internal_fn.updateDataAttributes = function (name, attrs) {
        var $$ = this,
            config = $$.config,
            current = config['data_' + name];
        if (typeof attrs === 'undefined') {
            return current;
        }
        Object.keys(attrs).forEach(function (id) {
            current[id] = attrs[id];
        });
        $$.redraw({ withLegend: true });
        return current;
    };

    c3_chart_internal_fn.load = function (targets, args) {
        var $$ = this;
        if (targets) {
            // filter loading targets if needed
            if (args.filter) {
                targets = targets.filter(args.filter);
            }
            // set type if args.types || args.type specified
            if (args.type || args.types) {
                targets.forEach(function (t) {
                    var type = args.types && args.types[t.id] ? args.types[t.id] : args.type;
                    $$.setTargetType(t.id, type);
                });
            }
            // Update/Add data
            $$.data.targets.forEach(function (d) {
                for (var i = 0; i < targets.length; i++) {
                    if (d.id === targets[i].id) {
                        d.values = targets[i].values;
                        targets.splice(i, 1);
                        break;
                    }
                }
            });
            $$.data.targets = $$.data.targets.concat(targets); // add remained
        }

        // Set targets
        $$.updateTargets($$.data.targets);

        // Redraw with new targets
        $$.redraw({ withUpdateOrgXDomain: true, withUpdateXDomain: true, withLegend: true });

        if (args.done) {
            args.done();
        }
    };
    c3_chart_internal_fn.loadFromArgs = function (args) {
        var $$ = this;
        if (args.data) {
            $$.load($$.convertDataToTargets(args.data), args);
        } else if (args.url) {
            $$.convertUrlToData(args.url, args.mimeType, args.headers, args.keys, function (data) {
                $$.load($$.convertDataToTargets(data), args);
            });
        } else if (args.json) {
            $$.load($$.convertDataToTargets($$.convertJsonToData(args.json, args.keys)), args);
        } else if (args.rows) {
            $$.load($$.convertDataToTargets($$.convertRowsToData(args.rows)), args);
        } else if (args.columns) {
            $$.load($$.convertDataToTargets($$.convertColumnsToData(args.columns)), args);
        } else {
            $$.load(null, args);
        }
    };
    c3_chart_internal_fn.unload = function (targetIds, done) {
        var $$ = this;
        if (!done) {
            done = function done() {};
        }
        // filter existing target
        targetIds = targetIds.filter(function (id) {
            return $$.hasTarget($$.data.targets, id);
        });
        // If no target, call done and return
        if (!targetIds || targetIds.length === 0) {
            done();
            return;
        }
        $$.svg.selectAll(targetIds.map(function (id) {
            return $$.selectorTarget(id);
        })).transition().style('opacity', 0).remove().call($$.endall, done);
        targetIds.forEach(function (id) {
            // Reset fadein for future load
            $$.withoutFadeIn[id] = false;
            // Remove target's elements
            if ($$.legend) {
                $$.legend.selectAll('.' + CLASS.legendItem + $$.getTargetSelectorSuffix(id)).remove();
            }
            // Remove target
            $$.data.targets = $$.data.targets.filter(function (t) {
                return t.id !== id;
            });
        });
    };

    c3_chart_internal_fn.getYDomainMin = function (targets) {
        var $$ = this,
            config = $$.config,
            ids = $$.mapToIds(targets),
            ys = $$.getValuesAsIdKeyed(targets),
            j,
            k,
            baseId,
            idsInGroup,
            id,
            hasNegativeValue;
        if (config.data_groups.length > 0) {
            hasNegativeValue = $$.hasNegativeValueInTargets(targets);
            for (j = 0; j < config.data_groups.length; j++) {
                // Determine baseId
                idsInGroup = config.data_groups[j].filter(function (id) {
                    return ids.indexOf(id) >= 0;
                });
                if (idsInGroup.length === 0) {
                    continue;
                }
                baseId = idsInGroup[0];
                // Consider negative values
                if (hasNegativeValue && ys[baseId]) {
                    ys[baseId].forEach(function (v, i) {
                        ys[baseId][i] = v < 0 ? v : 0;
                    });
                }
                // Compute min
                for (k = 1; k < idsInGroup.length; k++) {
                    id = idsInGroup[k];
                    if (!ys[id]) {
                        continue;
                    }
                    ys[id].forEach(function (v, i) {
                        if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasNegativeValue && +v > 0)) {
                            ys[baseId][i] += +v;
                        }
                    });
                }
            }
        }
        return $$.d3.min(Object.keys(ys).map(function (key) {
            return $$.d3.min(ys[key]);
        }));
    };
    c3_chart_internal_fn.getYDomainMax = function (targets) {
        var $$ = this,
            config = $$.config,
            ids = $$.mapToIds(targets),
            ys = $$.getValuesAsIdKeyed(targets),
            j,
            k,
            baseId,
            idsInGroup,
            id,
            hasPositiveValue;
        if (config.data_groups.length > 0) {
            hasPositiveValue = $$.hasPositiveValueInTargets(targets);
            for (j = 0; j < config.data_groups.length; j++) {
                // Determine baseId
                idsInGroup = config.data_groups[j].filter(function (id) {
                    return ids.indexOf(id) >= 0;
                });
                if (idsInGroup.length === 0) {
                    continue;
                }
                baseId = idsInGroup[0];
                // Consider positive values
                if (hasPositiveValue && ys[baseId]) {
                    ys[baseId].forEach(function (v, i) {
                        ys[baseId][i] = v > 0 ? v : 0;
                    });
                }
                // Compute max
                for (k = 1; k < idsInGroup.length; k++) {
                    id = idsInGroup[k];
                    if (!ys[id]) {
                        continue;
                    }
                    ys[id].forEach(function (v, i) {
                        if ($$.axis.getId(id) === $$.axis.getId(baseId) && ys[baseId] && !(hasPositiveValue && +v < 0)) {
                            ys[baseId][i] += +v;
                        }
                    });
                }
            }
        }
        return $$.d3.max(Object.keys(ys).map(function (key) {
            return $$.d3.max(ys[key]);
        }));
    };
    c3_chart_internal_fn.getYDomain = function (targets, axisId, xDomain) {
        var $$ = this,
            config = $$.config,
            targetsByAxisId = targets.filter(function (t) {
            return $$.axis.getId(t.id) === axisId;
        }),
            yTargets = xDomain ? $$.filterByXDomain(targetsByAxisId, xDomain) : targetsByAxisId,
            yMin = axisId === 'y2' ? config.axis_y2_min : config.axis_y_min,
            yMax = axisId === 'y2' ? config.axis_y2_max : config.axis_y_max,
            yDomainMin = $$.getYDomainMin(yTargets),
            yDomainMax = $$.getYDomainMax(yTargets),
            domain,
            domainLength,
            padding,
            padding_top,
            padding_bottom,
            center = axisId === 'y2' ? config.axis_y2_center : config.axis_y_center,
            yDomainAbs,
            lengths,
            diff,
            ratio,
            isAllPositive,
            isAllNegative,
            isZeroBased = $$.hasType('bar', yTargets) && config.bar_zerobased || $$.hasType('area', yTargets) && config.area_zerobased,
            isInverted = axisId === 'y2' ? config.axis_y2_inverted : config.axis_y_inverted,
            showHorizontalDataLabel = $$.hasDataLabel() && config.axis_rotated,
            showVerticalDataLabel = $$.hasDataLabel() && !config.axis_rotated;

        // MEMO: avoid inverting domain unexpectedly
        yDomainMin = isValue(yMin) ? yMin : isValue(yMax) ? yDomainMin < yMax ? yDomainMin : yMax - 10 : yDomainMin;
        yDomainMax = isValue(yMax) ? yMax : isValue(yMin) ? yMin < yDomainMax ? yDomainMax : yMin + 10 : yDomainMax;

        if (yTargets.length === 0) {
            // use current domain if target of axisId is none
            return axisId === 'y2' ? $$.y2.domain() : $$.y.domain();
        }
        if (isNaN(yDomainMin)) {
            // set minimum to zero when not number
            yDomainMin = 0;
        }
        if (isNaN(yDomainMax)) {
            // set maximum to have same value as yDomainMin
            yDomainMax = yDomainMin;
        }
        if (yDomainMin === yDomainMax) {
            yDomainMin < 0 ? yDomainMax = 0 : yDomainMin = 0;
        }
        isAllPositive = yDomainMin >= 0 && yDomainMax >= 0;
        isAllNegative = yDomainMin <= 0 && yDomainMax <= 0;

        // Cancel zerobased if axis_*_min / axis_*_max specified
        if (isValue(yMin) && isAllPositive || isValue(yMax) && isAllNegative) {
            isZeroBased = false;
        }

        // Bar/Area chart should be 0-based if all positive|negative
        if (isZeroBased) {
            if (isAllPositive) {
                yDomainMin = 0;
            }
            if (isAllNegative) {
                yDomainMax = 0;
            }
        }

        domainLength = Math.abs(yDomainMax - yDomainMin);
        padding = padding_top = padding_bottom = domainLength * 0.1;

        if (typeof center !== 'undefined') {
            yDomainAbs = Math.max(Math.abs(yDomainMin), Math.abs(yDomainMax));
            yDomainMax = center + yDomainAbs;
            yDomainMin = center - yDomainAbs;
        }
        // add padding for data label
        if (showHorizontalDataLabel) {
            lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, 'width');
            diff = diffDomain($$.y.range());
            ratio = [lengths[0] / diff, lengths[1] / diff];
            padding_top += domainLength * (ratio[1] / (1 - ratio[0] - ratio[1]));
            padding_bottom += domainLength * (ratio[0] / (1 - ratio[0] - ratio[1]));
        } else if (showVerticalDataLabel) {
            lengths = $$.getDataLabelLength(yDomainMin, yDomainMax, 'height');
            padding_top += $$.axis.convertPixelsToAxisPadding(lengths[1], domainLength);
            padding_bottom += $$.axis.convertPixelsToAxisPadding(lengths[0], domainLength);
        }
        if (axisId === 'y' && notEmpty(config.axis_y_padding)) {
            padding_top = $$.axis.getPadding(config.axis_y_padding, 'top', padding_top, domainLength);
            padding_bottom = $$.axis.getPadding(config.axis_y_padding, 'bottom', padding_bottom, domainLength);
        }
        if (axisId === 'y2' && notEmpty(config.axis_y2_padding)) {
            padding_top = $$.axis.getPadding(config.axis_y2_padding, 'top', padding_top, domainLength);
            padding_bottom = $$.axis.getPadding(config.axis_y2_padding, 'bottom', padding_bottom, domainLength);
        }
        // Bar/Area chart should be 0-based if all positive|negative
        if (isZeroBased) {
            if (isAllPositive) {
                padding_bottom = yDomainMin;
            }
            if (isAllNegative) {
                padding_top = -yDomainMax;
            }
        }
        domain = [yDomainMin - padding_bottom, yDomainMax + padding_top];
        return isInverted ? domain.reverse() : domain;
    };
    c3_chart_internal_fn.getXDomainMin = function (targets) {
        var $$ = this,
            config = $$.config;
        return isDefined(config.axis_x_min) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_min) : config.axis_x_min : $$.d3.min(targets, function (t) {
            return $$.d3.min(t.values, function (v) {
                return v.x;
            });
        });
    };
    c3_chart_internal_fn.getXDomainMax = function (targets) {
        var $$ = this,
            config = $$.config;
        return isDefined(config.axis_x_max) ? $$.isTimeSeries() ? this.parseDate(config.axis_x_max) : config.axis_x_max : $$.d3.max(targets, function (t) {
            return $$.d3.max(t.values, function (v) {
                return v.x;
            });
        });
    };
    c3_chart_internal_fn.getXDomainPadding = function (domain) {
        var $$ = this,
            config = $$.config,
            diff = domain[1] - domain[0],
            maxDataCount,
            padding,
            paddingLeft,
            paddingRight;
        if ($$.isCategorized()) {
            padding = 0;
        } else if ($$.hasType('bar')) {
            maxDataCount = $$.getMaxDataCount();
            padding = maxDataCount > 1 ? diff / (maxDataCount - 1) / 2 : 0.5;
        } else {
            padding = diff * 0.01;
        }
        if (_typeof(config.axis_x_padding) === 'object' && notEmpty(config.axis_x_padding)) {
            paddingLeft = isValue(config.axis_x_padding.left) ? config.axis_x_padding.left : padding;
            paddingRight = isValue(config.axis_x_padding.right) ? config.axis_x_padding.right : padding;
        } else if (typeof config.axis_x_padding === 'number') {
            paddingLeft = paddingRight = config.axis_x_padding;
        } else {
            paddingLeft = paddingRight = padding;
        }
        return { left: paddingLeft, right: paddingRight };
    };
    c3_chart_internal_fn.getXDomain = function (targets) {
        var $$ = this,
            xDomain = [$$.getXDomainMin(targets), $$.getXDomainMax(targets)],
            firstX = xDomain[0],
            lastX = xDomain[1],
            padding = $$.getXDomainPadding(xDomain),
            min = 0,
            max = 0;
        // show center of x domain if min and max are the same
        if (firstX - lastX === 0 && !$$.isCategorized()) {
            if ($$.isTimeSeries()) {
                firstX = new Date(firstX.getTime() * 0.5);
                lastX = new Date(lastX.getTime() * 1.5);
            } else {
                firstX = firstX === 0 ? 1 : firstX * 0.5;
                lastX = lastX === 0 ? -1 : lastX * 1.5;
            }
        }
        if (firstX || firstX === 0) {
            min = $$.isTimeSeries() ? new Date(firstX.getTime() - padding.left) : firstX - padding.left;
        }
        if (lastX || lastX === 0) {
            max = $$.isTimeSeries() ? new Date(lastX.getTime() + padding.right) : lastX + padding.right;
        }
        return [min, max];
    };
    c3_chart_internal_fn.updateXDomain = function (targets, withUpdateXDomain, withUpdateOrgXDomain, withTrim, domain) {
        var $$ = this,
            config = $$.config;

        if (withUpdateOrgXDomain) {
            $$.x.domain(domain ? domain : $$.d3.extent($$.getXDomain(targets)));
            $$.orgXDomain = $$.x.domain();
            if (config.zoom_enabled) {
                $$.zoom.scale($$.x).updateScaleExtent();
            }
            $$.subX.domain($$.x.domain());
            if ($$.brush) {
                $$.brush.scale($$.subX);
            }
        }
        if (withUpdateXDomain) {
            $$.x.domain(domain ? domain : !$$.brush || $$.brush.empty() ? $$.orgXDomain : $$.brush.extent());
            if (config.zoom_enabled) {
                $$.zoom.scale($$.x).updateScaleExtent();
            }
        }

        // Trim domain when too big by zoom mousemove event
        if (withTrim) {
            $$.x.domain($$.trimXDomain($$.x.orgDomain()));
        }

        return $$.x.domain();
    };
    c3_chart_internal_fn.trimXDomain = function (domain) {
        var zoomDomain = this.getZoomDomain(),
            min = zoomDomain[0],
            max = zoomDomain[1];
        if (domain[0] <= min) {
            domain[1] = +domain[1] + (min - domain[0]);
            domain[0] = min;
        }
        if (max <= domain[1]) {
            domain[0] = +domain[0] - (domain[1] - max);
            domain[1] = max;
        }
        return domain;
    };

    c3_chart_internal_fn.drag = function (mouse) {
        var $$ = this,
            config = $$.config,
            main = $$.main,
            d3 = $$.d3;
        var sx, sy, mx, my, minX, maxX, minY, maxY;

        if ($$.hasArcType()) {
            return;
        }
        if (!config.data_selection_enabled) {
            return;
        } // do nothing if not selectable
        if (config.zoom_enabled && !$$.zoom.altDomain) {
            return;
        } // skip if zoomable because of conflict drag dehavior
        if (!config.data_selection_multiple) {
            return;
        } // skip when single selection because drag is used for multiple selection

        sx = $$.dragStart[0];
        sy = $$.dragStart[1];
        mx = mouse[0];
        my = mouse[1];
        minX = Math.min(sx, mx);
        maxX = Math.max(sx, mx);
        minY = config.data_selection_grouped ? $$.margin.top : Math.min(sy, my);
        maxY = config.data_selection_grouped ? $$.height : Math.max(sy, my);

        main.select('.' + CLASS.dragarea).attr('x', minX).attr('y', minY).attr('width', maxX - minX).attr('height', maxY - minY);
        // TODO: binary search when multiple xs
        main.selectAll('.' + CLASS.shapes).selectAll('.' + CLASS.shape).filter(function (d) {
            return config.data_selection_isselectable(d);
        }).each(function (d, i) {
            var shape = d3.select(this),
                isSelected = shape.classed(CLASS.SELECTED),
                isIncluded = shape.classed(CLASS.INCLUDED),
                _x,
                _y,
                _w,
                _h,
                toggle,
                isWithin = false,
                box;
            if (shape.classed(CLASS.circle)) {
                _x = shape.attr("cx") * 1;
                _y = shape.attr("cy") * 1;
                toggle = $$.togglePoint;
                isWithin = minX < _x && _x < maxX && minY < _y && _y < maxY;
            } else if (shape.classed(CLASS.bar)) {
                box = getPathBox(this);
                _x = box.x;
                _y = box.y;
                _w = box.width;
                _h = box.height;
                toggle = $$.togglePath;
                isWithin = !(maxX < _x || _x + _w < minX) && !(maxY < _y || _y + _h < minY);
            } else {
                // line/area selection not supported yet
                return;
            }
            if (isWithin ^ isIncluded) {
                shape.classed(CLASS.INCLUDED, !isIncluded);
                // TODO: included/unincluded callback here
                shape.classed(CLASS.SELECTED, !isSelected);
                toggle.call($$, !isSelected, shape, d, i);
            }
        });
    };

    c3_chart_internal_fn.dragstart = function (mouse) {
        var $$ = this,
            config = $$.config;
        if ($$.hasArcType()) {
            return;
        }
        if (!config.data_selection_enabled) {
            return;
        } // do nothing if not selectable
        $$.dragStart = mouse;
        $$.main.select('.' + CLASS.chart).append('rect').attr('class', CLASS.dragarea).style('opacity', 0.1);
        $$.dragging = true;
    };

    c3_chart_internal_fn.dragend = function () {
        var $$ = this,
            config = $$.config;
        if ($$.hasArcType()) {
            return;
        }
        if (!config.data_selection_enabled) {
            return;
        } // do nothing if not selectable
        $$.main.select('.' + CLASS.dragarea).transition().duration(100).style('opacity', 0).remove();
        $$.main.selectAll('.' + CLASS.shape).classed(CLASS.INCLUDED, false);
        $$.dragging = false;
    };

    c3_chart_internal_fn.getYFormat = function (forArc) {
        var $$ = this,
            formatForY = forArc && !$$.hasType('gauge') ? $$.defaultArcValueFormat : $$.yFormat,
            formatForY2 = forArc && !$$.hasType('gauge') ? $$.defaultArcValueFormat : $$.y2Format;
        return function (v, ratio, id) {
            var format = $$.axis.getId(id) === 'y2' ? formatForY2 : formatForY;
            return format.call($$, v, ratio);
        };
    };
    c3_chart_internal_fn.yFormat = function (v) {
        var $$ = this,
            config = $$.config,
            format = config.axis_y_tick_format ? config.axis_y_tick_format : $$.defaultValueFormat;
        return format(v);
    };
    c3_chart_internal_fn.y2Format = function (v) {
        var $$ = this,
            config = $$.config,
            format = config.axis_y2_tick_format ? config.axis_y2_tick_format : $$.defaultValueFormat;
        return format(v);
    };
    c3_chart_internal_fn.defaultValueFormat = function (v) {
        return isValue(v) ? +v : "";
    };
    c3_chart_internal_fn.defaultArcValueFormat = function (v, ratio) {
        return (ratio * 100).toFixed(1) + '%';
    };
    c3_chart_internal_fn.dataLabelFormat = function (targetId) {
        var $$ = this,
            data_labels = $$.config.data_labels,
            format,
            defaultFormat = function defaultFormat(v) {
            return isValue(v) ? +v : "";
        };
        // find format according to axis id
        if (typeof data_labels.format === 'function') {
            format = data_labels.format;
        } else if (_typeof(data_labels.format) === 'object') {
            if (data_labels.format[targetId]) {
                format = data_labels.format[targetId] === true ? defaultFormat : data_labels.format[targetId];
            } else {
                format = function format() {
                    return '';
                };
            }
        } else {
            format = defaultFormat;
        }
        return format;
    };

    c3_chart_internal_fn.initGrid = function () {
        var $$ = this,
            config = $$.config,
            d3 = $$.d3;
        $$.grid = $$.main.append('g').attr("clip-path", $$.clipPathForGrid).attr('class', CLASS.grid);
        if (config.grid_x_show) {
            $$.grid.append("g").attr("class", CLASS.xgrids);
        }
        if (config.grid_y_show) {
            $$.grid.append('g').attr('class', CLASS.ygrids);
        }
        if (config.grid_focus_show) {
            $$.grid.append('g').attr("class", CLASS.xgridFocus).append('line').attr('class', CLASS.xgridFocus);
        }
        $$.xgrid = d3.selectAll([]);
        if (!config.grid_lines_front) {
            $$.initGridLines();
        }
    };
    c3_chart_internal_fn.initGridLines = function () {
        var $$ = this,
            d3 = $$.d3;
        $$.gridLines = $$.main.append('g').attr("clip-path", $$.clipPathForGrid).attr('class', CLASS.grid + ' ' + CLASS.gridLines);
        $$.gridLines.append('g').attr("class", CLASS.xgridLines);
        $$.gridLines.append('g').attr('class', CLASS.ygridLines);
        $$.xgridLines = d3.selectAll([]);
    };
    c3_chart_internal_fn.updateXGrid = function (withoutUpdate) {
        var $$ = this,
            config = $$.config,
            d3 = $$.d3,
            xgridData = $$.generateGridData(config.grid_x_type, $$.x),
            tickOffset = $$.isCategorized() ? $$.xAxis.tickOffset() : 0;

        $$.xgridAttr = config.axis_rotated ? {
            'x1': 0,
            'x2': $$.width,
            'y1': function y1(d) {
                return $$.x(d) - tickOffset;
            },
            'y2': function y2(d) {
                return $$.x(d) - tickOffset;
            }
        } : {
            'x1': function x1(d) {
                return $$.x(d) + tickOffset;
            },
            'x2': function x2(d) {
                return $$.x(d) + tickOffset;
            },
            'y1': 0,
            'y2': $$.height
        };

        $$.xgrid = $$.main.select('.' + CLASS.xgrids).selectAll('.' + CLASS.xgrid).data(xgridData);
        $$.xgrid.enter().append('line').attr("class", CLASS.xgrid);
        if (!withoutUpdate) {
            $$.xgrid.attr($$.xgridAttr).style("opacity", function () {
                return +d3.select(this).attr(config.axis_rotated ? 'y1' : 'x1') === (config.axis_rotated ? $$.height : 0) ? 0 : 1;
            });
        }
        $$.xgrid.exit().remove();
    };

    c3_chart_internal_fn.updateYGrid = function () {
        var $$ = this,
            config = $$.config,
            gridValues = $$.yAxis.tickValues() || $$.y.ticks(config.grid_y_ticks);
        $$.ygrid = $$.main.select('.' + CLASS.ygrids).selectAll('.' + CLASS.ygrid).data(gridValues);
        $$.ygrid.enter().append('line').attr('class', CLASS.ygrid);
        $$.ygrid.attr("x1", config.axis_rotated ? $$.y : 0).attr("x2", config.axis_rotated ? $$.y : $$.width).attr("y1", config.axis_rotated ? 0 : $$.y).attr("y2", config.axis_rotated ? $$.height : $$.y);
        $$.ygrid.exit().remove();
        $$.smoothLines($$.ygrid, 'grid');
    };

    c3_chart_internal_fn.gridTextAnchor = function (d) {
        return d.position ? d.position : "end";
    };
    c3_chart_internal_fn.gridTextDx = function (d) {
        return d.position === 'start' ? 4 : d.position === 'middle' ? 0 : -4;
    };
    c3_chart_internal_fn.xGridTextX = function (d) {
        return d.position === 'start' ? -this.height : d.position === 'middle' ? -this.height / 2 : 0;
    };
    c3_chart_internal_fn.yGridTextX = function (d) {
        return d.position === 'start' ? 0 : d.position === 'middle' ? this.width / 2 : this.width;
    };
    c3_chart_internal_fn.updateGrid = function (duration) {
        var $$ = this,
            main = $$.main,
            config = $$.config,
            xgridLine,
            ygridLine,
            yv;

        // hide if arc type
        $$.grid.style('visibility', $$.hasArcType() ? 'hidden' : 'visible');

        main.select('line.' + CLASS.xgridFocus).style("visibility", "hidden");
        if (config.grid_x_show) {
            $$.updateXGrid();
        }
        $$.xgridLines = main.select('.' + CLASS.xgridLines).selectAll('.' + CLASS.xgridLine).data(config.grid_x_lines);
        // enter
        xgridLine = $$.xgridLines.enter().append('g').attr("class", function (d) {
            return CLASS.xgridLine + (d['class'] ? ' ' + d['class'] : '');
        });
        xgridLine.append('line').style("opacity", 0);
        xgridLine.append('text').attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "" : "rotate(-90)").attr('dx', $$.gridTextDx).attr('dy', -5).style("opacity", 0);
        // udpate
        // done in d3.transition() of the end of this function
        // exit
        $$.xgridLines.exit().transition().duration(duration).style("opacity", 0).remove();

        // Y-Grid
        if (config.grid_y_show) {
            $$.updateYGrid();
        }
        $$.ygridLines = main.select('.' + CLASS.ygridLines).selectAll('.' + CLASS.ygridLine).data(config.grid_y_lines);
        // enter
        ygridLine = $$.ygridLines.enter().append('g').attr("class", function (d) {
            return CLASS.ygridLine + (d['class'] ? ' ' + d['class'] : '');
        });
        ygridLine.append('line').style("opacity", 0);
        ygridLine.append('text').attr("text-anchor", $$.gridTextAnchor).attr("transform", config.axis_rotated ? "rotate(-90)" : "").attr('dx', $$.gridTextDx).attr('dy', -5).style("opacity", 0);
        // update
        yv = $$.yv.bind($$);
        $$.ygridLines.select('line').transition().duration(duration).attr("x1", config.axis_rotated ? yv : 0).attr("x2", config.axis_rotated ? yv : $$.width).attr("y1", config.axis_rotated ? 0 : yv).attr("y2", config.axis_rotated ? $$.height : yv).style("opacity", 1);
        $$.ygridLines.select('text').transition().duration(duration).attr("x", config.axis_rotated ? $$.xGridTextX.bind($$) : $$.yGridTextX.bind($$)).attr("y", yv).text(function (d) {
            return d.text;
        }).style("opacity", 1);
        // exit
        $$.ygridLines.exit().transition().duration(duration).style("opacity", 0).remove();
    };
    c3_chart_internal_fn.redrawGrid = function (withTransition) {
        var $$ = this,
            config = $$.config,
            xv = $$.xv.bind($$),
            lines = $$.xgridLines.select('line'),
            texts = $$.xgridLines.select('text');
        return [(withTransition ? lines.transition() : lines).attr("x1", config.axis_rotated ? 0 : xv).attr("x2", config.axis_rotated ? $$.width : xv).attr("y1", config.axis_rotated ? xv : 0).attr("y2", config.axis_rotated ? xv : $$.height).style("opacity", 1), (withTransition ? texts.transition() : texts).attr("x", config.axis_rotated ? $$.yGridTextX.bind($$) : $$.xGridTextX.bind($$)).attr("y", xv).text(function (d) {
            return d.text;
        }).style("opacity", 1)];
    };
    c3_chart_internal_fn.showXGridFocus = function (selectedData) {
        var $$ = this,
            config = $$.config,
            dataToShow = selectedData.filter(function (d) {
            return d && isValue(d.value);
        }),
            focusEl = $$.main.selectAll('line.' + CLASS.xgridFocus),
            xx = $$.xx.bind($$);
        if (!config.tooltip_show) {
            return;
        }
        // Hide when scatter plot exists
        if ($$.hasType('scatter') || $$.hasArcType()) {
            return;
        }
        focusEl.style("visibility", "visible").data([dataToShow[0]]).attr(config.axis_rotated ? 'y1' : 'x1', xx).attr(config.axis_rotated ? 'y2' : 'x2', xx);
        $$.smoothLines(focusEl, 'grid');
    };
    c3_chart_internal_fn.hideXGridFocus = function () {
        this.main.select('line.' + CLASS.xgridFocus).style("visibility", "hidden");
    };
    c3_chart_internal_fn.updateXgridFocus = function () {
        var $$ = this,
            config = $$.config;
        $$.main.select('line.' + CLASS.xgridFocus).attr("x1", config.axis_rotated ? 0 : -10).attr("x2", config.axis_rotated ? $$.width : -10).attr("y1", config.axis_rotated ? -10 : 0).attr("y2", config.axis_rotated ? -10 : $$.height);
    };
    c3_chart_internal_fn.generateGridData = function (type, scale) {
        var $$ = this,
            gridData = [],
            xDomain,
            firstYear,
            lastYear,
            i,
            tickNum = $$.main.select("." + CLASS.axisX).selectAll('.tick').size();
        if (type === 'year') {
            xDomain = $$.getXDomain();
            firstYear = xDomain[0].getFullYear();
            lastYear = xDomain[1].getFullYear();
            for (i = firstYear; i <= lastYear; i++) {
                gridData.push(new Date(i + '-01-01 00:00:00'));
            }
        } else {
            gridData = scale.ticks(10);
            if (gridData.length > tickNum) {
                // use only int
                gridData = gridData.filter(function (d) {
                    return ("" + d).indexOf('.') < 0;
                });
            }
        }
        return gridData;
    };
    c3_chart_internal_fn.getGridFilterToRemove = function (params) {
        return params ? function (line) {
            var found = false;
            [].concat(params).forEach(function (param) {
                if ('value' in param && line.value === param.value || 'class' in param && line['class'] === param['class']) {
                    found = true;
                }
            });
            return found;
        } : function () {
            return true;
        };
    };
    c3_chart_internal_fn.removeGridLines = function (params, forX) {
        var $$ = this,
            config = $$.config,
            toRemove = $$.getGridFilterToRemove(params),
            toShow = function toShow(line) {
            return !toRemove(line);
        },
            classLines = forX ? CLASS.xgridLines : CLASS.ygridLines,
            classLine = forX ? CLASS.xgridLine : CLASS.ygridLine;
        $$.main.select('.' + classLines).selectAll('.' + classLine).filter(toRemove).transition().duration(config.transition_duration).style('opacity', 0).remove();
        if (forX) {
            config.grid_x_lines = config.grid_x_lines.filter(toShow);
        } else {
            config.grid_y_lines = config.grid_y_lines.filter(toShow);
        }
    };

    c3_chart_internal_fn.initEventRect = function () {
        var $$ = this;
        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.eventRects).style('fill-opacity', 0);
    };
    c3_chart_internal_fn.redrawEventRect = function () {
        var $$ = this,
            config = $$.config,
            eventRectUpdate,
            maxDataCountTarget,
            isMultipleX = $$.isMultipleX();

        // rects for mouseover
        var eventRects = $$.main.select('.' + CLASS.eventRects).style('cursor', config.zoom_enabled ? config.axis_rotated ? 'ns-resize' : 'ew-resize' : null).classed(CLASS.eventRectsMultiple, isMultipleX).classed(CLASS.eventRectsSingle, !isMultipleX);

        // clear old rects
        eventRects.selectAll('.' + CLASS.eventRect).remove();

        // open as public variable
        $$.eventRect = eventRects.selectAll('.' + CLASS.eventRect);

        if (isMultipleX) {
            eventRectUpdate = $$.eventRect.data([0]);
            // enter : only one rect will be added
            $$.generateEventRectsForMultipleXs(eventRectUpdate.enter());
            // update
            $$.updateEventRect(eventRectUpdate);
            // exit : not needed because always only one rect exists
        } else {
            // Set data and update $$.eventRect
            maxDataCountTarget = $$.getMaxDataCountTarget($$.data.targets);
            eventRects.datum(maxDataCountTarget ? maxDataCountTarget.values : []);
            $$.eventRect = eventRects.selectAll('.' + CLASS.eventRect);
            eventRectUpdate = $$.eventRect.data(function (d) {
                return d;
            });
            // enter
            $$.generateEventRectsForSingleX(eventRectUpdate.enter());
            // update
            $$.updateEventRect(eventRectUpdate);
            // exit
            eventRectUpdate.exit().remove();
        }
    };
    c3_chart_internal_fn.updateEventRect = function (eventRectUpdate) {
        var $$ = this,
            config = $$.config,
            x,
            y,
            w,
            h,
            rectW,
            rectX;

        // set update selection if null
        eventRectUpdate = eventRectUpdate || $$.eventRect.data(function (d) {
            return d;
        });

        if ($$.isMultipleX()) {
            // TODO: rotated not supported yet
            x = 0;
            y = 0;
            w = $$.width;
            h = $$.height;
        } else {
            if (($$.isCustomX() || $$.isTimeSeries()) && !$$.isCategorized()) {

                // update index for x that is used by prevX and nextX
                $$.updateXs();

                rectW = function rectW(d) {
                    var prevX = $$.getPrevX(d.index),
                        nextX = $$.getNextX(d.index);

                    // if there this is a single data point make the eventRect full width (or height)
                    if (prevX === null && nextX === null) {
                        return config.axis_rotated ? $$.height : $$.width;
                    }

                    if (prevX === null) {
                        prevX = $$.x.domain()[0];
                    }
                    if (nextX === null) {
                        nextX = $$.x.domain()[1];
                    }

                    return Math.max(0, ($$.x(nextX) - $$.x(prevX)) / 2);
                };
                rectX = function rectX(d) {
                    var prevX = $$.getPrevX(d.index),
                        nextX = $$.getNextX(d.index),
                        thisX = $$.data.xs[d.id][d.index];

                    // if there this is a single data point position the eventRect at 0
                    if (prevX === null && nextX === null) {
                        return 0;
                    }

                    if (prevX === null) {
                        prevX = $$.x.domain()[0];
                    }

                    return ($$.x(thisX) + $$.x(prevX)) / 2;
                };
            } else {
                rectW = $$.getEventRectWidth();
                rectX = function rectX(d) {
                    return $$.x(d.x) - rectW / 2;
                };
            }
            x = config.axis_rotated ? 0 : rectX;
            y = config.axis_rotated ? rectX : 0;
            w = config.axis_rotated ? $$.width : rectW;
            h = config.axis_rotated ? rectW : $$.height;
        }

        eventRectUpdate.attr('class', $$.classEvent.bind($$)).attr("x", x).attr("y", y).attr("width", w).attr("height", h);
    };
    c3_chart_internal_fn.generateEventRectsForSingleX = function (eventRectEnter) {
        var $$ = this,
            d3 = $$.d3,
            config = $$.config;
        eventRectEnter.append("rect").attr("class", $$.classEvent.bind($$)).style("cursor", config.data_selection_enabled && config.data_selection_grouped ? "pointer" : null).on('mouseover', function (d) {
            var index = d.index;

            if ($$.dragging || $$.flowing) {
                return;
            } // do nothing while dragging/flowing
            if ($$.hasArcType()) {
                return;
            }

            // Expand shapes for selection
            if (config.point_focus_expand_enabled) {
                $$.expandCircles(index, null, true);
            }
            $$.expandBars(index, null, true);

            // Call event handler
            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function (d) {
                config.data_onmouseover.call($$.api, d);
            });
        }).on('mouseout', function (d) {
            var index = d.index;
            if (!$$.config) {
                return;
            } // chart is destroyed
            if ($$.hasArcType()) {
                return;
            }
            $$.hideXGridFocus();
            $$.hideTooltip();
            // Undo expanded shapes
            $$.unexpandCircles();
            $$.unexpandBars();
            // Call event handler
            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function (d) {
                config.data_onmouseout.call($$.api, d);
            });
        }).on('mousemove', function (d) {
            var selectedData,
                index = d.index,
                eventRect = $$.svg.select('.' + CLASS.eventRect + '-' + index);

            if ($$.dragging || $$.flowing) {
                return;
            } // do nothing while dragging/flowing
            if ($$.hasArcType()) {
                return;
            }

            if ($$.isStepType(d) && $$.config.line_step_type === 'step-after' && d3.mouse(this)[0] < $$.x($$.getXValue(d.id, index))) {
                index -= 1;
            }

            // Show tooltip
            selectedData = $$.filterTargetsToShow($$.data.targets).map(function (t) {
                return $$.addName($$.getValueOnIndex(t.values, index));
            });

            if (config.tooltip_grouped) {
                $$.showTooltip(selectedData, this);
                $$.showXGridFocus(selectedData);
            }

            if (config.tooltip_grouped && (!config.data_selection_enabled || config.data_selection_grouped)) {
                return;
            }

            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function () {
                d3.select(this).classed(CLASS.EXPANDED, true);
                if (config.data_selection_enabled) {
                    eventRect.style('cursor', config.data_selection_grouped ? 'pointer' : null);
                }
                if (!config.tooltip_grouped) {
                    $$.hideXGridFocus();
                    $$.hideTooltip();
                    if (!config.data_selection_grouped) {
                        $$.unexpandCircles(index);
                        $$.unexpandBars(index);
                    }
                }
            }).filter(function (d) {
                return $$.isWithinShape(this, d);
            }).each(function (d) {
                if (config.data_selection_enabled && (config.data_selection_grouped || config.data_selection_isselectable(d))) {
                    eventRect.style('cursor', 'pointer');
                }
                if (!config.tooltip_grouped) {
                    $$.showTooltip([d], this);
                    $$.showXGridFocus([d]);
                    if (config.point_focus_expand_enabled) {
                        $$.expandCircles(index, d.id, true);
                    }
                    $$.expandBars(index, d.id, true);
                }
            });
        }).on('click', function (d) {
            var index = d.index;
            if ($$.hasArcType() || !$$.toggleShape) {
                return;
            }
            if ($$.cancelClick) {
                $$.cancelClick = false;
                return;
            }
            if ($$.isStepType(d) && config.line_step_type === 'step-after' && d3.mouse(this)[0] < $$.x($$.getXValue(d.id, index))) {
                index -= 1;
            }
            $$.main.selectAll('.' + CLASS.shape + '-' + index).each(function (d) {
                if (config.data_selection_grouped || $$.isWithinShape(this, d)) {
                    $$.toggleShape(this, d, index);
                    $$.config.data_onclick.call($$.api, d, this);
                }
            });
        }).call(config.data_selection_draggable && $$.drag ? d3.behavior.drag().origin(Object).on('drag', function () {
            $$.drag(d3.mouse(this));
        }).on('dragstart', function () {
            $$.dragstart(d3.mouse(this));
        }).on('dragend', function () {
            $$.dragend();
        }) : function () {});
    };

    c3_chart_internal_fn.generateEventRectsForMultipleXs = function (eventRectEnter) {
        var $$ = this,
            d3 = $$.d3,
            config = $$.config;

        function mouseout() {
            $$.svg.select('.' + CLASS.eventRect).style('cursor', null);
            $$.hideXGridFocus();
            $$.hideTooltip();
            $$.unexpandCircles();
            $$.unexpandBars();
        }

        eventRectEnter.append('rect').attr('x', 0).attr('y', 0).attr('width', $$.width).attr('height', $$.height).attr('class', CLASS.eventRect).on('mouseout', function () {
            if (!$$.config) {
                return;
            } // chart is destroyed
            if ($$.hasArcType()) {
                return;
            }
            mouseout();
        }).on('mousemove', function () {
            var targetsToShow = $$.filterTargetsToShow($$.data.targets);
            var mouse, closest, sameXData, selectedData;

            if ($$.dragging) {
                return;
            } // do nothing when dragging
            if ($$.hasArcType(targetsToShow)) {
                return;
            }

            mouse = d3.mouse(this);
            closest = $$.findClosestFromTargets(targetsToShow, mouse);

            if ($$.mouseover && (!closest || closest.id !== $$.mouseover.id)) {
                config.data_onmouseout.call($$.api, $$.mouseover);
                $$.mouseover = undefined;
            }

            if (!closest) {
                mouseout();
                return;
            }

            if ($$.isScatterType(closest) || !config.tooltip_grouped) {
                sameXData = [closest];
            } else {
                sameXData = $$.filterByX(targetsToShow, closest.x);
            }

            // show tooltip when cursor is close to some point
            selectedData = sameXData.map(function (d) {
                return $$.addName(d);
            });
            $$.showTooltip(selectedData, this);

            // expand points
            if (config.point_focus_expand_enabled) {
                $$.expandCircles(closest.index, closest.id, true);
            }
            $$.expandBars(closest.index, closest.id, true);

            // Show xgrid focus line
            $$.showXGridFocus(selectedData);

            // Show cursor as pointer if point is close to mouse position
            if ($$.isBarType(closest.id) || $$.dist(closest, mouse) < config.point_sensitivity) {
                $$.svg.select('.' + CLASS.eventRect).style('cursor', 'pointer');
                if (!$$.mouseover) {
                    config.data_onmouseover.call($$.api, closest);
                    $$.mouseover = closest;
                }
            }
        }).on('click', function () {
            var targetsToShow = $$.filterTargetsToShow($$.data.targets);
            var mouse, closest;
            if ($$.hasArcType(targetsToShow)) {
                return;
            }

            mouse = d3.mouse(this);
            closest = $$.findClosestFromTargets(targetsToShow, mouse);
            if (!closest) {
                return;
            }
            // select if selection enabled
            if ($$.isBarType(closest.id) || $$.dist(closest, mouse) < config.point_sensitivity) {
                $$.main.selectAll('.' + CLASS.shapes + $$.getTargetSelectorSuffix(closest.id)).selectAll('.' + CLASS.shape + '-' + closest.index).each(function () {
                    if (config.data_selection_grouped || $$.isWithinShape(this, closest)) {
                        $$.toggleShape(this, closest, closest.index);
                        $$.config.data_onclick.call($$.api, closest, this);
                    }
                });
            }
        }).call(config.data_selection_draggable && $$.drag ? d3.behavior.drag().origin(Object).on('drag', function () {
            $$.drag(d3.mouse(this));
        }).on('dragstart', function () {
            $$.dragstart(d3.mouse(this));
        }).on('dragend', function () {
            $$.dragend();
        }) : function () {});
    };
    c3_chart_internal_fn.dispatchEvent = function (type, index, mouse) {
        var $$ = this,
            selector = '.' + CLASS.eventRect + (!$$.isMultipleX() ? '-' + index : ''),
            eventRect = $$.main.select(selector).node(),
            box = eventRect.getBoundingClientRect(),
            x = box.left + (mouse ? mouse[0] : 0),
            y = box.top + (mouse ? mouse[1] : 0),
            event = document.createEvent("MouseEvents");

        event.initMouseEvent(type, true, true, window, 0, x, y, x, y, false, false, false, false, 0, null);
        eventRect.dispatchEvent(event);
    };

    c3_chart_internal_fn.initLegend = function () {
        var $$ = this;
        $$.legendItemTextBox = {};
        $$.legendHasRendered = false;
        $$.legend = $$.svg.append("g").attr("transform", $$.getTranslate('legend'));
        if (!$$.config.legend_show) {
            $$.legend.style('visibility', 'hidden');
            $$.hiddenLegendIds = $$.mapToIds($$.data.targets);
            return;
        }
        // MEMO: call here to update legend box and tranlate for all
        // MEMO: translate will be upated by this, so transform not needed in updateLegend()
        $$.updateLegendWithDefaults();
    };
    c3_chart_internal_fn.updateLegendWithDefaults = function () {
        var $$ = this;
        $$.updateLegend($$.mapToIds($$.data.targets), { withTransform: false, withTransitionForTransform: false, withTransition: false });
    };
    c3_chart_internal_fn.updateSizeForLegend = function (legendHeight, legendWidth) {
        var $$ = this,
            config = $$.config,
            insetLegendPosition = {
            top: $$.isLegendTop ? $$.getCurrentPaddingTop() + config.legend_inset_y + 5.5 : $$.currentHeight - legendHeight - $$.getCurrentPaddingBottom() - config.legend_inset_y,
            left: $$.isLegendLeft ? $$.getCurrentPaddingLeft() + config.legend_inset_x + 0.5 : $$.currentWidth - legendWidth - $$.getCurrentPaddingRight() - config.legend_inset_x + 0.5
        };

        $$.margin3 = {
            top: $$.isLegendRight ? 0 : $$.isLegendInset ? insetLegendPosition.top : $$.currentHeight - legendHeight,
            right: NaN,
            bottom: 0,
            left: $$.isLegendRight ? $$.currentWidth - legendWidth : $$.isLegendInset ? insetLegendPosition.left : 0
        };
    };
    c3_chart_internal_fn.transformLegend = function (withTransition) {
        var $$ = this;
        (withTransition ? $$.legend.transition() : $$.legend).attr("transform", $$.getTranslate('legend'));
    };
    c3_chart_internal_fn.updateLegendStep = function (step) {
        this.legendStep = step;
    };
    c3_chart_internal_fn.updateLegendItemWidth = function (w) {
        this.legendItemWidth = w;
    };
    c3_chart_internal_fn.updateLegendItemHeight = function (h) {
        this.legendItemHeight = h;
    };
    c3_chart_internal_fn.getLegendWidth = function () {
        var $$ = this;
        return $$.config.legend_show ? $$.isLegendRight || $$.isLegendInset ? $$.legendItemWidth * ($$.legendStep + 1) : $$.currentWidth : 0;
    };
    c3_chart_internal_fn.getLegendHeight = function () {
        var $$ = this,
            h = 0;
        if ($$.config.legend_show) {
            if ($$.isLegendRight) {
                h = $$.currentHeight;
            } else {
                h = Math.max(20, $$.legendItemHeight) * ($$.legendStep + 1);
            }
        }
        return h;
    };
    c3_chart_internal_fn.opacityForLegend = function (legendItem) {
        return legendItem.classed(CLASS.legendItemHidden) ? null : 1;
    };
    c3_chart_internal_fn.opacityForUnfocusedLegend = function (legendItem) {
        return legendItem.classed(CLASS.legendItemHidden) ? null : 0.3;
    };
    c3_chart_internal_fn.toggleFocusLegend = function (targetIds, focus) {
        var $$ = this;
        targetIds = $$.mapToTargetIds(targetIds);
        $$.legend.selectAll('.' + CLASS.legendItem).filter(function (id) {
            return targetIds.indexOf(id) >= 0;
        }).classed(CLASS.legendItemFocused, focus).transition().duration(100).style('opacity', function () {
            var opacity = focus ? $$.opacityForLegend : $$.opacityForUnfocusedLegend;
            return opacity.call($$, $$.d3.select(this));
        });
    };
    c3_chart_internal_fn.revertLegend = function () {
        var $$ = this,
            d3 = $$.d3;
        $$.legend.selectAll('.' + CLASS.legendItem).classed(CLASS.legendItemFocused, false).transition().duration(100).style('opacity', function () {
            return $$.opacityForLegend(d3.select(this));
        });
    };
    c3_chart_internal_fn.showLegend = function (targetIds) {
        var $$ = this,
            config = $$.config;
        if (!config.legend_show) {
            config.legend_show = true;
            $$.legend.style('visibility', 'visible');
            if (!$$.legendHasRendered) {
                $$.updateLegendWithDefaults();
            }
        }
        $$.removeHiddenLegendIds(targetIds);
        $$.legend.selectAll($$.selectorLegends(targetIds)).style('visibility', 'visible').transition().style('opacity', function () {
            return $$.opacityForLegend($$.d3.select(this));
        });
    };
    c3_chart_internal_fn.hideLegend = function (targetIds) {
        var $$ = this,
            config = $$.config;
        if (config.legend_show && isEmpty(targetIds)) {
            config.legend_show = false;
            $$.legend.style('visibility', 'hidden');
        }
        $$.addHiddenLegendIds(targetIds);
        $$.legend.selectAll($$.selectorLegends(targetIds)).style('opacity', 0).style('visibility', 'hidden');
    };
    c3_chart_internal_fn.clearLegendItemTextBoxCache = function () {
        this.legendItemTextBox = {};
    };
    c3_chart_internal_fn.updateLegend = function (targetIds, options, transitions) {
        var $$ = this,
            config = $$.config;
        var xForLegend, xForLegendText, xForLegendRect, yForLegend, yForLegendText, yForLegendRect, x1ForLegendTile, x2ForLegendTile, yForLegendTile;
        var paddingTop = 4,
            paddingRight = 10,
            maxWidth = 0,
            maxHeight = 0,
            posMin = 10,
            tileWidth = config.legend_item_tile_width + 5;
        var l,
            totalLength = 0,
            offsets = {},
            widths = {},
            heights = {},
            margins = [0],
            steps = {},
            step = 0;
        var withTransition, withTransitionForTransform;
        var texts, rects, tiles, background;

        // Skip elements when their name is set to null
        targetIds = targetIds.filter(function (id) {
            return !isDefined(config.data_names[id]) || config.data_names[id] !== null;
        });

        options = options || {};
        withTransition = getOption(options, "withTransition", true);
        withTransitionForTransform = getOption(options, "withTransitionForTransform", true);

        function getTextBox(textElement, id) {
            if (!$$.legendItemTextBox[id]) {
                $$.legendItemTextBox[id] = $$.getTextRect(textElement.textContent, CLASS.legendItem, textElement);
            }
            return $$.legendItemTextBox[id];
        }

        function updatePositions(textElement, id, index) {
            var reset = index === 0,
                isLast = index === targetIds.length - 1,
                box = getTextBox(textElement, id),
                itemWidth = box.width + tileWidth + (isLast && !($$.isLegendRight || $$.isLegendInset) ? 0 : paddingRight) + config.legend_padding,
                itemHeight = box.height + paddingTop,
                itemLength = $$.isLegendRight || $$.isLegendInset ? itemHeight : itemWidth,
                areaLength = $$.isLegendRight || $$.isLegendInset ? $$.getLegendHeight() : $$.getLegendWidth(),
                margin,
                maxLength;

            // MEMO: care about condifion of step, totalLength
            function updateValues(id, withoutStep) {
                if (!withoutStep) {
                    margin = (areaLength - totalLength - itemLength) / 2;
                    if (margin < posMin) {
                        margin = (areaLength - itemLength) / 2;
                        totalLength = 0;
                        step++;
                    }
                }
                steps[id] = step;
                margins[step] = $$.isLegendInset ? 10 : margin;
                offsets[id] = totalLength;
                totalLength += itemLength;
            }

            if (reset) {
                totalLength = 0;
                step = 0;
                maxWidth = 0;
                maxHeight = 0;
            }

            if (config.legend_show && !$$.isLegendToShow(id)) {
                widths[id] = heights[id] = steps[id] = offsets[id] = 0;
                return;
            }

            widths[id] = itemWidth;
            heights[id] = itemHeight;

            if (!maxWidth || itemWidth >= maxWidth) {
                maxWidth = itemWidth;
            }
            if (!maxHeight || itemHeight >= maxHeight) {
                maxHeight = itemHeight;
            }
            maxLength = $$.isLegendRight || $$.isLegendInset ? maxHeight : maxWidth;

            if (config.legend_equally) {
                Object.keys(widths).forEach(function (id) {
                    widths[id] = maxWidth;
                });
                Object.keys(heights).forEach(function (id) {
                    heights[id] = maxHeight;
                });
                margin = (areaLength - maxLength * targetIds.length) / 2;
                if (margin < posMin) {
                    totalLength = 0;
                    step = 0;
                    targetIds.forEach(function (id) {
                        updateValues(id);
                    });
                } else {
                    updateValues(id, true);
                }
            } else {
                updateValues(id);
            }
        }

        if ($$.isLegendInset) {
            step = config.legend_inset_step ? config.legend_inset_step : targetIds.length;
            $$.updateLegendStep(step);
        }

        if ($$.isLegendRight) {
            xForLegend = function xForLegend(id) {
                return maxWidth * steps[id];
            };
            yForLegend = function yForLegend(id) {
                return margins[steps[id]] + offsets[id];
            };
        } else if ($$.isLegendInset) {
            xForLegend = function xForLegend(id) {
                return maxWidth * steps[id] + 10;
            };
            yForLegend = function yForLegend(id) {
                return margins[steps[id]] + offsets[id];
            };
        } else {
            xForLegend = function xForLegend(id) {
                return margins[steps[id]] + offsets[id];
            };
            yForLegend = function yForLegend(id) {
                return maxHeight * steps[id];
            };
        }
        xForLegendText = function xForLegendText(id, i) {
            return xForLegend(id, i) + 4 + config.legend_item_tile_width;
        };
        yForLegendText = function yForLegendText(id, i) {
            return yForLegend(id, i) + 9;
        };
        xForLegendRect = function xForLegendRect(id, i) {
            return xForLegend(id, i);
        };
        yForLegendRect = function yForLegendRect(id, i) {
            return yForLegend(id, i) - 5;
        };
        x1ForLegendTile = function x1ForLegendTile(id, i) {
            return xForLegend(id, i) - 2;
        };
        x2ForLegendTile = function x2ForLegendTile(id, i) {
            return xForLegend(id, i) - 2 + config.legend_item_tile_width;
        };
        yForLegendTile = function yForLegendTile(id, i) {
            return yForLegend(id, i) + 4;
        };

        // Define g for legend area
        l = $$.legend.selectAll('.' + CLASS.legendItem).data(targetIds).enter().append('g').attr('class', function (id) {
            return $$.generateClass(CLASS.legendItem, id);
        }).style('visibility', function (id) {
            return $$.isLegendToShow(id) ? 'visible' : 'hidden';
        }).style('cursor', 'pointer').on('click', function (id) {
            if (config.legend_item_onclick) {
                config.legend_item_onclick.call($$, id);
            } else {
                if ($$.d3.event.altKey) {
                    $$.api.hide();
                    $$.api.show(id);
                } else {
                    $$.api.toggle(id);
                    $$.isTargetToShow(id) ? $$.api.focus(id) : $$.api.revert();
                }
            }
        }).on('mouseover', function (id) {
            if (config.legend_item_onmouseover) {
                config.legend_item_onmouseover.call($$, id);
            } else {
                $$.d3.select(this).classed(CLASS.legendItemFocused, true);
                if (!$$.transiting && $$.isTargetToShow(id)) {
                    $$.api.focus(id);
                }
            }
        }).on('mouseout', function (id) {
            if (config.legend_item_onmouseout) {
                config.legend_item_onmouseout.call($$, id);
            } else {
                $$.d3.select(this).classed(CLASS.legendItemFocused, false);
                $$.api.revert();
            }
        });
        l.append('text').text(function (id) {
            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
        }).each(function (id, i) {
            updatePositions(this, id, i);
        }).style("pointer-events", "none").attr('x', $$.isLegendRight || $$.isLegendInset ? xForLegendText : -200).attr('y', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendText);
        l.append('rect').attr("class", CLASS.legendItemEvent).style('fill-opacity', 0).attr('x', $$.isLegendRight || $$.isLegendInset ? xForLegendRect : -200).attr('y', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendRect);
        l.append('line').attr('class', CLASS.legendItemTile).style('stroke', $$.color).style("pointer-events", "none").attr('x1', $$.isLegendRight || $$.isLegendInset ? x1ForLegendTile : -200).attr('y1', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr('x2', $$.isLegendRight || $$.isLegendInset ? x2ForLegendTile : -200).attr('y2', $$.isLegendRight || $$.isLegendInset ? -200 : yForLegendTile).attr('stroke-width', config.legend_item_tile_height);

        // Set background for inset legend
        background = $$.legend.select('.' + CLASS.legendBackground + ' rect');
        if ($$.isLegendInset && maxWidth > 0 && background.size() === 0) {
            background = $$.legend.insert('g', '.' + CLASS.legendItem).attr("class", CLASS.legendBackground).append('rect');
        }

        texts = $$.legend.selectAll('text').data(targetIds).text(function (id) {
            return isDefined(config.data_names[id]) ? config.data_names[id] : id;
        }) // MEMO: needed for update
        .each(function (id, i) {
            updatePositions(this, id, i);
        });
        (withTransition ? texts.transition() : texts).attr('x', xForLegendText).attr('y', yForLegendText);

        rects = $$.legend.selectAll('rect.' + CLASS.legendItemEvent).data(targetIds);
        (withTransition ? rects.transition() : rects).attr('width', function (id) {
            return widths[id];
        }).attr('height', function (id) {
            return heights[id];
        }).attr('x', xForLegendRect).attr('y', yForLegendRect);

        tiles = $$.legend.selectAll('line.' + CLASS.legendItemTile).data(targetIds);
        (withTransition ? tiles.transition() : tiles).style('stroke', $$.levelColor ? function (id) {
            return $$.levelColor($$.cache[id].values[0].value);
        } : $$.color).attr('x1', x1ForLegendTile).attr('y1', yForLegendTile).attr('x2', x2ForLegendTile).attr('y2', yForLegendTile);

        if (background) {
            (withTransition ? background.transition() : background).attr('height', $$.getLegendHeight() - 12).attr('width', maxWidth * (step + 1) + 10);
        }

        // toggle legend state
        $$.legend.selectAll('.' + CLASS.legendItem).classed(CLASS.legendItemHidden, function (id) {
            return !$$.isTargetToShow(id);
        });

        // Update all to reflect change of legend
        $$.updateLegendItemWidth(maxWidth);
        $$.updateLegendItemHeight(maxHeight);
        $$.updateLegendStep(step);
        // Update size and scale
        $$.updateSizes();
        $$.updateScales();
        $$.updateSvgSize();
        // Update g positions
        $$.transformAll(withTransitionForTransform, transitions);
        $$.legendHasRendered = true;
    };

    c3_chart_internal_fn.initRegion = function () {
        var $$ = this;
        $$.region = $$.main.append('g').attr("clip-path", $$.clipPath).attr("class", CLASS.regions);
    };
    c3_chart_internal_fn.updateRegion = function (duration) {
        var $$ = this,
            config = $$.config;

        // hide if arc type
        $$.region.style('visibility', $$.hasArcType() ? 'hidden' : 'visible');

        $$.mainRegion = $$.main.select('.' + CLASS.regions).selectAll('.' + CLASS.region).data(config.regions);
        $$.mainRegion.enter().append('g').append('rect').style("fill-opacity", 0);
        $$.mainRegion.attr('class', $$.classRegion.bind($$));
        $$.mainRegion.exit().transition().duration(duration).style("opacity", 0).remove();
    };
    c3_chart_internal_fn.redrawRegion = function (withTransition) {
        var $$ = this,
            regions = $$.mainRegion.selectAll('rect').each(function () {
            // data is binded to g and it's not transferred to rect (child node) automatically,
            // then data of each rect has to be updated manually.
            // TODO: there should be more efficient way to solve this?
            var parentData = $$.d3.select(this.parentNode).datum();
            $$.d3.select(this).datum(parentData);
        }),
            x = $$.regionX.bind($$),
            y = $$.regionY.bind($$),
            w = $$.regionWidth.bind($$),
            h = $$.regionHeight.bind($$);
        return [(withTransition ? regions.transition() : regions).attr("x", x).attr("y", y).attr("width", w).attr("height", h).style("fill-opacity", function (d) {
            return isValue(d.opacity) ? d.opacity : 0.1;
        })];
    };
    c3_chart_internal_fn.regionX = function (d) {
        var $$ = this,
            config = $$.config,
            xPos,
            yScale = d.axis === 'y' ? $$.y : $$.y2;
        if (d.axis === 'y' || d.axis === 'y2') {
            xPos = config.axis_rotated ? 'start' in d ? yScale(d.start) : 0 : 0;
        } else {
            xPos = config.axis_rotated ? 0 : 'start' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0;
        }
        return xPos;
    };
    c3_chart_internal_fn.regionY = function (d) {
        var $$ = this,
            config = $$.config,
            yPos,
            yScale = d.axis === 'y' ? $$.y : $$.y2;
        if (d.axis === 'y' || d.axis === 'y2') {
            yPos = config.axis_rotated ? 0 : 'end' in d ? yScale(d.end) : 0;
        } else {
            yPos = config.axis_rotated ? 'start' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.start) : d.start) : 0 : 0;
        }
        return yPos;
    };
    c3_chart_internal_fn.regionWidth = function (d) {
        var $$ = this,
            config = $$.config,
            start = $$.regionX(d),
            end,
            yScale = d.axis === 'y' ? $$.y : $$.y2;
        if (d.axis === 'y' || d.axis === 'y2') {
            end = config.axis_rotated ? 'end' in d ? yScale(d.end) : $$.width : $$.width;
        } else {
            end = config.axis_rotated ? $$.width : 'end' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.width;
        }
        return end < start ? 0 : end - start;
    };
    c3_chart_internal_fn.regionHeight = function (d) {
        var $$ = this,
            config = $$.config,
            start = this.regionY(d),
            end,
            yScale = d.axis === 'y' ? $$.y : $$.y2;
        if (d.axis === 'y' || d.axis === 'y2') {
            end = config.axis_rotated ? $$.height : 'start' in d ? yScale(d.start) : $$.height;
        } else {
            end = config.axis_rotated ? 'end' in d ? $$.x($$.isTimeSeries() ? $$.parseDate(d.end) : d.end) : $$.height : $$.height;
        }
        return end < start ? 0 : end - start;
    };
    c3_chart_internal_fn.isRegionOnX = function (d) {
        return !d.axis || d.axis === 'x';
    };

    c3_chart_internal_fn.getScale = function (min, max, forTimeseries) {
        return (forTimeseries ? this.d3.time.scale() : this.d3.scale.linear()).range([min, max]);
    };
    c3_chart_internal_fn.getX = function (min, max, domain, offset) {
        var $$ = this,
            scale = $$.getScale(min, max, $$.isTimeSeries()),
            _scale = domain ? scale.domain(domain) : scale,
            key;
        // Define customized scale if categorized axis
        if ($$.isCategorized()) {
            offset = offset || function () {
                return 0;
            };
            scale = function scale(d, raw) {
                var v = _scale(d) + offset(d);
                return raw ? v : Math.ceil(v);
            };
        } else {
            scale = function scale(d, raw) {
                var v = _scale(d);
                return raw ? v : Math.ceil(v);
            };
        }
        // define functions
        for (key in _scale) {
            scale[key] = _scale[key];
        }
        scale.orgDomain = function () {
            return _scale.domain();
        };
        // define custom domain() for categorized axis
        if ($$.isCategorized()) {
            scale.domain = function (domain) {
                if (!arguments.length) {
                    domain = this.orgDomain();
                    return [domain[0], domain[1] + 1];
                }
                _scale.domain(domain);
                return scale;
            };
        }
        return scale;
    };
    c3_chart_internal_fn.getY = function (min, max, domain) {
        var scale = this.getScale(min, max, this.isTimeSeriesY());
        if (domain) {
            scale.domain(domain);
        }
        return scale;
    };
    c3_chart_internal_fn.getYScale = function (id) {
        return this.axis.getId(id) === 'y2' ? this.y2 : this.y;
    };
    c3_chart_internal_fn.getSubYScale = function (id) {
        return this.axis.getId(id) === 'y2' ? this.subY2 : this.subY;
    };
    c3_chart_internal_fn.updateScales = function () {
        var $$ = this,
            config = $$.config,
            forInit = !$$.x;
        // update edges
        $$.xMin = config.axis_rotated ? 1 : 0;
        $$.xMax = config.axis_rotated ? $$.height : $$.width;
        $$.yMin = config.axis_rotated ? 0 : $$.height;
        $$.yMax = config.axis_rotated ? $$.width : 1;
        $$.subXMin = $$.xMin;
        $$.subXMax = $$.xMax;
        $$.subYMin = config.axis_rotated ? 0 : $$.height2;
        $$.subYMax = config.axis_rotated ? $$.width2 : 1;
        // update scales
        $$.x = $$.getX($$.xMin, $$.xMax, forInit ? undefined : $$.x.orgDomain(), function () {
            return $$.xAxis.tickOffset();
        });
        $$.y = $$.getY($$.yMin, $$.yMax, forInit ? config.axis_y_default : $$.y.domain());
        $$.y2 = $$.getY($$.yMin, $$.yMax, forInit ? config.axis_y2_default : $$.y2.domain());
        $$.subX = $$.getX($$.xMin, $$.xMax, $$.orgXDomain, function (d) {
            return d % 1 ? 0 : $$.subXAxis.tickOffset();
        });
        $$.subY = $$.getY($$.subYMin, $$.subYMax, forInit ? config.axis_y_default : $$.subY.domain());
        $$.subY2 = $$.getY($$.subYMin, $$.subYMax, forInit ? config.axis_y2_default : $$.subY2.domain());
        // update axes
        $$.xAxisTickFormat = $$.axis.getXAxisTickFormat();
        $$.xAxisTickValues = $$.axis.getXAxisTickValues();
        $$.yAxisTickValues = $$.axis.getYAxisTickValues();
        $$.y2AxisTickValues = $$.axis.getY2AxisTickValues();

        $$.xAxis = $$.axis.getXAxis($$.x, $$.xOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
        $$.subXAxis = $$.axis.getXAxis($$.subX, $$.subXOrient, $$.xAxisTickFormat, $$.xAxisTickValues, config.axis_x_tick_outer);
        $$.yAxis = $$.axis.getYAxis($$.y, $$.yOrient, config.axis_y_tick_format, $$.yAxisTickValues, config.axis_y_tick_outer);
        $$.y2Axis = $$.axis.getYAxis($$.y2, $$.y2Orient, config.axis_y2_tick_format, $$.y2AxisTickValues, config.axis_y2_tick_outer);

        // Set initialized scales to brush and zoom
        if (!forInit) {
            if ($$.brush) {
                $$.brush.scale($$.subX);
            }
            if (config.zoom_enabled) {
                $$.zoom.scale($$.x);
            }
        }
        // update for arc
        if ($$.updateArc) {
            $$.updateArc();
        }
    };

    c3_chart_internal_fn.selectPoint = function (target, d, i) {
        var $$ = this,
            config = $$.config,
            cx = (config.axis_rotated ? $$.circleY : $$.circleX).bind($$),
            cy = (config.axis_rotated ? $$.circleX : $$.circleY).bind($$),
            r = $$.pointSelectR.bind($$);
        config.data_onselected.call($$.api, d, target.node());
        // add selected-circle on low layer g
        $$.main.select('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll('.' + CLASS.selectedCircle + '-' + i).data([d]).enter().append('circle').attr("class", function () {
            return $$.generateClass(CLASS.selectedCircle, i);
        }).attr("cx", cx).attr("cy", cy).attr("stroke", function () {
            return $$.color(d);
        }).attr("r", function (d) {
            return $$.pointSelectR(d) * 1.4;
        }).transition().duration(100).attr("r", r);
    };
    c3_chart_internal_fn.unselectPoint = function (target, d, i) {
        var $$ = this;
        $$.config.data_onunselected.call($$.api, d, target.node());
        // remove selected-circle from low layer g
        $$.main.select('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(d.id)).selectAll('.' + CLASS.selectedCircle + '-' + i).transition().duration(100).attr('r', 0).remove();
    };
    c3_chart_internal_fn.togglePoint = function (selected, target, d, i) {
        selected ? this.selectPoint(target, d, i) : this.unselectPoint(target, d, i);
    };
    c3_chart_internal_fn.selectPath = function (target, d) {
        var $$ = this;
        $$.config.data_onselected.call($$, d, target.node());
        if ($$.config.interaction_brighten) {
            target.transition().duration(100).style("fill", function () {
                return $$.d3.rgb($$.color(d)).brighter(0.75);
            });
        }
    };
    c3_chart_internal_fn.unselectPath = function (target, d) {
        var $$ = this;
        $$.config.data_onunselected.call($$, d, target.node());
        if ($$.config.interaction_brighten) {
            target.transition().duration(100).style("fill", function () {
                return $$.color(d);
            });
        }
    };
    c3_chart_internal_fn.togglePath = function (selected, target, d, i) {
        selected ? this.selectPath(target, d, i) : this.unselectPath(target, d, i);
    };
    c3_chart_internal_fn.getToggle = function (that, d) {
        var $$ = this,
            toggle;
        if (that.nodeName === 'circle') {
            if ($$.isStepType(d)) {
                // circle is hidden in step chart, so treat as within the click area
                toggle = function toggle() {}; // TODO: how to select step chart?
            } else {
                toggle = $$.togglePoint;
            }
        } else if (that.nodeName === 'path') {
            toggle = $$.togglePath;
        }
        return toggle;
    };
    c3_chart_internal_fn.toggleShape = function (that, d, i) {
        var $$ = this,
            d3 = $$.d3,
            config = $$.config,
            shape = d3.select(that),
            isSelected = shape.classed(CLASS.SELECTED),
            toggle = $$.getToggle(that, d).bind($$);

        if (config.data_selection_enabled && config.data_selection_isselectable(d)) {
            if (!config.data_selection_multiple) {
                $$.main.selectAll('.' + CLASS.shapes + (config.data_selection_grouped ? $$.getTargetSelectorSuffix(d.id) : "")).selectAll('.' + CLASS.shape).each(function (d, i) {
                    var shape = d3.select(this);
                    if (shape.classed(CLASS.SELECTED)) {
                        toggle(false, shape.classed(CLASS.SELECTED, false), d, i);
                    }
                });
            }
            shape.classed(CLASS.SELECTED, !isSelected);
            toggle(!isSelected, shape, d, i);
        }
    };

    c3_chart_internal_fn.initBar = function () {
        var $$ = this;
        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartBars);
    };
    c3_chart_internal_fn.updateTargetsForBar = function (targets) {
        var $$ = this,
            config = $$.config,
            mainBarUpdate,
            mainBarEnter,
            classChartBar = $$.classChartBar.bind($$),
            classBars = $$.classBars.bind($$),
            classFocus = $$.classFocus.bind($$);
        mainBarUpdate = $$.main.select('.' + CLASS.chartBars).selectAll('.' + CLASS.chartBar).data(targets).attr('class', function (d) {
            return classChartBar(d) + classFocus(d);
        });
        mainBarEnter = mainBarUpdate.enter().append('g').attr('class', classChartBar).style("pointer-events", "none");
        // Bars for each data
        mainBarEnter.append('g').attr("class", classBars).style("cursor", function (d) {
            return config.data_selection_isselectable(d) ? "pointer" : null;
        });
    };
    c3_chart_internal_fn.updateBar = function (durationForExit) {
        var $$ = this,
            barData = $$.barData.bind($$),
            classBar = $$.classBar.bind($$),
            initialOpacity = $$.initialOpacity.bind($$),
            color = function color(d) {
            return $$.color(d.id);
        };
        $$.mainBar = $$.main.selectAll('.' + CLASS.bars).selectAll('.' + CLASS.bar).data(barData);
        $$.mainBar.enter().append('path').attr("class", classBar).style("stroke", color).style("fill", color);
        $$.mainBar.style("opacity", initialOpacity);
        $$.mainBar.exit().transition().duration(durationForExit).remove();
    };
    c3_chart_internal_fn.redrawBar = function (drawBar, withTransition) {
        return [(withTransition ? this.mainBar.transition(Math.random().toString()) : this.mainBar).attr('d', drawBar).style("stroke", this.color).style("fill", this.color).style("opacity", 1)];
    };
    c3_chart_internal_fn.getBarW = function (axis, barTargetsNum) {
        var $$ = this,
            config = $$.config,
            w = typeof config.bar_width === 'number' ? config.bar_width : barTargetsNum ? axis.tickInterval() * config.bar_width_ratio / barTargetsNum : 0;
        return config.bar_width_max && w > config.bar_width_max ? config.bar_width_max : w;
    };
    c3_chart_internal_fn.getBars = function (i, id) {
        var $$ = this;
        return (id ? $$.main.selectAll('.' + CLASS.bars + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll('.' + CLASS.bar + (isValue(i) ? '-' + i : ''));
    };
    c3_chart_internal_fn.expandBars = function (i, id, reset) {
        var $$ = this;
        if (reset) {
            $$.unexpandBars();
        }
        $$.getBars(i, id).classed(CLASS.EXPANDED, true);
    };
    c3_chart_internal_fn.unexpandBars = function (i) {
        var $$ = this;
        $$.getBars(i).classed(CLASS.EXPANDED, false);
    };
    c3_chart_internal_fn.generateDrawBar = function (barIndices, isSub) {
        var $$ = this,
            config = $$.config,
            getPoints = $$.generateGetBarPoints(barIndices, isSub);
        return function (d, i) {
            // 4 points that make a bar
            var points = getPoints(d, i);

            // switch points if axis is rotated, not applicable for sub chart
            var indexX = config.axis_rotated ? 1 : 0;
            var indexY = config.axis_rotated ? 0 : 1;

            var path = 'M ' + points[0][indexX] + ',' + points[0][indexY] + ' ' + 'L' + points[1][indexX] + ',' + points[1][indexY] + ' ' + 'L' + points[2][indexX] + ',' + points[2][indexY] + ' ' + 'L' + points[3][indexX] + ',' + points[3][indexY] + ' ' + 'z';

            return path;
        };
    };
    c3_chart_internal_fn.generateGetBarPoints = function (barIndices, isSub) {
        var $$ = this,
            axis = isSub ? $$.subXAxis : $$.xAxis,
            barTargetsNum = barIndices.__max__ + 1,
            barW = $$.getBarW(axis, barTargetsNum),
            barX = $$.getShapeX(barW, barTargetsNum, barIndices, !!isSub),
            barY = $$.getShapeY(!!isSub),
            barOffset = $$.getShapeOffset($$.isBarType, barIndices, !!isSub),
            barSpaceOffset = barW * ($$.config.bar_space / 2),
            yScale = isSub ? $$.getSubYScale : $$.getYScale;
        return function (d, i) {
            var y0 = yScale.call($$, d.id)(0),
                offset = barOffset(d, i) || y0,
                // offset is for stacked bar chart
            posX = barX(d),
                posY = barY(d);
            // fix posY not to overflow opposite quadrant
            if ($$.config.axis_rotated) {
                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
                    posY = y0;
                }
            }
            // 4 points that make a bar
            return [[posX + barSpaceOffset, offset], [posX + barSpaceOffset, posY - (y0 - offset)], [posX + barW - barSpaceOffset, posY - (y0 - offset)], [posX + barW - barSpaceOffset, offset]];
        };
    };
    c3_chart_internal_fn.isWithinBar = function (that) {
        var mouse = this.d3.mouse(that),
            box = that.getBoundingClientRect(),
            seg0 = that.pathSegList.getItem(0),
            seg1 = that.pathSegList.getItem(1),
            x = Math.min(seg0.x, seg1.x),
            y = Math.min(seg0.y, seg1.y),
            w = box.width,
            h = box.height,
            offset = 2,
            sx = x - offset,
            ex = x + w + offset,
            sy = y + h + offset,
            ey = y - offset;
        return sx < mouse[0] && mouse[0] < ex && ey < mouse[1] && mouse[1] < sy;
    };

    c3_chart_internal_fn.getShapeIndices = function (typeFilter) {
        var $$ = this,
            config = $$.config,
            indices = {},
            i = 0,
            j,
            k;
        $$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$)).forEach(function (d) {
            for (j = 0; j < config.data_groups.length; j++) {
                if (config.data_groups[j].indexOf(d.id) < 0) {
                    continue;
                }
                for (k = 0; k < config.data_groups[j].length; k++) {
                    if (config.data_groups[j][k] in indices) {
                        indices[d.id] = indices[config.data_groups[j][k]];
                        break;
                    }
                }
            }
            if (isUndefined(indices[d.id])) {
                indices[d.id] = i++;
            }
        });
        indices.__max__ = i - 1;
        return indices;
    };
    c3_chart_internal_fn.getShapeX = function (offset, targetsNum, indices, isSub) {
        var $$ = this,
            scale = isSub ? $$.subX : $$.x;
        return function (d) {
            var index = d.id in indices ? indices[d.id] : 0;
            return d.x || d.x === 0 ? scale(d.x) - offset * (targetsNum / 2 - index) : 0;
        };
    };
    c3_chart_internal_fn.getShapeY = function (isSub) {
        var $$ = this;
        return function (d) {
            var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id);
            return scale(d.value);
        };
    };
    c3_chart_internal_fn.getShapeOffset = function (typeFilter, indices, isSub) {
        var $$ = this,
            targets = $$.orderTargets($$.filterTargetsToShow($$.data.targets.filter(typeFilter, $$))),
            targetIds = targets.map(function (t) {
            return t.id;
        });
        return function (d, i) {
            var scale = isSub ? $$.getSubYScale(d.id) : $$.getYScale(d.id),
                y0 = scale(0),
                offset = y0;
            targets.forEach(function (t) {
                var values = $$.isStepType(d) ? $$.convertValuesToStep(t.values) : t.values;
                if (t.id === d.id || indices[t.id] !== indices[d.id]) {
                    return;
                }
                if (targetIds.indexOf(t.id) < targetIds.indexOf(d.id)) {
                    // check if the x values line up
                    if (typeof values[i] === 'undefined' || +values[i].x !== +d.x) {
                        // "+" for timeseries
                        // if not, try to find the value that does line up
                        i = -1;
                        values.forEach(function (v, j) {
                            if (v.x === d.x) {
                                i = j;
                            }
                        });
                    }
                    if (i in values && values[i].value * d.value >= 0) {
                        offset += scale(values[i].value) - y0;
                    }
                }
            });
            return offset;
        };
    };
    c3_chart_internal_fn.isWithinShape = function (that, d) {
        var $$ = this,
            shape = $$.d3.select(that),
            isWithin;
        if (!$$.isTargetToShow(d.id)) {
            isWithin = false;
        } else if (that.nodeName === 'circle') {
            isWithin = $$.isStepType(d) ? $$.isWithinStep(that, $$.getYScale(d.id)(d.value)) : $$.isWithinCircle(that, $$.pointSelectR(d) * 1.5);
        } else if (that.nodeName === 'path') {
            isWithin = shape.classed(CLASS.bar) ? $$.isWithinBar(that) : true;
        }
        return isWithin;
    };

    c3_chart_internal_fn.getInterpolate = function (d) {
        var $$ = this,
            interpolation = $$.isInterpolationType($$.config.spline_interpolation_type) ? $$.config.spline_interpolation_type : 'cardinal';
        return $$.isSplineType(d) ? interpolation : $$.isStepType(d) ? $$.config.line_step_type : "linear";
    };

    c3_chart_internal_fn.initLine = function () {
        var $$ = this;
        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartLines);
    };
    c3_chart_internal_fn.updateTargetsForLine = function (targets) {
        var $$ = this,
            config = $$.config,
            mainLineUpdate,
            mainLineEnter,
            classChartLine = $$.classChartLine.bind($$),
            classLines = $$.classLines.bind($$),
            classAreas = $$.classAreas.bind($$),
            classCircles = $$.classCircles.bind($$),
            classFocus = $$.classFocus.bind($$);
        mainLineUpdate = $$.main.select('.' + CLASS.chartLines).selectAll('.' + CLASS.chartLine).data(targets).attr('class', function (d) {
            return classChartLine(d) + classFocus(d);
        });
        mainLineEnter = mainLineUpdate.enter().append('g').attr('class', classChartLine).style('opacity', 0).style("pointer-events", "none");
        // Lines for each data
        mainLineEnter.append('g').attr("class", classLines);
        // Areas
        mainLineEnter.append('g').attr('class', classAreas);
        // Circles for each data point on lines
        mainLineEnter.append('g').attr("class", function (d) {
            return $$.generateClass(CLASS.selectedCircles, d.id);
        });
        mainLineEnter.append('g').attr("class", classCircles).style("cursor", function (d) {
            return config.data_selection_isselectable(d) ? "pointer" : null;
        });
        // Update date for selected circles
        targets.forEach(function (t) {
            $$.main.selectAll('.' + CLASS.selectedCircles + $$.getTargetSelectorSuffix(t.id)).selectAll('.' + CLASS.selectedCircle).each(function (d) {
                d.value = t.values[d.index].value;
            });
        });
        // MEMO: can not keep same color...
        //mainLineUpdate.exit().remove();
    };
    c3_chart_internal_fn.updateLine = function (durationForExit) {
        var $$ = this;
        $$.mainLine = $$.main.selectAll('.' + CLASS.lines).selectAll('.' + CLASS.line).data($$.lineData.bind($$));
        $$.mainLine.enter().append('path').attr('class', $$.classLine.bind($$)).style("stroke", $$.color);
        $$.mainLine.style("opacity", $$.initialOpacity.bind($$)).style('shape-rendering', function (d) {
            return $$.isStepType(d) ? 'crispEdges' : '';
        }).attr('transform', null);
        $$.mainLine.exit().transition().duration(durationForExit).style('opacity', 0).remove();
    };
    c3_chart_internal_fn.redrawLine = function (drawLine, withTransition) {
        return [(withTransition ? this.mainLine.transition(Math.random().toString()) : this.mainLine).attr("d", drawLine).style("stroke", this.color).style("opacity", 1)];
    };
    c3_chart_internal_fn.generateDrawLine = function (lineIndices, isSub) {
        var $$ = this,
            config = $$.config,
            line = $$.d3.svg.line(),
            getPoints = $$.generateGetLinePoints(lineIndices, isSub),
            yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale,
            xValue = function xValue(d) {
            return (isSub ? $$.subxx : $$.xx).call($$, d);
        },
            yValue = function yValue(d, i) {
            return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)(d.value);
        };

        line = config.axis_rotated ? line.x(yValue).y(xValue) : line.x(xValue).y(yValue);
        if (!config.line_connectNull) {
            line = line.defined(function (d) {
                return d.value != null;
            });
        }
        return function (d) {
            var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values,
                x = isSub ? $$.subX : $$.x,
                y = yScaleGetter.call($$, d.id),
                x0 = 0,
                y0 = 0,
                path;
            if ($$.isLineType(d)) {
                if (config.data_regions[d.id]) {
                    path = $$.lineWithRegions(values, x, y, config.data_regions[d.id]);
                } else {
                    if ($$.isStepType(d)) {
                        values = $$.convertValuesToStep(values);
                    }
                    path = line.interpolate($$.getInterpolate(d))(values);
                }
            } else {
                if (values[0]) {
                    x0 = x(values[0].x);
                    y0 = y(values[0].value);
                }
                path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
            }
            return path ? path : "M 0 0";
        };
    };
    c3_chart_internal_fn.generateGetLinePoints = function (lineIndices, isSub) {
        // partial duplication of generateGetBarPoints
        var $$ = this,
            config = $$.config,
            lineTargetsNum = lineIndices.__max__ + 1,
            x = $$.getShapeX(0, lineTargetsNum, lineIndices, !!isSub),
            y = $$.getShapeY(!!isSub),
            lineOffset = $$.getShapeOffset($$.isLineType, lineIndices, !!isSub),
            yScale = isSub ? $$.getSubYScale : $$.getYScale;
        return function (d, i) {
            var y0 = yScale.call($$, d.id)(0),
                offset = lineOffset(d, i) || y0,
                // offset is for stacked area chart
            posX = x(d),
                posY = y(d);
            // fix posY not to overflow opposite quadrant
            if (config.axis_rotated) {
                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
                    posY = y0;
                }
            }
            // 1 point that marks the line position
            return [[posX, posY - (y0 - offset)], [posX, posY - (y0 - offset)], // needed for compatibility
            [posX, posY - (y0 - offset)], // needed for compatibility
            [posX, posY - (y0 - offset)] // needed for compatibility
            ];
        };
    };

    c3_chart_internal_fn.lineWithRegions = function (d, x, y, _regions) {
        var $$ = this,
            config = $$.config,
            prev = -1,
            i,
            j,
            s = "M",
            sWithRegion,
            xp,
            yp,
            dx,
            dy,
            dd,
            diff,
            diffx2,
            xOffset = $$.isCategorized() ? 0.5 : 0,
            xValue,
            yValue,
            regions = [];

        function isWithinRegions(x, regions) {
            var i;
            for (i = 0; i < regions.length; i++) {
                if (regions[i].start < x && x <= regions[i].end) {
                    return true;
                }
            }
            return false;
        }

        // Check start/end of regions
        if (isDefined(_regions)) {
            for (i = 0; i < _regions.length; i++) {
                regions[i] = {};
                if (isUndefined(_regions[i].start)) {
                    regions[i].start = d[0].x;
                } else {
                    regions[i].start = $$.isTimeSeries() ? $$.parseDate(_regions[i].start) : _regions[i].start;
                }
                if (isUndefined(_regions[i].end)) {
                    regions[i].end = d[d.length - 1].x;
                } else {
                    regions[i].end = $$.isTimeSeries() ? $$.parseDate(_regions[i].end) : _regions[i].end;
                }
            }
        }

        // Set scales
        xValue = config.axis_rotated ? function (d) {
            return y(d.value);
        } : function (d) {
            return x(d.x);
        };
        yValue = config.axis_rotated ? function (d) {
            return x(d.x);
        } : function (d) {
            return y(d.value);
        };

        // Define svg generator function for region
        function generateM(points) {
            return 'M' + points[0][0] + ' ' + points[0][1] + ' ' + points[1][0] + ' ' + points[1][1];
        }
        if ($$.isTimeSeries()) {
            sWithRegion = function sWithRegion(d0, d1, j, diff) {
                var x0 = d0.x.getTime(),
                    x_diff = d1.x - d0.x,
                    xv0 = new Date(x0 + x_diff * j),
                    xv1 = new Date(x0 + x_diff * (j + diff)),
                    points;
                if (config.axis_rotated) {
                    points = [[y(yp(j)), x(xv0)], [y(yp(j + diff)), x(xv1)]];
                } else {
                    points = [[x(xv0), y(yp(j))], [x(xv1), y(yp(j + diff))]];
                }
                return generateM(points);
            };
        } else {
            sWithRegion = function sWithRegion(d0, d1, j, diff) {
                var points;
                if (config.axis_rotated) {
                    points = [[y(yp(j), true), x(xp(j))], [y(yp(j + diff), true), x(xp(j + diff))]];
                } else {
                    points = [[x(xp(j), true), y(yp(j))], [x(xp(j + diff), true), y(yp(j + diff))]];
                }
                return generateM(points);
            };
        }

        // Generate
        for (i = 0; i < d.length; i++) {

            // Draw as normal
            if (isUndefined(regions) || !isWithinRegions(d[i].x, regions)) {
                s += " " + xValue(d[i]) + " " + yValue(d[i]);
            }
            // Draw with region // TODO: Fix for horizotal charts
            else {
                    xp = $$.getScale(d[i - 1].x + xOffset, d[i].x + xOffset, $$.isTimeSeries());
                    yp = $$.getScale(d[i - 1].value, d[i].value);

                    dx = x(d[i].x) - x(d[i - 1].x);
                    dy = y(d[i].value) - y(d[i - 1].value);
                    dd = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    diff = 2 / dd;
                    diffx2 = diff * 2;

                    for (j = diff; j <= 1; j += diffx2) {
                        s += sWithRegion(d[i - 1], d[i], j, diff);
                    }
                }
            prev = d[i].x;
        }

        return s;
    };

    c3_chart_internal_fn.updateArea = function (durationForExit) {
        var $$ = this,
            d3 = $$.d3;
        $$.mainArea = $$.main.selectAll('.' + CLASS.areas).selectAll('.' + CLASS.area).data($$.lineData.bind($$));
        $$.mainArea.enter().append('path').attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function () {
            $$.orgAreaOpacity = +d3.select(this).style('opacity');return 0;
        });
        $$.mainArea.style("opacity", $$.orgAreaOpacity);
        $$.mainArea.exit().transition().duration(durationForExit).style('opacity', 0).remove();
    };
    c3_chart_internal_fn.redrawArea = function (drawArea, withTransition) {
        return [(withTransition ? this.mainArea.transition(Math.random().toString()) : this.mainArea).attr("d", drawArea).style("fill", this.color).style("opacity", this.orgAreaOpacity)];
    };
    c3_chart_internal_fn.generateDrawArea = function (areaIndices, isSub) {
        var $$ = this,
            config = $$.config,
            area = $$.d3.svg.area(),
            getPoints = $$.generateGetAreaPoints(areaIndices, isSub),
            yScaleGetter = isSub ? $$.getSubYScale : $$.getYScale,
            xValue = function xValue(d) {
            return (isSub ? $$.subxx : $$.xx).call($$, d);
        },
            value0 = function value0(d, i) {
            return config.data_groups.length > 0 ? getPoints(d, i)[0][1] : yScaleGetter.call($$, d.id)($$.getAreaBaseValue(d.id));
        },
            value1 = function value1(d, i) {
            return config.data_groups.length > 0 ? getPoints(d, i)[1][1] : yScaleGetter.call($$, d.id)(d.value);
        };

        area = config.axis_rotated ? area.x0(value0).x1(value1).y(xValue) : area.x(xValue).y0(config.area_above ? 0 : value0).y1(value1);
        if (!config.line_connectNull) {
            area = area.defined(function (d) {
                return d.value !== null;
            });
        }

        return function (d) {
            var values = config.line_connectNull ? $$.filterRemoveNull(d.values) : d.values,
                x0 = 0,
                y0 = 0,
                path;
            if ($$.isAreaType(d)) {
                if ($$.isStepType(d)) {
                    values = $$.convertValuesToStep(values);
                }
                path = area.interpolate($$.getInterpolate(d))(values);
            } else {
                if (values[0]) {
                    x0 = $$.x(values[0].x);
                    y0 = $$.getYScale(d.id)(values[0].value);
                }
                path = config.axis_rotated ? "M " + y0 + " " + x0 : "M " + x0 + " " + y0;
            }
            return path ? path : "M 0 0";
        };
    };
    c3_chart_internal_fn.getAreaBaseValue = function () {
        return 0;
    };
    c3_chart_internal_fn.generateGetAreaPoints = function (areaIndices, isSub) {
        // partial duplication of generateGetBarPoints
        var $$ = this,
            config = $$.config,
            areaTargetsNum = areaIndices.__max__ + 1,
            x = $$.getShapeX(0, areaTargetsNum, areaIndices, !!isSub),
            y = $$.getShapeY(!!isSub),
            areaOffset = $$.getShapeOffset($$.isAreaType, areaIndices, !!isSub),
            yScale = isSub ? $$.getSubYScale : $$.getYScale;
        return function (d, i) {
            var y0 = yScale.call($$, d.id)(0),
                offset = areaOffset(d, i) || y0,
                // offset is for stacked area chart
            posX = x(d),
                posY = y(d);
            // fix posY not to overflow opposite quadrant
            if (config.axis_rotated) {
                if (0 < d.value && posY < y0 || d.value < 0 && y0 < posY) {
                    posY = y0;
                }
            }
            // 1 point that marks the area position
            return [[posX, offset], [posX, posY - (y0 - offset)], [posX, posY - (y0 - offset)], // needed for compatibility
            [posX, offset] // needed for compatibility
            ];
        };
    };

    c3_chart_internal_fn.updateCircle = function () {
        var $$ = this;
        $$.mainCircle = $$.main.selectAll('.' + CLASS.circles).selectAll('.' + CLASS.circle).data($$.lineOrScatterData.bind($$));
        $$.mainCircle.enter().append("circle").attr("class", $$.classCircle.bind($$)).attr("r", $$.pointR.bind($$)).style("fill", $$.color);
        $$.mainCircle.style("opacity", $$.initialOpacityForCircle.bind($$));
        $$.mainCircle.exit().remove();
    };
    c3_chart_internal_fn.redrawCircle = function (cx, cy, withTransition) {
        var selectedCircles = this.main.selectAll('.' + CLASS.selectedCircle);
        return [(withTransition ? this.mainCircle.transition(Math.random().toString()) : this.mainCircle).style('opacity', this.opacityForCircle.bind(this)).style("fill", this.color).attr("cx", cx).attr("cy", cy), (withTransition ? selectedCircles.transition(Math.random().toString()) : selectedCircles).attr("cx", cx).attr("cy", cy)];
    };
    c3_chart_internal_fn.circleX = function (d) {
        return d.x || d.x === 0 ? this.x(d.x) : null;
    };
    c3_chart_internal_fn.updateCircleY = function () {
        var $$ = this,
            lineIndices,
            getPoints;
        if ($$.config.data_groups.length > 0) {
            lineIndices = $$.getShapeIndices($$.isLineType), getPoints = $$.generateGetLinePoints(lineIndices);
            $$.circleY = function (d, i) {
                return getPoints(d, i)[0][1];
            };
        } else {
            $$.circleY = function (d) {
                return $$.getYScale(d.id)(d.value);
            };
        }
    };
    c3_chart_internal_fn.getCircles = function (i, id) {
        var $$ = this;
        return (id ? $$.main.selectAll('.' + CLASS.circles + $$.getTargetSelectorSuffix(id)) : $$.main).selectAll('.' + CLASS.circle + (isValue(i) ? '-' + i : ''));
    };
    c3_chart_internal_fn.expandCircles = function (i, id, reset) {
        var $$ = this,
            r = $$.pointExpandedR.bind($$);
        if (reset) {
            $$.unexpandCircles();
        }
        $$.getCircles(i, id).classed(CLASS.EXPANDED, true).attr('r', r);
    };
    c3_chart_internal_fn.unexpandCircles = function (i) {
        var $$ = this,
            r = $$.pointR.bind($$);
        $$.getCircles(i).filter(function () {
            return $$.d3.select(this).classed(CLASS.EXPANDED);
        }).classed(CLASS.EXPANDED, false).attr('r', r);
    };
    c3_chart_internal_fn.pointR = function (d) {
        var $$ = this,
            config = $$.config;
        return $$.isStepType(d) ? 0 : isFunction(config.point_r) ? config.point_r(d) : config.point_r;
    };
    c3_chart_internal_fn.pointExpandedR = function (d) {
        var $$ = this,
            config = $$.config;
        if (config.point_focus_expand_enabled) {
            return isFunction(config.point_focus_expand_r) ? config.point_focus_expand_r(d) : config.point_focus_expand_r ? config.point_focus_expand_r : $$.pointR(d) * 1.75;
        } else {
            return $$.pointR(d);
        }
    };
    c3_chart_internal_fn.pointSelectR = function (d) {
        var $$ = this,
            config = $$.config;
        return isFunction(config.point_select_r) ? config.point_select_r(d) : config.point_select_r ? config.point_select_r : $$.pointR(d) * 4;
    };
    c3_chart_internal_fn.isWithinCircle = function (that, r) {
        var d3 = this.d3,
            mouse = d3.mouse(that),
            d3_this = d3.select(that),
            cx = +d3_this.attr("cx"),
            cy = +d3_this.attr("cy");
        return Math.sqrt(Math.pow(cx - mouse[0], 2) + Math.pow(cy - mouse[1], 2)) < r;
    };
    c3_chart_internal_fn.isWithinStep = function (that, y) {
        return Math.abs(y - this.d3.mouse(that)[1]) < 30;
    };

    c3_chart_internal_fn.getCurrentWidth = function () {
        var $$ = this,
            config = $$.config;
        return config.size_width ? config.size_width : $$.getParentWidth();
    };
    c3_chart_internal_fn.getCurrentHeight = function () {
        var $$ = this,
            config = $$.config,
            h = config.size_height ? config.size_height : $$.getParentHeight();
        return h > 0 ? h : 320 / ($$.hasType('gauge') && !config.gauge_fullCircle ? 2 : 1);
    };
    c3_chart_internal_fn.getCurrentPaddingTop = function () {
        var $$ = this,
            config = $$.config,
            padding = isValue(config.padding_top) ? config.padding_top : 0;
        if ($$.title && $$.title.node()) {
            padding += $$.getTitlePadding();
        }
        return padding;
    };
    c3_chart_internal_fn.getCurrentPaddingBottom = function () {
        var config = this.config;
        return isValue(config.padding_bottom) ? config.padding_bottom : 0;
    };
    c3_chart_internal_fn.getCurrentPaddingLeft = function (withoutRecompute) {
        var $$ = this,
            config = $$.config;
        if (isValue(config.padding_left)) {
            return config.padding_left;
        } else if (config.axis_rotated) {
            return !config.axis_x_show || config.axis_x_inner ? 1 : Math.max(ceil10($$.getAxisWidthByAxisId('x', withoutRecompute)), 40);
        } else if (!config.axis_y_show || config.axis_y_inner) {
            // && !config.axis_rotated
            return $$.axis.getYAxisLabelPosition().isOuter ? 30 : 1;
        } else {
            return ceil10($$.getAxisWidthByAxisId('y', withoutRecompute));
        }
    };
    c3_chart_internal_fn.getCurrentPaddingRight = function () {
        var $$ = this,
            config = $$.config,
            defaultPadding = 10,
            legendWidthOnRight = $$.isLegendRight ? $$.getLegendWidth() + 20 : 0;
        if (isValue(config.padding_right)) {
            return config.padding_right + 1; // 1 is needed not to hide tick line
        } else if (config.axis_rotated) {
            return defaultPadding + legendWidthOnRight;
        } else if (!config.axis_y2_show || config.axis_y2_inner) {
            // && !config.axis_rotated
            return 2 + legendWidthOnRight + ($$.axis.getY2AxisLabelPosition().isOuter ? 20 : 0);
        } else {
            return ceil10($$.getAxisWidthByAxisId('y2')) + legendWidthOnRight;
        }
    };

    c3_chart_internal_fn.getParentRectValue = function (key) {
        var parent = this.selectChart.node(),
            v;
        while (parent && parent.tagName !== 'BODY') {
            try {
                v = parent.getBoundingClientRect()[key];
            } catch (e) {
                if (key === 'width') {
                    // In IE in certain cases getBoundingClientRect
                    // will cause an "unspecified error"
                    v = parent.offsetWidth;
                }
            }
            if (v) {
                break;
            }
            parent = parent.parentNode;
        }
        return v;
    };
    c3_chart_internal_fn.getParentWidth = function () {
        return this.getParentRectValue('width');
    };
    c3_chart_internal_fn.getParentHeight = function () {
        var h = this.selectChart.style('height');
        return h.indexOf('px') > 0 ? +h.replace('px', '') : 0;
    };

    c3_chart_internal_fn.getSvgLeft = function (withoutRecompute) {
        var $$ = this,
            config = $$.config,
            hasLeftAxisRect = config.axis_rotated || !config.axis_rotated && !config.axis_y_inner,
            leftAxisClass = config.axis_rotated ? CLASS.axisX : CLASS.axisY,
            leftAxis = $$.main.select('.' + leftAxisClass).node(),
            svgRect = leftAxis && hasLeftAxisRect ? leftAxis.getBoundingClientRect() : { right: 0 },
            chartRect = $$.selectChart.node().getBoundingClientRect(),
            hasArc = $$.hasArcType(),
            svgLeft = svgRect.right - chartRect.left - (hasArc ? 0 : $$.getCurrentPaddingLeft(withoutRecompute));
        return svgLeft > 0 ? svgLeft : 0;
    };

    c3_chart_internal_fn.getAxisWidthByAxisId = function (id, withoutRecompute) {
        var $$ = this,
            position = $$.axis.getLabelPositionById(id);
        return $$.axis.getMaxTickWidth(id, withoutRecompute) + (position.isInner ? 20 : 40);
    };
    c3_chart_internal_fn.getHorizontalAxisHeight = function (axisId) {
        var $$ = this,
            config = $$.config,
            h = 30;
        if (axisId === 'x' && !config.axis_x_show) {
            return 8;
        }
        if (axisId === 'x' && config.axis_x_height) {
            return config.axis_x_height;
        }
        if (axisId === 'y' && !config.axis_y_show) {
            return config.legend_show && !$$.isLegendRight && !$$.isLegendInset ? 10 : 1;
        }
        if (axisId === 'y2' && !config.axis_y2_show) {
            return $$.rotated_padding_top;
        }
        // Calculate x axis height when tick rotated
        if (axisId === 'x' && !config.axis_rotated && config.axis_x_tick_rotate) {
            h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - config.axis_x_tick_rotate) / 180);
        }
        // Calculate y axis height when tick rotated
        if (axisId === 'y' && config.axis_rotated && config.axis_y_tick_rotate) {
            h = 30 + $$.axis.getMaxTickWidth(axisId) * Math.cos(Math.PI * (90 - config.axis_y_tick_rotate) / 180);
        }
        return h + ($$.axis.getLabelPositionById(axisId).isInner ? 0 : 10) + (axisId === 'y2' ? -10 : 0);
    };

    c3_chart_internal_fn.getEventRectWidth = function () {
        return Math.max(0, this.xAxis.tickInterval());
    };

    c3_chart_internal_fn.initBrush = function () {
        var $$ = this,
            d3 = $$.d3;
        $$.brush = d3.svg.brush().on("brush", function () {
            $$.redrawForBrush();
        });
        $$.brush.update = function () {
            if ($$.context) {
                $$.context.select('.' + CLASS.brush).call(this);
            }
            return this;
        };
        $$.brush.scale = function (scale) {
            return $$.config.axis_rotated ? this.y(scale) : this.x(scale);
        };
    };
    c3_chart_internal_fn.initSubchart = function () {
        var $$ = this,
            config = $$.config,
            context = $$.context = $$.svg.append("g").attr("transform", $$.getTranslate('context')),
            visibility = config.subchart_show ? 'visible' : 'hidden';

        context.style('visibility', visibility);

        // Define g for chart area
        context.append('g').attr("clip-path", $$.clipPathForSubchart).attr('class', CLASS.chart);

        // Define g for bar chart area
        context.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartBars);

        // Define g for line chart area
        context.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartLines);

        // Add extent rect for Brush
        context.append("g").attr("clip-path", $$.clipPath).attr("class", CLASS.brush).call($$.brush);

        // ATTENTION: This must be called AFTER chart added
        // Add Axis
        $$.axes.subx = context.append("g").attr("class", CLASS.axisX).attr("transform", $$.getTranslate('subx')).attr("clip-path", config.axis_rotated ? "" : $$.clipPathForXAxis).style("visibility", config.subchart_axis_x_show ? visibility : 'hidden');
    };
    c3_chart_internal_fn.updateTargetsForSubchart = function (targets) {
        var $$ = this,
            context = $$.context,
            config = $$.config,
            contextLineEnter,
            contextLineUpdate,
            contextBarEnter,
            contextBarUpdate,
            classChartBar = $$.classChartBar.bind($$),
            classBars = $$.classBars.bind($$),
            classChartLine = $$.classChartLine.bind($$),
            classLines = $$.classLines.bind($$),
            classAreas = $$.classAreas.bind($$);

        if (config.subchart_show) {
            //-- Bar --//
            contextBarUpdate = context.select('.' + CLASS.chartBars).selectAll('.' + CLASS.chartBar).data(targets).attr('class', classChartBar);
            contextBarEnter = contextBarUpdate.enter().append('g').style('opacity', 0).attr('class', classChartBar);
            // Bars for each data
            contextBarEnter.append('g').attr("class", classBars);

            //-- Line --//
            contextLineUpdate = context.select('.' + CLASS.chartLines).selectAll('.' + CLASS.chartLine).data(targets).attr('class', classChartLine);
            contextLineEnter = contextLineUpdate.enter().append('g').style('opacity', 0).attr('class', classChartLine);
            // Lines for each data
            contextLineEnter.append("g").attr("class", classLines);
            // Area
            contextLineEnter.append("g").attr("class", classAreas);

            //-- Brush --//
            context.selectAll('.' + CLASS.brush + ' rect').attr(config.axis_rotated ? "width" : "height", config.axis_rotated ? $$.width2 : $$.height2);
        }
    };
    c3_chart_internal_fn.updateBarForSubchart = function (durationForExit) {
        var $$ = this;
        $$.contextBar = $$.context.selectAll('.' + CLASS.bars).selectAll('.' + CLASS.bar).data($$.barData.bind($$));
        $$.contextBar.enter().append('path').attr("class", $$.classBar.bind($$)).style("stroke", 'none').style("fill", $$.color);
        $$.contextBar.style("opacity", $$.initialOpacity.bind($$));
        $$.contextBar.exit().transition().duration(durationForExit).style('opacity', 0).remove();
    };
    c3_chart_internal_fn.redrawBarForSubchart = function (drawBarOnSub, withTransition, duration) {
        (withTransition ? this.contextBar.transition(Math.random().toString()).duration(duration) : this.contextBar).attr('d', drawBarOnSub).style('opacity', 1);
    };
    c3_chart_internal_fn.updateLineForSubchart = function (durationForExit) {
        var $$ = this;
        $$.contextLine = $$.context.selectAll('.' + CLASS.lines).selectAll('.' + CLASS.line).data($$.lineData.bind($$));
        $$.contextLine.enter().append('path').attr('class', $$.classLine.bind($$)).style('stroke', $$.color);
        $$.contextLine.style("opacity", $$.initialOpacity.bind($$));
        $$.contextLine.exit().transition().duration(durationForExit).style('opacity', 0).remove();
    };
    c3_chart_internal_fn.redrawLineForSubchart = function (drawLineOnSub, withTransition, duration) {
        (withTransition ? this.contextLine.transition(Math.random().toString()).duration(duration) : this.contextLine).attr("d", drawLineOnSub).style('opacity', 1);
    };
    c3_chart_internal_fn.updateAreaForSubchart = function (durationForExit) {
        var $$ = this,
            d3 = $$.d3;
        $$.contextArea = $$.context.selectAll('.' + CLASS.areas).selectAll('.' + CLASS.area).data($$.lineData.bind($$));
        $$.contextArea.enter().append('path').attr("class", $$.classArea.bind($$)).style("fill", $$.color).style("opacity", function () {
            $$.orgAreaOpacity = +d3.select(this).style('opacity');return 0;
        });
        $$.contextArea.style("opacity", 0);
        $$.contextArea.exit().transition().duration(durationForExit).style('opacity', 0).remove();
    };
    c3_chart_internal_fn.redrawAreaForSubchart = function (drawAreaOnSub, withTransition, duration) {
        (withTransition ? this.contextArea.transition(Math.random().toString()).duration(duration) : this.contextArea).attr("d", drawAreaOnSub).style("fill", this.color).style("opacity", this.orgAreaOpacity);
    };
    c3_chart_internal_fn.redrawSubchart = function (withSubchart, transitions, duration, durationForExit, areaIndices, barIndices, lineIndices) {
        var $$ = this,
            d3 = $$.d3,
            config = $$.config,
            drawAreaOnSub,
            drawBarOnSub,
            drawLineOnSub;

        $$.context.style('visibility', config.subchart_show ? 'visible' : 'hidden');

        // subchart
        if (config.subchart_show) {
            // reflect main chart to extent on subchart if zoomed
            if (d3.event && d3.event.type === 'zoom') {
                $$.brush.extent($$.x.orgDomain()).update();
            }
            // update subchart elements if needed
            if (withSubchart) {

                // extent rect
                if (!$$.brush.empty()) {
                    $$.brush.extent($$.x.orgDomain()).update();
                }
                // setup drawer - MEMO: this must be called after axis updated
                drawAreaOnSub = $$.generateDrawArea(areaIndices, true);
                drawBarOnSub = $$.generateDrawBar(barIndices, true);
                drawLineOnSub = $$.generateDrawLine(lineIndices, true);

                $$.updateBarForSubchart(duration);
                $$.updateLineForSubchart(duration);
                $$.updateAreaForSubchart(duration);

                $$.redrawBarForSubchart(drawBarOnSub, duration, duration);
                $$.redrawLineForSubchart(drawLineOnSub, duration, duration);
                $$.redrawAreaForSubchart(drawAreaOnSub, duration, duration);
            }
        }
    };
    c3_chart_internal_fn.redrawForBrush = function () {
        var $$ = this,
            x = $$.x;
        $$.redraw({
            withTransition: false,
            withY: $$.config.zoom_rescale,
            withSubchart: false,
            withUpdateXDomain: true,
            withDimension: false
        });
        $$.config.subchart_onbrush.call($$.api, x.orgDomain());
    };
    c3_chart_internal_fn.transformContext = function (withTransition, transitions) {
        var $$ = this,
            subXAxis;
        if (transitions && transitions.axisSubX) {
            subXAxis = transitions.axisSubX;
        } else {
            subXAxis = $$.context.select('.' + CLASS.axisX);
            if (withTransition) {
                subXAxis = subXAxis.transition();
            }
        }
        $$.context.attr("transform", $$.getTranslate('context'));
        subXAxis.attr("transform", $$.getTranslate('subx'));
    };
    c3_chart_internal_fn.getDefaultExtent = function () {
        var $$ = this,
            config = $$.config,
            extent = isFunction(config.axis_x_extent) ? config.axis_x_extent($$.getXDomain($$.data.targets)) : config.axis_x_extent;
        if ($$.isTimeSeries()) {
            extent = [$$.parseDate(extent[0]), $$.parseDate(extent[1])];
        }
        return extent;
    };

    c3_chart_internal_fn.initText = function () {
        var $$ = this;
        $$.main.select('.' + CLASS.chart).append("g").attr("class", CLASS.chartTexts);
        $$.mainText = $$.d3.selectAll([]);
    };
    c3_chart_internal_fn.updateTargetsForText = function (targets) {
        var $$ = this,
            mainTextUpdate,
            mainTextEnter,
            classChartText = $$.classChartText.bind($$),
            classTexts = $$.classTexts.bind($$),
            classFocus = $$.classFocus.bind($$);
        mainTextUpdate = $$.main.select('.' + CLASS.chartTexts).selectAll('.' + CLASS.chartText).data(targets).attr('class', function (d) {
            return classChartText(d) + classFocus(d);
        });
        mainTextEnter = mainTextUpdate.enter().append('g').attr('class', classChartText).style('opacity', 0).style("pointer-events", "none");
        mainTextEnter.append('g').attr('class', classTexts);
    };
    c3_chart_internal_fn.updateText = function (durationForExit) {
        var $$ = this,
            config = $$.config,
            barOrLineData = $$.barOrLineData.bind($$),
            classText = $$.classText.bind($$);
        $$.mainText = $$.main.selectAll('.' + CLASS.texts).selectAll('.' + CLASS.text).data(barOrLineData);
        $$.mainText.enter().append('text').attr("class", classText).attr('text-anchor', function (d) {
            return config.axis_rotated ? d.value < 0 ? 'end' : 'start' : 'middle';
        }).style("stroke", 'none').style("fill", function (d) {
            return $$.color(d);
        }).style("fill-opacity", 0);
        $$.mainText.text(function (d, i, j) {
            return $$.dataLabelFormat(d.id)(d.value, d.id, i, j);
        });
        $$.mainText.exit().transition().duration(durationForExit).style('fill-opacity', 0).remove();
    };
    c3_chart_internal_fn.redrawText = function (xForText, yForText, forFlow, withTransition) {
        return [(withTransition ? this.mainText.transition() : this.mainText).attr('x', xForText).attr('y', yForText).style("fill", this.color).style("fill-opacity", forFlow ? 0 : this.opacityForText.bind(this))];
    };
    c3_chart_internal_fn.getTextRect = function (text, cls, element) {
        var dummy = this.d3.select('body').append('div').classed('c3', true),
            svg = dummy.append("svg").style('visibility', 'hidden').style('position', 'fixed').style('top', 0).style('left', 0),
            font = this.d3.select(element).style('font'),
            rect;
        svg.selectAll('.dummy').data([text]).enter().append('text').classed(cls ? cls : "", true).style('font', font).text(text).each(function () {
            rect = this.getBoundingClientRect();
        });
        dummy.remove();
        return rect;
    };
    c3_chart_internal_fn.generateXYForText = function (areaIndices, barIndices, lineIndices, forX) {
        var $$ = this,
            getAreaPoints = $$.generateGetAreaPoints(areaIndices, false),
            getBarPoints = $$.generateGetBarPoints(barIndices, false),
            getLinePoints = $$.generateGetLinePoints(lineIndices, false),
            getter = forX ? $$.getXForText : $$.getYForText;
        return function (d, i) {
            var getPoints = $$.isAreaType(d) ? getAreaPoints : $$.isBarType(d) ? getBarPoints : getLinePoints;
            return getter.call($$, getPoints(d, i), d, this);
        };
    };
    c3_chart_internal_fn.getXForText = function (points, d, textElement) {
        var $$ = this,
            box = textElement.getBoundingClientRect(),
            xPos,
            padding;
        if ($$.config.axis_rotated) {
            padding = $$.isBarType(d) ? 4 : 6;
            xPos = points[2][1] + padding * (d.value < 0 ? -1 : 1);
        } else {
            xPos = $$.hasType('bar') ? (points[2][0] + points[0][0]) / 2 : points[0][0];
        }
        // show labels regardless of the domain if value is null
        if (d.value === null) {
            if (xPos > $$.width) {
                xPos = $$.width - box.width;
            } else if (xPos < 0) {
                xPos = 4;
            }
        }
        return xPos;
    };
    c3_chart_internal_fn.getYForText = function (points, d, textElement) {
        var $$ = this,
            box = textElement.getBoundingClientRect(),
            yPos;
        if ($$.config.axis_rotated) {
            yPos = (points[0][0] + points[2][0] + box.height * 0.6) / 2;
        } else {
            yPos = points[2][1];
            if (d.value < 0 || d.value === 0 && !$$.hasPositiveValue) {
                yPos += box.height;
                if ($$.isBarType(d) && $$.isSafari()) {
                    yPos -= 3;
                } else if (!$$.isBarType(d) && $$.isChrome()) {
                    yPos += 3;
                }
            } else {
                yPos += $$.isBarType(d) ? -3 : -6;
            }
        }
        // show labels regardless of the domain if value is null
        if (d.value === null && !$$.config.axis_rotated) {
            if (yPos < box.height) {
                yPos = box.height;
            } else if (yPos > this.height) {
                yPos = this.height - 4;
            }
        }
        return yPos;
    };

    c3_chart_internal_fn.initTitle = function () {
        var $$ = this;
        $$.title = $$.svg.append("text").text($$.config.title_text).attr("class", $$.CLASS.title);
    };
    c3_chart_internal_fn.redrawTitle = function () {
        var $$ = this;
        $$.title.attr("x", $$.xForTitle.bind($$)).attr("y", $$.yForTitle.bind($$));
    };
    c3_chart_internal_fn.xForTitle = function () {
        var $$ = this,
            config = $$.config,
            position = config.title_position || 'left',
            x;
        if (position.indexOf('right') >= 0) {
            x = $$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width - config.title_padding.right;
        } else if (position.indexOf('center') >= 0) {
            x = ($$.currentWidth - $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).width) / 2;
        } else {
            // left
            x = config.title_padding.left;
        }
        return x;
    };
    c3_chart_internal_fn.yForTitle = function () {
        var $$ = this;
        return $$.config.title_padding.top + $$.getTextRect($$.title.node().textContent, $$.CLASS.title, $$.title.node()).height;
    };
    c3_chart_internal_fn.getTitlePadding = function () {
        var $$ = this;
        return $$.yForTitle() + $$.config.title_padding.bottom;
    };

    c3_chart_internal_fn.initTooltip = function () {
        var $$ = this,
            config = $$.config,
            i;
        $$.tooltip = $$.selectChart.style("position", "relative").append("div").attr('class', CLASS.tooltipContainer).style("position", "absolute").style("pointer-events", "none").style("display", "none");
        // Show tooltip if needed
        if (config.tooltip_init_show) {
            if ($$.isTimeSeries() && isString(config.tooltip_init_x)) {
                config.tooltip_init_x = $$.parseDate(config.tooltip_init_x);
                for (i = 0; i < $$.data.targets[0].values.length; i++) {
                    if ($$.data.targets[0].values[i].x - config.tooltip_init_x === 0) {
                        break;
                    }
                }
                config.tooltip_init_x = i;
            }
            $$.tooltip.html(config.tooltip_contents.call($$, $$.data.targets.map(function (d) {
                return $$.addName(d.values[config.tooltip_init_x]);
            }), $$.axis.getXAxisTickFormat(), $$.getYFormat($$.hasArcType()), $$.color));
            $$.tooltip.style("top", config.tooltip_init_position.top).style("left", config.tooltip_init_position.left).style("display", "block");
        }
    };
    c3_chart_internal_fn.getTooltipSortFunction = function () {
        var $$ = this,
            config = $$.config;

        if (config.data_groups.length === 0 || config.tooltip_order !== undefined) {
            // if data are not grouped or if an order is specified
            // for the tooltip values we sort them by their values

            var order = config.tooltip_order;
            if (order === undefined) {
                order = config.data_order;
            }

            var valueOf = function valueOf(obj) {
                return obj ? obj.value : null;
            };

            // if data are not grouped, we sort them by their value
            if (isString(order) && order.toLowerCase() === 'asc') {
                return function (a, b) {
                    return valueOf(a) - valueOf(b);
                };
            } else if (isString(order) && order.toLowerCase() === 'desc') {
                return function (a, b) {
                    return valueOf(b) - valueOf(a);
                };
            } else if (isFunction(order)) {

                // if the function is from data_order we need
                // to wrap the returned function in order to format
                // the sorted value to the expected format

                var sortFunction = order;

                if (config.tooltip_order === undefined) {
                    sortFunction = function sortFunction(a, b) {
                        return order(a ? {
                            id: a.id,
                            values: [a]
                        } : null, b ? {
                            id: b.id,
                            values: [b]
                        } : null);
                    };
                }

                return sortFunction;
            } else if (isArray(order)) {
                return function (a, b) {
                    return order.indexOf(a.id) - order.indexOf(b.id);
                };
            }
        } else {
            // if data are grouped, we follow the order of grouped targets
            var ids = $$.orderTargets($$.data.targets).map(function (i) {
                return i.id;
            });

            // if it was either asc or desc we need to invert the order
            // returned by orderTargets
            if ($$.isOrderAsc() || $$.isOrderDesc()) {
                ids = ids.reverse();
            }

            return function (a, b) {
                return ids.indexOf(a.id) - ids.indexOf(b.id);
            };
        }
    };
    c3_chart_internal_fn.getTooltipContent = function (d, defaultTitleFormat, defaultValueFormat, color) {
        var $$ = this,
            config = $$.config,
            titleFormat = config.tooltip_format_title || defaultTitleFormat,
            nameFormat = config.tooltip_format_name || function (name) {
            return name;
        },
            valueFormat = config.tooltip_format_value || defaultValueFormat,
            text,
            i,
            title,
            value,
            name,
            bgcolor;

        var tooltipSortFunction = this.getTooltipSortFunction();
        if (tooltipSortFunction) {
            d.sort(tooltipSortFunction);
        }

        for (i = 0; i < d.length; i++) {
            if (!(d[i] && (d[i].value || d[i].value === 0))) {
                continue;
            }

            if (!text) {
                title = sanitise(titleFormat ? titleFormat(d[i].x) : d[i].x);
                text = "<table class='" + $$.CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + title + "</th></tr>" : "");
            }

            value = sanitise(valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index, d));
            if (value !== undefined) {
                // Skip elements when their name is set to null
                if (d[i].name === null) {
                    continue;
                }
                name = sanitise(nameFormat(d[i].name, d[i].ratio, d[i].id, d[i].index));
                bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);

                text += "<tr class='" + $$.CLASS.tooltipName + "-" + $$.getTargetSelectorSuffix(d[i].id) + "'>";
                text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
                text += "<td class='value'>" + value + "</td>";
                text += "</tr>";
            }
        }
        return text + "</table>";
    };
    c3_chart_internal_fn.tooltipPosition = function (dataToShow, tWidth, tHeight, element) {
        var $$ = this,
            config = $$.config,
            d3 = $$.d3;
        var svgLeft, tooltipLeft, tooltipRight, tooltipTop, chartRight;
        var forArc = $$.hasArcType(),
            mouse = d3.mouse(element);
        // Determin tooltip position
        if (forArc) {
            tooltipLeft = ($$.width - ($$.isLegendRight ? $$.getLegendWidth() : 0)) / 2 + mouse[0];
            tooltipTop = ($$.hasType('gauge') ? $$.height : $$.height / 2) + mouse[1] + 20;
        } else {
            svgLeft = $$.getSvgLeft(true);
            if (config.axis_rotated) {
                tooltipLeft = svgLeft + mouse[0] + 100;
                tooltipRight = tooltipLeft + tWidth;
                chartRight = $$.currentWidth - $$.getCurrentPaddingRight();
                tooltipTop = $$.x(dataToShow[0].x) + 20;
            } else {
                tooltipLeft = svgLeft + $$.getCurrentPaddingLeft(true) + $$.x(dataToShow[0].x) + 20;
                tooltipRight = tooltipLeft + tWidth;
                chartRight = svgLeft + $$.currentWidth - $$.getCurrentPaddingRight();
                tooltipTop = mouse[1] + 15;
            }

            if (tooltipRight > chartRight) {
                // 20 is needed for Firefox to keep tooltip width
                tooltipLeft -= tooltipRight - chartRight + 20;
            }
            if (tooltipTop + tHeight > $$.currentHeight) {
                tooltipTop -= tHeight + 30;
            }
        }
        if (tooltipTop < 0) {
            tooltipTop = 0;
        }
        return { top: tooltipTop, left: tooltipLeft };
    };
    c3_chart_internal_fn.showTooltip = function (selectedData, element) {
        var $$ = this,
            config = $$.config;
        var tWidth, tHeight, position;
        var forArc = $$.hasArcType(),
            dataToShow = selectedData.filter(function (d) {
            return d && isValue(d.value);
        }),
            positionFunction = config.tooltip_position || c3_chart_internal_fn.tooltipPosition;
        if (dataToShow.length === 0 || !config.tooltip_show) {
            return;
        }
        $$.tooltip.html(config.tooltip_contents.call($$, selectedData, $$.axis.getXAxisTickFormat(), $$.getYFormat(forArc), $$.color)).style("display", "block");

        // Get tooltip dimensions
        tWidth = $$.tooltip.property('offsetWidth');
        tHeight = $$.tooltip.property('offsetHeight');

        position = positionFunction.call(this, dataToShow, tWidth, tHeight, element);
        // Set tooltip
        $$.tooltip.style("top", position.top + "px").style("left", position.left + 'px');
    };
    c3_chart_internal_fn.hideTooltip = function () {
        this.tooltip.style("display", "none");
    };

    c3_chart_internal_fn.setTargetType = function (targetIds, type) {
        var $$ = this,
            config = $$.config;
        $$.mapToTargetIds(targetIds).forEach(function (id) {
            $$.withoutFadeIn[id] = type === config.data_types[id];
            config.data_types[id] = type;
        });
        if (!targetIds) {
            config.data_type = type;
        }
    };
    c3_chart_internal_fn.hasType = function (type, targets) {
        var $$ = this,
            types = $$.config.data_types,
            has = false;
        targets = targets || $$.data.targets;
        if (targets && targets.length) {
            targets.forEach(function (target) {
                var t = types[target.id];
                if (t && t.indexOf(type) >= 0 || !t && type === 'line') {
                    has = true;
                }
            });
        } else if (Object.keys(types).length) {
            Object.keys(types).forEach(function (id) {
                if (types[id] === type) {
                    has = true;
                }
            });
        } else {
            has = $$.config.data_type === type;
        }
        return has;
    };
    c3_chart_internal_fn.hasArcType = function (targets) {
        return this.hasType('pie', targets) || this.hasType('donut', targets) || this.hasType('gauge', targets);
    };
    c3_chart_internal_fn.isLineType = function (d) {
        var config = this.config,
            id = isString(d) ? d : d.id;
        return !config.data_types[id] || ['line', 'spline', 'area', 'area-spline', 'step', 'area-step'].indexOf(config.data_types[id]) >= 0;
    };
    c3_chart_internal_fn.isStepType = function (d) {
        var id = isString(d) ? d : d.id;
        return ['step', 'area-step'].indexOf(this.config.data_types[id]) >= 0;
    };
    c3_chart_internal_fn.isSplineType = function (d) {
        var id = isString(d) ? d : d.id;
        return ['spline', 'area-spline'].indexOf(this.config.data_types[id]) >= 0;
    };
    c3_chart_internal_fn.isAreaType = function (d) {
        var id = isString(d) ? d : d.id;
        return ['area', 'area-spline', 'area-step'].indexOf(this.config.data_types[id]) >= 0;
    };
    c3_chart_internal_fn.isBarType = function (d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === 'bar';
    };
    c3_chart_internal_fn.isScatterType = function (d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === 'scatter';
    };
    c3_chart_internal_fn.isPieType = function (d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === 'pie';
    };
    c3_chart_internal_fn.isGaugeType = function (d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === 'gauge';
    };
    c3_chart_internal_fn.isDonutType = function (d) {
        var id = isString(d) ? d : d.id;
        return this.config.data_types[id] === 'donut';
    };
    c3_chart_internal_fn.isArcType = function (d) {
        return this.isPieType(d) || this.isDonutType(d) || this.isGaugeType(d);
    };
    c3_chart_internal_fn.lineData = function (d) {
        return this.isLineType(d) ? [d] : [];
    };
    c3_chart_internal_fn.arcData = function (d) {
        return this.isArcType(d.data) ? [d] : [];
    };
    /* not used
     function scatterData(d) {
     return isScatterType(d) ? d.values : [];
     }
     */
    c3_chart_internal_fn.barData = function (d) {
        return this.isBarType(d) ? d.values : [];
    };
    c3_chart_internal_fn.lineOrScatterData = function (d) {
        return this.isLineType(d) || this.isScatterType(d) ? d.values : [];
    };
    c3_chart_internal_fn.barOrLineData = function (d) {
        return this.isBarType(d) || this.isLineType(d) ? d.values : [];
    };
    c3_chart_internal_fn.isInterpolationType = function (type) {
        return ['linear', 'linear-closed', 'basis', 'basis-open', 'basis-closed', 'bundle', 'cardinal', 'cardinal-open', 'cardinal-closed', 'monotone'].indexOf(type) >= 0;
    };

    c3_chart_internal_fn.isSafari = function () {
        var ua = window.navigator.userAgent;
        return ua.indexOf('Safari') >= 0 && ua.indexOf('Chrome') < 0;
    };
    c3_chart_internal_fn.isChrome = function () {
        var ua = window.navigator.userAgent;
        return ua.indexOf('Chrome') >= 0;
    };

    c3_chart_internal_fn.initZoom = function () {
        var $$ = this,
            d3 = $$.d3,
            config = $$.config,
            startEvent;

        $$.zoom = d3.behavior.zoom().on("zoomstart", function () {
            startEvent = d3.event.sourceEvent;
            $$.zoom.altDomain = d3.event.sourceEvent.altKey ? $$.x.orgDomain() : null;
            config.zoom_onzoomstart.call($$.api, d3.event.sourceEvent);
        }).on("zoom", function () {
            $$.redrawForZoom.call($$);
        }).on('zoomend', function () {
            var event = d3.event.sourceEvent;
            // if click, do nothing. otherwise, click interaction will be canceled.
            if (event && startEvent.clientX === event.clientX && startEvent.clientY === event.clientY) {
                return;
            }
            $$.redrawEventRect();
            $$.updateZoom();
            config.zoom_onzoomend.call($$.api, $$.x.orgDomain());
        });
        $$.zoom.scale = function (scale) {
            return config.axis_rotated ? this.y(scale) : this.x(scale);
        };
        $$.zoom.orgScaleExtent = function () {
            var extent = config.zoom_extent ? config.zoom_extent : [1, 10];
            return [extent[0], Math.max($$.getMaxDataCount() / extent[1], extent[1])];
        };
        $$.zoom.updateScaleExtent = function () {
            var ratio = diffDomain($$.x.orgDomain()) / diffDomain($$.getZoomDomain()),
                extent = this.orgScaleExtent();
            this.scaleExtent([extent[0] * ratio, extent[1] * ratio]);
            return this;
        };
    };
    c3_chart_internal_fn.getZoomDomain = function () {
        var $$ = this,
            config = $$.config,
            d3 = $$.d3,
            min = d3.min([$$.orgXDomain[0], config.zoom_x_min]),
            max = d3.max([$$.orgXDomain[1], config.zoom_x_max]);
        return [min, max];
    };
    c3_chart_internal_fn.updateZoom = function () {
        var $$ = this,
            z = $$.config.zoom_enabled ? $$.zoom : function () {};
        $$.main.select('.' + CLASS.zoomRect).call(z).on("dblclick.zoom", null);
        $$.main.selectAll('.' + CLASS.eventRect).call(z).on("dblclick.zoom", null);
    };
    c3_chart_internal_fn.redrawForZoom = function () {
        var $$ = this,
            d3 = $$.d3,
            config = $$.config,
            zoom = $$.zoom,
            x = $$.x;
        if (!config.zoom_enabled) {
            return;
        }
        if ($$.filterTargetsToShow($$.data.targets).length === 0) {
            return;
        }
        if (d3.event.sourceEvent.type === 'mousemove' && zoom.altDomain) {
            x.domain(zoom.altDomain);
            zoom.scale(x).updateScaleExtent();
            return;
        }
        if ($$.isCategorized() && x.orgDomain()[0] === $$.orgXDomain[0]) {
            x.domain([$$.orgXDomain[0] - 1e-10, x.orgDomain()[1]]);
        }
        $$.redraw({
            withTransition: false,
            withY: config.zoom_rescale,
            withSubchart: false,
            withEventRect: false,
            withDimension: false
        });
        if (d3.event.sourceEvent.type === 'mousemove') {
            $$.cancelClick = true;
        }
        config.zoom_onzoom.call($$.api, x.orgDomain());
    };

    return c3;

})));


/***/ }),

/***/ "./node_modules/c3/c3.min.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/cloner/build/cloner.node.js":
/***/ (function(module, exports) {

/*!
Copyright (C) 2015 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
var cloner = (function (O) {'use strict';

  // (C) Andrea Giammarchi - Mit Style

  var

    // constants
    VALUE   = 'value',
    PROTO   = '__proto__', // to avoid jshint complains

    // shortcuts
    isArray = Array.isArray,
    create  = O.create,
    dP      = O.defineProperty,
    dPs     = O.defineProperties,
    gOPD    = O.getOwnPropertyDescriptor,
    gOPN    = O.getOwnPropertyNames,
    gOPS    = O.getOwnPropertySymbols ||
              function (o) { return Array.prototype; },
    gPO     = O.getPrototypeOf ||
              function (o) { return o[PROTO]; },
    hOP     = O.prototype.hasOwnProperty,
    oKs     = (typeof Reflect !== typeof oK) &&
              Reflect.ownKeys ||
              function (o) { return gOPS(o).concat(gOPN(o)); },
    set     = function (descriptors, key, descriptor) {
      if (key in descriptors) dP(descriptors, key, {
        configurable: true,
        enumerable: true,
        value: descriptor
      });
      else descriptors[key] = descriptor;
    },

    // used to avoid recursions in deep copy
    index   = -1,
    known   = null,
    blown   = null,
    clean   = function () { known = blown = null; },

    // utilities
    New = function (source, descriptors) {
      var out = isArray(source) ? [] : create(gPO(source));
      return descriptors ? Object.defineProperties(out, descriptors) : out;
    },

    // deep copy and merge
    deepCopy = function deepCopy(source) {
      var result = New(source);
      known = [source];
      blown = [result];
      deepDefine(result, source);
      clean();
      return result;
    },
    deepMerge = function (target) {
      known = [];
      blown = [];
      for (var i = 1; i < arguments.length; i++) {
        known[i - 1] = arguments[i];
        blown[i - 1] = target;
      }
      merge.apply(true, arguments);
      clean();
      return target;
    },

    // shallow copy and merge
    shallowCopy = function shallowCopy(source) {
      clean();
      for (var
        key,
        descriptors = {},
        keys = oKs(source),
        i = keys.length; i--;
        set(descriptors, key, gOPD(source, key))
      ) key = keys[i];
      return New(source, descriptors);
    },
    shallowMerge = function () {
      clean();
      return merge.apply(false, arguments);
    },

    // internal methods
    isObject = function isObject(value) {
      /*jshint eqnull: true */
      return value != null && typeof value === 'object';
    },
    shouldCopy = function shouldCopy(value) {
      /*jshint eqnull: true */
      index = -1;
      if (isObject(value)) {
        if (known == null) return true;
        index = known.indexOf(value);
        if (index < 0) return 0 < known.push(value);
      }
      return false;
    },
    deepDefine = function deepDefine(target, source) {
      for (var
        key, descriptor,
        descriptors = {},
        keys = oKs(source),
        i = keys.length; i--;
      ) {
        key = keys[i];
        descriptor = gOPD(source, key);
        if (VALUE in descriptor) deepValue(descriptor);
        set(descriptors, key, descriptor);
      }
      dPs(target, descriptors);
    },
    deepValue = function deepValue(descriptor) {
      var value = descriptor[VALUE];
      if (shouldCopy(value)) {
        descriptor[VALUE] = New(value);
        deepDefine(descriptor[VALUE], value);
        blown[known.indexOf(value)] = descriptor[VALUE];
      } else if (-1 < index && index in blown) {
        descriptor[VALUE] = blown[index];
      }
    },
    merge = function merge(target) {
      for (var
        source,
        keys, key,
        value, tvalue,
        descriptor,
        deep = this.valueOf(),
        descriptors = {},
        i, a = 1;
        a < arguments.length; a++
      ) {
        source = arguments[a];
        keys = oKs(source);
        for (i = 0; i < keys.length; i++) {
          key = keys[i];
          descriptor = gOPD(source, key);
          if (hOP.call(target, key)) {
            if (VALUE in descriptor) {
              value = descriptor[VALUE];
              if (shouldCopy(value)) {
                descriptor = gOPD(target, key);
                if (VALUE in descriptor) {
                  tvalue = descriptor[VALUE];
                  if (isObject(tvalue)) {
                    merge.call(deep, tvalue, value);
                  }
                }
              }
            }
          } else {
            if (deep && VALUE in descriptor) {
              deepValue(descriptor);
            }
            set(descriptors, key, descriptor);
          }
        }
      }
      return dPs(target, descriptors);
    }
  ;

  return {
    deep: {
      copy: deepCopy,
      merge: deepMerge
    },
    shallow: {
      copy: shallowCopy,
      merge: shallowMerge
    }
  };

}(Object));
module.exports = cloner;

/***/ }),

/***/ "./node_modules/core-js/library/fn/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.array.from.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Array.from;


/***/ }),

/***/ "./node_modules/core-js/library/fn/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator.js");


/***/ }),

/***/ "./node_modules/core-js/library/fn/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.assign.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.get-own-property-names.js");
var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es7.object.values.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.values;


/***/ }),

/***/ "./node_modules/core-js/library/fn/promise.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.promise.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.promise.finally.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.promise.try.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Promise;


/***/ }),

/***/ "./node_modules/core-js/library/fn/set.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.set.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.set.to-json.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.set.of.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.set.from.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Set;


/***/ }),

/***/ "./node_modules/core-js/library/fn/symbol/has-instance.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.function.has-instance.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js").f('hasInstance');


/***/ }),

/***/ "./node_modules/core-js/library/modules/_an-instance.js":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-from-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var asc = __webpack_require__("./node_modules/core-js/library/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var isArray = __webpack_require__("./node_modules/core-js/library/modules/_is-array.js");
var SPECIES = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("./node_modules/core-js/library/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
var TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_collection-strong.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
var create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
var redefineAll = __webpack_require__("./node_modules/core-js/library/modules/_redefine-all.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var anInstance = __webpack_require__("./node_modules/core-js/library/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
var $iterDefine = __webpack_require__("./node_modules/core-js/library/modules/_iter-define.js");
var step = __webpack_require__("./node_modules/core-js/library/modules/_iter-step.js");
var setSpecies = __webpack_require__("./node_modules/core-js/library/modules/_set-species.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var fastKey = __webpack_require__("./node_modules/core-js/library/modules/_meta.js").fastKey;
var validate = __webpack_require__("./node_modules/core-js/library/modules/_validate-collection.js");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_collection-to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
var from = __webpack_require__("./node_modules/core-js/library/modules/_array-from-iterable.js");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var meta = __webpack_require__("./node_modules/core-js/library/modules/_meta.js");
var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var redefineAll = __webpack_require__("./node_modules/core-js/library/modules/_redefine-all.js");
var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
var anInstance = __webpack_require__("./node_modules/core-js/library/modules/_an-instance.js");
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
var each = __webpack_require__("./node_modules/core-js/library/modules/_array-methods.js")(0);
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_for-of.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var call = __webpack_require__("./node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("./node_modules/core-js/library/modules/_is-array-iter.js");
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var getIterFn = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_invoke.js":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_microtask.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var macrotask = __webpack_require__("./node_modules/core-js/library/modules/_task.js").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("./node_modules/core-js/library/modules/_cof.js")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_new-promise-capability.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var isEnum = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_perform.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_promise-resolve.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var newPromiseCapability = __webpack_require__("./node_modules/core-js/library/modules/_new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_redefine-all.js":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-collection-from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-collection-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var SPECIES = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
var SPECIES = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_task.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var invoke = __webpack_require__("./node_modules/core-js/library/modules/_invoke.js");
var html = __webpack_require__("./node_modules/core-js/library/modules/_html.js");
var cel = __webpack_require__("./node_modules/core-js/library/modules/_dom-create.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("./node_modules/core-js/library/modules/_cof.js")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_user-agent.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "./node_modules/core-js/library/modules/_validate-collection.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/core.get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var get = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var call = __webpack_require__("./node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("./node_modules/core-js/library/modules/_is-array-iter.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var createProperty = __webpack_require__("./node_modules/core-js/library/modules/_create-property.js");
var getIterFn = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.function.has-instance.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");
var HAS_INSTANCE = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('getOwnPropertyNames', function () {
  return __webpack_require__("./node_modules/core-js/library/modules/_object-gopn-ext.js").f;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
var anInstance = __webpack_require__("./node_modules/core-js/library/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
var speciesConstructor = __webpack_require__("./node_modules/core-js/library/modules/_species-constructor.js");
var task = __webpack_require__("./node_modules/core-js/library/modules/_task.js").set;
var microtask = __webpack_require__("./node_modules/core-js/library/modules/_microtask.js")();
var newPromiseCapabilityModule = __webpack_require__("./node_modules/core-js/library/modules/_new-promise-capability.js");
var perform = __webpack_require__("./node_modules/core-js/library/modules/_perform.js");
var userAgent = __webpack_require__("./node_modules/core-js/library/modules/_user-agent.js");
var promiseResolve = __webpack_require__("./node_modules/core-js/library/modules/_promise-resolve.js");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("./node_modules/core-js/library/modules/_redefine-all.js")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js")($Promise, PROMISE);
__webpack_require__("./node_modules/core-js/library/modules/_set-species.js")(PROMISE);
Wrapper = __webpack_require__("./node_modules/core-js/library/modules/_core.js")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.set.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("./node_modules/core-js/library/modules/_collection-strong.js");
var validate = __webpack_require__("./node_modules/core-js/library/modules/_validate-collection.js");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_collection.js")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var $values = __webpack_require__("./node_modules/core-js/library/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.promise.finally.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var speciesConstructor = __webpack_require__("./node_modules/core-js/library/modules/_species-constructor.js");
var promiseResolve = __webpack_require__("./node_modules/core-js/library/modules/_promise-resolve.js");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.promise.try.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var newPromiseCapability = __webpack_require__("./node_modules/core-js/library/modules/_new-promise-capability.js");
var perform = __webpack_require__("./node_modules/core-js/library/modules/_perform.js");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.set.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__("./node_modules/core-js/library/modules/_set-collection-from.js")('Set');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.set.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__("./node_modules/core-js/library/modules/_set-collection-of.js")('Set');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.set.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__("./node_modules/core-js/library/modules/_collection-to-json.js")('Set') });


/***/ }),

/***/ "./node_modules/d3/d3.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
  var d3 = {
    version: "3.5.17"
  };
  var d3_arraySlice = [].slice, d3_array = function(list) {
    return d3_arraySlice.call(list);
  };
  var d3_document = this.document;
  function d3_documentElement(node) {
    return node && (node.ownerDocument || node.document || node).documentElement;
  }
  function d3_window(node) {
    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
  }
  if (d3_document) {
    try {
      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
      d3_array = function(list) {
        var i = list.length, array = new Array(i);
        while (i--) array[i] = list[i];
        return array;
      };
    }
  }
  if (!Date.now) Date.now = function() {
    return +new Date();
  };
  if (d3_document) {
    try {
      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
    } catch (error) {
      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
      d3_element_prototype.setAttribute = function(name, value) {
        d3_element_setAttribute.call(this, name, value + "");
      };
      d3_element_prototype.setAttributeNS = function(space, local, value) {
        d3_element_setAttributeNS.call(this, space, local, value + "");
      };
      d3_style_prototype.setProperty = function(name, value, priority) {
        d3_style_setProperty.call(this, name, value + "", priority);
      };
    }
  }
  d3.ascending = d3_ascending;
  function d3_ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  d3.descending = function(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  };
  d3.min = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
    }
    return a;
  };
  d3.max = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
    }
    return a;
  };
  d3.extent = function(array, f) {
    var i = -1, n = array.length, a, b, c;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }
    return [ a, c ];
  };
  function d3_number(x) {
    return x === null ? NaN : +x;
  }
  function d3_numeric(x) {
    return !isNaN(x);
  }
  d3.sum = function(array, f) {
    var s = 0, n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
    } else {
      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
    }
    return s;
  };
  d3.mean = function(array, f) {
    var s = 0, n = array.length, a, i = -1, j = n;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
    }
    if (j) return s / j;
  };
  d3.quantile = function(values, p) {
    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
    return e ? v + e * (values[h] - v) : v;
  };
  d3.median = function(array, f) {
    var numbers = [], n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
    }
    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
  };
  d3.variance = function(array, f) {
    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }
    if (j > 1) return s / (j - 1);
  };
  d3.deviation = function() {
    var v = d3.variance.apply(this, arguments);
    return v ? Math.sqrt(v) : v;
  };
  function d3_bisector(compare) {
    return {
      left: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  var d3_bisect = d3_bisector(d3_ascending);
  d3.bisectLeft = d3_bisect.left;
  d3.bisect = d3.bisectRight = d3_bisect.right;
  d3.bisector = function(f) {
    return d3_bisector(f.length === 1 ? function(d, x) {
      return d3_ascending(f(d), x);
    } : f);
  };
  d3.shuffle = function(array, i0, i1) {
    if ((m = arguments.length) < 3) {
      i1 = array.length;
      if (m < 2) i0 = 0;
    }
    var m = i1 - i0, t, i;
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
    }
    return array;
  };
  d3.permute = function(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  };
  d3.pairs = function(array) {
    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
    return pairs;
  };
  d3.transpose = function(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  };
  function d3_transposeLength(d) {
    return d.length;
  }
  d3.zip = function() {
    return d3.transpose(arguments);
  };
  d3.keys = function(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  };
  d3.values = function(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  };
  d3.entries = function(map) {
    var entries = [];
    for (var key in map) entries.push({
      key: key,
      value: map[key]
    });
    return entries;
  };
  d3.merge = function(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while (++i < n) j += arrays[i].length;
    merged = new Array(j);
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
    return merged;
  };
  var abs = Math.abs;
  d3.range = function(start, stop, step) {
    if (arguments.length < 3) {
      step = 1;
      if (arguments.length < 2) {
        stop = start;
        start = 0;
      }
    }
    if ((stop - start) / step === Infinity) throw new Error("infinite range");
    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
    start *= k, stop *= k, step *= k;
    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
    return range;
  };
  function d3_range_integerScale(x) {
    var k = 1;
    while (x * k % 1) k *= 10;
    return k;
  }
  function d3_class(ctor, properties) {
    for (var key in properties) {
      Object.defineProperty(ctor.prototype, key, {
        value: properties[key],
        enumerable: false
      });
    }
  }
  d3.map = function(object, f) {
    var map = new d3_Map();
    if (object instanceof d3_Map) {
      object.forEach(function(key, value) {
        map.set(key, value);
      });
    } else if (Array.isArray(object)) {
      var i = -1, n = object.length, o;
      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
    } else {
      for (var key in object) map.set(key, object[key]);
    }
    return map;
  };
  function d3_Map() {
    this._ = Object.create(null);
  }
  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
  d3_class(d3_Map, {
    has: d3_map_has,
    get: function(key) {
      return this._[d3_map_escape(key)];
    },
    set: function(key, value) {
      return this._[d3_map_escape(key)] = value;
    },
    remove: d3_map_remove,
    keys: d3_map_keys,
    values: function() {
      var values = [];
      for (var key in this._) values.push(this._[key]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var key in this._) entries.push({
        key: d3_map_unescape(key),
        value: this._[key]
      });
      return entries;
    },
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
    }
  });
  function d3_map_escape(key) {
    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
  }
  function d3_map_unescape(key) {
    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
  }
  function d3_map_has(key) {
    return d3_map_escape(key) in this._;
  }
  function d3_map_remove(key) {
    return (key = d3_map_escape(key)) in this._ && delete this._[key];
  }
  function d3_map_keys() {
    var keys = [];
    for (var key in this._) keys.push(d3_map_unescape(key));
    return keys;
  }
  function d3_map_size() {
    var size = 0;
    for (var key in this._) ++size;
    return size;
  }
  function d3_map_empty() {
    for (var key in this._) return false;
    return true;
  }
  d3.nest = function() {
    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
    function map(mapType, array, depth) {
      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
          values.push(object);
        } else {
          valuesByKey.set(keyValue, [ object ]);
        }
      }
      if (mapType) {
        object = mapType();
        setter = function(keyValue, values) {
          object.set(keyValue, map(mapType, values, depth));
        };
      } else {
        object = {};
        setter = function(keyValue, values) {
          object[keyValue] = map(mapType, values, depth);
        };
      }
      valuesByKey.forEach(setter);
      return object;
    }
    function entries(map, depth) {
      if (depth >= keys.length) return map;
      var array = [], sortKey = sortKeys[depth++];
      map.forEach(function(key, keyMap) {
        array.push({
          key: key,
          values: entries(keyMap, depth)
        });
      });
      return sortKey ? array.sort(function(a, b) {
        return sortKey(a.key, b.key);
      }) : array;
    }
    nest.map = function(array, mapType) {
      return map(mapType, array, 0);
    };
    nest.entries = function(array) {
      return entries(map(d3.map, array, 0), 0);
    };
    nest.key = function(d) {
      keys.push(d);
      return nest;
    };
    nest.sortKeys = function(order) {
      sortKeys[keys.length - 1] = order;
      return nest;
    };
    nest.sortValues = function(order) {
      sortValues = order;
      return nest;
    };
    nest.rollup = function(f) {
      rollup = f;
      return nest;
    };
    return nest;
  };
  d3.set = function(array) {
    var set = new d3_Set();
    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
    return set;
  };
  function d3_Set() {
    this._ = Object.create(null);
  }
  d3_class(d3_Set, {
    has: d3_map_has,
    add: function(key) {
      this._[d3_map_escape(key += "")] = true;
      return key;
    },
    remove: d3_map_remove,
    values: d3_map_keys,
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key));
    }
  });
  d3.behavior = {};
  function d3_identity(d) {
    return d;
  }
  d3.rebind = function(target, source) {
    var i = 1, n = arguments.length, method;
    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    return target;
  };
  function d3_rebind(target, source, method) {
    return function() {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  function d3_vendorSymbol(object, name) {
    if (name in object) return name;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
      var prefixName = d3_vendorPrefixes[i] + name;
      if (prefixName in object) return prefixName;
    }
  }
  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
  function d3_noop() {}
  d3.dispatch = function() {
    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    return dispatch;
  };
  function d3_dispatch() {}
  d3_dispatch.prototype.on = function(type, listener) {
    var i = type.indexOf("."), name = "";
    if (i >= 0) {
      name = type.slice(i + 1);
      type = type.slice(0, i);
    }
    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
    if (arguments.length === 2) {
      if (listener == null) for (type in this) {
        if (this.hasOwnProperty(type)) this[type].on(name, null);
      }
      return this;
    }
  };
  function d3_dispatch_event(dispatch) {
    var listeners = [], listenerByName = new d3_Map();
    function event() {
      var z = listeners, i = -1, n = z.length, l;
      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
      return dispatch;
    }
    event.on = function(name, listener) {
      var l = listenerByName.get(name), i;
      if (arguments.length < 2) return l && l.on;
      if (l) {
        l.on = null;
        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
        listenerByName.remove(name);
      }
      if (listener) listeners.push(listenerByName.set(name, {
        on: listener
      }));
      return dispatch;
    };
    return event;
  }
  d3.event = null;
  function d3_eventPreventDefault() {
    d3.event.preventDefault();
  }
  function d3_eventSource() {
    var e = d3.event, s;
    while (s = e.sourceEvent) e = s;
    return e;
  }
  function d3_eventDispatch(target) {
    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    dispatch.of = function(thiz, argumentz) {
      return function(e1) {
        try {
          var e0 = e1.sourceEvent = d3.event;
          e1.target = target;
          d3.event = e1;
          dispatch[e1.type].apply(thiz, argumentz);
        } finally {
          d3.event = e0;
        }
      };
    };
    return dispatch;
  }
  d3.requote = function(s) {
    return s.replace(d3_requote_re, "\\$&");
  };
  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var d3_subclass = {}.__proto__ ? function(object, prototype) {
    object.__proto__ = prototype;
  } : function(object, prototype) {
    for (var property in prototype) object[property] = prototype[property];
  };
  function d3_selection(groups) {
    d3_subclass(groups, d3_selectionPrototype);
    return groups;
  }
  var d3_select = function(s, n) {
    return n.querySelector(s);
  }, d3_selectAll = function(s, n) {
    return n.querySelectorAll(s);
  }, d3_selectMatches = function(n, s) {
    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
    d3_selectMatches = function(n, s) {
      return d3_selectMatcher.call(n, s);
    };
    return d3_selectMatches(n, s);
  };
  if (typeof Sizzle === "function") {
    d3_select = function(s, n) {
      return Sizzle(s, n)[0] || null;
    };
    d3_selectAll = Sizzle;
    d3_selectMatches = Sizzle.matchesSelector;
  }
  d3.selection = function() {
    return d3.select(d3_document.documentElement);
  };
  var d3_selectionPrototype = d3.selection.prototype = [];
  d3_selectionPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, group, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selector(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_select(selector, this);
    };
  }
  d3_selectionPrototype.selectAll = function(selector) {
    var subgroups = [], subgroup, node;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
          subgroup.parentNode = node;
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selectorAll(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_selectAll(selector, this);
    };
  }
  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
  var d3_nsPrefix = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: d3_nsXhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  d3.ns = {
    prefix: d3_nsPrefix,
    qualify: function(name) {
      var i = name.indexOf(":"), prefix = name;
      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
      return d3_nsPrefix.hasOwnProperty(prefix) ? {
        space: d3_nsPrefix[prefix],
        local: name
      } : name;
    }
  };
  d3_selectionPrototype.attr = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node();
        name = d3.ns.qualify(name);
        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
      }
      for (value in name) this.each(d3_selection_attr(value, name[value]));
      return this;
    }
    return this.each(d3_selection_attr(name, value));
  };
  function d3_selection_attr(name, value) {
    name = d3.ns.qualify(name);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrConstant() {
      this.setAttribute(name, value);
    }
    function attrConstantNS() {
      this.setAttributeNS(name.space, name.local, value);
    }
    function attrFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
    }
    function attrFunctionNS() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
    }
    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
  }
  function d3_collapse(s) {
    return s.trim().replace(/\s+/g, " ");
  }
  d3_selectionPrototype.classed = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
        if (value = node.classList) {
          while (++i < n) if (!value.contains(name[i])) return false;
        } else {
          value = node.getAttribute("class");
          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
        }
        return true;
      }
      for (value in name) this.each(d3_selection_classed(value, name[value]));
      return this;
    }
    return this.each(d3_selection_classed(name, value));
  };
  function d3_selection_classedRe(name) {
    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
  }
  function d3_selection_classes(name) {
    return (name + "").trim().split(/^|\s+/);
  }
  function d3_selection_classed(name, value) {
    name = d3_selection_classes(name).map(d3_selection_classedName);
    var n = name.length;
    function classedConstant() {
      var i = -1;
      while (++i < n) name[i](this, value);
    }
    function classedFunction() {
      var i = -1, x = value.apply(this, arguments);
      while (++i < n) name[i](this, x);
    }
    return typeof value === "function" ? classedFunction : classedConstant;
  }
  function d3_selection_classedName(name) {
    var re = d3_selection_classedRe(name);
    return function(node, value) {
      if (c = node.classList) return value ? c.add(name) : c.remove(name);
      var c = node.getAttribute("class") || "";
      if (value) {
        re.lastIndex = 0;
        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
      } else {
        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
      }
    };
  }
  d3_selectionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
        return this;
      }
      if (n < 2) {
        var node = this.node();
        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }
      priority = "";
    }
    return this.each(d3_selection_style(name, value, priority));
  };
  function d3_selection_style(name, value, priority) {
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleConstant() {
      this.style.setProperty(name, value, priority);
    }
    function styleFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
    }
    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
  }
  d3_selectionPrototype.property = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") return this.node()[name];
      for (value in name) this.each(d3_selection_property(value, name[value]));
      return this;
    }
    return this.each(d3_selection_property(name, value));
  };
  function d3_selection_property(name, value) {
    function propertyNull() {
      delete this[name];
    }
    function propertyConstant() {
      this[name] = value;
    }
    function propertyFunction() {
      var x = value.apply(this, arguments);
      if (x == null) delete this[name]; else this[name] = x;
    }
    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
  }
  d3_selectionPrototype.text = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.textContent = v == null ? "" : v;
    } : value == null ? function() {
      this.textContent = "";
    } : function() {
      this.textContent = value;
    }) : this.node().textContent;
  };
  d3_selectionPrototype.html = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.innerHTML = v == null ? "" : v;
    } : value == null ? function() {
      this.innerHTML = "";
    } : function() {
      this.innerHTML = value;
    }) : this.node().innerHTML;
  };
  d3_selectionPrototype.append = function(name) {
    name = d3_selection_creator(name);
    return this.select(function() {
      return this.appendChild(name.apply(this, arguments));
    });
  };
  function d3_selection_creator(name) {
    function create() {
      var document = this.ownerDocument, namespace = this.namespaceURI;
      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
    }
    function createNS() {
      return this.ownerDocument.createElementNS(name.space, name.local);
    }
    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
  }
  d3_selectionPrototype.insert = function(name, before) {
    name = d3_selection_creator(name);
    before = d3_selection_selector(before);
    return this.select(function() {
      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
    });
  };
  d3_selectionPrototype.remove = function() {
    return this.each(d3_selectionRemove);
  };
  function d3_selectionRemove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
  }
  d3_selectionPrototype.data = function(value, key) {
    var i = -1, n = this.length, group, node;
    if (!arguments.length) {
      value = new Array(n = (group = this[0]).length);
      while (++i < n) {
        if (node = group[i]) {
          value[i] = node.__data__;
        }
      }
      return value;
    }
    function bind(group, groupData) {
      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
      if (key) {
        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
        for (i = -1; ++i < n; ) {
          if (node = group[i]) {
            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
              exitNodes[i] = node;
            } else {
              nodeByKeyValue.set(keyValue, node);
            }
            keyValues[i] = keyValue;
          }
        }
        for (i = -1; ++i < m; ) {
          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          } else if (node !== true) {
            updateNodes[i] = node;
            node.__data__ = nodeData;
          }
          nodeByKeyValue.set(keyValue, true);
        }
        for (i = -1; ++i < n; ) {
          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
            exitNodes[i] = group[i];
          }
        }
      } else {
        for (i = -1; ++i < n0; ) {
          node = group[i];
          nodeData = groupData[i];
          if (node) {
            node.__data__ = nodeData;
            updateNodes[i] = node;
          } else {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          }
        }
        for (;i < m; ++i) {
          enterNodes[i] = d3_selection_dataNode(groupData[i]);
        }
        for (;i < n; ++i) {
          exitNodes[i] = group[i];
        }
      }
      enterNodes.update = updateNodes;
      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
      enter.push(enterNodes);
      update.push(updateNodes);
      exit.push(exitNodes);
    }
    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
    if (typeof value === "function") {
      while (++i < n) {
        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
      }
    } else {
      while (++i < n) {
        bind(group = this[i], value);
      }
    }
    update.enter = function() {
      return enter;
    };
    update.exit = function() {
      return exit;
    };
    return update;
  };
  function d3_selection_dataNode(data) {
    return {
      __data__: data
    };
  }
  d3_selectionPrototype.datum = function(value) {
    return arguments.length ? this.property("__data__", value) : this.property("__data__");
  };
  d3_selectionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_filter(selector) {
    return function() {
      return d3_selectMatches(this, selector);
    };
  }
  d3_selectionPrototype.order = function() {
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
        if (node = group[i]) {
          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
          next = node;
        }
      }
    }
    return this;
  };
  d3_selectionPrototype.sort = function(comparator) {
    comparator = d3_selection_sortComparator.apply(this, arguments);
    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
    return this.order();
  };
  function d3_selection_sortComparator(comparator) {
    if (!arguments.length) comparator = d3_ascending;
    return function(a, b) {
      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
    };
  }
  d3_selectionPrototype.each = function(callback) {
    return d3_selection_each(this, function(node, i, j) {
      callback.call(node, node.__data__, i, j);
    });
  };
  function d3_selection_each(groups, callback) {
    for (var j = 0, m = groups.length; j < m; j++) {
      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
        if (node = group[i]) callback(node, i, j);
      }
    }
    return groups;
  }
  d3_selectionPrototype.call = function(callback) {
    var args = d3_array(arguments);
    callback.apply(args[0] = this, args);
    return this;
  };
  d3_selectionPrototype.empty = function() {
    return !this.node();
  };
  d3_selectionPrototype.node = function() {
    for (var j = 0, m = this.length; j < m; j++) {
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        var node = group[i];
        if (node) return node;
      }
    }
    return null;
  };
  d3_selectionPrototype.size = function() {
    var n = 0;
    d3_selection_each(this, function() {
      ++n;
    });
    return n;
  };
  function d3_selection_enter(selection) {
    d3_subclass(selection, d3_selection_enterPrototype);
    return selection;
  }
  var d3_selection_enterPrototype = [];
  d3.selection.enter = d3_selection_enter;
  d3.selection.enter.prototype = d3_selection_enterPrototype;
  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
  d3_selection_enterPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, upgroup, group, node;
    for (var j = -1, m = this.length; ++j < m; ) {
      upgroup = (group = this[j]).update;
      subgroups.push(subgroup = []);
      subgroup.parentNode = group.parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
          subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  d3_selection_enterPrototype.insert = function(name, before) {
    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
    return d3_selectionPrototype.insert.call(this, name, before);
  };
  function d3_selection_enterInsertBefore(enter) {
    var i0, j0;
    return function(d, i, j) {
      var group = enter[j].update, n = group.length, node;
      if (j != j0) j0 = j, i0 = 0;
      if (i >= i0) i0 = i + 1;
      while (!(node = group[i0]) && ++i0 < n) ;
      return node;
    };
  }
  d3.select = function(node) {
    var group;
    if (typeof node === "string") {
      group = [ d3_select(node, d3_document) ];
      group.parentNode = d3_document.documentElement;
    } else {
      group = [ node ];
      group.parentNode = d3_documentElement(node);
    }
    return d3_selection([ group ]);
  };
  d3.selectAll = function(nodes) {
    var group;
    if (typeof nodes === "string") {
      group = d3_array(d3_selectAll(nodes, d3_document));
      group.parentNode = d3_document.documentElement;
    } else {
      group = d3_array(nodes);
      group.parentNode = null;
    }
    return d3_selection([ group ]);
  };
  d3_selectionPrototype.on = function(type, listener, capture) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof type !== "string") {
        if (n < 2) listener = false;
        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
        return this;
      }
      if (n < 2) return (n = this.node()["__on" + type]) && n._;
      capture = false;
    }
    return this.each(d3_selection_on(type, listener, capture));
  };
  function d3_selection_on(type, listener, capture) {
    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
    if (i > 0) type = type.slice(0, i);
    var filter = d3_selection_onFilters.get(type);
    if (filter) type = filter, wrap = d3_selection_onFilter;
    function onRemove() {
      var l = this[name];
      if (l) {
        this.removeEventListener(type, l, l.$);
        delete this[name];
      }
    }
    function onAdd() {
      var l = wrap(listener, d3_array(arguments));
      onRemove.call(this);
      this.addEventListener(type, this[name] = l, l.$ = capture);
      l._ = listener;
    }
    function removeAll() {
      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
      for (var name in this) {
        if (match = name.match(re)) {
          var l = this[name];
          this.removeEventListener(match[1], l, l.$);
          delete this[name];
        }
      }
    }
    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
  }
  var d3_selection_onFilters = d3.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  if (d3_document) {
    d3_selection_onFilters.forEach(function(k) {
      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
  }
  function d3_selection_onListener(listener, argumentz) {
    return function(e) {
      var o = d3.event;
      d3.event = e;
      argumentz[0] = this.__data__;
      try {
        listener.apply(this, argumentz);
      } finally {
        d3.event = o;
      }
    };
  }
  function d3_selection_onFilter(listener, argumentz) {
    var l = d3_selection_onListener(listener, argumentz);
    return function(e) {
      var target = this, related = e.relatedTarget;
      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
        l.call(target, e);
      }
    };
  }
  var d3_event_dragSelect, d3_event_dragId = 0;
  function d3_event_dragSuppress(node) {
    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
    if (d3_event_dragSelect == null) {
      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
    }
    if (d3_event_dragSelect) {
      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
      style[d3_event_dragSelect] = "none";
    }
    return function(suppressClick) {
      w.on(name, null);
      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
      if (suppressClick) {
        var off = function() {
          w.on(click, null);
        };
        w.on(click, function() {
          d3_eventPreventDefault();
          off();
        }, true);
        setTimeout(off, 0);
      }
    };
  }
  d3.mouse = function(container) {
    return d3_mousePoint(container, d3_eventSource());
  };
  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
  function d3_mousePoint(container, e) {
    if (e.changedTouches) e = e.changedTouches[0];
    var svg = container.ownerSVGElement || container;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      if (d3_mouse_bug44083 < 0) {
        var window = d3_window(container);
        if (window.scrollX || window.scrollY) {
          svg = d3.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var ctm = svg[0][0].getScreenCTM();
          d3_mouse_bug44083 = !(ctm.f || ctm.e);
          svg.remove();
        }
      }
      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
      point.y = e.clientY;
      point = point.matrixTransform(container.getScreenCTM().inverse());
      return [ point.x, point.y ];
    }
    var rect = container.getBoundingClientRect();
    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
  }
  d3.touch = function(container, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
      if ((touch = touches[i]).identifier === identifier) {
        return d3_mousePoint(container, touch);
      }
    }
  };
  d3.behavior.drag = function() {
    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
    function drag() {
      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
    }
    function dragstart(id, position, subject, move, end) {
      return function() {
        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
        if (origin) {
          dragOffset = origin.apply(that, arguments);
          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
        } else {
          dragOffset = [ 0, 0 ];
        }
        dispatch({
          type: "dragstart"
        });
        function moved() {
          var position1 = position(parent, dragId), dx, dy;
          if (!position1) return;
          dx = position1[0] - position0[0];
          dy = position1[1] - position0[1];
          dragged |= dx | dy;
          position0 = position1;
          dispatch({
            type: "drag",
            x: position1[0] + dragOffset[0],
            y: position1[1] + dragOffset[1],
            dx: dx,
            dy: dy
          });
        }
        function ended() {
          if (!position(parent, dragId)) return;
          dragSubject.on(move + dragName, null).on(end + dragName, null);
          dragRestore(dragged);
          dispatch({
            type: "dragend"
          });
        }
      };
    }
    drag.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return drag;
    };
    return d3.rebind(drag, event, "on");
  };
  function d3_behavior_dragTouchId() {
    return d3.event.changedTouches[0].identifier;
  }
  d3.touches = function(container, touches) {
    if (arguments.length < 2) touches = d3_eventSource().touches;
    return touches ? d3_array(touches).map(function(touch) {
      var point = d3_mousePoint(container, touch);
      point.identifier = touch.identifier;
      return point;
    }) : [];
  };
  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
  function d3_sgn(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }
  function d3_cross2d(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function d3_acos(x) {
    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
  }
  function d3_asin(x) {
    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
  }
  function d3_sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  function d3_cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  function d3_tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  function d3_haversin(x) {
    return (x = Math.sin(x / 2)) * x;
  }
  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
  d3.interpolateZoom = function(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < ε2) {
      S = Math.log(w1 / w0) / ρ;
      i = function(t) {
        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / ρ;
      i = function(t) {
        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
      };
    }
    i.duration = S * 1e3;
    return i;
  };
  d3.behavior.zoom = function() {
    var view = {
      x: 0,
      y: 0,
      k: 1
    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
    if (!d3_behavior_zoomWheel) {
      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
      }, "MozMousePixelScroll");
    }
    function zoom(g) {
      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
    }
    zoom.event = function(g) {
      g.each(function() {
        var dispatch = event.of(this, arguments), view1 = view;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.zoom", function() {
            view = this.__chart__ || {
              x: 0,
              y: 0,
              k: 1
            };
            zoomstarted(dispatch);
          }).tween("zoom:zoom", function() {
            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
            return function(t) {
              var l = i(t), k = dx / l[2];
              this.__chart__ = view = {
                x: cx - l[0] * k,
                y: cy - l[1] * k,
                k: k
              };
              zoomed(dispatch);
            };
          }).each("interrupt.zoom", function() {
            zoomended(dispatch);
          }).each("end.zoom", function() {
            zoomended(dispatch);
          });
        } else {
          this.__chart__ = view;
          zoomstarted(dispatch);
          zoomed(dispatch);
          zoomended(dispatch);
        }
      });
    };
    zoom.translate = function(_) {
      if (!arguments.length) return [ view.x, view.y ];
      view = {
        x: +_[0],
        y: +_[1],
        k: view.k
      };
      rescale();
      return zoom;
    };
    zoom.scale = function(_) {
      if (!arguments.length) return view.k;
      view = {
        x: view.x,
        y: view.y,
        k: null
      };
      scaleTo(+_);
      rescale();
      return zoom;
    };
    zoom.scaleExtent = function(_) {
      if (!arguments.length) return scaleExtent;
      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.center = function(_) {
      if (!arguments.length) return center;
      center = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.size = function(_) {
      if (!arguments.length) return size;
      size = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.duration = function(_) {
      if (!arguments.length) return duration;
      duration = +_;
      return zoom;
    };
    zoom.x = function(z) {
      if (!arguments.length) return x1;
      x1 = z;
      x0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    zoom.y = function(z) {
      if (!arguments.length) return y1;
      y1 = z;
      y0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    function location(p) {
      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
    }
    function point(l) {
      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
    }
    function scaleTo(s) {
      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
    }
    function translateTo(p, l) {
      l = point(l);
      view.x += p[0] - l[0];
      view.y += p[1] - l[1];
    }
    function zoomTo(that, p, l, k) {
      that.__chart__ = {
        x: view.x,
        y: view.y,
        k: view.k
      };
      scaleTo(Math.pow(2, k));
      translateTo(center0 = p, l);
      that = d3.select(that);
      if (duration > 0) that = that.transition().duration(duration);
      that.call(zoom.event);
    }
    function rescale() {
      if (x1) x1.domain(x0.range().map(function(x) {
        return (x - view.x) / view.k;
      }).map(x0.invert));
      if (y1) y1.domain(y0.range().map(function(y) {
        return (y - view.y) / view.k;
      }).map(y0.invert));
    }
    function zoomstarted(dispatch) {
      if (!zooming++) dispatch({
        type: "zoomstart"
      });
    }
    function zoomed(dispatch) {
      rescale();
      dispatch({
        type: "zoom",
        scale: view.k,
        translate: [ view.x, view.y ]
      });
    }
    function zoomended(dispatch) {
      if (!--zooming) dispatch({
        type: "zoomend"
      }), center0 = null;
    }
    function mousedowned() {
      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
      d3_selection_interrupt.call(that);
      zoomstarted(dispatch);
      function moved() {
        dragged = 1;
        translateTo(d3.mouse(that), location0);
        zoomed(dispatch);
      }
      function ended() {
        subject.on(mousemove, null).on(mouseup, null);
        dragRestore(dragged);
        zoomended(dispatch);
      }
    }
    function touchstarted() {
      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
      started();
      zoomstarted(dispatch);
      subject.on(mousedown, null).on(touchstart, started);
      function relocate() {
        var touches = d3.touches(that);
        scale0 = view.k;
        touches.forEach(function(t) {
          if (t.identifier in locations0) locations0[t.identifier] = location(t);
        });
        return touches;
      }
      function started() {
        var target = d3.event.target;
        d3.select(target).on(touchmove, moved).on(touchend, ended);
        targets.push(target);
        var changed = d3.event.changedTouches;
        for (var i = 0, n = changed.length; i < n; ++i) {
          locations0[changed[i].identifier] = null;
        }
        var touches = relocate(), now = Date.now();
        if (touches.length === 1) {
          if (now - touchtime < 500) {
            var p = touches[0];
            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
            d3_eventPreventDefault();
          }
          touchtime = now;
        } else if (touches.length > 1) {
          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
          distance0 = dx * dx + dy * dy;
        }
      }
      function moved() {
        var touches = d3.touches(that), p0, l0, p1, l1;
        d3_selection_interrupt.call(that);
        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
          p1 = touches[i];
          if (l1 = locations0[p1.identifier]) {
            if (l0) break;
            p0 = p1, l0 = l1;
          }
        }
        if (l1) {
          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
          scaleTo(scale1 * scale0);
        }
        touchtime = null;
        translateTo(p0, l0);
        zoomed(dispatch);
      }
      function ended() {
        if (d3.event.touches.length) {
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            delete locations0[changed[i].identifier];
          }
          for (var identifier in locations0) {
            return void relocate();
          }
        }
        d3.selectAll(targets).on(zoomName, null);
        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
        dragRestore();
        zoomended(dispatch);
      }
    }
    function mousewheeled() {
      var dispatch = event.of(this, arguments);
      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
      mousewheelTimer = setTimeout(function() {
        mousewheelTimer = null;
        zoomended(dispatch);
      }, 50);
      d3_eventPreventDefault();
      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
      translateTo(center0, translate0);
      zoomed(dispatch);
    }
    function dblclicked() {
      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
    }
    return d3.rebind(zoom, event, "on");
  };
  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
  d3.color = d3_color;
  function d3_color() {}
  d3_color.prototype.toString = function() {
    return this.rgb() + "";
  };
  d3.hsl = d3_hsl;
  function d3_hsl(h, s, l) {
    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
  }
  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
  d3_hslPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, this.l / k);
  };
  d3_hslPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, k * this.l);
  };
  d3_hslPrototype.rgb = function() {
    return d3_hsl_rgb(this.h, this.s, this.l);
  };
  function d3_hsl_rgb(h, s, l) {
    var m1, m2;
    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
    l = l < 0 ? 0 : l > 1 ? 1 : l;
    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
    m1 = 2 * l - m2;
    function v(h) {
      if (h > 360) h -= 360; else if (h < 0) h += 360;
      if (h < 60) return m1 + (m2 - m1) * h / 60;
      if (h < 180) return m2;
      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
      return m1;
    }
    function vv(h) {
      return Math.round(v(h) * 255);
    }
    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
  }
  d3.hcl = d3_hcl;
  function d3_hcl(h, c, l) {
    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
  }
  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
  d3_hclPrototype.brighter = function(k) {
    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.darker = function(k) {
    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.rgb = function() {
    return d3_hcl_lab(this.h, this.c, this.l).rgb();
  };
  function d3_hcl_lab(h, c, l) {
    if (isNaN(h)) h = 0;
    if (isNaN(c)) c = 0;
    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
  }
  d3.lab = d3_lab;
  function d3_lab(l, a, b) {
    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
  }
  var d3_lab_K = 18;
  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
  var d3_labPrototype = d3_lab.prototype = new d3_color();
  d3_labPrototype.brighter = function(k) {
    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.darker = function(k) {
    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.rgb = function() {
    return d3_lab_rgb(this.l, this.a, this.b);
  };
  function d3_lab_rgb(l, a, b) {
    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
    x = d3_lab_xyz(x) * d3_lab_X;
    y = d3_lab_xyz(y) * d3_lab_Y;
    z = d3_lab_xyz(z) * d3_lab_Z;
    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
  }
  function d3_lab_hcl(l, a, b) {
    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
  }
  function d3_lab_xyz(x) {
    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
  }
  function d3_xyz_lab(x) {
    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
  }
  function d3_xyz_rgb(r) {
    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
  }
  d3.rgb = d3_rgb;
  function d3_rgb(r, g, b) {
    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
  }
  function d3_rgbNumber(value) {
    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
  }
  function d3_rgbString(value) {
    return d3_rgbNumber(value) + "";
  }
  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
  d3_rgbPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    var r = this.r, g = this.g, b = this.b, i = 30;
    if (!r && !g && !b) return new d3_rgb(i, i, i);
    if (r && r < i) r = i;
    if (g && g < i) g = i;
    if (b && b < i) b = i;
    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
  };
  d3_rgbPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_rgb(k * this.r, k * this.g, k * this.b);
  };
  d3_rgbPrototype.hsl = function() {
    return d3_rgb_hsl(this.r, this.g, this.b);
  };
  d3_rgbPrototype.toString = function() {
    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
  };
  function d3_rgb_hex(v) {
    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
  }
  function d3_rgb_parse(format, rgb, hsl) {
    var r = 0, g = 0, b = 0, m1, m2, color;
    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
    if (m1) {
      m2 = m1[2].split(",");
      switch (m1[1]) {
       case "hsl":
        {
          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
        }

       case "rgb":
        {
          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
        }
      }
    }
    if (color = d3_rgb_names.get(format)) {
      return rgb(color.r, color.g, color.b);
    }
    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
      if (format.length === 4) {
        r = (color & 3840) >> 4;
        r = r >> 4 | r;
        g = color & 240;
        g = g >> 4 | g;
        b = color & 15;
        b = b << 4 | b;
      } else if (format.length === 7) {
        r = (color & 16711680) >> 16;
        g = (color & 65280) >> 8;
        b = color & 255;
      }
    }
    return rgb(r, g, b);
  }
  function d3_rgb_hsl(r, g, b) {
    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
    if (d) {
      s = l < .5 ? d / (max + min) : d / (2 - max - min);
      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60;
    } else {
      h = NaN;
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new d3_hsl(h, s, l);
  }
  function d3_rgb_lab(r, g, b) {
    r = d3_rgb_xyz(r);
    g = d3_rgb_xyz(g);
    b = d3_rgb_xyz(b);
    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
  }
  function d3_rgb_xyz(r) {
    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
  }
  function d3_rgb_parseNumber(c) {
    var f = parseFloat(c);
    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
  }
  var d3_rgb_names = d3.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  d3_rgb_names.forEach(function(key, value) {
    d3_rgb_names.set(key, d3_rgbNumber(value));
  });
  function d3_functor(v) {
    return typeof v === "function" ? v : function() {
      return v;
    };
  }
  d3.functor = d3_functor;
  d3.xhr = d3_xhrType(d3_identity);
  function d3_xhrType(response) {
    return function(url, mimeType, callback) {
      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
      mimeType = null;
      return d3_xhr(url, mimeType, response, callback);
    };
  }
  function d3_xhr(url, mimeType, response, callback) {
    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
      request.readyState > 3 && respond();
    };
    function respond() {
      var status = request.status, result;
      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
        try {
          result = response.call(xhr, request);
        } catch (e) {
          dispatch.error.call(xhr, e);
          return;
        }
        dispatch.load.call(xhr, result);
      } else {
        dispatch.error.call(xhr, request);
      }
    }
    request.onprogress = function(event) {
      var o = d3.event;
      d3.event = event;
      try {
        dispatch.progress.call(xhr, request);
      } finally {
        d3.event = o;
      }
    };
    xhr.header = function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers[name];
      if (value == null) delete headers[name]; else headers[name] = value + "";
      return xhr;
    };
    xhr.mimeType = function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return xhr;
    };
    xhr.responseType = function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return xhr;
    };
    xhr.response = function(value) {
      response = value;
      return xhr;
    };
    [ "get", "post" ].forEach(function(method) {
      xhr[method] = function() {
        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
      };
    });
    xhr.send = function(method, data, callback) {
      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
      request.open(method, url, true);
      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
      if (responseType != null) request.responseType = responseType;
      if (callback != null) xhr.on("error", callback).on("load", function(request) {
        callback(null, request);
      });
      dispatch.beforesend.call(xhr, request);
      request.send(data == null ? null : data);
      return xhr;
    };
    xhr.abort = function() {
      request.abort();
      return xhr;
    };
    d3.rebind(xhr, dispatch, "on");
    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
  }
  function d3_xhr_fixCallback(callback) {
    return callback.length === 1 ? function(error, request) {
      callback(error == null ? request : null);
    } : callback;
  }
  function d3_xhrHasResponse(request) {
    var type = request.responseType;
    return type && type !== "text" ? request.response : request.responseText;
  }
  d3.dsv = function(delimiter, mimeType) {
    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
    function dsv(url, row, callback) {
      if (arguments.length < 3) callback = row, row = null;
      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
      xhr.row = function(_) {
        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
      };
      return xhr;
    }
    function response(request) {
      return dsv.parse(request.responseText);
    }
    function typedResponse(f) {
      return function(request) {
        return dsv.parse(request.responseText, f);
      };
    }
    dsv.parse = function(text, f) {
      var o;
      return dsv.parseRows(text, function(row, i) {
        if (o) return o(row, i - 1);
        var a = new Function("d", "return {" + row.map(function(name, i) {
          return JSON.stringify(name) + ": d[" + i + "]";
        }).join(",") + "}");
        o = f ? function(row, i) {
          return f(a(row), i);
        } : a;
      });
    };
    dsv.parseRows = function(text, f) {
      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
      function token() {
        if (I >= N) return EOF;
        if (eol) return eol = false, EOL;
        var j = I;
        if (text.charCodeAt(j) === 34) {
          var i = j;
          while (i++ < N) {
            if (text.charCodeAt(i) === 34) {
              if (text.charCodeAt(i + 1) !== 34) break;
              ++i;
            }
          }
          I = i + 2;
          var c = text.charCodeAt(i + 1);
          if (c === 13) {
            eol = true;
            if (text.charCodeAt(i + 2) === 10) ++I;
          } else if (c === 10) {
            eol = true;
          }
          return text.slice(j + 1, i).replace(/""/g, '"');
        }
        while (I < N) {
          var c = text.charCodeAt(I++), k = 1;
          if (c === 10) eol = true; else if (c === 13) {
            eol = true;
            if (text.charCodeAt(I) === 10) ++I, ++k;
          } else if (c !== delimiterCode) continue;
          return text.slice(j, I - k);
        }
        return text.slice(j);
      }
      while ((t = token()) !== EOF) {
        var a = [];
        while (t !== EOL && t !== EOF) {
          a.push(t);
          t = token();
        }
        if (f && (a = f(a, n++)) == null) continue;
        rows.push(a);
      }
      return rows;
    };
    dsv.format = function(rows) {
      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
      var fieldSet = new d3_Set(), fields = [];
      rows.forEach(function(row) {
        for (var field in row) {
          if (!fieldSet.has(field)) {
            fields.push(fieldSet.add(field));
          }
        }
      });
      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
        return fields.map(function(field) {
          return formatValue(row[field]);
        }).join(delimiter);
      })).join("\n");
    };
    dsv.formatRows = function(rows) {
      return rows.map(formatRow).join("\n");
    };
    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
    }
    return dsv;
  };
  d3.csv = d3.dsv(",", "text/csv");
  d3.tsv = d3.dsv("	", "text/tab-separated-values");
  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
    setTimeout(callback, 17);
  };
  d3.timer = function() {
    d3_timer.apply(this, arguments);
  };
  function d3_timer(callback, delay, then) {
    var n = arguments.length;
    if (n < 2) delay = 0;
    if (n < 3) then = Date.now();
    var time = then + delay, timer = {
      c: callback,
      t: time,
      n: null
    };
    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
    d3_timer_queueTail = timer;
    if (!d3_timer_interval) {
      d3_timer_timeout = clearTimeout(d3_timer_timeout);
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
    return timer;
  }
  function d3_timer_step() {
    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
    if (delay > 24) {
      if (isFinite(delay)) {
        clearTimeout(d3_timer_timeout);
        d3_timer_timeout = setTimeout(d3_timer_step, delay);
      }
      d3_timer_interval = 0;
    } else {
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
  }
  d3.timer.flush = function() {
    d3_timer_mark();
    d3_timer_sweep();
  };
  function d3_timer_mark() {
    var now = Date.now(), timer = d3_timer_queueHead;
    while (timer) {
      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
      timer = timer.n;
    }
    return now;
  }
  function d3_timer_sweep() {
    var t0, t1 = d3_timer_queueHead, time = Infinity;
    while (t1) {
      if (t1.c) {
        if (t1.t < time) time = t1.t;
        t1 = (t0 = t1).n;
      } else {
        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
      }
    }
    d3_timer_queueTail = t0;
    return time;
  }
  function d3_format_precision(x, p) {
    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
  }
  d3.round = function(x, n) {
    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
  };
  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
  d3.formatPrefix = function(value, precision) {
    var i = 0;
    if (value = +value) {
      if (value < 0) value *= -1;
      if (precision) value = d3.round(value, d3_format_precision(value, precision));
      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
    }
    return d3_formatPrefixes[8 + i / 3];
  };
  function d3_formatPrefix(d, i) {
    var k = Math.pow(10, abs(8 - i) * 3);
    return {
      scale: i > 8 ? function(d) {
        return d / k;
      } : function(d) {
        return d * k;
      },
      symbol: d
    };
  }
  function d3_locale_numberFormat(locale) {
    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = locale_grouping[j = (j + 1) % locale_grouping.length];
      }
      return t.reverse().join(locale_thousands);
    } : d3_identity;
    return function(specifier) {
      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
      if (precision) precision = +precision.substring(1);
      if (zfill || fill === "0" && align === "=") {
        zfill = fill = "0";
        align = "=";
      }
      switch (type) {
       case "n":
        comma = true;
        type = "g";
        break;

       case "%":
        scale = 100;
        suffix = "%";
        type = "f";
        break;

       case "p":
        scale = 100;
        suffix = "%";
        type = "r";
        break;

       case "b":
       case "o":
       case "x":
       case "X":
        if (symbol === "#") prefix = "0" + type.toLowerCase();

       case "c":
        exponent = false;

       case "d":
        integer = true;
        precision = 0;
        break;

       case "s":
        scale = -1;
        type = "r";
        break;
      }
      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
      if (type == "r" && !precision) type = "g";
      if (precision != null) {
        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
      }
      type = d3_format_types.get(type) || d3_format_typeDefault;
      var zcomma = zfill && comma;
      return function(value) {
        var fullSuffix = suffix;
        if (integer && value % 1) return "";
        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
        if (scale < 0) {
          var unit = d3.formatPrefix(value, precision);
          value = unit.scale(value);
          fullSuffix = unit.symbol + suffix;
        } else {
          value *= scale;
        }
        value = type(value, precision);
        var i = value.lastIndexOf("."), before, after;
        if (i < 0) {
          var j = exponent ? value.lastIndexOf("e") : -1;
          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
        } else {
          before = value.substring(0, i);
          after = locale_decimal + value.substring(i + 1);
        }
        if (!zfill && comma) before = formatGroup(before, Infinity);
        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
        negative += prefix;
        value = before + after;
        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
      };
    };
  }
  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
  var d3_format_types = d3.map({
    b: function(x) {
      return x.toString(2);
    },
    c: function(x) {
      return String.fromCharCode(x);
    },
    o: function(x) {
      return x.toString(8);
    },
    x: function(x) {
      return x.toString(16);
    },
    X: function(x) {
      return x.toString(16).toUpperCase();
    },
    g: function(x, p) {
      return x.toPrecision(p);
    },
    e: function(x, p) {
      return x.toExponential(p);
    },
    f: function(x, p) {
      return x.toFixed(p);
    },
    r: function(x, p) {
      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
    }
  });
  function d3_format_typeDefault(x) {
    return x + "";
  }
  var d3_time = d3.time = {}, d3_date = Date;
  function d3_date_utc() {
    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
  }
  d3_date_utc.prototype = {
    getDate: function() {
      return this._.getUTCDate();
    },
    getDay: function() {
      return this._.getUTCDay();
    },
    getFullYear: function() {
      return this._.getUTCFullYear();
    },
    getHours: function() {
      return this._.getUTCHours();
    },
    getMilliseconds: function() {
      return this._.getUTCMilliseconds();
    },
    getMinutes: function() {
      return this._.getUTCMinutes();
    },
    getMonth: function() {
      return this._.getUTCMonth();
    },
    getSeconds: function() {
      return this._.getUTCSeconds();
    },
    getTime: function() {
      return this._.getTime();
    },
    getTimezoneOffset: function() {
      return 0;
    },
    valueOf: function() {
      return this._.valueOf();
    },
    setDate: function() {
      d3_time_prototype.setUTCDate.apply(this._, arguments);
    },
    setDay: function() {
      d3_time_prototype.setUTCDay.apply(this._, arguments);
    },
    setFullYear: function() {
      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
    },
    setHours: function() {
      d3_time_prototype.setUTCHours.apply(this._, arguments);
    },
    setMilliseconds: function() {
      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
    },
    setMinutes: function() {
      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
    },
    setMonth: function() {
      d3_time_prototype.setUTCMonth.apply(this._, arguments);
    },
    setSeconds: function() {
      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
    },
    setTime: function() {
      d3_time_prototype.setTime.apply(this._, arguments);
    }
  };
  var d3_time_prototype = Date.prototype;
  function d3_time_interval(local, step, number) {
    function round(date) {
      var d0 = local(date), d1 = offset(d0, 1);
      return date - d0 < d1 - date ? d0 : d1;
    }
    function ceil(date) {
      step(date = local(new d3_date(date - 1)), 1);
      return date;
    }
    function offset(date, k) {
      step(date = new d3_date(+date), k);
      return date;
    }
    function range(t0, t1, dt) {
      var time = ceil(t0), times = [];
      if (dt > 1) {
        while (time < t1) {
          if (!(number(time) % dt)) times.push(new Date(+time));
          step(time, 1);
        }
      } else {
        while (time < t1) times.push(new Date(+time)), step(time, 1);
      }
      return times;
    }
    function range_utc(t0, t1, dt) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = t0;
        return range(utc, t1, dt);
      } finally {
        d3_date = Date;
      }
    }
    local.floor = local;
    local.round = round;
    local.ceil = ceil;
    local.offset = offset;
    local.range = range;
    var utc = local.utc = d3_time_interval_utc(local);
    utc.floor = utc;
    utc.round = d3_time_interval_utc(round);
    utc.ceil = d3_time_interval_utc(ceil);
    utc.offset = d3_time_interval_utc(offset);
    utc.range = range_utc;
    return local;
  }
  function d3_time_interval_utc(method) {
    return function(date, k) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = date;
        return method(utc, k)._;
      } finally {
        d3_date = Date;
      }
    };
  }
  d3_time.year = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setMonth(0, 1);
    return date;
  }, function(date, offset) {
    date.setFullYear(date.getFullYear() + offset);
  }, function(date) {
    return date.getFullYear();
  });
  d3_time.years = d3_time.year.range;
  d3_time.years.utc = d3_time.year.utc.range;
  d3_time.day = d3_time_interval(function(date) {
    var day = new d3_date(2e3, 0);
    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    return day;
  }, function(date, offset) {
    date.setDate(date.getDate() + offset);
  }, function(date) {
    return date.getDate() - 1;
  });
  d3_time.days = d3_time.day.range;
  d3_time.days.utc = d3_time.day.utc.range;
  d3_time.dayOfYear = function(date) {
    var year = d3_time.year(date);
    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
  };
  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
    i = 7 - i;
    var interval = d3_time[day] = d3_time_interval(function(date) {
      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
      return date;
    }, function(date, offset) {
      date.setDate(date.getDate() + Math.floor(offset) * 7);
    }, function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
    });
    d3_time[day + "s"] = interval.range;
    d3_time[day + "s"].utc = interval.utc.range;
    d3_time[day + "OfYear"] = function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
    };
  });
  d3_time.week = d3_time.sunday;
  d3_time.weeks = d3_time.sunday.range;
  d3_time.weeks.utc = d3_time.sunday.utc.range;
  d3_time.weekOfYear = d3_time.sundayOfYear;
  function d3_locale_timeFormat(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    function d3_time_format(template) {
      var n = template.length;
      function format(date) {
        var string = [], i = -1, j = 0, c, p, f;
        while (++i < n) {
          if (template.charCodeAt(i) === 37) {
            string.push(template.slice(j, i));
            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
            string.push(c);
            j = i + 1;
          }
        }
        string.push(template.slice(j, i));
        return string.join("");
      }
      format.parse = function(string) {
        var d = {
          y: 1900,
          m: 0,
          d: 1,
          H: 0,
          M: 0,
          S: 0,
          L: 0,
          Z: null
        }, i = d3_time_parse(d, template, string, 0);
        if (i != string.length) return null;
        if ("p" in d) d.H = d.H % 12 + d.p * 12;
        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
          date.setFullYear(d.y, 0, 1);
          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
        } else date.setFullYear(d.y, d.m, d.d);
        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
        return localZ ? date._ : date;
      };
      format.toString = function() {
        return template;
      };
      return format;
    }
    function d3_time_parse(date, template, string, j) {
      var c, p, t, i = 0, n = template.length, m = string.length;
      while (i < n) {
        if (j >= m) return -1;
        c = template.charCodeAt(i++);
        if (c === 37) {
          t = template.charAt(i++);
          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
          if (!p || (j = p(date, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }
      return j;
    }
    d3_time_format.utc = function(template) {
      var local = d3_time_format(template);
      function format(date) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date();
          utc._ = date;
          return local(utc);
        } finally {
          d3_date = Date;
        }
      }
      format.parse = function(string) {
        try {
          d3_date = d3_date_utc;
          var date = local.parse(string);
          return date && date._;
        } finally {
          d3_date = Date;
        }
      };
      format.toString = local.toString;
      return format;
    };
    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
    locale_periods.forEach(function(p, i) {
      d3_time_periodLookup.set(p.toLowerCase(), i);
    });
    var d3_time_formats = {
      a: function(d) {
        return locale_shortDays[d.getDay()];
      },
      A: function(d) {
        return locale_days[d.getDay()];
      },
      b: function(d) {
        return locale_shortMonths[d.getMonth()];
      },
      B: function(d) {
        return locale_months[d.getMonth()];
      },
      c: d3_time_format(locale_dateTime),
      d: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      e: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      H: function(d, p) {
        return d3_time_formatPad(d.getHours(), p, 2);
      },
      I: function(d, p) {
        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
      },
      j: function(d, p) {
        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
      },
      L: function(d, p) {
        return d3_time_formatPad(d.getMilliseconds(), p, 3);
      },
      m: function(d, p) {
        return d3_time_formatPad(d.getMonth() + 1, p, 2);
      },
      M: function(d, p) {
        return d3_time_formatPad(d.getMinutes(), p, 2);
      },
      p: function(d) {
        return locale_periods[+(d.getHours() >= 12)];
      },
      S: function(d, p) {
        return d3_time_formatPad(d.getSeconds(), p, 2);
      },
      U: function(d, p) {
        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
      },
      w: function(d) {
        return d.getDay();
      },
      W: function(d, p) {
        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
      },
      x: d3_time_format(locale_date),
      X: d3_time_format(locale_time),
      y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
      },
      Y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
      },
      Z: d3_time_zone,
      "%": function() {
        return "%";
      }
    };
    var d3_time_parsers = {
      a: d3_time_parseWeekdayAbbrev,
      A: d3_time_parseWeekday,
      b: d3_time_parseMonthAbbrev,
      B: d3_time_parseMonth,
      c: d3_time_parseLocaleFull,
      d: d3_time_parseDay,
      e: d3_time_parseDay,
      H: d3_time_parseHour24,
      I: d3_time_parseHour24,
      j: d3_time_parseDayOfYear,
      L: d3_time_parseMilliseconds,
      m: d3_time_parseMonthNumber,
      M: d3_time_parseMinutes,
      p: d3_time_parseAmPm,
      S: d3_time_parseSeconds,
      U: d3_time_parseWeekNumberSunday,
      w: d3_time_parseWeekdayNumber,
      W: d3_time_parseWeekNumberMonday,
      x: d3_time_parseLocaleDate,
      X: d3_time_parseLocaleTime,
      y: d3_time_parseYear,
      Y: d3_time_parseFullYear,
      Z: d3_time_parseZone,
      "%": d3_time_parseLiteralPercent
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
      d3_time_dayAbbrevRe.lastIndex = 0;
      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
      d3_time_dayRe.lastIndex = 0;
      var n = d3_time_dayRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
      d3_time_monthAbbrevRe.lastIndex = 0;
      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
      d3_time_monthRe.lastIndex = 0;
      var n = d3_time_monthRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseAmPm(date, string, i) {
      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
      return n == null ? -1 : (date.p = n, i);
    }
    return d3_time_format;
  }
  var d3_time_formatPads = {
    "-": "",
    _: " ",
    "0": "0"
  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
  function d3_time_formatPad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }
  function d3_time_formatRe(names) {
    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
  }
  function d3_time_formatLookup(names) {
    var map = new d3_Map(), i = -1, n = names.length;
    while (++i < n) map.set(names[i].toLowerCase(), i);
    return map;
  }
  function d3_time_parseWeekdayNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
    return n ? (date.w = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberSunday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.U = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberMonday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.W = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseFullYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
    return n ? (date.y = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
  }
  function d3_time_parseZone(date, string, i) {
    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
    i + 5) : -1;
  }
  function d3_time_expandYear(d) {
    return d + (d > 68 ? 1900 : 2e3);
  }
  function d3_time_parseMonthNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
  }
  function d3_time_parseDay(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.d = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseDayOfYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.j = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseHour24(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.H = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMinutes(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.M = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseSeconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.S = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMilliseconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.L = +n[0], i + n[0].length) : -1;
  }
  function d3_time_zone(d) {
    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
  }
  function d3_time_parseLiteralPercent(date, string, i) {
    d3_time_percentRe.lastIndex = 0;
    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  function d3_time_formatMulti(formats) {
    var n = formats.length, i = -1;
    while (++i < n) formats[i][0] = this(formats[i][0]);
    return function(date) {
      var i = 0, f = formats[i];
      while (!f[1](date)) f = formats[++i];
      return f[0](date);
    };
  }
  d3.locale = function(locale) {
    return {
      numberFormat: d3_locale_numberFormat(locale),
      timeFormat: d3_locale_timeFormat(locale)
    };
  };
  var d3_locale_enUS = d3.locale({
    decimal: ".",
    thousands: ",",
    grouping: [ 3 ],
    currency: [ "$", "" ],
    dateTime: "%a %b %e %X %Y",
    date: "%m/%d/%Y",
    time: "%H:%M:%S",
    periods: [ "AM", "PM" ],
    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
  });
  d3.format = d3_locale_enUS.numberFormat;
  d3.geo = {};
  function d3_adder() {}
  d3_adder.prototype = {
    s: 0,
    t: 0,
    add: function(y) {
      d3_adderSum(y, this.t, d3_adderTemp);
      d3_adderSum(d3_adderTemp.s, this.s, this);
      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
    },
    reset: function() {
      this.s = this.t = 0;
    },
    valueOf: function() {
      return this.s;
    }
  };
  var d3_adderTemp = new d3_adder();
  function d3_adderSum(a, b, o) {
    var x = o.s = a + b, bv = x - a, av = x - bv;
    o.t = a - av + (b - bv);
  }
  d3.geo.stream = function(object, listener) {
    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
      d3_geo_streamObjectType[object.type](object, listener);
    } else {
      d3_geo_streamGeometry(object, listener);
    }
  };
  function d3_geo_streamGeometry(geometry, listener) {
    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
      d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
  }
  var d3_geo_streamObjectType = {
    Feature: function(feature, listener) {
      d3_geo_streamGeometry(feature.geometry, listener);
    },
    FeatureCollection: function(object, listener) {
      var features = object.features, i = -1, n = features.length;
      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
    }
  };
  var d3_geo_streamGeometryType = {
    Sphere: function(object, listener) {
      listener.sphere();
    },
    Point: function(object, listener) {
      object = object.coordinates;
      listener.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
    },
    LineString: function(object, listener) {
      d3_geo_streamLine(object.coordinates, listener, 0);
    },
    MultiLineString: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
    },
    Polygon: function(object, listener) {
      d3_geo_streamPolygon(object.coordinates, listener);
    },
    MultiPolygon: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
    },
    GeometryCollection: function(object, listener) {
      var geometries = object.geometries, i = -1, n = geometries.length;
      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
    }
  };
  function d3_geo_streamLine(coordinates, listener, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    listener.lineStart();
    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
    listener.lineEnd();
  }
  function d3_geo_streamPolygon(coordinates, listener) {
    var i = -1, n = coordinates.length;
    listener.polygonStart();
    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
    listener.polygonEnd();
  }
  d3.geo.area = function(object) {
    d3_geo_areaSum = 0;
    d3.geo.stream(object, d3_geo_area);
    return d3_geo_areaSum;
  };
  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
  var d3_geo_area = {
    sphere: function() {
      d3_geo_areaSum += 4 * π;
    },
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_areaRingSum.reset();
      d3_geo_area.lineStart = d3_geo_areaRingStart;
    },
    polygonEnd: function() {
      var area = 2 * d3_geo_areaRingSum;
      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
    }
  };
  function d3_geo_areaRingStart() {
    var λ00, φ00, λ0, cosφ0, sinφ0;
    d3_geo_area.point = function(λ, φ) {
      d3_geo_area.point = nextPoint;
      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
      sinφ0 = Math.sin(φ);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      φ = φ * d3_radians / 2 + π / 4;
      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
      d3_geo_areaRingSum.add(Math.atan2(v, u));
      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
    }
    d3_geo_area.lineEnd = function() {
      nextPoint(λ00, φ00);
    };
  }
  function d3_geo_cartesian(spherical) {
    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
  }
  function d3_geo_cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  }
  function d3_geo_cartesianCross(a, b) {
    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
  }
  function d3_geo_cartesianAdd(a, b) {
    a[0] += b[0];
    a[1] += b[1];
    a[2] += b[2];
  }
  function d3_geo_cartesianScale(vector, k) {
    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
  }
  function d3_geo_cartesianNormalize(d) {
    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l;
    d[1] /= l;
    d[2] /= l;
  }
  function d3_geo_spherical(cartesian) {
    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
  }
  function d3_geo_sphericalEqual(a, b) {
    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
  }
  d3.geo.bounds = function() {
    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
    var bound = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        bound.point = ringPoint;
        bound.lineStart = ringStart;
        bound.lineEnd = ringEnd;
        dλSum = 0;
        d3_geo_area.polygonStart();
      },
      polygonEnd: function() {
        d3_geo_area.polygonEnd();
        bound.point = point;
        bound.lineStart = lineStart;
        bound.lineEnd = lineEnd;
        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
        range[0] = λ0, range[1] = λ1;
      }
    };
    function point(λ, φ) {
      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
      if (φ < φ0) φ0 = φ;
      if (φ > φ1) φ1 = φ;
    }
    function linePoint(λ, φ) {
      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
      if (p0) {
        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
        d3_geo_cartesianNormalize(inflection);
        inflection = d3_geo_spherical(inflection);
        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = inflection[1] * d3_degrees;
          if (φi > φ1) φ1 = φi;
        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = -inflection[1] * d3_degrees;
          if (φi < φ0) φ0 = φi;
        } else {
          if (φ < φ0) φ0 = φ;
          if (φ > φ1) φ1 = φ;
        }
        if (antimeridian) {
          if (λ < λ_) {
            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
          } else {
            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
          }
        } else {
          if (λ1 >= λ0) {
            if (λ < λ0) λ0 = λ;
            if (λ > λ1) λ1 = λ;
          } else {
            if (λ > λ_) {
              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
            } else {
              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
            }
          }
        }
      } else {
        point(λ, φ);
      }
      p0 = p, λ_ = λ;
    }
    function lineStart() {
      bound.point = linePoint;
    }
    function lineEnd() {
      range[0] = λ0, range[1] = λ1;
      bound.point = point;
      p0 = null;
    }
    function ringPoint(λ, φ) {
      if (p0) {
        var dλ = λ - λ_;
        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
      } else λ__ = λ, φ__ = φ;
      d3_geo_area.point(λ, φ);
      linePoint(λ, φ);
    }
    function ringStart() {
      d3_geo_area.lineStart();
    }
    function ringEnd() {
      ringPoint(λ__, φ__);
      d3_geo_area.lineEnd();
      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
      range[0] = λ0, range[1] = λ1;
      p0 = null;
    }
    function angle(λ0, λ1) {
      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
    }
    function compareRanges(a, b) {
      return a[0] - b[0];
    }
    function withinRange(x, range) {
      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    return function(feature) {
      φ1 = λ1 = -(λ0 = φ0 = Infinity);
      ranges = [];
      d3.geo.stream(feature, bound);
      var n = ranges.length;
      if (n) {
        ranges.sort(compareRanges);
        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
          b = ranges[i];
          if (withinRange(b[0], a) || withinRange(b[1], a)) {
            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
          } else {
            merged.push(a = b);
          }
        }
        var best = -Infinity, dλ;
        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
          b = merged[i];
          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
        }
      }
      ranges = range = null;
      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
    };
  }();
  d3.geo.centroid = function(object) {
    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
    d3.geo.stream(object, d3_geo_centroid);
    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
    if (m < ε2) {
      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
      m = x * x + y * y + z * z;
      if (m < ε2) return [ NaN, NaN ];
    }
    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
  };
  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
  var d3_geo_centroid = {
    sphere: d3_noop,
    point: d3_geo_centroidPoint,
    lineStart: d3_geo_centroidLineStart,
    lineEnd: d3_geo_centroidLineEnd,
    polygonStart: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
    }
  };
  function d3_geo_centroidPoint(λ, φ) {
    λ *= d3_radians;
    var cosφ = Math.cos(φ *= d3_radians);
    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
  }
  function d3_geo_centroidPointXYZ(x, y, z) {
    ++d3_geo_centroidW0;
    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
  }
  function d3_geo_centroidLineStart() {
    var x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroid.point = nextPoint;
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_centroidLineEnd() {
    d3_geo_centroid.point = d3_geo_centroidPoint;
  }
  function d3_geo_centroidRingStart() {
    var λ00, φ00, x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ00 = λ, φ00 = φ;
      d3_geo_centroid.point = nextPoint;
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    d3_geo_centroid.lineEnd = function() {
      nextPoint(λ00, φ00);
      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
      d3_geo_centroid.point = d3_geo_centroidPoint;
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
      d3_geo_centroidX2 += v * cx;
      d3_geo_centroidY2 += v * cy;
      d3_geo_centroidZ2 += v * cz;
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_compose(a, b) {
    function compose(x, y) {
      return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
  }
  function d3_true() {
    return true;
  }
  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
    var subject = [], clip = [];
    segments.forEach(function(segment) {
      if ((n = segment.length - 1) <= 0) return;
      var n, p0 = segment[0], p1 = segment[n];
      if (d3_geo_sphericalEqual(p0, p1)) {
        listener.lineStart();
        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
        listener.lineEnd();
        return;
      }
      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
      a.o = b;
      subject.push(a);
      clip.push(b);
      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
      a.o = b;
      subject.push(a);
      clip.push(b);
    });
    clip.sort(compare);
    d3_geo_clipPolygonLinkCircular(subject);
    d3_geo_clipPolygonLinkCircular(clip);
    if (!subject.length) return;
    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
      clip[i].e = entry = !entry;
    }
    var start = subject[0], points, point;
    while (1) {
      var current = start, isSubject = true;
      while (current.v) if ((current = current.n) === start) return;
      points = current.z;
      listener.lineStart();
      do {
        current.v = current.o.v = true;
        if (current.e) {
          if (isSubject) {
            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.n.x, 1, listener);
          }
          current = current.n;
        } else {
          if (isSubject) {
            points = current.p.z;
            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.p.x, -1, listener);
          }
          current = current.p;
        }
        current = current.o;
        points = current.z;
        isSubject = !isSubject;
      } while (!current.v);
      listener.lineEnd();
    }
  }
  function d3_geo_clipPolygonLinkCircular(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while (++i < n) {
      a.n = b = array[i];
      b.p = a;
      a = b;
    }
    a.n = b = array[0];
    b.p = a;
  }
  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other;
    this.e = entry;
    this.v = false;
    this.n = this.p = null;
  }
  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
    return function(rotate, listener) {
      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          clip.point = pointRing;
          clip.lineStart = ringStart;
          clip.lineEnd = ringEnd;
          segments = [];
          polygon = [];
        },
        polygonEnd: function() {
          clip.point = point;
          clip.lineStart = lineStart;
          clip.lineEnd = lineEnd;
          segments = d3.merge(segments);
          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
          if (segments.length) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
          } else if (clipStartInside) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            interpolate(null, null, 1, listener);
            listener.lineEnd();
          }
          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
          segments = polygon = null;
        },
        sphere: function() {
          listener.polygonStart();
          listener.lineStart();
          interpolate(null, null, 1, listener);
          listener.lineEnd();
          listener.polygonEnd();
        }
      };
      function point(λ, φ) {
        var point = rotate(λ, φ);
        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
      }
      function pointLine(λ, φ) {
        var point = rotate(λ, φ);
        line.point(point[0], point[1]);
      }
      function lineStart() {
        clip.point = pointLine;
        line.lineStart();
      }
      function lineEnd() {
        clip.point = point;
        line.lineEnd();
      }
      var segments;
      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
      function pointRing(λ, φ) {
        ring.push([ λ, φ ]);
        var point = rotate(λ, φ);
        ringListener.point(point[0], point[1]);
      }
      function ringStart() {
        ringListener.lineStart();
        ring = [];
      }
      function ringEnd() {
        pointRing(ring[0][0], ring[0][1]);
        ringListener.lineEnd();
        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
        ring.pop();
        polygon.push(ring);
        ring = null;
        if (!n) return;
        if (clean & 1) {
          segment = ringSegments[0];
          var n = segment.length - 1, i = -1, point;
          if (n > 0) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            while (++i < n) listener.point((point = segment[i])[0], point[1]);
            listener.lineEnd();
          }
          return;
        }
        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
      }
      return clip;
    };
  }
  function d3_geo_clipSegmentLength1(segment) {
    return segment.length > 1;
  }
  function d3_geo_clipBufferListener() {
    var lines = [], line;
    return {
      lineStart: function() {
        lines.push(line = []);
      },
      point: function(λ, φ) {
        line.push([ λ, φ ]);
      },
      lineEnd: d3_noop,
      buffer: function() {
        var buffer = lines;
        lines = [];
        line = null;
        return buffer;
      },
      rejoin: function() {
        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
      }
    };
  }
  function d3_geo_clipSort(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
  }
  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
  function d3_geo_clipAntimeridianLine(listener) {
    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
    return {
      lineStart: function() {
        listener.lineStart();
        clean = 1;
      },
      point: function(λ1, φ1) {
        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
        if (abs(dλ - π) < ε) {
          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          listener.point(λ1, φ0);
          clean = 0;
        } else if (sλ0 !== sλ1 && dλ >= π) {
          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          clean = 0;
        }
        listener.point(λ0 = λ1, φ0 = φ1);
        sλ0 = sλ1;
      },
      lineEnd: function() {
        listener.lineEnd();
        λ0 = φ0 = NaN;
      },
      clean: function() {
        return 2 - clean;
      }
    };
  }
  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
  }
  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
    var φ;
    if (from == null) {
      φ = direction * halfπ;
      listener.point(-π, φ);
      listener.point(0, φ);
      listener.point(π, φ);
      listener.point(π, 0);
      listener.point(π, -φ);
      listener.point(0, -φ);
      listener.point(-π, -φ);
      listener.point(-π, 0);
      listener.point(-π, φ);
    } else if (abs(from[0] - to[0]) > ε) {
      var s = from[0] < to[0] ? π : -π;
      φ = direction * s / 2;
      listener.point(-s, φ);
      listener.point(0, φ);
      listener.point(s, φ);
    } else {
      listener.point(to[0], to[1]);
    }
  }
  function d3_geo_pointInPolygon(point, polygon) {
    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
    d3_geo_areaRingSum.reset();
    for (var i = 0, n = polygon.length; i < n; ++i) {
      var ring = polygon[i], m = ring.length;
      if (!m) continue;
      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
      while (true) {
        if (j === m) j = 0;
        point = ring[j];
        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
          d3_geo_cartesianNormalize(arc);
          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
          d3_geo_cartesianNormalize(intersection);
          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
          }
        }
        if (!j++) break;
        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
      }
    }
    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
  }
  function d3_geo_clipCircle(radius) {
    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
    function visible(λ, φ) {
      return Math.cos(λ) * Math.cos(φ) > cr;
    }
    function clipLine(listener) {
      var point0, c0, v0, v00, clean;
      return {
        lineStart: function() {
          v00 = v0 = false;
          clean = 1;
        },
        point: function(λ, φ) {
          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
          if (!point0 && (v00 = v0 = v)) listener.lineStart();
          if (v !== v0) {
            point2 = intersect(point0, point1);
            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
              point1[0] += ε;
              point1[1] += ε;
              v = visible(point1[0], point1[1]);
            }
          }
          if (v !== v0) {
            clean = 0;
            if (v) {
              listener.lineStart();
              point2 = intersect(point1, point0);
              listener.point(point2[0], point2[1]);
            } else {
              point2 = intersect(point0, point1);
              listener.point(point2[0], point2[1]);
              listener.lineEnd();
            }
            point0 = point2;
          } else if (notHemisphere && point0 && smallRadius ^ v) {
            var t;
            if (!(c & c0) && (t = intersect(point1, point0, true))) {
              clean = 0;
              if (smallRadius) {
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
              } else {
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
              }
            }
          }
          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
            listener.point(point1[0], point1[1]);
          }
          point0 = point1, v0 = v, c0 = c;
        },
        lineEnd: function() {
          if (v0) listener.lineEnd();
          point0 = null;
        },
        clean: function() {
          return clean | (v00 && v0) << 1;
        }
      };
    }
    function intersect(a, b, two) {
      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
      if (!determinant) return !two && a;
      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
      d3_geo_cartesianAdd(A, B);
      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
      if (t2 < 0) return;
      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
      d3_geo_cartesianAdd(q, A);
      q = d3_geo_spherical(q);
      if (!two) return q;
      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
        d3_geo_cartesianAdd(q1, A);
        return [ q, d3_geo_spherical(q1) ];
      }
    }
    function code(λ, φ) {
      var r = smallRadius ? radius : π - radius, code = 0;
      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
      return code;
    }
  }
  function d3_geom_clipLine(x0, y0, x1, y1) {
    return function(line) {
      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
      r = x0 - ax;
      if (!dx && r > 0) return;
      r /= dx;
      if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = x1 - ax;
      if (!dx && r < 0) return;
      r /= dx;
      if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      r = y0 - ay;
      if (!dy && r > 0) return;
      r /= dy;
      if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = y1 - ay;
      if (!dy && r < 0) return;
      r /= dy;
      if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      if (t0 > 0) line.a = {
        x: ax + t0 * dx,
        y: ay + t0 * dy
      };
      if (t1 < 1) line.b = {
        x: ax + t1 * dx,
        y: ay + t1 * dy
      };
      return line;
    };
  }
  var d3_geo_clipExtentMAX = 1e9;
  d3.geo.clipExtent = function() {
    var x0, y0, x1, y1, stream, clip, clipExtent = {
      stream: function(output) {
        if (stream) stream.valid = false;
        stream = clip(output);
        stream.valid = true;
        return stream;
      },
      extent: function(_) {
        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
        if (stream) stream.valid = false, stream = null;
        return clipExtent;
      }
    };
    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
  };
  function d3_geo_clipExtent(x0, y0, x1, y1) {
    return function(listener) {
      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          listener = bufferListener;
          segments = [];
          polygon = [];
          clean = true;
        },
        polygonEnd: function() {
          listener = listener_;
          segments = d3.merge(segments);
          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
          if (inside || visible) {
            listener.polygonStart();
            if (inside) {
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
            }
            if (visible) {
              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
            }
            listener.polygonEnd();
          }
          segments = polygon = ring = null;
        }
      };
      function insidePolygon(p) {
        var wn = 0, n = polygon.length, y = p[1];
        for (var i = 0; i < n; ++i) {
          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
            b = v[j];
            if (a[1] <= y) {
              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
            } else {
              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
            }
            a = b;
          }
        }
        return wn !== 0;
      }
      function interpolate(from, to, direction, listener) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
          do {
            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
          } while ((a = (a + direction + 4) % 4) !== a1);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function pointVisible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
      }
      function point(x, y) {
        if (pointVisible(x, y)) listener.point(x, y);
      }
      var x__, y__, v__, x_, y_, v_, first, clean;
      function lineStart() {
        clip.point = linePoint;
        if (polygon) polygon.push(ring = []);
        first = true;
        v_ = false;
        x_ = y_ = NaN;
      }
      function lineEnd() {
        if (segments) {
          linePoint(x__, y__);
          if (v__ && v_) bufferListener.rejoin();
          segments.push(bufferListener.buffer());
        }
        clip.point = point;
        if (v_) listener.lineEnd();
      }
      function linePoint(x, y) {
        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
        var v = pointVisible(x, y);
        if (polygon) ring.push([ x, y ]);
        if (first) {
          x__ = x, y__ = y, v__ = v;
          first = false;
          if (v) {
            listener.lineStart();
            listener.point(x, y);
          }
        } else {
          if (v && v_) listener.point(x, y); else {
            var l = {
              a: {
                x: x_,
                y: y_
              },
              b: {
                x: x,
                y: y
              }
            };
            if (clipLine(l)) {
              if (!v_) {
                listener.lineStart();
                listener.point(l.a.x, l.a.y);
              }
              listener.point(l.b.x, l.b.y);
              if (!v) listener.lineEnd();
              clean = false;
            } else if (v) {
              listener.lineStart();
              listener.point(x, y);
              clean = false;
            }
          }
        }
        x_ = x, y_ = y, v_ = v;
      }
      return clip;
    };
    function corner(p, direction) {
      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
    }
    function compare(a, b) {
      return comparePoints(a.x, b.x);
    }
    function comparePoints(a, b) {
      var ca = corner(a, 1), cb = corner(b, 1);
      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
  }
  function d3_geo_conic(projectAt) {
    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
    p.parallels = function(_) {
      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
    };
    return p;
  }
  function d3_geo_conicEqualArea(φ0, φ1) {
    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
    function forward(λ, φ) {
      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = ρ0 - y;
      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
    };
    return forward;
  }
  (d3.geo.conicEqualArea = function() {
    return d3_geo_conic(d3_geo_conicEqualArea);
  }).raw = d3_geo_conicEqualArea;
  d3.geo.albers = function() {
    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
  };
  d3.geo.albersUsa = function() {
    var lower48 = d3.geo.albers();
    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
    var point, pointStream = {
      point: function(x, y) {
        point = [ x, y ];
      }
    }, lower48Point, alaskaPoint, hawaiiPoint;
    function albersUsa(coordinates) {
      var x = coordinates[0], y = coordinates[1];
      point = null;
      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
      return point;
    }
    albersUsa.invert = function(coordinates) {
      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
      return {
        point: function(x, y) {
          lower48Stream.point(x, y);
          alaskaStream.point(x, y);
          hawaiiStream.point(x, y);
        },
        sphere: function() {
          lower48Stream.sphere();
          alaskaStream.sphere();
          hawaiiStream.sphere();
        },
        lineStart: function() {
          lower48Stream.lineStart();
          alaskaStream.lineStart();
          hawaiiStream.lineStart();
        },
        lineEnd: function() {
          lower48Stream.lineEnd();
          alaskaStream.lineEnd();
          hawaiiStream.lineEnd();
        },
        polygonStart: function() {
          lower48Stream.polygonStart();
          alaskaStream.polygonStart();
          hawaiiStream.polygonStart();
        },
        polygonEnd: function() {
          lower48Stream.polygonEnd();
          alaskaStream.polygonEnd();
          hawaiiStream.polygonEnd();
        }
      };
    };
    albersUsa.precision = function(_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_);
      alaska.precision(_);
      hawaii.precision(_);
      return albersUsa;
    };
    albersUsa.scale = function(_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_);
      alaska.scale(_ * .35);
      hawaii.scale(_);
      return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(), x = +_[0], y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      return albersUsa;
    };
    return albersUsa.scale(1070);
  };
  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_pathAreaPolygon = 0;
      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
    }
  };
  function d3_geo_pathAreaRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathArea.point = function(x, y) {
      d3_geo_pathArea.point = nextPoint;
      x00 = x0 = x, y00 = y0 = y;
    };
    function nextPoint(x, y) {
      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
      x0 = x, y0 = y;
    }
    d3_geo_pathArea.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
  var d3_geo_pathBounds = {
    point: d3_geo_pathBoundsPoint,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_pathBoundsPoint(x, y) {
    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
  }
  function d3_geo_pathBuffer() {
    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointCircle = d3_geo_pathBufferCircle(_);
        return stream;
      },
      result: function() {
        if (buffer.length) {
          var result = buffer.join("");
          buffer = [];
          return result;
        }
      }
    };
    function point(x, y) {
      buffer.push("M", x, ",", y, pointCircle);
    }
    function pointLineStart(x, y) {
      buffer.push("M", x, ",", y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      buffer.push("L", x, ",", y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      buffer.push("Z");
    }
    return stream;
  }
  function d3_geo_pathBufferCircle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
  }
  var d3_geo_pathCentroid = {
    point: d3_geo_pathCentroidPoint,
    lineStart: d3_geo_pathCentroidLineStart,
    lineEnd: d3_geo_pathCentroidLineEnd,
    polygonStart: function() {
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
    }
  };
  function d3_geo_pathCentroidPoint(x, y) {
    d3_geo_centroidX0 += x;
    d3_geo_centroidY0 += y;
    ++d3_geo_centroidZ0;
  }
  function d3_geo_pathCentroidLineStart() {
    var x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
  }
  function d3_geo_pathCentroidLineEnd() {
    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
  }
  function d3_geo_pathCentroidRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      z = y0 * x - x0 * y;
      d3_geo_centroidX2 += z * (x0 + x);
      d3_geo_centroidY2 += z * (y0 + y);
      d3_geo_centroidZ2 += z * 3;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
    d3_geo_pathCentroid.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  function d3_geo_pathContext(context) {
    var pointRadius = 4.5;
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointRadius = _;
        return stream;
      },
      result: d3_noop
    };
    function point(x, y) {
      context.moveTo(x + pointRadius, y);
      context.arc(x, y, pointRadius, 0, τ);
    }
    function pointLineStart(x, y) {
      context.moveTo(x, y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      context.lineTo(x, y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      context.closePath();
    }
    return stream;
  }
  function d3_geo_resample(project) {
    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
    function resample(stream) {
      return (maxDepth ? resampleRecursive : resampleNone)(stream);
    }
    function resampleNone(stream) {
      return d3_geo_transformPoint(stream, function(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      });
    }
    function resampleRecursive(stream) {
      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
      var resample = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          stream.polygonStart();
          resample.lineStart = ringStart;
        },
        polygonEnd: function() {
          stream.polygonEnd();
          resample.lineStart = lineStart;
        }
      };
      function point(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      }
      function lineStart() {
        x0 = NaN;
        resample.point = linePoint;
        stream.lineStart();
      }
      function linePoint(λ, φ) {
        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
        stream.point(x0, y0);
      }
      function lineEnd() {
        resample.point = point;
        stream.lineEnd();
      }
      function ringStart() {
        lineStart();
        resample.point = ringPoint;
        resample.lineEnd = ringEnd;
      }
      function ringPoint(λ, φ) {
        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
        resample.point = linePoint;
      }
      function ringEnd() {
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
        resample.lineEnd = lineEnd;
        lineEnd();
      }
      return resample;
    }
    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
      if (d2 > 4 * δ2 && depth--) {
        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
          stream.point(x2, y2);
          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
        }
      }
    }
    resample.precision = function(_) {
      if (!arguments.length) return Math.sqrt(δ2);
      maxDepth = (δ2 = _ * _) > 0 && 16;
      return resample;
    };
    return resample;
  }
  d3.geo.path = function() {
    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
    function path(object) {
      if (object) {
        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
        d3.geo.stream(object, cacheStream);
      }
      return contextStream.result();
    }
    path.area = function(object) {
      d3_geo_pathAreaSum = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathArea));
      return d3_geo_pathAreaSum;
    };
    path.centroid = function(object) {
      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
    };
    path.bounds = function(object) {
      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
    };
    path.projection = function(_) {
      if (!arguments.length) return projection;
      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
      return reset();
    };
    path.context = function(_) {
      if (!arguments.length) return context;
      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
      return reset();
    };
    path.pointRadius = function(_) {
      if (!arguments.length) return pointRadius;
      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
      return path;
    };
    function reset() {
      cacheStream = null;
      return path;
    }
    return path.projection(d3.geo.albersUsa()).context(null);
  };
  function d3_geo_pathProjectStream(project) {
    var resample = d3_geo_resample(function(x, y) {
      return project([ x * d3_degrees, y * d3_degrees ]);
    });
    return function(stream) {
      return d3_geo_projectionRadians(resample(stream));
    };
  }
  d3.geo.transform = function(methods) {
    return {
      stream: function(stream) {
        var transform = new d3_geo_transform(stream);
        for (var k in methods) transform[k] = methods[k];
        return transform;
      }
    };
  };
  function d3_geo_transform(stream) {
    this.stream = stream;
  }
  d3_geo_transform.prototype = {
    point: function(x, y) {
      this.stream.point(x, y);
    },
    sphere: function() {
      this.stream.sphere();
    },
    lineStart: function() {
      this.stream.lineStart();
    },
    lineEnd: function() {
      this.stream.lineEnd();
    },
    polygonStart: function() {
      this.stream.polygonStart();
    },
    polygonEnd: function() {
      this.stream.polygonEnd();
    }
  };
  function d3_geo_transformPoint(stream, point) {
    return {
      point: point,
      sphere: function() {
        stream.sphere();
      },
      lineStart: function() {
        stream.lineStart();
      },
      lineEnd: function() {
        stream.lineEnd();
      },
      polygonStart: function() {
        stream.polygonStart();
      },
      polygonEnd: function() {
        stream.polygonEnd();
      }
    };
  }
  d3.geo.projection = d3_geo_projection;
  d3.geo.projectionMutator = d3_geo_projectionMutator;
  function d3_geo_projection(project) {
    return d3_geo_projectionMutator(function() {
      return project;
    })();
  }
  function d3_geo_projectionMutator(projectAt) {
    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
      x = project(x, y);
      return [ x[0] * k + δx, δy - x[1] * k ];
    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
    function projection(point) {
      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
      return [ point[0] * k + δx, δy - point[1] * k ];
    }
    function invert(point) {
      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
    }
    projection.stream = function(output) {
      if (stream) stream.valid = false;
      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
      stream.valid = true;
      return stream;
    };
    projection.clipAngle = function(_) {
      if (!arguments.length) return clipAngle;
      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
      return invalidate();
    };
    projection.clipExtent = function(_) {
      if (!arguments.length) return clipExtent;
      clipExtent = _;
      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
      return invalidate();
    };
    projection.scale = function(_) {
      if (!arguments.length) return k;
      k = +_;
      return reset();
    };
    projection.translate = function(_) {
      if (!arguments.length) return [ x, y ];
      x = +_[0];
      y = +_[1];
      return reset();
    };
    projection.center = function(_) {
      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
      λ = _[0] % 360 * d3_radians;
      φ = _[1] % 360 * d3_radians;
      return reset();
    };
    projection.rotate = function(_) {
      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
      δλ = _[0] % 360 * d3_radians;
      δφ = _[1] % 360 * d3_radians;
      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
      return reset();
    };
    d3.rebind(projection, projectResample, "precision");
    function reset() {
      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
      var center = project(λ, φ);
      δx = x - center[0] * k;
      δy = y + center[1] * k;
      return invalidate();
    }
    function invalidate() {
      if (stream) stream.valid = false, stream = null;
      return projection;
    }
    return function() {
      project = projectAt.apply(this, arguments);
      projection.invert = project.invert && invert;
      return reset();
    };
  }
  function d3_geo_projectionRadians(stream) {
    return d3_geo_transformPoint(stream, function(x, y) {
      stream.point(x * d3_radians, y * d3_radians);
    });
  }
  function d3_geo_equirectangular(λ, φ) {
    return [ λ, φ ];
  }
  (d3.geo.equirectangular = function() {
    return d3_geo_projection(d3_geo_equirectangular);
  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
  d3.geo.rotation = function(rotate) {
    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
    function forward(coordinates) {
      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    }
    forward.invert = function(coordinates) {
      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    };
    return forward;
  };
  function d3_geo_identityRotation(λ, φ) {
    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
  }
  d3_geo_identityRotation.invert = d3_geo_equirectangular;
  function d3_geo_rotation(δλ, δφ, δγ) {
    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
  }
  function d3_geo_forwardRotationλ(δλ) {
    return function(λ, φ) {
      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
    };
  }
  function d3_geo_rotationλ(δλ) {
    var rotation = d3_geo_forwardRotationλ(δλ);
    rotation.invert = d3_geo_forwardRotationλ(-δλ);
    return rotation;
  }
  function d3_geo_rotationφγ(δφ, δγ) {
    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
    function rotation(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
    }
    rotation.invert = function(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
    };
    return rotation;
  }
  d3.geo.circle = function() {
    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
    function circle() {
      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
      interpolate(null, null, 1, {
        point: function(x, y) {
          ring.push(x = rotate(x, y));
          x[0] *= d3_degrees, x[1] *= d3_degrees;
        }
      });
      return {
        type: "Polygon",
        coordinates: [ ring ]
      };
    }
    circle.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return circle;
    };
    circle.angle = function(x) {
      if (!arguments.length) return angle;
      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
      return circle;
    };
    circle.precision = function(_) {
      if (!arguments.length) return precision;
      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
      return circle;
    };
    return circle.angle(90);
  };
  function d3_geo_circleInterpolate(radius, precision) {
    var cr = Math.cos(radius), sr = Math.sin(radius);
    return function(from, to, direction, listener) {
      var step = direction * precision;
      if (from != null) {
        from = d3_geo_circleAngle(cr, from);
        to = d3_geo_circleAngle(cr, to);
        if (direction > 0 ? from < to : from > to) from += direction * τ;
      } else {
        from = radius + direction * τ;
        to = radius - .5 * step;
      }
      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
      }
    };
  }
  function d3_geo_circleAngle(cr, point) {
    var a = d3_geo_cartesian(point);
    a[0] -= cr;
    d3_geo_cartesianNormalize(a);
    var angle = d3_acos(-a[1]);
    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
  }
  d3.geo.distance = function(a, b) {
    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
  };
  d3.geo.graticule = function() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
      return {
        type: "MultiLineString",
        coordinates: lines()
      };
    }
    function lines() {
      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
        return abs(x % DX) > ε;
      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
        return abs(y % DY) > ε;
      }).map(y));
    }
    graticule.lines = function() {
      return lines().map(function(coordinates) {
        return {
          type: "LineString",
          coordinates: coordinates
        };
      });
    };
    graticule.outline = function() {
      return {
        type: "Polygon",
        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
      };
    };
    graticule.extent = function(_) {
      if (!arguments.length) return graticule.minorExtent();
      return graticule.majorExtent(_).minorExtent(_);
    };
    graticule.majorExtent = function(_) {
      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
      X0 = +_[0][0], X1 = +_[1][0];
      Y0 = +_[0][1], Y1 = +_[1][1];
      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
      return graticule.precision(precision);
    };
    graticule.minorExtent = function(_) {
      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
      x0 = +_[0][0], x1 = +_[1][0];
      y0 = +_[0][1], y1 = +_[1][1];
      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
      return graticule.precision(precision);
    };
    graticule.step = function(_) {
      if (!arguments.length) return graticule.minorStep();
      return graticule.majorStep(_).minorStep(_);
    };
    graticule.majorStep = function(_) {
      if (!arguments.length) return [ DX, DY ];
      DX = +_[0], DY = +_[1];
      return graticule;
    };
    graticule.minorStep = function(_) {
      if (!arguments.length) return [ dx, dy ];
      dx = +_[0], dy = +_[1];
      return graticule;
    };
    graticule.precision = function(_) {
      if (!arguments.length) return precision;
      precision = +_;
      x = d3_geo_graticuleX(y0, y1, 90);
      y = d3_geo_graticuleY(x0, x1, precision);
      X = d3_geo_graticuleX(Y0, Y1, 90);
      Y = d3_geo_graticuleY(X0, X1, precision);
      return graticule;
    };
    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
  };
  function d3_geo_graticuleX(y0, y1, dy) {
    var y = d3.range(y0, y1 - ε, dy).concat(y1);
    return function(x) {
      return y.map(function(y) {
        return [ x, y ];
      });
    };
  }
  function d3_geo_graticuleY(x0, x1, dx) {
    var x = d3.range(x0, x1 - ε, dx).concat(x1);
    return function(y) {
      return x.map(function(x) {
        return [ x, y ];
      });
    };
  }
  function d3_source(d) {
    return d.source;
  }
  function d3_target(d) {
    return d.target;
  }
  d3.geo.greatArc = function() {
    var source = d3_source, source_, target = d3_target, target_;
    function greatArc() {
      return {
        type: "LineString",
        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
      };
    }
    greatArc.distance = function() {
      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
    };
    greatArc.source = function(_) {
      if (!arguments.length) return source;
      source = _, source_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.target = function(_) {
      if (!arguments.length) return target;
      target = _, target_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.precision = function() {
      return arguments.length ? greatArc : 0;
    };
    return greatArc;
  };
  d3.geo.interpolate = function(source, target) {
    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
  };
  function d3_geo_interpolate(x0, y0, x1, y1) {
    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
    var interpolate = d ? function(t) {
      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
    } : function() {
      return [ x0 * d3_degrees, y0 * d3_degrees ];
    };
    interpolate.distance = d;
    return interpolate;
  }
  d3.geo.length = function(object) {
    d3_geo_lengthSum = 0;
    d3.geo.stream(object, d3_geo_length);
    return d3_geo_lengthSum;
  };
  var d3_geo_lengthSum;
  var d3_geo_length = {
    sphere: d3_noop,
    point: d3_noop,
    lineStart: d3_geo_lengthLineStart,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_lengthLineStart() {
    var λ0, sinφ0, cosφ0;
    d3_geo_length.point = function(λ, φ) {
      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
      d3_geo_length.point = nextPoint;
    };
    d3_geo_length.lineEnd = function() {
      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
    };
    function nextPoint(λ, φ) {
      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
    }
  }
  function d3_geo_azimuthal(scale, angle) {
    function azimuthal(λ, φ) {
      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
    }
    azimuthal.invert = function(x, y) {
      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
    };
    return azimuthal;
  }
  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
    return Math.sqrt(2 / (1 + cosλcosφ));
  }, function(ρ) {
    return 2 * Math.asin(ρ / 2);
  });
  (d3.geo.azimuthalEqualArea = function() {
    return d3_geo_projection(d3_geo_azimuthalEqualArea);
  }).raw = d3_geo_azimuthalEqualArea;
  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
    var c = Math.acos(cosλcosφ);
    return c && c / Math.sin(c);
  }, d3_identity);
  (d3.geo.azimuthalEquidistant = function() {
    return d3_geo_projection(d3_geo_azimuthalEquidistant);
  }).raw = d3_geo_azimuthalEquidistant;
  function d3_geo_conicConformal(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), t = function(φ) {
      return Math.tan(π / 4 + φ / 2);
    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
    if (!n) return d3_geo_mercator;
    function forward(λ, φ) {
      if (F > 0) {
        if (φ < -halfπ + ε) φ = -halfπ + ε;
      } else {
        if (φ > halfπ - ε) φ = halfπ - ε;
      }
      var ρ = F / Math.pow(t(φ), n);
      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
    };
    return forward;
  }
  (d3.geo.conicConformal = function() {
    return d3_geo_conic(d3_geo_conicConformal);
  }).raw = d3_geo_conicConformal;
  function d3_geo_conicEquidistant(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
    if (abs(n) < ε) return d3_geo_equirectangular;
    function forward(λ, φ) {
      var ρ = G - φ;
      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = G - y;
      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
    };
    return forward;
  }
  (d3.geo.conicEquidistant = function() {
    return d3_geo_conic(d3_geo_conicEquidistant);
  }).raw = d3_geo_conicEquidistant;
  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / cosλcosφ;
  }, Math.atan);
  (d3.geo.gnomonic = function() {
    return d3_geo_projection(d3_geo_gnomonic);
  }).raw = d3_geo_gnomonic;
  function d3_geo_mercator(λ, φ) {
    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
  }
  d3_geo_mercator.invert = function(x, y) {
    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
  };
  function d3_geo_mercatorProjection(project) {
    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
    m.scale = function() {
      var v = scale.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.translate = function() {
      var v = translate.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.clipExtent = function(_) {
      var v = clipExtent.apply(m, arguments);
      if (v === m) {
        if (clipAuto = _ == null) {
          var k = π * scale(), t = translate();
          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
        }
      } else if (clipAuto) {
        v = null;
      }
      return v;
    };
    return m.clipExtent(null);
  }
  (d3.geo.mercator = function() {
    return d3_geo_mercatorProjection(d3_geo_mercator);
  }).raw = d3_geo_mercator;
  var d3_geo_orthographic = d3_geo_azimuthal(function() {
    return 1;
  }, Math.asin);
  (d3.geo.orthographic = function() {
    return d3_geo_projection(d3_geo_orthographic);
  }).raw = d3_geo_orthographic;
  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / (1 + cosλcosφ);
  }, function(ρ) {
    return 2 * Math.atan(ρ);
  });
  (d3.geo.stereographic = function() {
    return d3_geo_projection(d3_geo_stereographic);
  }).raw = d3_geo_stereographic;
  function d3_geo_transverseMercator(λ, φ) {
    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
  }
  d3_geo_transverseMercator.invert = function(x, y) {
    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
  };
  (d3.geo.transverseMercator = function() {
    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
    projection.center = function(_) {
      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
    };
    projection.rotate = function(_) {
      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
      [ _[0], _[1], _[2] - 90 ]);
    };
    return rotate([ 0, 0, 90 ]);
  }).raw = d3_geo_transverseMercator;
  d3.geom = {};
  function d3_geom_pointX(d) {
    return d[0];
  }
  function d3_geom_pointY(d) {
    return d[1];
  }
  d3.geom.hull = function(vertices) {
    var x = d3_geom_pointX, y = d3_geom_pointY;
    if (arguments.length) return hull(vertices);
    function hull(data) {
      if (data.length < 3) return [];
      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
      for (i = 0; i < n; i++) {
        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
      }
      points.sort(d3_geom_hullOrder);
      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
      return polygon;
    }
    hull.x = function(_) {
      return arguments.length ? (x = _, hull) : x;
    };
    hull.y = function(_) {
      return arguments.length ? (y = _, hull) : y;
    };
    return hull;
  };
  function d3_geom_hullUpper(points) {
    var n = points.length, hull = [ 0, 1 ], hs = 2;
    for (var i = 2; i < n; i++) {
      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
      hull[hs++] = i;
    }
    return hull.slice(0, hs);
  }
  function d3_geom_hullOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
  }
  d3.geom.polygon = function(coordinates) {
    d3_subclass(coordinates, d3_geom_polygonPrototype);
    return coordinates;
  };
  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
  d3_geom_polygonPrototype.area = function() {
    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
    while (++i < n) {
      a = b;
      b = this[i];
      area += a[1] * b[0] - a[0] * b[1];
    }
    return area * .5;
  };
  d3_geom_polygonPrototype.centroid = function(k) {
    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
    if (!arguments.length) k = -1 / (6 * this.area());
    while (++i < n) {
      a = b;
      b = this[i];
      c = a[0] * b[1] - b[0] * a[1];
      x += (a[0] + b[0]) * c;
      y += (a[1] + b[1]) * c;
    }
    return [ x * k, y * k ];
  };
  d3_geom_polygonPrototype.clip = function(subject) {
    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
    while (++i < n) {
      input = subject.slice();
      subject.length = 0;
      b = this[i];
      c = input[(m = input.length - closed) - 1];
      j = -1;
      while (++j < m) {
        d = input[j];
        if (d3_geom_polygonInside(d, a, b)) {
          if (!d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          subject.push(d);
        } else if (d3_geom_polygonInside(c, a, b)) {
          subject.push(d3_geom_polygonIntersect(c, d, a, b));
        }
        c = d;
      }
      if (closed) subject.push(subject[0]);
      a = b;
    }
    return subject;
  };
  function d3_geom_polygonInside(p, a, b) {
    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
  }
  function d3_geom_polygonIntersect(c, d, a, b) {
    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
    return [ x1 + ua * x21, y1 + ua * y21 ];
  }
  function d3_geom_polygonClosed(coordinates) {
    var a = coordinates[0], b = coordinates[coordinates.length - 1];
    return !(a[0] - b[0] || a[1] - b[1]);
  }
  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
  function d3_geom_voronoiBeach() {
    d3_geom_voronoiRedBlackNode(this);
    this.edge = this.site = this.circle = null;
  }
  function d3_geom_voronoiCreateBeach(site) {
    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
    beach.site = site;
    return beach;
  }
  function d3_geom_voronoiDetachBeach(beach) {
    d3_geom_voronoiDetachCircle(beach);
    d3_geom_voronoiBeaches.remove(beach);
    d3_geom_voronoiBeachPool.push(beach);
    d3_geom_voronoiRedBlackNode(beach);
  }
  function d3_geom_voronoiRemoveBeach(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
      x: x,
      y: y
    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
    d3_geom_voronoiDetachBeach(beach);
    var lArc = previous;
    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
      previous = lArc.P;
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachBeach(lArc);
      lArc = previous;
    }
    disappearing.unshift(lArc);
    d3_geom_voronoiDetachCircle(lArc);
    var rArc = next;
    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
      next = rArc.N;
      disappearing.push(rArc);
      d3_geom_voronoiDetachBeach(rArc);
      rArc = next;
    }
    disappearing.push(rArc);
    d3_geom_voronoiDetachCircle(rArc);
    var nArcs = disappearing.length, iArc;
    for (iArc = 1; iArc < nArcs; ++iArc) {
      rArc = disappearing[iArc];
      lArc = disappearing[iArc - 1];
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiAddBeach(site) {
    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
    while (node) {
      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
      if (dxl > ε) node = node.L; else {
        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
        if (dxr > ε) {
          if (!node.R) {
            lArc = node;
            break;
          }
          node = node.R;
        } else {
          if (dxl > -ε) {
            lArc = node.P;
            rArc = node;
          } else if (dxr > -ε) {
            lArc = node;
            rArc = node.N;
          } else {
            lArc = rArc = node;
          }
          break;
        }
      }
    }
    var newArc = d3_geom_voronoiCreateBeach(site);
    d3_geom_voronoiBeaches.insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
      d3_geom_voronoiDetachCircle(lArc);
      rArc = d3_geom_voronoiCreateBeach(lArc.site);
      d3_geom_voronoiBeaches.insert(newArc, rArc);
      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
      return;
    }
    if (!rArc) {
      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      return;
    }
    d3_geom_voronoiDetachCircle(lArc);
    d3_geom_voronoiDetachCircle(rArc);
    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
      x: (cy * hb - by * hc) / d + ax,
      y: (bx * hc - cx * hb) / d + ay
    };
    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
  }
  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site.y === directrix ? site.x : Infinity;
  }
  function d3_geom_voronoiCell(site) {
    this.site = site;
    this.edges = [];
  }
  d3_geom_voronoiCell.prototype.prepare = function() {
    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
    while (iHalfEdge--) {
      edge = halfEdges[iHalfEdge].edge;
      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
    }
    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
    return halfEdges.length;
  };
  function d3_geom_voronoiCloseCells(extent) {
    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
    while (iCell--) {
      cell = cells[iCell];
      if (!cell || !cell.prepare()) continue;
      halfEdges = cell.edges;
      nHalfEdges = halfEdges.length;
      iHalfEdge = 0;
      while (iHalfEdge < nHalfEdges) {
        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
            x: x0,
            y: abs(x2 - x0) < ε ? y2 : y1
          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
            x: abs(y2 - y1) < ε ? x2 : x1,
            y: y1
          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
            x: x1,
            y: abs(x2 - x1) < ε ? y2 : y0
          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
            x: abs(y2 - y0) < ε ? x2 : x0,
            y: y0
          } : null), cell.site, null));
          ++nHalfEdges;
        }
      }
    }
  }
  function d3_geom_voronoiHalfEdgeOrder(a, b) {
    return b.angle - a.angle;
  }
  function d3_geom_voronoiCircle() {
    d3_geom_voronoiRedBlackNode(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function d3_geom_voronoiAttachCircle(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -ε2) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = cy + Math.sqrt(x * x + y * y);
    circle.cy = cy;
    arc.circle = circle;
    var before = null, node = d3_geom_voronoiCircles._;
    while (node) {
      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
        if (node.L) node = node.L; else {
          before = node.P;
          break;
        }
      } else {
        if (node.R) node = node.R; else {
          before = node;
          break;
        }
      }
    }
    d3_geom_voronoiCircles.insert(before, circle);
    if (!before) d3_geom_voronoiFirstCircle = circle;
  }
  function d3_geom_voronoiDetachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
      d3_geom_voronoiCircles.remove(circle);
      d3_geom_voronoiCirclePool.push(circle);
      d3_geom_voronoiRedBlackNode(circle);
      arc.circle = null;
    }
  }
  function d3_geom_voronoiClipEdges(extent) {
    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
    while (i--) {
      e = edges[i];
      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
        e.a = e.b = null;
        edges.splice(i, 1);
      }
    }
  }
  function d3_geom_voronoiConnectEdge(edge, extent) {
    var vb = edge.b;
    if (vb) return true;
    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
      if (fx < x0 || fx >= x1) return;
      if (lx > rx) {
        if (!va) va = {
          x: fx,
          y: y0
        }; else if (va.y >= y1) return;
        vb = {
          x: fx,
          y: y1
        };
      } else {
        if (!va) va = {
          x: fx,
          y: y1
        }; else if (va.y < y0) return;
        vb = {
          x: fx,
          y: y0
        };
      }
    } else {
      fm = (lx - rx) / (ry - ly);
      fb = fy - fm * fx;
      if (fm < -1 || fm > 1) {
        if (lx > rx) {
          if (!va) va = {
            x: (y0 - fb) / fm,
            y: y0
          }; else if (va.y >= y1) return;
          vb = {
            x: (y1 - fb) / fm,
            y: y1
          };
        } else {
          if (!va) va = {
            x: (y1 - fb) / fm,
            y: y1
          }; else if (va.y < y0) return;
          vb = {
            x: (y0 - fb) / fm,
            y: y0
          };
        }
      } else {
        if (ly < ry) {
          if (!va) va = {
            x: x0,
            y: fm * x0 + fb
          }; else if (va.x >= x1) return;
          vb = {
            x: x1,
            y: fm * x1 + fb
          };
        } else {
          if (!va) va = {
            x: x1,
            y: fm * x1 + fb
          }; else if (va.x < x0) return;
          vb = {
            x: x0,
            y: fm * x0 + fb
          };
        }
      }
    }
    edge.a = va;
    edge.b = vb;
    return true;
  }
  function d3_geom_voronoiEdge(lSite, rSite) {
    this.l = lSite;
    this.r = rSite;
    this.a = this.b = null;
  }
  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, rSite);
    d3_geom_voronoiEdges.push(edge);
    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
    return edge;
  }
  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, null);
    edge.a = va;
    edge.b = vb;
    d3_geom_voronoiEdges.push(edge);
    return edge;
  }
  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
    if (!edge.a && !edge.b) {
      edge.a = vertex;
      edge.l = lSite;
      edge.r = rSite;
    } else if (edge.l === rSite) {
      edge.b = vertex;
    } else {
      edge.a = vertex;
    }
  }
  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
    var va = edge.a, vb = edge.b;
    this.edge = edge;
    this.site = lSite;
    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
  }
  d3_geom_voronoiHalfEdge.prototype = {
    start: function() {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function() {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  };
  function d3_geom_voronoiRedBlackTree() {
    this._ = null;
  }
  function d3_geom_voronoiRedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null;
  }
  d3_geom_voronoiRedBlackTree.prototype = {
    insert: function(after, node) {
      var parent, grandpa, uncle;
      if (after) {
        node.P = after;
        node.N = after.N;
        if (after.N) after.N.P = node;
        after.N = node;
        if (after.R) {
          after = after.R;
          while (after.L) after = after.L;
          after.L = node;
        } else {
          after.R = node;
        }
        parent = after;
      } else if (this._) {
        after = d3_geom_voronoiRedBlackFirst(this._);
        node.P = null;
        node.N = after;
        after.P = after.L = node;
        parent = after;
      } else {
        node.P = node.N = null;
        this._ = node;
        parent = null;
      }
      node.L = node.R = null;
      node.U = parent;
      node.C = true;
      after = node;
      while (parent && parent.C) {
        grandpa = parent.U;
        if (parent === grandpa.L) {
          uncle = grandpa.R;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.R) {
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
          }
        } else {
          uncle = grandpa.L;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.L) {
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
          }
        }
        parent = after.U;
      }
      this._.C = false;
    },
    remove: function(node) {
      if (node.N) node.N.P = node.P;
      if (node.P) node.P.N = node.N;
      node.N = node.P = null;
      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
      if (parent) {
        if (parent.L === node) parent.L = next; else parent.R = next;
      } else {
        this._ = next;
      }
      if (left && right) {
        red = next.C;
        next.C = node.C;
        next.L = left;
        left.U = next;
        if (next !== right) {
          parent = next.U;
          next.U = node.U;
          node = next.R;
          parent.L = node;
          next.R = right;
          right.U = next;
        } else {
          next.U = parent;
          parent = next;
          node = next.R;
        }
      } else {
        red = node.C;
        node = next;
      }
      if (node) node.U = parent;
      if (red) return;
      if (node && node.C) {
        node.C = false;
        return;
      }
      do {
        if (node === this._) break;
        if (node === parent.L) {
          sibling = parent.R;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            sibling = parent.R;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.R || !sibling.R.C) {
              sibling.L.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, sibling);
              sibling = parent.R;
            }
            sibling.C = parent.C;
            parent.C = sibling.R.C = false;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            node = this._;
            break;
          }
        } else {
          sibling = parent.L;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            sibling = parent.L;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.L || !sibling.L.C) {
              sibling.R.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
              sibling = parent.L;
            }
            sibling.C = parent.C;
            parent.C = sibling.L.C = false;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            node = this._;
            break;
          }
        }
        sibling.C = true;
        node = parent;
        parent = parent.U;
      } while (!node.C);
      if (node) node.C = false;
    }
  };
  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
  }
  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
  }
  function d3_geom_voronoiRedBlackFirst(node) {
    while (node.L) node = node.L;
    return node;
  }
  function d3_geom_voronoi(sites, bbox) {
    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
    d3_geom_voronoiEdges = [];
    d3_geom_voronoiCells = new Array(sites.length);
    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
    while (true) {
      circle = d3_geom_voronoiFirstCircle;
      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
        if (site.x !== x0 || site.y !== y0) {
          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
          d3_geom_voronoiAddBeach(site);
          x0 = site.x, y0 = site.y;
        }
        site = sites.pop();
      } else if (circle) {
        d3_geom_voronoiRemoveBeach(circle.arc);
      } else {
        break;
      }
    }
    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
    var diagram = {
      cells: d3_geom_voronoiCells,
      edges: d3_geom_voronoiEdges
    };
    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
    return diagram;
  }
  function d3_geom_voronoiVertexOrder(a, b) {
    return b.y - a.y || b.x - a.x;
  }
  d3.geom.voronoi = function(points) {
    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
    if (points) return voronoi(points);
    function voronoi(data) {
      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
          var s = e.start();
          return [ s.x, s.y ];
        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
        polygon.point = data[i];
      });
      return polygons;
    }
    function sites(data) {
      return data.map(function(d, i) {
        return {
          x: Math.round(fx(d, i) / ε) * ε,
          y: Math.round(fy(d, i) / ε) * ε,
          i: i
        };
      });
    }
    voronoi.links = function(data) {
      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
        return edge.l && edge.r;
      }).map(function(edge) {
        return {
          source: data[edge.l.i],
          target: data[edge.r.i]
        };
      });
    };
    voronoi.triangles = function(data) {
      var triangles = [];
      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
        while (++j < m) {
          e0 = e1;
          s0 = s1;
          e1 = edges[j].edge;
          s1 = e1.l === site ? e1.r : e1.l;
          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
          }
        }
      });
      return triangles;
    };
    voronoi.x = function(_) {
      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
    };
    voronoi.y = function(_) {
      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
    };
    voronoi.clipExtent = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
      return voronoi;
    };
    voronoi.size = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
    };
    return voronoi;
  };
  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
  function d3_geom_voronoiTriangleArea(a, b, c) {
    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
  }
  d3.geom.delaunay = function(vertices) {
    return d3.geom.voronoi().triangles(vertices);
  };
  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
    if (compat = arguments.length) {
      x = d3_geom_quadtreeCompatX;
      y = d3_geom_quadtreeCompatY;
      if (compat === 3) {
        y2 = y1;
        x2 = x1;
        y1 = x1 = 0;
      }
      return quadtree(points);
    }
    function quadtree(data) {
      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
      if (x1 != null) {
        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
      } else {
        x2_ = y2_ = -(x1_ = y1_ = Infinity);
        xs = [], ys = [];
        n = data.length;
        if (compat) for (i = 0; i < n; ++i) {
          d = data[i];
          if (d.x < x1_) x1_ = d.x;
          if (d.y < y1_) y1_ = d.y;
          if (d.x > x2_) x2_ = d.x;
          if (d.y > y2_) y2_ = d.y;
          xs.push(d.x);
          ys.push(d.y);
        } else for (i = 0; i < n; ++i) {
          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
          if (x_ < x1_) x1_ = x_;
          if (y_ < y1_) y1_ = y_;
          if (x_ > x2_) x2_ = x_;
          if (y_ > y2_) y2_ = y_;
          xs.push(x_);
          ys.push(y_);
        }
      }
      var dx = x2_ - x1_, dy = y2_ - y1_;
      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
      function insert(n, d, x, y, x1, y1, x2, y2) {
        if (isNaN(x) || isNaN(y)) return;
        if (n.leaf) {
          var nx = n.x, ny = n.y;
          if (nx != null) {
            if (abs(nx - x) + abs(ny - y) < .01) {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            } else {
              var nPoint = n.point;
              n.x = n.y = n.point = null;
              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          } else {
            n.x = x, n.y = y, n.point = d;
          }
        } else {
          insertChild(n, d, x, y, x1, y1, x2, y2);
        }
      }
      function insertChild(n, d, x, y, x1, y1, x2, y2) {
        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
        n.leaf = false;
        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
        if (right) x1 = xm; else x2 = xm;
        if (below) y1 = ym; else y2 = ym;
        insert(n, d, x, y, x1, y1, x2, y2);
      }
      var root = d3_geom_quadtreeNode();
      root.add = function(d) {
        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
      };
      root.visit = function(f) {
        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
      };
      root.find = function(point) {
        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
      };
      i = -1;
      if (x1 == null) {
        while (++i < n) {
          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
        }
        --i;
      } else data.forEach(root.add);
      xs = ys = data = d = null;
      return root;
    }
    quadtree.x = function(_) {
      return arguments.length ? (x = _, quadtree) : x;
    };
    quadtree.y = function(_) {
      return arguments.length ? (y = _, quadtree) : y;
    };
    quadtree.extent = function(_) {
      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
      y2 = +_[1][1];
      return quadtree;
    };
    quadtree.size = function(_) {
      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
      return quadtree;
    };
    return quadtree;
  };
  function d3_geom_quadtreeCompatX(d) {
    return d.x;
  }
  function d3_geom_quadtreeCompatY(d) {
    return d.y;
  }
  function d3_geom_quadtreeNode() {
    return {
      leaf: true,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
    if (!f(node, x1, y1, x2, y2)) {
      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
    }
  }
  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
    var minDistance2 = Infinity, closestPoint;
    (function find(node, x1, y1, x2, y2) {
      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
      if (point = node.point) {
        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
        if (distance2 < minDistance2) {
          var distance = Math.sqrt(minDistance2 = distance2);
          x0 = x - distance, y0 = y - distance;
          x3 = x + distance, y3 = y + distance;
          closestPoint = point;
        }
      }
      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
        if (node = children[i & 3]) switch (i & 3) {
         case 0:
          find(node, x1, y1, xm, ym);
          break;

         case 1:
          find(node, xm, y1, x2, ym);
          break;

         case 2:
          find(node, x1, ym, xm, y2);
          break;

         case 3:
          find(node, xm, ym, x2, y2);
          break;
        }
      }
    })(root, x0, y0, x3, y3);
    return closestPoint;
  }
  d3.interpolateRgb = d3_interpolateRgb;
  function d3_interpolateRgb(a, b) {
    a = d3.rgb(a);
    b = d3.rgb(b);
    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
    return function(t) {
      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
    };
  }
  d3.interpolateObject = d3_interpolateObject;
  function d3_interpolateObject(a, b) {
    var i = {}, c = {}, k;
    for (k in a) {
      if (k in b) {
        i[k] = d3_interpolate(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }
    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }
    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }
  d3.interpolateNumber = d3_interpolateNumber;
  function d3_interpolateNumber(a, b) {
    a = +a, b = +b;
    return function(t) {
      return a * (1 - t) + b * t;
    };
  }
  d3.interpolateString = d3_interpolateString;
  function d3_interpolateString(a, b) {
    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
    a = a + "", b = b + "";
    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
      if ((bs = bm.index) > bi) {
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        if (s[i]) s[i] += bm; else s[++i] = bm;
      } else {
        s[++i] = null;
        q.push({
          i: i,
          x: d3_interpolateNumber(am, bm)
        });
      }
      bi = d3_interpolate_numberB.lastIndex;
    }
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; else s[++i] = bs;
    }
    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
      return b(t) + "";
    }) : function() {
      return b;
    } : (b = q.length, function(t) {
      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    });
  }
  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
  d3.interpolate = d3_interpolate;
  function d3_interpolate(a, b) {
    var i = d3.interpolators.length, f;
    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
    return f;
  }
  d3.interpolators = [ function(a, b) {
    var t = typeof b;
    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
  } ];
  d3.interpolateArray = d3_interpolateArray;
  function d3_interpolateArray(a, b) {
    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
    for (;i < na; ++i) c[i] = a[i];
    for (;i < nb; ++i) c[i] = b[i];
    return function(t) {
      for (i = 0; i < n0; ++i) c[i] = x[i](t);
      return c;
    };
  }
  var d3_ease_default = function() {
    return d3_identity;
  };
  var d3_ease = d3.map({
    linear: d3_ease_default,
    poly: d3_ease_poly,
    quad: function() {
      return d3_ease_quad;
    },
    cubic: function() {
      return d3_ease_cubic;
    },
    sin: function() {
      return d3_ease_sin;
    },
    exp: function() {
      return d3_ease_exp;
    },
    circle: function() {
      return d3_ease_circle;
    },
    elastic: d3_ease_elastic,
    back: d3_ease_back,
    bounce: function() {
      return d3_ease_bounce;
    }
  });
  var d3_ease_mode = d3.map({
    "in": d3_identity,
    out: d3_ease_reverse,
    "in-out": d3_ease_reflect,
    "out-in": function(f) {
      return d3_ease_reflect(d3_ease_reverse(f));
    }
  });
  d3.ease = function(name) {
    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
    t = d3_ease.get(t) || d3_ease_default;
    m = d3_ease_mode.get(m) || d3_identity;
    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
  };
  function d3_ease_clamp(f) {
    return function(t) {
      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
    };
  }
  function d3_ease_reverse(f) {
    return function(t) {
      return 1 - f(1 - t);
    };
  }
  function d3_ease_reflect(f) {
    return function(t) {
      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
    };
  }
  function d3_ease_quad(t) {
    return t * t;
  }
  function d3_ease_cubic(t) {
    return t * t * t;
  }
  function d3_ease_cubicInOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var t2 = t * t, t3 = t2 * t;
    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
  }
  function d3_ease_poly(e) {
    return function(t) {
      return Math.pow(t, e);
    };
  }
  function d3_ease_sin(t) {
    return 1 - Math.cos(t * halfπ);
  }
  function d3_ease_exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  function d3_ease_circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  function d3_ease_elastic(a, p) {
    var s;
    if (arguments.length < 2) p = .45;
    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
    return function(t) {
      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
    };
  }
  function d3_ease_back(s) {
    if (!s) s = 1.70158;
    return function(t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  function d3_ease_bounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
  }
  d3.interpolateHcl = d3_interpolateHcl;
  function d3_interpolateHcl(a, b) {
    a = d3.hcl(a);
    b = d3.hcl(b);
    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
    };
  }
  d3.interpolateHsl = d3_interpolateHsl;
  function d3_interpolateHsl(a, b) {
    a = d3.hsl(a);
    b = d3.hsl(b);
    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
    };
  }
  d3.interpolateLab = d3_interpolateLab;
  function d3_interpolateLab(a, b) {
    a = d3.lab(a);
    b = d3.lab(b);
    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
    return function(t) {
      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
    };
  }
  d3.interpolateRound = d3_interpolateRound;
  function d3_interpolateRound(a, b) {
    b -= a;
    return function(t) {
      return Math.round(a + b * t);
    };
  }
  d3.transform = function(string) {
    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
    return (d3.transform = function(string) {
      if (string != null) {
        g.setAttribute("transform", string);
        var t = g.transform.baseVal.consolidate();
      }
      return new d3_transform(t ? t.matrix : d3_transformIdentity);
    })(string);
  };
  function d3_transform(m) {
    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }
    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
    this.translate = [ m.e, m.f ];
    this.scale = [ kx, ky ];
    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
  }
  d3_transform.prototype.toString = function() {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  function d3_transformDot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }
  function d3_transformNormalize(a) {
    var k = Math.sqrt(d3_transformDot(a, a));
    if (k) {
      a[0] /= k;
      a[1] /= k;
    }
    return k;
  }
  function d3_transformCombine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }
  var d3_transformIdentity = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  d3.interpolateTransform = d3_interpolateTransform;
  function d3_interpolateTransformPop(s) {
    return s.length ? s.pop() + "," : "";
  }
  function d3_interpolateTranslate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ta[0], tb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ta[1], tb[1])
      });
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }
  function d3_interpolateRotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
        x: d3_interpolateNumber(ra, rb)
      });
    } else if (rb) {
      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
    }
  }
  function d3_interpolateSkew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
        x: d3_interpolateNumber(wa, wb)
      });
    } else if (wb) {
      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
    }
  }
  function d3_interpolateScale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ka[0], kb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ka[1], kb[1])
      });
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
    }
  }
  function d3_interpolateTransform(a, b) {
    var s = [], q = [];
    a = d3.transform(a), b = d3.transform(b);
    d3_interpolateTranslate(a.translate, b.translate, s, q);
    d3_interpolateRotate(a.rotate, b.rotate, s, q);
    d3_interpolateSkew(a.skew, b.skew, s, q);
    d3_interpolateScale(a.scale, b.scale, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  }
  function d3_uninterpolateNumber(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return (x - a) / b;
    };
  }
  function d3_uninterpolateClamp(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return Math.max(0, Math.min(1, (x - a) / b));
    };
  }
  d3.layout = {};
  d3.layout.bundle = function() {
    return function(links) {
      var paths = [], i = -1, n = links.length;
      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
      return paths;
    };
  };
  function d3_layout_bundlePath(link) {
    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
    while (start !== lca) {
      start = start.parent;
      points.push(start);
    }
    var k = points.length;
    while (end !== lca) {
      points.splice(k, 0, end);
      end = end.parent;
    }
    return points;
  }
  function d3_layout_bundleAncestors(node) {
    var ancestors = [], parent = node.parent;
    while (parent != null) {
      ancestors.push(node);
      node = parent;
      parent = parent.parent;
    }
    ancestors.push(node);
    return ancestors;
  }
  function d3_layout_bundleLeastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
    while (aNode === bNode) {
      sharedNode = aNode;
      aNode = aNodes.pop();
      bNode = bNodes.pop();
    }
    return sharedNode;
  }
  d3.layout.chord = function() {
    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
    function relayout() {
      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
      chords = [];
      groups = [];
      k = 0, i = -1;
      while (++i < n) {
        x = 0, j = -1;
        while (++j < n) {
          x += matrix[i][j];
        }
        groupSums.push(x);
        subgroupIndex.push(d3.range(n));
        k += x;
      }
      if (sortGroups) {
        groupIndex.sort(function(a, b) {
          return sortGroups(groupSums[a], groupSums[b]);
        });
      }
      if (sortSubgroups) {
        subgroupIndex.forEach(function(d, i) {
          d.sort(function(a, b) {
            return sortSubgroups(matrix[i][a], matrix[i][b]);
          });
        });
      }
      k = (τ - padding * n) / k;
      x = 0, i = -1;
      while (++i < n) {
        x0 = x, j = -1;
        while (++j < n) {
          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
          subgroups[di + "-" + dj] = {
            index: di,
            subindex: dj,
            startAngle: a0,
            endAngle: a1,
            value: v
          };
        }
        groups[di] = {
          index: di,
          startAngle: x0,
          endAngle: x,
          value: groupSums[di]
        };
        x += padding;
      }
      i = -1;
      while (++i < n) {
        j = i - 1;
        while (++j < n) {
          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
          if (source.value || target.value) {
            chords.push(source.value < target.value ? {
              source: target,
              target: source
            } : {
              source: source,
              target: target
            });
          }
        }
      }
      if (sortChords) resort();
    }
    function resort() {
      chords.sort(function(a, b) {
        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
      });
    }
    chord.matrix = function(x) {
      if (!arguments.length) return matrix;
      n = (matrix = x) && matrix.length;
      chords = groups = null;
      return chord;
    };
    chord.padding = function(x) {
      if (!arguments.length) return padding;
      padding = x;
      chords = groups = null;
      return chord;
    };
    chord.sortGroups = function(x) {
      if (!arguments.length) return sortGroups;
      sortGroups = x;
      chords = groups = null;
      return chord;
    };
    chord.sortSubgroups = function(x) {
      if (!arguments.length) return sortSubgroups;
      sortSubgroups = x;
      chords = null;
      return chord;
    };
    chord.sortChords = function(x) {
      if (!arguments.length) return sortChords;
      sortChords = x;
      if (chords) resort();
      return chord;
    };
    chord.chords = function() {
      if (!chords) relayout();
      return chords;
    };
    chord.groups = function() {
      if (!groups) relayout();
      return groups;
    };
    return chord;
  };
  d3.layout.force = function() {
    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
    function repulse(node) {
      return function(quad, x1, _, x2) {
        if (quad.point !== node) {
          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
          if (dw * dw / theta2 < dn) {
            if (dn < chargeDistance2) {
              var k = quad.charge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
            return true;
          }
          if (quad.point && dn && dn < chargeDistance2) {
            var k = quad.pointCharge / dn;
            node.px -= dx * k;
            node.py -= dy * k;
          }
        }
        return !quad.charge;
      };
    }
    force.tick = function() {
      if ((alpha *= .99) < .005) {
        timer = null;
        event.end({
          type: "end",
          alpha: alpha = 0
        });
        return true;
      }
      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
      for (i = 0; i < m; ++i) {
        o = links[i];
        s = o.source;
        t = o.target;
        x = t.x - s.x;
        y = t.y - s.y;
        if (l = x * x + y * y) {
          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
          x *= l;
          y *= l;
          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
          t.y -= y * k;
          s.x += x * (k = 1 - k);
          s.y += y * k;
        }
      }
      if (k = alpha * gravity) {
        x = size[0] / 2;
        y = size[1] / 2;
        i = -1;
        if (k) while (++i < n) {
          o = nodes[i];
          o.x += (x - o.x) * k;
          o.y += (y - o.y) * k;
        }
      }
      if (charge) {
        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
        i = -1;
        while (++i < n) {
          if (!(o = nodes[i]).fixed) {
            q.visit(repulse(o));
          }
        }
      }
      i = -1;
      while (++i < n) {
        o = nodes[i];
        if (o.fixed) {
          o.x = o.px;
          o.y = o.py;
        } else {
          o.x -= (o.px - (o.px = o.x)) * friction;
          o.y -= (o.py - (o.py = o.y)) * friction;
        }
      }
      event.tick({
        type: "tick",
        alpha: alpha
      });
    };
    force.nodes = function(x) {
      if (!arguments.length) return nodes;
      nodes = x;
      return force;
    };
    force.links = function(x) {
      if (!arguments.length) return links;
      links = x;
      return force;
    };
    force.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return force;
    };
    force.linkDistance = function(x) {
      if (!arguments.length) return linkDistance;
      linkDistance = typeof x === "function" ? x : +x;
      return force;
    };
    force.distance = force.linkDistance;
    force.linkStrength = function(x) {
      if (!arguments.length) return linkStrength;
      linkStrength = typeof x === "function" ? x : +x;
      return force;
    };
    force.friction = function(x) {
      if (!arguments.length) return friction;
      friction = +x;
      return force;
    };
    force.charge = function(x) {
      if (!arguments.length) return charge;
      charge = typeof x === "function" ? x : +x;
      return force;
    };
    force.chargeDistance = function(x) {
      if (!arguments.length) return Math.sqrt(chargeDistance2);
      chargeDistance2 = x * x;
      return force;
    };
    force.gravity = function(x) {
      if (!arguments.length) return gravity;
      gravity = +x;
      return force;
    };
    force.theta = function(x) {
      if (!arguments.length) return Math.sqrt(theta2);
      theta2 = x * x;
      return force;
    };
    force.alpha = function(x) {
      if (!arguments.length) return alpha;
      x = +x;
      if (alpha) {
        if (x > 0) {
          alpha = x;
        } else {
          timer.c = null, timer.t = NaN, timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
        }
      } else if (x > 0) {
        event.start({
          type: "start",
          alpha: alpha = x
        });
        timer = d3_timer(force.tick);
      }
      return force;
    };
    force.start = function() {
      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
      for (i = 0; i < n; ++i) {
        (o = nodes[i]).index = i;
        o.weight = 0;
      }
      for (i = 0; i < m; ++i) {
        o = links[i];
        if (typeof o.source == "number") o.source = nodes[o.source];
        if (typeof o.target == "number") o.target = nodes[o.target];
        ++o.source.weight;
        ++o.target.weight;
      }
      for (i = 0; i < n; ++i) {
        o = nodes[i];
        if (isNaN(o.x)) o.x = position("x", w);
        if (isNaN(o.y)) o.y = position("y", h);
        if (isNaN(o.px)) o.px = o.x;
        if (isNaN(o.py)) o.py = o.y;
      }
      distances = [];
      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
      strengths = [];
      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
      charges = [];
      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
      function position(dimension, size) {
        if (!neighbors) {
          neighbors = new Array(n);
          for (j = 0; j < n; ++j) {
            neighbors[j] = [];
          }
          for (j = 0; j < m; ++j) {
            var o = links[j];
            neighbors[o.source.index].push(o.target);
            neighbors[o.target.index].push(o.source);
          }
        }
        var candidates = neighbors[i], j = -1, l = candidates.length, x;
        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
        return Math.random() * size;
      }
      return force.resume();
    };
    force.resume = function() {
      return force.alpha(.1);
    };
    force.stop = function() {
      return force.alpha(0);
    };
    force.drag = function() {
      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
      if (!arguments.length) return drag;
      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
    };
    function dragmove(d) {
      d.px = d3.event.x, d.py = d3.event.y;
      force.resume();
    }
    return d3.rebind(force, event, "on");
  };
  function d3_layout_forceDragstart(d) {
    d.fixed |= 2;
  }
  function d3_layout_forceDragend(d) {
    d.fixed &= ~6;
  }
  function d3_layout_forceMouseover(d) {
    d.fixed |= 4;
    d.px = d.x, d.py = d.y;
  }
  function d3_layout_forceMouseout(d) {
    d.fixed &= ~4;
  }
  function d3_layout_forceAccumulate(quad, alpha, charges) {
    var cx = 0, cy = 0;
    quad.charge = 0;
    if (!quad.leaf) {
      var nodes = quad.nodes, n = nodes.length, i = -1, c;
      while (++i < n) {
        c = nodes[i];
        if (c == null) continue;
        d3_layout_forceAccumulate(c, alpha, charges);
        quad.charge += c.charge;
        cx += c.charge * c.cx;
        cy += c.charge * c.cy;
      }
    }
    if (quad.point) {
      if (!quad.leaf) {
        quad.point.x += Math.random() - .5;
        quad.point.y += Math.random() - .5;
      }
      var k = alpha * charges[quad.point.index];
      quad.charge += quad.pointCharge = k;
      cx += k * quad.point.x;
      cy += k * quad.point.y;
    }
    quad.cx = cx / quad.charge;
    quad.cy = cy / quad.charge;
  }
  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
  d3.layout.hierarchy = function() {
    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
    function hierarchy(root) {
      var stack = [ root ], nodes = [], node;
      root.depth = 0;
      while ((node = stack.pop()) != null) {
        nodes.push(node);
        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
          var n, childs, child;
          while (--n >= 0) {
            stack.push(child = childs[n]);
            child.parent = node;
            child.depth = node.depth + 1;
          }
          if (value) node.value = 0;
          node.children = childs;
        } else {
          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
          delete node.children;
        }
      }
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var childs, parent;
        if (sort && (childs = node.children)) childs.sort(sort);
        if (value && (parent = node.parent)) parent.value += node.value;
      });
      return nodes;
    }
    hierarchy.sort = function(x) {
      if (!arguments.length) return sort;
      sort = x;
      return hierarchy;
    };
    hierarchy.children = function(x) {
      if (!arguments.length) return children;
      children = x;
      return hierarchy;
    };
    hierarchy.value = function(x) {
      if (!arguments.length) return value;
      value = x;
      return hierarchy;
    };
    hierarchy.revalue = function(root) {
      if (value) {
        d3_layout_hierarchyVisitBefore(root, function(node) {
          if (node.children) node.value = 0;
        });
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var parent;
          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
          if (parent = node.parent) parent.value += node.value;
        });
      }
      return root;
    };
    return hierarchy;
  };
  function d3_layout_hierarchyRebind(object, hierarchy) {
    d3.rebind(object, hierarchy, "sort", "children", "value");
    object.nodes = object;
    object.links = d3_layout_hierarchyLinks;
    return object;
  }
  function d3_layout_hierarchyVisitBefore(node, callback) {
    var nodes = [ node ];
    while ((node = nodes.pop()) != null) {
      callback(node);
      if ((children = node.children) && (n = children.length)) {
        var n, children;
        while (--n >= 0) nodes.push(children[n]);
      }
    }
  }
  function d3_layout_hierarchyVisitAfter(node, callback) {
    var nodes = [ node ], nodes2 = [];
    while ((node = nodes.pop()) != null) {
      nodes2.push(node);
      if ((children = node.children) && (n = children.length)) {
        var i = -1, n, children;
        while (++i < n) nodes.push(children[i]);
      }
    }
    while ((node = nodes2.pop()) != null) {
      callback(node);
    }
  }
  function d3_layout_hierarchyChildren(d) {
    return d.children;
  }
  function d3_layout_hierarchyValue(d) {
    return d.value;
  }
  function d3_layout_hierarchySort(a, b) {
    return b.value - a.value;
  }
  function d3_layout_hierarchyLinks(nodes) {
    return d3.merge(nodes.map(function(parent) {
      return (parent.children || []).map(function(child) {
        return {
          source: parent,
          target: child
        };
      });
    }));
  }
  d3.layout.partition = function() {
    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
    function position(node, x, dx, dy) {
      var children = node.children;
      node.x = x;
      node.y = node.depth * dy;
      node.dx = dx;
      node.dy = dy;
      if (children && (n = children.length)) {
        var i = -1, n, c, d;
        dx = node.value ? dx / node.value : 0;
        while (++i < n) {
          position(c = children[i], x, d = c.value * dx, dy);
          x += d;
        }
      }
    }
    function depth(node) {
      var children = node.children, d = 0;
      if (children && (n = children.length)) {
        var i = -1, n;
        while (++i < n) d = Math.max(d, depth(children[i]));
      }
      return 1 + d;
    }
    function partition(d, i) {
      var nodes = hierarchy.call(this, d, i);
      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
      return nodes;
    }
    partition.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return partition;
    };
    return d3_layout_hierarchyRebind(partition, hierarchy);
  };
  d3.layout.pie = function() {
    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
    function pie(data) {
      var n = data.length, values = data.map(function(d, i) {
        return +value.call(pie, d, i);
      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
        return values[j] - values[i];
      } : function(i, j) {
        return sort(data[i], data[j]);
      });
      index.forEach(function(i) {
        arcs[i] = {
          data: data[i],
          value: v = values[i],
          startAngle: a,
          endAngle: a += v * k + pa,
          padAngle: p
        };
      });
      return arcs;
    }
    pie.value = function(_) {
      if (!arguments.length) return value;
      value = _;
      return pie;
    };
    pie.sort = function(_) {
      if (!arguments.length) return sort;
      sort = _;
      return pie;
    };
    pie.startAngle = function(_) {
      if (!arguments.length) return startAngle;
      startAngle = _;
      return pie;
    };
    pie.endAngle = function(_) {
      if (!arguments.length) return endAngle;
      endAngle = _;
      return pie;
    };
    pie.padAngle = function(_) {
      if (!arguments.length) return padAngle;
      padAngle = _;
      return pie;
    };
    return pie;
  };
  var d3_layout_pieSortByValue = {};
  d3.layout.stack = function() {
    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
    function stack(data, index) {
      if (!(n = data.length)) return data;
      var series = data.map(function(d, i) {
        return values.call(stack, d, i);
      });
      var points = series.map(function(d) {
        return d.map(function(v, i) {
          return [ x.call(stack, v, i), y.call(stack, v, i) ];
        });
      });
      var orders = order.call(stack, points, index);
      series = d3.permute(series, orders);
      points = d3.permute(points, orders);
      var offsets = offset.call(stack, points, index);
      var m = series[0].length, n, i, j, o;
      for (j = 0; j < m; ++j) {
        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
        for (i = 1; i < n; ++i) {
          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
        }
      }
      return data;
    }
    stack.values = function(x) {
      if (!arguments.length) return values;
      values = x;
      return stack;
    };
    stack.order = function(x) {
      if (!arguments.length) return order;
      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
      return stack;
    };
    stack.offset = function(x) {
      if (!arguments.length) return offset;
      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
      return stack;
    };
    stack.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      return stack;
    };
    stack.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      return stack;
    };
    stack.out = function(z) {
      if (!arguments.length) return out;
      out = z;
      return stack;
    };
    return stack;
  };
  function d3_layout_stackX(d) {
    return d.x;
  }
  function d3_layout_stackY(d) {
    return d.y;
  }
  function d3_layout_stackOut(d, y0, y) {
    d.y0 = y0;
    d.y = y;
  }
  var d3_layout_stackOrders = d3.map({
    "inside-out": function(data) {
      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
        return max[a] - max[b];
      }), top = 0, bottom = 0, tops = [], bottoms = [];
      for (i = 0; i < n; ++i) {
        j = index[i];
        if (top < bottom) {
          top += sums[j];
          tops.push(j);
        } else {
          bottom += sums[j];
          bottoms.push(j);
        }
      }
      return bottoms.reverse().concat(tops);
    },
    reverse: function(data) {
      return d3.range(data.length).reverse();
    },
    "default": d3_layout_stackOrderDefault
  });
  var d3_layout_stackOffsets = d3.map({
    silhouette: function(data) {
      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o > max) max = o;
        sums.push(o);
      }
      for (j = 0; j < m; ++j) {
        y0[j] = (max - sums[j]) / 2;
      }
      return y0;
    },
    wiggle: function(data) {
      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
      y0[0] = o = o0 = 0;
      for (j = 1; j < m; ++j) {
        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
          }
          s2 += s3 * data[i][j][1];
        }
        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
        if (o < o0) o0 = o;
      }
      for (j = 0; j < m; ++j) y0[j] -= o0;
      return y0;
    },
    expand: function(data) {
      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
      }
      for (j = 0; j < m; ++j) y0[j] = 0;
      return y0;
    },
    zero: d3_layout_stackOffsetZero
  });
  function d3_layout_stackOrderDefault(data) {
    return d3.range(data.length);
  }
  function d3_layout_stackOffsetZero(data) {
    var j = -1, m = data[0].length, y0 = [];
    while (++j < m) y0[j] = 0;
    return y0;
  }
  function d3_layout_stackMaxIndex(array) {
    var i = 1, j = 0, v = array[0][1], k, n = array.length;
    for (;i < n; ++i) {
      if ((k = array[i][1]) > v) {
        j = i;
        v = k;
      }
    }
    return j;
  }
  function d3_layout_stackReduceSum(d) {
    return d.reduce(d3_layout_stackSum, 0);
  }
  function d3_layout_stackSum(p, d) {
    return p + d[1];
  }
  d3.layout.histogram = function() {
    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
    function histogram(data, i) {
      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
      while (++i < m) {
        bin = bins[i] = [];
        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
        bin.y = 0;
      }
      if (m > 0) {
        i = -1;
        while (++i < n) {
          x = values[i];
          if (x >= range[0] && x <= range[1]) {
            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
            bin.y += k;
            bin.push(data[i]);
          }
        }
      }
      return bins;
    }
    histogram.value = function(x) {
      if (!arguments.length) return valuer;
      valuer = x;
      return histogram;
    };
    histogram.range = function(x) {
      if (!arguments.length) return ranger;
      ranger = d3_functor(x);
      return histogram;
    };
    histogram.bins = function(x) {
      if (!arguments.length) return binner;
      binner = typeof x === "number" ? function(range) {
        return d3_layout_histogramBinFixed(range, x);
      } : d3_functor(x);
      return histogram;
    };
    histogram.frequency = function(x) {
      if (!arguments.length) return frequency;
      frequency = !!x;
      return histogram;
    };
    return histogram;
  };
  function d3_layout_histogramBinSturges(range, values) {
    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
  }
  function d3_layout_histogramBinFixed(range, n) {
    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
    while (++x <= n) f[x] = m * x + b;
    return f;
  }
  function d3_layout_histogramRange(values) {
    return [ d3.min(values), d3.max(values) ];
  }
  d3.layout.pack = function() {
    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
    function pack(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
        return radius;
      };
      root.x = root.y = 0;
      d3_layout_hierarchyVisitAfter(root, function(d) {
        d.r = +r(d.value);
      });
      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
      if (padding) {
        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r += dr;
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r -= dr;
        });
      }
      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
      return nodes;
    }
    pack.size = function(_) {
      if (!arguments.length) return size;
      size = _;
      return pack;
    };
    pack.radius = function(_) {
      if (!arguments.length) return radius;
      radius = _ == null || typeof _ === "function" ? _ : +_;
      return pack;
    };
    pack.padding = function(_) {
      if (!arguments.length) return padding;
      padding = +_;
      return pack;
    };
    return d3_layout_hierarchyRebind(pack, hierarchy);
  };
  function d3_layout_packSort(a, b) {
    return a.value - b.value;
  }
  function d3_layout_packInsert(a, b) {
    var c = a._pack_next;
    a._pack_next = b;
    b._pack_prev = a;
    b._pack_next = c;
    c._pack_prev = b;
  }
  function d3_layout_packSplice(a, b) {
    a._pack_next = b;
    b._pack_prev = a;
  }
  function d3_layout_packIntersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return .999 * dr * dr > dx * dx + dy * dy;
  }
  function d3_layout_packSiblings(node) {
    if (!(nodes = node.children) || !(n = nodes.length)) return;
    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
    function bound(node) {
      xMin = Math.min(node.x - node.r, xMin);
      xMax = Math.max(node.x + node.r, xMax);
      yMin = Math.min(node.y - node.r, yMin);
      yMax = Math.max(node.y + node.r, yMax);
    }
    nodes.forEach(d3_layout_packLink);
    a = nodes[0];
    a.x = -a.r;
    a.y = 0;
    bound(a);
    if (n > 1) {
      b = nodes[1];
      b.x = b.r;
      b.y = 0;
      bound(b);
      if (n > 2) {
        c = nodes[2];
        d3_layout_packPlace(a, b, c);
        bound(c);
        d3_layout_packInsert(a, c);
        a._pack_prev = c;
        d3_layout_packInsert(c, b);
        b = a._pack_next;
        for (i = 3; i < n; i++) {
          d3_layout_packPlace(a, b, c = nodes[i]);
          var isect = 0, s1 = 1, s2 = 1;
          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
            if (d3_layout_packIntersects(j, c)) {
              isect = 1;
              break;
            }
          }
          if (isect == 1) {
            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
              if (d3_layout_packIntersects(k, c)) {
                break;
              }
            }
          }
          if (isect) {
            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
            i--;
          } else {
            d3_layout_packInsert(a, c);
            b = c;
            bound(c);
          }
        }
      }
    }
    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
    for (i = 0; i < n; i++) {
      c = nodes[i];
      c.x -= cx;
      c.y -= cy;
      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
    }
    node.r = cr;
    nodes.forEach(d3_layout_packUnlink);
  }
  function d3_layout_packLink(node) {
    node._pack_next = node._pack_prev = node;
  }
  function d3_layout_packUnlink(node) {
    delete node._pack_next;
    delete node._pack_prev;
  }
  function d3_layout_packTransform(node, x, y, k) {
    var children = node.children;
    node.x = x += k * node.x;
    node.y = y += k * node.y;
    node.r *= k;
    if (children) {
      var i = -1, n = children.length;
      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
    }
  }
  function d3_layout_packPlace(a, b, c) {
    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
    if (db && (dx || dy)) {
      var da = b.r + c.r, dc = dx * dx + dy * dy;
      da *= da;
      db *= db;
      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
      c.x = a.x + x * dx + y * dy;
      c.y = a.y + x * dy - y * dx;
    } else {
      c.x = a.x + db;
      c.y = a.y;
    }
  }
  d3.layout.tree = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
    function tree(d, i) {
      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
      d3_layout_hierarchyVisitBefore(root1, secondWalk);
      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
        var left = root0, right = root0, bottom = root0;
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
      return nodes;
    }
    function wrapTree(root0) {
      var root1 = {
        A: null,
        children: [ root0 ]
      }, queue = [ root1 ], node1;
      while ((node1 = queue.pop()) != null) {
        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
          queue.push((children[i] = child = {
            _: children[i],
            parent: node1,
            children: (child = children[i].children) && child.slice() || [],
            A: null,
            a: null,
            z: 0,
            m: 0,
            c: 0,
            s: 0,
            t: null,
            i: i
          }).a = child);
        }
      }
      return root1.children[0];
    }
    function firstWalk(v) {
      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
      if (children.length) {
        d3_layout_treeShift(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
          vom = d3_layout_treeLeft(vom);
          vop = d3_layout_treeRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !d3_layout_treeRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !d3_layout_treeLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
    function sizeNode(node) {
      node.x *= size[0];
      node.y = node.depth * size[1];
    }
    tree.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return tree;
    };
    tree.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null ? sizeNode : null;
      return tree;
    };
    tree.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) == null ? null : sizeNode;
      return tree;
    };
    return d3_layout_hierarchyRebind(tree, hierarchy);
  };
  function d3_layout_treeSeparation(a, b) {
    return a.parent == b.parent ? 1 : 2;
  }
  function d3_layout_treeLeft(v) {
    var children = v.children;
    return children.length ? children[0] : v.t;
  }
  function d3_layout_treeRight(v) {
    var children = v.children, n;
    return (n = children.length) ? children[n - 1] : v.t;
  }
  function d3_layout_treeMove(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  function d3_layout_treeShift(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  function d3_layout_treeAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  d3.layout.cluster = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
    function cluster(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var children = node.children;
        if (children && children.length) {
          node.x = d3_layout_clusterX(children);
          node.y = d3_layout_clusterY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
        node.x = (node.x - root.x) * size[0];
        node.y = (root.y - node.y) * size[1];
      } : function(node) {
        node.x = (node.x - x0) / (x1 - x0) * size[0];
        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
      });
      return nodes;
    }
    cluster.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return cluster;
    };
    cluster.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null;
      return cluster;
    };
    cluster.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) != null;
      return cluster;
    };
    return d3_layout_hierarchyRebind(cluster, hierarchy);
  };
  function d3_layout_clusterY(children) {
    return 1 + d3.max(children, function(child) {
      return child.y;
    });
  }
  function d3_layout_clusterX(children) {
    return children.reduce(function(x, child) {
      return x + child.x;
    }, 0) / children.length;
  }
  function d3_layout_clusterLeft(node) {
    var children = node.children;
    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
  }
  function d3_layout_clusterRight(node) {
    var children = node.children, n;
    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
  }
  d3.layout.treemap = function() {
    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
    function scale(children, k) {
      var i = -1, n = children.length, child, area;
      while (++i < n) {
        area = (child = children[i]).value * (k < 0 ? 0 : k);
        child.area = isNaN(area) || area <= 0 ? 0 : area;
      }
    }
    function squarify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while ((n = remaining.length) > 0) {
          row.push(child = remaining[n - 1]);
          row.area += child.area;
          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
            remaining.pop();
            best = score;
          } else {
            row.area -= row.pop().area;
            position(row, u, rect, false);
            u = Math.min(rect.dx, rect.dy);
            row.length = row.area = 0;
            best = Infinity;
          }
        }
        if (row.length) {
          position(row, u, rect, true);
          row.length = row.area = 0;
        }
        children.forEach(squarify);
      }
    }
    function stickify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), remaining = children.slice(), child, row = [];
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while (child = remaining.pop()) {
          row.push(child);
          row.area += child.area;
          if (child.z != null) {
            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
            row.length = row.area = 0;
          }
        }
        children.forEach(stickify);
      }
    }
    function worst(row, u) {
      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
      while (++i < n) {
        if (!(r = row[i].area)) continue;
        if (r < rmin) rmin = r;
        if (r > rmax) rmax = r;
      }
      s *= s;
      u *= u;
      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
    }
    function position(row, u, rect, flush) {
      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
      if (u == rect.dx) {
        if (flush || v > rect.dy) v = rect.dy;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dy = v;
          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
        }
        o.z = true;
        o.dx += rect.x + rect.dx - x;
        rect.y += v;
        rect.dy -= v;
      } else {
        if (flush || v > rect.dx) v = rect.dx;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dx = v;
          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
        }
        o.z = false;
        o.dy += rect.y + rect.dy - y;
        rect.x += v;
        rect.dx -= v;
      }
    }
    function treemap(d) {
      var nodes = stickies || hierarchy(d), root = nodes[0];
      root.x = root.y = 0;
      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
      if (stickies) hierarchy.revalue(root);
      scale([ root ], root.dx * root.dy / root.value);
      (stickies ? stickify : squarify)(root);
      if (sticky) stickies = nodes;
      return nodes;
    }
    treemap.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return treemap;
    };
    treemap.padding = function(x) {
      if (!arguments.length) return padding;
      function padFunction(node) {
        var p = x.call(treemap, node, node.depth);
        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
      }
      function padConstant(node) {
        return d3_layout_treemapPad(node, x);
      }
      var type;
      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
      padConstant) : padConstant;
      return treemap;
    };
    treemap.round = function(x) {
      if (!arguments.length) return round != Number;
      round = x ? Math.round : Number;
      return treemap;
    };
    treemap.sticky = function(x) {
      if (!arguments.length) return sticky;
      sticky = x;
      stickies = null;
      return treemap;
    };
    treemap.ratio = function(x) {
      if (!arguments.length) return ratio;
      ratio = x;
      return treemap;
    };
    treemap.mode = function(x) {
      if (!arguments.length) return mode;
      mode = x + "";
      return treemap;
    };
    return d3_layout_hierarchyRebind(treemap, hierarchy);
  };
  function d3_layout_treemapPadNull(node) {
    return {
      x: node.x,
      y: node.y,
      dx: node.dx,
      dy: node.dy
    };
  }
  function d3_layout_treemapPad(node, padding) {
    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
    if (dx < 0) {
      x += dx / 2;
      dx = 0;
    }
    if (dy < 0) {
      y += dy / 2;
      dy = 0;
    }
    return {
      x: x,
      y: y,
      dx: dx,
      dy: dy
    };
  }
  d3.random = {
    normal: function(µ, σ) {
      var n = arguments.length;
      if (n < 2) σ = 1;
      if (n < 1) µ = 0;
      return function() {
        var x, y, r;
        do {
          x = Math.random() * 2 - 1;
          y = Math.random() * 2 - 1;
          r = x * x + y * y;
        } while (!r || r > 1);
        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
      };
    },
    logNormal: function() {
      var random = d3.random.normal.apply(d3, arguments);
      return function() {
        return Math.exp(random());
      };
    },
    bates: function(m) {
      var random = d3.random.irwinHall(m);
      return function() {
        return random() / m;
      };
    },
    irwinHall: function(m) {
      return function() {
        for (var s = 0, j = 0; j < m; j++) s += Math.random();
        return s;
      };
    }
  };
  d3.scale = {};
  function d3_scaleExtent(domain) {
    var start = domain[0], stop = domain[domain.length - 1];
    return start < stop ? [ start, stop ] : [ stop, start ];
  }
  function d3_scaleRange(scale) {
    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
  }
  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
    return function(x) {
      return i(u(x));
    };
  }
  function d3_scale_nice(domain, nice) {
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
    if (x1 < x0) {
      dx = i0, i0 = i1, i1 = dx;
      dx = x0, x0 = x1, x1 = dx;
    }
    domain[i0] = nice.floor(x0);
    domain[i1] = nice.ceil(x1);
    return domain;
  }
  function d3_scale_niceStep(step) {
    return step ? {
      floor: function(x) {
        return Math.floor(x / step) * step;
      },
      ceil: function(x) {
        return Math.ceil(x / step) * step;
      }
    } : d3_scale_niceIdentity;
  }
  var d3_scale_niceIdentity = {
    floor: d3_identity,
    ceil: d3_identity
  };
  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
    if (domain[k] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    while (++j <= k) {
      u.push(uninterpolate(domain[j - 1], domain[j]));
      i.push(interpolate(range[j - 1], range[j]));
    }
    return function(x) {
      var j = d3.bisect(domain, x, 1, k) - 1;
      return i[j](u[j](x));
    };
  }
  d3.scale.linear = function() {
    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
  };
  function d3_scale_linear(domain, range, interpolate, clamp) {
    var output, input;
    function rescale() {
      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
      output = linear(domain, range, uninterpolate, interpolate);
      input = linear(range, domain, uninterpolate, d3_interpolate);
      return scale;
    }
    function scale(x) {
      return output(x);
    }
    scale.invert = function(y) {
      return input(y);
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(Number);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.rangeRound = function(x) {
      return scale.range(x).interpolate(d3_interpolateRound);
    };
    scale.clamp = function(x) {
      if (!arguments.length) return clamp;
      clamp = x;
      return rescale();
    };
    scale.interpolate = function(x) {
      if (!arguments.length) return interpolate;
      interpolate = x;
      return rescale();
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      d3_scale_linearNice(domain, m);
      return rescale();
    };
    scale.copy = function() {
      return d3_scale_linear(domain, range, interpolate, clamp);
    };
    return rescale();
  }
  function d3_scale_linearRebind(scale, linear) {
    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
  }
  function d3_scale_linearNice(domain, m) {
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    return domain;
  }
  function d3_scale_linearTickRange(domain, m) {
    if (m == null) m = 10;
    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
    extent[0] = Math.ceil(extent[0] / step) * step;
    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
    extent[2] = step;
    return extent;
  }
  function d3_scale_linearTicks(domain, m) {
    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
  }
  function d3_scale_linearTickFormat(domain, m, format) {
    var range = d3_scale_linearTickRange(domain, m);
    if (format) {
      var match = d3_format_re.exec(format);
      match.shift();
      if (match[8] === "s") {
        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
        match[8] = "f";
        format = d3.format(match.join(""));
        return function(d) {
          return format(prefix.scale(d)) + prefix.symbol;
        };
      }
      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
      format = match.join("");
    } else {
      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
    }
    return d3.format(format);
  }
  var d3_scale_linearFormatSignificant = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  function d3_scale_linearPrecision(value) {
    return -Math.floor(Math.log(value) / Math.LN10 + .01);
  }
  function d3_scale_linearFormatPrecision(type, range) {
    var p = d3_scale_linearPrecision(range[2]);
    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
  }
  d3.scale.log = function() {
    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
  };
  function d3_scale_log(linear, base, positive, domain) {
    function log(x) {
      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
    }
    function pow(x) {
      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
    }
    function scale(x) {
      return linear(log(x));
    }
    scale.invert = function(x) {
      return pow(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      positive = x[0] >= 0;
      linear.domain((domain = x.map(Number)).map(log));
      return scale;
    };
    scale.base = function(_) {
      if (!arguments.length) return base;
      base = +_;
      linear.domain(domain.map(log));
      return scale;
    };
    scale.nice = function() {
      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
      linear.domain(niced);
      domain = niced.map(pow);
      return scale;
    };
    scale.ticks = function() {
      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
      if (isFinite(j - i)) {
        if (positive) {
          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
          ticks.push(pow(i));
        } else {
          ticks.push(pow(i));
          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
        }
        for (i = 0; ticks[i] < u; i++) {}
        for (j = ticks.length; ticks[j - 1] > v; j--) {}
        ticks = ticks.slice(i, j);
      }
      return ticks;
    };
    scale.tickFormat = function(n, format) {
      if (!arguments.length) return d3_scale_logFormat;
      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
      var k = Math.max(1, base * n / scale.ticks().length);
      return function(d) {
        var i = d / pow(Math.round(log(d)));
        if (i * base < base - .5) i *= base;
        return i <= k ? format(d) : "";
      };
    };
    scale.copy = function() {
      return d3_scale_log(linear.copy(), base, positive, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
    floor: function(x) {
      return -Math.ceil(-x);
    },
    ceil: function(x) {
      return -Math.floor(-x);
    }
  };
  d3.scale.pow = function() {
    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
  };
  function d3_scale_pow(linear, exponent, domain) {
    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
    function scale(x) {
      return linear(powp(x));
    }
    scale.invert = function(x) {
      return powb(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      linear.domain((domain = x.map(Number)).map(powp));
      return scale;
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      return scale.domain(d3_scale_linearNice(domain, m));
    };
    scale.exponent = function(x) {
      if (!arguments.length) return exponent;
      powp = d3_scale_powPow(exponent = x);
      powb = d3_scale_powPow(1 / exponent);
      linear.domain(domain.map(powp));
      return scale;
    };
    scale.copy = function() {
      return d3_scale_pow(linear.copy(), exponent, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_scale_powPow(e) {
    return function(x) {
      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
    };
  }
  d3.scale.sqrt = function() {
    return d3.scale.pow().exponent(.5);
  };
  d3.scale.ordinal = function() {
    return d3_scale_ordinal([], {
      t: "range",
      a: [ [] ]
    });
  };
  function d3_scale_ordinal(domain, ranger) {
    var index, range, rangeBand;
    function scale(x) {
      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
    }
    function steps(start, step) {
      return d3.range(domain.length).map(function(i) {
        return start + step * i;
      });
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = [];
      index = new d3_Map();
      var i = -1, n = x.length, xi;
      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
      return scale[ranger.t].apply(scale, ranger.a);
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      rangeBand = 0;
      ranger = {
        t: "range",
        a: arguments
      };
      return scale;
    };
    scale.rangePoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
      0) : (stop - start) / (domain.length - 1 + padding);
      range = steps(start + step * padding / 2, step);
      rangeBand = 0;
      ranger = {
        t: "rangePoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundPoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
      0) : (stop - start) / (domain.length - 1 + padding) | 0;
      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
      rangeBand = 0;
      ranger = {
        t: "rangeRoundPoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
      range = steps(start + step * outerPadding, step);
      if (reverse) range.reverse();
      rangeBand = step * (1 - padding);
      ranger = {
        t: "rangeBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
      if (reverse) range.reverse();
      rangeBand = Math.round(step * (1 - padding));
      ranger = {
        t: "rangeRoundBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeBand = function() {
      return rangeBand;
    };
    scale.rangeExtent = function() {
      return d3_scaleExtent(ranger.a[0]);
    };
    scale.copy = function() {
      return d3_scale_ordinal(domain, ranger);
    };
    return scale.domain(domain);
  }
  d3.scale.category10 = function() {
    return d3.scale.ordinal().range(d3_category10);
  };
  d3.scale.category20 = function() {
    return d3.scale.ordinal().range(d3_category20);
  };
  d3.scale.category20b = function() {
    return d3.scale.ordinal().range(d3_category20b);
  };
  d3.scale.category20c = function() {
    return d3.scale.ordinal().range(d3_category20c);
  };
  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
  d3.scale.quantile = function() {
    return d3_scale_quantile([], []);
  };
  function d3_scale_quantile(domain, range) {
    var thresholds;
    function rescale() {
      var k = 0, q = range.length;
      thresholds = [];
      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
      return scale;
    }
    function scale(x) {
      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.quantiles = function() {
      return thresholds;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
    };
    scale.copy = function() {
      return d3_scale_quantile(domain, range);
    };
    return rescale();
  }
  d3.scale.quantize = function() {
    return d3_scale_quantize(0, 1, [ 0, 1 ]);
  };
  function d3_scale_quantize(x0, x1, range) {
    var kx, i;
    function scale(x) {
      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
    }
    function rescale() {
      kx = range.length / (x1 - x0);
      i = range.length - 1;
      return scale;
    }
    scale.domain = function(x) {
      if (!arguments.length) return [ x0, x1 ];
      x0 = +x[0];
      x1 = +x[x.length - 1];
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      y = y < 0 ? NaN : y / kx + x0;
      return [ y, y + 1 / kx ];
    };
    scale.copy = function() {
      return d3_scale_quantize(x0, x1, range);
    };
    return rescale();
  }
  d3.scale.threshold = function() {
    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
  };
  function d3_scale_threshold(domain, range) {
    function scale(x) {
      if (x <= x) return range[d3.bisect(domain, x)];
    }
    scale.domain = function(_) {
      if (!arguments.length) return domain;
      domain = _;
      return scale;
    };
    scale.range = function(_) {
      if (!arguments.length) return range;
      range = _;
      return scale;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return [ domain[y - 1], domain[y] ];
    };
    scale.copy = function() {
      return d3_scale_threshold(domain, range);
    };
    return scale;
  }
  d3.scale.identity = function() {
    return d3_scale_identity([ 0, 1 ]);
  };
  function d3_scale_identity(domain) {
    function identity(x) {
      return +x;
    }
    identity.invert = identity;
    identity.domain = identity.range = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(identity);
      return identity;
    };
    identity.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    identity.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    identity.copy = function() {
      return d3_scale_identity(domain);
    };
    return identity;
  }
  d3.svg = {};
  function d3_zero() {
    return 0;
  }
  d3.svg.arc = function() {
    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
    function arc() {
      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
        if (!cw) p1 *= -1;
        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
      }
      if (r1) {
        x0 = r1 * Math.cos(a0 + p1);
        y0 = r1 * Math.sin(a0 + p1);
        x1 = r1 * Math.cos(a1 - p1);
        y1 = r1 * Math.sin(a1 - p1);
        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
          var h1 = (a0 + a1) / 2;
          x0 = r1 * Math.cos(h1);
          y0 = r1 * Math.sin(h1);
          x1 = y1 = null;
        }
      } else {
        x0 = y0 = 0;
      }
      if (r0) {
        x2 = r0 * Math.cos(a1 - p0);
        y2 = r0 * Math.sin(a1 - p0);
        x3 = r0 * Math.cos(a0 + p0);
        y3 = r0 * Math.sin(a0 + p0);
        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
          var h0 = (a0 + a1) / 2;
          x2 = r0 * Math.cos(h0);
          y2 = r0 * Math.sin(h0);
          x3 = y3 = null;
        }
      } else {
        x2 = y2 = 0;
      }
      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
        cr = r0 < r1 ^ cw ? 0 : 1;
        var rc1 = rc, rc0 = rc;
        if (da < π) {
          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
        if (x1 != null) {
          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
          if (rc === rc1) {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
          } else {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
          }
        } else {
          path.push("M", x0, ",", y0);
        }
        if (x3 != null) {
          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
          if (rc === rc0) {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          } else {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          }
        } else {
          path.push("L", x2, ",", y2);
        }
      } else {
        path.push("M", x0, ",", y0);
        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
        path.push("L", x2, ",", y2);
        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
      }
      path.push("Z");
      return path.join("");
    }
    function circleSegment(r1, cw) {
      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
    }
    arc.innerRadius = function(v) {
      if (!arguments.length) return innerRadius;
      innerRadius = d3_functor(v);
      return arc;
    };
    arc.outerRadius = function(v) {
      if (!arguments.length) return outerRadius;
      outerRadius = d3_functor(v);
      return arc;
    };
    arc.cornerRadius = function(v) {
      if (!arguments.length) return cornerRadius;
      cornerRadius = d3_functor(v);
      return arc;
    };
    arc.padRadius = function(v) {
      if (!arguments.length) return padRadius;
      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
      return arc;
    };
    arc.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return arc;
    };
    arc.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return arc;
    };
    arc.padAngle = function(v) {
      if (!arguments.length) return padAngle;
      padAngle = d3_functor(v);
      return arc;
    };
    arc.centroid = function() {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
      return [ Math.cos(a) * r, Math.sin(a) * r ];
    };
    return arc;
  };
  var d3_svg_arcAuto = "auto";
  function d3_svg_arcInnerRadius(d) {
    return d.innerRadius;
  }
  function d3_svg_arcOuterRadius(d) {
    return d.outerRadius;
  }
  function d3_svg_arcStartAngle(d) {
    return d.startAngle;
  }
  function d3_svg_arcEndAngle(d) {
    return d.endAngle;
  }
  function d3_svg_arcPadAngle(d) {
    return d && d.padAngle;
  }
  function d3_svg_arcSweep(x0, y0, x1, y1) {
    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
  }
  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
  }
  function d3_svg_line(projection) {
    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
    function line(data) {
      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
      function segment() {
        segments.push("M", interpolate(projection(points), tension));
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
        } else if (points.length) {
          segment();
          points = [];
        }
      }
      if (points.length) segment();
      return segments.length ? segments.join("") : null;
    }
    line.x = function(_) {
      if (!arguments.length) return x;
      x = _;
      return line;
    };
    line.y = function(_) {
      if (!arguments.length) return y;
      y = _;
      return line;
    };
    line.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return line;
    };
    line.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      return line;
    };
    line.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return line;
    };
    return line;
  }
  d3.svg.line = function() {
    return d3_svg_line(d3_identity);
  };
  var d3_svg_lineInterpolators = d3.map({
    linear: d3_svg_lineLinear,
    "linear-closed": d3_svg_lineLinearClosed,
    step: d3_svg_lineStep,
    "step-before": d3_svg_lineStepBefore,
    "step-after": d3_svg_lineStepAfter,
    basis: d3_svg_lineBasis,
    "basis-open": d3_svg_lineBasisOpen,
    "basis-closed": d3_svg_lineBasisClosed,
    bundle: d3_svg_lineBundle,
    cardinal: d3_svg_lineCardinal,
    "cardinal-open": d3_svg_lineCardinalOpen,
    "cardinal-closed": d3_svg_lineCardinalClosed,
    monotone: d3_svg_lineMonotone
  });
  d3_svg_lineInterpolators.forEach(function(key, value) {
    value.key = key;
    value.closed = /-closed$/.test(key);
  });
  function d3_svg_lineLinear(points) {
    return points.length > 1 ? points.join("L") : points + "Z";
  }
  function d3_svg_lineLinearClosed(points) {
    return points.join("L") + "Z";
  }
  function d3_svg_lineStep(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
    if (n > 1) path.push("H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepBefore(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepAfter(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
    return path.join("");
  }
  function d3_svg_lineCardinalOpen(points, tension) {
    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineCardinalClosed(points, tension) {
    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
  }
  function d3_svg_lineCardinal(points, tension) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineHermite(points, tangents) {
    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
      return d3_svg_lineLinear(points);
    }
    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
    if (quad) {
      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
      p0 = points[1];
      pi = 2;
    }
    if (tangents.length > 1) {
      t = tangents[1];
      p = points[pi];
      pi++;
      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      for (var i = 2; i < tangents.length; i++, pi++) {
        p = points[pi];
        t = tangents[i];
        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      }
    }
    if (quad) {
      var lp = points[pi];
      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
    }
    return path;
  }
  function d3_svg_lineCardinalTangents(points, tension) {
    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
    while (++i < n) {
      p0 = p1;
      p1 = p2;
      p2 = points[i];
      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
    }
    return tangents;
  }
  function d3_svg_lineBasis(points) {
    if (points.length < 3) return d3_svg_lineLinear(points);
    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    points.push(points[n - 1]);
    while (++i <= n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    points.pop();
    path.push("L", pi);
    return path.join("");
  }
  function d3_svg_lineBasisOpen(points) {
    if (points.length < 4) return d3_svg_lineLinear(points);
    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
    while (++i < 3) {
      pi = points[i];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
    --i;
    while (++i < n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBasisClosed(points) {
    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
    while (++i < 4) {
      pi = points[i % n];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    --i;
    while (++i < m) {
      pi = points[i % n];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBundle(points, tension) {
    var n = points.length - 1;
    if (n) {
      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
      while (++i <= n) {
        p = points[i];
        t = i / n;
        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
      }
    }
    return d3_svg_lineBasis(points);
  }
  function d3_svg_lineDot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  }
  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
  function d3_svg_lineBasisBezier(path, x, y) {
    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
  }
  function d3_svg_lineSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
  }
  function d3_svg_lineFiniteDifferences(points) {
    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
    while (++i < j) {
      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
    }
    m[i] = d;
    return m;
  }
  function d3_svg_lineMonotoneTangents(points) {
    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
    while (++i < j) {
      d = d3_svg_lineSlope(points[i], points[i + 1]);
      if (abs(d) < ε) {
        m[i] = m[i + 1] = 0;
      } else {
        a = m[i] / d;
        b = m[i + 1] / d;
        s = a * a + b * b;
        if (s > 9) {
          s = d * 3 / Math.sqrt(s);
          m[i] = s * a;
          m[i + 1] = s * b;
        }
      }
    }
    i = -1;
    while (++i <= j) {
      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
      tangents.push([ s || 0, m[i] * s || 0 ]);
    }
    return tangents;
  }
  function d3_svg_lineMonotone(points) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
  }
  d3.svg.line.radial = function() {
    var line = d3_svg_line(d3_svg_lineRadial);
    line.radius = line.x, delete line.x;
    line.angle = line.y, delete line.y;
    return line;
  };
  function d3_svg_lineRadial(points) {
    var point, i = -1, n = points.length, r, a;
    while (++i < n) {
      point = points[i];
      r = point[0];
      a = point[1] - halfπ;
      point[0] = r * Math.cos(a);
      point[1] = r * Math.sin(a);
    }
    return points;
  }
  function d3_svg_area(projection) {
    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
    function area(data) {
      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
        return x;
      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
        return y;
      } : d3_functor(y1), x, y;
      function segment() {
        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
        } else if (points0.length) {
          segment();
          points0 = [];
          points1 = [];
        }
      }
      if (points0.length) segment();
      return segments.length ? segments.join("") : null;
    }
    area.x = function(_) {
      if (!arguments.length) return x1;
      x0 = x1 = _;
      return area;
    };
    area.x0 = function(_) {
      if (!arguments.length) return x0;
      x0 = _;
      return area;
    };
    area.x1 = function(_) {
      if (!arguments.length) return x1;
      x1 = _;
      return area;
    };
    area.y = function(_) {
      if (!arguments.length) return y1;
      y0 = y1 = _;
      return area;
    };
    area.y0 = function(_) {
      if (!arguments.length) return y0;
      y0 = _;
      return area;
    };
    area.y1 = function(_) {
      if (!arguments.length) return y1;
      y1 = _;
      return area;
    };
    area.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return area;
    };
    area.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      interpolateReverse = interpolate.reverse || interpolate;
      L = interpolate.closed ? "M" : "L";
      return area;
    };
    area.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return area;
    };
    return area;
  }
  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
  d3.svg.area = function() {
    return d3_svg_area(d3_identity);
  };
  d3.svg.area.radial = function() {
    var area = d3_svg_area(d3_svg_lineRadial);
    area.radius = area.x, delete area.x;
    area.innerRadius = area.x0, delete area.x0;
    area.outerRadius = area.x1, delete area.x1;
    area.angle = area.y, delete area.y;
    area.startAngle = area.y0, delete area.y0;
    area.endAngle = area.y1, delete area.y1;
    return area;
  };
  d3.svg.chord = function() {
    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
    function chord(d, i) {
      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
    }
    function subgroup(self, f, d, i) {
      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
      return {
        r: r,
        a0: a0,
        a1: a1,
        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
      };
    }
    function equals(a, b) {
      return a.a0 == b.a0 && a.a1 == b.a1;
    }
    function arc(r, p, a) {
      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
    }
    function curve(r0, p0, r1, p1) {
      return "Q 0,0 " + p1;
    }
    chord.radius = function(v) {
      if (!arguments.length) return radius;
      radius = d3_functor(v);
      return chord;
    };
    chord.source = function(v) {
      if (!arguments.length) return source;
      source = d3_functor(v);
      return chord;
    };
    chord.target = function(v) {
      if (!arguments.length) return target;
      target = d3_functor(v);
      return chord;
    };
    chord.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return chord;
    };
    chord.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return chord;
    };
    return chord;
  };
  function d3_svg_chordRadius(d) {
    return d.radius;
  }
  d3.svg.diagonal = function() {
    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
    function diagonal(d, i) {
      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
        x: p0.x,
        y: m
      }, {
        x: p3.x,
        y: m
      }, p3 ];
      p = p.map(projection);
      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
    }
    diagonal.source = function(x) {
      if (!arguments.length) return source;
      source = d3_functor(x);
      return diagonal;
    };
    diagonal.target = function(x) {
      if (!arguments.length) return target;
      target = d3_functor(x);
      return diagonal;
    };
    diagonal.projection = function(x) {
      if (!arguments.length) return projection;
      projection = x;
      return diagonal;
    };
    return diagonal;
  };
  function d3_svg_diagonalProjection(d) {
    return [ d.x, d.y ];
  }
  d3.svg.diagonal.radial = function() {
    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
    diagonal.projection = function(x) {
      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
    };
    return diagonal;
  };
  function d3_svg_diagonalRadialProjection(projection) {
    return function() {
      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
      return [ r * Math.cos(a), r * Math.sin(a) ];
    };
  }
  d3.svg.symbol = function() {
    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
    function symbol(d, i) {
      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
    }
    symbol.type = function(x) {
      if (!arguments.length) return type;
      type = d3_functor(x);
      return symbol;
    };
    symbol.size = function(x) {
      if (!arguments.length) return size;
      size = d3_functor(x);
      return symbol;
    };
    return symbol;
  };
  function d3_svg_symbolSize() {
    return 64;
  }
  function d3_svg_symbolType() {
    return "circle";
  }
  function d3_svg_symbolCircle(size) {
    var r = Math.sqrt(size / π);
    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
  }
  var d3_svg_symbols = d3.map({
    circle: d3_svg_symbolCircle,
    cross: function(size) {
      var r = Math.sqrt(size / 5) / 2;
      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
    },
    diamond: function(size) {
      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
    },
    square: function(size) {
      var r = Math.sqrt(size) / 2;
      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
    },
    "triangle-down": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
    },
    "triangle-up": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
    }
  });
  d3.svg.symbolTypes = d3_svg_symbols.keys();
  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
  d3_selectionPrototype.transition = function(name) {
    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
      time: Date.now(),
      ease: d3_ease_cubicInOut,
      delay: 0,
      duration: 250
    };
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_selectionPrototype.interrupt = function(name) {
    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
  };
  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
  function d3_selection_interruptNS(ns) {
    return function() {
      var lock, activeId, active;
      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
        active.timer.c = null;
        active.timer.t = NaN;
        if (--lock.count) delete lock[activeId]; else delete this[ns];
        lock.active += .5;
        active.event && active.event.interrupt.call(this, this.__data__, active.index);
      }
    };
  }
  function d3_transition(groups, ns, id) {
    d3_subclass(groups, d3_transitionPrototype);
    groups.namespace = ns;
    groups.id = id;
    return groups;
  }
  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
  d3_transitionPrototype.call = d3_selectionPrototype.call;
  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
  d3_transitionPrototype.node = d3_selectionPrototype.node;
  d3_transitionPrototype.size = d3_selectionPrototype.size;
  d3.transition = function(selection, name) {
    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
  };
  d3.transition.prototype = d3_transitionPrototype;
  d3_transitionPrototype.select = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
          if ("__data__" in node) subnode.__data__ = node.__data__;
          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
          subgroup.push(subnode);
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.selectAll = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          transition = node[ns][id];
          subnodes = selector.call(node, node.__data__, i, j);
          subgroups.push(subgroup = []);
          for (var k = -1, o = subnodes.length; ++k < o; ) {
            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
            subgroup.push(subnode);
          }
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_transition(subgroups, this.namespace, this.id);
  };
  d3_transitionPrototype.tween = function(name, tween) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
    return d3_selection_each(this, tween == null ? function(node) {
      node[ns][id].tween.remove(name);
    } : function(node) {
      node[ns][id].tween.set(name, tween);
    });
  };
  function d3_transition_tween(groups, name, value, tween) {
    var id = groups.id, ns = groups.namespace;
    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
    } : (value = tween(value), function(node) {
      node[ns][id].tween.set(name, value);
    }));
  }
  d3_transitionPrototype.attr = function(nameNS, value) {
    if (arguments.length < 2) {
      for (value in nameNS) this.attr(value, nameNS[value]);
      return this;
    }
    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrTween(b) {
      return b == null ? attrNull : (b += "", function() {
        var a = this.getAttribute(name), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttribute(name, i(t));
        });
      });
    }
    function attrTweenNS(b) {
      return b == null ? attrNullNS : (b += "", function() {
        var a = this.getAttributeNS(name.space, name.local), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttributeNS(name.space, name.local, i(t));
        });
      });
    }
    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.attrTween = function(nameNS, tween) {
    var name = d3.ns.qualify(nameNS);
    function attrTween(d, i) {
      var f = tween.call(this, d, i, this.getAttribute(name));
      return f && function(t) {
        this.setAttribute(name, f(t));
      };
    }
    function attrTweenNS(d, i) {
      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
      return f && function(t) {
        this.setAttributeNS(name.space, name.local, f(t));
      };
    }
    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.style(priority, name[priority], value);
        return this;
      }
      priority = "";
    }
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleString(b) {
      return b == null ? styleNull : (b += "", function() {
        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
        return a !== b && (i = d3_interpolate(a, b), function(t) {
          this.style.setProperty(name, i(t), priority);
        });
      });
    }
    return d3_transition_tween(this, "style." + name, value, styleString);
  };
  d3_transitionPrototype.styleTween = function(name, tween, priority) {
    if (arguments.length < 3) priority = "";
    function styleTween(d, i) {
      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
      return f && function(t) {
        this.style.setProperty(name, f(t), priority);
      };
    }
    return this.tween("style." + name, styleTween);
  };
  d3_transitionPrototype.text = function(value) {
    return d3_transition_tween(this, "text", value, d3_transition_text);
  };
  function d3_transition_text(b) {
    if (b == null) b = "";
    return function() {
      this.textContent = b;
    };
  }
  d3_transitionPrototype.remove = function() {
    var ns = this.namespace;
    return this.each("end.transition", function() {
      var p;
      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
    });
  };
  d3_transitionPrototype.ease = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].ease;
    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
    return d3_selection_each(this, function(node) {
      node[ns][id].ease = value;
    });
  };
  d3_transitionPrototype.delay = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].delay;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].delay = +value.call(node, node.__data__, i, j);
    } : (value = +value, function(node) {
      node[ns][id].delay = value;
    }));
  };
  d3_transitionPrototype.duration = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].duration;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
    } : (value = Math.max(1, value), function(node) {
      node[ns][id].duration = value;
    }));
  };
  d3_transitionPrototype.each = function(type, listener) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) {
      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
      try {
        d3_transitionInheritId = id;
        d3_selection_each(this, function(node, i, j) {
          d3_transitionInherit = node[ns][id];
          type.call(node, node.__data__, i, j);
        });
      } finally {
        d3_transitionInherit = inherit;
        d3_transitionInheritId = inheritId;
      }
    } else {
      d3_selection_each(this, function(node) {
        var transition = node[ns][id];
        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
      });
    }
    return this;
  };
  d3_transitionPrototype.transition = function() {
    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if (node = group[i]) {
          transition = node[ns][id0];
          d3_transitionNode(node, i, ns, id1, {
            time: transition.time,
            ease: transition.ease,
            delay: transition.delay + transition.duration,
            duration: transition.duration
          });
        }
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id1);
  };
  function d3_transitionNamespace(name) {
    return name == null ? "__transition__" : "__transition_" + name + "__";
  }
  function d3_transitionNode(node, i, ns, id, inherit) {
    var lock = node[ns] || (node[ns] = {
      active: 0,
      count: 0
    }), transition = lock[id], time, timer, duration, ease, tweens;
    function schedule(elapsed) {
      var delay = transition.delay;
      timer.t = delay + time;
      if (delay <= elapsed) return start(elapsed - delay);
      timer.c = start;
    }
    function start(elapsed) {
      var activeId = lock.active, active = lock[activeId];
      if (active) {
        active.timer.c = null;
        active.timer.t = NaN;
        --lock.count;
        delete lock[activeId];
        active.event && active.event.interrupt.call(node, node.__data__, active.index);
      }
      for (var cancelId in lock) {
        if (+cancelId < id) {
          var cancel = lock[cancelId];
          cancel.timer.c = null;
          cancel.timer.t = NaN;
          --lock.count;
          delete lock[cancelId];
        }
      }
      timer.c = tick;
      d3_timer(function() {
        if (timer.c && tick(elapsed || 1)) {
          timer.c = null;
          timer.t = NaN;
        }
        return 1;
      }, 0, time);
      lock.active = id;
      transition.event && transition.event.start.call(node, node.__data__, i);
      tweens = [];
      transition.tween.forEach(function(key, value) {
        if (value = value.call(node, node.__data__, i)) {
          tweens.push(value);
        }
      });
      ease = transition.ease;
      duration = transition.duration;
    }
    function tick(elapsed) {
      var t = elapsed / duration, e = ease(t), n = tweens.length;
      while (n > 0) {
        tweens[--n].call(node, e);
      }
      if (t >= 1) {
        transition.event && transition.event.end.call(node, node.__data__, i);
        if (--lock.count) delete lock[id]; else delete node[ns];
        return 1;
      }
    }
    if (!transition) {
      time = inherit.time;
      timer = d3_timer(schedule, 0, time);
      transition = lock[id] = {
        tween: new d3_Map(),
        time: time,
        timer: timer,
        delay: inherit.delay,
        duration: inherit.duration,
        ease: inherit.ease,
        index: i
      };
      inherit = null;
      ++lock.count;
    }
  }
  d3.svg.axis = function() {
    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
    function axis(g) {
      g.each(function() {
        var g = d3.select(this);
        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
        d3.transition(path));
        tickEnter.append("line");
        tickEnter.append("text");
        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
        if (orient === "bottom" || orient === "top") {
          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
        } else {
          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
        }
        lineEnter.attr(y2, sign * innerTickSize);
        textEnter.attr(y1, sign * tickSpacing);
        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
        if (scale1.rangeBand) {
          var x = scale1, dx = x.rangeBand() / 2;
          scale0 = scale1 = function(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, scale0);
        }
        tickEnter.call(tickTransform, scale0, scale1);
        tickUpdate.call(tickTransform, scale1, scale1);
      });
    }
    axis.scale = function(x) {
      if (!arguments.length) return scale;
      scale = x;
      return axis;
    };
    axis.orient = function(x) {
      if (!arguments.length) return orient;
      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
      return axis;
    };
    axis.ticks = function() {
      if (!arguments.length) return tickArguments_;
      tickArguments_ = d3_array(arguments);
      return axis;
    };
    axis.tickValues = function(x) {
      if (!arguments.length) return tickValues;
      tickValues = x;
      return axis;
    };
    axis.tickFormat = function(x) {
      if (!arguments.length) return tickFormat_;
      tickFormat_ = x;
      return axis;
    };
    axis.tickSize = function(x) {
      var n = arguments.length;
      if (!n) return innerTickSize;
      innerTickSize = +x;
      outerTickSize = +arguments[n - 1];
      return axis;
    };
    axis.innerTickSize = function(x) {
      if (!arguments.length) return innerTickSize;
      innerTickSize = +x;
      return axis;
    };
    axis.outerTickSize = function(x) {
      if (!arguments.length) return outerTickSize;
      outerTickSize = +x;
      return axis;
    };
    axis.tickPadding = function(x) {
      if (!arguments.length) return tickPadding;
      tickPadding = +x;
      return axis;
    };
    axis.tickSubdivide = function() {
      return arguments.length && axis;
    };
    return axis;
  };
  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  };
  function d3_svg_axisX(selection, x0, x1) {
    selection.attr("transform", function(d) {
      var v0 = x0(d);
      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
    });
  }
  function d3_svg_axisY(selection, y0, y1) {
    selection.attr("transform", function(d) {
      var v0 = y0(d);
      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
    });
  }
  d3.svg.brush = function() {
    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
    function brush(g) {
      g.each(function() {
        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
        var background = g.selectAll(".background").data([ 0 ]);
        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var resize = g.selectAll(".resize").data(resizes, d3_identity);
        resize.exit().remove();
        resize.enter().append("g").attr("class", function(d) {
          return "resize " + d;
        }).style("cursor", function(d) {
          return d3_svg_brushCursor[d];
        }).append("rect").attr("x", function(d) {
          return /[ew]$/.test(d) ? -3 : null;
        }).attr("y", function(d) {
          return /^[ns]/.test(d) ? -3 : null;
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
        resize.style("display", brush.empty() ? "none" : null);
        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
        if (x) {
          range = d3_scaleRange(x);
          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
          redrawX(gUpdate);
        }
        if (y) {
          range = d3_scaleRange(y);
          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
          redrawY(gUpdate);
        }
        redraw(gUpdate);
      });
    }
    brush.event = function(g) {
      g.each(function() {
        var event_ = event.of(this, arguments), extent1 = {
          x: xExtent,
          y: yExtent,
          i: xExtentDomain,
          j: yExtentDomain
        }, extent0 = this.__chart__ || extent1;
        this.__chart__ = extent1;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.brush", function() {
            xExtentDomain = extent0.i;
            yExtentDomain = extent0.j;
            xExtent = extent0.x;
            yExtent = extent0.y;
            event_({
              type: "brushstart"
            });
          }).tween("brush:brush", function() {
            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
            xExtentDomain = yExtentDomain = null;
            return function(t) {
              xExtent = extent1.x = xi(t);
              yExtent = extent1.y = yi(t);
              event_({
                type: "brush",
                mode: "resize"
              });
            };
          }).each("end.brush", function() {
            xExtentDomain = extent1.i;
            yExtentDomain = extent1.j;
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          });
        } else {
          event_({
            type: "brushstart"
          });
          event_({
            type: "brush",
            mode: "resize"
          });
          event_({
            type: "brushend"
          });
        }
      });
    };
    function redraw(g) {
      g.selectAll(".resize").attr("transform", function(d) {
        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
      });
    }
    function redrawX(g) {
      g.select(".extent").attr("x", xExtent[0]);
      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
    }
    function redrawY(g) {
      g.select(".extent").attr("y", yExtent[0]);
      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
    }
    function brushstart() {
      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
      if (d3.event.changedTouches) {
        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
      } else {
        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
      }
      g.interrupt().selectAll("*").interrupt();
      if (dragging) {
        origin[0] = xExtent[0] - origin[0];
        origin[1] = yExtent[0] - origin[1];
      } else if (resizing) {
        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
        origin[0] = xExtent[ex];
        origin[1] = yExtent[ey];
      } else if (d3.event.altKey) center = origin.slice();
      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
      d3.select("body").style("cursor", eventTarget.style("cursor"));
      event_({
        type: "brushstart"
      });
      brushmove();
      function keydown() {
        if (d3.event.keyCode == 32) {
          if (!dragging) {
            center = null;
            origin[0] -= xExtent[1];
            origin[1] -= yExtent[1];
            dragging = 2;
          }
          d3_eventPreventDefault();
        }
      }
      function keyup() {
        if (d3.event.keyCode == 32 && dragging == 2) {
          origin[0] += xExtent[1];
          origin[1] += yExtent[1];
          dragging = 0;
          d3_eventPreventDefault();
        }
      }
      function brushmove() {
        var point = d3.mouse(target), moved = false;
        if (offset) {
          point[0] += offset[0];
          point[1] += offset[1];
        }
        if (!dragging) {
          if (d3.event.altKey) {
            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
            origin[0] = xExtent[+(point[0] < center[0])];
            origin[1] = yExtent[+(point[1] < center[1])];
          } else center = null;
        }
        if (resizingX && move1(point, x, 0)) {
          redrawX(g);
          moved = true;
        }
        if (resizingY && move1(point, y, 1)) {
          redrawY(g);
          moved = true;
        }
        if (moved) {
          redraw(g);
          event_({
            type: "brush",
            mode: dragging ? "move" : "resize"
          });
        }
      }
      function move1(point, scale, i) {
        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
        if (dragging) {
          r0 -= position;
          r1 -= size + position;
        }
        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
        if (dragging) {
          max = (min += position) + size;
        } else {
          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
          if (position < min) {
            max = min;
            min = position;
          } else {
            max = position;
          }
        }
        if (extent[0] != min || extent[1] != max) {
          if (i) yExtentDomain = null; else xExtentDomain = null;
          extent[0] = min;
          extent[1] = max;
          return true;
        }
      }
      function brushend() {
        brushmove();
        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
        d3.select("body").style("cursor", null);
        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
        dragRestore();
        event_({
          type: "brushend"
        });
      }
    }
    brush.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.clamp = function(z) {
      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
      return brush;
    };
    brush.extent = function(z) {
      var x0, x1, y0, y1, t;
      if (!arguments.length) {
        if (x) {
          if (xExtentDomain) {
            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
          } else {
            x0 = xExtent[0], x1 = xExtent[1];
            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
          }
        }
        if (y) {
          if (yExtentDomain) {
            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
          } else {
            y0 = yExtent[0], y1 = yExtent[1];
            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
          }
        }
        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
      }
      if (x) {
        x0 = z[0], x1 = z[1];
        if (y) x0 = x0[0], x1 = x1[0];
        xExtentDomain = [ x0, x1 ];
        if (x.invert) x0 = x(x0), x1 = x(x1);
        if (x1 < x0) t = x0, x0 = x1, x1 = t;
        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
      }
      if (y) {
        y0 = z[0], y1 = z[1];
        if (x) y0 = y0[1], y1 = y1[1];
        yExtentDomain = [ y0, y1 ];
        if (y.invert) y0 = y(y0), y1 = y(y1);
        if (y1 < y0) t = y0, y0 = y1, y1 = t;
        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
      }
      return brush;
    };
    brush.clear = function() {
      if (!brush.empty()) {
        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
        xExtentDomain = yExtentDomain = null;
      }
      return brush;
    };
    brush.empty = function() {
      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
    };
    return d3.rebind(brush, event, "on");
  };
  var d3_svg_brushCursor = {
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  };
  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
  var d3_time_formatUtc = d3_time_format.utc;
  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
  function d3_time_formatIsoNative(date) {
    return date.toISOString();
  }
  d3_time_formatIsoNative.parse = function(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  };
  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
  d3_time.second = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 1e3) * 1e3);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
  }, function(date) {
    return date.getSeconds();
  });
  d3_time.seconds = d3_time.second.range;
  d3_time.seconds.utc = d3_time.second.utc.range;
  d3_time.minute = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 6e4) * 6e4);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
  }, function(date) {
    return date.getMinutes();
  });
  d3_time.minutes = d3_time.minute.range;
  d3_time.minutes.utc = d3_time.minute.utc.range;
  d3_time.hour = d3_time_interval(function(date) {
    var timezone = date.getTimezoneOffset() / 60;
    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
  }, function(date) {
    return date.getHours();
  });
  d3_time.hours = d3_time.hour.range;
  d3_time.hours.utc = d3_time.hour.utc.range;
  d3_time.month = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setDate(1);
    return date;
  }, function(date, offset) {
    date.setMonth(date.getMonth() + offset);
  }, function(date) {
    return date.getMonth();
  });
  d3_time.months = d3_time.month.range;
  d3_time.months.utc = d3_time.month.utc.range;
  function d3_time_scale(linear, methods, format) {
    function scale(x) {
      return linear(x);
    }
    scale.invert = function(x) {
      return d3_time_scaleDate(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
      linear.domain(x);
      return scale;
    };
    function tickMethod(extent, count) {
      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
        return d / 31536e6;
      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
    }
    scale.nice = function(interval, skip) {
      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
      if (method) interval = method[0], skip = method[1];
      function skipped(date) {
        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
      }
      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
        floor: function(date) {
          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
          return date;
        },
        ceil: function(date) {
          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
          return date;
        }
      } : interval));
    };
    scale.ticks = function(interval, skip) {
      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
        range: interval
      }, skip ];
      if (method) interval = method[0], skip = method[1];
      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
    };
    scale.tickFormat = function() {
      return format;
    };
    scale.copy = function() {
      return d3_time_scale(linear.copy(), methods, format);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_time_scaleDate(t) {
    return new Date(t);
  }
  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
    return d.getMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getMinutes();
  } ], [ "%I %p", function(d) {
    return d.getHours();
  } ], [ "%a %d", function(d) {
    return d.getDay() && d.getDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getDate() != 1;
  } ], [ "%B", function(d) {
    return d.getMonth();
  } ], [ "%Y", d3_true ] ]);
  var d3_time_scaleMilliseconds = {
    range: function(start, stop, step) {
      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
    },
    floor: d3_identity,
    ceil: d3_identity
  };
  d3_time_scaleLocalMethods.year = d3_time.year;
  d3_time.scale = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
  };
  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
    return [ m[0].utc, m[1] ];
  });
  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
    return d.getUTCMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getUTCSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getUTCMinutes();
  } ], [ "%I %p", function(d) {
    return d.getUTCHours();
  } ], [ "%a %d", function(d) {
    return d.getUTCDay() && d.getUTCDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getUTCDate() != 1;
  } ], [ "%B", function(d) {
    return d.getUTCMonth();
  } ], [ "%Y", d3_true ] ]);
  d3_time_scaleUtcMethods.year = d3_time.year.utc;
  d3_time.scale.utc = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
  };
  d3.text = d3_xhrType(function(request) {
    return request.responseText;
  });
  d3.json = function(url, callback) {
    return d3_xhr(url, "application/json", d3_json, callback);
  };
  function d3_json(request) {
    return JSON.parse(request.responseText);
  }
  d3.html = function(url, callback) {
    return d3_xhr(url, "text/html", d3_html, callback);
  };
  function d3_html(request) {
    var range = d3_document.createRange();
    range.selectNode(d3_document.body);
    return range.createContextualFragment(request.responseText);
  }
  d3.xml = d3_xhrType(function(request) {
    return request.responseXML;
  });
  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
}();

/***/ }),

/***/ "./node_modules/date-now/index.js":
/***/ (function(module, exports) {

module.exports = Date.now || now

function now() {
    return new Date().getTime()
}


/***/ }),

/***/ "./node_modules/debounce/index.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var now = __webpack_require__("./node_modules/date-now/index.js");

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

module.exports = function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = now() - timestamp;

    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
};


/***/ }),

/***/ "./node_modules/deep-bind-decorator/dist/deep-bind-decorator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

var _cloner = __webpack_require__("./node_modules/cloner/build/cloner.node.js");

var _traverse = __webpack_require__("./node_modules/traverse/index.js");

var _traverse2 = _interopRequireDefault(_traverse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateDecorator() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function deepBind(cls, name, desc) {
    if ((typeof cls === 'undefined' ? 'undefined' : (0, _typeof3.default)(cls)) === "object" && (typeof name === 'undefined' ? 'undefined' : (0, _typeof3.default)(name)) === "object" && ((typeof desc === 'undefined' ? 'undefined' : (0, _typeof3.default)(desc)) !== "object" || !desc.initializer)) {
      //isnt being used as a decorator! bind in object and context, then run initializer
      return generateDecorator({ obj: cls, context: name, opts: opts })().initializer();
    }

    if (desc && typeof desc.value === "function") {
      var bound = void 0;
      return {
        configurable: true,
        enumerable: desc.enumerable || true,
        get: function get() {
          if (bound) return bound;
          bound = desc.value.bind(this);
          return bound;
        }
      };
    }

    return {
      enumerable: true,
      writable: true,
      configurable: false,
      initializer: function initializer() {
        var context = opts.context || this;
        if (desc && typeof desc.value === "function") {
          debugger;
          cls;
          name;
          desc;
          self;
          return desc.value.bind(cls);
        }
        var src = opts.obj || desc.initializer.call(this);

        if ((typeof src === 'undefined' ? 'undefined' : (0, _typeof3.default)(src)) !== "object") throw new Error("must provide object to traverse");
        if ((typeof context === 'undefined' ? 'undefined' : (0, _typeof3.default)(context)) !== "object") throw new Error("must provide context to bind to");

        var clone = _cloner.deep.copy(src);
        (0, _traverse2.default)(clone).forEach(function (x) {
          var _this = this;

          var current = this;
          if (typeof x === "function" && opts.bindFunctions !== false) {
            this.update(x.bind(context), true);
          } else if (x && (typeof x === 'undefined' ? 'undefined' : (0, _typeof3.default)(x)) === "object") {
            var keys = (0, _keys2.default)(x);
            keys.forEach(function (key) {
              var descriptor = (0, _getOwnPropertyDescriptor2.default)(x, key);
              if (descriptor && (descriptor.set || descriptor.get)) {
                if (opts.bindProperties !== false) {
                  delete x[key];
                  (0, _defineProperty2.default)(x, key, (0, _assign2.default)(descriptor, {
                    get: descriptor.get && descriptor.get.bind(context),
                    set: descriptor.set && descriptor.set.bind(context),
                    enumerable: descriptor.hasOwnProperty("enumerable") ? descriptor.enumerable : true
                  }));
                }
                _this.keys.splice(_this.keys.indexOf(key), 1);
              }
            });
            this.update(x);
          }
        });

        return _cloner.deep.merge(src, clone);
      }
    };
  };
}

var deepBind = generateDecorator();
deepBind.onlyFunctions = generateDecorator({ bindProperties: false });
deepBind.onlyProperties = generateDecorator({ bindFunctions: false });

exports.default = deepBind;

/***/ }),

/***/ "./node_modules/deep-extend/lib/deep-extend.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * @description Recursive object extending
 * @author Viacheslav Lotsmanov <lotsmanov89@gmail.com>
 * @license MIT
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2013-2015 Viacheslav Lotsmanov
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



function isSpecificValue(val) {
	return (
		val instanceof Buffer
		|| val instanceof Date
		|| val instanceof RegExp
	) ? true : false;
}

function cloneSpecificValue(val) {
	if (val instanceof Buffer) {
		var x = new Buffer(val.length);
		val.copy(x);
		return x;
	} else if (val instanceof Date) {
		return new Date(val.getTime());
	} else if (val instanceof RegExp) {
		return new RegExp(val);
	} else {
		throw new Error('Unexpected situation');
	}
}

/**
 * Recursive cloning array.
 */
function deepCloneArray(arr) {
	var clone = [];
	arr.forEach(function (item, index) {
		if (typeof item === 'object' && item !== null) {
			if (Array.isArray(item)) {
				clone[index] = deepCloneArray(item);
			} else if (isSpecificValue(item)) {
				clone[index] = cloneSpecificValue(item);
			} else {
				clone[index] = deepExtend({}, item);
			}
		} else {
			clone[index] = item;
		}
	});
	return clone;
}

/**
 * Extening object that entered in first argument.
 *
 * Returns extended object or false if have no target object or incorrect type.
 *
 * If you wish to clone source object (without modify it), just use empty new
 * object as first argument, like this:
 *   deepExtend({}, yourObj_1, [yourObj_N]);
 */
var deepExtend = module.exports = function (/*obj_1, [obj_2], [obj_N]*/) {
	if (arguments.length < 1 || typeof arguments[0] !== 'object') {
		return false;
	}

	if (arguments.length < 2) {
		return arguments[0];
	}

	var target = arguments[0];

	// convert arguments to array and cut off target object
	var args = Array.prototype.slice.call(arguments, 1);

	var val, src, clone;

	args.forEach(function (obj) {
		// skip argument if isn't an object, is null, or is an array
		if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
			return;
		}

		Object.keys(obj).forEach(function (key) {
			src = target[key]; // source value
			val = obj[key]; // new value

			// recursion prevention
			if (val === target) {
				return;

			/**
			 * if new value isn't object then just overwrite by new value
			 * instead of extending.
			 */
			} else if (typeof val !== 'object' || val === null) {
				target[key] = val;
				return;

			// just clone arrays (and recursive clone objects inside)
			} else if (Array.isArray(val)) {
				target[key] = deepCloneArray(val);
				return;

			// custom cloning and overwrite for specific objects
			} else if (isSpecificValue(val)) {
				target[key] = cloneSpecificValue(val);
				return;

			// overwrite by new value if source isn't object or array
			} else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
				target[key] = deepExtend({}, val);
				return;

			// source value and new value is objects both, extending...
			} else {
				target[key] = deepExtend(src, val);
				return;
			}
		});
	});

	return target;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/extend-observable-decorator/dist/extend-observable-decorator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getOwnPropertyNames = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-names.js");

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

exports.default = extendObservableObj;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _cloner = __webpack_require__("./node_modules/cloner/build/cloner.node.js");

var _traverse = __webpack_require__("./node_modules/traverse/index.js");

var _traverse2 = _interopRequireDefault(_traverse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extendObservableObj(cls, name, desc) {
  return (0, _mobx.observable)(cls, name, {
    enumerable: true,
    writable: true,
    configurable: false,
    initializer: function initializer() {
      var _this = this;

      var src = desc.initializer.call(this);
      var target = (0, _mobx.toJS)(this[name]);
      //@TODO make recursive, this is only 1 layer deep.
      this[name].$mobx && (0, _getOwnPropertyNames2.default)(this[name]).forEach(function (k) {
        var prop = (0, _getOwnPropertyDescriptor2.default)(src, k);
        var hasGetSet = prop && (prop.get || prop.set);

        if (!hasGetSet && (0, _mobx.isObservable)(_this[name], k) && (0, _mobx.isComputed)(_this[name], k)) {
          (0, _defineProperty2.default)(target, k, {
            enumerable: true,
            get: _this[name].$mobx.values[k].derivation,
            set: _this[name].$mobx.values[k].setter
          });
        }
      });

      return _cloner.deep.merge(target, src);
    }
  });
}

/***/ }),

/***/ "./node_modules/ieee754/index.js":
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/invariant/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ "./node_modules/isarray/index.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/jquery/dist/jquery.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur as it's already being fired
		// in leverageNative.
		_default: function() {
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "./node_modules/lodash/_DataView.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "./node_modules/lodash/_Hash.js":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("./node_modules/lodash/_hashClear.js"),
    hashDelete = __webpack_require__("./node_modules/lodash/_hashDelete.js"),
    hashGet = __webpack_require__("./node_modules/lodash/_hashGet.js"),
    hashHas = __webpack_require__("./node_modules/lodash/_hashHas.js"),
    hashSet = __webpack_require__("./node_modules/lodash/_hashSet.js");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "./node_modules/lodash/_ListCache.js":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("./node_modules/lodash/_listCacheClear.js"),
    listCacheDelete = __webpack_require__("./node_modules/lodash/_listCacheDelete.js"),
    listCacheGet = __webpack_require__("./node_modules/lodash/_listCacheGet.js"),
    listCacheHas = __webpack_require__("./node_modules/lodash/_listCacheHas.js"),
    listCacheSet = __webpack_require__("./node_modules/lodash/_listCacheSet.js");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "./node_modules/lodash/_Map.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "./node_modules/lodash/_MapCache.js":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("./node_modules/lodash/_mapCacheClear.js"),
    mapCacheDelete = __webpack_require__("./node_modules/lodash/_mapCacheDelete.js"),
    mapCacheGet = __webpack_require__("./node_modules/lodash/_mapCacheGet.js"),
    mapCacheHas = __webpack_require__("./node_modules/lodash/_mapCacheHas.js"),
    mapCacheSet = __webpack_require__("./node_modules/lodash/_mapCacheSet.js");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "./node_modules/lodash/_Promise.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "./node_modules/lodash/_Set.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "./node_modules/lodash/_SetCache.js":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js"),
    setCacheAdd = __webpack_require__("./node_modules/lodash/_setCacheAdd.js"),
    setCacheHas = __webpack_require__("./node_modules/lodash/_setCacheHas.js");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "./node_modules/lodash/_Stack.js":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
    stackClear = __webpack_require__("./node_modules/lodash/_stackClear.js"),
    stackDelete = __webpack_require__("./node_modules/lodash/_stackDelete.js"),
    stackGet = __webpack_require__("./node_modules/lodash/_stackGet.js"),
    stackHas = __webpack_require__("./node_modules/lodash/_stackHas.js"),
    stackSet = __webpack_require__("./node_modules/lodash/_stackSet.js");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "./node_modules/lodash/_Uint8Array.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "./node_modules/lodash/_WeakMap.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
    root = __webpack_require__("./node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "./node_modules/lodash/_apply.js":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "./node_modules/lodash/_arrayFilter.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "./node_modules/lodash/_arrayLikeKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("./node_modules/lodash/_baseTimes.js"),
    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "./node_modules/lodash/_arrayMap.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "./node_modules/lodash/_arrayPush.js":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "./node_modules/lodash/_arraySome.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "./node_modules/lodash/_assocIndexOf.js":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("./node_modules/lodash/eq.js");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_baseEach.js":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("./node_modules/lodash/_baseForOwn.js"),
    createBaseEach = __webpack_require__("./node_modules/lodash/_createBaseEach.js");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "./node_modules/lodash/_baseFindIndex.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "./node_modules/lodash/_baseFlatten.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
    isFlattenable = __webpack_require__("./node_modules/lodash/_isFlattenable.js");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "./node_modules/lodash/_baseFor.js":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("./node_modules/lodash/_createBaseFor.js");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "./node_modules/lodash/_baseForOwn.js":
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__("./node_modules/lodash/_baseFor.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ "./node_modules/lodash/_baseGet.js":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "./node_modules/lodash/_baseGetAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "./node_modules/lodash/_baseHasIn.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "./node_modules/lodash/_baseIsArguments.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqual.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("./node_modules/lodash/_baseIsEqualDeep.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqualDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
    equalByTag = __webpack_require__("./node_modules/lodash/_equalByTag.js"),
    equalObjects = __webpack_require__("./node_modules/lodash/_equalObjects.js"),
    getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseIsMatch.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
    baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "./node_modules/lodash/_baseIsNative.js":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
    isMasked = __webpack_require__("./node_modules/lodash/_isMasked.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "./node_modules/lodash/_baseIsTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "./node_modules/lodash/_baseIteratee.js":
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__("./node_modules/lodash/_baseMatches.js"),
    baseMatchesProperty = __webpack_require__("./node_modules/lodash/_baseMatchesProperty.js"),
    identity = __webpack_require__("./node_modules/lodash/identity.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    property = __webpack_require__("./node_modules/lodash/property.js");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "./node_modules/lodash/_baseKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"),
    nativeKeys = __webpack_require__("./node_modules/lodash/_nativeKeys.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseMap.js":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ "./node_modules/lodash/_baseMatches.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("./node_modules/lodash/_baseIsMatch.js"),
    getMatchData = __webpack_require__("./node_modules/lodash/_getMatchData.js"),
    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "./node_modules/lodash/_baseMatchesProperty.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js"),
    get = __webpack_require__("./node_modules/lodash/get.js"),
    hasIn = __webpack_require__("./node_modules/lodash/hasIn.js"),
    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
    isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "./node_modules/lodash/_baseOrderBy.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
    baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    baseMap = __webpack_require__("./node_modules/lodash/_baseMap.js"),
    baseSortBy = __webpack_require__("./node_modules/lodash/_baseSortBy.js"),
    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
    compareMultiple = __webpack_require__("./node_modules/lodash/_compareMultiple.js"),
    identity = __webpack_require__("./node_modules/lodash/identity.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ "./node_modules/lodash/_baseProperty.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "./node_modules/lodash/_basePropertyDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseRest.js":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("./node_modules/lodash/identity.js"),
    overRest = __webpack_require__("./node_modules/lodash/_overRest.js"),
    setToString = __webpack_require__("./node_modules/lodash/_setToString.js");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "./node_modules/lodash/_baseSetToString.js":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("./node_modules/lodash/constant.js"),
    defineProperty = __webpack_require__("./node_modules/lodash/_defineProperty.js"),
    identity = __webpack_require__("./node_modules/lodash/identity.js");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "./node_modules/lodash/_baseSortBy.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ "./node_modules/lodash/_baseTimes.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "./node_modules/lodash/_baseToString.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "./node_modules/lodash/_baseTrim.js":
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__("./node_modules/lodash/_trimmedEndIndex.js");

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ "./node_modules/lodash/_baseUnary.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "./node_modules/lodash/_cacheHas.js":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "./node_modules/lodash/_castPath.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
    stringToPath = __webpack_require__("./node_modules/lodash/_stringToPath.js"),
    toString = __webpack_require__("./node_modules/lodash/toString.js");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "./node_modules/lodash/_compareAscending.js":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ "./node_modules/lodash/_compareMultiple.js":
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__("./node_modules/lodash/_compareAscending.js");

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ "./node_modules/lodash/_coreJsData.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "./node_modules/lodash/_createBaseEach.js":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "./node_modules/lodash/_createBaseFor.js":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "./node_modules/lodash/_createFind.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ "./node_modules/lodash/_defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "./node_modules/lodash/_equalArrays.js":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("./node_modules/lodash/_SetCache.js"),
    arraySome = __webpack_require__("./node_modules/lodash/_arraySome.js"),
    cacheHas = __webpack_require__("./node_modules/lodash/_cacheHas.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "./node_modules/lodash/_equalByTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    Uint8Array = __webpack_require__("./node_modules/lodash/_Uint8Array.js"),
    eq = __webpack_require__("./node_modules/lodash/eq.js"),
    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
    mapToArray = __webpack_require__("./node_modules/lodash/_mapToArray.js"),
    setToArray = __webpack_require__("./node_modules/lodash/_setToArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "./node_modules/lodash/_equalObjects.js":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("./node_modules/lodash/_getAllKeys.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/_getAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("./node_modules/lodash/_baseGetAllKeys.js"),
    getSymbols = __webpack_require__("./node_modules/lodash/_getSymbols.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_getMapData.js":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("./node_modules/lodash/_isKeyable.js");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "./node_modules/lodash/_getMatchData.js":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
    keys = __webpack_require__("./node_modules/lodash/keys.js");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "./node_modules/lodash/_getNative.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("./node_modules/lodash/_baseIsNative.js"),
    getValue = __webpack_require__("./node_modules/lodash/_getValue.js");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "./node_modules/lodash/_getSymbols.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("./node_modules/lodash/_arrayFilter.js"),
    stubArray = __webpack_require__("./node_modules/lodash/stubArray.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "./node_modules/lodash/_getTag.js":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("./node_modules/lodash/_DataView.js"),
    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
    Promise = __webpack_require__("./node_modules/lodash/_Promise.js"),
    Set = __webpack_require__("./node_modules/lodash/_Set.js"),
    WeakMap = __webpack_require__("./node_modules/lodash/_WeakMap.js"),
    baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "./node_modules/lodash/_getValue.js":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "./node_modules/lodash/_hasPath.js":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "./node_modules/lodash/_hashClear.js":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "./node_modules/lodash/_hashDelete.js":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "./node_modules/lodash/_hashGet.js":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "./node_modules/lodash/_hashHas.js":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "./node_modules/lodash/_hashSet.js":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "./node_modules/lodash/_isFlattenable.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("./node_modules/lodash/isArray.js");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "./node_modules/lodash/_isIndex.js":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "./node_modules/lodash/_isIterateeCall.js":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("./node_modules/lodash/eq.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "./node_modules/lodash/_isKey.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "./node_modules/lodash/_isKeyable.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "./node_modules/lodash/_isMasked.js":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("./node_modules/lodash/_coreJsData.js");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "./node_modules/lodash/_isPrototype.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "./node_modules/lodash/_isStrictComparable.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/lodash/isObject.js");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_listCacheClear.js":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_listCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_listCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_listCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_listCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheClear.js":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("./node_modules/lodash/_Hash.js"),
    ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__("./node_modules/lodash/_Map.js");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapToArray.js":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "./node_modules/lodash/_matchesStrictComparable.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_memoizeCapped.js":
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__("./node_modules/lodash/memoize.js");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ "./node_modules/lodash/_nativeCreate.js":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "./node_modules/lodash/_nativeKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "./node_modules/lodash/_nodeUtil.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "./node_modules/lodash/_overArg.js":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "./node_modules/lodash/_overRest.js":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("./node_modules/lodash/_apply.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "./node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "./node_modules/lodash/_setCacheAdd.js":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "./node_modules/lodash/_setCacheHas.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_setToArray.js":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "./node_modules/lodash/_setToString.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("./node_modules/lodash/_baseSetToString.js"),
    shortOut = __webpack_require__("./node_modules/lodash/_shortOut.js");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "./node_modules/lodash/_shortOut.js":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "./node_modules/lodash/_stackClear.js":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "./node_modules/lodash/_stackDelete.js":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "./node_modules/lodash/_stackGet.js":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "./node_modules/lodash/_stackHas.js":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "./node_modules/lodash/_stackSet.js":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
    MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "./node_modules/lodash/_stringToPath.js":
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__("./node_modules/lodash/_memoizeCapped.js");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "./node_modules/lodash/_toKey.js":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "./node_modules/lodash/_toSource.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "./node_modules/lodash/_trimmedEndIndex.js":
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ "./node_modules/lodash/constant.js":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "./node_modules/lodash/eq.js":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "./node_modules/lodash/find.js":
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__("./node_modules/lodash/_createFind.js"),
    findIndex = __webpack_require__("./node_modules/lodash/findIndex.js");

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ "./node_modules/lodash/findIndex.js":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("./node_modules/lodash/_baseFindIndex.js"),
    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
    toInteger = __webpack_require__("./node_modules/lodash/toInteger.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ "./node_modules/lodash/get.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "./node_modules/lodash/hasIn.js":
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__("./node_modules/lodash/_baseHasIn.js"),
    hasPath = __webpack_require__("./node_modules/lodash/_hasPath.js");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "./node_modules/lodash/identity.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "./node_modules/lodash/isArguments.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("./node_modules/lodash/_baseIsArguments.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "./node_modules/lodash/isArray.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "./node_modules/lodash/isArrayLike.js":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
    isLength = __webpack_require__("./node_modules/lodash/isLength.js");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "./node_modules/lodash/isBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("./node_modules/lodash/_root.js"),
    stubFalse = __webpack_require__("./node_modules/lodash/stubFalse.js");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/isFunction.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "./node_modules/lodash/isLength.js":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "./node_modules/lodash/isObject.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "./node_modules/lodash/isSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "./node_modules/lodash/isTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("./node_modules/lodash/_baseIsTypedArray.js"),
    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
    nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "./node_modules/lodash/keys.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("./node_modules/lodash/_arrayLikeKeys.js"),
    baseKeys = __webpack_require__("./node_modules/lodash/_baseKeys.js"),
    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "./node_modules/lodash/memoize.js":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ "./node_modules/lodash/property.js":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("./node_modules/lodash/_baseProperty.js"),
    basePropertyDeep = __webpack_require__("./node_modules/lodash/_basePropertyDeep.js"),
    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "./node_modules/lodash/sortBy.js":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("./node_modules/lodash/_baseFlatten.js"),
    baseOrderBy = __webpack_require__("./node_modules/lodash/_baseOrderBy.js"),
    baseRest = __webpack_require__("./node_modules/lodash/_baseRest.js"),
    isIterateeCall = __webpack_require__("./node_modules/lodash/_isIterateeCall.js");

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ "./node_modules/lodash/stubArray.js":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "./node_modules/lodash/stubFalse.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "./node_modules/lodash/toFinite.js":
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__("./node_modules/lodash/toNumber.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ "./node_modules/lodash/toInteger.js":
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__("./node_modules/lodash/toFinite.js");

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ "./node_modules/lodash/toNumber.js":
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__("./node_modules/lodash/_baseTrim.js"),
    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "./node_modules/lodash/toString.js":
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__("./node_modules/lodash/_baseToString.js");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "./node_modules/numeral/numeral.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules recursive ^\\.\\/[a-zA-Z0-9\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(dist|node_modules|tests)).*\\.(js|jsx|css|json)$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bypass-auth-strategy/component.js": "./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/component.js",
	"./bypass-auth-strategy/contentmodel.js": "./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/contentmodel.js",
	"./bypass-auth-strategy/index.js": "./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/index.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/platform-client-bootstrap/dist/core_modules recursive ^\\.\\/[a-zA-Z0-9\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(dist|node_modules|tests)).*\\.(js|jsx|css|json)$";

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/authoring-application/app.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _trcSimgate = __webpack_require__("./node_modules/trc-simgate/dist/trc.simgate.js");

var _trcSimgate2 = _interopRequireDefault(_trcSimgate);

var _trcAsyncTask = __webpack_require__("./node_modules/trc-async-task/dist/trc-async-task.js");

var _trcAsyncTask2 = _interopRequireDefault(_trcAsyncTask);

var _simgateContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simgate-contentmodel/index.js");

var _simgateContentmodel2 = _interopRequireDefault(_simgateContentmodel);

var _simgateDatamodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simgate-datamodel/index.js");

var _simgateDatamodel2 = _interopRequireDefault(_simgateDatamodel);

var _projectDomainStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/project-domain-store/index.js");

var _projectDomainStore2 = _interopRequireDefault(_projectDomainStore);

var _authoringModulesWebpackContext = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/authoring-modules-webpack-context/index.js");

var _authoringModulesWebpackContext2 = _interopRequireDefault(_authoringModulesWebpackContext);

var _projectEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/index.js");

var _systemEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/index.js");

var _configurationEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/index.js");

var _viewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/confirmation-modal/viewstore.js");

var _viewstore2 = _interopRequireDefault(_viewstore);

var _viewstore3 = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/ui-blocking-modal/viewstore.js");

var _viewstore4 = _interopRequireDefault(_viewstore3);

var _package = __webpack_require__("./package.json");

var _package2 = _interopRequireDefault(_package);

__webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/authoring-application/css/core.css");

__webpack_require__("./css/app.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

document.title = window.pageTitle || _package2.default.description || "The Regis Company - Authoring Tool";

var blockingModalState = new _viewstore4.default();
var modalViewStore = new _viewstore2.default({});

// global async task runner
var asyncTask = new _trcAsyncTask2.default({
  maximumParallel: 1,
  onFailure: function onFailure(err) {
    // @TODO how does simgate timeout work?
    if ((err instanceof Error && err.message.toLowerCase().indexOf("access denied")) > -1 || typeof err === "string" && err.toLowerCase().indexOf("access denied") > -1) {
      return console.log("bailed failure alert because this is access denied error, which indicates expired session");
    } else if ((err instanceof Error && err.message.toLowerCase().indexOf("code error")) > -1 || typeof err === "string" && err.toLowerCase().indexOf("code error") > -1) {
      modalViewStore.setModal({
        title: "Error",
        message: _react2.default.createElement(
          'div',
          null,
          'Please contact a developer, this functionality is broken.',
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'pre',
            { style: { fontSize: "8px" } },
            err.message
          )
        ),
        confirmLabel: 'Continue',
        confirmBtnClass: 'green'
      });
    } else {
      alert("Your request to the application has failed. Please wait 10 seconds and try again.");
    }
  },
  onRun: function onRun() {
    console.log("starting queue");
    // add wait screen
    blockingModalState.saveInProgress = true;
  },
  onDone: function onDone(err) {
    console.log("done with queue");
    // remove wait screen
    blockingModalState.saveInProgress = false;
  }
});

var simgate = window.simgate = new _trcSimgate2.default({
  debug: true,
  crossDomain: true,
  url: window.trcAppSettings && window.trcAppSettings.apiUrl || _package2.default.apiUrl || "http://platform.dev.regis-co.com/",
  trace: { limit: 50, updateData: true }
});

simgate.runTask = asyncTask.runTask.bind(asyncTask);

var Application = (_dec = _mobx.observable.ref, (_class = function () {
  function Application() {
    var _this = this;

    (0, _classCallCheck3.default)(this, Application);
    this.contentModel = new _simgateContentmodel2.default({
      simgate: simgate,
      webpackLoader: _authoringModulesWebpackContext2.default
    });
    this.dataModel = new _simgateDatamodel2.default({
      simgate: simgate
      // DO NOT ADD STORE HERE, will not respect mock override settings 
      // stores: [ProjectDomainStore]
      // onFail: () => alert(this.contentModel.projectContentStore["G:LoadFailed:G"])
    });
    this.blockingModalState = blockingModalState;
    this.modalViewStore = modalViewStore;

    _initDefineProp(this, 'isSettingUp', _descriptor, this);

    _initDefineProp(this, 'Configuration', _descriptor2, this);

    this.simDataModels = {};
    this.simgate = simgate;
    this.runTask = asyncTask.runTask.bind(asyncTask);

    this.dataModel.addStore(_projectDomainStore2.default);
    this.contentModel.entities.set("System", new _systemEntity.ContentModel());
    this.contentModel.loadEntities();

    (0, _mobx.when)(function () {
      return _this.contentModel.hasHydrated;
    }, function () {
      if (!(_this.Project = _this.contentModel.entities.get("Project_FlowEditor"))) {
        _this.Project = new _projectEntity.ContentModel({ id: "Project_FlowEditor", displayName: "Flow Editor" });
        _this.Project.saveEntity();
      }

      if (!(_this.Configuration = _this.contentModel.entities.get("Configuration"))) {
        _this.Configuration = new _configurationEntity.ContentModel({ id: "Configuration" }, _this);
        _this.Configuration.saveEntity();
      }

      var System = _this.contentModel.entities.get("System");

      window.viewEntities = function () {
        modalViewStore.setModal({
          title: "Entities",
          confirmLabel: 'Continue',
          confirmBtnClass: 'green check-a',
          message: _react2.default.createElement(
            'pre',
            { style: { fontSize: "8px", maxWidth: "500px" } },
            System.publishEntities({
              cm: _this.Configuration,
              path: "entities",
              outputToString: true
            })
          )
        });
      };

      window.importEntities = function () {
        modalViewStore.setModal({
          title: "Import Entities",
          confirmLabel: 'Continue',
          confirmBtnClass: 'green check-a',
          message: _react2.default.createElement('textarea', { className: 'import-entities-textarea' }),
          onConfirmFunc: function onConfirmFunc(e) {
            var confModalEl = e.target;
            while (confModalEl.className.indexOf("confirmation-modal") === -1) {
              confModalEl = confModalEl.parentNode;
            }var textarea = confModalEl.querySelector('textarea');
            var value = textarea.value;
            var parsed = void 0;
            try {
              parsed = JSON.parse(value);
            } catch (e) {
              modalViewStore.setModal({
                title: "Import Entities - Error",
                confirmLabel: 'Continue',
                confirmBtnClass: 'green check-a',
                message: e.message
              });
            }
            var ents = window.application.contentModel.hydrateEntities(parsed);
            var ids = [];
            var queue = 0;
            ents.forEach(function (ent) {
              queue++;
              ids.push(ent.id);
              ent.saveEntity(function () {
                return final(--queue);
              });
            });
            function final(queue) {
              if (!queue) {
                modalViewStore.setModal({
                  title: "Import Entities - Success",
                  confirmLabel: 'Continue',
                  confirmBtnClass: 'green check-a',
                  message: _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'div',
                      null,
                      'You have successfully imported these entities!'
                    ),
                    ids.map(function (id) {
                      return _react2.default.createElement(
                        'div',
                        null,
                        id
                      );
                    })
                  )
                });
              }
            }
          }
        });
      };

      // clear your routes, normally dont want to do this
      // this.Configuration.routes.clear();
      // this.Configuration.saveEntity();

      (0, _assign2.default)(System, {
        types: _this.contentModel.types["TypeContentModel"].allEntities(),
        configuration: _this.Configuration,
        project: _this.Project
      });

      (0, _mobx.when)(function () {
        return _this.Project.guid && _this.Configuration.guid;
      }, function () {
        var _Configuration$warnin = _this.Configuration.warning,
            noAdminRole = _Configuration$warnin.noAdminRole,
            noAdminRoute = _Configuration$warnin.noAdminRoute,
            duplicateRoutes = _Configuration$warnin.duplicateRoutes;
        var domainStore = _this.dataModel.domainStore;


        if (noAdminRoute || noAdminRole || duplicateRoutes) {
          _this.isSettingUp = true;
        } else if (_this.route) {
          (0, _mobx.when)(function () {
            return _this.role;
          }, function () {
            // set readOnlyAccessTypes for this role to readonly!       
            // @TODO make this pluggable per route content model
            // @TODO make this exposed to custom auth strat ??               
            if (_this.role.readOnlyAccessTypes && _this.role.readOnlyAccessTypes.length) {
              _this.role.readOnlyAccessTypes.forEach(function (type) {
                var ContentModel = _this.contentModel.types[type.id];
                ContentModel.readonly = true;
                ContentModel.allEntities().forEach(function (type2) {
                  return type2.readonly = true;
                });
              });
            }

            // if authStrategy has its own signOut, overwrite domainStore's signOut
            // and provide application as context
            if (_this.route.authStrategy && _this.route.authStrategy.signOut) {
              domainStore.signOut = function () {
                return _this.route.authStrategy.signOut.call(_this);
              };
            }
          });
        }
      });
    });
  }

  (0, _createClass3.default)(Application, [{
    key: 'route',
    get: function get() {
      if (!this.Configuration) return null;
      return this.Configuration.routes.find(function (r) {
        return r.urlmatch === window.location.search.substring(1);
      });
    }
  }, {
    key: 'role',
    get: function get() {
      var domainStore = this.dataModel.domainStore;

      if (!this.route || !domainStore.context.user.roleID) return null;
      return this.route.roles.find(function (role) {
        return role.roleId === domainStore.context.user.roleID;
      });
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var _this2 = this;

      var domainStore = this.dataModel.domainStore;
      var route = this.route,
          Configuration = this.Configuration;


      if (!Configuration) return {};

      var _Configuration$warnin2 = Configuration.warning,
          noAdminRole = _Configuration$warnin2.noAdminRole,
          noAdminRoute = _Configuration$warnin2.noAdminRoute,
          duplicateRoutes = _Configuration$warnin2.duplicateRoutes;


      if (!domainStore) throw new Error("missing domain store!");

      if (!noAdminRole && !noAdminRoute && !duplicateRoutes && this.isSettingUp) {
        return {
          "init-done": {
            id: "init-done",
            Component: function Component() {
              return _react2.default.createElement(
                'button',
                { onClick: function onClick(e) {
                    return window.location.reload();
                  } },
                'Reload'
              );
            }
          }
        };
      } else if ( /*(noAdminRole || noAdminRoute || duplicateRoutes) &&*/this.isSettingUp) {
        //@TODO why are project-layout and app separate now? merge them so can just leverage layout-component
        return {
          "init": {
            id: "init",
            contentModel: Configuration,
            options: {
              init: true
            }
          }
        };
      } else if (!route) {
        return {
          "badurl": {
            id: "badurl",
            Component: function Component() {
              return _react2.default.createElement(
                'div',
                null,
                'Bad url.'
              );
            }
          }
        };
      } else if (typeof route.authStrategy.done === "string" && eval(route.authStrategy.done) || (0, _mobx.isObservable)(route.authStrategy, "done") && !!route.authStrategy.done) {
        return route.destinations.reduce(function (acc, destination) {
          if (!destination || !destination.id) return acc;
          acc[destination.id] = {
            id: destination.id,
            contentModel: destination,
            displayTitle: destination.displayTitle || destination.displayName,
            application: _this2,
            show: true
          };
          return acc;
        }, {});
      } else {
        return {
          "auth": {
            id: "auth",
            contentModel: route.authStrategy,
            route: route,
            options: { auth: true }
          }
        };
      }
    }
  }]);
  return Application;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isSettingUp', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'Configuration', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'route', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'route'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'role', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'role'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype)), _class));
exports.default = Application;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(blockingModalState, 'blockingModalState', 'src/core_modules/authoring-application/app.js');

  __REACT_HOT_LOADER__.register(modalViewStore, 'modalViewStore', 'src/core_modules/authoring-application/app.js');

  __REACT_HOT_LOADER__.register(asyncTask, 'asyncTask', 'src/core_modules/authoring-application/app.js');

  __REACT_HOT_LOADER__.register(simgate, 'simgate', 'src/core_modules/authoring-application/app.js');

  __REACT_HOT_LOADER__.register(Application, 'Application', 'src/core_modules/authoring-application/app.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/authoring-application/css/core.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/authoring-application/project-layout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectLayout = exports.ProjectMenuBar = exports.ProjectLayoutViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");

var _values2 = _interopRequireDefault(_values);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _class2, _temp, _class3, _desc2, _value2, _class4, _descriptor2, _class6, _class7, _temp3;

// import DevTools,  { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from 'mobx-react-devtools';
// window.setLogEnabled = setLogEnabled;
// window.setUpdatesEnabled = setUpdatesEnabled;
// window.setGraphEnabled = setGraphEnabled;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _uiBlockingModal = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/ui-blocking-modal/index.js");

var _uiBlockingModal2 = _interopRequireDefault(_uiBlockingModal);

var _confirmationModal = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/confirmation-modal/index.js");

var _confirmationModal2 = _interopRequireDefault(_confirmationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var editorViewStore = new _simboxEditable.ViewStore({});

var ProjectLayoutViewStore = exports.ProjectLayoutViewStore = (_dec = _mobx.observable.ref, (_class = (_temp = _class2 = function (_mix$with) {
  (0, _inherits3.default)(ProjectLayoutViewStore, _mix$with);

  // do not need to track these
  function ProjectLayoutViewStore(props) {
    (0, _classCallCheck3.default)(this, ProjectLayoutViewStore);
    var application = props.application;

    if (!application) throw new Error("application is missing");

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectLayoutViewStore.__proto__ || (0, _getPrototypeOf2.default)(ProjectLayoutViewStore)).apply(this, arguments));

    _initDefineProp(_this, 'application', _descriptor, _this);

    _this.application = application;
    _this.props = (0, _assign2.default)({}, props, { editorViewStore: editorViewStore }); //cheating

    _this.dispose = (0, _mobx.reaction)(function () {
      return (0, _keys2.default)(_this.viewMap).join("");
    }, function () {
      var views = (0, _keys2.default)(_this.viewMap);
      if (views.length === 1) {
        // will force you to authStrategy destination
        if (_this._currentView !== views[0].id && _this._currentView !== views[0]) {
          _this.selectView(views[0]);
        }
      }
    }, { fireImmediately: true });
    return _this;
  }

  (0, _createClass3.default)(ProjectLayoutViewStore, [{
    key: 'viewMap',
    get: function get() {
      if (!this.application) return {};
      return this.application.viewMap;
    }
  }, {
    key: 'showMenuBar',
    get: function get() {
      //overrides ViewControllerMixin showMenuBar
      return this.viewMap && (0, _keys2.default)(this.viewMap).length > 1;
    }
  }, {
    key: 'inEditingMode',
    get: function get() {
      var _props = this.props,
          application = _props.application,
          _props$application = _props.application,
          route = _props$application.route,
          domainStore = _props$application.dataModel.domainStore;

      //return (window.trcAppSettings && window.trcAppSettings.environment === "dev") 

      return application.isSettingUp // initializing environment
      || !!route && route.authStrategy && route.authStrategy.done && domainStore.context.user.roleID !== 2 //not a participant
      ;
    }
  }]);
  return ProjectLayoutViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), _class2.trackBreadcrumbs = false, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'application', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showMenuBar', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'showMenuBar'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'inEditingMode', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'inEditingMode'), _class.prototype)), _class));

var ProjectMenuBar = exports.ProjectMenuBar = (0, _mobxReact.observer)(_class3 = (_class4 = function (_BaseComponent) {
  (0, _inherits3.default)(ProjectMenuBar, _BaseComponent);

  function ProjectMenuBar() {
    var _ref;

    var _temp2, _this2, _ret;

    (0, _classCallCheck3.default)(this, ProjectMenuBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = ProjectMenuBar.__proto__ || (0, _getPrototypeOf2.default)(ProjectMenuBar)).call.apply(_ref, [this].concat(args))), _this2), _initDefineProp(_this2, 'menuOpen', _descriptor2, _this2), _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(ProjectMenuBar, [{
    key: 'toggleMenu',
    value: function toggleMenu(event) {
      this.menuOpen = !this.menuOpen;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          viewMap = _props2.viewMap,
          clickItem = _props2.clickItem,
          currentViewId = _props2.currentViewId,
          signOut = _props2.signOut,
          userInfo = _props2.userInfo;

      var displayItems = (0, _values2.default)(viewMap).filter(function (v) {
        return v.show || v.menu && v.menu.show;
      });
      return _react2.default.createElement(
        'div',
        { className: this.menuOpen === true ? 'menu' : 'menu closed' },
        _react2.default.createElement('div', { className: this.menuOpen === true ? 'menu-toggle hidden' : 'menu-toggle', title: 'Open Menu', onClick: function onClick() {
            return _this3.toggleMenu();
          } }),
        _react2.default.createElement(
          'header',
          { className: 'header' },
          _react2.default.createElement('img', { src: 'assets/images/trc-logo-inverted.svg' }),
          _react2.default.createElement('div', { className: 'hide-menu', onClick: function onClick() {
              return _this3.toggleMenu();
            }, title: 'Close Menu' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'session-details' },
          !!userInfo && _react2.default.createElement(
            'div',
            { className: 'session' },
            _react2.default.createElement(
              'span',
              { className: 'label' },
              'User:'
            ),
            _react2.default.createElement(
              'span',
              { className: 'user' },
              userInfo.firstName && userInfo.lastName ? userInfo.lastName + ", " + userInfo.firstName : userInfo.loginName
            )
          ),
          !!signOut && _react2.default.createElement(
            'div',
            { className: 'actions' },
            _react2.default.createElement(
              'div',
              { className: 'action', onClick: function onClick(e) {
                  return signOut();
                } },
              'Logout'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'menu-items' },
          displayItems.map(function (view, index) {
            var iconClass = view.icon || view.contentModel && view.contentModel.icon || "";
            var menu = (0, _assign2.default)({ clickItem: clickItem }, view, view.menu);
            return _react2.default.createElement(
              'span',
              { key: "" + menu.id + index, className: menu.id === currentViewId ? "active" : "inactive" },
              _react2.default.createElement(
                'button',
                { className: "menu-item " + iconClass, onClick: function onClick(e) {
                    return !!menu.clickItem && menu.clickItem(view, viewMap);
                  }, disabled: menu.hasOwnProperty('enabled') ? !menu.enabled : false },
                menu.displayName,
                menu.displayTitle || menu.displayName || menu.id
              )
            );
          })
        )
      );
    }
  }]);
  return ProjectMenuBar;
}(_baseComponent2.default), (_descriptor2 = _applyDecoratedDescriptor(_class4.prototype, 'menuOpen', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class4.prototype, 'toggleMenu', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, 'toggleMenu'), _class4.prototype)), _class4)) || _class3;

var ProjectLayout = exports.ProjectLayout = (0, _mobxReact.observer)(_class6 = (0, _autoclassDecorator2.default)(_class6 = (_temp3 = _class7 = function (_BaseComponent2) {
  (0, _inherits3.default)(ProjectLayout, _BaseComponent2);

  function ProjectLayout() {
    (0, _classCallCheck3.default)(this, ProjectLayout);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectLayout.__proto__ || (0, _getPrototypeOf2.default)(ProjectLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectLayout, [{
    key: 'render',
    value: function render() {
      var _viewStore = this.viewStore,
          SelectedView = _viewStore.SelectedView,
          currentView = _viewStore.currentView,
          selectView = _viewStore.selectView,
          showMenuBar = _viewStore.showMenuBar,
          inEditingMode = _viewStore.inEditingMode,
          _props3 = this.props,
          application = _props3.application,
          _props3$application = _props3.application,
          dataModel = _props3$application.dataModel,
          domainStore = _props3$application.dataModel.domainStore,
          viewMap = _props3$application.viewMap,
          route = _props3$application.route,
          blockingModalState = _props3$application.blockingModalState,
          modalViewStore = _props3$application.modalViewStore;


      var viewKey = currentView && (currentView.type || currentView.contentModel && currentView.contentModel.type || currentView.id);

      // editorViewStore is "provided" so that is available to be injected into components via the "editable" decorator
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_uiBlockingModal2.default, { devMode: false, appState: blockingModalState }),
        _react2.default.createElement(_confirmationModal2.default, { viewStore: modalViewStore }),
        typeof DevTools !== "undefined" && _react2.default.createElement(DevTools, null),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            _mobxReact.Provider,
            { editorViewStore: inEditingMode && editorViewStore, dataModel: dataModel, application: application, modalViewStore: modalViewStore },
            _react2.default.createElement(
              'div',
              { className: 'columns' },
              showMenuBar && _react2.default.createElement(ProjectMenuBar, { viewMap: viewMap, clickItem: selectView, currentViewId: currentView && currentView.id, signOut: dataModel.domainStore.signOut, userInfo: dataModel.domainStore.context.user }),
              SelectedView && _react2.default.createElement(
                'div',
                { className: "middle " + viewKey },
                _react2.default.createElement(SelectedView, null)
              ),
              SelectedView && _react2.default.createElement(_simboxEditable.Component, { viewStore: editorViewStore })
            )
          )
        ),
        _react2.default.createElement('footer', { className: 'footer' })
      );
    }
  }]);
  return ProjectLayout;
}(_baseComponent2.default), _class7.ViewStore = ProjectLayoutViewStore, _temp3)) || _class6) || _class6;

var _default = ProjectLayout;
exports.default = _default;

//          <div className="trc-logo"></div>

;

var _temp4 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(editorViewStore, 'editorViewStore', 'src/core_modules/authoring-application/project-layout.js');

  __REACT_HOT_LOADER__.register(ProjectLayoutViewStore, 'ProjectLayoutViewStore', 'src/core_modules/authoring-application/project-layout.js');

  __REACT_HOT_LOADER__.register(ProjectMenuBar, 'ProjectMenuBar', 'src/core_modules/authoring-application/project-layout.js');

  __REACT_HOT_LOADER__.register(ProjectLayout, 'ProjectLayout', 'src/core_modules/authoring-application/project-layout.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/authoring-application/project-layout.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/authoring-modules-webpack-context/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

exports.default = webpackContext;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = ["-activity", "-auth-strategy", "-shell", "-entity"];

// this is annoying, but webpack doesnt allow new RegExp(" ... "), must be in slashes...
var moduleContexts = {
  appModules: __webpack_require__("./app_modules recursive ^\\.\\/[a-zA-Z0-9_\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(dist|node_modules|tests)).*\\.(js|jsx|css|json)$"),
  entityModules: __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules recursive ^\\.\\/[a-zA-Z0-9\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(dist|node_modules|tests)).*\\.(js|jsx|css|json)$"),
  coreModules: __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules recursive ^\\.\\/[a-zA-Z0-9\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(dist|node_modules|tests)).*\\.(js|jsx|css|json)$"),
  nodeModules: __webpack_require__("./node_modules recursive ^\\.\\/[a-zA-Z0-9\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(src|node_modules|tests)).*\\.(js|jsx|css|json)$")
};

function webpackContext(module) {
  var loadMain = module.indexOf("/") === -1;
  var path = "./" + module;
  if (loadMain) path += "/";
  var result = void 0;
  var lastError = void 0;
  var success = (0, _keys2.default)(moduleContexts).some(function (k) {
    var context = moduleContexts[k];
    try {
      if (loadMain) {
        var packageJson = void 0;
        try {
          packageJson = context(path + "package.json");
        } catch (e) {}
        return k === "nodeModules" ? !!(result = context(path + (packageJson ? packageJson.main : "index.js"))) : !!(result = context(path + (packageJson ? packageJson.module || packageJson.main : "index.js")));
      } else {
        return !!(result = context(path));
      }
    } catch (e) {
      if (e.message.toLowerCase().indexOf("cannot find module") === -1) lastError = e;
    }
  });

  if (!success && lastError) throw lastError;

  return result;
}

// memo-ize this
webpackContext._keys = [];

webpackContext.keys = function () {
  var contextType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  if (contextType && contextType.charAt(0) !== "-") contextType = "-" + contextType;
  if (contextType && contextTypes.indexOf(contextType) === -1) throw new Error("incorrect context type:" + contextType);

  if (!webpackContext._keys.length) {
    (0, _keys2.default)(moduleContexts).forEach(function (k) {
      moduleContexts[k].keys().forEach(function (path) {
        var sanitizedPath = path.replace(/\.\/|\/.*$/g, "");
        if (webpackContext._keys.indexOf(sanitizedPath) === -1) webpackContext._keys.push(sanitizedPath);
      });
    });
  }

  return contextType ? webpackContext._keys.filter(function (k) {
    return k.endsWith(contextType);
  }) : webpackContext._keys;
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(contextTypes, "contextTypes", "src/core_modules/authoring-modules-webpack-context/index.js");

  __REACT_HOT_LOADER__.register(moduleContexts, "moduleContexts", "src/core_modules/authoring-modules-webpack-context/index.js");

  __REACT_HOT_LOADER__.register(webpackContext, "webpackContext", "src/core_modules/authoring-modules-webpack-context/index.js");
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = autoclass;

var _react = __webpack_require__("./node_modules/react/react.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var done = {};

function autoclass(componentClass) {
  var packageName = void 0;

  if (module && module.parents && module.parents.length) {
    var parent = module.parents[module.parents.length - 1];
    var parentPath = parent;
    var parentPaths = parentPath.split("/");

    var _modulesIndex = void 0;
    parentPaths.forEach(function (path, index) {
      if (path.indexOf("_modules") > -1) _modulesIndex = index;
    });
    packageName = _modulesIndex > -1 ? parentPaths[_modulesIndex + 1] : parentPaths[parentPaths.length - 1].replace(".js", "");
  }

  var componentName = componentClass.displayName || componentClass.name;
  var prefix = packageName && !done[packageName] ? packageName + " " + componentName : componentName;

  if (packageName) {
    done[packageName] = true;
  }

  var DecoratedComponent = function (_componentClass) {
    (0, _inherits3.default)(DecoratedComponent, _componentClass);

    function DecoratedComponent() {
      (0, _classCallCheck3.default)(this, DecoratedComponent);
      return (0, _possibleConstructorReturn3.default)(this, (DecoratedComponent.__proto__ || (0, _getPrototypeOf2.default)(DecoratedComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(DecoratedComponent, [{
      key: "render",
      value: function render() {
        var element = (0, _get3.default)(DecoratedComponent.prototype.__proto__ || (0, _getPrototypeOf2.default)(DecoratedComponent.prototype), "render", this).call(this);
        if (!element) return element;
        var changes = {
          className: ((prefix || '') + " " + (element.type && element.type.name || '') + " " + (element.props.className || '')).trim()
        };
        return (0, _keys2.default)(changes).length === 0 ? element : (0, _react.cloneElement)(element, changes, element.props.children);
      }
    }]);
    return DecoratedComponent;
  }(componentClass);

  // for some reason losing statics
  (0, _keys2.default)(componentClass).forEach(function (k) {
    return !DecoratedComponent.hasOwnProperty(k) && (DecoratedComponent[k] = componentClass[k]);
  });

  // Add `className` propType, if none exists
  DecoratedComponent.propTypes = (0, _extends3.default)({ className: _react.PropTypes.string }, componentClass.propTypes);

  return DecoratedComponent;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(done, "done", "src/core_modules/autoclass-decorator/index.js");

  __REACT_HOT_LOADER__.register(autoclass, "autoclass", "src/core_modules/autoclass-decorator/index.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseComponent = function (_React$Component) {
  (0, _inherits3.default)(BaseComponent, _React$Component);

  function BaseComponent(props) {
    var _this$constructor;

    (0, _classCallCheck3.default)(this, BaseComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BaseComponent.__proto__ || (0, _getPrototypeOf2.default)(BaseComponent)).apply(this, arguments));

    _this.constructor.setUpMock && _this.constructor.setUpMock(_this);

    // absorb statics from viewstore
    if (_this.props.viewStore) {
      (0, _keys2.default)(_this.props.viewStore.constructor).forEach(function (k) {
        return !_this.constructor.hasOwnProperty[k] && (_this.constructor[k] = _this.props.viewStore.constructor[k]);
      });
    } else if (_this.constructor.ViewStore) {
      (0, _keys2.default)(_this.constructor.ViewStore).forEach(function (k) {
        return !_this.constructor.hasOwnProperty[k] && (_this.constructor[k] = _this.constructor.ViewStore[k]);
      });
    }

    // check deps
    (_this$constructor = _this.constructor).checkDependencies.apply(_this$constructor, arguments);

    // attach viewstore
    if (_this.props.viewStore) {
      _this.viewStore = _this.props.viewStore;
    } else if (_this.constructor.ViewStore) {
      _this.viewStore = new (Function.prototype.bind.apply(_this.constructor.ViewStore, [null].concat(Array.prototype.slice.call(arguments))))();
    }

    return _this;
  }

  (0, _createClass3.default)(BaseComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof this.dispose === "function") this.dispose();else if (Array.isArray(this.dispose)) this.dispose.forEach(function (dis) {
        return dis();
      });

      //if passing viewStore to children, do not want it disposing!
      if (this.viewStore === this.props.viewStore) return;

      if (this.viewStore && typeof this.viewStore.dispose === "function") this.viewStore.dispose();else if (this.viewStore && Array.isArray(this.viewStore.dispose)) this.viewStore.dispose.forEach(function (dis) {
        return dis();
      });
    }
  }], [{
    key: "checkDependencies",
    value: function checkDependencies(props) {
      // in this context, this === class's constructor, so all of the below would be found as "static" items
      var dependencies = this.dependencies,
          validateDeps = this.validateDeps;
      var stores = props.stores;


      stores && dependencies && validateDeps(stores, dependencies);
    }
  }, {
    key: "validateDeps",
    value: function validateDeps(stores, depList) {
      if (Array.isArray(depList)) {
        depList.forEach(function (d) {
          if (!stores[d]) {
            throw new Error("missing dependency: " + d);
          }
        });
      } else if ((typeof depList === "undefined" ? "undefined" : (0, _typeof3.default)(depList)) === "object") {
        (0, _keys2.default)(depList).forEach(function (d) {
          if (typeof depList[d] === "function" && !(stores[d] instanceof depList[d])) {
            throw new Error("type mismatch: " + d);
          }
        });
      }
    }
  }]);
  return BaseComponent;
}(_react2.default.Component);

exports.default = BaseComponent;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BaseComponent, "BaseComponent", "src/core_modules/base-component/index.js");
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.extendObservableObj = exports.deepBind = undefined;

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__("./node_modules/babel-runtime/core-js/json/stringify.js");

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty4 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

var _set = __webpack_require__("./node_modules/babel-runtime/core-js/set.js");

var _set2 = _interopRequireDefault(_set);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _class2, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _deepExtend = __webpack_require__("./node_modules/deep-extend/lib/deep-extend.js");

var _deepExtend2 = _interopRequireDefault(_deepExtend);

var _deepBindDecorator = __webpack_require__("./node_modules/deep-bind-decorator/dist/deep-bind-decorator.js");

var _deepBindDecorator2 = _interopRequireDefault(_deepBindDecorator);

var _extendObservableDecorator = __webpack_require__("./node_modules/extend-observable-decorator/dist/extend-observable-decorator.js");

var _extendObservableDecorator2 = _interopRequireDefault(_extendObservableDecorator);

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty3.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// import CollectionGridEditor from 'collection-grid-editor';

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

var deepBind = exports.deepBind = _deepBindDecorator2.default;
var extendObservableObj = exports.extendObservableObj = _extendObservableDecorator2.default;

var BaseContentModel = (_dec = _mobx.action.bound, _dec2 = _mobx.observable.ref, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, _dec12 = _mobx.action.bound, _dec13 = _mobx.action.bound, _dec14 = _mobx.action.bound, _dec15 = _mobx.action.bound, _dec16 = _mobx.action.bound, (_class = (_temp = _class2 = function () {
  (0, _createClass3.default)(BaseContentModel, null, [{
    key: 'allEntities',

    // get all entities of this type
    value: function allEntities() {
      var _this = this;

      if (!this.$parent) throw new Error("$parent not attached.  this method is unavailable");
      // if allEntities is run from BaseContentModel ALL entities are returned
      return this === BaseContentModel ? this.$parent.entities.values() : this.$parent.entities.values().filter(function (ent) {
        return ent instanceof _this;
      });
    } // reference to parent contentModel, mainly to access the dictionary of all entities

  }]);

  // default editor
  function BaseContentModel() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _this2 = this;

    var app = arguments[1];
    var type = arguments[2];
    (0, _classCallCheck3.default)(this, BaseContentModel);
    this.Editor = _simboxEditable.DefaultEditor;
    this.type = null;
    this.shouldAutoPopulate = false;

    _initDefineProp(this, 'hasBrokenRefs', _descriptor, this);

    _initDefineProp(this, 'guid', _descriptor2, this);

    _initDefineProp(this, 'id', _descriptor3, this);

    _initDefineProp(this, '$inputStore', _descriptor4, this);

    _initDefineProp(this, 'willSave', _descriptor5, this);

    _initDefineProp(this, 'hasSaved', _descriptor6, this);

    _initDefineProp(this, 'willLoad', _descriptor7, this);

    _initDefineProp(this, 'hasLoaded', _descriptor8, this);

    _initDefineProp(this, '_cache', _descriptor9, this);

    this.type = type || json.type || this.constructor.name; //gets saved to simbox "tag"
    if (!this.type || this.type.charAt(0) === "_") throw new Error("please supply content model type! (classname) ");

    // a little bit of a hack, but only way to access unknown Editor on child classes
    new Promise(function(resolve) { resolve(); }).then((function () {
      if (!_this2.FullEditor) {
        if ((0, _keys2.default)(_this2.slots).some(function (k) {
          return Array.isArray(_this2.slots[k]);
        })) {
          _this2.FullEditor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/collection-grid-editor/index.js").default;
        } else {
          _this2.FullEditor = _this2.Editor;
        }
      }
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

    // @TODO USE GUIDS?
    this.id = json.id || this.constructor.id;
    delete json.id;

    if (this.savable === false || this.saveable === false || this.readonly) this.guid = "fake-id";

    // @TODO remove this
    delete json.isNew;

    (0, _assign2.default)(this, json);

    if (this.isNew) {
      if (this.shouldAutoPopulate) this.autoPopulate();
      if (this.addImmediately && !this.$parent.entities.get(this.id)) this.$parent.entities.set(this.id, this);
      this.constructor.newEntityWasAdded.set(+new Date());
    }

    setTimeout(function () {
      _this2._updateCache();
    }, 10);
  }

  (0, _createClass3.default)(BaseContentModel, [{
    key: '_updateCache',
    value: function _updateCache() {
      this._cache = this._serialized;
    }
  }, {
    key: 'getAllChildEntitiesFiltered',


    // fn takes childCm, parentCm, slotName 

    value: function getAllChildEntitiesFiltered(fn) {
      var _this3 = this;

      fn = fn || function () {
        return true;
      };
      var entities = new _set2.default();
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this3.slots[name]) ? _this3.slots[name][0] : _this3.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this3[name];
          if (value == null || typeof value === "string") return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            value.forEach(function (cm) {
              if (cm == null || typeof cm === "string" || fn(cm, _this3, name) === false) return acc;
              acc.add(cm);
              var moreChildren = cm.getAllChildEntitiesFiltered(fn);
              if (!moreChildren) debugger;
              moreChildren.forEach(function (child) {
                return acc.add(child);
              });
            });
          } else {
            // if(typeof value === "string")
            if (fn(value, _this3, name) === false) return acc;
            acc.add(value);
            var moreChildren = value.getAllChildEntitiesFiltered(fn);
            moreChildren.forEach(function (child) {
              return acc.add(child);
            });
          }
        }
        return acc;
      }, entities);
      return (0, _from2.default)(entities);
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (opts.forceBasicEditor) return this.Editor || _simboxEditable.DefaultEditor;
      // if getComponent is called with forceFullEditor, the FullEditor is loaded
      if (opts.forceFullEditor) return this.FullEditor || this.Component;
      // else the  Component is loaded first
      return this.Component || this.FullEditor;
    }
  }, {
    key: 'getContentModel',
    value: function getContentModel() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this;
    }
  }, {
    key: 'revert',
    value: function revert() {
      if (this.readonly) return;
      var reverted = void 0;
      try {
        reverted = JSON.parse(this._cache);
      } catch (e) {}
      reverted && this.populate(reverted);
    }
  }, {
    key: 'populate',
    value: function populate(json) {
      var _this4 = this;

      (0, _assign2.default)(this, json);
      var cm = this;
      (0, _keys2.default)(cm).forEach(function (k) {
        var slot = cm.slots[k];
        if (!slot || cm[k] == null || cm[k] instanceof BaseContentModel) return;
        if (cm[k].constructor && cm[k].constructor.name === "ObservableArray" && Array.isArray(slot)) {
          var spliceMe = [];
          cm[k].forEach(function (cmName, index) {
            if (cm[k][index] instanceof BaseContentModel) return;
            cm[k][index] = _this4.$parent.entities.get(cmName);
            if (cm[k][index] == null) {
              console.warn(cm.id + " has a broken reference in the " + k + " slot (" + cmName + " is missing from the system).  Saving of this entity will be disabled.");
              //@TODO figure out what to do with broken refs
              //cm.hasBrokenRefs = true;
              spliceMe.push(index);
            }
          });
          spliceMe.forEach(function (i, index) {
            return cm[k].splice(i - index, 1);
          });
        } else if (slot === BaseContentModel || slot.prototype instanceof BaseContentModel) {
          var ref = _this4.$parent.entities.get(cm[k]);
          if (!ref) {
            console.warn(cm.id + " has a broken reference in the " + k + " slot (" + cm[k] + " is missing from the system).  Saving of this entity will be disabled.");
            //@TODO figure out what to do with broken refs
            //cm.hasBrokenRefs = true;
          } else {
            cm[k] = ref;
          }
        }
      });
      this._updateCache();
    }
  }, {
    key: 'updateValue',
    value: function updateValue(prop, val) {
      if (this.isNew && prop === "id") {
        this.id = val;
        return;
      }
      if (!this.slots.hasOwnProperty(prop)) throw new Error("not editable property" + prop);
      var slot = this.slots[prop];
      if (Array.isArray(slot)) {
        // trying to write over an array
        throw new Error("do not update array directly... clear or push etc");
      } else if (slot && slot.prototype && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel) && !val) {
        // slot is a contentmodel and val is null
        this[prop] = null;
      } else if (slot && slot.prototype && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel) && typeof val === "string") {
        // slot is a contentmodel and string is name of a contentmodel
        var newContentModel = this.$parent.entities.get(val);
        if (!newContentModel) throw new Error("content model does not exist: " + val);
        this[prop] = newContentModel;
      } else if (slot === val.constructor) {
        // slot and val are of same contentmodel type
        this[prop] = val;
      } else if ((slot === BaseContentModel || slot.prototype instanceof BaseContentModel) && val.constructor.prototype instanceof BaseContentModel) {
        // slot is "any", and val is a contentmodel
        this[prop] = val;
      } else if (slot === "" || slot === "RichText" || slot === 0 || typeof slot === "boolean") {
        // slot is of a primitive type, or RichText
        this[prop] = val;
      } else {
        // say what?
        throw new Error("error with slot type" + prop);
      }
    }

    // content models should not handle user input

  }, {
    key: 'updateInput',
    value: function updateInput(prop, val) {
      console.warn("this method is soon to be deprecated");
      if (!this[prop].hasOwnProperty("value")) throw new Error("missing value property: " + prop);
      this[prop].value = val;
    }

    // we do not want people coming up with their own variable names

  }, {
    key: 'updateInputVariable',
    value: function updateInputVariable(prop, val) {
      console.warn("this method is soon to be deprecated");
      if (!this[prop].hasOwnProperty("variable")) throw new Error("missing variable property: " + prop);
      this[prop].variable = val;
    }
  }, {
    key: 'loadEntity',
    value: function loadEntity() {
      return this._loadEntity.apply(this, arguments);
    }
  }, {
    key: '_loadEntity',
    value: function _loadEntity(cb, errCb, extras) {
      var _this5 = this;

      if (this.isLoading || this.isNew) return cb && cb();
      if (!this.$parent) throw new Error("missing parent");
      if (!this.$parent.simgate) throw new Error("missing simgate");
      var simgate = this.$parent.simgate;
      if (this.readonly || this.savable === false || this.saveable === false) return cb && cb();

      this.willLoad = +new Date();

      var taskArgs = [simgate.execQuery, {
        "query": "simbox-queries://" + "getbyname",
        "parameters": { name: this.id }
      }, {
        onSuccess: function onSuccess(res) {
          var ent = res.data[0][0];
          _this5.$parent.hydrateEntities((0, _defineProperty5.default)({}, ent.name, ent));
          _this5.hasLoaded = +new Date();
          if (typeof cb === "function") cb(_this5);
        },
        onFailure: function onFailure(err) {
          debugger;
          errCb && errCb(err, _this5);
        }
      }];

      if (simgate.runTask) {
        simgate.runTask.apply(simgate, taskArgs);
      } else {
        simgate.execQuery(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
      }
    }
  }, {
    key: 'saveEntity',
    value: function saveEntity() {
      return this._saveEntity.apply(this, arguments);
    }
  }, {
    key: '_saveEntity',
    value: function _saveEntity(cb, errCb, extras) {
      var _this6 = this;

      // overwritten in local.js  
      if (this.hasBrokenRefs && !this.constructor.allowBrokenChildren) console.warn("this entity has broken refs.  Will not save: " + this.id);
      if (this.isSaving || !this.isDirty && !this.isNew || this.hasBrokenRefs && !this.constructor.allowBrokenChildren) return cb && cb();
      if (!this.$parent) throw new Error("missing parent");
      if (!this.$parent.simgate) throw new Error("missing simgate");
      var simgate = this.$parent.simgate;
      if (this.readonly || this.savable === false || this.saveable === false) return cb && cb();

      this.willSave = +new Date();

      var taskArgs = [simgate.execQuery, {
        "query": "simbox-queries://" + (this.isNew ? "insert" : "update"),
        "parameters": extras ? (0, _assign2.default)(this.simboxDTO, extras) : this.simboxDTO
      }, {
        onSuccess: function onSuccess(res) {
          _this6._updateCache();
          // this.isNew = false;
          // @TODO after save needs to return guid, put it here
          _this6.guid = "fake-id";
          _this6.hasSaved = +new Date();
          _this6._lastReview = res.data[0][0][""];

          //add to parent entities content model if doesnt exist
          if (!_this6.$parent) debugger;
          if (!_this6.$parent.entities.get(_this6.id)) _this6.$parent.entities.set(_this6.id, _this6);

          if (typeof cb === "function") cb(_this6);
        },
        onFailure: errCb,
        onRetry: function onRetry(err) {
          if (err.message.indexOf("#3.14159") === 0) {
            _this6.willSave = 0;
            window.application.modalViewStore.setModal({
              title: "Content out of date!",
              message: _react2.default.createElement(
                'div',
                { style: { maxWidth: "500px" } },
                'The content for ',
                _this6.uniqueDisplayName,
                ' is out of date.  Saving is restricted until you have the latest copy.  Please click \'Update Now\' to revert the content to the latest version.  WARNING: You WILL lose your new content during this process, here it is for reference purposes: ',
                _react2.default.createElement(
                  'pre',
                  null,
                  (0, _stringify2.default)(JSON.parse(_this6._serialized), null, 2)
                )
              ),
              confirmLabel: 'Update Now',
              confirmBtnClass: 'green check-a',
              cancelLabel: 'Cancel',
              cancelBtnClass: 'red times-b',
              onConfirmFunc: function onConfirmFunc() {
                _this6.loadEntity(function () {
                  _this6.hasSaved = +new Date();
                  window.application.modalViewStore.resetModal();
                });
              }
            });
            return false;
          }
        }
      }];

      if (simgate.runTask) {
        simgate.runTask.apply(simgate, taskArgs);
      } else {
        simgate.execQuery(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
      }

      return this;
    }
  }, {
    key: 'deleteEntity',
    value: function deleteEntity(cb, errCb) {
      var _this7 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var modalViewStore = window.application.modalViewStore;

      var toBeRemovedFrom = false;
      var itemsToSearch = this.containedBy;
      if (itemsToSearch.length) {
        toBeRemovedFrom = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'b',
            null,
            'Warning!'
          ),
          ' This item will be permanently removed from:',
          _react2.default.createElement('br', null),
          itemsToSearch.map(function (it) {
            return _react2.default.createElement(
              'div',
              { key: it.id },
              it.uniqueDisplayName,
              ' ( ',
              it.type,
              ' )'
            );
          })
        );
      }

      modalViewStore.setModal({
        title: "Remove " + this.uniqueDisplayName,
        message: _react2.default.createElement(
          'div',
          null,
          'Permanently remove ',
          this.uniqueDisplayName,
          ' from the system? ',
          toBeRemovedFrom
        ),
        confirmLabel: 'Permanently Delete',
        confirmBtnClass: 'green delete-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          if (typeof options.onConfirmImmediate === "function") options.onConfirmImmediate(_this7);
          if (itemsToSearch && itemsToSearch.length) {
            //search through all items in containedBy and set them to null
            for (var i = 0; i < itemsToSearch.length; i++) {
              var item = itemsToSearch[i],
                  hasSlots = item.slots;

              for (var key in hasSlots) {
                if ((0, _typeof3.default)(hasSlots[key]) === 'object') {
                  //object or mobx array
                  if (Array.isArray(hasSlots[key].slice()) && hasSlots[key][0] === _this7.constructor) {
                    //is array and the same type
                    //we found the key that it belongs to so loop through this object and delete the item from it
                    for (var _i = 0; _i < item[key].length; _i++) {
                      var oItem = item[key][_i];
                      if (oItem.id === _this7.id) {
                        oItem = null;
                        item[key].splice(_i, 1);
                        item.saveEntity();
                        break;
                      }
                    }
                    break;
                  } else if (hasSlots[key] === _this7.constructor && hasSlots[key].id === _this7.id) {
                    //is actual object
                    hasSlots[key] = null;
                    item.saveEntity();
                    break;
                  }
                }
              }
            }
          }

          _this7._deleteEntity(function () {
            modalViewStore.resetModal();
            if (typeof cb === "function") cb();
          }, errCb, options);
        }
      });
    }
  }, {
    key: '_deleteEntity',
    value: function _deleteEntity(cb, errCb, extras) {
      var _this8 = this;

      // if(this.isSaving || (!this.isDirty && !this.isNew)) return cb && cb()
      if (!this.$parent) throw new Error("missing parent");
      if (!this.$parent.simgate) throw new Error("missing simgate");
      var simgate = this.$parent.simgate;
      // if(this.readonly || this.savable === false || this.saveable === false) return cb && cb()

      // this.willSave = +new Date;
      var params = {
        // this.id gets saved to name
        name: this.id
      };

      var taskArgs = [simgate.execQuery, {
        "query": "simbox-queries://deletebyname",
        "parameters": params
      }, {
        onSuccess: function onSuccess(res) {
          _this8.$parent.entities.delete(_this8.id);
          if (typeof cb === "function") cb(_this8, res);
        },
        onFailure: function onFailure(err) {
          // debugger
          console.error(err);
          errCb && errCb(err, _this8);
        }
      }];

      if (simgate.runTask) {
        simgate.runTask.apply(simgate, taskArgs);
      } else {
        simgate.execQuery(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
      }

      return this;
    }
  }, {
    key: 'handleUnsavedChanges',
    value: function handleUnsavedChanges(cb, cancelCb, options) {
      var _this9 = this;

      window.application.modalViewStore.setModal({
        title: "Unsaved Changes",
        message: "You have unsaved changes in " + this.uniqueDisplayName + ".  If you continue you will lose these changes!  Press cancel to go back.",
        confirmLabel: 'Revert and Continue',
        confirmBtnClass: 'green check-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          window.application.modalViewStore.resetModal();
          _this9.revert();
          if (typeof cb === "function") cb(_this9);
        }
      });
    }
  }, {
    key: 'cloneEntity',
    value: function cloneEntity() {
      return window.application.modalViewStore.setModal({
        title: "Clone " + this.uniqueDisplayName,
        message: "Cloning entities is not yet supported.",
        confirmLabel: "Continue",
        confirmBtnClass: 'green'
      });

      //@TODO move modalViewStore access to this.$parent (global contentModel)?
      window.application.modalViewStore.setModal({
        title: "Clone " + this.uniqueDisplayName,
        message: !this.allClonableChildren.length ? "Would you like to clone " + this.uniqueDisplayName + "?" : _react2.default.createElement(
          'div',
          { style: { maxWidth: "500px" } },
          'This entity has ',
          this.allClonableChildren.length,
          ' nested children.  Would you like to do a deep (clone all children) or shallow (keep original children) clone? ',
          _react2.default.createElement(
            'select',
            { id: 'cloneDeepOrShallow' },
            _react2.default.createElement(
              'option',
              null,
              'deep'
            ),
            _react2.default.createElement(
              'option',
              null,
              'shallow'
            )
          )
        ),
        confirmLabel: 'Clone',
        confirmBtnClass: 'green check-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          var select = document.getElementById("cloneDeepOrShallow");
          alert(select.value);
        }
      });
    }
  }, {
    key: 'autoPopulate',
    value: function autoPopulate() {
      var _this10 = this;

      var autopop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var autoPopulate = (0, _keys2.default)(this.slots);
      autoPopulate.forEach(function (name) {
        if (!_this10.slots.hasOwnProperty(name)) throw new Error("contentmodel missing slot: " + name);
        var num = getRandomIntInclusive(0, 1000);
        var slot = _this10.slots[name];
        var ContentModel = void 0;
        //@TODO __proto__ hack accounts for mock extension to match basecontentmodel also...
        if (slot === BaseContentModel || process && __webpack_require__.i({"api":"simgate","NODE_ENV":"production","localMode":false}) && false && slot.__proto__ === BaseContentModel) {
          if (!autopop[name] || !(autopop[name] instanceof BaseContentModel)) console.warn("no autopopulation class indicated for this `any` slot: " + name);
          _this10[name] = null;
          return;
        } else {
          if (!(slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) return;
          ContentModel = slot;
        }
        _this10[name] = new ContentModel({ id: ContentModel.name.replace("ContentModel", "") + "_" + num });
      });
    }
  }, {
    key: 'hasBrokenChildren',
    get: function get() {
      //@TODO need to figure out what to do with broken refs
      return false; //this.hasBrokenRefs || this.allChildEntities.some( ent => !!ent.hasBrokenChildren )
    }
  }, {
    key: 'isNew',
    get: function get() {
      return !this.guid;
    }
  }, {
    key: 'isSaving',
    get: function get() {
      return this.willSave - this.hasSaved > 0;
    }
  }, {
    key: 'isLoading',
    get: function get() {
      return this.willLoad - this.hasLoaded > 0;
    }
  }, {
    key: 'slots',
    get: function get() {
      if (!this.constructor._slots) throw new Error("contentmodel is missing slots");
      return this.constructor._slots;
    }
  }, {
    key: '$parent',
    get: function get() {
      return this.constructor.$parent;
    }
  }, {
    key: 'meta',
    get: function get() {
      return this.constructor._meta;
    }
  }, {
    key: 'allOfSameType',
    get: function get() {
      return this.constructor.allEntities();
    }
  }, {
    key: 'hasCollection',
    get: function get() {
      var _this11 = this;

      return (0, _keys2.default)(this.slots).some(function (k) {
        return Array.isArray(_this11.slots[k]);
      });
    }
  }, {
    key: 'containedBy',
    get: function get() {
      var _this12 = this;

      return this.$parent.entities.values().filter(function (e) {
        return !e.constructor.Synthetic && e.immediateChildren.indexOf(_this12) > -1;
      });
    }
  }, {
    key: 'uniqueDisplayName',
    get: function get() {
      return this.hasDuplicateDisplayName ? this.displayName + " (" + this.id + ")" : this.displayName || this.id;
    }
  }, {
    key: 'idOrDisplayName',
    get: function get() {
      return this.displayName ? this.displayName + " (" + this.id + ")" : this.id;
    }
  }, {
    key: 'hasDuplicateDisplayName',
    get: function get() {
      var _this13 = this;

      return this.displayName && this.$parent.entities.values().some(function (ent) {
        return ent !== _this13 && ent.displayName === _this13.displayName;
      });
    }
    // @TODO causes cycles
    // @computed get containedByProject(){
    //   return this.$parent.entities.get("Project").allChildEntities.some( e => e === this );
    // }

  }, {
    key: 'isOrphan',
    get: function get() {
      return this.containedBy.length === 0;
      // return this.containedByProject.length === 0;
    }
  }, {
    key: 'isAvailable',
    get: function get() {
      var _this14 = this;

      var maxParents = this.constructor.maxParents;
      if (!maxParents) return true;
      var count = 0;
      var typeCm = this.$parent.entities.get(maxParents[0]);
      var exceedsMaxParents = typeCm.entities.some(function (e) {
        if (e.immediateChildren.indexOf(_this14) > -1) count++;
        if (count >= maxParents[1]) return true;
      });
      return !exceedsMaxParents;
    }
  }, {
    key: 'allChildEntities',
    get: function get() {
      var _this15 = this;

      var entities = new _set2.default();
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this15.slots[name]) ? _this15.slots[name][0] : _this15.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this15[name];
          if (value == null || typeof value === "string") return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            value.forEach(function (cm) {
              if (cm == null || typeof cm === "string") return acc;
              acc.add(cm);
              var moreChildren = cm.allChildEntities;
              if (!moreChildren) debugger;
              moreChildren.forEach(function (child) {
                return acc.add(child);
              });
            });
          } else {
            // if(typeof value === "string")
            acc.add(value);
            var moreChildren = value.allChildEntities;
            moreChildren.forEach(function (child) {
              return acc.add(child);
            });
          }
        }
        return acc;
      }, entities);
      return (0, _from2.default)(entities);
    }
  }, {
    key: 'allClonableChildren',
    get: function get() {
      return this.getAllChildEntitiesFiltered(function (childCm, parentCm, slotName) {
        return childCm.clonable === false || childCm.constructor.clonable === false;
      });
    }
  }, {
    key: 'allChildCms',
    get: function get() {
      var _this16 = this;

      var entities = [];
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this16.slots[name]) ? _this16.slots[name][0] : _this16.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this16[name];
          if (value == null) return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            // ignoring arrays
            // value.forEach( cm => {
            //   acc.push( [cm,value] );
            //   const moreChildren = cm.allChildCms;
            //   moreChildren.forEach( child => acc.push( child ) )
            // })
          } else if (value instanceof BaseContentModel) {
            acc.push([value, _this16, name]);
            var moreChildren = value.allChildCms;
            if (!moreChildren) debugger;
            moreChildren.forEach(function (child) {
              return acc.push(child);
            });
          }
        }
        return acc;
      }, entities);
      return entities;
    }
  }, {
    key: 'immediateChildren',
    get: function get() {
      var _this17 = this;

      var entities = [];
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this17.slots[name]) ? _this17.slots[name][0] : _this17.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this17[name];
          if (value == null) return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            value.forEach(function (cm) {
              acc.push(cm);
            });
          } else if (value instanceof BaseContentModel) {
            acc.push(value);
          }
        }
        return acc;
      }, entities);
      return entities;
    }
  }, {
    key: 'allCms',
    get: function get() {
      var _this18 = this;

      var entities = [];
      (0, _keys2.default)(this.slots).reduce(function (acc, name) {
        var slot = Array.isArray(_this18.slots[name]) ? _this18.slots[name][0] : _this18.slots[name];
        if (slot && (slot === BaseContentModel || slot.prototype instanceof BaseContentModel)) {
          var value = _this18[name];
          if (typeof value === "string") {
            console.warn("improper slot, value combo", _this18.id);
            return acc;
          }
          if (value == null) return acc;
          if (Array.isArray(value) || value.constructor.name === "ObservableArray") {
            // ignoring arrays
            // value.forEach( cm => {
            //   acc.push( [cm,value] );
            //   const moreChildren = cm.allChildCms;
            //   moreChildren.forEach( child => acc.push( child ) )
            // })
          } else {
            var moreChildren = value.allChildCms;
            moreChildren.forEach(function (child) {
              return acc.push(child);
            });
          }
        }
        return acc;
      }, entities);
      return entities;
    }
  }, {
    key: '_serialized',
    get: function get() {
      var _this19 = this;

      if (this.readonly || this.constructor.readonly || !this.constructor._slots) return "";
      var ret = (0, _stringify2.default)((0, _mobx.toJS)((0, _keys2.default)(this.slots).reduce(function (acc, k) {
        if (Array.isArray(_this19.slots[k])) {
          // if(!this[k]) debugger
          acc[k] = _this19[k].filter(function (i) {
            return i != null;
          }).map(function (i) {
            return i.id;
          });
        } else if (_this19[k] instanceof BaseContentModel) {
          acc[k] = _this19[k].id;
        } else if (_this19.slots[k] === "Array") {
          acc[k] = _this19[k].slice();
        } else {
          acc[k] = _this19[k];
        }
        return acc;
      }, { id: this.id })));
      return ret;
    }
  }, {
    key: 'isDirty',
    get: function get() {
      var dirty = this._serialized !== this._cache;
      return dirty;
    }
  }, {
    key: 'anyDirty',
    get: function get() {
      //@TODO circular references...
      return this.getAllChildEntitiesFiltered(function (childCm, parentCm, slotName) {
        return childCm.savable !== false && childCm.constructor.savable !== false && childCm.Synthetic !== true && childCm.constructor.Synthetic !== true;
      }).some(function (ent) {
        return ent.isDirty;
      });
    }
  }, {
    key: 'allEntities',
    get: function get() {
      return [this].concat((0, _toConsumableArray3.default)(this.allChildEntities));
    }
  }, {
    key: '_invalid',
    get: function get() {
      var _invalid = {};
      if (this.isNew) {
        if (!!this.$parent.entities.get(this.id)) {
          _invalid.id = "An entity with this id (" + this.id + ") already exists.  Please choose a different id.";
        }
      }

      if (!this.id) _invalid.id = "Please provide an id!";

      if (this.hasBrokenRefs) _invalid.hasBrokenRefs = "This entity has broken references and will not be savable.";

      return _invalid;
    }
    // please overwrite me :-)

  }, {
    key: 'invalid',
    get: function get() {
      var invalid = (0, _assign2.default)({}, this._invalid);
      // add other validations
      return invalid;
    }
  }, {
    key: 'isInvalid',
    get: function get() {
      return !!(0, _keys2.default)(this.invalid).length;
    }
  }, {
    key: 'allowSave',
    get: function get() {
      return !(0, _keys2.default)(this.invalid).length && (this.isNew || this.isDirty);
    }
  }, {
    key: '_inputs',
    get: function get() {
      var _this20 = this;

      return (0, _keys2.default)(this).filter(function (k) {
        return (0, _keys2.default)(_this20.slots).indexOf(k) === -1 && (0, _mobx.isObservable)(_this20, k) && (0, _typeof3.default)(_this20.$mobx.target[k]) === "object" && (0, _mobx.isObservable)(_this20[k], "variable") && (0, _mobx.isComputed)(_this20[k], "variable");
      }).reduce(function (acc, k) {
        if ((0, _mobx.isObservable)(_this20[k], "value") && (0, _mobx.isComputed)(_this20[k], "value")) {
          (0, _defineProperty3.default)(acc, _this20[k].variable, {
            enumerable: true,
            get: function () {
              return this[k].value;
            }.bind(_this20)
          });
          return acc;
        }
        acc[_this20[k].variable] = _this20[k].defaultValue || null;
        return acc;
      }, {});
    }
  }, {
    key: 'simboxDTO',
    get: function get() {
      var params = {
        // this.id gets saved to name
        name: this.id,
        // this._serialized gets saved to attr1
        attr1: this._serialized,
        review: this._lastReview || 0,
        val: this._lastReview || 0,
        tag: this.type
        // this.type gets saved to tag, but only if new
      };if (this.isNew) params.tag = this.type;
      return params;
    }
  }]);
  return BaseContentModel;
}(), _class2.newEntityWasAdded = (0, _mobx.observable)(0), _class2.$parent = null, _temp), (_applyDecoratedDescriptor(_class.prototype, '_updateCache', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_updateCache'), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, 'hasBrokenRefs', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'hasBrokenChildren', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hasBrokenChildren'), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'guid', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isNew', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isNew'), _class.prototype), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, '$inputStore', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'willSave', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'hasSaved', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isSaving', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isSaving'), _class.prototype), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'willLoad', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'hasLoaded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isLoading', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isLoading'), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, '_cache', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, 'slots', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'slots'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '$parent', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '$parent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'meta', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'meta'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allOfSameType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allOfSameType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hasCollection'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'containedBy', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'containedBy'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'uniqueDisplayName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'uniqueDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'idOrDisplayName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'idOrDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasDuplicateDisplayName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hasDuplicateDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isOrphan', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isOrphan'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isAvailable', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isAvailable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allChildEntities', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allChildEntities'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allClonableChildren', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allClonableChildren'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allChildCms', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allChildCms'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'immediateChildren', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'immediateChildren'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allCms', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allCms'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_serialized', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_serialized'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'anyDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'anyDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allEntities', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allEntities'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_invalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'invalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isInvalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isInvalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allowSave', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allowSave'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_inputs', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_inputs'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'revert', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'revert'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'populate', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'populate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateValue', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateInput', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateInput'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateInputVariable', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateInputVariable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadEntity', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loadEntity', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_loadEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveEntity', [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'simboxDTO', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'simboxDTO'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_saveEntity', [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_saveEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteEntity', [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_deleteEntity', [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_deleteEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleUnsavedChanges', [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleUnsavedChanges'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cloneEntity', [_dec15], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cloneEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'autoPopulate', [_dec16], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'autoPopulate'), _class.prototype)), _class));
exports.default = BaseContentModel;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getRandomIntInclusive, 'getRandomIntInclusive', 'src/core_modules/base-contentmodel/index.js');

  __REACT_HOT_LOADER__.register(deepBind, 'deepBind', 'src/core_modules/base-contentmodel/index.js');

  __REACT_HOT_LOADER__.register(extendObservableObj, 'extendObservableObj', 'src/core_modules/base-contentmodel/index.js');

  __REACT_HOT_LOADER__.register(BaseContentModel, 'BaseContentModel', 'src/core_modules/base-contentmodel/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkInstanceOf = checkInstanceOf;
// Function to check for deep inheritance.  The native instanceof does not work correctly with transpiled code
function checkInstanceOf(prototype, base) {
  // if this object has a prototype then we are not looking at the prototype right now
  if (!prototype || !base) {
    return false;
  }
  if (prototype.prototype) {
    return checkInstanceOf(prototype.prototype, base);
  }
  if (base.prototype) {
    return checkInstanceOf(prototype, base.prototype);
  }
  // make sure this isn't a primative class, those are always false
  if (!prototype.constructor || prototype.constructor.name == "Object" || prototype.constructor.name == "Array" || prototype.constructor.name == "String" || prototype.constructor.name == "Number" || prototype.constructor.name == "Boolean") {
    return false;
  }
  // check for a match
  if (base.constructor && base.constructor.name == prototype.constructor.name || base.prototype && base.prototype.constructor && base.prototype.constructor.name == prototype.constructor.name || prototype.constructor.name == base) {
    return true;
  }
  return checkInstanceOf(prototype.__proto__, base);
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(checkInstanceOf, "checkInstanceOf", "src/core_modules/base-contentmodel/utils.js");
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseViewStore = function BaseViewStore(props, Component) {
  (0, _classCallCheck3.default)(this, BaseViewStore);

  this.props = props;
  this.constructor.setUpMock && this.constructor.setUpMock(this);
};

exports.default = BaseViewStore;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BaseViewStore, "BaseViewStore", "src/core_modules/base-viewstore/index.js");
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BypassAuth = undefined;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BypassAuth = exports.BypassAuth = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
  (0, _inherits3.default)(BypassAuth, _BaseComponent);

  function BypassAuth() {
    (0, _classCallCheck3.default)(this, BypassAuth);
    return (0, _possibleConstructorReturn3.default)(this, (BypassAuth.__proto__ || (0, _getPrototypeOf2.default)(BypassAuth)).apply(this, arguments));
  }

  (0, _createClass3.default)(BypassAuth, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        "Loading..."
      );
    }
  }]);
  return BypassAuth;
}(_baseComponent2.default)) || _class;

var _default = BypassAuth;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BypassAuth, "BypassAuth", "src/core_modules/bypass-auth-strategy/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "src/core_modules/bypass-auth-strategy/component.js");
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BypassAuthContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _class2, _temp2;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _component = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/component.js");

var _component2 = _interopRequireDefault(_component);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var BypassAuthContentModel = exports.BypassAuthContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(BypassAuthContentModel, _BaseContentModel);

  function BypassAuthContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BypassAuthContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BypassAuthContentModel.__proto__ || (0, _getPrototypeOf2.default)(BypassAuthContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.Component = _component2.default, _initDefineProp(_this, 'loadingMessage', _descriptor, _this), _this.done = "true", _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // @hint("this is the loading message that is displayed while the app is waiting") 
  // @slot 


  // condition for completion of this strategy, will be evalled


  return BypassAuthContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  loadingMessage: ""
}, _class2._hints = {
  loadingMessage: "this is the loading message that is displayed while the app is waiting"
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'loadingMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
})), _class);
var _default = BypassAuthContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BypassAuthContentModel, 'BypassAuthContentModel', 'src/core_modules/bypass-auth-strategy/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/bypass-auth-strategy/contentmodel.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.ContentModel = exports.ContentModels = exports.description = undefined;

var _component = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/component.js");

var _component2 = _interopRequireDefault(_component);

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/contentmodel.js");

var bypassAuthContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// // in local context, style will be loaded via normal webpack require (direct insert into head)
// // in remote context, webpack will compile this as a string, and export as "stylesheet" from module
// import style from './style.css';

// basic auth functionality
var description = exports.description = "Bypass auth strategy.  This allows anonymous straight in.";
// export const stylesheet = style;
var ContentModels = exports.ContentModels = bypassAuthContentModels;
var ContentModel = exports.ContentModel = bypassAuthContentModels.default;
var Component = exports.Component = _component2.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(description, 'description', 'src/core_modules/bypass-auth-strategy/index.js');

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/core_modules/bypass-auth-strategy/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/core_modules/bypass-auth-strategy/index.js');

  __REACT_HOT_LOADER__.register(Component, 'Component', 'src/core_modules/bypass-auth-strategy/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/collection-grid-editor/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.GridEditorView = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");

var _get3 = _interopRequireDefault(_get2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _dec5, _dec6, _class3, _class4, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var React = _interopRequireWildcard(_react);

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/editor.js");

var _editor2 = _interopRequireDefault(_editor);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _agGridReact = __webpack_require__("./node_modules/ag-grid-react/main.js");

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

__webpack_require__("./node_modules/ag-grid/dist/styles/ag-grid.css");

__webpack_require__("./node_modules/ag-grid/dist/styles/theme-fresh.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

var ViewStore = (_dec = _mobx.observable.ref, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class = function (_DefaultEditorViewSto) {
  (0, _inherits3.default)(ViewStore, _DefaultEditorViewSto);
  (0, _createClass3.default)(ViewStore, [{
    key: "viewMap",
    get: function get() {
      return this.collection.reduce(function (acc, item) {
        acc[item.id] = {
          id: item.id,
          contentModel: item.contentModel || item
        };

        (0, _keys2.default)(item.slots).filter(function (k) {
          return item.slots[k] && (item.slots[k].prototype instanceof _baseContentmodel2.default || item.slots[k] === _baseContentmodel2.default);
        }).forEach(function (k) {
          var subCm = item[k];
          if (!subCm) return;
          acc[subCm.id] = {
            id: subCm.id,
            contentModel: subCm.contentModel || subCm
          };
        });

        return acc;
      }, {});
    }
    /** end view controller mixin overrides **/

    /** local ViewStore class **/

  }]);

  function ViewStore() {
    (0, _classCallCheck3.default)(this, ViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ViewStore.__proto__ || (0, _getPrototypeOf2.default)(ViewStore)).apply(this, arguments));

    _this.dispose = [];

    _initDefineProp(_this, "api", _descriptor, _this);

    _initDefineProp(_this, "selectedCollectionName", _descriptor2, _this);

    var options = _this.props.options;

    _this.selectedCollectionName = options && options.collection ? options.collection : _this.availableCollectionNames[0] || "";
    _this.dispose.push((0, _mobx.reaction)(function () {
      return _this.selectedCollectionName;
    }, function () {
      return _this.props.editorViewStore.stopEditing();
    }));
    return _this;
  }

  (0, _createClass3.default)(ViewStore, [{
    key: "setCollection",
    value: function setCollection(val) {
      this.selectedCollectionName = val;
    }
  }, {
    key: "formatTitle",
    value: function formatTitle(propertyName) {
      return propertyName.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase();
      });
    }
  }, {
    key: "updateGrid",
    value: function updateGrid() {
      var contentModel = this.contentModel;

      if (window.GRIDUPDATE && window.GRIDUPDATE[contentModel.id]) {
        window.GRIDUPDATE[contentModel.id].forceUpdate();
      }
    }

    // no @action since calling super

  }, {
    key: "editItem",
    value: function editItem(item, node) {
      var _this2 = this;

      if (item.readonly) return;
      // super === DefaultEditorViewStore
      (0, _get3.default)(ViewStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(ViewStore.prototype), "editItem", this).call(this, item);
      if (typeof this.disposeEdit === "function") this.disposeEdit();
      if (node) {
        this.disposeEdit = (0, _mobx.reaction)(function () {
          return (0, _keys2.default)(item).map(function (k) {
            return item[k], (0, _typeof3.default)(item[k]) === "object" && item[k].length;
          });
        }, function () {
          return _this2.api.refreshRows([node]);
        });
      }
    }
  }, {
    key: "newItem",
    value: function newItem() {
      var _this3 = this;

      if (this.CollectionItemContentModel === _baseContentmodel2.default) return;
      var num = getRandomIntInclusive(0, 1000);
      var item = new this.CollectionItemContentModel({
        id: this.CollectionItemContentModel.name.replace("ContentModel", "") + "_" + num
      });

      var editorViewStore = this.props.editorViewStore;

      editorViewStore.startEditing({
        contentModel: item,
        onSave: function onSave(item) {
          _this3.collection.indexOf(item) === -1 && _this3.collection.push(item);
          _this3.contentModel.saveEntity();
          _this3.api.ensureNodeVisible(item);

          // if(typeof this.dispose === "function") this.dispose();
          // this.dispose = reaction( 
          //   () => Object.keys(item).map( k => (item[k], typeof item[k] === "object" && item[k].length) ),
          //   () => {
          //     const nodes = this.api.getRenderedNodes();
          //     this.api.refreshRows( [nodes[nodes.length-1]] )
          //   }
          // )    
        }
      });
    }
  }, {
    key: "collectionIsArray",
    get: function get() {
      if (!this.selectedCollectionName) throw new Error("no selectedCollectionName selected");
      var slots = this.contentModel.slots;
      return Array.isArray(slots[this.selectedCollectionName]);
    }
  }, {
    key: "collectionIsReadonly",
    get: function get() {
      if (!this.selectedCollectionName) throw new Error("no selectedCollectionName selected");
      var slots = this.contentModel.slots;
      if (!this.contentModel[this.selectedCollectionName]) throw new Error("incorrect collection!");
      return this.contentModel.meta && this.contentModel.meta[this.selectedCollectionName] && this.contentModel.meta[this.selectedCollectionName].readonly;
    }
  }, {
    key: "contentModel",
    get: function get() {
      if (!this.props.contentModel) throw new Error("missing contentmodel");
      return this.props.contentModel;
    }
  }, {
    key: "collection",
    get: function get() {
      if (!this.selectedCollectionName) throw new Error("no selectedCollectionName selected");
      var slots = this.contentModel.slots;
      if (!this.contentModel[this.selectedCollectionName]) throw new Error("incorrect collection!");
      return this.collectionIsArray ? this.contentModel[this.selectedCollectionName] : [this.contentModel[this.selectedCollectionName]];
    }
  }, {
    key: "availableCollectionNames",
    get: function get() {
      var slots = this.contentModel.slots;
      return (0, _keys2.default)(slots).filter(function (k) {
        return Array.isArray(slots[k]) || slots[k].prototype instanceof _baseContentmodel2.default;
      }).sort(function (a, b) {
        return Array.isArray(slots[b]) ? 1 : -1;
      });
    }
  }, {
    key: "CollectionItemContentModel",
    get: function get() {
      var slots = this.contentModel.slots;
      if (!this.selectedCollectionName) throw new Error("missing this.selectedCollectionName");
      var slot = slots[this.selectedCollectionName];
      return slot === _baseContentmodel2.default || Array.isArray(slot) && slot[0] === _baseContentmodel2.default ? this.contentModel.childConstructor || _baseContentmodel2.default : Array.isArray(slot) ? slot[0] : slot;
    }
  }, {
    key: "collectionSlots",
    get: function get() {
      if (this.CollectionItemContentModel === _baseContentmodel2.default) return {};
      var slots = this.CollectionItemContentModel._slots;
      if (!slots) throw new Error("collection contentModel missing _slots on constructor");
      return slots;
    }
  }, {
    key: "columnDefs",
    get: function get() {
      var _this4 = this;

      var contentModel = this.contentModel,
          selectedCollectionName = this.selectedCollectionName,
          collection = this.collection,
          newItem = this.newItem,
          viewItem = this.viewItem,
          editItem = this.editItem,
          collectionIsArray = this.collectionIsArray,
          slots = this.collectionSlots,
          collectionIsReadonly = this.collectionIsReadonly,
          CollectionItemContentModel = this.CollectionItemContentModel,
          _props = this.props,
          editorViewStore = _props.editorViewStore,
          modalViewStore = _props.modalViewStore;

      var defs = void 0;
      if (CollectionItemContentModel === _baseContentmodel2.default) {
        defs = [{ headerName: "Type", field: "type" }];
      }
      if (!defs) {
        var collectionSlotKeys = (0, _keys2.default)(slots).filter(function (k) {
          return k.charAt(0) !== "_" && k.charAt(0) !== "$";
        });
        defs = collectionSlotKeys.map(function (k) {
          var isArray = Array.isArray(slots[k]);
          if (isArray) {
            // return { headerName: "["+k+"]", field: k + ".length" }
            return { headerName: _this4.formatTitle(k), cellRenderer: function cellRenderer(params) {
                var item = params.data;
                var arr = item[k];
                var node = params.node;

                var div = document.createElement('div');
                div.style.textAlign = 'center';
                if (!item[k]) return div;

                var view = document.createElement('span');
                view.innerHTML = "" + arr.length;

                var view2 = document.createElement('span');
                view2.style.cursor = 'pointer';
                view2.title = 'View Collection';
                view2.innerHTML = ' <span class="ag-grid-view-item ag-grid-icon-item"></span>';
                item[k] && view2.addEventListener('click', function (e) {
                  viewItem(item, { onlyShow: [k], forceFullEditor: true });
                  editorViewStore.stopEditing();
                });

                div.appendChild(view);
                div.appendChild(view2);

                return div;
              } };
          } else {
            var isReference = slots[k] != null && (slots[k] instanceof _baseContentmodel2.default || slots[k] === _baseContentmodel2.default || slots[k].prototype instanceof _baseContentmodel2.default);
            var isObject = !isReference && (0, _typeof3.default)(slots[k]) === "object";
            if (!isReference) {
              return { headerName: _this4.formatTitle(k), field: k };
            } else {
              return { headerName: _this4.formatTitle(k), cellRenderer: function cellRenderer(params) {
                  var item = params.data;
                  var node = params.node;

                  var div = document.createElement('div');
                  div.style.textAlign = 'center';
                  if (!item[k]) return div;

                  var view = document.createElement('span');
                  view.innerHTML = item[k].id;

                  var view2 = document.createElement('span');
                  view2.style.cursor = 'pointer';
                  view2.title = 'View Item';
                  view2.innerHTML = ' <span class="ag-grid-view-item ag-grid-icon-item"></span>';
                  item[k] && view2.addEventListener('click', function (e) {
                    viewItem(item[k]);
                    editorViewStore.stopEditing();
                  });

                  var edit = document.createElement('span');
                  edit.style.cursor = 'pointer';
                  edit.title = 'Edit Item';
                  edit.innerHTML = ' <span class="ag-grid-edit-item ag-grid-icon-item"></span>';
                  edit.addEventListener('click', function (e) {
                    return editItem(item[k], node);
                  });

                  div.appendChild(view);
                  //!item[k].readonly && div.appendChild(view2)
                  div.appendChild(view2);
                  !item[k].readonly && div.appendChild(edit);

                  return div;
                } };
            }
          }
        });
        if (collection && collection[0] && collection[0]._dateEdited) {
          defs.push({ headerName: 'Date Added', field: '_dateAdded' });
          defs.push({ headerName: 'Date Edited', field: '_dateEdited' });
        }
      }
      defs.unshift({ headerName: "ID", field: "idOrDisplayName", sort: 'asc' });
      defs.unshift({
        headerName: "",
        suppressSorting: true,
        suppressMenu: true,
        width: 115,
        headerCellRenderer: collectionIsArray && !collectionIsReadonly ? function (params) {
          var add = document.createElement('span');
          add.style.cursor = 'pointer';
          add.title = 'Add Item';
          add.className = 'item-action';
          add.innerHTML = ' <span class="ag-grid-add-item ag-grid-icon-item"></span>';
          add.addEventListener('click', function (e) {
            return newItem();
          });
          return add;
        } : null,
        cellRenderer: function cellRenderer(params) {
          var item = params.data;
          var node = params.node;
          // if( item.readonly ) return '';
          var div = document.createElement('div');
          div.style.textAlign = 'center';

          var moveUp = document.createElement('span');
          moveUp.style.cursor = 'pointer';
          moveUp.title = 'Move Up';
          moveUp.className = 'item-action';
          moveUp.innerHTML = ' <span class="ag-grid-move-item-up ag-grid-icon-item"></span>';
          moveUp.addEventListener('click', function (e) {
            var contentModelIndex = collection.findIndex(function (cm) {
              return cm === item;
            });
            if (contentModelIndex !== 0) {
              collection.splice(contentModelIndex - 1, 0, collection.splice(contentModelIndex, 1)[0]);
              contentModel.saveEntity();
              _this4.updateGrid();
            }
          });

          var moveDown = document.createElement('span');
          moveDown.style.cursor = 'pointer';
          moveDown.title = 'Move Down';
          moveDown.className = 'item-action';
          moveDown.innerHTML = ' <span class="ag-grid-move-item-down ag-grid-icon-item"></span>';
          moveDown.addEventListener('click', function (e) {
            var contentModelIndex = collection.findIndex(function (cm) {
              return cm === item;
            });
            if (contentModelIndex !== collection.length - 1) {
              collection.splice(contentModelIndex + 1, 0, collection.splice(contentModelIndex, 1)[0]);
              contentModel.saveEntity();
              _this4.updateGrid();
            }
          });

          var view = document.createElement('span');
          view.style.cursor = 'pointer';
          view.title = 'View Item';
          view.className = 'item-action';
          view.innerHTML = ' <span class="ag-grid-view-item ag-grid-icon-item"></span>';
          view.addEventListener('click', function (e) {
            viewItem(item);
            editorViewStore.stopEditing();
          });

          var edit = document.createElement('span');
          edit.style.cursor = 'pointer';
          edit.title = 'Edit Item';
          edit.className = 'item-action';
          edit.innerHTML = ' <span class="ag-grid-edit-item ag-grid-icon-item"></span>';
          edit.addEventListener('click', function (e) {
            return editItem(item, node);
          });

          var clone = document.createElement('span');
          clone.style.cursor = 'pointer';
          clone.title = 'Clone Item';
          clone.className = 'item-action';
          clone.innerHTML = ' C';
          clone.addEventListener('click', function (e) {
            return item.cloneEntity();
          });

          var remove = document.createElement('span');
          remove.style.cursor = 'pointer';
          remove.title = 'Remove Item';
          remove.className = 'item-action';
          remove.innerHTML = ' <span class="ag-grid-delete-item ag-grid-icon-item"></span>';
          remove.addEventListener('click', (0, _mobx.action)(function (e) {
            //@TODO move most of this to base contentmodel
            var contentModelIndex = collection.findIndex(function (cm) {
              return cm === item;
            });

            var itemToDelete = collection[contentModelIndex];

            // System.Types and Orphans are the only places you can permanently delete entities with the grid editor
            var permanentDelete = contentModel.type === "TypeContentModel" || contentModel.type === "OrphansContentModel";

            if (permanentDelete) {
              item.deleteEntity(function () {
                _this4.updateGrid();
                modalViewStore.resetModal();
              });
            } else {
              modalViewStore.setModal({
                title: "Remove " + item.uniqueDisplayName,
                message: React.createElement(
                  "div",
                  null,
                  "Remove ",
                  item.uniqueDisplayName,
                  " from ",
                  contentModel.uniqueDisplayName + "." + selectedCollectionName + " collection",
                  "?"
                ),
                confirmLabel: 'Remove',
                confirmBtnClass: 'green delete-a',
                cancelLabel: 'Cancel',
                cancelBtnClass: 'red times-b',
                onConfirmFunc: function onConfirmFunc() {
                  collection.splice(contentModelIndex, 1);
                  contentModel.saveEntity();
                  modalViewStore.resetModal();
                }
              });
            }
          }));

          !collectionIsReadonly && div.appendChild(moveUp);
          !collectionIsReadonly && div.appendChild(moveDown);
          !item.readonly && !collectionIsReadonly && div.appendChild(edit);
          !item.constructor.Synthetic && div.appendChild(clone);
          /*!item.readonly && */div.appendChild(view);
          !collectionIsReadonly && div.appendChild(remove);

          return div;
        }
      });
      return defs;
    }
  }]);
  return ViewStore;
}(_editor.EditorViewStore), (_applyDecoratedDescriptor(_class.prototype, "viewMap", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "viewMap"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "api", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedCollectionName", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, "collectionIsArray", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "collectionIsArray"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collectionIsReadonly", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "collectionIsReadonly"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentModel", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "contentModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collection", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "collection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availableCollectionNames", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "availableCollectionNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "CollectionItemContentModel", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "CollectionItemContentModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collectionSlots", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "collectionSlots"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "columnDefs", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "columnDefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCollection", [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "setCollection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateGrid", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "updateGrid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "newItem", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "newItem"), _class.prototype)), _class));
var GridEditorView = exports.GridEditorView = (_dec5 = (0, _mobxReact.inject)("modalViewStore"), _dec6 = (0, _mobxReact.inject)("editorViewStore"), _dec5(_class3 = _dec6(_class3 = (0, _mobxReact.observer)(_class3 = (_temp = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(GridEditorView, _BaseComponent);

  function GridEditorView() {
    (0, _classCallCheck3.default)(this, GridEditorView);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (GridEditorView.__proto__ || (0, _getPrototypeOf2.default)(GridEditorView)).apply(this, arguments));

    _this5.api = null;


    _this5.state = {
      sizeHandler: null,
      height: 0
    };
    return _this5;
  }

  (0, _createClass3.default)(GridEditorView, [{
    key: "onGridReady",
    value: function onGridReady(params) {
      this.viewStore.api = this.api = params.api;
    }
  }, {
    key: "resize",
    value: function resize() {
      var cm = this.viewStore.contentModel;
      this.setState({ height: cm && cm.id === 'Configuration' ? window.innerHeight - 130 : window.innerHeight - 75 }); //TODO: height values should not be hardcoded
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var contentModel = this.props.contentModel;

      window.GRIDUPDATE = window.GRIDUPDATE || {};
      if (window.GRIDUPDATE[contentModel.id]) {
        delete window.GRIDUPDATE[contentModel.id];
      }

      if (this.state.sizeHandler) {
        window.removeEventListener('resize', this.state.sizeHandler);
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var contentModel = this.props.contentModel;

      window.GRIDUPDATE = window.GRIDUPDATE || {};
      window.GRIDUPDATE[contentModel.id] = this;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var resizer = this.resize.bind(this);
      resizer();
      window.addEventListener('resize', resizer);
      this.state.sizeHandler = resizer;
    }
  }, {
    key: "render",
    value: function render() {
      var viewStore = this.viewStore,
          _viewStore = this.viewStore,
          SelectedView = _viewStore.SelectedView,
          collection = _viewStore.collection,
          columnDefs = _viewStore.columnDefs,
          contentModel = _viewStore.contentModel,
          goBack = _viewStore.goBack,
          availableCollectionNames = _viewStore.availableCollectionNames,
          selectedCollectionName = _viewStore.selectedCollectionName,
          setCollection = _viewStore.setCollection,
          collectionIsArray = _viewStore.collectionIsArray,
          editItem = _viewStore.editItem,
          viewItem = _viewStore.viewItem,
          newItem = _viewStore.newItem,
          options = _viewStore.options,
          viewBreadcrumbs = _viewStore.viewBreadcrumbs,
          isRoot = _viewStore.isRoot,
          editorViewStore = this.props.editorViewStore,
          height = this.state.height;


      return React.createElement(
        "div",
        null,
        isRoot && React.createElement(_layoutComponent.Breadcrumbs, { viewstores: viewBreadcrumbs }),
        SelectedView ? React.createElement(SelectedView, null) : React.createElement(
          "div",
          { className: "ag-fresh round GridWrapper" },
          React.createElement(
            "div",
            { style: { height: height } },
            React.createElement(_agGridReact.AgGridReact, {
              onGridReady: this.onGridReady.bind(this)
              // listen for events with React callbacks
              // onRowSelected={onRowSelected}
              , onRowDoubleClicked: function onRowDoubleClicked(params) {
                viewItem(params.data, { forceFullEditor: true });
                editorViewStore.stopEditing();
              }
              // column definitions and row data are immutable, the grid
              // will update when these lists change
              , columnDefs: columnDefs,
              rowData: collection.slice()
              // or provide props the old way with no binding
              , rowSelection: "multiple",
              enableSorting: "true",
              suppressCellSelection: "true",
              suppressRowClickSelection: "true",
              enableFilter: "true",
              rowHeight: "26"
            })
          )
        )
      );
    }
  }]);
  return GridEditorView;
}(_baseComponent2.default), _class4.ViewStore = ViewStore, _temp)) || _class3) || _class3) || _class3);
var Component = exports.Component = GridEditorView;
var _default = Component;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getRandomIntInclusive, "getRandomIntInclusive", "src/core_modules/collection-grid-editor/index.js");

  __REACT_HOT_LOADER__.register(ViewStore, "ViewStore", "src/core_modules/collection-grid-editor/index.js");

  __REACT_HOT_LOADER__.register(GridEditorView, "GridEditorView", "src/core_modules/collection-grid-editor/index.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "src/core_modules/collection-grid-editor/index.js");

  __REACT_HOT_LOADER__.register(_default, "default", "src/core_modules/collection-grid-editor/index.js");
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/confirmation-modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationModal = (0, _mobxReact.observer)(_class = (0, _autoclassDecorator2.default)(_class = function (_BaseComponent) {
    (0, _inherits3.default)(ConfirmationModal, _BaseComponent);

    function ConfirmationModal() {
        (0, _classCallCheck3.default)(this, ConfirmationModal);
        return (0, _possibleConstructorReturn3.default)(this, (ConfirmationModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmationModal)).apply(this, arguments));
    }

    (0, _createClass3.default)(ConfirmationModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var Component = this.viewStore.Component;

            return _react2.default.createElement(
                'div',
                { className: this.viewStore.showConfirmationModal === true ? "confirmation-modal" : "confirmation-modal hidden" },
                !!Component ? _react2.default.createElement(
                    'div',
                    { className: 'box' },
                    _react2.default.createElement(Component, null)
                ) : _react2.default.createElement(
                    'div',
                    { className: 'box' },
                    this.viewStore.setTitle() !== false && _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        this.viewStore.setTitle()
                    ),
                    this.viewStore.setMessage() !== false && _react2.default.createElement(
                        'div',
                        { className: 'message' },
                        this.viewStore.setMessage()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'actions' },
                        this.viewStore.setCancelLabel() !== false && _react2.default.createElement(
                            'div',
                            { className: "btn" + this.viewStore.setCancelBtnClass(), onClick: function onClick(event) {
                                    return _this2.viewStore.onCancel(event);
                                } },
                            this.viewStore.setCancelLabel()
                        ),
                        this.viewStore.setConfirmLabel() !== false && _react2.default.createElement(
                            'div',
                            { className: "btn" + this.viewStore.setConfirmBtnClass(), onClick: function onClick(event) {
                                    return _this2.viewStore.onConfirm(event);
                                } },
                            this.viewStore.setConfirmLabel()
                        )
                    )
                )
            );
        }
    }]);
    return ConfirmationModal;
}(_baseComponent2.default)) || _class) || _class;

;

var _default = ConfirmationModal;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ConfirmationModal, 'ConfirmationModal', 'src/core_modules/confirmation-modal/index.jsx');

    __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/confirmation-modal/index.jsx');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/confirmation-modal/viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    (0, _defineProperty2.default)(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ConfirmationModalViewStore = (_dec = _mobx.observable.ref, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = function (_BaseViewstore) {
    (0, _inherits3.default)(ConfirmationModalViewStore, _BaseViewstore);

    function ConfirmationModalViewStore() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ConfirmationModalViewStore);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmationModalViewStore.__proto__ || (0, _getPrototypeOf2.default)(ConfirmationModalViewStore)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showConfirmationModal', _descriptor, _this), _initDefineProp(_this, 'title', _descriptor2, _this), _initDefineProp(_this, 'message', _descriptor3, _this), _initDefineProp(_this, 'confirmLabel', _descriptor4, _this), _initDefineProp(_this, 'confirmBtnClass', _descriptor5, _this), _initDefineProp(_this, 'cancelLabel', _descriptor6, _this), _initDefineProp(_this, 'cancelBtnClass', _descriptor7, _this), _initDefineProp(_this, 'onConfirmFunc', _descriptor8, _this), _initDefineProp(_this, 'onCancelFunc', _descriptor9, _this), _initDefineProp(_this, 'viewDefinition', _descriptor10, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ConfirmationModalViewStore, [{
        key: 'resetModal',
        value: function resetModal() {
            var _this2 = this;

            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;

            this.showConfirmationModal = false;
            var reset = function reset() {
                _this2.title = '';
                _this2.message = '';
                _this2.confirmLabel = '';
                _this2.confirmBtnClass = '';
                _this2.cancelLabel = '';
                _this2.cancelBtnClass = '';
                _this2.onConfirmFunc = null;
                _this2.onCancelFunc = null;
                _this2.viewDefinition = null;
            };

            if (delay === false) {
                reset();
            } else {
                setTimeout(reset, delay);
            }
        }
    }, {
        key: 'setModal',
        value: function setModal(newModal) {
            this.resetModal(false);
            this.showConfirmationModal = true;
            if (newModal.Component || newModal.contentModel) {
                this.viewDefinition = newModal;
            } else {
                (0, _assign2.default)(this, newModal);
            }
        }
    }, {
        key: 'setTitle',
        value: function setTitle() {
            if (this.title != undefined) {
                return this.title;
            } else {
                return false;
            }
        }
    }, {
        key: 'setMessage',
        value: function setMessage() {
            if (this.message != undefined) {
                return this.message;
            } else {
                return false;
            }
        }
    }, {
        key: 'setConfirmLabel',
        value: function setConfirmLabel() {
            if (this.confirmLabel != undefined && this.confirmLabel) {
                return this.confirmLabel;
            } else {
                return false;
            }
        }
    }, {
        key: 'setConfirmBtnClass',
        value: function setConfirmBtnClass() {
            if (this.confirmBtnClass != undefined) {
                return this.validateClass(String(this.confirmBtnClass));
            } else {
                return '';
            }
        }
    }, {
        key: 'setCancelLabel',
        value: function setCancelLabel() {
            if (this.cancelLabel != undefined && this.cancelLabel !== '') {
                return this.cancelLabel;
            } else {
                return false;
            }
        }
    }, {
        key: 'setCancelBtnClass',
        value: function setCancelBtnClass() {
            if (this.cancelBtnClass != undefined) {
                return this.validateClass(String(this.cancelBtnClass));
            } else {
                return '';
            }
        }
    }, {
        key: 'onCancel',
        value: function onCancel(e) {
            if (this.onCancelFunc != undefined && typeof this.onCancelFunc == 'function') {
                this.onCancelFunc(e);
            } else {
                this.resetModal();
            }
        }
    }, {
        key: 'onConfirm',
        value: function onConfirm(e) {
            if (this.onConfirmFunc != undefined && typeof this.onConfirmFunc == 'function') {
                this.onConfirmFunc(e);
            } else {
                this.resetModal();
            }
        }
    }, {
        key: 'validateClass',
        value: function validateClass(str) {
            if (str !== '') {
                if (str.indexOf(' ') !== 0) {
                    return ' ' + str;
                } else {
                    return str;
                }
            } else {
                return str;
            }
        }
    }, {
        key: 'Component',
        get: function get() {
            return !!this.viewDefinition && (0, _layoutComponent.getSelectedView)(this.viewDefinition);
        }
    }]);
    return ConfirmationModalViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'showConfirmationModal', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return false;
    }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'title', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'message', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'confirmLabel', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'confirmBtnClass', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'cancelLabel', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'cancelBtnClass', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return '';
    }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'onConfirmFunc', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'onCancelFunc', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'viewDefinition', [_dec], {
    enumerable: true,
    initializer: function initializer() {
        return null;
    }
}), _applyDecoratedDescriptor(_class.prototype, 'Component', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'Component'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetModal', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetModal'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setModal', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setModal'), _class.prototype)), _class));
;

var _default = ConfirmationModalViewStore;
exports.default = _default;
;

var _temp2 = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ConfirmationModalViewStore, 'ConfirmationModalViewStore', 'src/core_modules/confirmation-modal/viewstore.jsx');

    __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/confirmation-modal/viewstore.jsx');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuBar = exports.Breadcrumbs = exports.ViewControllerMixin = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");

var _values2 = _interopRequireDefault(_values);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec4, _class3, _class4;

exports.getSelectedView = getSelectedView;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ViewControllerMixin = exports.ViewControllerMixin = (0, _mixwith.Mixin)(function (superclass) {
  var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor;

  return _dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = function (_superclass) {
    (0, _inherits3.default)(_class, _superclass);

    function _class() {
      (0, _classCallCheck3.default)(this, _class);

      var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));

      _this.currentViewOptions = {};

      _initDefineProp(_this, '_currentView', _descriptor, _this);

      var trackBreadcrumbs = _this.trackBreadcrumbs !== false && _this.constructor.trackBreadcrumbs !== false;
      var addToBreadcrumbs = _this.addToBreadcrumbs !== false && _this.constructor.addToBreadcrumbs !== false;
      var providedLastCm = _this.props.lastCm;
      _this.insideEditor = _this.props.insideEditor;
      _this.isRoot = _this.props.hasOwnProperty('isRoot') ? _this.props.isRoot : !providedLastCm;

      if (trackBreadcrumbs) {
        _this.lastCm = providedLastCm || _mobx.observable.shallowArray([]);
        _this.viewBreadcrumbs = providedLastCm ? _this.props.viewBreadcrumbs : _mobx.observable.shallowArray([]);
        _this.viewBreadcrumbIndex = _this.viewBreadcrumbs.length;
        if (addToBreadcrumbs) {
          setTimeout(function () {
            // escape this render stack, otherwise get naughty error...
            _this.viewBreadcrumbs.push(_this);
            _this.viewBreadcrumbIndex = _this.viewBreadcrumbs.length;
            var lastViewCm = _this.contentModel || _this.props.contentModel;
            if (lastViewCm) _this.lastCm[0] = lastViewCm;
            if (!lastViewCm) debugger;
          }, 10);
        }
      }

      // setTimeout( () => {

      //   if( !this.viewMap && !Array.isArray( this.views ) ) throw new Error(" missing viewMap object, or views array")
      //   if( !this.viewMap && Array.isArray( this.views ) ){
      //     extendObservable( this, {
      //       get viewMap(){
      //         return this.views.reduce( (acc, item) => {
      //           acc[item.id] = item
      //           return acc;
      //         }, {})
      //       }
      //     })
      //   }
      // }, 10)
      return _this;
    }

    (0, _createClass3.default)(_class, [{
      key: 'selectView',
      value: function selectView(view) {
        var _this2 = this;

        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var editorViewStore = this.props.editorViewStore;

        var unregistered = void 0;
        if (typeof view === "string" && !!this.viewMap[view]) {
          this.currentViewOptions = opts;
          this._currentView !== view && setTimeout((0, _mobx.action)(function () {
            _this2._currentView = view;
          }), 10);
          this.clearView();
        } else if ((typeof view === 'undefined' ? 'undefined' : (0, _typeof3.default)(view)) === "object") {
          var registeredView = this.viewMap[view.id] || view.type && this.viewMap[view.type];
          if (!registeredView && view.getComponent) {
            unregistered = true;
            registeredView = (0, _extends3.default)({}, view, { Component: false, Editor: false, FullEditor: false });
          }
          if (!registeredView) throw new Error("invalid view!");

          if (view.onClick) return view.onClick(view, registeredView, opts);
          if (registeredView.onClick) return registeredView.onClick(view, registeredView, opts);
          this.currentViewOptions = opts;

          //capture supplied contentModel if is BaseContentModel (detect via _slots)
          if (view.slots) this.currentViewOptions.contentModel = view;

          if (unregistered) {
            setTimeout((0, _mobx.action)(function () {
              _this2._currentView = registeredView;
            }), 10);
          } else {
            this._currentView !== registeredView.id && setTimeout((0, _mobx.action)(function () {
              _this2._currentView = registeredView.id;
            }), 10);
          }
          this.clearView();
        } else {
          throw new Error("invalid view!");
        }
      }
    }, {
      key: 'clearView',
      value: function clearView(clearBreadcrumb) {
        var editorViewStore = this.props.editorViewStore;
        //recursive clear view
        // if(this.currentView && typeof this.currentView.clearView === "function"){
        //   debugger
        //   //does this ever actually happen?
        //   this.currentView.clearView();
        // } 

        this._currentView = null;
        if (clearBreadcrumb && this.viewBreadcrumbs && this.viewBreadcrumbs.length) {
          this.viewBreadcrumbs.splice(this.viewBreadcrumbIndex, this.viewBreadcrumbs.length - this.viewBreadcrumbIndex);
          if (this.viewBreadcrumbs.length) {
            var lastView = this.viewBreadcrumbs[this.viewBreadcrumbs.length - 1];
            var lastViewCm = lastView.contentModel || lastView.props.contentModel;
            if (lastViewCm) this.lastCm[0] = lastViewCm;
            if (!lastViewCm) debugger;
          }
        }
        if (editorViewStore && !(this.currentViewOptions && this.currentViewOptions.insideEditor)) editorViewStore.stopEditing();
      }
    }, {
      key: 'goBack',
      value: function goBack(e) {
        var _this3 = this;

        var editorViewStore = this.props.editorViewStore;

        if (this.lastCm) {
          var lastCm = this.lastCm[0];
          if (lastCm && lastCm.isDirty) /*|| (this.contentModel && this.contentModel.isDirty)*/{
              lastCm.handleUnsavedChanges(function () {
                return _this3.clearView(true);
              });
            } else {
            this.clearView(true); //clears Breadcrumbs
          }
        } else {
          this.clearView(true); //clears Breadcrumbs
        }
      }
    }, {
      key: 'currentView',
      get: function get() {
        var _props = this.props,
            dataModel = _props.dataModel,
            contentModel = _props.contentModel;
        var contentModelOverride = this.currentViewOptions.contentModel;

        var viewMap = this.viewMap || this.props.viewMap;
        var view = viewMap && this._currentView ? (0, _typeof3.default)(this._currentView) === "object" ? this._currentView : viewMap[this._currentView] : null;
        if (view) view.contentModel = contentModelOverride || view.contentModel;
        return view;
      }
    }, {
      key: 'SelectedView',
      get: function get() {
        // only want to listen to this.currentView changes in this computed.  everything else is computed by getSelectedView
        return !!this.currentView && getSelectedView.call(this, this.currentView);
      }
    }]);
    return _class;
  }(superclass), (_descriptor = _applyDecoratedDescriptor(_class.prototype, '_currentView', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
      return "";
    }
  }), _applyDecoratedDescriptor(_class.prototype, 'currentView', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'currentView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'SelectedView', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'SelectedView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectView', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearView', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clearView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'goBack', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'goBack'), _class.prototype)), _class);
});

var Breadcrumbs = exports.Breadcrumbs = (_dec4 = (0, _mobxReact.inject)("editorViewStore"), _dec4(_class3 = (0, _mobxReact.observer)(_class3 = function (_BaseComponent) {
  (0, _inherits3.default)(Breadcrumbs, _BaseComponent);

  function Breadcrumbs() {
    (0, _classCallCheck3.default)(this, Breadcrumbs);
    return (0, _possibleConstructorReturn3.default)(this, (Breadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumbs)).apply(this, arguments));
  }

  (0, _createClass3.default)(Breadcrumbs, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          viewstores = _props2.viewstores,
          useDisplayName = _props2.useDisplayName,
          editorViewStore = _props2.editorViewStore;

      var insideEditor = viewstores && viewstores.length && viewstores[0].insideEditor;

      return !!viewstores.length ? _react2.default.createElement(
        'div',
        { className: 'breadcrumbs' },
        viewstores.map(function (viewstore, i, arr) {
          var goBack = viewstore.goBack,
              editItem = viewstore.editItem,
              viewItem = viewstore.viewItem;

          var contentModel = viewstore.contentModel || viewstore.props.contentModel;
          if (!contentModel) throw new Error("malformed viewstore... must have contentModel or props.contentModel");
          var crumb = void 0;
          if (i !== arr.length - 1) {
            crumb = _react2.default.createElement(
              'div',
              { key: contentModel.id + i, onClick: goBack, className: 'crumb' },
              _react2.default.createElement(
                'div',
                null,
                !!useDisplayName && (contentModel.displayName || contentModel.displayTitle) || contentModel.id
              ),
              _react2.default.createElement('span', null)
            );
          } else {
            crumb = _react2.default.createElement(
              'div',
              { key: contentModel.id + i, className: 'crumb-current' },
              !!editorViewStore && !insideEditor && !contentModel.readonly && _react2.default.createElement(
                'span',
                { style: { cursor: "pointer" }, onClick: function onClick(e) {
                    return editItem(contentModel);
                  } },
                '\u270E '
              ),
              !!editorViewStore && !insideEditor && contentModel.Component && _react2.default.createElement(
                'span',
                { style: { cursor: "pointer" }, onClick: function onClick(e) {
                    return viewItem(contentModel);
                  } },
                '\uD83D\uDD0E '
              ),
              !!useDisplayName && (contentModel.displayName || contentModel.displayTitle) || contentModel.id,
              viewstore.hasOwnProperty('selectedCollectionName') && _react2.default.createElement(
                'select',
                { value: viewstore.selectedCollectionName || viewstore.availableCollectionNames[0], disabled: viewstore.availableCollectionNames.length < 2, onChange: function onChange(e) {
                    return viewstore.setCollection(e.target.value);
                  } },
                viewstore.availableCollectionNames.map(function (n) {
                  return _react2.default.createElement(
                    'option',
                    { key: n },
                    n
                  );
                })
              )
            );
          }
          return viewstore.BreadcrumbComponent ? _react2.default.createElement(viewstore.BreadcrumbComponent, { key: contentModel.id + i, originalCrumb: crumb, contentModel: contentModel, isCurrent: true }) : crumb;
        })
      ) : null;
    }
  }]);
  return Breadcrumbs;
}(_baseComponent2.default)) || _class3) || _class3);

var MenuBar = exports.MenuBar = (0, _mobxReact.observer)(_class4 = function (_BaseComponent2) {
  (0, _inherits3.default)(MenuBar, _BaseComponent2);

  function MenuBar() {
    (0, _classCallCheck3.default)(this, MenuBar);
    return (0, _possibleConstructorReturn3.default)(this, (MenuBar.__proto__ || (0, _getPrototypeOf2.default)(MenuBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(MenuBar, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          viewMap = _props3.viewMap,
          clickItem = _props3.clickItem,
          currentView = _props3.currentView,
          currentViewId = _props3.currentViewId;

      var displayItems = (0, _values2.default)(viewMap).filter(function (v) {
        return v.show || v.menu && v.menu.show;
      });
      return _react2.default.createElement(
        'div',
        { className: 'menu' },
        displayItems.map(function (view, index) {
          var iconClass = view.icon || view.contentModel && view.contentModel.icon || "";
          var menu = (0, _assign2.default)({ clickItem: clickItem }, view, view.menu);
          var itemStatus = currentViewId && menu.id === currentViewId || currentView && currentView.id === menu.id ? "active" : "inactive";
          return _react2.default.createElement(
            'span',
            { key: "" + menu.id + index, className: itemStatus },
            _react2.default.createElement(
              'button',
              { className: "menu-item " + iconClass, onClick: function onClick(e) {
                  return !!menu.clickItem && menu.clickItem(view, viewMap);
                }, disabled: menu.hasOwnProperty('enabled') ? !menu.enabled : false },
              menu.displayTitle || menu.displayName || menu.id
            )
          );
        })
      );
    }
  }]);
  return MenuBar;
}(_baseComponent2.default)) || _class4;

function getSelectedView(currentView) {
  if (!currentView) return null;

  var lastCm = void 0,
      viewBreadcrumbs = void 0,
      insideEditor = void 0,
      currentViewOptions = {},
      currentViewProps = currentView.props || {};

  if (this) {
    lastCm = this.lastCm;
    viewBreadcrumbs = this.viewBreadcrumbs;
    insideEditor = this.insideEditor;
    currentViewOptions = this.currentViewOptions || {};
  }

  var viewOptions = (0, _assign2.default)({}, currentViewOptions, currentView.options || {});

  var itemContentModel = currentView.contentModel && currentView.contentModel.getContentModel(viewOptions);

  //take directly provided Component
  //or currentView's contentModel and run getContentModel
  var actualComponent = currentView.Component || itemContentModel && itemContentModel.getComponent(viewOptions);
  if (!actualComponent) throw new Error("missing component for view");

  return function (props) {
    return _react2.default.createElement(actualComponent, (0, _extends3.default)({
      currentView: currentView,
      options: viewOptions,
      contentModel: itemContentModel,
      // @TODO provider/inject these?
      lastCm: lastCm,
      viewBreadcrumbs: viewBreadcrumbs,
      insideEditor: insideEditor
    }, currentViewProps, props));
  };
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ViewControllerMixin, 'ViewControllerMixin', 'src/core_modules/layout-component/index.js');

  __REACT_HOT_LOADER__.register(Breadcrumbs, 'Breadcrumbs', 'src/core_modules/layout-component/index.js');

  __REACT_HOT_LOADER__.register(MenuBar, 'MenuBar', 'src/core_modules/layout-component/index.js');

  __REACT_HOT_LOADER__.register(getSelectedView, 'getSelectedView', 'src/core_modules/layout-component/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _hasInstance = __webpack_require__("./node_modules/babel-runtime/core-js/symbol/has-instance.js");

var _hasInstance2 = _interopRequireDefault(_hasInstance);

var _setPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/set-prototype-of.js");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _symbol = __webpack_require__("./node_modules/babel-runtime/core-js/symbol.js");

var _symbol2 = _interopRequireDefault(_symbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (global, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.mixwith = mod.exports;
  }
})(undefined, function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _cachedApplicationRef = exports._cachedApplicationRef = (0, _symbol2.default)('_cachedApplicationRef');

  var _mixinRef = exports._mixinRef = (0, _symbol2.default)('_mixinRef');

  var _originalMixin = exports._originalMixin = (0, _symbol2.default)('_originalMixin');

  var wrap = exports.wrap = function (mixin, wrapper) {
    (0, _setPrototypeOf2.default)(wrapper, mixin);
    if (!mixin[_originalMixin]) {
      mixin[_originalMixin] = mixin;
    }
    return wrapper;
  };

  var Cached = exports.Cached = function (mixin) {
    return wrap(mixin, function (superclass) {
      // Get or create a symbol used to look up a previous application of mixin
      // to the class. This symbol is unique per mixin definition, so a class will have N
      // applicationRefs if it has had N mixins applied to it. A mixin will have
      // exactly one _cachedApplicationRef used to store its applications.
      var applicationRef = mixin[_cachedApplicationRef];
      if (!applicationRef) {
        applicationRef = mixin[_cachedApplicationRef] = (0, _symbol2.default)(mixin.name);
      }
      // Look up an existing application of `mixin` to `c`, return it if found.
      if (superclass.hasOwnProperty(applicationRef)) {
        return superclass[applicationRef];
      }
      // Apply the mixin
      var application = mixin(superclass);
      // Cache the mixin application on the superclass
      superclass[applicationRef] = application;
      return application;
    });
  };

  var HasInstance = exports.HasInstance = function (mixin) {
    if (_hasInstance2.default && !mixin.hasOwnProperty(_hasInstance2.default)) {
      (0, _defineProperty2.default)(mixin, _hasInstance2.default, {
        value: function value(o) {
          var originalMixin = this[_originalMixin];
          while (o != null) {
            if (o.hasOwnProperty(_mixinRef) && o[_mixinRef] === originalMixin) {
              return true;
            }
            o = (0, _getPrototypeOf2.default)(o);
          }
          return false;
        }
      });
    }
    return mixin;
  };

  var BareMixin = exports.BareMixin = function (mixin) {
    return wrap(mixin, function (superclass) {
      // Apply the mixin
      var application = mixin(superclass);

      // Attach a reference from mixin applition to wrapped mixin for RTTI
      // mixin[@@hasInstance] should use this.
      application.prototype[_mixinRef] = mixin[_originalMixin];
      return application;
    });
  };

  var Mixin = exports.Mixin = function (mixin) {
    return Cached(HasInstance(BareMixin(mixin)));
  };

  var mix = exports.mix = function (superClass) {
    return new MixinBuilder(superClass);
  };

  var MixinBuilder = function () {
    function MixinBuilder(superclass) {
      (0, _classCallCheck3.default)(this, MixinBuilder);

      this.superclass = superclass;
    }

    (0, _createClass3.default)(MixinBuilder, [{
      key: 'with',
      value: function _with() {
        return (0, _from2.default)(arguments).reduce(function (c, m) {
          return m(c);
        }, this.superclass);
      }
    }]);
    return MixinBuilder;
  }();
});
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/project-domain-store/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class2, _temp;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _debounce = __webpack_require__("./node_modules/debounce/index.js");

var _debounce2 = _interopRequireDefault(_debounce);

var _simgateInputStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simgate-input-store/index.js");

var _simgateInputStore2 = _interopRequireDefault(_simgateInputStore);

var _deepExtend = __webpack_require__("./node_modules/deep-extend/lib/deep-extend.js");

var _deepExtend2 = _interopRequireDefault(_deepExtend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ProjectDomainStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, (_class = (_temp = _class2 = function (_SimgateInputStore) {
  (0, _inherits3.default)(ProjectDomainStore, _SimgateInputStore);

  function ProjectDomainStore() {
    (0, _classCallCheck3.default)(this, ProjectDomainStore);

    // //@TODO put this in sim shell?
    // let pauseTimeout;
    // // user timeout functionality @TODO move to global domain store?
    // const checkTimer = debounce( () => {
    //   if(pauseTimeout === true) return          
    //   const thisTime = +new Date;
    //   if(this.hasRefreshed && (thisTime - this.hasRefreshed) > this.timeoutWarningDelay){
    //     this.refreshContext(timeouter);
    //   }
    //   timeouter()
    // }, 100)

    // const timeouter = debounce( () => {
    //   pauseTimeout = true;
    //   shell && shell.confirm && shell.confirm(
    //     "You are about to timeout.  Please click OK to refresh your session.  Please click CANCEL to logout.",
    //     confirm => {
    //       if(confirm){
    //         this.refreshContext(() => {
    //           pauseTimeout = false;
    //           timeouter();
    //         })
    //       }else{
    //         shell.signOut();
    //         return false; // this keeps callback from hiding alert
    //       }
    //     }
    //   )
    // }, this.timeoutWarningDelay );
    // timeouter();

    // document.querySelector("body").addEventListener("mousemove", checkTimer);
    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectDomainStore.__proto__ || (0, _getPrototypeOf2.default)(ProjectDomainStore)).apply(this, arguments));

    _initDefineProp(_this, 'isRefreshing', _descriptor, _this);

    _initDefineProp(_this, 'contextIsLoaded', _descriptor2, _this);

    _initDefineProp(_this, 'hasRefreshed', _descriptor3, _this);

    _initDefineProp(_this, 'context', _descriptor4, _this);

    return _this;
  }

  // timeoutWarningDelay = (1000 * 60) * 45 // minutes

  // @TODO make into computed (hasRefreshed - willRefresh > 0)


  (0, _createClass3.default)(ProjectDomainStore, [{
    key: 'signOut',
    value: function signOut(cb, errCb) {
      this._signOut.apply(this, arguments);
    }
  }, {
    key: '_signOut',
    value: function _signOut(cb, errCb) {
      if (!this.simgate) throw new Error("missing simgate");
      this.simgate.signOut().then(cb).catch(errCb);
    }
  }, {
    key: 'signIn',
    value: function signIn(claim, cb, errCb) {
      var _this2 = this;

      if (!this.simgate) throw new Error("missing simgate");
      var signOutCb = function signOutCb() {
        _this2.simgate.signIn(claim).then(function (res) {
          if (!res || !res.context) throw new Error("Access denied.");
          (0, _deepExtend2.default)(_this2.context, res.context);

          _this2.contextIsLoaded = true;
          if (typeof cb === "function") cb();
        }).catch(errCb);
      };

      this.simgate.signOut().then(signOutCb).catch(signOutCb);
    }
  }, {
    key: 'createUser',
    value: function createUser(create, cb, errCb) {
      if (!this.simgate) throw new Error("missing simgate");
      var taskArgs = [this.simgate.register, {
        pin: "pass",
        path: 3,
        user: create,
        signIn: create.signIn ? true : false,
        init: create.init ? true : false
      }, {
        onSuccess: cb,
        onFailure: errCb
      }];
      if (this.simgate.runTask) {
        var _simgate;

        (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
      } else if (this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.register(taskArgs[1]).then(cb).catch(errCb);
      }
    }
  }, {
    key: 'refreshContext',
    value: function refreshContext(cb, errCb) {
      var _this3 = this;

      if (!this.simgate) throw new Error("missing simgate");
      this.isRefreshing = true;
      var callback = (0, _mobx.action)("getContext-callback", function (res) {
        if (_this3.contextIsLoaded && res.context.pathID === 0) throw new Error('{"IsError":true,"ErrorMessage":"Access denied. Lost simgate context!"}');

        (0, _deepExtend2.default)(_this3.context, res.context);

        _this3.isRefreshing = false;
        _this3.hasRefreshed = +new Date();
        _this3.contextIsLoaded = true;

        if (typeof cb === "function") cb();
      });

      var taskArgs = [this.simgate.getContext, {}, {
        onSuccess: callback,
        onFailure: errCb
      }];
      if (this.simgate.runTask) {
        var _simgate2;

        (_simgate2 = this.simgate).runTask.apply(_simgate2, taskArgs);
      } else if (this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.getContext(taskArgs[1]).then(callback).catch(errCb);
      }

      return this;
    }
  }]);
  return ProjectDomainStore;
}(_simgateInputStore2.default), _class2.id = "domainStore", _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isRefreshing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'contextIsLoaded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'hasRefreshed', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'context', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get username() {
        return this.user.loginName;
      },
      set username(val) {
        this.user.loginName = val;
      },
      user: {
        loginName: "",
        userID: 0,
        // simgate compatibility:
        get id() {
          return this.userID;
        },
        set id(val) {
          this.userID = val;
        },
        pathID: 0,
        roleID: 0,
        // simgate compatibility:
        get roleId() {
          return this.roleID;
        },
        set roleId(val) {
          this.roleID = val;
        },
        email: "",
        properties: ""
      },
      sessionName: "--",
      team: {
        get id() {
          return this.pathId;
        },
        set id(val) {
          this.pathId = val;
        },
        pathId: 0,
        name: "--",
        pathType: 2,
        parentId: 0,
        attr1: 0,
        attr2: 0,
        attr3: 0,
        attr4: 0,
        attr5: 0,
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0
      },
      // @TODO gets set by session selector!
      simParentPathId: 0
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'signOut', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'signOut'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_signOut', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_signOut'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'signIn', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'signIn'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createUser', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createUser'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'refreshContext', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'refreshContext'), _class.prototype)), _class));
exports.default = ProjectDomainStore;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectDomainStore, 'ProjectDomainStore', 'src/core_modules/project-domain-store/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/sim-domain-store/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class2, _temp;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _deepExtend = __webpack_require__("./node_modules/deep-extend/lib/deep-extend.js");

var _deepExtend2 = _interopRequireDefault(_deepExtend);

var _simgateInputStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simgate-input-store/index.js");

var _simgateInputStore2 = _interopRequireDefault(_simgateInputStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SimDomainStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, (_class = (_temp = _class2 = function (_SimgateInputStore) {
  (0, _inherits3.default)(SimDomainStore, _SimgateInputStore);

  function SimDomainStore(opts) {
    (0, _classCallCheck3.default)(this, SimDomainStore);

    // let visitingId = getQueryVariable(window.location.search, "visiting");
    // if(visitingId){
    //   this.visitingId = +visitingId
    //   this.simgate.updateData = this.simgate.execCommand = function(args, cb){ 
    //     console.warn("in readonly mode!");
    //     if(typeof cb === "function") cb(); 
    //   }         
    // }
    var _this = (0, _possibleConstructorReturn3.default)(this, (SimDomainStore.__proto__ || (0, _getPrototypeOf2.default)(SimDomainStore)).apply(this, arguments));

    _initDefineProp(_this, 'teamName', _descriptor, _this);

    _initDefineProp(_this, 'contextIsLoaded', _descriptor2, _this);

    _initDefineProp(_this, 'pathId', _descriptor3, _this);

    _initDefineProp(_this, 'currentRoundNo', _descriptor4, _this);

    _initDefineProp(_this, 'teamStateName', _descriptor5, _this);

    _initDefineProp(_this, 'visitingId', _descriptor6, _this);

    _this.props = opts;
    var _this$props = _this.props,
        simgate = _this$props.simgate,
        projectDomainStore = _this$props.projectDomainStore,
        parentPathId = _this$props.parentPathId,
        simulation = _this$props.simulation;


    _this.teamName = projectDomainStore.context.user.userID + "@" + simulation.id;

    (0, _mobx.when)(function () {
      return _this.contextIsLoaded;
    }, function () {

      var context = window.application.dataModel.domainStore.context;
      // var simulation = window.application.Project.children[0];
      _this.pathId = context.team.pathId;
      _this.currentRoundNo = context.team.num5 || 1;
      _this.teamStateName = context.team.num4 || simulation.rounds[_this.currentRoundNo - 1].teamStates[0].id;

      // reload sim variable data on any teamstate change
      if (_this.loadableVariableNames.length) {
        (0, _mobx.reaction)(function () {
          return _this.teamStateName;
        }, function () {
          return _this.loadData();
        });
      }
    });

    // kick it off
    _this.refreshContext();
    return _this;
  }

  (0, _createClass3.default)(SimDomainStore, [{
    key: 'refreshContext',
    value: function refreshContext(cb, errCb) {
      var _props = this.props,
          simgate = _props.simgate,
          projectDomainStore = _props.projectDomainStore,
          parentPathId = _props.parentPathId,
          simulation = _props.simulation;


      var userId = projectDomainStore.context.user.id;

      // get the team and session information
      var self = this;
      this.simgate.execQuery({
        query: "custom-queries://getContextData",
        parameters: { userId: userId }
      }).then(function (result) {

        projectDomainStore.context.team = {
          id: result.data[0][0].PathID,
          name: result.data[0][0].Name,
          pathId: result.data[0][0].PathID,
          pathType: result.data[0][0].PathType,
          parentId: result.data[0][0].ParentID,
          attr1: result.data[0][0].Attr1,
          attr2: result.data[0][0].Attr2,
          attr3: result.data[0][0].Attr3,
          attr4: result.data[0][0].Attr4,
          attr5: result.data[0][0].Attr5,
          num1: result.data[0][0].Num1,
          num2: result.data[0][0].Num2,
          num3: result.data[0][0].Num3,
          num4: result.data[0][0].Num4,
          num5: result.data[0][0].Num5
        };
        projectDomainStore.context.user.pathId = result.data[0][0].UserTeamID;
        projectDomainStore.context.sessionName = result.data[0][0].SessionName;

        self.pathId = projectDomainStore.context.team.pathId;
        self.currentRoundNo = projectDomainStore.context.team.num5 || 1;
        self.teamStateName = projectDomainStore.context.team.attr4;
        self.parentPathId = projectDomainStore.context.team.parentId;
        self.contextIsLoaded = true;

        if (typeof cb === "function") cb();
      }).catch(errCb);
    }
  }, {
    key: 'completeTask',
    value: function completeTask(cb, errcb) {
      var _this2 = this;

      var getInput = this.getInput,
          setInput = this.setInput,
          saveData = this.saveData,
          _props2 = this.props,
          simulation = _props2.simulation,
          _dtos = _props2.simulation._dtos;


      if (false) {
        setInput(this, "isSimOver", true);
        saveData(function () {
          return _this2.refreshContext(cb, errcb);
        });
      } else {
        var taskArgs = [this.simgate.execCommand, {
          path: this.pathId,
          command: "Advance"
        }, {
          onSuccess: function onSuccess() {
            return _this2.refreshContext(cb, errcb);
          },
          onFailure: errcb
        }];

        if (this.simgate.runTask) {
          var _simgate;

          (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
        } else if (this.simgate.AsyncTask) {
          var asyncTask = new this.simgate.AsyncTask();
          asyncTask.runTask.apply(asyncTask, taskArgs);
        } else {
          this.simgate.execCommand(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
        }
      }
    }
  }, {
    key: 'context',

    // accomodating simgate-domain-store
    get: function get() {
      return { pathID: this.pathId };
    }
  }, {
    key: 'isVisiting',
    get: function get() {
      return !!this.visitingId;
    }

    // @TODO

  }, {
    key: 'inLastState',
    get: function get() {
      var simulation = this.simulation,
          _dtos = this.simulation._dtos;
    }
  }]);
  return SimDomainStore;
}(_simgateInputStore2.default), _class2.id = "domainStore", _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'teamName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'contextIsLoaded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'pathId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'context', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'context'), _class.prototype), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'currentRoundNo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'teamStateName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'visitingId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isVisiting', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isVisiting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'inLastState', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'inLastState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'refreshContext', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'refreshContext'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'completeTask', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'completeTask'), _class.prototype)), _class));
exports.default = SimDomainStore;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimDomainStore, 'SimDomainStore', 'src/core_modules/sim-domain-store/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/decorator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = simboxEditable;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _utils = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function transformElement(props, fn) {
  var changes = {};
  if ((0, _typeof3.default)(props.children) === 'object') {
    var children = _react.Children.toArray(props.children);
    var transformedChildren = children.map(fn);
    changes.children = transformedChildren;
  }

  return changes;
}

function finalizeElement(element, editorViewStore) {
  var addedChanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var dataEditableTransfer = arguments[3];
  var noChildren = arguments[4];

  var changes = transformElement(element.props, function (element) {
    return noChildren ? element : transform(element, editorViewStore, dataEditableTransfer);
  });

  if (addedChanges.children) {
    changes.children = changes.children && changes.children.length ? changes.children.concat(addedChanges.children) : addedChanges.children;
    delete addedChanges.children;
  }

  (0, _assign2.default)(changes, addedChanges);

  return (0, _keys2.default)(changes).length === 0 ? element : (0, _react.cloneElement)(element, changes, changes.children || element.props.children);
}

// this opens the editor's context menu by adding items to its menu
var openContextMenu = (0, _mobx.action)(function (e, menuItems, editorViewStore) {
  editorViewStore.closeMenu();
  var location = { x: e.pageX, y: e.pageY };
  setTimeout(function () {
    return editorViewStore.openMenu(location, menuItems);
  }, 10);
});

function transform(element, editorViewStore, dataEditableTransfer) {
  // return text elements
  if ((typeof element === 'undefined' ? 'undefined' : (0, _typeof3.default)(element)) !== 'object') return element;

  var checkParentArray = false;
  var dataEditable = void 0;
  var initParams = {};
  var hideInMenu = void 0;
  var noChildren = void 0;

  var isReactElement = typeof element.type === "function";

  // is a react element and needs to pass items down to their child dom elements to break the inheritence barrier
  if (isReactElement) {
    return finalizeElement(element, editorViewStore, {
      // "data-editable": element.props["data-editable"], 
      "data-editable-transfer": dataEditableTransfer || element.props["data-editable-transfer"],
      "data-editable-key": element.key // needed for array stuff
    });
  }

  var elementSuppliedDataEditable = element.dataset ? element.dataset.dataEditable : element.props["data-editable"];
  var dataEditableKey = element.props["data-editable-key"];
  dataEditableTransfer = element.props["data-editable-transfer"] || dataEditableTransfer;

  if (!dataEditableTransfer && typeof elementSuppliedDataEditable === "string") {
    throw new Error("cannot initiate data-editable with string, supply contentmodel earlier in the chain");
  } else if (dataEditableTransfer && typeof elementSuppliedDataEditable === "string") {
    // simple inherit mode
    // data-editable={"accessorTo..."}
    // transform to:
    // data-editable={[parentContentModel, "accessorTo..."]}
    dataEditable = [dataEditableTransfer, elementSuppliedDataEditable];
  } else if (elementSuppliedDataEditable) {
    // element's direct "data-editable", override inherited from transform
    if ((0, _typeof3.default)(element.props.children) !== 'object') {
      console.warn("do not place 'editable' on this element, it must have children (no inputs etc)");
      return element;
    }
    dataEditable = elementSuppliedDataEditable;
    // if(dataEditable 
    //   && Array.isArray( dataEditable ) 
    //   && ( dataEditable.length === 2 || dataEditable.length === 3 ) ) debugger
  } else if (dataEditableTransfer && Array.isArray(dataEditableTransfer) && (dataEditableTransfer.length === 2 || dataEditableTransfer.length === 3)) {
    // then dataEditable inherited via transform
    // since this dataEditable has been inherited, will want to check against it
    checkParentArray = true;
    dataEditable = dataEditableTransfer;
  } else if (dataEditableTransfer) {
    // passed via transform also, but no valid parent to check against... keep going
    return finalizeElement(element, editorViewStore, {}, dataEditableTransfer);
  } else if (!dataEditableTransfer) {
    // no data-editable supplied yet, traverse children until we find one
    return finalizeElement(element, editorViewStore);
  }

  // grab some init params if supplied (basic object as 3rd data-editable param)
  if ((0, _typeof3.default)(dataEditable[2]) === "object" && dataEditable[2].constructor.name !== "ObservableArray") {
    initParams = dataEditable.splice(2, 1)[0];
    if (initParams.hideInMenu) {
      hideInMenu = Array.isArray(initParams.hideInMenu) ? initParams.hideInMenu : [initParams.hideInMenu];
      delete initParams.hideInMenu;
    }
    if (initParams.noChildren) {
      noChildren = true;
      delete initParams.noChildren;
    }
  }

  if (dataEditable.length === 3 && dataEditable[2] !== undefined) {
    //not supported yet, so take it down a notch...
    // transform to:
    // data-editable={[parentContentModel, "accessorTo..."]}
    dataEditable = [dataEditable[0][dataEditable[1]], dataEditable[2]];
  }

  var changes = {};
  var editableIcons = [];
  var menuItems = void 0;
  var contentModel = void 0;
  var cmAccessorMode = void 0;

  // at this point dataEditable is either an object or an array. string never makes it!
  switch (dataEditable.length) {
    case undefined:
    case 1:
      // direct mode
      // data-editable={contentModel}
      // one model -> pencil -> directly opens in editor

      // just in case it looks like... data-editable={[contentModel]} check for array
      contentModel = Array.isArray(dataEditable) ? dataEditable[0] : dataEditable;
      changes.className = element.props.className ? element.props.className + " editable" : "editable";

      var handleClick = function handleClick(e) {
        return editorViewStore.startEditing({
          contentModel: contentModel
          // onSave: () => editorViewStore.stopEditing()
        });
      };

      editableIcons.push(_react2.default.createElement('span', {
        key: 'editIcon',
        className: 'editable-icon',
        onClick: handleClick }));
      break;

    case 2:
      contentModel = dataEditable[0];
      if (!(contentModel instanceof _baseContentmodel2.default)) {
        console.warn("not an editable contentModel!" + contentModel);
        return element;
      }
      if (!contentModel.slots) throw new Error("missing slot definition: " + accessor + contentModel.constructor.name);
      var accessor = dataEditable[1];
      var actual = contentModel[accessor];
      // if( actual == null ) throw new Error("property does not refer to an editable contentmodel or array: "+accessor)
      if (!contentModel.slots.hasOwnProperty(accessor)) throw new Error("accessor refers to non-contentmodel");
      var slot = contentModel.slots[accessor];

      var ItemContentModels = [];
      if (Array.isArray(slot)) {
        for (var i in slot) {
          var ItemContentModel = slot[i];
          if (!(0, _utils.checkInstanceOf)(ItemContentModel.prototype, _baseContentmodel2.default.prototype)) {
            console.warn("ItemContentModel " + ItemContentModel.prototype + " accessor refers to non-contentmodel! not supported yet.");
            continue;
          }

          // add all types that inherit from ItemContentModel
          for (var j in window.application.contentModel.types) {
            var SubItemContentModel = window.application.contentModel.types[j];
            if ((0, _utils.checkInstanceOf)(SubItemContentModel.prototype, ItemContentModel.prototype)) {
              ItemContentModels.push(SubItemContentModel);
            }
          }
        }
      } else {
        var _ItemContentModel = slot;
        if ((0, _utils.checkInstanceOf)(_ItemContentModel.prototype, _baseContentmodel2.default.prototype)) {
          // add all types that inherit from ItemContentModel
          for (var _j in window.application.contentModel.types) {
            var _SubItemContentModel = window.application.contentModel.types[_j];
            if ((0, _utils.checkInstanceOf)(_SubItemContentModel.prototype, _ItemContentModel.prototype)) {
              ItemContentModels.push(_SubItemContentModel);
            }
          }
        } else {
          console.warn("ItemContentModel " + _ItemContentModel.prototype + " accessor refers to non-contentmodel! not supported yet.");
        }
      }

      ItemContentModels = ItemContentModels.filter(function (cm, i) {
        return ItemContentModels.indexOf(cm) == i;
      });

      var actualIsArray = actual && (Array.isArray(actual) || actual.constructor && actual.constructor.name === "ObservableArray");
      cmAccessorMode = !actualIsArray;
      var arrayAccessorMode = actualIsArray && !checkParentArray;
      var arrayChildAccessorMode = actualIsArray && checkParentArray;

      // now we will define the menu items and editable icons for all the permutations
      var isReadOnly = contentModel.meta && contentModel.meta[accessor] && contentModel.meta[accessor].readonly;

      if (isReadOnly) {
        //do nothing
      } else if (cmAccessorMode) {
        // parentCm mode:
        // data-editable={[contentModel, "accessorToCM"]}
        // on sub-model -> pencil -> context menu -> edit, replace with existing, replace with new

        if (element.type !== "div" && element.type !== "p" && (0, _typeof3.default)(element.props.children) !== 'object') {
          console.warn("do not place 'editable' on this element, it must have children (no inputs etc)");
          return element;
        }

        changes.className = element.props.className ? element.props.className + " editable" : "editable";

        // make it a computed and re-get contentModel, so it updates properly after replace
        menuItems = (0, _mobx.computed)(function () {
          // naughty. updating state inside a computed!
          var actual = contentModel[accessor];

          var handleCreate = function handleCreate(e) {
            var ItemContentModel = ItemContentModels[e.target.value];
            var num = getRandomIntInclusive(0, 1000);
            var item = new ItemContentModel((0, _extends3.default)({
              id: ItemContentModel.name.replace("ContentModel", "") + "_" + num
            }, initParams));
            editorViewStore.startEditing({
              contentModel: item,
              onSave: function onSave() {
                // add item back to parent after having saved it
                contentModel.updateValue(accessor, item);
                contentModel.saveEntity(function () {
                  return initParams && initParams.onSave && initParams.onSave(contentModel, item);
                });
                // editorViewStore.stopEditing();
              }
            }, contentModel);
          };

          var handleReplace = function handleReplace(e) {
            var replacer = contentModel.$parent.entities.get(e.target.value);
            contentModel.updateValue(accessor, replacer);
            if (!initParams || !initParams.insideEditor) contentModel.saveEntity(function () {
              return initParams && initParams.onSave && initParams.onSave(contentModel, replacer);
            });
            editorViewStore.closeMenu();
          };

          var handleEdit = function handleEdit(e) {
            editorViewStore.startEditing({
              contentModel: actual
              // onSave: () => editorViewStore.stopEditing()
            }, contentModel);
            editorViewStore.closeMenu();
          };

          var handleRemove = function handleRemove(e) {
            contentModel.updateValue(accessor, null);
            if (!initParams || !initParams.insideEditor) contentModel.saveEntity(function () {
              return initParams && initParams.onSave && initParams.onSave(contentModel, replacer);
            });
            editorViewStore.closeMenu();
          };

          var filteredEnts = [];

          if (contentModel._options && contentModel._options.hasOwnProperty(accessor)) {
            filteredEnts = contentModel._options[accessor];
          } else {
            for (var _i in ItemContentModels) {
              filteredEnts = filteredEnts.concat(ItemContentModels[_i].allEntities());
            }
          }

          filteredEnts = filteredEnts.filter(function (cm) {
            return cm !== actual && cm.isAvailable && cm.id && cm.uniqueDisplayName;
          }).sort(function (a, b) {
            if (a.uniqueDisplayName.toLowerCase() < b.uniqueDisplayName.toLowerCase()) return -1;
            if (a.uniqueDisplayName.toLowerCase() > b.uniqueDisplayName.toLowerCase()) return 1;
            return 0;
          });

          var items = {
            create: _react2.default.createElement(
              'div',
              { key: 'create' },
              'Add new: ',
              _react2.default.createElement(
                'select',
                { onChange: handleCreate },
                _react2.default.createElement('option', null),
                (0, _keys2.default)(ItemContentModels).map(function (i) {
                  return _react2.default.createElement(
                    'option',
                    { key: i, value: i },
                    ItemContentModels[i].name
                  );
                })
              )
            ),
            edit: actual ? _react2.default.createElement(
              'span',
              { key: 'edit', onClick: handleEdit },
              'Edit ',
              actual.uniqueDisplayName
            ) : false,
            replace: _react2.default.createElement(
              'div',
              { key: 'replace' },
              actual == null ? 'Add' : 'Replace with',
              ': ',
              _react2.default.createElement(
                'select',
                { value: actual && actual.id, onChange: handleReplace },
                _react2.default.createElement('option', null),
                filteredEnts.map(function (cm) {
                  return _react2.default.createElement(
                    'option',
                    { key: cm.id, value: cm.id },
                    cm.uniqueDisplayName
                  );
                })
              )
            ),
            remove: _react2.default.createElement(
              'span',
              { key: 'remove', onClick: handleRemove },
              'Remove ',
              actual && actual.uniqueDisplayName
            )
          };
          var allReadOnly = true;
          for (var _i2 in ItemContentModels) {
            allReadOnly = allReadOnly && (ItemContentModels[_i2] === _baseContentmodel2.default || ItemContentModels[_i2].readonly);
          }
          if (!filteredEnts.length) delete items.replace;
          if (allReadOnly || actual != null && actual.readonly) delete items.create;
          if (actual == null || editorViewStore.contentModel === actual || editorViewStore.lastCm && editorViewStore.lastCm.length && editorViewStore.lastCm[0] && editorViewStore.lastCm[0] === actual || actual.readonly) delete items.edit && delete items.remove;
          if (hideInMenu) hideInMenu.forEach(function (k) {
            return delete items[k];
          });
          return items;
        });

        editableIcons.push(_react2.default.createElement('span', {
          key: 'editIcon',
          className: 'editable-icon',
          onClick: function onClick(e) {
            openContextMenu(e, menuItems, editorViewStore);
          } }));
      } else if (arrayAccessorMode) {
        // parentArray mode:
        // data-editable={[contentModel, "accessorToArray"]}
        // on array items -> pencil -> context menu -> edit, replace, create new, move up, move down

        // here we setup the parentArray
        // is a content model's property, and is an array

        // @TODO support array of strings and non-contentmodels
        changes.className = element.props.className ? element.props.className + " editable array" : "editable array";

        var handleExisting = function handleExisting(e) {
          var item = contentModel.$parent.entities.get(e.target.value);
          actual.indexOf(item) === -1 && actual.push(item);
          if (!initParams || !initParams.insideEditor) contentModel.saveEntity(function () {
            return initParams && initParams.onSave && initParams.onSave(contentModel);
          });
          editorViewStore.closeMenu();
        };

        var handleCreate = function handleCreate(e) {
          var ItemContentModel = ItemContentModels[e.target.value];
          var num = getRandomIntInclusive(0, 1000);
          var item = new ItemContentModel((0, _extends3.default)({
            id: ItemContentModel.name.replace("ContentModel", "") + "_" + num
          }, initParams));
          editorViewStore.startEditing({
            contentModel: item,
            onSave: function onSave() {
              actual.indexOf(item) === -1 && actual.push(item);
              contentModel.saveEntity(function () {
                return initParams && initParams.onSave && initParams.onSave(contentModel, item);
              });
              // editorViewStore.stopEditing();
            }
          }, contentModel);
        };

        var handleEdit = function handleEdit(e) {
          return editorViewStore.startEditing({
            contentModel: contentModel
            // onSave: () => editorViewStore.stopEditing()
          }, contentModel);
        };

        menuItems = (0, _mobx.computed)(function () {
          var filteredEnts = [];

          if (contentModel._options && contentModel._options.hasOwnProperty(accessor)) {
            filteredEnts = contentModel._options[accessor];
          } else {
            for (var _i3 in ItemContentModels) {
              filteredEnts = filteredEnts.concat(ItemContentModels[_i3].allEntities());
            }
          }

          filteredEnts = filteredEnts.filter(function (cm) {
            return cm.isAvailable && !actual.some(function (item) {
              return item === cm;
            }) && cm.id && cm.uniqueDisplayName;
          }).sort(function (a, b) {
            if (a.uniqueDisplayName.toLowerCase() < b.uniqueDisplayName.toLowerCase()) return -1;
            if (a.uniqueDisplayName.toLowerCase() > b.uniqueDisplayName.toLowerCase()) return 1;
            return 0;
          });

          var items = {
            create: _react2.default.createElement(
              'div',
              { key: 'create' },
              'Add new: ',
              _react2.default.createElement(
                'select',
                { onChange: handleCreate },
                _react2.default.createElement('option', null),
                (0, _keys2.default)(ItemContentModels).map(function (i) {
                  return _react2.default.createElement(
                    'option',
                    { key: i, value: i },
                    ItemContentModels[i].name
                  );
                })
              )
            ),
            existing: _react2.default.createElement(
              'div',
              { key: 'existing' },
              'Add existing: ',
              _react2.default.createElement(
                'select',
                { onChange: handleExisting },
                _react2.default.createElement('option', null),
                filteredEnts.map(function (cm) {
                  return _react2.default.createElement(
                    'option',
                    { key: cm.id, value: cm.id },
                    cm.uniqueDisplayName
                  );
                })
              )
            ),
            edit: _react2.default.createElement(
              'span',
              { key: 'edit', onClick: handleEdit },
              'Edit ',
              contentModel.uniqueDisplayName
            )
          };
          var allReadOnly = true;
          for (var _i4 in ItemContentModels) {
            allReadOnly = allReadOnly && (ItemContentModels[_i4] === _baseContentmodel2.default || ItemContentModels[_i4].readonly || ItemContentModels[_i4].Synthetic);
          }
          if (allReadOnly) delete items.create;
          if (!filteredEnts.length) delete items.existing;
          if (editorViewStore.contentModel === contentModel || editorViewStore.lastCm && editorViewStore.lastCm.length && editorViewStore.lastCm[0] && editorViewStore.lastCm[0] === contentModel || contentModel.readonly) delete items.edit;
          if (hideInMenu) hideInMenu.forEach(function (k) {
            return delete items[k];
          });
          return items;
        });

        editableIcons.push(_react2.default.createElement(
          'button',
          { key: 'addIcon', className: 'btn green add-b', onClick: function onClick(e) {
              return openContextMenu(e, menuItems, editorViewStore);
            } },
          'Add'
        ));
      } else if (arrayChildAccessorMode) {
        // @TODO a more specific way to check if inside iterator than if element.key is preset?
        // parentArray mode, child model:          
        // is simply contentmodel, but parent is a direct array
        // NOTE: when iterating through submodels, each will have its key checked against the last inherited data-editable parent
        // if the parent array contains a contentmodel with an id that matches the array item key, 
        // then the array item methods will be added to it (edit, replace, new, up, down)
        // For ex: {items.map( (item, index) => <div key={item.id}></div> )}
        // *so make sure the key === item.id*
        // identical items cannot exist in a contentmodel array that will have array editable features
        var parentArray = actual;
        var parentCm = contentModel;
        var key = element.key || dataEditableKey;

        // match key against parent array item ids
        var contentModelIndex = key ? parentArray.findIndex(function (cm) {
          return !!key.match("\\$" + cm.id + "$");
        }) : -1;
        // if (contentModelIndex === -1 && key && key.length > 2 ) debugger
        if (contentModelIndex > -1) {
          if ((0, _typeof3.default)(element.props.children) !== 'object') {
            console.warn("do not place 'editable' on this element, it must have children (no inputs etc)");
            return element;
          }

          changes.className = element.props.className ? element.props.className + " editable array-child" : "editable array-child";

          // make it a computed and re-get contentModel, so it updates properly after replace
          menuItems = (0, _mobx.computed)(function () {
            // naughty. updating state inside a computed!
            if (!parentArray.length) return false;
            if (contentModelIndex === parentArray.length) contentModelIndex--;
            var contentModel = parentArray[contentModelIndex];
            var handleRemove = function handleRemove(e) {
              parentArray.remove(contentModel);
              if (!initParams || !initParams.insideEditor) parentCm.saveEntity();
              editorViewStore.closeMenu();
            };

            var handleReplace = function handleReplace(e) {
              var replacer = contentModel.$parent.entities.get(e.target.value);
              parentArray.splice(contentModelIndex, 1, replacer);
              if (!initParams || !initParams.insideEditor) parentCm.saveEntity();
              editorViewStore.closeMenu();
            };

            var handleMoveUp = function handleMoveUp(e) {
              return (0, _mobx.runInAction)(function () {
                if (contentModelIndex !== 0) {
                  parentArray.splice(contentModelIndex - 1, 0, parentArray.splice(contentModelIndex, 1)[0]);
                  contentModelIndex--;
                  if (!initParams || !initParams.insideEditor) parentCm.saveEntity();
                  editorViewStore.closeMenu();
                }
              });
            };

            var handleMoveDown = function handleMoveDown(e) {
              return (0, _mobx.runInAction)(function () {
                if (contentModelIndex !== parentArray.length - 1) {
                  parentArray.splice(contentModelIndex + 1, 0, parentArray.splice(contentModelIndex, 1)[0]);
                  contentModelIndex++;
                  if (!initParams || !initParams.insideEditor) parentCm.saveEntity();
                  editorViewStore.closeMenu();
                }
              });
            };

            var handleEdit = function handleEdit(e) {
              editorViewStore.startEditing({
                contentModel: contentModel
                // onSave: () => editorViewStore.stopEditing()
              }, parentCm);
              editorViewStore.closeMenu();
            };

            var filteredEnts = (contentModel._options && contentModel._options.hasOwnProperty(accessor) ? contentModel._options[accessor] : contentModel.allOfSameType).filter(function (cm) {
              return cm.isAvailable && !parentArray.some(function (item) {
                return item === cm;
              }) && cm.id && cm.uniqueDisplayName;
            }).sort(function (a, b) {
              if (a.uniqueDisplayName.toLowerCase() < b.uniqueDisplayName.toLowerCase()) return -1;
              if (a.uniqueDisplayName.toLowerCase() > b.uniqueDisplayName.toLowerCase()) return 1;
              return 0;
            });

            var items = {
              edit: _react2.default.createElement(
                'span',
                { key: 'edit', onClick: handleEdit },
                'Edit ',
                contentModel.uniqueDisplayName
              ),
              replace: _react2.default.createElement(
                'div',
                { key: 'replace' },
                'Replace with: ',
                _react2.default.createElement(
                  'select',
                  { value: contentModel.id, onChange: handleReplace },
                  _react2.default.createElement('option', null),
                  filteredEnts.map(function (cm) {
                    return _react2.default.createElement(
                      'option',
                      { key: cm.id, value: cm.id },
                      cm.uniqueDisplayName
                    );
                  })
                )
              ),
              remove: _react2.default.createElement(
                'span',
                { key: 'remove', onClick: handleRemove },
                'Remove ',
                contentModel.uniqueDisplayName
              ),
              moveup: contentModelIndex !== 0 ? _react2.default.createElement(
                'span',
                { key: 'moveup', onClick: handleMoveUp },
                'Move up'
              ) : false,
              movedown: contentModelIndex !== parentArray.length - 1 ? _react2.default.createElement(
                'span',
                { key: 'movedown', onClick: handleMoveDown },
                'Move down'
              ) : false
            };
            if (!filteredEnts.length) delete items.replace;
            if (editorViewStore.contentModel === contentModel || editorViewStore.lastCm && editorViewStore.lastCm.length && editorViewStore.lastCm[0] && editorViewStore.lastCm[0] === contentModel || contentModel.readonly) delete items.edit;
            return items;
          });

          editableIcons.push(_react2.default.createElement('span', {
            key: 'editIcon',
            className: 'editable-icon',
            onClick: function onClick(e) {
              openContextMenu(e, menuItems, editorViewStore);
            } }));
        }
      } else {
        console.warn("fell through..." + contentModel.id + accessor);
      }
      break;
    case 3:
      // @TODO!!!
      // combined mode:

      // data-editable={[contentModel, "accessorToCM", "accessorToArray"]}
      // context menu allows directly on sub-model: direct edit, replace, replace with new, add new
      // pencils -> context menu allows on array items: direct edit, replace, create new, move up, move down
      // NOTE: when iterating, your element key must be the contentModel id
      // For ex: {array.map( item => <div key={item.id}></div> )}
      break;
  }

  if (editableIcons.length) changes.children = editableIcons;

  return finalizeElement(element, editorViewStore, changes, cmAccessorMode ? null : dataEditable, noChildren);
}

function simboxEditable(componentClass) {
  var _dec, _class;

  if (!componentClass.isMobXReactObserver) {
    var err = new Error();
    return err.stack;
    console.warn("Please ensure @editable decorator is placed before @observer, otherwise you may experience unpredictable results!");
    console.warn(err.stack);
  }

  var SimboxEditable = (_dec = (0, _mobxReact.inject)("editorViewStore"), _dec(_class = function (_componentClass) {
    (0, _inherits3.default)(SimboxEditable, _componentClass);

    function SimboxEditable() {
      (0, _classCallCheck3.default)(this, SimboxEditable);
      return (0, _possibleConstructorReturn3.default)(this, (SimboxEditable.__proto__ || (0, _getPrototypeOf2.default)(SimboxEditable)).apply(this, arguments));
    }

    (0, _createClass3.default)(SimboxEditable, [{
      key: 'render',
      value: function render() {
        var editorViewStore = this.props.editorViewStore;

        // if in simulation view for ex. just return normal rendered component!

        if (!editorViewStore) return (0, _get3.default)(SimboxEditable.prototype.__proto__ || (0, _getPrototypeOf2.default)(SimboxEditable.prototype), 'render', this).call(this);

        var transfer = {};
        if (this.props["data-editable"]) transfer["data-editable"] = this.props["data-editable"];
        if (this.props["data-editable-key"]) transfer["data-editable-key"] = this.props["data-editable-key"];
        if (this.props["data-editable-transfer"]) transfer["data-editable-transfer"] = this.props["data-editable-transfer"];
        return transform((0, _keys2.default)(transfer).length > 0 ? (0, _react.cloneElement)((0, _get3.default)(SimboxEditable.prototype.__proto__ || (0, _getPrototypeOf2.default)(SimboxEditable.prototype), 'render', this).call(this), transfer) : (0, _get3.default)(SimboxEditable.prototype.__proto__ || (0, _getPrototypeOf2.default)(SimboxEditable.prototype), 'render', this).call(this), editorViewStore);
      }
    }]);
    return SimboxEditable;
  }(componentClass)) || _class);

  // for some reason losing statics when injecting

  (0, _keys2.default)(componentClass).forEach(function (k) {
    return !SimboxEditable.hasOwnProperty(k) && (SimboxEditable[k] = componentClass[k]);
  });

  SimboxEditable.wrappedComponent = componentClass;

  return SimboxEditable;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getRandomIntInclusive, 'getRandomIntInclusive', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(transformElement, 'transformElement', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(finalizeElement, 'finalizeElement', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(openContextMenu, 'openContextMenu', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(transform, 'transform', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(simboxEditable, 'simboxEditable', 'src/core_modules/simbox-editable/decorator.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/editor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditorViewStore = exports.ActionBar = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

var _class, _dec, _dec2, _dec3, _desc, _value, _class2, _descriptor, _class4, _class5, _temp2;

exports.createEditorElement = createEditorElement;
exports.propperCase = propperCase;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__("./node_modules/trix/dist/trix.js");

__webpack_require__("./node_modules/trix/dist/trix.css");

var _reactTrix = __webpack_require__("./node_modules/react-trix/main.js");

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

var _decorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/decorator.js");

var _decorator2 = _interopRequireDefault(_decorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function createEditorElement(k, slots, contentModel, viewStore, initParams) {
  if ((!initParams || !initParams.insideEditor) && viewStore && viewStore.props.insideEditor) {
    initParams = initParams || {};
    initParams.insideEditor = true;
  }
  var ret = void 0;
  var propIsReadOnly = contentModel.readonly || contentModel.meta && contentModel.meta[k] && contentModel.meta[k].readonly;
  var slot = slots[k];
  var options = contentModel._options && contentModel._options[k];
  if (k === "id") {
    ret = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: 'editor-label' },
        'Id: '
      ),
      contentModel.isNew ? _react2.default.createElement('input', { onChange: function onChange(e) {
          return contentModel.updateValue("id", e.target.value);
        }, value: contentModel.id }) : contentModel.id
    );
  } else if (Array.isArray(slot)) {
    //if( slot.length > 1 ) throw new Error("multiple content model types per slot not yet supported")
    var args = initParams ? [contentModel, k, initParams] : [contentModel, k];
    ret = !contentModel.isNew ? _react2.default.createElement(
      'div',
      { 'data-editable': args },
      _react2.default.createElement(
        'span',
        { className: 'editor-label' },
        propperCase(k),
        ':'
      ),
      contentModel[k].map(function (cm) {
        return _react2.default.createElement(
          'div',
          { key: cm.id },
          _react2.default.createElement(
            'span',
            { className: 'editable-item', onClick: function onClick(e) {
                return cm.editable !== false && viewStore.viewItem(cm, initParams);
              } },
            cm.uniqueDisplayName
          )
        );
      }),
      _react2.default.createElement('br', null)
    ) : _react2.default.createElement(
      'div',
      null,
      propperCase(k),
      ': [ ]'
    );
  } else if (slot && slot.prototype && slot.prototype instanceof _baseContentmodel2.default || slot === _baseContentmodel2.default) {
    var _args = initParams ? [contentModel, k, initParams] : [contentModel, k];
    ret = _react2.default.createElement(
      'div',
      { 'data-editable': _args },
      _react2.default.createElement(
        'span',
        { className: 'editor-label' },
        propperCase(k),
        ':'
      ),
      !!contentModel[k] && _react2.default.createElement(
        'span',
        { className: 'editable-item', onClick: function onClick(e) {
            return contentModel[k].editable !== false && viewStore.viewItem(contentModel[k], initParams);
          } },
        contentModel[k].uniqueDisplayName
      )
    );
  } else if (slot == null || (typeof slot === 'undefined' ? 'undefined' : (0, _typeof3.default)(slot)) === "object") {
    console.warn("basic objects not yet supported");
    //simple object
  } else if (typeof slot === "string") {
    if (slot === "Array") {
      ret = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'editor-label' },
          propperCase(k),
          ':'
        ),
        contentModel[k].map(function (str, i) {
          return _react2.default.createElement(
            'div',
            { key: str.replace(/ /g, "").substring(0, 20) + i },
            _react2.default.createElement(
              'span',
              null,
              str
            ),
            ' - ',
            _react2.default.createElement(
              'span',
              { onClick: function onClick() {
                  return contentModel[k].splice(i, 1);
                } },
              'x'
            )
          );
        }),
        _react2.default.createElement('textarea', null),
        _react2.default.createElement(
          'button',
          { onClick: function onClick(e) {
              return e.target.previousSibling.value && contentModel[k].push(e.target.previousSibling.value) && (e.target.previousSibling.value = "");
            } },
          'Add'
        )
      );
    } else if (slot === "RichText" && viewStore && viewStore.swapRichTextToHtml !== true) {
      ret = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'editor-label' },
          propperCase(k),
          ':'
        ),
        viewStore && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('input', {
            type: 'checkbox',
            checked: viewStore.swapRichTextToHtml,
            onChange: function onChange(e) {
              return viewStore.swapRichTextToHtml = true;
            } }),
          ' Swap To HTML'
        ),
        _react2.default.createElement(_reactTrix.TrixEditor, { disabled: propIsReadOnly, id: "trix-" + k, type: 'hidden', name: 'content', value: contentModel[k],
          onChange: function onChange(value) {
            return contentModel.updateValue(k, value);
          } })
      );
    } else if (Array.isArray(options)) {
      ret = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'editor-label' },
          propperCase(k),
          ':'
        ),
        _react2.default.createElement(
          'select',
          { disabled: propIsReadOnly, value: contentModel[k], onChange: function onChange(e) {
              return contentModel.updateValue(k, e.target.value);
            } },
          _react2.default.createElement('option', null),
          options.map(function (o) {
            return _react2.default.createElement(
              'option',
              { key: o },
              o
            );
          })
        )
      );
    } else {
      //simple string
      ret = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'editor-label' },
          propperCase(k),
          ': '
        ),
        slot === "RichText" && viewStore && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('input', {
            type: 'checkbox',
            checked: viewStore.swapRichTextToHtml,
            onChange: function onChange(e) {
              return viewStore.swapRichTextToHtml = false;
            } }),
          _react2.default.createElement(
            'span',
            null,
            'Swap To RichText'
          )
        ),
        _react2.default.createElement('textarea', {
          disabled: propIsReadOnly,
          value: contentModel[k],
          onChange: function onChange(e) {
            return contentModel.updateValue(k, e.target.value);
          }
        }),
        k === "imageUrl" && _react2.default.createElement('img', { src: contentModel[k] })
      );
    }
  } else if (typeof slot === "number") {
    //simple number
    ret = _react2.default.createElement(
      'div',
      null,
      k,
      ': ',
      _react2.default.createElement('input', {
        disabled: propIsReadOnly,
        value: contentModel[k],
        onChange: function onChange(e) {
          return contentModel.updateValue(k, +e.target.value);
        }
      })
    );
  } else if (typeof slot === "boolean") {
    ret = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: 'editor-label' },
        k,
        ':'
      ),
      _react2.default.createElement('input', { id: k,
        disabled: propIsReadOnly,
        type: 'checkbox',
        checked: contentModel[k],
        onChange: function onChange(e) {
          return contentModel.updateValue(k, e.target.checked);
        }
      }),
      _react2.default.createElement(
        'label',
        null,
        _react2.default.createElement('span', null)
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'editable-group' },
    contentModel.invalid && contentModel.invalid[k] && _react2.default.createElement(
      'span',
      { className: "validation-error errorMsg " + k },
      contentModel.invalid[k]
    ),
    !!ret && ret
  );
}

/* Proper case a camel case property name */
function propperCase(propertyName) {
  return propertyName.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
}

var ActionBar = exports.ActionBar = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
  (0, _inherits3.default)(ActionBar, _BaseComponent);

  function ActionBar() {
    (0, _classCallCheck3.default)(this, ActionBar);
    return (0, _possibleConstructorReturn3.default)(this, (ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          contentModel = _props.contentModel,
          onSave = _props.onSave;

      return _react2.default.createElement(
        'div',
        { className: 'editable-group' },
        _react2.default.createElement(
          'button',
          { className: 'btn green upload-b', key: 'save', disabled: !contentModel.allowSave, onClick: function onClick(e) {
              return onSave ? contentModel.saveEntity(function () {
                return onSave(contentModel);
              }) : contentModel.saveEntity();
            } },
          'Save'
        ),
        _react2.default.createElement(
          'button',
          { className: 'btn red cancel-b', key: 'revert', disabled: !contentModel.isDirty, onClick: function onClick(e) {
              return contentModel.revert();
            } },
          'Cancel'
        ),
        contentModel.invalid.hasBrokenRefs && _react2.default.createElement(
          'div',
          null,
          contentModel.invalid.hasBrokenRefs
        )
      );
    }
  }]);
  return ActionBar;
}(_baseComponent2.default)) || _class;

var EditorViewStore = exports.EditorViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class2 = function (_mix$with) {
  (0, _inherits3.default)(EditorViewStore, _mix$with);

  function EditorViewStore() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, EditorViewStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = EditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(EditorViewStore)).call.apply(_ref, [this].concat(args))), _this2), _initDefineProp(_this2, 'swapRichTextToHtml', _descriptor, _this2), _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(EditorViewStore, [{
    key: 'save',
    value: function save(e) {
      var contentModel = this.props.contentModel;
      var id = contentModel.id,
          error = contentModel.error,
          isNew = contentModel.isNew,
          invalid = contentModel.invalid,
          readonly = contentModel.readonly;
      var primaryOptions = this.options;
      var secondaryOptions = this.props.options;

      var options = (0, _extends3.default)({}, secondaryOptions, primaryOptions);

      if (!contentModel) throw new Error("content model missing!");
      var onSave = options.onSave,
          onError = options.onError;

      contentModel.saveEntity(function () {
        return onSave && onSave(contentModel);
      }, onError);
    }
  }, {
    key: 'editItem',
    value: function editItem(item /*, opts = {}*/) {
      if (!(item instanceof _baseContentmodel2.default)) throw new Error("item must be a content model");
      var editorViewStore = this.props.editorViewStore;

      editorViewStore.startEditing(item);
    }
  }, {
    key: 'viewItem',
    value: function viewItem(item) {
      var _this3 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!(item instanceof _baseContentmodel2.default)) throw new Error("item must be a content model");
      if (this.lastCm && this.lastCm.length) {
        var lastCm = this.lastCm[0];
        if (lastCm && lastCm.isDirty) /*|| (this.contentModel && this.contentModel.isDirty)*/{
            lastCm.handleUnsavedChanges(function () {
              return _this3.selectView(item, opts);
            });
          } else {
          this.selectView(item, opts);
        }
      } else {
        this.selectView(item, opts);
      }
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var contentModel = this.props.currentView && this.props.currentView.contentModel || this.props.contentModel;
      return contentModel && (0, _keys2.default)(contentModel.slots).reduce(function (acc, name) {
        if (contentModel.slots[name] && contentModel.slots[name].prototype instanceof _baseContentmodel2.default) {
          var cmType = contentModel.slots[name];
          acc[cmType.name] = {
            id: cmType.name,
            ContentModelType: cmType
          };
        } else if (Array.isArray(contentModel.slots[name])) {
          var _cmType = contentModel.slots[name][0];
          acc[_cmType.name] = {
            id: _cmType.name,
            ContentModelType: _cmType
          };
          if (contentModel.slots[name].length > 1) {
            acc[_cmType.name].ids = [];
            acc[_cmType.name].ContentModelTypes = [];
            for (var i in contentModel.slots[name]) {
              acc[_cmType.name].ids.push(contentModel.slots[name][i].name);
              acc[_cmType.name].ContentModelTypes.push(contentModel.slots[name][i]);
            }
          }
        }
        return acc;
      }, {});
    }
  }]);
  return EditorViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'swapRichTextToHtml', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'save', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'save'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'editItem', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'editItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'viewItem', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'viewItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'viewMap'), _class2.prototype)), _class2));

var DefaultEditor = (0, _decorator2.default)(_class4 = (0, _mobxReact.observer)(_class4 = (_temp2 = _class5 = function (_BaseComponent2) {
  (0, _inherits3.default)(DefaultEditor, _BaseComponent2);

  function DefaultEditor() {
    (0, _classCallCheck3.default)(this, DefaultEditor);
    return (0, _possibleConstructorReturn3.default)(this, (DefaultEditor.__proto__ || (0, _getPrototypeOf2.default)(DefaultEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(DefaultEditor, [{
    key: 'render',
    value: function render() {
      var viewStore = this.viewStore,
          _viewStore = this.viewStore,
          save = _viewStore.save,
          currentView = _viewStore.currentView,
          isRoot = _viewStore.isRoot,
          viewBreadcrumbs = _viewStore.viewBreadcrumbs,
          SelectedView = _viewStore.SelectedView;
      var _props2 = this.props,
          contentModel = _props2.contentModel,
          editorViewStore = _props2.editorViewStore,
          passDownToLeaf = _props2.passDownToLeaf,
          options = _props2.options,
          showButtons = _props2.showButtons,
          children = _props2.children;
      var id = contentModel.id,
          error = contentModel.error,
          isNew = contentModel.isNew,
          invalid = contentModel.invalid,
          readonly = contentModel.readonly,
          EditorAppend = contentModel.EditorAppend;
      // !editorViewStore;
      // const options = primaryOptions || secondaryOptions;

      var hideProps = options && options.hideProps || [];
      var onlyShow = options && options.onlyShow || [];

      return _react2.default.createElement(
        'div',
        null,
        isRoot && _react2.default.createElement(_layoutComponent.Breadcrumbs, { viewstores: viewBreadcrumbs }),
        !currentView ? _react2.default.createElement(
          'div',
          null,
          isNew && _react2.default.createElement(
            'div',
            { className: 'editor-id' },
            createEditorElement("id", contentModel.slots, contentModel)
          ),
          (0, _keys2.default)(contentModel.slots).filter(function (k) {
            return options && (!onlyShow.length || onlyShow.indexOf(k) > -1) && hideProps.indexOf(k) === -1;
          }).map(function (k) {
            return _react2.default.createElement(
              'div',
              { key: k },
              createEditorElement(k, contentModel.slots, contentModel, viewStore, options)
            );
          }),
          showButtons !== false && _react2.default.createElement(ActionBar, { contentModel: contentModel, onSave: save }),
          !!children && children,
          !!EditorAppend && _react2.default.createElement(EditorAppend, { contentModel: contentModel })
        ) : //else IN DIRECT EDIT VIEW
        _react2.default.createElement(SelectedView, null)
      );
    }
  }]);
  return DefaultEditor;
}(_baseComponent2.default), _class5.ViewStore = EditorViewStore, _temp2)) || _class4) || _class4;

// @TODO new content model that has submodels is a special case
// {invalid.children && invalid.children.length && (
//   <div className="errorMessage">These sub-models are invalid or unsaved: {invalid.children.map( (id,ind,arr) => id + ((ind !== arr.length-1) ? ", " : "") )}</div>
// )}


exports.default = DefaultEditor;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(createEditorElement, 'createEditorElement', 'src/core_modules/simbox-editable/editor.js');

  __REACT_HOT_LOADER__.register(propperCase, 'propperCase', 'src/core_modules/simbox-editable/editor.js');

  __REACT_HOT_LOADER__.register(ActionBar, 'ActionBar', 'src/core_modules/simbox-editable/editor.js');

  __REACT_HOT_LOADER__.register(EditorViewStore, 'EditorViewStore', 'src/core_modules/simbox-editable/editor.js');

  __REACT_HOT_LOADER__.register(DefaultEditor, 'DefaultEditor', 'src/core_modules/simbox-editable/editor.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.ViewStore = exports.DefaultEditor = exports.Decorator = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class2, _temp2, _class3;

var _decorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/decorator.js");

Object.defineProperty(exports, 'Decorator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_decorator).default;
  }
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/editor.js");

var _editor2 = _interopRequireDefault(_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var DefaultEditor = exports.DefaultEditor = _editor2.default;

var ViewStore = exports.ViewStore = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.ref, _dec3 = _mobx.observable.ref, _dec4 = _mobx.observable.ref, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, (_class = (_temp2 = _class2 = function (_mix$with) {
  (0, _inherits3.default)(EditorViewStore, _mix$with);

  function EditorViewStore() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EditorViewStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(EditorViewStore)).call.apply(_ref, [this].concat(args))), _this), _this.insideEditor = true, _initDefineProp(_this, 'options', _descriptor, _this), _initDefineProp(_this, 'currentLocation', _descriptor2, _this), _initDefineProp(_this, 'contentModel', _descriptor3, _this), _initDefineProp(_this, 'availableMenuItems', _descriptor4, _this), _initDefineProp(_this, 'menu', _descriptor5, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EditorViewStore, [{
    key: 'openMenu',
    value: function openMenu(location, menuItems) {
      this.menu = menuItems;
      this.currentLocation = location;
    }
  }, {
    key: 'startEditing',
    value: function startEditing(contentModel /*, parent*/) {
      var _this2 = this;

      var opts = { forceBasicEditor: true, insideEditor: true };
      if (!(contentModel instanceof _baseContentmodel2.default) && (typeof contentModel === 'undefined' ? 'undefined' : (0, _typeof3.default)(contentModel)) === "object") {
        (0, _assign2.default)(opts, contentModel);
        contentModel = contentModel.contentModel;
        delete opts.contentModel;
      }

      var lastCm = this.lastCm && this.lastCm.length && this.lastCm[0];
      if (this.isEditorOpen && lastCm === contentModel) return;

      // check if lastCm slots contain the incoming CM
      var lastCmIsParent = void 0;

      if (lastCm && (contentModel.isNew && (0, _keys2.default)(lastCm.slots).some(function (i) {
        return (Array.isArray(lastCm.slots[i]) ? lastCm.slots[i][0] === contentModel.constructor : lastCm.slots[i] === contentModel.constructor) || lastCm.childConstructor === contentModel.constructor;
      }) || !contentModel.isNew && lastCm.immediateChildren.some(function (e) {
        return e === contentModel;
      }))) {
        lastCmIsParent = true;
      }

      var confirmed = true;
      if (lastCm && lastCm.isDirty) /*|| (this.contentModel && this.contentModel.isDirty)*/{
          confirmed = confirm("You have unsaved changes in " + lastCm.uniqueDisplayName + ".  If you continue you will lose these changes!  Press cancel to go back.");
          if (confirmed) lastCm.revert();
        }
      if (confirmed) {
        this.currentLocation = null;
        this.availableMenuItems.clear();
        this.menu = null;
        if (!lastCmIsParent) {
          this.options = opts;
          this.contentModel = null;
          this.clearView(true); //clear breadcrumbs
          setTimeout(function () {
            _this2.contentModel = contentModel;
            _this2.selectView(contentModel, opts);
          }, 10);
        } else {
          if (!this.viewBreadcrumbs.length) throw new Error("something went wrong with your breadcrumbs!");
          var lastView = this.viewBreadcrumbs[this.viewBreadcrumbs.length - 1];
          if (!lastView.selectView) {
            console.warn("you are missing selectView from your editor... necessary for breadcrumbs");
            this.options = opts;
            this.contentModel = null;
            this.clearView(true); //clear breadcrumbs
            setTimeout(function () {
              _this2.contentModel = contentModel;
              _this2.selectView(contentModel, opts);
            }, 10);
          } else {
            lastView.selectView(contentModel, opts);
          }
        }
      }
    }
  }, {
    key: 'stopEditing',
    value: function stopEditing() {
      var confirmed = true;
      if (this.lastCm && this.lastCm.length) {
        var lastCm = this.lastCm[0];
        if (lastCm && lastCm.isDirty) {
          // if(lastCm && lastCm.isDirty){
          confirmed = confirm("You have unsaved changes in " + lastCm.uniqueDisplayName + ".  If you continue you will lose these changes!  Press cancel to go back.");
          if (confirmed) lastCm.revert();
        }
      }
      if (confirmed) {
        this.currentLocation = null;
        this.options = {};
        this.menu = null;
        this.availableMenuItems.clear();
        this.contentModel = null;
        this.clearView(true);
        // @TODO should this be in clearView?
        this.lastCm.clear();
      }
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu(e) {
      // if(this.isMenuOpen){    
      this.currentLocation = null;
      this.availableMenuItems.clear();
      this.menu = null;
      // }
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var contentModel = this.contentModel;
      return contentModel && (0, _keys2.default)(contentModel.slots).reduce(function (acc, name) {
        if (contentModel.slots[name] && contentModel.slots[name].prototype instanceof _baseContentmodel2.default) {
          var cmType = contentModel.slots[name];
          acc[cmType.name] = {
            id: cmType.name,
            ContentModelType: cmType
          };
        } else if (Array.isArray(contentModel.slots[name])) {
          var _cmType = contentModel.slots[name][0];
          acc[_cmType.name] = {
            id: _cmType.name,
            ContentModelType: _cmType
          };
          if (contentModel.slots[name].length > 1) {
            acc[_cmType.name].ids = [];
            acc[_cmType.name].ContentModelTypes = [];
            for (var i in contentModel.slots[name]) {
              acc[_cmType.name].ids.push(contentModel.slots[name][i].name);
              acc[_cmType.name].ContentModelTypes.push(contentModel.slots[name][i]);
            }
          }
        }
        return acc;
      }, {});
    }

    // this viewstore gets instantiated globally (outside of the component) and injected where needed 

  }, {
    key: 'menuItems',
    get: function get() {
      if (this.menu && (0, _mobx.isComputed)(this.menu)) {
        return (0, _values2.default)(this.menu.get());
      } else {
        return [];
      }
    }
  }, {
    key: 'isMenuOpen',
    get: function get() {
      return !!this.currentLocation && !!this.menuItems.length;
    }
  }, {
    key: 'isEditorOpen',
    get: function get() {
      return !!this.currentView;
    }
  }, {
    key: 'calculatedLocation',
    get: function get() {
      if (!this.currentLocation) return;
      var _currentLocation = this.currentLocation,
          x = _currentLocation.x,
          y = _currentLocation.y;


      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      return {
        x: x > width - 350 ? width - 350 : x,
        y: y > height - 200 ? y - 100 : y
      };
    }
  }]);
  return EditorViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), _class2.addToBreadcrumbs = false, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, 'options', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'currentLocation', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'contentModel', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'availableMenuItems', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'menu', [_dec4], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'menuItems', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'menuItems'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isMenuOpen', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isMenuOpen'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isEditorOpen', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isEditorOpen'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'calculatedLocation', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'calculatedLocation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openMenu', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'openMenu'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'startEditing', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'startEditing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'stopEditing', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'stopEditing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeMenu', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'closeMenu'), _class.prototype)), _class));

var Component = exports.Component = (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = function (_BaseComponent) {
  (0, _inherits3.default)(Editor, _BaseComponent);

  // static ViewStore = ViewStore // for global editor, instantiats viewStore in layout
  function Editor() {
    (0, _classCallCheck3.default)(this, Editor);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (Editor.__proto__ || (0, _getPrototypeOf2.default)(Editor)).apply(this, arguments));

    var body = document.getElementsByTagName("body")[0];
    if (body.bodyHandled) return (0, _possibleConstructorReturn3.default)(_this3);
    // since Editor is only instantiated once, this is fine:
    body.addEventListener("click", function (e) {
      if (e.target.tagName === "SELECT" || e.target.tagName === "OPTION") {
        return;
      }
      setTimeout(function () {
        return _this3.viewStore.closeMenu();
      }, 10);
    });
    body.bodyHandled = true;
    return _this3;
  }

  (0, _createClass3.default)(Editor, [{
    key: 'render',
    value: function render() {
      var _viewStore = this.viewStore,
          SelectedView = _viewStore.SelectedView,
          isEditorOpen = _viewStore.isEditorOpen,
          isMenuOpen = _viewStore.isMenuOpen,
          menuItems = _viewStore.menuItems,
          stopEditing = _viewStore.stopEditing,
          startEditing = _viewStore.startEditing,
          options = _viewStore.options,
          calculatedLocation = _viewStore.calculatedLocation;


      return _react2.default.createElement(
        'div',
        { className: isEditorOpen ? "open" : "closed" },
        _react2.default.createElement(
          'div',
          null,
          isEditorOpen && _react2.default.createElement(
            'div',
            { className: 'editor' },
            _react2.default.createElement(
              'div',
              { className: 'editor-actions' },
              _react2.default.createElement(
                'span',
                { className: 'editor-title' },
                'Editor'
              ),
              _react2.default.createElement(
                'span',
                { key: 'close', className: 'btn-b times-a', onClick: function onClick(e) {
                    return stopEditing();
                  } },
                'Close'
              )
            ),
            _react2.default.createElement(SelectedView, { key: 'editor', isRoot: true /* telling this component its root so IT will render breadcrumbs */ })
          )
        ),
        isMenuOpen && _react2.default.createElement(
          'div',
          { className: 'context-menu', style: { top: calculatedLocation.y, left: calculatedLocation.x } },
          menuItems.map(function (cm) {
            if (Array.isArray(cm)) {
              var result = [];
              for (var i = 0; i < cm.length; ++i) {
                result.push(_react2.default.createElement(
                  'div',
                  { className: 'item', key: (cm[i].id || cm[i].key || cm[i].props.key) + i },
                  cm[i] instanceof _baseContentmodel2.default ? cm[i].uniqueDisplayName : cm[i]
                ));
              }
              return result;
            } else {
              return cm ? _react2.default.createElement(
                'div',
                { className: 'item', key: cm.id || cm.key || cm.props.key },
                cm instanceof _baseContentmodel2.default ? cm.uniqueDisplayName : cm
              ) : false;
            }
          })
        )
      );
    }
  }]);
  return Editor;
}(_baseComponent2.default)) || _class3) || _class3;
var _default = Component;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DefaultEditor, 'DefaultEditor', 'src/core_modules/simbox-editable/index.js');

  __REACT_HOT_LOADER__.register(ViewStore, 'ViewStore', 'src/core_modules/simbox-editable/index.js');

  __REACT_HOT_LOADER__.register(Component, 'Component', 'src/core_modules/simbox-editable/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/simbox-editable/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/simgate-contentmodel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrphansContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2, _dec, _dec2, _dec3, _desc2, _value2, _class3, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _collectionGridEditor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/collection-grid-editor/index.js");

var _collectionGridEditor2 = _interopRequireDefault(_collectionGridEditor);

var _typeEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/type-entity/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var OrphansContentModel = exports.OrphansContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(OrphansContentModel, _BaseContentModel);

  function OrphansContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OrphansContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrphansContentModel.__proto__ || (0, _getPrototypeOf2.default)(OrphansContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.readonly = true, _this.savable = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OrphansContentModel, [{
    key: 'orphans',
    get: function get() {
      return this.$parent.entities.values().filter(function (e) {
        return !e.constructor.Synthetic && e.isOrphan;
      });
    }
  }]);
  return OrphansContentModel;
}(_baseContentmodel2.default), _class2.Synthetic = true, _class2._slots = {
  orphans: [_baseContentmodel2.default]
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'orphans', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'orphans'), _class.prototype)), _class);
var ContentModel = (_dec = _mobx.observable.shallow, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class3 = function () {
  function ContentModel() {
    var _this2 = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ContentModel);

    _initDefineProp(this, 'types', _descriptor, this);

    _initDefineProp(this, 'willLoad', _descriptor2, this);

    _initDefineProp(this, 'hasLoaded', _descriptor3, this);

    _initDefineProp(this, 'willHydrate', _descriptor4, this);

    _initDefineProp(this, 'hasHydrated', _descriptor5, this);

    _initDefineProp(this, 'hasHydratedProject', _descriptor6, this);

    this.entities = _mobx.observable.shallowMap({});

    if (!(process && __webpack_require__.i({"api":"simgate","NODE_ENV":"production","localMode":false}) && false) && !opts.simgate) {
      throw new Error("content model requires a simgate instance");
    }
    if (!opts.webpackLoader) throw new Error("missing webpackLoader!");
    (0, _assign2.default)(this, opts);
    (0, _mobx.extendObservable)(this.types, this.getContentModels(this.webpackLoader));

    _baseContentmodel2.default.$parent = this;

    (0, _keys2.default)(this.types).filter(function (typeName) {
      return !_this2.types[typeName].Synthetic;
    }).forEach(function (typeName) {
      var type = _this2.types[typeName];
      var id = typeName;
      var typed = new _typeEntity.ContentModel({ id: id });
      _this2.entities.set(id, typed);
    });

    this.entities.set("Orphans", new OrphansContentModel({ id: "Orphans" }));
  }

  (0, _createClass3.default)(ContentModel, [{
    key: 'getContentModels',
    value: function getContentModels(loader) {
      var _this3 = this;

      var obj = {};
      loader.keys().forEach(function (k) {
        var module = loader(k);
        if (module.ContentModels) {
          (0, _keys2.default)(module.ContentModels).forEach(function (k2) {
            //do not attach default
            if (k2 === "default") return;
            // attach parent contentModel dictionary
            module.ContentModels[k2].$parent = _this3;
            obj[k2] = module.ContentModels[k2];
          });
        }
      });
      return obj;
    }
  }, {
    key: 'hydrateEntities',
    value: function hydrateEntities() {
      var _this4 = this;

      var contentModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.willHydrate = +new Date();
      // hydrate base entities into contentmodel
      var obj = (0, _keys2.default)(contentModel).reduce(function (acc, k) {
        var entity = contentModel[k];
        if (!entity || !entity.attr1) {
          console.log("entity rejected due to missing or broken JSON: " + entity.name);
          return acc;
        }

        var type = entity.tag;
        if (typeof entity.attr1 !== "string") throw new Error("malformed attr1" + entity.name);
        var data = void 0;

        try {
          data = JSON.parse(entity.attr1);
        } catch (e) {
          console.log("entity rejected due to broken JSON in attr1: " + entity.name);
          return acc;
        }

        data.guid = entity.id || "guid";
        var existingEntity = _this4.entities.get(k);
        if (existingEntity) {
          // if already registered
          existingEntity.populate(data);
          existingEntity._dateAdded = entity.dateAdded;
          existingEntity._dateEdited = entity.dateEdited;
          existingEntity._lastReview = entity.val;
        } else {
          var ItemContentModel = _this4.types[type];
          if (!ItemContentModel) {
            console.warn("missing contentmodel class for " + type);
            return acc;
          }
          acc[k] = new ItemContentModel(data, _this4.loaders);
          acc[k]._dateAdded = entity.dateAdded;
          acc[k]._dateEdited = entity.dateEdited;
          acc[k]._lastReview = entity.val;
        }
        return acc;
      }, {});

      var output = [];
      if ((0, _keys2.default)(obj).length) {
        this.entities.merge(obj);
        this.entities.keys(obj).forEach(function (k) {
          var ent = _this4.entities.get(k);
          ent.populate();
          output.push(ent);
        });
      }
      this.hasHydrated = +new Date();
      return output;
    }
  }, {
    key: 'loadEntities',
    value: function loadEntities(cb, errCb) {
      var _this5 = this;

      //overwritten in simgate-contentmodel.local.js
      if (this.isLoading) return cb && cb();
      this.willLoad = +new Date();

      // when loading in stage / prod, only use static entities.json
      if (window.trcAppSettings && window.trcAppSettings.environment !== 'dev' && window.trcAppSettings.environment !== 'qa' && window.trcAppSettings.environment !== 'demo' && window.trcAppSettings.environment !== 'authoring' && window.trcAppSettings.environment !== 'auth') {
        __webpack_require__.e/* require.ensure */(1).then((function () {
          var entities = __webpack_require__("./app/config/entities.json");
          if (!entities || !entities.entities || !entities.entities.length) throw new Error("content is missing!");
          entities = entities.entities;
          var ents = entities.reduce(function (acc, i) {
            return (acc[i.name] = i) && acc;
          }, {});
          _this5.hasLoaded = +new Date();
          _this5.hydrateEntities(ents);
          if (typeof cb === "function") cb(_this5);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      } else {
        if (!this.simgate) throw new Error("missing simgate");

        var taskArgs = [this.simgate.execQuery, {
          "query": "simbox-queries://getall"
        }, {
          onSuccess: function onSuccess(res) {
            var ents = res && res.data && res.data[0] && res.data[0].reduce(function (acc, i) {
              return (acc[i.name] = i) && acc;
            }, {});
            _this5.hasLoaded = +new Date();
            _this5.hydrateEntities(ents || {});
            if (typeof cb === "function") cb(_this5);
          },
          onFailure: errCb
        }];

        if (this.simgate.runTask) {
          var _simgate;

          (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
        } else {
          this.simgate.execQuery(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
        }
      }
      return this;
    }
  }, {
    key: 'deleteAllEntities',
    value: function deleteAllEntities(cb, errCb, ents) {
      // const entities = ents.length ? ents : this.entities.values()
      // @TODO if ents provided, only delete those
      // @TODO we need a mechanism for tracking isolated entities, those perhaps can be deleted
      this.simgate.execQuery({
        "query": "simbox-queries://deleteall"
      }).then(cb).catch(errCb);
    }
  }]);
  return ContentModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class3.prototype, 'types', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return {
      //gets extended in constructor
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class3.prototype, 'willLoad', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, 'hasLoaded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'willHydrate', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'hasHydrated', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'hasHydratedProject', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'loadEntities', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'loadEntities'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'deleteAllEntities', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'deleteAllEntities'), _class3.prototype)), _class3));
exports.default = ContentModel;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OrphansContentModel, 'OrphansContentModel', 'src/core_modules/simgate-contentmodel/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/core_modules/simgate-contentmodel/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/simgate-datamodel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");

var _values2 = _interopRequireDefault(_values);

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineEnumerableProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineEnumerableProperties.js");

var _defineEnumerableProperties3 = _interopRequireDefault(_defineEnumerableProperties2);

var _defineProperty4 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class2, _temp;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _simgateInputStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simgate-input-store/index.js");

var _simgateInputStore2 = _interopRequireDefault(_simgateInputStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty3.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DataModel = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.shallow, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, (_class = (_temp = _class2 = function (_SimgateInputStore) {
  (0, _inherits3.default)(DataModel, _SimgateInputStore);

  function DataModel() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, DataModel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DataModel.__proto__ || (0, _getPrototypeOf2.default)(DataModel)).apply(this, arguments));

    _this.wait = null;
    _this.loadDebounceTime = 500;
    _this.globalMode = true;

    _initDefineProp(_this, 'loadWasRequested', _descriptor, _this);

    _initDefineProp(_this, 'loadWasSuccess', _descriptor2, _this);

    _initDefineProp(_this, 'loadWasFailure', _descriptor3, _this);

    _initDefineProp(_this, 'domainStore', _descriptor4, _this);

    _initDefineProp(_this, 'stores', _descriptor5, _this);

    _initDefineProp(_this, 'queuedStores', _descriptor6, _this);

    _initDefineProp(_this, '_pathId', _descriptor7, _this);

    var stores = opts.stores,
        pathId = opts.pathId;

    // grab the init stores

    if (pathId) _this._pathId = opts.pathId;

    stores && stores.forEach(function (s) {
      return _this.addStore(s);
    });

    // set up loading listener, debounce
    (0, _mobx.reaction)(function () {
      return _this.loadWasRequested;
    }, function () {
      return _this.loadData();
    }, {
      delay: _this.loadDebounceTime || 0,
      fireImmediately: true
    });

    return _this;
  } // a mobx "when" gets attached if path not ready
  // in ms
  // global indirection / loading mode

  // loading hooks
  // optional, referenced for pathId if exists
  // stores registered
  // currently queued stores (for loading)

  (0, _createClass3.default)(DataModel, [{
    key: 'isStoreQueued',

    // pending mobx fix
    // set pathId(val){
    //   debugger
    //   this._pathId = val;
    // }

    value: function isStoreQueued(store) {
      return this.queuedStores.some(function (i) {
        return i === store;
      });
    }
  }, {
    key: 'addStore',
    value: function addStore(Store) {
      var _this2 = this;

      var extensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (extensions.id && this[extensions.id]) {
        if (!this[extensions.id].isLoaded) this[extensions.id].loadData();
        console.log("returning existing store: " + extensions.id);
        return this[extensions.id];
      }

      if (!Store.prototype) throw new Error("store already initialiazed, or incorrect type");

      var AdaptedStore = this.adaptInputStore(Store);

      var store = new AdaptedStore((0, _assign2.default)({ simgate: this.simgate }, extensions));

      var id = store.id;
      if (this[id]) {
        if (!this[id].isLoaded) this[id].loadData();
        console.log("returning existing store: " + id);
        return this[id];
      }

      store.loadableVariableNames.forEach(function (k) {
        return _this2.addKey(k, store);
      });

      //add to dataModel
      this[id] = store;
      this.stores.push(store);

      if (!store.isLoaded) {
        (0, _mobx.when)(function () {
          return _this2.pathId;
        }, function () {
          return store.loadData();
        });
      }

      return store;
    }
  }, {
    key: 'addKey',
    value: function addKey(key, store) {
      var _store$extendData, _mutatorMap;

      var globalStore = this;
      if (!this.inputs.hasOwnProperty(key)) {
        this.extendData(this.inputs, (0, _defineProperty5.default)({}, key, store.inputs[key] || null));
      }

      // dereference to global store
      if (store.inputs.$mobx && store.inputs.$mobx.values.hasOwnProperty(key)) {
        delete store.inputs.$mobx.values[key];
        delete store.inputs.$mobx.target[key];
        delete store.inputs[key];
      }

      store.extendData(store.inputs, (_store$extendData = {}, _mutatorMap = {}, _mutatorMap[key] = _mutatorMap[key] || {}, _mutatorMap[key].get = function () {
        return globalStore.inputs[key];
      }, _mutatorMap[key] = _mutatorMap[key] || {}, _mutatorMap[key].set = function (val) {
        globalStore.inputs[key] = val;
      }, (0, _defineEnumerableProperties3.default)(_store$extendData, _mutatorMap), _store$extendData));
    }
  }, {
    key: 'adaptInputStore',
    value: function adaptInputStore(Store) {
      var _dec9, _desc2, _value2, _class3, _class4, _temp2;

      if (this.globalMode === false) return Store;
      var self = this;
      var id = Store.id || Store.name;

      return _dec9 = _mobx.action.bound, (_class3 = (_temp2 = _class4 = function (_Store) {
        (0, _inherits3.default)(_class3, _Store);

        function _class3() {
          (0, _classCallCheck3.default)(this, _class3);

          var _this3 = (0, _possibleConstructorReturn3.default)(this, (_class3.__proto__ || (0, _getPrototypeOf2.default)(_class3)).apply(this, arguments));

          _this3.$parent = self;

          delete _this3.constructor.name;
          Object.defineProperty(_this3.constructor, "name", {
            enumerable: true,
            value: "AdaptedByDataModel_" + id
          });
          return _this3;
        }

        (0, _createClass3.default)(_class3, [{
          key: 'loadData',
          value: function loadData(cb, errCb, forceRetry) {
            var _this4 = this,
                _arguments = arguments;

            // in this context, this === store
            if (this.isLoading) {
              // force reload
              if (forceRetry) (0, _mobx.when)(function () {
                return _this4.isLoaded;
              }, function () {
                return _this4.loadData.apply(_this4, _arguments);
              });
              return console.warn("already loading...");
            }

            this.dataWillLoad = +new Date();

            // we'll want to clear data to make way for the new, but only if we've
            // already saved once (dont want to wipe defaults)
            if (this.dataWasSaved) {
              this.clearData();
            }

            // make an official load request
            this.$parent.requestLoad(this);

            var cachedDataWillLoad = this.$parent.dataWillLoad;

            (0, _mobx.when)(
            //next iteration that data will load
            function () {
              return _this4.$parent.dataWillLoad > cachedDataWillLoad;
            }, function () {
              // listening for dataModel loadWasSuccess
              var rxn1 = (0, _mobx.reaction)(function () {
                return _this4.$parent.loadWasSuccess;
              }, function () {
                _this4.dataWasLoaded = +new Date();
                cb && cb();
                rxn1();
                rxn2();
              });

              // listening for dataModel loadWasFailure
              var rxn2 = (0, _mobx.reaction)(function () {
                return _this4.$parent.loadWasFailure;
              }, function () {
                errCb && errCb(_this4.$parent.loadWasFailure.error);
                rxn1();
                rxn2();
              });
            });
          }
        }]);
        return _class3;
      }(Store), _class4.id = id, _temp2), (_applyDecoratedDescriptor(_class3.prototype, 'loadData', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'loadData'), _class3.prototype)), _class3);
    }
  }, {
    key: 'requestLoad',
    value: function requestLoad(store) {
      // add to queued stores in datamodel
      if (!this.isStoreQueued(store)) {
        this.queuedStores.push(store);
      }

      // officially request load
      this.loadWasRequested = +new Date();
    }
  }, {
    key: 'saveData',
    value: function saveData() {
      console.warn("dont do this! save data by store individually");
    }
  }, {
    key: 'loadData',
    value: function loadData(onSuccess, onFail) {
      var _this5 = this;

      if (!this.pathId || this.isLoading) {
        !this.pathId && console.log("waiting for pathId...");
        this.isLoading && console.log("waiting for loading to stop...");
        return this.wait || (this.wait = (0, _mobx.when)(function () {
          return _this5.pathId && !_this5.isLoading;
        }, function () {
          delete _this5.wait;
          _this5.loadData();
        }));
      }
      console.log("loading datamodel:", this.queuedStores.map(function (k) {
        return k.id;
      }).join(", "));

      this.dataWillLoad = +new Date();

      // make a local clone 
      var queuedStores = this.queuedStores.slice();

      // clear queue now that we're kicking this off!
      this.queuedStores.clear();

      // get all variable names for the stores we will load
      var allVarNames = queuedStores.reduce(function (accumulator, store) {
        accumulator.unshift.apply(accumulator, (0, _toConsumableArray3.default)(store.loadableVariableNames));
        return accumulator;
      }, []);

      if (!allVarNames.length) {
        console.log("nothing to load");
        return setTimeout((0, _mobx.action)("nothingToLoad", function () {
          _this5.loadWasSuccess = _this5.dataWasLoaded = +new Date();
        }), 10);
      }

      var taskArgs = [this.simgate.selectData, {
        select: allVarNames,
        path: this.pathId
      }, {
        //wrap in action for mobx transaction purposes (only refresh views after complete)
        onSuccess: (0, _mobx.action)("loadData-callback", function (res) {

          // @TODO still works this way after fix?
          _this5.setState((0, _values2.default)(res.selected), (0, _keys2.default)(res.selected));

          queuedStores.forEach(function (store) {
            return store.updateCache && store.updateCache();
          });
          _this5.loadWasSuccess = _this5.dataWasLoaded = +new Date();

          if (typeof onSuccess === "function") {
            onSuccess(res);
          }
          if (typeof _this5.onSuccess === "function") {
            _this5.onSuccess(res);
          }
        }),
        onFailure: (0, _mobx.action)("loadData-error", function (err) {
          _this5.loadWasFailure = {
            time: +new Date(),
            error: err
          };

          if (typeof onFail === "function") {
            onFail(err);
          }
          if (typeof _this5.onFail === "function") {
            _this5.onFail(err);
          }
        })
      }];

      if (this.simgate.runTask) {
        var _simgate;

        (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
      } else if (this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.selectData(taskArgs[1]).then(taskArgs[2].onSuccess).catch(taskArgs[2].onFailure);
      }
    }
  }, {
    key: 'pathId',
    // manual pathId override
    get: function get() {
      return this._pathId || this.domainStore && this.domainStore.context.pathID;
    }
  }]);
  return DataModel;
}(_simgateInputStore2.default), _class2.id = "dataModel", _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'loadWasRequested', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'loadWasSuccess', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'loadWasFailure', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      time: 0,
      error: null
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'domainStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'stores', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'queuedStores', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, '_pathId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'pathId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'pathId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addStore', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addStore'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addKey', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addKey'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'adaptInputStore', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'adaptInputStore'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'requestLoad', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'requestLoad'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveData', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadData', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadData'), _class.prototype)), _class));
exports.default = DataModel;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DataModel, 'DataModel', 'src/core_modules/simgate-datamodel/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/simgate-input-store/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _stringify = __webpack_require__("./node_modules/babel-runtime/core-js/json/stringify.js");

var _stringify2 = _interopRequireDefault(_stringify);

var _getOwnPropertyNames = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-names.js");

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SimgateInputStore = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.shallow, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, (_class = function () {
  function SimgateInputStore() {
    var _this = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, SimgateInputStore);
    this.inputSuffixRegex = /:(G|(\+|-)[0-9]{1,2})$/;

    _initDefineProp(this, "id", _descriptor, this);

    _initDefineProp(this, "pathId", _descriptor2, this);

    _initDefineProp(this, "dataWasChanged", _descriptor3, this);

    _initDefineProp(this, "dataWillLoad", _descriptor4, this);

    _initDefineProp(this, "dataWasLoaded", _descriptor5, this);

    _initDefineProp(this, "dataWillSave", _descriptor6, this);

    _initDefineProp(this, "dataWasSaved", _descriptor7, this);

    _initDefineProp(this, "inputWasUpdated", _descriptor8, this);

    _initDefineProp(this, "stateWasSet", _descriptor9, this);

    _initDefineProp(this, "inputs", _descriptor10, this);

    _initDefineProp(this, "_cache", _descriptor11, this);

    this.getInput = function (contentModel, varName) {
      if (!contentModel) throw new Error("must provide content model");
      if (!varName) throw new Error("must provide varName");

      var inputStore = this;

      var input = contentModel[varName];
      if (!input) throw new Error("the contentmodel does not contain this input: " + varName);

      var inputVariableName = input.variable;
      if (!inputVariableName) throw new Error("the input does not contain a variable name: " + input);

      return inputStore.inputs[inputVariableName];
    }.bind(this);

    if (!opts.simgate && !this.constructor.simgate) throw new Error("provide simgate as static property or argument at instantiation");
    this.simgate = opts.simgate || this.constructor.simgate;

    if (opts.pathId) this.pathId = opts.pathId;
    this.id = opts.id || this.constructor.id || this.constructor.name;

    setTimeout(function () {
      return _this.updateCache();
    }, 10);
  }

  (0, _createClass3.default)(SimgateInputStore, [{
    key: "isLoadableVariable",
    value: function isLoadableVariable(name) {
      var prop = void 0;
      return !(0, _mobx.isComputed)(this.inputs, name) // isnt a computed 
      || this.inputs.$mobx.values[name] && this.inputs.$mobx.values[name].hasOwnProperty('setter') // or has a setter
      || (prop = (0, _getOwnPropertyDescriptor2.default)(this.inputs.$mobx.target, name)) && prop.set && prop.set.toString().substring(9, 13) === "set"; // special setter...
    }
  }, {
    key: "updateCache",
    value: function updateCache() {
      this._cache = this._serialized;
    }
  }, {
    key: "revert",
    value: function revert() {
      var reverted = {};
      try {
        reverted = JSON.parse(this._cache);
      } catch (e) {}
      (0, _assign2.default)(this.inputs, reverted);
    }
  }, {
    key: "updateInput",
    value: function updateInput(name, value, offsets) {
      var _this2 = this;

      if (!name || name.indexOf(":") === -1) return console.warn("please supply full variable name (ex: G:IndMonth:G)");
      if (!this.inputs.hasOwnProperty(name)) return console.warn("this input does not exist");
      this.inputs[name] = value;
      if (Array.isArray(offsets)) offsets.forEach(function (offset) {
        return _this2.inputs[name.replace(_this2.inputSuffixReg, ":" + offset)] = value;
      });
      this.inputWasUpdated = { time: +new Date(), name: name, offsets: offsets || [] };
    }
  }, {
    key: "setState",
    value: function setState(values, varNames) {
      var _this3 = this;

      if (!varNames) return console.log("no varnames when setting state");
      varNames.forEach(function (name, index) {
        var prop = void 0;
        if (!_this3.inputs.hasOwnProperty(name)) return console.warn("missing input property: " + name);
        if (values[index] != null //not null (dont want null to overwrite default val in the class)
        && (!(_this3.inputs.$mobx.values[name] && _this3.inputs.$mobx.values[name].hasOwnProperty('derivation')) || _this3.inputs.$mobx.values[name] && _this3.inputs.$mobx.values[name].hasOwnProperty('setter') || (prop = (0, _getOwnPropertyDescriptor2.default)(_this3.inputs.$mobx.target, name)) && prop.set && prop.set.toString().substring(9, 13) === "set") //isnt computed, or has a setter
        ) {
            _this3.inputs[name] = values[index];
          }
      });
      this.stateWasSet = { time: +new Date(), vars: varNames };
    }
  }, {
    key: "saveData",
    value: function saveData(cb, errCb) {
      var _this4 = this,
          _arguments = arguments;

      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!this.simgate) throw new Error("input store missing simgate!");

      var pathId = this.pathId || opts.pathId || this.$parent && this.$parent.pathId;

      if (!pathId) throw new Error("no pathId provided");

      if (!this.isLoaded) return setTimeout(function () {
        console.warn("possible race condition, trying to save again");
        _this4.saveData.apply(_this4, _arguments);
      }, 500);

      this.dataWillSave = +new Date();

      var vars = [];
      var values = [];

      this.savableVariableNames.forEach(function (key) {
        vars.push(key);
        values.push(_this4.inputs[key]);
      });

      if (!vars.length) {
        successCb();
        return console.warn("no savable variables!");
      }

      var successCb = function successCb(res) {
        _this4.updateCache();
        _this4.dataWasSaved = +new Date();
        cb && cb.apply(undefined, _arguments);
      };

      var adaptedVals = void 0;

      var taskArgs = [this.simgate.updateData, {
        path: pathId,
        set: vars.reduce(function (acc, name, index) {
          acc[name] = values[index];
          return acc;
        }, {})
      }, (0, _assign2.default)({
        onSuccess: successCb,
        onFailure: errCb
      }, opts)];

      if (opts.blockingSave !== false && this.simgate.runTask) {
        var _simgate;

        (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
      } else if (opts.blockingSave !== false && this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.updateData(taskArgs[1]).then(successCb).catch(errCb);
      }
    }
  }, {
    key: "loadData",
    value: function loadData(cb, errCb) {
      var _this5 = this;

      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      /* in most cases this gets overriden by simgate-datamodel */
      if (!this.simgate) throw new Error("input store missing simgate!");

      if (this.isLoading) return console.log("already loading...");

      var pathId = this.pathId || opts.pathId || this.$parent && this.$parent.pathId;
      if (!pathId) return console.warn("no pathId");

      if (!this.loadableVariableNames.length) {
        this.dataWasLoaded = +new Date();
        cb && cb();
        return console.warn("no loadable variables!");
      }

      this.dataWillLoad = +new Date();

      //only clear data if data has already been saved (avoid wiping defaults)
      if (this.dataWasSaved) this.clearData();

      var successCb = function successCb(res) {
        _this5.setState(res.data[0].values, _this5.loadableVariableNames);
        _this5.updateCache();
        _this5.dataWasLoaded = +new Date();
        cb && cb(res);
      };

      var errorCb = function errorCb(err) {
        _this5.dataWasLoaded = +new Date();
        errCb && errCb(err);
      };

      var taskArgs = [this.simgate.selectData, {
        path: pathId,
        select: this.loadableVariableNames
      }, (0, _assign2.default)({
        onSuccess: successCb,
        onFailure: errorCb
      }, opts)];

      if (this.simgate.runTask) {
        var _simgate2;

        (_simgate2 = this.simgate).runTask.apply(_simgate2, taskArgs);
      } else if (this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.selectData(taskArgs[1]).then(successCb).catch(errorCb);
      }
    }
  }, {
    key: "clearData",
    value: function clearData() {
      var _this6 = this;

      this.loadableVariableNames.forEach(function (key) {
        try {
          _this6.inputs[key] = null;
        } catch (e) {
          console.warn("skipping nullification of " + key);
        }
      });
    }
  }, {
    key: "extendData",
    value: function extendData(src, val) {
      if ((typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) !== "object" || (typeof src === "undefined" ? "undefined" : (0, _typeof3.default)(src)) !== "object") throw new Error("src and val should be an object");
      (0, _mobx.extendObservable)(src, val);
      this.dataWasChanged = +new Date();
    }
  }, {
    key: "setInput",
    value: function setInput(contentModel, varName, val) {
      if (!contentModel) throw new Error("must provide content model");
      if (!varName) throw new Error("must provide varName");
      if (val === undefined) throw new Error("must provide val");

      var inputStore = this;

      var input = contentModel[varName];
      if (!input) throw new Error("the contentmodel does not contain this input: " + varName);

      var inputVariableName = input.variable;
      if (!inputVariableName) throw new Error("the input does not contain a variable name: " + input);

      inputStore.updateInput(inputVariableName, val);
    }
  }, {
    key: "isLoaded",
    get: function get() {
      return !this.isLoading && this.dataWasLoaded;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this.dataWasLoaded < this.dataWillLoad;
    }
  }, {
    key: "isSaved",
    get: function get() {
      return !this.isSaving && this.dataWasSaved;
    }
  }, {
    key: "isSaving",
    get: function get() {
      return this.dataWasSaved < this.dataWillSaved;
    }
  }, {
    key: "variableNames",
    get: function get() {
      var _this7 = this;

      this.dataWasChanged; //listen to this!
      var vars = (0, _getOwnPropertyNames2.default)(this.inputs);

      return vars.filter(function (v) {
        return v.indexOf("$") === -1 && v.charAt(1) === ":" && ( //isnt $mobx or other hidden prop, has a ":" at 2nd char ("G:", "O:", "I:", etc)
        v.indexOf(":+") === -1 && v.indexOf(":-") === -1 || //isnt relative time
        !_this7.domainStore //OR is relative, but no domainstore to check roundNo
        || _this7.domainStore.currentRoundNo //or is relative, there is domainstore, and roundNo is set
        );
      });
    }
  }, {
    key: "loadableVariableNames",
    get: function get() {
      var _this8 = this;

      return this.variableNames.filter(function (name) {
        return _this8.isLoadableVariable(name);
      });
    }
  }, {
    key: "savableVariableNames",
    get: function get() {
      return this.variableNames.filter(function (name) {
        return name.indexOf("G:") === 0 || name.indexOf("I:") === 0;
      });
    }
  }, {
    key: "_serialized",
    get: function get() {
      var _this9 = this;

      return (0, _stringify2.default)(
      // should this be a join of loadable AND savable?
      this.loadableVariableNames.reduce(function (acc, name) {
        if (_this9.savableVariableNames.indexOf(name) === -1) return acc;
        acc[name] = _this9.inputs[name];
        return acc;
      }, {}));
    }
  }, {
    key: "isDirty",
    get: function get() {
      return this._cache !== this._serialized;
    }
  }]);
  return SimgateInputStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pathId", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataWasChanged", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dataWillLoad", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dataWasLoaded", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dataWillSave", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dataWasSaved", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "inputWasUpdated", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return {
      time: 0,
      name: "",
      offsets: []
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "stateWasSet", [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return {
      time: 0,
      vars: []
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "inputs", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      // ["G:Variable1:G"]: "Variable1Value"
      // etc...
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "isLoaded", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLoading", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSaved", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isSaved"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSaving", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isSaving"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "variableNames", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "variableNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadableVariableNames", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "loadableVariableNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savableVariableNames", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "savableVariableNames"), _class.prototype), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_cache", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateCache", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "updateCache"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_serialized", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "_serialized"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDirty", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revert", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "revert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInput", [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "updateInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setState", [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "setState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveData", [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "saveData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadData", [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "loadData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearData", [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "clearData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "extendData", [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "extendData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setInput", [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "setInput"), _class.prototype)), _class));
exports.default = SimgateInputStore;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimgateInputStore, "SimgateInputStore", "src/core_modules/simgate-input-store/index.js");
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/ui-blocking-modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SavingDataIndicator = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(SavingDataIndicator, _Component);

  function SavingDataIndicator() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SavingDataIndicator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SavingDataIndicator.__proto__ || (0, _getPrototypeOf2.default)(SavingDataIndicator)).call.apply(_ref, [this].concat(args))), _this), _this.getVisibility = function () {
      var _this2;

      return (_this2 = _this).__getVisibility__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SavingDataIndicator, [{
    key: 'render',
    value: function render() {
      var devMode = this.props.devMode;

      return _react2.default.createElement(
        'div',
        { className: 'saving-data-container' },
        _react2.default.createElement(
          'div',
          { className: this.getVisibility(this.props.appState) },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'saving-spinner' },
              _react2.default.createElement('div', { className: 'spinner' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'saving-message' },
              'Please Wait...'
            )
          )
        ),
        devMode !== false && _react2.default.createElement(InjectDevControls, { appState: this.props.appState })
      );
    }
  }, {
    key: '__getVisibility__REACT_HOT_LOADER__',
    value: function __getVisibility__REACT_HOT_LOADER__() {
      return this.__getVisibility__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getVisibility__REACT_HOT_LOADER__',
    value: function __getVisibility__REACT_HOT_LOADER__() {
      return this.__getVisibility__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getVisibility__REACT_HOT_LOADER__',
    value: function __getVisibility__REACT_HOT_LOADER__(props) {
      var visibilityClass = void 0;
      if (props.saveInProgress === true) {
        visibilityClass = 'saving-data-indicator';
      } else {
        visibilityClass = 'saving-data-indicator hidden';
      }
      return visibilityClass;
    }
  }]);
  return SavingDataIndicator;
}(_react.Component)) || _class;

;

var InjectDevControls = (0, _mobxReact.observer)(function (props) {
  return props.appState.saveInProgress ? _react2.default.createElement(
    'div',
    { className: 'saving-data-dev-controls' },
    _react2.default.createElement(
      'button',
      { onClick: function onClick() {
          return props.appState.saveInProgress = false;
        } },
      'Simulate Save Complete'
    )
  ) : _react2.default.createElement(
    'div',
    { className: 'saving-data-dev-controls' },
    _react2.default.createElement(
      'button',
      { onClick: function onClick() {
          return props.appState.saveInProgress = true;
        } },
      'Simulate Save In Progress'
    )
  );
});

var _default = SavingDataIndicator;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SavingDataIndicator, 'SavingDataIndicator', 'src/core_modules/ui-blocking-modal/index.js');

  __REACT_HOT_LOADER__.register(InjectDevControls, 'InjectDevControls', 'src/core_modules/ui-blocking-modal/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/ui-blocking-modal/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/core_modules/ui-blocking-modal/viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var AppState = (_class = function AppState() {
  (0, _classCallCheck3.default)(this, AppState);

  _initDefineProp(this, 'saveInProgress', _descriptor, this);
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'saveInProgress', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
var _default = AppState;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AppState, 'AppState', 'src/core_modules/ui-blocking-modal/viewstore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/ui-blocking-modal/viewstore.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules recursive ^\\.\\/[a-zA-Z0-9\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(dist|node_modules|tests)).*\\.(js|jsx|css|json)$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./configuration-entity/contentmodel.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/contentmodel.js",
	"./configuration-entity/editor.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/editor.js",
	"./configuration-entity/index.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/index.js",
	"./group-entity/contentmodel.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/group-entity/contentmodel.js",
	"./group-entity/index.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/group-entity/index.js",
	"./project-entity/contentmodel.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/contentmodel.js",
	"./project-entity/editor-viewstore.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/editor-viewstore.js",
	"./project-entity/editor.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/editor.js",
	"./project-entity/index.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/index.js",
	"./round-entity/contentmodel.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/round-entity/contentmodel.js",
	"./round-entity/index.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/round-entity/index.js",
	"./simulation-entity/component.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/component.js",
	"./simulation-entity/contentmodel.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.js",
	"./simulation-entity/contentmodel.localmode.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.localmode.js",
	"./simulation-entity/editor.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/editor.js",
	"./simulation-entity/index.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/index.js",
	"./system-entity/contentmodel.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/contentmodel.js",
	"./system-entity/editor.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/editor.js",
	"./system-entity/index.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/index.js",
	"./task-entity/component.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/component.js",
	"./task-entity/contentmodel.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/contentmodel.js",
	"./task-entity/editor.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/editor.js",
	"./task-entity/index.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/index.js",
	"./teamstate-entity/contentmodel.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/teamstate-entity/contentmodel.js",
	"./teamstate-entity/index.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/teamstate-entity/index.js",
	"./type-entity/index.js": "./node_modules/platform-client-bootstrap/dist/entity_modules/type-entity/index.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/platform-client-bootstrap/dist/entity_modules recursive ^\\.\\/[a-zA-Z0-9\\-]*(-activity|-auth-strategy|-shell|-entity)\\/(?!.*(dist|node_modules|tests)).*\\.(js|jsx|css|json)$";

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigurationContentModel = exports.AuthRouteContentModel = exports.RegisteredAuthStrategyContentModel = exports.RegisteredShellContentModel = exports.RegisteredActivityContentModel = exports.RoleContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _class2, _temp2, _dec2, _desc2, _value2, _class3, _descriptor4, _descriptor5, _class4, _temp3, _dec3, _desc3, _value3, _class5, _descriptor6, _descriptor7, _class6, _temp4, _dec4, _desc4, _value4, _class7, _descriptor8, _descriptor9, _class8, _temp5, _dec5, _dec6, _dec7, _dec8, _desc5, _value5, _class9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _class10, _temp6, _dec9, _dec10, _dec11, _dec12, _dec13, _desc6, _value6, _class11, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _class12, _temp7;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _collectionGridEditor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/collection-grid-editor/index.js");

var _collectionGridEditor2 = _interopRequireDefault(_collectionGridEditor);

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/editor.js");

var _editor2 = _interopRequireDefault(_editor);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _typeEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/type-entity/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

// export class PermissionsContentModel extends BaseContentModel{
//   static _slots = {
//     canConfigure: [RoleContentModel],
//     canCreate: [RoleContentModel],
//     canEdit: [RoleContentModel],
//     canApprove: [RoleContentModel],
//     canFacilitate: [RoleContentModel],
//     canParticipate: [RoleContentModel]
//   }
//   /* @slot( RoleContentModel ) */ @observable.shallow canConfigure = [1]
//   /* @slot( RoleContentModel ) */ @observable.shallow canCreate = [1]
//   /* @slot( RoleContentModel ) */ @observable.shallow canEdit = [1,4,5]
//   /* @slot( RoleContentModel ) */ @observable.shallow canApprove = [1,4,5]
//   /* @slot( RoleContentModel ) */ @observable.shallow canFacilitate = [1,3,4]
//   /* @slot( RoleContentModel ) */ @observable.shallow canParticipate = [2]
// }

var RoleContentModel = exports.RoleContentModel = (_dec = _mobx.observable.shallow, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(RoleContentModel, _BaseContentModel);

  function RoleContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RoleContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RoleContentModel.__proto__ || (0, _getPrototypeOf2.default)(RoleContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'roleType', _descriptor, _this), _initDefineProp(_this, 'roleId', _descriptor2, _this), _initDefineProp(_this, 'readOnlyAccessTypes', _descriptor3, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /* @slot */ //for ex: superadmin
  /* @slot */ //for ex: 1
  /* @slot( TypeContentModel ) */

  (0, _createClass3.default)(RoleContentModel, [{
    key: 'getComponent',
    value: function getComponent() {
      return (0, _get3.default)(RoleContentModel.prototype.__proto__ || (0, _getPrototypeOf2.default)(RoleContentModel.prototype), 'getComponent', this).call(this, { forceBasicEditor: true });
    }
  }]);
  return RoleContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  roleType: "",
  roleId: 0,
  readOnlyAccessTypes: [_typeEntity.ContentModel] }, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'roleType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'roleId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'readOnlyAccessTypes', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
})), _class));

// export class RolePermissionContentModel extends BaseContentModel{
//   static _slots = {
//     role: RoleContentModel,
//     type: BaseContentModel,
//     canCreate: true,
//     canEdit: true,
//     canApprove: true,
//     canDelete: true
//   }
//   /* @slot( RoleContentModel ) */ @observable.ref role = null
//   /* @slot( BaseContentModel ) */ @observable.ref type = null
//   /* @slot */ @observable canCreate = true
//   /* @slot */ @observable canEdit = true
//   /* @slot */ @observable canApprove = true
//   /* @slot */ @observable canDelete = true
// }

var RegisteredActivityContentModel = exports.RegisteredActivityContentModel = (_dec2 = _mobx.observable.ref, (_class3 = (_temp3 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(RegisteredActivityContentModel, _BaseContentModel2);

  function RegisteredActivityContentModel(props) {
    (0, _classCallCheck3.default)(this, RegisteredActivityContentModel);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (RegisteredActivityContentModel.__proto__ || (0, _getPrototypeOf2.default)(RegisteredActivityContentModel)).apply(this, arguments));

    _initDefineProp(_this2, 'path', _descriptor4, _this2);

    _initDefineProp(_this2, 'module', _descriptor5, _this2);

    var webpackLoader = _this2.$parent.webpackLoader;
    if (!webpackLoader) throw new Error("missing webpack loader!");
    _this2.module = webpackLoader(_this2.path);
    return _this2;
  }
  // static _meta = {
  //   version: {
  //     readonly: true
  //   },
  //   hasUnitTests: {
  //     readonly: true
  //   },
  //   hasCustomView: {
  //     readonly: true
  //   },
  //   hasSampleData: {
  //     readonly: true
  //   },
  //   hasBaseStylesheet: {
  //     readonly: true
  //   },
  //   isInGitlab: {
  //     readonly: true
  //   },
  //   hasDocumentation: {
  //     readonly: true
  //   }
  // }


  (0, _createClass3.default)(RegisteredActivityContentModel, [{
    key: 'getFile',
    value: function getFile(file) {
      var webpackLoader = this.$parent.webpackLoader;
      if (!webpackLoader) throw new Error("missing webpack loader!");
      return webpackLoader(this.path + "/" + file);
    }
  }, {
    key: 'ContentModelName',
    get: function get() {
      return this.module && this.module.ContentModel && this.module.ContentModel.name;
    }
  }, {
    key: 'packageJson',
    get: function get() {
      return this.getFile("package.json");
    }
  }, {
    key: 'version',
    get: function get() {
      return this.packageJson && this.packageJson.version || "×";
    }
  }, {
    key: 'hasCustomView',
    get: function get() {
      return !!this.getFile("src/component") || !!this.getFile("src/component") || !!this.getFile("component") ? "✔" : "×";
    }
  }, {
    key: 'hasSampleData',
    get: function get() {
      return !!this.getFile("src/fixture") || !!this.getFile("dist/fixture") || !!this.getFile("fixture") ? "✔" : "×";
    }
  }, {
    key: 'hasBaseStylesheet',
    get: function get() {
      return !!this.getFile("src/style.css") || !!this.getFile("dist/style.css") || !!this.getFile("style.css") ? "✔" : "×";
    }
  }, {
    key: 'isInGitlab',
    get: function get() {
      return !!this.packageJson && !!this.packageJson.repository && !!this.packageJson.repository.url && this.packageJson.repository.url.indexOf("gitlab") > -1 ? "✔" : "×";
    }
  }, {
    key: 'hasDocumentation',
    get: function get() {
      return !!this.getFile("README.md") ? "✔" : "×";
    }
  }]);
  return RegisteredActivityContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  path: "",
  version: "",
  hasUnitTests: "",
  hasCustomView: "",
  hasSampleData: "",
  hasBaseStylesheet: "",
  isInGitlab: "",
  hasDocumentation: "" }, _class4.readonly = true, _class4.savable = false, _temp3), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'path', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'module', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'ContentModelName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'ContentModelName'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'packageJson', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'packageJson'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'version', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'version'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'hasCustomView', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'hasCustomView'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'hasSampleData', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'hasSampleData'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'hasBaseStylesheet', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'hasBaseStylesheet'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'isInGitlab', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'isInGitlab'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'hasDocumentation', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'hasDocumentation'), _class3.prototype)), _class3));
var RegisteredShellContentModel = exports.RegisteredShellContentModel = (_dec3 = _mobx.observable.ref, (_class5 = (_temp4 = _class6 = function (_BaseContentModel3) {
  (0, _inherits3.default)(RegisteredShellContentModel, _BaseContentModel3);

  function RegisteredShellContentModel(props) {
    (0, _classCallCheck3.default)(this, RegisteredShellContentModel);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (RegisteredShellContentModel.__proto__ || (0, _getPrototypeOf2.default)(RegisteredShellContentModel)).apply(this, arguments));

    _initDefineProp(_this3, 'path', _descriptor6, _this3);

    _initDefineProp(_this3, 'module', _descriptor7, _this3);

    var webpackLoader = _this3.$parent.webpackLoader;
    if (!webpackLoader) throw new Error("missing webpack loader!");
    _this3.module = webpackLoader(_this3.path);
    return _this3;
  }
  /* @slot */

  (0, _createClass3.default)(RegisteredShellContentModel, [{
    key: 'ContentModelName',
    get: function get() {
      return this.module && this.module.ContentModel && this.module.ContentModel.name;
    }
  }]);
  return RegisteredShellContentModel;
}(_baseContentmodel2.default), _class6._slots = {
  path: "" }, _class6.readonly = true, _class6.savable = false, _temp4), (_descriptor6 = _applyDecoratedDescriptor(_class5.prototype, 'path', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class5.prototype, 'module', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class5.prototype, 'ContentModelName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'ContentModelName'), _class5.prototype)), _class5));
var RegisteredAuthStrategyContentModel = exports.RegisteredAuthStrategyContentModel = (_dec4 = _mobx.observable.ref, (_class7 = (_temp5 = _class8 = function (_BaseContentModel4) {
  (0, _inherits3.default)(RegisteredAuthStrategyContentModel, _BaseContentModel4);

  function RegisteredAuthStrategyContentModel(props) {
    (0, _classCallCheck3.default)(this, RegisteredAuthStrategyContentModel);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (RegisteredAuthStrategyContentModel.__proto__ || (0, _getPrototypeOf2.default)(RegisteredAuthStrategyContentModel)).apply(this, arguments));

    _initDefineProp(_this4, 'path', _descriptor8, _this4);

    _initDefineProp(_this4, 'module', _descriptor9, _this4);

    var webpackLoader = _this4.$parent.webpackLoader;
    if (!webpackLoader) throw new Error("missing webpack loader!");
    _this4.module = webpackLoader(_this4.path);
    return _this4;
  }
  /* @slot */

  (0, _createClass3.default)(RegisteredAuthStrategyContentModel, [{
    key: 'ContentModelName',
    get: function get() {
      return this.module && this.module.ContentModel && this.module.ContentModel.name;
    }
  }]);
  return RegisteredAuthStrategyContentModel;
}(_baseContentmodel2.default), _class8._slots = {
  path: "" }, _class8.readonly = true, _class8.savable = false, _temp5), (_descriptor8 = _applyDecoratedDescriptor(_class7.prototype, 'path', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class7.prototype, 'module', [_dec4], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class7.prototype, 'ContentModelName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class7.prototype, 'ContentModelName'), _class7.prototype)), _class7));
var AuthRouteContentModel = exports.AuthRouteContentModel = (_dec5 = _mobx.observable.ref, _dec6 = _mobx.observable.ref, _dec7 = _mobx.observable.shallow, _dec8 = _mobx.observable.shallow, (_class9 = (_temp6 = _class10 = function (_BaseContentModel5) {
  (0, _inherits3.default)(AuthRouteContentModel, _BaseContentModel5);

  function AuthRouteContentModel(props) {
    (0, _classCallCheck3.default)(this, AuthRouteContentModel);

    // this converts "role" to "roles" array (back port roles)
    if (props.role && !(props.roles && props.roles.length)) {
      if (props.roles) props.roles.push(props.role);else props.roles = [props.role];
    }

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (AuthRouteContentModel.__proto__ || (0, _getPrototypeOf2.default)(AuthRouteContentModel)).apply(this, arguments));

    _this5.Editor = _editor.RouteEditor;

    _initDefineProp(_this5, 'authStrategyType', _descriptor10, _this5);

    _initDefineProp(_this5, 'authStrategy', _descriptor11, _this5);

    _initDefineProp(_this5, 'urlmatch', _descriptor12, _this5);

    _initDefineProp(_this5, 'roles', _descriptor13, _this5);

    _initDefineProp(_this5, 'destinations', _descriptor14, _this5);

    if (props.registeredAuthStrategies) {
      _this5.registeredAuthStrategies = props.registeredAuthStrategies;
    } else if (_this5.$parent) {
      _this5.registeredAuthStrategies = _this5.$parent.types.RegisteredAuthStrategyContentModel.allEntities();
    } else {
      throw new Error("unable to find registeredAuthStrategies");
    }

    // @TODO we should do this for all content model slots that are strings:
    _this5.$parent && (0, _mobx.when)(function () {
      return _this5.$parent.hasHydrated;
    }, function () {
      return _this5.destinations.forEach(function (destination, i, arr) {
        if (typeof destination === "string") {
          arr[i] = _this5.$parent.entities.get(destination) || destination;
        }
      });
    });

    return _this5;
  }

  /* @slot( RegisteredAuthStrategyContentModel ) */
  /* @slot( BaseContentModel ) */
  /* @slot */
  /* @slot( [RoleContentModel] ) */
  /* @slot( BaseContentModel ) */

  (0, _createClass3.default)(AuthRouteContentModel, [{
    key: 'createAuthStrategy',
    value: function createAuthStrategy() {
      this.authStrategy = new this.AuthStrategyContentModel({ isNew: true, id: this.id + "_authStrategy" });
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.isNew) {
        return (0, _get3.default)(AuthRouteContentModel.prototype.__proto__ || (0, _getPrototypeOf2.default)(AuthRouteContentModel.prototype), 'getComponent', this).call(this, opts);
      } else {
        return (0, _get3.default)(AuthRouteContentModel.prototype.__proto__ || (0, _getPrototypeOf2.default)(AuthRouteContentModel.prototype), 'getComponent', this).call(this, { forceBasicEditor: true });
      }
    }
  }, {
    key: 'AuthStrategyContentModel',
    get: function get() {
      return this.authStrategyType && this.authStrategyType.module && this.authStrategyType.module.ContentModel;
    }
  }, {
    key: 'authStrategyDescription',
    get: function get() {
      return this.authStrategyType && this.authStrategyType.module && this.authStrategyType.module.description;
    }
  }, {
    key: 'invalid',
    get: function get() {
      var invalid = (0, _assign2.default)({}, this._invalid);
      if (!this.authStrategyType) invalid.authStrategyType = "Please choose an authStrategyType";
      if (!this.roles.length) invalid.roles = "Please choose a role";
      // if(!this.destination) invalid.destination = "Please choose destination(s) for this route";
      if (!this.destinations.length) invalid.destinations = "Please choose destination(s) for this route";
      if (this.authStrategy && this.authStrategy.isNew && this.authStrategy.allChildCms.length && this.authStrategy.allChildCms.some(function (cm) {
        return cm[0].isNew;
      })) {
        invalid.authStrategy = "Please save all submodels";
      }
      return invalid;
    }
  }]);
  return AuthRouteContentModel;
}(_baseContentmodel2.default), _class10._slots = {
  authStrategyType: RegisteredAuthStrategyContentModel,
  authStrategy: _baseContentmodel2.default,
  urlmatch: "",
  roles: [RoleContentModel],
  destinations: [_baseContentmodel2.default]
}, _temp6), (_descriptor10 = _applyDecoratedDescriptor(_class9.prototype, 'authStrategyType', [_dec5], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class9.prototype, 'authStrategy', [_dec6], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class9.prototype, 'urlmatch', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class9.prototype, 'roles', [_dec7], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class9.prototype, 'destinations', [_dec8], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class9.prototype, 'AuthStrategyContentModel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, 'AuthStrategyContentModel'), _class9.prototype), _applyDecoratedDescriptor(_class9.prototype, 'authStrategyDescription', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, 'authStrategyDescription'), _class9.prototype), _applyDecoratedDescriptor(_class9.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, 'invalid'), _class9.prototype)), _class9));
var ConfigurationContentModel = exports.ConfigurationContentModel = (_dec9 = _mobx.observable.shallow, _dec10 = _mobx.observable.shallow, _dec11 = _mobx.observable.shallow, _dec12 = _mobx.observable.shallow, _dec13 = _mobx.observable.shallow, (_class11 = (_temp7 = _class12 = function (_BaseContentModel6) {
  (0, _inherits3.default)(ConfigurationContentModel, _BaseContentModel6);

  function ConfigurationContentModel(props) {
    (0, _classCallCheck3.default)(this, ConfigurationContentModel);

    // if(!app) throw new Error("missing app!");
    var _this6 = (0, _possibleConstructorReturn3.default)(this, (ConfigurationContentModel.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationContentModel)).apply(this, arguments));

    _initDefineProp(_this6, 'registeredActivities', _descriptor15, _this6);

    _initDefineProp(_this6, 'registeredAuthStrategies', _descriptor16, _this6);

    _initDefineProp(_this6, 'registeredShells', _descriptor17, _this6);

    _initDefineProp(_this6, 'roles', _descriptor18, _this6);

    _initDefineProp(_this6, 'routes', _descriptor19, _this6);

    _initDefineProp(_this6, 'pathTypes', _descriptor20, _this6);

    _initDefineProp(_this6, 'icon', _descriptor21, _this6);

    var webpackLoader = _this6.$parent.webpackLoader;
    _this6.registeredActivities = webpackLoader.keys("activity").map(function (k) {
      var registeredActivity = new RegisteredActivityContentModel({
        guid: k,
        id: k,
        path: k,
        readonly: true
      });
      if (_this6.$parent) {
        _this6.$parent.entities.set(k, registeredActivity);
      } else {
        console.warn("no $parent to attach entity to!");
      }
      return registeredActivity;
    });
    _this6.registeredShells = webpackLoader.keys("shell").map(function (k) {
      var registeredShell = new RegisteredShellContentModel({
        guid: k,
        id: k,
        path: k,
        readonly: true
      });
      if (_this6.$parent) {
        _this6.$parent.entities.set(k, registeredShell);
      } else {
        console.warn("no $parent to attach entity to!");
      }
      return registeredShell;
    });
    _this6.registeredAuthStrategies = webpackLoader.keys("auth-strategy").map(function (k) {
      var registeredAuthStrategy = new RegisteredAuthStrategyContentModel({
        guid: k,
        id: k,
        path: k,
        readonly: true
      });
      if (_this6.$parent) {
        _this6.$parent.entities.set(k, registeredAuthStrategy);
      } else {
        console.warn("no $parent to attach entity to!");
      }
      return registeredAuthStrategy;
    });
    return _this6;
  }

  (0, _createClass3.default)(ConfigurationContentModel, [{
    key: 'getComponent',

    // /* @slot( RolePermissionContentModel ) */ @observable.shallow rolePermissions = []
    value: function getComponent() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // if(opts.init){
      return _editor2.default;
      // }
      // return super.getComponent(opts);
    }
    // /* @slot( PermissionsContentModel ) */ @observable.ref permissions = null
    /* @readonly @slot( RegisteredActivityContentModel ) */
    /* @readonly @slot( RegisteredAuthStrategyContentModel ) */
    /* @readonly @slot( RegisteredShellContentModel ) */
    /* @slot( RoleContentModel ) */
    /* @slot( AuthRouteContentModel ) */
    /* @slot */
  }, {
    key: 'warning',
    get: function get() {
      var warning = {};
      var routesCheck = [];
      var hasDuplicateRoute = false;
      if (!this.roles.some(function (r) {
        return r.roleId === 1;
      })) {
        warning.noAdminRole = "You need at least 1 admin role.";
      }
      if (!this.routes.some(function (r) {
        return r.roles.some(function (role) {
          return role.roleId === 1;
        });
      })) {
        warning.noAdminRoute = "You need at least 1 admin route.";
      }
      this.routes.some(function (r) {
        if (routesCheck.indexOf(r.urlmatch) > -1) {
          warning.duplicateRoutes = 'You have a duplicate route url: ' + r.urlmatch + ' from contentmodel: ' + r.id;
          return true;
        }
        routesCheck.push(r.urlmatch);
      });

      return warning;
    }
  }]);
  return ConfigurationContentModel;
}(_baseContentmodel2.default), _class12._slots = {
  // permissions: PermissionsContentModel,
  registeredActivities: [RegisteredActivityContentModel],
  registeredShells: [RegisteredShellContentModel],
  registeredAuthStrategies: [RegisteredAuthStrategyContentModel],
  roles: [RoleContentModel],
  routes: [AuthRouteContentModel],
  pathTypes: "Array",
  icon: ""
  // rolePermissions: [RolePermissionContentModel]
}, _class12._meta = {
  registeredActivities: {
    readonly: true
  },
  registeredAuthStrategies: {
    readonly: true
  }
}, _temp7), (_applyDecoratedDescriptor(_class11.prototype, 'warning', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class11.prototype, 'warning'), _class11.prototype), _descriptor15 = _applyDecoratedDescriptor(_class11.prototype, 'registeredActivities', [_dec9], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class11.prototype, 'registeredAuthStrategies', [_dec10], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class11.prototype, 'registeredShells', [_dec11], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class11.prototype, 'roles', [_dec12], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class11.prototype, 'routes', [_dec13], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class11.prototype, 'pathTypes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class11.prototype, 'icon', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "system-icon";
  }
})), _class11));
var _default = ConfigurationContentModel;
exports.default = _default;
;

var _temp8 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RoleContentModel, 'RoleContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(RegisteredActivityContentModel, 'RegisteredActivityContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(RegisteredShellContentModel, 'RegisteredShellContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(RegisteredAuthStrategyContentModel, 'RegisteredAuthStrategyContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(AuthRouteContentModel, 'AuthRouteContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(ConfigurationContentModel, 'ConfigurationContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/configuration-entity/contentmodel.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/editor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteEditor = exports.default = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _dec, _desc, _value, _class3, _class4, _class5, _temp2, _dec2, _dec3, _dec4, _desc2, _value2, _class6, _descriptor;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/editor.js");

var _editor2 = _interopRequireDefault(_editor);

var _collectionGridEditor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/collection-grid-editor/index.js");

var _collectionGridEditor2 = _interopRequireDefault(_collectionGridEditor);

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ConfigurationEditor = (0, _simboxEditable.Decorator)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_BaseComponent) {
  (0, _inherits3.default)(ConfigurationEditor, _BaseComponent);

  function ConfigurationEditor() {
    (0, _classCallCheck3.default)(this, ConfigurationEditor);
    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationEditor.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfigurationEditor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          editorViewStore = _props.editorViewStore,
          currentView = _props.currentView,
          contentModel = _props.contentModel,
          _props$contentModel = _props.contentModel,
          isNew = _props$contentModel.isNew,
          slots = _props$contentModel.slots,
          registeredAuthStrategies = _props$contentModel.registeredAuthStrategies,
          warning = _props$contentModel.warning;
      var deleteAllEntities = this.viewStore.deleteAllEntities;


      if (options && options.init) return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          'Welcome to SimGreat.  Please initialize your authoring environment.'
        ),
        !!warning.noAdminRole && _react2.default.createElement(
          'div',
          null,
          warning.noAdminRole,
          (0, _editor.createEditorElement)("roles", slots, contentModel, this.viewStore, { hideInMenu: "edit", noChildren: true, onSave: function onSave() {
              return editorViewStore.stopEditing();
            } })
        ),
        !warning.noAdminRole && !!warning.noAdminRoute && _react2.default.createElement(
          'div',
          null,
          warning.noAdminRoute,
          (0, _editor.createEditorElement)("routes", slots, contentModel, this.viewStore, { registeredAuthStrategies: registeredAuthStrategies, hideInMenu: "edit", noChildren: true, onSave: function onSave() {
              return editorViewStore.stopEditing();
            } })
        ),
        !warning.noAdminRole && !warning.noAdminRoute && !!warning.duplicateRoutes && _react2.default.createElement(
          'div',
          null,
          warning.duplicateRoutes,
          (0, _editor.createEditorElement)("routes", slots, contentModel, this.viewStore, { registeredAuthStrategies: registeredAuthStrategies, onSave: function onSave() {
              return editorViewStore.stopEditing();
            } })
        )
      );

      if (!options.insideEditor) return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_collectionGridEditor2.default, { currentView: currentView, contentModel: contentModel }),
        _react2.default.createElement(
          'div',
          { className: 'editable-group' },
          _react2.default.createElement(
            'button',
            { className: 'btn red delete-b', onClick: deleteAllEntities },
            'DELETE ALL ENTITIES'
          )
        )
      );

      return _react2.default.createElement(_editor2.default, this.props);
    }
  }]);
  return ConfigurationEditor;
}(_baseComponent2.default), _class2.ViewStore = (_dec = _mobx.action.bound, (_class3 = function (_BaseViewStore) {
  (0, _inherits3.default)(ConfigurationViewStore, _BaseViewStore);

  function ConfigurationViewStore() {
    (0, _classCallCheck3.default)(this, ConfigurationViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationViewStore.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationViewStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(ConfigurationViewStore, [{
    key: 'deleteAllEntities',
    value: function deleteAllEntities(e) {
      if (confirm("This will permanently delete all entities, are you sure?")) {
        var contentModel = this.props.contentModel;

        contentModel.$parent.deleteAllEntities(function () {
          return window.location.reload();
        });
      }
    }
  }]);
  return ConfigurationViewStore;
}(_baseViewstore2.default), (_applyDecoratedDescriptor(_class3.prototype, 'deleteAllEntities', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'deleteAllEntities'), _class3.prototype)), _class3)), _temp)) || _class) || _class;

exports.default = ConfigurationEditor;

var RouteEditor = exports.RouteEditor = (0, _simboxEditable.Decorator)(_class4 = (0, _mobxReact.observer)(_class4 = (_temp2 = _class5 = function (_BaseComponent2) {
  (0, _inherits3.default)(RouteEditor, _BaseComponent2);

  function RouteEditor() {
    (0, _classCallCheck3.default)(this, RouteEditor);
    return (0, _possibleConstructorReturn3.default)(this, (RouteEditor.__proto__ || (0, _getPrototypeOf2.default)(RouteEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(RouteEditor, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          options = _props2.options,
          contentModel = _props2.contentModel,
          _props2$contentModel = _props2.contentModel,
          registeredAuthStrategies = _props2$contentModel.registeredAuthStrategies,
          isNew = _props2$contentModel.isNew,
          isDirty = _props2$contentModel.isDirty,
          updateValue = _props2$contentModel.updateValue,
          invalid = _props2$contentModel.invalid,
          authStrategy = _props2$contentModel.authStrategy,
          authStrategyType = _props2$contentModel.authStrategyType,
          allCms = _props2$contentModel.allCms,
          id = _props2$contentModel.id,
          authStrategyDescription = _props2$contentModel.authStrategyDescription,
          availableDestinations = _props2$contentModel.availableDestinations,
          slots = _props2$contentModel.slots;
      var _viewStore = this.viewStore,
          selectAuthStrategy = _viewStore.selectAuthStrategy,
          confirmAuthStrategy = _viewStore.confirmAuthStrategy,
          confirmedAuthStrategy = _viewStore.confirmedAuthStrategy,
          saveRoute = _viewStore.saveRoute,
          SelectedView = _viewStore.SelectedView,
          isRoot = _viewStore.isRoot,
          viewBreadcrumbs = _viewStore.viewBreadcrumbs;


      return _react2.default.createElement(
        'div',
        null,
        isRoot && _react2.default.createElement(_layoutComponent.Breadcrumbs, { viewstores: viewBreadcrumbs }),
        !!SelectedView ? _react2.default.createElement(SelectedView, null) // there is a sub-view, just edit THAT
        : confirmedAuthStrategy ? // auth strategy has been confirmed
        _react2.default.createElement(
          'div',
          null,
          (0, _editor.createEditorElement)("roles", slots, contentModel, this.viewStore, { hideInMenu: "create" }),
          (0, _editor.createEditorElement)("urlmatch", slots, contentModel),
          (0, _editor.createEditorElement)("destinations", slots, contentModel, this.viewStore, { hideInMenu: "edit" }),
          _react2.default.createElement(_editor2.default, { contentModel: authStrategy, showButtons: false, options: options, insideEditor: options.insideEditor }),
          _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'button',
              { disabled: (0, _keys2.default)(invalid).length || !isDirty && !authStrategy.isDirty || invalid.authStrategy, onClick: saveRoute },
              'Save'
            ),
            _react2.default.createElement(
              'button',
              { disabled: !isDirty && !authStrategy.isDirty, onClick: function onClick(e) {
                  contentModel.revert(), authStrategy.revert();
                } },
              'Cancel'
            )
          )
        ) : // initial view 
        _react2.default.createElement(
          'div',
          null,
          (0, _editor.createEditorElement)("id", slots, contentModel),
          !!invalid.authStrategyType && _react2.default.createElement(
            'div',
            { className: 'errorMessage' },
            invalid.authStrategyType
          ),
          _react2.default.createElement(
            'select',
            { onChange: selectAuthStrategy },
            _react2.default.createElement('option', null),
            registeredAuthStrategies.map(function (a) {
              return _react2.default.createElement(
                'option',
                { value: a.id, key: a.id },
                a.id
              );
            })
          ),
          !!authStrategyDescription && _react2.default.createElement(
            'div',
            null,
            authStrategyDescription
          ),
          _react2.default.createElement(
            'button',
            { disabled: !authStrategyType, onClick: function onClick(e) {
                return confirmAuthStrategy();
              } },
            'Confirm Auth Strategy'
          )
        )
      );
    }
  }]);
  return RouteEditor;
}(_baseComponent2.default), _class5.ViewStore = (_dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class6 = function (_EditorViewStore) {
  (0, _inherits3.default)(RouteEditorViewStore, _EditorViewStore);

  function RouteEditorViewStore() {
    (0, _classCallCheck3.default)(this, RouteEditorViewStore);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (RouteEditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(RouteEditorViewStore)).apply(this, arguments));

    _initDefineProp(_this4, 'confirmedAuthStrategy', _descriptor, _this4);

    var cm = _this4.props.contentModel;

    if (cm.authStrategy && !cm.authStrategy.isNew) _this4.confirmedAuthStrategy = true;

    _this4.dispose = (0, _mobx.reaction)(function () {
      return cm.id;
    }, function () {
      return cm.authStrategy && (cm.authStrategy.id = cm.id + "_authStrategy");
    });
    return _this4;
  }

  (0, _createClass3.default)(RouteEditorViewStore, [{
    key: 'selectAuthStrategy',
    value: function selectAuthStrategy(e) {
      var cm = this.props.contentModel;

      cm.updateValue("authStrategyType", e.target.value ? cm.registeredAuthStrategies.find(function (a) {
        return a.id === e.target.value;
      }) : null);
      if (e.target.value) {
        cm.createAuthStrategy();
      }
    }
  }, {
    key: 'confirmAuthStrategy',
    value: function confirmAuthStrategy() {
      var cm = this.props.contentModel;

      cm.authStrategy.saveEntity();
      cm.saveEntity();
      this.confirmedAuthStrategy = true;
    }
  }, {
    key: 'saveRoute',
    value: function saveRoute() {
      var _props3 = this.props,
          contentModel = _props3.contentModel,
          _props3$contentModel = _props3.contentModel,
          registeredAuthStrategies = _props3$contentModel.registeredAuthStrategies,
          authStrategy = _props3$contentModel.authStrategy,
          onSave = _props3.options.onSave;


      contentModel.saveEntity();
      authStrategy.saveEntity(function () {
        return typeof onSave === "function" && onSave(contentModel);
      });
    }
  }]);
  return RouteEditorViewStore;
}(_editor.EditorViewStore), (_descriptor = _applyDecoratedDescriptor(_class6.prototype, 'confirmedAuthStrategy', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class6.prototype, 'selectAuthStrategy', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, 'selectAuthStrategy'), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, 'confirmAuthStrategy', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, 'confirmAuthStrategy'), _class6.prototype), _applyDecoratedDescriptor(_class6.prototype, 'saveRoute', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class6.prototype, 'saveRoute'), _class6.prototype)), _class6)), _temp2)) || _class4) || _class4;

;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ConfigurationEditor, 'ConfigurationEditor', 'src/entity_modules/configuration-entity/editor.js');

  __REACT_HOT_LOADER__.register(RouteEditor, 'RouteEditor', 'src/entity_modules/configuration-entity/editor.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/contentmodel.js");

var configurationContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = configurationContentModels;
var ContentModel = exports.ContentModel = configurationContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/configuration-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/configuration-entity/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/group-entity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class2, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _deepExtend = __webpack_require__("./node_modules/deep-extend/lib/deep-extend.js");

var _deepExtend2 = _interopRequireDefault(_deepExtend);

var _typeEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/type-entity/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var GroupContentModel = exports.GroupContentModel = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.shallow, (_class = (_temp = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(GroupContentModel, _BaseContentModel);

  function GroupContentModel() {
    (0, _classCallCheck3.default)(this, GroupContentModel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GroupContentModel.__proto__ || (0, _getPrototypeOf2.default)(GroupContentModel)).apply(this, arguments));

    _initDefineProp(_this, 'pathId', _descriptor, _this);

    _initDefineProp(_this, 'childPathType', _descriptor2, _this);

    _initDefineProp(_this, 'icon', _descriptor3, _this);

    _initDefineProp(_this, 'childType', _descriptor4, _this);

    _initDefineProp(_this, 'children', _descriptor5, _this);

    _initDefineProp(_this, '_options', _descriptor6, _this);

    (0, _mobx.when)(function () {
      return _this.$parent.hasHydrated;
    }, function () {
      if (!_this.childType) _this.childType = _this.$parent.entities.get("GroupContentModel");
    });
    return _this;
  }
  //@TODO link to path levels?

  // getComponent(){
  //   return super.getComponent({forceBasicEditor: true})
  // }
  /* @slot( TypeContentModel ) */
  /* @options("entity.type === childType.id") @slot( BaseContentModel ) */

  (0, _createClass3.default)(GroupContentModel, [{
    key: 'meta',
    get: function get() {
      return (0, _deepExtend2.default)({
        childType: {
          readonly: this.children.length
        }
      }, this.constructor._meta || {});
    }
  }, {
    key: 'childConstructor',
    get: function get() {
      return this.childType && this.childType.childConstructor;
    }
  }, {
    key: 'invalid',
    get: function get() {
      var invalid = (0, _assign2.default)({}, this._invalid);
      if (!this.childType) invalid.childType = "Please select childType";
      return invalid;
    }
  }]);
  return GroupContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  childType: _typeEntity.ContentModel,
  children: [_baseContentmodel2.default],
  childPathType: "",
  icon: "" }, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'pathId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'childPathType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'icon', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "default-group-icon";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'childType', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'children', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, '_options', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get children() {
        var _this2 = this;

        return this.$parent.entities.values().filter(function (entity) {
          var childType = _this2.childType;

          return eval("entity.type === childType.id");
        });
      }
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'meta', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'meta'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'childConstructor', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'childConstructor'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'invalid'), _class.prototype)), _class));
var _default = GroupContentModel;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GroupContentModel, 'GroupContentModel', 'src/entity_modules/group-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/group-entity/contentmodel.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/group-entity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/group-entity/contentmodel.js");

var groupContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = groupContentModels;
var ContentModel = exports.ContentModel = groupContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/group-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/group-entity/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _class2, _temp2;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _deepExtend = __webpack_require__("./node_modules/deep-extend/lib/deep-extend.js");

var _deepExtend2 = _interopRequireDefault(_deepExtend);

var _simulationEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/index.js");

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/editor.js");

var _editor2 = _interopRequireDefault(_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ProjectContentModel = exports.ProjectContentModel = (_dec = _mobx.observable.shallow, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(ProjectContentModel, _BaseContentModel);

  function ProjectContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ProjectContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProjectContentModel.__proto__ || (0, _getPrototypeOf2.default)(ProjectContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.Component = _editor2.default, _initDefineProp(_this, 'pathId', _descriptor, _this), _initDefineProp(_this, 'icon', _descriptor2, _this), _initDefineProp(_this, 'children', _descriptor3, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  //@TODO link to path levels?

  /* @slot( SimulationContentModel ) */

  return ProjectContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  children: [_simulationEntity.ContentModel],
  icon: ""
}, _class2.allowBrokenChildren = true, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'pathId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'icon', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "default-group-icon";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'children', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
})), _class));
var _default = ProjectContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectContentModel, 'ProjectContentModel', 'src/entity_modules/project-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/project-entity/contentmodel.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/editor-viewstore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _stringify = __webpack_require__("./node_modules/babel-runtime/core-js/json/stringify.js");

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _simulationEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/index.js");

var _roundEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/round-entity/index.js");

var _taskEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/index.js");

var _teamstateEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/teamstate-entity/index.js");

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _mixwith = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js");

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var FlowEditorViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.observable.ref, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, _dec12 = _mobx.action.bound, _dec13 = _mobx.action.bound, _dec14 = _mobx.action.bound, _dec15 = _mobx.action.bound, _dec16 = _mobx.action.bound, _dec17 = _mobx.action.bound, _dec18 = _mobx.action.bound, _dec19 = _mobx.action.bound, _dec20 = _mobx.action.bound, _dec21 = _mobx.action.bound, _dec22 = _mobx.action.bound, _dec23 = _mobx.action.bound, _dec24 = _mobx.action.bound, _dec25 = _mobx.action.bound, _dec26 = _mobx.action.bound, _dec27 = _mobx.action.bound, _dec28 = _mobx.action.bound, _dec29 = _mobx.action.bound, _dec30 = _mobx.action.bound, _dec31 = _mobx.action.bound, _dec32 = _mobx.action.bound, _dec33 = _mobx.action.bound, _dec34 = _mobx.action.bound, _dec35 = _mobx.action.bound, _dec36 = _mobx.action.bound, _dec37 = _mobx.action.bound, _dec38 = _mobx.action.bound, _dec39 = _mobx.action.bound, _dec40 = _mobx.action.bound, _dec41 = _mobx.action.bound, _dec42 = _mobx.action.bound, _dec43 = _mobx.action.bound, _dec44 = _mobx.action.bound, _dec45 = _mobx.action.bound, _dec46 = _mobx.action.bound, (_class = function (_mix$with) {
  (0, _inherits3.default)(FlowEditorViewStore, _mix$with);
  (0, _createClass3.default)(FlowEditorViewStore, [{
    key: 'handleDeleteRound',
    // Used to track what element to scroll to when expanding...
    value: function handleDeleteRound(event, roundIndex) {
      var _this2 = this;

      this.props.modalViewStore.setModal({
        title: 'Delete Round',
        message: 'Are you sure you want to delete "' + this.simulation.rounds[roundIndex].displayName + '"?',
        confirmLabel: 'Confirm',
        confirmBtnClass: 'green delete-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          _this2.deleteRound(event, roundIndex);_this2.props.modalViewStore.resetModal();
        }
      });
    }
  }, {
    key: 'permanentlyDeleteTask',
    value: function permanentlyDeleteTask(task) {
      var _this3 = this;

      var activity = task.activity;
      task.deleteEntity(function () {
        return activity && activity._deleteEntity && activity._deleteEntity();
      }, null, { onConfirmImmediate: function onConfirmImmediate() {
          return _this3.taskPickerActiveTask = null;
        } });
      this.removeTaskFromQue(task.id);
    }
  }, {
    key: 'cloneTask',
    value: function cloneTask(task) {
      task.cloneEntity(null, null, {
        cloneChildren: true
      });
    }
  }, {
    key: 'handleDeleteAllRounds',
    value: function handleDeleteAllRounds(event) {
      var _this4 = this;

      var listAllRounds = function listAllRounds() {
        return _this4.simulation.rounds.map(function (round, roundIndex) {
          return _react2.default.createElement(
            'div',
            { className: 'round-display-title', key: roundIndex },
            round.displayName
          );
        });
      };

      this.props.modalViewStore.setModal({
        title: 'Delete All Rounds',
        message: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'sub-title' },
            'Are you sure you want to delete all rounds in this simulation?'
          ),
          _react2.default.createElement(
            'div',
            null,
            listAllRounds()
          )
        ),
        confirmLabel: 'Confirm',
        confirmBtnClass: 'green delete-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          _this4.deleteAllRounds(event);_this4.props.modalViewStore.resetModal();
        }
      });
    }
  }, {
    key: 'handleDeleteState',
    value: function handleDeleteState(event, round, stateIndex) {
      var _this5 = this;

      this.props.modalViewStore.setModal({
        title: 'Delete State',
        message: 'Are you sure you want to delete "' + round.teamStates[stateIndex].displayName + '"?',
        confirmLabel: 'Confirm',
        confirmBtnClass: 'green delete-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          _this5.deleteTeamState(event, round, stateIndex);_this5.props.modalViewStore.resetModal();
        }
      });
    }
  }, {
    key: 'handleViewSimWarnings',
    value: function handleViewSimWarnings(warnings) {
      this.props.modalViewStore.setModal({
        title: 'View Simulation Error(s)',
        message: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'sub-title' },
            'The following issues must be fixed before you can view this simulation:'
          ),
          _react2.default.createElement(
            'div',
            { className: "warnings" },
            warnings.map(function (warning) {
              return _react2.default.createElement(
                'div',
                { className: "warning" },
                warning
              );
            })
          )
        ),
        confirmLabel: 'OK',
        confirmBtnClass: 'red'
      });
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var _this6 = this;

      var map = (0, _keys2.default)(this.tasks).reduce(function (acc, id) {
        if (!_this6.tasks[id].activity) return acc;
        acc[id] = {
          id: id,
          contentModel: _this6.tasks[id],
          viewMode: "linear-editor"
        };
        return acc;
      }, {});

      if (this.simulation && this.simulation.shell) {
        map["edit" + this.simulation.shell.id] = {
          id: "edit" + this.simulation.shell.id,
          contentModel: this.simulation.shell,
          Component: this.simulation.shell.Editor
        };
        map[this.simulation.id] = {
          id: this.simulation.id,
          contentModel: this.simulation
        };
      }

      return map;
    }
  }]);

  function FlowEditorViewStore() {
    (0, _classCallCheck3.default)(this, FlowEditorViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FlowEditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(FlowEditorViewStore)).apply(this, arguments));

    _initDefineProp(_this, 'devMode', _descriptor, _this);

    _initDefineProp(_this, 'viewModeExpanded', _descriptor2, _this);

    _initDefineProp(_this, 'activeRoundTracker', _descriptor3, _this);

    _initDefineProp(_this, 'taskPickerActive', _descriptor4, _this);

    _initDefineProp(_this, 'taskPickerRoundObj', _descriptor5, _this);

    _initDefineProp(_this, 'taskPickerStateObj', _descriptor6, _this);

    _initDefineProp(_this, 'taskPickerStateIndex', _descriptor7, _this);

    _initDefineProp(_this, 'taskPickerRoundIndex', _descriptor8, _this);

    _initDefineProp(_this, 'taskPickerActiveTask', _descriptor9, _this);

    _initDefineProp(_this, 'taskPickerViewOnlyMode', _descriptor10, _this);

    _initDefineProp(_this, 'taskPickerNewTaskBuilderActive', _descriptor11, _this);

    _initDefineProp(_this, 'taskPickerNewTaskType', _descriptor12, _this);

    _initDefineProp(_this, 'taskPickerNewTaskTitle', _descriptor13, _this);

    _initDefineProp(_this, 'taskPickerNewTaskDescription', _descriptor14, _this);

    _initDefineProp(_this, 'taskPickerQue', _descriptor15, _this);

    _initDefineProp(_this, 'taskPickerSearchFilter', _descriptor16, _this);

    _initDefineProp(_this, 'activityManagerActive', _descriptor17, _this);

    _this.dispose = [];

    _initDefineProp(_this, 'simulation', _descriptor18, _this);

    _this.teamStateViewModel = {
      collapsed: false
    };
    _this.teamStatesState = _mobx.observable.map(window.localStorage.getItem("teamStatesState") ? JSON.parse(window.localStorage.getItem("teamStatesState")) : {});

    _initDefineProp(_this, 'inEditNameMode', _descriptor19, _this);

    _initDefineProp(_this, 'simPreviewActionsCollapsed', _descriptor20, _this);

    var project = _this.props.contentModel;

    var sim = project.children.find(function (ent) {
      return !ent.hasBrokenChildren;
    });

    if (!sim) _this.newSimulation();else _this.selectSimulation(sim.id);

    // makes sure there is a local view representation for each teamstate, always
    _this.dispose.push((0, _mobx.autorun)(function () {
      _this.teamStates.forEach(function (ts) {
        if (!_this.teamStatesState.get(ts.id)) _this.teamStatesState.set(ts.id, _this.teamStateViewModel);
      });
    }));

    //trims localstorage if it has no-longer-existing teamstates
    _this.dispose.push((0, _mobx.when)(function () {
      return _this.teamStates.length;
    }, function () {
      var orphans = _this.teamStatesState.keys().filter(function (k) {
        return !_this.teamStates.find(function (ts) {
          return k === ts.id;
        });
      });
      if (orphans.length) {
        orphans.forEach(function (k) {
          return _this.teamStatesState.delete(k);
        });
        _this.saveTeamStatesState();
      }
    }));

    _this.dispose.push((0, _mobx.autorun)(function () {
      if (_this.taskPickerActiveTask) _this.selectView(_this.taskPickerActiveTask);else _this.clearView();
    }));
    return _this;
  }

  (0, _createClass3.default)(FlowEditorViewStore, [{
    key: 'devMsg',
    value: function devMsg(msg) {
      if (this.devMode === true) {
        console.log(msg);
      }
    }
  }, {
    key: 'newTask',
    value: function newTask() {
      var cm = this.props.contentModel;
      var rnd = Math.floor(Math.random() * 1000000000 + 100000);
      var id = 'task_' + rnd; // Need to refactor the "guid"" or "id" creation, this is temporary
      var ret = new _taskEntity.ContentModel({
        "id": id,
        "activityType": cm.$parent.entities.get(this.taskPickerNewTaskType),
        "displayTitle": this.taskPickerNewTaskTitle,
        "description": this.taskPickerNewTaskDescription,
        "required": false,
        "addImmediately": true
      });
      ret.activity = new ret.activityType.module.ContentModel({ id: 'activity_' + rnd });
      ret.saveEntity();
      ret.activity.saveEntity();
      return ret;
    }
  }, {
    key: 'newRound',
    value: function newRound() {
      return new _roundEntity.ContentModel({
        id: 'round-' + Math.floor(Math.random() * 1000000000 + 100000), // Need to refactor the "guid"" or "id" creation, this is temporary
        displayName: "New Round (" + (this.simulation.rounds.length + 1) + ')',
        beginTime: 0,
        endTime: 0,
        userNotes: "Enter Notes Here..."
      });
    }
  }, {
    key: 'newTeamState',
    value: function newTeamState(round) {
      // Need to refactor the "guid"" or "id" creation, this is temporary
      return new _teamstateEntity.ContentModel({
        id: "state_" + Math.floor(Math.random() * 1000000000 + 100000),
        displayName: "New State (" + (round.teamStates.length + 1) + ')',
        isWaitState: false
      });
    }
  }, {
    key: 'quickNavToRound',
    value: function quickNavToRound(event, roundIndex) {
      if ($('.flow-editor .workspace-container .workspace .round-wrapper').length) {
        var desiredRound = $('.flow-editor .workspace-container .workspace .round-wrapper:nth-child(' + (roundIndex + 1) + ')');
        var currentScrollOffset = $('.flow-editor .workspace-container .workspace').offset().left;
        var scrollVal = desiredRound.offset().left - currentScrollOffset - 10;
        $('.flow-editor .workspace-container').animate({ scrollLeft: scrollVal }, 300);
        setTimeout(function () {
          desiredRound.addClass('flash');
        }, 200);
        setTimeout(function () {
          desiredRound.removeClass('flash');
        }, 500);
      }
    }
  }, {
    key: 'scrollToNewRound',
    value: function scrollToNewRound() {
      if ($('.flow-editor .workspace-container .workspace .round-wrapper').length) {
        var newRound = $('.flow-editor .workspace-container .workspace .round-wrapper:last-child');
        var currentScrollOffset = this.currentWorkspaceScrollOffset();
        var scrollHere = newRound.offset().left - currentScrollOffset + newRound.outerWidth();
        $('.flow-editor .workspace-container').animate({ scrollLeft: scrollHere }, 300);
      }
    }
  }, {
    key: 'selectActiveRoundQuickNavBasedOnRoundHover',
    value: function selectActiveRoundQuickNavBasedOnRoundHover(event, roundIndex, eventType) {
      if ($('.flow-editor .quick-navigation .item').length) {
        var targetedRound = $('.flow-editor .quick-navigation .item:nth-child(' + (roundIndex + 1) + ')');
        if (eventType === 'enter') {
          targetedRound.addClass('highlight');
          this.activeRoundTracker = roundIndex + 1;
        } else if (eventType === 'leave') {
          targetedRound.removeClass('highlight');
        }
      }
    }
  }, {
    key: 'selectActiveRoundQuickNav',
    value: function selectActiveRoundQuickNav(event, roundIndex, eventType) {
      if ($('.flow-editor .workspace-container .workspace .round-wrapper').length) {
        var targetedRound = $('.flow-editor .workspace-container .workspace .round-wrapper:nth-child(' + (roundIndex + 1) + ')');
        if (eventType === 'enter') {
          targetedRound.addClass('highlight-selected');
          //this.activeRoundTracker = roundIndex + 1;
        } else if (eventType === 'leave') {
          targetedRound.removeClass('highlight-selected');
        }
      }
    }
  }, {
    key: 'toggleWorkspaceViewMode',
    value: function toggleWorkspaceViewMode() {
      var self = this;
      if (this.viewModeExpanded === false) {
        $('body').addClass('expanded-view');
        var roundTarget = $('.flow-editor .workspace-container .workspace .round-wrapper:nth-child(' + self.activeRoundTracker + ')');
        var currentScrollOffset = self.currentWorkspaceScrollOffset();
        var scrollHere = roundTarget.offset().left - currentScrollOffset;
        $('.flow-editor .workspace-container').animate({ scrollLeft: scrollHere - 10 }, 0);
      } else if (this.viewModeExpanded === true) {
        $('body').removeClass('expanded-view');
      }
    }
  }, {
    key: 'currentWorkspaceScrollOffset',
    value: function currentWorkspaceScrollOffset() {
      if ($('.flow-editor .workspace-container .workspace').length) {
        return $('.flow-editor .workspace-container .workspace').offset().left;
      } else {
        return 0;
      }
    }
  }, {
    key: 'currentPoolOffset',
    value: function currentPoolOffset() {
      if ($('.task-picker .pool').length) {
        console.log($('.task-picker .pool').offset().top);
        return $('.task-picker .pool').offset().top;
      } else {
        return 0;
      }
    }
  }, {
    key: 'scrollToNewTask',
    value: function scrollToNewTask() {
      if ($('.task-picker .pool .task').length) {
        var newTask = $('.task-picker .pool .task:last-child');
        var currentScrollOffset = this.currentPoolOffset();
        var scrollHere = newTask.offset().top + currentScrollOffset + newTask.outerHeight();
        $('.task-picker .pool').animate({ scrollTop: scrollHere }, 300);
      }
    }
  }, {
    key: 'scrollToNewState',
    value: function scrollToNewState(roundIndex) {
      if ($('.round-wrapper .round').length) {
        var round = $('.round-wrapper:nth-child(' + (roundIndex + 1) + ')' + ' ' + '.round');
        round.animate({ scrollTop: round[0].scrollHeight }, 300);
      }
    }
  }, {
    key: 'move',
    value: function move(array, from, to) {
      if (to === from) return array;
      var target = array[from];
      var increment = to < from ? -1 : 1;
      for (var k = from; k != to; k += increment) {
        array[k] = array[k + increment];
      }
      array[to] = target;
      return array;
    }
  }, {
    key: 'toggleViewMode',
    value: function toggleViewMode() {
      if (this.viewModeExpanded === true) {
        this.viewModeExpanded = false;
      } else if (this.viewModeExpanded === false) {
        this.viewModeExpanded = true;
      }
      this.toggleWorkspaceViewMode();
      this.devMsg('Toggled: View Mode');
    }
  }, {
    key: 'deleteAllRounds',
    value: function deleteAllRounds() {
      this.simulation.rounds = [];
      this.devMsg('Deleted: All Rounds');
    }
  }, {
    key: 'deleteTeamState',
    value: function deleteTeamState(event, round, stateIndex) {
      round.teamStates.splice(stateIndex, 1);
      this.devMsg('Deleted: Team State');
    }
  }, {
    key: 'createNewRound',
    value: function createNewRound() {
      var self = this;
      this.simulation.rounds.push(this.newRound());
      this.scrollToNewRound();
      this.devMsg('Created: New Round');
    }
  }, {
    key: 'addNewTeamState',
    value: function addNewTeamState(event, round, roundIndex) {
      round.teamStates.push(this.newTeamState(round));
      this.scrollToNewState(roundIndex);
      this.devMsg('Added: Team State');
    }
  }, {
    key: 'updateRoundBeginTime',
    value: function updateRoundBeginTime(event, round) {
      round.beginTime = event.target.value;
      this.devMsg('Updated: Round Begin Time');
    }
  }, {
    key: 'updateRoundEndTime',
    value: function updateRoundEndTime(event, round) {
      round.endTime = event.target.value;
      this.devMsg('Updated: Round End Time');
    }
  }, {
    key: 'updateRoundDisplayName',
    value: function updateRoundDisplayName(event, round) {
      round.displayName = event.target.value;
      this.devMsg('Updated: Round Display Name');
    }
  }, {
    key: 'updateRoundNotes',
    value: function updateRoundNotes(event, round) {
      round.userNotes = event.target.value;
      this.devMsg('Updated: Round Notes');
    }
  }, {
    key: 'updateTeamStateDisplayName',
    value: function updateTeamStateDisplayName(event, state) {
      state.displayName = event.target.value;
      this.devMsg('Updated: State Name');
    }
  }, {
    key: 'updateTaskRequired',
    value: function updateTaskRequired(event, task) {
      if (task.required === true) {
        task.required = false;
      } else if (task.required === false) {
        task.required = true;
      }
      this.devMsg('Updated: Task Required');
    }
  }, {
    key: 'deleteTaskFromTeamState',
    value: function deleteTaskFromTeamState(event, state, taskIndex) {
      state.tasks.splice(taskIndex, 1);
      this.devMsg('Deleted: Team State');
    }
  }, {
    key: 'deleteRound',
    value: function deleteRound(event, roundIndex) {
      this.simulation.rounds.splice(roundIndex, 1);
      this.devMsg('Deleted: Round');
    }
  }, {
    key: 'reorderItem',
    value: function reorderItem(targetArray, oldIndex, newIndex) {
      var updatedArr = this.move(targetArray.slice(), oldIndex, newIndex);
      targetArray.replace(updatedArr);
      this.devMsg('Moved: Round, State or Task');
    }
  }, {
    key: 'toggleTeamStateCollapse',
    value: function toggleTeamStateCollapse(event, state) {
      var tsState = this.teamStatesState.get(state.id);
      if (tsState.collapsed === true) {
        tsState.collapsed = false;
        this.devMsg('Opened: State');
      } else if (tsState.collapsed === false) {
        tsState.collapsed = true;
        this.devMsg('Closed: State');
      }
      this.saveTeamStatesState();
    }
  }, {
    key: 'enableActivityManager',
    value: function enableActivityManager(event) {
      if (this.taskPickerActive !== true) {
        this.taskPickerActive = true;
        this.activityManagerActive = true;
      }
    }
  }, {
    key: 'resetTaskPicker',
    value: function resetTaskPicker() {
      var self = this;
      this.taskPickerActive = false;
      setTimeout(function () {
        self.taskPickerViewOnlyMode = false;
        self.taskPickerNewTaskBuilderActive = false;
        self.activityManagerActive = false;
        self.taskPickerRoundObj = null;
        self.taskPickerStateObj = null;
        self.taskPickerStateIndex = null;
        self.taskPickerRoundIndex = null;
        self.taskPickerActiveTask = null;
        self.taskPickerQue = [];
        self.taskPickerNewTaskType = '';
        self.taskPickerNewTaskTitle = '';
        self.taskPickerNewTaskDescription = '';
        self.taskPickerSearchFilter = '';
      }, 500);
      this.devMsg('Task Picker: State Reset');
    }
  }, {
    key: 'addTaskToSelectedState',
    value: function addTaskToSelectedState(event, state, round, stateIndex, roundIndex) {
      if (this.taskPickerActive !== true) {
        this.taskPickerRoundObj = round;
        this.taskPickerStateObj = state;
        this.taskPickerActive = true;
        this.taskPickerStateIndex = stateIndex;
        this.taskPickerRoundIndex = roundIndex;
        console.log('Round Index: ' + roundIndex);
        console.log('State Index: ' + stateIndex);
        this.devMsg('Added: State Context To Task Picker');
      }
    }
  }, {
    key: 'closeTaskPicker',
    value: function closeTaskPicker(event) {
      if (this.taskPickerActive !== false) {
        this.resetTaskPicker();
        this.devMsg('Closed: Task Picker');
      }
    }
  }, {
    key: 'addTaskToQue',
    value: function addTaskToQue(task) {
      var taskIndex = this.taskPickerQue.indexOf(task);
      if (taskIndex > -1) {
        this.taskPickerQue.splice(taskIndex, 1);
      } else {
        this.taskPickerQue.push(task);
      }
      this.devMsg('Added: Task To Que' + '"' + task + '"');
    }
  }, {
    key: 'removeTaskFromQue',
    value: function removeTaskFromQue(task) {
      var taskIndex = this.taskPickerQue.indexOf(task);
      if (taskIndex !== -1) {
        this.taskPickerQue.splice(taskIndex, 1);
      }
      this.devMsg('Removed: Task From Que' + '"' + task + '"');
    }
  }, {
    key: 'highlightTasksAddedToState',
    value: function highlightTasksAddedToState() {
      var roundIndex = this.taskPickerRoundIndex + 1;
      var stateIndex = this.taskPickerStateIndex + 1;
      var tasks = this.taskPickerQue.length;
      var state = $('.round-wrapper:nth-child(' + roundIndex + ')' + ' > .round').find('.team-state:nth-child(' + stateIndex + ')');

      function highlightNewTasks(actionType) {
        var amountOfTasks = state.find('.tasks > .task').length;
        var action;
        var cn = 'just-added';
        if (actionType === 'add') {
          // A dynamic solution should be implemented in the long term. Right now it is static and acount for up to 10 items
          if (tasks >= 1) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 1) + ')').addClass(cn);
          }
          if (tasks >= 2) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 2) + ')').addClass(cn);
          }
          if (tasks >= 3) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 3) + ')').addClass(cn);
          }
          if (tasks >= 4) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 4) + ')').addClass(cn);
          }
          if (tasks >= 5) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 5) + ')').addClass(cn);
          }
          if (tasks >= 6) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 6) + ')').addClass(cn);
          }
          if (tasks >= 7) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 7) + ')').addClass(cn);
          }
          if (tasks >= 8) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 8) + ')').addClass(cn);
          }
          if (tasks >= 9) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 9) + ')').addClass(cn);
          }
          if (tasks >= 10) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 10) + ')').addClass(cn);
          }
        } else if (actionType === 'remove') {
          if (tasks >= 1) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 1) + ')').removeClass(cn);
          }
          if (tasks >= 2) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 2) + ')').removeClass(cn);
          }
          if (tasks >= 3) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 3) + ')').removeClass(cn);
          }
          if (tasks >= 4) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 4) + ')').removeClass(cn);
          }
          if (tasks >= 5) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 5) + ')').removeClass(cn);
          }
          if (tasks >= 6) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 6) + ')').removeClass(cn);
          }
          if (tasks >= 7) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 7) + ')').removeClass(cn);
          }
          if (tasks >= 8) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 8) + ')').removeClass(cn);
          }
          if (tasks >= 9) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 9) + ')').removeClass(cn);
          }
          if (tasks >= 10) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 10) + ')').removeClass(cn);
          }
        }
      }

      setTimeout(function () {
        highlightNewTasks('add');
      }, 200);

      setTimeout(function () {
        highlightNewTasks('remove');
      }, 1400);
    }
  }, {
    key: 'addSelectedTasksToState',
    value: function addSelectedTasksToState() {
      console.log(this.taskPickerRoundObj);
      console.log(this.taskPickerStateObj);
      for (var i = 0; i < this.taskPickerQue.length; i++) {
        this.taskPickerStateObj.tasks.push(this.tasks[this.taskPickerQue[i]]);
      }
      this.highlightTasksAddedToState();
      this.resetTaskPicker();
      this.devMsg('Added: Selected Task(s) To State');
    }
  }, {
    key: 'viewTaskInTaskPicker',
    value: function viewTaskInTaskPicker(taskKey) {
      var _this7 = this;

      if (this.taskPickerActiveTask === taskKey) return;
      var editorViewStore = this.props.editorViewStore;

      var openTask = function openTask() {
        _this7.taskPickerNewTaskType = '';
        _this7.taskPickerNewTaskTitle = '';
        _this7.taskPickerNewTaskDescription = '';
        _this7.taskPickerNewTaskBuilderActive = false;
        _this7.taskPickerActiveTask = taskKey;
        _this7.devMsg('Viewing: Task [' + taskKey + ']');
      };

      if (editorViewStore.isEditorOpen) {
        editorViewStore.startEditing({
          contentModel: this.tasks[taskKey].activity,
          whenNotDirty: openTask
        });
      } else {
        openTask();
      }
    }
  }, {
    key: 'viewTaskPreview',
    value: function viewTaskPreview(event, state, round, task) {
      console.log(task);
      this.taskPickerRoundObj = round;
      this.taskPickerStateObj = state;
      this.taskPickerActiveTask = task.id;
      this.taskPickerActive = true;
      this.taskPickerViewOnlyMode = true;
      this.devMsg('Viewing: Task Preview [' + task.id + ']');
    }
  }, {
    key: 'createNewTask',
    value: function createNewTask() {
      this.taskPickerNewTaskBuilderActive = true;
      this.taskPickerActiveTask = null;
      this.devMsg('Task Creator: Active');
    }
  }, {
    key: 'cancelTaskCreation',
    value: function cancelTaskCreation() {
      this.taskPickerNewTaskBuilderActive = false;
      this.taskPickerActiveTask = null;
      this.devMsg('Canceled: Task Creation');
    }
  }, {
    key: 'createSelectedTask',
    value: function createSelectedTask() {
      var newTask = this.newTask();
      this.tasks[newTask.id] = newTask;
      this.taskPickerNewTaskType = '';
      this.taskPickerNewTaskTitle = '';
      this.taskPickerNewTaskDescription = '';
      this.taskPickerNewTaskBuilderActive = false;
      this.taskPickerActiveTask = newTask.id;
      this.scrollToNewTask();
      this.devMsg('Created: New Task');
    }
  }, {
    key: 'updateNewTaskType',
    value: function updateNewTaskType(event) {
      this.taskPickerNewTaskType = event.target.value;;
      this.devMsg('Updated: New Task Type');
    }
  }, {
    key: 'updateNewTaskDisplayTitle',
    value: function updateNewTaskDisplayTitle(event) {
      this.taskPickerNewTaskTitle = event.target.value;
      this.devMsg('Updated: New Task Title');
    }
  }, {
    key: 'updateNewTaskDescription',
    value: function updateNewTaskDescription(event) {
      this.taskPickerNewTaskDescription = event.target.value;
      this.devMsg('Updated: New Task Description');
    }
  }, {
    key: 'updateTaskPickerSearchFilter',
    value: function updateTaskPickerSearchFilter(event) {
      this.taskPickerSearchFilter = event.target.value;
      this.devMsg('Updated: Task Picker Search Filter');
    }
  }, {
    key: 'saveSimulation',
    value: function saveSimulation() {
      this.simulation.allEntities.forEach(function (ent) {
        return ent.saveEntity(null, function (err) {
          return alert(ent.id + " did not save!" + err);
        });
      });
    }
  }, {
    key: 'revertSimulation',
    value: function revertSimulation() {
      this.simulation.allEntities.forEach(function (ent) {
        return ent.revert();
      });
    }
  }, {
    key: 'selectSimulation',
    value: function selectSimulation(id) {
      if (id === "_new") return this.newSimulation();
      this.simulation = this.simulations.find(function (s) {
        return s.id === id;
      });
    }
  }, {
    key: 'newSimulation',
    value: function newSimulation() {
      var project = this.props.contentModel;

      var id = 'simulation_' + Math.floor(Math.random() * 1000000000 + 100000); // Need to refactor the "guid"" or "id" creation, this is temporary
      project.children.push(new _simulationEntity.ContentModel({
        id: id,
        "displayName": 'New Simulation (' + (this.simulations.length + 1) + ')'
      }));
      project.saveEntity();
      this.selectSimulation(id);
    }
  }, {
    key: 'saveTeamStatesState',
    value: function saveTeamStatesState() {
      window.localStorage.setItem("teamStatesState", (0, _stringify2.default)(this.teamStatesState.toJS()));
    }
  }, {
    key: 'toggleEditNameMode',
    value: function toggleEditNameMode() {
      this.inEditNameMode = !this.inEditNameMode;
    }
  }, {
    key: 'toggleSimPreviewActions',
    value: function toggleSimPreviewActions() {
      if (this.simPreviewActionsCollapsed === false) {
        this.simPreviewActionsCollapsed = true;
      } else if (this.simPreviewActionsCollapsed === true) {
        this.simPreviewActionsCollapsed = false;
      }
    }
  }, {
    key: 'project',
    get: function get() {
      var project = this.props.contentModel;

      return project;
    }
  }, {
    key: 'simulations',
    get: function get() {
      return this.project.children.filter(function (ent) {
        return !ent.hasBrokenChildren;
      });
    }
  }, {
    key: 'teamStates',
    get: function get() {
      return this.project.children.length ? this.project.children.reduce(function (acc, simulation) {
        return acc.concat(simulation.rounds.reduce(function (acc2, rnd) {
          return acc2.concat(rnd.teamStates.slice());
        }, []));
      }, []) : [];
    }
  }, {
    key: 'tasks',
    get: function get() {
      var type = this.project.$parent.entities.get("TaskContentModel");
      return type.entities.filter(function (ent) {
        return !ent.hasBrokenChildren;
      }).reduce(function (acc, t) {
        acc[t.id] = t;return acc;
      }, {});
    }
  }, {
    key: 'componentList',
    get: function get() {
      var type = this.project.$parent.entities.get("RegisteredActivityContentModel");
      return type.entities.map(function (ent) {
        return ent.id;
      });
    }
  }, {
    key: 'selectedTask',
    get: function get() {
      return this.taskPickerActiveTask && this.tasks[this.taskPickerActiveTask];
    }
  }, {
    key: 'SelectedTaskActivity',
    get: function get() {
      return this.selectedTask.activity.Component || this.selectedTask.activity.FullEditor || this.selectedTask.activity.Editor;
    }
  }]);
  return FlowEditorViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'devMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'viewModeExpanded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'activeRoundTracker', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerActive', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerRoundObj', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerStateObj', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerStateIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerRoundIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerActiveTask', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerViewOnlyMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerNewTaskBuilderActive', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerNewTaskType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerNewTaskTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerNewTaskDescription', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerQue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerSearchFilter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, 'activityManagerActive', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'handleDeleteRound', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleDeleteRound'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'permanentlyDeleteTask', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'permanentlyDeleteTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cloneTask', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cloneTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleDeleteAllRounds', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleDeleteAllRounds'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleDeleteState', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleDeleteState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleViewSimWarnings', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleViewSimWarnings'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'project', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'project'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'simulations', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'simulations'), _class.prototype), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, 'simulation', [_dec7], {
  enumerable: true,
  initializer: function initializer() {
    return { displayName: "", id: "", rounds: [], allChildEntities: [], publishWarnings: [], warnings: [] };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'teamStates', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'teamStates'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'tasks', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tasks'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'componentList', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'componentList'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'move', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'move'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleViewMode', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleViewMode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteAllRounds', [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteAllRounds'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteTeamState', [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteTeamState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createNewRound', [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createNewRound'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addNewTeamState', [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addNewTeamState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRoundBeginTime', [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRoundBeginTime'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRoundEndTime', [_dec15], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRoundEndTime'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRoundDisplayName', [_dec16], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRoundDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRoundNotes', [_dec17], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRoundNotes'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateTeamStateDisplayName', [_dec18], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateTeamStateDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateTaskRequired', [_dec19], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateTaskRequired'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteTaskFromTeamState', [_dec20], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteTaskFromTeamState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteRound', [_dec21], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteRound'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reorderItem', [_dec22], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reorderItem'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleTeamStateCollapse', [_dec23], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleTeamStateCollapse'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'enableActivityManager', [_dec24], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'enableActivityManager'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetTaskPicker', [_dec25], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetTaskPicker'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addTaskToSelectedState', [_dec26], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addTaskToSelectedState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeTaskPicker', [_dec27], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'closeTaskPicker'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addTaskToQue', [_dec28], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addTaskToQue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeTaskFromQue', [_dec29], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'removeTaskFromQue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addSelectedTasksToState', [_dec30], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addSelectedTasksToState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'viewTaskInTaskPicker', [_dec31], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewTaskInTaskPicker'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'viewTaskPreview', [_dec32], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewTaskPreview'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createNewTask', [_dec33], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createNewTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cancelTaskCreation', [_dec34], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cancelTaskCreation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createSelectedTask', [_dec35], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createSelectedTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateNewTaskType', [_dec36], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateNewTaskType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateNewTaskDisplayTitle', [_dec37], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateNewTaskDisplayTitle'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateNewTaskDescription', [_dec38], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateNewTaskDescription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateTaskPickerSearchFilter', [_dec39], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateTaskPickerSearchFilter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectedTask', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectedTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'SelectedTaskActivity', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'SelectedTaskActivity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveSimulation', [_dec40], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveSimulation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'revertSimulation', [_dec41], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'revertSimulation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectSimulation', [_dec42], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectSimulation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'newSimulation', [_dec43], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'newSimulation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveTeamStatesState', [_dec44], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveTeamStatesState'), _class.prototype), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, 'inEditNameMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'toggleEditNameMode', [_dec45], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleEditNameMode'), _class.prototype), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, 'simPreviewActionsCollapsed', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'toggleSimPreviewActions', [_dec46], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleSimPreviewActions'), _class.prototype)), _class));
var _default = FlowEditorViewStore;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FlowEditorViewStore, 'FlowEditorViewStore', 'src/entity_modules/project-entity/editor-viewstore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/project-entity/editor-viewstore.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/editor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _class3, _class4, _class6, _class7, _class9, _dec, _class11, _class13, _dec2, _dec3, _class15, _class16, _temp6;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactSortableHoc = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/index.js");

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _editorViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/editor-viewstore.js");

var _editorViewstore2 = _interopRequireDefault(_editorViewstore);

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlowActionBar = (0, _simboxEditable.Decorator)(_class = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
  (0, _inherits3.default)(FlowActionBar, _BaseComponent);

  function FlowActionBar() {
    (0, _classCallCheck3.default)(this, FlowActionBar);
    return (0, _possibleConstructorReturn3.default)(this, (FlowActionBar.__proto__ || (0, _getPrototypeOf2.default)(FlowActionBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlowActionBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$viewStore = this.props.viewStore,
          simulation = _props$viewStore.simulation,
          warnings = _props$viewStore.simulation.warnings,
          simulations = _props$viewStore.simulations,
          selectView = _props$viewStore.selectView,
          selectSimulation = _props$viewStore.selectSimulation,
          inEditNameMode = _props$viewStore.inEditNameMode,
          toggleEditNameMode = _props$viewStore.toggleEditNameMode,
          project = _props$viewStore.project;

      return _react2.default.createElement(
        'div',
        { className: 'action-bar' },
        _react2.default.createElement(
          'div',
          { className: 'actions-and-details' },
          _react2.default.createElement(
            'div',
            { className: 'sim-details' },
            _react2.default.createElement(
              'div',
              { className: this.props.viewStore.inEditNameMode === true ? 'detail display-name editing-text' : 'detail display-name' },
              _react2.default.createElement(
                'div',
                { onClick: function onClick() {
                    return toggleEditNameMode();
                  } },
                'Simulation',
                _react2.default.createElement('i', { className: 'fa fa-pencil-square-o', title: 'Edit Simulation Name' })
              ),
              _react2.default.createElement(
                'div',
                null,
                inEditNameMode ? _react2.default.createElement('input', { value: simulation.displayName, onChange: function onChange(e) {
                    return simulation.updateValue("displayName", e.target.value);
                  } }) : _react2.default.createElement(
                  'div',
                  { className: 'custom-select' },
                  _react2.default.createElement(
                    'select',
                    { value: simulation.id, onChange: function onChange(e) {
                        return selectSimulation(e.target.value);
                      } },
                    simulations.map(function (s) {
                      return _react2.default.createElement(
                        'option',
                        { key: s.id, value: s.id },
                        (s.displayName || s.id) + (s.anyDirty ? " **" : s.isPublishDirty ? " *" : "")
                      );
                    }),
                    _react2.default.createElement(
                      'option',
                      { value: '_new' },
                      'New Simulation...'
                    )
                  ),
                  _react2.default.createElement('div', null)
                )
              )
            ),
            !!simulation.shell && _react2.default.createElement(
              'div',
              { className: 'detail shell-name', 'data-editable': !simulation.shellType ? [simulation, "shellType"] : null },
              _react2.default.createElement(
                'span',
                null,
                'Shell Type',
                !!simulation.shell && _react2.default.createElement('i', { className: 'fa fa-pencil-square-o', onClick: function onClick() {
                    return selectView("edit" + simulation.shell.id);
                  } })
              ),
              _react2.default.createElement(
                'span',
                null,
                !!simulation.shellType && simulation.shellType.id
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'sim-actions' },
            _react2.default.createElement(
              'div',
              { className: 'action activity-manager', onClick: function onClick(event) {
                  return _this2.props.viewStore.enableActivityManager();
                } },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Activity Manager'
              )
            ),
            simulation.rounds.length !== 0 && _react2.default.createElement(
              'div',
              { className: 'action view-simulation', onClick: function onClick() {
                  return warnings.length ? _this2.props.viewStore.handleViewSimWarnings(warnings) : selectView(simulation.id);
                } },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'View Simulation'
              )
            ),
            simulation.rounds.length !== 0 && _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.props.viewStore.createNewRound();
                }, className: 'action new-round' },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'New Round'
              )
            ),
            simulation.rounds.length !== 0 && _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.props.viewStore.handleDeleteAllRounds(event);
                }, className: 'action delete-all' },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Delete All Rounds'
              )
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return simulation.anyDirty && _this2.props.viewStore.revertSimulation();
                }, className: "cancel action " + (simulation.anyDirty ? "" : "disabled") },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Revert'
              )
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return simulation.anyDirty && _this2.props.viewStore.saveSimulation();
                }, className: "save action " + (simulation.anyDirty ? "" : "disabled") },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Save'
              )
            ),
            simulation.rounds.length !== 0 && _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return simulation.publishWarnings.length ? alert(simulation.publishWarnings) : simulation.exportToServer();
                }, className: "publish action " + (!simulation.publishWarnings.length && simulation.isPublishDirty ? "" : "disabled") },
              _react2.default.createElement('span', null),
              _react2.default.createElement(
                'span',
                null,
                'Publish'
              )
            )
          )
        )
      );
    }
  }]);
  return FlowActionBar;
}(_baseComponent2.default)) || _class) || _class;

;

var FlowQuickNav = (0, _mobxReact.observer)(_class2 = function (_BaseComponent2) {
  (0, _inherits3.default)(FlowQuickNav, _BaseComponent2);

  function FlowQuickNav() {
    (0, _classCallCheck3.default)(this, FlowQuickNav);
    return (0, _possibleConstructorReturn3.default)(this, (FlowQuickNav.__proto__ || (0, _getPrototypeOf2.default)(FlowQuickNav)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlowQuickNav, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'quick-navigation' },
        this.props.viewStore.simulation.rounds.map(function (round, roundIndex) {
          return _react2.default.createElement(
            'div',
            { key: roundIndex, className: 'item', onMouseEnter: function onMouseEnter(event) {
                return _this4.props.viewStore.selectActiveRoundQuickNav(event, roundIndex, 'enter');
              }, onMouseLeave: function onMouseLeave(event) {
                return _this4.props.viewStore.selectActiveRoundQuickNav(event, roundIndex, 'leave');
              }, title: round.displayName, onClick: function onClick(event) {
                return _this4.props.viewStore.quickNavToRound(event, roundIndex);
              } },
            _this4.props.viewStore.simulation.rounds.length < 25 ? _react2.default.createElement(
              'span',
              { className: 'title' },
              _this4.props.viewStore.simulation.rounds[roundIndex].displayName
            ) : ''
          );
        })
      );
    }
  }]);
  return FlowQuickNav;
}(_baseComponent2.default)) || _class2;

;

var FlowWorkspace = (0, _mobxReact.observer)(_class3 = function (_BaseComponent3) {
  (0, _inherits3.default)(FlowWorkspace, _BaseComponent3);

  function FlowWorkspace() {
    (0, _classCallCheck3.default)(this, FlowWorkspace);
    return (0, _possibleConstructorReturn3.default)(this, (FlowWorkspace.__proto__ || (0, _getPrototypeOf2.default)(FlowWorkspace)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlowWorkspace, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SortableRoundsContainer, { viewStore: this.props.viewStore });
    }
  }]);
  return FlowWorkspace;
}(_baseComponent2.default)) || _class3;

;

var SortableRoundsContainer = (0, _mobxReact.observer)(_class4 = function (_BaseComponent4) {
  (0, _inherits3.default)(SortableRoundsContainer, _BaseComponent4);

  function SortableRoundsContainer() {
    var _ref;

    var _temp, _this6, _ret;

    (0, _classCallCheck3.default)(this, SortableRoundsContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref = SortableRoundsContainer.__proto__ || (0, _getPrototypeOf2.default)(SortableRoundsContainer)).call.apply(_ref, [this].concat(args))), _this6), _this6.onSortEnd = function () {
      var _this7;

      return (_this7 = _this6).__onSortEnd__REACT_HOT_LOADER__.apply(_this7, arguments);
    }, _this6.axis = 'x', _this6.lockAxis = 'x', _this6.helperClass = 'dragging', _this6.pressDelay = 200, _this6.pressThreshold = 5, _temp), (0, _possibleConstructorReturn3.default)(_this6, _ret);
  }

  (0, _createClass3.default)(SortableRoundsContainer, [{
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__(_ref2) {
      var oldIndex = _ref2.oldIndex,
          newIndex = _ref2.newIndex;

      if (oldIndex !== newIndex) {
        this.props.viewStore.reorderItem(this.props.viewStore.simulation.rounds, oldIndex, newIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SortableRounds, {
        viewStore: this.props.viewStore,
        lockAxis: this.axis,
        axis: this.lockAxis,
        helperClass: this.helperClass,
        onSortEnd: this.onSortEnd,
        pressDelay: this.pressDelay,
        pressThreshold: this.pressThreshold });
    }
  }]);
  return SortableRoundsContainer;
}(_baseComponent2.default)) || _class4;

// const SortableRounds = SortableContainer(
//   observer(({ viewStore }) => {
//     return (
//       <div className="workspace-container">
//         <div className={viewStore.viewModeExpanded === true ? 'workspace' : 'workspace expanded-view'}>
//           {viewStore.simulation.rounds.map((round, roundIndex) => 
//             <SortableRound index={roundIndex} key={`round-${roundIndex}`} viewStore={viewStore} round={round} roundIndex={roundIndex}/>
//           )}
//         </div>
//       </div>
//     );
//   }));

var SortableRounds = (0, _reactSortableHoc.SortableContainer)(_class6 = (0, _mobxReact.observer)(_class6 = function (_BaseComponent5) {
  (0, _inherits3.default)(SortableRounds, _BaseComponent5);

  function SortableRounds() {
    (0, _classCallCheck3.default)(this, SortableRounds);
    return (0, _possibleConstructorReturn3.default)(this, (SortableRounds.__proto__ || (0, _getPrototypeOf2.default)(SortableRounds)).apply(this, arguments));
  }

  (0, _createClass3.default)(SortableRounds, [{
    key: 'render',
    value: function render() {
      var viewStore = this.props.viewStore;

      return _react2.default.createElement(
        'div',
        { className: 'workspace-container' },
        _react2.default.createElement(
          'div',
          { className: viewStore.viewModeExpanded === true ? 'workspace' : 'workspace expanded-view' },
          viewStore.simulation.rounds.map(function (round, roundIndex) {
            return _react2.default.createElement(SortableRound, { index: roundIndex, key: 'round-' + roundIndex, viewStore: viewStore, round: round, roundIndex: roundIndex });
          })
        )
      );
    }
  }]);
  return SortableRounds;
}(_baseComponent2.default)) || _class6) || _class6;

var SortableRound = (0, _reactSortableHoc.SortableElement)((0, _mobxReact.observer)(function (_ref3) {
  var viewStore = _ref3.viewStore,
      round = _ref3.round,
      roundIndex = _ref3.roundIndex;

  return _react2.default.createElement(
    'div',
    { className: 'round-wrapper', onMouseEnter: function onMouseEnter(event) {
        return viewStore.selectActiveRoundQuickNavBasedOnRoundHover(event, roundIndex, 'enter');
      }, onMouseLeave: function onMouseLeave(event) {
        return viewStore.selectActiveRoundQuickNavBasedOnRoundHover(event, roundIndex, 'leave');
      } },
    _react2.default.createElement(
      'div',
      { className: 'round' },
      _react2.default.createElement(
        'div',
        { className: 'rounds-details' },
        _react2.default.createElement(
          'div',
          { className: 'detail display-name' },
          _react2.default.createElement('span', { className: 'action expand-collapse-round', title: viewStore.viewModeExpanded === true ? "Expand To Detailed View" : "", onClick: function onClick(event) {
              return viewStore.toggleViewMode(event, roundIndex);
            } }),
          _react2.default.createElement('input', { type: 'text', onChange: function onChange(event) {
              return viewStore.updateRoundDisplayName(event, round);
            }, value: round.displayName }),
          _react2.default.createElement('span', { className: 'action delete-round', title: 'Delete Round', onClick: function onClick(event) {
              viewStore.handleDeleteRound(event, roundIndex);
            } })
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail begin-time' },
          _react2.default.createElement(
            'span',
            null,
            'Begin Time:'
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('input', { type: 'text', onChange: function onChange(event) {
                return viewStore.updateRoundBeginTime(event, round);
              }, defaultValue: round.beginTime })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail begin-time' },
          _react2.default.createElement(
            'span',
            null,
            'End Time:'
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('input', { type: 'text', onChange: function onChange(event) {
                return viewStore.updateRoundEndTime(event, round);
              }, defaultValue: round.endTime })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail notes' },
          _react2.default.createElement(
            'div',
            null,
            'Notes: '
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('textarea', { rows: '4', cols: '50', onChange: function onChange(event) {
                return viewStore.updateRoundNotes(event, round);
              }, placeholder: 'Enter Notes Here...', defaultChecked: round.userNotes })
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'team-states-container' },
        _react2.default.createElement(SortableStatesContainer, { index: roundIndex, key: 'states-' + roundIndex, viewStore: viewStore, round: round, roundIndex: roundIndex })
      )
    )
  );
}));

var SortableStatesContainer = (0, _mobxReact.observer)(_class7 = function (_BaseComponent6) {
  (0, _inherits3.default)(SortableStatesContainer, _BaseComponent6);

  function SortableStatesContainer() {
    var _ref4;

    var _temp2, _this9, _ret2;

    (0, _classCallCheck3.default)(this, SortableStatesContainer);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this9 = (0, _possibleConstructorReturn3.default)(this, (_ref4 = SortableStatesContainer.__proto__ || (0, _getPrototypeOf2.default)(SortableStatesContainer)).call.apply(_ref4, [this].concat(args))), _this9), _this9.onSortEnd = function () {
      var _this10;

      return (_this10 = _this9).__onSortEnd__REACT_HOT_LOADER__.apply(_this10, arguments);
    }, _this9.axis = 'y', _this9.lockAxis = 'y', _this9.helperClass = 'dragging', _this9.pressDelay = 200, _this9.pressThreshold = 5, _temp2), (0, _possibleConstructorReturn3.default)(_this9, _ret2);
  }

  (0, _createClass3.default)(SortableStatesContainer, [{
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__(_ref5) {
      var oldIndex = _ref5.oldIndex,
          newIndex = _ref5.newIndex;

      if (oldIndex !== newIndex) {
        this.props.viewStore.reorderItem(this.props.round.teamStates, oldIndex, newIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SortableStates, {
        viewStore: this.props.viewStore,
        round: this.props.round,
        roundIndex: this.props.roundIndex,
        lockAxis: this.lockAxis,
        axis: this.axis,
        helperClass: this.helperClass,
        onSortEnd: this.onSortEnd,
        pressDelay: this.pressDelay,
        pressThreshold: this.pressThreshold });
    }
  }]);
  return SortableStatesContainer;
}(_baseComponent2.default)) || _class7;

var SortableStates = (0, _reactSortableHoc.SortableContainer)((0, _mobxReact.observer)(function (_ref6) {
  var viewStore = _ref6.viewStore,
      round = _ref6.round,
      roundIndex = _ref6.roundIndex;

  return _react2.default.createElement(
    'div',
    { className: 'team-states' },
    round.teamStates.map(function (state, stateIndex) {
      return _react2.default.createElement(SortableState, { index: stateIndex, key: 'state-' + stateIndex, viewStore: viewStore, round: round, state: state, stateIndex: stateIndex, roundIndex: roundIndex });
    }),
    _react2.default.createElement(
      'div',
      { className: 'add-team-state-container' },
      _react2.default.createElement(
        'div',
        { className: 'add-team-state', onClick: function onClick(event) {
            return viewStore.addNewTeamState(event, round, roundIndex);
          } },
        'New State'
      )
    )
  );
}));

var SortableState = (0, _reactSortableHoc.SortableElement)((0, _mobxReact.observer)(function (_ref7) {
  var viewStore = _ref7.viewStore,
      round = _ref7.round,
      state = _ref7.state,
      stateIndex = _ref7.stateIndex,
      roundIndex = _ref7.roundIndex;

  var tsState = viewStore.teamStatesState.get(state.id);
  if (!tsState) return false;
  return _react2.default.createElement(
    'div',
    { className: tsState && tsState.collapsed === true ? 'team-state collapsed' : 'team-state', key: stateIndex },
    _react2.default.createElement(
      'div',
      { className: 'detail display-name' },
      _react2.default.createElement('span', { className: 'carrot', onClick: function onClick(event) {
          return viewStore.toggleTeamStateCollapse(event, state);
        }, title: tsState && tsState.collapsed === true ? 'Open State' : 'Close State' }),
      _react2.default.createElement(
        'span',
        { className: tsState.collapsed === false ? 'task-count-indicator hidden' : 'task-count-indicator' },
        state.tasks.length
      ),
      _react2.default.createElement('input', { type: 'text', onChange: function onChange(event) {
          return viewStore.updateTeamStateDisplayName(event, state);
        }, value: state.displayName }),
      _react2.default.createElement(
        'div',
        { className: 'state-actions' },
        _react2.default.createElement('span', { className: 'action delete', title: 'Delete State', onClick: function onClick(event) {
            viewStore.handleDeleteState(event, round, stateIndex);
          } })
      )
    ),
    _react2.default.createElement(SortableTasksContainer, { viewStore: viewStore, key: 'tasks-' + stateIndex, round: round, state: state, stateIndex: stateIndex, roundIndex: roundIndex, index: stateIndex })
  );
}));

var SortableTasksContainer = (0, _mobxReact.observer)(_class9 = function (_BaseComponent7) {
  (0, _inherits3.default)(SortableTasksContainer, _BaseComponent7);

  function SortableTasksContainer() {
    var _ref8;

    var _temp3, _this11, _ret3;

    (0, _classCallCheck3.default)(this, SortableTasksContainer);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this11 = (0, _possibleConstructorReturn3.default)(this, (_ref8 = SortableTasksContainer.__proto__ || (0, _getPrototypeOf2.default)(SortableTasksContainer)).call.apply(_ref8, [this].concat(args))), _this11), _this11.onSortEnd = function () {
      var _this12;

      return (_this12 = _this11).__onSortEnd__REACT_HOT_LOADER__.apply(_this12, arguments);
    }, _this11.axis = 'y', _this11.lockAxis = 'y', _this11.helperClass = 'dragging', _this11.pressDelay = 200, _this11.pressThreshold = 5, _temp3), (0, _possibleConstructorReturn3.default)(_this11, _ret3);
  }

  (0, _createClass3.default)(SortableTasksContainer, [{
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__() {
      return this.__onSortEnd__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__onSortEnd__REACT_HOT_LOADER__',
    value: function __onSortEnd__REACT_HOT_LOADER__(_ref9) {
      var oldIndex = _ref9.oldIndex,
          newIndex = _ref9.newIndex;

      if (oldIndex !== newIndex) {
        this.props.viewStore.reorderItem(this.props.state.tasks, oldIndex, newIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SortableTasks, {
        viewStore: this.props.viewStore,
        round: this.props.round,
        state: this.props.state,
        roundIndex: this.props.roundIndex,
        stateIndex: this.props.stateIndex,
        axis: this.axis,
        lockAxis: this.lockAxis,
        pressDelay: this.pressDelay,
        helperClass: this.helperClass,
        onSortEnd: this.onSortEnd,
        pressThreshold: this.pressThreshold });
    }
  }]);
  return SortableTasksContainer;
}(_baseComponent2.default)) || _class9;

var SortableTasks = (0, _reactSortableHoc.SortableContainer)((0, _mobxReact.observer)(function (_ref10) {
  var viewStore = _ref10.viewStore,
      state = _ref10.state,
      round = _ref10.round,
      stateIndex = _ref10.stateIndex,
      roundIndex = _ref10.roundIndex;

  return _react2.default.createElement(
    'div',
    { className: 'tasks' },
    viewStore.viewModeExpanded === false && state.tasks.length !== 0 ? _react2.default.createElement(
      'div',
      { className: 'task task-category-labels' },
      _react2.default.createElement(
        'div',
        { className: 'task-details' },
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'ID'
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Type'
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Title'
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Description'
        ),
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Required'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'task-actions-container' },
        _react2.default.createElement(
          'div',
          { className: 'detail' },
          'Actions'
        )
      )
    ) : '',
    state.tasks.map(function (task, taskIndex) {
      return _react2.default.createElement(SortableTask, { viewStore: viewStore, key: 'task-' + taskIndex, index: taskIndex, taskIndex: taskIndex, task: task, state: state, round: round });
    }),
    state.tasks.length === 0 && _react2.default.createElement(
      'div',
      { className: 'state-empty' },
      'State Empty'
    ),
    _react2.default.createElement(
      'div',
      { className: 'add-task-container' },
      _react2.default.createElement(
        'div',
        { className: 'add-task', onClick: function onClick(event) {
            return viewStore.addTaskToSelectedState(event, state, round, stateIndex, roundIndex);
          } },
        'Add Activity'
      )
    )
  );
}));

var SortableTask = (0, _reactSortableHoc.SortableElement)((0, _mobxReact.observer)(function (_ref11) {
  var viewStore = _ref11.viewStore,
      taskIndex = _ref11.taskIndex,
      task = _ref11.task,
      state = _ref11.state,
      round = _ref11.round;
  return _react2.default.createElement(
    'div',
    { className: 'task' },
    _react2.default.createElement(
      'div',
      { className: 'task-details' },
      viewStore.viewModeExpanded === false ? _react2.default.createElement(
        'div',
        { className: 'detail id' },
        _react2.default.createElement(
          'span',
          null,
          viewStore.viewModeExpanded === true ? 'ID: ' : ''
        ),
        _react2.default.createElement(
          'span',
          null,
          viewStore.tasks[task.id]["id"]
        )
      ) : '',
      _react2.default.createElement(
        'div',
        { className: 'detail display-title' },
        _react2.default.createElement(
          'span',
          null,
          viewStore.viewModeExpanded === true ? 'Title: ' : ''
        ),
        _react2.default.createElement(
          'span',
          null,
          task.displayTitle
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'detail activity-type' },
        _react2.default.createElement(
          'span',
          null,
          viewStore.viewModeExpanded === true ? 'Type: ' : ''
        ),
        _react2.default.createElement(
          'span',
          null,
          task.activityType.id
        )
      ),
      viewStore.viewModeExpanded === false ? _react2.default.createElement(
        'div',
        { className: 'detail description' },
        _react2.default.createElement('span', null),
        _react2.default.createElement(
          'span',
          null,
          task.description
        )
      ) : '',
      _react2.default.createElement(
        'div',
        { className: 'detail required' },
        _react2.default.createElement(
          'span',
          null,
          viewStore.viewModeExpanded === true ? 'Required: ' : ''
        ),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('input', { type: 'checkbox', className: 'toggle', onChange: function onChange(event) {
              return viewStore.updateTaskRequired(event, task);
            }, checked: task.required }),
          _react2.default.createElement(
            'label',
            { onClick: function onClick(event) {
                return viewStore.updateTaskRequired(event, task);
              } },
            _react2.default.createElement('span', null)
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'task-actions-container' },
      _react2.default.createElement(
        'div',
        { className: 'task-actions' },
        _react2.default.createElement(
          'div',
          { className: 'action delete', onClick: function onClick(event) {
              return viewStore.deleteTaskFromTeamState(event, state, taskIndex);
            } },
          'Remove'
        ),
        _react2.default.createElement(
          'div',
          { className: 'action view', onClick: function onClick(event) {
              return viewStore.viewTaskPreview(event, state, round, task);
            } },
          'View'
        )
      )
    )
  );
}));

var TaskManager = (_dec = (0, _mobxReact.inject)('editorViewStore'), _dec(_class11 = (0, _mobxReact.observer)(_class11 = function (_BaseComponent8) {
  (0, _inherits3.default)(TaskManager, _BaseComponent8);

  function TaskManager() {
    var _ref12;

    var _temp4, _this13, _ret4;

    (0, _classCallCheck3.default)(this, TaskManager);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp4 = (_this13 = (0, _possibleConstructorReturn3.default)(this, (_ref12 = TaskManager.__proto__ || (0, _getPrototypeOf2.default)(TaskManager)).call.apply(_ref12, [this].concat(args))), _this13), _this13.taskTypePlaceholder = 'Select Task Type...', _temp4), (0, _possibleConstructorReturn3.default)(_this13, _ret4);
  }

  (0, _createClass3.default)(TaskManager, [{
    key: 'generateTask',
    value: function generateTask(taskKey) {
      var _this14 = this;

      var task = this.props.viewStore.tasks[taskKey];
      if (this.props.viewStore.tasks[taskKey].displayTitle.toLowerCase().indexOf(this.props.viewStore.taskPickerSearchFilter.toLowerCase()) > -1 || this.props.viewStore.tasks[taskKey].description.toLowerCase().indexOf(this.props.viewStore.taskPickerSearchFilter.toLowerCase()) > -1 || this.props.viewStore.tasks[taskKey].activityType.id && this.props.viewStore.tasks[taskKey].activityType.id.toLowerCase().indexOf(this.props.viewStore.taskPickerSearchFilter.toLowerCase()) > -1) {
        var _React$createElement;

        return _react2.default.createElement(
          'div',
          (_React$createElement = { className: 'task' }, (0, _defineProperty3.default)(_React$createElement, 'className', this.props.viewStore.taskPickerActiveTask === taskKey ? "task viewing" : "task"), (0, _defineProperty3.default)(_React$createElement, 'key', taskKey), (0, _defineProperty3.default)(_React$createElement, 'onClick', function onClick(event) {
            return _this14.props.viewStore.viewTaskInTaskPicker(taskKey);
          }), _React$createElement),
          this.props.viewStore.activityManagerActive !== true && _react2.default.createElement(
            'div',
            { className: 'add-to-que' },
            _react2.default.createElement(
              'span',
              { className: 'checkbox-item' },
              _react2.default.createElement('input', { type: 'checkbox', className: 'checkbox green', checked: this.props.viewStore.taskPickerQue.indexOf(taskKey) > -1 ? 'checked' : '' }),
              _react2.default.createElement(
                'label',
                { onClick: function onClick(event) {
                    return _this14.props.viewStore.addTaskToQue(taskKey);
                  } },
                _react2.default.createElement('span', null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'details' },
            _react2.default.createElement(
              'div',
              { className: 'detail', title: 'ID: ' + this.props.viewStore.tasks[taskKey].id },
              this.props.viewStore.tasks[taskKey].displayTitle
            ),
            _react2.default.createElement(
              'div',
              { className: 'detail' },
              this.props.viewStore.tasks[taskKey].activityType.id
            ),
            _react2.default.createElement(
              'div',
              { className: 'detail' },
              this.props.viewStore.tasks[taskKey].description
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'actions' },
            _react2.default.createElement(
              'div',
              { className: 'clone action', onClick: function onClick(e) {
                  return _this14.props.viewStore.cloneTask(task);
                } },
              'Clone'
            ),
            _react2.default.createElement(
              'div',
              { className: 'delete action', onClick: function onClick(e) {
                  return _this14.props.viewStore.permanentlyDeleteTask(task);
                } },
              'Delete'
            )
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this15 = this;

      var self = this;
      var _props = this.props,
          _props$viewStore2 = _props.viewStore,
          componentList = _props$viewStore2.componentList,
          SelectedView = _props$viewStore2.SelectedView,
          selectedTask = _props$viewStore2.selectedTask,
          editorViewStore = _props.editorViewStore;


      function titleCase(str) {
        if (str != undefined) {
          var splitStr = str.replace('-', ' ').toLowerCase().split(' ');
          for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
          }
          return splitStr.join(' ');
        } else {
          return str;
        }
      }

      return _react2.default.createElement(
        'div',
        { className: "task-picker " + (this.props.active === true ? 'active' : '') },
        _react2.default.createElement(
          'div',
          (0, _defineProperty3.default)({ className: 'task-pool' }, 'className', this.props.viewStore.taskPickerViewOnlyMode === false ? 'task-pool' : 'task-pool view-only-mode'),
          _react2.default.createElement(
            'div',
            { className: 'header' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              'Activity Manager'
            ),
            _react2.default.createElement(
              'div',
              { className: 'round-and-state-details' },
              _react2.default.createElement(
                'div',
                { className: 'details' },
                _react2.default.createElement(
                  'div',
                  { className: 'round-name' },
                  _react2.default.createElement(
                    'span',
                    { className: 'icon' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Target Round - '
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    this.props.viewStore.taskPickerRoundObj && this.props.viewStore.taskPickerRoundObj.displayName
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'state-name' },
                  _react2.default.createElement(
                    'span',
                    { className: 'icon' },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Target State - '
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    this.props.viewStore.taskPickerStateObj && this.props.viewStore.taskPickerStateObj.displayName
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              (0, _defineProperty3.default)({ className: 'filter search' }, 'className', this.props.viewStore.taskPickerNewTaskBuilderActive === true ? 'filter search expand-input' : 'filter search'),
              _react2.default.createElement('input', { type: 'text', placeholder: 'Activity Search...', value: this.props.viewStore.taskPickerSearchFilter, onChange: function onChange(event) {
                  return _this15.props.viewStore.updateTaskPickerSearchFilter(event);
                } }),
              this.props.viewStore.taskPickerNewTaskBuilderActive === false ? _react2.default.createElement(
                'div',
                { className: this.props.viewStore.taskPickerViewOnlyMode === true ? 'btn green add-a' : 'btn green add-a', onClick: function onClick(event) {
                    return _this15.props.viewStore.createNewTask();
                  } },
                'Create Activity'
              ) : ''
            )
          ),
          _react2.default.createElement(
            'div',
            { className: this.props.viewStore.activityManagerActive !== true ? 'pool' : 'pool task-manager-active' },
            (0, _keys2.default)(self.props.viewStore.tasks).map(function (task, taskIndex, tasks) {
              return self.generateTask(task);
            })
          ),
          this.props.viewStore.activityManagerActive !== true && _react2.default.createElement(
            'div',
            { className: 'footer' },
            _react2.default.createElement(
              'div',
              { className: 'round-name' },
              _react2.default.createElement(
                'span',
                { className: 'icon' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Target Round - '
                )
              ),
              _react2.default.createElement(
                'span',
                null,
                this.props.viewStore.taskPickerRoundObj && this.props.viewStore.taskPickerRoundObj.displayName
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'state-name' },
              _react2.default.createElement(
                'span',
                { className: 'icon' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Target State - '
                )
              ),
              _react2.default.createElement(
                'span',
                null,
                this.props.viewStore.taskPickerStateObj && this.props.viewStore.taskPickerStateObj.displayName
              )
            ),
            _react2.default.createElement(
              'div',
              { className: this.props.viewStore.taskPickerQue.length ? "btn green checked-b" : "btn green checked-b disabled", onClick: function onClick(event) {
                  return self.props.viewStore.addSelectedTasksToState();
                } },
              'Add Checked To: ',
              _react2.default.createElement(
                'b',
                null,
                this.props.viewStore.taskPickerStateObj && this.props.viewStore.taskPickerStateObj.displayName
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: this.props.viewStore.taskPickerViewOnlyMode === false ? 'task-viewer' : 'task-viewer view-only-mode' },
          _react2.default.createElement(
            'div',
            { className: 'title-bar' },
            _react2.default.createElement(
              'span',
              { className: 'detail' },
              this.props.viewStore.taskPickerActiveTask !== null ? selectedTask.displayTitle : '',
              ' '
            ),
            this.props.viewStore.taskPickerActiveTask !== null && _react2.default.createElement(
              'div',
              { className: this.props.editorViewStore.isEditorOpen === false ? 'btn-b edit-b' : 'btn-b edit-b hide', onClick: function onClick() {
                  return editorViewStore.startEditing(selectedTask.activity);
                } },
              'Edit'
            ),
            _react2.default.createElement(
              'div',
              { className: this.props.editorViewStore.isEditorOpen === false ? 'btn-b arrow-left-b' : 'btn-b arrow-left-b hide', onClick: function onClick(event) {
                  return _this15.props.viewStore.closeTaskPicker();
                } },
              'Back'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'viewport' },
            this.props.viewStore.taskPickerNewTaskBuilderActive !== false ? _react2.default.createElement(
              'div',
              { className: 'task-creator' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                'Create Activity'
              ),
              _react2.default.createElement(
                'div',
                { className: 'options' },
                _react2.default.createElement(
                  'div',
                  { className: 'detail select-component' },
                  _react2.default.createElement(
                    'div',
                    { className: 'custom-select' },
                    _react2.default.createElement(
                      'select',
                      { onChange: function onChange(event) {
                          return _this15.props.viewStore.updateNewTaskType(event);
                        } },
                      _react2.default.createElement(
                        'option',
                        { selected: true, disabled: true },
                        'Activity Type...'
                      ),
                      componentList.map(function (type, tIndex) {
                        return _react2.default.createElement(
                          'option',
                          { key: tIndex, value: componentList[tIndex] },
                          componentList[tIndex]
                        );
                      })
                    ),
                    _react2.default.createElement('div', null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'detail display-name' },
                  _react2.default.createElement('input', { placeholder: 'Activity Name', type: 'text', onChange: function onChange(event) {
                      return _this15.props.viewStore.updateNewTaskDisplayTitle(event);
                    } })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'detail description' },
                  _react2.default.createElement('textarea', { placeholder: 'Activity Description (optional)', type: 'text', onChange: function onChange(event) {
                      return _this15.props.viewStore.updateNewTaskDescription(event);
                    } })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'validation' },
                  this.props.viewStore.taskPickerNewTaskType === '' || this.props.viewStore.taskPickerNewTaskType === this.taskTypePlaceholder ? _react2.default.createElement(
                    'div',
                    { className: 'item' },
                    'You must select an activity type'
                  ) : "",
                  this.props.viewStore.taskPickerNewTaskTitle === '' ? _react2.default.createElement(
                    'div',
                    { className: 'item' },
                    'You must give the new activity a name'
                  ) : ""
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'actions' },
                  _react2.default.createElement(
                    'span',
                    { className: 'btn red cancel-b', onClick: function onClick(event) {
                        return _this15.props.viewStore.cancelTaskCreation();
                      } },
                    'Cancel'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: this.props.viewStore.taskPickerNewTaskTitle !== '' && this.props.viewStore.taskPickerNewTaskType !== this.taskTypePlaceholder && this.props.viewStore.taskPickerNewTaskType !== '' ? 'btn green add-a' : 'btn green add-a disabled', onClick: function onClick(event) {
                        return _this15.props.viewStore.createSelectedTask();
                      } },
                    'Create'
                  )
                )
              )
            ) : '',
            !!SelectedView && this.props.viewStore.taskPickerActiveTask !== null && this.props.viewStore.taskPickerNewTaskBuilderActive === false ? _react2.default.createElement(
              'div',
              { className: 'task-preview' },
              _react2.default.createElement(SelectedView, null)
            ) : '',
            this.props.viewStore.taskPickerActiveTask !== null || this.props.viewStore.taskPickerNewTaskBuilderActive === true ? '' : _react2.default.createElement(
              'div',
              { className: 'select-task-message' },
              'Select An Activity...'
            )
          )
        )
      );
    }
  }]);
  return TaskManager;
}(_baseComponent2.default)) || _class11) || _class11);

var NothingToShowMessage = (0, _mobxReact.observer)(_class13 = function (_BaseComponent9) {
  (0, _inherits3.default)(NothingToShowMessage, _BaseComponent9);

  function NothingToShowMessage() {
    var _ref13;

    var _temp5, _this16, _ret5;

    (0, _classCallCheck3.default)(this, NothingToShowMessage);

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _ret5 = (_temp5 = (_this16 = (0, _possibleConstructorReturn3.default)(this, (_ref13 = NothingToShowMessage.__proto__ || (0, _getPrototypeOf2.default)(NothingToShowMessage)).call.apply(_ref13, [this].concat(args))), _this16), _this16.quotes = [{
      "quote": "The creation of a thousand forests is in one acorn",
      "author": "Ralph Waldo Emerson"
    }, {
      "quote": "Innovation has nothing to do with how many R & D dollars you have. When Apple came up with the Mac, IBM was spending at least 100 times more on R & D. It's not about money. It's about the people you have, how you're led, and how much you get it.",
      "author": "Steve Jobs"
    }, {
      "quote": "The main factor in any form of creativeness is the life of a human spirit, that of the actor and his part, their joint feelings and subconscious creation.",
      "author": "Constantin Stanislavski"
    }, {
      "quote": "Let the future tell the truth, and evaluate each one according to his work and accomplishments. The present is theirs; the future, for which I have really worked, is mine.",
      "author": "Nikola Tesla"
    }, {
      "quote": "Genius is one percent inspiration and ninety-nine percent perspiration.",
      "author": "Thomas A. Edison"
    }, {
      "quote": "I'm an inventor. I became interested in long-term trends because an invention has to make sense in the world in which it is finished, not the world in which it is started.",
      "author": "Ray Kurzweil"
    }, {
      "quote": "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma - which is living with the results of other people's thinking. Don't let the noise of others' opinions drown out your own inner voice. And most important, have the courage to follow your heart and intuition.",
      "author": "Steve Jobs"
    }, {
      "quote": "Your work is going to fill a large part of your life, and the only way to be truly satisfied is to do what you believe is great work. And the only way to do great work is to love what you do. If you haven't found it yet, keep looking. Don't settle. As with all matters of the heart, you'll know when you find it.",
      "author": "Steve Jobs"
    }], _this16.newQuote = _this16.generateQuote(), _temp5), (0, _possibleConstructorReturn3.default)(_this16, _ret5);
  }

  (0, _createClass3.default)(NothingToShowMessage, [{
    key: 'generateQuote',
    value: function generateQuote() {
      var randomQuote = Math.floor(Math.random() * this.quotes.length);
      return _react2.default.createElement(
        'div',
        { className: 'quote' },
        _react2.default.createElement(
          'div',
          { className: 'text' },
          _react2.default.createElement(
            'b',
            null,
            '"'
          ),
          this.quotes[randomQuote]["quote"],
          _react2.default.createElement(
            'b',
            null,
            '"'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'author' },
          '~ ',
          this.quotes[randomQuote]["author"]
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this17 = this;

      var options = this.props.viewStore.simulation.$parent.entities.get("RegisteredShellContentModel").entities.map(function (ent) {
        return ent.id;
      });
      return _react2.default.createElement(
        'div',
        { className: 'workspace-container empty' },
        _react2.default.createElement(
          'div',
          { className: 'workspace' },
          _react2.default.createElement(
            'div',
            { className: 'empty-message' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              'Let\'s Build Something Awesome!'
            ),
            this.newQuote,
            _react2.default.createElement(
              'div',
              { className: 'display-name' },
              _react2.default.createElement('input', { placeholder: 'Enter Simulation Name', onChange: function onChange(e) {
                  return _this17.props.viewStore.simulation.updateValue("displayName", e.target.value);
                } })
            ),
            !this.props.viewStore.simulation.shellType && _react2.default.createElement(
              'div',
              { className: 'custom-select' },
              _react2.default.createElement(
                'select',
                { onChange: function onChange(e) {
                    return _this17.props.viewStore.simulation.updateValue("shellType", e.target.value);
                  } },
                _react2.default.createElement(
                  'option',
                  null,
                  'Select Simulation Shell'
                ),
                options.map(function (o) {
                  return _react2.default.createElement(
                    'option',
                    { key: o },
                    o
                  );
                })
              ),
              _react2.default.createElement('div', null)
            ),
            _react2.default.createElement(
              'div',
              { className: !this.props.viewStore.simulation.shellType ? 'flow-button create-new-round disabled' : 'flow-button create-new-round', onClick: function onClick() {
                  return _this17.props.viewStore.createNewRound();
                } },
              'Create Simulation'
            )
          )
        )
      );
    }
  }]);
  return NothingToShowMessage;
}(_baseComponent2.default)) || _class13;

var LinearFlowEditor = (_dec2 = (0, _mobxReact.inject)('editorViewStore'), _dec3 = (0, _mobxReact.inject)('modalViewStore'), _dec2(_class15 = _dec3(_class15 = (0, _mobxReact.observer)(_class15 = (_temp6 = _class16 = function (_BaseComponent10) {
  (0, _inherits3.default)(LinearFlowEditor, _BaseComponent10);

  function LinearFlowEditor() {
    (0, _classCallCheck3.default)(this, LinearFlowEditor);
    return (0, _possibleConstructorReturn3.default)(this, (LinearFlowEditor.__proto__ || (0, _getPrototypeOf2.default)(LinearFlowEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(LinearFlowEditor, [{
    key: 'render',
    value: function render() {
      var _this19 = this;

      var _viewStore = this.viewStore,
          currentView = _viewStore.currentView,
          clearView = _viewStore.clearView,
          SelectedView = _viewStore.SelectedView;


      if (currentView && currentView.id.indexOf("simulation_") === 0) {
        // When viewing simulation player
        return _react2.default.createElement(
          'div',
          { className: 'shell-wrapper ' + (this.viewStore.simPreviewActionsCollapsed === true ? 'header-bar-closed' : 'header-bar-open') },
          _react2.default.createElement(
            'div',
            { className: 'sim-shell-actions ' + (this.viewStore.simPreviewActionsCollapsed === true ? 'closed' : 'opened') },
            _react2.default.createElement(
              'div',
              { className: 'shell-viewer-title' },
              'Simulation Preview'
            ),
            _react2.default.createElement(
              'div',
              { className: 'btn-b arrow-left-b', onClick: function onClick() {
                  return clearView();
                } },
              'Back'
            ),
            _react2.default.createElement('div', { className: 'toggle ' + (this.viewStore.simPreviewActionsCollapsed === true ? 'closed' : 'opened'), onClick: function onClick() {
                return _this19.viewStore.toggleSimPreviewActions();
              } })
          ),
          _react2.default.createElement(SelectedView, { className: 'activity' })
        );
      } else if (currentView && currentView.id.indexOf("editsimulation_") === 0) {
        // When viewing shell edit view
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'sim-shell-options' },
            _react2.default.createElement(
              'div',
              { className: '', onClick: function onClick() {
                  return clearView();
                } },
              'Back'
            )
          ),
          _react2.default.createElement(SelectedView, null)
        );
      } else {
        // When viewing linear flow editor
        return _react2.default.createElement(
          'div',
          { className: 'flow-and-tasks' },
          _react2.default.createElement(
            'div',
            { className: "flow-editor " + (this.viewStore.taskPickerActive === false ? "active" : "") },
            _react2.default.createElement(FlowActionBar, { viewStore: this.viewStore }),
            _react2.default.createElement(FlowQuickNav, { viewStore: this.viewStore }),
            this.viewStore.simulation.rounds.length !== 0 ? _react2.default.createElement(FlowWorkspace, { viewStore: this.viewStore }) : _react2.default.createElement(NothingToShowMessage, { viewStore: this.viewStore })
          ),
          _react2.default.createElement(TaskManager, { viewStore: this.viewStore, active: this.viewStore.taskPickerActive === true })
        );
      }
    }
  }]);
  return LinearFlowEditor;
}(_baseComponent2.default), _class16.ViewStore = _editorViewstore2.default, _temp6)) || _class15) || _class15) || _class15);
;

var _default = LinearFlowEditor;
exports.default = _default;
;

var _temp7 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FlowActionBar, 'FlowActionBar', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(FlowQuickNav, 'FlowQuickNav', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(FlowWorkspace, 'FlowWorkspace', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableRoundsContainer, 'SortableRoundsContainer', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableRounds, 'SortableRounds', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableRound, 'SortableRound', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableStatesContainer, 'SortableStatesContainer', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableStates, 'SortableStates', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableState, 'SortableState', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableTasksContainer, 'SortableTasksContainer', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableTasks, 'SortableTasks', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(SortableTask, 'SortableTask', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(TaskManager, 'TaskManager', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(NothingToShowMessage, 'NothingToShowMessage', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(LinearFlowEditor, 'LinearFlowEditor', 'src/entity_modules/project-entity/editor.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/project-entity/editor.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/contentmodel.js");

var projectContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = projectContentModels;
var ContentModel = exports.ContentModel = projectContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/project-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/project-entity/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/round-entity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoundContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class2, _temp2;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _teamstateEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/teamstate-entity/index.js");

var _collectionGridEditor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/collection-grid-editor/index.js");

var _collectionGridEditor2 = _interopRequireDefault(_collectionGridEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RoundContentModel = exports.RoundContentModel = (_dec = _mobx.observable.shallow, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(RoundContentModel, _BaseContentModel);

  function RoundContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RoundContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RoundContentModel.__proto__ || (0, _getPrototypeOf2.default)(RoundContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'displayName', _descriptor, _this), _initDefineProp(_this, 'beginTime', _descriptor2, _this), _initDefineProp(_this, 'endTime', _descriptor3, _this), _initDefineProp(_this, 'teamStates', _descriptor4, _this), _initDefineProp(_this, 'icon', _descriptor5, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /*@slot */
  /*@slot */
  /*@slot */
  /*@slot( TeamStateContentModel ) */

  return RoundContentModel;
}(_baseContentmodel2.default), _class2.maxParents = ["SimulationContentModel", 1], _class2._slots = {
  displayName: "",
  beginTime: 0,
  endTime: 0,
  teamStates: [_teamstateEntity.ContentModel],
  icon: "" }, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'displayName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'beginTime', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'endTime', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 2;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'teamStates', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'icon', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "round-icon";
  }
})), _class));
var _default = RoundContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RoundContentModel, 'RoundContentModel', 'src/entity_modules/round-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/round-entity/contentmodel.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/round-entity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/round-entity/contentmodel.js");

var roundContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = roundContentModels;
var ContentModel = exports.ContentModel = roundContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/round-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/round-entity/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.SimulationComponent = exports.SimulationViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _dec2, _class3, _class4, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _simgateDatamodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simgate-datamodel/index.js");

var _simgateDatamodel2 = _interopRequireDefault(_simgateDatamodel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SimulationViewStore = exports.SimulationViewStore = (_dec = _mobx.observable.ref, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(SimulationViewStore, _BaseViewStore);

  function SimulationViewStore() {
    (0, _classCallCheck3.default)(this, SimulationViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SimulationViewStore.__proto__ || (0, _getPrototypeOf2.default)(SimulationViewStore)).apply(this, arguments));

    _this.dispose = [];

    _initDefineProp(_this, "dataModel", _descriptor, _this);

    var _this$props = _this.props,
        _this$props$dataModel = _this$props.dataModel,
        projectDomainStore = _this$props$dataModel.domainStore,
        _this$props$dataModel2 = _this$props$dataModel.domainStore,
        simgate = _this$props$dataModel2.simgate,
        parentPathId = _this$props$dataModel2.context.simParentPathId,
        simulation = _this$props.contentModel,
        application = _this$props.application;


    if (!application) throw new Error("no application!");
    if (!simgate) throw new Error("no simgate!");
    if (!parentPathId) throw new Error("no parentPathId!");

    //get existing dataModel for this sim if it exists, otherwise create
    if (application.simDataModels[simulation.id]) {
      _this.simDataModel = application.simDataModels[simulation.id];
    } else {
      _this.simDataModel = application.simDataModels[simulation.id] = new _simgateDatamodel2.default({
        simgate: simgate
      });
    }

    // add sim domain store if it doesnt exist
    if (!_this.simDataModel.domainStore) {
      _this.simDataModel.addStore(simulation.SimDomainStore, {
        simgate: simgate,
        projectDomainStore: projectDomainStore,
        simulation: simulation,
        parentPathId: parentPathId,
        contentModel: _this // we can link this in, because we know there is a 1:1 relationship between sim store and sim content model.  this differs from activities because activities may have an unknown hierarchy of submodels etc, and we dont know which may be driving input values at any given time
      });
    }
    _this.simDomainStore = _this.simDataModel.domainStore;

    _this.dispose.push((0, _mobx.reaction)(function () {
      return _this.simDomainStore.isLoaded && !!_this.currentTeamState;
    }, function (ready) {
      if (!ready) return;
      _this.currentTeamState.tasks.forEach(function (task) {
        task.activity.$inputStore = _this.simDataModel[task.id] || _this.simDataModel.addStore(task.activity.InputStore || task.InputStore);
      });
    }));

    if (simulation.shell && simulation.shell.autoAdvanceTeams) {
      _this.dispose.push((0, _mobx.autorun)(function () {
        return _this.allComplete && _this.simDomainStore.completeTask();
      }));
    }
    return _this;
  }

  (0, _createClass3.default)(SimulationViewStore, [{
    key: "currentRoundTeamStates",
    get: function get() {
      var simulation = this.props.contentModel;


      var round = simulation.rounds[this.simDomainStore.currentRoundNo ? this.simDomainStore.currentRoundNo - 1 : 0];
      return round.teamStates;
    }
  }, {
    key: "currentTeamState",
    get: function get() {
      var _this2 = this;

      var ts = this.currentRoundTeamStates.find(function (ts) {
        return ts.id === _this2.simDomainStore.teamStateName;
      });
      if (ts && !ts.tasks.length) debugger;
      return this.currentRoundTeamStates.find(function (ts) {
        return ts.id === _this2.simDomainStore.teamStateName;
      });
    }
  }, {
    key: "allComplete",
    get: function get() {
      return this.currentTeamState && this.currentTeamState.tasks.every(function (task) {
        if (!task.required) return true;
        return task.isCompleted;
      });
    }
  }]);
  return SimulationViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dataModel", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentRoundTeamStates", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "currentRoundTeamStates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTeamState", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "currentTeamState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allComplete", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "allComplete"), _class.prototype)), _class));
var SimulationComponent = exports.SimulationComponent = (_dec2 = (0, _mobxReact.inject)("dataModel", "application"), _dec2(_class3 = (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = (_temp = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(SimulationComponent, _BaseComponent);

  function SimulationComponent() {
    (0, _classCallCheck3.default)(this, SimulationComponent);
    return (0, _possibleConstructorReturn3.default)(this, (SimulationComponent.__proto__ || (0, _getPrototypeOf2.default)(SimulationComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimulationComponent, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$dataModel = _props.dataModel,
          projectDomainStore = _props$dataModel.domainStore,
          _props$dataModel$doma = _props$dataModel.domainStore,
          simgate = _props$dataModel$doma.simgate,
          parentPathId = _props$dataModel$doma.context.simParentPathId,
          simulation = _props.contentModel,
          application = _props.application;
      var simDataModel = this.viewStore.simDataModel;


      var Shell = simulation.shell && simulation.shell.Component;

      return !!Shell && _react2.default.createElement(
        _mobxReact.Provider,
        { inputStore: this.simDomainStore, dataModel: simDataModel },
        _react2.default.createElement(Shell, {
          inputStore: this.simDomainStore,
          dataModel: simDataModel,
          contentModel: simulation.shell,
          simulation: simulation,
          projectDomainStore: projectDomainStore,
          parentPathId: parentPathId
        })
      );
    }
  }]);
  return SimulationComponent;
}(_baseComponent2.default), _class4.ViewStore = SimulationViewStore, _temp)) || _class3) || _class3) || _class3);
var Component = exports.Component = SimulationComponent;
var _default = Component;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimulationViewStore, "SimulationViewStore", "src/entity_modules/simulation-entity/component.js");

  __REACT_HOT_LOADER__.register(SimulationComponent, "SimulationComponent", "src/entity_modules/simulation-entity/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "src/entity_modules/simulation-entity/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "src/entity_modules/simulation-entity/component.js");
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulationContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _class2, _temp;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _cloner = __webpack_require__("./node_modules/cloner/build/cloner.node.js");

var _component = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/component.js");

var _component2 = _interopRequireDefault(_component);

var _roundEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/round-entity/index.js");

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/editor.js");

var _editor2 = _interopRequireDefault(_editor);

var _simDomainStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/sim-domain-store/index.js");

var _simDomainStore2 = _interopRequireDefault(_simDomainStore);

var _configurationEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RegisteredShellContentModel = _configurationEntity.ContentModels.RegisteredShellContentModel;
var SimulationContentModel = exports.SimulationContentModel = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.ref, _dec3 = _mobx.observable.shallow, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, (_class = (_temp = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(SimulationContentModel, _BaseContentModel);

  function SimulationContentModel() {
    (0, _classCallCheck3.default)(this, SimulationContentModel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SimulationContentModel.__proto__ || (0, _getPrototypeOf2.default)(SimulationContentModel)).apply(this, arguments));

    _this.Editor = _editor2.default;
    _this.Component = _component2.default;

    _initDefineProp(_this, '_options', _descriptor, _this);

    _initDefineProp(_this, 'lastSaved', _descriptor2, _this);

    _initDefineProp(_this, 'lastPublished', _descriptor3, _this);

    _initDefineProp(_this, 'willPublish', _descriptor4, _this);

    _initDefineProp(_this, 'shellType', _descriptor5, _this);

    _initDefineProp(_this, 'shell', _descriptor6, _this);

    _initDefineProp(_this, 'displayName', _descriptor7, _this);

    _initDefineProp(_this, 'rounds', _descriptor8, _this);

    (0, _mobx.when)(function () {
      return _this.$parent.hasHydrated;
    }, function () {
      // auto create shell when shellType is chosen
      if (!_this.shell) {
        (0, _mobx.reaction)(function () {
          return _this.shellType;
        }, function (shellType, rxn) {
          if (!shellType) return;
          _this.createShell();
          _this.saveEntity();
          _this.shell.saveEntity();
          rxn.dispose();
        }, { fireImmediately: true });
      }
    });
    return _this;
  }
  // @observable @deepBind meta = {
  //   shellType: {
  //     get readonly(){
  //       return !this.isNew
  //     }
  //   },
  //   "displayName": {
  //     required: true
  //   }
  // }


  (0, _createClass3.default)(SimulationContentModel, [{
    key: 'saveEntity',
    value: function saveEntity() {
      var _this2 = this;

      var ref = this.lastSaved;
      this.lastSaved = +new Date();
      this._saveEntity(null, function (err) {
        return _this2.lastSaved = ref;
      });
    }
  }, {
    key: 'exportToServer',
    value: function exportToServer(cb, errCbOrig) {
      var _this3 = this;

      if (this.anyDirty) return console.warn("cannot publish while dirty, please save");

      if (!this.readyToWriteToServer) {
        // save normally
        throw new Error("not ready to write to server!");
      }

      if (this.isSaving || this.isPublishing) return console.warn("already saving...");

      // so we know when this "isSaving"
      this.willPublish = +new Date();
      var simgate = this.$parent.simgate;
      var ref = this.lastPublished;
      this.lastPublished = +new Date();

      var errCb = function errCb(err) {
        _this3.lastPublished = ref;
        errCbOrig && errCbOrig(err);
      };

      // @TODO promises anyone???
      // add stateMachine first
      simgate.runTask(simgate.config.update, {
        path: 'simulation://stateMachine.flows.' + this.id,
        set: this._dtos.machine
      }, {
        // add scenario that references state machine
        onSuccess: function onSuccess() {
          return simgate.runTask(simgate.config.update, {
            path: 'simulation://scenarios.' + _this3.id,
            set: _this3._dtos.scenario
          }, {
            // add stateMachine first
            onSuccess: function onSuccess() {
              return simgate.runTask(simgate.config.update, {
                path: 'simulation' + (window.trcAppSettings.publishEnv || '') + '://stateMachine.flows.' + _this3.id,
                set: _this3._dtos.machine
              }, {
                // add scenario that references state machine
                onSuccess: function onSuccess() {
                  return simgate.runTask(simgate.config.update, {
                    path: 'simulation' + (window.trcAppSettings.publishEnv || '') + '://scenarios.' + _this3.id,
                    set: _this3._dtos.scenario
                  }, {
                    // commit to svn
                    onSuccess: function onSuccess() {
                      return simgate.runTask(simgate.config.commit, { path: "simulation" + (window.trcAppSettings.publishEnv || '') }, {
                        onSuccess: function onSuccess() {
                          return simgate.runTask(simgate.utils.execute, {
                            command: "authoring-commands://compile-state-machine",
                            arguments: '"..\\simulation' + (window.trcAppSettings.publishEnv || '') + '.json" -batch -config "Debug" -copySource true"'
                          }, {
                            onSuccess: function onSuccess() {
                              return _this3._saveEntity(cb, errCb);
                            },
                            onFailure: errCb
                          });
                        },
                        onFailure: errCb
                      });
                    },
                    onFailure: errCb
                  });
                },
                onFailure: errCb
              });
            },
            onFailure: errCb
          });
        },
        onFailure: errCb
      });
    }
  }, {
    key: 'createShell',
    value: function createShell() {
      this.shell = new this.ShellContentModel({ id: this.id + "_shell" + Math.floor(Math.random() * 100), shouldAutoPopulate: true });
    }
  }, {
    key: 'isPublishing',
    get: function get() {
      return this.willPublish > this.lastPublished;
    }

    /* slot( RegisteredShellContentModel ) */
    /* slot */
    /* @slot */
    /* @slot( RoundContentModel ) */
  }, {
    key: 'warnings',

    // /* @slot( BooleanContentModel ) */ @observable default = true
    // /* @slot( TeamStateContentModel ) */ @observable initState = null
    // /* @slot( TeamStateContentModel ) */ @observable states = []

    get: function get() {
      var warnings = [];
      if (!this.rounds.length) warnings.push("Missing rounds");
      if (!this.rounds.every(function (rnd) {
        return rnd.teamStates.length > 0 && rnd.teamStates.every(function (ts) {
          return ts.tasks.length > 0;
        });
      })) warnings.push("Round(s) missing teamstates/tasks");
      if (this.anyDirty) warnings.push("Simulation must be saved");
      if (this.isPublishDirty) warnings.push("Simulation must be published");
      return warnings;
    }
  }, {
    key: 'publishWarnings',
    get: function get() {
      var warnings = [];
      if (!this.rounds.length) warnings.push("Missing rounds");
      if (!this.rounds.every(function (rnd) {
        return rnd.teamStates.length > 0 && rnd.teamStates.every(function (ts) {
          return ts.tasks.length > 0;
        });
      })) warnings.push("Round(s) missing teamstates/tasks");
      if (this.anyDirty) warnings.push("Simulation must be saved");
      if (!this.isPublishDirty) warnings.push("Simulation already published");
      return warnings;
    }
  }, {
    key: 'SimDomainStore',
    get: function get() {
      var _desc2, _value2, _class3, _descriptor9;

      var self = this;
      return _class3 = function (_DomainStore) {
        (0, _inherits3.default)(SimDomainStore, _DomainStore);

        function SimDomainStore() {
          var _ref;

          var _temp2, _this4, _ret;

          (0, _classCallCheck3.default)(this, SimDomainStore);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp2 = (_this4 = (0, _possibleConstructorReturn3.default)(this, (_ref = SimDomainStore.__proto__ || (0, _getPrototypeOf2.default)(SimDomainStore)).call.apply(_ref, [this].concat(args))), _this4), _initDefineProp(_this4, 'inputs', _descriptor9, _this4), _temp2), (0, _possibleConstructorReturn3.default)(_this4, _ret);
        }

        return SimDomainStore;
      }(_simDomainStore2.default), (_descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'inputs', [_mobx.observable], {
        enumerable: true,
        initializer: function initializer() {
          return self.allSpecificInputs;
        }
      })), _class3;
    }

    // all inputs of the shell and its children, inputs of tasks and sub-sims are ignored since they are already managed
    // these inputs get put onto the SimDomainStore for this sim

  }, {
    key: 'allSpecificInputs',
    get: function get() {
      var collectedInputs = this.shell.getAllChildEntitiesFiltered(function (childCm, parentCm, slotName) {
        var slot = parentCm.slots[slotName];
        if (Array.isArray(slot)) slot = slot[0];
        if (slot === SimulationContentModel) return false;
      }).map(function (ent) {
        return ent._inputs;
      }).concat(this.shell._inputs);

      return _cloner.shallow.merge.apply(_cloner.shallow, [{}].concat((0, _toConsumableArray3.default)(collectedInputs)));
    }
  }, {
    key: 'isPublishDirty',
    get: function get() {
      return !this.anyDirty && this.lastPublished < this.lastSaved;
    }
  }, {
    key: 'ShellContentModel',
    get: function get() {
      return this.shellType && this.shellType.module && this.shellType.module.ContentModel;
    }
  }, {
    key: 'shellDescription',
    get: function get() {
      return this.shellType && this.shellType.module && this.shellType.module.description;
    }
  }, {
    key: 'invalid',
    get: function get() {
      var invalid = (0, _assign2.default)({}, this._invalid);
      if (!this.displayName) invalid.displayName = "Please provide a display title!";
      if (!this.shellType) invalid.shellType = "Please choose a shellType";
      if (this.shell && this.shell.isNew && this.shell.allChildCms.length && this.shell.allChildCms.some(function (cm) {
        return cm[0].isNew;
      })) {
        invalid.shell = "Please save all submodels";
      }
      return invalid;
    }
  }, {
    key: '_dtos',
    get: function get() {
      var _this5 = this;

      var states = {};
      var rounds = [];

      this.rounds.forEach(function (round, roundIndex, roundArr) {
        // handle teamstates
        var isFirstRound = roundIndex === 0;
        var isLastRound = roundIndex === roundArr.length - 1;
        var roundNumber = roundIndex + 1;
        round.teamStates.forEach(function (state, stateIndex, stateArr) {
          var isFirstState = stateIndex === 0;
          var isLastState = stateIndex === stateArr.length - 1;
          if (isFirstRound && isFirstState) {
            states["Init"] = {
              "title": "Init",
              "commands": {
                "enter": 'ResetTeam(TeamResetOptions.Default & ~TeamResetOptions.Num1);Team.Round = 1;TransitionTo("' + state.id + '");'
              }
            };
          }

          states[state.id] = {
            "title": state.displayName || state.id,
            "commands": state.runModel ? { "enter": 'RunModel("' + state.runModel + '", null, new XObject("actors", new object[] { new XObject("tag", "' + state.runModel + '", "saveOutputs", true) }));' } : {}
          };
          if (isFirstState && !isFirstRound) states[state.id].commands.enter = 'Team.Round = ' + roundNumber + ';';
          if (!(isLastState && isLastRound)) {
            var nextState = isLastState ? roundArr[roundIndex + 1].teamStates[0] : stateArr[stateIndex + 1];
            if (!nextState) return console.warn("round in simulation missing teamstate!" + _this5.id + " " + roundArr[roundIndex + 1].id);
            states[state.id].commands.advance = 'TransitionTo("' + nextState.id + '");';
          }
        });

        // add round to array
        rounds.push({
          "name": round.displayName || round.id,
          "beginTime": round.beginTime,
          "endTime": round.endTime
        });
      });

      return {
        "machine": {
          "type": 'MySimulation.' + this.id + ', MySimulation',
          // "procedures": {
          //   "computeScore": "O[\"Score\"] = 100;"
          // },
          "states": states
        },
        "scenario": {
          "title": this.displayName || this.id,
          "flow": this.id,
          "rounds": rounds
        }
      };
    }
  }, {
    key: 'readyToWriteToServer',
    get: function get() {
      return !(this.isNew //new
      || !this.rounds.length //no rounds
      || !(0, _keys2.default)(this._dtos.machine.states).length //no states
      );
    }
  }]);
  return SimulationContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  "displayName": "",
  "rounds": [_roundEntity.ContentModel],
  shell: _baseContentmodel2.default,
  shellType: RegisteredShellContentModel,
  lastSaved: 0,
  lastPublished: 0
}, _class2._meta = {
  lastSaved: {
    readonly: true
  },
  lastPublished: {
    readonly: true
  } }, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, '_options', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get shell() {
        var _this6 = this;

        return this.$parent.entities.values().filter(function (entity) {
          var shellType = _this6.shellType;

          return eval("shellType && shellType.ContentModelName === entity.type");
        });
      }
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'lastSaved', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'lastPublished', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'willPublish', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isPublishing', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isPublishing'), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'shellType', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'shell', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'displayName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Simulation Name";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'rounds', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'warnings', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'warnings'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'publishWarnings', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'publishWarnings'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'SimDomainStore', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'SimDomainStore'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allSpecificInputs', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allSpecificInputs'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveEntity', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveEntity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isPublishDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isPublishDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'ShellContentModel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'ShellContentModel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'shellDescription', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'shellDescription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'invalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_dtos', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_dtos'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readyToWriteToServer', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readyToWriteToServer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'exportToServer', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'exportToServer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createShell', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createShell'), _class.prototype)), _class));
var _default = SimulationContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RegisteredShellContentModel, 'RegisteredShellContentModel', 'src/entity_modules/simulation-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(SimulationContentModel, 'SimulationContentModel', 'src/entity_modules/simulation-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/simulation-entity/contentmodel.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.localmode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulationContentModel = undefined;

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.js");

var _contentmodel2 = _interopRequireDefault(_contentmodel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SimulationContentModel = exports.SimulationContentModel = (_dec = _mobx.action.bound, (_class = function (_ContentModel) {
  (0, _inherits3.default)(SimulationContentModel, _ContentModel);

  function SimulationContentModel() {
    (0, _classCallCheck3.default)(this, SimulationContentModel);
    return (0, _possibleConstructorReturn3.default)(this, (SimulationContentModel.__proto__ || (0, _getPrototypeOf2.default)(SimulationContentModel)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimulationContentModel, [{
    key: 'exportToServer',
    value: function exportToServer(cb, errCb) {

      if (this.anyDirty) return console.warn("cannot publish while dirty, please save");

      if (!this.readyToWriteToServer) {
        // save normally
        throw new Error("not ready to write to server!");
      }

      if (this.isSaving || this.isPublishing) return console.warn("already saving...");

      // so we know when this "isSaving"
      this.willPublish = +new Date();
      var ref = this.lastPublished;
      this.lastPublished = +new Date();

      this._saveEntity(cb, errCb);
    }
  }]);
  return SimulationContentModel;
}(_contentmodel2.default), (_applyDecoratedDescriptor(_class.prototype, 'exportToServer', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'exportToServer'), _class.prototype)), _class));
var _default = SimulationContentModel;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimulationContentModel, 'SimulationContentModel', 'src/entity_modules/simulation-entity/contentmodel.localmode.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/simulation-entity/contentmodel.localmode.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/editor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SimulationEditorViewStore = undefined;

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _class2, _class3, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/editor.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SimulationEditorViewStore = exports.SimulationEditorViewStore = (_dec = _mobx.action.bound, (_class = function (_EditorViewStore) {
  (0, _inherits3.default)(SimulationEditorViewStore, _EditorViewStore);

  function SimulationEditorViewStore() {
    (0, _classCallCheck3.default)(this, SimulationEditorViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (SimulationEditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(SimulationEditorViewStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimulationEditorViewStore, [{
    key: 'handleExisting',
    value: function handleExisting(e, parent, name) {
      var item = parent.$parent.entities.get(e.target.value) /* || new parent.slots[name]({isNew: true, autoPopulate: true} )*/;
      if (!item) throw new Error("no item");
      parent.updateValue(name, item);
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var contentModel = this.props.contentModel;
      var ret = contentModel && (0, _keys2.default)(contentModel.slots).reduce(function (acc, name) {
        if (contentModel.slots[name] && contentModel.slots[name].prototype instanceof _baseContentmodel2.default) {
          var _subCm = contentModel[name];
          if (!_subCm) return acc;
          if (_subCm.contentModel) debugger;
          acc[_subCm.id] = {
            id: _subCm.id,
            contentModel: _subCm.contentModel || _subCm
          };
        } else if (Array.isArray(contentModel.slots[name])) {
          contentModel[name].forEach(function (subCm) {
            if (!(subCm instanceof _baseContentmodel2.default)) return;
            if (subCm.contentModel) debugger;
            acc[subCm.id] = {
              id: subCm.id,
              contentModel: subCm.contentModel || subCm
            };
          });
        }
        return acc;
      }, {});

      var subCm = contentModel.shell;
      if (!subCm) return ret;
      if (subCm.shellContentModel) debugger;
      ret[subCm.id] = {
        id: subCm.id,
        contentModel: subCm.shellContentModel || subCm
      };

      return ret;
    }
  }]);
  return SimulationEditorViewStore;
}(_editor.EditorViewStore), (_applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleExisting', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleExisting'), _class.prototype)), _class));

var SimulationEditor = (0, _simboxEditable.Decorator)(_class2 = (0, _mobxReact.observer)(_class2 = (_temp = _class3 = function (_BaseComponent) {
  (0, _inherits3.default)(SimulationEditor, _BaseComponent);

  function SimulationEditor() {
    (0, _classCallCheck3.default)(this, SimulationEditor);
    return (0, _possibleConstructorReturn3.default)(this, (SimulationEditor.__proto__ || (0, _getPrototypeOf2.default)(SimulationEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimulationEditor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          editorViewStore = _props.editorViewStore,
          contentModel = _props.contentModel,
          _props$contentModel = _props.contentModel,
          readyToWriteToServer = _props$contentModel.readyToWriteToServer,
          exportToServer = _props$contentModel.exportToServer,
          allCms = _props$contentModel.allCms,
          shell = _props$contentModel.shell,
          isNew = _props$contentModel.isNew,
          updateValue = _props$contentModel.updateValue,
          invalid = _props$contentModel.invalid,
          shellType = _props$contentModel.shellType,
          id = _props$contentModel.id,
          createShell = _props$contentModel.createShell,
          slots = _props$contentModel.slots,
          rounds = _props$contentModel.rounds,
          options = _props.options,
          _onSave = _props.options.onSave,
          viewStore = _props.viewStore;
      var _viewStore = this.viewStore,
          handleExisting = _viewStore.handleExisting,
          SelectedView = _viewStore.SelectedView,
          clearView = _viewStore.clearView,
          viewBreadcrumbs = _viewStore.viewBreadcrumbs,
          isRoot = _viewStore.isRoot;

      // @TODO need autopopulation view in default editor for CMs

      return _react2.default.createElement(
        'div',
        null,
        isRoot && !!viewBreadcrumbs.length && _react2.default.createElement(_layoutComponent.Breadcrumbs, { viewstores: viewBreadcrumbs }),
        SelectedView ? _react2.default.createElement(SelectedView, null) : _react2.default.createElement(
          'div',
          null,
          (0, _editor.createEditorElement)("id", slots, contentModel),
          (0, _editor.createEditorElement)("displayName", slots, contentModel, this.viewStore),
          isNew || !shellType ? (0, _editor.createEditorElement)("shellType", slots, contentModel, this.viewStore, options) : _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'span',
              { className: 'editor-label' },
              'Shell Type:'
            ),
            ' ',
            shellType.id
          ),
          shellType && (!shell || shell.isNew) && _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'span',
              { className: 'editor-label' },
              'Shell Id:'
            ),
            ' ',
            shell && shell.id,
            _react2.default.createElement(
              'div',
              null,
              invalid.shell && _react2.default.createElement(
                'div',
                { className: 'validation errorMessage' },
                invalid.shell
              ),
              allCms.map(function (data) {
                var cm = data[0];
                var parent = data[1];
                var name = data[2];
                var type = parent.slots[name].name;
                return _react2.default.createElement(
                  'div',
                  null,
                  cm.isNew && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'editor-label' },
                      name,
                      ': ',
                      cm.id
                    ),
                    !!cm.allOfSameType.length && _react2.default.createElement(
                      'div',
                      null,
                      'Select existing ',
                      type,
                      ' ',
                      _react2.default.createElement(
                        'select',
                        { onChange: function onChange(e) {
                            return handleExisting(e, parent, name);
                          } },
                        _react2.default.createElement('option', null),
                        cm.allOfSameType.map(function (cm) {
                          return _react2.default.createElement(
                            'option',
                            { key: cm.id },
                            cm.id
                          );
                        })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Create new ',
                        type,
                        ':'
                      ),
                      _react2.default.createElement('input', { value: cm.id, onChange: function onChange(e) {
                          return cm.updateValue("id", e.target.value);
                        } }),
                      _react2.default.createElement(
                        'button',
                        { onClick: function onClick(e) {
                            return cm.saveEntity();
                          } },
                        'save'
                      )
                    )
                  )
                );
              })
            )
          ),
          shellType && shell && !shell.isNew && (0, _editor.createEditorElement)("shell", slots, contentModel, this.viewStore, options),
          (0, _editor.createEditorElement)("rounds", slots, contentModel, this.viewStore, options),
          _react2.default.createElement(_editor.ActionBar, { contentModel: contentModel, onSave: function onSave(e) {
              return shell.saveEntity(function () {
                return typeof _onSave === "function" && _onSave(e);
              });
            } })
        )
      );
    }
  }]);
  return SimulationEditor;
}(_baseComponent2.default), _class3.ViewStore = SimulationEditorViewStore, _temp)) || _class2) || _class2;

exports.default = SimulationEditor;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimulationEditorViewStore, 'SimulationEditorViewStore', 'src/entity_modules/simulation-entity/editor.js');

  __REACT_HOT_LOADER__.register(SimulationEditor, 'SimulationEditor', 'src/entity_modules/simulation-entity/editor.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.js");

var simulationContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = simulationContentModels;
var ContentModel = exports.ContentModel = simulationContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/simulation-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/simulation-entity/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _stringify = __webpack_require__("./node_modules/babel-runtime/core-js/json/stringify.js");

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class2, _temp2;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/editor.js");

var _editor2 = _interopRequireDefault(_editor);

var _projectEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/index.js");

var _configurationEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/index.js");

var _typeEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/type-entity/index.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SystemContentModel = exports.SystemContentModel = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.ref, _dec3 = _mobx.observable.ref, _dec4 = _mobx.action.bound, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(SystemContentModel, _BaseContentModel);

  function SystemContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SystemContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SystemContentModel.__proto__ || (0, _getPrototypeOf2.default)(SystemContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.guid = "Synthetic", _this.readonly = true, _this.savable = false, _this.FullEditor = _editor2.default, _initDefineProp(_this, 'types', _descriptor, _this), _initDefineProp(_this, 'configuration', _descriptor2, _this), _initDefineProp(_this, 'project', _descriptor3, _this), _initDefineProp(_this, 'icon', _descriptor4, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SystemContentModel, [{
    key: 'publishEntities',
    value: function publishEntities(_ref2) {
      var cm = _ref2.cm,
          _ref2$path = _ref2.path,
          path = _ref2$path === undefined ? "entities" : _ref2$path,
          cb = _ref2.cb,
          _ref2$addConfigs = _ref2.addConfigs,
          addConfigs = _ref2$addConfigs === undefined ? true : _ref2$addConfigs,
          _ref2$outputToString = _ref2.outputToString,
          outputToString = _ref2$outputToString === undefined ? false : _ref2$outputToString;

      var simgate = this.$parent.simgate;
      var addEnts = [cm];

      if (addConfigs) {
        var Configuration = this.$parent.entities.get("Configuration");
        var Project = this.$parent.entities.get("Project_FlowEditor");
        if (Configuration !== cm) addEnts.push(Configuration);
        if (Project !== cm) addEnts.push(Project);
      }

      var serializedEntities = cm.getAllChildEntitiesFiltered(function (ent) {
        return ent.Synthetic !== true && ent.constructor.Synthetic !== true && ent.savable !== false && ent.constructor.savable !== false && addEnts.indexOf(ent) === -1;
      }).concat(addEnts).map(function (ent) {
        return ent.simboxDTO;
      });

      if (outputToString) return (0, _stringify2.default)(serializedEntities, null, 2);
      debugger;

      simgate.config.update({
        path: path + "://entities",
        set: serializedEntities
      }).then(function () {
        return simgate.config.commit({
          path: path
        }).then(function () {
          if (cb) cb();else alert("success publishing entities!  you may now build and push to stage / prod");
        });
      });
    }
  }]);
  return SystemContentModel;
}(_baseContentmodel2.default), _class2.Synthetic = true, _class2._slots = {
  types: [_typeEntity.ContentModel],
  configuration: _configurationEntity.ContentModel,
  project: _projectEntity.ContentModel,
  icon: ""
}, _class2._meta = {
  types: {
    readonly: true
  }
}, _class2.id = "System", _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'types', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'configuration', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'project', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'icon', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "system-icon";
  }
}), _applyDecoratedDescriptor(_class.prototype, 'publishEntities', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'publishEntities'), _class.prototype)), _class));
var _default = SystemContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SystemContentModel, 'SystemContentModel', 'src/entity_modules/system-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/system-entity/contentmodel.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/editor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _desc, _value, _class3;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _index = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _index2 = _interopRequireDefault(_index);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/editor.js");

var _editor2 = _interopRequireDefault(_editor);

var _collectionGridEditor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/collection-grid-editor/index.js");

var _collectionGridEditor2 = _interopRequireDefault(_collectionGridEditor);

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SystemEditor = (_dec = (0, _mobxReact.inject)("modalViewStore"), _dec(_class = (0, _simboxEditable.Decorator)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_BaseComponent) {
  (0, _inherits3.default)(SystemEditor, _BaseComponent);

  function SystemEditor() {
    (0, _classCallCheck3.default)(this, SystemEditor);
    return (0, _possibleConstructorReturn3.default)(this, (SystemEditor.__proto__ || (0, _getPrototypeOf2.default)(SystemEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(SystemEditor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          currentView = _props.currentView,
          contentModel = _props.contentModel;
      var publishEntities = this.viewStore.publishEntities;


      if (!options.insideEditor) return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_collectionGridEditor2.default, { currentView: currentView, contentModel: contentModel }),
        _react2.default.createElement(
          'div',
          { className: 'editable-group' },
          _react2.default.createElement(
            'button',
            { className: 'btn red', onClick: publishEntities },
            'PUBLISH ALL ENTITIES'
          )
        )
      );

      return _react2.default.createElement(_editor2.default, this.props);
    }
  }]);
  return SystemEditor;
}(_baseComponent2.default), _class2.ViewStore = (_dec2 = _mobx.action.bound, (_class3 = function (_BaseViewStore) {
  (0, _inherits3.default)(SystemViewStore, _BaseViewStore);

  function SystemViewStore() {
    (0, _classCallCheck3.default)(this, SystemViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (SystemViewStore.__proto__ || (0, _getPrototypeOf2.default)(SystemViewStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(SystemViewStore, [{
    key: 'publishEntities',
    value: function publishEntities(e) {
      var modalViewStore = this.props.modalViewStore;

      var system = this.props.contentModel;
      var Configuration = system.$parent.entities.get("Configuration");
      modalViewStore.setModal({
        title: "Publish Entities?",
        message: /*Configuration.anyDirty ?  "You have unsaved changes.  Unable to publish.": */"Would you like to publish all entities to entities.json?",
        confirmLabel: 'Continue',
        confirmBtnClass: 'green check-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: /*!Configuration.anyDirty && */function onConfirmFunc() {
          return system.publishEntities({
            cm: Configuration,
            path: "entities",
            cb: function cb() {
              modalViewStore.setModal({
                title: "Published",
                message: "You have published your entities to entitites.json.  Please rebuild, and release to stage.",
                confirmLabel: 'Continue',
                confirmBtnClass: 'green check-a'
              });
            }
          });
        }
      });
    }
  }]);
  return SystemViewStore;
}(_index2.default), (_applyDecoratedDescriptor(_class3.prototype, 'publishEntities', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'publishEntities'), _class3.prototype)), _class3)), _temp)) || _class) || _class) || _class);
exports.default = SystemEditor;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SystemEditor, 'SystemEditor', 'src/entity_modules/system-entity/editor.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/contentmodel.js");

var systemContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = systemContentModels;
var ContentModel = exports.ContentModel = systemContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/system-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/system-entity/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.TaskComponent = exports.TaskViewStore = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _dec2, _class3, _class4, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var TaskViewStore = exports.TaskViewStore = (_dec = _mobx.observable.ref, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(TaskViewStore, _BaseViewStore);

  function TaskViewStore() {
    (0, _classCallCheck3.default)(this, TaskViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskViewStore.__proto__ || (0, _getPrototypeOf2.default)(TaskViewStore)).apply(this, arguments));

    _initDefineProp(_this, "inputStore", _descriptor, _this);

    var _this$props = _this.props,
        task = _this$props.contentModel,
        _this$props$currentVi = _this$props.currentView,
        simDataModel = _this$props$currentVi.dataModel,
        viewMode = _this$props$currentVi.viewMode,
        application = _this$props.application;


    var InputStore = task.activity.InputStore || task.InputStore;

    if (!!simDataModel) {
      _this.inputStore = simDataModel[task.id] || simDataModel.addStore(InputStore);
    } else {
      _this.inputStore = new InputStore({ simgate: application.simgate });
      _this.inputStore.loadData();
    }
    // add reference for sake of any computed input values
    task.activity.$inputStore = _this.inputStore;
    return _this;
  }

  return TaskViewStore;
}(_baseViewstore2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "inputStore", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class));
var TaskComponent = exports.TaskComponent = (_dec2 = (0, _mobxReact.inject)("application"), _dec2(_class3 = (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = (_temp = _class4 = function (_BaseComponent) {
  (0, _inherits3.default)(TaskComponent, _BaseComponent);

  function TaskComponent() {
    (0, _classCallCheck3.default)(this, TaskComponent);
    return (0, _possibleConstructorReturn3.default)(this, (TaskComponent.__proto__ || (0, _getPrototypeOf2.default)(TaskComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(TaskComponent, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          task = _props.contentModel,
          simDataModel = _props.currentView.dataModel;
      var inputStore = this.viewStore.inputStore;


      if (typeof task.activity === "string") {
        return _react2.default.createElement(
          "div",
          null,
          "activity is invalid (",
          task.activity,
          ")",
          _react2.default.createElement("br", null),
          "you are likely missing this component (",
          task.activityType,
          ") from your filesystem"
        );
      }

      var Activity = task.activity && task.activity.Component;

      return !!Activity && _react2.default.createElement(
        _mobxReact.Provider,
        { inputStore: inputStore, dataModel: simDataModel },
        _react2.default.createElement(Activity, {
          inputStore: inputStore,
          dataModel: simDataModel,
          contentModel: task.activity
        })
      );
    }
  }]);
  return TaskComponent;
}(_baseComponent2.default), _class4.ViewStore = TaskViewStore, _temp)) || _class3) || _class3) || _class3);
var Component = exports.Component = TaskComponent;
var _default = Component;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TaskViewStore, "TaskViewStore", "src/entity_modules/task-entity/component.js");

  __REACT_HOT_LOADER__.register(TaskComponent, "TaskComponent", "src/entity_modules/task-entity/component.js");

  __REACT_HOT_LOADER__.register(Component, "Component", "src/entity_modules/task-entity/component.js");

  __REACT_HOT_LOADER__.register(_default, "default", "src/entity_modules/task-entity/component.js");
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class2, _temp2;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _cloner = __webpack_require__("./node_modules/cloner/build/cloner.node.js");

var _simgateInputStore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simgate-input-store/index.js");

var _simgateInputStore2 = _interopRequireDefault(_simgateInputStore);

var _component = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/component.js");

var _component2 = _interopRequireDefault(_component);

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/editor.js");

var _editor2 = _interopRequireDefault(_editor);

var _configurationEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/index.js");

var _simulationEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RegisteredActivityContentModel = _configurationEntity.ContentModels.RegisteredActivityContentModel;
var TaskContentModel = exports.TaskContentModel = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.ref, _dec3 = _mobx.action.bound, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(TaskContentModel, _BaseContentModel);

  function TaskContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TaskContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TaskContentModel.__proto__ || (0, _getPrototypeOf2.default)(TaskContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'meta', _descriptor, _this), _initDefineProp(_this, '_options', _descriptor2, _this), _this.Editor = _editor2.default, _initDefineProp(_this, 'activityType', _descriptor3, _this), _initDefineProp(_this, 'activity', _descriptor4, _this), _initDefineProp(_this, 'displayTitle', _descriptor5, _this), _initDefineProp(_this, 'description', _descriptor6, _this), _initDefineProp(_this, 'required', _descriptor7, _this), _this.Component = _component2.default, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* slot( RegisteredActivityContentModel ) */
  /* slot */
  /* slot */
  /* slot */
  /* slot */

  (0, _createClass3.default)(TaskContentModel, [{
    key: 'createActivity',


    // getComponent( opts = {} ){
    //   // if getComponent is called with editMode, the TASK FullEditor is loaded
    //   if(opts.forceFullEditor) return this.FullEditor
    //   // else the computed Component (activity) is loaded
    //   return (this.activity && this.activity.getComponent( opts )) || this.FullEditor
    // }
    // getContentModel( opts = {} ){
    //   // if getContentModel is called with editMode, the TASK contentModel is loaded
    //   if(opts.forceFullEditor) return this
    //   // else the activity contentModel is loaded
    //   return this.activity;
    // }

    // @TODO menu show / enabled somehow configurable via slots... maybe evalled in context?
    value: function createActivity() {
      this.activity = new this.ActivityContentModel({ id: this.id + "_activity", shouldAutoPopulate: true });
    }
  }, {
    key: 'displayName',
    get: function get() {
      return this.displayTitle;
    }

    // /* @input */ @observable @deepBind isCompleted = {
    //   get variable(){ return `G:${this.id}_Completed:G`; },
    //   defaultValue: false //user inputted
    //   get value(){
    //     this.$inputStore.getInput( this.activity, "complete" )
    //   }
    // }

  }, {
    key: 'isCompleted',
    get: function get() {
      if (!this.activity || !this.activity.$inputStore) return false;
      // activity must be saved AND have isCompleted input === true
      var _activity$$inputStore = this.activity.$inputStore,
          isDirty = _activity$$inputStore.isDirty,
          getInput = _activity$$inputStore.getInput;

      return !isDirty && !!getInput(this.activity, "isCompleted");
    }

    // override me
    // @computed get readonly(){
    //   return this.isCompleted.value
    // }

  }, {
    key: 'InputStore',
    get: function get() {
      var _desc2, _value2, _class3, _descriptor8;

      var self = this;
      return _class3 = function (_SimgateInputStore) {
        (0, _inherits3.default)(InputStore, _SimgateInputStore);

        function InputStore() {
          var _ref2;

          var _temp3, _this2, _ret2;

          (0, _classCallCheck3.default)(this, InputStore);

          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = InputStore.__proto__ || (0, _getPrototypeOf2.default)(InputStore)).call.apply(_ref2, [this].concat(args))), _this2), _this2.id = self.id, _initDefineProp(_this2, 'inputs', _descriptor8, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
        }

        return InputStore;
      }(_simgateInputStore2.default), (_descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'inputs', [_mobx.observable], {
        enumerable: true,
        initializer: function initializer() {
          return self.allInputs;
        }
      })), _class3;
    }
  }, {
    key: 'allInputs',
    get: function get() {
      if (!this.activity) return {};

      var collectedInputs = this.activity.getAllChildEntitiesFiltered(function (childCm, parentCm, slotName) {
        var slot = parentCm.slots[slotName];
        if (Array.isArray(slot)) slot = slot[0];
        if (slot === _simulationEntity.ContentModel) return false;
      }).map(function (ent) {
        return ent._inputs;
      });

      return _cloner.shallow.merge.apply(_cloner.shallow, [{}].concat((0, _toConsumableArray3.default)(collectedInputs)));
    }
  }, {
    key: 'ActivityContentModel',
    get: function get() {
      return this.activityType && this.activityType.module && this.activityType.module.ContentModel;
    }
  }, {
    key: 'activityDescription',
    get: function get() {
      return this.activityType && this.activityType.module && this.activityType.module.description;
    }
  }, {
    key: 'invalid',
    get: function get() {
      var invalid = (0, _assign2.default)({}, this._invalid);
      if (!this.displayTitle) invalid.displayTitle = "Please provide a display title!";
      if (!this.description) invalid.description = "Please provide a description!";
      if (!this.activityType) invalid.activityType = "Please choose an activityType";
      if (this.activity && this.activity.isNew && this.activity.allChildCms.length && this.activity.allChildCms.some(function (cm) {
        return cm[0].isNew;
      })) {
        invalid.activity = "Please save all submodels";
      }
      return invalid;
    }
  }]);
  return TaskContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  activity: _baseContentmodel2.default,
  activityType: RegisteredActivityContentModel,
  displayTitle: "",
  description: "",
  required: true
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'meta', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      activityType: {
        get readonly() {
          return !this.isNew;
        }
      }
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, '_options', [_mobx.observable, _baseContentmodel.deepBind], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get activity() {
        var _this3 = this;

        return this.$parent.entities.values().filter(function (entity) {
          var activityType = _this3.activityType;

          return eval("activityType && activityType.ContentModelName === entity.type");
        });
      }
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'activityType', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'activity', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'displayTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'description', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'required', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'displayName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'displayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isCompleted', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isCompleted'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'InputStore', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'InputStore'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allInputs', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allInputs'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'ActivityContentModel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'ActivityContentModel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'activityDescription', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'activityDescription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'invalid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createActivity', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createActivity'), _class.prototype)), _class));
var _default = TaskContentModel;
exports.default = _default;
;

var _temp4 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RegisteredActivityContentModel, 'RegisteredActivityContentModel', 'src/entity_modules/task-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(TaskContentModel, 'TaskContentModel', 'src/entity_modules/task-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/task-entity/contentmodel.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/editor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TaskEditorViewStore = undefined;

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _class2, _class3, _temp;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _layoutComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _editor = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/editor.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var TaskEditorViewStore = exports.TaskEditorViewStore = (_dec = _mobx.action.bound, (_class = function (_EditorViewStore) {
  (0, _inherits3.default)(TaskEditorViewStore, _EditorViewStore);

  function TaskEditorViewStore() {
    (0, _classCallCheck3.default)(this, TaskEditorViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskEditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(TaskEditorViewStore)).apply(this, arguments));

    var cm = _this.props.contentModel;
    var rxns = [];
    rxns.push((0, _mobx.reaction)(function () {
      return cm.id;
    }, function () {
      if (cm.activity) cm.activity.id = cm.id + "_activity";
    }), (0, _mobx.reaction)(function () {
      return cm.activityType;
    }, function () {
      return cm.createActivity();
    }));
    _this.dispose = function () {
      return rxns.forEach(function (rxn) {
        return rxn();
      });
    };
    return _this;
  }

  (0, _createClass3.default)(TaskEditorViewStore, [{
    key: 'handleExisting',
    value: function handleExisting(e, parent, name) {
      var item = parent.$parent.entities.get(e.target.value) /* || new parent.slots[name]({isNew: true, autoPopulate: true} )*/;
      if (!item) throw new Error("no item");
      parent.updateValue(name, item);
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var contentModel = this.props.contentModel;
      var ret = contentModel && (0, _keys2.default)(contentModel.slots).reduce(function (acc, name) {
        if (contentModel.slots[name] && contentModel.slots[name].prototype instanceof _baseContentmodel2.default) {
          var _subCm = contentModel[name];
          if (!_subCm) return acc;
          if (_subCm.contentModel) debugger;
          acc[_subCm.id] = {
            id: _subCm.id,
            contentModel: _subCm.contentModel || _subCm
          };
        } else if (Array.isArray(contentModel.slots[name])) {
          contentModel[name].forEach(function (subCm) {
            if (!(subCm instanceof _baseContentmodel2.default)) return;
            if (subCm.contentModel) debugger;
            acc[subCm.id] = {
              id: subCm.id,
              contentModel: subCm.contentModel || subCm
            };
          });
        }
        return acc;
      }, {});

      var subCm = contentModel.activity;
      if (!subCm) return ret;
      if (subCm.activityContentModel) debugger;
      ret[subCm.id] = {
        id: subCm.id,
        contentModel: subCm.activityContentModel || subCm
      };

      return ret;
    }
  }]);
  return TaskEditorViewStore;
}(_editor.EditorViewStore), (_applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleExisting', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleExisting'), _class.prototype)), _class));

var TaskEditor = (0, _simboxEditable.Decorator)(_class2 = (0, _mobxReact.observer)(_class2 = (_temp = _class3 = function (_BaseComponent) {
  (0, _inherits3.default)(TaskEditor, _BaseComponent);

  function TaskEditor() {
    (0, _classCallCheck3.default)(this, TaskEditor);
    return (0, _possibleConstructorReturn3.default)(this, (TaskEditor.__proto__ || (0, _getPrototypeOf2.default)(TaskEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(TaskEditor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          editorViewStore = _props.editorViewStore,
          contentModel = _props.contentModel,
          _props$contentModel = _props.contentModel,
          allCms = _props$contentModel.allCms,
          allInputs = _props$contentModel.allInputs,
          activity = _props$contentModel.activity,
          isNew = _props$contentModel.isNew,
          updateValue = _props$contentModel.updateValue,
          invalid = _props$contentModel.invalid,
          activityType = _props$contentModel.activityType,
          description = _props$contentModel.description,
          displayTitle = _props$contentModel.displayTitle,
          id = _props$contentModel.id,
          createActivity = _props$contentModel.createActivity,
          slots = _props$contentModel.slots,
          options = _props.options,
          _onSave = _props.options.onSave,
          viewStore = _props.viewStore;
      var _viewStore = this.viewStore,
          handleExisting = _viewStore.handleExisting,
          SelectedView = _viewStore.SelectedView,
          clearView = _viewStore.clearView,
          viewBreadcrumbs = _viewStore.viewBreadcrumbs,
          isRoot = _viewStore.isRoot;

      // @TODO need autopopulation view in default editor for CMs

      return _react2.default.createElement(
        'div',
        null,
        isRoot && !!viewBreadcrumbs.length && _react2.default.createElement(_layoutComponent.Breadcrumbs, { viewstores: viewBreadcrumbs }),
        SelectedView ? _react2.default.createElement(SelectedView, null) : _react2.default.createElement(
          'div',
          null,
          (0, _editor.createEditorElement)("id", slots, contentModel),
          isNew ? (0, _editor.createEditorElement)("activityType", slots, contentModel) : _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'span',
              { className: 'editor-label' },
              'Activity Type:'
            ),
            ' ',
            activityType.id
          ),
          activityType && (!activity || activity.isNew) && _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'span',
              { className: 'editor-label' },
              'Activity Id:'
            ),
            ' ',
            activity && activity.id,
            _react2.default.createElement(
              'div',
              null,
              invalid.activity && _react2.default.createElement(
                'div',
                { className: 'validation errorMessage' },
                invalid.activity
              ),
              allCms.map(function (data) {
                var cm = data[0];
                var parent = data[1];
                var name = data[2];
                var type = parent.slots[name].name;
                return _react2.default.createElement(
                  'div',
                  null,
                  cm.isNew && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'editor-label' },
                      name,
                      ': ',
                      cm.id
                    ),
                    !!cm.allOfSameType.length && _react2.default.createElement(
                      'div',
                      null,
                      'Select existing ',
                      type,
                      ' ',
                      _react2.default.createElement(
                        'select',
                        { onChange: function onChange(e) {
                            return handleExisting(e, parent, name);
                          } },
                        _react2.default.createElement('option', null),
                        cm.allOfSameType.map(function (cm) {
                          return _react2.default.createElement(
                            'option',
                            { key: cm.id },
                            cm.id
                          );
                        })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Create new ',
                        type,
                        ':'
                      ),
                      _react2.default.createElement('input', { value: cm.id, onChange: function onChange(e) {
                          return cm.updateValue("id", e.target.value);
                        } }),
                      _react2.default.createElement(
                        'button',
                        { onClick: function onClick(e) {
                            return cm.saveEntity();
                          } },
                        'save'
                      )
                    )
                  )
                );
              })
            )
          ),
          activityType && activity && !activity.isNew && (0, _editor.createEditorElement)("activity", slots, contentModel, this.viewStore, options),
          (0, _editor.createEditorElement)("required", slots, contentModel),
          (0, _editor.createEditorElement)("displayTitle", slots, contentModel),
          (0, _editor.createEditorElement)("description", slots, contentModel),
          !!activity && _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'span',
              { className: 'editor-label' },
              'Activity Variables:'
            ),
            ' ',
            (0, _keys2.default)(allInputs).map(function (i) {
              return _react2.default.createElement(
                'div',
                { key: i },
                i
              );
            })
          ),
          _react2.default.createElement(_editor.ActionBar, { contentModel: contentModel, onSave: function onSave(e) {
              return activity.saveEntity(function () {
                return typeof _onSave === "function" && _onSave(e);
              });
            } })
        )
      );
    }
  }]);
  return TaskEditor;
}(_baseComponent2.default), _class3.ViewStore = TaskEditorViewStore, _temp)) || _class2) || _class2;

exports.default = TaskEditor;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TaskEditorViewStore, 'TaskEditorViewStore', 'src/entity_modules/task-entity/editor.js');

  __REACT_HOT_LOADER__.register(TaskEditor, 'TaskEditor', 'src/entity_modules/task-entity/editor.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/contentmodel.js");

var taskContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = taskContentModels;
var ContentModel = exports.ContentModel = taskContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/task-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/task-entity/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/teamstate-entity/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamStateContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class2, _temp2;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _taskEntity = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var TeamStateContentModel = exports.TeamStateContentModel = (_dec = _mobx.observable.shallow, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(TeamStateContentModel, _BaseContentModel);

  function TeamStateContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TeamStateContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TeamStateContentModel.__proto__ || (0, _getPrototypeOf2.default)(TeamStateContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'displayName', _descriptor, _this), _initDefineProp(_this, 'runModel', _descriptor2, _this), _initDefineProp(_this, 'tasks', _descriptor3, _this), _initDefineProp(_this, 'isWaitState', _descriptor4, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /*@slot */
  /*@slot */
  /*@slot( TaskContentModel )*/
  // /*@slot( DictionaryContentModel )*/ @observable transitions =  null
  // /*@slot( DictionaryContentModel )*/ @observable customCommands = null
  /*@slot */

  return TeamStateContentModel;
}(_baseContentmodel2.default), _class2.maxParents = ["RoundContentModel", 1], _class2._slots = {
  displayName: "",
  tasks: [_taskEntity.ContentModel],
  runModel: "",
  // transitions: {},
  // customCommands: {},
  isWaitState: false }, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'displayName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'runModel', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'tasks', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'isWaitState', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class));
var _default = TeamStateContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TeamStateContentModel, 'TeamStateContentModel', 'src/entity_modules/teamstate-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/teamstate-entity/contentmodel.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/teamstate-entity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/entity_modules/teamstate-entity/contentmodel.js");

var teamStateContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = teamStateContentModels;
var ContentModel = exports.ContentModel = teamStateContentModels.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/teamstate-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/teamstate-entity/index.js');
}();

;

/***/ }),

/***/ "./node_modules/platform-client-bootstrap/dist/entity_modules/type-entity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentModels = exports.ContentModel = undefined;

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _deepExtend = __webpack_require__("./node_modules/deep-extend/lib/deep-extend.js");

var _deepExtend2 = _interopRequireDefault(_deepExtend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ContentModel = exports.ContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(TypeContentModel, _BaseContentModel);

  function TypeContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TypeContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TypeContentModel.__proto__ || (0, _getPrototypeOf2.default)(TypeContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.readonly = true, _this.savable = false, _this.editable = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TypeContentModel, [{
    key: 'meta',
    get: function get() {
      return (0, _deepExtend2.default)({
        entities: {
          readonly: this.id === "TypeContentModel"
        }
      }, this.constructor._meta || {});
    }
  }, {
    key: 'entities',
    get: function get() {
      // this.$parent.types[this.id].newEntityWasAdded.get(); // refresh this computed :-)
      return this.$parent.types[this.id].allEntities();
    }
  }, {
    key: 'childConstructor',
    get: function get() {
      return this.$parent.types[this.id];
    }
  }]);
  return TypeContentModel;
}(_baseContentmodel2.default), _class2.Synthetic = true, _class2._slots = {
  entities: [_baseContentmodel2.default]
}, _class2._meta = {}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'meta', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'meta'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'entities', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'entities'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'childConstructor', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'childConstructor'), _class.prototype)), _class);
var ContentModels = exports.ContentModels = { TypeContentModel: ContentModel };
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/entity_modules/type-entity/index.js');

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/entity_modules/type-entity/index.js');
}();

;

/***/ }),

/***/ "./node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/react-sortable-hoc/dist/commonjs/Manager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__("./node_modules/lodash/find.js");

var _find2 = _interopRequireDefault(_find);

var _sortBy = __webpack_require__("./node_modules/lodash/sortBy.js");

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: 'add',
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: 'remove',
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: 'isActive',
    value: function isActive() {
      return this.active;
    }
  }, {
    key: 'getActive',
    value: function getActive() {
      var _this = this;

      return (0, _find2.default)(this.refs[this.active.collection],
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: 'getIndex',
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: 'getOrderedRefs',
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
        var node = _ref2.node;
        return node.sortableInfo.index;
      });
    }
  }]);

  return Manager;
}();

exports.default = Manager;

/***/ }),

/***/ "./node_modules/react-sortable-hoc/dist/commonjs/SortableContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableContainer;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _Manager = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/Manager.js");

var _Manager2 = _interopRequireDefault(_Manager);

var _utils = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (e) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;


        if (e.button === 2 || shouldCancelStart(e)) {
          return false;
        }

        _this._touched = true;
        _this._pos = {
          x: e.pageX,
          y: e.pageY
        };

        var node = (0, _utils.closest)(e.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;


          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */
          if (e.target.tagName.toLowerCase() === 'a') {
            e.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(e);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(e);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (e) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;


        if (!_this.state.sorting && _this._touched) {
          _this._delta = {
            x: _this._pos.x - e.pageX,
            y: _this._pos.y - e.pageY
          };
          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);

          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && delta >= distance && _this.manager.isActive()) {
            _this.handlePress(e);
          }
        }
      };

      _this.handleEnd = function () {
        var distance = _this.props.distance;


        _this._touched = false;

        if (!distance) {
          _this.cancel();
        }
      };

      _this.cancel = function () {
        if (!_this.state.sorting) {
          clearTimeout(_this.pressTimer);
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (e) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, _utils.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = _this.getEdgeOffset(node);
          _this.initialOffset = _this.getOffset(e);
          _this.initialScroll = {
            top: _this.scrollContainer.scrollTop,
            left: _this.scrollContainer.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = e.touches ? node : _this.contentWindow;
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
        }
      };

      _this.handleSortMove = function (e) {
        var onSortMove = _this.props.onSortMove;

        e.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(e);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) onSortMove(e);
      };

      _this.handleSortEnd = function (e) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          _utils.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          _utils.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[_utils.vendorPrefix + 'Transform'] = '';
          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, e);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            getContainer = _props.getContainer,
            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;

        /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */

        var contentWindow = this.props.contentWindow || window;

        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
        this.document = this.container.ownerDocument || document;
        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;

        var _loop = function _loop(key) {
          if (_this2.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          }
        };

        for (var key in this.events) {
          _loop(key);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var _loop2 = function _loop2(key) {
          if (_this3.events.hasOwnProperty(key)) {
            _utils.events[key].forEach(function (eventName) {
              return _this3.container.removeEventListener(eventName, _this3.events[key]);
            });
          }
        };

        for (var key in this.events) {
          _loop2(key);
        }
      }
    }, {
      key: 'getEdgeOffset',
      value: function getEdgeOffset(node) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };

        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
        if (node) {
          var nodeOffset = {
            top: offset.top + node.offsetTop,
            left: offset.left + node.offsetLeft
          };
          if (node.parentNode !== this.container) {
            return this.getEdgeOffset(node.parentNode, nodeOffset);
          } else {
            return nodeOffset;
          }
        }
      }
    }, {
      key: 'getOffset',
      value: function getOffset(e) {
        return {
          x: e.touches ? e.touches[0].pageX : e.pageX,
          y: e.touches ? e.touches[0].pageY : e.pageY
        };
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var lockOffset = this.props.lockOffset;


        if (!Array.isArray(lockOffset)) {
          lockOffset = [lockOffset, lockOffset];
        }

        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _lockOffset = lockOffset,
            _lockOffset2 = _slicedToArray(_lockOffset, 2),
            minLockOffset = _lockOffset2[0],
            maxLockOffset = _lockOffset2[1];

        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
      }
    }, {
      key: 'getLockPixelOffset',
      value: function getLockPixelOffset(lockOffset) {
        var offsetX = lockOffset;
        var offsetY = lockOffset;
        var unit = 'px';

        if (typeof lockOffset === 'string') {
          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

          offsetX = offsetY = parseFloat(lockOffset);
          unit = match[1];
        }

        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

        if (unit === '%') {
          offsetX = offsetX * this.width / 100;
          offsetY = offsetY * this.height / 100;
        }

        return {
          x: offsetX,
          y: offsetY
        };
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(e) {
        var _props2 = this.props,
            lockAxis = _props2.lockAxis,
            lockToContainerEdges = _props2.lockToContainerEdges;


        var offset = this.getOffset(e);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props3 = this.props,
            transitionDuration = _props3.transitionDuration,
            hideSortableGhost = _props3.hideSortableGhost;

        var nodes = this.manager.getOrderedRefs();
        var deltaScroll = {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
        };
        var scrollDifference = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}

/***/ }),

/***/ "./node_modules/react-sortable-hoc/dist/commonjs/SortableElement/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableElement;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;


        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;


        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

/***/ }),

/***/ "./node_modules/react-sortable-hoc/dist/commonjs/SortableHandle/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableHandle;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

/***/ }),

/***/ "./node_modules/react-sortable-hoc/dist/commonjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;

var _utils = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/utils.js");

Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return _utils.arrayMove;
  }
});

var _SortableContainer2 = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/SortableContainer/index.js");

var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);

var _SortableElement2 = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/SortableElement/index.js");

var _SortableElement3 = _interopRequireDefault(_SortableElement2);

var _SortableHandle2 = __webpack_require__("./node_modules/react-sortable-hoc/dist/commonjs/SortableHandle/index.js");

var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;

/***/ }),

/***/ "./node_modules/react-sortable-hoc/dist/commonjs/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

/***/ }),

/***/ "./node_modules/react-trix/lib/react-trix.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var TrixEditor = (function (_super) {
    __extends(TrixEditor, _super);
    function TrixEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.container = null;
        _this.editor = null;
        _this.d = null;
        _this.id = _this.generateId();
        _this.state = {
            showMergeTags: false,
            tags: []
        };
        return _this;
    }
    TrixEditor.prototype.generateId = function () {
        var timestamp = Date.now();
        var uniqueNumber = 0;
        (function () {
            if (timestamp <= uniqueNumber) {
                timestamp = ++uniqueNumber;
            }
            else {
                uniqueNumber = timestamp;
            }
        })();
        return "T" + timestamp.toString();
    };
    TrixEditor.prototype.componentDidMount = function () {
        var _this = this;
        var props = this.props;
        this.container = document.getElementById("editor-" + this.id);
        if (this.container) {
            this.container.addEventListener("trix-initialize", function () {
                _this.editor = _this.container.editor;
                if (!_this.editor) {
                    console.error("cannot  find trix editor");
                }
                if (props.onEditorReady && typeof props.onEditorReady == "function") {
                    props.onEditorReady(_this.editor);
                }
            }, false);
            this.container.addEventListener('trix-change', this.handleChange.bind(this), false);
            if (props.uploadURL) {
                this.container.addEventListener("trix-attachment-add", this.handleUpload.bind(this));
            }
        }
        else {
            console.error("editor not found");
        }
    };
    TrixEditor.prototype.componentWillUnmount = function () {
        this.container.removeEventListener("trix-initialize", this.handleChange);
        this.container.removeEventListener("trix-change", this.handleChange);
        if (this.props.uploadURL) {
            this.container.removeEventListener("trix-attachment-add", this.handleUpload);
        }
    };
    TrixEditor.prototype.handleChange = function (e) {
        var props = this.props;
        var state = this.state;
        var text = e.target.innerText;
        if (props.onChange) {
            props.onChange(e.target.innerHTML, text);
        }
        var range = this.editor.getSelectedRange();
        if (text && range[0] == range[1]) {
            if (props.mergeTags) {
                var lastChar = range[0] - 1;
                if (lastChar >= 0 && lastChar < text.length) {
                    var trigger = text[lastChar];
                    for (var i = 0; i < props.mergeTags.length; i++) {
                        if (trigger == props.mergeTags[i].trigger) {
                            state.showMergeTags = true;
                            state.tags = props.mergeTags[i].tags;
                            this.setState(state);
                            break;
                        }
                    }
                }
            }
        }
    };
    TrixEditor.prototype.handleUpload = function (e) {
        var attachment = e.attachment;
        if (attachment.file) {
            return this.uploadAttachment(attachment);
        }
    };
    TrixEditor.prototype.uploadAttachment = function (attachment) {
        var file, form, xhr;
        file = attachment.file;
        form = new FormData();
        if (this.props.uploadData) {
            for (var k in this.props.uploadData) {
                form[k] = this.props.uploadData[k];
            }
        }
        form.append("Content-Type", file.type);
        form.append("file", file);
        xhr = new XMLHttpRequest();
        xhr.open("POST", this.props.uploadURL, true);
        xhr.upload.onprogress = function (event) {
            var progress = event.loaded / event.total * 100;
            return attachment.setUploadProgress(progress);
        };
        xhr.onload = function () {
            var href, url;
            if (xhr.status == 204) {
                url = href = xhr.responseText;
                return attachment.setAttributes({
                    url: url,
                    href: href
                });
            }
        };
        return xhr.send(form);
    };
    TrixEditor.prototype.handleTagSelected = function (t, e) {
        e.preventDefault();
        var state = this.state;
        state.showMergeTags = false;
        this.setState(state);
        this.editor.expandSelectionInDirection("backward");
        this.editor.insertString(t.tag);
    };
    TrixEditor.prototype.renderTagSelector = function (tags) {
        var _this = this;
        if (!tags) {
            return null;
        }
        var editorPosition = document.getElementById("trix-editor-top-level").getBoundingClientRect();
        var rect = this.editor.getClientRectAtPosition(this.editor.getSelectedRange()[0]);
        var boxStyle = {
            "position": "absolute",
            "top": rect.top + 25 - editorPosition.top,
            "left": rect.left + 25 - editorPosition.left,
            "width": "250px",
            "boxSizing": "border-box",
            "padding": 0,
            "margin": ".2em 0 0",
            "backgroundColor": "hsla(0,0%,100%,.9)",
            "borderRadius": ".3em",
            "background": "linear-gradient(to bottom right, white, hsla(0,0%,100%,.8))",
            "border": "1px solid rgba(0,0,0,.3)",
            "boxShadow": ".05em .2em .6em rgba(0,0,0,.2)",
            "textShadow": "none"
        };
        var tagStyle = {
            "display": "block",
            "padding": ".2em .5em",
            "cursor": "pointer"
        };
        return (React.createElement("div", { style: boxStyle, className: "react-trix-suggestions" }, tags.map(function (t) {
            return React.createElement("a", { key: t.name, style: tagStyle, href: "#", onClick: _this.handleTagSelected.bind(_this, t) }, t.name);
        })));
    };
    TrixEditor.prototype.render = function () {
        var _this = this;
        var state = this.state;
        var props = this.props;
        var attributes = {
            "id": "editor-" + this.id,
            "input": "input-" + this.id
        };
        if (props.autoFocus) {
            attributes["autoFocus"] = props.autoFocus.toString();
        }
        if (props.placeholder) {
            attributes["placeholder"] = props.placeholder;
        }
        var mergetags = null;
        if (state.showMergeTags) {
            mergetags = this.renderTagSelector(state.tags);
        }
        return (React.createElement("div", { id: "trix-editor-top-level", ref: function (d) { return _this.d = d; }, style: { "position": "relative" } },
            React.createElement("trix-editor", attributes),
            React.createElement("input", { type: "hidden", id: "input-" + this.id, value: this.props.value }),
            mergetags));
    };
    return TrixEditor;
}(React.Component));
exports.TrixEditor = TrixEditor;
//# sourceMappingURL=react-trix.js.map

/***/ }),

/***/ "./node_modules/react-trix/main.js":
/***/ (function(module, exports, __webpack_require__) {

exports.TrixEditor = __webpack_require__("./node_modules/react-trix/lib/react-trix.js").TrixEditor;


/***/ }),

/***/ "./node_modules/setimmediate/setImmediate.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/timers-browserify/main.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("./node_modules/setimmediate/setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/traverse/index.js":
/***/ (function(module, exports) {

var traverse = module.exports = function (obj) {
    return new Traverse(obj);
};

function Traverse (obj) {
    this.value = obj;
}

Traverse.prototype.get = function (ps) {
    var node = this.value;
    for (var i = 0; i < ps.length; i ++) {
        var key = ps[i];
        if (!node || !hasOwnProperty.call(node, key)) {
            node = undefined;
            break;
        }
        node = node[key];
    }
    return node;
};

Traverse.prototype.has = function (ps) {
    var node = this.value;
    for (var i = 0; i < ps.length; i ++) {
        var key = ps[i];
        if (!node || !hasOwnProperty.call(node, key)) {
            return false;
        }
        node = node[key];
    }
    return true;
};

Traverse.prototype.set = function (ps, value) {
    var node = this.value;
    for (var i = 0; i < ps.length - 1; i ++) {
        var key = ps[i];
        if (!hasOwnProperty.call(node, key)) node[key] = {};
        node = node[key];
    }
    node[ps[i]] = value;
    return value;
};

Traverse.prototype.map = function (cb) {
    return walk(this.value, cb, true);
};

Traverse.prototype.forEach = function (cb) {
    this.value = walk(this.value, cb, false);
    return this.value;
};

Traverse.prototype.reduce = function (cb, init) {
    var skip = arguments.length === 1;
    var acc = skip ? this.value : init;
    this.forEach(function (x) {
        if (!this.isRoot || !skip) {
            acc = cb.call(this, acc, x);
        }
    });
    return acc;
};

Traverse.prototype.paths = function () {
    var acc = [];
    this.forEach(function (x) {
        acc.push(this.path); 
    });
    return acc;
};

Traverse.prototype.nodes = function () {
    var acc = [];
    this.forEach(function (x) {
        acc.push(this.node);
    });
    return acc;
};

Traverse.prototype.clone = function () {
    var parents = [], nodes = [];
    
    return (function clone (src) {
        for (var i = 0; i < parents.length; i++) {
            if (parents[i] === src) {
                return nodes[i];
            }
        }
        
        if (typeof src === 'object' && src !== null) {
            var dst = copy(src);
            
            parents.push(src);
            nodes.push(dst);
            
            forEach(objectKeys(src), function (key) {
                dst[key] = clone(src[key]);
            });
            
            parents.pop();
            nodes.pop();
            return dst;
        }
        else {
            return src;
        }
    })(this.value);
};

function walk (root, cb, immutable) {
    var path = [];
    var parents = [];
    var alive = true;
    
    return (function walker (node_) {
        var node = immutable ? copy(node_) : node_;
        var modifiers = {};
        
        var keepGoing = true;
        
        var state = {
            node : node,
            node_ : node_,
            path : [].concat(path),
            parent : parents[parents.length - 1],
            parents : parents,
            key : path.slice(-1)[0],
            isRoot : path.length === 0,
            level : path.length,
            circular : null,
            update : function (x, stopHere) {
                if (!state.isRoot) {
                    state.parent.node[state.key] = x;
                }
                state.node = x;
                if (stopHere) keepGoing = false;
            },
            'delete' : function (stopHere) {
                delete state.parent.node[state.key];
                if (stopHere) keepGoing = false;
            },
            remove : function (stopHere) {
                if (isArray(state.parent.node)) {
                    state.parent.node.splice(state.key, 1);
                }
                else {
                    delete state.parent.node[state.key];
                }
                if (stopHere) keepGoing = false;
            },
            keys : null,
            before : function (f) { modifiers.before = f },
            after : function (f) { modifiers.after = f },
            pre : function (f) { modifiers.pre = f },
            post : function (f) { modifiers.post = f },
            stop : function () { alive = false },
            block : function () { keepGoing = false }
        };
        
        if (!alive) return state;
        
        function updateState() {
            if (typeof state.node === 'object' && state.node !== null) {
                if (!state.keys || state.node_ !== state.node) {
                    state.keys = objectKeys(state.node)
                }
                
                state.isLeaf = state.keys.length == 0;
                
                for (var i = 0; i < parents.length; i++) {
                    if (parents[i].node_ === node_) {
                        state.circular = parents[i];
                        break;
                    }
                }
            }
            else {
                state.isLeaf = true;
                state.keys = null;
            }
            
            state.notLeaf = !state.isLeaf;
            state.notRoot = !state.isRoot;
        }
        
        updateState();
        
        // use return values to update if defined
        var ret = cb.call(state, state.node);
        if (ret !== undefined && state.update) state.update(ret);
        
        if (modifiers.before) modifiers.before.call(state, state.node);
        
        if (!keepGoing) return state;
        
        if (typeof state.node == 'object'
        && state.node !== null && !state.circular) {
            parents.push(state);
            
            updateState();
            
            forEach(state.keys, function (key, i) {
                path.push(key);
                
                if (modifiers.pre) modifiers.pre.call(state, state.node[key], key);
                
                var child = walker(state.node[key]);
                if (immutable && hasOwnProperty.call(state.node, key)) {
                    state.node[key] = child.node;
                }
                
                child.isLast = i == state.keys.length - 1;
                child.isFirst = i == 0;
                
                if (modifiers.post) modifiers.post.call(state, child);
                
                path.pop();
            });
            parents.pop();
        }
        
        if (modifiers.after) modifiers.after.call(state, state.node);
        
        return state;
    })(root).node;
}

function copy (src) {
    if (typeof src === 'object' && src !== null) {
        var dst;
        
        if (isArray(src)) {
            dst = [];
        }
        else if (isDate(src)) {
            dst = new Date(src.getTime ? src.getTime() : src);
        }
        else if (isRegExp(src)) {
            dst = new RegExp(src);
        }
        else if (isError(src)) {
            dst = { message: src.message };
        }
        else if (isBoolean(src)) {
            dst = new Boolean(src);
        }
        else if (isNumber(src)) {
            dst = new Number(src);
        }
        else if (isString(src)) {
            dst = new String(src);
        }
        else if (Object.create && Object.getPrototypeOf) {
            dst = Object.create(Object.getPrototypeOf(src));
        }
        else if (src.constructor === Object) {
            dst = {};
        }
        else {
            var proto =
                (src.constructor && src.constructor.prototype)
                || src.__proto__
                || {}
            ;
            var T = function () {};
            T.prototype = proto;
            dst = new T;
        }
        
        forEach(objectKeys(src), function (key) {
            dst[key] = src[key];
        });
        return dst;
    }
    else return src;
}

var objectKeys = Object.keys || function keys (obj) {
    var res = [];
    for (var key in obj) res.push(key)
    return res;
};

function toS (obj) { return Object.prototype.toString.call(obj) }
function isDate (obj) { return toS(obj) === '[object Date]' }
function isRegExp (obj) { return toS(obj) === '[object RegExp]' }
function isError (obj) { return toS(obj) === '[object Error]' }
function isBoolean (obj) { return toS(obj) === '[object Boolean]' }
function isNumber (obj) { return toS(obj) === '[object Number]' }
function isString (obj) { return toS(obj) === '[object String]' }

var isArray = Array.isArray || function isArray (xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

forEach(objectKeys(Traverse.prototype), function (key) {
    traverse[key] = function (obj) {
        var args = [].slice.call(arguments, 1);
        var t = new Traverse(obj);
        return t[key].apply(t, args);
    };
});

var hasOwnProperty = Object.hasOwnProperty || function (obj, key) {
    return key in obj;
};


/***/ }),

/***/ "./node_modules/trc-async-task/dist/trc-async-task.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Handles asynchronous Simport API calls with automatic retrying when a calls fail.
 */
var AsyncTask = function () {

    /**
    * Default function invoked when a Simport call fails.
    */
    // onFailure = null;

    /**
    * Default function invoked when Simport call succeeds.
    */
    // onSuccess = null;

    /**
    * Default function invoked when Simport call retries. return false to escape retry loop
    * @param lastErr   error returned from last attempt.
    * @param numberOfRetries   number of times retried for this method.
    */
    // onRetry(lastErr, numberOfRetries){ }


    /**
    * Returns an object for making asynchronous Simport calls.
    *
    * @param defaults   defaults get merged to 'this' on construction.
    */


    /**
    * How long to wait between retries
    */


    /**
    * Maximum number of requests to allow simultaneously
    */
    function AsyncTask() {
        var _this = this;

        var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheck3.default)(this, AsyncTask);
        this.maximumRetries = 3;
        this.maximumParallel = 1;
        this.haltQueueUponfail = true;
        this.timeBetweenRetries = 2000;
        this.pending = 0;
        this.runqueue = [];
        this.queue = [];
        this.context = null;

        (0, _keys2.default)(defaults).forEach(function (k) {
            if (defaults[k] != null) _this[k] = defaults[k];
        });
    }

    /**
    * How many pending items in the queue
    */


    /**
    * clear Queue if any request fails max times
    */


    /**
    * Maximum number of times to retry a failed call before giving up and reporting a failure.
    */


    (0, _createClass3.default)(AsyncTask, [{
        key: "runQueue",
        value: function runQueue() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (this.queue.length === 0) return;

            if (!this.runqueue.length && !this.pending && typeof this.onRun === "function" && !opts.skipOnRun) this.onRun.call(this);
            for (var x = 0, len = this.queue.length; x < len; x++) {
                var item = this.queue.shift();
                this.runqueue.push(item);
                this.runItem(item);
            }
        }
    }, {
        key: "runItem",
        value: function runItem(callTask) {
            var _this2 = this,
                _arguments = arguments;

            if (callTask.cancelled) {
                this.checkQueueComplete();
                return console.log("callTask cancelled");
            }

            if (this.maximumParallel && this.pending >= this.maximumParallel) return setTimeout(function () {
                console.log("waiting 500 ms");_this2.runItem.apply(_this2, _arguments);
            }, 500);

            this.pending++;
            callTask(function (err, haltQueueUponfail) {
                if (callTask.cancelled) return;
                if (err && haltQueueUponfail) {
                    debugger;
                    _this2.clearQueue();
                } else {
                    if (_this2.pending) _this2.pending--;
                    var index;
                    for (var i = 0; i < _this2.runqueue.length; ++i) {
                        if (_this2.runqueue[i] === callTask) {
                            index = i;
                            break;
                        }
                    }
                    if (index == null) throw new Error("missing calltask! may be already splliced?");
                    _this2.runqueue.splice(index, 1);
                    callTask.completed = true;
                }
                _this2.checkQueueComplete(err);
            });
        }
    }, {
        key: "checkQueueComplete",
        value: function checkQueueComplete(err) {
            var _this3 = this;

            if (this.queueTimer) clearTimeout(this.queueTimer);
            this.queueTimer = setTimeout(function () {
                if (_this3.pending === 0 && _this3.runqueue.length === 0) {
                    if (typeof _this3.onDone === "function") _this3.onDone.call(_this3, err);
                }
                clearTimeout(_this3.queueTimer);
                _this3.queueTimer = null;
            }, 300);
        }
    }, {
        key: "clearQueue",
        value: function clearQueue() {
            this.queue.length = 0;
            this.pending = 0;
            this.runqueue.forEach(function (i) {
                i.cancelled = true;
            });
            this.runqueue.length = 0;
        }

        /**
         * Called before trying to retry a Simport call that has failed.
         *
         * @param {function} retry  Function to call to retry a Simport call.
         */

    }, {
        key: "retry",
        value: function retry(retryTarget, callTask, lastErr, numberOfRetries, done) {
            var continueOn = true;
            if (typeof retryTarget === "function") continueOn = retryTarget.call(this, lastErr, numberOfRetries);

            if (continueOn === false) return done();

            if (this.timeBetweenRetries) {
                setTimeout(function () {
                    return callTask(done);
                }, +this.timeBetweenRetries);
            } else {
                callTask(done);
            }
        }
    }, {
        key: "runTask",


        /**
         * Executes an asynchronous Simport 3 task (or task fulfilling simport-like interface: (opts, success, error) => ... )
         *
         * @param {function} task           A Simport 3 asynchronous function to run.
         * @param {object?} [params]  Parameters for the given Simport 3 task.
         * @param {function} [options]    all options: onSuccess {function}, onFailure {function}, onRetry {function}, maximumRetries {int}
         */
        value: function runTask(task, params) {
            var _this4 = this;

            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (!task) {
                throw new Exception("Task is required");
            }

            var numberOfRetries = 0;
            var failureTarget = options.onFailure || this.onFailure;
            var successTarget = options.onSuccess || this.onSuccess;
            var retryTarget = options.onRetry || this.onRetry;
            var maximumRetries = typeof options.maximumRetries === "number" ? options.maximumRetries : this.maximumRetries;

            var _callTask = void 0;
            var promise = new _promise2.default(function (resolve, reject) {
                _callTask = function callTask(done) {
                    var calledTask = _this4.context ? task.call(_this4.context, params) : task(params);
                    calledTask.then(function (res, xhr) {
                        if (!res && xhr.getResponseHeader('x-simport-error')) throw new Error(xhr.getResponseHeader('x-simport-error'));
                        if (typeof successTarget === "function") {
                            try {
                                successTarget(res);
                            } catch (e) {
                                numberOfRetries = maximumRetries;
                                console.error(e);
                                throw new Error("code error: " + e.stack);
                            }
                        }
                        done();
                        resolve(res);
                    }).catch(function (err, xhr) {
                        numberOfRetries++;
                        if (numberOfRetries < maximumRetries) {
                            _this4.retry(retryTarget, _callTask, err, numberOfRetries, done);
                        } else {
                            if (typeof failureTarget === "function") failureTarget(err);
                            done(err, _this4.haltQueueUponfail);
                            reject(err);
                        }
                    });
                };

                _this4.queue.push(_callTask);
                setTimeout(function () {
                    return _this4.runQueue(options);
                }, 10);
            });
            promise.callTask = _callTask;
            return promise;
        }
    }]);
    return AsyncTask;
}();

exports.default = AsyncTask;
;

/***/ }),

/***/ "./node_modules/trc-example-activity/coverage/coverage-summary.json":
/***/ (function(module, exports) {

module.exports = {"total":{"lines":{"total":87,"covered":75,"skipped":0,"pct":86.21},"statements":{"total":92,"covered":76,"skipped":0,"pct":82.61},"functions":{"total":16,"covered":13,"skipped":0,"pct":81.25},"branches":{"total":40,"covered":31,"skipped":0,"pct":77.5}},"D:\\dev\\regis\\archive\\trc-example-activity\\src\\component.js":{"lines":{"total":24,"covered":19,"skipped":0,"pct":79.17},"functions":{"total":10,"covered":7,"skipped":0,"pct":70},"statements":{"total":28,"covered":20,"skipped":0,"pct":71.43},"branches":{"total":34,"covered":28,"skipped":0,"pct":82.35}},"D:\\dev\\regis\\archive\\trc-example-activity\\src\\contentmodel.js":{"lines":{"total":12,"covered":11,"skipped":0,"pct":91.67},"functions":{"total":2,"covered":2,"skipped":0,"pct":100},"statements":{"total":13,"covered":11,"skipped":0,"pct":84.62},"branches":{"total":2,"covered":1,"skipped":0,"pct":50}},"D:\\dev\\regis\\archive\\trc-example-activity\\src\\index.js":{"lines":{"total":4,"covered":4,"skipped":0,"pct":100},"functions":{"total":0,"covered":0,"skipped":0,"pct":100},"statements":{"total":4,"covered":4,"skipped":0,"pct":100},"branches":{"total":0,"covered":0,"skipped":0,"pct":100}},"D:\\dev\\regis\\archive\\trc-example-activity\\tests\\custom.js":{"lines":{"total":46,"covered":40,"skipped":0,"pct":86.96},"functions":{"total":4,"covered":4,"skipped":0,"pct":100},"statements":{"total":46,"covered":40,"skipped":0,"pct":86.96},"branches":{"total":4,"covered":2,"skipped":0,"pct":50}},"D:\\dev\\regis\\archive\\trc-example-activity\\tests\\generic.js":{"lines":{"total":1,"covered":1,"skipped":0,"pct":100},"functions":{"total":0,"covered":0,"skipped":0,"pct":100},"statements":{"total":1,"covered":1,"skipped":0,"pct":100},"branches":{"total":0,"covered":0,"skipped":0,"pct":100}}}

/***/ }),

/***/ "./node_modules/trc-example-activity/dist/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleSub = exports.Example = exports.ExampleViewStore = undefined;

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _class2, _class3, _temp, _class4;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _simboxEditable = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js");

var _autoclassDecorator = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/autoclass-decorator/index.js");

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-viewstore/index.js");

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// this is like a ViewModel, contains all user actions for this component
var ExampleViewStore = exports.ExampleViewStore = (_dec = _mobx.action.bound, (_class = function (_BaseViewStore) {
  (0, _inherits3.default)(ExampleViewStore, _BaseViewStore);

  function ExampleViewStore() {
    (0, _classCallCheck3.default)(this, ExampleViewStore);
    return (0, _possibleConstructorReturn3.default)(this, (ExampleViewStore.__proto__ || (0, _getPrototypeOf2.default)(ExampleViewStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExampleViewStore, [{
    key: "save",
    value: function save() {
      var _this2 = this;

      var _props = this.props,
          contentModel = _props.contentModel,
          inputStore = _props.inputStore;

      inputStore && inputStore.setInput(contentModel, "isCompleted", true);
      inputStore && inputStore.saveData(function () {
        return console.log(_this2.id + " saved!");
      });
    }
  }, {
    key: "invalid",
    get: function get() {
      var invalid = {};
      var _props2 = this.props,
          activity = _props2.contentModel,
          inputStore = _props2.inputStore;


      var userInputValue = inputStore && inputStore.getInput(activity, "userInput");

      if (!userInputValue) invalid.userInput = "User, please provide a value!";

      return invalid;
    }
  }]);
  return ExampleViewStore;
}(_baseViewstore2.default), (_applyDecoratedDescriptor(_class.prototype, "invalid", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "invalid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "save"), _class.prototype)), _class));

// this automatically gives consistent `className`s to components using module and component names
var Example = exports.Example = (0, _simboxEditable.Decorator)(_class2 = (0, _mobxReact.observer)(_class2 = (0, _autoclassDecorator2.default)(_class2 = (_temp = _class3 = function (_BaseComponent) {
  (0, _inherits3.default)(Example, _BaseComponent);

  function Example() {
    (0, _classCallCheck3.default)(this, Example);
    return (0, _possibleConstructorReturn3.default)(this, (Example.__proto__ || (0, _getPrototypeOf2.default)(Example)).apply(this, arguments));
  }

  (0, _createClass3.default)(Example, [{
    key: "render",
    //ViewStore gets auto-instantiated and attached to the component on creation
    value: function render() {
      var _props3 = this.props,
          currentView = _props3.currentView,
          contentModel = _props3.contentModel,
          inputStore = _props3.inputStore;
      var textSlot = contentModel.textSlot,
          richTextSlot = contentModel.richTextSlot,
          textOptionsSlot = contentModel.textOptionsSlot,
          numberSlot = contentModel.numberSlot,
          booleanSlot = contentModel.booleanSlot,
          referenceSlot = contentModel.referenceSlot,
          referenceArraySlot = contentModel.referenceArraySlot; // this contentModel's properties

      var _viewStore = this.viewStore,
          invalid = _viewStore.invalid,
          save = _viewStore.save; // this components viewStore.  Will have actions and UI properties

      var isDirty = inputStore && inputStore.isDirty;
      var isLoading = inputStore && inputStore.isLoading;
      var revert = inputStore ? inputStore.revert : function () {};

      function createMarkup(html) {
        return { __html: html };
      }

      if (isLoading) return _react2.default.createElement(
        "div",
        null,
        "Loading..."
      );

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "header" },
          _react2.default.createElement(
            "h2",
            { className: "title" },
            textOptionsSlot,
            " - ",
            numberSlot
          ),
          _react2.default.createElement(
            "div",
            { className: "subtitle" },
            textSlot
          ),
          !!booleanSlot && _react2.default.createElement(
            "div",
            { className: "boolean" },
            "Boolean selected"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "content-area" },
          _react2.default.createElement(
            "div",
            { className: "left-column" },
            _react2.default.createElement("div", { dangerouslySetInnerHTML: createMarkup(richTextSlot) }),
            _react2.default.createElement("hr", null),
            !!invalid.userInput && _react2.default.createElement(
              "div",
              { className: "validation-error" },
              invalid.userInput
            ),
            _react2.default.createElement("input", { type: "text", value: inputStore && inputStore.getInput(contentModel, "userInput"), onChange: function onChange(e) {
                return inputStore && inputStore.setInput(contentModel, "userInput", e.target.value);
              } }),
            _react2.default.createElement("textarea", { disabled: "true", value: inputStore && inputStore.getInput(contentModel, "userInput_computed") }),
            _react2.default.createElement("hr", null),
            _react2.default.createElement(
              "button",
              { id: "save-button", onClick: save, disabled: (0, _keys2.default)(invalid).length || !isDirty },
              "Save"
            ),
            _react2.default.createElement(
              "button",
              { id: "revert-button", onClick: revert, disabled: !isDirty },
              "Undo"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "center-column" },
            _react2.default.createElement(
              "div",
              null,
              "Single / direct reference slot:"
            ),
            _react2.default.createElement(ExampleSub, { "data-editable": [contentModel, "referenceSlot"], contentModel: referenceSlot })
          ),
          _react2.default.createElement(
            "div",
            { className: "right-column", "data-editable": [contentModel, "referenceArraySlot"] },
            _react2.default.createElement(
              "div",
              null,
              "Array of references slot:"
            ),
            referenceArraySlot.length > 0 && referenceArraySlot.map(function (cm) {
              return cm && _react2.default.createElement(ExampleSub, { key: cm.id, contentModel: cm });
            })
          )
        )
      );
    }
  }]);
  return Example;
}(_baseComponent2.default), _class3.ViewStore = ExampleViewStore, _temp)) || _class2) || _class2) || _class2;

exports.default = Example; //need to export top level component as "default"

var ExampleSub = exports.ExampleSub = (0, _simboxEditable.Decorator)(_class4 = (0, _mobxReact.observer)(_class4 = (0, _autoclassDecorator2.default)(_class4 = function (_BaseComponent2) {
  (0, _inherits3.default)(ExampleSub, _BaseComponent2);

  function ExampleSub() {
    (0, _classCallCheck3.default)(this, ExampleSub);
    return (0, _possibleConstructorReturn3.default)(this, (ExampleSub.__proto__ || (0, _getPrototypeOf2.default)(ExampleSub)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExampleSub, [{
    key: "render",
    value: function render() {
      var contentModel = this.props.contentModel;

      if (!contentModel) return _react2.default.createElement(
        "div",
        null,
        "No contentmodel supplied"
      );
      var text = contentModel.text,
          richText = contentModel.richText;


      function createMarkup(html) {
        return { __html: html };
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "title" },
          text
        ),
        _react2.default.createElement("div", { className: "body", dangerouslySetInnerHTML: createMarkup(richText) })
      );
    }
  }]);
  return ExampleSub;
}(_baseComponent2.default)) || _class4) || _class4) || _class4;

/***/ }),

/***/ "./node_modules/trc-example-activity/dist/contentmodel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleContentModel = exports.ExampleSubContentModel = undefined;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _class2, _temp2, _dec, _dec2, _desc2, _value2, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _class4, _temp4;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");

var _mobxReact = __webpack_require__("./node_modules/mobx-react/index.module.js");

var _deepBindDecorator = __webpack_require__("./node_modules/deep-bind-decorator/dist/deep-bind-decorator.js");

var _deepBindDecorator2 = _interopRequireDefault(_deepBindDecorator);

var _baseComponent = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-component/index.js");

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseContentmodel = __webpack_require__("./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/index.js");

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _component = __webpack_require__("./node_modules/trc-example-activity/dist/component.js");

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ExampleSubContentModel = exports.ExampleSubContentModel = (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(ExampleSubContentModel, _BaseContentModel);

  function ExampleSubContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExampleSubContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExampleSubContentModel.__proto__ || (0, _getPrototypeOf2.default)(ExampleSubContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'text', _descriptor, _this), _initDefineProp(_this, 'richText', _descriptor2, _this), _initDefineProp(_this, 'userInput', _descriptor3, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExampleSubContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return {
        text: "This is the default text for this content model",
        richText: "<h1>Title</h1><br/>Some <b><i>Rich</i></b> text."
      };
    }

    /* @slot */

    /* @slot("RichText") */
  }]);
  return ExampleSubContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  text: "",
  richText: "RichText"
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'text', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'richText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "Default text for richText";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'userInput', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_userInput:G';
      },
      defaultValue: "another default"
    };
  }
})), _class);
var ExampleContentModel = exports.ExampleContentModel = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.shallow, (_class3 = (_temp4 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(ExampleContentModel, _BaseContentModel2);

  function ExampleContentModel() {
    var _ref2;

    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, ExampleContentModel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ExampleContentModel.__proto__ || (0, _getPrototypeOf2.default)(ExampleContentModel)).call.apply(_ref2, [this].concat(args))), _this2), _initDefineProp(_this2, '_options', _descriptor4, _this2), _this2.Component = _component2.default, _initDefineProp(_this2, 'textSlot', _descriptor5, _this2), _initDefineProp(_this2, 'richTextSlot', _descriptor6, _this2), _initDefineProp(_this2, 'textOptionsSlot', _descriptor7, _this2), _initDefineProp(_this2, 'numberSlot', _descriptor8, _this2), _initDefineProp(_this2, 'booleanSlot', _descriptor9, _this2), _initDefineProp(_this2, 'referenceSlot', _descriptor10, _this2), _initDefineProp(_this2, 'referenceArraySlot', _descriptor11, _this2), _initDefineProp(_this2, 'isCompleted', _descriptor12, _this2), _initDefineProp(_this2, 'userInput', _descriptor13, _this2), _initDefineProp(_this2, 'userInput_computed', _descriptor14, _this2), _initDefineProp(_this2, 'customUserInput', _descriptor15, _this2), _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }
  // the ContentModel classes contain the customizable "slots" that content creators will be filling in
  // presently these are defined via static _slots, but will be applied via @slot sugar
  // see the list below for examples of the slot types, and the editor input created for each:


  (0, _createClass3.default)(ExampleContentModel, null, [{
    key: '_defaults',
    get: function get() {
      return {
        textSlot: "Some default text",
        richTextSlot: "Default RichText",
        textOptionsSlot: "Option1",
        numberSlot: 8,
        booleanSlot: false,
        referenceSlot: new ExampleSubContentModel(ExampleSubContentModel._defaults),
        referenceArraySlot: [new ExampleSubContentModel(ExampleSubContentModel._defaults), new ExampleSubContentModel(ExampleSubContentModel._defaults)]
      };
    }

    // options are a way to supply slots with specific options
    // this is currently defined manually, but will be taken care of by @options decorator 

    // define the default Component (Sim) view of this component

    /* @slot */

    // below is what content model definitions will ultimately look like. note the commented out decorators.
    // when these are in place, you will not need @observable, @observable.ref, etc

    /* @slot("RichText") */
    /* @options(["Option1", "Option2", "Option3"]) @slot */
    /* @slot */
    /* @slot */
    /* @slot(ExampleSubContentModel) */
    /* @slot([ExampleSubContentModel]) */

    // @input userInput = 100
    // creates...

    // @input.computed userInput_computed = () => {
    // const userInput2Val = this.$inputStore.getInput(this, "userInput2")
    // return userInput2Val + " was computed ... "
    // }
    // creates...

    // @input( () => `G:${this.id}_customVarName123:G` ) customUserInput = () => this.textOptionsSlot
    // creates...

  }]);
  return ExampleContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  textSlot: "", // textarea
  richTextSlot: "RichText", // trix wysiwyg
  textOptionsSlot: "", // see _options
  numberSlot: 0, // text input, coerced to number
  booleanSlot: false, // checkbox
  referenceSlot: ExampleSubContentModel, // data-editable, contentModel mode
  referenceArraySlot: [ExampleSubContentModel] // data-editable, arrayAccessor mode
}, _temp4), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, '_options', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get textOptionsSlot() {
        // turns textOptionsSlot into dropdown
        return ["Option1", "Option2", "Option3"];
      }
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'textSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'richTextSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, 'textOptionsSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'numberSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'booleanSlot', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, 'referenceSlot', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, 'referenceArraySlot', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class3.prototype, 'isCompleted', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_isCompleted:G';
      },
      defaultValue: false };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class3.prototype, 'userInput', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_userInput:G';
      },
      defaultValue: 100,
      value: "" };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class3.prototype, 'userInput_computed', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_userInput_computed:G';
      },
      get value() {
        if (!this.$inputStore) return "";
        var userInputVal = this.$inputStore.getInput(this, "userInput");
        return userInputVal + " was computed! (also gets saved, but is computed on UI), saves to variable: " + this["userInput_computed"].variable;
      }
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class3.prototype, 'customUserInput', [_mobx.observable, _deepBindDecorator2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get variable() {
        return 'G:' + this.id + '_customVarName123:G';
      },
      get defaultValue() {
        return this.textOptionsSlot;
      },
      value: ""
    };
  }
})), _class3));
exports.default = ExampleContentModel;

/***/ }),

/***/ "./node_modules/trc-example-activity/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = __webpack_require__("./node_modules/trc-example-activity/dist/contentmodel.js");

var exampleContentModels = _interopRequireWildcard(_contentmodel);

__webpack_require__("./node_modules/trc-example-activity/dist/style.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = exampleContentModels;
var ContentModel = exports.ContentModel = exampleContentModels.default;

var description = exports.description = "This is the example-activity.";
var instructions = exports.instructions = '\nThese are the example-activity installation instructions:\n  Step 1...\n  Step 2...\n  Step 3...\n';

/***/ }),

/***/ "./node_modules/trc-example-activity/dist/style.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/trc-example-activity/package.json":
/***/ (function(module, exports) {

module.exports = {"_from":"git+https://gitlab.com/regiscompany/trc-example-activity.git","_id":"trc-example-activity@1.0.3","_inBundle":false,"_integrity":"","_location":"/trc-example-activity","_phantomChildren":{"traverse":"0.6.6"},"_requested":{"type":"git","raw":"trc-example-activity@git+https://gitlab.com/regiscompany/trc-example-activity.git","name":"trc-example-activity","escapedName":"trc-example-activity","rawSpec":"git+https://gitlab.com/regiscompany/trc-example-activity.git","saveSpec":"git+https://gitlab.com/regiscompany/trc-example-activity.git","fetchSpec":"https://gitlab.com/regiscompany/trc-example-activity.git","gitCommittish":null},"_requiredBy":["/platform-client-bootstrap"],"_resolved":"git+https://gitlab.com/regiscompany/trc-example-activity.git#5c2468bb2482edf6006e951f20d8548ca6c1573b","_spec":"trc-example-activity@git+https://gitlab.com/regiscompany/trc-example-activity.git","_where":"D:\\VSTS\\agent\\_work\\24\\s\\node_modules\\platform-client-bootstrap","author":"","bugs":{"url":"https://gitlab.com/regiscompany/trc-component-template/issues"},"bundleDependencies":false,"dependencies":{"debug":"^3.1.0","deep-bind-decorator":"git+https://gitlab.com/regiscompany/deep-bind-decorator.git#v1.0.4","mobx":"^3.0.2","mobx-react":"^4.1.0","react":"^15.4.2","react-dom":"^15.4.2"},"deprecated":false,"description":"TRC platform activity example","devDependencies":{"babel-cli":"^6.26.0","babel-plugin-istanbul":"^4.1.5","babel-plugin-module-resolver":"^3.0.0-beta.5","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-require-ignore":"^0.1.1","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.0","babel-preset-react":"^6.24.0","babel-preset-stage-1":"^6.24.0","cloner":"^0.4.0","component-testing-tools":"git+https://gitlab.com/regiscompany/component-testing-tools.git#v1.x.x","copyfiles":"1.2.0","cross-env":"^5.0.5","deep-extend":"^0.5.0","enzyme":"^2.9.1","is-online-cli":"^2.0.0","istanbul":"^0.4.5","jsdom":"^11.5.1","nyc":"^11.4.1","platform-client-src":"git+https://gitlab.com/regiscompany/platform-client-src.git#v4.x.x","react-test-renderer":"^15.6.1","tape":"4.5.1","trc-debug-runner":"git+https://gitlab.com/regiscompany/trc-debug-runner.git#v1.x.x","trc-tagme":"git+https://gitlab.com/regiscompany/trc-tagme.git"},"files":["coverage","dist"],"homepage":"https://gitlab.com/regiscompany/trc-component-template#readme","license":"ISC","main":"dist/index.js","module":"src/index.js","name":"trc-example-activity","nyc":{"require":["babel-register"],"reporter":["lcov","json-summary","text","text-summary"],"sourceMap":false,"instrument":false},"repository":{"type":"git","url":"git+https://gitlab.com/regiscompany/trc-component-template.git"},"scripts":{"compile":"npm run test && npm run copy-css && npm run copy-json && npm run copy-xml && babel src -d dist","compile-and-commit":"npm run compile && git add . && git commit -m \"Compiling\"","copy-css":"copyfiles -u 1 \"src/*.css\" dist && copyfiles -u 1 \"src/**/*.css\" dist","copy-json":"copyfiles -u 1 \"src/*.json\" dist && copyfiles -u 1 \"src/**/*.json\" dist","copy-xml":"copyfiles -u 1 \"src/*.xml\" dist && copyfiles -u 1 \"src/**/*.xml\" dist","inspect":"cross-env BABEL_ENV=test trc-inspect \"tests/*.js\"","publish":"npm run compile-and-commit && is-online && npm version patch && trc-tagme && git push --follow-tags","publish-major":"npm run compile-and-commit && is-online && npm version major && trc-tagme && git push --follow-tags","publish-minor":"npm run compile-and-commit && is-online && npm version minor && trc-tagme && git push --follow-tags","publish-patch":"npm run publish","test":"cross-env BABEL_ENV=test nyc trc-test \"tests/*.js\""},"version":"1.0.3"}

/***/ }),

/***/ "./node_modules/trc-simgate/dist/trc.simgate.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;﻿/*!
trc.simgate.js v0.2.0 07/31/2017 Copyright (c) 2013,2017 The Regis Company, Inc. All Rights Reserved.
For details and terms of use please visit: http://www.regiscompany.com
*/
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var _FILE_ = "trc.simgate: ",
        _U_ = "undefined",
        _B_ = "boolean",
        _F_ = "function",
        _O_ = "object",
        _S_ = "string",
        _CNT_ = "content",
        _HDR_CT_ = "Content-Type",
        _HDR_CL_ = "Content-Length",
        _HDR_CD_ = "Content-Disposition",
        _HDR_CFS_ = "x-simgate-file-size",
        _CT_JSON_ = "application/json",
        _CT_FORM_ = "multipart/form-data",
        _CT_TEXT_ = "text/plain; charset=utf-8",
        _CT_CROSS_ = [_CT_TEXT_, "application/x-www-form-urlencoded", _CT_FORM_],
        _REQ_ = "simgate-request",
        _WebRequestQueue_ = [],
        _XhrSpecialOptions = ["withCredentials", "user", "password", "delay"],
        _XhrEvents = [
            ["done", "success", "complete"],
            ["fail", "error", "catch"],
            ["abort", "cancel"],
            ["timeout", "timeOut"],
            ["always", "after"]
        ];

    function _void() {
    }

    function _isNull(v) {
        return (v === null || typeof v === _U_ || typeof v === "unknown");
    }

    function _isObj(o) {
        return (!_isNull(o) && (typeof o === _O_));
    }

    function _isArray(a) {
        return (_isObj(a) && ((a instanceof Array) || (a.constructor == Array) || !isNaN(a.length)));
    }

    function _int(v) {
        var n = parseInt(v);
        return isNaN(n) ? (arguments.length > 1 ? arguments[1] : NaN) : n;
    }

    function _date(src) {
        var d = new Date();
        d.setTime((src ? src.getTime() : 0));
        return d;
    }

    function _getProp(o, p, remove) {
        var v = null;
        try {
            if (o) {
                v = o[p];
                if (remove) {
                    delete o[p];
                }
                if (typeof v === _U_) {
                    v = null;
                }
            }
        }
        catch (e) {
        }
        return v;
    }

    function _delete(obj, prop) {
        if (_isObj(obj) && prop) {
            try {
                if (typeof prop === _S_) {
                    delete obj[prop];
                }
                else {
                    for (var i = 0, l = prop.length; i < l; i++) {
                        delete obj[prop[i]];
                    }
                }
            }
            catch (err) {

            }
        }
        return obj;
    }

    function _merge(dest, src) {
        if (src) {
            if (_isNull(dest)) {
                dest = src;
                return dest;
            }

            var s, st, d, dt;
            for (var prop in src) {
                s = src[prop];
                if (_isNull(s)) {
                    dest[prop] = s;
                }
                else {
                    d = dest[prop];
                    dt = typeof d;
                    st = typeof s;
                    switch (st) {
                        case _O_:
                            if (dt === _S_) { //s + o = o
                                if (!s.hasOwnProperty("value")) {
                                    s = _clone(s);
                                    s.value = d;
                                }
                            }
                            else {
                                if (s instanceof Date) {
                                    s = _date(s);
                                }
                                else {
                                    s = _merge(d, s);
                                }
                            }
                            break;

                        case _S_:
                            if (dt === _O_ && !_isNull(d)) { // o + s = o
                                dest[prop].value = s;
                                continue;
                            }
                            break;
                    }
                    dest[prop] = s;
                }
            }
        }
        return dest;
    }

    function _clone(value) {
        if (!value) {
            return value;
        }

        switch (typeof value) {
            case _U_:
                return undefined;

            case _S_:
                value = value.substring(0);
                for (var i = 1; i < arguments.length; i++) {
                    value += arguments[i];
                }
                return value;

            case "symbol": // ECMA2015
                return new Symbol(value);

            case _O_:
                if (value instanceof Date) {
                    return _date(value);
                }
                if (_isArray(value)) {
                    var array = [];
                    for (var i = -1, len = value.length; ++i < len;) {
                        array.push(_clone(value[i]));
                    }
                    return array;
                }
                var obj = {}, p;
                for (p in value) {
                    obj[p] = _clone(value[p]);
                }
                if (arguments.length > 1) {
                    obj = _merge(obj, arguments[1]);
                }
                return obj;
        }
        return value;
    }

    function _ab2Str(buffer, encoding) {
        if (!encoding) {
            encoding = "";
        }
        switch (encoding) {
            case "":
            case "utf-8":
                encoding = Uint8Array;
                break;
            case "utf-16":
                encoding = Uint8Array; //Uint16Array;
                break;
            case "utf-32":
                encoding = Uint8Array; //Uint32Array;
                break;
            default:
                throw new Error("Unsupported encoding " + encoding);
        }
        var bytes = new encoding(buffer), str = "";
        for (var i = 0, len = bytes.length; i < len; i++) {
            str += ("%" + ("00" + bytes[i].toString(16)).slice(-2));
        }
        return decodeURIComponent(str);
    }

    function _getMethod(obj, names, remove) {
        var m = null;
        if (obj && names) {
            if (!_isArray(names)) {
                names = [names.toString()];
            }
            for (var i = 0, n; i < names.length; i++) {
                n = names[i];
                if (typeof obj[n] === _F_) {
                    m = obj[n];
                    if (remove === 1) {
                        delete obj[n];
                        remove = false;
                    }
                    break;
                }
            }
            if (remove === true || remove > 1) {
                _delete(obj, names);
            }
        }
        return m;
    }

    function ContentType(header) {
        this.contentType = null;
        this.encoding = null;

        if (header) {
            header = header.toLowerCase().split(/\s*;\s*/);
            this.contentType = header[0];
            if (header.length > 1) {
                header = header[1].split(/\s*=\s*/);
                this.encoding = header[(header.length > 1 ? 1 : 0)];
            }
        }
    }

    function toJson(obj) {
        return (obj === null || obj === undefined) ? "null" : JSON.stringify(obj);
    }

    function parseJSON(json) {
        return json ? JSON.parse(json) : null;
    }

    function FileInfo(name, type, length, disp) {
        this.filename = name;
        this.type = type;
        this.length = _int(length, null);
        this.disposition = disp;
    }

    function WebRequest(req, trace) {
        var self = this,
            _xhr = null,
            _handlers = {},
            _isResolved = false,
            _trace = trace,
            _traceResp = _void,
            _traceError = _void;

        this.url = null;
        this.xhrParsers = [];
        this.result = null;

        if (_trace) {
            _traceResp = function (prop, value) {
                _trace.response = _trace.response || {};
                _trace.response[prop] = value;
            };

            _traceError = function (err) {
                _traceResp("error", err);
            };
        }

        _merge(this, req);

        this.headers = this.headers || {};
        if (this.nocache) {
            this.headers["Cache-Control"] = "no-cache";
        }
        delete this.nocache;

        function _error(err) {
            if (!_isResolved) {
                _traceError(err);
                if (_handlers.fail) {
                    _handlers.fail.call(self, err, _xhr);
                }
            }
        }

        function _onError() {
            var message = "Request error.",
                statusCode = 0;
            if (_xhr) {
                statusCode = _xhr.status;
                message = "Status code: " + (statusCode ? statusCode : "<unknown>");
                if (_xhr.statusText) {
                    message += ("\nStatus description: " + _xhr.statusText);
                }
                if (_xhr.responseText) {
                    message += ("\nResponse: " + _xhr.responseText);
                }
            }
            if (console && console.log) {
                console.log("Simgate error: " + message);
            }
            var err = new Error(message);
            err.request = _xhr;
            err.number = statusCode;
            _error(err);
        }

        function _onAbort() {
            if (!_isResolved) {
                _traceResp("abort", true);
                var err = new Error("Request aborted.");
                if (_handlers.abort) {
                    _traceError(err);
                    _handlers.abort.call(self, _xhr);
                }
                else {
                    _error(err);
                }
            }
        }

        function _onTimeout() {
            if (!_isResolved) {
                var err = new Error("Request timed out.");
                _traceResp("timeout", true);
                if (_handlers.timeout) {
                    _traceError(err);
                    _handlers.timeout.call(self, _xhr);
                }
                else {
                    _error(err);
                }
            }
        }

        function _parseResponse(xhr) {
            var status = xhr.status,
                message = xhr.statusText,
                description = xhr.responseText,
                res = null;

            try {
                var ct = new ContentType(xhr.getResponseHeader("content-type")), json = null;
                switch (ct.contentType) {
                    case _CT_JSON_:
                    case "application/javascript":
                    case "application/x-javascript":
                    case "text/javascript":
                        if (ArrayBuffer && (xhr.response instanceof ArrayBuffer)) {
                            json = _ab2Str(xhr.response, ct.encoding);
                        }
                        else {
                            json = _getProp(xhr, "responseText");
                            if (!json) {
                                json = _getProp(xhr, "responseJSON");
                            }
                        }
                        break;

                    case "text/plain":
                    default:
                        if (ArrayBuffer && (xhr.response instanceof ArrayBuffer)) {
                            json = _ab2Str(xhr.response, ct.encoding);
                        }
                        else {
                            json = _getProp(xhr, "responseJSON"); //jquery ajax
                        }
                        break;
                }

                if (status < 200 || status >= 300 || (message || "").toLowerCase().indexOf("simgate server error") != -1) { // http/server error
                    var data = parseJSON(json);
                    if (data && data.error) {
                        message = data.error.message;
                        status = data.error.number;
                        description = data.error.description;
                    }
                    res = new Error(message);
                    res.number = status;
                    if (description) {
                        res.description = description;
                    }
                }
                else {
                    var file = xhr.getResponseHeader(_HDR_CD_);
                    if (file) {
                        var fileName = /filename\s*=\s*((['"]).*?\2|[^;\n\r]*)/.exec(file);
                        file = /([^;]\w+);/.exec(file);
                        file = new FileInfo(
                            ((fileName && fileName[1]) ? fileName[1].toString() : "document"),
                            xhr.getResponseHeader(_HDR_CT_),
                            xhr.getResponseHeader(_HDR_CL_) || xhr.getResponseHeader(_HDR_CFS_),
                            ((file && file[1]) ? file[1].toString().toLowerCase() : "attachment")
                        );
                        return file; //this it??
                    }

                    res = parseJSON(json);
                    if (res) {
                        if (res.hasOwnProperty("d")) {
                            res = res.d;
                        }
                        if (res) {
                            if (res.hasOwnProperty("error")) {
                                throw res.error;
                            }
                            if (res.hasOwnProperty("result")) {
                                res = res.result;
                            }
                        }
                    }
                }
            }
            catch (err) {
                res = err;
                res.response = xhr;
            }
            return res;
        }

        function _onLoad() {
            try {
                if (this.readyState !== 4) {
                    return;
                }

                _traceResp("status", this.status);

                self.result = _parseResponse(_xhr);

                if (self.result instanceof Error) {
                    throw self.result;
                }

                if (self.xhrParsers) {
                    for (var i in self.xhrParsers) {
                        var p = self.xhrParsers[i];
                        if ((typeof p === _F_) && p.call(self, self.result, _xhr) === false) {
                            break;
                        }
                    }
                }
                if (!_isResolved && _handlers.done) {
                    _handlers.done.call(self, self.result, _xhr);
                }
            }
            catch (error) {
                if (!_isResolved) {
                    _traceError(error);
                    if (_handlers.fail) {
                        _handlers.fail.call(self, error, _xhr);
                    }
                }
            }
            finally {
                if (!_isResolved) {
                    self.resolve(true);
                    if (_handlers.always) {
                        _handlers.always.call(self, _xhr);
                    }
                }
            }
        }

        //#region Event handlers
        for (var i = 0, et, en; i < _XhrEvents.length; i++) {
            et = _XhrEvents[i];
            en = et[0];
            _handlers[en] = _getMethod(this, et, true);
            for (var j = 0; j < et.length; j++) {
                (function (f) {
                    self[et[j]] = function (cb) {
                        if (typeof cb === _F_) {
                            _handlers[f] = cb;
                        }
                        return self;
                    };
                })(en);
            }
        }

        this.before = function (f) {
            if (typeof f === _F_) {
                _handlers.before = f;
            }
            return self;
        };

        this.then = function (d, f, a) {
            if (typeof d === _F_) {
                _handlers.done = d;
            }
            if (typeof f === _F_) {
                _handlers.fail = f;
            }
            if (typeof a === _F_) {
                _handlers.always = a;
            }
            return self;
        };
        //#endregion

        this.send = function (options) {
            var method = self.method || "POST",
                delay = 7; //7 ms.

            _xhr = new XMLHttpRequest();
            _xhr.addEventListener("error", _onError);
            _xhr.addEventListener("abort", _onAbort);
            _xhr.addEventListener("load", _onLoad);
            _xhr.addEventListener("timeout", _onTimeout);

            options = options || {};
            method = options.method || method;
            if (typeof options.withCredentials !== _U_) {
                _xhr.withCredentials = !!options.withCredentials;
            }
            if (_xhr.withCredentials || options.user || options.password) {
                _xhr.open(method, self.url, true, options.user || "", options.password || "");
            }
            else {
                _xhr.open(method, self.url);
            }

            //setup xhr headers
            if (self.headers) {
                for (var h in self.headers) {
                    _xhr.setRequestHeader(h, self.headers[h]);
                }
            }

            //setup additional xhr parameters if any (skip special options)
            for (var o in options) {
                if (_XhrSpecialOptions.indexOf(o) == -1) {
                    _xhr[o] = options[o];
                }
            }
            if (options.delay > 7) {
                delay = _int(options.delay);
            }

            setTimeout(function () {
                var s = ((typeof _handlers.before === _F_) && _handlers.before.call(self, _xhr) === false) ? false : true;
                if (s === true) {
                    try {
                        _xhr.send(self.data);
                    }
                    catch (err) {
                        _error(err);
                    }
                }
            }, delay);
            return self;
        };

        this.resolve = function () {
            if (arguments.length > 0) {
                _isResolved = (typeof arguments[0] === _B_) ? arguments[0] : _isResolved;
                var p = _WebRequestQueue_.indexOf(self);
                if (_isResolved) {
                    if (p != -1) {
                        _WebRequestQueue_.splice(p, 1);
                    }
                }
                else {
                    if (p == -1) {
                        _WebRequestQueue_.push(self);
                    }
                }
            }
            return _isResolved;
        };

        this.abortRequest = function () {
            if (_xhr && !_isResolved && (_xhr.state == 2 || _xhr.state == 3)) {
                _xhr.abort();
            }
        };

        _WebRequestQueue_.push(this);
    }

    function SimgateContext(src) {
        this.userId = 0;
        this.roleId = 0;
        this.user = null;
        this.path = null;
		_merge(this, src);
    }

    SimgateContext.isContext = function (o) {
        return (o instanceof SimgateContext);
    };

    function _createTF(filter) {
        filter = filter.split(/\//gi);
        if (filter.length > 1) {
            if (!filter[0]) {
                filter[0] = "*";
            }
            if (filter.length > 2 && !filter[1]) {
                filter[1] = "*";
            }
            filter = filter.join("/");
        }
        else {
            filter = filter[0];
        }
        filter = filter.replace(/\*/g, "[-\\w]+").replace(/\//gi, "\\/");
        return new RegExp(filter, "i");
    }

    function _testTF(trace, filter) {
        return (trace && (!filter || (trace.req && filter.test(trace.req.url))));
    }

    function Simgate(configuration) {
        var self = this,
            _traceData = [];

        if (typeof configuration === _F_) {
            configuration = new configuration();
        }

        this.url = "";
        this.apiUrl = "";
        this.context = new SimgateContext();
        this.trace = { limit: 0 };
        this.options = {};
        this.crossDomain = false;
        this.onError = function (error) {
            var msg = Error.format(error);
            if (msg) {
                Error.trace(_FILE_, msg);
                alert(_FILE_ + msg);
            }
        };

        _merge(this, configuration);

        this.url = this.url ? this.url.replace(/\/$/gi, "") : "";
        if (!this.apiUrl) {
            this.apiUrl = this.url + "/api/simgate";
        }
        this.crossDomain = !!this.crossDomain;

        this.setContext = function (ctx) {
			if (!SimgateContext.isContext(self.context)) {
				self.context = new SimgateContext(self.context);
			}
			_merge(self.context, ctx);
            return self;
        };

        this.clearContext = function () {
            self.context = new SimgateContext();
        };

        this.createTrace = function (req) {
            if (self.trace.limit > 0) { //["path/select""]
                var t = {
                    time: new Date(),
                    url: req.url,
                    data: req.data
                };
                if (_traceData.length > 0) {
                    var over = _traceData.length - self.trace.limit;
                    if (over >= 0) {
                        _traceData.splice(0, over + 1);
                    }
                }
                _traceData.push(t);
                return t;
            }
            return null;
        };

        this.selectTrace = function (filter) {
            if (!filter) {
                return _traceData;
            }
            filter = _createTF(filter);
            var filtered = [];
            for (var i = 0; i < _traceData.length; i++) {
                if (_testTF(_traceData[i], filter)) {
                    filtered.push(_traceData[i]);
                }
            }
            return filtered;
        };

        this.deleteTrace = function (filter) {
            if (_traceData.length > 0) {
                if (!filter) {
                    _traceData = [];
                }
                else {
                    filter = _createTF(filter);
                    for (var i = _traceData.length; --i > -1;) {
                        if (_testTF(_traceData[i], filter)) {
                            _traceData.splice(i, 1);
                        }
                    }
                }
            }
            return _traceData;
        };

        self.fetch = function (url, request) {
            if (!url) {
                throw new Error("Invalid argument 'url'");
            }

            var xhrHeaders = _getProp(request, "xhrHeaders", true),
                contentType = _getProp(request, "contentType", true),
                options = _clone(self.options, _getProp(request, "xhrOptions", true)),
                parsers = _getProp(request, "xhrParsers", true),
                isFormData = (request instanceof FormData);

            if (self.crossDomain) {
                if (contentType) {
                    contentType = contentType.toLowerCase();
                    var i = 0, ct, len = contentType.length;
                    for (; i < _CT_CROSS_.length; i++) {
						ct = _CT_CROSS_[i];
                        if (ct && len >= ct.length && contentType.substring(0, ct.length) === ct) {
                            break;
                        }
                    }
                    if (i >= 3) {
                        throw new Error(_HDR_CT_ + " '" + contentType + "' is not allowed in cross-domain mode.");
                    }
                    if (!isFormData) {
                        request = toJson(request);
                    }
                }
                else {
                    if (!isFormData) {
                        contentType = _CT_TEXT_;
                        request = toJson(request);
                    }
                }
                options = options || {};
                if (!options.hasOwnProperty("withCredentials")) {
                    options.withCredentials = true; // by default true otherwise auth. cookie won't be sent
                }
            }
            else {
                if (!contentType) {
                    if (isFormData) {
                        contentType = _CT_FORM_;
                    }
                    else {
                        contentType = _CT_JSON_;
                        request = toJson(request);
                    }
                }
            }

            if (contentType) {
                xhrHeaders = xhrHeaders || {};
                xhrHeaders[_HDR_CT_] = contentType;
            }
            var req = {
                url: url,
                data: request
            };
            if (xhrHeaders) {
                req.headers = xhrHeaders;
            }
            if (parsers) {
                req.xhrParsers = parsers;
            }
            return (new WebRequest(req, self.createTrace(req))).send(options);
        };

		function _addParser(r) {
			r = r || {};
			r.xhrParsers = (r.xhrParsers || []);
			r.xhrParsers.push(syncCtx);
			return r;
		}

		function _fetch(url, data, options) {
		    return self.fetch(self.apiUrl + "/" + url, data || {}, options);
		}

        //#region Security API
		function syncCtx(r) {
			if (r) {
				self.setContext(r.context);
			}
		}
        this.security = {
            signIn: function (d, o) { return _fetch("security/signIn", _addParser(d, syncCtx), o); },
            signOut: function (d, o) { return _fetch("security/signOut", d, o); },
            getContext: function (d, o) { return _fetch("security/getContext", d, o); },
            register: function (d, o) { return _fetch("security/register", d, o); },
            changePassword: function (d, o) { return _fetch("security/changePassword", d, o); },
            resetPassword: function (d, o) { return _fetch("security/resetPassword", d, o); },
            forgotPassword: function (d, o) { return _fetch("security/forgotPassword", d, o); }
        };
        this.signIn = this.security.signIn;
        this.signOut = this.security.signOut;
        this.getContext = this.security.getContext;
        this.register = this.security.register;
        this.changePassword = this.security.changePassword;
        this.resetPassword = this.security.resetPassword;
        this.forgotPassword = this.security.forgotPassword;
        //#endregion

        //#region Configuration API
        this.config = {
            select: function (d, o) { return _fetch("config/select", d, o); },
            create: function (d, o) { return _fetch("config/create", d, o); },
            update: function (d, o) { return _fetch("config/update", d, o); },
            delete: function (d, o) { return _fetch("config/delete", d, o); },
            reviews: function (d, o) { return _fetch("config/reviews", d, o); },
            trim: function (d, o) { return _fetch("config/trim", d, o); },
            commit: function (d, o) { return _fetch("config/commit", d, o); },
            revert: function (d, o) { return _fetch("config/revert", d, o); }
        };
        //#endregion

        //#region User API
        this.user = {
            select: function (d, o) { return _fetch("user/select", d, o); },
            create: function (d, o) { return _fetch("user/create", d, o); },
            update: function (d, o) { return _fetch("user/update", d, o); },
            delete: function (d, o) { return _fetch("user/delete", d, o); }
        };
        this.selectUser = this.user.select;
        this.createUser = this.user.create;
        this.updateUser = this.user.update;
        this.deleteUser = this.user.delete;
        //#endregion

        //#region Path API
        this.path = {
            select: function (d, o) { return _fetch("path/select", d, o); },
            create: function (d, o) { return _fetch("path/create", d, o); },
            update: function (d, o) { return _fetch("path/update", d, o); },
            delete: function (d, o) { return _fetch("path/delete", d, o); }
        };
        this.selectPath = this.path.select;
        this.createPath = this.path.create;
        this.updatePath = this.path.update;
        this.deletePath = this.path.delete;
        //#endregion

        //#region Session API
        this.session = {
            select: function (d, o) { return _fetch("session/select", d, o); },
            create: function (d, o) { return _fetch("session/create", d, o); },
            update: function (d, o) { return _fetch("session/update", d, o); },
            delete: function (d, o) { return _fetch("session/delete", d, o); }
        };
        this.selectSession = this.session.select;
        this.createSession = this.session.create;
        this.updateSession = this.session.update;
        this.deleteSession = this.session.delete;
        //#endregion

        //#region Team API
        this.team = {
            select: function (d, o) { return _fetch("team/select", d, o); },
            create: function (d, o) { return _fetch("team/create", d, o); },
            update: function (d, o) { return _fetch("team/update", d, o); },
            delete: function (d, o) { return _fetch("team/delete", d, o); },
            reset: function (d, o) { return _fetch("team/reset", d, o); },
            takeControl: function (d, o) { return _fetch("team/takeControl", d, o); },
            releaseControl: function (d, o) { return _fetch("team/releaseControl", d, o); },
            transition: function (d, o) { return _fetch("team/transition", d, o); },
            execute: function (d, o) { return _fetch("team/execCommand", d, o); }
        };
        this.selectTeam = this.team.select;
        this.createTeam = this.team.create;
        this.updateTeam = this.team.update;
        this.deleteTeam = this.team.delete;
        this.resetTeam = this.team.reset;
        this.takeControl = this.team.takeControl;
        this.releaseControl = this.team.releaseControl;
        this.transitionTeam = this.team.transition;
        this.execCommand = this.team.execute;
        //#endregion

        //#region Data API
        this.data = {
            select: function (d, o) { return _fetch("data/select", d, o); },
            update: function (d, o) { return _fetch("data/update", d, o); },
            execQuery: function (d, o) { return _fetch("data/execQuery", d, o); },
            runModel: function (d, o) { return _fetch("data/runModel", d, o); }
        };
        this.selectData = this.data.select;
        this.updateData = this.data.update;
		this.execQuery = this.data.execQuery;
		this.runModel = this.data.runModel;
        //#endregion

        //#region Document API
        function addDocContent(formData, doc, prop, index) {
            if (_isObj(doc)) {
                var content = doc[prop];
                if (content instanceof File) {
                    doc[prop] = null;
                    formData.append("form-file" + (index === undefined ? "" : index.toString()), content);
                }
            }
            return formData;
        }

        this.document = {
            select: function (d, o) { return _fetch("document/select", d, o); },
            create: function (r, o) {
                var formData = new FormData(),
                    create = r.create;
                if (!_isArray(create)) {
                    create = [create];
                }
                r.create = create;
                for (var i = 0; i < create.length; i++) {
                    addDocContent(formData, create[i], _CNT_, i);
                }
                formData.append(_REQ_, toJson(r));
                return _fetch("document/create", formData, o);
            },
            update: function (d, o) {
                var data = addDocContent(new FormData(), (d || {}).set, _CNT_);
                data.append(_REQ_, toJson(d));
                return _fetch("document/update", data, o);
            },
            delete: function (d, o) {
                return _fetch("document/delete", d, o);
            },
            commit: function (d, o) {
                var data = addDocContent(new FormData(), d, "file");
                data.append(_REQ_, toJson(d));
                return _fetch("document/commit", data, o);
            },
            download: function (r, o) {
                r = r || {};
                r.xhrOptions = r.xhrOptions || {};
                r.xhrOptions.responseType = "arraybuffer";
                if (!_isArray(r.responseParser)) {
                    r.xhrParsers = [];
                }
                r.xhrParsers.push(function (res, xhr) {
                    if (!(res instanceof FileInfo)) {
                        throw new Error("Server response has no file information.");
                    }
                    if (res.saved) {
                        return;
                    }
                    res.saved = true;
                    if (!res.filename) {
                        res.filename = "document";
                    }
                    var blob = new Blob([xhr.response], { type: res.type });
                    if (typeof window.navigator.msSaveOrOpenBlob != _U_) {
                        // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                        if (res.disposition == "attachment") {
                            window.navigator.msSaveOrOpenBlob(blob, res.filename);
                        }
                        else {
                            window.navigator.msSaveBlob(blob, res.filename);
                        }
                    }
                    else {
                        var URL = window.URL || window.webkitURL,
                            downloadUrl = URL.createObjectURL(blob);

                        if (res.filename) {
                            // use HTML5 a[download] attribute to specify filename
                            var a = document.createElement("A");
                            a.style.display = "none";
                            // safari doesn't support this yet
                            if (typeof a.download === _U_) {
                                if (this.target) {
                                    window.location = downloadUrl;
                                }
                            }
                            else {
                                a.href = downloadUrl;
                                a.download = res.filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        }
                        else {
                            window.location = downloadUrl;
                        }

                        setTimeout(function () {
                            URL.revokeObjectURL(downloadUrl);
                        }, 100);
                    }
                    this.result = res;
                });
                return _fetch("download", r, o);
            }
        };
        this.selectDocument = this.document.select;
        this.createDocument = this.document.create;
        this.updateDocument = this.document.update;
        this.deleteDocument = this.document.delete;
        this.downloadDocument = this.document.download;
        //#endregion

        //#region Utility API
        this.utils = {
            getInfo: function (d, o) { return _fetch("utils/getInfo", d, o); },
            ping: function (d, o) { return _fetch("utils/ping", d, o); },
            startPing: function (r) {
                r = r || {};
                var timeout = _int(r.timeout, 0);
                if (timeout < 5000) {
                    timeout = 5000;
                }
                return setInterval(function () {
                    self.ping(r);
                }, timeout);
            },
            cancelPing: function (ping) {
                if (ping) {
                    clearInterval(ping);
                    return true;
                }
                return false;
            },
            execute: function (d, o) { return _fetch("utils/execute", d, o); },
            upload: function (d, o) {
                var data = addDocContent(new FormData(), d, "file");
                data.append(_REQ_, toJson(d));
                return _fetch("utils/upload", data, o);
            }
        };
        //#endregion

        //#region Snapshot API
        this.snapshot = {
            select: function (d, o) { return _fetch("spanshot/select", d, o); },
            create: function (d, o) { return _fetch("spanshot/create", d, o); },
            update: function (d, o) { return _fetch("spanshot/update", d, o); },
            delete: function (d, o) { return _fetch("spanshot/delete", d, o); },
            restore: function (d, o) { return _fetch("spanshot/restore", d, o); }
        };
        //#endregion
    }

    Simgate.version = "0.1.5";
    Simgate.isSimgate = function (o) {
        return (o instanceof Simgate);
    };
    Simgate.Context = SimgateContext;

    return Simgate;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./node_modules/trix/dist/trix.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/trix/dist/trix.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
Trix 0.10.2
Copyright © 2017 Basecamp, LLC
http://trix-editor.org/
 */
(function(){}).call(this),function(){var t;null==window.Set&&(window.Set=t=function(){function t(){this.clear()}return t.prototype.clear=function(){return this.values=[]},t.prototype.has=function(t){return-1!==this.values.indexOf(t)},t.prototype.add=function(t){return this.has(t)||this.values.push(t),this},t.prototype["delete"]=function(t){var e;return-1===(e=this.values.indexOf(t))?!1:(this.values.splice(e,1),!0)},t.prototype.forEach=function(){var t;return(t=this.values).forEach.apply(t,arguments)},t}())}.call(this),function(t){function e(){}function n(t,e){return function(){t.apply(e,arguments)}}function o(t){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],c(t,this)}function i(t,e){for(;3===t._state;)t=t._value;return 0===t._state?void t._deferreds.push(e):(t._handled=!0,void h(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null===n)return void(1===t._state?r:s)(e.promise,t._value);var o;try{o=n(t._value)}catch(i){return void s(e.promise,i)}r(e.promise,o)}))}function r(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var i=e.then;if(e instanceof o)return t._state=3,t._value=e,void a(t);if("function"==typeof i)return void c(n(i,e),t)}t._state=1,t._value=e,a(t)}catch(r){s(t,r)}}function s(t,e){t._state=2,t._value=e,a(t)}function a(t){2===t._state&&0===t._deferreds.length&&setTimeout(function(){t._handled||p(t._value)},1);for(var e=0,n=t._deferreds.length;n>e;e++)i(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}function c(t,e){var n=!1;try{t(function(t){n||(n=!0,r(e,t))},function(t){n||(n=!0,s(e,t))})}catch(o){if(n)return;n=!0,s(e,o)}}var l=setTimeout,h="function"==typeof setImmediate&&setImmediate||function(t){l(t,1)},p=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)};o.prototype["catch"]=function(t){return this.then(null,t)},o.prototype.then=function(t,n){var r=new o(e);return i(this,new u(t,n,r)),r},o.all=function(t){var e=Array.prototype.slice.call(t);return new o(function(t,n){function o(r,s){try{if(s&&("object"==typeof s||"function"==typeof s)){var a=s.then;if("function"==typeof a)return void a.call(s,function(t){o(r,t)},n)}e[r]=s,0===--i&&t(e)}catch(u){n(u)}}if(0===e.length)return t([]);for(var i=e.length,r=0;r<e.length;r++)o(r,e[r])})},o.resolve=function(t){return t&&"object"==typeof t&&t.constructor===o?t:new o(function(e){e(t)})},o.reject=function(t){return new o(function(e,n){n(t)})},o.race=function(t){return new o(function(e,n){for(var o=0,i=t.length;i>o;o++)t[o].then(e,n)})},o._setImmediateFn=function(t){h=t},o._setUnhandledRejectionFn=function(t){p=t},"undefined"!=typeof module&&module.exports?module.exports=o:t.Promise||(t.Promise=o)}(this),/**
 * @license
 * Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */
"undefined"==typeof WeakMap&&!function(){var t=Object.defineProperty,e=Date.now()%1e9,n=function(){this.name="__st"+(1e9*Math.random()>>>0)+(e++ +"__")};n.prototype={set:function(e,n){var o=e[this.name];return o&&o[0]===e?o[1]=n:t(e,this.name,{value:[e,n],writable:!0}),this},get:function(t){var e;return(e=t[this.name])&&e[0]===t?e[1]:void 0},"delete":function(t){var e=t[this.name];return e&&e[0]===t?(e[0]=e[1]=void 0,!0):!1},has:function(t){var e=t[this.name];return e?e[0]===t:!1}},window.WeakMap=n}(),function(t){function e(t){A.push(t),b||(b=!0,g(o))}function n(t){return window.ShadowDOMPolyfill&&window.ShadowDOMPolyfill.wrapIfNeeded(t)||t}function o(){b=!1;var t=A;A=[],t.sort(function(t,e){return t.uid_-e.uid_});var e=!1;t.forEach(function(t){var n=t.takeRecords();i(t),n.length&&(t.callback_(n,t),e=!0)}),e&&o()}function i(t){t.nodes_.forEach(function(e){var n=m.get(e);n&&n.forEach(function(e){e.observer===t&&e.removeTransientObservers()})})}function r(t,e){for(var n=t;n;n=n.parentNode){var o=m.get(n);if(o)for(var i=0;i<o.length;i++){var r=o[i],s=r.options;if(n===t||s.subtree){var a=e(s);a&&r.enqueue(a)}}}}function s(t){this.callback_=t,this.nodes_=[],this.records_=[],this.uid_=++C}function a(t,e){this.type=t,this.target=e,this.addedNodes=[],this.removedNodes=[],this.previousSibling=null,this.nextSibling=null,this.attributeName=null,this.attributeNamespace=null,this.oldValue=null}function u(t){var e=new a(t.type,t.target);return e.addedNodes=t.addedNodes.slice(),e.removedNodes=t.removedNodes.slice(),e.previousSibling=t.previousSibling,e.nextSibling=t.nextSibling,e.attributeName=t.attributeName,e.attributeNamespace=t.attributeNamespace,e.oldValue=t.oldValue,e}function c(t,e){return w=new a(t,e)}function l(t){return x?x:(x=u(w),x.oldValue=t,x)}function h(){w=x=void 0}function p(t){return t===x||t===w}function d(t,e){return t===e?t:x&&p(t)?x:null}function f(t,e,n){this.observer=t,this.target=e,this.options=n,this.transientObservedNodes=[]}if(!t.JsMutationObserver){var g,m=new WeakMap;if(/Trident|Edge/.test(navigator.userAgent))g=setTimeout;else if(window.setImmediate)g=window.setImmediate;else{var y=[],v=String(Math.random());window.addEventListener("message",function(t){if(t.data===v){var e=y;y=[],e.forEach(function(t){t()})}}),g=function(t){y.push(t),window.postMessage(v,"*")}}var b=!1,A=[],C=0;s.prototype={observe:function(t,e){if(t=n(t),!e.childList&&!e.attributes&&!e.characterData||e.attributeOldValue&&!e.attributes||e.attributeFilter&&e.attributeFilter.length&&!e.attributes||e.characterDataOldValue&&!e.characterData)throw new SyntaxError;var o=m.get(t);o||m.set(t,o=[]);for(var i,r=0;r<o.length;r++)if(o[r].observer===this){i=o[r],i.removeListeners(),i.options=e;break}i||(i=new f(this,t,e),o.push(i),this.nodes_.push(t)),i.addListeners()},disconnect:function(){this.nodes_.forEach(function(t){for(var e=m.get(t),n=0;n<e.length;n++){var o=e[n];if(o.observer===this){o.removeListeners(),e.splice(n,1);break}}},this),this.records_=[]},takeRecords:function(){var t=this.records_;return this.records_=[],t}};var w,x;f.prototype={enqueue:function(t){var n=this.observer.records_,o=n.length;if(n.length>0){var i=n[o-1],r=d(i,t);if(r)return void(n[o-1]=r)}else e(this.observer);n[o]=t},addListeners:function(){this.addListeners_(this.target)},addListeners_:function(t){var e=this.options;e.attributes&&t.addEventListener("DOMAttrModified",this,!0),e.characterData&&t.addEventListener("DOMCharacterDataModified",this,!0),e.childList&&t.addEventListener("DOMNodeInserted",this,!0),(e.childList||e.subtree)&&t.addEventListener("DOMNodeRemoved",this,!0)},removeListeners:function(){this.removeListeners_(this.target)},removeListeners_:function(t){var e=this.options;e.attributes&&t.removeEventListener("DOMAttrModified",this,!0),e.characterData&&t.removeEventListener("DOMCharacterDataModified",this,!0),e.childList&&t.removeEventListener("DOMNodeInserted",this,!0),(e.childList||e.subtree)&&t.removeEventListener("DOMNodeRemoved",this,!0)},addTransientObserver:function(t){if(t!==this.target){this.addListeners_(t),this.transientObservedNodes.push(t);var e=m.get(t);e||m.set(t,e=[]),e.push(this)}},removeTransientObservers:function(){var t=this.transientObservedNodes;this.transientObservedNodes=[],t.forEach(function(t){this.removeListeners_(t);for(var e=m.get(t),n=0;n<e.length;n++)if(e[n]===this){e.splice(n,1);break}},this)},handleEvent:function(t){switch(t.stopImmediatePropagation(),t.type){case"DOMAttrModified":var e=t.attrName,n=t.relatedNode.namespaceURI,o=t.target,i=new c("attributes",o);i.attributeName=e,i.attributeNamespace=n;var s=t.attrChange===MutationEvent.ADDITION?null:t.prevValue;r(o,function(t){return!t.attributes||t.attributeFilter&&t.attributeFilter.length&&-1===t.attributeFilter.indexOf(e)&&-1===t.attributeFilter.indexOf(n)?void 0:t.attributeOldValue?l(s):i});break;case"DOMCharacterDataModified":var o=t.target,i=c("characterData",o),s=t.prevValue;r(o,function(t){return t.characterData?t.characterDataOldValue?l(s):i:void 0});break;case"DOMNodeRemoved":this.addTransientObserver(t.target);case"DOMNodeInserted":var a,u,p=t.target;"DOMNodeInserted"===t.type?(a=[p],u=[]):(a=[],u=[p]);var d=p.previousSibling,f=p.nextSibling,i=c("childList",t.target.parentNode);i.addedNodes=a,i.removedNodes=u,i.previousSibling=d,i.nextSibling=f,r(t.relatedNode,function(t){return t.childList?i:void 0})}h()}},t.JsMutationObserver=s,t.MutationObserver||(t.MutationObserver=s,s._isPolyfilled=!0)}}(self),function(){"use strict";if(!window.performance){var t=Date.now();window.performance={now:function(){return Date.now()-t}}}window.requestAnimationFrame||(window.requestAnimationFrame=function(){var t=window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame;return t?function(e){return t(function(){e(performance.now())})}:function(t){return window.setTimeout(t,1e3/60)}}()),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(){return window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame||function(t){clearTimeout(t)}}());var e=function(){var t=document.createEvent("Event");return t.initEvent("foo",!0,!0),t.preventDefault(),t.defaultPrevented}();if(!e){var n=Event.prototype.preventDefault;Event.prototype.preventDefault=function(){this.cancelable&&(n.call(this),Object.defineProperty(this,"defaultPrevented",{get:function(){return!0},configurable:!0}))}}var o=/Trident/.test(navigator.userAgent);if((!window.CustomEvent||o&&"function"!=typeof window.CustomEvent)&&(window.CustomEvent=function(t,e){e=e||{};var n=document.createEvent("CustomEvent");return n.initCustomEvent(t,Boolean(e.bubbles),Boolean(e.cancelable),e.detail),n},window.CustomEvent.prototype=window.Event.prototype),!window.Event||o&&"function"!=typeof window.Event){var i=window.Event;window.Event=function(t,e){e=e||{};var n=document.createEvent("Event");return n.initEvent(t,Boolean(e.bubbles),Boolean(e.cancelable)),n},window.Event.prototype=i.prototype}}(window.WebComponents),window.CustomElements=window.CustomElements||{flags:{}},function(t){var e=t.flags,n=[],o=function(t){n.push(t)},i=function(){n.forEach(function(e){e(t)})};t.addModule=o,t.initializeModules=i,t.hasNative=Boolean(document.registerElement),t.isIE=/Trident/.test(navigator.userAgent),t.useNative=!e.register&&t.hasNative&&!window.ShadowDOMPolyfill&&(!window.HTMLImports||window.HTMLImports.useNative)}(window.CustomElements),window.CustomElements.addModule(function(t){function e(t,e){n(t,function(t){return e(t)?!0:void o(t,e)}),o(t,e)}function n(t,e,o){var i=t.firstElementChild;if(!i)for(i=t.firstChild;i&&i.nodeType!==Node.ELEMENT_NODE;)i=i.nextSibling;for(;i;)e(i,o)!==!0&&n(i,e,o),i=i.nextElementSibling;return null}function o(t,n){for(var o=t.shadowRoot;o;)e(o,n),o=o.olderShadowRoot}function i(t,e){r(t,e,[])}function r(t,e,n){if(t=window.wrap(t),!(n.indexOf(t)>=0)){n.push(t);for(var o,i=t.querySelectorAll("link[rel="+s+"]"),a=0,u=i.length;u>a&&(o=i[a]);a++)o.import&&r(o.import,e,n);e(t)}}var s=window.HTMLImports?window.HTMLImports.IMPORT_LINK_TYPE:"none";t.forDocumentTree=i,t.forSubtree=e}),window.CustomElements.addModule(function(t){function e(t,e){return n(t,e)||o(t,e)}function n(e,n){return t.upgrade(e,n)?!0:void(n&&s(e))}function o(t,e){b(t,function(t){return n(t,e)?!0:void 0})}function i(t){x.push(t),w||(w=!0,setTimeout(r))}function r(){w=!1;for(var t,e=x,n=0,o=e.length;o>n&&(t=e[n]);n++)t();x=[]}function s(t){C?i(function(){a(t)}):a(t)}function a(t){t.__upgraded__&&!t.__attached&&(t.__attached=!0,t.attachedCallback&&t.attachedCallback())}function u(t){c(t),b(t,function(t){c(t)})}function c(t){C?i(function(){l(t)}):l(t)}function l(t){t.__upgraded__&&t.__attached&&(t.__attached=!1,t.detachedCallback&&t.detachedCallback())}function h(t){for(var e=t,n=window.wrap(document);e;){if(e==n)return!0;e=e.parentNode||e.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&e.host}}function p(t){if(t.shadowRoot&&!t.shadowRoot.__watched){v.dom&&console.log("watching shadow-root for: ",t.localName);for(var e=t.shadowRoot;e;)g(e),e=e.olderShadowRoot}}function d(t,n){if(v.dom){var o=n[0];if(o&&"childList"===o.type&&o.addedNodes&&o.addedNodes){for(var i=o.addedNodes[0];i&&i!==document&&!i.host;)i=i.parentNode;var r=i&&(i.URL||i._URL||i.host&&i.host.localName)||"";r=r.split("/?").shift().split("/").pop()}console.group("mutations (%d) [%s]",n.length,r||"")}var s=h(t);n.forEach(function(t){"childList"===t.type&&(E(t.addedNodes,function(t){t.localName&&e(t,s)}),E(t.removedNodes,function(t){t.localName&&u(t)}))}),v.dom&&console.groupEnd()}function f(t){for(t=window.wrap(t),t||(t=window.wrap(document));t.parentNode;)t=t.parentNode;var e=t.__observer;e&&(d(t,e.takeRecords()),r())}function g(t){if(!t.__observer){var e=new MutationObserver(d.bind(this,t));e.observe(t,{childList:!0,subtree:!0}),t.__observer=e}}function m(t){t=window.wrap(t),v.dom&&console.group("upgradeDocument: ",t.baseURI.split("/").pop());var n=t===window.wrap(document);e(t,n),g(t),v.dom&&console.groupEnd()}function y(t){A(t,m)}var v=t.flags,b=t.forSubtree,A=t.forDocumentTree,C=window.MutationObserver._isPolyfilled&&v["throttle-attached"];t.hasPolyfillMutations=C,t.hasThrottledAttached=C;var w=!1,x=[],E=Array.prototype.forEach.call.bind(Array.prototype.forEach),S=Element.prototype.createShadowRoot;S&&(Element.prototype.createShadowRoot=function(){var t=S.call(this);return window.CustomElements.watchShadow(this),t}),t.watchShadow=p,t.upgradeDocumentTree=y,t.upgradeDocument=m,t.upgradeSubtree=o,t.upgradeAll=e,t.attached=s,t.takeRecords=f}),window.CustomElements.addModule(function(t){function e(e,o){if("template"===e.localName&&window.HTMLTemplateElement&&HTMLTemplateElement.decorate&&HTMLTemplateElement.decorate(e),!e.__upgraded__&&e.nodeType===Node.ELEMENT_NODE){var i=e.getAttribute("is"),r=t.getRegisteredDefinition(e.localName)||t.getRegisteredDefinition(i);if(r&&(i&&r.tag==e.localName||!i&&!r.extends))return n(e,r,o)}}function n(e,n,i){return s.upgrade&&console.group("upgrade:",e.localName),n.is&&e.setAttribute("is",n.is),o(e,n),e.__upgraded__=!0,r(e),i&&t.attached(e),t.upgradeSubtree(e,i),s.upgrade&&console.groupEnd(),e}function o(t,e){Object.__proto__?t.__proto__=e.prototype:(i(t,e.prototype,e.native),t.__proto__=e.prototype)}function i(t,e,n){for(var o={},i=e;i!==n&&i!==HTMLElement.prototype;){for(var r,s=Object.getOwnPropertyNames(i),a=0;r=s[a];a++)o[r]||(Object.defineProperty(t,r,Object.getOwnPropertyDescriptor(i,r)),o[r]=1);i=Object.getPrototypeOf(i)}}function r(t){t.createdCallback&&t.createdCallback()}var s=t.flags;t.upgrade=e,t.upgradeWithDefinition=n,t.implementPrototype=o}),window.CustomElements.addModule(function(t){function e(e,o){var u=o||{};if(!e)throw new Error("document.registerElement: first argument `name` must not be empty");if(e.indexOf("-")<0)throw new Error("document.registerElement: first argument ('name') must contain a dash ('-'). Argument provided was '"+String(e)+"'.");if(i(e))throw new Error("Failed to execute 'registerElement' on 'Document': Registration failed for type '"+String(e)+"'. The type name is invalid.");if(c(e))throw new Error("DuplicateDefinitionError: a type with name '"+String(e)+"' is already registered");return u.prototype||(u.prototype=Object.create(HTMLElement.prototype)),u.__name=e.toLowerCase(),u.extends&&(u.extends=u.extends.toLowerCase()),u.lifecycle=u.lifecycle||{},u.ancestry=r(u.extends),s(u),a(u),n(u.prototype),l(u.__name,u),u.ctor=h(u),u.ctor.prototype=u.prototype,u.prototype.constructor=u.ctor,t.ready&&m(document),u.ctor}function n(t){if(!t.setAttribute._polyfilled){var e=t.setAttribute;t.setAttribute=function(t,n){o.call(this,t,n,e)};var n=t.removeAttribute;t.removeAttribute=function(t){o.call(this,t,null,n)},t.setAttribute._polyfilled=!0}}function o(t,e,n){t=t.toLowerCase();var o=this.getAttribute(t);n.apply(this,arguments);var i=this.getAttribute(t);this.attributeChangedCallback&&i!==o&&this.attributeChangedCallback(t,o,i)}function i(t){for(var e=0;e<C.length;e++)if(t===C[e])return!0}function r(t){var e=c(t);return e?r(e.extends).concat([e]):[]}function s(t){for(var e,n=t.extends,o=0;e=t.ancestry[o];o++)n=e.is&&e.tag;t.tag=n||t.__name,n&&(t.is=t.__name)}function a(t){if(!Object.__proto__){var e=HTMLElement.prototype;if(t.is){var n=document.createElement(t.tag);e=Object.getPrototypeOf(n)}for(var o,i=t.prototype,r=!1;i;)i==e&&(r=!0),o=Object.getPrototypeOf(i),o&&(i.__proto__=o),i=o;r||console.warn(t.tag+" prototype not found in prototype chain for "+t.is),t.native=e}}function u(t){return v(E(t.tag),t)}function c(t){return t?w[t.toLowerCase()]:void 0}function l(t,e){w[t]=e}function h(t){return function(){return u(t)}}function p(t,e,n){return t===x?d(e,n):S(t,e)}function d(t,e){t&&(t=t.toLowerCase()),e&&(e=e.toLowerCase());var n=c(e||t);if(n){if(t==n.tag&&e==n.is)return new n.ctor;if(!e&&!n.is)return new n.ctor}var o;return e?(o=d(t),o.setAttribute("is",e),o):(o=E(t),t.indexOf("-")>=0&&b(o,HTMLElement),o)}function f(t,e){var n=t[e];t[e]=function(){var t=n.apply(this,arguments);return y(t),t}}var g,m=(t.isIE,t.upgradeDocumentTree),y=t.upgradeAll,v=t.upgradeWithDefinition,b=t.implementPrototype,A=t.useNative,C=["annotation-xml","color-profile","font-face","font-face-src","font-face-uri","font-face-format","font-face-name","missing-glyph"],w={},x="http://www.w3.org/1999/xhtml",E=document.createElement.bind(document),S=document.createElementNS.bind(document);g=Object.__proto__||A?function(t,e){return t instanceof e}:function(t,e){if(t instanceof e)return!0;for(var n=t;n;){if(n===e.prototype)return!0;n=n.__proto__}return!1},f(Node.prototype,"cloneNode"),f(document,"importNode"),document.registerElement=e,document.createElement=d,document.createElementNS=p,t.registry=w,t.instanceof=g,t.reservedTagList=C,t.getRegisteredDefinition=c,document.register=document.registerElement}),function(t){function e(){r(window.wrap(document)),window.CustomElements.ready=!0;var t=window.requestAnimationFrame||function(t){setTimeout(t,16)};t(function(){setTimeout(function(){window.CustomElements.readyTime=Date.now(),window.HTMLImports&&(window.CustomElements.elapsed=window.CustomElements.readyTime-window.HTMLImports.readyTime),document.dispatchEvent(new CustomEvent("WebComponentsReady",{bubbles:!0}))})})}{var n=t.useNative,o=t.initializeModules;t.isIE}if(n){var i=function(){};t.watchShadow=i,t.upgrade=i,t.upgradeAll=i,t.upgradeDocumentTree=i,t.upgradeSubtree=i,t.takeRecords=i,t.instanceof=function(t,e){return t instanceof e}}else o();var r=t.upgradeDocumentTree,s=t.upgradeDocument;if(window.wrap||(window.ShadowDOMPolyfill?(window.wrap=window.ShadowDOMPolyfill.wrapIfNeeded,window.unwrap=window.ShadowDOMPolyfill.unwrapIfNeeded):window.wrap=window.unwrap=function(t){return t}),window.HTMLImports&&(window.HTMLImports.__importsParsingHook=function(t){t.import&&s(wrap(t.import))}),"complete"===document.readyState||t.flags.eager)e();else if("interactive"!==document.readyState||window.attachEvent||window.HTMLImports&&!window.HTMLImports.ready){var a=window.HTMLImports&&!window.HTMLImports.ready?"HTMLImportsLoaded":"DOMContentLoaded";window.addEventListener(a,e)}else e()}(window.CustomElements),function(){}.call(this),function(){var t=this;(function(){(function(){this.Trix={VERSION:"0.10.2",ZERO_WIDTH_SPACE:"\ufeff",NON_BREAKING_SPACE:"\xa0",OBJECT_REPLACEMENT_CHARACTER:"\ufffc",config:{}}}).call(this)}).call(t);var e=t.Trix;(function(){(function(){e.BasicObject=function(){function t(){}var e,n,o;return t.proxyMethod=function(t){var o,i,r,s,a;return r=n(t),o=r.name,s=r.toMethod,a=r.toProperty,i=r.optional,this.prototype[o]=function(){var t,n;return t=null!=s?i?"function"==typeof this[s]?this[s]():void 0:this[s]():null!=a?this[a]:void 0,i?(n=null!=t?t[o]:void 0,null!=n?e.call(n,t,arguments):void 0):(n=t[o],e.call(n,t,arguments))}},n=function(t){var e,n;if(!(n=t.match(o)))throw new Error("can't parse @proxyMethod expression: "+t);return e={name:n[4]},null!=n[2]?e.toMethod=n[1]:e.toProperty=n[1],null!=n[3]&&(e.optional=!0),e},e=Function.prototype.apply,o=/^(.+?)(\(\))?(\?)?\.(.+?)$/,t}()}).call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Object=function(n){function o(){this.id=++i}var i;return t(o,n),i=0,o.fromJSONString=function(t){return this.fromJSON(JSON.parse(t))},o.prototype.hasSameConstructorAs=function(t){return this.constructor===(null!=t?t.constructor:void 0)},o.prototype.isEqualTo=function(t){return this===t},o.prototype.inspect=function(){var t,e,n;return t=function(){var t,o,i;o=null!=(t=this.contentsForInspection())?t:{},i=[];for(e in o)n=o[e],i.push(e+"="+n);return i}.call(this),"#<"+this.constructor.name+":"+this.id+(t.length?" "+t.join(", "):"")+">"},o.prototype.contentsForInspection=function(){},o.prototype.toJSONString=function(){return JSON.stringify(this)},o.prototype.toUTF16String=function(){return e.UTF16String.box(this)},o.prototype.getCacheKey=function(){return this.id.toString()},o}(e.BasicObject)}.call(this),function(){e.extend=function(t){var e,n;for(e in t)n=t[e],this[e]=n;return this}}.call(this),function(){e.extend({defer:function(t){return setTimeout(t,1)}})}.call(this),function(){var t,n;e.extend({normalizeSpaces:function(t){return t.replace(RegExp(""+e.ZERO_WIDTH_SPACE,"g"),"").replace(RegExp(""+e.NON_BREAKING_SPACE,"g")," ")},normalizeNewlines:function(t){return t.replace(/\r\n/g,"\n")},summarizeStringChange:function(t,o){var i,r,s,a;return t=e.UTF16String.box(t),o=e.UTF16String.box(o),o.length<t.length?(r=n(t,o),a=r[0],i=r[1]):(s=n(o,t),i=s[0],a=s[1]),{added:i,removed:a}}}),n=function(n,o){var i,r,s,a,u;return n.isEqualTo(o)?["",""]:(r=t(n,o),a=r.utf16String.length,s=a?(u=r.offset,r,i=n.codepoints.slice(0,u).concat(n.codepoints.slice(u+a)),t(o,e.UTF16String.fromCodepoints(i))):t(o,n),[r.utf16String.toString(),s.utf16String.toString()])},t=function(t,e){var n,o,i;for(n=0,o=t.length,i=e.length;o>n&&t.charAt(n).isEqualTo(e.charAt(n));)n++;for(;o>n+1&&t.charAt(o-1).isEqualTo(e.charAt(i-1));)o--,i--;return{utf16String:t.slice(n,o),offset:n}}}.call(this),function(){e.extend({copyObject:function(t){var e,n,o;null==t&&(t={}),n={};for(e in t)o=t[e],n[e]=o;return n},objectsAreEqual:function(t,e){var n,o;if(null==t&&(t={}),null==e&&(e={}),Object.keys(t).length!==Object.keys(e).length)return!1;for(n in t)if(o=t[n],o!==e[n])return!1;return!0}})}.call(this),function(){var t=[].slice;e.extend({arraysAreEqual:function(t,e){var n,o,i,r;if(null==t&&(t=[]),null==e&&(e=[]),t.length!==e.length)return!1;for(o=n=0,i=t.length;i>n;o=++n)if(r=t[o],r!==e[o])return!1;return!0},arrayStartsWith:function(t,n){return null==t&&(t=[]),null==n&&(n=[]),e.arraysAreEqual(t.slice(0,n.length),n)},spliceArray:function(){var e,n,o;return n=arguments[0],e=2<=arguments.length?t.call(arguments,1):[],o=n.slice(0),o.splice.apply(o,e),o},summarizeArrayChange:function(t,e){var n,o,i,r,s,a,u,c,l,h,p;for(null==t&&(t=[]),null==e&&(e=[]),n=[],h=[],i=new Set,r=0,u=t.length;u>r;r++)p=t[r],i.add(p);for(o=new Set,s=0,c=e.length;c>s;s++)p=e[s],o.add(p),i.has(p)||n.push(p);for(a=0,l=t.length;l>a;a++)p=t[a],o.has(p)||h.push(p);return{added:n,removed:h}}})}.call(this),function(){var t,n,o,i;t=null,n=null,i=null,o=null,e.extend({getAllAttributeNames:function(){return null!=t?t:t=e.getTextAttributeNames().concat(e.getBlockAttributeNames())},getBlockConfig:function(t){return e.config.blockAttributes[t]},getBlockAttributeNames:function(){return null!=n?n:n=Object.keys(e.config.blockAttributes)},getTextConfig:function(t){return e.config.textAttributes[t]},getTextAttributeNames:function(){return null!=i?i:i=Object.keys(e.config.textAttributes)},getListAttributeNames:function(){var t,n;return null!=o?o:o=function(){var o,i;o=e.config.blockAttributes,i=[];for(t in o)n=o[t].listAttribute,null!=n&&i.push(n);return i}()}})}.call(this),function(){var t,n,o,i,r,s=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=document.documentElement,n=null!=(o=null!=(i=null!=(r=t.matchesSelector)?r:t.webkitMatchesSelector)?i:t.msMatchesSelector)?o:t.mozMatchesSelector,e.extend({handleEvent:function(n,o){var i,r,s,a,u,c,l,h,p,d,f,g;return h=null!=o?o:{},c=h.onElement,u=h.matchingSelector,g=h.withCallback,a=h.inPhase,l=h.preventDefault,d=h.times,r=null!=c?c:t,p=u,i=g,f="capturing"===a,s=function(t){var n;return null!=d&&0===--d&&s.destroy(),n=e.findClosestElementFromNode(t.target,{matchingSelector:p}),null!=n&&(null!=g&&g.call(n,t,n),l)?t.preventDefault():void 0},s.destroy=function(){return r.removeEventListener(n,s,f)},r.addEventListener(n,s,f),s},handleEventOnce:function(t,n){return null==n&&(n={}),n.times=1,e.handleEvent(t,n)},triggerEvent:function(n,o){var i,r,s,a,u,c,l;return l=null!=o?o:{},c=l.onElement,r=l.bubbles,s=l.cancelable,i=l.attributes,a=null!=c?c:t,r=r!==!1,s=s!==!1,u=document.createEvent("Events"),u.initEvent(n,r,s),null!=i&&e.extend.call(u,i),a.dispatchEvent(u)},elementMatchesSelector:function(t,e){return 1===(null!=t?t.nodeType:void 0)?n.call(t,e):void 0},findClosestElementFromNode:function(t,n){var o,i,r;for(i=null!=n?n:{},o=i.matchingSelector,r=i.untilNode;null!=t&&t.nodeType!==Node.ELEMENT_NODE;)t=t.parentNode;if(null!=t){if(null==o)return t;if(t.closest&&null==r)return t.closest(o);for(;t&&t!==r;){if(e.elementMatchesSelector(t,o))return t;t=t.parentNode}}},findInnerElement:function(t){for(;null!=t?t.firstElementChild:void 0;)t=t.firstElementChild;return t},innerElementIsActive:function(t){return document.activeElement!==t&&e.elementContainsNode(t,document.activeElement)},elementContainsNode:function(t,e){if(t&&e)for(;e;){if(e===t)return!0;e=e.parentNode}},findNodeFromContainerAndOffset:function(t,e){var n;if(t)return t.nodeType===Node.TEXT_NODE?t:0===e?null!=(n=t.firstChild)?n:t:t.childNodes.item(e-1)},findElementFromContainerAndOffset:function(t,n){var o;return o=e.findNodeFromContainerAndOffset(t,n),e.findClosestElementFromNode(o)},findChildIndexOfNode:function(t){var e;if(null!=t?t.parentNode:void 0){for(e=0;t=t.previousSibling;)e++;return e}},walkTree:function(t,e){var n,o,i,r,s;return i=null!=e?e:{},o=i.onlyNodesOfType,r=i.usingFilter,n=i.expandEntityReferences,s=function(){switch(o){case"element":return NodeFilter.SHOW_ELEMENT;case"text":return NodeFilter.SHOW_TEXT;case"comment":return NodeFilter.SHOW_COMMENT;default:return NodeFilter.SHOW_ALL}}(),document.createTreeWalker(t,s,null!=r?r:null,n===!0)},tagName:function(t){var e;return null!=t&&null!=(e=t.tagName)?e.toLowerCase():void 0},makeElement:function(t,e){var n,o,i,r,s,a,u,c,l,h;if(null==e&&(e={}),"object"==typeof t?(e=t,t=e.tagName):e={attributes:e},o=document.createElement(t),null!=e.editable&&(null==e.attributes&&(e.attributes={}),e.attributes.contenteditable=e.editable),e.attributes){a=e.attributes;for(r in a)h=a[r],o.setAttribute(r,h)}if(e.style){u=e.style;for(r in u)h=u[r],o.style[r]=h}if(e.data){c=e.data;for(r in c)h=c[r],o.dataset[r]=h}if(e.className)for(l=e.className.split(" "),i=0,s=l.length;s>i;i++)n=l[i],o.classList.add(n);return e.textContent&&(o.textContent=e.textContent),o},cloneFragment:function(t){var e,n,o,i,r;for(e=document.createDocumentFragment(),r=t.childNodes,n=0,o=r.length;o>n;n++)i=r[n],e.appendChild(i.cloneNode(!0));return e},makeFragment:function(t){var e,n,o;for(null==t&&(t=""),e=document.createElement("div"),e.innerHTML=t,n=document.createDocumentFragment();o=e.firstChild;)n.appendChild(o);return n},getBlockTagNames:function(){var t,n;return null!=e.blockTagNames?e.blockTagNames:e.blockTagNames=function(){var o,i;o=e.config.blockAttributes,i=[];for(t in o)n=o[t],i.push(n.tagName);return i}()},nodeIsBlockContainer:function(t){return e.nodeIsBlockStartComment(null!=t?t.firstChild:void 0)},nodeProbablyIsBlockContainer:function(t){var n,o;return n=e.tagName(t),s.call(e.getBlockTagNames(),n)>=0&&(o=e.tagName(t.firstChild),s.call(e.getBlockTagNames(),o)<0)},nodeIsBlockStart:function(t,n){var o;return o=(null!=n?n:{strict:!0}).strict,o?e.nodeIsBlockStartComment(t):e.nodeIsBlockStartComment(t)||!e.nodeIsBlockStartComment(t.firstChild)&&e.nodeProbablyIsBlockContainer(t)},nodeIsBlockStartComment:function(t){return e.nodeIsCommentNode(t)&&"block"===(null!=t?t.data:void 0)},nodeIsCommentNode:function(t){return(null!=t?t.nodeType:void 0)===Node.COMMENT_NODE},nodeIsCursorTarget:function(t){return t?e.nodeIsTextNode(t)?t.data===e.ZERO_WIDTH_SPACE:e.nodeIsCursorTarget(t.firstChild):void 0},nodeIsAttachmentElement:function(t){return e.elementMatchesSelector(t,e.AttachmentView.attachmentSelector)},nodeIsEmptyTextNode:function(t){return e.nodeIsTextNode(t)&&""===(null!=t?t.data:void 0)},nodeIsTextNode:function(t){return(null!=t?t.nodeType:void 0)===Node.TEXT_NODE}})}.call(this),function(){var t,n,o,i,r;t=e.copyObject,i=e.objectsAreEqual,e.extend({normalizeRange:o=function(t){var e;if(null!=t)return Array.isArray(t)||(t=[t,t]),[n(t[0]),n(null!=(e=t[1])?e:t[0])]},rangeIsCollapsed:function(t){var e,n,i;if(null!=t)return n=o(t),i=n[0],e=n[1],r(i,e)},rangesAreEqual:function(t,e){var n,i,s,a,u,c;if(null!=t&&null!=e)return s=o(t),i=s[0],n=s[1],a=o(e),c=a[0],u=a[1],r(i,c)&&r(n,u)}}),n=function(e){return"number"==typeof e?e:t(e)},r=function(t,e){return"number"==typeof t?t===e:i(t,e)}}.call(this),function(){var t,n,o,i;t={extendsTagName:"div",css:"%t { display: block; }"},e.registerElement=function(e,n){var r,s,a,u,c,l,h;return null==n&&(n={}),e=e.toLowerCase(),c=i(n),u=null!=(h=c.extendsTagName)?h:t.extendsTagName,delete c.extendsTagName,s=c.defaultCSS,delete c.defaultCSS,null!=s&&u===t.extendsTagName?s+="\n"+t.css:s=t.css,o(s,e),a=Object.getPrototypeOf(document.createElement(u)),a.__super__=a,l=Object.create(a,c),r=document.registerElement(e,{prototype:l}),Object.defineProperty(l,"constructor",{value:r}),r},o=function(t,e){var o;return o=n(e),o.textContent=t.replace(/%t/g,e)},n=function(t){var e;return e=document.createElement("style"),e.setAttribute("type","text/css"),e.setAttribute("data-tag-name",t.toLowerCase()),document.head.insertBefore(e,document.head.firstChild),e},i=function(t){var e,n,o;n={};for(e in t)o=t[e],n[e]="function"==typeof o?{value:o}:o;return n}}.call(this),function(){var t,n;e.extend({getDOMSelection:function(){var t;return t=window.getSelection(),t.rangeCount>0?t:void 0},getDOMRange:function(){var n,o;return(n=null!=(o=e.getDOMSelection())?o.getRangeAt(0):void 0)&&!t(n)?n:void 0},setDOMRange:function(t){var n;return n=window.getSelection(),n.removeAllRanges(),n.addRange(t),e.selectionChangeObserver.update()}}),t=function(t){return n(t.startContainer)||n(t.endContainer)},n=function(t){return!Object.getPrototypeOf(t)}}.call(this),function(){}.call(this),function(){var t,n=function(t,e){function n(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},o={}.hasOwnProperty;t=e.arraysAreEqual,e.Hash=function(o){function i(t){null==t&&(t={}),this.values=s(t),i.__super__.constructor.apply(this,arguments)}var r,s,a,u,c;return n(i,o),i.fromCommonAttributesOfObjects=function(t){var e,n,o,i,s,a;if(null==t&&(t=[]),!t.length)return new this;for(e=r(t[0]),o=e.getKeys(),a=t.slice(1),n=0,i=a.length;i>n;n++)s=a[n],o=e.getKeysCommonToHash(r(s)),e=e.slice(o);return e},i.box=function(t){return r(t)},i.prototype.add=function(t,e){return this.merge(u(t,e))},i.prototype.remove=function(t){return new e.Hash(s(this.values,t))},i.prototype.get=function(t){return this.values[t]},i.prototype.has=function(t){return t in this.values},i.prototype.merge=function(t){return new e.Hash(a(this.values,c(t)))},i.prototype.slice=function(t){var n,o,i,r;for(r={},n=0,i=t.length;i>n;n++)o=t[n],this.has(o)&&(r[o]=this.values[o]);return new e.Hash(r)},i.prototype.getKeys=function(){return Object.keys(this.values)},i.prototype.getKeysCommonToHash=function(t){var e,n,o,i,s;for(t=r(t),i=this.getKeys(),s=[],e=0,o=i.length;o>e;e++)n=i[e],this.values[n]===t.values[n]&&s.push(n);return s},i.prototype.isEqualTo=function(e){return t(this.toArray(),r(e).toArray())},i.prototype.isEmpty=function(){return 0===this.getKeys().length},i.prototype.toArray=function(){var t,e,n;return(null!=this.array?this.array:this.array=function(){var o;e=[],o=this.values;for(t in o)n=o[t],e.push(t,n);return e}.call(this)).slice(0)},i.prototype.toObject=function(){return s(this.values)},i.prototype.toJSON=function(){return this.toObject()},i.prototype.contentsForInspection=function(){return{values:JSON.stringify(this.values)}},u=function(t,e){var n;return n={},n[t]=e,n},a=function(t,e){var n,o,i;o=s(t);for(n in e)i=e[n],o[n]=i;return o},s=function(t,e){var n,o,i,r,s;for(r={},s=Object.keys(t).sort(),n=0,i=s.length;i>n;n++)o=s[n],o!==e&&(r[o]=t[o]);return r},r=function(t){return t instanceof e.Hash?t:new e.Hash(t)},c=function(t){return t instanceof e.Hash?t.values:t},i}(e.Object)}.call(this),function(){e.ObjectGroup=function(){function t(t,e){var n,o;this.objects=null!=t?t:[],o=e.depth,n=e.asTree,n&&(this.depth=o,this.objects=this.constructor.groupObjects(this.objects,{asTree:n,depth:this.depth+1}))}return t.groupObjects=function(t,e){var n,o,i,r,s,a,u,c,l;for(null==t&&(t=[]),l=null!=e?e:{},i=l.depth,n=l.asTree,n&&null==i&&(i=0),c=[],s=0,a=t.length;a>s;s++){if(u=t[s],r){if(("function"==typeof u.canBeGrouped?u.canBeGrouped(i):void 0)&&("function"==typeof(o=r[r.length-1]).canBeGroupedWith?o.canBeGroupedWith(u,i):void 0)){r.push(u);continue}c.push(new this(r,{depth:i,asTree:n})),r=null}("function"==typeof u.canBeGrouped?u.canBeGrouped(i):void 0)?r=[u]:c.push(u)}return r&&c.push(new this(r,{depth:i,asTree:n})),c},t.prototype.getObjects=function(){return this.objects},t.prototype.getDepth=function(){return this.depth},t.prototype.getCacheKey=function(){var t,e,n,o,i;for(e=["objectGroup"],i=this.getObjects(),t=0,n=i.length;n>t;t++)o=i[t],e.push(o.getCacheKey());return e.join("/")},t}()}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.ObjectMap=function(e){function n(t){var e,n,o,i,r;for(null==t&&(t=[]),this.objects={},o=0,i=t.length;i>o;o++)r=t[o],n=JSON.stringify(r),null==(e=this.objects)[n]&&(e[n]=r)}return t(n,e),n.prototype.find=function(t){var e;return e=JSON.stringify(t),this.objects[e]},n}(e.BasicObject)}.call(this),function(){e.ElementStore=function(){function t(t){this.reset(t)}var e;return t.prototype.add=function(t){var n;return n=e(t),this.elements[n]=t},t.prototype.remove=function(t){var n,o;return n=e(t),(o=this.elements[n])?(delete this.elements[n],o):void 0},t.prototype.reset=function(t){var e,n,o;for(null==t&&(t=[]),this.elements={},n=0,o=t.length;o>n;n++)e=t[n],this.add(e);return t},e=function(t){return t.dataset.trixStoreKey},t}()}.call(this),function(){}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Operation=function(e){function n(){return n.__super__.constructor.apply(this,arguments)}return t(n,e),n.prototype.isPerforming=function(){return this.performing===!0},n.prototype.hasPerformed=function(){return this.performed===!0},n.prototype.hasSucceeded=function(){return this.performed&&this.succeeded},n.prototype.hasFailed=function(){return this.performed&&!this.succeeded},n.prototype.getPromise=function(){return null!=this.promise?this.promise:this.promise=new Promise(function(t){return function(e,n){return t.performing=!0,t.perform(function(o,i){return t.succeeded=o,t.performing=!1,t.performed=!0,t.succeeded?e(i):n(i)})}}(this))},n.prototype.perform=function(t){return t(!1)},n.prototype.release=function(){var t;return null!=(t=this.promise)&&"function"==typeof t.cancel&&t.cancel(),this.promise=null,this.performing=null,this.performed=null,this.succeeded=null
},n.proxyMethod("getPromise().then"),n.proxyMethod("getPromise().catch"),n}(e.BasicObject)}.call(this),function(){var t,n,o,i,r,s=function(t,e){function n(){this.constructor=t}for(var o in e)a.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},a={}.hasOwnProperty;e.UTF16String=function(t){function e(t,e){this.ucs2String=t,this.codepoints=e,this.length=this.codepoints.length,this.ucs2Length=this.ucs2String.length}return s(e,t),e.box=function(t){return null==t&&(t=""),t instanceof this?t:this.fromUCS2String(null!=t?t.toString():void 0)},e.fromUCS2String=function(t){return new this(t,i(t))},e.fromCodepoints=function(t){return new this(r(t),t)},e.prototype.offsetToUCS2Offset=function(t){return r(this.codepoints.slice(0,Math.max(0,t))).length},e.prototype.offsetFromUCS2Offset=function(t){return i(this.ucs2String.slice(0,Math.max(0,t))).length},e.prototype.slice=function(){var t;return this.constructor.fromCodepoints((t=this.codepoints).slice.apply(t,arguments))},e.prototype.charAt=function(t){return this.slice(t,t+1)},e.prototype.isEqualTo=function(t){return this.constructor.box(t).ucs2String===this.ucs2String},e.prototype.toJSON=function(){return this.ucs2String},e.prototype.getCacheKey=function(){return this.ucs2String},e.prototype.toString=function(){return this.ucs2String},e}(e.BasicObject),t=1===("function"==typeof Array.from?Array.from("\ud83d\udc7c").length:void 0),n=null!=("function"==typeof" ".codePointAt?" ".codePointAt(0):void 0),o=" \ud83d\udc7c"===("function"==typeof String.fromCodePoint?String.fromCodePoint(32,128124):void 0),i=t&&n?function(t){return Array.from(t).map(function(t){return t.codePointAt(0)})}:function(t){var e,n,o,i,r;for(i=[],e=0,o=t.length;o>e;)r=t.charCodeAt(e++),r>=55296&&56319>=r&&o>e&&(n=t.charCodeAt(e++),56320===(64512&n)?r=((1023&r)<<10)+(1023&n)+65536:e--),i.push(r);return i},r=o?function(t){return String.fromCodePoint.apply(String,t)}:function(t){var e,n,o;return e=function(){var e,i,r;for(r=[],e=0,i=t.length;i>e;e++)o=t[e],n="",o>65535&&(o-=65536,n+=String.fromCharCode(o>>>10&1023|55296),o=56320|1023&o),r.push(n+String.fromCharCode(o));return r}(),e.join("")}}.call(this),function(){}.call(this),function(){}.call(this),function(){e.config.lang={bold:"Bold",bullets:"Bullets","byte":"Byte",bytes:"Bytes",captionPlaceholder:"Type a caption here\u2026",captionPrompt:"Add a caption\u2026",code:"Code",heading1:"Heading",indent:"Increase Level",italic:"Italic",link:"Link",numbers:"Numbers",outdent:"Decrease Level",quote:"Quote",redo:"Redo",remove:"Remove",strike:"Strikethrough",undo:"Undo",unlink:"Unlink",urlPlaceholder:"Enter a URL\u2026",GB:"GB",KB:"KB",MB:"MB",PB:"PB",TB:"TB"}}.call(this),function(){e.config.css={classNames:{attachment:{container:"attachment",typePrefix:"attachment-",caption:"caption",captionEdited:"caption-edited",captionEditor:"caption-editor",editingCaption:"caption-editing",progressBar:"progress",removeButton:"remove icon",size:"size"}}}}.call(this),function(){var t;e.config.blockAttributes=t={"default":{tagName:"div",parse:!1},quote:{tagName:"blockquote",nestable:!0},heading1:{tagName:"h1",terminal:!0,breakOnReturn:!0,group:!1},code:{tagName:"pre",terminal:!0,text:{plaintext:!0}},bulletList:{tagName:"ul",parse:!1},bullet:{tagName:"li",listAttribute:"bulletList",group:!1,nestable:!0,test:function(n){return e.tagName(n.parentNode)===t[this.listAttribute].tagName}},numberList:{tagName:"ol",parse:!1},number:{tagName:"li",listAttribute:"numberList",group:!1,nestable:!0,test:function(n){return e.tagName(n.parentNode)===t[this.listAttribute].tagName}}}}.call(this),function(){var t,n;t=e.config.lang,n=[t.bytes,t.KB,t.MB,t.GB,t.TB,t.PB],e.config.fileSize={prefix:"IEC",precision:2,formatter:function(e){var o,i,r,s,a;switch(e){case 0:return"0 "+t.bytes;case 1:return"1 "+t.byte;default:return o=function(){switch(this.prefix){case"SI":return 1e3;case"IEC":return 1024}}.call(this),i=Math.floor(Math.log(e)/Math.log(o)),r=e/Math.pow(o,i),s=r.toFixed(this.precision),a=s.replace(/0*$/,"").replace(/\.$/,""),a+" "+n[i]}}}}.call(this),function(){e.config.textAttributes={bold:{tagName:"strong",inheritable:!0,parser:function(t){var e;return e=window.getComputedStyle(t),"bold"===e.fontWeight||e.fontWeight>=600}},italic:{tagName:"em",inheritable:!0,parser:function(t){var e;return e=window.getComputedStyle(t),"italic"===e.fontStyle}},href:{groupTagName:"a",parser:function(t){var n,o,i;return n=e.AttachmentView.attachmentSelector,i="a:not("+n+")",(o=e.findClosestElementFromNode(t,{matchingSelector:i}))?o.getAttribute("href"):void 0}},strike:{tagName:"del",inheritable:!0},frozen:{style:{backgroundColor:"highlight"}}}}.call(this),function(){var t,n,o,i,r;r="[data-trix-serialize=false]",i=["contenteditable","data-trix-id","data-trix-store-key","data-trix-mutable"],n="data-trix-serialized-attributes",o="["+n+"]",t=new RegExp("<!--block-->","g"),e.extend({serializers:{"application/json":function(t){var n;if(t instanceof e.Document)n=t;else{if(!(t instanceof HTMLElement))throw new Error("unserializable object");n=e.Document.fromHTML(t.innerHTML)}return n.toSerializableDocument().toJSONString()},"text/html":function(s){var a,u,c,l,h,p,d,f,g,m,y,v,b,A,C,w,x;if(s instanceof e.Document)l=e.DocumentView.render(s);else{if(!(s instanceof HTMLElement))throw new Error("unserializable object");l=s.cloneNode(!0)}for(A=l.querySelectorAll(r),h=0,g=A.length;g>h;h++)c=A[h],c.parentNode.removeChild(c);for(p=0,m=i.length;m>p;p++)for(a=i[p],C=l.querySelectorAll("["+a+"]"),d=0,y=C.length;y>d;d++)c=C[d],c.removeAttribute(a);for(w=l.querySelectorAll(o),f=0,v=w.length;v>f;f++){c=w[f];try{u=JSON.parse(c.getAttribute(n)),c.removeAttribute(n);for(b in u)x=u[b],c.setAttribute(b,x)}catch(E){}}return l.innerHTML.replace(t,"")}},deserializers:{"application/json":function(t){return e.Document.fromJSONString(t)},"text/html":function(t){return e.Document.fromHTML(t)}},serializeToContentType:function(t,n){var o;if(o=e.serializers[n])return o(t);throw new Error("unknown content type: "+n)},deserializeFromContentType:function(t,n){var o;if(o=e.deserializers[n])return o(t);throw new Error("unknown content type: "+n)}})}.call(this),function(){var t,n;n=e.makeFragment,t=e.config.lang,e.config.toolbar={content:n('<div class="button_row">\n  <span class="button_group text_tools">\n    <button type="button" class="icon bold" data-trix-attribute="bold" data-trix-key="b" title="'+t.bold+'" tabindex="-1">'+t.bold+'</button>\n    <button type="button" class="icon italic" data-trix-attribute="italic" data-trix-key="i" title="'+t.italic+'" tabindex="-1">'+t.italic+'</button>\n    <button type="button" class="icon strike" data-trix-attribute="strike" title="'+t.strike+'" tabindex="-1">'+t.strike+'</button>\n    <button type="button" class="icon link" data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="'+t.link+'" tabindex="-1">'+t.link+'</button>\n  </span>\n\n  <span class="button_group block_tools">\n    <button type="button" class="icon heading-1" data-trix-attribute="heading1" title="'+t.heading1+'" tabindex="-1">'+t.heading1+'</button>\n    <button type="button" class="icon quote" data-trix-attribute="quote" title="'+t.quote+'" tabindex="-1">'+t.quote+'</button>\n    <button type="button" class="icon code" data-trix-attribute="code" title="'+t.code+'" tabindex="-1">'+t.code+'</button>\n    <button type="button" class="icon list bullets" data-trix-attribute="bullet" title="'+t.bullets+'" tabindex="-1">'+t.bullets+'</button>\n    <button type="button" class="icon list numbers" data-trix-attribute="number" title="'+t.numbers+'" tabindex="-1">'+t.numbers+'</button>\n    <button type="button" class="icon nesting-level decrease" data-trix-action="decreaseNestingLevel" title="'+t.outdent+'" tabindex="-1">'+t.outdent+'</button>\n    <button type="button" class="icon nesting-level increase" data-trix-action="increaseNestingLevel" title="'+t.indent+'" tabindex="-1">'+t.indent+'</button>\n  </span>\n\n  <span class="button_group history_tools">\n    <button type="button" class="icon undo" data-trix-action="undo" data-trix-key="z" title="'+t.undo+'" tabindex="-1">'+t.undo+'</button>\n    <button type="button" class="icon redo" data-trix-action="redo" data-trix-key="shift+z" title="'+t.redo+'" tabindex="-1">'+t.redo+'</button>\n  </span>\n</div>\n\n<div class="dialogs">\n  <div class="dialog link_dialog" data-trix-attribute="href" data-trix-dialog="href">\n    <div class="link_url_fields">\n      <input type="url" required name="href" placeholder="'+t.urlPlaceholder+'">\n      <div class="button_group">\n        <input type="button" value="'+t.link+'" data-trix-method="setAttribute">\n        <input type="button" value="'+t.unlink+'" data-trix-method="removeAttribute">\n      </div>\n    </div>\n  </div>\n</div>')}}.call(this),function(){e.config.undoInterval=5e3}.call(this),function(){}.call(this),function(){var t;t=e.cloneFragment,e.registerElement("trix-toolbar",{defaultCSS:"%t {\n  white-space: nowrap;\n}\n\n%t .dialog {\n  display: none;\n}\n\n%t .dialog.active {\n  display: block;\n}\n\n%t .dialog input.validate:invalid {\n  background-color: #ffdddd;\n}\n\n%t[native] {\n  display: none;\n}",createdCallback:function(){return""===this.innerHTML?this.appendChild(t(e.config.toolbar.content)):void 0}})}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty,o=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};e.ObjectView=function(n){function i(t,e){this.object=t,this.options=null!=e?e:{},this.childViews=[],this.rootView=this}return t(i,n),i.prototype.getNodes=function(){var t,e,n,o,i;for(null==this.nodes&&(this.nodes=this.createNodes()),o=this.nodes,i=[],t=0,e=o.length;e>t;t++)n=o[t],i.push(n.cloneNode(!0));return i},i.prototype.invalidate=function(){var t;return this.nodes=null,null!=(t=this.parentView)?t.invalidate():void 0},i.prototype.invalidateViewForObject=function(t){var e;return null!=(e=this.findViewForObject(t))?e.invalidate():void 0},i.prototype.findOrCreateCachedChildView=function(t,e){var n;return(n=this.getCachedViewForObject(e))?this.recordChildView(n):(n=this.createChildView.apply(this,arguments),this.cacheViewForObject(n,e)),n},i.prototype.createChildView=function(t,n,o){var i;return null==o&&(o={}),n instanceof e.ObjectGroup&&(o.viewClass=t,t=e.ObjectGroupView),i=new t(n,o),this.recordChildView(i)},i.prototype.recordChildView=function(t){return t.parentView=this,t.rootView=this.rootView,o.call(this.childViews,t)<0&&this.childViews.push(t),t},i.prototype.getAllChildViews=function(){var t,e,n,o,i;for(i=[],o=this.childViews,e=0,n=o.length;n>e;e++)t=o[e],i.push(t),i=i.concat(t.getAllChildViews());return i},i.prototype.findElement=function(){return this.findElementForObject(this.object)},i.prototype.findElementForObject=function(t){var e;return(e=null!=t?t.id:void 0)?this.rootView.element.querySelector("[data-trix-id='"+e+"']"):void 0},i.prototype.findViewForObject=function(t){var e,n,o,i;for(o=this.getAllChildViews(),e=0,n=o.length;n>e;e++)if(i=o[e],i.object===t)return i},i.prototype.getViewCache=function(){return this.rootView!==this?this.rootView.getViewCache():this.isViewCachingEnabled()?null!=this.viewCache?this.viewCache:this.viewCache={}:void 0},i.prototype.isViewCachingEnabled=function(){return this.shouldCacheViews!==!1},i.prototype.enableViewCaching=function(){return this.shouldCacheViews=!0},i.prototype.disableViewCaching=function(){return this.shouldCacheViews=!1},i.prototype.getCachedViewForObject=function(t){var e;return null!=(e=this.getViewCache())?e[t.getCacheKey()]:void 0},i.prototype.cacheViewForObject=function(t,e){var n;return null!=(n=this.getViewCache())?n[e.getCacheKey()]=t:void 0},i.prototype.garbageCollectCachedViews=function(){var t,e,n,i,r,s;if(t=this.getViewCache()){s=this.getAllChildViews().concat(this),n=function(){var t,e,n;for(n=[],t=0,e=s.length;e>t;t++)r=s[t],n.push(r.object.getCacheKey());return n}(),i=[];for(e in t)o.call(n,e)<0&&i.push(delete t[e]);return i}},i}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.ObjectGroupView=function(e){function n(){n.__super__.constructor.apply(this,arguments),this.objectGroup=this.object,this.viewClass=this.options.viewClass,delete this.options.viewClass}return t(n,e),n.prototype.getChildViews=function(){var t,e,n,o;if(!this.childViews.length)for(o=this.objectGroup.getObjects(),t=0,e=o.length;e>t;t++)n=o[t],this.findOrCreateCachedChildView(this.viewClass,n,this.options);return this.childViews},n.prototype.createNodes=function(){var t,e,n,o,i,r,s,a,u;for(t=this.createContainerElement(),s=this.getChildViews(),e=0,o=s.length;o>e;e++)for(u=s[e],a=u.getNodes(),n=0,i=a.length;i>n;n++)r=a[n],t.appendChild(r);return[t]},n.prototype.createContainerElement=function(t){return null==t&&(t=this.objectGroup.getDepth()),this.getChildViews()[0].createContainerElement(t)},n}(e.ObjectView)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Controller=function(e){function n(){return n.__super__.constructor.apply(this,arguments)}return t(n,e),n}(e.BasicObject)}.call(this),function(){var t,n,o,i,r,s,a=function(t,e){return function(){return t.apply(e,arguments)}},u=function(t,e){function n(){this.constructor=t}for(var o in e)c.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},c={}.hasOwnProperty,l=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.findClosestElementFromNode,o=e.nodeIsEmptyTextNode,n=e.nodeIsBlockStartComment,i=e.normalizeSpaces,r=e.summarizeStringChange,s=e.tagName,e.MutationObserver=function(e){function c(t){this.element=t,this.didMutate=a(this.didMutate,this),this.observer=new window.MutationObserver(this.didMutate),this.start()}var h,p,d,f;return u(c,e),p="data-trix-mutable",d="["+p+"]",f={attributes:!0,childList:!0,characterData:!0,characterDataOldValue:!0,subtree:!0},c.prototype.start=function(){return this.reset(),this.observer.observe(this.element,f)},c.prototype.stop=function(){return this.observer.disconnect()},c.prototype.didMutate=function(t){var e,n;return(e=this.mutations).push.apply(e,this.findSignificantMutations(t)),this.mutations.length?(null!=(n=this.delegate)&&"function"==typeof n.elementDidMutate&&n.elementDidMutate(this.getMutationSummary()),this.reset()):void 0},c.prototype.reset=function(){return this.mutations=[]},c.prototype.findSignificantMutations=function(t){var e,n,o,i;for(i=[],e=0,n=t.length;n>e;e++)o=t[e],this.mutationIsSignificant(o)&&i.push(o);return i},c.prototype.mutationIsSignificant=function(t){var e,n,o,i;for(i=this.nodesModifiedByMutation(t),e=0,n=i.length;n>e;e++)if(o=i[e],this.nodeIsSignificant(o))return!0;return!1},c.prototype.nodeIsSignificant=function(t){return t!==this.element&&!this.nodeIsMutable(t)&&!o(t)},c.prototype.nodeIsMutable=function(e){return t(e,{matchingSelector:d})},c.prototype.nodesModifiedByMutation=function(t){var e;switch(e=[],t.type){case"attributes":t.attributeName!==p&&e.push(t.target);break;case"characterData":e.push(t.target.parentNode),e.push(t.target);break;case"childList":e.push.apply(e,t.addedNodes),e.push.apply(e,t.removedNodes)}return e},c.prototype.getMutationSummary=function(){return this.getTextMutationSummary()},c.prototype.getTextMutationSummary=function(){var t,e,n,o,i,r,s,a,u,c,h;for(a=this.getTextChangesFromCharacterData(),n=a.additions,i=a.deletions,h=this.getTextChangesFromChildList(),u=h.additions,r=0,s=u.length;s>r;r++)e=u[r],l.call(n,e)<0&&n.push(e);return i.push.apply(i,h.deletions),c={},(t=n.join(""))&&(c.textAdded=t),(o=i.join(""))&&(c.textDeleted=o),c},c.prototype.getMutationsByType=function(t){var e,n,o,i,r;for(i=this.mutations,r=[],e=0,n=i.length;n>e;e++)o=i[e],o.type===t&&r.push(o);return r},c.prototype.getTextChangesFromChildList=function(){var t,e,o,r,s,a,u,c,l,p,d;for(t=[],u=[],a=this.getMutationsByType("childList"),e=0,r=a.length;r>e;e++)s=a[e],t.push.apply(t,s.addedNodes),u.push.apply(u,s.removedNodes);return c=0===t.length&&1===u.length&&n(u[0]),c?(p=[],d=["\n"]):(p=h(t),d=h(u)),{additions:function(){var t,e,n;for(n=[],o=t=0,e=p.length;e>t;o=++t)l=p[o],l!==d[o]&&n.push(i(l));return n}(),deletions:function(){var t,e,n;for(n=[],o=t=0,e=d.length;e>t;o=++t)l=d[o],l!==p[o]&&n.push(i(l));return n}()}},c.prototype.getTextChangesFromCharacterData=function(){var t,e,n,o,s,a,u,c;return e=this.getMutationsByType("characterData"),e.length&&(c=e[0],n=e[e.length-1],s=i(c.oldValue),o=i(n.target.data),a=r(s,o),t=a.added,u=a.removed),{additions:t?[t]:[],deletions:u?[u]:[]}},h=function(t){var e,n,o,i;for(null==t&&(t=[]),i=[],e=0,n=t.length;n>e;e++)switch(o=t[e],o.nodeType){case Node.TEXT_NODE:i.push(o.data);break;case Node.ELEMENT_NODE:"br"===s(o)?i.push("\n"):i.push.apply(i,h(o.childNodes))}return i},c}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.FileVerificationOperation=function(e){function n(t){this.file=t}return t(n,e),n.prototype.perform=function(t){var e;return e=new FileReader,e.onerror=function(){return t(!1)},e.onload=function(n){return function(){e.onerror=null;try{e.abort()}catch(o){}return t(!0,n.file)}}(this),e.readAsArrayBuffer(this.file)},n}(e.Operation)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.CompositionInput=function(e){function n(t){var e;this.inputController=t,e=this.inputController,this.responder=e.responder,this.delegate=e.delegate,this.inputSummary=e.inputSummary,this.data={}}return t(n,e),n.prototype.start=function(t){var e,n;return this.data.start=t,"keypress"===this.inputSummary.eventName&&this.inputSummary.textAdded&&null!=(e=this.responder)&&e.deleteInDirection("left"),this.selectionIsExpanded()||(this.insertPlaceholder(),this.requestRender()),this.range=null!=(n=this.responder)?n.getSelectedRange():void 0},n.prototype.update=function(t){var e;return this.data.update=t,(e=this.selectPlaceholder())?(this.forgetPlaceholder(),this.range=e):void 0},n.prototype.end=function(t){var e,n,o,i;return this.data.end=t,this.forgetPlaceholder(),this.canApplyToDocument()?(this.setInputSummary({preferDocument:!0}),null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),null!=(n=this.responder)&&n.setSelectedRange(this.range),null!=(o=this.responder)&&o.insertString(this.data.end),null!=(i=this.responder)?i.setSelectedRange(this.range[0]+this.data.end.length):void 0):null!=this.data.start||null!=this.data.update?(this.requestReparse(),this.inputController.reset()):void 0},n.prototype.getEndData=function(){return this.data.end},n.prototype.isEnded=function(){return null!=this.getEndData()},n.prototype.canApplyToDocument=function(){var t,e;return 0===(null!=(t=this.data.start)?t.length:void 0)&&(null!=(e=this.data.end)?e.length:void 0)>0&&null!=this.range},n.proxyMethod("inputController.setInputSummary"),n.proxyMethod("inputController.requestRender"),n.proxyMethod("inputController.requestReparse"),n.proxyMethod("responder?.selectionIsExpanded"),n.proxyMethod("responder?.insertPlaceholder"),n.proxyMethod("responder?.selectPlaceholder"),n.proxyMethod("responder?.forgetPlaceholder"),n}(e.BasicObject)}.call(this),function(){var t,n,o,i,r,s,a,u,c,l,h,p,d,f=function(t,e){function n(){this.constructor=t}for(var o in e)g.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},g={}.hasOwnProperty,m=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};i=e.handleEvent,c=e.makeElement,r=e.innerElementIsActive,l=e.objectsAreEqual,p=e.tagName,e.InputController=function(p){function d(t){var n;this.element=t,this.resetInputSummary(),this.mutationObserver=new e.MutationObserver(this.element),this.mutationObserver.delegate=this;for(n in this.events)i(n,{onElement:this.element,withCallback:this.handlerFor(n),inPhase:"capturing"})}var g;return f(d,p),g=0,d.keyNames={8:"backspace",9:"tab",13:"return",37:"left",39:"right",46:"delete",68:"d",72:"h",79:"o"},d.prototype.handlerFor=function(t){return function(e){return function(n){return e.handleInput(function(){return r(this.element)?void 0:(this.eventName=t,this.events[t].call(this,n))})}}(this)},d.prototype.setInputSummary=function(t){var e,n;null==t&&(t={}),this.inputSummary.eventName=this.eventName;for(e in t)n=t[e],this.inputSummary[e]=n;return this.inputSummary},d.prototype.resetInputSummary=function(){return this.inputSummary={}},d.prototype.reset=function(){return this.resetInputSummary(),e.selectionChangeObserver.reset()},d.prototype.editorWillSyncDocumentView=function(){return this.mutationObserver.stop()},d.prototype.editorDidSyncDocumentView=function(){return this.mutationObserver.start()},d.prototype.requestRender=function(){var t;return null!=(t=this.delegate)&&"function"==typeof t.inputControllerDidRequestRender?t.inputControllerDidRequestRender():void 0},d.prototype.requestReparse=function(){var t;return null!=(t=this.delegate)&&"function"==typeof t.inputControllerDidRequestReparse&&t.inputControllerDidRequestReparse(),this.requestRender()},d.prototype.elementDidMutate=function(t){var e;return this.isComposing()?null!=(e=this.delegate)&&"function"==typeof e.inputControllerDidAllowUnhandledInput?e.inputControllerDidAllowUnhandledInput():void 0:this.handleInput(function(){return this.mutationIsSignificant(t)&&(this.mutationIsExpected(t)?this.requestRender():this.requestReparse()),this.reset()})},d.prototype.mutationIsExpected=function(t){var e,n,o,i,r,s,a,u,c,l;return a=t.textAdded,u=t.textDeleted,this.inputSummary.preferDocument?!0:(e=null!=a?a===this.inputSummary.textAdded:!this.inputSummary.textAdded,n=null!=u?this.inputSummary.didDelete:!this.inputSummary.didDelete,c=("\n"===a||" \n"===a)&&!e,l="\n"===u&&!n,s=c&&!l||l&&!c,s&&(i=this.getSelectedRange())&&(o=c?a.replace(/\n$/,"").length||-1:1,null!=(r=this.responder)?r.positionIsBlockBreak(i[1]+o):void 0)?!0:e&&n)},d.prototype.mutationIsSignificant=function(t){var e,n,o;return o=Object.keys(t).length>0,e=""===(null!=(n=this.compositionInput)?n.getEndData():void 0),o||!e},d.prototype.attachFiles=function(t){var n,o;return o=function(){var o,i,r;for(r=[],o=0,i=t.length;i>o;o++)n=t[o],r.push(new e.FileVerificationOperation(n));return r}(),Promise.all(o).then(function(t){return function(e){return t.handleInput(function(){var t,n;return null!=(t=this.delegate)&&t.inputControllerWillAttachFiles(),null!=(n=this.responder)&&n.insertFiles(e),this.requestRender()})}}(this))},d.prototype.events={keydown:function(t){var n,o,i,r,a,u,c,l,h;if(this.isComposing()||this.resetInputSummary(),r=this.constructor.keyNames[t.keyCode]){for(o=this.keys,l=["ctrl","alt","shift","meta"],i=0,u=l.length;u>i;i++)c=l[i],t[c+"Key"]&&("ctrl"===c&&(c="control"),o=null!=o?o[c]:void 0);null!=(null!=o?o[r]:void 0)&&(this.setInputSummary({keyName:r}),e.selectionChangeObserver.reset(),o[r].call(this,t))}return s(t)&&(n=String.fromCharCode(t.keyCode).toLowerCase())&&(a=function(){var e,n,o,i;for(o=["alt","shift"],i=[],e=0,n=o.length;n>e;e++)c=o[e],t[c+"Key"]&&i.push(c);return i}(),a.push(n),null!=(h=this.delegate)?h.inputControllerDidReceiveKeyboardCommand(a):void 0)?t.preventDefault():void 0},keypress:function(t){var e,n,o;if(null==this.inputSummary.eventName&&(!t.metaKey&&!t.ctrlKey||t.altKey)&&!u(t)&&!a(t))return null===t.which?e=String.fromCharCode(t.keyCode):0!==t.which&&0!==t.charCode&&(e=String.fromCharCode(t.charCode)),null!=e?(null!=(n=this.delegate)&&n.inputControllerWillPerformTyping(),null!=(o=this.responder)&&o.insertString(e),this.setInputSummary({textAdded:e,didDelete:this.selectionIsExpanded()})):void 0},textInput:function(t){var e,n,o,i;return e=t.data,i=this.inputSummary.textAdded,i&&i!==e&&i.toUpperCase()===e?(n=this.getSelectedRange(),this.setSelectedRange([n[0],n[1]+i.length]),null!=(o=this.responder)&&o.insertString(e),this.setInputSummary({textAdded:e}),this.setSelectedRange(n)):void 0},dragenter:function(t){return t.preventDefault()},dragstart:function(t){var e,n;return n=t.target,this.serializeSelectionToDataTransfer(t.dataTransfer),this.draggedRange=this.getSelectedRange(),null!=(e=this.delegate)&&"function"==typeof e.inputControllerDidStartDrag?e.inputControllerDidStartDrag():void 0},dragover:function(t){var e,n;return!this.draggedRange&&!this.canAcceptDataTransfer(t.dataTransfer)||(t.preventDefault(),e={x:t.clientX,y:t.clientY},l(e,this.draggingPoint))?void 0:(this.draggingPoint=e,null!=(n=this.delegate)&&"function"==typeof n.inputControllerDidReceiveDragOverPoint?n.inputControllerDidReceiveDragOverPoint(this.draggingPoint):void 0)},dragend:function(){var t;return null!=(t=this.delegate)&&"function"==typeof t.inputControllerDidCancelDrag&&t.inputControllerDidCancelDrag(),this.draggedRange=null,this.draggingPoint=null},drop:function(t){var n,o,i,r,s,a,u,c,l;return t.preventDefault(),i=null!=(s=t.dataTransfer)?s.files:void 0,r={x:t.clientX,y:t.clientY},null!=(a=this.responder)&&a.setLocationRangeFromPointRange(r),(null!=i?i.length:void 0)?this.attachFiles(i):this.draggedRange?(null!=(u=this.delegate)&&u.inputControllerWillMoveText(),null!=(c=this.responder)&&c.moveTextFromRange(this.draggedRange),this.draggedRange=null,this.requestRender()):(o=t.dataTransfer.getData("application/x-trix-document"))&&(n=e.Document.fromJSONString(o),null!=(l=this.responder)&&l.insertDocument(n),this.requestRender()),this.draggedRange=null,this.draggingPoint=null},cut:function(t){var e,n;return(null!=(e=this.responder)?e.selectionIsExpanded():void 0)&&(this.serializeSelectionToDataTransfer(t.clipboardData)&&t.preventDefault(),null!=(n=this.delegate)&&n.inputControllerWillCutText(),this.deleteInDirection("backward"),t.defaultPrevented)?this.requestRender():void 0},copy:function(t){var e;return(null!=(e=this.responder)?e.selectionIsExpanded():void 0)&&this.serializeSelectionToDataTransfer(t.clipboardData)?t.preventDefault():void 0},paste:function(n){var i,r,s,a,u,c,l,p,d,f,y,v,b,A,C,w,x,E,S,k,R,L;return u=null!=(l=n.clipboardData)?l:n.testClipboardData,c={paste:u},null==u||h(n)?void this.getPastedHTMLUsingHiddenElement(function(t){return function(e){var n,o,i;return c.html=e,null!=(n=t.delegate)&&n.inputControllerWillPasteText(c),null!=(o=t.responder)&&o.insertHTML(e),t.requestRender(),null!=(i=t.delegate)?i.inputControllerDidPaste(c):void 0}}(this)):((s=u.getData("URL"))?(L=u.getData("public.url-name")||s,c.string=L,this.setInputSummary({textAdded:L,didDelete:this.selectionIsExpanded()}),null!=(p=this.delegate)&&p.inputControllerWillPasteText(c),null!=(A=this.responder)&&A.insertText(e.Text.textForStringWithAttributes(L,{href:s})),this.requestRender(),null!=(C=this.delegate)&&C.inputControllerDidPaste(c)):t(u)?(L=u.getData("text/plain"),c.string=L,this.setInputSummary({textAdded:L,didDelete:this.selectionIsExpanded()}),null!=(w=this.delegate)&&w.inputControllerWillPasteText(c),null!=(x=this.responder)&&x.insertString(L),this.requestRender(),null!=(E=this.delegate)&&E.inputControllerDidPaste(c)):(a=u.getData("text/html"))?(c.html=a,null!=(S=this.delegate)&&S.inputControllerWillPasteText(c),null!=(k=this.responder)&&k.insertHTML(a),this.requestRender(),null!=(R=this.delegate)&&R.inputControllerDidPaste(c)):m.call(u.types,"Files")>=0&&(r=null!=(d=u.items)&&null!=(f=d[0])&&"function"==typeof f.getAsFile?f.getAsFile():void 0)&&(!r.name&&(i=o(r))&&(r.name="pasted-file-"+ ++g+"."+i),c.file=r,null!=(y=this.delegate)&&y.inputControllerWillAttachFiles(),null!=(v=this.responder)&&v.insertFile(r),this.requestRender(),null!=(b=this.delegate)&&b.inputControllerDidPaste(c)),n.preventDefault())},compositionstart:function(t){return this.getCompositionInput().start(t.data)},compositionupdate:function(t){return this.getCompositionInput().update(t.data)},compositionend:function(t){return this.getCompositionInput().end(t.data)},input:function(t){return t.stopPropagation()}},d.prototype.keys={backspace:function(t){var e;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),this.deleteInDirection("backward",t)},"delete":function(t){var e;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),this.deleteInDirection("forward",t)},"return":function(){var t,e;return this.setInputSummary({preferDocument:!0}),null!=(t=this.delegate)&&t.inputControllerWillPerformTyping(),null!=(e=this.responder)?e.insertLineBreak():void 0},tab:function(t){var e,n;return(null!=(e=this.responder)?e.canIncreaseNestingLevel():void 0)?(null!=(n=this.responder)&&n.increaseNestingLevel(),this.requestRender(),t.preventDefault()):void 0},left:function(t){var e;return this.selectionIsInCursorTarget()?(t.preventDefault(),null!=(e=this.responder)?e.moveCursorInDirection("backward"):void 0):void 0},right:function(t){var e;return this.selectionIsInCursorTarget()?(t.preventDefault(),null!=(e=this.responder)?e.moveCursorInDirection("forward"):void 0):void 0},control:{d:function(t){var e;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),this.deleteInDirection("forward",t)},h:function(t){var e;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),this.deleteInDirection("backward",t)},o:function(t){var e,n;return t.preventDefault(),null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),null!=(n=this.responder)&&n.insertString("\n",{updatePosition:!1}),this.requestRender()}},shift:{"return":function(t){var e,n;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),null!=(n=this.responder)&&n.insertString("\n"),this.requestRender(),t.preventDefault()},tab:function(t){var e,n;return(null!=(e=this.responder)?e.canDecreaseNestingLevel():void 0)?(null!=(n=this.responder)&&n.decreaseNestingLevel(),this.requestRender(),t.preventDefault()):void 0},left:function(t){return this.selectionIsInCursorTarget()?(t.preventDefault(),this.expandSelectionInDirection("backward")):void 0},right:function(t){return this.selectionIsInCursorTarget()?(t.preventDefault(),this.expandSelectionInDirection("forward")):void 0}},alt:{backspace:function(){var t;return this.setInputSummary({preferDocument:!1}),null!=(t=this.delegate)?t.inputControllerWillPerformTyping():void 0}},meta:{backspace:function(){var t;return this.setInputSummary({preferDocument:!1}),null!=(t=this.delegate)?t.inputControllerWillPerformTyping():void 0}}},d.prototype.handleInput=function(t){var e,n;try{return null!=(e=this.delegate)&&e.inputControllerWillHandleInput(),t.call(this)}finally{null!=(n=this.delegate)&&n.inputControllerDidHandleInput()}},d.prototype.getCompositionInput=function(){return this.isComposing()?this.compositionInput:this.compositionInput=new e.CompositionInput(this)},d.prototype.isComposing=function(){return null!=this.compositionInput&&!this.compositionInput.isEnded()},d.prototype.deleteInDirection=function(t,e){var n;return(null!=(n=this.responder)?n.deleteInDirection(t):void 0)!==!1?this.setInputSummary({didDelete:!0}):e?(e.preventDefault(),this.requestRender()):void 0},d.prototype.serializeSelectionToDataTransfer=function(t){var o,i;if(n(t))return o=null!=(i=this.responder)?i.getSelectedDocument().toSerializableDocument():void 0,t.setData("application/x-trix-document",JSON.stringify(o)),t.setData("text/html",e.DocumentView.render(o).innerHTML),t.setData("text/plain",o.toString().replace(/\n$/,"")),!0},d.prototype.canAcceptDataTransfer=function(t){var e,n,o,i,r,s;for(s={},i=null!=(o=null!=t?t.types:void 0)?o:[],e=0,n=i.length;n>e;e++)r=i[e],s[r]=!0;return s.Files||s["application/x-trix-document"]||s["text/html"]||s["text/plain"]},d.prototype.getPastedHTMLUsingHiddenElement=function(t){var e,n,o;return n=this.getSelectedRange(),o={position:"absolute",left:window.pageXOffset+"px",top:window.pageYOffset+"px",opacity:0},e=c({style:o,tagName:"div",editable:!0}),document.body.appendChild(e),e.focus(),requestAnimationFrame(function(o){return function(){var i;return i=e.innerHTML,document.body.removeChild(e),o.setSelectedRange(n),t(i)}}(this))},d.proxyMethod("responder?.getSelectedRange"),d.proxyMethod("responder?.setSelectedRange"),d.proxyMethod("responder?.expandSelectionInDirection"),d.proxyMethod("responder?.selectionIsInCursorTarget"),d.proxyMethod("responder?.selectionIsExpanded"),d
}(e.BasicObject),o=function(t){var e,n;return null!=(e=t.type)&&null!=(n=e.match(/\/(\w+)$/))?n[1]:void 0},u=function(t){return t.metaKey&&t.altKey&&!t.shiftKey&&94===t.keyCode},a=function(t){return t.metaKey&&t.altKey&&t.shiftKey&&9674===t.keyCode},s=function(t){return/Mac|^iP/.test(navigator.platform)?t.metaKey:t.ctrlKey},h=function(t){var e,n,o,i;return(i=t.clipboardData)?m.call(i.types,"text/html")>=0?o=i.types.some(function(t){var e,n;return e=/^CorePasteboardFlavorType/.test(t),n=/^dyn\./.test(t)&&i.getData(t),e||n}):(e=m.call(i.types,"com.apple.webarchive")>=0,n=m.call(i.types,"com.apple.flat-rtfd")>=0,e||n):void 0},t=function(t){var e,n,o;return o=t.getData("text/plain"),n=t.getData("text/html"),o&&n?(e=c("div"),e.innerHTML=n,e.textContent===o?!e.querySelector(":not(meta)"):void 0):null!=o?o.length:void 0},d={"application/x-trix-feature-detection":"test"},n=function(t){var e,n;if(null!=(null!=t?t.setData:void 0)){for(e in d)if(n=d[e],!function(){try{return t.setData(e,n),t.getData(e)===n}catch(o){}}())return;return!0}}}.call(this),function(){var t,n,o,i,r,s,a=function(t,e){return function(){return t.apply(e,arguments)}},u=function(t,e){function n(){this.constructor=t}for(var o in e)c.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},c={}.hasOwnProperty;n=e.handleEvent,r=e.makeElement,s=e.tagName,o=e.InputController.keyNames,i=e.config.lang,t=e.config.css.classNames,e.AttachmentEditorController=function(e){function c(t,e,n){this.attachmentPiece=t,this.element=e,this.container=n,this.didBlurCaption=a(this.didBlurCaption,this),this.didChangeCaption=a(this.didChangeCaption,this),this.didInputCaption=a(this.didInputCaption,this),this.didKeyDownCaption=a(this.didKeyDownCaption,this),this.didClickCaption=a(this.didClickCaption,this),this.didClickRemoveButton=a(this.didClickRemoveButton,this),this.attachment=this.attachmentPiece.attachment,"a"===s(this.element)&&(this.element=this.element.firstChild),this.install()}var l;return u(c,e),l=function(t){return function(){var e;return e=t.apply(this,arguments),e["do"](),null==this.undos&&(this.undos=[]),this.undos.push(e.undo)}},c.prototype.install=function(){return this.makeElementMutable(),this.attachment.isPreviewable()&&this.makeCaptionEditable(),this.addRemoveButton()},c.prototype.uninstall=function(){var t,e;for(this.savePendingCaption();e=this.undos.pop();)e();return null!=(t=this.delegate)?t.didUninstallAttachmentEditor(this):void 0},c.prototype.savePendingCaption=function(){var t,e,n;return null!=this.pendingCaption?(t=this.pendingCaption,this.pendingCaption=null,t?null!=(e=this.delegate)&&"function"==typeof e.attachmentEditorDidRequestUpdatingAttributesForAttachment?e.attachmentEditorDidRequestUpdatingAttributesForAttachment({caption:t},this.attachment):void 0:null!=(n=this.delegate)&&"function"==typeof n.attachmentEditorDidRequestRemovingAttributeForAttachment?n.attachmentEditorDidRequestRemovingAttributeForAttachment("caption",this.attachment):void 0):void 0},c.prototype.makeElementMutable=l(function(){return{"do":function(t){return function(){return t.element.dataset.trixMutable=!0}}(this),undo:function(t){return function(){return delete t.element.dataset.trixMutable}}(this)}}),c.prototype.makeCaptionEditable=l(function(){var t,e;return t=this.element.querySelector("figcaption"),e=null,{"do":function(o){return function(){return e=n("click",{onElement:t,withCallback:o.didClickCaption,inPhase:"capturing"})}}(this),undo:function(){return function(){return e.destroy()}}(this)}}),c.prototype.addRemoveButton=l(function(){var e;return e=r({tagName:"button",textContent:i.remove,className:t.attachment.removeButton,attributes:{type:"button",title:i.remove},data:{trixMutable:!0}}),n("click",{onElement:e,withCallback:this.didClickRemoveButton}),{"do":function(t){return function(){return t.element.appendChild(e)}}(this),undo:function(t){return function(){return t.element.removeChild(e)}}(this)}}),c.prototype.editCaption=l(function(){var e,o,s,a,u;return a=r({tagName:"textarea",className:t.attachment.captionEditor,attributes:{placeholder:i.captionPlaceholder}}),a.value=this.attachmentPiece.getCaption(),u=a.cloneNode(),u.classList.add("trix-autoresize-clone"),e=function(){return u.value=a.value,a.style.height=u.scrollHeight+"px"},n("keydown",{onElement:a,withCallback:this.didKeyDownCaption}),n("input",{onElement:a,withCallback:this.didInputCaption}),n("change",{onElement:a,withCallback:this.didChangeCaption}),n("blur",{onElement:a,withCallback:this.didBlurCaption}),s=this.element.querySelector("figcaption"),o=s.cloneNode(),{"do":function(){return s.style.display="none",o.appendChild(a),o.appendChild(u),o.classList.add(t.attachment.editingCaption),s.parentElement.insertBefore(o,s),e(),a.focus()},undo:function(){return o.parentNode.removeChild(o),s.style.display=null}}}),c.prototype.didClickRemoveButton=function(t){var e;return t.preventDefault(),t.stopPropagation(),null!=(e=this.delegate)?e.attachmentEditorDidRequestRemovalOfAttachment(this.attachment):void 0},c.prototype.didClickCaption=function(t){return t.preventDefault(),this.editCaption()},c.prototype.didKeyDownCaption=function(t){var e;return"return"===o[t.keyCode]?(t.preventDefault(),this.savePendingCaption(),null!=(e=this.delegate)&&"function"==typeof e.attachmentEditorDidRequestDeselectingAttachment?e.attachmentEditorDidRequestDeselectingAttachment(this.attachment):void 0):void 0},c.prototype.didInputCaption=function(t){return this.pendingCaption=t.target.value.replace(/\s/g," ").trim()},c.prototype.didChangeCaption=function(){return this.savePendingCaption()},c.prototype.didBlurCaption=function(){return this.savePendingCaption()},c}(e.BasicObject)}.call(this),function(){var t,n,o,i=function(t,e){function n(){this.constructor=t}for(var o in e)r.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},r={}.hasOwnProperty;o=e.makeElement,t=e.config.css.classNames,e.AttachmentView=function(r){function s(){s.__super__.constructor.apply(this,arguments),this.attachment=this.object,this.attachment.uploadProgressDelegate=this,this.attachmentPiece=this.options.piece}var a;return i(s,r),s.attachmentSelector="[data-trix-attachment]",s.prototype.createContentNodes=function(){return[]},s.prototype.createNodes=function(){var e,n,i,r,s,u,c,l,h,p,d;if(r=o({tagName:"figure",className:this.getClassName()}),this.attachment.hasContent())r.innerHTML=this.attachment.getContent();else for(p=this.createContentNodes(),u=0,l=p.length;l>u;u++)h=p[u],r.appendChild(h);r.appendChild(this.createCaptionElement()),n={trixAttachment:JSON.stringify(this.attachment),trixContentType:this.attachment.getContentType(),trixId:this.attachment.id},e=this.attachmentPiece.getAttributesForAttachment(),e.isEmpty()||(n.trixAttributes=JSON.stringify(e)),this.attachment.isPending()&&(this.progressElement=o({tagName:"progress",attributes:{"class":t.attachment.progressBar,value:this.attachment.getUploadProgress(),max:100},data:{trixMutable:!0,trixStoreKey:["progressElement",this.attachment.id].join("/")}}),r.appendChild(this.progressElement),n.trixSerialize=!1),(s=this.getHref())?(i=o("a",{href:s}),i.appendChild(r)):i=r;for(c in n)d=n[c],i.dataset[c]=d;return i.setAttribute("contenteditable",!1),[a("left"),i,a("right")]},s.prototype.createCaptionElement=function(){var e,n,i,r,s;return n=o({tagName:"figcaption",className:t.attachment.caption}),(e=this.attachmentPiece.getCaption())?(n.classList.add(t.attachment.captionEdited),n.textContent=e):(i=this.attachment.getFilename())&&(n.textContent=i,(r=this.attachment.getFormattedFilesize())&&(n.appendChild(document.createTextNode(" ")),s=o({tagName:"span",className:t.attachment.size,textContent:r}),n.appendChild(s))),n},s.prototype.getClassName=function(){var e,n;return n=[t.attachment.container,""+t.attachment.typePrefix+this.attachment.getType()],(e=this.attachment.getExtension())&&n.push(e),n.join(" ")},s.prototype.getHref=function(){return n(this.attachment.getContent(),"a")?void 0:this.attachment.getHref()},s.prototype.findProgressElement=function(){var t;return null!=(t=this.findElement())?t.querySelector("progress"):void 0},a=function(t){return o({tagName:"span",textContent:e.ZERO_WIDTH_SPACE,data:{trixCursorTarget:t,trixSerialize:!1}})},s.prototype.attachmentDidChangeUploadProgress=function(){var t,e;return e=this.attachment.getUploadProgress(),null!=(t=this.findProgressElement())?t.value=e:void 0},s}(e.ObjectView),n=function(t,e){var n;return n=o("div"),n.innerHTML=null!=t?t:"",n.querySelector(e)}}.call(this),function(){var t,n=function(t,e){function n(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},o={}.hasOwnProperty;t=e.makeElement,e.PreviewableAttachmentView=function(e){function o(){o.__super__.constructor.apply(this,arguments),this.attachment.previewDelegate=this}return n(o,e),o.prototype.createContentNodes=function(){return this.image=t({tagName:"img",attributes:{src:""},data:{trixMutable:!0}}),this.refresh(this.image),[this.image]},o.prototype.refresh=function(t){var e;return null==t&&(t=null!=(e=this.findElement())?e.querySelector("img"):void 0),t?this.updateAttributesForImage(t):void 0},o.prototype.updateAttributesForImage=function(t){var e,n,o,i,r,s;return r=this.attachment.getURL(),n=this.attachment.getPreviewURL(),t.src=n||r,n===r?t.removeAttribute("data-trix-serialized-attributes"):(o=JSON.stringify({src:r}),t.setAttribute("data-trix-serialized-attributes",o)),s=this.attachment.getWidth(),e=this.attachment.getHeight(),null!=s&&(t.width=s),null!=e&&(t.height=e),i=["imageElement",this.attachment.id,t.src,t.width,t.height].join("/"),t.dataset.trixStoreKey=i},o.prototype.attachmentDidChangeAttributes=function(){return this.refresh(this.image),this.refresh()},o}(e.AttachmentView)}.call(this),function(){var t,n,o,i=function(t,e){function n(){this.constructor=t}for(var o in e)r.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},r={}.hasOwnProperty;o=e.makeElement,t=e.findInnerElement,n=e.getTextConfig,e.PieceView=function(r){function s(){var t;s.__super__.constructor.apply(this,arguments),this.piece=this.object,this.attributes=this.piece.getAttributes(),t=this.options,this.textConfig=t.textConfig,this.context=t.context,this.piece.attachment?this.attachment=this.piece.attachment:this.string=this.piece.toString()}var a;return i(s,r),s.prototype.createNodes=function(){var e,n,o,i,r,s;if(s=this.attachment?this.createAttachmentNodes():this.createStringNodes(),e=this.createElement()){for(o=t(e),n=0,i=s.length;i>n;n++)r=s[n],o.appendChild(r);s=[e]}return s},s.prototype.createAttachmentNodes=function(){var t,n;return t=this.attachment.isPreviewable()?e.PreviewableAttachmentView:e.AttachmentView,n=this.createChildView(t,this.piece.attachment,{piece:this.piece}),n.getNodes()},s.prototype.createStringNodes=function(){var t,e,n,i,r,s,a,u,c,l;if(null!=(u=this.textConfig)?u.plaintext:void 0)return[document.createTextNode(this.string)];for(a=[],c=this.string.split("\n"),n=e=0,i=c.length;i>e;n=++e)l=c[n],n>0&&(t=o("br"),a.push(t)),(r=l.length)&&(s=document.createTextNode(this.preserveSpaces(l)),a.push(s));return a},s.prototype.createElement=function(){var t,e,i,r,s,a,u,c;for(r in this.attributes)if((t=n(r))&&(t.tagName&&(s=o(t.tagName),i?(i.appendChild(s),i=s):e=i=s),t.style))if(u){a=t.style;for(r in a)c=a[r],u[r]=c}else u=t.style;if(u){null==e&&(e=o("span"));for(r in u)c=u[r],e.style[r]=c}return e},s.prototype.createContainerElement=function(){var t,e,i,r,s;r=this.attributes;for(i in r)if(s=r[i],(e=n(i))&&e.groupTagName)return t={},t[i]=s,o(e.groupTagName,t)},a=e.NON_BREAKING_SPACE,s.prototype.preserveSpaces=function(t){return this.context.isLast&&(t=t.replace(/\ $/,a)),t=t.replace(/(\S)\ {3}(\S)/g,"$1 "+a+" $2").replace(/\ {2}/g,a+" ").replace(/\ {2}/g," "+a),(this.context.isFirst||this.context.followsWhitespace)&&(t=t.replace(/^\ /,a)),t},s}(e.ObjectView)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.TextView=function(n){function o(){o.__super__.constructor.apply(this,arguments),this.text=this.object,this.textConfig=this.options.textConfig}var i;return t(o,n),o.prototype.createNodes=function(){var t,n,o,r,s,a,u,c,l,h;for(a=[],c=e.ObjectGroup.groupObjects(this.getPieces()),r=c.length-1,o=n=0,s=c.length;s>n;o=++n)u=c[o],t={},0===o&&(t.isFirst=!0),o===r&&(t.isLast=!0),i(l)&&(t.followsWhitespace=!0),h=this.findOrCreateCachedChildView(e.PieceView,u,{textConfig:this.textConfig,context:t}),a.push.apply(a,h.getNodes()),l=u;return a},o.prototype.getPieces=function(){var t,e,n,o,i;for(o=this.text.getPieces(),i=[],t=0,e=o.length;e>t;t++)n=o[t],n.hasAttribute("blockBreak")||i.push(n);return i},i=function(t){return/\s$/.test(null!=t?t.toString():void 0)},o}(e.ObjectView)}.call(this),function(){var t,n,o=function(t,e){function n(){this.constructor=t}for(var o in e)i.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},i={}.hasOwnProperty;n=e.makeElement,t=e.getBlockConfig,e.BlockView=function(i){function r(){r.__super__.constructor.apply(this,arguments),this.block=this.object,this.attributes=this.block.getAttributes()}return o(r,i),r.prototype.createNodes=function(){var o,i,r,s,a,u,c,l,h;if(o=document.createComment("block"),u=[o],this.block.isEmpty()?u.push(n("br")):(l=null!=(c=t(this.block.getLastAttribute()))?c.text:void 0,h=this.findOrCreateCachedChildView(e.TextView,this.block.text,{textConfig:l}),u.push.apply(u,h.getNodes()),this.shouldAddExtraNewlineElement()&&u.push(n("br"))),this.attributes.length)return u;for(i=n(e.config.blockAttributes["default"].tagName),r=0,s=u.length;s>r;r++)a=u[r],i.appendChild(a);return[i]},r.prototype.createContainerElement=function(e){var o,i;return o=this.attributes[e],i=t(o),n(i.tagName)},r.prototype.shouldAddExtraNewlineElement=function(){return/\n\n$/.test(this.block.toString())},r}(e.ObjectView)}.call(this),function(){var t,n,o=function(t,e){function n(){this.constructor=t}for(var o in e)i.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},i={}.hasOwnProperty;t=e.defer,n=e.makeElement,e.DocumentView=function(i){function r(){r.__super__.constructor.apply(this,arguments),this.element=this.options.element,this.elementStore=new e.ElementStore,this.setDocument(this.object)}var s,a,u;return o(r,i),r.render=function(t){var e,o;return e=n("div"),o=new this(t,{element:e}),o.render(),o.sync(),e},r.prototype.setDocument=function(t){return t.isEqualTo(this.document)?void 0:this.document=this.object=t},r.prototype.render=function(){var t,o,i,r,s,a,u;if(this.childViews=[],this.shadowElement=n("div"),!this.document.isEmpty()){for(s=e.ObjectGroup.groupObjects(this.document.getBlocks(),{asTree:!0}),a=[],t=0,o=s.length;o>t;t++)r=s[t],u=this.findOrCreateCachedChildView(e.BlockView,r),a.push(function(){var t,e,n,o;for(n=u.getNodes(),o=[],t=0,e=n.length;e>t;t++)i=n[t],o.push(this.shadowElement.appendChild(i));return o}.call(this));return a}},r.prototype.isSynced=function(){return s(this.shadowElement,this.element)},r.prototype.sync=function(){var t;for(t=this.createDocumentFragmentForSync();this.element.lastChild;)this.element.removeChild(this.element.lastChild);return this.element.appendChild(t),this.didSync()},r.prototype.didSync=function(){return this.elementStore.reset(a(this.element)),t(function(t){return function(){return t.garbageCollectCachedViews()}}(this))},r.prototype.createDocumentFragmentForSync=function(){var t,e,n,o,i,r,s,u,c,l;for(e=document.createDocumentFragment(),u=this.shadowElement.childNodes,n=0,i=u.length;i>n;n++)s=u[n],e.appendChild(s.cloneNode(!0));for(c=a(e),o=0,r=c.length;r>o;o++)t=c[o],(l=this.elementStore.remove(t))&&t.parentNode.replaceChild(l,t);return e},a=function(t){return t.querySelectorAll("[data-trix-store-key]")},s=function(t,e){return u(t.innerHTML)===u(e.innerHTML)},u=function(t){return t.replace(/&nbsp;/g," ")},r}(e.ObjectView)}.call(this),function(){var t,n,o,i,r=function(t,e){return function(){return t.apply(e,arguments)}},s=function(t,e){function n(){this.constructor=t}for(var o in e)a.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},a={}.hasOwnProperty;o=e.handleEvent,i=e.innerElementIsActive,n=e.defer,t=e.AttachmentView.attachmentSelector,e.CompositionController=function(a){function u(n,i){this.element=n,this.composition=i,this.didClickAttachment=r(this.didClickAttachment,this),this.didBlur=r(this.didBlur,this),this.didFocus=r(this.didFocus,this),this.documentView=new e.DocumentView(this.composition.document,{element:this.element}),o("focus",{onElement:this.element,withCallback:this.didFocus}),o("blur",{onElement:this.element,withCallback:this.didBlur}),o("click",{onElement:this.element,matchingSelector:"a[contenteditable=false]",preventDefault:!0}),o("mousedown",{onElement:this.element,matchingSelector:t,withCallback:this.didClickAttachment}),o("click",{onElement:this.element,matchingSelector:"a"+t,preventDefault:!0})}return s(u,a),u.prototype.didFocus=function(){var t,e,n;return t=function(t){return function(){var e;return t.focused?void 0:(t.focused=!0,null!=(e=t.delegate)&&"function"==typeof e.compositionControllerDidFocus?e.compositionControllerDidFocus():void 0)}}(this),null!=(e=null!=(n=this.blurPromise)?n.then(t):void 0)?e:t()},u.prototype.didBlur=function(){return this.blurPromise=new Promise(function(t){return function(e){return n(function(){var n;return i(t.element)||(t.focused=null,null!=(n=t.delegate)&&"function"==typeof n.compositionControllerDidBlur&&n.compositionControllerDidBlur()),t.blurPromise=null,e()})}}(this))},u.prototype.didClickAttachment=function(t,e){var n,o;return n=this.findAttachmentForElement(e),null!=(o=this.delegate)&&"function"==typeof o.compositionControllerDidSelectAttachment?o.compositionControllerDidSelectAttachment(n):void 0},u.prototype.render=function(){var t,e,n;return this.revision!==this.composition.revision&&(this.documentView.setDocument(this.composition.document),this.documentView.render(),this.revision=this.composition.revision),this.documentView.isSynced()||(null!=(t=this.delegate)&&"function"==typeof t.compositionControllerWillSyncDocumentView&&t.compositionControllerWillSyncDocumentView(),this.documentView.sync(),this.reinstallAttachmentEditor(),null!=(e=this.delegate)&&"function"==typeof e.compositionControllerDidSyncDocumentView&&e.compositionControllerDidSyncDocumentView()),null!=(n=this.delegate)&&"function"==typeof n.compositionControllerDidRender?n.compositionControllerDidRender():void 0},u.prototype.rerenderViewForObject=function(t){return this.invalidateViewForObject(t),this.render()},u.prototype.invalidateViewForObject=function(t){return this.documentView.invalidateViewForObject(t)},u.prototype.isViewCachingEnabled=function(){return this.documentView.isViewCachingEnabled()},u.prototype.enableViewCaching=function(){return this.documentView.enableViewCaching()},u.prototype.disableViewCaching=function(){return this.documentView.disableViewCaching()},u.prototype.refreshViewCache=function(){return this.documentView.garbageCollectCachedViews()},u.prototype.installAttachmentEditorForAttachment=function(t){var n,o,i;if((null!=(i=this.attachmentEditor)?i.attachment:void 0)!==t&&(o=this.documentView.findElementForObject(t)))return this.uninstallAttachmentEditor(),n=this.composition.document.getAttachmentPieceForAttachment(t),this.attachmentEditor=new e.AttachmentEditorController(n,o,this.element),this.attachmentEditor.delegate=this},u.prototype.uninstallAttachmentEditor=function(){var t;return null!=(t=this.attachmentEditor)?t.uninstall():void 0},u.prototype.reinstallAttachmentEditor=function(){var t;return this.attachmentEditor?(t=this.attachmentEditor.attachment,this.uninstallAttachmentEditor(),this.installAttachmentEditorForAttachment(t)):void 0},u.prototype.editAttachmentCaption=function(){var t;return null!=(t=this.attachmentEditor)?t.editCaption():void 0},u.prototype.didUninstallAttachmentEditor=function(){return this.attachmentEditor=null,this.render()},u.prototype.attachmentEditorDidRequestUpdatingAttributesForAttachment=function(t,e){var n;return null!=(n=this.delegate)&&"function"==typeof n.compositionControllerWillUpdateAttachment&&n.compositionControllerWillUpdateAttachment(e),this.composition.updateAttributesForAttachment(t,e)},u.prototype.attachmentEditorDidRequestRemovingAttributeForAttachment=function(t,e){var n;return null!=(n=this.delegate)&&"function"==typeof n.compositionControllerWillUpdateAttachment&&n.compositionControllerWillUpdateAttachment(e),this.composition.removeAttributeForAttachment(t,e)},u.prototype.attachmentEditorDidRequestRemovalOfAttachment=function(t){var e;return null!=(e=this.delegate)&&"function"==typeof e.compositionControllerDidRequestRemovalOfAttachment?e.compositionControllerDidRequestRemovalOfAttachment(t):void 0},u.prototype.attachmentEditorDidRequestDeselectingAttachment=function(t){var e;return null!=(e=this.delegate)&&"function"==typeof e.compositionControllerDidRequestDeselectingAttachment?e.compositionControllerDidRequestDeselectingAttachment(t):void 0},u.prototype.findAttachmentForElement=function(t){return this.composition.document.getAttachmentById(parseInt(t.dataset.trixId,10))},u}(e.BasicObject)}.call(this),function(){var t,n,o,i=function(t,e){return function(){return t.apply(e,arguments)}},r=function(t,e){function n(){this.constructor=t}for(var o in e)s.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},s={}.hasOwnProperty;n=e.handleEvent,o=e.triggerEvent,t=e.findClosestElementFromNode,e.ToolbarController=function(e){function s(t){this.element=t,this.didKeyDownDialogInput=i(this.didKeyDownDialogInput,this),this.didClickDialogButton=i(this.didClickDialogButton,this),this.didClickAttributeButton=i(this.didClickAttributeButton,this),this.didClickActionButton=i(this.didClickActionButton,this),this.attributes={},this.actions={},this.resetDialogInputs(),n("mousedown",{onElement:this.element,matchingSelector:a,withCallback:this.didClickActionButton}),n("mousedown",{onElement:this.element,matchingSelector:c,withCallback:this.didClickAttributeButton}),n("click",{onElement:this.element,matchingSelector:y,preventDefault:!0}),n("click",{onElement:this.element,matchingSelector:l,withCallback:this.didClickDialogButton}),n("keydown",{onElement:this.element,matchingSelector:h,withCallback:this.didKeyDownDialogInput})}var a,u,c,l,h,p,d,f,g,m,y;return r(s,e),a="button[data-trix-action]",c="button[data-trix-attribute]",y=[a,c].join(", "),p=".dialog[data-trix-dialog]",u=p+".active",l=p+" input[data-trix-method]",h=p+" input[type=text], "+p+" input[type=url]",s.prototype.didClickActionButton=function(t,e){var n,o,i;return null!=(o=this.delegate)&&o.toolbarDidClickButton(),t.preventDefault(),n=d(e),this.getDialog(n)?this.toggleDialog(n):null!=(i=this.delegate)?i.toolbarDidInvokeAction(n):void 0},s.prototype.didClickAttributeButton=function(t,e){var n,o,i;return null!=(o=this.delegate)&&o.toolbarDidClickButton(),t.preventDefault(),n=f(e),this.getDialog(n)?this.toggleDialog(n):null!=(i=this.delegate)&&i.toolbarDidToggleAttribute(n),this.refreshAttributeButtons()},s.prototype.didClickDialogButton=function(e,n){var o,i;return o=t(n,{matchingSelector:p}),i=n.getAttribute("data-trix-method"),this[i].call(this,o)},s.prototype.didKeyDownDialogInput=function(t,e){var n,o;return 13===t.keyCode&&(t.preventDefault(),n=e.getAttribute("name"),o=this.getDialog(n),this.setAttribute(o)),27===t.keyCode?(t.preventDefault(),this.hideDialog()):void 0},s.prototype.updateActions=function(t){return this.actions=t,this.refreshActionButtons()},s.prototype.refreshActionButtons=function(){return this.eachActionButton(function(t){return function(e,n){return e.disabled=t.actions[n]===!1}}(this))},s.prototype.eachActionButton=function(t){var e,n,o,i,r;for(i=this.element.querySelectorAll(a),r=[],n=0,o=i.length;o>n;n++)e=i[n],r.push(t(e,d(e)));return r},s.prototype.updateAttributes=function(t){return this.attributes=t,this.refreshAttributeButtons()},s.prototype.refreshAttributeButtons=function(){return this.eachAttributeButton(function(t){return function(e,n){return e.disabled=t.attributes[n]===!1,t.attributes[n]||t.dialogIsVisible(n)?e.classList.add("active"):e.classList.remove("active")}}(this))},s.prototype.eachAttributeButton=function(t){var e,n,o,i,r;for(i=this.element.querySelectorAll(c),r=[],n=0,o=i.length;o>n;n++)e=i[n],r.push(t(e,f(e)));return r},s.prototype.applyKeyboardCommand=function(t){var e,n,i,r,s,a,u;for(s=JSON.stringify(t.sort()),u=this.element.querySelectorAll("[data-trix-key]"),r=0,a=u.length;a>r;r++)if(e=u[r],i=e.getAttribute("data-trix-key").split("+"),n=JSON.stringify(i.sort()),n===s)return o("mousedown",{onElement:e}),!0;return!1},s.prototype.dialogIsVisible=function(t){var e;return(e=this.getDialog(t))?e.classList.contains("active"):void 0},s.prototype.toggleDialog=function(t){return this.dialogIsVisible(t)?this.hideDialog():this.showDialog(t)},s.prototype.showDialog=function(t){var e,n,o,i,r,s,a,u,c,l;for(this.hideDialog(),null!=(a=this.delegate)&&a.toolbarWillShowDialog(),o=this.getDialog(t),o.classList.add("active"),u=o.querySelectorAll("input[disabled]"),i=0,s=u.length;s>i;i++)n=u[i],n.removeAttribute("disabled");return(e=f(o))&&(r=m(o,t))&&(r.value=null!=(c=this.attributes[e])?c:"",r.select()),null!=(l=this.delegate)?l.toolbarDidShowDialog(t):void 0},s.prototype.setAttribute=function(t){var e,n,o;return e=f(t),n=m(t,e),n.willValidate&&!n.checkValidity()?(n.classList.add("validate"),n.focus()):(null!=(o=this.delegate)&&o.toolbarDidUpdateAttribute(e,n.value),this.hideDialog())},s.prototype.removeAttribute=function(t){var e,n;return e=f(t),null!=(n=this.delegate)&&n.toolbarDidRemoveAttribute(e),this.hideDialog()},s.prototype.hideDialog=function(){var t,e;return(t=this.element.querySelector(u))?(t.classList.remove("active"),this.resetDialogInputs(),null!=(e=this.delegate)?e.toolbarDidHideDialog(g(t)):void 0):void 0},s.prototype.resetDialogInputs=function(){var t,e,n,o,i;for(o=this.element.querySelectorAll(h),i=[],t=0,n=o.length;n>t;t++)e=o[t],e.setAttribute("disabled","disabled"),i.push(e.classList.remove("validate"));return i},s.prototype.getDialog=function(t){return this.element.querySelector(".dialog[data-trix-dialog="+t+"]")},m=function(t,e){return null==e&&(e=f(t)),t.querySelector("input[name='"+e+"']")},d=function(t){return t.getAttribute("data-trix-action")},f=function(t){return t.getAttribute("data-trix-attribute")},g=function(t){return t.getAttribute("data-trix-dialog")},s}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.ImagePreloadOperation=function(e){function n(t){this.url=t}return t(n,e),n.prototype.perform=function(t){var e;return e=new Image,e.onload=function(n){return function(){return e.width=n.width=e.naturalWidth,e.height=n.height=e.naturalHeight,t(!0,e)}}(this),e.onerror=function(){return t(!1)},e.src=this.url},n}(e.Operation)}.call(this),function(){var t=function(t,e){return function(){return t.apply(e,arguments)}},n=function(t,e){function n(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},o={}.hasOwnProperty;e.Attachment=function(o){function i(n){null==n&&(n={}),this.releaseFile=t(this.releaseFile,this),i.__super__.constructor.apply(this,arguments),this.attributes=e.Hash.box(n),this.didChangeAttributes()}return n(i,o),i.previewablePattern=/^image(\/(gif|png|jpe?g)|$)/,i.attachmentForFile=function(t){var e,n;return n=this.attributesForFile(t),e=new this(n),e.setFile(t),e},i.attributesForFile=function(t){return new e.Hash({filename:t.name,filesize:t.size,contentType:t.type})},i.fromJSON=function(t){return new this(t)},i.prototype.getAttribute=function(t){return this.attributes.get(t)},i.prototype.hasAttribute=function(t){return this.attributes.has(t)},i.prototype.getAttributes=function(){return this.attributes.toObject()},i.prototype.setAttributes=function(t){var e,n,o;return null==t&&(t={}),e=this.attributes.merge(t),this.attributes.isEqualTo(e)?void 0:(this.attributes=e,this.didChangeAttributes(),null!=(n=this.previewDelegate)&&"function"==typeof n.attachmentDidChangeAttributes&&n.attachmentDidChangeAttributes(this),null!=(o=this.delegate)&&"function"==typeof o.attachmentDidChangeAttributes?o.attachmentDidChangeAttributes(this):void 0)},i.prototype.didChangeAttributes=function(){return this.isPreviewable()?this.preloadURL():void 0},i.prototype.isPending=function(){return null!=this.file&&!(this.getURL()||this.getHref())},i.prototype.isPreviewable=function(){return this.attributes.has("previewable")?this.attributes.get("previewable"):this.constructor.previewablePattern.test(this.getContentType())},i.prototype.getType=function(){return this.hasContent()?"content":this.isPreviewable()?"preview":"file"},i.prototype.getURL=function(){return this.attributes.get("url")},i.prototype.getHref=function(){return this.attributes.get("href")},i.prototype.getFilename=function(){var t;return null!=(t=this.attributes.get("filename"))?t:""},i.prototype.getFilesize=function(){return this.attributes.get("filesize")},i.prototype.getFormattedFilesize=function(){var t;return t=this.attributes.get("filesize"),"number"==typeof t?e.config.fileSize.formatter(t):""},i.prototype.getExtension=function(){var t;return null!=(t=this.getFilename().match(/\.(\w+)$/))?t[1].toLowerCase():void 0},i.prototype.getContentType=function(){return this.attributes.get("contentType")},i.prototype.hasContent=function(){return this.attributes.has("content")},i.prototype.getContent=function(){return this.attributes.get("content")},i.prototype.getWidth=function(){return this.attributes.get("width")},i.prototype.getHeight=function(){return this.attributes.get("height")},i.prototype.getFile=function(){return this.file},i.prototype.setFile=function(t){return this.file=t,this.isPreviewable()?this.preloadFile():void 0},i.prototype.releaseFile=function(){return this.releasePreloadedFile(),this.file=null},i.prototype.getUploadProgress=function(){var t;return null!=(t=this.uploadProgress)?t:0},i.prototype.setUploadProgress=function(t){var e;return this.uploadProgress!==t?(this.uploadProgress=t,null!=(e=this.uploadProgressDelegate)&&"function"==typeof e.attachmentDidChangeUploadProgress?e.attachmentDidChangeUploadProgress(this):void 0):void 0},i.prototype.toJSON=function(){return this.getAttributes()},i.prototype.getCacheKey=function(){return[i.__super__.getCacheKey.apply(this,arguments),this.attributes.getCacheKey(),this.getPreviewURL()].join("/")},i.prototype.getPreviewURL=function(){return this.previewURL||this.preloadingURL},i.prototype.setPreviewURL=function(t){var e,n;return t!==this.getPreviewURL()?(this.previewURL=t,null!=(e=this.previewDelegate)&&"function"==typeof e.attachmentDidChangeAttributes&&e.attachmentDidChangeAttributes(this),null!=(n=this.delegate)&&"function"==typeof n.attachmentDidChangePreviewURL?n.attachmentDidChangePreviewURL(this):void 0):void 0},i.prototype.preloadURL=function(){return this.preload(this.getURL(),this.releaseFile)},i.prototype.preloadFile=function(){return this.file?(this.fileObjectURL=URL.createObjectURL(this.file),this.preload(this.fileObjectURL)):void 0},i.prototype.releasePreloadedFile=function(){return this.fileObjectURL?(URL.revokeObjectURL(this.fileObjectURL),this.fileObjectURL=null):void 0},i.prototype.preload=function(t,n){var o;return t&&t!==this.getPreviewURL()?(this.preloadingURL=t,o=new e.ImagePreloadOperation(t),o.then(function(e){return function(o){var i,r;return r=o.width,i=o.height,e.setAttributes({width:r,height:i}),e.preloadingURL=null,e.setPreviewURL(t),"function"==typeof n?n():void 0}}(this))):void 0},i}(e.Object)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Piece=function(n){function o(t,n){null==n&&(n={}),o.__super__.constructor.apply(this,arguments),this.attributes=e.Hash.box(n)}return t(o,n),o.types={},o.registerType=function(t,e){return e.type=t,this.types[t]=e},o.fromJSON=function(t){var e;return(e=this.types[t.type])?e.fromJSON(t):void 0},o.prototype.copyWithAttributes=function(t){return new this.constructor(this.getValue(),t)},o.prototype.copyWithAdditionalAttributes=function(t){return this.copyWithAttributes(this.attributes.merge(t))
},o.prototype.copyWithoutAttribute=function(t){return this.copyWithAttributes(this.attributes.remove(t))},o.prototype.copy=function(){return this.copyWithAttributes(this.attributes)},o.prototype.getAttribute=function(t){return this.attributes.get(t)},o.prototype.getAttributesHash=function(){return this.attributes},o.prototype.getAttributes=function(){return this.attributes.toObject()},o.prototype.getCommonAttributes=function(){var t,e,n;return(n=pieceList.getPieceAtIndex(0))?(t=n.attributes,e=t.getKeys(),pieceList.eachPiece(function(n){return e=t.getKeysCommonToHash(n.attributes),t=t.slice(e)}),t.toObject()):{}},o.prototype.hasAttribute=function(t){return this.attributes.has(t)},o.prototype.hasSameStringValueAsPiece=function(t){return null!=t&&this.toString()===t.toString()},o.prototype.hasSameAttributesAsPiece=function(t){return null!=t&&(this.attributes===t.attributes||this.attributes.isEqualTo(t.attributes))},o.prototype.isBlockBreak=function(){return!1},o.prototype.isEqualTo=function(t){return o.__super__.isEqualTo.apply(this,arguments)||this.hasSameConstructorAs(t)&&this.hasSameStringValueAsPiece(t)&&this.hasSameAttributesAsPiece(t)},o.prototype.isEmpty=function(){return 0===this.length},o.prototype.isSerializable=function(){return!0},o.prototype.toJSON=function(){return{type:this.constructor.type,attributes:this.getAttributes()}},o.prototype.contentsForInspection=function(){return{type:this.constructor.type,attributes:this.attributes.inspect()}},o.prototype.canBeGrouped=function(){return this.hasAttribute("href")},o.prototype.canBeGroupedWith=function(t){return this.getAttribute("href")===t.getAttribute("href")},o.prototype.getLength=function(){return this.length},o.prototype.canBeConsolidatedWith=function(){return!1},o}(e.Object)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Piece.registerType("attachment",e.AttachmentPiece=function(n){function o(t){this.attachment=t,o.__super__.constructor.apply(this,arguments),this.length=1,this.ensureAttachmentExclusivelyHasAttribute("href")}return t(o,n),o.fromJSON=function(t){return new this(e.Attachment.fromJSON(t.attachment),t.attributes)},o.prototype.ensureAttachmentExclusivelyHasAttribute=function(t){return this.hasAttribute(t)&&this.attachment.hasAttribute(t)?this.attributes=this.attributes.remove(t):void 0},o.prototype.getValue=function(){return this.attachment},o.prototype.isSerializable=function(){return!this.attachment.isPending()},o.prototype.getCaption=function(){var t;return null!=(t=this.attributes.get("caption"))?t:""},o.prototype.getAttributesForAttachment=function(){return this.attributes.slice(["caption"])},o.prototype.canBeGrouped=function(){return o.__super__.canBeGrouped.apply(this,arguments)&&!this.attachment.hasAttribute("href")},o.prototype.isEqualTo=function(t){var e;return o.__super__.isEqualTo.apply(this,arguments)&&this.attachment.id===(null!=t&&null!=(e=t.attachment)?e.id:void 0)},o.prototype.toString=function(){return e.OBJECT_REPLACEMENT_CHARACTER},o.prototype.toJSON=function(){var t;return t=o.__super__.toJSON.apply(this,arguments),t.attachment=this.attachment,t},o.prototype.getCacheKey=function(){return[o.__super__.getCacheKey.apply(this,arguments),this.attachment.getCacheKey()].join("/")},o.prototype.toConsole=function(){return JSON.stringify(this.toString())},o}(e.Piece))}.call(this),function(){var t,n=function(t,e){function n(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},o={}.hasOwnProperty;t=e.normalizeNewlines,e.Piece.registerType("string",e.StringPiece=function(e){function o(e){o.__super__.constructor.apply(this,arguments),this.string=t(e),this.length=this.string.length}return n(o,e),o.fromJSON=function(t){return new this(t.string,t.attributes)},o.prototype.getValue=function(){return this.string},o.prototype.toString=function(){return this.string.toString()},o.prototype.isBlockBreak=function(){return"\n"===this.toString()&&this.getAttribute("blockBreak")===!0},o.prototype.toJSON=function(){var t;return t=o.__super__.toJSON.apply(this,arguments),t.string=this.string,t},o.prototype.canBeConsolidatedWith=function(t){return null!=t&&this.hasSameConstructorAs(t)&&this.hasSameAttributesAsPiece(t)},o.prototype.consolidateWith=function(t){return new this.constructor(this.toString()+t.toString(),this.attributes)},o.prototype.splitAtOffset=function(t){var e,n;return 0===t?(e=null,n=this):t===this.length?(e=this,n=null):(e=new this.constructor(this.string.slice(0,t),this.attributes),n=new this.constructor(this.string.slice(t),this.attributes)),[e,n]},o.prototype.toConsole=function(){var t;return t=this.string,t.length>15&&(t=t.slice(0,14)+"\u2026"),JSON.stringify(t.toString())},o}(e.Piece))}.call(this),function(){var t,n=function(t,e){function n(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},o={}.hasOwnProperty,i=[].slice;t=e.spliceArray,e.SplittableList=function(e){function o(t){null==t&&(t=[]),o.__super__.constructor.apply(this,arguments),this.objects=t.slice(0),this.length=this.objects.length}var r,s,a;return n(o,e),o.box=function(t){return t instanceof this?t:new this(t)},o.prototype.indexOf=function(t){return this.objects.indexOf(t)},o.prototype.splice=function(){var e;return e=1<=arguments.length?i.call(arguments,0):[],new this.constructor(t.apply(null,[this.objects].concat(i.call(e))))},o.prototype.eachObject=function(t){var e,n,o,i,r,s;for(r=this.objects,s=[],n=e=0,o=r.length;o>e;n=++e)i=r[n],s.push(t(i,n));return s},o.prototype.insertObjectAtIndex=function(t,e){return this.splice(e,0,t)},o.prototype.insertSplittableListAtIndex=function(t,e){return this.splice.apply(this,[e,0].concat(i.call(t.objects)))},o.prototype.insertSplittableListAtPosition=function(t,e){var n,o,i;return i=this.splitObjectAtPosition(e),o=i[0],n=i[1],new this.constructor(o).insertSplittableListAtIndex(t,n)},o.prototype.editObjectAtIndex=function(t,e){return this.replaceObjectAtIndex(e(this.objects[t]),t)},o.prototype.replaceObjectAtIndex=function(t,e){return this.splice(e,1,t)},o.prototype.removeObjectAtIndex=function(t){return this.splice(t,1)},o.prototype.getObjectAtIndex=function(t){return this.objects[t]},o.prototype.getSplittableListInRange=function(t){var e,n,o,i;return o=this.splitObjectsAtRange(t),n=o[0],e=o[1],i=o[2],new this.constructor(n.slice(e,i+1))},o.prototype.selectSplittableList=function(t){var e,n;return n=function(){var n,o,i,r;for(i=this.objects,r=[],n=0,o=i.length;o>n;n++)e=i[n],t(e)&&r.push(e);return r}.call(this),new this.constructor(n)},o.prototype.removeObjectsInRange=function(t){var e,n,o,i;return o=this.splitObjectsAtRange(t),n=o[0],e=o[1],i=o[2],new this.constructor(n).splice(e,i-e+1)},o.prototype.transformObjectsInRange=function(t,e){var n,o,i,r,s,a,u;return s=this.splitObjectsAtRange(t),r=s[0],o=s[1],a=s[2],u=function(){var t,s,u;for(u=[],n=t=0,s=r.length;s>t;n=++t)i=r[n],u.push(n>=o&&a>=n?e(i):i);return u}(),new this.constructor(u)},o.prototype.splitObjectsAtRange=function(t){var e,n,o,i,s,u;return i=this.splitObjectAtPosition(a(t)),n=i[0],e=i[1],o=i[2],s=new this.constructor(n).splitObjectAtPosition(r(t)+o),n=s[0],u=s[1],[n,e,u-1]},o.prototype.getObjectAtPosition=function(t){var e,n,o;return o=this.findIndexAndOffsetAtPosition(t),e=o.index,n=o.offset,this.objects[e]},o.prototype.splitObjectAtPosition=function(t){var e,n,o,i,r,s,a,u,c,l;return s=this.findIndexAndOffsetAtPosition(t),e=s.index,r=s.offset,i=this.objects.slice(0),null!=e?0===r?(c=e,l=0):(o=this.getObjectAtIndex(e),a=o.splitAtOffset(r),n=a[0],u=a[1],i.splice(e,1,n,u),c=e+1,l=n.getLength()-r):(c=i.length,l=0),[i,c,l]},o.prototype.consolidate=function(){var t,e,n,o,i,r;for(o=[],i=this.objects[0],r=this.objects.slice(1),t=0,e=r.length;e>t;t++)n=r[t],("function"==typeof i.canBeConsolidatedWith?i.canBeConsolidatedWith(n):void 0)?i=i.consolidateWith(n):(o.push(i),i=n);return null!=i&&o.push(i),new this.constructor(o)},o.prototype.consolidateFromIndexToIndex=function(t,e){var n,o,r;return o=this.objects.slice(0),r=o.slice(t,e+1),n=new this.constructor(r).consolidate().toArray(),this.splice.apply(this,[t,r.length].concat(i.call(n)))},o.prototype.findIndexAndOffsetAtPosition=function(t){var e,n,o,i,r,s,a;for(e=0,a=this.objects,o=n=0,i=a.length;i>n;o=++n){if(s=a[o],r=e+s.getLength(),t>=e&&r>t)return{index:o,offset:t-e};e=r}return{index:null,offset:null}},o.prototype.findPositionAtIndexAndOffset=function(t,e){var n,o,i,r,s,a;for(s=0,a=this.objects,n=o=0,i=a.length;i>o;n=++o)if(r=a[n],t>n)s+=r.getLength();else if(n===t){s+=e;break}return s},o.prototype.getEndPosition=function(){var t,e;return null!=this.endPosition?this.endPosition:this.endPosition=function(){var n,o,i;for(e=0,i=this.objects,n=0,o=i.length;o>n;n++)t=i[n],e+=t.getLength();return e}.call(this)},o.prototype.toString=function(){return this.objects.join("")},o.prototype.toArray=function(){return this.objects.slice(0)},o.prototype.toJSON=function(){return this.toArray()},o.prototype.isEqualTo=function(t){return o.__super__.isEqualTo.apply(this,arguments)||s(this.objects,null!=t?t.objects:void 0)},s=function(t,e){var n,o,i,r,s;if(null==e&&(e=[]),t.length!==e.length)return!1;for(s=!0,o=n=0,i=t.length;i>n;o=++n)r=t[o],s&&!r.isEqualTo(e[o])&&(s=!1);return s},o.prototype.contentsForInspection=function(){var t;return{objects:"["+function(){var e,n,o,i;for(o=this.objects,i=[],e=0,n=o.length;n>e;e++)t=o[e],i.push(t.inspect());return i}.call(this).join(", ")+"]"}},a=function(t){return t[0]},r=function(t){return t[1]},o}(e.Object)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Text=function(n){function o(t){var n;null==t&&(t=[]),o.__super__.constructor.apply(this,arguments),this.pieceList=new e.SplittableList(function(){var e,o,i;for(i=[],e=0,o=t.length;o>e;e++)n=t[e],n.isEmpty()||i.push(n);return i}())}return t(o,n),o.textForAttachmentWithAttributes=function(t,n){var o;return o=new e.AttachmentPiece(t,n),new this([o])},o.textForStringWithAttributes=function(t,n){var o;return o=new e.StringPiece(t,n),new this([o])},o.fromJSON=function(t){var n,o;return o=function(){var o,i,r;for(r=[],o=0,i=t.length;i>o;o++)n=t[o],r.push(e.Piece.fromJSON(n));return r}(),new this(o)},o.prototype.copy=function(){return this.copyWithPieceList(this.pieceList)},o.prototype.copyWithPieceList=function(t){return new this.constructor(t.consolidate().toArray())},o.prototype.copyUsingObjectMap=function(t){var e,n;return n=function(){var n,o,i,r,s;for(i=this.getPieces(),s=[],n=0,o=i.length;o>n;n++)e=i[n],s.push(null!=(r=t.find(e))?r:e);return s}.call(this),new this.constructor(n)},o.prototype.appendText=function(t){return this.insertTextAtPosition(t,this.getLength())},o.prototype.insertTextAtPosition=function(t,e){return this.copyWithPieceList(this.pieceList.insertSplittableListAtPosition(t.pieceList,e))},o.prototype.removeTextAtRange=function(t){return this.copyWithPieceList(this.pieceList.removeObjectsInRange(t))},o.prototype.replaceTextAtRange=function(t,e){return this.removeTextAtRange(e).insertTextAtPosition(t,e[0])},o.prototype.moveTextFromRangeToPosition=function(t,e){var n,o;if(!(t[0]<=e&&e<=t[1]))return o=this.getTextAtRange(t),n=o.getLength(),t[0]<e&&(e-=n),this.removeTextAtRange(t).insertTextAtPosition(o,e)},o.prototype.addAttributeAtRange=function(t,e,n){var o;return o={},o[t]=e,this.addAttributesAtRange(o,n)},o.prototype.addAttributesAtRange=function(t,e){return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e,function(e){return e.copyWithAdditionalAttributes(t)}))},o.prototype.removeAttributeAtRange=function(t,e){return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e,function(e){return e.copyWithoutAttribute(t)}))},o.prototype.setAttributesAtRange=function(t,e){return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e,function(e){return e.copyWithAttributes(t)}))},o.prototype.getAttributesAtPosition=function(t){var e,n;return null!=(e=null!=(n=this.pieceList.getObjectAtPosition(t))?n.getAttributes():void 0)?e:{}},o.prototype.getCommonAttributes=function(){var t,n;return t=function(){var t,e,o,i;for(o=this.pieceList.toArray(),i=[],t=0,e=o.length;e>t;t++)n=o[t],i.push(n.getAttributes());return i}.call(this),e.Hash.fromCommonAttributesOfObjects(t).toObject()},o.prototype.getCommonAttributesAtRange=function(t){var e;return null!=(e=this.getTextAtRange(t).getCommonAttributes())?e:{}},o.prototype.getExpandedRangeForAttributeAtOffset=function(t,e){var n,o,i;for(n=i=e,o=this.getLength();n>0&&this.getCommonAttributesAtRange([n-1,i])[t];)n--;for(;o>i&&this.getCommonAttributesAtRange([e,i+1])[t];)i++;return[n,i]},o.prototype.getTextAtRange=function(t){return this.copyWithPieceList(this.pieceList.getSplittableListInRange(t))},o.prototype.getStringAtRange=function(t){return this.pieceList.getSplittableListInRange(t).toString()},o.prototype.getStringAtPosition=function(t){return this.getStringAtRange([t,t+1])},o.prototype.startsWithString=function(t){return this.getStringAtRange([0,t.length])===t},o.prototype.endsWithString=function(t){var e;return e=this.getLength(),this.getStringAtRange([e-t.length,e])===t},o.prototype.getAttachmentPieces=function(){var t,e,n,o,i;for(o=this.pieceList.toArray(),i=[],t=0,e=o.length;e>t;t++)n=o[t],null!=n.attachment&&i.push(n);return i},o.prototype.getAttachments=function(){var t,e,n,o,i;for(o=this.getAttachmentPieces(),i=[],t=0,e=o.length;e>t;t++)n=o[t],i.push(n.attachment);return i},o.prototype.getAttachmentAndPositionById=function(t){var e,n,o,i,r,s;for(i=0,r=this.pieceList.toArray(),e=0,n=r.length;n>e;e++){if(o=r[e],(null!=(s=o.attachment)?s.id:void 0)===t)return{attachment:o.attachment,position:i};i+=o.length}return{attachment:null,position:null}},o.prototype.getAttachmentById=function(t){var e,n,o;return o=this.getAttachmentAndPositionById(t),e=o.attachment,n=o.position,e},o.prototype.getRangeOfAttachment=function(t){var e,n;return n=this.getAttachmentAndPositionById(t.id),t=n.attachment,e=n.position,null!=t?[e,e+1]:void 0},o.prototype.updateAttributesForAttachment=function(t,e){var n;return(n=this.getRangeOfAttachment(e))?this.addAttributesAtRange(t,n):this},o.prototype.getLength=function(){return this.pieceList.getEndPosition()},o.prototype.isEmpty=function(){return 0===this.getLength()},o.prototype.isEqualTo=function(t){var e;return o.__super__.isEqualTo.apply(this,arguments)||(null!=t&&null!=(e=t.pieceList)?e.isEqualTo(this.pieceList):void 0)},o.prototype.isBlockBreak=function(){return 1===this.getLength()&&this.pieceList.getObjectAtIndex(0).isBlockBreak()},o.prototype.eachPiece=function(t){return this.pieceList.eachObject(t)},o.prototype.getPieces=function(){return this.pieceList.toArray()},o.prototype.getPieceAtPosition=function(t){return this.pieceList.getObjectAtPosition(t)},o.prototype.contentsForInspection=function(){return{pieceList:this.pieceList.inspect()}},o.prototype.toSerializableText=function(){var t;return t=this.pieceList.selectSplittableList(function(t){return t.isSerializable()}),this.copyWithPieceList(t)},o.prototype.toString=function(){return this.pieceList.toString()},o.prototype.toJSON=function(){return this.pieceList.toJSON()},o.prototype.toConsole=function(){var t;return JSON.stringify(function(){var e,n,o,i;for(o=this.pieceList.toArray(),i=[],e=0,n=o.length;n>e;e++)t=o[e],i.push(JSON.parse(t.toConsole()));return i}.call(this))},o}(e.Object)}.call(this),function(){var t,n,o,i,r,s=function(t,e){function n(){this.constructor=t}for(var o in e)a.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},a={}.hasOwnProperty,u=[].slice,c=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.arraysAreEqual,r=e.spliceArray,o=e.getBlockConfig,n=e.getBlockAttributeNames,i=e.getListAttributeNames,e.Block=function(n){function a(t,n){null==t&&(t=new e.Text),null==n&&(n=[]),a.__super__.constructor.apply(this,arguments),this.text=h(t),this.attributes=n}var l,h,p,d,f,g,m,y,v;return s(a,n),a.fromJSON=function(t){var n;return n=e.Text.fromJSON(t.text),new this(n,t.attributes)},a.prototype.isEmpty=function(){return this.text.isBlockBreak()},a.prototype.isEqualTo=function(e){return a.__super__.isEqualTo.apply(this,arguments)||this.text.isEqualTo(null!=e?e.text:void 0)&&t(this.attributes,null!=e?e.attributes:void 0)},a.prototype.copyWithText=function(t){return new this.constructor(t,this.attributes)},a.prototype.copyWithoutText=function(){return this.copyWithText(null)},a.prototype.copyWithAttributes=function(t){return new this.constructor(this.text,t)},a.prototype.copyUsingObjectMap=function(t){var e;return this.copyWithText((e=t.find(this.text))?e:this.text.copyUsingObjectMap(t))},a.prototype.addAttribute=function(t){var e;return e=this.attributes.concat(d(t)),this.copyWithAttributes(e)},a.prototype.removeAttribute=function(t){var e,n;return n=o(t).listAttribute,e=g(g(this.attributes,t),n),this.copyWithAttributes(e)},a.prototype.removeLastAttribute=function(){return this.removeAttribute(this.getLastAttribute())},a.prototype.getLastAttribute=function(){return f(this.attributes)},a.prototype.getAttributes=function(){return this.attributes.slice(0)},a.prototype.getAttributeLevel=function(){return this.attributes.length},a.prototype.getAttributeAtLevel=function(t){return this.attributes[t-1]},a.prototype.hasAttributes=function(){return this.getAttributeLevel()>0},a.prototype.getLastNestableAttribute=function(){return f(this.getNestableAttributes())},a.prototype.getNestableAttributes=function(){var t,e,n,i,r;for(i=this.attributes,r=[],e=0,n=i.length;n>e;e++)t=i[e],o(t).nestable&&r.push(t);return r},a.prototype.getNestingLevel=function(){return this.getNestableAttributes().length},a.prototype.decreaseNestingLevel=function(){var t;return(t=this.getLastNestableAttribute())?this.removeAttribute(t):this},a.prototype.increaseNestingLevel=function(){var t,e,n;return(t=this.getLastNestableAttribute())?(n=this.attributes.lastIndexOf(t),e=r.apply(null,[this.attributes,n+1,0].concat(u.call(d(t)))),this.copyWithAttributes(e)):this},a.prototype.getListItemAttributes=function(){var t,e,n,i,r;for(i=this.attributes,r=[],e=0,n=i.length;n>e;e++)t=i[e],o(t).listAttribute&&r.push(t);return r},a.prototype.isListItem=function(){var t;return null!=(t=o(this.getLastAttribute()))?t.listAttribute:void 0},a.prototype.isTerminalBlock=function(){var t;return null!=(t=o(this.getLastAttribute()))?t.terminal:void 0},a.prototype.breaksOnReturn=function(){var t;return null!=(t=o(this.getLastAttribute()))?t.breakOnReturn:void 0},a.prototype.findLineBreakInDirectionFromPosition=function(t,e){var n,o;return o=this.toString(),n=function(){switch(t){case"forward":return o.indexOf("\n",e);case"backward":return o.slice(0,e).lastIndexOf("\n")}}(),-1!==n?n:void 0},a.prototype.contentsForInspection=function(){return{text:this.text.inspect(),attributes:this.attributes}},a.prototype.toString=function(){return this.text.toString()},a.prototype.toJSON=function(){return{text:this.text,attributes:this.attributes}},a.prototype.getLength=function(){return this.text.getLength()},a.prototype.canBeConsolidatedWith=function(t){return!this.hasAttributes()&&!t.hasAttributes()},a.prototype.consolidateWith=function(t){var n,o;return n=e.Text.textForStringWithAttributes("\n"),o=this.getTextWithoutBlockBreak().appendText(n),this.copyWithText(o.appendText(t.text))},a.prototype.splitAtOffset=function(t){var e,n;return 0===t?(e=null,n=this):t===this.getLength()?(e=this,n=null):(e=this.copyWithText(this.text.getTextAtRange([0,t])),n=this.copyWithText(this.text.getTextAtRange([t,this.getLength()]))),[e,n]},a.prototype.getBlockBreakPosition=function(){return this.text.getLength()-1},a.prototype.getTextWithoutBlockBreak=function(){return m(this.text)?this.text.getTextAtRange([0,this.getBlockBreakPosition()]):this.text.copy()},a.prototype.canBeGrouped=function(t){return this.attributes[t]},a.prototype.canBeGroupedWith=function(t,e){var n,r,s,a;return s=t.getAttributes(),r=s[e],n=this.attributes[e],n===r&&!(o(n).group===!1&&(a=s[e+1],c.call(i(),a)<0))},h=function(t){return t=v(t),t=l(t)},v=function(t){var n,o,i,r,s,a;return r=!1,a=t.getPieces(),o=2<=a.length?u.call(a,0,n=a.length-1):(n=0,[]),i=a[n++],null==i?t:(o=function(){var t,e,n;for(n=[],t=0,e=o.length;e>t;t++)s=o[t],s.isBlockBreak()?(r=!0,n.push(y(s))):n.push(s);return n}(),r?new e.Text(u.call(o).concat([i])):t)},p=e.Text.textForStringWithAttributes("\n",{blockBreak:!0}),l=function(t){return m(t)?t:t.appendText(p)},m=function(t){var e,n;return n=t.getLength(),0===n?!1:(e=t.getTextAtRange([n-1,n]),e.isBlockBreak())},y=function(t){return t.copyWithoutAttribute("blockBreak")},d=function(t){var e;return e=o(t).listAttribute,null!=e?[e,t]:[t]},f=function(t){return t.slice(-1)[0]},g=function(t,e){var n;return n=t.lastIndexOf(e),-1===n?t:r(t,n,1)},a}(e.Object)}.call(this),function(){var t,n,o,i,r,s,a,u,c,l=function(t,e){function n(){this.constructor=t}for(var o in e)h.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},h={}.hasOwnProperty,p=[].slice,d=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.arraysAreEqual,a=e.normalizeSpaces,r=e.makeElement,u=e.tagName,i=e.getBlockTagNames,c=e.walkTree,o=e.findClosestElementFromNode,n=e.elementContainsNode,s=e.nodeIsAttachmentElement,e.HTMLParser=function(h){function f(t,e){this.html=t,this.referenceElement=(null!=e?e:{}).referenceElement,this.blocks=[],this.blockElements=[],this.processedElements=[]}var g,m,y,v,b,A,C,w,x,E,S,k,R,L,D,O;return l(f,h),g="style href src width height class".split(" "),f.parse=function(t,e){var n;return n=new this(t,e),n.parse(),n},f.prototype.getDocument=function(){return e.Document.fromJSON(this.blocks)},f.prototype.parse=function(){var t,e;try{for(this.createHiddenContainer(),t=R(this.html),this.containerElement.innerHTML=t,e=c(this.containerElement,{usingFilter:E});e.nextNode();)this.processNode(e.currentNode);return this.translateBlockElementMarginsToNewlines()}finally{this.removeHiddenContainer()}},f.prototype.createHiddenContainer=function(){return this.referenceElement?(this.containerElement=this.referenceElement.cloneNode(!1),this.containerElement.removeAttribute("id"),this.containerElement.setAttribute("data-trix-internal",""),this.containerElement.style.display="none",this.referenceElement.parentNode.insertBefore(this.containerElement,this.referenceElement.nextSibling)):(this.containerElement=r({tagName:"div",style:{display:"none"}}),document.body.appendChild(this.containerElement))},f.prototype.removeHiddenContainer=function(){return this.containerElement.parentNode.removeChild(this.containerElement)},R=function(t){var e,n,o,i,r,s,a,u,l,h,f,m,y,v,A,C;for(t=t.replace(/<\/html[^>]*>[^]*$/i,"</html>"),n=document.implementation.createHTMLDocument(""),n.documentElement.innerHTML=t,e=n.body,o=n.head,y=o.querySelectorAll("style"),i=0,a=y.length;a>i;i++)A=y[i],e.appendChild(A);for(m=[],C=c(e);C.nextNode();)switch(f=C.currentNode,f.nodeType){case Node.ELEMENT_NODE:if(b(f))m.push(f);else for(v=p.call(f.attributes),r=0,u=v.length;u>r;r++)h=v[r].name,d.call(g,h)>=0||0===h.indexOf("data-trix")||f.removeAttribute(h);break;case Node.COMMENT_NODE:m.push(f)}for(s=0,l=m.length;l>s;s++)f=m[s],f.parentNode.removeChild(f);return e.innerHTML},b=function(t){return(null!=t?t.nodeType:void 0)!==Node.ELEMENT_NODE||s(t)?void 0:"script"===u(t)||"false"===t.getAttribute("data-trix-serialize")},E=function(t){return"style"===u(t)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT},f.prototype.processNode=function(t){switch(t.nodeType){case Node.TEXT_NODE:return this.processTextNode(t);case Node.ELEMENT_NODE:return this.appendBlockForElement(t),this.processElement(t)}},f.prototype.appendBlockForElement=function(e){var o,i,r,s;if(r=this.isBlockElement(e),i=n(this.currentBlockElement,e),r&&!this.isBlockElement(e.firstChild)){if(!(this.isInsignificantTextNode(e.firstChild)&&this.isBlockElement(e.firstElementChild)||(o=this.getBlockAttributes(e),i&&t(o,this.currentBlock.attributes))))return this.currentBlock=this.appendBlockForAttributesWithElement(o,e),this.currentBlockElement=e}else if(this.currentBlockElement&&!i&&!r)return(s=this.findParentBlockElement(e))?this.appendBlockForElement(s):(this.currentBlock=this.appendEmptyBlock(),this.currentBlockElement=null)},f.prototype.findParentBlockElement=function(t){var e;for(e=t.parentElement;e&&e!==this.containerElement;){if(this.isBlockElement(e)&&d.call(this.blockElements,e)>=0)return e;e=e.parentElement}return null},f.prototype.processTextNode=function(t){var e,n;return this.isInsignificantTextNode(t)?void 0:(n=t.data,v(t.parentNode)||(n=L(n),D(null!=(e=t.previousSibling)?e.textContent:void 0)&&(n=x(n))),this.appendStringWithAttributes(n,this.getTextAttributes(t.parentNode)))},f.prototype.processElement=function(t){var e,n,o,i,r;if(s(t))return e=A(t),Object.keys(e).length&&(i=this.getTextAttributes(t),this.appendAttachmentWithAttributes(e,i),t.innerHTML=""),this.processedElements.push(t);switch(u(t)){case"br":return this.isExtraBR(t)||this.isBlockElement(t.nextSibling)||this.appendStringWithAttributes("\n",this.getTextAttributes(t)),this.processedElements.push(t);case"img":e={url:t.getAttribute("src"),contentType:"image"},o=w(t);for(n in o)r=o[n],e[n]=r;return this.appendAttachmentWithAttributes(e,this.getTextAttributes(t)),this.processedElements.push(t);case"tr":if(t.parentNode.firstChild!==t)return this.appendStringWithAttributes("\n");break;case"td":if(t.parentNode.firstChild!==t)return this.appendStringWithAttributes(" | ")}},f.prototype.appendBlockForAttributesWithElement=function(t,e){var n;return this.blockElements.push(e),n=m(t),this.blocks.push(n),n},f.prototype.appendEmptyBlock=function(){return this.appendBlockForAttributesWithElement([],null)},f.prototype.appendStringWithAttributes=function(t,e){return this.appendPiece(k(t,e))},f.prototype.appendAttachmentWithAttributes=function(t,e){return this.appendPiece(S(t,e))},f.prototype.appendPiece=function(t){return 0===this.blocks.length&&this.appendEmptyBlock(),this.blocks[this.blocks.length-1].text.push(t)},f.prototype.appendStringToTextAtIndex=function(t,e){var n,o;return o=this.blocks[e].text,n=o[o.length-1],"string"===(null!=n?n.type:void 0)?n.string+=t:o.push(k(t))},f.prototype.prependStringToTextAtIndex=function(t,e){var n,o;return o=this.blocks[e].text,n=o[0],"string"===(null!=n?n.type:void 0)?n.string=t+n.string:o.unshift(k(t))},k=function(t,e){var n;return null==e&&(e={}),n="string",t=a(t),{string:t,attributes:e,type:n}},S=function(t,e){var n;return null==e&&(e={}),n="attachment",{attachment:t,attributes:e,type:n}},m=function(t){var e;return null==t&&(t={}),e=[],{text:e,attributes:t}},f.prototype.getTextAttributes=function(t){var n,i,r,a,u,c,l,h,p,d,f,g,m;r={},d=e.config.textAttributes;for(n in d)if(u=d[n],u.tagName&&o(t,{matchingSelector:u.tagName,untilNode:this.containerElement}))r[n]=!0;else if(u.parser&&(m=u.parser(t))){for(i=!1,f=this.findBlockElementAncestors(t),c=0,p=f.length;p>c;c++)if(a=f[c],u.parser(a)===m){i=!0;break}i||(r[n]=m)}if(s(t)&&(l=t.getAttribute("data-trix-attributes"))){g=JSON.parse(l);for(h in g)m=g[h],r[h]=m}return r},f.prototype.getBlockAttributes=function(t){var n,o,i,r;for(o=[];t&&t!==this.containerElement;){r=e.config.blockAttributes;for(n in r)i=r[n],i.parse!==!1&&u(t)===i.tagName&&(("function"==typeof i.test?i.test(t):void 0)||!i.test)&&(o.push(n),i.listAttribute&&o.push(i.listAttribute));t=t.parentNode}return o.reverse()},f.prototype.findBlockElementAncestors=function(t){var e,n;for(e=[];t&&t!==this.containerElement;)n=u(t),d.call(i(),n)>=0&&e.push(t),t=t.parentNode;return e},A=function(t){return JSON.parse(t.getAttribute("data-trix-attachment"))},w=function(t){var e,n,o;return o=t.getAttribute("width"),n=t.getAttribute("height"),e={},o&&(e.width=parseInt(o,10)),n&&(e.height=parseInt(n,10)),e},f.prototype.isBlockElement=function(t){var e;if((null!=t?t.nodeType:void 0)===Node.ELEMENT_NODE&&!o(t,{matchingSelector:"td",untilNode:this.containerElement}))return e=u(t),d.call(i(),e)>=0||"block"===window.getComputedStyle(t).display},f.prototype.isInsignificantTextNode=function(t){return(null!=t?t.nodeType:void 0)===Node.TEXT_NODE&&O(t.data)&&!v(t.parentNode)?!t.previousSibling||this.isBlockElement(t.previousSibling)||!t.nextSibling||this.isBlockElement(t.nextSibling):void 0},f.prototype.isExtraBR=function(t){return"br"===u(t)&&this.isBlockElement(t.parentNode)&&t.parentNode.lastChild===t},v=function(t){var e;return e=window.getComputedStyle(t).whiteSpace,"pre"===e||"pre-wrap"===e||"pre-line"===e},f.prototype.translateBlockElementMarginsToNewlines=function(){var t,e,n,o,i,r,s,a;for(e=this.getMarginOfDefaultBlockElement(),s=this.blocks,a=[],o=n=0,i=s.length;i>n;o=++n)t=s[o],(r=this.getMarginOfBlockElementAtIndex(o))&&(r.top>2*e.top&&this.prependStringToTextAtIndex("\n",o),a.push(r.bottom>2*e.bottom?this.appendStringToTextAtIndex("\n",o):void 0));return a},f.prototype.getMarginOfBlockElementAtIndex=function(t){var e,n;return!(e=this.blockElements[t])||(n=u(e),d.call(i(),n)>=0||d.call(this.processedElements,e)>=0)?void 0:C(e)},f.prototype.getMarginOfDefaultBlockElement=function(){var t;return t=r(e.config.blockAttributes["default"].tagName),this.containerElement.appendChild(t),C(t)},C=function(t){var e;return e=window.getComputedStyle(t),"block"===e.display?{top:parseInt(e.marginTop),bottom:parseInt(e.marginBottom)}:void 0},y=RegExp("[^\\S"+e.NON_BREAKING_SPACE+"]"),L=function(t){return t.replace(RegExp(""+y.source,"g")," ").replace(/\ {2,}/g," ")},x=function(t){return t.replace(RegExp("^"+y.source+"+"),"")},O=function(t){return RegExp("^"+y.source+"*$").test(t)},D=function(t){return/\s$/.test(t)},f}(e.BasicObject)}.call(this),function(){var t,n,o,i,r=function(t,e){function n(){this.constructor=t}for(var o in e)s.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},s={}.hasOwnProperty,a=[].slice,u=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.arraysAreEqual,o=e.normalizeRange,i=e.rangeIsCollapsed,n=e.getBlockConfig,e.Document=function(s){function c(t){null==t&&(t=[]),c.__super__.constructor.apply(this,arguments),0===t.length&&(t=[new e.Block]),this.blockList=e.SplittableList.box(t)}var l;return r(c,s),c.fromJSON=function(t){var n,o;return o=function(){var o,i,r;for(r=[],o=0,i=t.length;i>o;o++)n=t[o],r.push(e.Block.fromJSON(n));return r}(),new this(o)},c.fromHTML=function(t,n){return e.HTMLParser.parse(t,n).getDocument()},c.fromString=function(t,n){var o;return o=e.Text.textForStringWithAttributes(t,n),new this([new e.Block(o)])},c.prototype.isEmpty=function(){var t;return 1===this.blockList.length&&(t=this.getBlockAtIndex(0),t.isEmpty()&&!t.hasAttributes())},c.prototype.copy=function(t){var e;return null==t&&(t={}),e=t.consolidateBlocks?this.blockList.consolidate().toArray():this.blockList.toArray(),new this.constructor(e)},c.prototype.copyUsingObjectsFromDocument=function(t){var n;return n=new e.ObjectMap(t.getObjects()),this.copyUsingObjectMap(n)},c.prototype.copyUsingObjectMap=function(t){var e,n,o;return n=function(){var n,i,r,s;for(r=this.getBlocks(),s=[],n=0,i=r.length;i>n;n++)e=r[n],s.push((o=t.find(e))?o:e.copyUsingObjectMap(t));return s}.call(this),new this.constructor(n)},c.prototype.copyWithBaseBlockAttributes=function(t){var e,n,o;return null==t&&(t=[]),o=function(){var o,i,r,s;for(r=this.getBlocks(),s=[],o=0,i=r.length;i>o;o++)n=r[o],e=t.concat(n.getAttributes()),s.push(n.copyWithAttributes(e));return s}.call(this),new this.constructor(o)},c.prototype.replaceBlock=function(t,e){var n;return n=this.blockList.indexOf(t),-1===n?this:new this.constructor(this.blockList.replaceObjectAtIndex(e,n))},c.prototype.insertDocumentAtRange=function(t,e){var n,r,s,a,u,c,l;return r=t.blockList,u=(e=o(e))[0],c=this.locationFromPosition(u),s=c.index,a=c.offset,l=this,n=this.getBlockAtPosition(u),i(e)&&n.isEmpty()&&!n.hasAttributes()?l=new this.constructor(l.blockList.removeObjectAtIndex(s)):n.getBlockBreakPosition()===a&&u++,l=l.removeTextAtRange(e),new this.constructor(l.blockList.insertSplittableListAtPosition(r,u))},c.prototype.mergeDocumentAtRange=function(e,n){var i,r,s,a,u,c,l,h,p,d,f,g;return f=(n=o(n))[0],d=this.locationFromPosition(f),r=this.getBlockAtIndex(d.index).getAttributes(),i=e.getBaseBlockAttributes(),g=r.slice(-i.length),t(i,g)?(l=r.slice(0,-i.length),c=e.copyWithBaseBlockAttributes(l)):c=e.copy({consolidateBlocks:!0}).copyWithBaseBlockAttributes(r),s=c.getBlockCount(),a=c.getBlockAtIndex(0),t(r,a.getAttributes())?(u=a.getTextWithoutBlockBreak(),p=this.insertTextAtRange(u,n),s>1&&(c=new this.constructor(c.getBlocks().slice(1)),h=f+u.getLength(),p=p.insertDocumentAtRange(c,h))):p=this.insertDocumentAtRange(c,n),p
},c.prototype.insertTextAtRange=function(t,e){var n,i,r,s,a;return a=(e=o(e))[0],s=this.locationFromPosition(a),i=s.index,r=s.offset,n=this.removeTextAtRange(e),new this.constructor(n.blockList.editObjectAtIndex(i,function(e){return e.copyWithText(e.text.insertTextAtPosition(t,r))}))},c.prototype.removeTextAtRange=function(t){var e,n,r,s,a,u,c,l,h,p,d,f,g,m,y,v,b,A,C,w,x;return p=t=o(t),l=p[0],A=p[1],i(t)?this:(d=this.locationRangeFromRange(t),u=d[0],v=d[1],a=u.index,c=u.offset,s=this.getBlockAtIndex(a),y=v.index,b=v.offset,m=this.getBlockAtIndex(y),f=A-l===1&&s.getBlockBreakPosition()===c&&m.getBlockBreakPosition()!==b&&"\n"===m.text.getStringAtPosition(b),f?r=this.blockList.editObjectAtIndex(y,function(t){return t.copyWithText(t.text.removeTextAtRange([b,b+1]))}):(h=s.text.getTextAtRange([0,c]),C=m.text.getTextAtRange([b,m.getLength()]),w=h.appendText(C),g=a!==y&&0===c,x=g&&s.getAttributeLevel()>=m.getAttributeLevel(),n=x?m.copyWithText(w):s.copyWithText(w),e=y+1-a,r=this.blockList.splice(a,e,n)),new this.constructor(r))},c.prototype.moveTextFromRangeToPosition=function(t,e){var n,i,r,s,u,c,l,h,p,d;if(c=t=o(t),p=c[0],r=c[1],e>=p&&r>=e)return this;if(i=this.getDocumentAtRange(t),h=this.removeTextAtRange(t),u=e>p,u&&(e-=i.getLength()),!h.firstBlockInRangeIsEntirelySelected(t)){if(l=i.getBlocks(),s=l[0],n=2<=l.length?a.call(l,1):[],0===n.length?(d=s.getTextWithoutBlockBreak(),u&&(e+=1)):d=s.text,h=h.insertTextAtRange(d,e),0===n.length)return h;i=new this.constructor(n),e+=d.getLength()}return h.insertDocumentAtRange(i,e)},c.prototype.addAttributeAtRange=function(t,e,o){var i;return i=this.blockList,this.eachBlockAtRange(o,function(o,r,s){return i=i.editObjectAtIndex(s,function(){return n(t)?o.addAttribute(t,e):r[0]===r[1]?o:o.copyWithText(o.text.addAttributeAtRange(t,e,r))})}),new this.constructor(i)},c.prototype.addAttribute=function(t,e){var n;return n=this.blockList,this.eachBlock(function(o,i){return n=n.editObjectAtIndex(i,function(){return o.addAttribute(t,e)})}),new this.constructor(n)},c.prototype.removeAttributeAtRange=function(t,e){var o;return o=this.blockList,this.eachBlockAtRange(e,function(e,i,r){return n(t)?o=o.editObjectAtIndex(r,function(){return e.removeAttribute(t)}):i[0]!==i[1]?o=o.editObjectAtIndex(r,function(){return e.copyWithText(e.text.removeAttributeAtRange(t,i))}):void 0}),new this.constructor(o)},c.prototype.updateAttributesForAttachment=function(t,e){var n,o,i,r;return i=(o=this.getRangeOfAttachment(e))[0],n=this.locationFromPosition(i).index,r=this.getTextAtIndex(n),new this.constructor(this.blockList.editObjectAtIndex(n,function(n){return n.copyWithText(r.updateAttributesForAttachment(t,e))}))},c.prototype.removeAttributeForAttachment=function(t,e){var n;return n=this.getRangeOfAttachment(e),this.removeAttributeAtRange(t,n)},c.prototype.insertBlockBreakAtRange=function(t){var n,i,r,s;return s=(t=o(t))[0],r=this.locationFromPosition(s).offset,i=this.removeTextAtRange(t),0===r&&(n=[new e.Block]),new this.constructor(i.blockList.insertSplittableListAtPosition(new e.SplittableList(n),s))},c.prototype.applyBlockAttributeAtRange=function(t,e,o){var i,r,s,a;return s=this.expandRangeToLineBreaksAndSplitBlocks(o),r=s.document,o=s.range,i=n(t),i.listAttribute?(r=r.removeLastListAttributeAtRange(o,{exceptAttributeName:t}),a=r.convertLineBreaksToBlockBreaksInRange(o),r=a.document,o=a.range):r=i.terminal?r.removeLastTerminalAttributeAtRange(o):r.consolidateBlocksAtRange(o),r.addAttributeAtRange(t,e,o)},c.prototype.removeLastListAttributeAtRange=function(t,e){var o;return null==e&&(e={}),o=this.blockList,this.eachBlockAtRange(t,function(t,i,r){var s;if((s=t.getLastAttribute())&&n(s).listAttribute&&s!==e.exceptAttributeName)return o=o.editObjectAtIndex(r,function(){return t.removeAttribute(s)})}),new this.constructor(o)},c.prototype.removeLastTerminalAttributeAtRange=function(t){var e;return e=this.blockList,this.eachBlockAtRange(t,function(t,o,i){var r;if((r=t.getLastAttribute())&&n(r).terminal)return e=e.editObjectAtIndex(i,function(){return t.removeAttribute(r)})}),new this.constructor(e)},c.prototype.firstBlockInRangeIsEntirelySelected=function(t){var e,n,i,r,s,a;return r=t=o(t),a=r[0],e=r[1],n=this.locationFromPosition(a),s=this.locationFromPosition(e),0===n.offset&&n.index<s.index?!0:n.index===s.index?(i=this.getBlockAtIndex(n.index).getLength(),0===n.offset&&s.offset===i):!1},c.prototype.expandRangeToLineBreaksAndSplitBlocks=function(t){var e,n,i,r,s,a,u,c,l;return a=t=o(t),l=a[0],r=a[1],c=this.locationFromPosition(l),i=this.locationFromPosition(r),e=this,u=e.getBlockAtIndex(c.index),null!=(c.offset=u.findLineBreakInDirectionFromPosition("backward",c.offset))&&(s=e.positionFromLocation(c),e=e.insertBlockBreakAtRange([s,s+1]),i.index+=1,i.offset-=e.getBlockAtIndex(c.index).getLength(),c.index+=1),c.offset=0,0===i.offset&&i.index>c.index?(i.index-=1,i.offset=e.getBlockAtIndex(i.index).getBlockBreakPosition()):(n=e.getBlockAtIndex(i.index),"\n"===n.text.getStringAtRange([i.offset-1,i.offset])?i.offset-=1:i.offset=n.findLineBreakInDirectionFromPosition("forward",i.offset),i.offset!==n.getBlockBreakPosition()&&(s=e.positionFromLocation(i),e=e.insertBlockBreakAtRange([s,s+1]))),l=e.positionFromLocation(c),r=e.positionFromLocation(i),t=o([l,r]),{document:e,range:t}},c.prototype.convertLineBreaksToBlockBreaksInRange=function(t){var e,n,i;return n=(t=o(t))[0],i=this.getStringAtRange(t).slice(0,-1),e=this,i.replace(/.*?\n/g,function(t){return n+=t.length,e=e.insertBlockBreakAtRange([n-1,n])}),{document:e,range:t}},c.prototype.consolidateBlocksAtRange=function(t){var e,n,i,r,s;return i=t=o(t),s=i[0],n=i[1],r=this.locationFromPosition(s).index,e=this.locationFromPosition(n).index,new this.constructor(this.blockList.consolidateFromIndexToIndex(r,e))},c.prototype.getDocumentAtRange=function(t){var e;return t=o(t),e=this.blockList.getSplittableListInRange(t).toArray(),new this.constructor(e)},c.prototype.getStringAtRange=function(t){var e,n,i;return i=t=o(t),n=i[i.length-1],n!==this.getLength()&&(e=-1),this.getDocumentAtRange(t).toString().slice(0,e)},c.prototype.getBlockAtIndex=function(t){return this.blockList.getObjectAtIndex(t)},c.prototype.getBlockAtPosition=function(t){var e;return e=this.locationFromPosition(t).index,this.getBlockAtIndex(e)},c.prototype.getTextAtIndex=function(t){var e;return null!=(e=this.getBlockAtIndex(t))?e.text:void 0},c.prototype.getTextAtPosition=function(t){var e;return e=this.locationFromPosition(t).index,this.getTextAtIndex(e)},c.prototype.getPieceAtPosition=function(t){var e,n,o;return o=this.locationFromPosition(t),e=o.index,n=o.offset,this.getTextAtIndex(e).getPieceAtPosition(n)},c.prototype.getCharacterAtPosition=function(t){var e,n,o;return o=this.locationFromPosition(t),e=o.index,n=o.offset,this.getTextAtIndex(e).getStringAtRange([n,n+1])},c.prototype.getLength=function(){return this.blockList.getEndPosition()},c.prototype.getBlocks=function(){return this.blockList.toArray()},c.prototype.getBlockCount=function(){return this.blockList.length},c.prototype.getEditCount=function(){return this.editCount},c.prototype.eachBlock=function(t){return this.blockList.eachObject(t)},c.prototype.eachBlockAtRange=function(t,e){var n,i,r,s,a,u,c,l,h,p,d,f;if(u=t=o(t),d=u[0],r=u[1],p=this.locationFromPosition(d),i=this.locationFromPosition(r),p.index===i.index)return n=this.getBlockAtIndex(p.index),f=[p.offset,i.offset],e(n,f,p.index);for(h=[],a=s=c=p.index,l=i.index;l>=c?l>=s:s>=l;a=l>=c?++s:--s)(n=this.getBlockAtIndex(a))?(f=function(){switch(a){case p.index:return[p.offset,n.text.getLength()];case i.index:return[0,i.offset];default:return[0,n.text.getLength()]}}(),h.push(e(n,f,a))):h.push(void 0);return h},c.prototype.getCommonAttributesAtRange=function(t){var n,r,s;return r=(t=o(t))[0],i(t)?this.getCommonAttributesAtPosition(r):(s=[],n=[],this.eachBlockAtRange(t,function(t,e){return e[0]!==e[1]?(s.push(t.text.getCommonAttributesAtRange(e)),n.push(l(t))):void 0}),e.Hash.fromCommonAttributesOfObjects(s).merge(e.Hash.fromCommonAttributesOfObjects(n)).toObject())},c.prototype.getCommonAttributesAtPosition=function(t){var n,o,i,r,s,a,c,h,p,d;if(p=this.locationFromPosition(t),s=p.index,h=p.offset,i=this.getBlockAtIndex(s),!i)return{};r=l(i),n=i.text.getAttributesAtPosition(h),o=i.text.getAttributesAtPosition(h-1),a=function(){var t,n;t=e.config.textAttributes,n=[];for(c in t)d=t[c],d.inheritable&&n.push(c);return n}();for(c in o)d=o[c],(d===n[c]||u.call(a,c)>=0)&&(r[c]=d);return r},c.prototype.getRangeOfCommonAttributeAtPosition=function(t,e){var n,i,r,s,a,u,c,l,h;return a=this.locationFromPosition(e),r=a.index,s=a.offset,h=this.getTextAtIndex(r),u=h.getExpandedRangeForAttributeAtOffset(t,s),l=u[0],i=u[1],c=this.positionFromLocation({index:r,offset:l}),n=this.positionFromLocation({index:r,offset:i}),o([c,n])},c.prototype.getBaseBlockAttributes=function(){var t,e,n,o,i,r,s;for(t=this.getBlockAtIndex(0).getAttributes(),n=o=1,s=this.getBlockCount();s>=1?s>o:o>s;n=s>=1?++o:--o)e=this.getBlockAtIndex(n).getAttributes(),r=Math.min(t.length,e.length),t=function(){var n,o,s;for(s=[],i=n=0,o=r;(o>=0?o>n:n>o)&&e[i]===t[i];i=o>=0?++n:--n)s.push(e[i]);return s}();return t},l=function(t){var e,n;return n={},(e=t.getLastAttribute())&&(n[e]=!0),n},c.prototype.getAttachmentById=function(t){var e,n,o,i;for(i=this.getAttachments(),n=0,o=i.length;o>n;n++)if(e=i[n],e.id===t)return e},c.prototype.getAttachmentPieces=function(){var t;return t=[],this.blockList.eachObject(function(e){var n;return n=e.text,t=t.concat(n.getAttachmentPieces())}),t},c.prototype.getAttachments=function(){var t,e,n,o,i;for(o=this.getAttachmentPieces(),i=[],t=0,e=o.length;e>t;t++)n=o[t],i.push(n.attachment);return i},c.prototype.getRangeOfAttachment=function(t){var e,n,i,r,s,a,u;for(r=0,s=this.blockList.toArray(),n=e=0,i=s.length;i>e;n=++e){if(a=s[n].text,u=a.getRangeOfAttachment(t))return o([r+u[0],r+u[1]]);r+=a.getLength()}},c.prototype.getLocationRangeOfAttachment=function(t){var e;return e=this.getRangeOfAttachment(t),this.locationRangeFromRange(e)},c.prototype.getAttachmentPieceForAttachment=function(t){var e,n,o,i;for(i=this.getAttachmentPieces(),e=0,n=i.length;n>e;e++)if(o=i[e],o.attachment===t)return o},c.prototype.findRangesForTextAttribute=function(t,e){var n,o,i,r,s,a,u,c,l,h;for(h=(null!=e?e:{}).withValue,a=0,u=[],c=[],r=function(e){return null!=h?e.getAttribute(t)===h:e.hasAttribute(t)},l=this.getPieces(),n=0,o=l.length;o>n;n++)s=l[n],i=s.getLength(),r(s)&&(u[1]===a?u[1]=a+i:c.push(u=[a,a+i])),a+=i;return c},c.prototype.locationFromPosition=function(t){var e,n;return n=this.blockList.findIndexAndOffsetAtPosition(Math.max(0,t)),null!=n.index?n:(e=this.getBlocks(),{index:e.length-1,offset:e[e.length-1].getLength()})},c.prototype.positionFromLocation=function(t){return this.blockList.findPositionAtIndexAndOffset(t.index,t.offset)},c.prototype.locationRangeFromPosition=function(t){return o(this.locationFromPosition(t))},c.prototype.locationRangeFromRange=function(t){var e,n,i,r;if(t=o(t))return r=t[0],n=t[1],i=this.locationFromPosition(r),e=this.locationFromPosition(n),o([i,e])},c.prototype.rangeFromLocationRange=function(t){var e,n;return t=o(t),e=this.positionFromLocation(t[0]),i(t)||(n=this.positionFromLocation(t[1])),o([e,n])},c.prototype.isEqualTo=function(t){return this.blockList.isEqualTo(null!=t?t.blockList:void 0)},c.prototype.getTexts=function(){var t,e,n,o,i;for(o=this.getBlocks(),i=[],e=0,n=o.length;n>e;e++)t=o[e],i.push(t.text);return i},c.prototype.getPieces=function(){var t,e,n,o,i;for(n=[],o=this.getTexts(),t=0,e=o.length;e>t;t++)i=o[t],n.push.apply(n,i.getPieces());return n},c.prototype.getObjects=function(){return this.getBlocks().concat(this.getTexts()).concat(this.getPieces())},c.prototype.toSerializableDocument=function(){var t;return t=[],this.blockList.eachObject(function(e){return t.push(e.copyWithText(e.text.toSerializableText()))}),new this.constructor(t)},c.prototype.toString=function(){return this.blockList.toString()},c.prototype.toJSON=function(){return this.blockList.toJSON()},c.prototype.toConsole=function(){var t;return JSON.stringify(function(){var e,n,o,i;for(o=this.blockList.toArray(),i=[],e=0,n=o.length;n>e;e++)t=o[e],i.push(JSON.parse(t.text.toConsole()));return i}.call(this))},c}(e.Object)}.call(this),function(){e.LineBreakInsertion=function(){function t(t){var e;this.composition=t,this.document=this.composition.document,e=this.composition.getSelectedRange(),this.startPosition=e[0],this.endPosition=e[1],this.startLocation=this.document.locationFromPosition(this.startPosition),this.endLocation=this.document.locationFromPosition(this.endPosition),this.block=this.document.getBlockAtIndex(this.endLocation.index),this.breaksOnReturn=this.block.breaksOnReturn(),this.previousCharacter=this.block.text.getStringAtPosition(this.endLocation.offset-1),this.nextCharacter=this.block.text.getStringAtPosition(this.endLocation.offset)}return t.prototype.shouldInsertBlockBreak=function(){return this.block.hasAttributes()&&this.block.isListItem()&&!this.block.isEmpty()?0!==this.startLocation.offset:this.breaksOnReturn&&"\n"!==this.nextCharacter},t.prototype.shouldBreakFormattedBlock=function(){return this.block.hasAttributes()&&!this.block.isListItem()&&(this.breaksOnReturn&&"\n"===this.nextCharacter||"\n"===this.previousCharacter)},t.prototype.shouldDecreaseListLevel=function(){return this.block.hasAttributes()&&this.block.isListItem()&&this.block.isEmpty()},t.prototype.shouldPrependListItem=function(){return this.block.isListItem()&&0===this.startLocation.offset&&!this.block.isEmpty()},t.prototype.shouldRemoveLastBlockAttribute=function(){return this.block.hasAttributes()&&!this.block.isListItem()&&this.block.isEmpty()},t}()}.call(this),function(){var t,n,o,i,r,s,a,u,c,l,h=function(t,e){function n(){this.constructor=t}for(var o in e)p.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},p={}.hasOwnProperty;s=e.normalizeRange,c=e.rangesAreEqual,u=e.rangeIsCollapsed,a=e.objectsAreEqual,t=e.arrayStartsWith,l=e.summarizeArrayChange,o=e.getAllAttributeNames,i=e.getBlockConfig,r=e.getTextConfig,n=e.extend,e.Composition=function(p){function d(){this.document=new e.Document,this.attachments=[],this.currentAttributes={},this.revision=0}var f;return h(d,p),d.prototype.setDocument=function(t){var e;return t.isEqualTo(this.document)?void 0:(this.document=t,this.refreshAttachments(),this.revision++,null!=(e=this.delegate)&&"function"==typeof e.compositionDidChangeDocument?e.compositionDidChangeDocument(t):void 0)},d.prototype.getSnapshot=function(){return{document:this.document,selectedRange:this.getSelectedRange()}},d.prototype.loadSnapshot=function(t){var n,o,i,r;return n=t.document,r=t.selectedRange,null!=(o=this.delegate)&&"function"==typeof o.compositionWillLoadSnapshot&&o.compositionWillLoadSnapshot(),this.setDocument(null!=n?n:new e.Document),this.setSelection(null!=r?r:[0,0]),null!=(i=this.delegate)&&"function"==typeof i.compositionDidLoadSnapshot?i.compositionDidLoadSnapshot():void 0},d.prototype.insertText=function(t,e){var n,o,i,r;return r=(null!=e?e:{updatePosition:!0}).updatePosition,o=this.getSelectedRange(),this.setDocument(this.document.insertTextAtRange(t,o)),i=o[0],n=i+t.getLength(),r&&this.setSelection(n),this.notifyDelegateOfInsertionAtRange([i,n])},d.prototype.insertBlock=function(t){var n;return null==t&&(t=new e.Block),n=new e.Document([t]),this.insertDocument(n)},d.prototype.insertDocument=function(t){var n,o,i;return null==t&&(t=new e.Document),o=this.getSelectedRange(),this.setDocument(this.document.insertDocumentAtRange(t,o)),i=o[0],n=i+t.getLength(),this.setSelection(n),this.notifyDelegateOfInsertionAtRange([i,n])},d.prototype.insertString=function(t,n){var o,i;return o=this.getCurrentTextAttributes(),i=e.Text.textForStringWithAttributes(t,o),this.insertText(i,n)},d.prototype.insertBlockBreak=function(){var t,e,n;return e=this.getSelectedRange(),this.setDocument(this.document.insertBlockBreakAtRange(e)),n=e[0],t=n+1,this.setSelection(t),this.notifyDelegateOfInsertionAtRange([n,t])},d.prototype.insertLineBreak=function(){var t,n;return n=new e.LineBreakInsertion(this),n.shouldDecreaseListLevel()?(this.decreaseListLevel(),this.setSelection(n.startPosition)):n.shouldPrependListItem()?(t=new e.Document([n.block.copyWithoutText()]),this.insertDocument(t)):n.shouldInsertBlockBreak()?this.insertBlockBreak():n.shouldRemoveLastBlockAttribute()?this.removeLastBlockAttribute():n.shouldBreakFormattedBlock()?this.breakFormattedBlock(n):this.insertString("\n")},d.prototype.insertHTML=function(t){var n,o,i,r,s;return s=this.getPosition(),r=this.document.getLength(),n=e.Document.fromHTML(t),this.setDocument(this.document.mergeDocumentAtRange(n,this.getSelectedRange())),o=this.document.getLength(),i=s+(o-r),this.setSelection(i),this.notifyDelegateOfInsertionAtRange([s,i])},d.prototype.replaceHTML=function(t){var n,o,i;return n=e.Document.fromHTML(t).copyUsingObjectsFromDocument(this.document),o=this.getLocationRange({strict:!1}),i=this.document.rangeFromLocationRange(o),this.setDocument(n),this.setSelection(i)},d.prototype.insertFile=function(t){var n,o;return(null!=(o=this.delegate)?o.compositionShouldAcceptFile(t):void 0)?(n=e.Attachment.attachmentForFile(t),this.insertAttachment(n)):void 0},d.prototype.insertFiles=function(t){var n,o,i,r,s,a,u;for(u=new e.Text,r=0,s=t.length;s>r;r++)i=t[r],(null!=(a=this.delegate)?a.compositionShouldAcceptFile(i):void 0)&&(n=e.Attachment.attachmentForFile(i),o=e.Text.textForAttachmentWithAttributes(n,this.currentAttributes),u=u.appendText(o));return this.insertText(u)},d.prototype.insertAttachment=function(t){var n;return n=e.Text.textForAttachmentWithAttributes(t,this.currentAttributes),this.insertText(n)},d.prototype.deleteInDirection=function(t){var e,n,o,i,r,s,a;return i=this.getLocationRange(),r=this.getSelectedRange(),s=u(r),s?o="backward"===t&&0===i[0].offset:a=i[0].index!==i[1].index,o&&this.canDecreaseBlockAttributeLevel()&&(n=this.getBlock(),n.isListItem()?this.decreaseListLevel():this.decreaseBlockAttributeLevel(),this.setSelection(r[0]),n.isEmpty())?!1:(s&&(r=this.getExpandedRangeInDirection(t),"backward"===t&&(e=this.getAttachmentAtRange(r))),e?(this.editAttachment(e),!1):(this.setDocument(this.document.removeTextAtRange(r)),this.setSelection(r[0]),o||a?!1:void 0))},d.prototype.moveTextFromRange=function(t){var e;return e=this.getSelectedRange()[0],this.setDocument(this.document.moveTextFromRangeToPosition(t,e)),this.setSelection(e)},d.prototype.removeAttachment=function(t){var e;return(e=this.document.getRangeOfAttachment(t))?(this.stopEditingAttachment(),this.setDocument(this.document.removeTextAtRange(e)),this.setSelection(e[0])):void 0},d.prototype.removeLastBlockAttribute=function(){var t,e,n,o;return n=this.getSelectedRange(),o=n[0],e=n[1],t=this.document.getBlockAtPosition(e),this.removeCurrentAttribute(t.getLastAttribute()),this.setSelection(o)},f=" ",d.prototype.insertPlaceholder=function(){return this.placeholderPosition=this.getPosition(),this.insertString(f)},d.prototype.selectPlaceholder=function(){return null!=this.placeholderPosition?(this.setSelectedRange([this.placeholderPosition,this.placeholderPosition+f.length]),this.getSelectedRange()):void 0},d.prototype.forgetPlaceholder=function(){return this.placeholderPosition=null},d.prototype.hasCurrentAttribute=function(t){var e;return e=this.currentAttributes[t],null!=e&&e!==!1},d.prototype.toggleCurrentAttribute=function(t){var e;return(e=!this.currentAttributes[t])?this.setCurrentAttribute(t,e):this.removeCurrentAttribute(t)},d.prototype.canSetCurrentAttribute=function(t){return i(t)?this.canSetCurrentBlockAttribute(t):this.canSetCurrentTextAttribute(t)},d.prototype.canSetCurrentTextAttribute=function(t){switch(t){case"href":return!this.selectionContainsAttachmentWithAttribute(t);default:return!0}},d.prototype.canSetCurrentBlockAttribute=function(){var t;if(t=this.getBlock())return!t.isTerminalBlock()},d.prototype.setCurrentAttribute=function(t,e){return i(t)?this.setBlockAttribute(t,e):(this.setTextAttribute(t,e),this.currentAttributes[t]=e,this.notifyDelegateOfCurrentAttributesChange())},d.prototype.setTextAttribute=function(t,n){var o,i,r,s;if(i=this.getSelectedRange())return r=i[0],o=i[1],r!==o?this.setDocument(this.document.addAttributeAtRange(t,n,i)):"href"===t?(s=e.Text.textForStringWithAttributes(n,{href:n}),this.insertText(s)):void 0},d.prototype.setBlockAttribute=function(t,e){var n,o;if(o=this.getSelectedRange())return this.canSetCurrentAttribute(t)?(n=this.getBlock(),this.setDocument(this.document.applyBlockAttributeAtRange(t,e,o)),this.setSelection(o)):void 0},d.prototype.removeCurrentAttribute=function(t){return i(t)?(this.removeBlockAttribute(t),this.updateCurrentAttributes()):(this.removeTextAttribute(t),delete this.currentAttributes[t],this.notifyDelegateOfCurrentAttributesChange())},d.prototype.removeTextAttribute=function(t){var e;if(e=this.getSelectedRange())return this.setDocument(this.document.removeAttributeAtRange(t,e))},d.prototype.removeBlockAttribute=function(t){var e;if(e=this.getSelectedRange())return this.setDocument(this.document.removeAttributeAtRange(t,e))},d.prototype.canDecreaseNestingLevel=function(){var t;return(null!=(t=this.getBlock())?t.getNestingLevel():void 0)>0},d.prototype.canIncreaseNestingLevel=function(){var e,n,o;if(e=this.getBlock())return(null!=(o=i(e.getLastNestableAttribute()))?o.listAttribute:0)?(n=this.getPreviousBlock())?t(n.getListItemAttributes(),e.getListItemAttributes()):void 0:e.getNestingLevel()>0},d.prototype.decreaseNestingLevel=function(){var t;if(t=this.getBlock())return this.setDocument(this.document.replaceBlock(t,t.decreaseNestingLevel()))},d.prototype.increaseNestingLevel=function(){var t;if(t=this.getBlock())return this.setDocument(this.document.replaceBlock(t,t.increaseNestingLevel()))},d.prototype.canDecreaseBlockAttributeLevel=function(){var t;return(null!=(t=this.getBlock())?t.getAttributeLevel():void 0)>0},d.prototype.decreaseBlockAttributeLevel=function(){var t,e;return(t=null!=(e=this.getBlock())?e.getLastAttribute():void 0)?this.removeCurrentAttribute(t):void 0},d.prototype.decreaseListLevel=function(){var t,e,n,o,i,r;for(r=this.getSelectedRange()[0],i=this.document.locationFromPosition(r).index,n=i,t=this.getBlock().getAttributeLevel();(e=this.document.getBlockAtIndex(n+1))&&e.isListItem()&&e.getAttributeLevel()>t;)n++;return r=this.document.positionFromLocation({index:i,offset:0}),o=this.document.positionFromLocation({index:n,offset:0}),this.setDocument(this.document.removeLastListAttributeAtRange([r,o]))},d.prototype.updateCurrentAttributes=function(){var t,e,n,i,r,s;if(s=this.getSelectedRange({ignoreLock:!0})){for(e=this.document.getCommonAttributesAtRange(s),r=o(),n=0,i=r.length;i>n;n++)t=r[n],e[t]||this.canSetCurrentAttribute(t)||(e[t]=!1);if(!a(e,this.currentAttributes))return this.currentAttributes=e,this.notifyDelegateOfCurrentAttributesChange()}},d.prototype.getCurrentAttributes=function(){return n.call({},this.currentAttributes)},d.prototype.getCurrentTextAttributes=function(){var t,e,n,o;t={},n=this.currentAttributes;for(e in n)o=n[e],r(e)&&(t[e]=o);return t},d.prototype.freezeSelection=function(){return this.setCurrentAttribute("frozen",!0)},d.prototype.thawSelection=function(){return this.removeCurrentAttribute("frozen")},d.prototype.hasFrozenSelection=function(){return this.hasCurrentAttribute("frozen")},d.proxyMethod("getSelectionManager().getPointRange"),d.proxyMethod("getSelectionManager().setLocationRangeFromPointRange"),d.proxyMethod("getSelectionManager().locationIsCursorTarget"),d.proxyMethod("getSelectionManager().selectionIsExpanded"),d.proxyMethod("delegate?.getSelectionManager"),d.prototype.setSelection=function(t){var e,n;return e=this.document.locationRangeFromRange(t),null!=(n=this.delegate)?n.compositionDidRequestChangingSelectionToLocationRange(e):void 0},d.prototype.getSelectedRange=function(){var t;return(t=this.getLocationRange())?this.document.rangeFromLocationRange(t):void 0},d.prototype.setSelectedRange=function(t){var e;return e=this.document.locationRangeFromRange(t),this.getSelectionManager().setLocationRange(e)},d.prototype.getPosition=function(){var t;return(t=this.getLocationRange())?this.document.positionFromLocation(t[0]):void 0},d.prototype.getLocationRange=function(t){var e;return null!=(e=this.getSelectionManager().getLocationRange(t))?e:s({index:0,offset:0})},d.prototype.getExpandedRangeInDirection=function(t){var e,n,o;return n=this.getSelectedRange(),o=n[0],e=n[1],"backward"===t?o=this.translateUTF16PositionFromOffset(o,-1):e=this.translateUTF16PositionFromOffset(e,1),s([o,e])},d.prototype.moveCursorInDirection=function(t){var e,n,o,i;return this.editingAttachment?o=this.document.getRangeOfAttachment(this.editingAttachment):(i=this.getSelectedRange(),o=this.getExpandedRangeInDirection(t),n=!c(i,o)),this.setSelectedRange("backward"===t?o[0]:o[1]),n&&(e=this.getAttachmentAtRange(o))?this.editAttachment(e):void 0},d.prototype.expandSelectionInDirection=function(t){var e;return e=this.getExpandedRangeInDirection(t),this.setSelectedRange(e)},d.prototype.expandSelectionForEditing=function(){return this.hasCurrentAttribute("href")?this.expandSelectionAroundCommonAttribute("href"):void 0},d.prototype.expandSelectionAroundCommonAttribute=function(t){var e,n;return e=this.getPosition(),n=this.document.getRangeOfCommonAttributeAtPosition(t,e),this.setSelectedRange(n)},d.prototype.selectionContainsAttachmentWithAttribute=function(t){var e,n,o,i,r;if(r=this.getSelectedRange()){for(i=this.document.getDocumentAtRange(r).getAttachments(),n=0,o=i.length;o>n;n++)if(e=i[n],e.hasAttribute(t))return!0;return!1}},d.prototype.selectionIsInCursorTarget=function(){return this.editingAttachment||this.positionIsCursorTarget(this.getPosition())},d.prototype.positionIsCursorTarget=function(t){var e;return(e=this.document.locationFromPosition(t))?this.locationIsCursorTarget(e):void 0},d.prototype.positionIsBlockBreak=function(t){var e;return null!=(e=this.document.getPieceAtPosition(t))?e.isBlockBreak():void 0},d.prototype.getSelectedDocument=function(){var t;return(t=this.getSelectedRange())?this.document.getDocumentAtRange(t):void 0},d.prototype.getAttachments=function(){return this.attachments.slice(0)},d.prototype.refreshAttachments=function(){var t,e,n,o,i,r,s,a,u,c,h,p;for(n=this.document.getAttachments(),a=l(this.attachments,n),t=a.added,h=a.removed,this.attachments=n,o=0,r=h.length;r>o;o++)e=h[o],e.delegate=null,null!=(u=this.delegate)&&"function"==typeof u.compositionDidRemoveAttachment&&u.compositionDidRemoveAttachment(e);for(p=[],i=0,s=t.length;s>i;i++)e=t[i],e.delegate=this,p.push(null!=(c=this.delegate)&&"function"==typeof c.compositionDidAddAttachment?c.compositionDidAddAttachment(e):void 0);return p},d.prototype.attachmentDidChangeAttributes=function(t){var e;return this.revision++,null!=(e=this.delegate)&&"function"==typeof e.compositionDidEditAttachment?e.compositionDidEditAttachment(t):void 0},d.prototype.attachmentDidChangePreviewURL=function(t){var e;return this.revision++,null!=(e=this.delegate)&&"function"==typeof e.compositionDidChangeAttachmentPreviewURL?e.compositionDidChangeAttachmentPreviewURL(t):void 0},d.prototype.editAttachment=function(t){var e;if(t!==this.editingAttachment)return this.stopEditingAttachment(),this.editingAttachment=t,null!=(e=this.delegate)&&"function"==typeof e.compositionDidStartEditingAttachment?e.compositionDidStartEditingAttachment(this.editingAttachment):void 0},d.prototype.stopEditingAttachment=function(){var t;if(this.editingAttachment)return null!=(t=this.delegate)&&"function"==typeof t.compositionDidStopEditingAttachment&&t.compositionDidStopEditingAttachment(this.editingAttachment),this.editingAttachment=null},d.prototype.canEditAttachmentCaption=function(){var t;return null!=(t=this.editingAttachment)?t.isPreviewable():void 0},d.prototype.updateAttributesForAttachment=function(t,e){return this.setDocument(this.document.updateAttributesForAttachment(t,e))},d.prototype.removeAttributeForAttachment=function(t,e){return this.setDocument(this.document.removeAttributeForAttachment(t,e))},d.prototype.breakFormattedBlock=function(t){var n,o,i,r,s;return o=t.document,n=t.block,r=t.startPosition,s=[r-1,r],n.getBlockBreakPosition()===t.startLocation.offset?(n.breaksOnReturn()&&"\n"===t.nextCharacter?r+=1:o=o.removeTextAtRange(s),s=[r,r]):"\n"===t.nextCharacter?"\n"===t.previousCharacter?s=[r-1,r+1]:(s=[r,r+1],r+=1):t.startLocation.offset-1!==0&&(r+=1),i=new e.Document([n.removeLastAttribute().copyWithoutText()]),this.setDocument(o.insertDocumentAtRange(i,s)),this.setSelection(r)},d.prototype.getPreviousBlock=function(){var t,e;return(e=this.getLocationRange())&&(t=e[0].index,t>0)?this.document.getBlockAtIndex(t-1):void 0},d.prototype.getBlock=function(){var t;return(t=this.getLocationRange())?this.document.getBlockAtIndex(t[0].index):void 0},d.prototype.getAttachmentAtRange=function(t){var n;return n=this.document.getDocumentAtRange(t),n.toString()===e.OBJECT_REPLACEMENT_CHARACTER+"\n"?n.getAttachments()[0]:void 0},d.prototype.notifyDelegateOfCurrentAttributesChange=function(){var t;return null!=(t=this.delegate)&&"function"==typeof t.compositionDidChangeCurrentAttributes?t.compositionDidChangeCurrentAttributes(this.currentAttributes):void 0},d.prototype.notifyDelegateOfInsertionAtRange=function(t){var e;return null!=(e=this.delegate)&&"function"==typeof e.compositionDidPerformInsertionAtRange?e.compositionDidPerformInsertionAtRange(t):void 0},d.prototype.translateUTF16PositionFromOffset=function(t,e){var n,o;return o=this.document.toUTF16String(),n=o.offsetFromUCS2Offset(t),o.offsetToUCS2Offset(n+e)},d}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.UndoManager=function(e){function n(t){this.composition=t,this.undoEntries=[],this.redoEntries=[]}var o;return t(n,e),n.prototype.recordUndoEntry=function(t,e){var n,i,r,s,a;return s=null!=e?e:{},i=s.context,n=s.consolidatable,r=this.undoEntries.slice(-1)[0],n&&o(r,t,i)?void 0:(a=this.createEntry({description:t,context:i}),this.undoEntries.push(a),this.redoEntries=[])},n.prototype.undo=function(){var t,e;return(e=this.undoEntries.pop())?(t=this.createEntry(e),this.redoEntries.push(t),this.composition.loadSnapshot(e.snapshot)):void 0},n.prototype.redo=function(){var t,e;return(t=this.redoEntries.pop())?(e=this.createEntry(t),this.undoEntries.push(e),this.composition.loadSnapshot(t.snapshot)):void 0},n.prototype.canUndo=function(){return this.undoEntries.length>0},n.prototype.canRedo=function(){return this.redoEntries.length>0},n.prototype.createEntry=function(t){var e,n,o;return o=null!=t?t:{},n=o.description,e=o.context,{description:null!=n?n.toString():void 0,context:JSON.stringify(e),snapshot:this.composition.getSnapshot()}},o=function(t,e,n){return(null!=t?t.description:void 0)===(null!=e?e.toString():void 0)&&(null!=t?t.context:void 0)===JSON.stringify(n)},n}(e.BasicObject)}.call(this),function(){e.Editor=function(){function t(t,n,o){this.composition=t,this.selectionManager=n,this.element=o,this.undoManager=new e.UndoManager(this.composition)}return t.prototype.loadDocument=function(t){return this.loadSnapshot({document:t,selectedRange:[0,0]})},t.prototype.loadHTML=function(t){return null==t&&(t=""),this.loadDocument(e.Document.fromHTML(t,{referenceElement:this.element}))},t.prototype.loadJSON=function(t){var n,o;return n=t.document,o=t.selectedRange,n=e.Document.fromJSON(n),this.loadSnapshot({document:n,selectedRange:o})},t.prototype.loadSnapshot=function(t){return this.undoManager=new e.UndoManager(this.composition),this.composition.loadSnapshot(t)},t.prototype.getDocument=function(){return this.composition.document},t.prototype.getSelectedDocument=function(){return this.composition.getSelectedDocument()},t.prototype.getSnapshot=function(){return this.composition.getSnapshot()},t.prototype.toJSON=function(){return this.getSnapshot()},t.prototype.deleteInDirection=function(t){return this.composition.deleteInDirection(t)},t.prototype.insertAttachment=function(t){return this.composition.insertAttachment(t)},t.prototype.insertDocument=function(t){return this.composition.insertDocument(t)},t.prototype.insertFile=function(t){return this.composition.insertFile(t)},t.prototype.insertHTML=function(t){return this.composition.insertHTML(t)},t.prototype.insertString=function(t){return this.composition.insertString(t)},t.prototype.insertText=function(t){return this.composition.insertText(t)},t.prototype.insertLineBreak=function(){return this.composition.insertLineBreak()},t.prototype.getSelectedRange=function(){return this.composition.getSelectedRange()
},t.prototype.getPosition=function(){return this.composition.getPosition()},t.prototype.getClientRectAtPosition=function(t){var e;return e=this.getDocument().locationRangeFromRange([t,t+1]),this.selectionManager.getClientRectAtLocationRange(e)},t.prototype.expandSelectionInDirection=function(t){return this.composition.expandSelectionInDirection(t)},t.prototype.moveCursorInDirection=function(t){return this.composition.moveCursorInDirection(t)},t.prototype.setSelectedRange=function(t){return this.composition.setSelectedRange(t)},t.prototype.activateAttribute=function(t,e){return null==e&&(e=!0),this.composition.setCurrentAttribute(t,e)},t.prototype.attributeIsActive=function(t){return this.composition.hasCurrentAttribute(t)},t.prototype.canActivateAttribute=function(t){return this.composition.canSetCurrentAttribute(t)},t.prototype.deactivateAttribute=function(t){return this.composition.removeCurrentAttribute(t)},t.prototype.canDecreaseNestingLevel=function(){return this.composition.canDecreaseNestingLevel()},t.prototype.canIncreaseNestingLevel=function(){return this.composition.canIncreaseNestingLevel()},t.prototype.decreaseNestingLevel=function(){return this.canDecreaseNestingLevel()?this.composition.decreaseNestingLevel():void 0},t.prototype.increaseNestingLevel=function(){return this.canIncreaseNestingLevel()?this.composition.increaseNestingLevel():void 0},t.prototype.canDecreaseIndentationLevel=function(){return this.canDecreaseNestingLevel()},t.prototype.canIncreaseIndentationLevel=function(){return this.canIncreaseNestingLevel()},t.prototype.decreaseIndentationLevel=function(){return this.decreaseNestingLevel()},t.prototype.increaseIndentationLevel=function(){return this.increaseNestingLevel()},t.prototype.canRedo=function(){return this.undoManager.canRedo()},t.prototype.canUndo=function(){return this.undoManager.canUndo()},t.prototype.recordUndoEntry=function(t,e){var n,o,i;return i=null!=e?e:{},o=i.context,n=i.consolidatable,this.undoManager.recordUndoEntry(t,{context:o,consolidatable:n})},t.prototype.redo=function(){return this.canRedo()?this.undoManager.redo():void 0},t.prototype.undo=function(){return this.canUndo()?this.undoManager.undo():void 0},t}()}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.ManagedAttachment=function(e){function n(t,e){var n;this.attachmentManager=t,this.attachment=e,n=this.attachment,this.id=n.id,this.file=n.file}return t(n,e),n.prototype.remove=function(){return this.attachmentManager.requestRemovalOfAttachment(this.attachment)},n.proxyMethod("attachment.getAttribute"),n.proxyMethod("attachment.hasAttribute"),n.proxyMethod("attachment.setAttribute"),n.proxyMethod("attachment.getAttributes"),n.proxyMethod("attachment.setAttributes"),n.proxyMethod("attachment.isPending"),n.proxyMethod("attachment.isPreviewable"),n.proxyMethod("attachment.getURL"),n.proxyMethod("attachment.getHref"),n.proxyMethod("attachment.getFilename"),n.proxyMethod("attachment.getFilesize"),n.proxyMethod("attachment.getFormattedFilesize"),n.proxyMethod("attachment.getExtension"),n.proxyMethod("attachment.getContentType"),n.proxyMethod("attachment.getFile"),n.proxyMethod("attachment.setFile"),n.proxyMethod("attachment.releaseFile"),n.proxyMethod("attachment.getUploadProgress"),n.proxyMethod("attachment.setUploadProgress"),n}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.AttachmentManager=function(n){function o(t){var e,n,o;for(null==t&&(t=[]),this.managedAttachments={},n=0,o=t.length;o>n;n++)e=t[n],this.manageAttachment(e)}return t(o,n),o.prototype.getAttachments=function(){var t,e,n,o;n=this.managedAttachments,o=[];for(e in n)t=n[e],o.push(t);return o},o.prototype.manageAttachment=function(t){var n,o;return null!=(n=this.managedAttachments)[o=t.id]?n[o]:n[o]=new e.ManagedAttachment(this,t)},o.prototype.attachmentIsManaged=function(t){return t.id in this.managedAttachments},o.prototype.requestRemovalOfAttachment=function(t){var e;return this.attachmentIsManaged(t)&&null!=(e=this.delegate)&&"function"==typeof e.attachmentManagerDidRequestRemovalOfAttachment?e.attachmentManagerDidRequestRemovalOfAttachment(t):void 0},o.prototype.unmanageAttachment=function(t){var e;return e=this.managedAttachments[t.id],delete this.managedAttachments[t.id],e},o}(e.BasicObject)}.call(this),function(){var t,n,o,i,r,s,a,u,c,l,h;t=e.elementContainsNode,n=e.findChildIndexOfNode,r=e.nodeIsBlockStart,s=e.nodeIsBlockStartComment,i=e.nodeIsBlockContainer,a=e.nodeIsCursorTarget,u=e.nodeIsEmptyTextNode,c=e.nodeIsTextNode,o=e.nodeIsAttachmentElement,l=e.tagName,h=e.walkTree,e.LocationMapper=function(){function e(t){this.element=t}var p,d,f,g;return e.prototype.findLocationFromContainerAndOffset=function(e,o,i){var s,u,l,p,g,m,y;for(m=(null!=i?i:{strict:!0}).strict,u=0,l=!1,p={index:0,offset:0},(s=this.findAttachmentElementParentForNode(e))&&(e=s.parentNode,o=n(s)),y=h(this.element,{usingFilter:f});y.nextNode();){if(g=y.currentNode,g===e&&c(e)){a(g)||(p.offset+=o);break}if(g.parentNode===e){if(u++===o)break}else if(!t(e,g)&&u>0)break;r(g,{strict:m})?(l&&p.index++,p.offset=0,l=!0):p.offset+=d(g)}return p},e.prototype.findContainerAndOffsetFromLocation=function(t){var e,o,s,a,u,l;if(0===t.index&&0===t.offset){for(e=this.element,a=0;e.firstChild;)if(e=e.firstChild,i(e)){a=1;break}return[e,a]}if(u=this.findNodeAndOffsetFromLocation(t),o=u[0],s=u[1],o){if(c(o))e=o,l=o.textContent,a=t.offset-s;else{if(e=o.parentNode,!r(o.previousSibling)&&!i(e))for(;o===e.lastChild&&(o=e,e=e.parentNode,!i(e)););a=n(o),0!==t.offset&&a++}return[e,a]}},e.prototype.findNodeAndOffsetFromLocation=function(t){var e,n,o,i,r,s,u,l;for(u=0,l=this.getSignificantNodesForIndex(t.index),n=0,o=l.length;o>n;n++){if(e=l[n],i=d(e),t.offset<=u+i)if(c(e)){if(r=e,s=u,t.offset===s&&a(r))break}else r||(r=e,s=u);if(u+=i,u>t.offset)break}return[r,s]},e.prototype.findAttachmentElementParentForNode=function(t){for(;t&&t!==this.element;){if(o(t))return t;t=t.parentNode}},e.prototype.getSignificantNodesForIndex=function(t){var e,n,o,i,r;for(o=[],r=h(this.element,{usingFilter:p}),i=!1;r.nextNode();)if(n=r.currentNode,s(n)){if("undefined"!=typeof e&&null!==e?e++:e=0,e===t)i=!0;else if(i)break}else i&&o.push(n);return o},d=function(t){var e;return t.nodeType===Node.TEXT_NODE?a(t)?0:(e=t.textContent,e.length):"br"===l(t)||o(t)?1:0},p=function(t){return g(t)===NodeFilter.FILTER_ACCEPT?f(t):NodeFilter.FILTER_REJECT},g=function(t){return u(t)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT},f=function(t){return o(t.parentNode)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT},e}()}.call(this),function(){var t,n,o=[].slice;t=e.getDOMRange,n=e.setDOMRange,e.PointMapper=function(){function e(){}return e.prototype.createDOMRangeFromPoint=function(e){var o,i,r,s,a,u,c,l;if(c=e.x,l=e.y,document.caretPositionFromPoint)return a=document.caretPositionFromPoint(c,l),r=a.offsetNode,i=a.offset,o=document.createRange(),o.setStart(r,i),o;if(document.caretRangeFromPoint)return document.caretRangeFromPoint(c,l);if(document.body.createTextRange){s=t();try{u=document.body.createTextRange(),u.moveToPoint(c,l),u.select()}catch(h){}return o=t(),n(s),o}},e.prototype.getClientRectsForDOMRange=function(t){var e,n,i;return n=o.call(t.getClientRects()),i=n[0],e=n[n.length-1],[i,e]},e}()}.call(this),function(){var t,n=function(t,e){return function(){return t.apply(e,arguments)}},o=function(t,e){function n(){this.constructor=t}for(var o in e)i.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},i={}.hasOwnProperty,r=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.getDOMRange,e.SelectionChangeObserver=function(e){function i(){this.run=n(this.run,this),this.update=n(this.update,this),this.selectionManagers=[]}var s;return o(i,e),i.prototype.start=function(){return this.started?void 0:(this.started=!0,"onselectionchange"in document?document.addEventListener("selectionchange",this.update,!0):this.run())},i.prototype.stop=function(){return this.started?(this.started=!1,document.removeEventListener("selectionchange",this.update,!0)):void 0},i.prototype.registerSelectionManager=function(t){return r.call(this.selectionManagers,t)<0?(this.selectionManagers.push(t),this.start()):void 0},i.prototype.unregisterSelectionManager=function(t){var e;return this.selectionManagers=function(){var n,o,i,r;for(i=this.selectionManagers,r=[],n=0,o=i.length;o>n;n++)e=i[n],e!==t&&r.push(e);return r}.call(this),0===this.selectionManagers.length?this.stop():void 0},i.prototype.notifySelectionManagersOfSelectionChange=function(){var t,e,n,o,i;for(n=this.selectionManagers,o=[],t=0,e=n.length;e>t;t++)i=n[t],o.push(i.selectionDidChange());return o},i.prototype.update=function(){var e;return e=t(),s(e,this.domRange)?void 0:(this.domRange=e,this.notifySelectionManagersOfSelectionChange())},i.prototype.reset=function(){return this.domRange=null,this.update()},i.prototype.run=function(){return this.started?(this.update(),requestAnimationFrame(this.run)):void 0},s=function(t,e){return(null!=t?t.startContainer:void 0)===(null!=e?e.startContainer:void 0)&&(null!=t?t.startOffset:void 0)===(null!=e?e.startOffset:void 0)&&(null!=t?t.endContainer:void 0)===(null!=e?e.endContainer:void 0)&&(null!=t?t.endOffset:void 0)===(null!=e?e.endOffset:void 0)},i}(e.BasicObject),null==e.selectionChangeObserver&&(e.selectionChangeObserver=new e.SelectionChangeObserver)}.call(this),function(){var t,n,o,i,r,s,a,u,c,l,h=function(t,e){return function(){return t.apply(e,arguments)}},p=function(t,e){function n(){this.constructor=t}for(var o in e)d.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},d={}.hasOwnProperty;o=e.getDOMSelection,n=e.getDOMRange,l=e.setDOMRange,t=e.elementContainsNode,s=e.nodeIsCursorTarget,r=e.innerElementIsActive,i=e.handleEvent,a=e.normalizeRange,u=e.rangeIsCollapsed,c=e.rangesAreEqual,e.SelectionManager=function(d){function f(t){this.element=t,this.selectionDidChange=h(this.selectionDidChange,this),this.didMouseDown=h(this.didMouseDown,this),this.locationMapper=new e.LocationMapper(this.element),this.pointMapper=new e.PointMapper,this.lockCount=0,i("mousedown",{onElement:this.element,withCallback:this.didMouseDown})}return p(f,d),f.prototype.getLocationRange=function(t){var e,o;return null==t&&(t={}),e=t.strict===!1?this.createLocationRangeFromDOMRange(n(),{strict:!1}):t.ignoreLock?this.currentLocationRange:null!=(o=this.lockedLocationRange)?o:this.currentLocationRange},f.prototype.setLocationRange=function(t){var e;if(!this.lockedLocationRange)return t=a(t),(e=this.createDOMRangeFromLocationRange(t))?(l(e),this.updateCurrentLocationRange(t)):void 0},f.prototype.setLocationRangeFromPointRange=function(t){var e,n;return t=a(t),n=this.getLocationAtPoint(t[0]),e=this.getLocationAtPoint(t[1]),this.setLocationRange([n,e])},f.prototype.getClientRectAtLocationRange=function(t){var e;return(e=this.createDOMRangeFromLocationRange(t))?this.getClientRectsForDOMRange(e)[1]:void 0},f.prototype.locationIsCursorTarget=function(t){var e,n,o;return o=this.findNodeAndOffsetFromLocation(t),e=o[0],n=o[1],s(e)},f.prototype.lock=function(){return 0===this.lockCount++?(this.updateCurrentLocationRange(),this.lockedLocationRange=this.getLocationRange()):void 0},f.prototype.unlock=function(){var t;return 0===--this.lockCount&&(t=this.lockedLocationRange,this.lockedLocationRange=null,null!=t)?this.setLocationRange(t):void 0},f.prototype.clearSelection=function(){var t;return null!=(t=o())?t.removeAllRanges():void 0},f.prototype.selectionIsCollapsed=function(){var t;return(null!=(t=n())?t.collapsed:void 0)===!0},f.prototype.selectionIsExpanded=function(){return!this.selectionIsCollapsed()},f.proxyMethod("locationMapper.findLocationFromContainerAndOffset"),f.proxyMethod("locationMapper.findContainerAndOffsetFromLocation"),f.proxyMethod("locationMapper.findNodeAndOffsetFromLocation"),f.proxyMethod("pointMapper.createDOMRangeFromPoint"),f.proxyMethod("pointMapper.getClientRectsForDOMRange"),f.prototype.didMouseDown=function(){return this.pauseTemporarily()},f.prototype.pauseTemporarily=function(){var e,n,o,r;return this.paused=!0,n=function(e){return function(){var n,i,s;for(e.paused=!1,clearTimeout(r),i=0,s=o.length;s>i;i++)n=o[i],n.destroy();return t(document,e.element)?e.selectionDidChange():void 0}}(this),r=setTimeout(n,200),o=function(){var t,o,r,s;for(r=["mousemove","keydown"],s=[],t=0,o=r.length;o>t;t++)e=r[t],s.push(i(e,{onElement:document,withCallback:n}));return s}()},f.prototype.selectionDidChange=function(){return this.paused||r(this.element)?void 0:this.updateCurrentLocationRange()},f.prototype.updateCurrentLocationRange=function(t){var e;return(null!=t?t:t=this.createLocationRangeFromDOMRange(n()))&&!c(t,this.currentLocationRange)?(this.currentLocationRange=t,null!=(e=this.delegate)&&"function"==typeof e.locationRangeDidChange?e.locationRangeDidChange(this.currentLocationRange.slice(0)):void 0):void 0},f.prototype.createDOMRangeFromLocationRange=function(t){var e,n,o,i;return o=this.findContainerAndOffsetFromLocation(t[0]),n=u(t)?o:null!=(i=this.findContainerAndOffsetFromLocation(t[1]))?i:o,null!=o&&null!=n?(e=document.createRange(),e.setStart.apply(e,o),e.setEnd.apply(e,n),e):void 0},f.prototype.createLocationRangeFromDOMRange=function(t,e){var n,o;if(null!=t&&this.domRangeWithinElement(t)&&(o=this.findLocationFromContainerAndOffset(t.startContainer,t.startOffset,e)))return t.collapsed||(n=this.findLocationFromContainerAndOffset(t.endContainer,t.endOffset,e)),a([o,n])},f.prototype.getLocationAtPoint=function(t){var e,n;return(e=this.createDOMRangeFromPoint(t))&&null!=(n=this.createLocationRangeFromDOMRange(e))?n[0]:void 0},f.prototype.domRangeWithinElement=function(e){return e.collapsed?t(this.element,e.startContainer):t(this.element,e.startContainer)&&t(this.element,e.endContainer)},f}(e.BasicObject)}.call(this),function(){var t,n,o,i=function(t,e){function n(){this.constructor=t}for(var o in e)r.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},r={}.hasOwnProperty,s=[].slice;n=e.rangeIsCollapsed,o=e.rangesAreEqual,t=e.objectsAreEqual,e.EditorController=function(r){function a(t){var n,o;this.editorElement=t.editorElement,n=t.document,o=t.html,this.selectionManager=new e.SelectionManager(this.editorElement),this.selectionManager.delegate=this,this.composition=new e.Composition,this.composition.delegate=this,this.attachmentManager=new e.AttachmentManager(this.composition.getAttachments()),this.attachmentManager.delegate=this,this.inputController=new e.InputController(this.editorElement),this.inputController.delegate=this,this.inputController.responder=this.composition,this.compositionController=new e.CompositionController(this.editorElement,this.composition),this.compositionController.delegate=this,this.toolbarController=new e.ToolbarController(this.editorElement.toolbarElement),this.toolbarController.delegate=this,this.editor=new e.Editor(this.composition,this.selectionManager,this.editorElement),null!=n?this.editor.loadDocument(n):this.editor.loadHTML(o)}return i(a,r),a.prototype.registerSelectionManager=function(){return e.selectionChangeObserver.registerSelectionManager(this.selectionManager)},a.prototype.unregisterSelectionManager=function(){return e.selectionChangeObserver.unregisterSelectionManager(this.selectionManager)},a.prototype.compositionDidChangeDocument=function(){return this.editorElement.notify("document-change"),this.handlingInput?void 0:this.render()},a.prototype.compositionDidChangeCurrentAttributes=function(t){return this.currentAttributes=t,this.toolbarController.updateAttributes(this.currentAttributes),this.updateCurrentActions(),this.editorElement.notify("attributes-change",{attributes:this.currentAttributes})},a.prototype.compositionDidPerformInsertionAtRange=function(t){return this.pasting?this.pastedRange=t:void 0},a.prototype.compositionShouldAcceptFile=function(t){return this.editorElement.notify("file-accept",{file:t})},a.prototype.compositionDidAddAttachment=function(t){var e;return e=this.attachmentManager.manageAttachment(t),this.editorElement.notify("attachment-add",{attachment:e})},a.prototype.compositionDidEditAttachment=function(t){var e;return this.compositionController.rerenderViewForObject(t),e=this.attachmentManager.manageAttachment(t),this.editorElement.notify("attachment-edit",{attachment:e}),this.editorElement.notify("change")},a.prototype.compositionDidChangeAttachmentPreviewURL=function(t){return this.compositionController.invalidateViewForObject(t),this.editorElement.notify("change")},a.prototype.compositionDidRemoveAttachment=function(t){var e;return e=this.attachmentManager.unmanageAttachment(t),this.editorElement.notify("attachment-remove",{attachment:e})},a.prototype.compositionDidStartEditingAttachment=function(t){return this.attachmentLocationRange=this.composition.document.getLocationRangeOfAttachment(t),this.compositionController.installAttachmentEditorForAttachment(t),this.selectionManager.setLocationRange(this.attachmentLocationRange)},a.prototype.compositionDidStopEditingAttachment=function(){return this.compositionController.uninstallAttachmentEditor(),this.attachmentLocationRange=null},a.prototype.compositionDidRequestChangingSelectionToLocationRange=function(t){return!this.loadingSnapshot||this.isFocused()?(this.requestedLocationRange=t,this.compositionRevisionWhenLocationRangeRequested=this.composition.revision,this.handlingInput?void 0:this.render()):void 0},a.prototype.compositionWillLoadSnapshot=function(){return this.loadingSnapshot=!0},a.prototype.compositionDidLoadSnapshot=function(){return this.compositionController.refreshViewCache(),this.render(),this.loadingSnapshot=!1},a.prototype.getSelectionManager=function(){return this.selectionManager},a.proxyMethod("getSelectionManager().setLocationRange"),a.proxyMethod("getSelectionManager().getLocationRange"),a.prototype.attachmentManagerDidRequestRemovalOfAttachment=function(t){return this.removeAttachment(t)},a.prototype.compositionControllerWillSyncDocumentView=function(){return this.inputController.editorWillSyncDocumentView(),this.selectionManager.lock(),this.selectionManager.clearSelection()},a.prototype.compositionControllerDidSyncDocumentView=function(){return this.inputController.editorDidSyncDocumentView(),this.selectionManager.unlock(),this.updateCurrentActions(),this.editorElement.notify("sync")},a.prototype.compositionControllerDidRender=function(){return null!=this.requestedLocationRange&&(this.compositionRevisionWhenLocationRangeRequested===this.composition.revision&&this.selectionManager.setLocationRange(this.requestedLocationRange),this.requestedLocationRange=null,this.compositionRevisionWhenLocationRangeRequested=null),this.renderedCompositionRevision!==this.composition.revision&&(this.composition.updateCurrentAttributes(),this.editorElement.notify("render")),this.renderedCompositionRevision=this.composition.revision},a.prototype.compositionControllerDidFocus=function(){return this.toolbarController.hideDialog(),this.editorElement.notify("focus")},a.prototype.compositionControllerDidBlur=function(){return this.editorElement.notify("blur")},a.prototype.compositionControllerDidSelectAttachment=function(t){return this.composition.editAttachment(t)},a.prototype.compositionControllerDidRequestDeselectingAttachment=function(t){var e,n;return e=null!=(n=this.attachmentLocationRange)?n:this.composition.document.getLocationRangeOfAttachment(t),this.selectionManager.setLocationRange(e[1])},a.prototype.compositionControllerWillUpdateAttachment=function(t){return this.editor.recordUndoEntry("Edit Attachment",{context:t.id,consolidatable:!0})},a.prototype.compositionControllerDidRequestRemovalOfAttachment=function(t){return this.removeAttachment(t)},a.prototype.inputControllerWillHandleInput=function(){return this.handlingInput=!0,this.requestedRender=!1},a.prototype.inputControllerDidRequestRender=function(){return this.requestedRender=!0},a.prototype.inputControllerDidHandleInput=function(){return this.handlingInput=!1,this.requestedRender?(this.requestedRender=!1,this.render()):void 0},a.prototype.inputControllerDidAllowUnhandledInput=function(){return this.editorElement.notify("change")},a.prototype.inputControllerDidRequestReparse=function(){return this.reparse()},a.prototype.inputControllerWillPerformTyping=function(){return this.recordTypingUndoEntry()},a.prototype.inputControllerWillCutText=function(){return this.editor.recordUndoEntry("Cut")},a.prototype.inputControllerWillPasteText=function(){return this.editor.recordUndoEntry("Paste"),this.pasting=!0},a.prototype.inputControllerDidPaste=function(t){var e;return e=this.pastedRange,this.pastedRange=null,this.pasting=null,this.editorElement.notify("paste",{pasteData:t,range:e})},a.prototype.inputControllerWillMoveText=function(){return this.editor.recordUndoEntry("Move")},a.prototype.inputControllerWillAttachFiles=function(){return this.editor.recordUndoEntry("Drop Files")},a.prototype.inputControllerDidReceiveKeyboardCommand=function(t){return this.toolbarController.applyKeyboardCommand(t)},a.prototype.inputControllerDidStartDrag=function(){return this.locationRangeBeforeDrag=this.selectionManager.getLocationRange()},a.prototype.inputControllerDidReceiveDragOverPoint=function(t){return this.selectionManager.setLocationRangeFromPointRange(t)},a.prototype.inputControllerDidCancelDrag=function(){return this.selectionManager.setLocationRange(this.locationRangeBeforeDrag),this.locationRangeBeforeDrag=null},a.prototype.locationRangeDidChange=function(t){return this.composition.updateCurrentAttributes(),this.updateCurrentActions(),this.attachmentLocationRange&&!o(this.attachmentLocationRange,t)&&this.composition.stopEditingAttachment(),this.editorElement.notify("selection-change")},a.prototype.toolbarDidClickButton=function(){return this.getLocationRange()?void 0:this.setLocationRange({index:0,offset:0})},a.prototype.toolbarDidInvokeAction=function(t){return this.invokeAction(t)},a.prototype.toolbarDidToggleAttribute=function(t){return this.recordFormattingUndoEntry(),this.composition.toggleCurrentAttribute(t),this.render(),this.selectionFrozen?void 0:this.editorElement.focus()},a.prototype.toolbarDidUpdateAttribute=function(t,e){return this.recordFormattingUndoEntry(),this.composition.setCurrentAttribute(t,e),this.render(),this.selectionFrozen?void 0:this.editorElement.focus()},a.prototype.toolbarDidRemoveAttribute=function(t){return this.recordFormattingUndoEntry(),this.composition.removeCurrentAttribute(t),this.render(),this.selectionFrozen?void 0:this.editorElement.focus()},a.prototype.toolbarWillShowDialog=function(){return this.composition.expandSelectionForEditing(),this.freezeSelection()},a.prototype.toolbarDidShowDialog=function(t){return this.editorElement.notify("toolbar-dialog-show",{dialogName:t})},a.prototype.toolbarDidHideDialog=function(t){return this.thawSelection(),this.editorElement.focus(),this.editorElement.notify("toolbar-dialog-hide",{dialogName:t})},a.prototype.freezeSelection=function(){return this.selectionFrozen?void 0:(this.selectionManager.lock(),this.composition.freezeSelection(),this.selectionFrozen=!0,this.render())},a.prototype.thawSelection=function(){return this.selectionFrozen?(this.composition.thawSelection(),this.selectionManager.unlock(),this.selectionFrozen=!1,this.render()):void 0},a.prototype.actions={undo:{test:function(){return this.editor.canUndo()},perform:function(){return this.editor.undo()}},redo:{test:function(){return this.editor.canRedo()},perform:function(){return this.editor.redo()}},link:{test:function(){return this.editor.canActivateAttribute("href")}},increaseNestingLevel:{test:function(){return this.editor.canIncreaseNestingLevel()},perform:function(){return this.editor.increaseNestingLevel()&&this.render()}},decreaseNestingLevel:{test:function(){return this.editor.canDecreaseNestingLevel()},perform:function(){return this.editor.decreaseNestingLevel()&&this.render()}},increaseBlockLevel:{test:function(){return this.editor.canIncreaseNestingLevel()},perform:function(){return this.editor.increaseNestingLevel()&&this.render()}},decreaseBlockLevel:{test:function(){return this.editor.canDecreaseNestingLevel()},perform:function(){return this.editor.decreaseNestingLevel()&&this.render()}}},a.prototype.canInvokeAction=function(t){var e,n;return this.actionIsExternal(t)?!0:!!(null!=(e=this.actions[t])&&null!=(n=e.test)?n.call(this):void 0)},a.prototype.invokeAction=function(t){var e,n;return this.actionIsExternal(t)?this.editorElement.notify("action-invoke",{actionName:t}):null!=(e=this.actions[t])&&null!=(n=e.perform)?n.call(this):void 0},a.prototype.actionIsExternal=function(t){return/^x-./.test(t)},a.prototype.getCurrentActions=function(){var t,e;e={};for(t in this.actions)e[t]=this.canInvokeAction(t);return e},a.prototype.updateCurrentActions=function(){var e;return e=this.getCurrentActions(),t(e,this.currentActions)?void 0:(this.currentActions=e,this.toolbarController.updateActions(this.currentActions),this.editorElement.notify("actions-change",{actions:this.currentActions}))},a.prototype.reparse=function(){return this.composition.replaceHTML(this.editorElement.innerHTML)},a.prototype.render=function(){return this.compositionController.render()},a.prototype.removeAttachment=function(t){return this.editor.recordUndoEntry("Delete Attachment"),this.composition.removeAttachment(t),this.render()},a.prototype.recordFormattingUndoEntry=function(){var t;return t=this.selectionManager.getLocationRange(),n(t)?void 0:this.editor.recordUndoEntry("Formatting",{context:this.getUndoContext(),consolidatable:!0})},a.prototype.recordTypingUndoEntry=function(){return this.editor.recordUndoEntry("Typing",{context:this.getUndoContext(this.currentAttributes),consolidatable:!0})},a.prototype.getUndoContext=function(){var t;return t=1<=arguments.length?s.call(arguments,0):[],[this.getLocationContext(),this.getTimeContext()].concat(s.call(t))},a.prototype.getLocationContext=function(){var t;return t=this.selectionManager.getLocationRange(),n(t)?t[0].index:t},a.prototype.getTimeContext=function(){return e.config.undoInterval>0?Math.floor((new Date).getTime()/e.config.undoInterval):0},a.prototype.isFocused=function(){var t;return this.editorElement===(null!=(t=this.editorElement.ownerDocument)?t.activeElement:void 0)},a}(e.Controller)}.call(this),function(){var t,n,o,i,r;i=e.makeElement,r=e.triggerEvent,n=e.handleEvent,o=e.handleEventOnce,t=e.AttachmentView.attachmentSelector,e.registerElement("trix-editor",function(){var s,a,u,c,l,h,p,d;return h=0,s=function(t){return!document.querySelector(":focus")&&t.hasAttribute("autofocus")&&document.querySelector("[autofocus]")===t?t.focus():void 0},p=function(t){return t.hasAttribute("contenteditable")?void 0:(t.setAttribute("contenteditable",""),o("focus",{onElement:t,withCallback:function(){return u(t)}}))},u=function(t){return l(t),d(t)},l=function(t){return("function"==typeof document.queryCommandSupported?document.queryCommandSupported("enableObjectResizing"):void 0)?(document.execCommand("enableObjectResizing",!1,!1),n("mscontrolselect",{onElement:t,preventDefault:!0})):void 0},d=function(){var t;return("function"==typeof document.queryCommandSupported?document.queryCommandSupported("DefaultParagraphSeparator"):void 0)&&(t=e.config.blockAttributes["default"].tagName,"div"===t||"p"===t)?document.execCommand("DefaultParagraphSeparator",!1,t):void 0},a=/Trident.*rv:11/.test(navigator.userAgent),c=function(){return a?{display:"inline",width:"auto"}:{display:"inline-block",width:"1px"}}(),{defaultCSS:"%t:empty:not(:focus)::before {\n  content: attr(placeholder);\n  color: graytext;\n}\n\n%t a[contenteditable=false] {\n  cursor: text;\n}\n\n%t img {\n  max-width: 100%;\n  height: auto;\n}\n\n%t "+t+" figcaption textarea {\n  resize: none;\n}\n\n%t "+t+" figcaption textarea.trix-autoresize-clone {\n  position: absolute;\n  left: -9999px;\n  max-height: 0px;\n}\n\n%t "+t+'[data-trix-mutable] figcaption:empty::before {\n  content: "'+e.config.lang.captionPrompt+'";\n  color: graytext;\n}\n\n%t [data-trix-cursor-target] {\n  display: '+c.display+" !important;\n  width: "+c.width+" !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  border: none !important;\n}\n\n%t [data-trix-cursor-target=left] {\n  vertical-align: top !important;\n  margin-left: -1px !important;\n}\n\n%t [data-trix-cursor-target=right] {\n  vertical-align: bottom !important;\n  margin-right: -1px !important;\n}",trixId:{get:function(){return this.hasAttribute("trix-id")?this.getAttribute("trix-id"):(this.setAttribute("trix-id",++h),this.trixId)}},toolbarElement:{get:function(){var t,e,n;return this.hasAttribute("toolbar")?null!=(e=this.ownerDocument)?e.getElementById(this.getAttribute("toolbar")):void 0:this.parentNode?(n="trix-toolbar-"+this.trixId,this.setAttribute("toolbar",n),t=i("trix-toolbar",{id:n}),this.parentNode.insertBefore(t,this),t):void 0}},inputElement:{get:function(){var t,e,n;return this.hasAttribute("input")?null!=(n=this.ownerDocument)?n.getElementById(this.getAttribute("input")):void 0:this.parentNode?(e="trix-input-"+this.trixId,this.setAttribute("input",e),t=i("input",{type:"hidden",id:e}),this.parentNode.insertBefore(t,this.nextElementSibling),t):void 0}},editor:{get:function(){var t;return null!=(t=this.editorController)?t.editor:void 0}},name:{get:function(){var t;return null!=(t=this.inputElement)?t.name:void 0}},value:{get:function(){var t;return null!=(t=this.inputElement)?t.value:void 0},set:function(t){var e;return this.defaultValue=t,null!=(e=this.editor)?e.loadHTML(this.defaultValue):void 0}},notify:function(t,n){var o;switch(t){case"document-change":this.documentChangedSinceLastRender=!0;break;case"render":this.documentChangedSinceLastRender&&(this.documentChangedSinceLastRender=!1,this.notify("change"));break;case"change":case"attachment-add":case"attachment-edit":case"attachment-remove":null!=(o=this.inputElement)&&(o.value=e.serializeToContentType(this,"text/html"))}return this.editorController?r("trix-"+t,{onElement:this,attributes:n}):void 0},createdCallback:function(){return p(this)},attachedCallback:function(){return this.hasAttribute("data-trix-internal")?void 0:(null==this.editorController&&(this.editorController=new e.EditorController({editorElement:this,html:this.defaultValue=this.value})),this.editorController.registerSelectionManager(),this.registerResetListener(),s(this),requestAnimationFrame(function(t){return function(){return t.notify("initialize")}}(this)))},detachedCallback:function(){var t;return null!=(t=this.editorController)&&t.unregisterSelectionManager(),this.unregisterResetListener()},registerResetListener:function(){return this.resetListener=this.resetBubbled.bind(this),window.addEventListener("reset",this.resetListener,!1)},unregisterResetListener:function(){return window.removeEventListener("reset",this.resetListener,!1)},resetBubbled:function(t){var e;return t.target!==(null!=(e=this.inputElement)?e.form:void 0)||t.defaultPrevented?void 0:this.reset()},reset:function(){return this.value=this.defaultValue}}}())}.call(this),function(){}.call(this)}).call(this),"object"==typeof module&&module.exports?module.exports=e:"function"=="function"&&__webpack_require__("./node_modules/webpack/buildin/amd-options.js")&&!(__WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}.call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/timers-browserify/main.js").setImmediate))

/***/ })

});


// WEBPACK FOOTER //
// 0.bundle.js